(function (){
    'use strict';

    angular
        .module('app.pages.users', [
            'flow'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.pages_new_user', {
                url      : '/new_user/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/new_user/new_user.html',
                        controller : 'UsersNewController as vm'
                    }
                }
            })
            .state('app.pages_profile_new_relative', {
                url      : '/profile_new_relative/:parentId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/new_relative/new_relative.html',
                        controller : 'UsersNewRelativeController as vm'
                    }
                }
            })
            .state('app.pages_user_logindestination', {
                url      : '/user/logindestination',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/login_destination/login_destination.html',
                        controller : 'LoginDestinationController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile', {
                url      : '/user/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/profile.html',
                        controller : 'ProfileController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_docs', {
                url      : '/profile_docs/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/documents/documents.html',
                        controller : 'ProfileDocumentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.profile_attendances', {
                url      : '/profile_attendances/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/attendances/attendances.html',
                        controller : 'ProfileAttendancesController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.user_attendances', {
                url      : '/user_attendances/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/attendances/attendances.html',
                        controller : 'ProfileAttendancesController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_relatives', {
                url      : '/profile_relatives/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/relatives/relatives.html',
                        controller : 'ProfileRelativesController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_relatives', {
                url      : '/user_relatives/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/relatives/relatives.html',
                        controller : 'ProfileRelativesController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_parents', {
                url: '/profile_parents/:userId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/parents/parents.html',
                        controller: 'ProfileParentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_parents', {
                url: '/user_parents/:userId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/parents/parents.html',
                        controller: 'ProfileParentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_services', {
                url      : '/profile_services/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/services/offered-services.html',
                        controller : 'ProfileServicesController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_documents', {
                url      : '/user_documents/:userId/:subscriptionId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_documents/documents.html',
                        controller : 'UserDocumentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_payments', {
                url      : '/profile_payments/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/payments/payments.html',
                        controller : 'ProfilePaymentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_payments', {
                url      : '/user_payments/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/tabs/payments/payments.html',
                        controller : 'ProfilePaymentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_tabbed', {
                url      : '/user/:userId/:tab',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/profile.html',
                        controller : 'ProfileController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_detail', {
                url      : '/userdetail/:userId/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_detail/user-detail.html',
                        controller : 'UserDetailController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_detail', {
                url      : '/profiledetail/:userId/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_detail/user-detail.html',
                        controller : 'UserDetailController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_socio', {
                url      : '/profile/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_profile/profile.html',
                        controller : 'ProfileController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_profile_settings', {
                url      : '/profile_settings/:userId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/profile_settings/profile_settings.html',//nic
                        controller : 'ProfileSettingsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_pending_payments', {
                url      : '/user/:userId/pending_payments/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/pending_payments/pending_payments.html',
                        controller : 'PendingPaymentsController as vm'
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pages_user_carnet', {
                url      : '/user_carnet/:organizationId/:userId/:orderId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/user_carnet/user_carnet.html',
                        controller : 'UserCarnetController as vm'
                    }
                },
                bodyClass: 'profile'
            })
        ;


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/users');

    }

})();

(function (){
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfileServicesController', ProfileServicesController);

    function ProfileServicesController($log, $state, $scope, $location, $rootScope, _, blockUI, $translate, $mdToast, $mdDialog, LoopBackAuth, OfferedService, Organization, CylUtils, User, ServiceDoctype,Notification, UserIdentity, Payment, SubscriptionDocument, Subscription, AlertMessageService,  UserDocument, AuthenticationService, DTOptionsBuilder, ApiPath)
    {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userProfile = null;
        vm.userIdentity = null;
        vm.editableProfile = false;
        vm.userServices = [];
        vm.userDocuments = [];
        vm.apiPath = ApiPath;
        vm.isUserDetail= ($location.path().startsWith('/user'));
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.sendMessage=sendMessage;

        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });

        vm.goToOrganization=goToOrganization;
        vm.goToOrganizations=goToOrganizations;
        vm.gotoOfferedService=gotoOfferedService;
        vm.goToRelativeDetail = goToRelativeDetail;
        vm.formatDate=formatDate;
        vm.goBack=goBack;
        vm.editUserServiceDocuments=editUserServiceDocuments;
        vm.goToOrganizationDetail = goToOrganizationDetail;
        vm.goToNewOrganization = goToNewOrganization;
        vm.apiPath=ApiPath;
        vm.gotoDocuments=gotoDocuments;
        vm.gotoRelatives=gotoRelatives;
        vm.gotoServices=gotoServices;
        vm.gotoPayments=gotoPayments;
        vm.gotoProfile=gotoProfile;
        vm.goToPayment=goToPayment;
        vm.isAuthorized = true;

        init();

        //////////

        function init(){
            // utente corrente
            vm.currentUserId = User.getCurrentId().toString();

            //utente di cui voglio vedere il profilo
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());

            vm.userId = userId.toString();
            if (AuthenticationService.isAuthenticated()){

                loadUserProfile(userId).then(
                    function(data){
                        $log.debug(data);
                        var myUser = data;
                        vm.userProfile = (JSON.parse(JSON.stringify(myUser)));
                        // vm.userIdentity = data.identities[0];
                        // //TODO USERRLOAD
                        // if (vm.userProfile.birthDate && vm.userProfile.birthDate!==null && typeof(vm.userProfile.birthDate == 'string')){
                        //     vm.userProfile.birthDate = new Date(vm.userProfile.birthDate);
                        // }

                        var userIdForDocs = [userId];
                        //PER IL CARICAMENTO DEI DOCUMENTI:
                        // - SE SONO UTENTE NORMALER CARICO I MIEI
                        // - SE HO FIGLI O GENITORI VEDO ANCHE I LORO DOCUMENTI
                        if (vm.userProfile.parents && vm.userProfile.parents.length>0) {
                            userIdForDocs.push(vm.userProfile.parents[0].id);
                        }
                        if (vm.userProfile.children && vm.userProfile.children.length>0) {
                            for (var i = 0; i < vm.userProfile.children.length; i++) {
                                userIdForDocs.push(vm.userProfile.children[i].id);
                            }
                        }
                        userIdForDocs=_.uniq(userIdForDocs);

                        //controllo di poter effettivamente vedere la pagina
                        if (vm.currentUserId != vm.userId) {
                            var found = _.find(userIdForDocs, function(uid) {
                               return uid == vm.currentUserId;
                            });
                            if (!found) {
                                vm.isAuthorized = false;
                                $log.debug('User ' + vm.currentUserId + ' is not athorized to see anything about user ' + vm.userId);
                                return;
                            }
                        }

                        loadUserDocuments(userIdForDocs).then(
                            function(data){
                                $log.debug(data);
                                vm.userDocuments = data;
                            },
                            function(error){
                                $log.debug(error);
                            }
                        );

                        loadUserServices(myUser);


                    },
                    function(error){
                        $log.debug(error);
                    });

            } else {
                $state.go('app.pages_auth_login');
            }


            $rootScope.$on('PAYMENTS_TO_BE_RELOADED', function (event, valore) {
                loadUserServices(vm.userProfile);
            });

        }


        function gotoDocuments() {
            $state.go('app.pages_profile_docs', {userId: userId});
        }

        function gotoRelatives() {
            $state.go('app.pages_profile_relatives', {userId: userId});
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', {userId: userId});
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', {userId: userId});
        }

        function gotoProfile() {
            $state.go('app.pages_profile_socio', {userId: userId});
        }

        function loadUserDocuments(userIds){
            var query = {
                filter: {
                    where :
                        {and: [
                                {userId: {inq: userIds} },
                                {flgActive: 1}
                            ]
                        }
                }
            };
            return UserDocument.find(query).$promise;
        }


        function goToOrganizationDetail(organizationId)
        {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);

            $state.go('app.organization', {organizationId: organizationId});
        }


        function goToNewOrganization()
        {
            $state.go('app.new_organization');
        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }

        function goToRelativeDetail(userId) {
            $state.go('app.pages_profile', {userId: userId});
        }

        function goToPayment(service) {
            if (!service.stripeEnabled) {
                AlertMessageService.showErrorAlert('MESSAGE.ORGANIZATION_WITHOUT_STRIPE_ENABLED');
            }
            else {
                $state.go('app.pay_subscription', {subscriptionId: service.subscriptionId});
            }
        }

        function loadUserProfile(userId){
            return User.findById({
                id: userId,
                filter: {
                    include: ['identities', 'children', 'parents']
                }
            }).$promise;
        }


        function backgroundImage() {
            if (vm.userProfile && vm.userProfile!==null && vm.userProfile.uriBackground && vm.userProfile.uriBackground !==null) {
                return {'background-image': 'url('+ApiPath+'/userDocumentsContainers/'+$rootScope.CYL_USER_DOC_PREFIX+vm.userProfile.id +'/download/'+vm.userProfile.uriBackground+')'};
            }
            return '';

        }



        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function editUserServiceDocuments(ev, service) {
            //SE SONO UTENTE CONNESSO O L'UTENTE CONNESSO E' UNO DEI MIEI FIGLI MOSTRO LA MODALE DI ASSOCIAZIONE DOCUMENTUI
            //ALTRIMENTI, SE SONO ADMIN DELLA ASSOCIAZIONE VADO ALLA PAGINA AMMINISTRATIVA

            var isParent = false;
            var isChild = false;

            if (vm.userProfile.parents) {
                var found  = _.find(vm.userProfile.parents, function (p) { return p.id === service.userId; });
                if (found) isParent = true;
            }

            if (vm.userProfile.children) {
                var found  = _.find(vm.userProfile.children, function (p) { return p.id === service.userId; });
                if (found) isChild = true;
            }

            if (service.userId!=vm.userId &&  !isParent && !isChild) {
                $state.go('app.docs_validation', {serviceId:service.id, subscriptionId:  service.subscriptionId});
                return;
            }


            $scope.doctypes={};
            $scope.myResource={};
            $scope.myResource.serviceDocuments={};
            //carica documenti necessari per il servizio
            var query ={
                filter: {
                    where : {offeredServiceId: service.id},
                    include : ['organizationDoctype' ]
                }
            };
            ServiceDoctype.find(query, function(docs) {
                $scope.doctypes=docs;

                for (var i = 0; i < docs.length; i++) {
                    $scope.myResource.serviceDocuments[docs[i].organizationDoctype.id]={};
                }

                //carico eventuale documentazione già salvata
                var querySubDocs ={
                    filter: {
                        where : {subscriptionId: service.subscriptionId},
                        include : ['userDocument','organizationDoctype' ]
                    }
                };
                SubscriptionDocument.find(querySubDocs, function(subDocs) {
                    if (subDocs && subDocs!==null) {
                        for (var i = 0; i < subDocs.length; i++) {
                            var docTypeId = subDocs[i].organizationDoctype.id;
                            $scope.myResource.serviceDocuments[docTypeId]= subDocs[i];
                        }
                    }

                    $mdDialog.show({
                        controller: DialogController,
                        templateUrl: 'app/main/pages/users/user_profile/tabs/services/edit_docs_dialog.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose:true
                    })
                        .then(function(answer) {

                            $log.debug(answer.serviceDocuments);

                            var subscriptionDocuments = [];
                            if (answer.serviceDocuments && answer.serviceDocuments!==null) {
                                var keys = Object.keys(answer.serviceDocuments);
                                for (var i = 0; i<keys.length; i++) {
                                    if (answer.serviceDocuments[keys[i]] && answer.serviceDocuments[keys[i]].isEditing) {
                                        //traduco l'orario in risorsa
                                        var subscriptionDocument = {};
                                        subscriptionDocument.subscriptionId = service.subscriptionId;
                                        subscriptionDocument.organizationDoctypeId = keys[i];
                                        subscriptionDocument.id = answer.serviceDocuments[keys[i]].id;
                                        subscriptionDocument.flgValidated = 0;
                                        if (answer.serviceDocuments[keys[i]].userDocument) {
                                            subscriptionDocument.isPaperDoc = false;
                                            subscriptionDocument.userDocumentId = answer.serviceDocuments[keys[i]].userDocument.id;
                                            subscriptionDocument.uri = answer.serviceDocuments[keys[i]].userDocument.uri;
                                        } else {
                                            //da frontend ignoro doc senza file
                                            continue;
                                        }
                                        subscriptionDocuments.push(subscriptionDocument);
                                    }
                                }
                            }

                            if (subscriptionDocuments.length==0) {
                                //non ho fatto niente
                                return;
                            }

                            Subscription.findById({
                                id: service.subscriptionId
                            }).$promise.then(function(mySub) {
                                mySub.$prototype$updateSubscriptionDocuments({subscriptionDocuments: subscriptionDocuments})
                                    .then(function(data){
                                        $log.debug('success');
                                        $log.debug(data);
                                        AlertMessageService.showSuccessMessage();
                                        loadUserServices(vm.userProfile);

                                    },function(httpResponse){
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                            });
                        }, function() {
                            $log.debug('You cancelled the dialog.');
                        });

                });
            });

        }


        function goBack() {
            window.history.back();
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function loadUserServices(myUser) {
            $log.debug('ProfileServicesController.loadUserServices()');
            blockUI.start();
            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {
                        blockUI.stop();
                        if ( response.result.services &&  response.result.services!==null) {
                            for (var i = 0; i <  response.result.services.length; i++) {
                                var dateFrom =  response.result.services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    response.result.services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  response.result.services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    response.result.services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }
                        vm.userServices = response.result.services;
                        $log.debug('vm.userServices: ' + JSON.stringify(vm.userServices, undefined, 2));
                    }, function(httpResponse) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
            });
        }

        function sendMessage(ev) {
            $scope.myResource={};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    Notification.create(
                        {senderId: vm.currentUserId,
                            recipientId: vm.userId,
                            title: answer.title,
                            text: answer.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        },
                        function(n,responseHeaders){
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }

    }

})();

(function (){
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfileRelativesController', ProfileRelativesController);

    function ProfileRelativesController ($log, $state, $scope, $location, $rootScope, $translate, $mdToast, $mdDialog, LoopBackAuth, OfferedService, _,
                                         Organization, CylUtils, User, ServiceDoctype,Notification, UserIdentity, Payment, DictionaryService, SubscriptionDocument, UserRelation,
                                         Subscription, AlertMessageService,  UserDocument, AuthenticationService, DTOptionsBuilder, ApiPath)
    {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userProfile = null;
        vm.userIdentity = null;
        vm.editableProfile = false;
        vm.userChildren = [];
        vm.userParents = [];
        vm.removeAsChild=removeAsChild;

        vm.apiPath = ApiPath;
        vm.isUserDetail= ($location.path().startsWith('/user'));
        vm.goToRelativeDetail = goToRelativeDetail;
        vm.askUserDetails = askUserDetails;
        vm.formatDate=formatDate;
        vm.goBack=goBack;
        vm.apiPath=ApiPath;
        vm.sendMessage=sendMessage;
        vm.deleteChild=deleteChild;
        vm.updateChildRelationType=updateChildRelationType;
        vm.childRelationTypes = [];
        vm.parentRelationTypes = [];

        vm.gotoDocuments=gotoDocuments;
        vm.gotoRelatives=gotoRelatives;
        vm.gotoServices=gotoServices;
        vm.gotoPayments=gotoPayments;
        vm.gotoProfile=gotoProfile;

        init();

        //////////

        function init(){
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
            vm.userId=userId.toString();
            if (AuthenticationService.isAuthenticated()){

                //CONTROLLI PRELIMINARI

                // SE SONO AMMINITRATORE /vm.isUserDetail===true/
                // - vedo solo i children eventualmente soci delle mie società
                // - se clicco su link di iscrizioni vado alla maschear di subscriptions

                //SE SONO SOCIO /vm.isUserDetail===false/
                // - vedo i miei tutelati come se fossi io
                // - vado al profilo
                vm.loading = true;


                DictionaryService.loadDictionary(function() {
                    vm.childRelationTypes = DictionaryService.loadSection('CHILD_RELATION');
                    vm.parentRelationTypes = DictionaryService.loadSection('PARENT_RELATION');
                    loadUserProfile(userId).then(
                        function(data){
                            $log.debug(data);
                            var myUser = data;
                            vm.userProfile = (JSON.parse(JSON.stringify(myUser)));
                            vm.userIdentity = data.identities[0];
                            vm.userChildren = data.children;
                            vm.userParents = data.parents;

                            //completo i dati dei parenti con le rispetrtive tipologie di relazione
                            for (var i = 0; i < vm.userChildren.length; i++) {
                                var theRelation = _.find(data.childRelations, function (r) { return r.childId === vm.userChildren[i].id;});
                                if (theRelation) {
                                    vm.userChildren[i].relationType=theRelation.relationType;
                                }
                            }

                            for (var i = 0; i < vm.userParents.length; i++) {
                                var theRelation = _.find(data.parentRelations, function (r) { return r.parentId === vm.userParents[i].id;});
                                if (theRelation) {
                                    vm.userParents[i].relationType=theRelation.relationType;
                                }
                            }

                            if (vm.userProfile.birthDate && vm.userProfile.birthDate!==null && typeof(vm.userProfile.birthDate == 'string')){
                                vm.userProfile.birthDate = new Date(vm.userProfile.birthDate);
                            }

                            vm.loading = false;

                        },
                        function(error){
                            vm.loading = false;
                            $log.debug(error);
                        });
                });
            } else {
                $state.go('app.pages_auth_login');
            }


        }


        function goToOrganizationDetail(organizationId)
        {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);

            $state.go('app.organization', {organizationId: organizationId});
        }


        function goToNewOrganization()
        {
            $state.go('app.new_organization');
        }


        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }

        function goToRelativeDetail(userId) {
            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
            if (vm.isUserDetail) {
                $state.go('app.pages_user_detail', {userId: userId});
            } else {
                $state.go('app.pages_profile_socio', {userId: userId});
            }
        }


        function gotoDocuments() {
            $state.go('app.pages_profile_docs', {userId: userId});
        }

        function gotoRelatives() {
            $state.go('app.pages_profile_relatives', {userId: userId});
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', {userId: userId});
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', {userId: userId});
        }

        function gotoProfile() {
            $state.go('app.pages_profile_socio', {userId: userId});
        }

        function loadUserProfile(userId){
            return User.findById({
                id: userId,
                filter: {
                    include: ['identities', 'children', 'parents', 'childRelations', 'parentRelations']
                }
            }).$promise;
        }




        function backgroundImage() {
            if (vm.userProfile && vm.userProfile!==null && vm.userProfile.uriBackground && vm.userProfile.uriBackground !==null) {
                return {'background-image': 'url('+ApiPath+'/userDocumentsContainers/'+$rootScope.CYL_USER_DOC_PREFIX+vm.userProfile.id +'/download/'+vm.userProfile.uriBackground+')'};
            }
            return '';

        }

        function askUserDetails(ev){
            $state.go('app.pages_profile_new_relative', {parentId: userId});
        }


        function removeAsChild(child){

            var childData = _.find(vm.userProfile.children, function (c) { return c.id==child.id;});
            if (!childData) {
                alert("Invalid child");
                return;
            }

            $scope.childEmail = child.email;
            $scope.childEmailConfirm = null;
            $scope.child = child;
            $scope.child.parentDisplayName = vm.userProfile.displayName;
            if ($scope.childEmail && $scope.childEmail.endsWith(".invalid")) {
                $scope.childEmail=null;
            }
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_profile/tabs/relatives/remove_child_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    child.email = answer.email;
                    User.prototype$patchAttributes(
                        { id: child.id },
                        child).$promise.then(
                        function(data){
                            $log.debug(data);
                            User.removeChildUser({childId: child.id.toString(), parentId: userId}).$promise.then(
                                function(data) {
                                    AlertMessageService.showSuccessMessage();
                                    init();
                                }, function(httpResponse){
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data
                                        && httpResponse.data.error);
                                }
                            )
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data
                                && httpResponse.data.error);
                        }
                    );

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }


        function deleteChild(user) {
            $mdDialog.show({
                controller : DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent : angular.element(document.body),
                scope : $scope,
                preserveScope : true,
                clickOutsideToClose : true
            })
                .then(function(answer) {
                    User.deleteChild({userId: user.id, parentId: userId}).$promise.then(function(res) {
                        AlertMessageService.showSuccessMessage();
                        init();
                    }, function(httpResponse) {
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data
                            && httpResponse.data.error);
                    });
                });
        }



        function updateChildRelationType(child) {
            UserRelation.updateAll(
                {
                    where: { childId: child.id, parentId: vm.userId }
                },
                {relationType: child.relationType},
                function(org,responseHeaders){
                    AlertMessageService.showSuccessMessage();
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);
                });
        }



        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function goBack() {
            window.history.back();
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function loadUserServices(myUser) {
            //TODO USERRLOAD
            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {

                        if ( response.result.services &&  response.result.services!==null) {
                            for (var i = 0; i <  response.result.services.length; i++) {
                                var dateFrom =  response.result.services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    response.result.services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  response.result.services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    response.result.services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }


                        vm.userServices = response.result.services;
                    });
            });
        }

        function sendMessage(ev) {
            $scope.myResource={};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    User.notifyUser({userId: vm.userId, subject: answer.title, text:answer.text }).$promise.then(
                        function(n,responseHeaders){
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        }
                    );
                    Notification.create(
                        {senderId: vm.currentUserId,
                            recipientId: vm.userId,
                            title: answer.title,
                            text: answer.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        },
                        function(n,responseHeaders){
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }



    }

})();

(function (){
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfilePaymentsController', ProfilePaymentsController);

    function ProfilePaymentsController($log, $state, $scope, $location, $rootScope, $translate, $mdDialog, $q,
                                        $compile, User, OrganizationPrivateDocPrefix, Notification, LoopBackAuth,
                                       AlertMessageService, AuthenticationService, DTOptionsBuilder,
                                       ApiPath, DTColumnBuilder, EarningCost, PaymentReason)
    {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userProfile;
        vm.userIdentity;
        vm.editableProfile = false;
        vm.userDocuments;
        vm.userServices;
        vm.organizations;
        vm.organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION') || null;
        vm.dtInstance = {};
        vm.accessToken=LoopBackAuth.accessTokenId;

        // periodo di riferimento, che non si usa per l'utente, e lascio vuoto
        vm.referencePeriod = {
            dtFrom: null,
            dtTo: null,
        };

        // filtri per ricerca
        vm.searchFilters = {
            dtFrom: null,
            dtTo: null,
            description: null,
            offeredServiceId: null,
            userId: null,
            paymentReasonId: null,
            entryValueFrom: null,
            entryValueTo: null,
            // elementi per popolare dropdown e autocomplete
            lists: {
                organizations: [],
                services: [],
                paymentReasons: [],
            },
            // elementi selezionati dalle md-autocomplete
            selectedOrganization: null,
            loading: {
                filtersData: false,
                data: false,
            }
        };

        vm.apiPath = ApiPath;
        vm.isUserDetail= ($location.path().startsWith('/user'));
        vm.gotoDocuments=gotoDocuments;
        vm.gotoRelatives=gotoRelatives;
        vm.gotoServices=gotoServices;
        vm.gotoPayments=gotoPayments;
        vm.sendMessage=sendMessage;
        vm.goToOrganization=goToOrganization;
        vm.goToOrganizations=goToOrganizations;
        vm.gotoOfferedService=gotoOfferedService;
        vm.goToRelativeDetail = goToRelativeDetail;
        vm.formatDate=formatDate;
        vm.goBack=goBack;
        vm.backgroundImage=backgroundImage;
        vm.goToOrganizationDetail = goToOrganizationDetail;
        vm.goToNewOrganization = goToNewOrganization;
        vm.apiPath=ApiPath;
        vm.gotoProfile=gotoProfile;
        vm.loadEntries = loadEntries;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadEntries)
            .withDataProp('data')
            .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withDisplayLength(100)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtColumns = [
            // DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('entryDate').withTitle($translate.instant('EARNING_COST.DATE')).withClass('dt-column-date').notSortable().withOption('width', '10%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= formatDate(new Date(data));
                    return ret;
                }),
            DTColumnBuilder.newColumn('paymentReason').withTitle($translate.instant('EARNING_COST.REASON')).withClass('dt-column-paymentreason').notSortable().withOption('width', '10%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if (row.paymentReason && row.paymentReason!==null) {
                        ret += '<span class="cell-paymentreason-' + row.paymentReason.id + '">' +
                            row.paymentReason.name +
                            '</span>';
                    }
                    return ret;
                }),
            DTColumnBuilder.newColumn('entryCompany')
                .withTitle($translate.instant('EARNING_COST.COUNTER_PART'))
                .notSortable()
                .withOption('width', '15%')
                .withClass('dt-column-user')
                .renderWith(
                    function (data,type, row) {
                        var ret = '';
                        if (row.user && row.user!==null) {
                            ret += '<span class="cell-user-' + row.user.id + '">' +
                                row.user.familyName + ' ' + row.user.givenName +
                                '</span>';
                        } else if ( data && data!=null) {
                            ret+= data;
                        }
                        return ret;
                    }),
            DTColumnBuilder.newColumn('entryOrganization')
                    .withTitle('Organizzazione')
                    .notSortable()
                    .withOption('width', '15%')
                    .withClass('dt-column-organization')
                    .renderWith(
                        function (data,type, row) {
                            var ret = '';
                            if (row.organization) {
                                ret += '<span class="cell-organization-' + row.organization.id + '">' + row.organization.name + '</span>';
                            }
                            return ret;
                        }),
            DTColumnBuilder.newColumn('offeredService').withTitle($translate.instant('EARNING_COST.SERVICE')).withClass('dt-column-service').notSortable().withOption('width', '15%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if (row.offeredService && row.offeredService!==null) {
                        ret += '<span class="cell-offeredService-' + row.offeredService.id + '">' +
                            row.offeredService.name + '</span>';
                    }
                    return ret;
                }),
            DTColumnBuilder.newColumn('entryValue').withTitle($translate.instant('EARNING_COST.AMOUNT')).withClass('dt-column-amount').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    var iVal = parseInt(data);
                    if ( data && data!=null)
                        ret+= data;
                    return ret;
                }),
            DTColumnBuilder.newColumn('entryDescription').withTitle($translate.instant('EARNING_COST.DESCRIPTION')).withClass('dt-column-description').notSortable().withOption('width', '30%').renderWith(
                function (data,type, row) {
                    var ret = '';

                    if (row.creditNote) {
                        ret += 'NOTA DI CREDITO:<br>';
                    }

                    if ( data && data!=null)
                        ret+= data;

                    var edit = '<md-icon class="s-16" md-font-icon="icon-pencil" title="Modifica descrizione" ng-click="vm.modificaDescrizione('+row.id +');" style="cursor: pointer; color: #ccc; font-size: 18px"></md-icon>';
                    return edit + '&nbsp;&nbsp;' + ret;
                }),
            DTColumnBuilder.newColumn(null).withClass('dt-column-generateinvoice').withTitle('').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    if (row.invoiceId) {
                        return '<a title="Scarica ricevuta" ' +
                                'id="btn-downloadinvoice-' + row.invoice.id + '" ' +
                                'class="btn-downloadinvoice" ' +
                                // 'disabled="disabled"' +
                                'ng-href="' + vm.apiPath + '/organizationPrivateDocumentsContainers/'+ OrganizationPrivateDocPrefix + row.organizationId + '/download/' + row.invoice.pdfUri + '?access_token='+vm.accessToken+'" ' +
                                'target="_blank">' +
                                '<md-icon md-font-icon="icon-file-pdf"></md-icon>' +
                            '</a>';
                    }
                }),
            ];


        /**
         * Inizializza controller
         */
        vm.init = function() {
            $log.debug('ProfilePaymentsController.init()');
            vm.searchFilters.loading.filtersData = true;
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
            vm.userId=userId.toString();
            if (AuthenticationService.isAuthenticated()) {
                $q.all([
                    loadUserProfile(userId),
                    readPaymentReasons(),
                ]).then(
                    function(results) {
                        $log.debug({results: results});
                        vm.userProfile = results[0];
                        vm.searchFilters.lists.organizations = getUniqueOrganizations(vm.userProfile.organizations);
                        if (results && results[1]) {
                            vm.searchFilters.lists.paymentReasons = getUniqueOrganizations(results[1]);
                        }
                        vm.searchFilters.loading.filtersData = false;
                    },
                    function(err) {
                        vm.searchFilters.loading.filtersData = false;
                        AlertMessageService.showErrorAlert('Errore caricando i dati');
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        /**
         * Cerca le Organization che contengono una stringa
         *
         * @param {string} searchText
         */
         vm.getMatchingOrganizations = function(searchText) {
            var matchingItems = [];
            if (searchText && typeof searchText === 'string' && searchText.length >= 2) {
                if (vm.searchFilters.lists.organizations && vm.searchFilters.lists.organizations.length > 0) {
                    vm.searchFilters.lists.organizations.forEach(function(item) {
                        if (item && item.name && (item.name.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)) {
                            matchingItems.push(item);
                        }
                    })
                }
            }
            return matchingItems;
        };


        function goToOrganizationDetail(organizationId) {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);
            $state.go('app.organization', {organizationId: organizationId});
        }


        vm.reloadEntries = function() {
            vm.dtInstance.DataTable.draw();
        }


        /**
         * Puilisce i filtri di ricerca e riavvia la ricerca
         */
         vm.cleanFilters = function() {
            vm.searchFilters.offeredServiceId = null;
            vm.searchFilters.userId = null;
            vm.searchFilters.paymentReasonId = null;
            vm.searchFilters.selectedUser = null;
            vm.searchFilters.selectedOfferedService = null;
            vm.searchFilters.selectedOrganization = null;
            vm.searchFilters.dtFrom = vm.referencePeriod.dtFrom;
            vm.searchFilters.dtTo = vm.referencePeriod.dtTo;
            vm.searchFilters.description = null;
            vm.searchFilters.entryValueFrom = null;
            vm.searchFilters.entryValueTo = null;
            vm.reloadEntries();
        };


        function goToNewOrganization() {
            $state.go('app.new_organization');
        }

        function loadUser(userId) {
            return User.findById({
                id: userId,
            }).$promise;
        }

        function loadOrganizations(user) {
            return user.$prototype$allOrganizations();
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }

        function goToRelativeDetail(userId) {
            $state.go('app.pages_profile', {userId: userId});
        }

        function gotoDocuments() {
            $state.go('app.pages_profile_docs', {userId: userId});
        }

        function gotoRelatives() {
            $state.go('app.pages_profile_relatives', {userId: userId});
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', {userId: userId});
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', {userId: userId});
        }


        function gotoProfile() {
            $state.go('app.pages_profile_socio', {userId: userId});
        }

        /**
         * Va alla pagina dei pagamenti pendenti
         */
        vm.gotoPendingPayments = function() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.pages_user_pending_payments', {
                    userId: userId,
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        };



        /**
         * Carica il profilo di un utente
         * 
         * @param {*} userId 
         * @returns 
         */
        function loadUserProfile(userId) {
            return User.findById({
                id: userId,
                filter: {
                    include: ['identities', 'children', 'parents', 'organizations' /*{organizations: 'offeredServices'}*/]
                }
            }).$promise;
        }


        /**
         * Avvia una promise per leggere le PaymentReason (globali e per una organization)
         */
        function readPaymentReasons() {
            var deferred = $q.defer();
            PaymentReason.find(
                {
                    filter: {
                        where : {
                            organizationId: null,
                        },
                        order: 'name'
                    }
                },
                function(paymentReasons) {
                    deferred.resolve(paymentReasons);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        

        /**
         * Legge gli elementi da mettere nella datatable
         * 
         * @param {*} sSource 
         * @param {*} aoData 
         * @param {*} fnCallback 
         * @param {*} oSettings 
         */
        function loadEntries(sSource, aoData, fnCallback, oSettings) {
            vm.searchFilters.loading.data = true;
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var query = {
                filter: {
                    where: {
                        and: [
                            // organizationFilter,
                            {userId: vm.userId},
                            {dtDel: null},
                            {_p: new Date().getTime()}
                        ]
                    },
                    limit: length,
                    order: 'entryDate DESC',
                    skip: start,
                    include: ['offeredService', 'entryOrganization', 'user', 'paymentReason', 'invoice', 'payments', 'organization']
                }
            };

            // reference period filter
            if (vm.searchFilters.dtFrom) {
                query.filter.where.and.push({entryDate: {gte: vm.searchFilters.dtFrom}});
            }
            if (vm.searchFilters.dtTo) {
                query.filter.where.and.push({entryDate: {lte: vm.searchFilters.dtTo}});
            }
            // description contained
            if (vm.searchFilters.description) {
                query.filter.where.and.push({entryDescription: {like: '%' + vm.searchFilters.description + '%'}});
            }
            // entryValue from-to
            if (vm.searchFilters.entryValueFrom) {
                query.filter.where.and.push({entryValue: {gte: vm.searchFilters.entryValueFrom}});
            }
            if (vm.searchFilters.entryValueTo) {
                query.filter.where.and.push({entryValue: {lte: vm.searchFilters.entryValueTo}});
            }
            // paymentReason filter
            if (vm.searchFilters.paymentReasonId) {
                if (vm.searchFilters.paymentReasonId === -999999) {
                    query.filter.where.and.push({paymentReasonId: null});
                } else {
                    query.filter.where.and.push({paymentReasonId: vm.searchFilters.paymentReasonId});
                }
            }
            // organization filter
            if (vm.searchFilters.selectedOrganization && vm.searchFilters.selectedOrganization.id) {
                query.filter.where.and.push({organizationId: vm.searchFilters.selectedOrganization.id});
            }
            // offeredService filter
            if (vm.searchFilters.selectedOfferedService && vm.searchFilters.selectedOfferedService.id) {
                query.filter.where.and.push({offeredServiceId: vm.searchFilters.selectedOfferedService.id});
            }
            // user filter
            if (vm.searchFilters.selectedUser && vm.searchFilters.selectedUser.id) {
                query.filter.where.and.push({userId: vm.searchFilters.selectedUser.id});
            }

            // perform query
            EarningCost.count({where: query.filter.where}, function(totalNumber) {
                // $log.debug('query: ' + JSON.stringify(query,null,2));
                EarningCost.find(query, function(payments) {
                    vm.earningcosts = payments;
                    $log.debug(vm.earningcosts);

                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': payments
                    };
                    vm.searchFilters.loading.data = false;
                    fnCallback(records);
                });
            });
        }


        function backgroundImage() {
           if (vm.userProfile && vm.userProfile!==null && vm.userProfile.uriBackground && vm.userProfile.uriBackground !==null) {
               return {'background-image': 'url('+ApiPath+'/userDocumentsContainers/'+$rootScope.CYL_USER_DOC_PREFIX+vm.userProfile.id +'/download/'+vm.userProfile.uriBackground+')'};
           }
           return '';

        }

        function DialogController($scope, $mdDialog) {
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
          $scope.answer = function(answer) {
            $mdDialog.hide(answer);
          };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



       function goBack() {
         window.history.back();
       }

       function formatDate(date) {
           if (!date || date===null ) {
              return '-';
           }
           return moment(date).format('DD/MM/YYYY');
      }


       function sendMessage(ev) {
           $scope.myResource={};
           $mdDialog.show({
               controller: DialogController,
               templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
               parent: angular.element(document.body),
               targetEvent: ev,
               scope: $scope,
               preserveScope: true,
               clickOutsideToClose:true
           })
           .then(function(answer) {
               User.notifyUser({userId: vm.userId, subject: answer.title, text:answer.text }).$promise.then(
                       function(n,responseHeaders){
                           AlertMessageService.showSuccessMessage();
                       },
                       function(httpResponse){
                           $log.debug(httpResponse);
                           AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                       }
                  );
               Notification.create(
                       {senderId: vm.currentUserId,
                        recipientId: vm.userId,
                        title: answer.title,
                        text: answer.text,
                        notificationType: 'CHAT',
                        status: 'N',
                        notificationDate: new Date()
                       },
                       function(n,responseHeaders){
                           AlertMessageService.showSuccessMessage();
                       },
                       function(httpResponse){
                           $log.debug(httpResponse);
                           AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                       });

           });
      }


    /**
     * Ritorna un array unico di organizzazioni, dato uno che può avere più elementi duplicati
     * 
     * @param {*} organizations 
     * @returns {array}
     */
    function getUniqueOrganizations(organizations) {
        const ret = [];
        if (organizations && organizations.length > 0) {
            organizations.forEach(function(organization) {
                if (ret.findIndex(function(existingOrganization) {
                    return (existingOrganization && organization && organization.id === existingOrganization.id);
                }) === -1) {
                    ret.push(organization);
                }
            });
        }
        return ret;
    }


    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfileParentsController', ProfileParentsController);

    function ProfileParentsController($log, $state, $scope, $location, $rootScope, $translate, $mdToast, $mdDialog, LoopBackAuth, OfferedService, _,
                                      Organization, CylUtils, User, ServiceDoctype, Notification, UserIdentity, Payment, DictionaryService, SubscriptionDocument, UserRelation,
                                      Subscription, AlertMessageService, UserDocument, AuthenticationService, DTOptionsBuilder, ApiPath) {
        var userId;
        var preUpdateProfile;

        var vm = this;
        vm.apiPath = ApiPath;
        vm.loading = true;

        init();

        //////////

        function init() {
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
            vm.userId = userId.toString();
            vm.isUserDetail = ($location.path().startsWith('/user'));
            if (AuthenticationService.isAuthenticated()) {


                User.findById({id: userId, filter: {include: ['parents']}}).$promise.then(function(data) {
                    vm.child = data;
                    vm.loading = false;
                });

            } else {
                $state.go('app.pages_auth_login');
            }


        }

        vm.goToRelativeDetail = function(userId) {
            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
            if (vm.isUserDetail) {
                $state.go('app.pages_user_detail', {userId: userId});
            } else {
                $state.go('app.pages_profile_socio', {userId: userId});
            }
        }

    }

})();

(function() {
    'use strict';

    angular.module('app.pages.users').controller('ProfileDocumentsController', ProfileDocumentsController);

    function ProfileDocumentsController(
        $log,
        $state,
        $scope,
        $location,
        $rootScope,
        $translate,
        $mdToast,
        $mdDialog,
        LoopBackAuth,
        OfferedService,
        Organization,
        CylUtils,
        User,
        ServiceDoctype,
        Notification,
        UserIdentity,
        Payment,
        SubscriptionDocument,
        Subscription,
        AlertMessageService,
        UserDocumentsContainer,
        UserDocument,
        AuthenticationService,
        ApiPath,
        $q
    ) {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userDocuments = [];
        vm.accessToken = LoopBackAuth.accessTokenId;
        vm.apiPath = ApiPath;
        vm.isUserDetail = $location.path().startsWith('/user');
        // vm.sendMessage=sendMessage;

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target:
                ApiPath +
                '/userDocumentsContainers/' +
                $rootScope.CYL_USER_DOC_PREFIX +
                $state.params.userId +
                '/upload',
            chunkSize: 15 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            query: { cyl_type: vm.attachmentType },
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {},
            flowLogo: {},
            flowBackground: {},
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.deleteDocument = deleteDocument;
        vm.editDocument = editDocument;
        vm.formatDate = formatDate;
        vm.goBack = goBack;

        vm.gotoDocuments = gotoDocuments;
        vm.gotoRelatives = gotoRelatives;
        vm.gotoServices = gotoServices;
        vm.gotoPayments = gotoPayments;
        vm.gotoProfile = gotoProfile;

        vm.dragEnter = function() {
            //$log.debug("Drag Enter");
            $('#document-image-uploader').addClass('drag-enter');
        };

        vm.dragLeave = function() {
            //$log.debug("Drag Leave");
            $('#document-image-uploader').removeClass('drag-enter');
        };

        vm.apiPath = ApiPath;

        init();

        //////////

        function init() {
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = $state.params.userId ? $state.params.userId : User.getCurrentId();
            vm.userId = userId.toString();
            if (AuthenticationService.isAuthenticated()) {
                loadUserProfile(userId).then(
                    function(data) {
                        $log.debug(data);
                        var myUser = data;
                        vm.userProfile = JSON.parse(JSON.stringify(myUser));
                        vm.userIdentity = data.identities[0];

                        loadUserDocuments(userId).then(
                            function(data) {
                                $log.debug(data);
                                vm.userDocuments = data;
                            },
                            function(error) {
                                $log.debug(error);
                            }
                        );
                    },
                    function(error) {
                        $log.debug(error);
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }

            // $rootScope.$on('PAYMENTS_TO_BE_RELOADED', function (event, valore) {
            //     loadUserServices(vm.userProfile);
            // });
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', { organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION') });
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION'),
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', { userId: User.getCurrentId() });
        }

        function gotoDocuments() {
            $state.go('app.pages_profile_docs', { userId: userId });
        }

        function gotoRelatives() {
            $state.go('app.pages_profile_relatives', { userId: userId });
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', { userId: userId });
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', { userId: userId });
        }

        function gotoProfile() {
            $state.go('app.pages_profile_socio', { userId: userId });
        }

        function loadUserProfile(userId) {
            return User.findById({
                id: userId,
                filter: {
                    include: [
                        'identities',
                        { children: [{ subscriptions: { offeredService: ['organization', 'requiredDocuments'] } }] },
                        'parents',
                        { subscriptions: { offeredService: ['organization', 'requiredDocuments'] } },
                    ],
                },
            }).$promise;
        }

        function loadUserDocuments(userId) {
            var query = {
                filter: {
                    where: {
                        and: [{ userId: userId }, { flgActive: 1 }],
                    },
                    include: [
                        {
                            subscriptionDocuments: [
                                { subscription: [{ offeredService: ['organization'] }] },
                                'organizationDoctype',
                            ],
                        },
                    ],
                    order: 'created DESC',
                },
            };

            return UserDocument.find(query).$promise;
        }

        function fileAdded(file) {
            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: 'uploading',
            };

            vm.contentToUpload = uploadingFile;
            upload();
        }

        function upload(typeFile) {
            vm.contentToUpload.type = 'uploading';

            // Set headers
            vm.ngFlow.flow.opts.headers = {
                //'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
                //'Authorization' : 'Bearer {' + AuthenticationService.getToken() + '}'
            };

            vm.ngFlowOptions.query.cyl_type = 'FILE';
            vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
            vm.ngFlow.flow.upload();
        }

        function fileSuccess(file, message, typeFile) {
            $log.debug('fileSuccess');

            //PER FS recupero file FIXME
            var uri = JSON.parse(message).result.files.file[0].name;
            var size = JSON.parse(message).result.files.file[0].size;
            var mimetype = JSON.parse(message).result.files.file[0].type;

            //scrivo nella UserDocument
            UserDocument.create(
                {
                    userId: userId,
                    name: file.name,
                    uri: uri,
                    size: size,
                    mimetype: mimetype,
                    created: new Date(),
                    flgActive: 1,
                },
                function(org, responseHeaders) {
                    $log.debug('UserDocument create() riuscita: ');
                    $log.debug(org);
                    loadUserDocuments(userId).then(
                        function(data) {
                            vm.userDocuments = data;
                        },
                        function(error) {
                            $log.debug(error);
                        }
                    );

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .textContent($translate.instant('USERS.DOCUMENT_UPLOADED'))
                            .position('top right')
                            .hideDelay(3000)
                    );
                },
                function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                }
            );
        }

        function editDocument(document) {
            $scope.myResource = {};
            $scope.myResource.name = document.name;
            $scope.myResource.description = document.description;
            $mdDialog
                .show({
                    controller: DialogController,
                    templateUrl: 'app/main/pages/users/user_profile/tabs/documents/edit_document_dialog.html',
                    parent: angular.element(document.body),
                    scope: $scope,
                    preserveScope: true,
                    clickOutsideToClose: true,
                })
                .then(
                    function(answer) {
                        UserDocument.updateAll(
                            {
                                where: { id: document.id },
                            },
                            answer,
                            function(org, responseHeaders) {
                                loadUserDocuments(userId).then(
                                    function(data) {
                                        vm.userDocuments = data;
                                    },
                                    function(error) {
                                        $log.debug(error);
                                    }
                                );

                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent($translate.instant('USERS.DOCUMENT_MODIFIED'))
                                        .position('top right')
                                        .hideDelay(3000)
                                );
                            },
                            function(httpResponse) {
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            }
                        );
                    },
                    function() {
                        $log.debug('You cancelled the dialog.');
                    }
                );
        }

        function deleteDocument(document) {
            $mdDialog
                .show({
                    controller: DialogController,
                    templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                })
                .then(function(answer) {
                    document.flgActive = 0;
                    UserDocument.updateAll(
                        {
                            where: { id: document.id },
                        },
                        document,
                        function(org, responseHeaders) {
                            loadUserDocuments(userId).then(
                                function(data) {
                                    vm.userDocuments = data;
                                },
                                function(error) {
                                    $log.debug(error);
                                }
                            );

                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .textContent($translate.instant('USERS.DOCUMENT_DELETED'))
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        },
                        function(httpResponse) {
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );
                });
        }

        function backgroundImage() {
            if (
                vm.userProfile &&
                vm.userProfile !== null &&
                vm.userProfile.uriBackground &&
                vm.userProfile.uriBackground !== null
            ) {
                return {
                    'background-image':
                        'url(' +
                        ApiPath +
                        '/userDocumentsContainers/' +
                        $rootScope.CYL_USER_DOC_PREFIX +
                        vm.userProfile.id +
                        '/download/' +
                        vm.userProfile.uriBackground +
                        ')',
                };
            }
            return '';
        }

        function goBack() {
            window.history.back();
        }

        function formatDate(date) {
            if (!date || date === null) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        /**
         * Controller della modal per la scelta della subscription da associare al documento
         *
         * @param {*} $scope
         * @param {*} $mdDialog
         */
        function LinkDocumentSubscriptionDialogController($log, $scope, $mdDialog) {
            if ($scope.userSubscriptions) {
                $log.debug($scope.userSubscriptions);
            }
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        LinkDocumentSubscriptionDialogController.inject = ['$log', '$scope', '$mdDialog'];

        /**
         * Apre una modale per chiedere a quale delle subscription dell'utente corrente
         * correlare un documento.
         *
         *
         * @param {object} document
         */
        vm.AddSubscriptionDocument = function(userDocument) {
            $log.debug('ProfileDocumentsController.vm.AddSubscriptionDocument()');
            // estrapola delle subscription dell'utente
            var subscriptions = vm.getSubscriptions(vm.userProfile);
            // $log.debug('subscriptions: ' + JSON.stringify(subscriptions));
            $scope.userSubscriptions = subscriptions;
            $scope.userId = vm.userProfile.id;

            $mdDialog
                .show({
                    controller: LinkDocumentSubscriptionDialogController,
                    templateUrl:
                        'app/main/pages/users/user_profile/tabs/documents/dialogs/link-document-subscription-dialog.html',
                    parent: angular.element(document.body),
                    // targetEvent: ev,
                    scope: $scope,
                    preserveScope: true,
                    clickOutsideToClose: true,
                })
                .then(
                    function(subscriptionDocumentData) {
                        $log.debug(subscriptionDocumentData);
                        vm.addSubscriptionDocument(subscriptionDocumentData, userDocument).then(
                            function() {
                                loadUserDocuments(userId).then(
                                    function(data) {
                                        $log.debug(data);
                                        vm.userDocuments = data;
                                    },
                                    function(error) {
                                        $log.debug(error);
                                    }
                                );
                                AlertMessageService.showSuccessMessage();
                            },
                            function(err) {
                                // errore, avviso utente
                                $log.error(err);
                                // ignora errore se è perchè il subscriptionDocument esiste già
                                if (err && err.msg && err.msg !== 'existing') {
                                    AlertMessageService.showErrorAlert('Errore in condivisione documento');
                                }
                            }
                        );
                    },
                    function(err) {
                        $log.error(err);
                    }
                );
        };

        /**
         * Ritorna un elenco delle subsccription di un utente e dei suoi eventuali figli
         * Functional
         *
         * @param {*} user
         */
        vm.getSubscriptions = function(user) {
            var subscriptions = [];
            // cicla tra le subscription dell'utente
            if (user && user.subscriptions) {
                user.subscriptions.forEach(function(subscription) {
                    if (
                        subscription &&
                        subscription.offeredService &&
                        subscription.offeredService.organization &&
                        !subscription.offeredService.isDeleted &&
                        subscription.offeredService.requiredDocuments
                    ) {
                        subscription.offeredService.requiredDocuments.forEach(function(requiredDocument) {
                            if (requiredDocument) {
                                subscriptions.push({
                                    subscriptionId: subscription.id,
                                    offeredServiceId: subscription.offeredService.id,
                                    offeredServiceName: subscription.offeredService.name,
                                    requiredDocumentId: requiredDocument.id,
                                    requiredDocumentName: requiredDocument.name,
                                    organizationId: subscription.offeredService.organization.id,
                                    organizationName: subscription.offeredService.organization.name,
                                    userId: user.id,
                                    userName: (user.familyName + ' ' + user.givenName).trim(),
                                });
                            }
                        });
                    }
                });
            }
            // cicla tra le subscription dei figli
            if (user && user.children) {
                user.children.forEach(function(child) {
                    if (child && child.subscriptions) {
                        child.subscriptions.forEach(function(subscription) {
                            if (
                                subscription &&
                                subscription.offeredService &&
                                subscription.offeredService.organization &&
                                !subscription.offeredService.isDeleted &&
                                subscription.offeredService.requiredDocuments
                            ) {
                                subscription.offeredService.requiredDocuments.forEach(function(requiredDocument) {
                                    if (requiredDocument) {
                                        subscriptions.push({
                                            subscriptionId: subscription.id,
                                            offeredServiceId: subscription.offeredService.id,
                                            offeredServiceName: subscription.offeredService.name,
                                            requiredDocumentId: requiredDocument.id,
                                            requiredDocumentName: requiredDocument.name,
                                            organizationId: subscription.offeredService.organization.id,
                                            organizationName: subscription.offeredService.organization.name,
                                            userId: child.id,
                                            userName: (child.familyName + ' ' + child.givenName).trim(),
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }

            return subscriptions;
        };

        /**
         * Crea un nuovo
         * @param {*} subscriptionDocumentData
         * @param {*} userDocument
         */
        vm.addSubscriptionDocument = function(subscriptionDocumentData, userDocument) {
            $log.debug('vm.addSubscriptionDocument(subscriptionDocumentData, userDocument)');
            $log.debug(arguments);
            var deferred = $q.defer();
            var subscriptionDocument = {
                flgValidated: 0,
                isPaperDoc: false,
                subscriptionId: subscriptionDocumentData.subscriptionId,
                organizationDoctypeId: subscriptionDocumentData.requiredDocumentId,
                userDocumentId: userDocument.id,
            };
            // verifica che non vi sia già lo stesso subscriptionDocument associato all'userDocument
            var isExistingSubscriptionDocument = false;
            if (userDocument && userDocument.subscriptionDocuments) {
                userDocument.subscriptionDocuments.forEach(function(existingSubscriptionDocument) {
                    if (existingSubscriptionDocument &&
                        existingSubscriptionDocument.userDocumentId === subscriptionDocument.userDocumentId &&
                        existingSubscriptionDocument.organizationDoctypeId === subscriptionDocument.organizationDoctypeId &&
                        existingSubscriptionDocument.subscriptionId === subscriptionDocument.subscriptionId) {
                        isExistingSubscriptionDocument = true;
                    }
                });
            }
            if (!isExistingSubscriptionDocument) {
                $log.debug(subscriptionDocument);
                SubscriptionDocument.create(
                    subscriptionDocument,
                    function(result) {
                        deferred.resolve(result);
                    },
                    function(err) {
                        deferred.reject({msg: 'error'});
                    }
                );
            } else {
                deferred.reject({msg: 'existing'});
            }
            return deferred.promise;
        };

        /**
         * Rimuove l'associazione di un documento con un servizio
         * @param {object} subscriptionDocument
         */
        vm.deleteSubscriptionDocument = function(subscriptionDocument) {
            $log.debug('vm.deleteSubscriptionDocument()');
            $log.debug(subscriptionDocument);
            if (subscriptionDocument && subscriptionDocument.id) {
                var confirm = $mdDialog
                    .confirm()
                    .title('Conferma')
                    .textContent(
                        "Proseguendo, il documento non sarà più associato al servizio e l'associazione nno sarà più in grado di consultarlo. Potrai in ogni momento associarlo nuovamente."
                    )
                    .ariaLabel('Conferma')
                    .clickOutsideToClose(true)
                    .ok('Rimuovi')
                    .cancel('Annulla');
                $mdDialog.show(confirm).then(
                    function() {
                        SubscriptionDocument.deleteById({ id: subscriptionDocument.id }).$promise.then(
                            function(result) {
                                loadUserDocuments(userId).then(
                                    function(data) {
                                        vm.userDocuments = data;
                                    },
                                    function(error) {
                                        $log.debug(error);
                                    }
                                );
                                AlertMessageService.showSuccessMessage();
                            },
                            function(err) {
                                $log.error(err);
                                AlertMessageService.showErrorAlert('Errore in rimozione condivisione documento');
                            }
                        );
                    },
                    function() {
                        // annullato, non fa nulla
                    }
                );
            }
        };
    }
})();

'use strict';

(function (){
    angular
        .module('app.pages.users')
        .controller('ProfileAttendancesController', ProfileAttendancesController);


    function ProfileAttendancesController($log, $state, $scope, $rootScope, $compile, _,
                                          AuthenticationService, DTOptionsBuilder, DTColumnBuilder,
                                          breadcrumbManager, User, Attendance, OfferedService) {
        var vm = this;
        var self = this;
        // utente di cui vedo i dati
        vm.userId = $state.params.userId || User.getCurrentId();
        vm.user = null;
        // organizzazione corrente
        vm.organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION') || null;

        // filtri di ricerca
        vm.searchFilter = {
            userId: vm.userId,
            organizationId: vm.organizationId,
            offeredService: null,
            carnet: null,
            dateFrom: null,
            dateTo: null,
        };
        vm.offeredServices = [];        // elenco servizi per dropdown filtro
        vm.carnet = [];                 // elenco carnet per dropdown filtro

        // datatable
        vm.dtInstance = null;
        vm.dtOptions = null;
        vm.dtColumns = null;


        /**
         * Al cambio del periodo di riferimento, reimposta il filtro e ricarica i dati
         */
        $rootScope.$on('REF_PERIOD_CHANGED', function (event, value) {
            // self.loadDtItems();
            vm.dtInstance.DataTable.draw();
        });


        /**
         * Inizializza la finestra caricando utente e avviando l'inizializzazione della datatable
         */
        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                // carica utente correntemente visualizzato
                self.loadUser(vm.userId).then(
                    function(user) {
                        // $log.debug('user: ' + JSON.stringify(user));
                        vm.user = JSON.parse(JSON.stringify(user));
                    }
                );
                self.initDataTable();
                self.loadDtItems();
                self.loadFiltersData();
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Inizializza la tabella con i dati
         */
        self.initDataTable = function() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withOption('serverSide', true)
                .withFnServerData(self.loadDtItems)
                .withDataProp('data')
                .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
                .withOption('responsive', true)
                .withOption('autoWidth', false)
                .withDisplayLength(50)
                .withPaginationType('full_numbers')
                .withOption('createdRow', function(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                .withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            vm.dtColumns = [
                DTColumnBuilder.newColumn('user').withTitle('Utente').renderWith(self.renderDtColumnUtente),
                DTColumnBuilder.newColumn('data').withTitle('Data').renderWith(self.renderDtColumnData),
                DTColumnBuilder.newColumn('service').withTitle('Servizio').renderWith(self.renderDtColumnServizio),
                DTColumnBuilder.newColumn('carnet').withTitle('Carnet').renderWith(self.renderDtColumnCarnet),
                DTColumnBuilder.newColumn('present').withTitle('Presente').renderWith(self.renderDtColumnPresente),
                DTColumnBuilder.newColumn('actions').withTitle('Azioni').notSortable().renderWith(self.renderDtColumnActions),
            ];
        };


        /**
         * Disegno di valori delle celle della tabella
         *
         * @param data
         * @param type
         * @param item
         * @returns {string}
         */
        self.renderDtColumnUtente = function(data, type, item) {
            return (item.userFamilyName + ' ' + item.userGivenName).trim().toUpperCase();
        };
        self.renderDtColumnData = function(data, type, item) {
            return moment(item.day, 'YYYYMMDD').format('DD/MM/YYYY');
        };
        self.renderDtColumnServizio = function(data, type, item) {
            return item.offeredServiceName;
        };
        self.renderDtColumnCarnet = function(data, type, item) {
            return item.carnetName;
        };
        self.renderDtColumnPresente = function(data, type, item) {
            return (item.present ? '' : 'non ') + 'presente';
        };
        self.renderDtColumnActions = function(data, type, item) {
            return vm.getDtButtonHtml('Dettagli carnet', 'icon-credit-card', 'vm.gotoUserCarnet(' + item.userId + ', ' + item.organizationId + ', ' + item.orderId + ');', false) +
                vm.getDtButtonHtml('Vedi presenze data', 'icon-account-check', 'vm.gotoPresenzeData(' + item.offeredServiceId + ', ' + item.day + ');', false);
        };


        /**
         * Carica una paginata di dati dalla tabella
         *
         * @param sSource
         * @param aoData
         * @param fnCallback
         * @param oSettings
         */
        self.loadDtItems = function(sSource, aoData, fnCallback, oSettings) {
            var draw =  null;
            var order = null;
            var start = null;
            var length = null;
            if (aoData && aoData[0] && aoData[2] && aoData[3] && aoData[4]) {
                draw = aoData[0].value;
                order = aoData[2].value;
                start = aoData[3].value;
                length = aoData[4].value;
            }

            // legge periodo di riferimento e imposta il filtro sui dati
            if (draw) {
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    var dateFrom = null, dateTo = null;
                    if (refPeriod) {
                        dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : '20000101';
                        dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : '29991231';
                    }
                    vm.searchFilter.dateFrom = dateFrom;
                    vm.searchFilter.dateTo = dateTo;

                    // copia l'oggetto dei filtri senza le poprietà null
                    var filters = {};
                    _.each(_.keys(vm.searchFilter), function(key) {
                        if (vm.searchFilter[key] && key !== 'offeredService' && key !== 'carnet') {
                            filters[key] = vm.searchFilter[key];
                        }
                    });
                    if (vm.searchFilter.offeredService && vm.searchFilter.offeredService.id) {
                        filters.offeredServiceId = vm.searchFilter.offeredService.id.toString();
                    }
                    if (vm.searchFilter.carnet && vm.searchFilter.carnet.id) {
                        filters.carnetId = vm.searchFilter.carnet.id.toString();
                    }
                    // $log.debug('filters: ' + JSON.stringify(filters));

                    Attendance.fetchAttendances(filters).$promise.then(
                        function(attendances) {
                            attendances = JSON.parse(JSON.stringify(attendances));

                            // filtra la paginazione
                            var recordsTotal = attendances.length;
                            var i = 0;
                            var items = [];
                            _.each(attendances, function(item) {
                                if (i >= start && i < start+length) {
                                    items.push(item);
                                }
                                i++;
                            });
                            attendances = JSON.parse(JSON.stringify(items));

                            fnCallback({
                                'draw': draw,
                                'recordsTotal': recordsTotal,
                                'recordsFiltered': recordsTotal,
                                'data': attendances,
                            });
                        },
                        function(err) {
                            $log.error('Errore chiamando Attendance.fetchAttendances():');
                            $log.error(err);
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': []
                            });
                        }
                    );
                });
            }
        };


        /**
         * Carica i dati di un utente
         *
         * @param id
         * @returns {Resource.$promise|_.$promise}
         */
        self.loadUser = function(id) {
            return User.findById(
                { id: id, },
                { filter: { include: ['parents', 'parentRelations'] }}
            ).$promise;
        };


        /**
         * Carica i dati necessari a popolare i filtri
         */
        self.loadFiltersData = function() {
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: vm.organizationId,
                        isDeleted: false,
                    }
                }
            }).$promise.then(
                function(services) {
                    services = JSON.parse(JSON.stringify(services));
                    _.each(services, function(service) {
                        if (service.isCarnet) {
                            vm.carnet.push(service);
                        } else if (!service.isPaymentPlan) {
                            vm.offeredServices.push(service);
                        }
                    });
                    // $log.debug('vm.offeredServices: ' + JSON.stringify(vm.offeredServices));
                    // $log.debug('vm.carnet: ' + JSON.stringify(vm.carnet));
                },
                function(err) {
                    $log.error('Errore leggendo i servizi:');
                    $log.error(err);
                }
            );
        };


        /**
         * Returns the html code to generate a button
         *
         * @param {string} label
         * @param {string} icon
         * @param {string} fn
         * @returns {string}
         */
        vm.getDtButtonHtml = function(label, icon, fn, disabled) {
            return '<md-button class="edit-button md-icon-button" ' +
                'aria-label="' + label + ' " ng-click="' + fn + '" ' +
                (disabled ? 'ng-disabled="true" ' : '') + '>' +
                '    <md-icon md-font-icon="' + icon + '"></md-icon>' +
                '</md-button>';
        };



        /**
         * Va al dettaglio dei carnet (magari evidenziando lo specifico order indicato).
         *
         * @param userId
         * @param organizationId
         * @param orderId Facoltativo, se impostato apre il dettaglio di uno specifico Order
         */
        vm.gotoUserCarnet = function(userId, organizationId, orderId) {
            $state.go('app.pages_user_carnet', { userId: userId, organizationId: organizationId, orderId: orderId });
        };



        /**
         * Va al dettaglio delle presenze per una certa data
         *
         * @param offeredServiceId
         * @param day
         */
        vm.gotoPresenzeData = function(offeredServiceId, day) {
            $state.go('app.pages_attendance_detail', { offeredServiceId: offeredServiceId, day: day });
        };

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations',
            [
                'datatables','ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.organizations', {
                url      : '/organizations',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organizations/organizations.html',
                        controller : 'OrganizationsController as vm'
                    }
                }
            })
            .state('app.organization', {
                url      : '/organizations/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization/organization.html',
                        controller : 'OrganizationController as vm'
                    }
                }
            })
            .state('app.organization_startpage', {
                url      : '/organizations/:organizationId/start',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_startpage/organization_startpage.html',
                        controller : 'OrganizationStartpageController as vm'
                    }
                }
            })
            .state('app.organization_privacy', {
                url      : '/organizations/:clubyourlifeId/privacy',
                views    : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.organization_privacy': {
                        templateUrl: 'app/main/pages/organizations/views/privacy_page/organization_privacy.html',
                        controller : 'OrganizationPrivacyController as vm'
                    }
                }
            })
            .state('app.organization_settings', {
                url      : '/organizations/:organizationId/settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_settings/organization_settings.html',
                        controller : 'OrganizationSettingsController as vm'
                    }
                }
            })
            .state('app.organization_plans', {
                url      : '/organizations/:organizationId/plans',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_settings/organization_settings.html',
                        controller : 'OrganizationSettingsController as vm'
                    }
                }
            })
            .state('app.organization_changeplan', {
                url      : '/organizations/:organizationId/changeplan/result/:success',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/changeplan/changeplan.html',
                        controller : 'OrganizationChangePlanController as vm'
                    }
                }
            })
            .state('app.organization_welcome_page', {
                url      : '/organizations/:organizationId/welcome',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_settings/organization_welcome_page.html',
                        controller : 'OrganizationSettingsController as vm'
                    }
                }
            })
            .state('app.organization_members', {
                url      : '/organizations/:organizationId/members',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_members/organization_members.html',
                        controller : 'OrganizationMembersController as vm'
                    }
                }
            })
            .state('app.organization_resources', {
                url      : '/organizations/:organizationId/resources',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_resources/organization_resources.html',
                        controller : 'OrganizationResourcesController as vm'
                    }
                }
            })
            .state('app.organization_services', {
                url      : '/organizations/:organizationId/services/:serviceType',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_services/organization_services.html',
                        controller : 'OrganizationServicesController as vm'
                    }
                }
            })
            .state('app.organization_events', {
                url      : '/organizations/:organizationId/events/:serviceType',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization_services/organization_services.html',
                        controller : 'OrganizationServicesController as vm'
                    }
                }
            })
            .state('app.clubyourlife', {
                url      : '/club/:clubyourlifeId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization/organization.html',
                        controller : 'OrganizationController as vm'
                    }
                }
            })
            .state('app.new_organization', {
                url      : '/new_organization',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/new_organization/new_organization.html',
                        controller : 'NewOrganizationController as vm'
                    }
                }
            })
            .state('app.edit_organization', {
                url      : '/organizations/:organizationId/edit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/organizations/views/organization/edit-organization.html',
                        controller : 'OrganizationController as vm'
                    }
                }
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/organizations');


    }
})();

'use strict';

(function() {
    angular.module('app.pages.organizations').controller(
        'QuoteIscrizioneController', QuoteIscrizioneController);

    /** @ngInject */
    function QuoteIscrizioneController($log, $state, $scope, $mdDialog, _, AlertMessageService, AuthenticationService,
                                       User, Organization, OfferedService, OfferedServiceTypeRelation,
                                       ServiceType) {
        var vm = this;
        vm.organizationId = null;
        vm.organization = null;
        vm.items = [];
        vm.loading = false;


        /**
         * Inizializzazione controller
         */
        vm.init = function() {
            $log.debug('QuoteIscrizioneController.init()');
            vm.items = [];
            vm.loading = true;
            if (AuthenticationService.isAuthenticated()) {
                var currentUserId = User.getCurrentId().toString();
                vm.organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION');
                // legge servizi
                vm.loadItems();
                // legge l'organizzazione
                if (vm.organizationId) {
                    Organization.findById({id: vm.organizationId}).$promise.then(
                        function(organization) {
                            vm.organization = JSON.parse(JSON.stringify(organization));
                        },
                        function(httpResponse) {
                            $log.error(httpResponse);
                        }
                    );
                } else {
                    $state.go('app.organizations');
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica gli elementi
         */
        vm.loadItems = function() {
            if (vm.organizationId) {
                OfferedService.find({
                    filter: {
                        where: {
                            organizationId: vm.organizationId,
                            isDeleted: false,
                        },
                        include: ['serviceTypes', 'offeredServiceTypeRelations'],
                    }
                }).$promise.then(
                    function(items) {
                        vm.items = JSON.parse(JSON.stringify(items));
                        // filtra eliminando i servizi che non sono sottoscrizioni
                        vm.items = _.filter(vm.items, function(item) {
                            var ret = false;
                            if (item && item.serviceTypes) {
                                _.each(item.serviceTypes, function(serviceType) {
                                    if (serviceType.internalCode === 'SUBSCRIPTION') {
                                        ret = true;
                                    }
                                });
                            }
                            return ret;
                        });
                        // aggiunge le metainformaizoni di servizio all'elemento
                        _.each(vm.items, function(item) {
                            item._info = {
                                editing: false
                            };
                        });
                        vm.loading = false;
                        $log.debug(vm.items);
                    },
                    function(httpResponse) {
                        $log.error(httpResponse);
                        vm.loading = false;
                    }
                );
            }
        };



        /**
         * Avvia l'edit di un elemento
         *
         * @param item
         */
        vm.editItem = function(item) {
            if (item && !item._info) {
                item._info = {};
            }
            if (item && item._info) {
                item._info.editing = true;
                // salva i valori prima dell'edit
                item._info.backup = {
                    name: item.name,
                    description: item.description,
                    subscriptionPrice: item.subscriptionPrice,
                    start: item.start,
                    end: item.end
                };
            }
        };


        /**
         * Annulla l'edit di un elemento
         *
         * @param item
         */
        vm.unEditItem = function(item) {
            if (item && !item._info) {
                item._info = {};
            }
            if (item && item._info) {
                // se era un elemento nuovo, lo elimino
                if (item._info.new) {
                    var itemPosition = _.findIndex(vm.items, function(item) {
                        return item && item._info && item._info.new;
                    });
                    if (itemPosition >= 0) {
                        vm.items.splice(itemPosition, 1);
                    }
                } else {
                    item._info.editing = false;
                    // ripristina i valori di prima dell'edit
                    if (item._info.backup) {
                        item.name = item._info.backup.name;
                        item.description = item._info.backup.description;
                        item.subscriptionPrice = item._info.backup.subscriptionPrice;
                        item.start = item._info.backup.start;
                        item.end = item._info.backup.end;
                        delete item._info.backup;
                    }
                }
            }
        };


        /**
         * Crea un nuovo elemento, da salvare
         */
        vm.newItem = function() {
            var item = {
                description: '',
                end: null,
                name: 'Nuova quota associativa',
                organizationId: vm.organizationId,
                paymentType: 'O',
                serviceType: 'SERVICE',
                standalone: 'S',
                start: null,
                subscriptionPrice: 0,
                _info: {
                    new: true,
                },
                isDeleted: false,
            };
            vm.items.push(item);
            vm.editItem(item);
        };


        /**
         * Salva un elemento, creandolo se nuovo e aggiornandolo se non nuovo
         *
         * @param item
         */
        vm.saveItem = function(item) {
            if (item && item._info) {
                item._info.saving = true;
                // se deve aggiornare
                if (item.id) {
                    OfferedService.update({
                            where: {id: item.id}
                        },
                        {
                            name: item.name,
                            description: item.description,
                            subscriptionPrice: item.subscriptionPrice,
                            start: item.start || null,
                            end: item.end || null,
                        },
                        function(updatedItem) {
                            item._info.saving = false;
                            item._info.editing = false;
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse) {
                            $log.error(httpResponse);
                            item._info.saving = false;
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                } else {
                    // se deve creare un elemento nuovo
                    OfferedService.create(item).$promise.then(
                        function(itemInstance) {
                            // aggiunge la relazione con la quota associativa
                            ServiceType.find({
                                where: {
                                    organizationId: vm.organizationId,
                                    internalCode: 'SUBSCRIPTION'
                                }
                            }).$promise.then(
                                function(serviceTypes) {
                                    if (serviceTypes.length > 0) {
                                        OfferedServiceTypeRelation.create({
                                            offeredServiceId: itemInstance.id,
                                            serviceTypeId: serviceTypes[0].id
                                        }).$promise.then(
                                            function(serviceTypeRelation) {
                                                // ricarica gli elementi
                                                vm.loadItems();
                                                AlertMessageService.showSuccessMessage();
                                            },
                                            function(httpResponse) {
                                                $log.error(httpResponse);
                                                item._info.saving = false;
                                                AlertMessageService.showErrorAlert(httpResponse);
                                            }
                                        );
                                    }
                                },
                                function(httpResponse) {
                                    $log.error(httpResponse);
                                    item._info.saving = false;
                                    AlertMessageService.showErrorAlert(httpResponse);
                                }
                            );
                        },
                        function(httpResponse) {
                            $log.error(httpResponse);
                            item._info.saving = false;
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                }
            }
        };


        /**
         * Elimina un elemento
         * @param item
         */
        vm.deleteItem = function(item) {
            // prima chiede conferma con una dialog
            var confirm = $mdDialog.confirm()
                .title('Conferma eliminazione quota')
                .textContent('Confermi di voler eliminare la quota associativa "' + item.name + '"?')
                .ariaLabel('Conferma eliminazione quota')
                .ok('Elimina quota')
                .cancel('Annulla')
                .clickOutsideToClose(true);
            $mdDialog.show(confirm).then(
                // confermo eliminazione quota
                function() {
                    // salvo le offeredServiceTypeRelation, da eliminare poi
                    var ostrIds = [];
                    _.each(item.offeredServiceTypeRelations, function(ostr) {
                        ostrIds.push(ostr.id);
                    });
                    // elimino OfferedService
                    OfferedService.deleteById({
                        id: item.id
                    }).$promise.then(
                        function() {
                            // elimino OfferedServiceTypeRelation senza più servizio (best effort)
                            _.each(ostrIds, function(ostrId) {
                                OfferedServiceTypeRelation.deleteById({
                                    id: ostrId
                                }).$promise.then(
                                    function() {
                                        $log.debug('Eliminato OfferedServiceTypeRelation id: ' + ostrId);
                                    },
                                    function(httpResponse) {
                                        $log.error(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse);
                                    }
                                );
                            });
                            // ricarica gli elementi
                            vm.loadItems();
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse) {
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        }
                    );
                },
                function() {
                    $log.debug('cancel');
                });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('ServiceTypesController', ServiceTypesController);

    /** @ngInject */
    function ServiceTypesController($rootScope, $scope,  $mdDialog, $compile, DTOptionsBuilder, UserOrganizationRole, DTColumnBuilder, $log,
                                 $translate, AuthenticationService,  User, Organization, $location,  $state, ServiceType, AlertMessageService, _) {
        var vm = this;
        var userId;

        vm.loadServiceTypes=loadServiceTypes;
        vm.serviceTypes=[];
        vm.deleteServiceType=deleteServiceType;
        vm.dtInstance = {};
        vm.reloadServiceTypes=reloadServiceTypes;
        vm.addServiceType=addServiceType;
        vm.editServiceType=editServiceType;
        vm.init=init;

        var organizationId = organizationId;
        init();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadServiceTypes)
            .withOption('processing', true)
            .withDataProp('data')
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            //			.withOption('rowCallback', rowCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('name').withTitle($translate.instant('ORGANIZATIONS.NAME')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null) {
                        ret+= data;
                    }
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function (data,type, row) {
                    if (row.internalCode && row.internalCode!==null && row.internalCode!=='') {
                        return '';
                    }
                    return '<md-button class="edit-button md-icon-button" ng-click="serviceTypesVm.deleteServiceType('+row.id +');" ><md-icon md-font-icon="icon-delete" ></md-icon></md-button>';
                }),
        ];

        $rootScope.$on('$translateChangeEnd', function () {
            updateTableLocale();
        });

        function init(orgId) {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                organizationId=orgId;
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function loadServiceTypes(sSource, aoData, fnCallback, oSettings) {

            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            var query ={
                filter: {
                    where : {organizationId: organizationId },
                    limit: length,
                    order: 'name ASC',
                    skip: start
                }
            };

            ServiceType.count({where: query.filter.where}, function(totalNumber) {

                ServiceType.find(query, function(rts) {
                    vm.serviceTypes=rts;

                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': rts
                    };
                    fnCallback(records);

                });
            });


        }




        function reloadServiceTypes() {
            //$rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }

        function deleteServiceType(id) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to delete....');
                    var query = {serviceTypeId: id, organizationId: organizationId};
                    // UserOrganizationRole.count({where: query}, function(res) {
                    //     if (!res || res===null || res.count===0) {
                    ServiceType.deleteById({
                        id: id
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        reloadServiceTypes();
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                    //     }
                    //     else {
                    //         AlertMessageService.showErrorAlert($translate.instant('ORGANIZATIONS.ERRORS.ROLE_TYPE_IN_USE'));
                    //
                    //     }
                    //
                    // });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });




        }


        function editServiceType(serviceTypeId, serviceTypeName) {
            $scope.serviceTypeName = serviceTypeName;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/service_types/dialogs/edit_servicetype_dialog.html',
                        parent : angular.element(document.body),
                        scope : $scope,
                        preserveScope : true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveServiceType(serviceTypeId, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
            setTimeout(function() {
                $('#idOrganizationRoleName').focus();
            }, 1000);
        }


        function addServiceType(ev) {
            $scope.serviceTypeName = null;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/service_types/dialogs/new_servicetype_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveServiceType(null, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
            setTimeout(function() {
                $('#idOrganizationRoleName').focus();
            }, 1000);
        }


        function saveServiceType(serviceTypeId, serviceType) {
            serviceType.organizationId = organizationId;
            if (serviceTypeId && serviceTypeId !== null) {
                serviceType.id = serviceTypeId;
            }

            if (serviceType.id && serviceType.id !== null) {
                ServiceType.update({
                    where : {
                        id : serviceType.id
                    }
                }, serviceType, function(value, responseHeaders) {
                    reloadServiceTypes();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });
            } else {
                ServiceType.create(serviceType, function(org, responseHeaders) {
                    reloadServiceTypes();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });
            }

        }


        function updateTableLocale() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            setTimeout(function() {
                vm.dtInstance.DataTable.column(1).header().textContent=$translate.instant('ORGANIZATIONS.NAME');

            }, 300);
        }

        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function formatRowCell(data, row) {
            return '<span style=\'cursor:pointer; text-decoration: underline;\'  ng-click="serviceTypesVm.editServiceType('+row.id +', \''+row.name+'\');" >'+data+'</span>';
        }



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('RoleTypesController', RoleTypesController);

    /** @ngInject */
    function RoleTypesController($rootScope, $scope,  $mdDialog, $compile, DTOptionsBuilder, UserOrganizationRole, DTColumnBuilder, $log,
                                 $translate, AuthenticationService,  User, Organization, $location,  $state, RoleType, AlertMessageService, _)
    {
        var vm = this;
        var userId;

        vm.loadRoleTypes=loadRoleTypes;
        vm.roleTypes=[];
        vm.deleteRoleType=deleteRoleType;
        vm.dtInstance = {};
        vm.reloadRoleTypes=reloadRoleTypes;
        vm.addRoleType=addRoleType;
        vm.editRoleType=editRoleType;
        vm.init=init;

        var organizationId = organizationId;
        init();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadRoleTypes)
            .withOption('processing', true)
            .withDataProp('data')
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            //			.withOption('rowCallback', rowCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('name').withTitle($translate.instant('ORGANIZATIONS.NAME')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= data;
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function (data,type, row) {
                    if (row.internalCode && row.internalCode!==null && row.internalCode!=='')
                        return '';
                    return '<md-button class="edit-button md-icon-button" ng-click="roleTypesVm.deleteRoleType('+row.id +');" ><md-icon md-font-icon="icon-delete" ></md-icon></md-button>';
                }),
        ];

        $rootScope.$on('$translateChangeEnd', function () {
            updateTableLocale();
        });

        function init(orgId) {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                organizationId=orgId;
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function loadRoleTypes(sSource, aoData, fnCallback, oSettings) {

            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            var query ={
                filter: {
                    where : {organizationId: organizationId },
                    limit: length,
                    order: 'name ASC',
                    skip: start
                }
            };

            RoleType.count({where: query.filter.where}, function(totalNumber) {

                RoleType.find(query, function(rts) {
                    vm.roleTypes=rts;

                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': rts
                    };
                    fnCallback(records);

                });
            });


        }




        function reloadRoleTypes() {
            //$rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }

        function deleteRoleType(id) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/organizations/views/role_types/dialogs/delete_roletype_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to delete....');
                    var query = {roleTypeId: id, organizationId: organizationId};
                    UserOrganizationRole.count({where: query}, function(res) {
                        if (!res || res===null || res.count===0) {
                            RoleType.deleteById({
                                id: id
                            }).$promise.then(function(data) {
                                $log.debug('success');
                                $log.debug(data);
                                reloadRoleTypes();
                            },function(httpResponse){
                                $log.debug('error');
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                        }
                        else {
                            AlertMessageService.showErrorAlert($translate.instant('ORGANIZATIONS.ERRORS.ROLE_TYPE_IN_USE'));

                        }

                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });




        }


        function editRoleType(roleTypeId, roleTypeName) {
            $scope.roleName = roleTypeName;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/role_types/dialogs/edit_role_dialog.html',
                        parent : angular.element(document.body),
                        scope : $scope,
                        preserveScope : true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveRoleType(roleTypeId, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
            setTimeout(function() {
                $('#idOrganizationRoleName').focus()
            }, 1000);
        }


        function addRoleType(ev) {
            $scope.roleName = null;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/role_types/dialogs/new_role_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveRoleType(null, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
            setTimeout(function() {
                $('#idOrganizationRoleName').focus()
            }, 1000);
        }


        function saveRoleType(roleTypeId, roleType) {
            roleType.organizationId = organizationId;
            if (roleTypeId && roleTypeId !== null) {
                roleType.id = roleTypeId;
            }

            if (roleType.id && roleType.id !== null) {
                RoleType.update({
                    where : {
                        id : roleType.id
                    }
                }, roleType, function(value, responseHeaders) {
                    reloadRoleTypes();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);

                });
            } else {
                RoleType.create(roleType, function(org, responseHeaders) {
                    reloadRoleTypes();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);

                });
            }

        }


        function updateTableLocale() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            setTimeout(function() {
                vm.dtInstance.DataTable.column(1).header().textContent=$translate.instant('ORGANIZATIONS.NAME');

            }, 300);
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        function formatRowCell(data, row) {
            return '<span style=\'cursor:pointer; text-decoration: underline;\'  ng-click="roleTypesVm.editRoleType('+row.id +', \''+row.name+'\');" >'+data+'</span>';
        }



    }

})();

(function() {
	'use strict';

	angular.module('app.pages.organizations').controller(
			'OrganizationPrivacyController', OrganizationPrivacyController);

	/** @ngInject */
	function OrganizationPrivacyController($log, $document, $rootScope, $scope,$compile,$sce,
			$mdDialog, $state, $translate, AuthenticationService, Organization, User, LoopBackAuth,
			DTOptionsBuilder, DTColumnDefBuilder, AlertMessageService, ApiPath) {
		var vm = this;

		// Data
        vm.apiPath=ApiPath;
        vm.clubyourlifeId=null;
        vm.organization={};
        vm.backgroundImage=backgroundImage;
        vm.trustedHtml='';

        init();

		/**
		 * Initialize
		 */
		function init() {
			//pagina pubblica
    		vm.clubyourlifeId = $state.params.clubyourlifeId;
			if (vm.clubyourlifeId && vm.clubyourlifeId!==null) {
				loadOrganization();
			}

		}

		function loadOrganization() {
		    findOrganizationByCylID(vm.clubyourlifeId)
			.then(
				function(data) {
					var myOrganization = data;
					vm.organization = (JSON.parse(JSON
							.stringify(myOrganization[0])));
					vm.trustedHtml = $sce.trustAsHtml(vm.organization.privacyPolicy);
				}, function(error) {
					$log.debug(error);
				});
		}



       function backgroundImage() {
           if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
               return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
           }
           return '';

       }

        function findOrganizationByCylID() {
            return Organization.find({filter:{
                where : {
                    clubyourlifeId:vm.clubyourlifeId
                }
            }
            }).$promise;
        }

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('OrganizationsController', OrganizationsController);

    /** @ngInject */
    function OrganizationsController($log, $state, $scope, $rootScope, $translate, User, Organization, AuthenticationService, DTOptionsBuilder,DTColumnDefBuilder,AlertMessageService,OfferedService,ApiPath, $mdDialog, breadcrumbManager)
    {
        var vm = this;

        // Data
        vm.organizations = [];
        vm.deleteOrganization=deleteOrganization;

//        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
//            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
//            $('td', nRow).unbind('click');
//            $('td', nRow).bind('click', function() {
//                $scope.$apply(function() {
//                    //vm.someClickHandler(aData);
//                	vm.goToOrganizationDetail(aData[0]);
//                });
//            });
//            return nRow;
//        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('scrollY','auto')
            .withOption('responsive',true)
            .withDisplayLength(100)
            .withOption('autoWidth', false)
            //			.withOption('rowCallback', rowCallback)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('initComplete',function (){
                var api = this.api(),
                    searchBox = angular.element('body').find('#organizations-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            });
//        vm.dtColumnDefs = [
//            DTColumnDefBuilder.newColumnDef(0).notVisible(),
//            DTColumnDefBuilder.newColumnDef(1).notSortable(),
//            DTColumnDefBuilder.newColumnDef(2),
//            DTColumnDefBuilder.newColumnDef(3).notSortable()
//        ];


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });

        // Methods
        vm.goToOrganizationDetail = goToOrganizationDetail;
        vm.goToNewOrganization = goToNewOrganization;
        vm.apiPath=ApiPath;
        init();

        /**
         * Initialize
         */
        function init()
        {
            if (AuthenticationService.isAuthenticated()){
                AuthenticationService.loggedUser().then(
                    function(value,headers){
                        vm.user = value;
                        $log.debug(vm.user);

                        breadcrumbManager.popOrganization();
                        breadcrumbManager.popOfferedService();

                        loadUser( vm.user.id ).then(function(user){
                            loadOrganizations(user).then(
                                function(data){
                                    vm.organizations = _.filter(data.result.organizations, function (o) { return o.isAdmin; });
                                    vm.organizations = _.sortBy(vm.organizations, function(o){ return o.name; });
                                    $rootScope.$emit('ORGANIZATION_SELECTED', null);
                                });
                        });


                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }


        }
        //////////

        /**
         * Go to product detail
         *
         * @param id
         */
        function goToOrganizationDetail(organizationId)
        {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);
            $rootScope.$emit('ORGANIZATION_SELECTED', organizationId);
            $state.go('app.organization', {organizationId: organizationId});
        }

        function goToNewOrganization()
        {
            $state.go('app.new_organization');
        }

        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function deleteOrganization(organizationId){
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    //controllo se la associazione ha servizi associati
                    OfferedService.count({
                        where : {dtDel: null, organizationId: organizationId}
                    }, function(totalNumber) {
                        if (totalNumber.count && totalNumber.count>0)  {
                            //ERRORE: ci sono servizi associati
                            AlertMessageService.showErrorAlert("ORGANIZATIONS.ERRORS.CANT_DELETE_HAS_SERVICES");
                        }
                        else {
                            $log.debug('OrganizationsController.deleteOrganization()');
                            Organization.findById({
                                id : organizationId
                            }).$promise.then(function(org) {
                                org.dtDel=new Date();
                                Organization.prototype$patchAttributes(
                                    { id: org.id },
                                    org).$promise.then(function (res) {
                                    loadUser(User.getCurrentId()).then(function(user){
                                        loadOrganizations(user).then(
                                            function(data){
                                                //aggiorno il menu

                                                vm.organizations = _.filter(data.result.organizations, function (o) { return o.isAdmin; });
                                                $rootScope.$emit('ORGANIZATION_DELETED',organizationId);
                                            });
                                    });
                                });
                            });

                        }
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

    }
})();

'use strict';

(function() {
    angular
        .module('app.pages.organizations')
        .controller('OrganizationStartpageController', OrganizationStartpageController);

    /** @ngInject */
    function OrganizationStartpageController($log, $state, User, Organization, AuthenticationService, ApiPath) {
        var vm = this;
        vm.organizationId = null;


        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                vm.organizationId = $state.params.organizationId;
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        vm.gotoMemberships = function(organizationId) {
            $state.go('app.pages_memberships_index', {
                organizationId: organizationId,
            });
        };

        vm.gotoServices = function(organizationId) {
            $state.go('app.organization_services', {
                organizationId: organizationId,
                serviceType: 'SERVICE',
            });
        };

        vm.gotoCarnet = function(organizationId) {
            $state.go('app.organization_services', {
                organizationId: organizationId,
                serviceType: 'CARNET',
            });
        };

        vm.gotoEvents = function(organizationId) {
            $state.go('app.organization_events', {
                organizationId: organizationId,
                serviceType: 'EVENTS',
            });
        };

        vm.gotoResources = function(organizationId) {
            $state.go('app.organization_resources', {
                organizationId: organizationId,
            });
        };

        vm.gotoEarningCosts = function(organizationId) {
            $state.go('app.pages_earningcosts', {
                organizationId: organizationId,
            });
        };

        vm.gotoSettings = function(organizationId) {
            $state.go('app.organization_settings', {
                organizationId: organizationId,
            });
        };

    }
})();

(function() {
	'use strict';

	angular.module('app.pages.organizations').controller(
			'OrganizationSettingsController', OrganizationSettingsController);

	/** @ngInject */
	function OrganizationSettingsController($log, $timeout, $document, $rootScope, $scope, $compile, $sce, $filter,
			$mdDialog, $state, $translate, $http, AuthenticationService, Organization, User, Category, LoopBackAuth,
			UserOrganizationRole, RoleType, OrganizationResource, uiCalendarConfig, ResourceCalendar,DynamicDocumentConnector, CylPlan,
			DTOptionsBuilder, DTColumnDefBuilder, AlertMessageService, ApiPath, OrganizationType, _, StripePublicKey,
            blockUI, appDataService, PublicCylUrl) {
		var vm = this;

		// Data
        vm.apiPath=ApiPath;
        vm.organizationId='';
        vm.organization={};
        vm.ngFlowOptions = {
                // You can configure the ngFlow from here
                target                   : ApiPath + "/organizationDocumentsContainers/" + $rootScope.CYL_ORG_DOC_PREFIX +$state.params.organizationId+ "/upload",
                chunkSize                : 15 * 1024 * 1024,
                maxChunkRetries          : 1,
                simultaneousUploads      : 1,
                testChunks               : false,
                progressCallbacksInterval: 1000,
                allowDuplicateUploads: true,
                query: {}
            };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flowLogo: {},
            flowBackground: {}
        };
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.backgroundImage=backgroundImage;
        vm.removeBackground=removeBackground;
        vm.removeLogo=removeLogo;
        vm.openMenuImageDeletion=openMenuImageDeletion;
        vm.gotoOrganizations=gotoOrganizations;
        vm.goToOrganization=goToOrganization;
        vm.deactivateStripe=deactivateStripe;
        vm.saveOrganization=saveOrganization;
        vm.enableInvoices=enableInvoices;
        vm.flgEnableInvoicesAtStart=false;
        vm.epaymentsEnabled= StripePublicKey && StripePublicKey!=='';
        vm.helpMe=helpMe;
        //designer
        vm.addTemplateItem=addTemplateItem;
        vm.reloadPreview=reloadPreview;
        vm.addChoice=addChoice;
        vm.removeChoice=removeChoice;
        vm.addRule=addRule;
        vm.removeRule=removeRule;
        vm.removeItem=removeItem;
        vm.userTemplate = {template: {items: []} };
        vm.saveTemplate=saveTemplate;
        vm.myTemplateStructure = {};
        vm.calculateTemplateItemName=calculateTemplateItemName;
        vm.jsonOptions = {mode: 'code'};
        vm.adminPreferences = {};
        vm.chatPreferences = {};
        vm.planWarning = null;

        vm.updateLocationFromMap = updateLocationFromMap;
        vm.updateLocationFromAddress = updateLocationFromAddress;

        vm.manageStripeToken=manageStripeToken;
        vm.saveAdminPreferences = saveAdminPreferences;
        vm.stripeRequestToken='';
        vm.stripeClientId='';

        //GESTIONE PIANI E TARIFFAZIONE
        vm.welcomeStatus = 'WELCOME';
        vm.cylPlan = {};
        vm.plans = [];
        vm.goToPreview = goToPreview;
        vm.previewInvoice = {
            items: [],
            amount: 0
        };
        vm.planPage = 'STATUS';
        vm.formatDate = formatDate;
        vm.appDataService = appDataService;
        vm.planChart = {
            dataPoints: [],
            dataColumns: [
                {id: 'a', type:'donut', name: 'Contatti attivi'},
                {id: 'b', type:'donut', name: 'Contatti non utilizzati'}
            ]
        };

        $timeout(function() {
            $log.debug('appDataService: ' + JSON.stringify(vm.appDataService));
            vm.planChart.colors = '#2bd3be,#ccc';
            var numActiveContacts = vm.appDataService.organizationPlanStats.numActiveContacts;
            var maxActiveContacts = vm.appDataService.organizationPlanStats.plan.metadata['max-org-members'];
            var realActiveContacts = numActiveContacts;
            if (numActiveContacts > maxActiveContacts) {
                realActiveContacts = maxActiveContacts;
                vm.planChart.colors = '#ff1e7f, #ccc';
                vm.planWarning = (numActiveContacts - maxActiveContacts) + ' contatti attivi oltre il massimo previsto dal piano';
            }
            vm.planChart.dataPoints.push({a: realActiveContacts});
            vm.planChart.dataPoints.push({b: maxActiveContacts - realActiveContacts});
        }, 5000);
        //FINE GESTIONE PIANI E TARIFFAZIONE

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear',  'fontColor', 'backgroundColor'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];


		init();

		/**
		 * Initialize
		 */
        function init() {
            if (AuthenticationService.isAuthenticated()){
                vm.organizationId = $state.params.organizationId;
                if (vm.organizationId && vm.organizationId!==null) {
                    loadOrganization();
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        }

		function loadOrganization() {
			findOrganization(vm.organizationId).then(
				function(data) {
					var myOrganization = data;
					//tengo traccia se all'inizio èra abilitata la gestione delle ricevute/fatture
                    vm.flgEnableInvoicesAtStart=myOrganization.flgEnableInvoice;

					if (AuthenticationService.isAuthenticated() && !vm.isAdmin) {
						AuthenticationService.loggedUser().then(function(value, headers) {
							vm.user = value;
							$log.debug(vm.user);

							//myOrganization.$prototype$isAdmin(
                            Organization.isOrganizationAdmin(
                            {
                                organizationId: myOrganization.id,
								userId : vm.user.id
							}).$promise
							.then(function(response) {
								vm.isAdmin = response && response.isAdmin;
								if (vm.isAdmin) {
                                    loadCylPlans();
                                    loadOrganizationAsCustomer(vm.organizationId);
								    UserOrganizationRole.find({
                                        filter: {
                                            where: {
                                                userId: vm.user.id,
                                                organizationId: vm.organizationId,
                                                role: 'ADMIN'
                                            }
                                        }
                                    }).$promise.then(function(data) {
                                        if (data && data.length > 0) {
                                            if (data[0] && data[0].rolePreferences) {
                                                vm.adminPreferences = JSON.parse(data[0].rolePreferences);
                                            }
                                        }
                                    });

                                    $timeout(function() {
                                        $(".gllpLatlonPicker").each(function() {
                                            var $obj = $(document).gMapsLatLonPicker();

                                            $obj.params.strings.markerText = "Drag this Marker (example edit)";

                                            $obj.params.displayError = function(message) {
                                                $log.error("MAPS ERROR: " + message); // instead of alert()
                                            };

                                            $obj.init($(this));

                                            centerMap();

                                        });

                                    }, 1000);
                                }
							});
						});
					}

					vm.organization = (JSON.parse(JSON.stringify(myOrganization)));

                    //se ho il template dinamico dell'utente e lo uso allora lo richiedo al dyndoc
		            if (vm.organization.flgUserDynAttributes && vm.organization.organizationUserTemplateId && vm.organization.organizationUserTemplateId!=='') {
		                DynamicDocumentConnector.template({templateId:vm.organization.organizationUserTemplateId}).$promise.then(
		                   function(data) {
		                        vm.userTemplate.template = data;
		                        vm.myTemplateStructure={};
		                        _retrieveTemplateInfo(vm.userTemplate.template.items);
		                   }, function(httpResponse) {
		                       $log.debug(httpResponse);
		                       AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
		                   }
		                );
		            }
				}, function(error) {
					$log.debug(error);
				});
		}

        function updateLocationFromMap() {
            console.log('updateLocationFromMap()');
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.organization.longitude = longitude;
            vm.organization.latitude = latitude;
            $('#organization-latitude').trigger('input'); 
            $('#organization-longitude').trigger('input'); 
        }

        function centerMap() {
            if (vm.organization.longitude && vm.organization.longitude !== null && vm.organization.latitude && vm.organization.latitude !== null) {
                $('input.gllpLatitude').val(vm.organization.latitude);
                $('input.gllpLongitude').val(vm.organization.longitude);
                $('input.gllpZoom').val(10);

            }

        }

        function updateLocationFromAddress() {
            var address = '';
            if (vm.organization.addressOperat && vm.organization.cityOperat) {
                address = vm.organization.addressOperat + ' ' + vm.organization.addressNumberOperat + ' ' + vm.organization.postalCodeOperat + ' ' + vm.organization.provinceOperat + ' ' + vm.organization.cityOperat;
            } else {
                address = vm.organization.address + ' ' + vm.organization.addressNumber + ' ' + vm.organization.postalCode + ' ' + vm.organization.province + ' ' + vm.organization.city;
            }
            if (address.trim()) {
                $('input.gllpSearchField').val(address.trim());
                $('input.gllpSearchButton').click();
                setTimeout(updateLocationFromMap, 1500);
            }
        }


		function findOrganization(id) {
            $log.debug('OrganizationSettings.findOrganization()');
			return Organization.findById({
				id : id,
				filter : {
					include : [ 'roleTypes', 'categories'],
				}
			}).$promise;
		}


        /**
         * Carica il dettaglio della sottoscrzione corrente
         * @param organizationId
         */
		function loadCurrentPlan(organizationId) {
		    if (!vm.organization.cylCustomerId || !vm.organization.cylSubscriptionId || vm.organization.cylSubscriptionId === 'FREE') {
		        //non ho una iscrizione
                vm.cylPlan = {
                    id: 'FREE',
                    nickname: 'Piano Gratuito'
                };
            } else {
                //ho una iscrizione
                CylPlan.loadCurrentSubscription({organizationId: organizationId}).$promise.then(function(sub) {
                    vm.cylPlan = sub.items.data[0].plan;
                    vm.cylSubscriptionStart = moment(sub.current_period_start * 1000).format('DD/MM/YYYY');
                    vm.cylSubscriptionEnd = moment(sub.current_period_end * 1000).format('DD/MM/YYYY');
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                });
            }
        }

        function loadOrganizationAsCustomer(organizationId) {
            CylPlan.loadOrganizationAsCustomer({organizationId: organizationId}).$promise.then(function(cus) {
                vm.cylCustomer = cus;
                vm.paymentCardId = cus.default_source;
                if (!vm.paymentCardId) {
                    vm.paymentCardId = 'NEW_CARD';
                }

                if ($state.current.name === 'app.organization_plans') {
                    vm.selectedTabIndex = 7;// PIANI e PAGAMENTI
                }

            }, function(httpResponse) {
                $log.debug(httpResponse);
            });
        }

        /**
         * Carica la lista dei piani disponibili
         */
        function loadCylPlans() {
            blockUI.start();
            CylPlan.loadAvailablePlans().$promise.then(function(plans) {
                blockUI.stop();
                vm.plans = plans;
                loadCurrentPlan(vm.organizationId);
            }, function(httpResponse) {
                blockUI.stop();
                $log.debug(httpResponse);
            });
        }


        /**
         * Prima di modificare una sottoscrizione mi dice quanto devo pagare
         * @param plan
         */
        function goToPreview(plan) {
            $log.debug('goToPreview()');
            $log.debug('plan: ' + JSON.stringify(plan));
            if (vm.organization.cylSubscriptionId && vm.organization.cylSubscriptionId !== 'FREE' && vm.organization.cylCustomerId) {
                $log.debug('Cambio sottoscrizione');
                vm.choosedPlan = plan;
                if (plan.id === 'FREE') {
                    $log.debug('Torno a piano FREE');
                    vm.choosedPlan = plan;
                    vm.previewInvoice = {
                        items: [vm.choosedPlan],
                        amount: -1 //valore fittizio
                    };
                    vm.planPage = 'PREVIEW';
                } else {
                    $log.debug('Modifca piano esistente');
                    blockUI.start();
                    CylPlan.previewSubscriptionUpdate({organizationId: vm.organizationId, planId: plan.id}).$promise.then(function(invoice) {
                        vm.previewInvoice = invoice;
                        vm.planPage = 'PREVIEW';

                        var button = document.getElementById('buttonCheckout');
                        button.addEventListener('click', function(ev) {
                            checkoutHandler.open({
                                name: plan.nickname,
                                description: '',
                                token: handleToken,
                                image: 'assets/images/logos/logo_payments.png',
                                currency: 'eur',
                                amount: vm.previewInvoice.amount
                            });
                        });
                        blockUI.stop();
                    }, function(httpResponse) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }
            } else {
                $log.debug('Nuova sottoscrizione');
                vm.choosedPlan = plan;
                vm.previewInvoice = {
                    items: [vm.choosedPlan],
                    amount: vm.choosedPlan.amount
                };
                vm.planPage = 'PREVIEW';
            }

        }


        // function updateSubscription() {
        //     blockUI.start();
        //     CylPlan.upgradeSubscription({organizationId: vm.organizationId, planId: vm.choosedPlan.id, sourceId: vm.paymentCardId}).$promise.then(function(done) {
        //         AlertMessageService.showSuccessMessage();
        //         blockUI.stop();
        //         window.location.href = '/organizations/' + vm.organizationId;
        //     }, function(httpResponse) {
        //         AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
        //         blockUI.stop();
        //     });
        // }



        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }


        function handleSource(source) {
            blockUI.start();
            CylPlan.upgradeSubscription({
                organizationId: vm.organizationId,
                planId: vm.choosedPlan.id,
                sourceId: source.id
            }).$promise.then(function(done) {
                AlertMessageService.showSuccessMessage();
                blockUI.stop();
                window.location.href = '/organizations/' + vm.organizationId;
                //$state.go('app.organization', {organizationId: vm.organizationId});
            }, function(httpResponse) {
                blockUI.stop();
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }

        function handleToken(token) {
            blockUI.start();
            CylPlan.upgradeSubscription({organizationId: vm.organizationId, planId: vm.choosedPlan.id, stripeToken: token.id}).$promise.then(function(done) {
                AlertMessageService.showSuccessMessage();
                blockUI.stop();
                window.location.href = '/organizations/' + vm.organizationId;
                //$state.go('app.organization', {organizationId: vm.organizationId});
            }, function(httpResponse) {
                blockUI.stop();
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }

        /*************************************************
         * GESTIONE LOGO
         */

        function fileAdded(file, typeFile){
            $log.debug(file);
            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };
            vm.contentToUpload = uploadingFile;
            upload(typeFile);
        }


        function upload(typeFile){
            vm.contentToUpload.type = 'uploading';

            if (typeFile === 'LOGO') {
                vm.ngFlowOptions.query.cyl_type = 'LOGO';
                vm.ngFlowOptions.query.organizationId = vm.organization.id;
                vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
                vm.ngFlow.flowLogo.upload();
            }
            else if (typeFile === 'BACKGROUND') {
                vm.ngFlowOptions.query.cyl_type = 'BACKGROUND';
                vm.ngFlowOptions.query.organizationId = vm.organization.id;
                vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
                vm.ngFlow.flowBackground.upload();
            }
        }

        function backgroundImage() {
            if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
            }
            return {'background-image': 'none'};
        }


        function removeBackground() {
             Organization.update({
                 where : {
                     id : vm.organization.id
                 }
             }, {uriBackgroundImage: null}, function(value, responseHeaders) {
                 $log.debug(value);
                 vm.organization.uriBackgroundImage = null;
                 AlertMessageService.showSuccessMessage();
                 $rootScope.$emit('CURRENT_ORGNANIZATION_REFRESH', vm.organization.id);
             }, function(httpResponse) {
                 $log.debug(httpResponse);
                 AlertMessageService.showErrorAlert(httpResponse.data
                         && httpResponse.data.error);

             });
        }

        function removeLogo() {
             Organization.update({
                 where : {
                     id : vm.organization.id
                 }
             }, {uriLogo: null}, function(value, responseHeaders) {
                 $log.debug(value);
                 vm.organization.uriLogo = null;
                 AlertMessageService.showSuccessMessage();
                 $rootScope.$emit('CURRENT_ORGNANIZATION_REFRESH', vm.organization.id);
             }, function(httpResponse) {
                 $log.debug(httpResponse);
                 AlertMessageService.showErrorAlert(httpResponse.data
                         && httpResponse.data.error);

             });
       }

        function openMenuImageDeletion($mdOpenMenu, ev) {
               $mdOpenMenu(ev);
             };

        function fileSuccess(file, message, typeFile){
            $log.debug('fileSuccess');
            AlertMessageService.showSuccessMessage();
            $timeout(function() {
                loadOrganization();
                $rootScope.$emit('CURRENT_ORGNANIZATION_REFRESH', vm.organization.id);
            }, 3000);
        }

        function fileError(file, message, typeFile){
            $log.error('fileError:');
            $log.error(message);
            AlertMessageService.showErrorAlert('La funzionalità di upload è al momento non disponibile. Si prega di ' +
                'riprovare più tardi e se il problema persiste informare l\'assistenza.');
        }


        /***
         * GENERA O ELIMINA IL TOKEN DI CONNESSIONE STRIPE DALLA ORGANIZZAZIONE
         */
        function manageStripeToken() {
            if (vm.organization.flgEnableStripePayments) {
                Organization.generateStripeRequestToken({organizationId: vm.organization.id.toString()}).$promise.then(function (data) {
                    vm.stripeRequestToken=data.res.token;
                    vm.stripeClientId=data.res.stripeClientId;
                }, function (err) {
                    $log.debug(err);
                })
            }
            else {
                Organization.eraseStripeRequestToken({organizationId: vm.organization.id.toString()}).$promise.then(function (res) {
                    vm.stripeRequestToken='';
                }, function (err) {
                    $log.debug(err);
                })
            }
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
              $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        /**
         * Disattiva stripe per questa associazione
         * TODO richiesta di conferma. Gestione doppio click
         */
        function deactivateStripe() {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
              })
              .then(function(answer) {
                  Organization.deactivateStripe({organizationId: vm.organization.id.toString()}).$promise.then(function (data) {
                      findOrganization(vm.organizationId)
                      .then(
                          function(data) {
                              var myOrganization = data;
                              vm.organization = (JSON.parse(JSON
                                      .stringify(myOrganization)));
                          }, function(error) {
                              $log.debug(error);
                          });
                  }, function (err) {
                      $log.debug(err);
                  })
              });
        }


        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()});
        }

        function goToOrganization() {
            $state.go('app.organization',{organizationId: vm.organization.id});
        }


        vm.gotoSeasonChange = function() {
            $state.go('app.pages_seasonchange', { organizationId: vm.organization.id });
        };

        function helpMe(ev, helpContext) {
            if (helpContext==='CYL_ID') {
                $scope.helpTitle=$translate.instant("ORGANIZATIONS.CYL_ID");
                $scope.helpText=$sce.trustAsHtml($translate.instant("ORGANIZATIONS.CYL_ID_HELP"));
            }

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/organizations/views/organization/dialogs/help_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
              })
              .then(function(answer) {
              }, function() {
                  $log.debug('You cancelled the dialog.');
              });
        }


        function saveOrganization(nextWelcomeStatus) {
            Organization.update({
                where : {
                    id : vm.organization.id
                }
            }, vm.organization, function(value, responseHeaders) {
                $log.debug(value);
                //aggiorno il menu
                AlertMessageService.showSuccessMessage();
                loadOrganization();
                $rootScope.$emit('CURRENT_ORGNANIZATION_REFRESH', vm.organization.id);

                if (nextWelcomeStatus) {
                    vm.welcomeStatus = nextWelcomeStatus;
                }
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);

            });
        }

        function saveTemplate() {
            DynamicDocumentConnector.upsertTemplate({data:vm.userTemplate.template}).$promise.then(function(value, responseHeaders) {
                $log.debug(value);
                //aggiorno il menu
                var templateId = value.id;
                vm.organization.organizationUserTemplateId=value.id;
                saveOrganization();
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }

        function saveAdminPreferences() {
            UserOrganizationRole.find({
                filter: {
                    where: {
                        userId: vm.user.id,
                        organizationId: vm.organizationId,
                        role: 'ADMIN'
                    }
                }
            }).$promise.then(function(data) {
                if (data && data.length > 0) {
                    var id = data[0].id;
                    var obj = data[0];
                    obj.rolePreferences = JSON.stringify(vm.adminPreferences);
                    UserOrganizationRole.update({
                        where : {
                            id : id
                        }
                    }, obj, function(value, responseHeaders) {
                        $log.debug(value);
                        AlertMessageService.showSuccessMessage();
                    }, function(httpResponse) {
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
                }
            });
        }


        function enableInvoices() {
            Organization.enableInvoices({
                organizationId: vm.organization.id.toString(),
                startFrom: vm.organization.invoiceNextNumber ? vm.organization.invoiceNextNumber : 0,
                section: vm.organization.invoiceSection  ? vm.organization.invoiceSection : '',
                type: 'INVOICE'
            }).$promise.then(function(value, responseHeaders) {
                Organization.enableInvoices({
                    organizationId: vm.organization.id.toString(),
                    startFrom: vm.organization.creditNoteNextNumber ? vm.organization.creditNoteNextNumber : 0,
                    section: vm.organization.creditNoteSection  ? vm.organization.creditNoteSection : '',
                    type: 'CREDIT_NOTE'
                }).$promise.then(function(value, responseHeaders) {
                    saveOrganization();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }


        function calculateTemplateItemName(item) {
            if (item.saved) {
                return;
            }

            var caption = item.caption;
            if (!caption || caption==='') {
                caption = "____";
            } else {
                //rimuovo caratteri speciali e spazi
                caption = caption.replace(/[^a-zA-Z ]/g, "");
                caption = caption.replace(/\s+/g, '');
                //conto occorrenze già presenti con quel nome
                var name = caption;
                var keys = _.keys(vm.myTemplateStructure);
                var keysWithoutExt = _.map(keys, function (key) { return (key.indexOf('-')>0) ? key.substring(0, key.indexOf('-')) : key; });
                var cnt=_.countBy(keysWithoutExt, function (k) { return k ==caption;});
                if (cnt[true]>0) {
                    name+='-'+(cnt[true]+1);
                }
                item.name=name;
            }
        }


        /**
         * Gestione designer utente
         *
         *
         */
        function addTemplateItem() {
            if (!vm.userTemplate.template) {
                vm.userTemplate.template={};
            }
            if (!vm.userTemplate.template.items) {
                vm.userTemplate.template.items=[];
            }
            var num =  (vm.userTemplate.template.items.length +1);

            vm.userTemplate.template.items.push({
                name: "Campo "+ num,
                caption: "Campo "+ num,
                type: "text",
                options: {}
            });
        }

        function addChoice(item) {
            if (!item.choices) {
                item.choices=[];
            }
            item.choices.push(
            {
                "uuid": "",
                "value": 0,
                "weight": 0,
                "caption": ""
            });
        }

        function removeChoice(item, index) {
            item.choices.splice(index, 1);
        }

        function addRule(item) {
            if (!item.options) {
                item.options={};
            }

            if (!item.options.rules) {
                item.options.rules=[];
            }
            item.options.rules.push(
            {
                "when": "<NOME> EQ 'VALORE'",
                "actions": [{subject:"campo", action:"clear"}]
            });
        }

        function _retrieveTemplateInfo( items) {
            _.each(items, function (item) {
                if (item.name && item.name!==null && item.type!=='group' && item.type!=='label'){
                    vm.myTemplateStructure[item.name]={type:item.type, multiple:item.multiple, choices: item.choices, saved: true};
                }

                if (item.type && item.type==='group') {
                    _retrieveTemplateInfo( item.items);
                }
            });
        }


        vm.translateCategory = function(item) {
            return $filter('cylDictionary')(item.name,'ORGANIZATION_CATEGORY',item.code);
        }


        vm.lookupCategories= function(txt){
            //txt=txt+'%';

            //CERCO NEL DIZIONARIO LE CATEGORIE CON IN LIKE IL VALORE: prendo il codice e lo passo alla lista
            var records = _.filter($rootScope.cylDictionary, function(d) {
                return (d.section==='ORGANIZATION_CATEGORY' && d.locale===$rootScope.currentLanguage && d.value.toLowerCase().startsWith(txt.toLowerCase()));
            });

            var codes = _.map(records, function(r) {return r.code;});

            var categories = _.filter($rootScope.organizationCategories, function(d) {
                return (_.contains(codes,d.code));
            });

            for (var i = 0; i < categories.length; i++) {
                categories[i].name=$filter('cylDictionary')(categories[i].name,'ORGANIZATION_CATEGORY',categories[i].code);
            }

            return categories;


        }

        vm.transformChip = function(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip };
        }

        function removeRule(item, index) {
            item.options.rules.splice(index, 1);
        }


        function removeItem(index) {
            vm.userTemplate.template.items.splice(index, 1);
        }

        function reloadPreview() {
            $rootScope.$emit('DYN-DOC-LOADTEMPLATE', vm.userTemplate.template);
        }


        /**
         * Invia il pagamento tramite stripe, versione con SCA (Strong Client Authentication)
         *
         */
        vm.sendStripePayment = function() {
            $log.debug('vm.sendStripePayment()');
            $http.post(
                ApiPath + '/stripe/paydynamicsubscription',
                {
                    plan: vm.choosedPlan.id,
                    successUrl: PublicCylUrl + '/organizations/' + vm.organizationId + '/changeplan/result/success',
                    cancelUrl: PublicCylUrl + '/organizations/' + vm.organizationId + '/changeplan/result/cancel',
                    organizationId: vm.organizationId,
                }
            ).then(
                function(response) {
                    if (response.status === 200) {
                        $log.debug('Sessione stripe creata correttamente');
                        $log.debug(response.data);
                        var checkoutSessionData = response.data;
                        var stripe = Stripe(StripePublicKey);
                        stripe.redirectToCheckout({
                            sessionId: checkoutSessionData.id
                        }).then(function(result) {
                            // If `redirectToCheckout` fails due to a browser or network
                            // error, display the localized error message to your customer
                            // using `result.error.message`.
                            if (result && result.error && result.error.message) {
                                $log.error(result);
                                $state.go('app.organization_changeplan', { organizationId: vm.organizationId, success: 'fail'})
                            } else {
                                $log.debug('pagamento ok');
                                $log.debug(result);
                                $state.go('app.organization_changeplan', { organizationId: vm.organizationId, success: 'success'})
                            }
                        });
                    } else {
                        $log.warn(response.status);
                        $log.warn(response.data);
                        AlertMessageService.showErrorAlert(response.err.message);
                    }
                },
                function(err) {
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Problema con i parametri di pagamento, riprovare.');
                }
            );
        };

	}
})();

(function() {
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('OrganizationServicesController', OrganizationServicesController);

    /** @ngInject */
    function OrganizationServicesController($rootScope, $scope,  $mdDialog, $compile, $q, DTOptionsBuilder,
                                            UserOrganizationRole, DTColumnBuilder, $log, breadcrumbManager,
                                            $translate, AuthenticationService,  User, Organization, $location,  $state,
                                            OfferedService, Subscription, AlertMessageService, _, ApiPath, LoopBackAuth,
                                            appDataService, EarningCost, PaymentReason, CylUtils, Payment, blockUI,
                                            DateFormatter) {
        var vm = this;
        vm.currentUserId = null;
        vm.organizationId = null;
        vm.serviceType = null;
        vm.paymentsFilter = null;
        vm.offeredServiceId = null;
        vm.selectedTabIndex = 0;            // currently selected tab
        vm.organization = null;             // current organization
        vm.isAdmin = false;                 // true if logged user is administrator of the current organization
        vm.services = [];                   // services list (it's in the DataTable, but we keep it here too, for buttons handler purposes)
        vm.searchableService = [];          // elenco dei servici cercabili
        // datatable variables
        vm.dtServicesInstance = null;
        vm.dtServicesOptions = null;
        vm.dtServicesColumns = null;
        vm.dtServicesSearchText = null;                 // text search for services table
        vm.dtServicesSearchStandalone = null;           // data for standalone services dropdown
        // struttura per gestire i servizi con i dati che li rendono ricercabili.
        // usata per mostrare l'avviso in alto per consigliare la compilazione dei dati
        vm.searchableServicesStats = {
            total: 0,
            withEnoughData: 0,
        };


        /**
         * Initializes the controller
         */
        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                vm.organizationId = $state.params.organizationId;
                vm.serviceType = $state.params.serviceType;

                // set the tab to display
                vm.selectedTabIndex = vm.getSelectedTabIndex($state);

                // read parameters, if set
                if ($state.params && $state.params.paymentsFilter) {
                    vm.paymentsFilter = $state.params.paymentsFilter;
                }
                if ($state.params && $state.params.offeredServiceId) {
                    vm.offeredServiceId = $state.params.offeredServiceId;
                }

                // read current organization
                vm.findOrganization(vm.organizationId).then(
                    function(myOrganization) {
                        if (myOrganization) {
                            vm.organization = _.clone(myOrganization);
                            $log.debug('vm.organization: ' + JSON.stringify(vm.organization));
                            //myOrganization.$prototype$isAdmin(
                            Organization.isOrganizationAdmin(
                                {
                                    organizationId: myOrganization.id,
                                    userId : vm.currentUserId
                                }
                            ).$promise.then(
                                function(response) {
                                    vm.isAdmin = response && response.isAdmin;
                                }, function(err) {
                                    $log.error('Error in myOrganization.$prototype$isAdmin()');
                                }
                            );
                        }
                    },
                    function() {
                        $log.error('Error in vm.findOrganization()');
                    });

                // initializes DataTable
                vm.initServicesTable();
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Returns the html code to generate a button
         *
         * @param {string} label
         * @param {string} icon
         * @param {string} fn
         * @returns {string}
         */
        vm.getDtButtonHtml = function(label, icon, fn) {
            return '<md-button class="edit-button md-icon-button" title="' + label + '" aria-label="' + label + '" ng-click="' + fn + '">' +
                '    <md-icon md-font-icon="' + icon + '"></md-icon>' +
                '</md-button>';
        };


        /**
         * Services DataTable rendering methods
         */
        vm.renderDtServicesColumnName = function(data, type, service) {
            return (service && service.name) ? service.name : 'Servizio senza nome';
        };
        vm.renderDtServicesColumnSchedule = function(data, type, service) {
            switch (service.scheduleType) {
                case 'P':
                    return DateFormatter.formatDate(service.start) + ' - ' + DateFormatter.formatDate(service.end);
                    break;
                case 'R':
                    return $translate.instant('OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND');
                    break;
                case 'N':
                    return $translate.instant('OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_NONE');
                    break;
                case 'A':
                    return $translate.instant('OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_ACCESS');
                    break;
                case 'D':
                    return DateFormatter.formatDate(service.start);
                    break;
                default:
                    return '';
            }
        };
        vm.renderDtServicesColumnInfo = function(data, type, service) {
            var s = '';
            if (service.paymentType === 'R' || service.paymentType === 'O') {
                s = $translate.instant('OFFERED_SERVICES.SUBSCRIPTION_PRICE') + ' ' +
                    service.subscriptionPrice + '<br />';
            }
            if (service.paymentType === 'R') {
                s += $translate.instant('OFFERED_SERVICES.RENEWAL_PRICE') + ' ' +
                    service.renewalPrice + '<br /><br />' +
                    $translate.instant('OFFERED_SERVICES.RENEWAL') +': ';
                switch (service.paymentRenewInterval) {
                    case 'day':
                        s += $translate.instant('OFFERED_SERVICES.DAY');
                        break;
                    case 'month':
                        s += $translate.instant('OFFERED_SERVICES.MONTH');
                        break;
                    case 'year':
                        s += $translate.instant('OFFERED_SERVICES.YEAR');
                        break;
                    case 'week':
                        s += $translate.instant('OFFERED_SERVICES.WEEK');
                        break;
                    case '2-month':
                        s += $translate.instant('OFFERED_SERVICES.2_MONTH');
                        break;
                    case '3-month':
                        s += $translate.instant('OFFERED_SERVICES.3_MONTH');
                        break;
                    case '4-month':
                        s += $translate.instant('OFFERED_SERVICES.4_MONTH');
                        break;
                    case '6-month':
                        s += $translate.instant('OFFERED_SERVICES.6_MONTH');
                        break;
                }
            }
            return s;
        };
        vm.renderDtServicesColumnTypes = function(data, type, service) {
            return (service && service.serviceTypeNames) ? service.serviceTypeNames : '';
        };
        vm.renderDtServicesColumnSearchable = function(data, type, service) {
            vm.searchableService[service.id] = (service.isSearchable === 1 || service.isSearchable === true);
            var title = service.isSearchable ?
                'Il servizio è ricercabile anche all\'esterno di ClubYourLife' :
                'Il servizio non è ricercabile all\'esterno di ClubYourLife';
            var ret = '<md-switch data-serviceid="' + service.id + '" ng-model="vm.searchableService[' + service.id + ']" ng-change="vm.switchSearchable(' + service.id + ')" title="' + title + '"></md-switch>';
            // se il servizio è cercabile, aggiunge le informazioni sullo stato della ricercabilità
            if (service.isSearchable) {
                if (hasEnoughSearchableInfo(service)) {
                    ret += '<md-icon md-font-icon="icon-cloud-check" title="' + getSearchableInfo(service) + '"></md-icon>';
                } else {
                    ret += '<md-icon md-font-icon="icon-cloud-outline-off" title="' + getSearchableInfo(service) + '"></md-icon>';
                }
            }
            return ret;
        };
        vm.renderDtServicesColumnActions = function(data, type, service) {
            var s = '';
            if (vm.isAdmin) {
                s += vm.getDtButtonHtml('Elenco iscritti', 'icon-eye', 'vm.gotoOfferedService(' + service.id + ');') +
                    vm.getDtButtonHtml('Vai ai pagamenti', 'icon-currency-eur', 'vm.gotoSubscriptions(' + service.id + ');') +
                    vm.getDtButtonHtml('Inserisci presenze', 'icon-account-check', 'vm.gotoPresenze(' + service.id + ');') +
                    vm.getDtButtonHtml('Impostazioni', 'icon-cog', 'vm.gotoServiceSettings(' + service.id + ');');
                if (vm.serviceType !== 'EVENT') {
                    s += vm.getDtButtonHtml('Report mensile pagamenti', 'icon-receipt', 'vm.gotoServicePaymentsReport(' + service.id + ');');
                }
                s += vm.getDtButtonHtml('Elimina servizio', 'icon-delete', 'vm.deleteService(' + service.id + ');');
            }
            return s;
        };


        /**
         * Retrieve data for Services Datatable
         */
        vm.loadDtServicesItems = function(sSource, aoData, fnCallback, oSettings) {
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            // load reference period
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var dateFrom = null, dateTo = null;
                if (refPeriod) {
                    dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                    dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                }
                // build query filters
                var filters = {
                    organizationId: vm.organizationId,
                    serviceType: vm.serviceType,
                    dtDel: null,
                    dateFrom: dateFrom,
                    dateTo: dateTo
                };

                // filter CARNET only, if selected
                if ($state.params && $state.params.serviceType && $state.params.serviceType === 'CARNET') {
                    filters.serviceType = 'SERVICE';
                    filters.scheduleType = 'A';
                    filters.isCarnet = true;
                } else {
                    // else, show SERVICE only
                    filters.scheduleType = '!A';
                    filters.isCarnet = null;
                    filters.isPaymentPlan = null;
                }

                // filter searchtext, if appliable
                if (vm.dtServicesSearchText) {
                    filters.searchText = vm.dtServicesSearchText;
                }
                if (vm.dtServicesSearchStandalone) {
                    filters.searchStandalone = vm.dtServicesSearchStandalone;
                }
                // $log.debug('where filters: ' + JSON.stringify(filters));

                OfferedService.getItems(
                    {
                        filters: filters,
                        excludeMemberships: true,
                    },
                    function(items) {
                        items = _.map(items, function(item) {
                            item.serviceTypeNames = '';
                            if (item.serviceTypes) {
                                for (var i = 0; i < item.serviceTypes.length; i++) {
                                    if (item.serviceTypeNames !== '') {
                                        item.serviceTypeNames += ', ';
                                    }
                                    item.serviceTypeNames += item.serviceTypes[i].name;
                                }
                            }
                            return item;
                        });
                        // save items, too
                        vm.services = items;

                        // issue #379: elimina servizi di tipo quota associativa
                        vm.services = _.filter(vm.services, function(service) {
                            $log.debug({service: service});
                            var isSubscription = false;
                            _.each(service.serviceTypes, function(serviceType) {
                                if (serviceType && serviceType.internalCode && serviceType.internalCode === 'SUBSCRIPTION') {
                                    isSubscription = true;
                                }
                            });
                            return !isSubscription;
                        });

                        // filters elements #
                        // $log.debug('Filtro elementi per pagina.');
                        // $log.debug('Elementi totali: ' + vm.services.length);
                        // $log.debug('Pagina: ' + start + ' - ' + length);
                        var recordsTotal = vm.services.length;
                        var i = 0;
                        var items = [];
                        _.each(vm.services, function(item) {
                            if (i >= start && i < start+length) {
                                items.push(item);
                            }
                            i++;
                        });
                        // $log.debug('Elementi filtrati: ' + items.length);
                        vm.services = JSON.parse(JSON.stringify(items));

                        // aggiorna conteggio dei servizi senza abbastanza dati per la ricerca
                        vm.searchableServicesStats.total = 0;
                        vm.searchableServicesStats.withEnoughData = 0;
                        vm.services.forEach(function(service) {
                            // $log.debug('Service: ' + service.name);
                            if (service && service.isSearchable) {
                                vm.searchableServicesStats.total++;
                                if (hasEnoughSearchableInfo(service)) {
                                    vm.searchableServicesStats.withEnoughData++;
                                }
                            }
                        });
                        // $log.debug('vm.searchableServicesStats: ' + JSON.stringify(vm.searchableServicesStats));

                        // return items list
                        // $log.debug('vm.services dopo filtro: ' + JSON.stringify(vm.services));
                        fnCallback({
                            'draw': draw,
                            'recordsTotal': recordsTotal,
                            'recordsFiltered': recordsTotal,
                            'data': vm.services
                        });
                    }
                );
            });
        };


        /**
         * Initializes services DataTable
         */
        vm.initServicesTable = function() {
            vm.dtServicesOptions = DTOptionsBuilder
                .newOptions()
                .withOption('serverSide', true)
                .withFnServerData(vm.loadDtServicesItems)
                .withDataProp('data')
                .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
                .withOption('responsive', true)
                .withOption('autoWidth', false)
                .withDisplayLength(50)
                .withPaginationType('full_numbers')
                .withOption('createdRow', function(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                .withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            ;
            vm.dtServicesColumns = [
                DTColumnBuilder.newColumn('serviceName').withTitle('Nome').notSortable().renderWith(vm.renderDtServicesColumnName),
                DTColumnBuilder.newColumn('serviceSchedule').withTitle('Schedulazione').notSortable().renderWith(vm.renderDtServicesColumnSchedule),
                DTColumnBuilder.newColumn('serviceInfo').withTitle('Informazioni').notSortable().renderWith(vm.renderDtServicesColumnInfo),
                // NDR: rimossa colonna, non sembra avere informazioni utili
                // DTColumnBuilder.newColumn('serviceTypes').withTitle('Tipologie').notSortable().renderWith(vm.renderDtServicesColumnTypes),
                DTColumnBuilder.newColumn('serviceActions').withTitle('Azioni').notSortable().renderWith(vm.renderDtServicesColumnActions),
                DTColumnBuilder.newColumn('serviceSearchable').withTitle('Pubblicato').notSortable().renderWith(vm.renderDtServicesColumnSearchable),
            ];
        };


        /**
         * Update Datatable's locale
         */
        vm.updateServicesTableLocale = function() {
            vm.dtServicesOptions.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
        };


        /**
         * launches reloading dataTable data
         */
        vm.reloadServicesTableItems = function() {
            vm.dtServicesInstance.DataTable.draw();
        };


        /**
         * Returns the tabIndex to activate
         *
         * @param {object} state $state object
         * @returns {number} tabIndex
         */
        vm.getSelectedTabIndex = function(state) {
            if (state && state.current && state.current.name) {
                var stateName = state.current.name;
                if (stateName === 'app.pages_subscriptions_pre' || stateName === 'app.pages_subscriptions_person') {
                    return 1;
                } else if (stateName === 'app.pages_service_attendances') {
                    return 2;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        };


        /**
         * Avvia la ricerca di una Organization dato l'ID
         *
         * @param {nuber} organizationId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.findOrganization = function(organizationId) {
            $log.debug('OrganizationServicesController.vm.findOrganization()');
            return Organization.findById({
                id : organizationId,
                filter : {}
            }).$promise;
        };


        /**
         * Va all'elenco delle subscription per un determinato servizio, filtrando per i pagamenti mancanti
         *
         * @param serviceId
         */
        vm.gotoSubscriptions = function(serviceId) {
            $state.go('app.pages_subscriptions_pre', {
                organizationId: vm.organizationId,
                offeredServiceId: serviceId,
                paymentsFilter: 'A',
                documentsFilter: null,
            });
        };


        /**
         * Va al dettaglio di un servizio
         *
         * @param serviceId
         */
        vm.gotoOfferedService = function(serviceId) {
            sessionStorage.setItem('CURRENT_SERVICE', serviceId);
            sessionStorage.setItem('currentServiceTab', 0); //PARTO DI DEFAULT CON GLI ISCRITTI

            $state.go('app.offered_service', {
                offeredServiceId : serviceId,
                organizationId : vm.organizationId
            });
        };


        /**
         * Si sposta alla schermata di inserimento presenze per il servizio selezionato.
         *
         * @param {number} serviceId
         */
        vm.gotoPresenze = function(serviceId) {
            $state.go('app.pages_attendance_detail', {offeredServiceId: serviceId, day: moment().format('YYYYMMDD')});
        };


        /**
         * Si sposta alla pagina delle impostazioni di un servizio
         *
         * @param {number} serviceId
         */
        vm.gotoServiceSettings = function(serviceId) {
            $state.go('app.offered_service_settings', {
                offeredServiceId: serviceId,
                organizationId: $state.params.organizationId
            });
        };


        /**
         * Va alla pagina di generazione del report mensile di pagamento di un servizio
         *
         * @param {number} serviceId
         */
        vm.gotoServicePaymentsReport = function(serviceId) {
            $state.go('app.pages_service_payments_report', { serviceId : serviceId });
        };


        /**
         * Va alla pagina di creazione di un nuovo OfferedService
         */
        vm.gotoNewOfferedService = function() {
            if (vm.serviceType === 'CARNET') {
                $state.go('app.new_carnet', { organizationId : vm.organizationId });
            } else {
                $state.go('app.new_offered_service', { organizationId : vm.organizationId });
            }
        };


        /**
         * Va alla pagina di inserimento nuova subscription
         */
        vm.goToNewSubscription = function() {
            $state.go('app.new_subcription', {organizationId: appDataService.currentOrganization.id});
        };


        /**
         * Va alla pagina di inserimento nuovo evento
         */
        vm.gotoNewEvent = function() {
            $log.debug('vm.goToNewEvent()');
            $state.go('app.new_event', { organizationId : vm.organizationId });
        };


        /**
         * Va alla gestione delle presenze
         * @param day
         */
        vm.goToAttendanceDetail = function(selectedServiceId) {
            var day = moment().format('YYYYMMDD');
            if (selectedServiceId) {
                $state.go('app.pages_attendance_detail', {
                    offeredServiceId: selectedServiceId,
                    day: moment().format('YYYYMMDD')
                });
            }
        };


        /**
         * Va alla pagina di invio della notifica massiva
         *
         * @param organizationId
         * @param offeredServiceId
         * @param paymentsFilter
         */
        vm.goToSendMassiveNotification = function(organizationId, offeredServiceId, paymentsFilter) {
            $state.go('app.pages_massive_notification', {organizationId: organizationId, offeredServiceId: offeredServiceId, paymentsFilter: paymentsFilter});
        };


        /**
         * Mostra la dialog per eliminare un servizio
         *
         * @param {number} offeredServiceId
         */
        vm.deleteService = function(offeredServiceId){
            $mdDialog.show({
                controller: vm.deleteConfirmDialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            }).then(function(answer) {
                Subscription.count({
                    where : {dtDel: null, offeredServiceId: offeredServiceId}
                }, function(totalNumber) {
                    if (totalNumber.count && totalNumber.count>0)  {
                        //ERRORE: ci sono servizi associati
                        AlertMessageService.showErrorAlert("OFFERED_SERVICES.ERRORS.CANT_DELETE_HAS_SUBSCRIPTION");
                    } else {
                        OfferedService.findById({
                            id : offeredServiceId
                        }).$promise.then(
                            function(off) {
                                off.dtDel = new Date();
                                OfferedService.prototype$patchAttributes({ id: off.id }, off)
                                    .$promise.then(vm.reloadServicesTableItems);
                            });
                    }
                });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        };


        /**
         * Dialog per la modal di conferma eliminazione elemento
         *
         * @param $scope
         * @param $mdDialog
         */
        vm.deleteConfirmDialogController = function($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        };
        vm.deleteConfirmDialogController.$inject = ['$scope', '$mdDialog'];



        /**
         * Mostra la dialog per aggiugere un pagamento di questo utente
         *
         * @param {string} serviceId Se indicato, la finestra agirà solo sul servizio indicato (pago un servizio)
         */
        vm.addPayment = function(serviceId) {
            $scope.onlyServiceId = serviceId || null;
            $scope.myResource = {};
            $scope.myResource.entryDate = new Date();
            if ($scope.onlyServiceId) {
                $scope.myResource.paymentOrEntry = 'P';
            } else {
                $scope.myResource.paymentOrEntry = 'E';
            }
            $scope.userOrg = {};
            $scope.organizationId = vm.organizationId;
            vm.userServices = [];

            $mdDialog.show({
                controller: PaymentDialogController,
                templateUrl: 'app/main/pages/earningcosts/dialogs/edit_earningcost_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            }).then(
                function(answer) {
                    var entryType = parseInt(answer.entryType);
                    if ($scope.myResource.paymentOrEntry === 'N') {
                        entryType = -1; //LA NOTA DI CREDITO E' UNA USCITA
                    }
                    answer.entryValue = answer.entryValue * entryType;
                    var userId = ($scope.myResource.selectedItem && $scope.myResource.selectedItem !== null && $scope.myResource.selectedItem.type === 'U') ? $scope.myResource.selectedItem.id : null;
                    var entryOrganizationId = ($scope.myResource.selectedItem && $scope.myResource.selectedItem !== null && $scope.myResource.selectedItem.type === 'O') ? $scope.myResource.selectedItem.id : null;
                    var entryCompany = ($scope.myResource.selectedItem && $scope.myResource.selectedItem !== null && $scope.myResource.selectedItem.type === 'O') ? $scope.myResource.selectedItem.displayName : null;
                    //caso in cui ho scritto il fornitore ma non lo hho selezionato daq tendina
                    if (!entryCompany && !$scope.myResource.selectedItem && vm.searchText && vm.searchText.trim() !== '') {
                        entryCompany = vm.searchText.trim();
                    }
                    vm.searchText = '';
                    EarningCost.create({
                        entryDate: answer.entryDate,
                        entryValue: answer.entryValue,
                        entryDescription: answer.entryDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason !== null) ? answer.paymentReason.id : null,
                        userId: userId,
                        entryOrganizationId: entryOrganizationId,
                        entryCompany: entryCompany,
                        organizationId: vm.organizationId,
                        creditNote: ($scope.myResource.paymentOrEntry === 'N')
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                    }, function(httpResponse) {
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                    vm.searchText = '';
                });
        };


        function PaymentDialogController($scope, $mdDialog) {
            var self = this;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.reloadReason = function() {
                var paymentType='';
                if ($scope.myResource.entryType==1) {
                    paymentType='IN';
                }
                else {
                    paymentType='EX';
                }

                var query =  {
                    filter: {
                        where : {
                            organizationId: null,
                            paymentType:paymentType,
                            internalCode: null
                        }//TODO gestire quelle specifiche della organizzazione
                    }
                };
                PaymentReason.find(query,function(paymentReasons) {
                    $scope.paymentReasons =  paymentReasons;
                });

            };
            $scope.addUserOrganization = function() {
                $scope.isAddingUserOrganization=true;
            };
            $scope.isUserOrganizationValid = function() {
                if (!$scope.userOrg || $scope.userOrg===null  || !$scope.userOrg.type || ($scope.userOrg.type!=='U' && $scope.userOrg.type!=='O') ) {
                    return false;
                }

                if (!$scope.userOrg.email || $scope.userOrg.email===null || $scope.userOrg.email==='') {
                    return false;
                }


                return true;
            };
            $scope.cancelUserOrganization = function() {
                $scope.isAddingUserOrganization=false;
            };
            $scope.addUserOrganizationOnDB = function() {
                $log.debug('OrganizationServicesController.$scope.addUserOrganizationOnDB()');
                return Organization.findById({
                    id : $scope.organizationId
                }).$promise.then(function(organization) {

                    organization.$prototype$findOrAddUserOrganization({
                        search_type:$scope.userOrg.type,
                        search_givenName:$scope.userOrg.givenName,
                        search_familyName:$scope.userOrg.familyName,
                        search_name:$scope.userOrg.name,
                        search_piva:$scope.userOrg.piva,
                        search_email:$scope.userOrg.email
                    })
                        .then(function(response) {
                            $scope.isAddingUserOrganization=false;
                            var val = $scope.userOrg;
                            val.id=response.result.id;
                            if ( $scope.userOrg.type==='U') {
                                val.displayName = $scope.userOrg.givenName.charAt(0).toUpperCase()
                                    + $scope.userOrg.givenName.slice(1) + " "
                                    + $scope.userOrg.familyName.charAt(0).toUpperCase()
                                    + $scope.userOrg.familyName.slice(1);
                            }
                            else {
                                val.displayName=$scope.userOrg.name;
                            }
                            $scope.myResource.selectedItem=val;
                        });
                });
            };
            $scope.lookupUserOrganizations= function(txt){

                var deferred = $q.defer();

                txt='%' + txt+'%';
                var queryUsers = {
                    filter: {
                        where :
                            {or: [
                                    {username: { like: txt } },
                                    {displayName: { like: txt } },
                                    {email: { like: txt }},
                                    {givenName: { like: txt }},
                                    {familyName: { like: txt }}
                                ]
                            }
                    }
                };


                User.find(queryUsers).$promise.then (function(users) {
                    var queryOrgs = {
                        filter: {
                            where : {name: { like: txt } }
                        }
                    };
                    Organization.find(queryOrgs).$promise.then(function(orgs) {
                        var finalList = [];
                        for (var i = 0; i < users.length; i++) {
                            finalList.push({id:users[i].id, type: 'U', email:users[i].email, displayName:users[i].displayName });
                        }
                        for (var i = 0; i < orgs.length; i++) {
                            finalList.push({id:orgs[i].id, type: 'O', email:orgs[i].email, displayName:orgs[i].name });
                        }
                        var finalOrderedList = _.sortBy(finalList, function(x){ return x.displayName; });

                        deferred.resolve(finalOrderedList);

                    });
                });
                return deferred.promise;

            }
            $scope.lookupUser= function(txt){

                var deferred = $q.defer();

                User.lookupUsers({text: txt, organizationId: vm.organizationId}).$promise.then (function(data) {
                    deferred.resolve(data.users);
                });
                return deferred.promise;
            };

            $scope.selectedUserOrganizationChange= function(item) {
                $scope.myResource.selectedItem=item;
            };
            $scope.selectedUserChange= function(item) {
                $scope.myResource.selectedUser=item;
                if ($scope.myResource.selectedUser && $scope.myResource.selectedUser.id) {
                    //carico la lista dei servizi da pagare
                    User.loadUser({
                        id: $scope.myResource.selectedUser.id,
                        organizationId: vm.organizationId
                    }).$promise.then(function(user){
                        user.$prototype$allServices().then(
                            function(response) {

                                if ( response.result.services &&  response.result.services!==null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i <  theServices.length; i++) {
                                        var dateFrom =  theServices[i].dateFrom;
                                        if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                            theServices[i].dateFrom=new Date(dateFrom);
                                        }
                                        var dateTo =  theServices[i].dateTo;
                                        if (dateTo && dateTo!==null && dateTo!=='') {
                                            theServices[i].dateTo=new Date(dateTo);
                                        }
                                    }
                                    //filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                                    theServices = _.filter(theServices, function(service) {
                                        return (vm.organization.id == service.organizationId && service.paymentValue < service.paymentDue);
                                    });
                                    vm.userServices = theServices;

                                    // nic: se ho indicato solo un servizio preciso, mostro solo quello nella lista
                                    // nota: ci sono problemi nel filtro, funziona la prima volta ma non la seconda
                                    // if ($scope.onlyServiceId) {
                                    //     var selectedService = _.find(vm.userServices, function(service) {
                                    //         return service.id === $scope.onlyServiceId;
                                    //     });
                                    //     vm.userServices = [selectedService];
                                    // }
                                } else {
                                    vm.userServices=[];
                                }
                            });
                    });
                }
            };
        }
        PaymentDialogController.inject = ['$scope', '$mdDialog'];


        /**
         * Effettua un pagamento di iscrizione
         *
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        vm.askPaymentDetails = function( userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(amount);
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $log.debug($scope.paymentReasons);
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            $mdDialog.show({
                controller: PaymentDialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    blockUI.start();

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        //aggiungo un piccolo T.O. per la generazione della ricevuta
                        if ($scope.myResource.showFlgGenerateInvoice) {
                            setTimeout(function () {
                                blockUI.stop();
                            }, 3000);
                        } else {
                            blockUI.stop();
                        }

                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        blockUI.stop();
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        };


        /**
         * Aggiorna lo stato searchable di un servizio
         * 
         * @param {number} serviceId Id del servizio da aggiornare
         * vm.searchableService[serviceId] contiene il nuovo valore, da assegnare
         */
        vm.switchSearchable = function(serviceId) {
            $log.debug('vm.switchSearchable(' + serviceId + ')');
            if (serviceId) {
                $log.debug(vm.searchableService[serviceId]);
                // prima cerca il servizio nella lista services
                var service = vm.services.find(function(currentService) {
                    return currentService && currentService.id === serviceId;
                });
                if (service) {
                    // $log.debug(service);
                    // ne aggiorna il valore in ram
                    service.isSearchable = vm.searchableService[serviceId];
                    // ne aggiorna il valore su DB
                    OfferedService.prototype$patchAttributes({ id: serviceId }, {isSearchable: service.isSearchable});
                }
            }
        };


        /**
         * Verifica se un servizio ha abbastanza elementi compilati tra quelli che contribuiscono a far trovare il servizio (5 su 7)
         * @param {*} offeredService 
         * @returns 
         */
        function hasEnoughSearchableInfo(offeredService) {
            var score = 0 +
                (offeredService.categoriesCount > 0 ? 1 : 0) +
                (('' + (offeredService.address ? offeredService.address : '') + (offeredService.city ? offeredService.city : '')).trim().length > 0 ? 1 : 0) +
                (offeredService.latitude && offeredService.longitude ? 1 : 0) +
                (!!offeredService.intensity > 0 ? 1 : 0) +
                (!!offeredService.ageFrom > 0 ? 1 : 0) +
                (!!offeredService.ageTo > 0 ? 1 : 0) +
                (offeredService.pictureCount > 0 ? 1 : 0);
            return score >= 5;
        }

        /**
         * Ritorna l'elenco dei dati inseriti e non che hanno a che fare con la ricercabilità di un servizio
         *
         * @param {OfferedService} offeredService 
         * @returns {string}
         */
        function getSearchableInfo(offeredService) {
            var s = 'Dati utili per ricercare il servizio:' + "\n\n";
            if (offeredService) {
                s += 'Categorie: ';
                if (offeredService.categoriesCount > 0) {
                    s += offeredService.categoriesCount + "\n";
                } else {
                    s +='&ndash;' + "\n";
                }
                s += 'Indirizzo: ';
                var address = ((offeredService.address ? offeredService.address + ' ' : '') +
                    (offeredService.addressNumber ? offeredService.addressNumber + ', ' : '') +
                    (offeredService.postalCode ? offeredService.postalCode + ' ' : '') +
                    (offeredService.city ? offeredService.city + ' ' : '') +
                    (offeredService.province ? offeredService.province : '')).trim();
                if (address) {
                    s += address + "\n";
                } else {
                    s += '&ndash;' + "\n";
                }
                s += 'Localizzazione: ';
                if (offeredService.latitude && offeredService.longitude) {
                    s += '(' + offeredService.latitude + ', ' + offeredService.longitude + ")\n";
                } else {
                    s += '&ndash;' + "\n";
                }
                s += 'Intensità: ';
                if (offeredService.intensity) {
                    s += (offeredService.intensity <= 15 ? 'Molto bassa' : (
                        offeredService.intensity <= 30 ? 'Bassa' :
                        offeredService.intensity <= 70 ? 'Media' : 'Alta'
                    )) + "\n";
                } else {
                    s +='&ndash;' + "\n";
                }
                s += 'Età consigliata: ';
                if (typeof offeredService.ageFrom === 'number' || typeof offeredService.ageTo === 'number') {
                    s += (offeredService.ageFrom ? offeredService.ageFrom : '') + ' - ' +
                    (offeredService.ageTo ? offeredService.ageTo : '') + "\n";
                } else {
                    s +='&ndash;' + "\n";
                }
                s += 'Immagini: ';
                if (offeredService.pictureCount > 0) {
                    s += offeredService.pictureCount + "\n";
                } else {
                    s +='&ndash;' + "\n";
                }
            }
            return s;
        }

    }
})();

(function() {
    'use strict';

    angular.module('app.pages.organizations').controller(
        'OrganizationResourcesController', OrganizationResourcesController);

    /** @ngInject */
    function OrganizationResourcesController($log, $document, $rootScope, $scope, $compile, $sce, $q,
                                             $mdDialog, $state, $translate, AuthenticationService, Organization, User, Category, LoopBackAuth,
                                             UserOrganizationRole, RoleType, OrganizationResource, uiCalendarConfig, ResourceCalendar, ServiceResource,
                                             DTOptionsBuilder, DTColumnDefBuilder, AlertMessageService, ApiPath, OrganizationType, _) {
        var vm = this;

        // Data
        vm.apiPath=ApiPath;
        vm.organizationId='';
        vm.organization={};
        vm.resources=[];

        vm.askOrganizationResourceDetails = askOrganizationResourceDetails;
        vm.saveOrganizationResource = saveOrganizationResource;
        vm.editOrganizationResourceDetails = editOrganizationResourceDetails;
        vm.isShowResourceCalendar=false;
        vm.backToResources=backToResources;
        vm.showResourceCalendar = showResourceCalendar;
        vm.gotoOrganizations=gotoOrganizations;
        vm.goToOrganization=goToOrganization;
        vm.backgroundImage=backgroundImage;
        vm.calendarResource=null;
        vm.loading = true;

        vm.dtOptionsResources = DTOptionsBuilder
            .newOptions()
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withPaginationType('full_numbers')
            .withOption('initComplete',function (){
                var api = this.api(), searchBox = angular.element('body').find('#resources-search');
                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            })
            .withLanguageSource(
                'assets/datatable-lang/' + $translate.use() + '.json')
            .withDOM(
                'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        init();

        /**
         * Initialize
         */
        function init() {

            if (AuthenticationService.isAuthenticated()){
                initResourceCalendar();

                vm.organizationId = $state.params.organizationId;
                if (vm.organizationId && vm.organizationId!==null) {
                    loadOrganization();
                }
            } else {
                $state.go('app.pages_auth_login');
            }

        }

        function loadOrganization() {
            vm.loading = true;
            findOrganization(vm.organizationId)
                .then(
                    function(data) {
                        var myOrganization = data;


                        if (AuthenticationService.isAuthenticated() && !vm.isAdmin) {
                            AuthenticationService.loggedUser().then(function(value, headers) {
                                vm.user = value;
                                $log.debug(vm.user);

                                //myOrganization.$prototype$isAdmin(
                                Organization.isOrganizationAdmin(
                                    {
                                        organizationId: myOrganization.id,
                                        userId : vm.user.id
                                    }).$promise
                                    .then(function(response) {
                                        vm.isAdmin = response && response.isAdmin;
                                    });
                            });
                        }

                        vm.organization = (JSON.parse(JSON
                            .stringify(myOrganization)));
                        vm.loading = false;


                    }, function(error) {
                        vm.loading = false;
                        $log.debug(error);
                    });
        }


        $rootScope.$on('$translateChangeEnd', function() {
            vm.dtOptionsResources.withLanguageSource('assets/datatable-lang/'
                + $translate.use() + '.json');
            vm.uiConfig.resourceCalendar.lang=$translate.use();


        });


        function findOrganization(id) {
            $log.debug('OrganizationResourcesController.findOrganization()');
            return Organization.findById({
                id : id,
                filter : {
                    include : [ 'roleTypes', {organizationResources: 'staffMember' }],
                }
            }).$promise;
        }


        //
        // gestione RESOURCES
        //
        function saveOrganizationResource(resourceId, organizationResource) {
            organizationResource.organizationId = vm.organization.id;
            if (resourceId && resourceId !== null) {
                organizationResource.id = resourceId;
            }

            if (!organizationResource.flgStaff) {
                organizationResource.userId=null;
            }
            else {
                organizationResource.totalNumber=1;
            }

            if (organizationResource.id && organizationResource.id !== null) {
                OrganizationResource.update({
                    where : {
                        id : organizationResource.id
                    }
                }, organizationResource, function(value, responseHeaders) {
                    $log.debug(value);
                    loadOrganization(vm.organization.id);
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);

                });
            } else {
                OrganizationResource.create(organizationResource, function(org,
                                                                           responseHeaders) {
                    $log.debug('saveOrganization() riuscita: ');
                    $log.debug(org);
                    loadOrganization(vm.organization.id);
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);

                });
            }

        }

        function askOrganizationResourceDetails(ev) {
            $scope.myResource = {};

            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/organization/dialogs/new_resource_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        scope : $scope,
                        preserveScope : true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                vm.saveOrganizationResource(null, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }

        function editOrganizationResourceDetails(ev, organizationResource) {
            $scope.myResource = organizationResource;

            $scope.myResource.selectedItem=organizationResource.staffMember;

            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/organization/dialogs/edit_resource_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        scope : $scope,
                        preserveScope : true,
                        clickOutsideToClose : true
                    }).then(
                function(answer) {
                    vm.saveOrganizationResource(
                        organizationResource.id, answer);
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }

        function initResourceCalendar() {
            vm.uiConfig = {};
            vm.uiConfig.resourceCalendar={
                editable: false,
                height: 450,
                viewRender: function(view, element) {
                    //showResourceCalendar();
                    //loadResourceCalendar($state.params.organizationId, view.intervalStart.toDate(), view.intervalEnd.toDate());
                },
                eventClick: function(calEvent, jsEvent, view) {
                    editResourceDetails(null, calEvent.serviceResource);
                },
                header:{
                    left: 'month agendaWeek agendaDay',
                    center: 'title',
                    right: 'today prev,next'
                },
                lang:$translate.use()
            };
        }


        /**
         * Carica calendario relativo a una singola risorsa
         */
        function showResourceCalendar(ev, resource) {

            loadOrganizationResources();

            if (resource) {
                vm.calendarResource=resource;
            }

            var query ={
                filter: {
                    where : {resourceId: vm.calendarResource.id, itemType: 'R'},
                    include : [ 'offeredService', 'serviceResource',  {organizationResource: 'staffMember'} ]
                }
            }
            ResourceCalendar.find(query, function(calendars) {

                vm.eventSourcesForResource = [];
                var events = [];

                for (var i = 0; i < calendars.length; i++) {

                    var calOccurrence = calendars[i];

                    var dtServiceResourceFrom = calOccurrence.serviceResource.dateFrom;
                    if (dtServiceResourceFrom && dtServiceResourceFrom!==null && dtServiceResourceFrom!=='') {
                        calOccurrence.serviceResource.dateFrom=new Date(dtServiceResourceFrom);
                    }
                    var dtServiceResourceTo = calOccurrence.serviceResource.dateTo;
                    if (dtServiceResourceTo && dtServiceResourceTo!==null && dtServiceResourceTo!=='') {
                        calOccurrence.serviceResource.dateTo=new Date(dtServiceResourceTo);
                    }


                    var calObj = {};

                    var dateFrom = moment(calOccurrence.eventDate);
                    dateFrom.hour(calOccurrence.minutesFrom/60);
                    dateFrom.minutes(calOccurrence.minutesFrom%60);

                    var dateTo = moment(calOccurrence.eventDate);
                    dateTo.hour(calOccurrence.minutesTo/60);
                    dateTo.minutes(calOccurrence.minutesTo%60);


                    calObj.title = '';

                    var staffMember = calOccurrence.organizationResource.staffMember;
                    if (staffMember && staffMember!==null) {
                        calObj.title += staffMember.displayName +  ' - ';
                    }
                    if (calOccurrence.organizationResource && calOccurrence.organizationResource!==null) {
                        calObj.title += calOccurrence.organizationResource.name;
                    }
                    if (calOccurrence.offeredService && calOccurrence.offeredService!==null) {
                        calObj.title += " - "+ calOccurrence.offeredService.name;
                    }

                    calObj.color = (staffMember && staffMember!==null)?'green':'darkred';

                    // calObj.color = 'darkred';

                    calObj.start = dateFrom.toDate();
                    calObj.end = dateTo.toDate();
                    calObj.allDay = false;
                    calObj.textColor = 'white';
                    calObj.serviceResource=calOccurrence.serviceResource;

                    events.push(calObj);
                }

                vm.eventSourcesForResource.push(events);

                uiCalendarConfig.calendars.myResourceCalendar.fullCalendar('removeEvents');
                uiCalendarConfig.calendars.myResourceCalendar.fullCalendar('addEventSource', vm.eventSourcesForResource[0]);

                vm.isShowResourceCalendar=true;

                //pessimo ma funzionante WORK AROUND per mostrare il calendario dentro una pannello a scomparsa
                setTimeout(function() {
                    try {
                        uiCalendarConfig.calendars.myResourceCalendar.fullCalendar( 'changeView', 'xxx' );//DA SISTEMARE!!! FIXME
                    } catch(err) {}
                    uiCalendarConfig.calendars.myResourceCalendar.fullCalendar( 'changeView', 'month' );
                }, 0);

            })

        }

        function backToResources() {
            vm.calendarResource=null;
            vm.isShowResourceCalendar=false;
        }

        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };

            $scope.changeHourFrom = function() {
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesFrom || $scope.myResource.minutesFrom===null || $scope.myResource.minutesFrom==='')) {
                    $scope.myResource.minutesFrom='0';
                }
            }
            $scope.changeHourTo = function() {
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesTo || $scope.myResource.minutesTo===null || $scope.myResource.minutesTo==='')) {
                    $scope.myResource.minutesTo='0';
                }
            }

            $scope.selectedStaffMember = function(item) {
                $scope.myResource.userId=item.id;
                $scope.myResource.totalNumber=1;
            };

            $scope.changeHourTo = function() {
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesTo || $scope.myResource.minutesTo===null || $scope.myResource.minutesTo==='')) {
                    $scope.myResource.minutesTo=0;
                }
            }
            $scope.changeTypeCode = function() {
                if ($scope.myResource && $scope.myResource!=null && $scope.myResource.typeCode==='S') {
                    $scope.myResource.weekDay=null;
                    $scope.showWeekDay=true;
                }
                else {
                    $scope.showWeekDay=false;
                }
            };

            $scope.lookupStaffUser= function(txt){
                var deferred = $q.defer();
                var search = txt==null?'':txt.toLowerCase();
                RoleType.find( {filter: {
                        where : {internalCode: 'STAFF', organizationId: vm.organization.id}
                    }
                }, function(roles, responseHeaders) {
                    var role = roles[0];
                    var query = {roleTypeId: role.id, organizationId: vm.organization.id };
                    UserOrganizationRole.find({filter:{where: query, include: ['user']}}, function(res) {
                        //res
                        var users = _.map(res, function(r) {return r.user;});
                        var filteredList = _.filter(users, function(x){
                            return x.displayName.startsWith(search) || x.givenName.startsWith(search) || x.familyName.startsWith(search) || x.email.startsWith(search);
                        });
                        var finalOrderedList = _.sortBy(filteredList, function(x){ return x.displayName; });
                        for (var i = 0; i < finalOrderedList.length; i++) {
                            if (finalOrderedList[i].email && finalOrderedList[i].email !==null && finalOrderedList[i].email.endsWith('invalid')) {
                                finalOrderedList[i].email=null;
                            }
                        }

                        deferred.resolve(finalOrderedList);

                    });
                });

                return deferred.promise;

            }
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        function CalendarDialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                var isOk = false;
                //CHECK
                //- date inizio e fine popolate
                //- data inizio <= data fine
                if (!$scope.myResource.dateFrom || !$scope.myResource.dateTo) {
                    $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_MANDATORY');
                } else if (moment($scope.myResource.dateFrom).isAfter(moment($scope.myResource.dateTo))) {
                    $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_INTERVAL_INVALID');
                } else if ( !$scope.myResource.typeCode) {
                    $scope.displayErrorDay = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_TYPE_MANDATORY');
                } else if ( $scope.myResource.typeCode==='S' && !$scope.myResource.weekDay) {
                    $scope.displayErrorDay = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_WEEKDAY_MANDATORY');
                } else if (!$scope.myResource.hourFrom || !$scope.myResource.hourTo) {
                    $scope.displayErrorHours = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_HOURS_MANDATORY');
                } else {
                    var minInizio = parseInt($scope.myResource.hourFrom *60) + parseInt($scope.myResource.minutesFrom);
                    var minFine = parseInt($scope.myResource.hourTo *60) + parseInt($scope.myResource.minutesTo);
                    if (minInizio > minFine) {
                        $scope.displayErrorHours = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_HOURS_INVERTED');
                    } else {
                        isOk=true;
                    }
                }
                //giorno obbligatorio se settimanale
                if (isOk) {
                    $mdDialog.hide(answer);
                }
            };
            $scope.changeHourFrom = function() {
                $scope.displayErrorHours='';
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesFrom || $scope.myResource.minutesFrom===null || $scope.myResource.minutesFrom==='')) {
                    $scope.myResource.minutesFrom='0';
                }
            }
            $scope.changeHourTo = function() {
                $scope.displayErrorHours='';
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesTo || $scope.myResource.minutesTo===null || $scope.myResource.minutesTo==='')) {
                    $scope.myResource.minutesTo='0';
                }
            }
            $scope.changeTypeCode = function() {
                $scope.displayErrorDay='';
                if ($scope.myResource && $scope.myResource!=null && $scope.myResource.typeCode==='S') {
                    $scope.myResource.weekDay=1;
                    $scope.showWeekDay=true;
                }
                else {
                    $scope.showWeekDay=false;
                }
            }
            $scope.populateResourceDefault = function() {
                if ($scope.myResource && $scope.myResource!=null && $scope.myResource.resource &&  $scope.myResource.resource!==null ) {
                    if (!$scope.myResource.userCost || $scope.myResource.userCost===null) {
                        $scope.myResource.userCost = $scope.myResource.resource.userCost;
                    }
                    if (!$scope.myResource.organizationCost || $scope.myResource.organizationCost===null) {
                        $scope.myResource.organizationCost = $scope.myResource.resource.organizationCost;
                    }
                    if ($scope.myResource.freeUsage===null) {
                        $scope.myResource.freeUsage = $scope.myResource.resource.freeUsage;
                    }
                }
            }
        }
        CalendarDialogController.inject = ['$scope', '$mdDialog'];



        function loadOrganizationResources() {
            var query =  {
                filter: {
                    where : {organizationId: $state.params.organizationId },
                    include: 'staffMember'
                }
            };
            return OrganizationResource.find(query,function(resources) {
                vm.resources =  resources;
            });
        }

        /**
         * Apre modale e esegue MODIFICA RISORSA USATA DAL SERVIZIO
         */
        function editResourceDetails(ev, resource){
            $scope.resources=vm.resources;
            $scope.myResource=resource;
            $scope.myResource.resource={
                id:resource.resourceId,
                name:resource.name,
                staffMember: resource.staffMember
            };

            if ($scope.myResource.typeCode==='S') {
                $scope.weekDay=null;
                $scope.showWeekDay=true;
            }
            else {
                $scope.showWeekDay=false;
            }

            $mdDialog.show({
                controller: CalendarDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_resource_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceResource = answer;
                    serviceResource.id=resource.id;
                    serviceResource.offeredServiceId = resource.offeredServiceId;

                    ServiceResource.updateAll(
                        {
                            where: { id: resource.id }
                        },
                        serviceResource,
                        function(org,responseHeaders){
                            $log.debug('saveOrganization() riuscita: ');
                            $log.debug(org);
                            showResourceCalendar();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         * Go to organizations page
         */
        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()});
        }


        function goToOrganization() {
            $state.go('app.organization',{organizationId: vm.organization.id});
        }

        function backgroundImage() {
            if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
            }
            return {'background-image': 'none'};

        }

    }
})();

(function() {
    'use strict';

    angular.module('app.pages.organizations').controller(
        'OrganizationMembersController', OrganizationMembersController);

    /** @ngInject */
    function OrganizationMembersController($log, $document, $rootScope, $scope, $compile, $sce,
                                           $mdDialog, $state, $translate, AuthenticationService, Organization, User,
                                           Category, LoopBackAuth,
                                           UserOrganizationRole, RoleType, OrganizationResource, uiCalendarConfig,
                                           ResourceCalendar,
                                           DTOptionsBuilder, DTColumnBuilder, AlertMessageService, ApiPath,
                                           OrganizationType, _, $q, Subscription, blockUI,
                                           EarningCost, PaymentReason, CylUtils, Payment, entitiesService) {
        var vm = this;

        // Data
        vm.apiPath=ApiPath;
        vm.organizationId='';
        vm.organization={};
        vm.usersWithRoles = {};
        vm.user = null;
        vm.deleteMember = deleteMember;
        vm.askUserDetails = askUserDetails;
        vm.gotoOrganizations=gotoOrganizations;
        vm.goToOrganization=goToOrganization;
        vm.backgroundImage=backgroundImage;
        vm.exportExcel=exportExcel;


        //
        // Datatable
        //
        vm.dtInstance = {};
        vm.dtSearchTerm = '';
        vm.dtItems = [];                // eleneoc lementi nella DT, serve per cercare gli elementi negli handler dei bottoni vari
        vm.reloadItems=reloadItems;


        /**
         * Carica una pagina di elementi dalla datatables
         * @param sSource
         * @param aoData
         * @param fnCallback
         * @param oSettings
         */
        vm.loadDtItems = function(sSource, aoData, fnCallback, oSettings) {
            $log.debug('vm.loadDtItems()');
            vm.computeStart = Date.now();
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            entitiesService.fetchOrganization(vm.organizationId, ['roleTypes', 'offeredServices']).then(
                function(organization) {
                    $log.debug({organization: organization});
                    organization.$prototype$allUsers().then(
                        function(response) {
                            $log.debug(getSecondsFromStart() + ' - organization.$prototype$allUsers() succeeded');
                            var items = [];

                            // search filter
                            if (vm.dtSearchTerm) {
                                vm.dtSearchTerm = vm.dtSearchTerm.trim().toLowerCase();
                                response.result.users = _.filter(response.result.users, function(item) {
                                    var keep = false;
                                    if (!keep && item.familyName) {
                                        keep = item.familyName.toLowerCase().indexOf(vm.dtSearchTerm) >= 0;
                                    }
                                    if (!keep && item.givenName) {
                                        keep = item.givenName.toLowerCase().indexOf(vm.dtSearchTerm) >= 0;
                                    }
                                    if (!keep && item.email) {
                                        keep = item.email.toLowerCase().indexOf(vm.dtSearchTerm) >= 0;
                                    }
                                    if (!keep && item.contactEmail) {
                                        keep = item.contactEmail.toLowerCase().indexOf(vm.dtSearchTerm) >= 0;
                                    }
                                    return keep;
                                });
                                $log.debug(getSecondsFromStart() + ' - search filter applied');
                            }
                            var totItems = response.result.users.length;
                            var filteredItems = totItems;

                            // filters elements #
                            var i = 0;
                            _.each(response.result.users, function(item) {
                                if (i >= start && i < start+length) {
                                    items.push(item);
                                }
                                i++;
                            });
                            $log.debug(getSecondsFromStart() + ' - star/limit applied');

                            vm.dtItems = items;
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': totItems,
                                'recordsFiltered': totItems,
                                'data': items
                            });
                        },
                        function(err) {
                            $log.warn('organization.$prototype$allUsers() failed');
                        }
                    );
                },
                function(err) {
                    $log.error(err);
                }
            );
        };
        vm.dtOptionsUsers = DTOptionsBuilder
            .newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadDtItems)
            .withDataProp('data')
            .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withDisplayLength(50)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
        ;
        vm.renderDtColumnAvatar = function(data, type, member) {
            if (member && member.uriAvatar) {
                return '<img md-menu-align-target class="avatar" src="' + vm.apiPath + '/userDocumentsContainers/' + $rootScope.CYL_USER_DOC_PREFIX + member.id + '/download/' + member.uriAvatar + '">';
            } else {
                return '<img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg">';
            }
        };
        vm.renderDtColumnName = function(data, type, member) {
            if (member && (member.familyName || member.givenName)) {
                return member.familyName + ' ' + member.givenName;
            } else {
                return 'utente ' + member.id || 'sconosciuto';
            }
        };
        vm.renderDtColumnEmail = function(data, type, member) {
            return member.email.endsWith('invalid') ?
                ((member.contactEmail && !member.contactEmail.endsWith('invalid')) ?
                    'Contatto: ' + member.contactEmail :
                    '')
                :
                member.email;
        };
        vm.renderDtColumnRuoli = function(data, type, member) {
            if (member && member.roles) {
                return '<span ng-click="vm.editUserRoles($event, ' + member.id + ');" class="ov-cursor-pointer">' +
                    '<md-icon ng-if="member.toVerify" md-font-icon="icon-account-alert" title="da verificare"></md-icon> ' +
                    '<md-icon ng-if="!member.toVerify" md-font-icon="icon-pencil-box" class="s16"></md-icon> ' +
                    member.roles + '</span>';
            } else {
                return '';
            }
        };
        vm.renderDtColumnActive = function(data, type, member) {
            if (member) {
                return '<span ng-click="vm.toggleActivation(' + member.id + ', ' + member.active + ');" class="ov-cursor-pointer">' +
                    (
                        member.active ?
                            '<i class="fa fa-toggle-on"></i> attivo' :
                            '<i class="fa fa-toggle-off"></i> non attivo'
                    ) +
                    '</span>';
            } else {
                return '';
            }
        };
        vm.renderDtColumnActions = function(data, type, member) {
            if (member && member.id) {
                return '' +
                    // pagamenti
                    '<md-button class="edit-button md-icon-button" ' +
                        'ng-click="vm.addPayment(' + member.id + ');" ' +
                        'aria-label="Pagamenti" title="Pagamenti">' +
                        '<md-icon md-font-icon="icon-currency-eur"></md-icon>' +
                    '</md-button>' +
                    // profilo utente
                    '<md-button class="edit-button md-icon-button" ' +
                        'ng-click="vm.gotoUserProfile(' + member.id + ');" ' +
                        'aria-label="Scheda personale" title="Scheda personale">' +
                        '<md-icon md-font-icon="icon-account-box"></md-icon>' +
                    '</md-button>' +
                    // documenti
                    '<md-button class="edit-button md-icon-button" ' +
                        'ng-click="vm.gotoUserDocuments(' + member.id + ');" ' +
                        'aria-label="Documenti" title="Documenti">' +
                        '<md-icon md-font-icon="icon-file-multiple"></md-icon>' +
                    '</md-button>' +
                    // presenze
                    '<md-button class="edit-button md-icon-button" ' +
                        'ng-click="vm.gotoUserPresenze(' + member.id + ');" ' +
                        'aria-label="Presenze" title="Presenze">' +
                        '<md-icon md-font-icon="icon-account-check"></md-icon>' +
                    '</md-button>' +
                    // eliminazione
                    '<md-button class="edit-button md-icon-button" ' +
                        'ng-click="vm.deleteMember($event, ' + member.id + ');" ' +
                        'aria-label="Elimina" title="Elimina">' +
                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                    '</md-button>'
                    ;
            } else {
                return '';
            }
        };
        vm.dtColumnsUsers = [
            DTColumnBuilder.newColumn('memberAvatar').withTitle('').notSortable().renderWith(vm.renderDtColumnAvatar),
            DTColumnBuilder.newColumn('memberName').withTitle('Nome').notSortable().renderWith(vm.renderDtColumnName),
            DTColumnBuilder.newColumn('memberEmail').withTitle('Email').notSortable().renderWith(vm.renderDtColumnEmail),
            DTColumnBuilder.newColumn('memberRoles').withTitle('Ruoli').notSortable().renderWith(vm.renderDtColumnRuoli),
            DTColumnBuilder.newColumn('memberActivate').withTitle('').notSortable().renderWith(vm.renderDtColumnActive),
            DTColumnBuilder.newColumn('memberActions').withTitle('Azioni').notSortable().renderWith(vm.renderDtColumnActions),
        ];
        vm.updateTableLocale = function() {
            vm.dtOptionsUsers.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
        };
        function reloadItems() {
            //$rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }

        $rootScope.$on('$translateChangeEnd', function () {
            vm.updateTableLocale();
        });
        vm.updateTableLocale();


        init();

        /**
         * Initialize
         */
        function init() {
            $log.debug('OrganizationMembersController.init()');
            if (AuthenticationService.isAuthenticated()) {
                vm.organizationId = $state.params.organizationId;
                loadOrganization();
            } else {
                $state.go('app.pages_auth_login');
            }

        }

        $rootScope.$on('$translateChangeEnd', function() {
            vm.dtOptionsUsers.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
        });




        /**
         * Carica i dati dell'organizzazione gestita
         */
        function loadOrganization() {
            if (AuthenticationService.isAuthenticated()) {
                AuthenticationService.loggedUser().then(
                    function(loggedUser) {
                        vm.user = loggedUser;
                        $log.debug(vm.user);
                        // check whether user is organization's admin
                        entitiesService.fetchOrganization(vm.organizationId, ['roleTypes', 'offeredServices']).then(
                            function(myOrganization) {
                                vm.organization = JSON.parse(JSON.stringify(myOrganization));
                                Organization.isOrganizationAdmin({
                                    organizationId: myOrganization.id,
                                    userId: vm.user.id
                                }).$promise.then(
                                    function(response) {
                                        vm.isAdmin = response && response.isAdmin;
                                    },
                                    function() {
                                    }
                                );
                            },
                            function() {
                                // ignora errori
                            }
                        );
                    },
                    function(err) {
                        // ignora errori
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function exportExcel() {
            var url = ApiPath + '/organizations/xlsx-organization-users?organizationId='+vm.organization.id+'&tk='+LoopBackAuth.accessTokenId;
            window.open(url, '_blank');
        }


        /**
         * Apre una modal per gestire i tuoli dell'utente selezionato
         *
         * @param ev
         * @param userId
         */
        vm.editUserRoles = function(ev, userId) {
            var user = _.find(vm.dtItems, function(member) {
                return member.id === userId;
            });
            $scope.roles = new Array();
            for (var i = 0; i < vm.organization.roleTypes.length; i++) {
                $scope.roles.push(vm.organization.roleTypes[i].name.trim());
            }

            var userRolesNames = user.roles.split(',');
            $scope.userRoles = new Array();
            for (var i = 0; i < userRolesNames.length; i++) {
                $scope.userRoles.push(userRolesNames[i].trim());
            }

            $mdDialog.show({
                controller : DialogController,
                templateUrl : 'app/main/pages/organizations/views/organization/dialogs/edit_user_roles_dialog.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                scope : $scope,
                preserveScope : true,
                clickOutsideToClose : true
            })
                .then(
                    function(answer) {

                        //
                        //NOTA:
                        //Prevengo il caso in cui sono amministratore e sto cambiando i ruoli di me stesso: non salvo ne cancello il ruolo amministratore
                        //per evitare di auto escludermi dalla applicazione
                        //

                        // prendo la lista dei ruoli da salvare e
                        // estraggo gli id
                        var toSave = new Array();
                        for (var i = 0; i < $scope.userRoles.length; i++) {
                            var name = $scope.userRoles[i];

                            var roleType = _.find( vm.organization.roleTypes, function(r){ return r.name === name; });

                            if (roleType && roleType!=null) {
                                //se sto salvando i ruoli di me stesso e roleType.internalCode=='ADMIN' -> skip
                                if ( user.id == vm.user.id && roleType.internalCode && roleType.internalCode==='ADMIN') {
                                    continue;
                                }
                                toSave.push({
                                    userId : user.id,
                                    organizationId : vm.organization.id,
                                    roleTypeId : roleType.id
                                });
                            }
                        }



                        entitiesService.fetchOrganization(vm.organization.id, ['roleTypes', 'offeredServices']).then(
                            function(myOrganization) {
                                myOrganization.$prototype$deleteRolesByUser(
                                    {
                                        userId : user.id
                                    },
                                    function(org,responseHeaders) {
                                        $log.debug('UserOrganizationRole.destroyAll() riuscita: ');
                                        $log.debug(org);

                                        UserOrganizationRole.createMany(
                                            toSave,
                                            function(org,responseHeaders) {
                                                vm.dtInstance.DataTable.draw();
                                            },
                                            function(httpResponse) {
                                                $log.debug(httpResponse);
                                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                            });

                                    },
                                    function(httpResponse) {
                                        httpResponse.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                    });
                            });

                    }, function() {
                        $log.debug('You cancelled the dialog.');
                    });
        }



        function deleteMember(ev, userId) {
            var user = _.find(vm.dtItems, function(member) {
                return member.id === userId;
            });
            $mdDialog.show({
                controller : DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                scope : $scope,
                preserveScope : true,
                clickOutsideToClose : true
            })
                .then(function(answer) {
                    if ( user.id == vm.user.id ) {
                        AlertMessageService.showErrorAlert("ORGANIZATIONS.ERRORS.CANT_DELETE_YOURSELF");
                        return;
                    }

                    entitiesService.fetchOrganization(vm.organization.id, ['roleTypes', 'offeredServices']).then(
                        function(theOrganization) {// $log.debug(data);
                            var offeredServicesId = _.map(theOrganization.offeredServices, function (s) { return s.id;} );

                            //CONTROLLO SE L'UTENTE HA ISCRIZIONI ATTIVE
                            Subscription.count({
                                where : {dtDel: null, userId: user.id, offeredServiceId: {inq: offeredServicesId}}
                            }, function(totalNumber) {
                                if (totalNumber.count && totalNumber.count>0)  {
                                    //ERRORE: ci sono servizi associati
                                    AlertMessageService.showErrorAlert("ORGANIZATIONS.ERRORS.CANT_DELETE_USER_HAS_SUBSCRIPTIONS");
                                }
                                else {
                                    //CANCELLO I USER ROLE
                                    theOrganization.$prototype$deleteRolesByUser(
                                        {
                                            userId : user.id
                                        },
                                        function(org,responseHeaders) {
                                            vm.dtInstance.DataTable.draw();
                                        },
                                        function(httpResponse) {
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                        });
                                }
                            });
                        });
                });
        }


        /**
         * Attiva o disattiva un utente
         */
        vm.toggleActivation = function(userId, active) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            }).then(function(answer) {
                var setactive = active ? false : true;
                User.activateUserForOrganization(
                        {userId: userId.toString(), organizationId: vm.organizationId.toString(), isActive: setactive}
                    ).$promise.then(
                        function(data) {
                            vm.dtInstance.DataTable.draw();
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse) {
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );
            }, function() {
                // $log.debug('You cancelled the dialog.');
            });
        };


        function askUserDetails(ev){
            $state.go('app.pages_new_user', {organizationId: vm.organization.id});
        }


        vm.gotoUserProfile = function(userId) {
            $state.go('app.pages_user_detail', {userId: userId, organizationId: vm.organizationId});
        };


        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        // va alla gestione delle presenze di una persona per l'organizzazione corrente
        vm.gotoUserPresenze = function(userId) {
            $state.go('app.user_attendances', { userId: userId });
        };



        // va alla gestione dei documenti di una persona
        vm.gotoUserDocuments = function(userId) {
            $state.go('app.pages_user_documents', { userId: userId });
        };





        /**
         * Go to organizations page
         */
        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()});
        }

        function goToOrganization() {
            $state.go('app.organization',{organizationId: vm.organization.id});
        }

        function backgroundImage() {
            if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
            }
            return {'background-image': 'none'};

        }


        /**
         * Va alla pagina dei pagamenti di una persona
         *
         * @param options
         */
        vm.gotoPayments = function(userId) {
            if (userId) {
                $state.go('app.pages_user_payments', {userId: userId});
            }
        };
        // questa la tengo che non si sa mai, forse in precedenza effettuava il pagamento?
        vm.addPayment = function(userId) {
            if (userId) {
                $state.go('app.pages_user_payments', {userId: userId});
            }
        };



        function PaymentDialogController($scope, $mdDialog) {
            var self = this;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.reloadReason = function() {
                var paymentType='';
                if ($scope.myResource.entryType==1) {
                    paymentType='IN';
                }
                else {
                    paymentType='EX';
                }

                var query =  {
                    filter: {
                        where : {
                            organizationId: null,
                            paymentType:paymentType,
                            internalCode: null
                        }//TODO gestire quelle specifiche della organizzazione
                    }
                };
                PaymentReason.find(query,function(paymentReasons) {
                    $scope.paymentReasons =  paymentReasons;
                });

            };
            $scope.addUserOrganization = function() {
                $scope.isAddingUserOrganization=true;
            };
            $scope.isUserOrganizationValid = function() {
                if (!$scope.userOrg || $scope.userOrg===null  || !$scope.userOrg.type || ($scope.userOrg.type!=='U' && $scope.userOrg.type!=='O') ) {
                    return false;
                }

                if (!$scope.userOrg.email || $scope.userOrg.email===null || $scope.userOrg.email==='') {
                    return false;
                }


                return true;
            };
            $scope.cancelUserOrganization = function() {
                $scope.isAddingUserOrganization=false;
            };
            $scope.addUserOrganizationOnDB = function() {
                $log.debug('$scope.addUserOrganizationOnDB()');
                entitiesService.fetchOrganization($scope.organizationId, ['roleTypes', 'offeredServices']).then(
                    function(organization) {
                        organization.$prototype$findOrAddUserOrganization({
                            search_type:$scope.userOrg.type,
                            search_givenName:$scope.userOrg.givenName,
                            search_familyName:$scope.userOrg.familyName,
                            search_name:$scope.userOrg.name,
                            search_piva:$scope.userOrg.piva,
                            search_email:$scope.userOrg.email
                        })
                        .then(function(response) {
                            $scope.isAddingUserOrganization=false;
                            var val = $scope.userOrg;
                            val.id=response.result.id;
                            if ( $scope.userOrg.type==='U') {
                                val.displayName = $scope.userOrg.givenName.charAt(0).toUpperCase()
                                    + $scope.userOrg.givenName.slice(1) + " "
                                    + $scope.userOrg.familyName.charAt(0).toUpperCase()
                                    + $scope.userOrg.familyName.slice(1);
                            }
                            else {
                                val.displayName=$scope.userOrg.name;
                            }
                            $scope.myResource.selectedItem=val;
                        });
                });
            };
            $scope.lookupUserOrganizations= function(txt){

                var deferred = $q.defer();

                txt='%' + txt+'%';
                var queryUsers = {
                    filter: {
                        where :
                            {or: [
                                    {username: { like: txt } },
                                    {displayName: { like: txt } },
                                    {email: { like: txt }},
                                    {givenName: { like: txt }},
                                    {familyName: { like: txt }}
                                ]
                            }
                    }
                };


                User.find(queryUsers).$promise.then (function(users) {
                    var queryOrgs = {
                        filter: {
                            where : {name: { like: txt } }
                        }
                    };
                    Organization.find(queryOrgs).$promise.then(function(orgs) {
                        var finalList = [];
                        for (var i = 0; i < users.length; i++) {
                            finalList.push({id:users[i].id, type: 'U', email:users[i].email, displayName:users[i].displayName });
                        }
                        for (var i = 0; i < orgs.length; i++) {
                            finalList.push({id:orgs[i].id, type: 'O', email:orgs[i].email, displayName:orgs[i].name });
                        }
                        var finalOrderedList = _.sortBy(finalList, function(x){ return x.displayName; });

                        deferred.resolve(finalOrderedList);

                    });
                });
                return deferred.promise;

            }
            $scope.lookupUser= function(txt){

                var deferred = $q.defer();

                User.lookupUsers({text: txt, organizationId: vm.organizationId}).$promise.then (function(data) {
                    deferred.resolve(data.users);
                });
                return deferred.promise;
            };

            $scope.selectedUserOrganizationChange= function(item) {
                $scope.myResource.selectedItem=item;
            };
            $scope.selectedUserChange= function(item) {
                $scope.myResource.selectedUser=item;
                if ($scope.myResource.selectedUser && $scope.myResource.selectedUser.id) {
                    //carico la lista dei servizi da pagare
                    User.loadUser({
                        id: $scope.myResource.selectedUser.id,
                        organizationId: vm.organizationId
                    }).$promise.then(function(user){
                        user.$prototype$allServices().then(
                            function(response) {

                                if ( response.result.services &&  response.result.services!==null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i <  theServices.length; i++) {
                                        var dateFrom =  theServices[i].dateFrom;
                                        if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                            theServices[i].dateFrom=new Date(dateFrom);
                                        }
                                        var dateTo =  theServices[i].dateTo;
                                        if (dateTo && dateTo!==null && dateTo!=='') {
                                            theServices[i].dateTo=new Date(dateTo);
                                        }
                                    }
                                    //filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                                    theServices = _.filter(theServices, function(service) {
                                        return (vm.organization.id == service.organizationId && service.paymentValue < service.paymentDue);
                                    })
                                    vm.userServices = theServices;
                                } else {
                                    vm.userServices=[];
                                }
                            });
                    });
                }
            };

        }
        PaymentDialogController.inject = ['$scope', '$mdDialog'];



        /**
         * Effettua un pagamento di iscrizione
         *
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        vm.askPaymentDetails = function( userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(amount);
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $log.debug($scope.paymentReasons);
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            $mdDialog.show({
                controller: PaymentDialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    blockUI.start();

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        //aggiungo un piccolo T.O. per la generazione della ricevuta
                        if ($scope.myResource.showFlgGenerateInvoice) {
                            setTimeout(function () {
                                blockUI.stop();
                            }, 3000);
                        } else {
                            blockUI.stop();
                        }

                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        blockUI.stop();
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        };


        /**
         * Ritorna il nr. di secondi trascorsi dall'inizio dell'elaborazione.
         *
         * @returns {string}
         */
        function getSecondsFromStart() {
            return '' + ((Date.now() - vm.computeStart) / 1000).toLocaleString(
                'it-IT',
                {
                    minimumFractionDigits: 3,
                }
            );
        }


        $scope.gotoUserProfileFromOrganizationMembersController = function(userId, organizationId) {
            $state.go('app.pages_profile', {
                userId : userId,
                organizationId: organizationId,
            });
        };


    }
})();

(function() {
    'use strict';

    angular.module('app.pages.organizations').controller(
        'OrganizationController', OrganizationController);

    /** @ngInject */
    function OrganizationController($log,  $q, $cookies, $document, $rootScope, $scope, $compile, $sce, $filter,
                                    $timeout, $interval, $mdDialog, $state, $translate, AuthenticationService,
                                    Organization, User, Category, UserOrganizationRole, RoleType, OrganizationResource,
                                    uiCalendarConfig, ResourceCalendar, Subscription,
                                    DTOptionsBuilder, DTColumnDefBuilder, TourService, CylPlan, AlertMessageService,
                                    ApiPath, OrganizationType, _, breadcrumbManager, appDataService,
                                    OrganizationPreference) {
        var vm = this;
        vm.appDataService = appDataService;
        vm.planChart = {
            dataPoints: [],
            dataColumns: [
                {id: 'a', type:'donut', name: 'Contatti attivi'},
                {id: 'b', type:'donut', name: 'Contatti non utilizzati'}
            ]
        };
        // effettua il polling periodico in attesa delle statistiche per il grafico del piano acquistato
        var intervalPlanStats = $interval(function() {
            // $log.debug('appDataService: ' + JSON.stringify(vm.appDataService));
            var numActiveContacts = null;
            var maxActiveContacts = null;
            if (vm.appDataService && vm.appDataService.organizationPlanStats &&
                vm.appDataService.organizationPlanStats.numActiveContacts) {
                numActiveContacts = vm.appDataService.organizationPlanStats.numActiveContacts;
                if (vm.appDataService.organizationPlanStats.plan && vm.appDataService.organizationPlanStats.plan.metadata &&
                    vm.appDataService.organizationPlanStats.plan.metadata['max-org-members']
                ) {
                    maxActiveContacts = vm.appDataService.organizationPlanStats.plan.metadata['max-org-members'];
                }
            } else {
                $log.info('Non ho ancora dati');
            }
            if (numActiveContacts && maxActiveContacts) {
                vm.planChart.colors = '#2bd3be, #ccc';
                var realActiveContacts = numActiveContacts;
                if (numActiveContacts > maxActiveContacts) {
                    realActiveContacts = maxActiveContacts;
                    vm.planChart.colors = '#ff1e7f, #ccc';
                    vm.planWarning = (numActiveContacts - maxActiveContacts) + ' contatti attivi oltre il massimo previsto dal piano';
                }
                vm.planChart.dataPoints.push({a: realActiveContacts});
                vm.planChart.dataPoints.push({b: maxActiveContacts - realActiveContacts});
                // dopo la prima esecuzione, termina il ciclo
                if (angular.isDefined(intervalPlanStats)) {
                    $interval.cancel(intervalPlanStats);
                    intervalPlanStats = undefined;
                }
            }
        }, 500);


        function rowServicesCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    //vm.someClickHandler(aData);
                    vm.gotoOfferedService(aData[0]);
                });
            });
            return nRow;
        }


        // Data
        vm.organization = {};
        vm.isAdmin = false;
        vm.isEditing=false;
        vm.stats={};
        vm.currentStep={}; //STEP DEL TOUR
        vm.organizationTypes = [];
        vm.organizationId=$state.params.organizationId;
        vm.organizationPlanStats = null;
        vm.carnetAnomalies = {
            items: [],
            loading: true,
        };
        $rootScope.showOrganizationAlert = false;

        vm.dtOptionsServices = DTOptionsBuilder
            .newOptions()
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('rowCallback', rowServicesCallback)
            .withPaginationType('full_numbers')
            .withOption('initComplete',function (){
                var api = this.api(), searchBox = angular.element('body').find('#services-search');
                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            })
            .withLanguageSource(
                'assets/datatable-lang/' + $translate.use() + '.json')
            .withDOM(
                'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');



        vm.dtOptionsRoles = DTOptionsBuilder
            .newOptions()
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withPaginationType('full_numbers')
            .withLanguageSource(
                'assets/datatable-lang/' + $translate.use() + '.json')
            .withDOM(
                'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        $rootScope.$on('$translateChangeEnd', function() {
            vm.dtOptionsServices.withLanguageSource('assets/datatable-lang/'
                + $translate.use() + '.json');
            vm.uiConfig.calendar.lang=$translate.use();
//        	vm.uiConfig.resourceCalendar.lang=$translate.use();
        });

        $rootScope.$on('REF_PERIOD_CHANGED', function (event, value) {
            setTimeout(function() {
                loadStats($state.params.organizationId);
            },200);
        });

        // Methods
        vm.gotoOrganizations = gotoOrganizations;
        vm.saveOrganization = saveOrganization;
        vm.formatDate=formatDate;
        vm.apiPath=ApiPath;
        vm.backgroundImage=backgroundImage;
        vm.updateLocationFromMap=updateLocationFromMap;
        vm.updateLocationFromAddress=updateLocationFromAddress;
        vm.doEditMode=doEditMode;
        vm.goToSubscriptions=goToSubscriptions;
        vm.helpMe=helpMe;
        vm.goToOrganizationSettings=goToOrganizationSettings;
        vm.gotoResources=gotoResources;
        vm.gotoMembers=gotoMembers;
        vm.gotoServices=gotoServices;
        vm.gotoEarningCosts=gotoEarningCosts;
        vm.gotoEvents=gotoEvents;
        vm.gotoEdit=gotoEdit;
        // ////////

        init();

        /**
         * Initialize
         */
        function init() {
            if (AuthenticationService.isAuthenticated()) {
                initCalendar();
                var organizationId = $state.params.organizationId;
                if (organizationId && organizationId!==null) {
                    sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
                    loadOrganizationTypes();
                    loadOrganization(organizationId);
                    initTabIndex();
                } else if ($state.params.clubyourlifeId && $state.params.clubyourlifeId!==null) {
                    findOrganizationByCylID($state.params.clubyourlifeId).then(
                        function(data) {
                            if (data && data!==null && data.length===1) {
                                var organizationId  = data[0].id;
                                sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
                                loadOrganizationTypes();
                                loadOrganization(organizationId);
                                initTabIndex();
                            }
                        }
                    );
                }
                $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
                    for (var i = 0; i < vm.organization.categories.length; i++) {
                        vm.organization.categories[i].name = $filter('cylDictionary')(vm.organization.categories[i].name,'ORGANIZATION_CATEGORY',vm.organization.categories[i].code);
                    }
                });
                TourService.initTour('ORGANIZATION', vm.currentStep);
            } else {
                $state.go('app.pages_auth_login');
            }
        }




        function loadOrganization(organizationId) {

            CylPlan.loadCurrentOrganizationStats({organizationId: organizationId}).$promise.then(
                function(stats) {
                    //logger.debug('vm.organizationPlanStats: ' + JSON.stringify(vm.organizationPlanStats));
                    vm.organizationPlanStats = stats;

                },  function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });


            findOrganization(organizationId)
                .then(
                    function(data) {
                        var myOrganization = data;

                        breadcrumbManager.pushOrganization(myOrganization);

                        if (AuthenticationService.isAuthenticated() && !vm.isAdmin) {
                            AuthenticationService.loggedUser().then(function(value, headers) {
                                vm.user = value;
                                $log.debug(vm.user);

                                $log.debug('Lancio myOrganization.$prototype$isAdmin()');
                                //myOrganization.$prototype$isAdmin(
                                Organization.isOrganizationAdmin(
                                    {
                                        organizationId: myOrganization.id,
                                        userId : vm.user.id
                                    }).$promise
                                    .then(function(response) {
                                        vm.isAdmin = response && response.isAdmin;

                                        //se sono admin calcolo le stats
                                        loadStats($state.params.organizationId);
                                        vm.loadCarnetAnomalies($state.params.organizationId);
                                    });
                            });
                        }

                        vm.organization = (JSON.parse(JSON
                            .stringify(myOrganization)));

                        //translate delle categorie
                        for (var i = 0; i < vm.organization.categories.length; i++) {
                            vm.organization.categories[i].name = $filter('cylDictionary')(vm.organization.categories[i].name,'ORGANIZATION_CATEGORY',vm.organization.categories[i].code);
                        }

                        //loadCalendar(organizationId);

                        centerMap();

                        //INIZIALIZZAZIONE DELLA MAPPA
                        setTimeout(function() {
                            $(".gllpLatlonPicker").each(function () {
                                var $obj = $(document).gMapsLatLonPicker();
                                $obj.init( $(this) );
                            });

                            var elementMap = document.getElementById('map');
                            if (elementMap) {
                                var map = new google.maps.Map(document.getElementById('map'), {
                                    center: {lat: parseFloat(vm.organization.latitude), lng: parseFloat(vm.organization.longitude)},
                                    zoom: 10
                                });
                                var marker = new google.maps.Marker({
                                    position: {lat: parseFloat(vm.organization.latitude), lng: parseFloat(vm.organization.longitude)},
                                    map: map
                                });
                            }

                        }, 2000);

                    }, function(error) {
                        $log.debug(error);
                    });
        }


        /**
         * Carica le statistiche da mostrare nel pannello
         *
         * @param organizationId
         */
        function loadStats(organizationId) {
            if (vm.isAdmin) {
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    vm.stats = {};
                    var dateFrom = null, dateTo = null;
                    if (refPeriod) {
                        dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : '20000101';
                        // la data di fine statistiche è sempre oggi, così vedo i pagamenti scaduti alla data di oggi
                        dateTo = moment().format('YYYYMMDD');
                    }
                    var statsParams = {
                        organizationId: organizationId,
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                    };

                    // entrate e uscite
                    // tremporaneo: per ora uso la preferenza UNHIDE_STATSENTRATEUSCITE_TO per decidere se mostrare o meno le statistiche delle entrate/uscita
                    // se ho l'esplicita autorizzazione
                    OrganizationPreference.find({
                        filter: {
                            where: {
                                organizationId: organizationId,
                                code: 'UNHIDE_STATSENTRATEUSCITE_TO',
                                value: vm.user.id,
                            }
                        }
                    }).$promise.then(
                        function(allowedUsers) {
                            if (allowedUsers && allowedUsers.length > 0) {
                                // ho l'esplicita autorizzazione, carico el statistiche
                                Organization.getStatsEntrateUscite(statsParams).$promise.then(
                                    function(response) {
                                        if (response) {
                                            response = JSON.parse(JSON.stringify(response));
                                            vm.stats.entrateUscite = response;
                                        }
                                    },
                                    function(err) {
                                        $log.warn('Errore in Organization.fetchStatsEntrateUscite():');
                                        $log.warn(err);
                                    });
                            } else {
                                OrganizationPreference.find({
                                    filter: {
                                        where: {
                                            organizationId: organizationId,
                                            code: 'UNHIDE_STATSENTRATEUSCITE_TO',
                                        }
                                    }
                                }).$promise.then(
                                    function(allowedUsers) {
                                        if (!allowedUsers || allowedUsers.length === 0) {
                                            // la preferenza non è impostata per la mia organizzazione, mostro ugualmente le statistiche
                                            Organization.getStatsEntrateUscite(statsParams).$promise.then(
                                                function(response) {
                                                    if (response) {
                                                        response = JSON.parse(JSON.stringify(response));
                                                        vm.stats.entrateUscite = response;
                                                    }
                                                },
                                                function(err) {
                                                    $log.warn('Errore in Organization.fetchStatsEntrateUscite():');
                                                    $log.warn(err);
                                                });
                                        }
                                    }
                                );
                            }
                        }
                    );



                    // statistiche documenti
                    Organization.documentStats(statsParams).$promise.then(
                        function(stats) {
                            $log.info('Organization.documentStats():');
                            $log.info(stats);
                            vm.stats.documenti = JSON.parse(JSON.stringify(stats));
                        },
                        function(err) {
                            $log.warn('Errore in Organization.documentStats():');
                            $log.warn(err);
                        }
                    );

                    // statistiche pagamenti ad oggi
                    Organization.paymentsStats(statsParams).$promise.then(
                        function(stats) {
                            $log.info('Organization.paymentsStats():');
                            $log.info(stats);
                            vm.stats.pagamenti = JSON.parse(JSON.stringify(stats));
                        },
                        function(err) {
                            $log.warn('Errore in Organization.paymentsStats():');
                            $log.warn(err);
                        }
                    );

                    // statistiche pagamenti a fine periodo di riferimento, se impostato
                    if (refPeriod && refPeriod.dateTo) {
                        var statsParamsRif = JSON.parse(JSON.stringify(statsParams));
                        statsParamsRif.dateTo = moment(refPeriod.dateTo).format('YYYYMMDD');
                        Organization.paymentsStats(statsParamsRif).$promise.then(
                            function(stats) {
                                $log.info('Organization.paymentsStats():');
                                $log.info(stats);
                                vm.stats.pagamentiRif = JSON.parse(JSON.stringify(stats));
                                vm.stats.pagamentiRif.dateTo = moment(refPeriod.dateTo).format('DD/MM/YYYY');
                            },
                            function(err) {
                                vm.stats.pagamentiRif = null;
                                $log.warn('Errore in Organization.paymentsStats():');
                                $log.warn(err);
                            }
                        );
                    }
                });


                //
                // Vecchia versione monolitica, da eliminare
                //
                // findOrganization(organizationId).then(function(org) {
                //     breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                //         var dateFrom = null, dateTo = null;
                //         if (refPeriod) {
                //             dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                //             dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                //         }
                //         org.$prototype$allStats({dateFrom: dateFrom, dateTo: dateTo}).then(function(response) {
                //             //se sono admin calcolo le stats
                //             vm.stats = response.result;
                //             if (!vm.stats.entrate) {
                //                 vm.stats.entrate = 0;
                //             }
                //             if (!vm.stats.uscite) {
                //                 vm.stats.uscite = 0;
                //             }
                //         });
                //     });
                // });
            }
        }

        /**
         * Go to organizations page
         */
        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()});
        }



        function findOrganization(id) {
            $log.debug('OrganizationController.findOrganization()');
            return Organization.findById({
                id : id,
                filter : {
                    include : [  'roleTypes', /*'organizationResources',*/
                        'categories' ],
                }
            }).$promise;
        }

        function findOrganizationByCylID(clubyourlifeId) {
            return Organization.find({filter:{
                    where : {
                        clubyourlifeId:clubyourlifeId
                    }
                }
            }).$promise;
        }

        function saveOrganization() {
            Organization.update({
                where : {
                    id : vm.organization.id
                }
            }, vm.organization, function(value, responseHeaders) {
                $log.debug(value);
                //aggiorno il menu
                $rootScope.$emit('RELOAD_MENU', '');

                gotoOrganizations();
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data
                    && httpResponse.data.error);

            });
        }




        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.selectedUserChange= function(item) {
                if (item && item!==null) {
                    $scope.userId=item.id;
                    $scope.givenName=item.givenName;
                    $scope.familyName=item.familyName;
                    $scope.email=item.email;
                    $scope.birthDate=(item.birthDate && item.birthDate!==null && item.birthDate!=='')?moment(item.birthDate).toDate():null;
                }
                else {
                    $scope.userId=null;
                    $scope.givenName=null;
                    $scope.familyName=null;
                    $scope.email=null;
                    delete $scope.birthDate;
                }

            };
            $scope.selectedStaffMember = function(item) {
                $scope.myResource.userId=item.id;
                $scope.myResource.totalNumber=1;
            };
            // $scope.lookupUser= function(txt){
            //     txt=txt+'%';
            //     var deferred = $q.defer();
            //     var query = {
            //         filter: {
            //             where :
            //                 {or: [
            //                         {username: { like: txt } },
            //                         {email: { like: txt }},
            //                         {givenName: { like: txt }},
            //                         {familyName: { like: txt }}
            //                     ]
            //                 }
            //         }
            //     };
            //
            //     User.find(query, function(users, responseHeaders) {
            //         for (var i = 0; i < users.length; i++) {
            //             if (users[i].email && users[i].email !==null && users[i].email.endsWith('invalid')) {
            //                 users[i].email=null;
            //             }
            //         }
            //         deferred.resolve(users);
            //
            //     });
            //     return deferred.promise;
            //
            // };
            $scope.lookupStaffUser= function(txt){
                var deferred = $q.defer();
                var search = txt==null?'':txt.toLowerCase();
                RoleType.find( {filter: {
                        where : {internalCode: 'STAFF', organizationId: vm.organization.id}
                    }
                }, function(roles, responseHeaders) {
                    var role = roles[0];
                    var query = {roleTypeId: role.id, organizationId: vm.organization.id };
                    UserOrganizationRole.find({filter:{where: query, include: ['user']}}, function(res) {
                        //res
                        var users = _.map(res, function(r) {return r.user;});
                        var filteredList = _.filter(users, function(x){
                            return x.displayName.startsWith(search) || x.givenName.startsWith(search) || x.familyName.startsWith(search) || x.email.startsWith(search);
                        });
                        var finalOrderedList = _.sortBy(filteredList, function(x){ return x.displayName; });
                        for (var i = 0; i < finalOrderedList.length; i++) {
                            if (finalOrderedList[i].email && finalOrderedList[i].email !==null && finalOrderedList[i].email.endsWith('invalid')) {
                                finalOrderedList[i].email=null;
                            }
                        }

                        deferred.resolve(finalOrderedList);

                    });
                });

                return deferred.promise;

            }
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        function initCalendar() {
            vm.uiConfig = {
                calendar:{
                    editable: false,
                    header:{
                        left: 'month agendaWeek agendaDay',
                        center: 'title',
                        right: 'today prev,next'
                    },
                    eventClick: function(calEvent, jsEvent, view) {
                        sessionStorage.setItem('CURRENT_SERVICE',calEvent.id);
                        if (calEvent.itemType==='R') {
                            sessionStorage.setItem('currentServiceTab', 4); //RISORSE
                        } else {
                            sessionStorage.setItem('currentServiceTab', 3); //ORARI
                        }

                        $state.go('app.offered_service', {
                            offeredServiceId : calEvent.id,
                            organizationId : vm.organization.id
                        });
                    },
                    viewRender: function(view) {
                        loadCalendar($state.params.organizationId, view.intervalStart.toDate(), view.intervalEnd.toDate());
                    },
                    lang:$translate.use()


                }
            };
        }


        /**
         * Carica calendario dei servizi offerti
         */
        function loadCalendar(organizationId, dateFrom, dateTo) {

            $('#myCalendar').block({
                message: $translate.instant('PROCESSING'),
                css: { padding: '20px', border: 'none', borderRadius: '10px' }
            });

            var reqNum = Math.random();

            var query ={
                filter: {
                    where : {organizationId: organizationId, itemType: {inq: ['R','S']}, eventDate: {between: [dateFrom,dateTo]}},
                    include : [ 'offeredService', 'serviceSchedule', 'organizationResource',  'serviceResource', {organizationResource: 'staffMember'} ]
                }
            }
            ResourceCalendar.find(query, function(calendars) {
                vm.eventSources = [];
                var events = [];

                for (var i = 0; i < calendars.length; i++) {

                    var calOccurrence = calendars[i];
                    var calObj = {};

                    // var dateFrom = new Date(calOccurrence.eventDate);
                    // dateFrom.setMinutes(dateFrom.getMinutes() + calOccurrence.minutesFrom);
                    //
                    // var dateTo = new Date(calOccurrence.eventDate);
                    // dateTo.setMinutes(dateTo.getMinutes() + calOccurrence.minutesTo);

                    calObj.id = calOccurrence.offeredService.id;

                    var dateFrom = moment(calOccurrence.eventDate);
                    dateFrom.hour(calOccurrence.minutesFrom/60);
                    dateFrom.minutes(calOccurrence.minutesFrom%60);

                    var dateTo = moment(calOccurrence.eventDate);
                    dateTo.hour(calOccurrence.minutesTo/60);
                    dateTo.minutes(calOccurrence.minutesTo%60);

                    if (calOccurrence.itemType==='R') {
                        var staffMember = calOccurrence.organizationResource.staffMember;
                        calObj.title = ((staffMember && staffMember!==null)?staffMember.displayName+' - ': '') + calOccurrence.organizationResource.name+" - "+calOccurrence.offeredService.name;
                        calObj.color = (staffMember && staffMember!==null) ? 'green' : 'darkred';
                    }
                    else {
                        calObj.title = calOccurrence.offeredService.name;
                        calObj.color = '#3a87ad';
                    }

                    calObj.start = dateFrom;
                    calObj.end = dateTo;
                    calObj.allDay = false;
                    calObj.textColor = 'white';
                    calObj.itemType = calOccurrence.itemType;
                    calObj.serviceResource=calOccurrence.serviceResource;
                    calObj.serviceSchedule=calOccurrence.serviceSchedule;

                    events.push(calObj);
                }
                $('#myCalendar').unblock();

                vm.eventSources.push(events);

                angular.element('#myCalendar').fullCalendar('removeEvents');
                angular.element('#myCalendar').fullCalendar('addEventSource', vm.eventSources[0]);

            });

        }




        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }




        function backgroundImage() {
            if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
            }
            return '';

        }

        function openMenuImageDeletion($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.organization.longitude=longitude;
            vm.organization.latitude=latitude;
        }

        function centerMap() {
            if (vm.organization.longitude && vm.organization.longitude!==null && vm.organization.latitude && vm.organization.latitude!==null) {
                $('input.gllpLatitude').val(vm.organization.latitude);
                $('input.gllpLongitude').val(vm.organization.longitude);
                $('input.gllpZoom').val(10);

            }

        }

        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.organization.address+ ' ' + vm.organization.addressNumber + ' ' + vm.organization.postalCode + ' '  + vm.organization.province + ' ' + vm.organization.city);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }

        function doEditMode(val) {
            vm.isEditing=val;

            $("#content").animate({ scrollTop: 0 });

            setTimeout(function() {
                $(".gllpLatlonPicker").each(function() {
                    var $obj = $(document).gMapsLatLonPicker();

                    $obj.params.strings.markerText = "Drag this Marker (example edit)";

                    $obj.params.displayError = function(message) {
                        $log.error("MAPS ERROR: " + message); // instead of alert()
                    };

                    $obj.init( $(this) );

                    centerMap();

                });

            }, 1000);
        }


        /*** GESTIONE DEL TOUR *****/
        function getTabCode() {
            switch (vm.selectedTabIndex) {
                case 0: return vm.isAdmin?'INFO_ADMIN':'INFO';
                case 1: return vm.isAdmin?'MEMBERS':'SERVICES';
                case 2: return vm.isAdmin?'SERVICES_ADMIN':'CALENDAR';
                case 3: return vm.isAdmin?'RESOURCES':null;
                case 4: return vm.isAdmin?'CALENDAR':null;
                case 5: return vm.isAdmin?'EARNING_COSTS':null;
                default: return null;
            };
        }



        vm.stepComplete = function() {
            TourService.stepComplete( vm.currentStep);
        };
        vm.tourComplete = function() {
            TourService.tourComplete( vm.currentStep);
        };
        vm.tourEnded = function() {
            TourService.tourEnded( vm.currentStep);
        };

        /**** FINE GESTIONE DEL TOUR *****/


        function initTabIndex() {
            vm.selectedTabIndex = 0;
            if (sessionStorage.getItem('currentOrganizationTab') && sessionStorage.getItem('currentOrganizationTab')!==null) {
                vm.selectedTabIndex=parseInt(sessionStorage.getItem('currentOrganizationTab'));
            }
            $scope.$watch('vm.selectedTabIndex', function(current, old){
                sessionStorage.setItem('currentOrganizationTab',current);

                TourService.initTour(getTabCode(), vm.currentStep);

            });
        }


        /**
         *
         * @param offeredServiceId
         * @param paymentsFilter
         * @param documentsFilter
         * @param {string} dtEndRefPeriod Se compilata, utilizza questa data al cposto di quella di fine periodo di riferimento. Formato: YYYYMMDD
         * @param {string} hiddenColumns Colonne da nascondere ['d'|'p'|'dp'|'pd]
         */
        function goToSubscriptions(offeredServiceId, paymentsFilter, documentsFilter, dtEndRefPeriod, hiddenColumns) {
            $state.go('app.pages_subscriptions_pre', {
                organizationId: vm.organization.id,
                offeredServiceId: offeredServiceId,
                paymentsFilter: paymentsFilter,
                documentsFilter: documentsFilter,
                userId: '',
                dtEndRefPeriod: dtEndRefPeriod === 'today' ? moment().format('YYYYMMDD') : null,
                hiddenColumns: hiddenColumns,
            });
        }



        function goToOrganizationSettings(offeredServiceId, paymentsFilter, documentsFilter) {
            $state.go('app.organization_settings', {
                organizationId: vm.organization.id
            });
        }



        function loadOrganizationTypes() {
            OrganizationType.find( {filter: {
                    orderBy : {name: 'ASC'}
                }
            }, function(organizationTypes, responseHeaders) {
                vm.organizationTypes=organizationTypes;
            }, function(httpResponse) {
                $log.debug(httpResponse);
            });
        }

        function helpMe(ev, helpContext) {
            if (helpContext==='CYL_ID') {
                $scope.helpTitle=$translate.instant("ORGANIZATIONS.CYL_ID");
                $scope.helpText=$sce.trustAsHtml($translate.instant("ORGANIZATIONS.CYL_ID_HELP"));
            }

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/organizations/views/organization/dialogs/help_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        function editResourceDetails(resource){
            $scope.myResource=resource;
            $scope.myResource.resource={
                id:resource.resourceId,
                name:resource.name,
                staffMember: resource.staffMember
            };

            if ($scope.myResource.typeCode==='S') {
                $scope.weekDay=null;
                $scope.showWeekDay=true;
            }
            else {
                $scope.showWeekDay=false;
            }

            $mdDialog.show({
                controller: ScheduleResourceDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_resource_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceResource = answer;
                    serviceResource.id=resource.id;
                    serviceResource.offeredServiceId = $state.params.offeredServiceId;


                    ServiceResource.updateAll(
                        {
                            where: { id: resource.id }
                        },
                        serviceResource,
                        function(org,responseHeaders){
                            $log.debug('saveOrganization() riuscita: ');
                            $log.debug(org);
                            loadOfferedService( $state.params.offeredServiceId);
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }




        function gotoResources() {
            $state.go('app.organization_resources', {organizationId:vm.organization.id});
        }

        function gotoMembers() {
            $state.go('app.organization_members', {organizationId:vm.organization.id});
        }

        function gotoServices() {
            $state.go('app.organization_services', {organizationId:vm.organization.id, serviceType: 'SERVICE'});
        }

        function gotoEvents() {
            $state.go('app.organization_events', {organizationId:vm.organization.id, serviceType: 'EVENT'});
        }

        function gotoEdit() {
            $state.go('app.edit_organization', {organizationId:vm.organization.id});
        }

        function gotoEarningCosts() {
            $state.go('app.pages_earningcosts', {organizationId:vm.organization.id});
        }

        setTimeout( function() {
            var btnContainer = $("#btn-container");
            if (btnContainer && btnContainer.offset()) {
                var sOffset = $("#btn-container").offset().top;
                var shareheight = $("#btn-container").height() + 20;
                $("#content").scroll(function() {
                    var scrollYpos = $("#content").scrollTop();
                    if (scrollYpos > sOffset - shareheight) {
                        $("#btn-container").css({
//    					   'top': (scrollYpos+20)+'px',
                            'position': 'fixed'
                        });
                    }
                });
            }
        },1000);



        // /**
        //  * Per debug: estrae le statistiche sui documenti
        //  */
        // vm.getStatsDocumenti = function() {
        //     $log.debug('vm.getStatsDocumenti()');
        //     Organization.documentStats({organizationId: vm.organizationId}).$promise.then(
        //         function(stats) {
        //             console.log(stats);
        //             vm.statsDocumenti = JSON.stringify(stats);
        //         },
        //         function(err) {
        //             $log.error(err);
        //         }
        //     );
        // };


        /**
         * Carica l'elenco delle anomalie sui carnet
         *
         * @param organizationId
         */
        vm.loadCarnetAnomalies = function(organizationId) {
            vm.carnetAnomalies.loading = true;
            Subscription.carnetAnomalies({ organizationId: organizationId }).$promise.then(
                function(carnetAnomalies) {
                    // $log.debug('carnetAnomalies: ' + JSON.stringify(carnetAnomalies));
                    vm.carnetAnomalies.loading = false;
                    vm.carnetAnomalies.items = _.sortBy(carnetAnomalies, function(carnet) {
                        return carnet.familyName + carnet.givenName;
                    });
                },
                function(err) {
                    vm.carnetAnomalies.loading = false;
                    // ignora errori
                }
            );
        };


        vm.gotoUserCarnet = function(organizationId, userId) {
            $state.go('app.pages_user_carnet', { organizationId: organizationId, userId: userId });
        };

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('NewOrganizationController', NewOrganizationController);

    /** @ngInject */
    function NewOrganizationController($log, $rootScope, $filter, $scope, $sce, $translate, breadcrumbManager,
                                       $mdDialog,  blockUI, $state, User, Organization, AuthenticationService,
                                       CylPlan, LoopBackAuth, StripePublicKey, AlertMessageService, Category,
                                       OrganizationCategory, OrganizationType, ApiPath, NewOrganizationTemplateId)
    {
        var vm = this;

        // Data
        vm.organization = {};
        vm.organizationTypes = [];

        vm.apiPath = ApiPath;
        vm.templateUrl = vm.apiPath+'/dynamicDocumentConnectors/template/' + NewOrganizationTemplateId;
        vm.documentUrl = '';

        vm.isEditing = true;
        vm.hasWizard=false;
        vm.wizardPages=[];
        vm.currentWizardIndex = -1;
        vm.saveAndGoToNextWizardPage = saveAndGoToNextWizardPage;
        vm.saveAndGoToPrevWizardPage = saveAndGoToPrevWizardPage;
        vm.createFreeOrganization = createFreeOrganization;

        // Methods
        vm.gotoOrganizations = gotoOrganizations;
        vm.saveOrganization = saveOrganization;
        vm.goToPayment = goToPayment;
        vm.goToPlan = goToPlan;
        vm.helpMe=helpMe;
        vm.dynDocumentId = null;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.stripePublicKey = StripePublicKey;
        vm.plans = [];
        vm.choosedPlan = {};
        vm.isLoading=true;

        vm.status = 'DATI';
        //////////

        //FORM DINAMICA INIZIALIZZATA
        $rootScope.$on('DYN-DOC-LOADED', function (event, value) {
            if (!vm.isLoading) {
                console.log('--- Document structure loaded: '+ JSON.stringify(value));
                vm.isLoading=true;
            }
        });

        //FORM DINAMICA DISEGNATA
        $rootScope.$on('DYN-DOC-RENDERED', function (event, value) {
            console.log('--- Document rendered');
            if (value && value._wizard && value._wizard.pages.length>0) {
                vm.hasWizard=true;
                vm.wizardPages=value._wizard.pages;
                vm.currentWizardIndex = 0;
                vm.calculateCompletionRatio = value.calculateCompletionRatio;
                vm.goToFirstMissingField = value.goToFirstMissingField;
                vm.calculatePageCompletionRatio = value.calculatePageCompletionRatio;
                vm.goToFirstMissingFieldForPage = value.goToFirstMissingFieldForPage;
                if (value._model) {
                    value._model.copyFromSedeLegale = true;
                }
            }
            else {
                vm.hasWizard=false;
                vm.wizardPages=[];
                vm.currentWizardIndex = -1;
            }
            vm.isLoading=false;
        });


        init();


        /**
         * Initialize
         */
        function init() {
            $log.debug('NewOrganizationController.init()');
            if (AuthenticationService.isAuthenticated()){
                $log.debug('isAuthenticated');
                loadOrganizationTypes();
                breadcrumbManager.popOrganization();
                loadCylPlans();
                AuthenticationService.loggedUser().then(
                    function(value,headers){
                        vm.user = value;
                        $log.debug(vm.user);
                        vm.organization.userId = vm.user.id;
                    }
                );
                vm.organization.name = '';
                vm.organization.categories=[];
                vm.isCreatingOrganization=true;

                $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
                    for (var i = 0; i < vm.organization.categories.length; i++) {
                        vm.organization.categories[i].name = $filter('cylDictionary')(vm.organization.categories[i].name,'ORGANIZATION_CATEGORY',vm.organization.categories[i].code);
                    }
                });
            }
        }

        /**
         * Go to organizations page
         */
        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()},{ reload: true });
        }



        function saveAndGoToNextWizardPage() {
            $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'NEXT_WIZARD_PAGE', documentId:vm.documentId, templateId: vm.templateId});
        }

        function saveAndGoToPrevWizardPage() {
            $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'PREV_WIZARD_PAGE', documentId:vm.documentId, templateId: vm.templateId});
        }


        function saveOrganization(){
            $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'SAVE_DONE', extradata: {subscriptionId: vm.subscriptionId}});
        }

        function goToPayment(plan) {
            vm.status = 'PAGAMENTI';
            vm.choosedPlan = plan;
            vm.documentUrl = vm.apiPath+'/dynamicDocumentConnectors/' + vm.dynDocumentId;
            vm.templateUrl = '';

            var button = document.getElementById('buttonNewOrgCheckout');
            button.addEventListener('click', function(ev) {
                checkoutHandler.open({
                    name: 'Nuova associazione',
                    description: plan.nickname,
                    token: handleToken,
                    image: 'assets/images/logos/logo_payments.png',
                    currency: 'eur',
                    amount: plan.amount
                });
            });
        }

        /**
         * Crea la nuova associazione in base al pagamento
         * @param token
         */
        function handleToken(token) {
            blockUI.start();
            CylPlan.createOrganization({dynDocumentId: vm.dynDocumentId, planId: vm.choosedPlan.id, stripeToken: token.id}).$promise.then(function(done) {
                AlertMessageService.showSuccessMessage();
                $rootScope.$emit('RELOAD_MENU', '');
                $state.go('app.organization_welcome_page', {organizationId: done.id});
                blockUI.stop();
            }, function(httpResponse) {
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                blockUI.stop();
            });
        }

        function createFreeOrganization() {
            blockUI.start();
            CylPlan.createOrganization({dynDocumentId: vm.dynDocumentId, planId: 'FREE'/*vm.choosedPlan.id*/}).$promise.then(function(done) {
                sessionStorage.setItem('CURRENT_ORGANIZATION', done.id);
                AlertMessageService.showSuccessMessage();
                $rootScope.$emit('RELOAD_MENU', '');
                $state.go('app.organization_welcome_page', {organizationId: done.id});
                blockUI.stop();
            }, function(httpResponse) {
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                blockUI.stop();
            });
        }

        function goToPlan() {
            vm.documentUrl = vm.apiPath+'/dynamicDocumentConnectors/' + vm.dynDocumentId;
            vm.templateUrl = '';
            var completionRation = vm.calculateCompletionRatio();
            if (completionRation < 100) {
                alert('campi mancanti');
                vm.goToFirstMissingField();
            } else {
                $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'SUBMIT', documentId:vm.documentId, templateId: vm.templateId});
            }
        }

        $scope.myOnSuccess=function (succ, action) {
            vm.dynDocumentId = succ.data.data.id;
            doFinelAction(action, succ);

        }

        $scope.myOnErr=function (err) {

        }

        function doFinelAction(action, succ) {
            vm.dynDocumentId = succ.data.data.id;
            if ('BACK'===action) {
                window.history.back();
            }
            else if ('NEXT_WIZARD_PAGE' === action){
                    dynDocGoNextPage();
            } else if ('PREV_WIZARD_PAGE' === action){
                    dynDocGoPrevPage();
            } else if ('DO_SAVE' === action){
                //
            }
            else if ('SUBMIT' === action){
                vm.status = 'PLANS';
            }

        }


        function loadCylPlans() {
            $log.debug('vm.loadCylPlans()');
            CylPlan.loadAvailablePlans().$promise.then(function(plans) {
                vm.plans = plans;
                $log.debug('vm.plans: ' + JSON.stringify(vm.plans));
            }, function(httpResponse) {
                $log.debug(httpResponse);
            });
        }

        function dynDocGoNextPage() {
            vm.currentWizardIndex++;
            var pageWizard = vm.wizardPages[vm.currentWizardIndex];
            $rootScope.$emit('DYN-DOC-SHOW-WIZARD-PAGE', {page:pageWizard});
            $('#dyn-doc').animate({ scrollTop: 0 }, 0);
        }


        function dynDocGoPrevPage() {
            vm.currentWizardIndex--;
            var pageWizard = vm.wizardPages[vm.currentWizardIndex];
            $rootScope.$emit('DYN-DOC-SHOW-WIZARD-PAGE', {page:pageWizard});
            $('#dyn-doc').animate({ scrollTop: 0 }, 0);
        }

        // function setLoggedUserAsAdmin(organization,userId){
        //     $log.debug(organization);
        //
        //     organization.$prototype$addAdmin({
        //         userId: userId
        //     },function(data){
        //         $log.debug(data);
        //     }, function(error){
        //         $log.debug(error);
        //     });
        // }
        //
        // vm.lookupCategories= function(txt){
        //     //txt=txt+'%';
        //
        //     //CERCO NEL DIZIONARIO LE CATEGORIE CON IN LIKE IL VALORE: prendo il codice e lo passo alla lista
        //     var records = _.filter($rootScope.cylDictionary, function(d) {
        //         return (d.section==='ORGANIZATION_CATEGORY'
        //             && d.locale===$rootScope.currentLanguage
        //             && d.value.toLowerCase().startsWith(txt.toLowerCase()));
        //     });
        //
        //     var codes = _.map(records, function(r) {return r.code;});
        //
        //     var categories = _.filter($rootScope.organizationCategories, function(d) {
        //         return (_.contains(codes,d.code));
        //     });
        //
        //     for (var i = 0; i < categories.length; i++) {
        //         categories[i].name=$filter('cylDictionary')(categories[i].name,'ORGANIZATION_CATEGORY',categories[i].code);
        //     }
        //
        //     return categories;
        //
        //
        // }

        vm.transformChip = function(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }

        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.organization.longitude=longitude;
            vm.organization.latitude=latitude;
        }

        function centerMap() {
            if (vm.organization.longitude && vm.organization.longitude!==null && vm.organization.latitude && vm.organization.latitude!==null) {
                $('input.gllpLatitude').val(vm.organization.latitude);
                $('input.gllpLongitude').val(vm.organization.longitude);
                $('input.gllpZoom').val(10);

            }

        }

        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.organization.address+ ' ' + vm.organization.addressNumber + ' ' + vm.organization.postalCode + ' '  + vm.organization.province + ' ' + vm.organization.city);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }




        function loadOrganizationTypes() {
            $log.debug('loadOrganizationTypes()');
            OrganizationType.find( {filter: {
                    orderBy : {name: 'ASC'}
                }
            }, function(organizationTypes, responseHeaders) {
                vm.organizationTypes=organizationTypes;
                $log.debug('vm.organizationTypes: ' + JSON.stringify(vm.organizationTypes));
            }, function(httpResponse) {
                $log.debug(httpResponse);
            });
        }


        function helpMe(ev, helpContext) {
            if (helpContext==='CYL_ID') {
                $scope.helpTitle=$translate.instant("ORGANIZATIONS.CYL_ID");
                $scope.helpText=$sce.trustAsHtml($translate.instant("ORGANIZATIONS.CYL_ID_HELP"));
            }

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/organizations/views/organization/dialogs/help_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.organizations')
        .controller('DiscountsController', DiscountsController);

    /** @ngInject */
    function DiscountsController($rootScope, $scope,  $mdDialog, $compile, DTOptionsBuilder, DTColumnBuilder, $log,
                                 $translate, AuthenticationService,  User, Organization, $location,  $state, Discount, AlertMessageService, _)
    {
        var vm = this;
        var userId;

        vm.loadDiscounts=loadDiscounts;
        vm.discounts=[];
        vm.deleteDiscount=deleteDiscount;
        vm.dtInstance = {};
        vm.reloadDiscounts=reloadDiscounts;
        vm.addDiscount=addDiscount;
        vm.editDiscount=editDiscount;
        vm.init=init;

        var organizationId = organizationId;
        init();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadDiscounts)
            .withOption('processing', true)
            .withDataProp('data')
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            //			.withOption('rowCallback', rowCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('name').withTitle($translate.instant('ORGANIZATIONS.NAME')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= data;
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function (data,type, row) {
                    if (row.type==='PERCENT') {
                        return formatRowCell(row.value + '%', row);
                    } else {
                        return formatRowCell(row.value + ' Euro', row);
                    }
                }),
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function (data,type, row) {
                    var ret = $translate.instant('ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_'+row.durationType);
                    if (row.durationType==='MONTHS') {
                        ret+=': '+row.duration;
                    }
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function (data,type, row) {
                    if (row.internalCode && row.internalCode!==null && row.internalCode!=='')
                        return '';
                    return '<md-button class="edit-button md-icon-button" ng-click="discountsVm.deleteDiscount('+row.id +');" ><md-icon md-font-icon="icon-delete" ></md-icon></md-button>';
                }),
        ];

        $rootScope.$on('$translateChangeEnd', function () {
            updateTableLocale();
        });

        function init(orgId) {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                organizationId=orgId;
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function loadDiscounts(sSource, aoData, fnCallback, oSettings) {

            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            var query ={
                filter: {
                    where : {organizationId: organizationId },
                    limit: length,
                    order: 'name ASC',
                    skip: start
                }
            };

            Discount.count({where: query.filter.where}, function(totalNumber) {

                Discount.find(query, function(rts) {
                    vm.discounts=rts;

                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': rts
                    };
                    fnCallback(records);

                });
            });


        }




        function reloadDiscounts() {
            //$rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }

        function deleteDiscount(id) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {
                $log.debug('You choosed to delete....');
                // UserOrganizationRole.count({where: query}, function(res) {
                //     if (!res || res===null || res.count===0) {
                Discount.deleteById({
                    id: id
                }).$promise.then(function(data) {
                    $log.debug('success');
                    $log.debug(data);
                    reloadDiscounts();
                },function(httpResponse){
                    $log.debug('error');
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
                //     }
                //     else {
                //         AlertMessageService.showErrorAlert($translate.instant('ORGANIZATIONS.ERRORS.ROLE_TYPE_IN_USE'));
                //
                //     }
                //
                // });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }


        function editDiscount(discountId) {
            var theDiscount = _.find( vm.discounts, function (d) {
                return d.id==discountId;
            });
            $scope.discountName = theDiscount.name;
            $scope.discountType = theDiscount.type;
            $scope.discountValue = theDiscount.value;
            $scope.durationType = theDiscount.durationType;
            $scope.duration = theDiscount.duration;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/discounts/dialogs/edit_discount_dialog.html',
                        parent : angular.element(document.body),
                        scope : $scope,
                        preserveScope : true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveDiscount(discountId, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }


        function addDiscount(ev) {
            $scope.discountName = null;
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/organizations/views/discounts/dialogs/new_discount_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                saveDiscount(null, answer);
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }


        function saveDiscount(discountId, discount) {
            discount.organizationId = organizationId;
            if (discountId && discountId !== null) {
                discount.id = discountId;
            }

            if (discount.id && discount.id !== null) {
                Discount.update({
                    where : {
                        id : discount.id
                    }
                }, discount, function(value, responseHeaders) {
                    reloadDiscounts();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });
            } else {
                Discount.create(discount, function(org, responseHeaders) {
                    reloadDiscounts();
                }, function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }

        }


        function updateTableLocale() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            setTimeout(function() {
                vm.dtInstance.DataTable.column(1).header().textContent=$translate.instant('ORGANIZATIONS.NAME');

            }, 300);
        }

        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        function formatRowCell(data, row) {
            return '<span style=\'cursor:pointer; text-decoration: underline;\'  ng-click="discountsVm.editDiscount('+row.id +');" >'+data+'</span>';
        }



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.message', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_message', {
            url      : '/message/:messageCode/:messageType',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/message/message.html',
                    controller : 'MessageController as vm'
                }
            },
            bodyClass: 'message'
        }).state('app.pages_message_fullScreen', {
            url      : '/messagefs/:messageCode/:messageType',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_message_fullScreen': {
                    templateUrl: 'app/main/pages/message/message.html',
                    controller : 'MessageController as vm'
                }
            },
            bodyClass: 'message'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/message');

    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.message')
        .controller('OrganizationChangePlanController', OrganizationChangePlanController);

    /** @ngInject */
    function OrganizationChangePlanController($log, $state,
                                              AuthenticationService) {
        var vm = this;
        vm.organizationId = $state.params.organizationId ? $state.params.organizationId : null;
        vm.success = $state.params.success ? $state.params.success === 'success' : null;

        vm.init = function() {
            if (AuthenticationService.isAuthenticated()){
                vm.organizationId = $state.params.organizationId ? $state.params.organizationId : null;
                if (vm.organizationId) {
                    //
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        vm.gotoOrganizationHome = function() {
            $state.go('app.organization', { organizationId: vm.organizationId });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.offered_services',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.offered_service', {
                url      : '/offered-services/:offeredServiceId/org/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/offered_service/offered_service.html',
                        controller : 'OfferedServiceController as vm'
                    }
                }
            })
            .state('app.offered_service_settings', {
                url      : '/offered-services/:offeredServiceId/:organizationId/settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/offered_service_settings/offered_service_settings.html',
                        controller : 'OfferedServiceSettingsController as vm'
                    }
                }
            })
            .state('app.offered_service_settings_payment_plans', {
                url      : '/offered-services/:offeredServiceId/:organizationId/settings_payments_plans',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/offered_service_settings/offered_service_settings.html',
                        controller : 'OfferedServiceSettingsController as vm'
                    }
                }
            })

//            .state('app.offered_service', {
//                url      : '/offered-services/:offeredServiceId/:tab?organizationId',
//                views    : {
//                    'content@app': {
//                        templateUrl: 'app/main/pages/offered_services/views/offered_service/offered_service.html',
//                        controller : 'OfferedServiceController as vm'
//                    }
//                }
//            })
            .state('app.new_offered_service', {
                url      : '/new_offered-service/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_offered_service/new_offered_service.html',
                        controller : 'OfferedServiceNewController as vm'
                    }
                }
            })
            .state('app.new_carnet', {
                url      : '/new_carnet/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_carnet/new_carnet.html',
                        controller : 'CarnetNewController as vm'
                    }
                }
            })
            .state('app.copy_offered_service', {
                url      : '/copy_offered-service/:organizationId/:toCopyServiceId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_offered_service/new_offered_service.html',
                        controller : 'OfferedServiceNewController as vm'
                    }
                }
            })
            .state('app.new_event', {
                url      : '/new_event/:organizationId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_offered_service/new_event.html',
                        controller : 'OfferedServiceNewController as vm'
                    }
                }
            })
            .state('app.copy_event', {
                url      : '/copy_event/:organizationId/:toCopyServiceId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_offered_service/new_offered_service.html',
                        controller : 'OfferedServiceNewController as vm'
                    }
                }
            })
            .state('app.new_generated_event', {
                url      : '/new_generated_event/:organizationId/:srcOfferedServiceId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/offered_services/views/new_offered_service/new_event.html',
                        controller : 'OfferedServiceNewController as vm'
                    }
                }
            })
        ;


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/offered_services');

    }
})();

'use strict';

(function() {

    angular
        .module('app.pages.offered_services')
        .controller('OfferedServiceSettingsController', OfferedServiceSettingsController);

    /** @ngInject */
    function OfferedServiceSettingsController($log, $state, $rootScope, $filter, $anchorScroll, $location, $timeout, $scope,
                                              $mdDialog, LoopBackAuth, Notification, $q,
                                              ApiPath, AuthenticationService, breadcrumbManager, AlertMessageService,
                                              User, OfferedService, OfferedServiceRelation, OrganizationDoctype,
                                              DynamicDocumentConnector, SubscriptionPage, Subscription, PublicCylUrl,
                                              Category, ServiceCategory, OfferedServicePicture) {
        var vm = this;
        // proprietà
        vm.currentUserId = null;
        vm.item = null;
        // variabili interne di supporto
        vm.isAdmin = false;
        vm.loading = {
            service: false,
            children: false,                    // caricamento servizi figli
        };
        vm.selectedTabIndex = 0;
        vm.showHintScheduleType = false;
        vm.isSubscriptionService = false;
        vm.organizationDoctypes = [];// tipi di documento
        vm.serviziChildAttivabili = [];
        vm.offeredService = {includeMoreServices: 'N'};
        vm.serviceSubscribers = [];
        vm.organizationDoctypes = [];
        vm.organizationServicetypes = [];
        vm.selecteDoctypeIds = {};
        vm.selectedServiceIds = {};
        vm.isSubscriptionService = false;
        vm.childServiceToAdd = {}; //carnet #127
        // oggetto che contiene dati, impostazioni e metodi della gestione dell'autocomplete delle categorie del servizio
        vm.categories = {
            searchText: null,       // testo digitato per cercare un elemento
            selectedItem: null,     // elemento selezionato
            selectedItems: [],      // elementi selezionati
            transformChip: function(chip) {
                // If it is an object, it's already a known chip
                if (angular.isObject(chip)) {
                  return chip;
                }
                // Otherwise, create a new one
                return { name: chip, type: 'new' };
            },
            querySearch: searchServiceCategory,
        };
        // oggetto che contiene lo stato delle immagini del servizio
        vm.pictures = {
            ngFlowOptions: {
                target: ApiPath + '/organizationDocumentsContainers/' + $rootScope.CYL_ORG_DOC_PREFIX + $state.params.organizationId + '/upload',
                chunkSize: 15 * 1024 * 1024,
                maxChunkRetries: 1,
                simultaneousUploads: 1,
                testChunks: false,
                progressCallbacksInterval: 1000,
                allowDuplicateUploads: true,
                query: {}
            },
            ngFlow: {
                flowOfferedServicePicture: {},
            },
            upload: pictureUpload,
            fileAdded: pictureFileAdded,
            fileSuccess: pictureFileSuccess,
            fileError: pictureFileError,
            uploadComplete: pictureUploadComplete,
            remove: pictureRemove,
        };
        // Tab web
        vm.flgHasSubscriptionByQrCode = false;
        vm.flgHasSubscriptionPage = false;
        vm.subscriptionPage = null;
        vm.subscriptionPageOptions = null;
        vm.userTemplate = {template: {items: []}};
        vm.myTemplateStructure = {};
        vm.jsonOptions = {mode: 'code'};
        vm.apiPath = ApiPath;
        vm.publicCylUrl = PublicCylUrl;

        //SUBSCRIPTION PAGE
        vm.flgHasSubscriptionByQrCode = false;
        vm.subscriptionPage = null;
        vm.subscriptionPageOptions = null;
        vm.flgHasSubscriptionPage = false;
        // designer per subscription page
        vm.serviziChildAttivabili = [];
        vm.userTemplate = {template: {items: []}};
        vm.myTemplateStructure = {};
        vm.jsonOptions = {mode: 'code'};
        //FINE SUBSCRIPTION PAGE

        //MAPPA
        vm.updateLocationFromMap=updateLocationFromMap;
        vm.updateLocationFromAddress=updateLocationFromAddress;

        // servizi figli
        vm.children = [];           // elenco servizi figli (il primo è il servizio stesso)

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   : ApiPath + "/organizationDocumentsContainers/" + $rootScope.CYL_ORG_DOC_PREFIX + $state.params.organizationId + "/upload",
            chunkSize                : 15 * 1024 * 1024,
            maxChunkRetries          : 1,
            simultaneousUploads      : 1,
            testChunks               : false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            query: {}
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flowLogo: {},
            flowBackground: {}
        };
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.removeLogo = removeLogo;


        /**
         * Inizializzazioni
         */
        vm.init = function() {
            $log.debug('OfferedServiceSettingsController.vm.init()');
            console.log($state.current.name);
            vm.loading.service = true;
            if (AuthenticationService.isAuthenticated()) {
                // carica dati iniziali
                var id = $state.params.offeredServiceId;
                vm.currentUserId = User.getCurrentId().toString();
                sessionStorage.setItem('CURRENT_SERVICE', id);

                // verifica permessi
                OfferedService.isCurrentUserAdminForOfferedService({offeredServiceId: $state.params.offeredServiceId.toString()}).$promise
                    .then(
                        function(response) {
                            $log.debug(response);
                            vm.isAdmin = response.result;
                            if (vm.isAdmin) {
                                $log.debug('Sono amministratore');
                                vm.loadItem(id);
                                if ($state.current.name === 'app.offered_service_settings_payment_plans') {
                                    vm.selectedTabIndex = 2;
                                }
                            }
                            vm.loading.service = false;
                        },
                        function(err) {
                            $log.debug(err);
                            vm.loading.service = false;
                        });
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica dal DB un elemento
         * @param id
         */
        vm.loadItem = function(id) {
            OfferedService.findById({
                id: id,
                filter: {
                    include: ['organization', 'serviceSchedules', 'serviceTypes', 'subscriptionPages',
                        'children', 'requiredDocuments', 'categories', 'serviceCategories', 'pictures']
                }
            }).$promise
                .then(
                    function(data, headers) {
                        var myService = data;
                        breadcrumbManager.pushOrganizationAndService(data.organization, data);
                        vm.item = JSON.parse(JSON.stringify(myService));
                        loadAllPotentialChildService(vm.item.organizationId);

                        $log.debug('vm.item:');
                        $log.debug(myService);

                        // normalizza date
                        if (vm.item.start && vm.item.start !== null) {
                            vm.item.start = new Date(vm.item.start);
                        }
                        if (vm.item.end && vm.item.end !== null) {
                            vm.item.end = new Date(vm.item.end);

                        }

                        // normalizza URL sito
                        if (vm.item.organization.website && vm.item.organization.website !== null && vm.item.organization.website !== '') {
                            if (!vm.item.organization.website.startsWith('http://') && !vm.item.organization.website.startsWith('https://')) {
                                vm.item.organization.website = 'http://' + vm.item.organization.website;
                            }
                        }
                        vm.flgHasSubscriptionByQrCode = (vm.item.subscriptionQrCodeUri && vm.item.subscriptionQrCodeUri !== '');

                        if (vm.item.subscriptionPages && vm.item.subscriptionPages.length > 0) {
                            vm.subscriptionPage = vm.item.subscriptionPages[0];
                            vm.subscriptionPageOptions = JSON.parse(vm.subscriptionPage.options);
                            vm.flgHasSubscriptionPage = true;
                            DynamicDocumentConnector.template({templateId: vm.subscriptionPage.templateId}).$promise.then(
                                function(data) {
                                    vm.userTemplate.template = data;
                                    vm.myTemplateStructure = {};
                                    _retrieveTemplateInfo(vm.userTemplate.template.items);
                                }, function(httpResponse) {
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                }
                            );
                        }


                        if (vm.item.requiredDocuments && vm.item.requiredDocuments != null) {
                            for (var i = 0; i < vm.item.requiredDocuments.length; i++) {
                                vm.selecteDoctypeIds[vm.item.requiredDocuments[i].id] = true;
                            }
                        }

                        if (vm.item.serviceTypes && vm.item.serviceTypes != null) {
                            for (var i = 0; i < vm.item.serviceTypes.length; i++) {
                                vm.selectedServiceIds[vm.item.serviceTypes[i].id] = true;
                                if (vm.item.serviceTypes[i].internalCode === 'SUBSCRIPTION') {
                                    vm.isSubscriptionService = true;
                                }
                            }
                        }

                        //carnet #127
                        if (vm.item.scheduleType === 'A' && vm.item.children && vm.item.children.length > 0) {
                            vm.item.includeMoreServices = 'Y';
                            _.each(vm.item.children, function(child){
                                vm.childServiceToAdd[child.id] = true;
                            });
                        } else {
                            vm.item.includeMoreServices = 'N';
                        }

                        // carica i tipi di documento
                        vm.loadOrganizationDoctypes();

                        // carica i servizi figli
                        vm.loadChildServices();

                        centerMap();
                        //INIZIALIZZAZIONE DELLA MAPPA
                        setTimeout(function() {
                            $(".gllpLatlonPicker").each(function () {
                                var $obj = $(document).gMapsLatLonPicker();
                                $obj.init( $(this) );
                            });

                            var mapElement = document.getElementById('map');
                            if (mapElement) {
                                var map = new google.maps.Map(document.getElementById('map'), {
                                    center: {lat: parseFloat(vm.item.latitude), lng: parseFloat(vm.item.longitude)},
                                    zoom: 13
                                });
                                var marker = new google.maps.Marker({
                                    position: {lat: parseFloat(vm.item.latitude), lng: parseFloat(vm.item.longitude)},
                                    map: map
                                });
                            }
                        }, 2000);

                        // legge le categorie collegate al servizio e riempie l'autocomplete
                        if (vm.item && vm.item.categories) {
                            vm.categories.selectedItems = vm.item.categories;
                        }
                    },
                    function(error) {
                        $log.debug(error);
                    }
                );
        };


        /**
         * Salva il servizio
         */
        vm.saveOfferedService = function() {
            $log.debug('vm.saveOfferedService()');
            if (vm.item.scheduleType === 'D') {
                vm.item.end = vm.item.start;
            }

            //CONTROLLO che se si è detto che il servizio è un carnet che comprende N servizi allora
            //devo aver selezionato almeno un servizio compreso (No carnet vuoti!!)
            var childToAddNum = 0;
            _.each(_.keys(vm.childServiceToAdd), function(key) {
                if (vm.childServiceToAdd[key] === true) {
                    childToAddNum++;
                }
            });
            if (vm.item.scheduleType === 'A' && vm.item.includeMoreServices === 'Y' && childToAddNum === 0) {
                AlertMessageService.showErrorAlert('Occorre selezionare almeno un servizio incluso dal carnet');
                return;
            }
            if (vm.item.scheduleType === 'A' && vm.item.includeMoreServices === 'Y') {
                vm.item.needsOrganizationSubscription = false;
                //nel caso di carnet multiservizio devo decidere se c'è bisogno della quota associativa
                _.each(_.keys(vm.childServiceToAdd), function(key) {
                    if (vm.childServiceToAdd[key] === true) {
                        //passo in rassegna is servizi e vedo se qualcuno abbisogna della quota
                        var servizioInCarnet = _.find(vm.serviziChildAttivabili, function(off) {
                            return off.id == key;
                        });
                        if (servizioInCarnet && servizioInCarnet.needsOrganizationSubscription) {
                            vm.item.needsOrganizationSubscription = true;
                        }
                    }
                });
            }
            // se il servizio non è periodico, mi assicuro di non avere un prezzo periodico
            if (vm.item.paymentType !== 'R') {
                vm.item.renewalPrice = 0;
            }
            OfferedService.update({
                    where: {
                        id: vm.item.id
                    }
                }, vm.item
            ).$promise.then(
                function(os, responseHeaders) {
                    // esegue in parallelo
                    var tasks = [
                        aggiornaRequiredDoctypes(),
                        aggiornaCategories(),
                    ];
                    $q.all(tasks).then(
                        function(response) {
                            $log.debug(response);
                            AlertMessageService.showSuccessMessage();
                        },
                        function(err) {
                            $log.error(err);
                            AlertMessageService.showErrorAlert(err.data && err.data.error);
                        }
                    );
                },
                function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
        };


        /**
         * Aggiorna le categorie associate al servizio
         *
         * @returns {Promise}
         */
        function aggiornaCategories() {
            var deferred = $q.defer();
            // prima rimuove tutte le associazioni del servizio con le categorie
            var deleteTasks = [];
            if (vm.item && vm.item.serviceCategories && vm.item.serviceCategories.length > 0) {
                vm.item.serviceCategories.forEach(function(serviceCategory) {
                    deleteTasks.push(ServiceCategory.delete({id: serviceCategory.id}).$promise);
                });
            }
            $q.all(deleteTasks).then(
                function(response) {
                    $log.debug(response);
                    // creare le nuove associazioni
                    var newTasks = [];
                    if (vm.categories && vm.categories.selectedItems && vm.categories.selectedItems.length > 0) {
                        vm.categories.selectedItems.forEach(function(category) {
                            newTasks.push(ServiceCategory.create({
                                categoryId: category.id,
                                offeredServiceId: vm.item.id,
                            }).$promise);
                        });
                    }
                    $q.all(newTasks).then(
                        function(response) {
                            deferred.resolve(response);
                        },
                        function(err) {
                            deferred.reject(err);
                        }
                    );
                },
                function(err) {
                    $log.error(err);
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        }


        /**
         * aggiorna i documenti richiesti, spostata qui per eseguirla in parallelo con altre attività
         * @returns {Promise}
         */
        function aggiornaRequiredDoctypes() {
            var deferred = $q.defer();
            OfferedService.findById({
                id: vm.item.id
            }).$promise.then(
                function(myOfferedService) {
                    vm.item.requiredDocuments = [];
                    var keys = _.keys(vm.selecteDoctypeIds);
                    for (var i = 0; i < keys.length; i++) {
                        if (vm.selecteDoctypeIds[keys[i]]) {
                            //cerco il doc per id
                            var docType = _.find(vm.organizationDoctypes, function(d) {
                                return d.id == keys[i];
                            });
                            vm.item.requiredDocuments.push(docType);
                        }
                    }
                    myOfferedService.$prototype$updateRequiredDocTypes({requiredDocuments: vm.item.requiredDocuments})
                        .then(
                            function(data) {
                                OfferedService.updateServiceTypes({
                                    offeredServiceId: vm.item.id.toString(),
                                    serviceTypes: vm.selectedServiceIds
                                }).$promise.then(
                                    function(data) {
                                        OfferedService.updateServiceChildren({
                                            offeredServiceId: vm.item.id.toString(),
                                            children: vm.childServiceToAdd
                                        }).$promise.then(
                                            function(data) {
                                                vm.loadItem(vm.item.id);
                                                deferred.resolve(data);
                                            },
                                            function(httpResponse) {
                                                $log.error(httpResponse);
                                                deferred.reject(httpResponse);
                                            });
                                    },
                                    function(httpResponse) {
                                        $log.error(httpResponse);
                                        deferred.reject(httpResponse);
                                    });
                            },
                            function(httpResponse) {
                                $log.error(httpResponse);
                                deferred.reject(httpResponse);
                            });
                },
                function(httpResponse) {
                    $log.error(httpResponse);
                    deferred.reject(httpResponse);
                });
            return deferred.promise;
        }


        /**
         * Imposta la data di fine evento uguale alla data di inizio.
         * Serve per aggiungere una data di fine evento, altrimenti rimarrebbe vuota.
         * nel dubbio imposta i minuti a fine giornata
         *
         * @param {Date} startDate          Data di inizio selezionata nel widget data
         * @param {string} scheduleType     Tipo di schedulazione (D=singola data)
         */
        vm.offeredServiceStartdateChange = function(startDate, scheduleType) {
            if (scheduleType.toUpperCase() === 'D') {
                $log.debug(startDate);
                vm.item.end = moment(startDate).endOf('day').toDate();
                $log.debug(vm.item.end);
            }
        };


        /**
         * Carica i tipi di documento dell'organizzazione
         */
        vm.loadOrganizationDoctypes = function() {
            var query = {
                filter: {
                    where: {
                        or: [
                            {organizationId: vm.item.organizationId},
                            {organizationId: null},
                        ]
                    }
                }
            };
            OrganizationDoctype.find(query).$promise.then(function(data) {
                vm.organizationDoctypes = data;
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name, 'DOCTYPE', vm.organizationDoctypes[i].code);
                }
            });
        };


        // ------------------------------------------------------------------------------------------------------------
        // Tab pagina web
        // ------------------------------------------------------------------------------------------------------------

        /**
         *
         */
        vm.saveWebAttributes = function() {
            OfferedService.saveSubscriptionByQrCode({
                offeredServiceId: vm.item.id.toString(),
                enabled: vm.flgHasSubscriptionByQrCode ? vm.flgHasSubscriptionByQrCode : false
            }).$promise.then(function(data) {
                vm.item.subscriptionQrCodeUri = data.uri;
                if (vm.subscriptionPage) {
                    vm.saveSubscriptionPage();
                } else {
                    vm.deleteSubscriptionPage();
                }
            }, function(httpResponse) {
                $log.debug('error');
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }

        /**
         * Genera token e QRCODE per iscrizione a servizio
         *
         */
        vm.saveSubscriptionByQrCode = function() {
            OfferedService.saveSubscriptionByQrCode({
                offeredServiceId: vm.item.id.toString(),
                enabled: vm.flgHasSubscriptionByQrCode ? vm.flgHasSubscriptionByQrCode : false
            }).$promise.then(function(data) {
                vm.item.subscriptionQrCodeUri = data.uri;
                AlertMessageService.showSuccessMessage();
            }, function(httpResponse) {
                $log.debug('error');
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        };


        /**
         * Gestisce il cambio di presenza o meno della pagina web del servizio
         */
        vm.changeHasSubscriptionPage = function() {
            if (vm.flgHasSubscriptionPage) {
                vm.subscriptionPage = {offeredServiceId: vm.item.id, options: {fields: {}}};
            } else {
                vm.subscriptionPageIdBackup = vm.subscriptionPage.id;
                vm.subscriptionPage = null;
            }
        };


        /**
         * Elimina la pagina web del servizio
         */
        vm.deleteSubscriptionPage = function() {
            if (vm.subscriptionPageIdBackup) {
                SubscriptionPage.destroyById(
                    {id: vm.subscriptionPageIdBackup},
                    function(org, responseHeaders) {
                        vm.subscriptionPageIdBackup = null;
                        AlertMessageService.showSuccessMessage();
                        vm.loadItem($state.params.offeredServiceId);
                    },
                    function(httpResponse) {
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
            }
        };


        /**
         * Salva la pagina web del servizio
         */
        vm.saveSubscriptionPage = function() {
            //salvo il template
            DynamicDocumentConnector.upsertTemplate({data: vm.userTemplate.template}).$promise.then(function(value, responseHeaders) {
                //aggiorno il menu
                vm.subscriptionPage.templateId = value.id;
                //salvo la sottoscrizione
                vm.subscriptionPage.options = JSON.stringify(vm.subscriptionPageOptions);
                if (vm.subscriptionPage.id) {
                    SubscriptionPage.updateAll(
                        {
                            where: {id: vm.subscriptionPage.id}
                        },
                        vm.subscriptionPage,
                        function(org, responseHeaders) {
                            AlertMessageService.showSuccessMessage();
                            vm.loadItem($state.params.offeredServiceId);
                        },
                        function(httpResponse) {
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                } else {
                    SubscriptionPage.create(
                        vm.subscriptionPage,
                        function(org, responseHeaders) {
                            AlertMessageService.showSuccessMessage();
                            vm.loadItem($state.params.offeredServiceId);
                        },
                        function(httpResponse) {
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }

            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data
                    && httpResponse.data.error);
            });
        };


        vm.saveTemplate = function() {
            DynamicDocumentConnector.upsertTemplate({data: vm.userTemplate.template}).$promise.then(function(value, responseHeaders) {
                $log.debug(value);
                //aggiorno il menu
                var templateId = value.id;
                vm.organization.organizationUserTemplateId = value.id;
                saveOrganization();
            }, function(httpResponse) {
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        };


        function _retrieveTemplateInfo(items) {
            _.each(items, function(item) {
                if (item.name && item.name !== null && item.type !== 'group' && item.type !== 'label') {
                    vm.myTemplateStructure[item.name] = {
                        type: item.type,
                        multiple: item.multiple,
                        choices: item.choices,
                        saved: true
                    };
                }

                if (item.type && item.type === 'group') {
                    _retrieveTemplateInfo(item.items);
                }
            });
        }


        /**
         * Generazione del nome del campo del template
         * @param item
         */
        vm.calculateTemplateItemName = function(item) {
            if (item.saved) {
                return;
            }
            var caption = item.caption;
            if (!caption || caption === '') {
                caption = "____";
            } else {
                //rimuovo caratteri speciali e spazi
                caption = caption.replace(/[^a-zA-Z ]/g, "");
                caption = caption.replace(/\s+/g, '');
                //conto occorrenze già presenti con quel nome
                var name = caption;
                var keys = _.keys(vm.myTemplateStructure);
                var keysWithoutExt = _.map(keys, function(key) {
                    return (key.indexOf('-') > 0) ? key.substring(0, key.indexOf('-')) : key;
                });
                var cnt = _.countBy(keysWithoutExt, function(k) {
                    return k == caption;
                });
                if (cnt[true] > 0) {
                    name += '-' + (cnt[true] + 1);
                }
                item.name = name;
            }
        };


        vm.addTemplateItem = function() {
            if (!vm.userTemplate.template) {
                vm.userTemplate.template = {};
            }
            if (!vm.userTemplate.template.items) {
                vm.userTemplate.template.items = [];
            }
            var num = (vm.userTemplate.template.items.length + 1);
            vm.userTemplate.template.items.push({
                name: "Campo " + num,
                caption: "Campo " + num,
                type: "text",
                options: {}
            });
        };


        vm.addChoice = function(item) {
            if (!item.choices) {
                item.choices = [];
            }
            item.choices.push(
                {
                    "uuid": "",
                    "value": 0,
                    "weight": 0,
                    "caption": ""
                });
        };


        vm.removeChoice = function(item, index) {
            item.choices.splice(index, 1);
        };


        vm.addRule = function(item) {
            if (!item.options) {
                item.options = {};
            }

            if (!item.options.rules) {
                item.options.rules = [];
            }
            item.options.rules.push(
                {
                    "when": "<NOME> EQ 'VALORE'",
                    "actions": [{subject: "campo", action: "clear"}]
                });
        };


        vm.removeRule = function(item, index) {
            item.options.rules.splice(index, 1);
        };


        vm.removeItem = function(index) {
            vm.userTemplate.template.items.splice(index, 1);
        };


        vm.reloadPreview = function() {
            $rootScope.$emit('DYN-DOC-LOADTEMPLATE', vm.userTemplate.template);
        };


        /**
         * Al cambio di lingua, aggiorna i tipi di documento
         */
        $rootScope.$on('CHANGE_LANGUAGE', function(lang) {
            for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name, 'DOCTYPE', vm.organizationDoctypes[i].code);
            }
        });


        function loadAllPotentialChildService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        serviceType: 'SERVICE',
                        scheduleType: {neq: 'A'},
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.serviziChildAttivabili = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return true;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode === 'SUBSCRIPTION';
                        });
                        if (found) {
                            return false;
                        } else {
                            return true;
                        }
                    });

                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * Carica i servizi figli di quello visualizzato. Imposta il servizio attualmente visualizzato come
         * primo figlio.
         */
        vm.loadChildServices = function() {
            $log.debug('vm.loadChildServices()');
            vm.loading.children = true;
            vm.children = [];
            // come primo figlio mette il servizio stesso
            vm.children.push(vm.item);

            // poi cercai servizi figli e li aggiunge
            OfferedService.findById({
                id: vm.item.id,
                filter: {
                    include: ['children'],
                }
            }).$promise.then(
                function(offeredService) {
                    offeredService = JSON.parse(JSON.stringify(offeredService));
                    // carica i children in vm.children
                    _.each(offeredService.children, function(child) {
                        if (!child.dtDel && child.isPaymentPlan) {
                            vm.children.push(child);
                        }
                    });
                    vm.loading.children = false;
                },
                function(err) {
                    $log.error('Errore caricando OfferedService figli');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Errore caricando OfferedService figli: ' + err.message);
                    vm.loading.children = false;
                }
            );
        };


        /* -----------------------------------------------------------------------------------------------------------
                                                Gestione piani di pagamento
        ----------------------------------------------------------------------------------------------------------- */
        /**
         * Pulsante per aggiungere un elemento figlio
         */
        vm.addChildShow = function() {
            // crea un nuovo child e lo accoda a quelli esistenti in modalità editing
            var child = {
                name: vm.item.name + ' (copy)',
                subscriptionPrice: 0,
                renewalPrice: 0,
                isPaymentPlan: true,
                _editing: true,
            };
            vm.children.push(child);

            // sposta la visualizzazione al nuovo form
            $timeout(function() {
                // $location.hash('child-new');
                // $anchorScroll();
                $('#content').animate({
                    scrollTop: $('#child-new').offset().top
                }, 800);
            }, 100);
        };


        /**
         * Annulla la creazione di un nuovo child
         */
        vm.addChildCancel = function() {
            // cerca gli elementi con _editing e li elimina
            vm.childrenTmp = [];
            _.each(vm.children, function(child) {
                if (child && !child._editing) {
                    vm.childrenTmp.push(JSON.parse(JSON.stringify(child)));
                }
            });
            vm.children = vm.childrenTmp;
        };



        /**
         * Salva un OfferedService dopo la modifica o la creazione
         *
         * @param {OfferedService} child
         */
        vm.saveChild = function(child) {
            $log.debug('vm.saveChild()');
            child._saving = true;
            // copia i dati che non sono di pagamento dal genitore
            vm.copiaDati(vm.item, child);
            $log.debug('Salvo offeredService (in offered_service_settings.js): ' + JSON.stringify(child));
            if (child && child.id) {
                // salva elemento modificato
                OfferedService.update({
                    where : {
                        id : child.id
                    }
                }, child, function(savedInstance) {
                    $log.debug('offeredService salvato correttamente: ' + JSON.stringify(savedInstance));
                    // rimuove backup, non serve più
                    if (vm && vm.backupChildData) {
                        delete vm.backupChildData;
                    }
                    // riabilita editing degli altri elementi
                    if (child && child._editing) {
                        delete child._editing;
                    }
                    delete child._saving;
                    // avvia il reload dei servizi children
                    vm.loadChildServices();
                }, function(httpResponse) {
                    delete child._saving;
                    $log.error('Errore aggiornando offeredService');
                    $log.error(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            } else {
                // crea nuovo elemento
                OfferedService.create(
                    child
                ).$promise.then(
                    function(newChildInstance) {
                        $log.debug('Creato OfferedService: ' + JSON.stringify(newChildInstance));
                        // aggiunge il riferimento al genitore
                        OfferedServiceRelation.create({
                            childId: newChildInstance.id,
                            parentId: vm.item.id,
                        }).$promise.then(
                            function(osRelationInstance) {
                                delete child._saving;
                                // avvia il reload dei servizi children
                                vm.loadChildServices();
                            },
                            function(err) {
                                delete child._saving;
                                $log.error('Errore in creazione OfferedServiceRelation');
                                $log.error(err);
                                AlertMessageService.showErrorAlert('Errore in creazione OfferedServiceRelation: ' + err.message);
                            }
                        );
                    },
                    function(err) {
                        delete child._saving;
                        $log.error('Errore in creazione OfferedService');
                        $log.error(err);
                        AlertMessageService.showErrorAlert('Errore in creazione OfferedService: ' + err.message);
                    }
                );
            }
        };



        /**
         * Copia i dati da un OfferedService padre ad un nuovo figlio. Ignora i campi relativi al pagamento.
         *
         * @param {OfferedService} parent
         * @param {OfferedService} child
         */
        vm.copiaDati = function(parent, child) {
            //$log.debug('vm.copiaDati()');
            var ignoredFields = ['id', 'name', 'description', 'paymentType', 'paymentRenewInterval', 'renewalPrice',
                'numMaxRenewal', 'subscriptionPrice', 'serviceSchedules ', 'serviceTypes ', 'subscriptionPages',
                'children', '$$hashkey', 'organization', '_editing', 'isCarnet', 'isPaymentPlan'];
            _.mapObject(parent, function(propValue, propName) {
                // se il campo non è da ignorare
                if (_.indexOf(ignoredFields, propName) === -1) {
                    child[propName] = parent[propName];
                    //$log.debug('Imposto child.' + propName + ' <= ' + parent[propName]);
                } else {
                    //$log.debug('Ignorato child.' + propName);
                }
            });
        };



        /**
         * Attiva la modalità di edit di un sottoservizio
         *
         * @param {OfferedService} child
         */
        vm.editPayment = function(child) {
            // permetto l'edit di un solo campo alla volta
            if (!vm.backupChildData) {
                vm.backupChildData = {
                    name: child.name,
                    description: child.description,
                    paymentType: child.paymentType,
                    paymentRenewInterval: child.paymentRenewInterval,
                    renewalPrice: child.renewalPrice,
                    numMaxRenewal: child.numMaxRenewal,
                    subscriptionPrice: child.subscriptionPrice,
                };
                child._editing = true;
            }
        };



        /**
         * Abbandona l'editing di un elemento
         *
         * @param {OfferedService} child
         */
        vm.editChildCancel = function(child) {
            // se è un elemento nuovo
            if (!child.id) {
                vm.addChildCancel(child);
            } else {
                // se ero in edit
                if (vm && vm.backupChildData) {
                    child.name = vm.backupChildData.name;
                    child.description = vm.backupChildData.description;
                    child.paymentType = vm.backupChildData.paymentType;
                    child.paymentRenewInterval = vm.backupChildData.paymentRenewInterval;
                    child.renewalPrice = vm.backupChildData.renewalPrice;
                    child.numMaxRenewal = vm.backupChildData.numMaxRenewal;
                    child.subscriptionPrice = vm.backupChildData.subscriptionPrice;
                    delete vm.backupChildData;
                }
                if (child && child._editing && child.id) {
                    delete child._editing;
                }
            }
        };



        /**
         * Eliminazine di un OfferedService, previa conferma
         *
         * @param child
         */
        vm.deleteChild = function(child) {
            $log.debug('vm.deleteChild()');
            // se il child ha iscrizioni, non va cancellata
            Subscription.find({
                filter: { where: {offeredServiceId: child.id}}
            }).$promise.then(
                function(subscriptions) {
                    //$log.info(JSON.stringify(subscriptions));
                    if (Array.isArray(subscriptions) && subscriptions.length === 0) {
                        // chiede conferma
                        $log.debug('Chiedo conferma prima di eliminare OfferedService');
                        var conferma = $mdDialog.confirm()
                            .parent(angular.element(document.querySelector('child-' + child.id)))//.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Eliminazione ' + child.name)
                            .textContent('Il servizio ' + child.name + ' non risulta utilizzato in alcuna ' +
                                'sottoscrizione, puoi eliminarlo senza effetti collaterali. Confermi l\'eliminazione?')
                            //.ariaLabel('Conferma eliminazione')
                            .ok('Conferma')
                            .cancel('Annulla');
                        $mdDialog.show(conferma).then(
                            function() {
                                $log.debug('Procedo ad eliminare elemento');
                                // imposta dtDel = adesso
                                child.dtDel = moment().toDate();
                                // lancia update
                                OfferedService.update({
                                    where : {
                                        id : child.id
                                    }
                                }, child, function(savedInstance) {
                                    $log.debug('offeredService savlato correttamente: ' + JSON.stringify(savedInstance));
                                    // avvia il reload dei servizi children
                                    vm.loadChildServices();
                                }, function(httpResponse) {
                                    $log.error('Errore aggiornando offeredService');
                                    $log.error(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            }
                        );
                    } else {
                        $log.warn('OfferedService non vuoto, non sarà eliminato');
                        AlertMessageService.showErrorAlert('OfferedService non vuoto, non sarà eliminato');
                    }
                },
                function(error) {
                    $log.error('Errore cercando subscription correlate');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Errore cercando subscription correlate: ' + err.message);
                }
            );
        };

        /**
         * Ritorna il numero di rate di un piano di pagamento, data la periodicità del pagamento e la durata del
         * servizio. Se ho impostato un numero massimo di rate, limita a quello.
         *
         * @param {object} item Servizio di cui calcolo il numero di rate
         * @param {object} child Piano di pagamento (come sottoservizio del servizio principale)
         * @param {object} options {ignoreNumMaxRenewal: false}
         * @return {integer} Numero di rate, eventualmente limitato al numero massimo
         */
        vm.calcolaNumRate = function(item, child, options) {
            var numRate = null;
            // parametri di default
            options = options || {};
            options.ignoreNumMaxRenewal = options.ignoreNumMaxRenewal || false;

            // prima calcola il numero di rate, se il pagamento è periodico
            if (vm.item && child.paymentType && child.paymentType === 'R' && child.paymentRenewInterval &&
                vm.item.start && vm.item.end) {
                var mInizio = moment(vm.item.start).startOf('day');
                var mFine = moment(vm.item.end).endOf('day');
                //var durata = moment.duration(mFine.diff(mInizio));
                if (child.paymentRenewInterval === 'day') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'days', true) + 0.5);
                } else if (child.paymentRenewInterval === 'week') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'weeks', true) + 0.5);
                } else if (child.paymentRenewInterval === 'month') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'months', true) + 0.5);
                } else if (child.paymentRenewInterval === '2-month') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'months', true) / 2 + 0.5);
                } else if (child.paymentRenewInterval === '3-month') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'months', true) / 3 + 0.5);
                } else if (child.paymentRenewInterval === '4-month') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'months', true) / 4 + 0.5);
                } else if (child.paymentRenewInterval === '6-month') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'months', true) / 6 + 0.5);
                } else if (child.paymentRenewInterval === 'year') {
                    numRate = Math.trunc(mFine.diff(mInizio, 'years', true) + 0.5);
                }
                // se sforo il numero max di rate, lo limito
                if (options.ignoreNumMaxRenewal === false && numRate > child.numMaxRenewal) {
                    numRate = child.numMaxRenewal;
                }
            }
            return numRate;
        };





        //mappe

        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.item.longitude=longitude;
            vm.item.latitude=latitude;
        }

        function centerMap() {
            if (vm.item.longitude && vm.item.longitude!==null && vm.item.latitude && vm.item.latitude!==null) {
                $('input.gllpLatitude').val(vm.item.latitude);
                $('input.gllpLongitude').val(vm.item.longitude);
                $('input.gllpZoom').val(10);

            }

        }

        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.item.address + ',' + vm.item.addressNumber + ' ' + vm.item.postalCode + ' ' + vm.item.city + ' ' + vm.item.province);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }

        /*************************************************
         * GESTIONE LOGO
         */

        function fileAdded(file, typeFile){

            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            vm.contentToUpload = uploadingFile;
            upload(typeFile);
        }

        function upload(typeFile){
            vm.contentToUpload.type = 'uploading';

            if (typeFile === 'LOGO') {
                vm.ngFlowOptions.query.cyl_type = 'LOGO';
                vm.ngFlowOptions.query.organizationId = vm.item.organizationId;
                vm.ngFlowOptions.query.offeredServiceId = vm.item.id;
                vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
                vm.ngFlow.flowLogo.upload();
            }
            else if (typeFile === 'BACKGROUND') {
                vm.ngFlowOptions.query.cyl_type = 'BACKGROUND';
                vm.ngFlowOptions.query.organizationId = vm.item.organizationId;
                vm.ngFlowOptions.query.offeredServiceId = vm.item.id;
                vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
                vm.ngFlow.flowBackground.upload();
            }
        }

        function removeLogo() {
            OfferedService.update({
                where : {
                    id : vm.item.id
                }
            }, {uriLogo: null}, function(value, responseHeaders) {
                $log.debug(value);
                vm.item.uriLogo = null;
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data  && httpResponse.data.error);
            });
        }


        function fileSuccess(file, message, typeFile){
            $log.debug('fileSuccess');
            vm.loadItem(vm.item.id);

        }

        function fileError(file, message, typeFile){
            $log.error('fileError:');
            $log.error(message);
            AlertMessageService.showErrorAlert('La funzionalità di upload è al momento non disponibile. Si prega di ' +
                'riprovare più tardi e se il problema persiste informare l\'assistenza.');
        }


        /**
         *
         * Controller comune alle varie dialogs tranne che per quelle di allocazione orari e risorse
         * @param $scope
         * @param $mdDialog
         * @constructor
         */
        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        /**
         * Cerca gli elementi delle categorie di servizi che contengono il testo indicato
         * @param {string} searchText 
         */
        function searchServiceCategory(searchText) {
            var deferred = $q.defer();
            Category.find({
                filter: {
                    where: {
                        name: {like: '%' + searchText + '%'},
                        type: 'OFFEREDSERVICE',
                    }
                }
            }).$promise.then(
                function(data) {
                    $log.debug(data);
                    deferred.resolve(data);
                },
                function(err) {
                    $log.error(err);
                    deferred.reject();
                }
            );
            return deferred.promise;
        };




        /**
         * Metodi per l'upload delle immagini
         */
        // un file viene selezionato dal disco
        function pictureFileAdded(file) {
            $log.debug('pictureFileAdded()');
            $log.debug(file);
            vm.pictures.uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };
            pictureUpload();
        }
        // avvia l'upload di un file
        function pictureUpload() {
            $log.debug('pictureUpload()');
            vm.pictures.uploadingFile.type = 'uploading';
            vm.pictures.ngFlowOptions.query.cyl_type = 'OFFEREDSERVICEPICTURE';
            vm.pictures.ngFlowOptions.query.organizationId = vm.item.organizationId;
            vm.pictures.ngFlowOptions.query.offeredServiceId = vm.item.id;
            vm.pictures.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
            vm.pictures.ngFlow.flowOfferedServicePicture.upload();
        }
        function pictureFileSuccess(file, message) {
            $log.debug('pictureFileSuccess()');
            $log.debug({message: message});
        }
        function pictureFileError(file, message, flow) {
            $log.error('pictureFileError()');
            $log.error({file: file, message: message, flow: flow});
        }
        // upload complete, refresh page
        function pictureUploadComplete() {
            $log.debug('pictureUploadComplete()');
            if (vm.item && vm.item.id) {
                vm.loadItem(vm.item.id);
            }
        }
        // remove a picture from service
        function pictureRemove(picture) {
            if (picture) {
                var confirm = $mdDialog
                    .confirm()
                    .title('Conferma eliminazione')
                    .textContent('Confermi l\'eliminazione di questa immagine?')
                    .ariaLabel('Conferma eliminazione')
                    .clickOutsideToClose(true)
                    .ok('Elimina')
                    .cancel('Annulla');
                $mdDialog.show(confirm).then(
                    function() {
                        OfferedServicePicture.updateAll(
                            {where: {id: picture.id}},
                            {isDeleted: true}
                        ).$promise.then(
                            function(result) {
                                AlertMessageService.showSuccessMessage();
                                if (vm.item && vm.item.id) {
                                    vm.loadItem(vm.item.id);
                                }
                            },
                            function(err) {
                                $log.error(err);
                                AlertMessageService.showErrorAlert('Errore in rimozione immagine');
                            }
                        );
                    },
                    function() {
                        // annullato, non fa nulla
                    }
                );
            }
        }



        /**
         * Rimanda all'evento generato
         */
        vm.goToGeneratedEvent = function() {
            $state.go('app.new_generated_event', {
                organizationId: vm.item.organizationId,
                srcOfferedServiceId: vm.offeredService.id
            });
        }

        /**
         * Rimanda agli inviti
         */
        vm.goToInvitations = function() {
            $state.go('app.pages_invitations', {offeredServiceId: vm.item.id});
        }

        /**
         * Riporta alla sezione operativa
         */
        vm.gotoService = function() {
            $state.go('app.offered_service', {organizationId: vm.item.organizationId, offeredServiceId: vm.item.id});
        }


    } // OfferedServiceSettingsController
})();

(function (){
    'use strict';

    angular
        .module('app.pages.offered_services')
        .controller('OfferedServiceController', OfferedServiceController);

    /** @ngInject */
    function OfferedServiceController($log, $state, $scope, $rootScope, $timeout, $translate, $q, ServiceType,
                                      AuthenticationService, Attendance, UserRelation, CylUtils,
                                      OfferedService, Organization, OrganizationResource, ServiceResource,
                                      ServiceSchedule, DTColumnDefBuilder, uiCalendarConfig, ResourceCalendar,
                                      LoopBackAuth, PublicCylUrl, breadcrumbManager,
                                      $mdDialog, User, DTOptionsBuilder,  AlertMessageService, Payment, ApiPath,
                                      OrganizationDoctype, ServiceDoctype,Subscription, SubscriptionDocument, blockUI,
                                      $mdConstant, Notification, PaymentReason, _, $filter)
    {
        var vm = this;

        vm.isAdmin = false;


        // Data
        vm.offeredService = { includeMoreServices: 'N'};
        vm.serviceSubscribers=[];
        vm.organizationDoctypes = [];
        vm.organizationServicetypes = [];
        vm.selecteDoctypeIds = {};
        vm.selectedServiceIds = {};
        vm.isSubscriptionService = false;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.goToNewSubscription=goToNewSubscription;
        vm.goToSubscriptionPayments=goToSubscriptionPayments;
        vm.goToInvitations = goToInvitations;
        vm.goToRenewSubscription = goToRenewSubscription;

        vm.updateLocationFromMap=updateLocationFromMap;
        vm.updateLocationFromAddress=updateLocationFromAddress;
        vm.saveHasCard = saveHasCard;
        vm.modificaNumTessera = modificaNumTessera;
        vm.childServiceToAdd = {}; //carnet #127
        vm.onChangeCarnetType = onChangeCarnetType;
        vm.modificaNumMaxAccess = modificaNumMaxAccess;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withDisplayLength(100)
            .withOption('autoWidth', false)
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        // versione con vecchia sorgente di dati allSubscribers, da eliminare
        vm.dtOptionSubscribers = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withDisplayLength(100)
            .withOption('autoWidth', false)
            .withOption('initComplete',function (){
                var api = this.api(), searchBox = angular.element('body').find('#subscribers-search');
                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            })
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        // versione nuova che usa la nuova subscribersList
        vm.dtOptionSubscribers2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withDisplayLength(100)
            .withOption('autoWidth', false)
            .withOption('initComplete',function (){
                var api = this.api(), searchBox = angular.element('body').find('#subscribers-search');
                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            })
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtOptionAttendances = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withDisplayLength(100)
            .withOption('order', [])
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtColumnDefsAttendances = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
        ];

        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            vm.dtOptionSubscribers.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            vm.uiConfig.calendar.lang=$translate.use();
            loadCalendar($state.params.offeredServiceId);

        });

        $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
            for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
            }
        });

        var onServiceSendMessageCleanup = $rootScope.$on('SERVICE_SEND_MESSAGE', function(event, value) {
            vm.sendMessage();
        });

        // Cleanup
        $scope.$on('$destroy', function ()
        {
            if (onServiceSendMessageCleanup) onServiceSendMessageCleanup();
        });

        // filtro sulle uscrizioni da reperire
        vm.searchFiler= {payments: 'A', documents: '', hasCard: ''};
        vm.searchFilter= {
            paymentStatus: 'A',
            documentStatus: '',
            hasCard: ''
        };


        // Methods
//        vm.askUserDetails = askUserDetails;
        vm.gotoUserProfile = gotoUserProfile;
        vm.gotoUserDetail = gotoUserDetail;
        vm.askResourceDetails = askResourceDetails;
        vm.goToAttendanceDetail = goToAttendanceDetail;
        vm.editResourceDetails = editResourceDetails;
        vm.askScheduleDetails = askScheduleDetails;
        vm.editScheduleDetails = editScheduleDetails;
        vm.formatDate = formatDate;
        vm.formatDateFriendly = formatDateFriendly;
        vm.roundEuro = CylUtils.roundEuro;
        vm.formatMinutes = formatMinutes;
        vm.goBack=goBack;
        vm.deleteResource=deleteResource;
        vm.deleteSchedule=deleteSchedule;
        vm.goToOrganization=goToOrganization;
        vm.gotoOrganizations=gotoOrganizations;
        vm.gotoOfferedServices=gotoOfferedServices;
        vm.serviceTypeChanged=serviceTypeChanged;
        vm.saveOfferedService=saveOfferedService;
        vm.validateUserDocuments=validateUserDocuments;
        vm.apiPath=ApiPath;
        vm.publicCylUrl=PublicCylUrl;
        vm.separatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        vm.sendMessage = sendMessage;
        vm.doSubscribersSearch=doSubscribersSearch;
        vm.helpMe=helpMe;
        vm.gotoUserPayments=gotoUserPayments;
        // vm.askPaymentDetails=askPaymentDetails;
        vm.gotoPaymentWindow = gotoPaymentWindow;
        vm.deleteSubscriber=deleteSubscriber;
        vm.editSubscriber=editSubscriber;
        vm.formatDateFromDay = formatDateFromDay;
        vm.showSubscriptionForm=showSubscriptionForm;
        vm.exportSubscribersExcel=exportSubscribersExcel;
        vm.goToGeneratedEvent = goToGeneratedEvent;
        vm.selectedTabIndex=0;

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   : ApiPath + "/organizationDocumentsContainers/" + $rootScope.CYL_ORG_DOC_PREFIX + $state.params.organizationId+ "/upload",
            chunkSize                : 15 * 1024 * 1024,
            maxChunkRetries          : 1,
            simultaneousUploads      : 1,
            testChunks               : false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            query: {}
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flowLogo: {},
            flowBackground: {}
        };
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.backgroundImage = backgroundImage;
        vm.removeBackground = removeBackground;
        vm.removeLogo = removeLogo;
        vm.openMenuImageDeletion = openMenuImageDeletion;

        init();



        /**
         * Initialize
         */
        function init() {
            if (AuthenticationService.isAuthenticated()){
                configCalendars();
                vm.currentUserId = User.getCurrentId().toString();
                vm.offeredServiceId = $state.params.offeredServiceId;
                vm.organizationId = $state.params.organizationId;
                sessionStorage.setItem('CURRENT_SERVICE', vm.offeredServiceId);

                OfferedService.isCurrentUserAdminForOfferedService({offeredServiceId: $state.params.offeredServiceId.toString()}).$promise.then(
                    function(response) {
                        vm.isAdmin=response.result;

                        loadOfferedService(vm.offeredServiceId);

                        if (vm.isAdmin) {
                            $scope.loadOrganizationResources = function() {
                                var query =  {
                                    filter: {
                                        where : {organizationId: $state.params.organizationId },
                                        include: 'staffMember'
                                    }
                                };
                                return OrganizationResource.find(query,function(resources) {
                                    $scope.resources =  resources;
                                });
                            };
                            $scope.loadOrganizationResources();
                            loadAllPotentialChildService($state.params.organizationId);
                            loadOrganizationDoctypes();
                            loadOrganizationServicetypes();
                        }

                    });

            } else {
                $state.go('app.pages_auth_login');
            }

        }


        function goToOrganization()
        {
            $state.go('app.organization', {organizationId: $state.params.organizationId});
        }

        function gotoOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }


        function gotoOfferedServices() {
            if (vm.offeredService.serviceType==='EVENT') {
                $state.go('app.organization_events', {organizationId: $state.params.organizationId, serviceType: vm.offeredService.serviceType});
            }
            else {
                $state.go('app.organization_services', {organizationId: $state.params.organizationId, serviceType: vm.offeredService.serviceType});
            }
        }



        function doSubscribersSearch() {
            loadOfferedService( $state.params.offeredServiceId);
        }

        function onChangeCarnetType() {
            if (vm.offeredService.includeMoreServices === 'N') {
                vm.childServiceToAdd = {};
            }
        }

        function loadOfferedService(id){
            //ISSUE #127 includere i per i carnet anche i childOfferedServiceId

            blockUI.start();
            OfferedService.findById({
                id: id,
                filter: {
                    include: ['organization',{resources: 'staffMember'},{serviceResources: {organizationResource: 'staffMember'}},'serviceSchedules', 'requiredDocuments', 'serviceTypes', 'subscriptionPages', 'children']
                }
            }).$promise.then(
                function(data, headers){
                    //$log.debug(data);
                    initTabIndex();

                    var myService = data;

                    breadcrumbManager.pushOrganizationAndService(data.organization, data);

                    vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                    vm.offeredService.hasChatUnsaved = vm.offeredService.hasChat;

                    //carnet #127
                    if (vm.offeredService.scheduleType === 'A' && vm.offeredService.children && vm.offeredService.children.length > 0) {
                        vm.offeredService.includeMoreServices = 'Y';
                        _.each(vm.offeredService.children, function(child){
                            vm.childServiceToAdd[child.id] = true;
                        });
                    } else {
                        vm.offeredService.includeMoreServices = 'N';
                    }

                    if (vm.offeredService.start && vm.offeredService.start!==null) {
                        vm.offeredService.start=new Date(vm.offeredService.start);
                    }

                    if (vm.offeredService.end && vm.offeredService.end!==null) {
                        vm.offeredService.end=new Date(vm.offeredService.end);

                    }

                    if (vm.offeredService.organization.website && vm.offeredService.organization.website!==null && vm.offeredService.organization.website!=='') {
                        if (!vm.offeredService.organization.website.startsWith('http://') && !vm.offeredService.organization.website.startsWith('https://') ) {
                            vm.offeredService.organization.website='http://'+vm.offeredService.organization.website;
                        }

                    }

                    //sistemo le date
                    if (vm.offeredService.serviceResources && vm.offeredService.serviceResources!==null) {
                        for (var i = 0; i < vm.offeredService.serviceResources.length; i++) {
                            var dateFrom = vm.offeredService.serviceResources[i].dateFrom;
                            if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                vm.offeredService.serviceResources[i].dateFrom=new Date(dateFrom);
                            }
                            var dateTo = vm.offeredService.serviceResources[i].dateTo;
                            if (dateTo && dateTo!==null && dateTo!=='') {
                                vm.offeredService.serviceResources[i].dateTo=new Date(dateTo);
                            }
                        }
                    }


                    if (vm.offeredService.serviceSchedules && vm.offeredService.serviceSchedules!==null) {
                        for (var i = 0; i < vm.offeredService.serviceSchedules.length; i++) {
                            var dateFrom = vm.offeredService.serviceSchedules[i].dateFrom;
                            if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                vm.offeredService.serviceSchedules[i].dateFrom=new Date(dateFrom);
                            }
                            var dateTo = vm.offeredService.serviceSchedules[i].dateTo;
                            if (dateTo && dateTo!==null && dateTo!=='') {
                                vm.offeredService.serviceSchedules[i].dateTo=new Date(dateTo);
                            }
                        }
                    }

                    if (myService.requiredDocuments && myService.requiredDocuments!=null) {
                        for (var i = 0; i < myService.requiredDocuments.length; i++) {
                            vm.selecteDoctypeIds[myService.requiredDocuments[i].id]=true;
                        }
                    }

                    if (myService.serviceTypes && myService.serviceTypes!=null) {
                        for (var i = 0; i < myService.serviceTypes.length; i++) {
                            vm.selectedServiceIds[myService.serviceTypes[i].id]=true;
                            if (myService.serviceTypes[i].internalCode==='SUBSCRIPTION') {
                                vm.isSubscriptionService=true;
                            }
                        }
                    }

                    loadCalendar($state.params.offeredServiceId);
                    loadAttendances();

                    // carica gli iscritti da visualizzare
                    fetchSubscribersList(function(err, subscribers) {
                        //
                    });

                    // versione precedente,parcheggiata
                    // myService.$prototype$allSubscribers(vm.searchFiler).then(
                    //     function(response) {
                    //         $log.debug('Ritorno da allSubscribers: ');
                    //         $log.debug(response);
                    //         $log.debug('vm.searchFiler: ' + JSON.stringify(vm.searchFiler));
                    //         vm.serviceSubscribersOld = _.map(response.result.users, function(u) {
                    //             if (u.hasCard) {
                    //                 u.hasCard = true;
                    //             }
                    //             return u;
                    //         });
                    //         $log.debug('vm.serviceSubscribersOld: ' + JSON.stringify(vm.serviceSubscribersOld));
                    //         blockUI.stop();
                    //     }, function(err) {
                    //         blockUI.stop();
                    //     });


                    centerMap();

                    //INIZIALIZZAZIONE DELLA MAPPA
                    setTimeout(function() {
                        $(".gllpLatlonPicker").each(function () {
                            var $obj = $(document).gMapsLatLonPicker();
                            $obj.init( $(this) );
                        });

                        var mapElement = document.getElementById('map');
                            if (mapElement) {
                            var map = new google.maps.Map(document.getElementById('map'), {
                                center: {lat: parseFloat(vm.offeredService.latitude), lng: parseFloat(vm.offeredService.longitude)},
                                zoom: 13
                            });
                            var marker = new google.maps.Marker({
                                position: {lat: parseFloat(vm.offeredService.latitude), lng: parseFloat(vm.offeredService.longitude)},
                                map: map
                            });
                        }
                    }, 2000);
                },
                function(error){
                    $log.debug(error);
                });
        }


        /**
         * Aggiorna l'elenco degli iscritti
         *
         * @param {function|null} callback
         */
        function fetchSubscribersList(callback) {
            // $log.debug('fetchSubscribersList()');
            // prima legge il periodo di riferimento impostato dall'utente
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var dateFrom = null, dateTo = null;
                if (refPeriod) {
                    dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : 20000101;
                    dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : 29991231;
                }
                vm.searchFilter.organizationId = vm.organizationId;
                vm.searchFilter.dateFrom = dateFrom;
                vm.searchFilter.dateTo = dateTo;
                vm.searchFilter.offeredServiceId = vm.offeredServiceId;
                // $log.debug('vm.searchFilter: ' + JSON.stringify(vm.searchFilter));

                $log.debug('Avvio Organization.subscribersList():');
                Organization.subscribersList(vm.searchFilter).$promise.then(
                    function(subscribers) {
                        subscribers = JSON.parse(JSON.stringify(subscribers));
                        // $log.debug('Risultato di Organization.subscribersList(): ' + JSON.stringify(subscribers));

                        // aggiorna campo hasCard
                        vm.serviceSubscribers = _.map(subscribers, function(u) {
                            if (u.subscriptionHasCard) {
                                u.subscriptionHasCard = true;
                            }
                            return u;
                        });

                        // aggiorna stato carnet per ciascuna subscription
                        // $log.debug('Avvio getCarnetSummary()');
                        Subscription.getCarnetSummary({
                            organizationId: vm.organizationId,
                            offeredServiceId: vm.offeredServiceId,
                        }).$promise.then(
                            // cerca le corrispondenti subscription e vi aggancia lo stato dei carnet aperti e oltre al limite
                            function(carnetOrders) {
                                //  $log.debug({carnetOrders: carnetOrders})
                                // per ogni carnet che ha letto
                                _.each(carnetOrders, function(carnetOrder) {
                                    // cerca e aggiorna la corrispondente subscription
                                    _.map(vm.serviceSubscribers, function(serviceSubscriber) {
                                        if (serviceSubscriber.subscriptionId === carnetOrder.subscription.id) {
                                            if (!serviceSubscriber.carnetSummary) {
                                                serviceSubscriber.carnetSummary = [];
                                            }
                                            serviceSubscriber.carnetSummary.push(JSON.parse(JSON.stringify(carnetOrder)));
                                        }
                                    });
                                    // $log.debug('vm.serviceSubscribers con carnet: ' + JSON.stringify(vm.serviceSubscribers));
                                    blockUI.stop();
                                });
                            },
                            function(err) {
                                $log.error('Errore in Subscription.getCarnetSummary():');
                                $log.error(err);
                                blockUI.stop();
                            }
                        );
                    },
                    function(err) {
                        $log.error('Errore chiamando Organization.subscribersList():');
                        $log.error(err);
                        blockUI.stop();
                    }
                );
            });
        }



        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllPotentialChildService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        serviceType: 'SERVICE',
                        scheduleType: {neq: 'A'},
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.serviziChildAttivabili = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return true;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode==='SUBSCRIPTION';
                        });
                        if (found) {
                            return false;
                        } else {
                            return true;
                        }
                    });

                },
                function(error){
                    $log.debug(error);
                });
        }


        function loadAttendances() {
            Attendance.allAttendances({serviceId: vm.offeredService.id}).$promise.then(
                function(response) {
                    vm.serviceAttendances = response.attendances;
                    $log.debug(vm.serviceAttendances);
                    vm.requestInProgress = false;
                }, function(error) {
                    $log.debug(error);
                    vm.requestInProgress = false;
                });
        }

        function goToAttendanceDetail(day) {
            if (!day) {
                day = moment().format('YYYYMMDD');
            }
            $state.go('app.pages_attendance_detail_service', {offeredServiceId: vm.offeredService.id, day: day});
        }

        function findUserByMail(txt, callback){
            var query ={email: txt };
            User.find(query, function(users) {
                callback(users);
            });
        }

        function goToNewSubscription() {
            //$state.go('app.new_subcription', {offeredServiceId: vm.offeredService.id, organizationId: vm.offeredService.organizationId});
            // crea nuova subscription, visto che parto dal servizio e non conosco la persona, chiedo quella
            $state.go('app.pages_subscriptions_new_from_service', {
                offeredServiceId: vm.offeredService.id,
                organizationId: vm.offeredService.organizationId
            });
        }

        function goToSubscriptionPayments(subscriptionId) {
            $state.go('app.pages_subscription_payments',{subscriptionId: subscriptionId});
        }

        function goToInvitations() {
            $state.go('app.pages_invitations', {offeredServiceId: vm.offeredService.id});
        }

        function goToRenewSubscription(ev, subscriber) {
            var templateUrl = 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html';
            var numMaxAccessForOrder = subscriber.numMaxAccessForOrder ? subscriber.numMaxAccessForOrder : vm.offeredService.numMaxAccess;
            if (!subscriber.presences || subscriber.presences < numMaxAccessForOrder) {//TODO #issue #250
                templateUrl = 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/renew_confirm_dialog.html';
            }
            $mdDialog.show({
                controller: DialogController,
                templateUrl: templateUrl,
                parent: angular.element(document.body),
                scope: $scope,
                targetEvent: ev,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {
                $state.go('app.renew_subscription', {offeredServiceId: vm.offeredService.id, subscriptionId: subscriber.subscriptionId});
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }

        function editSubscriber(ev, subscription) {
            $state.go('app.pages_subscription',{subscriptionId: subscription.subscriptionId});
        }

        function formatDateFromDay(day) {
            return moment(day, 'YYYYMMDD').format('DD/MM/YYYY');
        }

        function showSubscriptionForm(ev, subscription ) {
            $scope.dyndocUrl= vm.apiPath + '/dynamicDocumentConnectors/' + subscription.dyndocId;

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/dyndoc_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                targetEvent: ev,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {
                angular.noop();
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }

        function deleteSubscriber(ev, subscription){
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    Payment.count({
                        where : {dtDel: null, subscriptionId: subscription.subscriptionId, paymentStatus: 'PAYED'}
                    }, function(totalNumber) {
                        if (totalNumber.count && totalNumber.count>0)  {
                            //ERRORE: ci sono servizi associati
                            AlertMessageService.showErrorAlert("OFFERED_SERVICES.ERRORS.CANT_DELETE_HAS_PAYMENTS");
                        }
                        else {
                            Subscription.findById({
                                id :  subscription.subscriptionId, dtDel: null
                            }).$promise.then(function(sub) {
                                sub.dtDel =  new Date();
                                sub.isDeleted = 1;
                                Subscription.prototype$patchAttributes(
                                    { id: sub.id },
                                    sub).$promise.then(
                                    function(data){
                                        OfferedService.findById({
                                            id: vm.offeredService.id,
                                        }).$promise.then(function(dtSer) {
                                            // TODO chiamare funzione che fa il refresh dei dati, questa è anche rimasta non aggiornata!!
                                            dtSer.$prototype$allSubscribers(vm.searchFiler).then(
                                                function(response) {
                                                    vm.serviceSubscribers = response.result.users;
                                                });
                                        });
                                    });
                            });
                        }
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        /**
         * Apre modale e esegue INSERIMENTO RISORSA USATA DAL SERVIZIO
         */
        function askResourceDetails(ev, resourceToCopy){
            if (resourceToCopy) {
                $scope.myResource = _.clone(resourceToCopy);
                delete $scope.myResource.id;
                $scope.myResource.resource={
                    id:resourceToCopy.resourceId,
                    name:resourceToCopy.organizationResource.name,
                    staffMember: resourceToCopy.organizationResource.staffMember
                };

                if ($scope.myResource.typeCode==='S') {
                    $scope.weekDay=null;
                    $scope.showWeekDay=true;
                }
                else {
                    $scope.showWeekDay=false;
                }

            } else {
                var dateFrom = new Date();
                var dateTo = null;
                if (vm.offeredService.scheduleType === 'P') {
                    dateFrom = vm.offeredService.start;
                    dateTo = vm.offeredService.end;
                } else if (vm.offeredService.scheduleType === 'D') {
                    dateFrom = vm.offeredService.start;
                    dateTo = vm.offeredService.start;
                }

                $scope.myResource = {
                    //impostazioni di default
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    hourFrom: '9',
                    hourTo: '12',
                    minutesFrom: '0',
                    minutesTo: '0',
                };
            }

            $mdDialog.show({
                controller: ScheduleResourceDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/new_resource_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceResource = answer;
                    serviceResource.offeredServiceId = $state.params.offeredServiceId;


                    ServiceResource.create(
                        serviceResource,
                        function(org,responseHeaders){
                            $log.debug('saveOrganization() riuscita: ');
                            $log.debug(org);
                            loadOfferedService( $state.params.offeredServiceId);
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        /**
         * Apre modale e esegue MODIFICA RISORSA USATA DAL SERVIZIO
         */
        function editResourceDetails(ev, resource){
            $scope.myResource=resource;
            $scope.myResource.resource={
                id:resource.resourceId,
                name:resource.name,
                staffMember: resource.staffMember
            };

            if ($scope.myResource.typeCode==='S') {
                $scope.weekDay=null;
                $scope.showWeekDay=true;
            }
            else {
                $scope.showWeekDay=false;
            }

            $mdDialog.show({
                controller: ScheduleResourceDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_resource_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceResource = answer;
                    serviceResource.id=resource.id;
                    serviceResource.offeredServiceId = $state.params.offeredServiceId;


                    ServiceResource.updateAll(
                        {
                            where: { id: resource.id }
                        },
                        serviceResource,
                        function(org,responseHeaders){
                            $log.debug('saveOrganization() riuscita: ');
                            $log.debug(org);
                            loadOfferedService( $state.params.offeredServiceId);
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         *
         * Controller comune alle varie dialogs tranne che per quelle di allocazione orari e risorse
         * @param $scope
         * @param $mdDialog
         * @constructor
         */
        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.paymentButtonEnabled = true;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }

        /**
         * Controller specifico per allocazione orari e risorse
         * @param $scope
         * @param $mdDialog
         * @constructor
         */
        function ScheduleResourceDialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                var isOk = false;
                //CHECK
                //- date inizio e fine popolate
                //- data inizio <= data fine
                if (!$scope.myResource.dateFrom || !$scope.myResource.dateTo) {
                    $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_MANDATORY');
                } else if (moment($scope.myResource.dateFrom).isAfter(moment($scope.myResource.dateTo))) {
                    $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_INTERVAL_INVALID');
                } else if ( !$scope.myResource.typeCode) {
                    $scope.displayErrorDay = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_TYPE_MANDATORY');
                } else if ( $scope.myResource.typeCode==='S' && !$scope.myResource.weekDay) {
                    $scope.displayErrorDay = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_WEEKDAY_MANDATORY');
                } else if (!$scope.myResource.hourFrom || !$scope.myResource.hourTo) {
                    $scope.displayErrorHours = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_HOURS_MANDATORY');
                } else {
                    var minInizio = parseInt($scope.myResource.hourFrom *60) + parseInt($scope.myResource.minutesFrom);
                    var minFine = parseInt($scope.myResource.hourTo *60) + parseInt($scope.myResource.minutesTo);
                    if (minInizio > minFine) {
                        $scope.displayErrorHours = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_HOURS_INVERTED');
                    } else {
                        isOk=true;
                    }
                }

                //giorno obbligatorio se settimanale
                if (isOk) {
                    $mdDialog.hide(answer);
                }
            };
            $scope.changeHourFrom = function() {
                $scope.displayErrorHours='';
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesFrom || $scope.myResource.minutesFrom===null || $scope.myResource.minutesFrom==='')) {
                    $scope.myResource.minutesFrom='0';
                }
            }
            $scope.changeHourTo = function() {
                $scope.displayErrorHours='';
                if ($scope.myResource && $scope.myResource!=null && (!$scope.myResource.minutesTo || $scope.myResource.minutesTo===null || $scope.myResource.minutesTo==='')) {
                    $scope.myResource.minutesTo='0';
                }
            }
            $scope.changeTypeCode = function() {
                $scope.displayErrorDay='';
                if ($scope.myResource && $scope.myResource!=null && $scope.myResource.typeCode==='S') {
                    $scope.myResource.weekDay=1;
                    $scope.showWeekDay=true;
                }
                else {
                    $scope.showWeekDay=false;
                }
            }
            $scope.populateResourceDefault = function() {
                if ($scope.myResource && $scope.myResource!=null && $scope.myResource.resource &&  $scope.myResource.resource!==null ) {
                    if (!$scope.myResource.userCost || $scope.myResource.userCost===null) {
                        $scope.myResource.userCost = $scope.myResource.resource.userCost;
                    }
                    if (!$scope.myResource.organizationCost || $scope.myResource.organizationCost===null) {
                        $scope.myResource.organizationCost = $scope.myResource.resource.organizationCost;
                    }
                    if ($scope.myResource.freeUsage===null) {
                        $scope.myResource.freeUsage = $scope.myResource.resource.freeUsage;
                    }
                }
            }
        }

        /**
         * Apre modale e esegue INSERIMENTO ORARIO USATO DAL SERVIZIO (CON EVENTUALI RISORSE COLLEGATE)
         */
        function askScheduleDetails(ev, resourceToCopy){
            if (resourceToCopy) {
                $scope.myResource = _.clone(resourceToCopy);

                if ($scope.myResource.typeCode==='S') {
                    $scope.weekDay=null;
                    $scope.showWeekDay=true;
                }
                else {
                    $scope.showWeekDay=false;
                }

                //carico dalle risorse eventuali collegate
                $scope.myResource.scheduleResources={};
                $scope.myResource.scheduleResourceNumber={}
                //FIXME per ora sfrutto il fatto che le liste sono paginate a front end
                if (vm.offeredService.serviceResources && vm.offeredService.serviceResources!==null && vm.offeredService.serviceResources.length>0) {
                    for (var i = 0; i < vm.offeredService.serviceResources.length; i++) {
                        if (vm.offeredService.serviceResources[i].serviceScheduleId===$scope.myResource.id) {
                            $scope.myResource.scheduleResources[vm.offeredService.serviceResources[i].resourceId]=true;
                            $scope.myResource.scheduleResourceNumber[vm.offeredService.serviceResources[i].resourceId]=vm.offeredService.serviceResources[i].totalNumber;
                        }
                    }
                }

                delete $scope.myResource.id;

            } else {
                //NUOVO ORARIO: IMPOSTO LE DATE A SECONDA DI COME E' IL CORSO
                var dateFrom = new Date();
                var dateTo = null;
                if (vm.offeredService.scheduleType === 'P') {
                    dateFrom = vm.offeredService.start;
                    dateTo = vm.offeredService.end;
                } else if (vm.offeredService.scheduleType === 'D') {
                    dateFrom = vm.offeredService.start;
                    dateTo = vm.offeredService.start;
                }

                $scope.myResource = {
                    //impostazioni di default
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    hourFrom: '9',
                    hourTo: '12',
                    minutesFrom: '0',
                    minutesTo: '0',
                };
            }


            $mdDialog.show({
                controller: ScheduleResourceDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/new_schedule_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceSchedule = answer;
                    serviceSchedule.offeredServiceId = $state.params.offeredServiceId;

                    var serviceScheduleResources = prepareScheduleResources(answer);


                    ServiceSchedule.create(
                        serviceSchedule,
                        function(scheduleData,responseHeaders){
                            $log.debug('saveSchedule() riuscita: ');
                            $log.debug(scheduleData);

                            if (!serviceScheduleResources || serviceScheduleResources===null || serviceScheduleResources.length===0) {
                                loadOfferedService( $state.params.offeredServiceId);

                            }
                            else {
                                ServiceSchedule.findById({
                                    id: scheduleData.id
                                }).$promise.then(function(mySched) {
                                    mySched.$prototype$updateScheduleResources({serviceScheduleResources: serviceScheduleResources})
                                        .then(function(data){
                                            $log.debug('success');
                                            $log.debug(data);
                                            loadOfferedService( $state.params.offeredServiceId);
                                        },function(httpResponse){
                                            $log.debug('error');
                                            $log.debug(httpResponse);
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                        });
                                });


                            }
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         * Apre modale e esegue MODIFICA ORARIO USATO DAL SERVIZIO (CON EVENTUALI RISORSE COLLEGATE)
         */
        function editScheduleDetails(ev, schedule){
            $scope.myResource=schedule;

            if ($scope.myResource.typeCode==='S') {
                $scope.weekDay=null;
                $scope.showWeekDay=true;
            }
            else {
                $scope.showWeekDay=false;
            }


            //carico dalle risorse eventuali collegate
            $scope.myResource.scheduleResources={};
            $scope.myResource.scheduleResourceNumber={}
            //FIXME per ora sfrutto il fatto che le liste sono paginate a front end
            if (vm.offeredService.serviceResources && vm.offeredService.serviceResources!==null && vm.offeredService.serviceResources.length>0) {
                for (var i = 0; i < vm.offeredService.serviceResources.length; i++) {
                    if (vm.offeredService.serviceResources[i].serviceScheduleId===schedule.id) {
                        $scope.myResource.scheduleResources[vm.offeredService.serviceResources[i].resourceId]=true;
                        $scope.myResource.scheduleResourceNumber[vm.offeredService.serviceResources[i].resourceId]=vm.offeredService.serviceResources[i].totalNumber;
                    }
                }
            }


            $mdDialog.show({
                controller: ScheduleResourceDialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_schedule_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var serviceSchedule = answer;
                    serviceSchedule.id=schedule.id;
                    serviceSchedule.offeredServiceId = $state.params.offeredServiceId;

                    var serviceScheduleResources = prepareScheduleResources(answer);

                    ServiceSchedule.updateAll(
                        {
                            where: { id: schedule.id }
                        },
                        serviceSchedule,
                        function(scheduleData,responseHeaders){
                            $log.debug('saveSchedule() riuscita: ');
                            $log.debug(scheduleData);

                            if (!serviceScheduleResources || serviceScheduleResources===null || serviceScheduleResources.length===0) {
                                loadOfferedService( $state.params.offeredServiceId);

                            }
                            else {
                                ServiceSchedule.findById({
                                    id: schedule.id
                                }).$promise.then(function(mySched) {
                                    mySched.$prototype$updateScheduleResources({serviceScheduleResources: serviceScheduleResources})
                                        .then(function(data){
                                            $log.debug('success');
                                            $log.debug(data);
                                            loadOfferedService( $state.params.offeredServiceId);
                                        },function(httpResponse){
                                            $log.debug('error');
                                            $log.debug(httpResponse);
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                        });
                                });

                            }
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }



        function gotoUserProfile(userId){
            $state.go('app.pages_profile',{ userId: userId });
        }

        function goToGeneratedEvent() {
            $state.go('app.new_generated_event',{ organizationId: vm.offeredService.organizationId, srcOfferedServiceId: vm.offeredService.id });
        }

        function gotoUserDetail(userId) {
            console.log('gotoUserDetail()');
            $state.go('app.pages_user_detail', {userId: userId, organizationId: vm.offeredService.organizationId});
        }


        function formatMinutes(minutes) {
            if (!minutes || minutes===null ) {
                return '00';
            }
            var m = parseInt(minutes);
            if (m < 10) {
                return '0'+m;
            }
            return m;
        }


        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function formatDateFriendly(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('dddd DD MMMM YYYY');
        }


        function parseDate(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', false);
            return m.isValid() ? m.toDate() : new Date(NaN);
        }

        function findOrganization(id){
            $log.debug('OfferedServiceController.findOrganization()');
            return Organization.findById({
                id: id
            }).$promise;
        }

        function configCalendars() {
            vm.uiConfig = {
                calendar:{
                    editable: false,
                    viewRender: function(view, element) {
                        $log.debug("View Changed: ", view.visStart, view.visEnd, view.start, view.end);
                    },
                    header:{
                        left: 'month agendaWeek agendaDay',
                        center: 'title',
                        right: 'today prev,next'
                    },
                    eventClick: function(calEvent, jsEvent, view) {
                        editResourceDetails(null, calEvent.serviceResource);
                        //alert('Event: ' + calEvent.title);
                    },
                    lang:$translate.use()

                }

            };
        }

        /**
         * Genera token e QRCODE per iscrizione a servizio
         */
        function saveSubscriptionByQrCode() {
            OfferedService.saveSubscriptionByQrCode({offeredServiceId: vm.offeredService.id.toString(), enabled: vm.flgHasSubscriptionByQrCode}).$promise.then(function(data) {
                vm.offeredService.subscriptionQrCodeUri = data.uri;
            }, function (httpResponse) {
                $log.debug('error');
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }


        /**
         * Carica calendario relativo al servizio offerto
         */
        function loadCalendar(offeredServiceId) {

            var query ={
                filter: {
                    where : {offeredServiceId: offeredServiceId, itemType: 'R'},
                    include : [ 'offeredService', 'organizationResource', 'serviceResource', {organizationResource: 'staffMember'} ]
                }
            };
            ResourceCalendar.find(query, function(calendars) {
                //callback(users);
                $log.debug(calendars);

                vm.eventSources = [];
                var events = [];

                for (var i = 0; i < calendars.length; i++) {

                    var calOccurrence = calendars[i];

                    var dtServiceResourceFrom = calOccurrence.serviceResource.dateFrom;
                    if (dtServiceResourceFrom && dtServiceResourceFrom!==null && dtServiceResourceFrom!=='') {
                        calOccurrence.serviceResource.dateFrom=new Date(dtServiceResourceFrom);
                    }
                    var dtServiceResourceTo = calOccurrence.serviceResource.dateTo;
                    if (dtServiceResourceTo && dtServiceResourceTo!==null && dtServiceResourceTo!=='') {
                        calOccurrence.serviceResource.dateTo=new Date(dtServiceResourceTo);
                    }

                    var calObj = {};

                    var dateFrom = moment(calOccurrence.eventDate);
                    dateFrom.hour(calOccurrence.minutesFrom/60);
                    dateFrom.minutes(calOccurrence.minutesFrom%60);

                    var dateTo = moment(calOccurrence.eventDate);
                    dateTo.hour(calOccurrence.minutesTo/60);
                    dateTo.minutes(calOccurrence.minutesTo%60);



                    if (calOccurrence.itemType==='R') {
                        var staffMember = calOccurrence.organizationResource.staffMember;
                        calObj.title = ((staffMember && staffMember!==null)?staffMember.displayName+' - ': '') + calOccurrence.organizationResource.name+" - "+calOccurrence.offeredService.name;
                        calObj.color = (staffMember && staffMember!==null) ? 'green' : 'darkred';
                    }
                    else {
                        calObj.title = calOccurrence.offeredService.name;
                        calObj.color = '#3a87ad';
                    }

                    calObj.start = dateFrom.toDate();
                    calObj.end = dateTo.toDate();
                    calObj.allDay = false;
                    calObj.textColor = 'white';
                    calObj.serviceResource=calOccurrence.serviceResource;

                    events.push(calObj);
                }

                vm.eventSources.push(events);

                $timeout(function() {
                    if (uiCalendarConfig && uiCalendarConfig.calendars && uiCalendarConfig.calendars.myServiceCalendar) {
                        uiCalendarConfig.calendars.myServiceCalendar.fullCalendar('removeEvents');
                        uiCalendarConfig.calendars.myServiceCalendar.fullCalendar('addEventSource', vm.eventSources[0]);
                    }
                }, 2000);


            });


        }

        function goBack() {
            window.history.back();
        }

        function deleteResource(ev, resource) {
            $scope.myResource={};
            $scope.myResource.resource={
                id:resource.resourceId,
                name:resource.name
            };

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to delete....');
                    ServiceResource.deleteById({
                        id: resource.id
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        loadOfferedService( $state.params.offeredServiceId);
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        // va alla pagina di gestione e validazine dcumenti utente per la subscription
        function validateUserDocuments(ev, service) {
            //$state.go('app.docs_validation', {serviceId: $state.params.offeredServiceId, subscriptionId:  service.subscriptionId});
            $state.go('app.pages_user_documents', {userId: service.userId, subscriptionId:  service.subscriptionId});
        }


        function deleteSchedule(ev, schedule) {
            $scope.myResource={};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to delete....');
                    ServiceSchedule.deleteById({
                        id: schedule.id
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        loadOfferedService( $state.params.offeredServiceId);
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        function prepareScheduleResources(answer) {
            var serviceScheduleResources = [];
            if (answer.scheduleResources && answer.scheduleResources!==null) {
                var keys = Object.keys(answer.scheduleResources);
                for (var i = 0; i<keys.length; i++) {
                    if (answer.scheduleResources[keys[i]]) {
                        //traduco l'orario in risorsa
                        var serviceResource = {};
                        serviceResource.resourceId=keys[i];
                        serviceResource.offeredServiceId = $state.params.offeredServiceId;
                        //scedulazione -> presa da orario
                        serviceResource.dateFrom=answer.dateFrom;
                        serviceResource.dateTo=answer.dateTo;
                        serviceResource.hourFrom=answer.hourFrom;
                        serviceResource.hourTo=answer.hourTo;
                        serviceResource.minutesFrom=answer.minutesFrom;
                        serviceResource.minutesTo=answer.minutesTo;
                        serviceResource.typeCode=answer.typeCode;
                        serviceResource.weekDay=answer.weekDay;
                        if (answer.scheduleResourceNumber && answer.scheduleResourceNumber!==null && answer.scheduleResourceNumber[keys[i]]) {
                            serviceResource.totalNumber=answer.scheduleResourceNumber[keys[i]];
                        }
                        //TODO prendere da ANAGRAFICA i costi
//  						userCost:answer.userCost,
//  						organizationCost:answer.organizationCost,
//  						freeUsage:answer.freeUsage
                        serviceScheduleResources.push(serviceResource);
                    }
                }

            }
            return serviceScheduleResources;
        }

        /**
         * effettua il salvataggio del servizio
         */
        function saveOfferedService(){
            if (vm.offeredService.scheduleType==='D') {
                vm.offeredService.end=vm.offeredService.start;
            }

            //CONTROLLO che se si è detto che il sevizio è un carnet che comprende N servizi allora
            //devo aver selezionato almeno un servizio compreso (No carnet vuoti!!)
            var childToAddNum = 0;
            _.each(_.keys(vm.childServiceToAdd), function(key) {
               if (vm.childServiceToAdd[key] === true) {
                   childToAddNum++;
               }
            });
            if (vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y' && childToAddNum === 0 ) {
                AlertMessageService.showErrorAlert('Occorre selezionare almeno un servizio incluso dal carnet');
                return;
            }
            if (vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y') {
                vm.offeredService.needsOrganizationSubscription = false;
                //nel caso di carnet multiservizio devo decidere se c'è bisogno della quota associativa
                _.each(_.keys(vm.childServiceToAdd), function(key) {
                    if (vm.childServiceToAdd[key] === true) {
                        //passo in rassegna is servizi e vedo se qualcuno abbisogna della quota
                        var servizioInCarnet = _.find(vm.serviziChildAttivabili, function(off) { return off.id == key; });
                        if (servizioInCarnet && servizioInCarnet.needsOrganizationSubscription) {
                            vm.offeredService.needsOrganizationSubscription = true;
                        }
                    }
                });
            }


            OfferedService.update({
                    where : {
                        id : vm.offeredService.id
                    }
                },vm.offeredService
            ).$promise.then(
                function(os,responseHeaders){
                    OfferedService.findById({
                        id: vm.offeredService.id
                    }).$promise.then(function(myOfferedService) {

                        vm.offeredService.requiredDocuments=[];
                        var keys = _.keys(vm.selecteDoctypeIds);
                        for (var i = 0; i < keys.length; i++) {
                            if (vm.selecteDoctypeIds[keys[i]]) {
                                //cerco il doc per id
                                var docType = _.find(vm.organizationDoctypes, function(d){return d.id==keys[i];});
                                vm.offeredService.requiredDocuments.push(docType);
                            }
                        }


                        myOfferedService.$prototype$updateRequiredDocTypes( {requiredDocuments: vm.offeredService.requiredDocuments})
                            .then(function(data){
                                $log.debug('success');
                                $log.debug(data);

                                OfferedService.updateServiceTypes({offeredServiceId: vm.offeredService.id.toString(), serviceTypes: vm.selectedServiceIds}).$promise.then(function(data) {
                                    OfferedService.updateServiceChildren({offeredServiceId: vm.offeredService.id.toString(), children: vm.childServiceToAdd}).$promise.then(function(data) {
                                        loadOfferedService( vm.offeredService.id);
                                        AlertMessageService.showSuccessMessage();
                                    },function(httpResponse){
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                                },function(httpResponse){
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });

                            },function(httpResponse){
                                $log.debug('error');
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });

                    });
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });
        }

        function loadOrganizationDoctypes() {
            var query = {
                filter: {
                    where : {
                        or : [
                            {organizationId: vm.offeredService.organizationId},
                            {organizationId: null},
                        ]
                    }
                }
            };

            OrganizationDoctype.find(query).$promise.then(function(data) {
                vm.organizationDoctypes=data;
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
                }
            });
        }


        /**
         * Carica i tipi di servizio previsti per l'organizzazione
         */
        function loadOrganizationServicetypes() {
            var query = {
                filter: {
                    where : {
                        organizationId: $state.params.organizationId,
                    }
                }
            };

            ServiceType.find(query).$promise.then(function(data) {
                vm.organizationServicetypes=data;
            });
        }



        function sendMessage() {
            $scope.myResource={};
            $scope.notificationType = vm.offeredService.chatType;
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/send_message_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    var notifications = [];

                    if (vm.offeredService.chatType==='G') {
                        //CHAT DI GRUPPO: scrivo sulla chat un solo messaggio con senderOfferedServiceId
                        notifications.push({
                            senderId: vm.currentUserId,
                            senderOfferedServiceId: vm.offeredService.id,
                            title: answer.title,
                            text: answer.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        });

                        Notification.createMany(
                            notifications,
                            function(n,responseHeaders){
                                AlertMessageService.showSuccessMessage();
                            },
                            function(httpResponse){
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                            });
                    }
                    else if (vm.offeredService.chatType==='B') {
                        //CHAT BROADCAST: scrivo sulla chat N messaggi (per ogni iscritto) con senderOfferedServiceId = null
                        var userToNotifyIds = _.map(vm.serviceSubscribers, function(u){ return u.id; });
                        if (userToNotifyIds.length > 0) {
                            //PRENDO ANCHE I GENITORI
                            UserRelation.find({filter: {
                                    where: {
                                        childId: {inq: userToNotifyIds}
                                    }
                                }}).$promise.then(function(userRelations) {
                                var parentIds = _.map(userRelations, function(u){ return u.parentId; });
                                userToNotifyIds.push(parentIds);
                                userToNotifyIds = _.uniq(_.flatten(userToNotifyIds));
                                for (var i = 0; i < userToNotifyIds.length; i++) {
                                    if (vm.currentUserId == userToNotifyIds[i]) {
                                        continue;
                                    }
                                    notifications.push({
                                        senderId: vm.currentUserId,
                                        recipientId: userToNotifyIds[i],
                                        title: vm.offeredService.name,
                                        text: answer.text,
                                        notificationType: 'CHAT',
                                        status: 'N',
                                        notificationDate: new Date(),
                                        broadcastChatServiceId: vm.offeredService.id
                                    });
                                }

                                //AGGIUNGO NOTIFICA FITTIZIA SENZA DESTINATARIO per pterla vedere nella "room"
                                notifications.push({
                                    senderId: vm.currentUserId,
                                    recipientId: null,
                                    title: vm.offeredService.name,
                                    text: answer.text,
                                    notificationType: 'CHAT',
                                    status: 'N',
                                    notificationDate: new Date(),
                                    broadcastChatServiceId: vm.offeredService.id
                                });

                                if (notifications.length > 0) {
                                    //creo la notifica
                                    Notification.createMany(
                                        notifications,
                                        function(n,responseHeaders){
                                            AlertMessageService.showSuccessMessage();
                                        },
                                        function(httpResponse){
                                            $log.debug(httpResponse);
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                        });
                                }
                            }, function(httpResponse){
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                        }

                        // for (var i = 0; i < vm.serviceSubscribers.length; i++) {
                        //     if (vm.currentUserId == vm.serviceSubscribers[i].id) {
                        //         continue;
                        //     }
                        //
                        //     notifications.push({
                        //         senderId: vm.currentUserId,
                        //         recipientId: vm.serviceSubscribers[i].id,
                        //         title: answer.title,
                        //         text: answer.text,
                        //         notificationType: 'CHAT',
                        //         status: 'N',
                        //         notificationDate: new Date()
                        //     });
                        // }

                        // //creo la notifica
                        // if (notifications.length > 0) {
                        //     Notification.createMany(
                        //         notifications,
                        //         function(n,responseHeaders){
                        //             AlertMessageService.showSuccessMessage();
                        //         },
                        //         function(httpResponse){
                        //             $log.debug(httpResponse);
                        //             AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        //         });
                        // }
                    }
                    else if (vm.offeredService.chatType==='N') {
                        //CHAT READ-ONLY: mando una notifica
                        OfferedService.findById({
                            id: vm.offeredService.id,
                        }).$promise.then(
                            function(data, headers){
                                data.$prototype$notifyAllSubscribersWithAutomaticMessage(
                                    {organizationId: null, senderId: vm.currentUserId, title: answer.title, text: answer.text}).then(
                                    function(data) {
                                        AlertMessageService.showSuccessMessage();
                                    }, function (err) {
                                        AlertMessageService.showErrorAlert(err);
                                    });
                            });

                    }


                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }

        function initTabIndex() {
            vm.selectedTabIndex = 0;//(vm.offeredService.standalone==='S') ? 2 : 0;//PARTO DI DEFAULT CON GLI ISCRITTI, SE INVECE NON SI EROGA DA SOLO ALLORA DAL DETTAGLIO
            if (sessionStorage.getItem('currentServiceTab') && sessionStorage.getItem('currentServiceTab')!==null) {
                vm.selectedTabIndex=parseInt(sessionStorage.getItem('currentServiceTab'));
            }
            $scope.$watch('vm.selectedTabIndex', function(current, old){
                sessionStorage.setItem('currentServiceTab',current);
            });
        }



        // setTimeout( function() {
        //     var btnContaimerElem = $("#btn-container");
        //     if (!btnContaimerElem || !btnContaimerElem.offset()) return;
        //
        //     var sOffset = btnContaimerElem.offset().top;
        //     var shareheight = btnContaimerElem.height() + 20;
        //     $("#content").scroll(function() {
        //         var scrollYpos = $("#content").scrollTop();
        //         if (scrollYpos > sOffset - shareheight-200) {
        //             btnContaimerElem.css({
        //                 'position': 'fixed'
        //             });
        //         }
        //
        //     });},1000);


        function helpMe(ev, helpContext) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/help_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }



        function gotoUserPayments(userId) {
            $state.go('app.pages_profile_tabbed',{ userId: userId, tab: 'PAY' });
        }


        /**
         * Apre la modal di pagamento
         */
        function gotoPaymentWindow(subscriber) {
            // trova pagamento con quell'id
            try {
                console.log(subscriber);
                if (subscriber && subscriber.userId && subscriber.subscriptionId && vm.organizationId &&
                    subscriber.totalDue !== undefined && subscriber.totalPaid !== undefined) {
                    sessionStorage.setItem('payModalState', JSON.stringify({
                        backState: $state.current.name,
                        backParams: $state.params,
                    }));
                    $state.go('app.pages_payments_pay', {
                        organizationId: vm.organizationId,
                        subscriptionId: subscriber.subscriptionId,
                        userId: subscriber.userId,
                        amount: 0 + (subscriber.totalDue - subscriber.totalPaid),
                    });
                }

            } catch(e) {
                console.error(e);
            }
        }


        /**
         * @deprecated sostituita da vm.gotoPaymentWindow
         */
        function askPaymentDetails(ev, userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.offeredService.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.offeredService.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.offeredService.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.offeredService.organization.flgEnableInvoice;
            if (amount) {
                $scope.myResource.paymentValue=CylUtils.roundEuro(amount);
            } else {
                $scope.myResource.paymentValue=null;
            }

            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $scope.myResource.paymentReasons=paymentReasons[0];
            });


            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    // answer.paymentDescription
                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        OfferedService.findById({
                            id: vm.offeredService.id,
                        }).$promise.then(function(dtSer) {
                            // dtSer.$prototype$allSubscribers(vm.searchFiler).then(
                            //     function(response) {
                            //         vm.serviceSubscribers = response.result.users;
                            //     });
                            fetchSubscribersList(function(err, subscribers) {
                                //
                            });
                        });

                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        } // askPaymentDetails


        /*************************************************
         * GESTIONE LOGO
         */

        function fileAdded(file, typeFile){

            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            vm.contentToUpload = uploadingFile;
            upload(typeFile);
        }

        function upload(typeFile){
            vm.contentToUpload.type = 'uploading';

            if (typeFile=='LOGO') {
                vm.ngFlowOptions.query.cyl_type='LOGO';
                vm.ngFlowOptions.query.organizationId=vm.offeredService.organizationId;
                vm.ngFlowOptions.query.offeredServiceId=vm.offeredService.id;
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowLogo.upload();
            }
            else if (typeFile=='BACKGROUND') {
                vm.ngFlowOptions.query.cyl_type='BACKGROUND';
                vm.ngFlowOptions.query.organizationId=vm.offeredService.organizationId;
                vm.ngFlowOptions.query.offeredServiceId=vm.offeredService.id;
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowBackground.upload();
            }
        }

        function backgroundImage() {
            if (vm.offeredService.uriBackgroundImage && vm.offeredService.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organizationId +'/download/'+vm.offeredService.uriBackgroundImage+')'};
            }

            return {'background-image':'none'};

        }


        function removeBackground() {
            OfferedService.update({
                where : {
                    id : vm.offeredService.id
                }
            }, {uriBackgroundImage: null}, function(value, responseHeaders) {
                $log.debug(value);
                vm.offeredService.uriBackgroundImage = null;
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data
                    && httpResponse.data.error);

            });
        }

        function removeLogo() {
            OfferedService.update({
                where : {
                    id : vm.offeredService.id
                }
            }, {uriLogo: null}, function(value, responseHeaders) {
                $log.debug(value);
                vm.offeredService.uriLogo = null;
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data
                    && httpResponse.data.error);
            });
        }

        function openMenuImageDeletion($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        function fileSuccess(file, message, typeFile){
            $log.debug('fileSuccess');
            loadOfferedService( vm.offeredService.id);

        }

        function fileError(file, message, typeFile){
            $log.error('fileError:');
            $log.error(message);
            AlertMessageService.showErrorAlert('La funzionalità di upload è al momento non disponibile. Si prega di ' +
                'riprovare più tardi e se il problema persiste informare l\'assistenza.');
        }

        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.offeredService.longitude=longitude;
            vm.offeredService.latitude=latitude;
        }

        function centerMap() {
            if (vm.offeredService.longitude && vm.offeredService.longitude!==null && vm.offeredService.latitude && vm.offeredService.latitude!==null) {
                $('input.gllpLatitude').val(vm.offeredService.latitude);
                $('input.gllpLongitude').val(vm.offeredService.longitude);
                $('input.gllpZoom').val(10);

            }

        }

        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.offeredService.address);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }



        function serviceTypeChanged(serviceType, selected) {
            if (serviceType && serviceType.internalCode==='SUBSCRIPTION') {
                vm.isSubscriptionService=selected;
            }
        }




        //RISCONTRO TESSERA
        function saveHasCard(subscriptionId, hasCard) {
            Subscription.update({
                where: {
                    id: subscriptionId
                }
            },{
                hasCard : hasCard
            }, function(value, responseHeaders) {
                $log.debug(value);
                AlertMessageService.showSuccessMessage();
            }, function(httpResponse) {
                $log.error(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse);
            });
        }

        function modificaNumTessera(subscriptionId) {
            var entry = _.find(vm.serviceSubscribers, function (e) {
                return e.subscriptionId ==  subscriptionId;
            });
            $scope.myResource = {cardNumber: entry.cardNumber}
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_cardnum_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    Subscription.update({
                        where: {
                            id: subscriptionId
                        }
                    },{
                        cardNumber: answer.cardNumber
                    }, function(value, responseHeaders) {
                        $log.debug(value);
                        entry.cardNumber = answer.cardNumber;
                        AlertMessageService.showSuccessMessage();
                    }, function(httpResponse) {
                        $log.error(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse);
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        /**
         * Modifica il numero massimo di presenze sulla singola iscrizione
         * @param subscriptionId
         */
        function modificaNumMaxAccess(entry) {
            $scope.myResource = {numMaxAccessForOrder: entry.numMaxAccessForOrder}
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_num_max_access_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    if (!answer || !answer.numMaxAccessForOrder) {
                        AlertMessageService.showErrorAlert('Occorre specificare un numero compreso tra 1 e 999');
                    } else {
                        var iNumMaxAccess = parseInt(answer.numMaxAccessForOrder);
                        if (!iNumMaxAccess || isNaN(iNumMaxAccess)) {
                            AlertMessageService.showErrorAlert('Occorre specificare un numero compreso tra 1 e 999');
                        } else {
                            Subscription.updateNumMaxAccessForOrder({subscriptionId: entry.subscriptionId.toString(), numMaxAccessForOrder: iNumMaxAccess}).$promise.then(function(value) {
                                $log.debug(value);
                                entry.numMaxAccessForOrder = iNumMaxAccess;
                                AlertMessageService.showSuccessMessage();
                            }, function(httpResponse) {
                                $log.error(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse);
                            });
                        }
                    }
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }



        function exportSubscribersExcel() {
            var url = ApiPath + '/offeredServices/xlsx-service-subscribers?offeredServiceId='+vm.offeredService.id+'&tk='+LoopBackAuth.accessTokenId + '&payments=' + vm.searchFilter.paymentStatus + '&documents=' + vm.searchFilter.documentStatus + '&hasCard=' + vm.searchFilter.hasCard;
            window.open(url, '_blank');
        }



        /**
         * Imposta la data di fine evento uguale alla data di inizio.
         * Serve per aggiungere una data di fine evento, altrimenti rimarrebbe vuota.
         * nel dubbio imposta i minuti a fine giornata
         *
         * @param {Date} startDate          Data di inizio selezionata nel widget data
         * @param {string} scheduleType     Tipo di schedulazione (D=singola data)
         */
        vm.offeredServiceStartdateChange = function(startDate, scheduleType) {
            if (scheduleType.toUpperCase() === 'D') {
                $log.debug(startDate);
                vm.offeredService.end = moment(startDate).endOf('day').toDate();
                $log.debug(vm.offeredService.end);
            }
        };


        /**
         * Si sposta alla pagina delle impostazioni di un servizio
         * @param serviceId
         */
        vm.gotoServiceSettings = function(serviceId) {
            $state.go('app.offered_service_settings', { offeredServiceId: serviceId, organizationId: $state.params.organizationId });
        };



        /**
         * Avvia la procedura che crea gli order mancanti alla Subscription indicata
         *
         * @param subscriptionId
         */
        vm.addOrderMancanti = function(subscriptionId) {
            $log.debug('vm.addOrderMancanti(' + subscriptionId + ')');
            Subscription.find({
                filter: {
                    where: {id: subscriptionId},
                    include: 'offeredService',
                },
            }).$promise.then(
                function(subscriptions) {
                    subscriptions = JSON.parse(JSON.stringify(subscriptions));
                    $log.debug('Subscriptions: ' + JSON.stringify(subscriptions));
                    if (subscriptions) {
                        var subscription = _.first(subscriptions);
                        var o = {
                            subscription: subscription,
                            offeredService: subscription.offeredService,
                        };
                        //console.log(o);
                        Subscription.createMissingOrders({
                            subscriptionContext: {
                                subscription: subscription,
                                offeredService: subscription.offeredService,
                            }
                        }).$promise.then(
                            function(data) {
                                $log.debug('Terminato di aggiornare la subscription: ' + JSON.stringify(data));
                                AlertMessageService.showSuccessMessage();
                            },
                            function(err) {
                                $log.error('Problema aggiornando la subscription: ' + JSON.stringify(err));
                                AlertMessageService.showErrorAlert(err);
                            }
                        );
                    }
                },
                function(err) {
                    $log.error(err);
                });
        };


    }
})();

(function (){
    'use strict';

    angular
        .module('app.pages.offered_services')
        .controller('OfferedServiceNewController', OfferedServiceNewController);

    /** @ngInject */
    function OfferedServiceNewController($log, $location, $state, $rootScope, $translate, OfferedService, blockUI, $scope, $timeout,
                                         breadcrumbManager, Organization, ServiceSchedule , $mdDialog,
                                         AuthenticationService, AlertMessageService, OrganizationDoctype,
                                         $filter, ServiceType, _, OfferedServiceRelation )
    {
        var vm = this;

        var organizationId;

        // Data
        vm.offeredService = {
            subscriptionPrice: 0,
            enableAttendances: true,
            start: moment().toDate(),
            end: moment().toDate(),
            chatType: 'N',
            isDeleted: false,
        };
        vm.offeredService.requiredDocuments=[];
        vm.organizationDoctypes = [];
        vm.organizationServicetypes = [];
        vm.selecteDoctypeIds = {};
        vm.selectedServiceIds = {};
        vm.selecteServicetypeIds = {};
        vm.isSubscriptionService=false;
        vm.changeStandalone=changeStandalone;
        vm.serviceTypeChanged=serviceTypeChanged;
        vm.changePaymentType=changePaymentType;
        // Methods
        vm.saveOfferedService = saveOfferedService;
        vm.gotoOfferedService = gotoOfferedService;
        vm.gotoPianiPagamento = gotoPianiPagamento;

        vm.cancel = cancel;
        vm.serviceType='SERVICE';

        vm.serviziChildAttivabili = [];
        vm.childServiceToAdd = [];

        vm.updateLocationFromMap=updateLocationFromMap;
        vm.updateLocationFromAddress=updateLocationFromAddress;


        init();

        //////////
        /**
         * Initialize
         */
        function init(){
            if (AuthenticationService.isAuthenticated()){

                if ($location.path().startsWith('/new_event') || $location.path().startsWith('/new_generated_event')) {
                    vm.serviceType='EVENT';
                }
                breadcrumbManager.popOfferedService();

                organizationId = $state.params.organizationId;
                $log.debug('NewOfferedServiceController.init()');
                Organization.findById({
                    id : organizationId,
                    filter : {}
                }).$promise.then(function(organization) {
                    vm.organization = organization;
                });


                loadOrganizationDoctypes();
                loadOrganizationServicetypes();
                if (vm.serviceType !== 'EVENT') {
                    loadAllPotentialChildService($state.params.organizationId);
                }

                if ($state.params.toCopyServiceId) {
                    //OfferedService.di
                }

            } else {
                $state.go('app.pages_auth_login');
            }

            $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
                }
            });

            //INIZIALIZZAZIONE DELLA MAPPA
            setTimeout(function() {
                $(".gllpLatlonPicker").each(function () {
                    var $obj = $(document).gMapsLatLonPicker();
                    $obj.init( $(this) );
                });

            }, 2000);
        }



        function saveOfferedService(){
            vm.offeredService.serviceType=vm.serviceType;
            if (vm.offeredService.standalone==='N') {
                vm.offeredService.scheduleType = 'N';
            }
            if (vm.offeredService.scheduleType==='D') {
                vm.offeredService.end=vm.offeredService.start;
            }


            if (vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y') {
                vm.offeredService.needsOrganizationSubscription = false;
                //nel caso di carnet multiservizio devo decidere se c'è bisogno della quota associativa
                _.each(_.keys(vm.childServiceToAdd), function(key) {
                    if (vm.childServiceToAdd[key] === true) {
                        //passo in rassegna is servizi e vedo se qualcuno abbisogna della quota
                        var servizioInCarnet = _.find(vm.serviziChildAttivabili, function(off) { return off.id == key; });
                        if (servizioInCarnet && servizioInCarnet.needsOrganizationSubscription) {
                            vm.offeredService.needsOrganizationSubscription = true;
                        }
                    }
                });
            }

            // correzione timezone delle date
            if (vm.offeredService && vm.offeredService.start) {
                vm.offeredService.start = moment(vm.offeredService.start).add(12, 'hours');
            }
            if (vm.offeredService && vm.offeredService.end) {
                vm.offeredService.end = moment(vm.offeredService.end).add(12, 'hours');
            }


            if (organizationId) {
                // create a service for organization "organizationId"
                blockUI.start();
                Organization.offeredServices.create(
                    { id: organizationId },
                    vm.offeredService
                ).$promise.then(
                    function(os,responseHeaders){
                        $log.debug(os);
                        OfferedService.findById({
                            id: os.id
                        }).$promise.then(function(myOfferedService) {

                            vm.offeredService.requiredDocuments=[];
                            var keys = _.keys(vm.selecteDoctypeIds);
                            for (var i = 0; i < keys.length; i++) {
                                if (vm.selecteDoctypeIds[keys[i]]) {
                                    //cerco il doc per id
                                    var docType = _.find(vm.organizationDoctypes, function(d){return d.id==keys[i];});
                                    vm.offeredService.requiredDocuments.push(docType);
                                }
                            }

                            myOfferedService.$prototype$updateRequiredDocTypes( {requiredDocuments: vm.offeredService.requiredDocuments})
                                .then(function(data){
                                    $log.debug('success');
                                    $log.debug(data);

                                    OfferedService.updateServiceTypes({offeredServiceId: myOfferedService.id.toString(), serviceTypes: vm.selectedServiceIds}).$promise.then(function(data) {
                                        if (!$state.params.srcOfferedServiceId) {
                                            blockUI.stop();
                                            vm.offeredService.id = os.id;
                                            goToNextStep();
                                        } else {
                                            OfferedService.copySubscribers({sourceOfferedServiceId: $state.params.srcOfferedServiceId.toString(), destOfferedServiceId: os.id.toString() }).$promise.then(function(data) {
                                                blockUI.stop();
                                                vm.offeredService.id = os.id;
                                                goToNextStep();
                                            }, function(httpResponse) {
                                                blockUI.stop();
                                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                            });
                                        }
                                    },function(httpResponse){
                                        blockUI.stop();
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                                },function(httpResponse){
                                    blockUI.stop();
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });

                            //SE HO UN SERVIZIO PUNTUALE E HO DATA ORE E MINUTI INSERISCO ANCHE L'ORARIO
                            if (vm.offeredService.scheduleType==='D' && vm.offeredService.hourFrom && vm.offeredService.hourFrom!==null && vm.offeredService.hourTo && vm.offeredService.hourTo!==null) {

                                ServiceSchedule.create(
                                    {
                                        offeredServiceId:os.id,
                                        dateFrom:vm.offeredService.start,
                                        dateTo:vm.offeredService.end,
                                        hourFrom:vm.offeredService.hourFrom,
                                        hourTo:vm.offeredService.hourTo,
                                        minutesFrom:vm.offeredService.minutesFrom,
                                        minutesTo:vm.offeredService.minutesTo,
                                        typeCode:'P'
                                    },
                                    function(scheduleData,responseHeaders){
                                        $log.debug('saveSchedule() riuscita: ');
                                        $log.debug(scheduleData);
                                    },
                                    function(httpResponse){
                                        $log.debug(httpResponse);
                                    });

                            }

                            if (vm.serviceType !== 'EVENT' && vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y') {
                                var serviceRelations = [];
                                _.each(_.keys(vm.childServiceToAdd), function(keyId) {
                                    if (vm.childServiceToAdd[keyId] === true) {
                                        serviceRelations.push({
                                            childId: keyId,
                                            parentId:  os.id
                                        });
                                    }
                                });
                                if (serviceRelations.length > 0) {
                                    OfferedServiceRelation.createMany(serviceRelations,
                                        function(rels, responseHeaders){
                                            $log.debug('saveSchedule() riuscita: ');
                                            $log.debug(rels);
                                        },
                                        function(httpResponse){
                                            $log.debug(httpResponse);
                                        });
                                }
                            }


                        });
                    },
                    function(httpResponse){
                        blockUI.stop();
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });

            } else {

                OfferedService.create(
                    vm.offeredService,
                    function(os,responseHeaders){
                        $log.debug(os);
                        vm.offeredService.id = os.id;
                        goToNextStep();
                    },
                    function(httpResponse){
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
            }
        }



        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllPotentialChildService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        serviceType: 'SERVICE',
                        scheduleType: {neq: 'A'},
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.serviziChildAttivabili = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return true;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode==='SUBSCRIPTION';
                        });
                        if (found) {
                            return false;
                        } else {
                            return true;
                        }
                    });
                    vm.childServiceToAdd = _.map(vm.serviziChildAttivabili, function (s) {
                        return s.id;
                    });
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * chiamato al change dell'attributo standalone (S = si N = no)
         */
        function changeStandalone() {
            if (vm.offeredService.standalone=='N') {
                vm.offeredService.trialDays=0;
                vm.hasChat=false;
                vm.scheduleType='N';
            }
        }

        function changePaymentType() {
            if (vm.offeredService.paymentType=='F') {
                vm.offeredService.subscriptionPrice=0;
                vm.offeredService.renewalPrice=0;
            }
            else if (vm.offeredService.paymentType=='O') {
                vm.offeredService.renewalPrice=0;
            }
        }

        function cancel(){
            $log.debug(organizationId);
            if (organizationId){
                gotoOrganization(organizationId)
            } else {
                gotoDashboard();
            }
        }

        /**
         * Hook chiamato al cambio di tab che fa scrollare in su la pagina
         */
        vm.onWizardStepChange = function() {
            $timeout(function() {
                $('#content').animate({scrollTop: 0});
            }, 100);
        }


        function goToNextStep() {
            if ($scope.$$childHead && $scope.$$childHead.$$nextSibling && $scope.$$childHead.$$nextSibling.msWizard) {
                $scope.$$childHead.$$nextSibling.msWizard.nextStep();// = stepFinale;//FIXME modificare questa espressione allucinante!!!
            } else if ($scope.$$childHead && $scope.$$childHead.$$nextSibling && $scope.$$childHead.$$nextSibling.$$nextSibling && $scope.$$childHead.$$nextSibling.$$nextSibling.msWizard) {
                $scope.$$childHead.$$nextSibling.$$nextSibling.msWizard.nextStep();
            } else if ($scope.$$childHead && $scope.$$childHead.msWizard) {
                $scope.$$childHead.msWizard.nextStep();
            }
        }

        function gotoOfferedService(){
            $state.go('app.offered_service',{ offeredServiceId: vm.offeredService.id,  organizationId: vm.organization.id });
        }

        function gotoPianiPagamento() {
            $state.go('app.offered_service_settings_payment_plans', { offeredServiceId: vm.offeredService.id, organizationId: vm.organization.id });
        }

        function gotoOrganization(organizationId){
            $state.go('app.organization',{ organizationId: organizationId });
        }

        function gotoDashboard(){
            $state.go('app.pages_dashboard');
        }



//        function helpMe(ev, helpContext) {
//            $mdDialog.show({
//                controller: DialogController,
//                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/help_dialog.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose:true
//              })
//              .then(function(answer) {
//              }, function() {
//                  $log.debug('You cancelled the dialog.');
//              });
//        }

        //Controller comune alle varie dialogs
        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        vm.changeHourFrom = function() {
            if (!vm.offeredService.minutesFrom || vm.offeredService.minutesFrom===null || vm.offeredService.minutesFrom==='') {
                vm.offeredService.minutesFrom=0;
            }
        }
        vm.changeHourTo = function() {
            if (!vm.offeredService.minutesTo || vm.offeredService.minutesTo===null || vm.offeredService.minutesTo==='') {
                vm.offeredService.minutesTo=0;
            }
        }


        /**
         * Carica i tipi di documento previsti per l'organizzazione
         */
        function loadOrganizationDoctypes() {
            var query = {
                filter: {
                    where : {
                        or : [
                            {organizationId: organizationId},
                            {organizationId: null},
                        ]
                    }
                }
            };

            OrganizationDoctype.find(query).$promise.then(function(data) {
                vm.organizationDoctypes=data;
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
                }
            });
        }


        /**
         * Carica i tipi di servizio previsti per l'organizzazione
         */
        function loadOrganizationServicetypes() {
            var query = {
                filter: {
                    where : {
                        organizationId: organizationId,
                    }
                }
            };

            ServiceType.find(query).$promise.then(function(data) {
                vm.organizationServicetypes=data;
            });
        }



        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.offeredService.longitude=longitude;
            vm.offeredService.latitude=latitude;
        }

        function centerMap() {
            if (vm.offeredService.longitude && vm.offeredService.longitude!==null && vm.offeredService.latitude && vm.offeredService.latitude!==null) {
                $('input.gllpLatitude').val(vm.offeredService.latitude);
                $('input.gllpLongitude').val(vm.offeredService.longitude);
                $('input.gllpZoom').val(10);

            }

        }


        function serviceTypeChanged(serviceType, selected) {
            if (serviceType && serviceType.internalCode==='SUBSCRIPTION') {
                vm.isSubscriptionService=selected;
            }
        }


        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.offeredService.address);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }


        /**
         * Se deseleziono il costo di iscrizione, devo anche azzerarlo. Riff issue #408
         */
        vm.enableSubscriptionPriceChanged = function() {
            if (!vm.offeredService.enableSubscriptionPrice) {
                vm.offeredService.subscriptionPrice = 0;
            }
        };

    }
})();

'use strict';

(function (){
    angular
        .module('app.pages.offered_services')
        .controller('CarnetNewController', CarnetNewController);

    /** @ngInject */
    function CarnetNewController($log, $location, $state, $rootScope, $translate, OfferedService, blockUI, $scope, $timeout,
                                         breadcrumbManager, Organization, ServiceSchedule , $mdDialog,
                                         AuthenticationService, AlertMessageService, OrganizationDoctype,
                                         $filter, ServiceType, _, OfferedServiceRelation ) {
        var vm = this;

        var organizationId;

        // Data
        vm.offeredService = {
            subscriptionPrice: 0,
            enableAttendances: true,
            start: null,
            end: null,
            // precompilo i campi che identificano un carnet
            serviceType: 'SERVICE',
            standalone: 'S',
            scheduleType: 'A',
            includeMoreServices: 'Y',
            isCarnet: true,
            isDeleted: false,
        };
        vm.offeredService.requiredDocuments=[];
        vm.organizationDoctypes = [];
        vm.organizationServicetypes = [];
        vm.selecteDoctypeIds = {};
        vm.selectedServiceIds = {};
        vm.selecteServicetypeIds = {};
        vm.isSubscriptionService=false;
        vm.changeStandalone=changeStandalone;
        vm.serviceTypeChanged=serviceTypeChanged;
        vm.changePaymentType=changePaymentType;
        // Methods
        vm.saveOfferedService = saveOfferedService;
        vm.gotoOfferedService = gotoOfferedService;
        vm.gotoPianiPagamento = gotoPianiPagamento;

        vm.cancel = cancel;
        vm.serviceType='SERVICE';

        vm.serviziChildAttivabili = [];
        vm.childServiceToAdd = [];

        vm.updateLocationFromMap=updateLocationFromMap;
        vm.updateLocationFromAddress=updateLocationFromAddress;


        init();

        //////////
        /**
         * Initialize
         */
        function init(){
            if (AuthenticationService.isAuthenticated()){

                if ($location.path().startsWith('/new_event') || $location.path().startsWith('/new_generated_event')) {
                    vm.serviceType='EVENT';
                }
                breadcrumbManager.popOfferedService();

                organizationId = $state.params.organizationId;
                $log.debug('NewCarnetController.init()');
                Organization.findById({
                    id : organizationId,
                    filter : {}
                }).$promise.then(function(organization) {
                    vm.organization = organization;
                });


                loadOrganizationDoctypes();
                loadOrganizationServicetypes();
                if (vm.serviceType !== 'EVENT') {
                    loadAllPotentialChildService($state.params.organizationId);
                }

                if ($state.params.toCopyServiceId) {
                    //OfferedService.di
                }

            } else {
                $state.go('app.pages_auth_login');
            }

            $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
                }
            });

            //INIZIALIZZAZIONE DELLA MAPPA
            setTimeout(function() {
                $(".gllpLatlonPicker").each(function () {
                    var $obj = $(document).gMapsLatLonPicker();
                    $obj.init( $(this) );
                });

            }, 2000);
        }



        function saveOfferedService(){
            vm.offeredService.serviceType=vm.serviceType;
            if (vm.offeredService.standalone==='N') {
                vm.offeredService.scheduleType = 'N';
            }
            if (vm.offeredService.scheduleType==='D') {
                vm.offeredService.end=vm.offeredService.start;
            }


            if (vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y') {
                vm.offeredService.needsOrganizationSubscription = false;
                //nel caso di carnet multiservizio devo decidere se c'è bisogno della quota associativa
                _.each(_.keys(vm.childServiceToAdd), function(key) {
                    if (vm.childServiceToAdd[key] === true) {
                        //passo in rassegna is servizi e vedo se qualcuno abbisogna della quota
                        var servizioInCarnet = _.find(vm.serviziChildAttivabili, function(off) { return off.id == key; });
                        if (servizioInCarnet && servizioInCarnet.needsOrganizationSubscription) {
                            vm.offeredService.needsOrganizationSubscription = true;
                        }
                    }
                });
            }

            // correzione timezone delle date
            if (vm.offeredService && vm.offeredService.start) {
                vm.offeredService.start = moment(vm.offeredService.start).add(12, 'hours');
            }
            if (vm.offeredService && vm.offeredService.end) {
                vm.offeredService.end = moment(vm.offeredService.end).add(12, 'hours');
            }


            if (organizationId) {
                // create a service for organization "organizationId"
                blockUI.start();
                Organization.offeredServices.create(
                    { id: organizationId },
                    vm.offeredService
                ).$promise.then(
                    function(os,responseHeaders){
                        $log.debug(os);
                        OfferedService.findById({
                            id: os.id
                        }).$promise.then(function(myOfferedService) {

                            vm.offeredService.requiredDocuments=[];
                            var keys = _.keys(vm.selecteDoctypeIds);
                            for (var i = 0; i < keys.length; i++) {
                                if (vm.selecteDoctypeIds[keys[i]]) {
                                    //cerco il doc per id
                                    var docType = _.find(vm.organizationDoctypes, function(d){return d.id==keys[i];});
                                    vm.offeredService.requiredDocuments.push(docType);
                                }
                            }

                            myOfferedService.$prototype$updateRequiredDocTypes( {requiredDocuments: vm.offeredService.requiredDocuments})
                                .then(function(data){
                                    $log.debug('success');
                                    $log.debug(data);

                                    OfferedService.updateServiceTypes({offeredServiceId: myOfferedService.id.toString(), serviceTypes: vm.selectedServiceIds}).$promise.then(function(data) {
                                        if (!$state.params.srcOfferedServiceId) {
                                            blockUI.stop();
                                            vm.offeredService.id = os.id;
                                            goToNextStep();
                                        } else {
                                            OfferedService.copySubscribers({sourceOfferedServiceId: $state.params.srcOfferedServiceId.toString(), destOfferedServiceId: os.id.toString() }).$promise.then(function(data) {
                                                blockUI.stop();
                                                vm.offeredService.id = os.id;
                                                goToNextStep();
                                            }, function(httpResponse) {
                                                blockUI.stop();
                                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                            });
                                        }
                                    },function(httpResponse){
                                        blockUI.stop();
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                                },function(httpResponse){
                                    blockUI.stop();
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });

                            //SE HO UN SERVIZIO PUNTUALE E HO DATA ORE E MINUTI INSERISCO ANCHE L'ORARIO
                            if (vm.offeredService.scheduleType==='D' && vm.offeredService.hourFrom && vm.offeredService.hourFrom!==null && vm.offeredService.hourTo && vm.offeredService.hourTo!==null) {

                                ServiceSchedule.create(
                                    {
                                        offeredServiceId:os.id,
                                        dateFrom:vm.offeredService.start,
                                        dateTo:vm.offeredService.end,
                                        hourFrom:vm.offeredService.hourFrom,
                                        hourTo:vm.offeredService.hourTo,
                                        minutesFrom:vm.offeredService.minutesFrom,
                                        minutesTo:vm.offeredService.minutesTo,
                                        typeCode:'P'
                                    },
                                    function(scheduleData,responseHeaders){
                                        $log.debug('saveSchedule() riuscita: ');
                                        $log.debug(scheduleData);
                                    },
                                    function(httpResponse){
                                        $log.debug(httpResponse);
                                    });

                            }

                            if (vm.serviceType !== 'EVENT' && vm.offeredService.scheduleType === 'A' && vm.offeredService.includeMoreServices === 'Y') {
                                var serviceRelations = [];
                                _.each(_.keys(vm.childServiceToAdd), function(keyId) {
                                    if (vm.childServiceToAdd[keyId] === true) {
                                        serviceRelations.push({
                                            childId: keyId,
                                            parentId:  os.id
                                        });
                                    }
                                });
                                if (serviceRelations.length > 0) {
                                    OfferedServiceRelation.createMany(serviceRelations,
                                        function(rels, responseHeaders){
                                            $log.debug('saveSchedule() riuscita: ');
                                            $log.debug(rels);
                                        },
                                        function(httpResponse){
                                            $log.debug(httpResponse);
                                        });
                                }
                            }


                        });
                    },
                    function(httpResponse){
                        blockUI.stop();
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });

            } else {

                OfferedService.create(
                    vm.offeredService,
                    function(os,responseHeaders){
                        $log.debug(os);
                        vm.offeredService.id = os.id;
                        goToNextStep();
                    },
                    function(httpResponse){
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
            }
        }



        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllPotentialChildService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        serviceType: 'SERVICE',
                        scheduleType: {neq: 'A'},
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.serviziChildAttivabili = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return true;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode==='SUBSCRIPTION';
                        });
                        if (found) {
                            return false;
                        } else {
                            return true;
                        }
                    });
                    vm.childServiceToAdd = _.map(vm.serviziChildAttivabili, function (s) {
                        return s.id;
                    });
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * chiamato al change dell'attributo standalone (S = si N = no)
         */
        function changeStandalone() {
            if (vm.offeredService.standalone=='N') {
                vm.offeredService.trialDays=0;
                vm.hasChat=false;
                vm.scheduleType='N';
            }
        }

        function changePaymentType() {
            if (vm.offeredService.paymentType=='F') {
                vm.offeredService.subscriptionPrice=0;
                vm.offeredService.renewalPrice=0;
            }
            else if (vm.offeredService.paymentType=='O') {
                vm.offeredService.renewalPrice=0;
            }
        }

        function cancel(){
            $log.debug(organizationId);
            if (organizationId){
                gotoOrganization(organizationId)
            } else {
                gotoDashboard();
            }
        }

        /**
         * Hook chiamato al cambio di tab che fa scrollare in su la pagina
         */
        vm.onWizardStepChange = function() {
            $timeout(function() {
                $('#content').animate({scrollTop: 0});
            }, 100);
        }


        function goToNextStep() {
            if ($scope.$$childHead && $scope.$$childHead.$$nextSibling && $scope.$$childHead.$$nextSibling.msWizard) {
                $scope.$$childHead.$$nextSibling.msWizard.nextStep();// = stepFinale;//FIXME modificare questa espressione allucinante!!!
            } else if ($scope.$$childHead && $scope.$$childHead.$$nextSibling && $scope.$$childHead.$$nextSibling.$$nextSibling && $scope.$$childHead.$$nextSibling.$$nextSibling.msWizard) {
                $scope.$$childHead.$$nextSibling.$$nextSibling.msWizard.nextStep();
            } else if ($scope.$$childHead && $scope.$$childHead.msWizard) {
                $scope.$$childHead.msWizard.nextStep();
            }
        }

        function gotoOfferedService(){
            $state.go('app.offered_service',{ offeredServiceId: vm.offeredService.id,  organizationId: vm.offeredService.organizationId });
        }

        function gotoPianiPagamento() {
            $state.go('app.offered_service_settings_payment_plans', { offeredServiceId: vm.offeredService.id, organizationId: vm.offeredService.organizationId });
        }

        function gotoOrganization(organizationId){
            $state.go('app.organization',{ organizationId: organizationId });
        }

        function gotoDashboard(){
            $state.go('app.pages_dashboard');
        }



//        function helpMe(ev, helpContext) {
//            $mdDialog.show({
//                controller: DialogController,
//                templateUrl: 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/help_dialog.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose:true
//              })
//              .then(function(answer) {
//              }, function() {
//                  $log.debug('You cancelled the dialog.');
//              });
//        }

        //Controller comune alle varie dialogs
        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        vm.changeHourFrom = function() {
            if (!vm.offeredService.minutesFrom || vm.offeredService.minutesFrom===null || vm.offeredService.minutesFrom==='') {
                vm.offeredService.minutesFrom=0;
            }
        }
        vm.changeHourTo = function() {
            if (!vm.offeredService.minutesTo || vm.offeredService.minutesTo===null || vm.offeredService.minutesTo==='') {
                vm.offeredService.minutesTo=0;
            }
        }


        /**
         * Carica i tipi di documento previsti per l'organizzazione
         */
        function loadOrganizationDoctypes() {
            var query = {
                filter: {
                    where : {
                        or : [
                            {organizationId: organizationId},
                            {organizationId: null},
                        ]
                    }
                }
            };

            OrganizationDoctype.find(query).$promise.then(function(data) {
                vm.organizationDoctypes=data;
                for (var i = 0; i < vm.organizationDoctypes.length; i++) {
                    vm.organizationDoctypes[i].name = $filter('cylDictionary')(vm.organizationDoctypes[i].name,'DOCTYPE',vm.organizationDoctypes[i].code);
                }
            });
        }


        /**
         * Carica i tipi di servizio previsti per l'organizzazione
         */
        function loadOrganizationServicetypes() {
            var query = {
                filter: {
                    where : {
                        organizationId: organizationId,
                    }
                }
            };

            ServiceType.find(query).$promise.then(function(data) {
                vm.organizationServicetypes=data;
            });
        }



        function updateLocationFromMap() {
            var centerId = $('#field-id').data('value');
            var latitude = $('input.gllpLatitude').val();
            var longitude = $('input.gllpLongitude').val();
            vm.offeredService.longitude=longitude;
            vm.offeredService.latitude=latitude;
        }

        function centerMap() {
            if (vm.offeredService.longitude && vm.offeredService.longitude!==null && vm.offeredService.latitude && vm.offeredService.latitude!==null) {
                $('input.gllpLatitude').val(vm.offeredService.latitude);
                $('input.gllpLongitude').val(vm.offeredService.longitude);
                $('input.gllpZoom').val(10);

            }

        }


        function serviceTypeChanged(serviceType, selected) {
            if (serviceType && serviceType.internalCode==='SUBSCRIPTION') {
                vm.isSubscriptionService=selected;
            }
        }


        function updateLocationFromAddress() {
            $('input.gllpSearchField').val(vm.offeredService.address);
            $('input.gllpSearchButton').click();
            setTimeout(updateLocationFromMap, 500);
        }

    }
})();

// 'use strict';
//
// (function() {
//     angular
//         .module('app.pages.earningcosts')
//         .controller('SinglePaymentDialogController', SinglePaymentDialogController);
//
//     /** @ngInject */
//     function SinglePaymentDialogController($scope, $log) {
//         $log.debug('SinglePaymentDialogController()');
//
//         $scope.cancel = function() {
//             $mdDialog.cancel();
//         };
//
//         $scope.answer = function(answer) {
//             answer = answer || { answer: true };
//             $mdDialog.hide(answer);
//         };
//     }
// })();

(function (){
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfileController', ProfileController);

    function ProfileController($log, $state, $scope, $location, $rootScope, _, $translate, DictionaryService, $mdToast,
                               $mdDialog, LoopBackAuth, breadcrumbManager, OfferedService, Organization, CylUtils,
                               User, ServiceDoctype,Notification, UserIdentity, Payment, SubscriptionDocument,
                               Subscription, AlertMessageService,  UserDocument, AuthenticationService,
                               DTOptionsBuilder, ApiPath)
    {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userProfile = null;
        vm.userIdentity = null;
        vm.editableProfile = false;
        vm.userDocuments = [];
        vm.userServices = [];
        vm.organizations = [];
        vm.userDetailVisibility = null;

        vm.apiPath = ApiPath;
        vm.isUserDetail= ($location.path().startsWith('/user'));
        vm.gotoDocuments=gotoDocuments;
        vm.gotoRelatives=gotoRelatives;
        vm.gotoServices=gotoServices;
        vm.gotoPayments=gotoPayments;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.gotoNewUserSubscription=gotoNewUserSubscription;
        vm.gotoProfileAttendances = gotoProfileAttendances;

        // statistiche dei pagamenti, per il widget. Dopo modifiche issue #635
        vm.paymentsStats = {
            paidCount: 0,
            unpaidCount: 0,
            unpaidAmount: 0,
        };

        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   : ApiPath + "/userDocumentsContainers/"+$rootScope.CYL_USER_DOC_PREFIX + $state.params.userId + "/upload",
            chunkSize                : 15 * 1024 * 1024,
            maxChunkRetries          : 1,
            simultaneousUploads      : 1,
            testChunks               : false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            query: {cyl_type:vm.attachmentType}
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {},
            flowLogo: {},
            flowBackground: {}
        };

        // Methods
        vm.editProfile = editProfile;
        vm.cancelEdit = cancelEdit;
        vm.saveProfile = saveProfile;

        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.goToOrganization=goToOrganization;
        vm.goToOrganizations=goToOrganizations;
        vm.gotoOfferedService=gotoOfferedService;
        vm.gotoSubscriptions = gotoSubscriptions;
        vm.goToRelativeDetail = goToRelativeDetail;

        vm.formatDate=formatDate;
        vm.goBack=goBack;
        vm.sendMessage=sendMessage;
        vm.removeAvatar=removeAvatar;
        vm.removeBackground=removeBackground;
        vm.openMenuImageDeletion=openMenuImageDeletion;
        vm.backgroundImage=backgroundImage;
        vm.deleteOrganization=deleteOrganization;
        vm.subscriptionsStats={};
        vm.isParentManagementEnabled = false;


        vm.dragEnter = function(){
            //$log.debug("Drag Enter");
            $('#document-image-uploader').addClass('drag-enter');
        }

        vm.dragLeave = function(){
            //$log.debug("Drag Leave");
            $('#document-image-uploader').removeClass('drag-enter');
        }

        vm.editUserServiceDocuments=editUserServiceDocuments;

        vm.goToOrganizationDetail = goToOrganizationDetail;
        vm.goToNewOrganization = goToNewOrganization;
        vm.apiPath=ApiPath;

        init();

        //////////

        function init(){
            $log.debug('ProfileController.init()');
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
            vm.userId=userId.toString();

            if (AuthenticationService.isAuthenticated()){

                //CONTROLLI PRELIMINARI
                // - se accedo come socio vedo solo me o i miei figli (vm.isUserDetail===false)
                // - se accedo come amministratore vedo i miei soci / contatti oppure le loro persone di riferimento

                vm.subscriptionsStats.payed=0;
                vm.subscriptionsStats.unpayed=0;
                vm.subscriptionsStats.docsMissing = 0;
                vm.subscriptionsStats.docsExpired = 0;
                vm.subscriptionsStats.docsExpiring = 0;
                vm.subscriptionsStats.docsValidated = 0;
                vm.subscriptionsStats.docsToValidate = 0;
                vm.subscriptionsStats.docsRejected = 0;
                vm.subscriptionsStats.loaded = false;

                User.isParentManagementEnabled({userId: vm.userId}).$promise.then(function(data) {
                    vm.isParentManagementEnabled=data.result;
                });


                loadUser(userId ).then(function(user){
                    loadOrganizations(user).then(
                        function(data){
                            vm.organizations = data.result.organizations;
                        });
                });

                loadUserProfile(userId).then(
                    function(data){
                        $log.debug(data);
                        var myUser = data;
                        vm.userProfile = (JSON.parse(JSON.stringify(myUser)));

                        try {
                            vm.userDetailVisibility = JSON.parse(vm.userProfile.userDetailVisibility);
                        } catch(err) {
                            vm.userDetailVisibility =  {};
                        }

                        //filtro i doppioni sulle organizzazioni
                        vm.userProfile.organizations = _.uniq(vm.userProfile.organizations, function(o) {return o.id;});


                        vm.userIdentity = data.identities[0];
                        if (vm.userProfile.birthDate && vm.userProfile.birthDate!==null && typeof(vm.userProfile.birthDate == 'string')){
                            vm.userProfile.birthDate = new Date(vm.userProfile.birthDate);
                        }

                        DictionaryService.loadDictionary(function() {
                            for (var i = 0; i < vm.userProfile.parents.length; i++) {
                                var theRelation = _.find(vm.userProfile.parentRelations, function (r) { return r.parentId === vm.userProfile.parents[i].id;});
                                if (theRelation && theRelation.relationType) {
                                    vm.userProfile.parents[i].relationType= DictionaryService.translateMessage('PARENT_RELATION', theRelation.relationType, '');
                                }
                            }
                        });

                        // #635: dopo aver cambiato i campi per le statistiche dei pagamenti, il widget non si visualizzava più
                        Organization.clientUserPaymentsStats({
                            dateFrom: moment('2000-01-01').toISOString(),
                            dateTo: moment('2999-12-31').toISOString(),
                            userId: userId,
                        }).$promise.then(
                            function(statsResponse) {
                                $log.debug('returned from Organization.userPaymentsStats():');
                                $log.debug(statsResponse);
                                vm.paymentsStats = {
                                    paidCount: statsResponse.paidSubscriptions ? statsResponse.paidSubscriptions : 0,
                                    unpaidCount: statsResponse.unpaidSubscriptions ? statsResponse.unpaidSubscriptions : 0,
                                    unpaidAmount: statsResponse.unpaidSubscriptionsValue ? statsResponse.unpaidSubscriptionsValue : 0,
                                };
                            },
                            function(err) {
                                $log.error(err);
                            }
                        );



                        loadUserServices(myUser);

                    },
                    function(error){
                        $log.debug(error);
                    });

                if (!vm.isUserDetail) {
                    sessionStorage.setItem('CURRENT_ORGANIZATION',null);
                    sessionStorage.setItem('CURRENT_SERVICE',null);
                }

                $rootScope.$on('PAYMENTS_TO_BE_RELOADED', function (event, valore) {
                    loadUserServices(vm.userProfile);
                });

            } else {
                $state.go('app.pages_auth_login');
            }



        }


        function goToOrganizationDetail(organizationId)
        {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);

            $state.go('app.organization', {organizationId: organizationId});
        }


        function goToNewOrganization()
        {
            $state.go('app.new_organization');
        }

        function loadUser(userId){
            return User.findById({
                id: userId,
            }, {filter: {include: ['parents', 'parentRelations'] }}).$promise;
        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }


        function gotoSubscriptions() {
            var item = breadcrumbManager.currentOrganization();
            $state.go('app.pages_subscriptions_pre', {
                organizationId: item.id,
                offeredServiceId: '',
                paymentsFilter: 'A',
                documentsFilter: '',
                userId: userId
            });
        }


        function goToRelativeDetail(userId) {
            if (vm.isUserDetail) {
                $state.go('app.pages_profile', {userId: userId});
            } else {
                $state.go('app.pages_profile_socio', {userId: userId});
            }
        }


        function gotoDocuments() {
            $state.go('app.pages_profile_docs', {userId: userId});
        }

        function gotoRelatives() {
            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
            if (vm.isUserDetail) {
                $state.go('app.pages_user_relatives', {userId: userId});
            } else {
                $state.go('app.pages_profile_relatives', {userId: userId});
            }
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', {userId: userId});
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', {userId: userId});
        }

        function gotoNewUserSubscription(userId) {
            var organization = breadcrumbManager.currentOrganization();
            $state.go('app.new_user_subcription', {
                userId : vm.userProfile.id,
                organizationId: organization.id
            });
        }

        function gotoProfileAttendances() {
            $state.go('app.profile_attendances', {userId: userId});
        }

        function loadUserProfile(userId){
            var organizationId = '';
            var item = breadcrumbManager.currentOrganization();
            if (vm.isUserDetail && item) {
                organizationId = item.id;
            }
            return User.loadUser({
                id: userId,
                filter: {
                    include: ['identities', 'children', 'parents', 'parentRelations', 'organizations']
                },
                organizationId: organizationId
            }).$promise;
        }



        function editProfile(){
            if (vm.isUserDetail) {
                $state.go('app.pages_user_detail', {userId: vm.userProfile.id});
            } else {
                $state.go('app.pages_profile_detail', {userId: vm.userProfile.id});
            }
        }

        function cancelEdit(){
            vm.editableProfile = false;
            vm.userProfile = angular.copy(preUpdateProfile);
        }

        function saveProfile(){
            //$log.debug(vm.userData);
            vm.editableProfile = false;

            //vm.userProfile.displayName =  vm.userProfile.name.familyName + " " + vm.userProfile.name.givenName;
            vm.userProfile.userDetailVisibility = JSON.stringify(vm.userDetailVisibility);

            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {userDetailVisibility: vm.userProfile.userDetailVisibility, isSearchable: vm.userProfile.isSearchable}).$promise.then(
                function(data){
                User.loadUser({
                    id: vm.userProfile.id,
                    filter: {}
                }, function(user) {
                    user.userDetailVisibility = vm.userProfile.userDetailVisibility;
                    user.isSearchable = vm.userProfile.isSearchable;
                    User.saveUser({
                        user: user,
                        organizationId: ''
                    }).$promise.then(
                        function(data){
                            $log.debug(data);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant('USERS.PROFILE_SAVED'))
                                    .position("top right")
                                    .hideDelay(2000)
                            );
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );
                }, function(error){
                    $log.debug(error);
                });
            });


            // User.prototype$patchAttributes(
            //     { id: vm.userProfile.id },
            //     {userDetailVisibility: vm.userProfile.userDetailVisibility, isSearchable: vm.userProfile.isSearchable}).$promise.then(
            //     function(data){
            //         $log.debug(data);
            //         $mdToast.show(
            //             $mdToast.simple()
            //                 .textContent($translate.instant('USERS.PROFILE_SAVED'))
            //                 .position("top right")
            //                 .hideDelay(2000)
            //         );
            //     }
            // );
        }

        function fileAdded(file){

            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            vm.contentToUpload = uploadingFile;
            upload();
        }

        function upload(typeFile){
            vm.contentToUpload.type = 'uploading';
            vm.ngFlow.flow.opts={};
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                //'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
                //'Authorization' : 'Bearer {' + AuthenticationService.getToken() + '}'
            };

            if (typeFile==='LOGO') {
                vm.ngFlowOptions.query.cyl_type='LOGO';
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowLogo.upload();
            }
            else if (typeFile==='BACKGROUND') {
                vm.ngFlowOptions.query.cyl_type='BACKGROUND';
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowBackground.upload();
            }

        }

        function fileSuccess(file, message, typeFile){
            $log.debug('fileSuccess');

            //PER FS recupero file FIXME
            var uri = JSON.parse(message).result.files.file[0].name;

            if (typeFile==='LOGO') {
                loadUser(userId ).then(function(user){
                    vm.userProfile=user;
                    $rootScope.uriAvatar=uri;
                });
            }
            else if (typeFile==='BACKGROUND') {
                loadUser(userId ).then(function(user){
                    vm.userProfile=user;
                    $rootScope.uriBackground=uri;
                });
            }
        }

        function fileError(file, message, typeFile){
            $log.error('fileError:');
            $log.error(message);
            AlertMessageService.showErrorAlert('La funzionalità di upload è al momento non disponibile. Si prega di ' +
                'riprovare più tardi e se il problema persiste informare l\'assistenza.');
        }


        function backgroundImage() {
            if (vm.userProfile && vm.userProfile!==null && vm.userProfile.uriBackground && vm.userProfile.uriBackground !==null) {
                return {'background-image': 'url('+ApiPath+'/userDocumentsContainers/'+$rootScope.CYL_USER_DOC_PREFIX+vm.userProfile.id +'/download/'+vm.userProfile.uriBackground+')'};
            }
            return '';

        }

        function openMenuImageDeletion($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };


        function removeBackground() {
            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {uriBackground: null}).$promise.then(
                function(data){
                    $log.debug(data);
                    vm.userProfile.uriBackground = null;
                }
            );
        }

        function removeAvatar() {
            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {uriAvatar: null}).$promise.then(
                function(data){
                    $log.debug(data);
                    vm.userProfile.uriAvatar = null;
                    $rootScope.uriAvatar=null;

                }
            );
        }



        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function editUserServiceDocuments(ev, service) {
            $scope.doctypes={};
            $scope.myResource={};
            $scope.myResource.serviceDocuments={};
            //carica documenti necessari per il servizio
            var query ={
                filter: {
                    where : {offeredServiceId: service.id},
                    include : ['organizationDoctype' ]
                }
            };
            ServiceDoctype.find(query, function(docs) {
                $scope.doctypes=docs;
                //carico eventuale documentazione già salvata
                var querySubDocs ={
                    filter: {
                        where : {subscriptionId: service.subscriptionId},
                        include : ['userDocument','organizationDoctype' ]
                    }
                };
                SubscriptionDocument.find(querySubDocs, function(subDocs) {
                    if (subDocs && subDocs!==null) {
                        for (var i = 0; i < subDocs.length; i++) {
                            $scope.myResource.serviceDocuments[subDocs[i].organizationDoctype.id]= subDocs[i].userDocument;
                        }
                    }

                    $mdDialog.show({
                        controller: DialogController,
                        templateUrl: 'app/main/pages/users/user_profile/tabs/services/edit_docs_dialog.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose:true
                    })
                        .then(function(answer) {

                            $log.debug(answer.serviceDocuments);

                            var subscriptionDocuments = [];
                            if (answer.serviceDocuments && answer.serviceDocuments!==null) {
                                var keys = Object.keys(answer.serviceDocuments);
                                for (var i = 0; i<keys.length; i++) {
                                    if (answer.serviceDocuments[keys[i]]) {
                                        //traduco l'orario in risorsa
                                        var subscriptionDocument = {};
                                        subscriptionDocument.subscriptionId=service.subscriptionId;
                                        subscriptionDocument.organizationDoctypeId=keys[i];
                                        subscriptionDocument.userDocumentId=answer.serviceDocuments[keys[i]].id;
                                        subscriptionDocument.uri=answer.serviceDocuments[keys[i]].uri;
                                        subscriptionDocuments.push(subscriptionDocument);
                                    }
                                }
                            }

                            Subscription.findById({
                                id: service.subscriptionId
                            }).$promise.then(function(mySub) {
                                mySub.$prototype$updateSubscriptionDocuments({subscriptionDocuments: subscriptionDocuments})
                                    .then(function(data){
                                        $log.debug('success');
                                        $log.debug(data);
                                        loadUserServices(vm.userProfile);
                                        AlertMessageService.showSuccessMessage();

                                    },function(httpResponse){
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                            });
                        }, function() {
                            $log.debug('You cancelled the dialog.');
                        });

                });
            });

        }


        function goBack() {
            window.history.back();
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function loadUserServices(myUser) {
            $log.debug('ProfileController.loadUserServices()');
            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {
                        if ( response.result.services &&  response.result.services!==null) {
                            for (var i = 0; i <  response.result.services.length; i++) {
                                var dateFrom =  response.result.services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    response.result.services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  response.result.services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    response.result.services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }
                        vm.userServices = response.result.services;
                        // $log.debug('vm.userServices: ' + JSON.stringify(vm.userServices, undefined, 2));
                    });
            });
            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allMySubscriptionsStats().then(function(response) {
                    // $log.debug('returning from user.$prototype$allMySubscriptionsStats()');
                    // $log.debug({response: response});
                    vm.subscriptionsStats=response.result;
                    vm.subscriptionsStats.loaded=true;
                });
            });
        }


        function sendMessage(ev) {
            $scope.myResource={};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    //creo la notifica sia tra le NOTIFICHE SIA IN CHAT
                    User.notifyUser({userId: vm.userId, subject: answer.title, text:answer.text }).$promise.then(
                        function(n,responseHeaders){
                            $log.debug('Notifica inviata');
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        }
                    );

                    Notification.create(
                        {senderId: vm.currentUserId,
                            recipientId: vm.userId,
                            title: answer.title,
                            text: answer.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        },
                        function(n,responseHeaders){
                            $log.debug('Scrittura in chat inviata');
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }

        function deleteOrganization(organizationId){
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    //controllo se la associazione ha servizi associati
                    OfferedService.count({
                        where : {dtDel: null, organizationId: organizationId}
                    }, function(totalNumber) {
                        if (totalNumber.count && totalNumber.count>0)  {
                            //ERRORE: ci sono servizi associati
                            AlertMessageService.showErrorAlert("ORGANIZATIONS.ERRORS.CANT_DELETE_HAS_SERVICES");
                        }
                        else {
                            $log.debug('ProfileController.deleteOrganization()');
                            Organization.findById({
                                id : organizationId
                            }).$promise.then(function(org) {
                                org.dtDel=new Date();
                                Organization.upsert(org,
                                    function(org,responseHeaders){
                                        loadUser(vm.userId ).then(function(user){
                                            loadOrganizations(user).then(
                                                function(data){
                                                    vm.organizations = data.result.organizations;
                                                });
                                        });
                                    },
                                    function(httpResponse){
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                            });
                        }
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }



    }

})();

'use strict';

(function (){
    angular
        .module('app.pages.users')
        .controller('UserDocumentsController', UserDocumentsController);

    function UserDocumentsController($log, $state, AuthenticationService, _, AlertMessageService, appDataService,
                                     User, SubscriptionDocument, Subscription, breadcrumbManager) {
        var vm = this;
        vm.loading = true;
        vm.user = null;
        vm.subscriptions = [];
        vm.subscriptionId = null;      // eventuale unica subscription da mostrare


        /**
         * Inizializza la finestra
         */
        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                var userId = $state.params.userId ? $state.params.userId : null;
                vm.subscriptionId = $state.params.subscriptionId ? $state.params.subscriptionId : null;
                if (userId) {
                    loadUser(userId).then(
                        function(user) {
                            vm.user = JSON.parse(JSON.stringify(user));
                            $log.debug(vm.user);
                            // carica le subscriptions
                            loadSubscriptions(vm.user.id, function(subscriptions) {
                                // al momento non serve fare nulla
                            });
                        },
                        function(err) {
                            $log.error('Errore caricando utente');
                            $log.error(err);
                            vm.loading = false;
                        }
                    );
                } else {
                    // non ho indicato un utente, avviso
                    vm.loading = false;
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica un utente dato l'id
         *
         * @param userId
         * @returns {promise}
         */
        function loadUser(userId) {
            return User.findById(
                { id: userId },
                {}
                ).$promise;
        }


        /**
         * Trova i servizi sottoscritti da un utente, con i relativi documenti
         * @note Bisogna filtrare via i servizi di altre associazioni
         *
         * @param userId
         * @returns {promise}
         */
        function loadDocuments(userId) {
            return User.find({
                filter: {
                    where: {
                        id: userId
                    },
                    include: [
                        { serviceSubscriptions: ['requiredDocuments']},
                        { subscriptions: ['documents', {offeredService: 'requiredDocuments' }]}
                        ]
                }
            }).$promise;
        }


        /**
         * Carica le subscription, le filtra e crea le strutture aggiuntive _info per lo status
         * @param userId
         * @param callback
         */
        function loadSubscriptions(userId, callback) {
            $log.debug('loadSubscriptions()');
            var organizationId = null;
            if (appDataService.currentOrganization) {
                organizationId = appDataService.currentOrganization.id;
            } else {
                organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION');
            }
            // $log.debug('organizationId: ' + organizationId);

            if (organizationId) {
                // applica il periodo di riferimento all'elenco
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    var dateFrom = null, dateTo = null;
                    if (refPeriod) {
                        dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                        dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                    }
                    Subscription.getNormalizedSubscriptions({ organizationId: organizationId.toString(), userId: vm.user.id.toString(), dateFrom: dateFrom, dateTo: dateTo}, {}).$promise.then(
                        function(subscriptions) {
                            if (subscriptions && subscriptions.subscriptions) {
                                vm.subscriptions = JSON.parse(JSON.stringify(subscriptions.subscriptions));

                                // filtro per eventuale subscriptionId indicata come parametro
                                if (vm.subscriptionId) {
                                    // $log.debug('Filtro per subscriptionId: ' + vm.subscriptionId);
                                    vm.subscriptions = _.filter(vm.subscriptions, function(subscription) {
                                        return subscription.id.toString() === vm.subscriptionId;
                                    });
                                }

                                // aggiunge lo status a ciascun documento necessario
                                addDocumentStatus(vm.subscriptions);
                            } else {
                                vm.subscriptions = [];
                            }
                            $log.debug(vm.subscriptions);
                            vm.loading = false;
                            callback(null, vm.subscriptions);
                        },
                        function(err) {
                            $log.error('Errore caricando i documenti');
                            $log.error(err);
                            vm.loading = false;
                            callback(err, null);
                        }
                    );
                });
            } else {
                $log.warn('organizationId mancante');
                vm.loading = false;
                callback(new Error('organizationId mancante'), null);
            }
        }


        /**
         * Scorre i documenti di ciascuna sottoscrizione e li associa al relativo requiredDocument, aggiungendovi
         * una proprietà _info
         *
         * @param {array<Subscription>} subscriptions
         */
        function addDocumentStatus(subscriptions) {
            // $log.debug('addDocumentStatus()');
            // per ogni subscription
            _.each(subscriptions, function(subscription) {
                // $log.debug('controllo ' + subscription.offeredService.name);
                if (subscription && subscription.offeredService &&
                    subscription.offeredService.requiredDocuments &&
                    subscription.documents) {
                    // per ogni documento richiesto
                    _.each(subscription.offeredService.requiredDocuments, function(requiredDocument) {
                        // $log.debug('    cerco documento ' + requiredDocument.name);
                        // cerca il documento corretto
                        var docFound = _.find(subscription.documents, function(document) {
                            // $log.debug('        verifico documento ' + document.uri + ' ' + (document.organizationDoctypeId === requiredDocument.id ? 'trovato' : 'non trovato'));
                            return document.organizationDoctypeId === requiredDocument.id;
                        });
                        // se trova il documento
                        if (docFound) {
                            requiredDocument['_info'] = JSON.parse(JSON.stringify(docFound));
                            // $log.debug('        Aggiunte info: ' + JSON.stringify(requiredDocument));
                        }
                    });
                }
            });
        }



        /**
         * Ritorna TRUE se un requiredDocument è tutto ok
         *
         * @param requiredDocument
         * @returns {boolean}
         */
        vm.isRequiredDocumentOk = function(requiredDocument) {
            // se presente il document
            if (requiredDocument && requiredDocument['_info']) {
                var doc = requiredDocument['_info'];
                if (doc.flgValidated && moment().isSameOrBefore(doc.validTo)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        };


        /**
         * Ritorna il messaggio da mostrare se un requiredDocument non è valido.
         *
         * @param requiredDocument
         * @returns {string}
         */
        vm.requiredDocumentProblems = function(requiredDocument) {
            var ret = '';
            if (!requiredDocument || !requiredDocument['_info']) {
                ret = 'documento mancante';
            } else {
                var doc = requiredDocument['_info'];
                if (!doc.flgValidated) {
                    ret += 'non validato';
                }
                if (!doc.validTo || moment().isAfter(doc.validTo)) {
                    if (ret) {
                        ret += '; ';
                    }
                    ret += 'scaduto o data non valida';
                }
            }

            return ret;
        };


        /**
         * Quando modifico il segno di spunta sul documento cartaceo/non cartaceo
         *
         * @param requiredDocument
         * @param subscription
         */
        vm.toggleCartaceo = function(requiredDocument, subscription) {
            // se avevo un documento
            if (requiredDocument && requiredDocument._info) {
                // se il documento era cartaceo, lo elimino
                if (requiredDocument._info.isPaperDoc) {
                    delete requiredDocument._info;
                } else {
                    // se era un documento non cartaceo, lo imposto comecartaceo
                    // NOTA: se poi togglo nuovamente, mi viene eliminato
                    requiredDocument._info.isPaperDoc = true;
                }
            } else if (requiredDocument && !requiredDocument._info) {
                // creo un nuovo documento cartaceo
                requiredDocument._info = {
                    description: null,
                    expiredNotificationDate: null,
                    expiringNotificationDate: null,
                    flgValidated: 0,
                    isPaperDoc: true,
                    notes: null,
                    organizationDoctypeId: requiredDocument.id,
                    subscriptionId: subscription.id,
                    uri: null,
                    userDocumentId: null,
                    validFrom: null,
                    validTo: null,
                };
            }
        };


        /**
         * Applica la validazione di un documento
         *
         * @param requiredDocument
         * @param subscription
         * @param isValid
         */
        vm.validate = function(requiredDocument, subscription, isValid) {
            $log.debug('vm.validate()');
            if (requiredDocument && requiredDocument._info) {
                // se ho un id, aggiorno il subscriptionDocument
                if (requiredDocument._info.id) {
                    $log.debug('Aggiorno il SubscriptionDocument esistente');
                    // leggo il SubscriptionDocument
                    SubscriptionDocument.findById({id: requiredDocument._info.id}).$promise.then(
                        function(subscriptionDocument) {
                            // copia oggetto _info nel documento da salvare
                            subscriptionDocument = _.extendOwn(subscriptionDocument, requiredDocument._info);
                            // imposta valore validated o meno
                            subscriptionDocument.flgValidated = isValid;
                            // se valido resetto i flag delle notifiche
                            if (subscriptionDocument.flgValidated) {
                                subscriptionDocument.expiringNotificationDate = null;
                                subscriptionDocument.expiredNotificationDate = null;
                            }
                            SubscriptionDocument.updateAll(
                                {
                                    where: {id: subscriptionDocument.id}
                                },
                                subscriptionDocument, function(updatedSubscriptionDocument, responseHeaders) {
                                    $log.debug('SubscriptionDocument salvato: ' + JSON.stringify(updatedSubscriptionDocument));
                                    // TODO vedi se spalmare l'approvazione anche sulle altre sottoscrizioni dello
                                    // stesso utente nella stessa organizzazione
                                    // rif. docs_validation.controller.doValidationForThisSubscription()
                                    AlertMessageService.showSuccessMessage();

                                    // carica le subscriptions
                                    loadSubscriptions(vm.user.id, function(subscriptions) {
                                        // al momento non serve fare nulla
                                    });
                                },
                                function(httpResponse) {
                                    $log.error(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                        },
                        function(httpResponse) {
                            // errore in lettura documento
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );
                } else {
                    // se non ho un id, creo il subscriptionDocument
                    $log.debug('Creo un nuovo SubscriptionDocument');
                    SubscriptionDocument.create(
                        requiredDocument._info, function(subscriptionDocument, responseHeaders) {
                            $log.debug('SubscriptionDocument creato: ' + JSON.stringify(subscriptionDocument));
                            requiredDocument._info.id = subscriptionDocument.id;
                            // TODO vedi se spalmare l'approvazione anche sulle altre sottoscrizioni dello
                            // stesso utente nella stessa organizzazione
                            // rif. docs_validation.controller.doValidationForThisSubscription()

                            AlertMessageService.showSuccessMessage();
                            // carica le subscriptions
                            loadSubscriptions(vm.user.id, function(subscriptions) {
                                // al momento non serve fare nulla
                            });
                        },
                        function(httpResponse) {
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }
            }
            $log.debug(vm.subscriptions);
        };



        /**
         * Permette di gestire l'editing della data di validità di un documento già caricato.
         * @param requiredDocument
         */
        vm.editDataValidita = function(requiredDocument) {
            $log.debug(requiredDocument);
            if (!requiredDocument._info.editingDataValidita) {
                requiredDocument._info.validTo = moment(requiredDocument._info.validTo).toDate();
                requiredDocument._info.editingDataValidita = true;
            }
        };




        /**
         * Salva un documento dopo un aggiornamento, senza modificarne i dati di validazione
         * @param requiredDocument
         */
        vm.saveDocument = function(requiredDocument) {
            $log.debug('vm.saveDocument()');
            if (requiredDocument && requiredDocument._info && requiredDocument._info.id) {
                // leggo il SubscriptionDocument
                SubscriptionDocument.findById({id: requiredDocument._info.id}).$promise.then(
                    function(subscriptionDocument) {
                        // copia oggetto _info nel documento da salvare
                        subscriptionDocument = _.extendOwn(subscriptionDocument, requiredDocument._info);
                        SubscriptionDocument.updateAll(
                            {
                                where: {id: subscriptionDocument.id}
                            },
                            subscriptionDocument, function(updatedSubscriptionDocument, responseHeaders) {
                                $log.debug('SubscriptionDocument salvato: ' + JSON.stringify(updatedSubscriptionDocument));
                                AlertMessageService.showSuccessMessage();
                                // se stavo editando la data, la segno come salvata
                                if (requiredDocument._info.editingDataValidita) {
                                    requiredDocument._info.editingDataValidita = false;
                                }
                            },
                            function(httpResponse) {
                                $log.error(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                    },
                    function(httpResponse) {
                        // errore in lettura documento
                        $log.error(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
            }
        };



    } // controller
})();

(function ()
        {
    'use strict';

    angular
    .module('app.pages.users')
    .controller('UserDetailController', UserDetailController);

    /** @ngInject */
    function UserDetailController($log, $rootScope, $filter, $scope, $sce, $translate,  $mdDialog,  $state, $location,
                                  UserContact, blockUI, User, AuthenticationService, AlertMessageService,  Organization,
                                  ApiPath, $q, _, breadcrumbManager, Payment, Subscription, UserOrganizationRole,
                                  $timeout, dateUtilitiesService) {
        var vm = this;

        vm.goBack=goBack;
        vm.formatDate=formatDate;
        vm.gotoUserProfile=gotoUserProfile;

        vm.user={};
        vm.mailBackup = null;
        vm.organizationId=null;
        vm.organization = null;
        vm.userId=null;
        vm.apiPath=ApiPath;

        vm.addContact = addContact;
        vm.editContact = editContact;
        vm.deleteContact = deleteContact;
        vm.gotoNewUserSubscription = gotoNewUserSubscription;
        vm.editEmail = editEmail;
        vm.removeChildEmail = removeChildEmail;
        vm.goToParentData = goToParentData;
        vm.isUserDetail= ($location.path().startsWith('/userdetail'));

        vm.subscriptionsStats = {};
        vm.subscriptions = {
            items: [],
            loading: true,
        };
        vm.subscriptionsFromPublicPage = [];
        vm.payments = {
            allItems: [],
            items: [],
            loading: true,
            options: {
                showOldest: false,
                showFuture: false,
                showPaid: true,
                oldestPaymentsDays: 30,
                futurePaymentsDays: 30,
            }
        };
        vm.carnet = {
            items: [],
            loading: true,
            mostraEsauriti: false,
        };
        vm.loadingTemplateData = false;
        vm.stats = {};
        vm.refPeriod = null;

        init();


        //FORM DINAMICA DISEGNATA
        var docRenderedCleanupFunc = $rootScope.$on('DYN-DOC-RENDERED', function (event, value) {
            console.log('--- Document rendered');
            vm.loadingTemplateData = false;
        });

        $scope.$on('$destroy', function() {
            if (docRenderedCleanupFunc) {
                docRenderedCleanupFunc();
            }
        });
        /**
         * Initialize
         */
        function init()
        {
            if (AuthenticationService.isAuthenticated()){
                vm.userId = $state.params.userId;
                var organizationId = $state.params.organizationId;
                vm.organizationId = organizationId;

                // azzera statistiche
                vm.subscriptionsStats.payed=0;
                vm.subscriptionsStats.unpayed=0;
                vm.subscriptionsStats.docsMissing = 0;
                vm.subscriptionsStats.docsExpired = 0;
                vm.subscriptionsStats.docsExpiring = 0;
                vm.subscriptionsStats.docsValidated = 0;
                vm.subscriptionsStats.docsToValidate = 0;
                vm.subscriptionsStats.docsRejected = 0;
                vm.subscriptionsStats.loaded = false;

                // legge e normalizza il periodo di riferimento
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    vm.refPeriod = JSON.parse(JSON.stringify(refPeriod));
                    if (!refPeriod) {
                        vm.refPeriod = {};
                    }
                    if (!refPeriod.dateFrom) {
                        vm.refPeriod.dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    if (!refPeriod.dateTo) {
                        vm.refPeriod.dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }
                    vm.refPeriod.dateFrom = moment(vm.refPeriod.dateFrom).startOf('day');
                    vm.refPeriod.dateTo = moment(vm.refPeriod.dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    //continua il caricamento degli altri dati
                    // carica statistiche
                    User.findById({
                        id: vm.userId
                    }).$promise.then(function(user){
                        $log.debug('user: ' + JSON.stringify(user));
                        vm.loadStats();
                    });

                    if (!organizationId && vm.isUserDetail) {
                        var item = breadcrumbManager.currentOrganization();
                        organizationId = (item) ? item.id :  null;
                    }
                    if (organizationId && organizationId !== null) {
                        Organization.findById({
                            id : organizationId,
                            filter : {
                                include: ['roleTypes']
                            }
                        }).$promise.then(function(organization) {
                            $log.debug(organization);
                            vm.organization = organization;
                            vm.userId=$state.params.userId;
                            vm.organizationUserTemplateId=organization.organizationUserTemplateId;
                            if (vm.organizationUserTemplateId) {
                                vm.loadingTemplateData = true;
                            }
                            if ($state.params.userId && $state.params.userId!==null) {
                                loadUser();
                            }
                        });
                    } else if ($state.params.userId && $state.params.userId!==null) {
                        vm.userId=$state.params.userId;
                        loadUser();
                    }

                    // carica carnet
                    if (organizationId && vm.userId) {
                        Subscription.carnet({organizationId: organizationId, userId: vm.userId}).$promise.then(
                            function(carnetList) {
                                // $log.debug('carnetList: ' + JSON.stringify(carnetList));
                                vm.carnet.loading = false;
                                // li mette in ordine temporale
                                vm.carnet.items = _.sortBy(carnetList, function(carnet) {
                                    return carnet.orderId;
                                });
                            },
                            function(err) {
                                vm.carnet.loading = false;
                                // ignora errori
                            }
                        );
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        /**
         * Carica le statistiche da mostrare nei widget
         */
        vm.loadStats = function() {
            vm.stats = {};
            var dateFrom = null, dateTo = null;
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                if (refPeriod) {
                    dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : '20000101';
                    dateTo = moment().format('YYYYMMDD');
                }
                var statsParams = {
                    organizationId: vm.organizationId,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    userId: vm.userId,
                };

                // statistiche pagamenti
                Organization.userPaymentsStats(statsParams).$promise.then(
                    function(stats) {
                        $log.info('Organization.paymentsStats():');
                        $log.info(stats);
                        vm.stats.pagamenti = JSON.parse(JSON.stringify(stats));
                    },
                    function(err) {
                        $log.warn('Errore in Organization.paymentsStats():');
                        $log.warn(err);
                    }
                );

                // statistiche documenti
                Organization.documentStats({
                    organizationId: vm.organizationId,
                    dateFrom: dateFrom,
                    dateTo: moment().format('YYYYMMDD'),
                    userId: parseInt(vm.userId),
                }).$promise.then(
                    function(stats) {
                        $log.info('Organization.documentStats():');
                        $log.info(stats);
                        vm.stats.documenti = JSON.parse(JSON.stringify(stats));
                    },
                    function(err) {
                        $log.warn('Errore in Organization.documentStats():');
                        $log.warn(err);
                    }
                );
            });
        };


        function goBack() {
            window.history.back();
        }


        /**
         * Salva i dati dell'utente
         */
        vm.saveUser = function() {
            $log.debug('vm.saveUser()');
            if (vm.user.id) {
                if (!vm.user.email) {
                    vm.user.email = vm.mailBackup;
                }
                User.saveUser({
                    user: vm.user,
                    organizationId: vm.organizationId ? vm.organizationId :  ''
                }).$promise.then(
                    function(data){
                        $log.debug('dati aggiornati: ' + JSON.stringify(data));

                        // svuota i ruoli esistenti
                        if (vm.organization) {
                            vm.organization.$prototype$deleteRolesByUser(
                                {
                                    userId : vm.user.id
                                },
                                function(value, responseHeaders) {
                                    // ricrea i ruoli come da vm.user
                                    _.each(vm.user.userOrganizationRoles, function(userRole) {
                                        // visto che lo ricreo, elimino l'id se presente
                                        if (userRole.id) {
                                            delete userRole.id;
                                        }
                                        UserOrganizationRole.create(
                                            userRole,
                                            function(value, responseHeaders) {
                                                $log.debug('User.userOrganizationRoles.create()');
                                                $log.debug(userRole);
                                            },
                                            function(httpResponse) {
                                                $log.error('errore in User.userOrganizationRoles.create()');
                                                $log.error(userRole);
                                                $log.error(httpResponse);
                                            }
                                        );
                                    });
                                },
                                function(httpResponse) {
                                    $log.error('errore in User.userOrganizationRoles.destroyAll()');
                                    $log.error(httpResponse);
                                }
                            );
                        }


                        AlertMessageService.showSuccessMessage();
                        checkAndSaveDynamicAttributes();
                        window.history.back();
                    },
                    function(httpResponse){
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    }
                );
            } else {
                $log.warn('Manca vm.user.id');
                $log.debug(vm.user);
            }
        };


        /**
         * Si sposta alla pagina delle iscrizioni mancanti di un utente
         */
        vm.gotoUserSubscriptions = function() {
            //:organizationId/:offeredServiceId/:paymentsFilter/:documentsFilter/:userId
            $state.go('app.pages_subscriptions_person', {
                organizationId: vm.organizationId,
                paymentsFilter: 'M',
                userId: vm.userId,
            });
        };



        /**
         * Per il minore rimanda alla scheda del genitore
         */
        function goToParentData() {
            $state.go('app.pages_user_detail', {userId: vm.user.parents[0].id});

        }

        function gotoUserProfile(userId) {
            $state.go('app.pages_profile', {
                userId : userId
            });
        }

        function gotoNewUserSubscription(userId) {
            $state.go('app.new_user_subcription', {
                userId : userId,
                organizationId: vm.organizationId
            });
        }

        function checkAndSaveDynamicAttributes() {
            if (vm.organizationId && vm.userId) {
                $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'SAVE_DONE', extradata: {userId: vm.userId, organizationId: vm.organizationId.toString()}});
            }
        }


        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }


        function findUserById(id) {
            return User.loadUser({
                id : id,
                organizationId: vm.isUserDetail ? vm.organizationId : null,
                filter: {
                    include: ['parents', 'contacts', 'userOrganizationRoles']
                }
            }).$promise;
        }


        /**
         * Funzione che apre la modale per cambio mail
         */
        function editEmail() {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_detail/change_mail_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {
                User.requestChangeEmailAddress({userId: $state.params.userId, newEmail: answer.email, organizationId: $state.params.organizationId}).$promise.then(function(data) {
                    loadUser();
                    if (data.action === 'REQUEST_ACCEPTED') {
                        AlertMessageService.showAlert('Richiesta effettuata', 'E\' stata inviata una mail all\'indirizzo ' + vm.user.email + ' con un link per completare l\'operazione');
                    } else {
                        AlertMessageService.showSuccessMessage();
                    }
                }, function(httpResponse) {
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }

        /**
         * Funzione permette di eliminare la mail del minore se non confermata
         */
        function removeChildEmail() {
            $mdDialog.show({
                controller : DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent : angular.element(document.body),
                scope : $scope,
                preserveScope : true,
                clickOutsideToClose : true
            }).then(function(answer) {
                User.removeChildEmail({userId: $state.params.userId, organizationId: $state.params.organizationId}).$promise.then(function(data) {
                    loadUser();
                    AlertMessageService.showSuccessMessage();
                }, function(httpResponse) {
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }



        function initTabIndex() {
            vm.selectedTabIndex = 0;
            if (sessionStorage.getItem('currentPazienteTab') && sessionStorage.getItem('currentPazienteTab')!==null) {
                vm.selectedTabIndex=parseInt(sessionStorage.getItem('currentPazienteTab'));
            }
            $scope.$watch('vm.selectedTabIndex', function(current, old){
                sessionStorage.setItem('currentPazienteTab',current);
            });
        }


        /**
         * Caricamento dettagli utente corrrente
         */
        function loadUser() {
            // legge il periodo di riferimento
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                findUserById($state.params.userId).then(function(data) {
                    vm.mailBackup=data.email;
                    if (data.email && data.email.endsWith('.invalid')) {
                        data.email='';
                    }

                    if (data.parents && data.parents!=null && data.parents.length>0) {
                        data.hasParents=true;
                    }

                    //pulisco i contatti da quelli eliminati
                    if (data.contacts && data.contacts.length>0) {
                        data.contacts = _.filter(data.contacts, function(c) { return !c.dtDel;});
                    }
                    vm.user=data;

                    // elimino i ruoli su altre organizzazioni
                    if (vm.organization && vm.organization.id) {
                        vm.user.userOrganizationRoles = _.filter(vm.user.userOrganizationRoles, function(role) {
                            return role.organizationId === vm.organization.id;
                        });
                    }

                    $log.debug(vm.user);
                    vm.user.emailAlreadyPresent = vm.user.email && vm.user.email.indexOf('.invalid') < 0;

                    var organizationId = $state.params.organizationId;

                    // avvia caricamento riepilogo pagamenti
                    Payment.find({
                        filter: {
                            where: {
                                userId: vm.user.id,
                                organizationId: organizationId,
                            },
                            include: [{subscription: 'offeredService'}, {orderDetail: 'order'}]
                        }
                    }).$promise.then(
                        function(payments) {
                            vm.payments.allItems = payments.filter(isPaymentInReferencePeriod);
                            vm.payments.allItems = vm.payments.allItems.sort(function(a, b) {
                                return parseInt(moment(getPaymentDate(a)).format('YYYYMMDD')) -
                                    parseInt(moment(getPaymentDate(b)).format('YYYYMMDD'));
                            });
                            vm.updatePaymentsFilter();
                            vm.payments.loading = false;
                        },
                        function(err) {
                            vm.payments.loading = false;
                        }
                    );
                    // avvia caricamento riepilogo iscrizioni
                    vm.subscriptionsFromPublicPage = [];
                    Subscription.find({
                        filter: {
                            where: {
                                userId: vm.user.id,
                                dtDel: null,
                            },
                            include: [{'offeredService': 'requiredDocuments'}]
                        }
                    }).$promise.then(
                        function(subscriptions) {
                            vm.subscriptions.items = subscriptions;
                            //$log.debug(vm.subscriptions.items);
                            vm.subscriptionsFromPublicPage = _.filter(subscriptions, function(item) {
                                return item.dyndocId;
                            });

                            // filtra solo le subscription della organizzzazione corrente
                            vm.subscriptions.items = _.filter(vm.subscriptions.items, function(item) {
                                return (item && item.offeredService && item.offeredService.organizationId &&
                                    parseInt(item.offeredService.organizationId) === parseInt(vm.organizationId));
                            });

                            // filtra solo le subscription del periodo di riferimento (se impostato, altrimenti nemme tutto)
                            var dateFrom, dateTo;
                            if (refPeriod) {
                                dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom) : null;
                                dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo) : null;
                                if (dateFrom && dateTo) {
                                    vm.subscriptions.items = _.filter(vm.subscriptions.items, function(item) {
                                        if (item) {
                                            var itemDateStart = item.dtStart ? moment(item.dtStart) : null;
                                            var itemDateEnd = item.dtEnd ? moment(item.dtEnd) : null;
                                            if (dateUtilitiesService.arePeriodsOverlapping(dateFrom, dateTo, itemDateStart, itemDateEnd)) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        } else {
                                            return false;
                                        }
                                    });
                                }
                            }
                            vm.subscriptions.loading = false;
                        },
                        function(err) {
                            vm.subscriptions.loading = false;
                        }
                    );
                });
            });
        }


        /**
         * Return true if a payment is within the reference period
         *
         * @param payment
         * @returns {boolean}
         */
        function isPaymentInReferencePeriod(payment) {
            return moment(getPaymentDate(payment)).isSameOrAfter(vm.refPeriod.dateFrom) &&
                moment(getPaymentDate(payment)).isSameOrBefore(vm.refPeriod.dateTo);
        }


        /**
         * Ritorna una data relativa al pagamento (la prende possibilemnte dalla data di inizio del
         * periodo di pagamento dell'order).
         *
         * @param payment
         * @returns {null|*}
         */
        function getPaymentDate(payment) {
            if (payment) {
                if (payment && payment.orderDetail && payment.orderDetail.order &&
                    payment.orderDetail.order.dtBillingPeriodStart) {
                    return payment.orderDetail.order.dtBillingPeriodStart;
                } else {
                    if (payment.paymentDate) {
                        return payment.paymentDate;
                    } else {
                        return payment.created;
                    }
                }
            } else {
                return null;
            }
        }


        /**
         * Avvia l'aggiornamento dei filtri sui pagamenti.
         * Si lancia solitamente dopo aver modificato le impostazioni sui filtri dei pagamenti.
         */
        vm.updatePaymentsFilter = function() {
            vm.payments.items = getFilteredPayments(vm.payments.allItems, vm.payments.options);
        };


        /**
         * Ritorna i pagamenti filtrati per i parametri indicati nelle opzioni
         * @param payments
         */
        function getFilteredPayments(payments, options) {
            console.log({payments: payments, options: options});
            var ret = [];
            if (payments && payments.length > 0) {
                payments.forEach(function(payment) {
                    if (payment) {
                        var listed = true;
                        // rimuove pagamenti eliminati
                        if (payment.dtDel !== null || payment.isDeleted !== false || payment.paymentStatus === 'DELETED') {
                            listed = false;
                        }
                        // rimuove sconti
                        // if (payment.paymentStatus === 'DISCOUNT_USED') {
                        //     listed = false;
                        // }
                        // rimuove pagamenti a 0
                        if (payment.paymentValue === 0) {
                            listed = false;
                        }
                        // rimuove pagamenti più vecchi di N giorni (se non richiesto diversamente)
                        if (options.showOldest === false) {
                            if (payment && payment.orderDetail && payment.orderDetail.order &&
                                payment.orderDetail.order.dtBillingPeriodStart &&
                                moment(payment.orderDetail.order.dtBillingPeriodStart).isBefore(moment().subtract(options.oldestPaymentsDays, 'days'))) {
                                listed = false;
                            }
                        }
                        // rimuove pagamenti nel futuro oltre N giorni (se non richiesto diversamente)
                        if (options.showFuture === false) {
                            if (payment && payment.orderDetail && payment.orderDetail.order &&
                                payment.orderDetail.order.dtBillingPeriodStart &&
                                moment(payment.orderDetail.order.dtBillingPeriodStart).isAfter(moment().add(options.futurePaymentsDays, 'days'))) {
                                listed = false;
                            }
                        }
                        // rimuove pagamenti saldati (se richiesto)
                        if (options.showPaid === false) {
                            if (payment.paymentStatus === 'PAYED' || payment.paymentStatus === 'PAID' || payment.paymentStatus === 'DISCOUNT_USED') {
                                listed = false;
                            }
                        }
                        if (listed) {
                            ret.push(payment);
                        }
                    }
                });
            }
            return ret;
        }

        function reloadContacts() {
            findUserById($state.params.userId).then(function(data) {
                //pulisco i contatti da quelli eliminati
                if (data.contacts && data.contacts.length>0) {
                    data.contacts = _.filter(data.contacts, function(c) { return !c.dtDel;});
                }
                vm.user.contacts=data.contacts;
            });
        }

        $scope.myOnSuccess=function (succ, action) {
            angular.noop();
        };


        /**
         * FUNZIONI PER LA GESTIONE DEI CONTATTI
         */

        function addContact(ev) {
            $scope.contact = {contactType: 'EMAIL'};
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/commons/dialogs/other_contact_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                UserContact.create({
                    userId: vm.user.id,
                    contact: $scope.contact.contact,
                    organizationId: vm.organizationId,
                    contactType: $scope.contact.contactType,
                    description: $scope.contact.description,
                    createdAt: new Date()
                }).$promise.then(function(data) {
                    reloadContacts();
                }, function(httpResponse) {
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }


        function editContact(ev, contact) {
            $scope.contact = _.clone(contact);
            $mdDialog
                .show(
                    {
                        controller : DialogController,
                        templateUrl : 'app/main/pages/commons/dialogs/other_contact_dialog.html',
                        parent : angular.element(document.body),
                        targetEvent : ev,
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose : true
                    }).then(function(answer) {
                UserContact.findById({
                    id : contact.id
                }).$promise.then(function(ct) {
                    ct.contact=$scope.contact.contact;
                    ct.contactType=$scope.contact.contactType;
                    ct.description=$scope.contact.description;
                    UserContact.prototype$patchAttributes(
                        { id: ct.id },
                        ct).$promise.then(function (res) {
                        reloadContacts();
                    }, function(httpResponse) {
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
                });
            }, function() {
                $log.debug('You cancelled the dialog.');
            });
        }

        function deleteContact(ev, contact) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            }).then(function(answer) {
                UserContact.findById({
                    id : contact.id
                }).$promise.then(function(ct) {
                    ct.dtDel=new Date();
                    UserContact.prototype$patchAttributes(
                        { id: ct.id },
                        ct).$promise.then(function (res) {
                        reloadContacts();
                    }, function(httpResponse) {
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
                });
            });
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }

        $timeout(function() {
            // nicola: aggiunti controlli altrimenti non trova $("#btn-container").offset() e va in errore;
            // non ho ancora capito di preciso cosa faccia questa parte
            if ($("#btn-container") && $("#btn-container").offset() && $("#btn-container").height()) {
                var sOffset = $("#btn-container").offset().top;
                var shareheight = $("#btn-container").height() + 20;
                $("#content").scroll(function() {
                    var scrollYpos = $("#content").scrollTop();
                    if (scrollYpos > sOffset - shareheight) {
                        $("#btn-container").css({
//                        'top': (scrollYpos+20)+'px',
                            'position': 'fixed'
                        });
                    }

                });
            }
        }, 1000);


        /**
         * Si sposta ad una determinata subscriptopn
         */
        vm.gotoSubscription = function(subscriptionId) {
            $state.go('app.pages_subscription', {subscriptionId: subscriptionId});
        };



        /**
         * Si sposta all'elenco delle subscription
         *
         * @param offeredServiceId
         * @param paymentsFilter
         * @param documentsFilter
         */
        vm.goToSubscriptions = function(offeredServiceId, paymentsFilter, documentsFilter) {
            $state.go('app.pages_subscriptions_pre', {
                organizationId: vm.organization.id,
                offeredServiceId: offeredServiceId,
                paymentsFilter: paymentsFilter,
                documentsFilter: documentsFilter,
                userId: vm.userId,
            });
        };




        /**
         * Va alla gestione documenti per una sottoscrizione
         * @param serviceId
         * @param subscriptionId
         */
        vm.gotoDocumenti = function(serviceId, subscriptionId) {
            $state.go('app.docs_validation', {serviceId: serviceId, subscriptionId: subscriptionId});
        };



        /**
         * Ritorna TRUE se un determinato roleType è associato all'utente

         * @param {object} item
         * @returns {boolean}
         */
        vm.isRoleTypeSelected = function(item) {
            // $log.debug('vm.isRoleTypeSelected()');
            // $log.debug(item);
            // $log.debug(vm.user.userOrganizationRoles);
            var ret = false;
            _.each(vm.user.userOrganizationRoles, function(userRole) {
                if (userRole.roleTypeId === item.id) {
                    ret = true;
                }
            });
            return ret;
        };


        /**
         * Aggiunge o rimuove all'utente un ruolo
         *
         * @param roleType
         */
        vm.toggleRoleTypeSelected = function(roleType) {
            // $log.debug('vm.toggleRoleTypeSelected()');
            // $log.debug(roleType);
            // $log.debug(vm.user.userOrganizationRoles);
            var newRoles = [];
            var found = false;
            // per ogni ruolo dell'utente, se lo trovo, non lo copio tra i nuovi ruoli
            _.each(vm.user.userOrganizationRoles, function(userRole) {
                if (userRole.roleTypeId !== roleType.id) {
                    newRoles.push(userRole);
                } else {
                    found = true;
                }
            });
            // se invece nno ho trovato il ruolo, lo aggiungo
            if (!found) {
                newRoles.push({
                    dateFrom: null,
                    dateTo: null,
                    organizationId: roleType.organizationId,
                    role: roleType.internalCode,
                    rolePreferences: null,
                    roleTypeId: roleType.id,
                    userId: vm.userId,
                });
            }
            vm.user.userOrganizationRoles = newRoles;
            // $log.debug(newRoles);
        };


        // /**
        //  * Va alla pagina delle iscrizioni del carnet selezionato
        //  *
        //  * @param offeredServiceId
        //  * @param organizationId
        //  */
        // vm.gotoIscrittiCarnet = function(offeredServiceId, organizationId) {
        //     if (offeredServiceId && organizationId) {
        //         $state.go('app.offered_service', {offeredServiceId: offeredServiceId, organizationId: organizationId});
        //     }
        // };


        vm.gotoUserCarnet = function(organizationId, userId) {
            $state.go('app.pages_user_carnet', { organizationId: organizationId, userId: userId });
        };


        /**
         * Rimuove spinner dati da pagina pubblica se il documento on arriva più
         */
        $timeout(function() {
            vm.loadingTemplateData = false;
        }, 15000);

    }
})();

(function() {
    'use strict';

    angular.module('app.pages.users').controller(
        'UserCarnetController', UserCarnetController);

    /** @ngInject */
    function UserCarnetController($log, $state, AuthenticationService, AlertMessageService,
                                  User, Subscription, Attendance, Order) {
        var vm = this;
        vm.userId = $state.params.userId;
        vm.organizationId = $state.params.organizationId;
        vm.user = null;
        vm.carnet = {
            items: [],
            loading: true,
            // i 2 carnet selezionati per scambiare le presenze ra di loro
            selectedForAttendanceExchange: [],
        };


        /**
         * Inizializza il controller
         */
        vm.init = function() {
            // se sono autenticato
            if (AuthenticationService.isAuthenticated()) {
                // carica dati utente
                User.findById({ id: vm.userId }).$promise.then(
                    function(user) {
                        vm.user = user;
                        vm.loadItems(vm.organizationId, vm.userId);
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica gi elementi da visualizzare
         */
        vm.loadItems = function(organizationId, userId) {
            Subscription.carnet({organizationId: organizationId, userId: vm.userId}).$promise.then(
                function(carnetList) {
                    vm.carnet.loading = false;
                    // li mette in ordine temporale
                    vm.carnet.items = _.sortBy(carnetList, function(carnet) {
                        return carnet.orderId;
                    });
                    // eventualmengte espande quello indicato
                    if ($state.params.orderId) {
                        _.each(vm.carnet.items, function(carnet) {
                            if (carnet && carnet.orderId && carnet.orderId.toString() === $state.params.orderId.toString()) {
                                vm.expandCarnetToggle(carnet);
                            } else {
                                $log.debug(carnet.orderId);
                                $log.debug($state.params.orderId);
                            }
                        });
                    }
                    // $log.debug('vm.carnet.items: ' + JSON.stringify(vm.carnet.items));
                },
                function(err) {
                    vm.carnet.loading = false;
                    // ignora errori
                }
            );
        };


        /**
         * Espande o ricompatta un carnet.
         * All'espansione, carica i dettagli da visualizzare nel pannello
         *
         * @param {object} carnet
         */
        vm.expandCarnetToggle = function(carnet) {
            carnet.expanded = !carnet.expanded;
            // se espando il pannello, carico i dettagli
            if (carnet.expanded) {
                if (!carnet.presenze) {
                    vm.loadPresenze(carnet);
                }
                // if (!carnet.servizi) {
                //     vm.loadServizi(carnet);
                // }
                // if (!carnet.pagamenti) {
                //     vm.loadPagamenti(carnet);
                // }
                if (!carnet.info) {
                    vm.loadInfo(carnet);
                }
            }
        };


        /**
         * Carica le presenze associate ad un carnet
         *
         * @param {object} carnet
         */
        vm.loadPresenze = function(carnet) {
            if (carnet && carnet.orderId) {
                Attendance.find({
                    filter: {
                        where: {
                            organizationId: vm.organizationId,
                            orderId: carnet.orderId,
                            present: true,
                        }
                    }
                }).$promise.then(
                    function(presenze) {
                        carnet.presenze = JSON.parse(JSON.stringify(presenze));
                        // decodifica la data della presenza
                        _.each(carnet.presenze, function(presenza) {
                            if (presenza.day) {
                                presenza.dtPresenza = moment(presenza.day, 'YYYY/MM/DD').add(12, 'hours').startOf('day').toDate();
                            }
                        });
                        // ordina per data presenza
                        carnet.presenze = _.sortBy(carnet.presenze, function(presenza) {
                            return presenza.day;
                        });
                    }
                );
            }
        };


        /**
         * Carica i dettagli di questo carnet
         *
         * @param {object} carnet
         */
        vm.loadInfo = function(carnet) {
            if (carnet && carnet.orderId) {
                carnet.servizi = [];
                carnet.pagamenti = [];
                carnet.info = {};
                Order.findById(
                    {
                        id: carnet.orderId,
                        filter: {
                            include: [
                                { orderDetails: 'payments' },
                                { subscription: { offeredService: 'children' } }
                            ],
                        }
                    }).$promise.then(
                    function(order) {
                        order = JSON.parse(JSON.stringify(order));
                        $log.debug('order: ' + JSON.stringify(order));

                        // aggiunge pagamenti
                        if (order && order.orderDetails) {
                            _.each(order.orderDetails, function(orderDetail) {
                                if (orderDetail && orderDetail.payments) {
                                    _.each(orderDetail.payments, function(payment) {
                                        if (payment && !payment.isDeleted) {
                                            carnet.pagamenti.push(payment);
                                        }
                                    });
                                }
                            });
                        }

                        // aggiunge servizi inclusi
                        if (order && order.subscription && order.subscription.offeredService &&
                            order.subscription.offeredService.children) {
                            _.each(order.subscription.offeredService.children, function(offeredService) {
                                if (offeredService && !offeredService.isDeleted && !offeredService.isPaymentPlan &&
                                    !offeredService.isCarnet) {
                                    carnet.servizi.push(offeredService);
                                }
                            });
                            // ordina i servizi inj modo alfabetico
                            carnet.servizi = _.sortBy(carnet.servizi, function(servizio) {
                                return servizio.name;
                            });
                        }

                        // aggiunge le info
                        if (order) {
                            carnet.info.dtBillingPeriodStart = order.dtBillingPeriodStart ? order.dtBillingPeriodStart : null;
                            carnet.info.dtBillingPeriodEnd = order.dtBillingPeriodEnd ? order.dtBillingPeriodEnd : null;
                            carnet.info.dtMaxAttandancesReachedNotif = order.dtMaxAttandancesReachedNotif ? order.dtMaxAttandancesReachedNotif : null;
                        }
                    }
                );
            }
        };


        /**
         * Aggiunge o rimuove un carnet dall'elenco di quelli pronti per lo scambio di presenze
         *
         * @param {object} carnet
         */
        vm.toggleSelectedForAttendanceExchange = function(carnet) {
            // se era selezionato per lo scambio di presenze
            if (carnet.selectedForAttendanceExchange) {
                carnet.selectedForAttendanceExchange = false;
            } else {
                // se non era selezionato, lo seleziono e lo aggiungo all'array del selezionati
                if (vm.carnet.selectedForAttendanceExchange.length < 2) {
                    carnet.selectedForAttendanceExchange = true;
                } else {
                    // se ne avevo già selezionati 2, avviso
                    AlertMessageService.showErrorAlert('Sono già selezionati due elementi');
                }
            }
            // ricostruisce array dei carnet selezionati
            vm.carnet.selectedForAttendanceExchange = [];
            _.each(vm.carnet.items, function(currentCarnet) {
                if (currentCarnet && currentCarnet.orderId && currentCarnet.offeredServiceName &&
                    currentCarnet.selectedForAttendanceExchange) {
                    vm.carnet.selectedForAttendanceExchange.push({
                        id: currentCarnet.orderId,
                        name: currentCarnet.offeredServiceName,
                        currentAttendances: currentCarnet.currentAttendances,
                        numMaxAccessForOrder: currentCarnet.numMaxAccessForOrder,
                    });
                }
            });
        };


        /**
         * Va alla pagina in cui scambio le presenze tra due Order
         *
         * @param {number} orderIdLeft
         * @param {number} orderIdRight
         */
        vm.gotoMoveAttendances = function(orderIdLeft, orderIdRight) {
            $state.go('app.pages_attendances_carnet_exchange', {
                organizationId: vm.organizationId,
                orderIdLeft: orderIdLeft,
                orderIdRight: orderIdRight,
            });
        };
    }
})();

(function (){
    'use strict';

    angular
        .module('app.pages.users')
        .controller('ProfileSettingsController', ProfileSettingsController);

    function ProfileSettingsController($log, $state, $scope, $location, $rootScope, _, $translate, DictionaryService, $mdToast, $mdDialog, LoopBackAuth, breadcrumbManager, OfferedService, Organization, CylUtils, User, ServiceDoctype,Notification, UserIdentity, Payment, SubscriptionDocument, Subscription, AlertMessageService,  UserDocument, AuthenticationService, DTOptionsBuilder, ApiPath)
    {
        var userId;
        var preUpdateProfile;

        var vm = this;

        // Data
        vm.userProfile = null;
        vm.userIdentity = null;
        vm.editableProfile = false;
        vm.userDocuments = [];
        vm.userServices = [];
        vm.organizations = [];
        vm.userDetailVisibility = null;

        vm.apiPath = ApiPath;
        vm.isUserDetail= ($location.path().startsWith('/user'));
        vm.gotoDocuments=gotoDocuments;
        vm.gotoRelatives=gotoRelatives;
        vm.gotoServices=gotoServices;
        vm.gotoPayments=gotoPayments;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.gotoNewUserSubscription=gotoNewUserSubscription;
        vm.gotoProfileAttendances = gotoProfileAttendances;

        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType','simple')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   : ApiPath + "/userDocumentsContainers/" + $rootScope.CYL_USER_DOC_PREFIX + User.getCurrentId() + "/upload",
            chunkSize                : 15 * 1024 * 1024,
            maxChunkRetries          : 1,
            simultaneousUploads      : 1,
            testChunks               : false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            query: {cyl_type:vm.attachmentType}
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {},
            flowLogo: {},
            flowBackground: {}
        };

        // Methods
        vm.editProfile = editProfile;
        vm.cancelEdit = cancelEdit;
        vm.saveProfile = saveProfile;

        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.goToOrganization=goToOrganization;
        vm.goToOrganizations=goToOrganizations;
        vm.gotoOfferedService=gotoOfferedService;
        vm.gotoSubscriptions = gotoSubscriptions;
        vm.goToRelativeDetail = goToRelativeDetail;

        vm.formatDate=formatDate;
        vm.goBack=goBack;
        vm.sendMessage=sendMessage;
        vm.removeAvatar=removeAvatar;
        vm.removeBackground=removeBackground;
        vm.openMenuImageDeletion=openMenuImageDeletion;
        vm.backgroundImage=backgroundImage;
        vm.deleteOrganization=deleteOrganization;
        vm.goToChangePwd=goToChangePwd;

        vm.subscriptionsStats={};
        vm.isParentManagementEnabled = false;


        vm.dragEnter = function(){
            //$log.debug("Drag Enter");
            $('#document-image-uploader').addClass('drag-enter');
        }

        vm.dragLeave = function(){
            //$log.debug("Drag Leave");
            $('#document-image-uploader').removeClass('drag-enter');
        }

        vm.editUserServiceDocuments=editUserServiceDocuments;

        vm.goToOrganizationDetail = goToOrganizationDetail;
        vm.goToNewOrganization = goToNewOrganization;
        vm.apiPath=ApiPath;

        init();

        //////////

        function init(){
            // se userId non è passato allora
            vm.currentUserId = User.getCurrentId().toString();
            userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
            vm.userId=userId.toString();
            vm.isChild = false;

            if (AuthenticationService.isAuthenticated()){

                //CONTROLLI PRELIMINARI
                // - se accedo come socio vedo solo me o i miei figli (vm.isUserDetail===false)
                // - se accedo come amministratore vedo i miei soci / contatti oppure le loro persone di riferimento

                vm.subscriptionsStats.payed=0;
                vm.subscriptionsStats.unpayed=0;
                vm.subscriptionsStats.docsMissing = 0;
                vm.subscriptionsStats.docsExpired = 0;
                vm.subscriptionsStats.docsExpiring = 0;
                vm.subscriptionsStats.docsValidated = 0;
                vm.subscriptionsStats.docsToValidate = 0;
                vm.subscriptionsStats.docsRejected = 0;
                vm.subscriptionsStats.loaded=false;

                User.isParentManagementEnabled({userId: vm.userId}).$promise.then(function(data) {
                    vm.isParentManagementEnabled=data.result;
                });


                loadUser(userId ).then(function(user){
                    loadOrganizations(user).then(
                        function(data){
                            vm.organizations = data.result.organizations;
                        });
                });

                //-----------------------------------------------
                // carico il profilo dell'utente corrente
                loadUserProfile(vm.currentUserId).then(
                    function(data) {
                        //controllo se l'utente selezionato è figlio di quello corrente
                        var curUser = (JSON.parse(JSON.stringify(data)));
                        var childFound = _.find(curUser.children, function(child) { return child.id == userId; });
                        vm.isChild = childFound ? true : false;
                    }
                );


                //-----------------------------------------------
                // carico il profilo dell'utente selezionato
                loadUserProfile(userId).then(
                    function(data){
                        $log.debug(data);
                        var myUser = data;
                        vm.userProfile = (JSON.parse(JSON.stringify(myUser)));

                        try {
                            vm.userDetailVisibility = JSON.parse(vm.userProfile.userDetailVisibility);
                        } catch(err) {
                            vm.userDetailVisibility =  {};
                        }

                        //filtro i doppioni sulle organizzazioni
                        vm.userProfile.organizations = _.uniq(vm.userProfile.organizations, function(o) {return o.id;});


                        vm.userIdentity = data.identities[0];
                        if (vm.userProfile.birthDate && vm.userProfile.birthDate!==null && typeof(vm.userProfile.birthDate == 'string')){
                            vm.userProfile.birthDate = new Date(vm.userProfile.birthDate);
                        }

                        DictionaryService.loadDictionary(function() {
                            for (var i = 0; i < vm.userProfile.parents.length; i++) {
                                var theRelation = _.find(vm.userProfile.parentRelations, function (r) { return r.parentId === vm.userProfile.parents[i].id;});
                                if (theRelation && theRelation.relationType) {
                                    vm.userProfile.parents[i].relationType= DictionaryService.translateMessage('PARENT_RELATION', theRelation.relationType, '');
                                }
                            }
                        });



                        loadUserServices(myUser);

                    },
                    function(error){
                        $log.debug(error);
                    });

                if (!vm.isUserDetail) {
                    sessionStorage.setItem('CURRENT_ORGANIZATION',null);
                    sessionStorage.setItem('CURRENT_SERVICE',null);
                }

                $rootScope.$on('PAYMENTS_TO_BE_RELOADED', function (event, valore) {
                    loadUserServices(vm.userProfile);
                });

            } else {
                $state.go('app.pages_auth_login');
            }



        }


        function goToOrganizationDetail(organizationId)
        {
            sessionStorage.setItem('CURRENT_ORGANIZATION',organizationId);
            sessionStorage.setItem('currentOrganizationTab',0);

            $state.go('app.organization', {organizationId: organizationId});
        }


        function goToNewOrganization()
        {
            $state.go('app.new_organization');
        }

        function loadUser(userId){
            return User.findById({
                id: userId,
            }, {filter: {include: ['parents', 'parentRelations'] }}).$promise;
        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        function goToOrganization() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                $state.go('app.organization', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
            }
        }

        function gotoOfferedService() {
            if (sessionStorage.getItem('CURRENT_ORGANIZATION') && sessionStorage.getItem('CURRENT_SERVICE')) {
                $state.go('app.offered_service', {
                    offeredServiceId: sessionStorage.getItem('CURRENT_SERVICE'),
                    organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')
                });
            }
        }

        function goToOrganizations() {
            $state.go('app.organizations', {userId: User.getCurrentId()});
        }


        function gotoSubscriptions() {
            var item = breadcrumbManager.currentOrganization();
            $state.go('app.pages_subscriptions_pre', {
                organizationId: item.id,
                offeredServiceId: '',
                paymentsFilter: 'A',
                documentsFilter: '',
                userId: userId
            });
        }


        function goToRelativeDetail(userId) {
            if (vm.isUserDetail) {
                $state.go('app.pages_profile', {userId: userId});
            } else {
                $state.go('app.pages_profile_socio', {userId: userId});
            }
        }


        function gotoDocuments() {
            $state.go('app.pages_profile_docs', {userId: userId});
        }

        function gotoRelatives() {
            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
            if (vm.isUserDetail) {
                $state.go('app.pages_user_relatives', {userId: userId});
            } else {
                $state.go('app.pages_profile_relatives', {userId: userId});
            }
        }

        function gotoServices() {
            $state.go('app.pages_profile_services', {userId: userId});
        }

        function gotoPayments() {
            $state.go('app.pages_profile_payments', {userId: userId});
        }

        function gotoNewUserSubscription(userId) {
            var organization = breadcrumbManager.currentOrganization();
            $state.go('app.new_user_subcription', {
                userId : vm.userProfile.id,
                organizationId: organization.id
            });
        }

        function gotoProfileAttendances() {
            $state.go('app.profile_attendances', {userId: userId});
        }

        function loadUserProfile(userId){
            var organizationId = '';
            var item = breadcrumbManager.currentOrganization();
            if (vm.isUserDetail && item) {
                organizationId = item.id;
            }
            return User.loadUser({
                id: userId,
                filter: {
                    include: ['identities', 'children', 'parents', 'parentRelations', 'organizations']
                },
                organizationId: organizationId
            }).$promise;
        }



        function editProfile(){
            if (vm.isUserDetail) {
                $state.go('app.pages_user_detail', {userId: vm.userProfile.id});
            } else {
                $state.go('app.pages_profile_detail', {userId: vm.userProfile.id});
            }
        }

        function cancelEdit(){
            vm.editableProfile = false;
            vm.userProfile = angular.copy(preUpdateProfile);
        }

        function saveProfile(){
            //$log.debug(vm.userData);
            vm.editableProfile = false;

            //vm.userProfile.displayName =  vm.userProfile.name.familyName + " " + vm.userProfile.name.givenName;
            vm.userProfile.userDetailVisibility = JSON.stringify(vm.userDetailVisibility);

            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {userDetailVisibility: vm.userProfile.userDetailVisibility, isSearchable: vm.userProfile.isSearchable}).$promise.then(
                function(data){
                User.loadUser({
                    id: vm.userProfile.id,
                    filter: {}
                }, function(user) {
                    user.userDetailVisibility = vm.userProfile.userDetailVisibility;
                    user.isSearchable = vm.userProfile.isSearchable;
                    User.saveUser({
                        user: user,
                        organizationId: ''
                    }).$promise.then(
                        function(data){
                            $log.debug(data);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant('USERS.PROFILE_SAVED'))
                                    .position("top right")
                                    .hideDelay(2000)
                            );
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );
                }, function(error){
                    $log.debug(error);
                });
            });


            // User.prototype$patchAttributes(
            //     { id: vm.userProfile.id },
            //     {userDetailVisibility: vm.userProfile.userDetailVisibility, isSearchable: vm.userProfile.isSearchable}).$promise.then(
            //     function(data){
            //         $log.debug(data);
            //         $mdToast.show(
            //             $mdToast.simple()
            //                 .textContent($translate.instant('USERS.PROFILE_SAVED'))
            //                 .position("top right")
            //                 .hideDelay(2000)
            //         );
            //     }
            // );
        }

        function fileAdded(file){

            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            vm.contentToUpload = uploadingFile;
            upload();
        }

        function upload(typeFile){
            vm.contentToUpload.type = 'uploading';
            vm.ngFlow.flow.opts={};
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                //'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
                //'Authorization' : 'Bearer {' + AuthenticationService.getToken() + '}'
            };

            if (typeFile==='LOGO') {
                vm.ngFlowOptions.query.cyl_type='LOGO';
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowLogo.upload();
            }
            else if (typeFile==='BACKGROUND') {
                vm.ngFlowOptions.query.cyl_type='BACKGROUND';
                vm.ngFlowOptions.query.authorization=LoopBackAuth.accessTokenId;
                vm.ngFlow.flowBackground.upload();
            }

        }

        function fileSuccess(file, message, typeFile){
            $log.debug('fileSuccess');

            //PER FS recupero file FIXME
            var uri = JSON.parse(message).result.files.file[0].name;

            if (typeFile==='LOGO') {
                loadUser(userId ).then(function(user){
                    vm.userProfile=user;
                    $rootScope.uriAvatar=uri;
                });
            }
            else if (typeFile==='BACKGROUND') {
                loadUser(userId ).then(function(user){
                    vm.userProfile=user;
                    $rootScope.uriBackground=uri;
                });
            }
        }

        function fileError(file, message, typeFile){
            $log.error('fileError:');
            $log.error(message);
            AlertMessageService.showErrorAlert('La funzionalità di upload è al momento non disponibile. Si prega di ' +
                'riprovare più tardi e se il problema persiste informare l\'assistenza.');
        }


        function backgroundImage() {
            if (vm.userProfile && vm.userProfile!==null && vm.userProfile.uriBackground && vm.userProfile.uriBackground !==null) {
                return {'background-image': 'url('+ApiPath+'/userDocumentsContainers/'+$rootScope.CYL_USER_DOC_PREFIX+vm.userProfile.id +'/download/'+vm.userProfile.uriBackground+')'};
            }
            return '';

        }

        function openMenuImageDeletion($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };


        function removeBackground() {
            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {uriBackground: null}).$promise.then(
                function(data){
                    $log.debug(data);
                    vm.userProfile.uriBackground = null;
                }
            );
        }

        function removeAvatar() {
            User.prototype$patchAttributes(
                { id: vm.userProfile.id },
                {uriAvatar: null}).$promise.then(
                function(data){
                    $log.debug(data);
                    vm.userProfile.uriAvatar = null;
                    $rootScope.uriAvatar=null;

                }
            );
        }



        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function editUserServiceDocuments(ev, service) {
            $scope.doctypes={};
            $scope.myResource={};
            $scope.myResource.serviceDocuments={};
            //carica documenti necessari per il servizio
            var query ={
                filter: {
                    where : {offeredServiceId: service.id},
                    include : ['organizationDoctype' ]
                }
            };
            ServiceDoctype.find(query, function(docs) {
                $scope.doctypes=docs;
                //carico eventuale documentazione già salvata
                var querySubDocs ={
                    filter: {
                        where : {subscriptionId: service.subscriptionId},
                        include : ['userDocument','organizationDoctype' ]
                    }
                };
                SubscriptionDocument.find(querySubDocs, function(subDocs) {
                    if (subDocs && subDocs!==null) {
                        for (var i = 0; i < subDocs.length; i++) {
                            $scope.myResource.serviceDocuments[subDocs[i].organizationDoctype.id]= subDocs[i].userDocument;
                        }
                    }

                    $mdDialog.show({
                        controller: DialogController,
                        templateUrl: 'app/main/pages/users/user_profile/tabs/services/edit_docs_dialog.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose:true
                    })
                        .then(function(answer) {

                            $log.debug(answer.serviceDocuments);

                            var subscriptionDocuments = [];
                            if (answer.serviceDocuments && answer.serviceDocuments!==null) {
                                var keys = Object.keys(answer.serviceDocuments);
                                for (var i = 0; i<keys.length; i++) {
                                    if (answer.serviceDocuments[keys[i]]) {
                                        //traduco l'orario in risorsa
                                        var subscriptionDocument = {};
                                        subscriptionDocument.subscriptionId=service.subscriptionId;
                                        subscriptionDocument.organizationDoctypeId=keys[i];
                                        subscriptionDocument.userDocumentId=answer.serviceDocuments[keys[i]].id;
                                        subscriptionDocument.uri=answer.serviceDocuments[keys[i]].uri;
                                        subscriptionDocuments.push(subscriptionDocument);
                                    }
                                }
                            }

                            Subscription.findById({
                                id: service.subscriptionId
                            }).$promise.then(function(mySub) {
                                mySub.$prototype$updateSubscriptionDocuments({subscriptionDocuments: subscriptionDocuments})
                                    .then(function(data){
                                        $log.debug('success');
                                        $log.debug(data);
                                        loadUserServices(vm.userProfile);
                                        AlertMessageService.showSuccessMessage();

                                    },function(httpResponse){
                                        $log.debug('error');
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                            });
                        }, function() {
                            $log.debug('You cancelled the dialog.');
                        });

                });
            });

        }


        function goBack() {
            window.history.back();
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function loadUserServices(myUser) {
            $log.debug('ProfileSettingsController.loadUserServices()');
            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {
                        if ( response.result.services &&  response.result.services!==null) {
                            for (var i = 0; i <  response.result.services.length; i++) {
                                var dateFrom =  response.result.services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    response.result.services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  response.result.services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    response.result.services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }
                        vm.userServices = response.result.services;
                        $log.debug('vm.userServices: ' + JSON.stringify(vm.userServices, undefined, 2));
                    });
            });

            User.findById({
                id: myUser.id
            }).$promise.then(function(user){
                user.$prototype$allMySubscriptionsStats().then(function(response) {
                    vm.subscriptionsStats=response.result;
                    vm.subscriptionsStats.loaded=true;

                });
            });
        }


        function sendMessage(ev) {
            $scope.myResource={};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    //creo la notifica sia tra le NOTIFICHE SIA IN CHAT
                    User.notifyUser({userId: vm.userId, subject: answer.title, text:answer.text }).$promise.then(
                        function(n,responseHeaders){
                            $log.debug('Notifica inviata');
                            AlertMessageService.showSuccessMessage();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        }
                    );

                    Notification.create(
                        {senderId: vm.currentUserId,
                            recipientId: vm.userId,
                            title: answer.title,
                            text: answer.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        },
                        function(n,responseHeaders){
                            $log.debug('Scrittura in chat inviata');
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

        }

        function deleteOrganization(organizationId){
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    //controllo se la associazione ha servizi associati
                    OfferedService.count({
                        where : {dtDel: null, organizationId: organizationId}
                    }, function(totalNumber) {
                        if (totalNumber.count && totalNumber.count>0)  {
                            //ERRORE: ci sono servizi associati
                            AlertMessageService.showErrorAlert("ORGANIZATIONS.ERRORS.CANT_DELETE_HAS_SERVICES");
                        }
                        else {
                            $log.debug('ProfileSettingsController.deleteOrganization()');
                            Organization.findById({
                                id : organizationId
                            }).$promise.then(function(org) {
                                org.dtDel=new Date();
                                Organization.upsert(org,
                                    function(org,responseHeaders){
                                        loadUser(vm.userId ).then(function(user){
                                            loadOrganizations(user).then(
                                                function(data){
                                                    vm.organizations = data.result.organizations;
                                                });
                                        });
                                    },
                                    function(httpResponse){
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    });
                            });
                        }
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        function goToChangePwd() {
            $state.go('app.pages_auth_change_pwd');
        }



        vm.gotoLoginDestination = function() {
            $state.go('app.pages_user_logindestination');
        };


        vm.goToGdprSettings = function() {
            $state.go('app.legal_gdpr_settings');
        };




    }

})();

'use strict';

(function() {
    angular
        .module('app.pages.users')
        .controller('PendingPaymentsController', PendingPaymentsController);

    /** @ngInject */
    function PendingPaymentsController($log, $state, $scope, $translate, $mdDialog, DateFormatter, DTOptionsBuilder,
                                       AlertMessageService, ApiPath,
                                       User, Subscription, PaymentReason, Payment, OfferedService, Organization) {
        var vm = this;
        vm.userId = null;
        vm.user = null;
        vm.organizationId = null;
        vm.organization = null;
        vm.servicesToPay = [];
        vm.offeredService = null;
        vm.subscriptionServices = [];
        vm.subscriptionServicesIds = [];
        vm.organizationSubscriptionStatusType = {
            QUOTA_ASSOCIATIVA_NON_NECESSARIA: 0,
            QUOTA_ASSOCIATIVA_NON_ISCRITTO: 10,
            QUOTA_ASSOCIATIVA_NON_PAGATA: 20,
            QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI: 30,
            QUOTA_ASSOCIATIVA_OK: 100,
        };
        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA;
        vm.serviziQuotaAssociativaUtente = [];// TODO popolare
        vm.serviziQuotaAssociativaAttivabili = [];
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            .withOption('responsive', true)
            .withOption('autoWidth', true)
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        /**
         * Inizializza il controller
         */
        vm.init = function() {
            $log.debug('PendingPaymentsController.init()');
            // lettura parametri URL
            if ($state && $state.params && $state.params.userId) {
                vm.userId = $state.params.userId;
                $log.debug(vm.userId);
            }
            if ($state && $state.params && $state.params.organizationId) {
                vm.organizationId = $state.params.organizationId;
                $log.debug(vm.organizationId);
            }
            if (vm.userId && vm.organizationId) {
                vm.loadServicesToPay();
                loadAllSubscriptionsService(vm.organizationId);
                loadOrganization(vm.organizationId);
            } else {
                // TODO messaggio di errore, utente o organizzzaione mancanti
            }
        };



        // setTimeout(function() {
        //     $log.debug(vm.user);
        // }, 5000);



        /**
         * Calcola i servizi dell'utente ancora da pagare
         */
        vm.loadServicesToPay = function() {
            $log.debug('vm.loadServicesToPay()');
            User.loadUser({
                id: vm.userId,
                organizationId: vm.organizationId
            }).$promise.then(function(user) {
                vm.user = JSON.parse(JSON.stringify(user));
                user.$prototype$allServices().then(
                    function(response) {
                        //console.log(vm.user);
                        if (response.result.services && response.result.services !== null) {
                            var theServices = response.result.services;
                            for (var i = 0; i < theServices.length; i++) {
                                var dateFrom = theServices[i].dateFrom;
                                if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                    theServices[i].dateFrom = new Date(dateFrom);
                                }
                                var dateTo = theServices[i].dateTo;
                                if (dateTo && dateTo !== null && dateTo !== '') {
                                    theServices[i].dateTo = new Date(dateTo);
                                }
                            }
                            // filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                            theServices = _.filter(theServices, function(service) {
                                return (vm.organizationId == service.organizationId && service.paymentValue < service.paymentDue);
                            });
                            //PRENDO GLI ORDER DETAILS RELATIVI
                            if (theServices.length > 0) {
                                var subscritpionIds = _.map(theServices, function(s) {
                                    return s.subscriptionId;
                                });
                                Subscription.find({
                                    filter: {
                                        where: {id: {inq: subscritpionIds}},
                                        include: ['user', 'payments', {orders: {orderDetails: ['offeredService', {subscriptionDiscount: 'discount'}]}}]
                                    }
                                }).$promise.then(
                                    function(data, headers) {
                                        _.each(data, function(subscription) {
                                            var curService = _.find(theServices, function(s) {
                                                return s.subscriptionId == subscription.id;
                                            });
                                            curService.details = [];
                                            var payments = subscription.payments;
                                            // ordino gli Order prima di mostrarli
                                            subscription.orders = _.sortBy(subscription.orders, function(order) {
                                                //return moment(order.created).toISOString();
                                                return moment(order.dtBillingPeriodStart).toISOString();
                                            });
                                            _.each(subscription.orders, function(order) {
                                                // ordino gli OrderDetail
                                                order.orderDetails = _.sortBy(order.orderDetails, function(orderDetail) {
                                                    return moment(orderDetail.created).toISOString();
                                                });
                                                _.each(order.orderDetails, function(orderDetail) {
                                                    var obj = orderDetail;
                                                    obj.dtBillingPeriodStart = order.dtBillingPeriodStart;
                                                    obj.dtBillingPeriodEnd = order.dtBillingPeriodEnd;
                                                    if (obj.subscriptionDiscountId) {
                                                        var discounts = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'DISCOUNT';
                                                        });
                                                        var amount = _.reduce(discounts, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    } else {
                                                        var paymentsUnpayed = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'UNPAYED';
                                                        });
                                                        var amount = _.reduce(paymentsUnpayed, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    }

                                                    if (obj.paymentStatus !== 'PAYED') {
                                                        curService.details.push(obj);
                                                    }
                                                });
                                            });
                                            curService.details = _.sortBy(curService.details, function(d) {
                                                return d.dtBillingPeriodStart;
                                            });
                                        });
                                        _.each(theServices, function(service) {
                                            var paymentDueAtToday = 0;
                                            _.each(service.details, function(detail) {
                                                if (moment().isAfter(detail.dtBillingPeriodStart)) {
                                                    paymentDueAtToday += detail.amount;
                                                }
                                            });
                                            if (paymentDueAtToday === 0 && service.details.length > 0) {
                                                //prendo order id del primo ordine
                                                var firstOrderId = service.details[0].orderId;
                                                //prendo tutti i dettagli di quell'ordine
                                                _.each(service.details, function(detail) {
                                                    if (detail.orderId === firstOrderId) {
                                                        paymentDueAtToday += detail.amount;
                                                    }
                                                });
                                            }
                                            service.paymentDue = paymentDueAtToday;
                                        });
                                        vm.servicesToPay = theServices;
                                        // aggiunge totale piano pagamento
                                        _.each(vm.servicesToPay, function(service) {
                                            service.paymentPlanRemaining = 0;
                                            _.each(service.details, function(detail) {
                                                service.paymentPlanRemaining += detail.amount;
                                            });
                                        });
                                        $log.debug(vm.servicesToPay);
                                    },
                                    function(error) {
                                        $log.error(error);
                                    });
                            }
                        } else {
                            vm.servicesToPay = [];
                        }
                    }, function(error) {
                        $log.debug(error);
                    });
            }, function(error) {
                $log.debug(error);
            });
        };



        /**
         * Effettua un pagamento di iscrizione
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        vm.askPaymentDetails = function(userId, subscriptionId, amount) {
            $scope.myResource = {};
            $scope.myResource.paymentDate = new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = amount;
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query = {
                filter: {
                    where: {organizationId: null, paymentType: 'IN', internalCode: 'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query, function(paymentReasons) {
                $scope.paymentReasons = paymentReasons;
                $scope.myResource.paymentReasons = paymentReasons[0];
            });
            loadUserServices(userId);
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            }).then(function(answer) {
                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason !== null) ? answer.paymentReason.id.toString() : null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        // ricaria i dati
                        vm.init();
                    }, function(httpResponse) {
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                });
        };


        /**
         *
         */
        function loadUserServices() {
                if (vm.user && vm.user.id) {
                    User.findById({
                        id: vm.user.id
                    }).$promise.then(function(user) {
                        user.$prototype$allServices().then(
                            function(response) {
                                if (response.result.services && response.result.services !== null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i < theServices.length; i++) {
                                        var dateFrom = theServices[i].dateFrom;
                                        if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                            theServices[i].dateFrom = new Date(dateFrom);
                                        }
                                        var dateTo = theServices[i].dateTo;
                                        if (dateTo && dateTo !== null && dateTo !== '') {
                                            theServices[i].dateTo = new Date(dateTo);
                                        }
                                    }
                                    //FILTRO PER QUELLI DELLA ORGANIZZAZIONE DI TIPO ISCRIZIONE
                                    theServices = _.filter(theServices, function(s) {
                                        if (s.organizationId !== vm.organizationId) {
                                            return false;
                                        }
                                        var found = _.find(vm.subscriptionServicesIds, function(id) {
                                            return id == s.id;
                                        });
                                        return found ? true : false;
                                    });
                                    //scremo eventuali doppioni per parenti o tutelati
                                    theServices = _.filter(theServices, function(s) {
                                        return userId == s.userId;
                                    });
                                    vm.serviziQuotaAssociativaUtente = theServices;
                                } else {
                                    vm.serviziQuotaAssociativaUtente = [];
                                }
                                checkQuoteAssociativeAttivabili();
                            });
                    });
            } else {
                $log.error('vm.user vale null');
            }
        }



        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllSubscriptionsService(organizationId) {
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone: 'S',
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers) {
                    vm.subscriptionServices = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length === 0) {
                            return false;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode === 'SUBSCRIPTION';
                        });
                        if (found) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    vm.subscriptionServicesIds = _.map(vm.subscriptionServices, function(s) {
                        return s.id;
                    });
                },
                function(error) {
                    $log.debug(error);
                });
        }



        function checkQuoteAssociativeAttivabili() {
            //SE IL SERVIZIO CORRENTE RICHIEDE ISCRIZIONE ALLA QUOTA ASSOCIATIVA ALLORA CERCO tra i vm.subscriptionServices
            //SE QUELLI CHE PER DATA SI AGGANCIANO AL SERVIZIO SONO PRESENTI, PAGATI O CON DOC MANCANTI
            if (vm.offeredService && vm.offeredService.needsOrganizationSubscription) {
                //cerco tra i vm.subscriptionServices le iscrizioni plausibili includendo:
                // - quelle la cui data di inizio fine comprende data di inizio del servizio
                // - quelle la cui data di inizio fine comprende la data di oggi
                vm.serviziQuotaAssociativaAttivabili = _.filter(vm.subscriptionServices, function(sqa) {
                    if (sqa.start && sqa.end) {
                        if (vm.offeredService.start && !moment(sqa.start).isAfter(vm.offeredService.start) && !moment(vm.offeredService.start).isAfter(sqa.end)) {
                            return true;
                        } else if (!moment(sqa.start).isAfter(new Date()) && !moment().isAfter(sqa.end)) {
                            return true;
                        }
                    } else if (!sqa.start && !sqa.end) {
                        //quota associativa che non ha nè inizio nè fine: ha senso?
                        return true;
                    }
                    return false;
                });

                //CONTROLLO LO STATO DELLE ISCRIZIONI RISPETTO serviziQuotaAssociativaAttivabili
                var iscrizioneQuotaAssociativa = null;
                for (var i = 0; i < vm.serviziQuotaAssociativaAttivabili.length; i++) {
                    var servizioAttivabile = vm.serviziQuotaAssociativaAttivabili[i];
                    var found = _.find(vm.serviziQuotaAssociativaUtente, function(squ) {
                        return squ.id == servizioAttivabile.id;
                    });
                    if (found) {
                        iscrizioneQuotaAssociativa = found;
                        break;
                    }
                }

                if (!iscrizioneQuotaAssociativa) {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                } else {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                    if (iscrizioneQuotaAssociativa.paymentValue < iscrizioneQuotaAssociativa.paymentDue) {
                        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA;
                    } else {
                        var docOk = true;
                        for (var i = 0; i < iscrizioneQuotaAssociativa.docs.length; i++) {
                            var doc = iscrizioneQuotaAssociativa.docs[i];
                            if (doc.status === 'MISSING' || doc.status === 'EXPIRED' || doc.status === 'REJECTED' || doc.status === 'EXPIRING') {
                                docOk = false;
                                break;
                            }
                        }
                        if (docOk) {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK;
                        } else {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI;
                        }
                    }

                }
            }
        }



        function loadOrganization(id) {
            $log.debug('PendingPaymentsController.loadOrganization()');
            Organization.findById({
                id: id
            }).$promise.then(
                function(organization) {
                    vm.organization = organization;
                }
            );
        }




        /**
         * Formatta una data
         *
         * @param dt
         */
        vm.formatDate = function(dt) {
            return DateFormatter.formatDate(dt);
        };



        /**
         * Controller per la dialog di pagamento
         *
         * @param $scope
         * @param $mdDialog
         * @constructor
         */
        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.users')
        .controller('UsersNewController', UsersNewController);

    /** @ngInject */
    function UsersNewController($log, $state, $scope, $rootScope, $mdDialog, UserRelation, User, Organization,
                                OfferedService, AuthenticationService, $q, ApiPath, RoleType, UserOrganizationRole,
                                AlertMessageService, $translate) {
        var organizationId, offeredServiceId;
        var vm = this;

        // Data
        vm.user = {};
        vm.saveButtonEnabled = true;    // prvent double click on submit button

        // Methods
        vm.saveUser = saveUser;
        vm.selectedUserChange = selectedUserChange;
        vm.lookupUser = lookupUser;
        vm.apiPath = ApiPath;
        vm.isRelativeCreation = ($state.params.parentId && $state.params.parentId !== null);
        vm.parentUserId = $state.params.parentId;
        vm.templateUrl = '';
        vm.currentUserId = '';
        vm.subscriptionId = null;
        vm.organization = null;
        vm.selectedRoleTypes = [];

        init();

        //////////

        function init() {

            if (AuthenticationService.isAuthenticated()) {

                vm.currentUserId = User.getCurrentId().toString();
                offeredServiceId = $state.params.offeredServiceId;
                $log.debug('NewUserController.init()');
                Organization.findById({
                    id: $state.params.organizationId,
                    filter: {
                        include: ['roleTypes'],
                    }
                }).$promise.then(function(organization) {
                    vm.organization = organization;
                    vm.organizationUserTemplateId = organization.organizationUserTemplateId;
                    vm.templateUrl = vm.apiPath + '/dynamicDocumentConnectors/template/' + vm.organizationUserTemplateId;
                });

            } else {
                $state.go('app.pages_auth_login');
            }

        }

        /**
         * eFFETTUA LA EFFETTIVA CREAZIONE DELL'UTENTE figlio A PARTIRE DAl PADRE/GENITORE
         * @param parent
         */
        var doRealChildCreation = function(theParentUser, callback) {

            User.findById({id: theParentUser.id}).$promise.then(function(parent) {
                //se è stata messa al figlo la mail del padre allora sbianco quella del figlio
                // e salvo (tanto saranno propagate automaticamente le info)
                var aParent = parent;

                if (vm.user.email && vm.user.email.trim().toLowerCase() === aParent.email.trim().toLowerCase()) {
                    vm.user.email = null;
                }

                //altrimenti cerco che non vi sia già l'utente in cyl
                if (vm.user.email) {
                    findUserByMail(vm.user.email, function(users) {
                        if (!users || users === null || users.length === 0) {
                            var organizationId = null;
                            if ($state.params.organizationId) {
                                organizationId = $state.params.organizationId;
                            }
                            aParent.$prototype$addChild({
                                user: vm.user,
                                organizationId: organizationId
                            }).then(function(data) {
                                $log.debug('Child created');
                                if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                                    checkAndSaveDynamicAttributes(data.child.id);
                                }
                                if (callback) {
                                    callback(data.child);
                                } else {
                                    window.history.back();
                                }
                            }, function(error) {
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                        else {
                            // AlertMessageService.showErrorAlert("LP_ERRORS.EMAIL_ALREADY_IN_USE");
                            // Controllo se ho una relazione con l'utente
                            var theUser = users[0];
                            //SE NO La CREO E RITORNO A PAGINA FIGLI
                            UserRelation.find({
                                filter: {
                                    where: {
                                        childId: theUser.id,
                                        parentId: aParent.id
                                    }
                                }
                            }).$promise.then(function(relations) {
                                if (relations && relations.length > 0) {
                                    AlertMessageService.showSuccessMessage();
                                    if (callback) {
                                        callback(theUser);
                                    } else {
                                        window.history.back();
                                    }
                                } else {
                                    var organizationId = null;
                                    if ($state.params.organizationId) {
                                        organizationId = $state.params.organizationId;
                                    }
                                    UserRelation.create({
                                        childId: theUser.id,
                                        parentId: aParent.id,
                                        createOrganizationId: organizationId
                                    }).$promise.then(function(data) {
                                        AlertMessageService.showSuccessMessage();
                                        if (callback) {
                                            callback(theUser);
                                        } else {
                                            window.history.back();
                                        }
                                    }, function(error) {
                                        AlertMessageService.showErrorAlert(error);
                                    });
                                }

                            }, function(error) {
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                    });
                } else {
                    var organizationId = null;
                    if ($state.params.organizationId) {
                        organizationId = $state.params.organizationId;
                    }
                    aParent.$prototype$addChild({user: vm.user, organizationId: organizationId}).then(function(data) {
                        $log.debug('Child created');
                        if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                            checkAndSaveDynamicAttributes(data.child.id);
                        }
                        if (callback) {
                            callback(data.child);
                        } else {
                            window.history.back();
                        }
                    }, function(error) {
                        AlertMessageService.showErrorAlert(error);
                    });
                }

            });


        };

        var completeChildCreationAsAdmin = function(theParent) {
            doRealChildCreation(theParent, function(childUser) {
                vm.user.id = childUser.id;
                vm.user.contactEmail = theParent.email;
                User.saveUser({
                    user: vm.user,
                    organizationId: $state.params.organizationId.toString(),
                }).$promise.then(
                    function(data) {
                        $log.debug(data);
                        UserOrganizationRole.addAsContact({
                            userId: childUser.id.toString(),
                            organizationId: $state.params.organizationId.toString(),
                            sendNotification: false
                        }).$promise.then(
                            function(data) {
                                window.history.back();
                            },
                            function(httpResponse) {
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            }
                        );
                    },
                    function(httpResponse) {
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    }
                );


            });
        };


        /**
         * Salva l'utente
         */
        function saveUser() {
            $log.debug('saveUser()');
            vm.saveButtonEnabled = false;

            if (!vm.selectedRoleTypes || vm.selectedRoleTypes.length === 0) {
                AlertMessageService.showErrorAlert("E' obbligatorio specificare almeno un ruolo per la persona all'interno del club");
                return;
            }

            var nome = vm.user.givenName.toLowerCase();
            var cognome = vm.user.familyName.toLowerCase();
            vm.user.displayName = nome.charAt(0).toUpperCase() + nome.slice(1) + " " + cognome.charAt(0).toUpperCase() + cognome.slice(1);
            vm.user.created = new Date();
            vm.user.lastUpdated = new Date();
            vm.user.password = AuthenticationService.createFakePassword();
            $scope.myResource = {sendInvitation: false, invitationNote: ''};
            var modalToOpen = 'ask_contact_notification';
            if (!vm.user.email) {
                modalToOpen = 'warning_no_mail';
            }
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/' + modalToOpen + '.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
                .then(function(answer) {
                    if (vm.user.id && vm.user.id !== null) {
                        //UTENTE SCELTO DA LOOKUP
                        loadUserDetail(vm.user.id).then(function(user) {
                            if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                                checkAndSaveDynamicAttributes(user.id);
                                createUserOrganizationRole(user, $scope.myResource.sendInvitation, $scope.myResource.invitationNote);
                                User.saveUser({
                                    user: vm.user,
                                    organizationId: $state.params.organizationId.toString(),
                                }).$promise.then(function(data) {
                                        vm.saveButtonEnabled = true;
                                        $log.debug(data);
                                    }, function(httpResponse) {
                                    vm.saveButtonEnabled = true;
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                    }
                                );
                            } else {
                                vm.saveButtonEnabled = true;
                            }
                        });
                    }
                    else {
                        if (vm.isRelativeCreation) {
                            //CREAZIONE FIGLIO PARENTE ECC

                            //CASO IN CUI A CREARE IL FIGLIO E' IL GENITORE STESSO
                            if (vm.parentUserId) {
                                loadUserDetail(vm.parentUserId).then(function(parent) {
                                    doRealChildCreation(parent);
                                }, function(error) {
                                    $log.debug('error');
                                    $log.debug(error);
                                });
                            } else if (vm.parentUserEmail) {//CASO IN CUI IL FIGLIO E' CREATO DALLA ASSOCIAZIONE
                                //CERCO IL PADRE VIA MAIL: SE ESISTE LO ASSOCIO SE NO LO CREO CON NOME FITTIZIO
                                findUserByMail(vm.parentUserEmail, function(users) {
                                    if (!users || users === null || users.length === 0) {
                                        //creazione fittizia del genitore
                                        User.createUserAndNotify({
                                            user: {
                                                givenName: 'Genitore di ' + vm.user.givenName,
                                                familyName: vm.user.familyName,
                                                email: vm.parentUserEmail
                                            },
                                            organizationId: vm.organization.id.toString(),
                                            sendNotification: false,
                                            notificationText: ''
                                        }).$promise.then(
                                            function(response) {
                                                var theParent = response.user;
                                                completeChildCreationAsAdmin(theParent);
                                                vm.saveButtonEnabled = true;
                                            },
                                            function(error) {
                                                vm.saveButtonEnabled = true;
                                                AlertMessageService.showErrorAlert(error);
                                            });
                                    }
                                    else {
                                        var theParent = users[0];
                                        completeChildCreationAsAdmin(theParent);
                                        vm.saveButtonEnabled = true;
                                    }
                                });
                            }
                        }
                        else {
                            //UTENTE COMPILATO A MANO
                            findUserByMail(vm.user.email, function(users) {
                                if (!users || users === null || users.length === 0) {
                                    User.createUserAndNotify({
                                        user: vm.user,
                                        organizationId: $state.params.organizationId.toString(),
                                        sendNotification: $scope.myResource.sendInvitation,
                                        notificationText: $scope.myResource.invitationNote
                                    }).$promise.then(
                                        function(response) {
                                            var myUser = response.user;
                                            if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                                                checkAndSaveDynamicAttributes(myUser.id);
                                                createUserOrganizationRole(myUser, $scope.myResource.sendInvitation, $scope.myResource.invitationNote);
                                                vm.saveButtonEnabled = true;
                                            }
                                        },
                                        function(error) {
                                            vm.saveButtonEnabled = true;
                                            AlertMessageService.showErrorAlert(error);
                                        });
                                }
                                else {
                                    createUserOrganizationRole(users[0], $scope.myResource.sendInvitation, $scope.myResource.invitationNote);
                                    vm.saveButtonEnabled = true;
                                }

                            });
                        }
                    }
                }, function() {
                    vm.saveButtonEnabled = true;
                    $log.debug('You cancelled the dialog.');
                });
        }


        function createUserOrganizationRole(user, sendInvitation, invitationNote) {
            // $log.debug('createUserOrganizationRole()');
            // var funzParallele = [];
            // _.each(vm.selectedRoleTypes, function(roleType) {
            //     var myRoleType = _.clone(roleType);
            //     var myFunc = function() {
            //             var deferred = $q.defer();
            //             var roleTypeInternalCode = myRoleType.internalCode;
            //             UserOrganizationRole.addAs({
            //                 userId: user.id.toString(),
            //                 organizationId: $state.params.organizationId.toString(),
            //                 roleTypeInternalCode: roleTypeInternalCode,
            //                 sendNotification: sendInvitation,
            //                 notificationText: invitationNote,
            //             }).$promise.then(
            //                 function(data) {
            //                     $log.debug('UserOrganizationRole.addAs riuscita: ' + JSON.stringify(data));
            //                     deferred.resolve(data);
            //                 },
            //                 function(httpResponse) {
            //                     $log.debug('UserOrganizationRole.addAs fallita: ' + JSON.stringify(httpResponse));
            //                     deferred.reject(httpResponse);
            //                 }
            //             );
            //             return deferred.promise;
            //         };
            //     funzParallele.push(myFunc);
            // });
            // $log.debug('funzParallele: ' + JSON.stringify(funzParallele));
            // $q.all(funzParallele)
            //     .then(function(results) {
            //         // se tutto ok, torna indietro
            //         $log.debug(results);
            //         window.history.back();
            //     }, function(httpResponse) {
            //         $log.debug(httpResponse);
            //         AlertMessageService.showErrorAlert(httpResponse.data
            //             && httpResponse.data.error);
            //     });


            // UserOrganizationRole.addAsContact({
            //     userId: user.id.toString(),
            //     organizationId: $state.params.organizationId.toString(),
            //     sendNotification: sendInvitation,
            //     notificationText: invitationNote
            // }).$promise.then(
            //     function(data) {
            //         window.history.back();
            //     },
            //     function (httpResponse) {
            //         $log.debug(httpResponse);
            //         AlertMessageService.showErrorAlert(httpResponse.data
            //             && httpResponse.data.error);
            //     }
            // );


            var roleTypeInternalCodes = '';
            _.each(vm.selectedRoleTypes, function(roleType) {
                if (roleTypeInternalCodes !== '') {
                    roleTypeInternalCodes += ',';
                }
                roleTypeInternalCodes += roleType.internalCode;
            });
            UserOrganizationRole.addAsRoles({
                userId: user.id.toString(),
                organizationId: $state.params.organizationId.toString(),
                roleTypeInternalCodes: roleTypeInternalCodes,
                sendNotification: sendInvitation,
                notificationText: invitationNote
            }).$promise.then(
                function(data) {
                    window.history.back();
                },
                function (httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data
                        && httpResponse.data.error);
                }
            );
        }

        function selectedUserChange(item) {
            if (item && item !== null) {
                loadUserDetail(item.id).then(function(myUser) {
                    vm.user = myUser;
                    vm.user.birthDate = (myUser.birthDate && myUser.birthDate !== null && myUser.birthDate !== '') ? moment(myUser.birthDate).toDate() : null;
                });
            }
            else {
                vm.user = {};
            }

        };

        function lookupUser(txt) {
            txt = txt + '%';
            var deferred = $q.defer();
            var query = {
                filter: {
                    where: {
                        and: [
                            {
                                or: [
                                    {username: {like: txt}},
                                    {email: {like: txt}},
                                    {givenName: {like: txt}},
                                    {familyName: {like: txt}},
                                ]
                            },
                            {isSearchable: true}
                        ],
                    },
                    include: 'parents'
                }
            };

            //user lookup, non serve caricare dati ulteriori
            User.find(query, function(users, responseHeaders) {
                for (var i = 0; i < users.length; i++) {
                    if (users[i].email && users[i].email !== null && users[i].email.endsWith('invalid')) {
                        users[i].email = null;
                    }

                    users[i].hasParents = users[i].parents && users[i].parents !== null && users[i].parents.length > 0;

                }
                deferred.resolve(users);

            });
            return deferred.promise;

        };

        function loadUserDetail(id) {
            return User.loadUser({
                id: id,
                organizationId: $state.params.organizationId
            }, {
                filter: {
                    include: 'parents'
                }
            }).$promise;
        }

        function findUserByMail(mail, callback) {
            var query = {
                filter: {
                    where: {email: mail}
                }
            }
            User.find(query, function(users) {
                callback(users);
            });
        }

        function checkAndSaveDynamicAttributes(userId) {
            $rootScope.$emit('DYN-DOC-DO-SAVE', {
                action: 'SAVE_DONE',
                extradata: {userId: userId, organizationId: $state.params.organizationId.toString()}
            });
        }

        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        $scope.myOnSuccess = function(succ, action) {
            //Aggiorno
        }


        setTimeout(function() {
            var sOffset = $("#btn-container").offset().top;
            var shareheight = $("#btn-container").height() + 20;
            $("#content").scroll(function() {
                var scrollYpos = $("#content").scrollTop();
                if (scrollYpos > sOffset - shareheight) {
                    $("#btn-container").css({
//                        'top': (scrollYpos+20)+'px',
                        'position': 'fixed'
                    });
                }

            });
        }, 1000);


        /**
         * Ritorna TRUE se un determinato roleType è elencato tra quelli selezionati.

         * @param {object} item
         * @param {array} list
         * @returns {boolean}
         */
        vm.isRoleTypeSelected = function(item, list) {
            var ret = false;
            _.each(list, function(listItem) {
                if (listItem.id === item.id) {
                    ret = true;
                }
            });
            return ret;
        };


        /**
         * Se un elemento esiste in lista, lo toglie; se non è in lista lo aggiunge.

         * @param {object} item
         * @param {array} list
         */
        vm.toggleRoleTypeSelected = function(item, list) {
            var newList = [];
            var found = false;
            _.each(list, function(listItem) {
                //$log.debug('verifico se ' + parseInt(listItem.id) + ' !== ' + parseInt(item.id));
                if (parseInt(listItem.id) !== parseInt(item.id)) {
                    newList.push(listItem);
                } else {
                    // se l'elemento esiste in lista, lo salta così viene tolto
                    found = true;
                }
            });
            // se non aveva trovato l'elemento, lo aggiunge
            if (!found) {
                newList.push(item);
            }
            vm.selectedRoleTypes = newList;
        };


    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.users')
        .controller('UsersNewRelativeController', UsersNewRelativeController);

    /** @ngInject */
    function UsersNewRelativeController($log, $state, $scope, $rootScope, $mdDialog, UserRelation, User, Organization,
                                OfferedService, AuthenticationService, $q, ApiPath, RoleType, UserOrganizationRole,
                                AlertMessageService, $translate) {
        var organizationId, offeredServiceId;
        var vm = this;

        // Data
        vm.user = {};

        // Methods
        vm.saveUser = saveUser;
        vm.selectedUserChange = selectedUserChange;
        vm.lookupUser = lookupUser;
        vm.apiPath = ApiPath;
        vm.isRelativeCreation = ($state.params.parentId && $state.params.parentId !== null);
        vm.parentUserId = $state.params.parentId;
        vm.templateUrl = '';
        vm.currentUserId = '';
        vm.subscriptionId = null;
        vm.organization = null;
        vm.selectedRoleTypes = [];

        init();

        //////////

        function init() {
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                offeredServiceId = $state.params.offeredServiceId;
                $log.debug('NewRelativeController.init()');
                Organization.findById({
                    id: $state.params.organizationId,
                    filter: {
                        include: ['roleTypes'],
                    }
                }).$promise.then(function(organization) {
                    vm.organization = organization;
                    vm.organizationUserTemplateId = organization.organizationUserTemplateId;
                    vm.templateUrl = vm.apiPath + '/dynamicDocumentConnectors/template/' + vm.organizationUserTemplateId;
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        /**
         * eFFETTUA LA EFFETTIVA CREAZIONE DELL'UTENTE figlio A PARTIRE DAl PADRE/GENITORE
         * @param parent
         */
        var doRealChildCreation = function(theParentUser, callback) {
            User.findById({id: theParentUser.id}).$promise.then(function(parent) {
                //se è stata messa al figlo la mail del padre allora sbianco quella del figlio
                // e salvo (tanto saranno propagate automaticamente le info)
                var aParent = parent;

                if (vm.user.email && vm.user.email.trim().toLowerCase() === aParent.email.trim().toLowerCase()) {
                    vm.user.email = null;
                }

                //altrimenti cerco che non vi sia già l'utente in cyl
                if (vm.user.email) {
                    findUserByMail(vm.user.email, function(users) {
                        if (!users || users === null || users.length === 0) {
                            var organizationId = null;
                            if ($state.params.organizationId) {
                                organizationId = $state.params.organizationId;
                            }
                            aParent.$prototype$addChild({
                                user: vm.user,
                                organizationId: organizationId
                            }).then(function(data) {
                                $log.debug('Child created');
                                if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                                    checkAndSaveDynamicAttributes(data.child.id);
                                }
                                if (callback) {
                                    callback(data.child);
                                } else {
                                    window.history.back();
                                }
                            }, function(error) {
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                        else {
                            // AlertMessageService.showErrorAlert("LP_ERRORS.EMAIL_ALREADY_IN_USE");
                            // Controllo se ho una relazione con l'utente
                            var theUser = users[0];
                            //SE NO La CREO E RITORNO A PAGINA FIGLI
                            UserRelation.find({
                                filter: {
                                    where: {
                                        childId: theUser.id,
                                        parentId: aParent.id
                                    }
                                }
                            }).$promise.then(function(relations) {
                                if (relations && relations.length > 0) {
                                    AlertMessageService.showSuccessMessage();
                                    if (callback) {
                                        callback(theUser);
                                    } else {
                                        window.history.back();
                                    }
                                } else {
                                    var organizationId = null;
                                    if ($state.params.organizationId) {
                                        organizationId = $state.params.organizationId;
                                    }
                                    UserRelation.create({
                                        childId: theUser.id,
                                        parentId: aParent.id,
                                        createOrganizationId: organizationId
                                    }).$promise.then(function(data) {
                                        AlertMessageService.showSuccessMessage();
                                        if (callback) {
                                            callback(theUser);
                                        } else {
                                            window.history.back();
                                        }
                                    }, function(error) {
                                        AlertMessageService.showErrorAlert(error);
                                    });
                                }

                            }, function(error) {
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                    });
                } else {
                    var organizationId = null;
                    if ($state.params.organizationId) {
                        organizationId = $state.params.organizationId;
                    }
                    aParent.$prototype$addChild({user: vm.user, organizationId: organizationId}).then(function(data) {
                        $log.debug('Child created');
                        if ($state.params.organizationId) {//solo se sto lavorando per organizzazione (magari sto inserendo un utente
                            checkAndSaveDynamicAttributes(data.child.id);
                        }
                        if (callback) {
                            callback(data.child);
                        } else {
                            window.history.back();
                        }
                    }, function(error) {
                        AlertMessageService.showErrorAlert(error);
                    });
                }

            });


        };


        /**
         * Salva l'utente
         */
        function saveUser() {
            $log.debug('saveUser()');
            var nome = vm.user.givenName.toLowerCase();
            var cognome = vm.user.familyName.toLowerCase();
            vm.user.displayName = nome.charAt(0).toUpperCase() + nome.slice(1) + " " + cognome.charAt(0).toUpperCase() + cognome.slice(1);
            vm.user.created = new Date();
            vm.user.lastUpdated = new Date();
            vm.user.password = AuthenticationService.createFakePassword();
            $scope.myResource = {sendInvitation: false, invitationNote: ''};
            var modalToOpen = 'ask_contact_notification';
            if (!vm.user.email) {
                modalToOpen = 'warning_no_mail';
            }
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/' + modalToOpen + '.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
                .then(
                    function(answer) {
                        loadUserDetail(vm.parentUserId).then(function(parent) {
                            doRealChildCreation(parent);
                        }, function(error) {
                            $log.debug('error');
                            $log.debug(error);
                        });
                    },
                    function() {
                        $log.debug('You cancelled the dialog.');
                    });
        }


        function selectedUserChange(item) {
            if (item && item !== null) {
                loadUserDetail(item.id).then(function(myUser) {
                    vm.user = myUser;
                    vm.user.birthDate = (myUser.birthDate && myUser.birthDate !== null && myUser.birthDate !== '') ? moment(myUser.birthDate).toDate() : null;
                });
            }
            else {
                vm.user = {};
            }
        }


        function lookupUser(txt) {
            txt = txt + '%';
            var deferred = $q.defer();
            var query = {
                filter: {
                    where: {
                        and: [
                            {
                                or: [
                                    {username: {like: txt}},
                                    {email: {like: txt}},
                                    {givenName: {like: txt}},
                                    {familyName: {like: txt}},
                                ]
                            },
                            {isSearchable: true}
                        ],
                    },
                    include: 'parents'
                }
            };

            //user lookup, non serve caricare dati ulteriori
            User.find(query, function(users, responseHeaders) {
                for (var i = 0; i < users.length; i++) {
                    if (users[i].email && users[i].email !== null && users[i].email.endsWith('invalid')) {
                        users[i].email = null;
                    }

                    users[i].hasParents = users[i].parents && users[i].parents !== null && users[i].parents.length > 0;

                }
                deferred.resolve(users);

            });
            return deferred.promise;

        }


        function loadUserDetail(id) {
            return User.loadUser({
                id: id,
                organizationId: $state.params.organizationId
            }, {
                filter: {
                    include: 'parents'
                }
            }).$promise;
        }


        function findUserByMail(mail, callback) {
            var query = {
                filter: {
                    where: {email: mail}
                }
            };
            User.find(query, function(users) {
                callback(users);
            });
        }


        function checkAndSaveDynamicAttributes(userId) {
            $rootScope.$emit('DYN-DOC-DO-SAVE', {
                action: 'SAVE_DONE',
                extradata: {userId: userId, organizationId: $state.params.organizationId.toString()}
            });
        }


        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        $scope.myOnSuccess = function(succ, action) {
            //Aggiorno
        };


        setTimeout(function() {
            var sOffset = $("#btn-container").offset().top;
            var shareheight = $("#btn-container").height() + 20;
            $("#content").scroll(function() {
                var scrollYpos = $("#content").scrollTop();
                if (scrollYpos > sOffset - shareheight) {
                    $("#btn-container").css({
//                        'top': (scrollYpos+20)+'px',
                        'position': 'fixed'
                    });
                }

            });
        }, 1000);


        /**
         * Ritorna TRUE se un determinato roleType è elencato tra quelli selezionati.

         * @param {object} item
         * @param {array} list
         * @returns {boolean}
         */
        vm.isRoleTypeSelected = function(item, list) {
            var ret = false;
            _.each(list, function(listItem) {
                if (listItem.id === item.id) {
                    ret = true;
                }
            });
            return ret;
        };


        /**
         * Se un elemento esiste in lista, lo toglie; se non è in lista lo aggiunge.

         * @param {object} item
         * @param {array} list
         */
        vm.toggleRoleTypeSelected = function(item, list) {
            var newList = [];
            var found = false;
            _.each(list, function(listItem) {
                //$log.debug('verifico se ' + parseInt(listItem.id) + ' !== ' + parseInt(item.id));
                if (parseInt(listItem.id) !== parseInt(item.id)) {
                    newList.push(listItem);
                } else {
                    // se l'elemento esiste in lista, lo salta così viene tolto
                    found = true;
                }
            });
            // se non aveva trovato l'elemento, lo aggiunge
            if (!found) {
                newList.push(item);
            }
            vm.selectedRoleTypes = newList;
        };


    }

})();

'use strict';
(function() {
    angular
        .module('app.pages.users')
        .controller('LoginDestinationController', LoginDestinationController);

    /**
     * Controller della pagina che chiede all'utente se  desidera accedere sempre alla pagina di amministrazione delle
     * organizzazioni o se preferisce andare alla pagina di utente.
     */
    function LoginDestinationController($log, $state, LoopBackAuth, User, AuthenticationService, UserPreference,
                                        AlertMessageService) {
        var vm = this;
        vm.currentUserId = null;

        vm.init = function() {
            $log.debug('LoginDestinationController.init()');
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Imposta la preferenza LOGIN_DESTINATION per l'utente corrente
         *
         * @param {string} preferenceValue
         */
        vm.setUserPreference = function(preferenceValue) {
            // prova a leggere la userPreference
            UserPreference.find(
                {
                    filter: {
                        where: {
                            and: [
                                { userId: vm.currentUserId },
                                { code: 'LOGIN_DESTINATION' }
                            ]
                        }
                    }
                },
                function(existingPreferences) {
                    // se esiste, la aggiorna
                    if (existingPreferences && existingPreferences.length > 0) {
                        var existingPreference = existingPreferences[0];
                        existingPreference.value = preferenceValue;
                        UserPreference.updateAll(
                            { where: { and: [{ userId: vm.currentUserId }, { code: 'LOGIN_DESTINATION' }]}},
                            { value: preferenceValue },
                            function(savedPreference) {
                                AlertMessageService.showSuccessMessage();
                                $state.go('app.dispatcher');
                            },
                            function(err) {
                                $state.go('app.dispatcher');
                            }
                        );
                    } else {
                        // se non esisteva, la crea
                        UserPreference.save({
                            userId: vm.currentUserId,
                            code: 'LOGIN_DESTINATION',
                            value: preferenceValue
                        }, function(newPreference) {
                            AlertMessageService.showSuccessMessage();
                            $state.go('app.dispatcher');
                        }, function(err) {
                            $state.go('app.dispatcher');
                        })
                    }
                },
                function(err) {
                    // se ci sono errori, prova comunque a scriverla, poi esce
                    UserPreference.save({
                        userId: vm.currentUserId,
                        code: 'LOGIN_DESTINATION',
                        value: preferenceValue
                    }, function(newPreference) {
                        AlertMessageService.showSuccessMessage();
                        $state.go('app.dispatcher');
                    }, function(err) {
                        $state.go('app.dispatcher');
                    })
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.service_payments_report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_service_payments_report', {
            url      : '/reports/service_payments/:serviceId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/reports/service_payments_report/service_payments_report.html',
                    controller : 'ServicePaymentsReportController as vm'
                }
            },
            bodyClass: 'reports'
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.service_payments_report')
        .controller('ServicePaymentsReportController', ServicePaymentsReportController);

    /** @ngInject */
    function ServicePaymentsReportController($log, $state, AuthenticationService, LoopBackAuth, ApiPath,
                                             User, Organization, OfferedService, PaymentReport) {
        var vm = this;
        var self = this;
        vm.currentUserId = null;
        vm.organizationId = null;
        // existing reports data
        vm.reports = {
            items: [],
            loading: true,
        };
        // available form values
        vm.offeredServices = [];
        vm.yearlySubscriptionServices = [];
        vm.months = [];
        vm.years = [];
        // selected data in start report form
        vm.reportParams = {
            serviceId: null,
            year: moment().format('YYYY'),
            month: moment().format('MM'),
            yearlySubscriptionSelected: [],
        };


        /**
         * Initializes the view
         */
        vm.init = function() {
            $log.debug('ServicePaymentsReportController.init()');
            vm.months = self.getMonths();
            vm.years = self.getYears();
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                vm.organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION');
                vm.reportParams.serviceId = $state.params.serviceId || null;
                self.readOrganizationServices(vm.organizationId);
                // self.readExistingReports(vm.organizationId);
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Read all reports of an existing organization
         */
        self.readExistingReports = function(organizationId) {
            vm.reports.loading = true;
            if (organizationId) {
                PaymentReport.find({
                    where: {
                        organizationId: organizationId,
                        dtDel: null
                    }
                }).$promise.then(
                    function(err, reports) {
                        if (!err) {
                            reports = JSON.parse(JSON.stringify(reports));
                            vm.reports.items = reports;
                            $log.debug(JSON.stringify(vm.reports));
                        } else {
                            $log.error(err);
                        }
                        vm.reports.loading = false;
                    },
                    function(err) {
                        $log.error(err);
                        vm.reports.loading = false;
                    }
                );
            } else {
                vm.reports.loading = false;
            }
        };


        /**
         * Read all services for a given organization
         */
        self.readOrganizationServices = function() {
            if (vm.organizationId) {
                OfferedService.find({
                    filter: {
                        where: {
                            organizationId: vm.organizationId,
                            dtDel: null,
                        },
                        include: ['serviceTypes']
                    }
                }).$promise.then(
                    function(offeredServices) {
                        offeredServices = JSON.parse(JSON.stringify(offeredServices));
                        // sort by name
                        offeredServices = _.sortBy(offeredServices, function(offeredService) {
                            return offeredService.name.toLowerCase();
                        });
                        // remove payment plans
                        offeredServices = _.filter(offeredServices, function(offeredService) {
                            return !offeredService.isPaymentPlan;
                        });
                        $log.debug(offeredServices);
                        // extract services
                        vm.offeredServices = _.filter(offeredServices, function(offeredService) {
                            var ret = true;
                            _.each(offeredService.serviceTypes, function(serviceType) {
                                if (serviceType && serviceType.internalCode && serviceType.internalCode === 'SUBSCRIPTION') {
                                    ret = false;
                                }
                            });
                            return ret;
                        });
                        // extract yearly subscriptions
                        vm.yearlySubscriptionServices = _.filter(offeredServices, function(offeredService) {
                            var ret = false;
                            _.each(offeredService.serviceTypes, function(serviceType) {
                                if (serviceType && serviceType.internalCode && serviceType.internalCode === 'SUBSCRIPTION') {
                                    ret = true;
                                }
                            });
                            return ret;
                        });
                    },
                    function(err) {
                        $log.error('Errore in lettura OfferedServices');
                        $log.error(err);
                    }
                );
            }
        };



        /**
         * Returns the objects representing the year's months
         *
         * @returns {object[]}
         */
        self.getMonths = function() {
            // $log.debug('self.getMonths()');
            var months = [];
            var m = null;
            var dt = null;
            for (var i = 0; i < 12; i++) {
                // $log.debug('i: ' + i);
                dt = moment('2019-' + (i+1 < 10 ? '0' : '') + (i+1) + '-15', 'YYYY-MM-DD');
                // $log.debug('dt: ' + JSON.stringify(dt));
                m = {
                    nr: i+1,
                    name: dt.format('MMMM'),
                };
                // $log.debug('m: ' + JSON.stringify(m));
                months.push(m);
                // $log.debug('i.toString(): ' + i.toString() + ' dt.format(\'M\'): ' + dt.format('M'));
                if (i.toString() === dt.format('M')) {
                    vm.month = m;
                }
            }
            return months;
        };


        /**
         * Returns last years
         *
         * @returns {number[]}
         */
        self.getYears = function() {
            var dt = new Date();
            return [dt.getFullYear(), dt.getFullYear()-1, dt.getFullYear()-2];
        };


        /**
         * Go back to current organization's services
         */
        vm.gotoServices = function() {
            $state.go('app.organization_services', { organizationId: vm.organizationId, serviceType: 'SERVICE' });
        };


        /**
         * Start report generation and downloads it
         */
        vm.downloadReport = function() {
            // create selected yearlySubscriotions array
            vm.reportParams.yearlySubscriptionSelected = [];
            _.each(vm.yearlySubscriptionServices, function(service) {
                if (service.selected) {
                    vm.reportParams.yearlySubscriptionSelected.push(service.id);
                }
            });
            // laucnh report
            var url = ApiPath + '/paymentReports/generate?organizationId=' + vm.organizationId +
                '&offeredServiceId=' + vm.reportParams.serviceId +
                '&refYear=' + vm.reportParams.year +
                '&refMonth=' + vm.reportParams.month +
                '&linkedOfferedServices=' +
                    encodeURIComponent('[' + vm.reportParams.yearlySubscriptionSelected.toString() + ']') +
                '&tk=' + LoopBackAuth.accessTokenId;
            window.open(url, '_blank');
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.payments', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.pages_payments', {
                url      : '/payments',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/payments/payments.html',
                        controller : 'PaymentsController as vm'
                    }
                },
                bodyClass: 'payments'
            })
            .state('app.pages_payments_pay', {
                url      : '/payments/pay/:organizationId/:subscriptionId/:userId/:amount',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/payments/pay/pay.html',
                        controller : 'PayController as vm'
                    }
                },
                bodyClass: 'pay'
            })
            .state('app.pay_subscription', {
                url      : '/pay_subscription/:subscriptionId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/payments/pay_subscription.html',
                        controller : 'PaySubscriptionController as vm'
                    }
                },
                bodyClass: 'payments'
            })
            .state('app.pay_subscription_success', {
                url      : '/pay_subscription/:subscriptionId/success/:checkoutSessionId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/payments/pay_subscription_success.html',
                        controller : 'PaySubscriptionSuccessController as vm'
                    }
                },
                bodyClass: 'payments'
            })
            .state('app.pay_cylplan_success', {
                url      : '/pay_cylplan/:organizationId/success/:planData',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/payments/pay_cylplan_success.html',
                        controller : 'PayCylplanSuccessController as vm'
                    }
                },
                bodyClass: 'payments'
            })
            .state('app.pay_app_subscription', {
                url      : '/pay_app_subscription/:success',
                views    : {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.pay_app_subscription': {
                        templateUrl: 'app/main/pages/payments/pay_app_subscription.html',
                        controller : 'PayAppSubscriptionController as vm'
                    }
                },
                bodyClass: 'payments'
            });


        $translatePartialLoaderProvider.addPart('app/main/pages/payments');


    }

})();

/*
    Finestra per effettuare i pagamenti di una subscription. Quando pagato, o quando si annulla,
    la finesdtra torna allo stato che l'ha chiamata.

    Uso:
    Prima di effettuare il routing verso questa finestra, impostare lo stato di partenza nel sessionStorage:
    ```
    sessionStorage.setItem('payModalState', JSON.stringify({
        backState: $state.current.name,
        backParams: $state.params,
    }));
    $state.go('app.pages_payments_pay', {
        backState: $state.current.name,
        backParams: JSON.stringify($state.params),
    });
    ```
 */
(function() {
    'use strict';

    angular.module('app.pages.payments').controller('PayController', PayController);

    /** @ngInject */
    function PayController($log, $state, $q, AlertMessageService,
                           Organization, PaymentReason, Payment) {
        var vm = this;
        vm.organizationId = $state.params.organizationId;
        vm.subscriptionId = $state.params.subscriptionId;
        vm.userId = $state.params.subscriptionId;
        vm.organization = null;
        vm.paymentReasons = null;
        vm.payment = {
            date: new Date(),
            amount: parseFloat($state.params.amount),
            reasonId: null,
            description: null,
            flgGenerateInvoice: null,
            flgSendNotification: null,
        };
        vm.showFlgGenerateInvoice = null;
        vm.loading = false;
        vm.paying = false;


        /**
         * Inizializzazione dati
         */
        vm.init = function() {
            $log.debug('PayController.vm.init()');
            $log.debug({state: $state});
            $q.all([
                readOrganization(vm.organizationId),
                readPaymentReasons(vm.organizationId),
            ]).then(
                function(results) {
                    $log.debug({results: results});
                    vm.organization = results[0];
                    vm.paymentReasons = results[1];
                    if (vm.organization) {
                        vm.payment.flgGenerateInvoice = vm.organization.flgEnableInvoice;
                        vm.payment.flgSendNotification = vm.organization.flgEnableInvoice;
                        vm.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
                    }
                    vm.loading = false;
                },
                function(err) {
                    // errore cercando dati iniziali, consente solo back
                    vm.loading = false;
                    AlertMessageService.showErrorAlert('Errore caricando i dati del pagamento');
                }
            );
        };


        /**
         * Avvia una promise per leggere le PaymentReason (globali e per una organization)
         */
        function readOrganization(organizationId) {
            var deferred = $q.defer();
            Organization.findById(
                {id: organizationId},
                function(organization) {
                    deferred.resolve(organization);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        /**
         * Avvia una promise per leggere le PaymentReason (globali e per una organization)
         */
        function readPaymentReasons(organizationId) {
            var deferred = $q.defer();
            // TODO aggiungere configurazione per filtrare o meno internalCode
            // TODO aggiungere PaymentReason specifiche per organizzazione
            PaymentReason.find(
                {
                    filter: {
                        where : {
                            organizationId: null,
                            paymentType:'IN',
                            /*internalCode:'SERVICE',*/
                        }
                    }
                },
                function(paymentReasons) {
                    deferred.resolve(paymentReasons);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        /**
         * Torna alla pagina precedente, leggendo dal sessionStorage lo state di ritorno.
         * Come fallback, torna alla home
         */
        vm.back = function() {
            try {
                var payModalState = JSON.parse(sessionStorage.getItem('payModalState'));
                $log.debug({payModalState: payModalState});
                if (payModalState && payModalState.backState) {
                    var backState = payModalState.backState;
                    var backParams = payModalState.backParams ? payModalState.backParams : null;
                    sessionStorage.removeItem('payModalState'); // clean sessionStorage
                    $state.go(backState, backParams );
                } else {
                    throw 'invalid or missing destination state';
                }
            } catch(e) {
                $log.error(e);
                $state.go('app.dispatcher');
            }
        };


        /**
         * Inserisce il pagamento e torna alla schermata originaria
         */
        vm.insertPayment = function() {
            vm.paying = true;
            Payment.pay({
                subscriptionId: vm.subscriptionId.toString(),
                paymentDate: vm.payment.date,
                amount: vm.payment.amount,
                description: vm.payment.description ? vm.payment.description.toString() : '',
                paymentReasonId: vm.payment.reasonId.toString(),
                flgGenerateReceipt: vm.payment.flgGenerateInvoice,
                flgSendReceipt: vm.payment.flgSendNotification,
            }).$promise.then(function(data) {
                $log.debug(data);
                AlertMessageService.showSuccessMessage();
                vm.paying = false;
                vm.back();
            },function(httpResponse) {
                $log.error(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                vm.paying = false;
                vm.back();
            });
        };


        vm.isSubmitDisabled = function() {
            // $log.debug('vm.isSubmitDisabled()');
            // $log.debug({
            //     loading: vm.loading,
            //     organization: vm.organization,
            //     paymentReasons: vm.paymentReasons,
            //     reasonId: vm.payment.reasonId,
            // });
            return !(
                !vm.loading &&          // nono devo essere in caricamento
                !vm.paying &&           // nono devo essere in pagamento
                vm.organization &&      // organization deve esistere
                vm.payment.amount &&    // una cifra >0 deve essere indicata
                vm.paymentReasons &&    // devo avere delle paymentReasons
                vm.payment.reasonId);   // devo aver selezionato una reasonId
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.memberships', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.pages_memberships_index', {
            url      : '/memberships/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/memberships/index/memberships-index.html',
                    controller : 'MembershipsIndexController as vm'
                }
            },
        }),
        $stateProvider.state('app.pages_memberships_new', {
            url      : '/memberships/:organizationId/new',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/memberships/new/memberships-new.html',
                    controller : 'MembershipsNewController as vm'
                }
            },
        })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.memberships')
        .controller('MembershipsNewController', MembershipsNewController);

    /** @ngInject */
    function MembershipsNewController($scope, $rootScope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $state, $q,
                                      $timeout, LoopBackAuth, AuthenticationService, breadcrumbManager, ApiPath,
                                      User, Organization, OfferedService, blockUI, AlertMessageService, Subscription,
                                      UserRelation, UserOrganizationRole) {

        var vm = this;
        vm.apiPath=ApiPath;
        vm.loggedUserId = null;
        vm.loggedUser = null;
        vm.organizationId = null;
        vm.organization = null;
        vm.isAdmin = false;                 // if true, logged user is current organization's admin
        vm.membershipServices = null;
        vm.subscriberData = {};             // utente inserito o selezionato tramite barra di ricerca
        vm.isRelativeSubscription = null;   // se TRUE, sto iscrivendo il figlio con la mail del genitore
        vm.parentUserEmail = null;          // email del genitore, non fa parte dell'utente



        vm.init = function() {
            $log.debug('vm.init()');
            if (AuthenticationService.isAuthenticated()) {
                blockUI.start();
                // $log.debug('AuthenticationService.isAuthenticated() === true');
                // load logged user
                vm.loggedUserId = User.getCurrentId().toString();
                vm.fetchUser(vm.loggedUserId).then(
                    function(user) {
                        vm.loggedUser = user;
                        // $log.debug('vm.loggedUser: ' + JSON.stringify(vm.loggedUser));
                    }
                );

                // read current organization
                if ($state.params && $state.params.organizationId) {
                    vm.organizationId = $state.params.organizationId;
                    vm.fetchOrganization(vm.organizationId).then(
                        function(myOrganization) {
                            if (myOrganization) {
                                // $log.debug('myOrganization: ' + JSON.stringify(myOrganization));
                                //myOrganization.$prototype$isAdmin(
                                Organization.isOrganizationAdmin(
                                    { organizationId: myOrganization.id, userId : vm.loggedUserId }
                                ).$promise.then(
                                    function(response) {
                                        // $log.debug('response: ' + JSON.stringify(response));
                                        if (response && response.isAdmin) {
                                            vm.organization = _.clone(myOrganization);
                                            // $log.debug('vm.organization: ' + JSON.stringify(vm.organization));
                                            vm.isAdmin = true;

                                            // lettura dei servizi di tesseramento
                                            vm.fetchMembershipServices(vm.organizationId);
                                        }
                                    }, function(err) {
                                        $log.error('Error in myOrganization.$prototype$isAdmin()');
                                    }
                                );
                            }
                        },
                        function() {
                            blockUI.stop();
                            $log.error('Error in vm.fetchOrganization()');
                        }
                    );
                }
            } else {
                $state.go('app.pages_login');
            }
        };



        /**
         * Carica l'elenco dei servizi di tesseramento per una associazione
         *
         * @param organizationId {number}
         */
        vm.fetchMembershipServices = function(organizationId) {
            if (vm.organizationId) {
                OfferedService.find({
                    filter: {
                        where: {
                            organizationId: vm.organizationId,
                            isDeleted: false,
                        },
                        include: ['serviceTypes', 'offeredServiceTypeRelations'],
                    }
                }).$promise.then(
                    function(items) {
                        // estrai dai risultati i servizi che non sono sottoscrizioni
                        vm.membershipServices = _.filter(JSON.parse(JSON.stringify(items)), function(item) {
                            var ret = false;
                            if (item && item.serviceTypes) {
                                _.each(item.serviceTypes, function(serviceType) {
                                    if (serviceType.internalCode === 'SUBSCRIPTION') {
                                        ret = true;
                                    }
                                });
                            }
                            return ret;
                        });
                        $log.debug({membershipServices: vm.membershipServices});
                    },
                    function(httpResponse) {
                        $log.error(httpResponse);
                        vm.loading = false;
                    }
                );
            }
        };



        /**
         * Load a user by id
         *
         * @param {number} userId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchUser = function(userId) {
            return User.findById({ id: userId }).$promise;
        };



        /**
         * Load an Organization, given it's ID
         *
         * @param {number} organizationId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchOrganization = function(organizationId) {
            $log.debug('MembershipNewController.vm.fetchOrganization()');
            return Organization.findById({
                id : organizationId,
                filter : {}
            }).$promise;
        };


        /**
         * Selezione o deseleziona un servizio. Deseleziona tutti gli altri.
         * @param serviceId
         */
        vm.toggleSelectedService = function(serviceId) {
            vm.membershipServices.map(function(service) {
                if (service && service.id && service.id === serviceId) {
                    service.selected = !service.selected;
                } else if (service) {
                    service.selected = null;
                }
            });
        };


        /**
         * ricerca utente
         */
        vm.lookupUser = function(txt) {
            var txt = txt + '%';
            var deferred = $q.defer();
            User.lookupUsers({
                text: txt,
                organizationId: vm.organizationId,
                isGlobalSearch: false
            }).$promise.then(function(data) {
                deferred.resolve(data.users);
            });

            return deferred.promise;
        };



        /**
         * selezione utente da autocompletion
         */
        vm.selectedUserChange = function(item) {
            if (item) {
                loadUserDetail(item.id, function(myUser) {
                    if (myUser.email && myUser.email.endsWith('.invalid')) {
                        myUser.email = '';
                    }
                    vm.subscriberData = myUser;
                    vm.subscriberData.birthDate = (myUser.birthDate && myUser.birthDate !== null && myUser.birthDate !== '') ? moment(myUser.birthDate).toDate() : null;
                    vm.parentUserEmail = (myUser.parents && myUser.parents.length > 0) ? myUser.parents[0].email : null;
                    vm.isRelativeSubscription = (myUser.parents && myUser.parents.length > 0);
                });
            } else {
                vm.subscriberData = {};
                vm.parentUserEmail = null;
            }
        };


        function loadUserDetail(id, callback) {
            User.loadUser({
                id: id,
                organizationId: vm.organizationId,
                filter: {include: 'parents'}
            }, function(user) {
                callback(user);
            }, function(error) {
                $log.error(error);
            });
        }


        /**
         * Ritorna TRUE se tutti i dati sono inseriti per procedere al salvataggio
         */
        vm.isFormValid = function() {
            $log.debug('isFormValid()');
            var userEntered = false;
            var serviceSelected = false;
            // il form della persona deve essere compilato
            if (vm.subscriberData && vm.subscriberData.id) {
                // selezionato da barra di ricerca
                userEntered = true;
            } else {
                // inserito a mano
                if (vm.subscriberData && vm.subscriberData.givenName && vm.subscriberData.familyName &&
                    (vm.parentUserEmail || vm.subscriberData.email)) {
                    userEntered = true;
                }
            }
            // deve esserci una tessera selezionata
            vm.membershipServices.map(function(service) {
                if (service && service.selected) {
                    serviceSelected = true;
                }
            });

            return userEntered && serviceSelected;
        };



        vm.gotoMembershipsIndex = function() {
            $state.go('app.pages_memberships_index', { organizationId: vm.organizationId });
        };


        /**
         * Crea l'iscrizione al servizio ed eventualmente l'utente a cui associarla
         */
        vm.saveMembership = function() {
            $log.debug('vm.saveMambership()');
            blockUI.start();
            // crea utente ed eventuale genitore
            checkForChildParentCreation(function(done) {
                // cerca il il servizio scelto
                var membershipService = null;
                vm.membershipServices.map(function(service) {
                    if (service && service.id && service.selected) {
                        membershipService = service;
                    }
                });
                $log.debug({membershipService: membershipService});
                // imposta la data di subscription come data di inizio del servizio
                vm.subscriberData.dtStart = membershipService.start;
                $log.debug({subscriberData: vm.subscriberData});
                // aggiunge la subscription al servizio di quota associativa scelto
                OfferedService.addNonRegisteredSubscriber({
                    offeredServiceId: membershipService.id.toString(),      // servizio capofila
                    subscriberData: vm.subscriberData,          // dati utente
                    subscribedServices: [membershipService.id.toString()],                     // servizi accessori
                    subscriptionDiscount: {id: '', amount: 0},                   // sconto eventuale
                }).$promise.then(function(data) {
                    $log.debug('ritorno da OfferedService.addNonRegisteredSubscriber(); data: ' + JSON.stringify(data));
                    Subscription.findById({id: data.result}).$promise.then(function(subscription) {
                        $log.debug('ritorno da Subscription.findById(); data: ' + JSON.stringify(data));
                        // attendo altrimenti il refresh non ha l'utente nuovo
                        $timeout(function() {
                            blockUI.stop();
                            AlertMessageService.showSuccessMessage();
                            vm.gotoMembershipsIndex();
                        }, 2500);
                    }, function(httpResponse) {
                        $log.error('fallita Subscription.findById(); httpResponse: ' + JSON.stringify(httpResponse));
                        blockUI.stop();
                        $log.error(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }, function(httpResponse) {
                    $log.error('fallita OfferedService.addNonRegisteredSubscriber(); httpResponse: ' + JSON.stringify(httpResponse));
                    blockUI.stop();
                    $log.error(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            });

            $state.go('app.pages_memberships_index', { organizationId: vm.organizationId });
        };


        /**
         * Creazione utente ed eventuale genitore
         * @param callback
         */
        function checkForChildParentCreation(callback) {
            // se sto inserendo un minore nuovo e ho la mail del genitore
            if (vm.isRelativeSubscription && !vm.subscriberData.id && vm.parentUserEmail) {
                //CERCO IL PADRE VIA MAIL: SE ESISTE LO ASSOCIO SE NO LO CREO CON NOME FITTIZIO
                findUserByMail(vm.parentUserEmail, function(users) {
                    if (!users || users === null || users.length === 0) {
                        //creazione fittizia del genitore
                        User.createUserAndNotify({
                            user: {
                                givenName: 'Genitore di ' + vm.subscriberData.givenName,
                                familyName: vm.subscriberData.familyName,
                                email: vm.parentUserEmail
                            },
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false,
                            notificationText: ''
                        }).$promise.then(
                            function(response) {
                                var theParent = response.user;
                                completeChildCreationAsAdmin(theParent, callback);
                            },
                            function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                    }
                    else {
                        var theParent = users[0];
                        completeChildCreationAsAdmin(theParent, callback);

                    }
                });
            } else {
                callback();
            }
        }


        /**
         * Cerca un utente per mail
         * @param mail
         * @param callback
         */
        function findUserByMail(mail, callback) {
            var query = {
                filter: {
                    where: {email: mail},
                    include: 'children'
                }
            };
            User.find(query, function(users) {
                callback(users);
            });
        }


        function completeChildCreationAsAdmin(theParent, callback) {
            doRealChildCreation(theParent, function(childUser) {
                vm.subscriberData.id = childUser.id;
                vm.subscriberData.contactEmail = theParent.email;
                User.saveUser({
                    user: vm.subscriberData,
                    organizationId: vm.organization.id.toString(),
                }).$promise.then(
                    function(data) {
                        $log.debug(data);
                        UserOrganizationRole.addAsContact({
                            userId: childUser.id.toString(),
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false
                        }).$promise.then(
                            function(data) {
                                callback(data);
                            },
                            function(httpResponse) {
                                blockUI.stop();
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            }
                        );
                    },
                    function(httpResponse) {
                        blockUI.stop();
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    }
                );
            });
        }


        /**
         * eFFETTUA LA EFFETTIVA CREAZIONE DELL'UTENTE figlio A PARTIRE DAl PADRE/GENITORE
         * @param parent
         */
        function doRealChildCreation(theParentUser, callback) {
            User.findById({id: theParentUser.id}).$promise.then(function(parent) {
                //se è stata messa al figlo la mail del padre allora sbianco quella del figlio
                // e salvo (tanto saranno propagate automaticamente le info)
                var aParent = parent;
                if (vm.subscriberData.email && vm.subscriberData.email.trim().toLowerCase() === aParent.email.trim().toLowerCase()) {
                    vm.subscriberData.email = null;
                }
                //altrimenti cerco che non vi sia già l'utente in cyl
                if (vm.subscriberData.email) {
                    findUserByMail(vm.subscriberData.email, function(users) {
                        if (!users || users === null || users.length === 0) {
                            var organizationId = vm.organization.id;
                            aParent.$prototype$addChild({
                                user: vm.subscriberData,
                                organizationId: organizationId
                            }).then(function(data) {
                                $log.debug('Child created');
                                callback(data.child);
                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                        else {
                            // AlertMessageService.showErrorAlert("LP_ERRORS.EMAIL_ALREADY_IN_USE");
                            // Controllo se ho una relazione con l'utente
                            var theUser = users[0];
                            //SE NO La CREO E RITORNO A PAGINA FIGLI
                            UserRelation.find({
                                filter: {
                                    where: {
                                        childId: theUser.id,
                                        parentId: aParent.id
                                    }
                                }
                            }).$promise.then(function(relations) {
                                if (relations && relations.length > 0) {
                                    blockUI.stop();
                                    AlertMessageService.showErrorAlert('RELAZIONE GIA ESISTENTE');
                                } else {
                                    var organizationId = vm.organization.id;
                                    UserRelation.create({
                                        childId: theUser.id,
                                        parentId: aParent.id,
                                        createOrganizationId: organizationId
                                    }).$promise.then(function(data) {
                                        blockUI.stop();
                                        AlertMessageService.showSuccessMessage();
                                        callback(theUser);
                                    }, function(error) {
                                        blockUI.stop();
                                        AlertMessageService.showErrorAlert(error);
                                    });
                                }

                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                    });
                } else {
                    var organizationId = null;
                    if ($state.params.organizationId) {
                        organizationId = $state.params.organizationId;
                    }
                    aParent.$prototype$addChild({
                        user: vm.subscriberData,
                        organizationId: organizationId
                    }).then(function(data) {
                        $log.debug('Child created');
                        callback(data.child);
                    }, function(error) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(error);
                    });
                }
            });
        }


    }//MembershipsIndexController
})();

(function() {
    'use strict';

    angular
        .module('app.pages.memberships')
        .controller('MembershipsIndexController', MembershipsIndexController);

    /** @ngInject */
    function MembershipsIndexController($scope, $rootScope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $state,
                                        LoopBackAuth, AuthenticationService, breadcrumbManager, ApiPath, blockUI,
                                        AlertMessageService, CylUtils, PaymentReason,
                                        User, Organization, Subscription, $mdDialog, Payment) {

        var vm = this;
        vm.apiPath=ApiPath;
        vm.loggedUserId = null;
        vm.loggedUser = null;
        vm.organizationId = null;
        vm.organization = null;
        vm.isAdmin = false;                 // if true, logged user is current organization's admin
        // datatable variables
        vm.dtServicesInstance = null;
        vm.dtServicesOptions = null;
        vm.dtServicesColumns = null;
        vm.dtServicesSearchText = null;                 // text search for services table
        vm.dtItemsCount = null;                         // items count
        vm.subscriptions = [];                          // subscriptions shown in table (needed only to avoid lookup a subscription when moving to payment window)



        vm.init = function() {
            $log.debug('vm.init()');
            if (AuthenticationService.isAuthenticated()) {
                blockUI.start();
                // $log.debug('AuthenticationService.isAuthenticated() === true');
                // load logged user
                vm.loggedUserId = User.getCurrentId().toString();
                vm.fetchUser(vm.loggedUserId).then(
                    function(user) {
                        vm.loggedUser = user;
                        // $log.debug('vm.loggedUser: ' + JSON.stringify(vm.loggedUser));
                    }
                );

                // read current organization
                if ($state.params && $state.params.organizationId) {
                    vm.organizationId = $state.params.organizationId;
                    vm.fetchOrganization(vm.organizationId).then(
                        function(myOrganization) {
                            if (myOrganization) {
                                // $log.debug('myOrganization: ' + JSON.stringify(myOrganization));
                                //myOrganization.$prototype$isAdmin(
                                Organization.isOrganizationAdmin(
                                    { organizationId: myOrganization.id, userId : vm.loggedUserId }
                                ).$promise.then(
                                    function(response) {
                                        // $log.debug('response: ' + JSON.stringify(response));
                                        if (response && response.isAdmin) {
                                            vm.organization = _.clone(myOrganization);
                                            // $log.debug('vm.organization: ' + JSON.stringify(vm.organization));
                                            vm.isAdmin = true;
                                        }
                                    }, function(err) {
                                        $log.error('Error in myOrganization.$prototype$isAdmin()');
                                    }
                                );
                            }
                        },
                        function() {
                            $log.error('Error in vm.fetchOrganization()');
                        }
                    );
                }

                // initializes DataTable
                vm.initServicesTable();
            } else {
                $state.go('app.pages_login');
            }
        };


        /**
         * Services DataTable rendering methods
         */
        vm.renderDtServicesColumnAvatar = function(data, type, subscription) {
            if (subscription && subscription.user && subscription.user.uriAvatar) {
                return '<img md-menu-align-target class="avatar" src="' + vm.apiPath + '/userDocumentsContainers/' + $rootScope.CYL_USER_DOC_PREFIX + subscription.user.id + '/download/' + subscription.user.uriAvatar + '">';
            } else {
                return '<img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg">';
            }
        };
        vm.renderDtServicesColumnUsername = function(data, type, subscription) {
            return ((subscription && subscription.user && subscription.user.familyName) ? subscription.user.familyName : '') + ' ' +
                ((subscription && subscription.user && subscription.user.givenName) ? subscription.user.givenName : '');
        };
        vm.renderDtServicesColumnService = function(data, type, subscription) {
            return (subscription && subscription.offeredService && subscription.offeredService.name) ? subscription.offeredService.name : '-';
        };
        vm.renderDtServicesColumnPayments = function(data, type, subscription) {
            var s = '';
            if (subscription) {
                s = '<ov-subscription-payments-status ' +
                    'class="ov-cursor-pointer" ' +
                    'ng-click="vm.goToSubscriptionPayments(' + subscription.id + ');" ' +
                    'totaldue="' + subscription.totalDue + '" ' +
                    'totalpaid="' + subscription.totalPaid + '" ' +
                    'todaydue="' + subscription.todayDue + '" ' +
                    'todaypaid="' + subscription.todayPaid + '" ' +
                    '></ov-subscription-payments-status>';
            }
            return s;
        };
        vm.renderDtServicesColumnActions = function(data, type, subscription) {
            var s = '';
            // pagamenti
            s += '<md-button class="edit-button md-icon-button" ' +
                'ng-click="vm.gotoPaymentWindow(' + subscription.id +');" aria-label="Inserisci pagamento" title="Inserisci pagamento"> ' +
                '<md-icon md-font-icon="icon-currency-eur"></md-icon> ' +
                '</md-button>';
            // profilo utente
            s += '<md-button class="edit-button md-icon-button" ' +
                'ng-click="vm.gotoUserProfile(' + subscription.user.id + ');" ' +
                'aria-label="Scheda personale" title="Scheda personale"> ' +
                '<md-icon md-font-icon="icon-account-box"></md-icon> ' +
                '</md-button>';
            // elimina tessera
            s += '<md-button class="edit-button md-icon-button" ' +
                'ng-click="vm.deleteSubscription(' + subscription.id + ');" ' +
                'aria-label="Elimina tesseramento" title="Elimina tesseramento"> ' +
                '<md-icon md-font-icon="icon-trash"></md-icon> ' +
                '</md-button>';
            return s;
        };




        /**
         * Retrieve data for Datatable
         */
        vm.loadDtItems = function(sSource, aoData, fnCallback, oSettings) {
            $log.debug('vm.loadDtItems()');
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            // load reference period
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var dateFrom = null, dateTo = null;
                if (refPeriod) {
                    dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                    dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                }
                // build query filters
                var filters = {
                    organizationId: vm.organizationId,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    start: start,
                    length: length,
                    order: order,
                    searchText: vm.dtServicesSearchText,
                };
                // filter searchtext, if appliable
                if (vm.dtServicesSearchText) {
                    filters.searchText = vm.dtServicesSearchText;
                }
                $log.debug({filters: filters});

                Subscription.getMemberships(
                    { filters: filters},
                    function(returnObject) {
                        returnObject = JSON.parse(JSON.stringify(returnObject));
                        $log.debug({getMemberships: returnObject});
                        if (returnObject && returnObject.items) {
                            vm.dtItemsCount = returnObject.recordsTotal;
                            vm.subscriptions = returnObject.items;

                            // return items list
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': returnObject.recordsTotal,
                                'recordsFiltered': returnObject.recordsFiltered,
                                'data': vm.subscriptions
                            });
                        } else {
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': []
                            });
                        }
                    }
                );
            });
        };



        /**
         * Initializes services DataTable
         */
        vm.initServicesTable = function() {
            vm.dtServicesOptions = DTOptionsBuilder
                .newOptions()
                .withOption('serverSide', true)
                .withFnServerData(vm.loadDtItems)
                .withDataProp('data')
                .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
                .withOption('responsive', true)
                .withOption('autoWidth', false)
                .withDisplayLength(50)
                .withPaginationType('full_numbers')
                .withOption('createdRow', function(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                .withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('drawCallback', function() {
                    blockUI.stop();
                })
                .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            ;
            vm.dtServicesColumns = [
                DTColumnBuilder.newColumn('avatar').withTitle('').notSortable().renderWith(vm.renderDtServicesColumnAvatar),
                DTColumnBuilder.newColumn('username').withTitle('Cognome e nome').renderWith(vm.renderDtServicesColumnUsername),
                DTColumnBuilder.newColumn('serviceName').withTitle('Tessera').notSortable().renderWith(vm.renderDtServicesColumnService),
                DTColumnBuilder.newColumn('payment').withTitle('Pagamenti').notSortable().renderWith(vm.renderDtServicesColumnPayments),
                DTColumnBuilder.newColumn('actions').withTitle('Azioni').notSortable().renderWith(vm.renderDtServicesColumnActions),
            ];
        };




        /**
         * Load a user by id
         *
         * @param {number} userId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchUser = function(userId) {
            return User.findById({ id: userId }).$promise;
        };



        /**
         * Load an Organization, given it's ID
         *
         * @param {number} organizationId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchOrganization = function(organizationId) {
            $log.debug('MembershipsIndexController.vm.fetchOrganization()');
            return Organization.findById({
                id : organizationId,
                filter : {}
            }).$promise;
        };



        /**
         * Elimina una tessera, se non è stato registrato il pagamento
         *
         * @param ev
         * @param subscription
         */
        vm.deleteSubscription = function(subscriptionId) {
            $mdDialog.show({
                controller: DeleteDialogController,
                templateUrl: 'app/main/pages/commons/dialogs/delete_confirm_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    blockUI.start();
                    Payment.count({
                        where : {dtDel: null, subscriptionId: subscriptionId, paymentStatus: 'PAYED'}
                    }, function(totalNumber) {
                        if (totalNumber.count && totalNumber.count > 0)  {
                            blockUI.stop();
                            //ERRORE: ci sono servizi associati
                            AlertMessageService.showErrorAlert("OFFERED_SERVICES.ERRORS.CANT_DELETE_HAS_PAYMENTS");
                        }
                        else {
                            Subscription.findById({
                                id :  subscriptionId, dtDel: null
                            }).$promise.then(
                                function(sub) {
                                    sub.dtDel =  new Date();
                                    sub.isDeleted = 1;
                                    Subscription.prototype$patchAttributes(
                                        { id: sub.id },
                                        sub
                                    ).$promise.then(
                                        function(data) {
                                            // fatto, ora faccio refresh dei dati
                                            AlertMessageService.showSuccessMessage();
                                            vm.dtServicesInstance.DataTable.draw();
                                        });
                                });
                        }
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        };


        function DeleteDialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DeleteDialogController.inject = ['$scope', '$mdDialog'];


        /**
         * @deprecated vedi vm.gotoPaymentWindow()
         */
        function PaymentDialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        PaymentDialogController.inject = ['$scope', '$mdDialog'];


        /**
         * launches reloading dataTable data
         */
        vm.reloadDatatableItems = function() {
            $log.debug('vm.reloadDatatableItems()');
            vm.dtServicesInstance.DataTable.draw();
        };



        vm.goToSubscriptionPayments = function(subscriptionId) {
            $state.go('app.pages_subscription_payments', { subscriptionId: subscriptionId });
        };


        vm.gotoUserProfile = function(userId) {
            $state.go('app.pages_user_detail', {userId: userId, organizationId: vm.organizationId});
        };


        vm.gotoNuovoTesserato = function() {
            $state.go('app.pages_memberships_new', {organizationId: vm.organizationId});
        };


        vm.gotoImpostazioni = function() {
            $state.go('app.organization_settings', {organizationId: vm.organizationId});
        };


        vm.gotoPaymentWindow = function(subscriptionId) {
            // console.log('vm.gotoPaymentWindow()');
            try {
                // first search for subscription
                var subscription = vm.subscriptions.find(function(element) {
                    return element && element.id && element.id === subscriptionId;
                });
                sessionStorage.setItem('payModalState', JSON.stringify({
                    backState: $state.current.name,
                    backParams: $state.params,
                }));
                $state.go('app.pages_payments_pay', {
                    organizationId: vm.organizationId,
                    subscriptionId: subscription.id,
                    userId: subscription.userId,
                    amount: 0 + (subscription.todayDue - subscription.todayPaid),
                });
            } catch (e) {
                $log.error(e);
            }
        };


    }//MembershipsIndexController
})();

(function (){
    'use strict';

    angular
        .module('app.pages.legal', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.legal_gdpr_settings', {
                url      : '/legal/gdpr-settings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/legal/gdpr-settings/gdpr-settings.html',
                        controller : 'LegalGdprSettingsController as vm'
                    }
                }
            })
            .state('app.legal_personal_data_policy_it', {
                url      : '/legal/personal-data/it',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/legal/personal-data-policy/it.html',
                        controller : 'PersonalDataPolicyController as vm'
                    }
                }
            })
            .state('app.legal_cookie_policy_it', {
                url      : '/legal/cookie-policy/it',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/legal/cookie-policy/it.html',
                        controller : 'CookiePolicyController as vm'
                    }
                }
            })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.legal')
        .controller('PersonalDataPolicyController', PersonalDataPolicyController);

    /** @ngInject */
    function PersonalDataPolicyController() {
        var vm = this;


        /**
         * Inizializza la pagina
         */
        vm.init = function() {
            //
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.legal')
        .controller('LegalGdprSettingsController', LegalGdprSettingsController);

    /** @ngInject */
    function LegalGdprSettingsController($log, $state, $window, AuthenticationService,
                                         ApiPath, AlertMessageService, User) {
        var vm = this;
        var self = this;

        // Data
        vm.currentUserId = null;
        vm.user = null;
        vm.loadingUser = false;


        /**
         * Inizializza la pagina
         */
        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                vm.loadingUser = true;
                User.findById({
                    id: vm.currentUserId
                }).$promise.then(
                    function(user) {
                        vm.user = JSON.parse(JSON.stringify(user));
                        // $log.debug('Caricato utente: ' + JSON.stringify(vm.user));
                        vm.loadingUser = false;
                    },
                    function(err) {
                        $log.error('Errore caricando utente');
                        $log.error(err);
                        vm.loadingUser = false;
                        $state.go('app.pages_auth_login');
                    });
            } else {
                $state.go('app.pages_auth_login');
            }
        };



        /**
         * Salva l'utente con i consensi aggiornati
         */
        vm.savePreferences = function() {
            User.saveUser({
                user: vm.user,
                organizationId: ''
            }).$promise.then(
                    function(updatedUser) {
                        $log.debug('Aggiornamento effettuato');
                        AlertMessageService.showSuccessMessage();
                        // $window.location.reload();
                        // $state.reload();
                        $state.go('app.dispatcher');
                    },
                    function(err) {
                        $log.error('Errore aggiornando utente');
                        $log.error(err);
                        AlertMessageService.showErrorAlert(err.data && err.data.error);
                    }
            );
        };


        vm.goToPrivacyPolicy = function() {
            $state.go('app.legal_personal_data_policy_it');
        };

        vm.goToCookiePolicy = function() {
            $state.go('app.legal_cookie_policy_it');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.legal')
        .controller('CookiePolicyController', CookiePolicyController);

    /** @ngInject */
    function CookiePolicyController() {
        var vm = this;


        /**
         * Inizializza la pagina
         */
        vm.init = function() {
            //
        };


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.resetpwd', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_resetpwd', {
            url      : '/pages/auth/reset/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_resetpwd': {
                    templateUrl: 'app/main/pages/auth/reset/reset.html',
                    controller : 'ResetPwdController as vm'
                }
            }            
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.resetpwd')
        .controller('ResetPwdController', ResetPwdController);

    /** @ngInject */
    function ResetPwdController($state, $location, $log, AuthenticationService, User, AlertMessageService, $translate)
    {
        var vm = this;
        var myToken = $state.params.token;

        User.activateReset({token:myToken},
            function(value){
                if (value && value!==null && value.user && value.user!==null) {
                    $state.go('app.pages_auth_token_set_pwd', {token:myToken, userId:value.user.id });
                } else {
                    AlertMessageService.showErrorAlert($translate.instant('CHANGE_PWD.INVALID_PASSWORD'));
                    $state.go('app.pages_auth_login');
                }
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showAlert($translate.instant('PAGES.WARNING'), $translate.instant('CHANGE_PWD.INVALID_LINK'));
                $state.go('app.pages_auth_login');
            });


    }

})();



(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        }).state('app.pages_auth_register_custom', {
            url      : '/pages/auth/:clubyourlifeId/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register_custom': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($log, $scope, $location, User, AlertMessageService, $translate, $state, $rootScope, Organization, ApiPath, DefaultBackgroundUrl )
    {
        // Data
        var vm = this;

        vm.apiPath=ApiPath;
        vm.pageStyle={
            'background-repeat' :'no-repeat'
        };
        vm.organization={};
        vm.clubyourlifeId=$state.params.clubyourlifeId;
        vm.goToLogin=goToLogin;

        vm.confirmNotificationSent = false;     // se true, ha appena inviato la notifica di utente da attivare

        vm.form = {
        };

        vm.doRegister = doRegister;

        init();

        // Methods
        vm.checkPwd=checkPwd;

        function init(){
            $log.debug("User Registration")

            //se arrivo alla mia pagina dal cylId allora customizzo la pagina cercando la giusta parte di sfondi
            if ($state.params.clubyourlifeId) {
                findOrganizationByCylID($state.params.clubyourlifeId).then(
                    function(data) {
                        decorateOrganization( (data && data!==null && data.length===1) ? data[0] : null);
                    }
                );
            } else {
                decorateOrganization(null);

            }

        }

        function goToLogin(){

            $location.url('/pages/auth/login');
        }

        function doRegister(){
            var user = vm.form;

            //creo il display name
            var nome = user.givenName.toLowerCase();
            var cognome = user.familyName.toLowerCase();
            user.displayName = nome.charAt(0).toUpperCase() + nome.slice(1) + " "+cognome.charAt(0).toUpperCase() + cognome.slice(1);

            user.created=new Date();
            user.lastUpdated=new Date();

            if (!checkPwd(user)) {
            	return;
            }

            // chiama API per registrare unj  nuovo utente
            User.registerNewUser({"userData": user}, function(registrationResult){
                if (!registrationResult.result.error) {
                    $log.debug('registrazione utente ok');
                    // se ha creato l'utente
                    if (registrationResult.result && registrationResult.result.created) {
                        $log.debug('utente creato');
                        // mostra sezione conferma email
                        AlertMessageService.showAlert($translate.instant('REGISTER.SUCCESS'), $translate.instant('REGISTER.SUCCESS_MESSAGE'));
                        vm.confirmNotificationSent = true;
                        $state.go('app.pages_auth_login');
                    }
                    // se l'utente esisteva già
                    else {
                        $log.debug('utente già esistente');
                        // se l'utente era già attivo
                        if (registrationResult.result && registrationResult.result.userActive) {
                            $log.debug('utente già attivo, puoi fare login');
                            // avvisa e rimanda alla pagina di login
                            AlertMessageService.showAlert($translate.instant('REGISTER.ERRORS.REGISTRATION_EXISTING_TITLE'), $translate.instant('REGISTER.ERRORS.REGISTRATION_EXISTING_MESSAGE'));
                            $state.go('app.pages_auth_login');
                        } else {
                            $log.debug('utente non ancora attivato, mail di registrazione reinviata');
                            // mostra sezione conferma email
                            vm.confirmNotificationSent = true;
                            AlertMessageService.showAlert($translate.instant('REGISTER.SUCCESS'), $translate.instant('REGISTER.SUCCESS_MESSAGE'));
                            $state.go('app.pages_auth_login');
                        }
                    }
                }
                // se registrazione fallita
                else {
                    $log.debug('registrazione utente fallita');
                    // avvisa e rimani qui
                    AlertMessageService.showErrorAlert($translate.instant('REGISTER.ERRORS.REGISTRATION_FAILED'));
                }
            });
        };

        //////////
        function checkPwd(user) {
        	if (user.password.length < 8) {
        		AlertMessageService.showErrorAlert($translate.instant('REGISTER.ERRORS.PASSWORD_MIN_8_CHARS'));
        		return false
        	}
        	else if (user.password &&  user.passwordConfirm
        			&& user.password!==user.passwordConfirm) {
        		AlertMessageService.showErrorAlert($translate.instant('REGISTER.ERRORS.PASSWORD_CONFIRM_NOT_EQUALS'));
        		return false

        	}

        	return true;
        }

        function countUserByMail(mail, callback){
        	var query ={
                where : {email: mail}
            }
            User.count(query, function(users) {
                  callback(users);
            });
        }


        function goToLogin() {
            if (vm.clubyourlifeId && vm.clubyourlifeId!=='') {
                $state.go('app.pages_auth_login_custom', {clubyourlifeId: vm.clubyourlifeId});
            }
            else {
                $state.go('app.pages_auth_login');
            }
        }



        function findOrganizationByCylID(clubyourlifeId) {
            return Organization.find({filter:{
                where : {
                    clubyourlifeId:clubyourlifeId
                }
            }
            }).$promise;
        }

        function decorateOrganization(org) {
            if (org && org!==null) {
                vm.organization = org;
                vm.pageStyle['background-image'] = "url('"+vm.apiPath+"/organizationDocumentsContainers/"+$rootScope.CYL_ORG_DOC_PREFIX + vm.organization.id + "/download/"+vm.organization.uriBackgroundImage+"')";
            } else {
                vm.organization=null;
                vm.pageStyle['background-image'] = "url('"+DefaultBackgroundUrl+"')";
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        }).state('app.pages_auth_login_custom', {
            url      : '/pages/auth/:clubyourlifeId/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login_custom': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($log, $state, $window, $scope, $translate, $mdDialog, AuthenticationService, ApiPath, $rootScope, User, AlertMessageService, Organization, DefaultBackgroundUrl)
    {
        // Data
        var vm = this;
        vm.apiPath=ApiPath;
        vm.pageStyle={
            'background-repeat' :'no-repeat'
        };
        vm.organization={};
        vm.clubyourlifeId=$state.params.clubyourlifeId;
        vm.goToRegistration=goToRegistration;
        vm.goToForgotPassword=goToForgotPassword;
        vm.goToPrivacyPolicy=goToPrivacyPolicy;

        vm.form = {
            email: "",
            password: ""
        }


        // Methods
        vm.doLogin = doLogin;

        vm.facebookLogin = function(){
            $window.location.href = ApiPath + "/auth/facebook";
        }

        vm.googleLogin = function(){
            $window.location.href = ApiPath + "/auth/google";
        }

        init();

        ////////////
        function init(){
            // effettua logout solo se necessario
            if (sessionStorage.getItem('$LoopBack$accessTokenId')) {
                User.logout(
                    {},
                    {},
                    function(value, responseHeaders){
                        localStorage.clear();
                        AuthenticationService.clearCookie();
                    },
                    function(error){
                        localStorage.clear();
                        AuthenticationService.clearCookie();
                    });
            } else {
                localStorage.clear();
                AuthenticationService.clearCookie();
            }

        	//se arrivo alla mia pagina dal cylId allora customizzo la pagina cercando la giusta parte di sfondi
        	if ($state.params && $state.params.clubyourlifeId) {
                findOrganizationByCylID($state.params.clubyourlifeId).then(
                    function(data) {
                        //se ho trovato la mia associazione per cylID allora tengo in sessione questo dato in modo che poi lo uso in logout e in redirezioni varie
                        if ((data && data!==null && data.length===1)) {
                            sessionStorage.setItem('clubyourlifeId', $state.params.clubyourlifeId);
                        } else {
                            sessionStorage.setItem('clubyourlifeId', null);
                        }
                        decorateOrganization( (data && data!==null && data.length===1) ? data[0] : null);
                    },
                    function(err) {
                        decorateOrganization(null);
                        sessionStorage.setItem('clubyourlifeId', null);
                    }
                );
        	} else {
                decorateOrganization(null);
                sessionStorage.setItem('clubyourlifeId', null);
        	}

        }

        function doLogin(){
            AuthenticationService.login(vm.form.email,vm.form.password).then(
                function(value, responseHeaders){

                    if (value.user.activationToken && value.user.activationToken!=='') {
                        AlertMessageService.showAlert($translate.instant('LOGIN.NOT_ACTIVATED_TITLE'), $translate.instant('LOGIN.NOT_ACTIVATED_MESSAGE'));
                        AuthenticationService.clearCookie();
                        return;
                    }

                    //Mi sottoscrivo alla chat dopo il login
            		$rootScope.$emit('LOGIN_EVENT', value);

                    $state.go("app.dispatcher");


                },
                function(error){
                    $log.debug('Login errato');
                    alertWrongLogin();
                });
        }


        function alertWrongLogin(){
            $translate(['LOGIN.BAD_CREDENTIALS.TITLE','LOGIN.BAD_CREDENTIALS.CONTENT','LOGIN.BAD_CREDENTIALS.CONFIRM'])
            .then(function (translations) {
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title(translations['LOGIN.BAD_CREDENTIALS.TITLE'])
                    .textContent(translations['LOGIN.BAD_CREDENTIALS.CONTENT'])
                    .ariaLabel('Login Error')
                    .ok(translations['LOGIN.BAD_CREDENTIALS.CONFIRM'])
                );
              }, function (translationId) {

              });
        }




        function goToRegistration() {
            if (vm.clubyourlifeId && vm.clubyourlifeId!=='') {
                $state.go('app.pages_auth_register_custom', {clubyourlifeId: vm.clubyourlifeId});
            }
            else {
                $state.go('app.pages_auth_register');
            }
        }

        function goToForgotPassword() {
            if (vm.clubyourlifeId && vm.clubyourlifeId!=='') {
                $state.go('app.pages_auth_forgot-password_custom', {clubyourlifeId: vm.clubyourlifeId});
            }
            else {
                $state.go('app.pages_auth_forgot-password');
            }
        }

        function goToPrivacyPolicy() {
            $state.go('app.organization_privacy', {clubyourlifeId: vm.clubyourlifeId});
        }


        function findOrganizationByCylID(clubyourlifeId) {
            return Organization.find({filter:{
                where : {
                    clubyourlifeId:clubyourlifeId
                }
            }
            }).$promise;
        }

        function decorateOrganization(org) {
            if (org && org!==null) {
                vm.organization = org;
                vm.pageStyle['background-image'] = "url('"+vm.apiPath+"/organizationDocumentsContainers/"+$rootScope.CYL_ORG_DOC_PREFIX + vm.organization.id + "/download/"+vm.organization.uriBackgroundImage+"')";
            } else {
                vm.organization=null;
                vm.pageStyle['background-image'] = "url('"+DefaultBackgroundUrl+"')";
            }
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot_password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'login'
        }).state('app.pages_auth_forgot-password_custom', {
            url      : '/pages/auth/:clubyourlifeId/forgot-password',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password_custom': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot_password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($log, $state, $window, $scope, $translate, AlertMessageService,
                            AuthenticationService, ApiPath, $rootScope, User, $location, Organization,DefaultBackgroundUrl)
    {
        $log.debug('ForgotPasswordController()');
        var vm = this;
        
        vm.apiPath=ApiPath;
        vm.pageStyle={
            'background-repeat' :'no-repeat'
        };
        vm.organization={};
        vm.clubyourlifeId=$state.params.clubyourlifeId;
        
        vm.email = null;
        vm.working = false;
        vm.sent = false;
        vm.error = null;

        init();

        
        function init(){
            $log.debug('ForgotPasswordController.init()');
            
            //se arrivo alla mia pagina dal cylId allora customizzo la pagina cercando la giusta parte di sfondi
            if ($state.params.clubyourlifeId) {
                findOrganizationByCylID($state.params.clubyourlifeId).then(
                    function(data) {
                        decorateOrganization( (data && data!==null && data.length===1) ? data[0] : null);
                    }
                );
            } else {
                decorateOrganization(null);

            }
                               
        }




        /**
         * Chiama l'API che invia l'email con il link per poter resettare la password
         */
        vm.sendResetPasswordNotification = function() {
            $log.debug('sendResetPasswordNotification()');
            vm.working=true;
            // invia email di reset password
            User.sendResetPasswordUrl({email: vm.email}).$promise.then(
                function(returnStatus){
                    // quando ha terminato
                    $log.debug('reset password url notification sent');
                    vm.working=false;
                    vm.sent=true;
                },
                function(err) {
                    // quando ha terminato
                    vm.working=false;
                    $log.debug('error sending reset password url notification');
                    vm.error = 'Failed sending reset password email';
                }
            );
        }
        
        
        
        
        function findOrganizationByCylID(clubyourlifeId) {
            return Organization.find({filter:{
                where : {
                    clubyourlifeId:clubyourlifeId
                }
            }
            }).$promise;
        }     
        
        function decorateOrganization(org) {
            if (org && org!==null) {
                vm.organization = org;
                vm.pageStyle['background-image'] = "url('"+vm.apiPath+"/organizationDocumentsContainers/"+$rootScope.CYL_ORG_DOC_PREFIX + vm.organization.id + "/download/"+vm.organization.uriBackgroundImage+"')";
            } else {
                vm.organization=null;
                vm.pageStyle['background-image'] = "url('"+DefaultBackgroundUrl+"')";
            }
        }              


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.changemailconfirm', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_changemailconfirm', {
            url      : '/pages/auth/changemailconfirm/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_changemailconfirm': {
                    templateUrl: 'app/main/pages/auth/changemailconfirm/changemailconfirm.html',
                    controller : 'ChangeMailConfirmController as vm'
                }
            }
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.changemailconfirm')
        .controller('ChangeMailConfirmController', ChangeMailConfirmController);

    /** @ngInject */
    function ChangeMailConfirmController($state, $location, $log, AuthenticationService, User, AlertMessageService, $translate)
    {
        var vm = this;
        var myToken = $state.params.token;

        User.changeEmailAddressFromToken({tokenId: myToken},
            function(value){
                AlertMessageService.showAlert('Operazione effettuata con successo', 'Puoi ora accedere utilizzando il nuovo indirizzo email');
                $state.go('app.pages_auth_login');
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showAlert($translate.instant('PAGES.WARNING'), $translate.instant('CHANGE_PWD.INVALID_LINK'));
                $state.go('app.pages_auth_login');
            });
    }

})();



(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.change_pwd', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_change_pwd', {
            url      : '/pages/auth/change_pwd',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_change_pwd': {
                    templateUrl: 'app/main/pages/auth/change_pwd/change-pwd.html',
                    controller : 'ChangePwdController as vm'
                }
            }
        })
        .state('app.pages_auth_token_set_pwd', {
            url      : '/pages/auth/set_pwd/:token/:userId',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_token_set_pwd': {
                    templateUrl: 'app/main/pages/auth/change_pwd/change-pwd.html',
                    controller : 'ChangePwdController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/change_pwd');


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.change_pwd')
        .controller('ChangePwdController', ChangePwdController);

    /** @ngInject */
    function ChangePwdController(AuthenticationService, AlertMessageService , User, $translate, $state, $rootScope, ApiPath, Organization, DefaultBackgroundUrl)
    {
        var vm = this;

        
        vm.apiPath=ApiPath;
        vm.pageStyle={
            'background-repeat' :'no-repeat'
        };
        vm.organization={};
        vm.clubyourlifeId=sessionStorage.getItem('clubyourlifeId');
        
        vm.form={};
        
        vm.doChangePwd=doChangePwd;

        // Methods
        init();
        
        function init() {
            
            //se arrivo alla mia pagina dal cylId allora customizzo la pagina cercando la giusta parte di sfondi
            if (vm.clubyourlifeId && vm.clubyourlifeId!=='') {
                findOrganizationByCylID().then(
                    function(data) {
                        decorateOrganization( (data && data!==null && data.length===1) ? data[0] : null);
                    }
                );
            } else {
                decorateOrganization(null);

            }            

            if ($state.params.token && $state.params.token!==null && $state.params.token!=='') {
                //SE SONO QUI SONO NEL CASO DI UN UTENTE CHE HA DIMENTICATO LA PWD oppure
                //CHE E' STATO ISCRITTO E DEVE ATTIVARSI: PERTANTO MI ACCERTO DI NON AVERE SESSIONI APERTE
                //E FORZO UN LOGOUT
                User.logout(
                    {},
                    {},
                    function(value, responseHeaders){
                        localStorage.clear();
                        AuthenticationService.clearCookie();
                    },
                    function(error){
                        localStorage.clear();
                        AuthenticationService.clearCookie();
                    });         
                AuthenticationService.clearCookie();
                
                vm.user = {};
                vm.user.id =$state.params.userId;
                vm.user.resetPwdToken =$state.params.token;
                vm.user.flgMustResetPwd =true;
            }            
            else if (AuthenticationService.isAuthenticated()){
				AuthenticationService.loggedUser().then(
				function(value,headers){
                    vm.user = value;
				});
			}

        }

        //////////
        function doChangePwd() {
        	//prendo l'utente corrente
        	if (!vm.user.flgMustResetPwd) {
        		//se è un cambio password voluto allora verifico la pwd corrente
        		AuthenticationService.checkPwd(vm.user.email,vm.form.password).then(
    				function(value, responseHeaders){
    					_doChangePwd();                 
    				},
    				function(error){
    					AlertMessageService.showErrorAlert($translate.instant('CHANGE_PWD.INVALID_PASSWORD'));
    				});
        	}
        	else {
        		_doChangePwd();
        	}

        }
        
        //////////
        
        function _doChangePwd() {
        	if (_checkPwd()) {
        	   if (vm.user.resetPwdToken && vm.user.resetPwdToken!==null) {
               	   User.findByIdAndToken({id:vm.user.id.toString(), token:vm.user.resetPwdToken}).$promise.then(function(value){   	
	       				if (value && value!==null && value.user && value.user!==null) {
	       					var myUser = value.user;
	       					User.changePwdAfterReset({userId:vm.user.id.toString(), token: vm.user.resetPwdToken,newPwd: vm.form.passwordNew}).$promise.then(
	             					function(response) {
	             			            AuthenticationService.login(myUser.email,vm.form.passwordNew).then(
	             			                  function(value, responseHeaders){
	             			                	  //Mi sottoscrivo alla chat dopo il login
	             			              		  $rootScope.$emit('LOGIN_EVENT', value);
	             			                      $state.go("app.dispatcher");
	             			                  },
	             			                  function(error){
	             			                      $log.debug('Login errato');
	             			                      alertWrongLogin();
	             			                  });
	             					},
	                 				function(error){
	                 					AlertMessageService.showErrorAlert(error);
	                 				});                     
	    				}
	                    else {
	    					AlertMessageService.showErrorAlert($translate.instant('CHANGE_PWD.INVALID_PASSWORD'));
	    					$state.go('app.pages_auth_login');
	                    }
               	   });
        		   
        	   }
        	   else {
               	   User.findById({id:vm.user.id}).$promise.then(function(user){  
                	   user.$prototype$changePwd({newPwd: vm.form.passwordNew}).then(
             					function(response) {
             						AlertMessageService.showSuccessMessage();
                             		$state.go("app.dispatcher");
             					},
                 				function(error){
                 					AlertMessageService.showErrorAlert(error);
                 				});                		   
               	   });

        	   }
        	}
        }
        
        function _checkPwd() {
        	if (vm.form.passwordNew.length < 8) {
        		AlertMessageService.showErrorAlert($translate.instant('REGISTER.ERRORS.PASSWORD_MIN_8_CHARS'));
        		return false
        	}
        	else if (vm.form.passwordNew &&  vm.form.passwordConfirm 
        			&& vm.form.passwordNew!==vm.form.passwordConfirm) {
        		AlertMessageService.showErrorAlert($translate.instant('REGISTER.ERRORS.PASSWORD_CONFIRM_NOT_EQUALS'));
        		return false

        	}
        	
        	return true;
        }
        
        
        
        function findOrganizationByCylID() {
            return Organization.find({filter:{
                where : {
                    clubyourlifeId:vm.clubyourlifeId
                }
            }
            }).$promise;
        }     
        
        function decorateOrganization(org) {
            if (org && org!==null) {
                vm.organization = org;
                vm.pageStyle['background-image'] = "url('"+vm.apiPath+"/organizationDocumentsContainers/"+$rootScope.CYL_ORG_DOC_PREFIX + vm.organization.id + "/download/"+vm.organization.uriBackgroundImage+"')";
            } else {
                vm.organization=null;
                vm.pageStyle['background-image'] = "url('"+DefaultBackgroundUrl+"')";
            }
        }              
        
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.activate', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_activate', {
            url      : '/pages/auth/activate/:token',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_activate': {
                    templateUrl: 'app/main/pages/auth/activateuser/activateuser.html',
                    controller : 'ActivateUserController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/activateuser');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.activate')
        .controller('ActivateUserController', ActivateUserController);

    /** @ngInject */
    function ActivateUserController($log, $state, $window, $scope, $translate, AlertMessageService,
                            AuthenticationService, ApiPath, $rootScope, User, $location, DefaultBackgroundUrl)
    {
        $log.debug('ActivateUserController()');
        var vm = this;
        vm.token = null;
        vm.user = null;
        vm.message = "";
        vm.activating = false;
        vm.pageStyle={
            'background-repeat' :'no-repeat',
            'background-image' : "url('"+DefaultBackgroundUrl+"')"                    
        };
        
        init();

        
        function init(){
            $log.debug('ActivateUserController.init()');
            // read activation token from URL
            if ($state.params.token && ($state.params.token !== null)) {
                vm.token = $state.params.token;
                $log.debug('token: ' + vm.token);
                vm.activating = true;
                User.activateNewUser({"activationToken": vm.token}).$promise.then(
                    function(user){
                        $log.debug('utente attivato');
                        $log.debug(user);
                        vm.user = user;
                        // informa utente e mostra link per login
                        vm.message = "activated";
                    },
                    function(err){
                        $log.debug('errore in attivazione utente');
                        $log.debug(err);
                        // informa utente e mostra link per login e registrazione
                        vm.message = "activationError";
                    }
                );
            } else {
                $log.debug('token non valido o non indicato');
                // informa utente e mostra link per login e registrazione
                vm.message = "invalidToken";
            }
        }


        /**
         * 
         */
        vm.gotoRegister = function(){
            $state.go('app.pages_auth_register');
        };


        /**
         * 
         */
        vm.gotoLogin = function() {
            $state.go('app.pages_auth_login');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.attendances', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_attendances', {
            url      : '/attendances',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/attendances/attendances.html',
                    controller : 'AttendancesController as vm'
                }
            },
            bodyClass: 'attendances'
        }).state('app.pages_service_attendances', {
            url      : '/service_attendances',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/organizations/views/organization_services/organization_services.html',
                    controller : 'OrganizationServicesController as vm'
                }
            },
            bodyClass: 'attendances'
        }).state('app.pages_attendances_pre', {
            url      : '/attendances/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/attendances/attendances.html',
                    controller : 'AttendancesController as vm'
                }
            },
            bodyClass: 'attendances'
        }).state('app.pages_attendance_detail', {
            url      : '/attendance/:offeredServiceId/:day',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/attendances/attendance_detail.html',
                    controller : 'AttendanceDetailController as vm'
                }
            },
            bodyClass: 'attendances'
        }).state('app.pages_attendance_detail_service', {
            url      : '/attendance_service/:offeredServiceId/:day',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/attendances/attendance_detail.html',
                    controller : 'AttendanceDetailController as vm'
                }
            },
            bodyClass: 'attendances'
        }).state('app.pages_attendances_carnet_exchange', {
            url      : '/attendances_carnet_exchange/:organizationId/:orderIdLeft/:orderIdRight',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/attendances/carnet_exchange/attendances_carnet_exchange.html',
                    controller : 'AttendancesCarnetExchangeController as vm'
                }
            },
            bodyClass: 'attendances'
        })
        ;

        $translatePartialLoaderProvider.addPart('app/main/pages/attendances');


    }

})();

(function() {
    'use strict';

    angular.module('app.pages.attendances').controller(
        'AttendancesCarnetExchangeController', AttendancesCarnetExchangeController);

    /** @ngInject */
    function AttendancesCarnetExchangeController($log, $state, AuthenticationService, AlertMessageService,
                                                 Order, Attendance) {
        var vm = this;
        vm.organizationId = $state.params.organizationId;
        vm.orderIdLeft = $state.params.orderIdLeft;
        vm.orderIdRight = $state.params.orderIdRight;
        vm.orders = {
            left: null,
            right: null,
            changes: [],
        };


        /**
         * Inizializza il controller
         */
        vm.init = function() {
            // se sono autenticato
            if (AuthenticationService.isAuthenticated()) {
                vm.loadItems(vm.orderIdLeft, vm.orderIdRight);
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Normalizza i dati di un order
         * - decodifica la data della presenza
         * - elimina le presenze eliminate e non presenti
         *
         * @param {object} order
         * @return {object}
         */
        vm.normalizzaOrder = function(order) {
            order = JSON.parse(JSON.stringify(order));
            if (order && order.attendances) {
                // rimuove presenze eliminate
                order.attendances = _.filter(order.attendances, function(attendance) {
                    return (attendance && attendance.present);
                });
                // decodifica data presenza
                _.map(order.attendances, function(attendance) {
                    if (attendance && attendance.day) {
                        attendance.dtPresenza = moment(attendance.day, 'YYYY/MM/DD').add(12, 'hours').startOf('day').toDate();
                        attendance.status = null;
                    }
                });
                // ordina le presenze per data
                order.attendances = _.sortBy(order.attendances, function(attendance) {
                    return attendance.day;
                });
            }

            return order;
        };



        /**
         * Carica gi elementi da visualizzare
         */
        vm.loadItems = function(orderIdRight, orderIdLeft) {
            vm.orders = {
                left: null,
                right: null,
                changes: [],
            };
            Order.findById({
                id: orderIdLeft,
                filter: {
                    include: [
                        'attendances', 'offeredService'
                    ],
                },
            }).$promise.then(
                function(order) {
                    order = JSON.parse(JSON.stringify(order));
                    vm.orders.left = vm.normalizzaOrder(order);
                    $log.debug(vm.orders);
                }
            );
            Order.findById({
                id: orderIdRight,
                filter: {
                    include: [
                        'attendances', 'offeredService'
                    ],
                },
            }).$promise.then(
                function(order) {
                    order = JSON.parse(JSON.stringify(order));
                    vm.orders.right = vm.normalizzaOrder(order);
                    $log.debug(vm.orders);
                }
            );
        };


        /**
         * Accoda alla lista dei cambiamenti lo spostamento di una presenza da un order all'altro.
         * Modifica anche opportunamente l'elenco delle presenze
         *
         * @param {object} attendance Attendance da spostare
         * @param {object} orderFrom Order di partenza
         * @param {object} orderTo Order di arrivo
         */
        vm.moveAttendance = function(attendance, orderFrom, orderTo) {
            // spostamento dell'elemento dalla lista delle attendance
            if (attendance.status === null) {
                // se non è mai stata toccata, aggiunge il record al carnet di destinazione e segnalo eliminato dal carnet di partenza
                attendance.status = 'new';
                orderTo.attendances.push(JSON.parse(JSON.stringify(attendance)));       // copia l'attendance, indicandola come nuova
                attendance.status = 'deleted';                                          // indica come rimossa la precedente

                // aggiunge l'elemento dalla lista degli scambi
                vm.orders.changes.push(attendance);
            } else if (attendance.status === 'new') {
                // se era già stata spostata, annulla lo spostamento dal carnet di destinazione (era già lì)
                _.each(orderTo.attendances, function(currentAttendance) {
                    if (currentAttendance && currentAttendance.id === attendance.id) {
                        currentAttendance.status = null;
                    }
                });
                // e rimuove l'elemento dal carnet di partenza
                orderFrom.attendances = _.filter(orderFrom.attendances, function(currentAttendance) {
                    return (currentAttendance && currentAttendance.id !== attendance.id);
                });

                // rimuove l'elemento dalla lista degli scambi
                vm.orders.changes = _.filter(vm.orders.changes, function(changedAttendance) {
                    return (changedAttendance && changedAttendance.id !== attendance.id);
                });
            }
        };


        /**
         * Salva le modifiche
         *
         */
        vm.persist = function() {
            Attendance.exchangeAttendances({
                orderLeftId: vm.orders.left.id,
                orderRightId: vm.orders.right.id,
                changes: vm.orders.changes,
            }).$promise.then(
                function(changes) {
                    $log.debug('Attendance spostate');
                    $log.debug('changes: ' + JSON.stringify(changes));
                    AlertMessageService.showSuccessMessage();
                    vm.loadItems(vm.orderIdLeft, vm.orderIdRight);
                },
                function(err) {
                    AlertMessageService.showErrorAlert('Si sono verificati errori nello spostamento delle presenze!');
                    $log.error(err);
                }
            );
        };



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.chat', {
            url    : '/chat',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/chat');

//        // Navigation
//        msNavigationServiceProvider.saveItem('pages.chat', {
//            title : 'Chat',
//            icon  : 'icon-hangouts',
//            state : 'app.chat',
//            weight: 5
//        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($q, msApi)
    {
        
        var service = {
            chats         : {},
            contacts      : [],
            getContactChat: getContactChat
        };

        /**
         * Get contact chat from the server
         *
         * @param contactId
         * @returns {*}
         */
        function getContactChat(contactId)
        {

            // Create a new deferred object
            var deferred = $q.defer();

            // If contact doesn't have lastMessage, create a new chat
            if ( !service.contacts.getById(contactId).lastMessage)
            {
                service.chats[contactId] = [];

                deferred.resolve(service.chats[contactId]);
            }

            // If the chat exist in the service data, do not request
            if ( service.chats[contactId] )
            {
                deferred.resolve(service.chats[contactId]);
                
                return deferred.promise;
            }

            // Request the chat with the contactId
            msApi.request('chat.chats@get', {id: contactId},

                // SUCCESS
                function (response)
                {
                    // Attach the chats
                    service.chats[contactId] = response.data;

                    // Resolve the promise
                    deferred.resolve(service.chats[contactId]);
                },

                // ERROR
                function (response)
                {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.subscriptions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_subscriptions', {
            url      : '/subscriptions',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/subscriptions.html',
                    controller : 'SubscriptionsController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.pages_subscription', {
            url      : '/subscription/:subscriptionId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/subscription_detail.html',
                    controller : 'SubscriptionDetailController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.pages_subscription_payments', {
            url      : '/subscription/:subscriptionId/payments',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/subscription_payments.html',
                    controller : 'SubscriptionPaymentsController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.pages_subscriptions_pre', {
            url      : '/subscriptions/:organizationId/:offeredServiceId/:paymentsFilter/:documentsFilter/:userId/:dtEndRefPeriod/:hiddenColumns',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/organizations/views/organization_services/organization_services.html',
                    controller : 'OrganizationServicesController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.pages_subscriptions_person', {
            url      : '/subscriptions_person/:organizationId/:offeredServiceId/:paymentsFilter/:documentsFilter/:userId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/subscriptions.html',
                    controller : 'SubscriptionsController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.new_subcription', {
            url      : '/new_subscription/:offeredServiceId/org/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/new_subscription.html',
                    controller : 'SubscriptionNewController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.new_subcription_user', {
            url      : '/new_subscription_user/:userId/org/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/new_subscription.html',
                    controller : 'SubscriptionNewController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.renew_subscription', {
            url      : '/renew_subscription/:offeredServiceId/s/:subscriptionId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/renew_subscription.html',
                    controller : 'SubscriptionRenewController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.new_user_subcription', {
            url      : '/new_user_subscription/:userId/s/:offeredServiceId/org/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/new_subscription.html',
                    controller : 'SubscriptionNewController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.public_subscription', {
            url      : '/subscribe/:uuid',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.public_subscription': {
                    templateUrl: 'app/main/pages/subscriptions/public_subscription.html',
                    controller : 'PublicSubscriptionController as vm'
                }
            },
            bodyClass: 'subscriptions'
        }).state('app.public_subscription_success', {
            url      : '/public_subscription_success/:subscriptionId/success/:checkoutSessionId/:amount',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.public_subscription_success': {
                    templateUrl: 'app/main/pages/subscriptions/public_subscription_success.html',
                    controller : 'PublicSubscriptionSuccessController as vm'
                }
            },
            bodyClass: 'subscriptions'
        })
        // nuova subscription partendo da un servizio (chiede solo la personae il piando di pagamento)
        .state('app.pages_subscriptions_new_from_service', {
            url      : '/subscriptions/newfromservice/:offeredServiceId/org/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/subscriptions/new_from_service.html',
                    controller : 'NewSubscriptionFromServiceController as vm'
                }
            },
            bodyClass: 'subscriptions'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/subscriptions');

    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('SubscriptionsController', SubscriptionsController);

    /** @ngInject */
    function SubscriptionsController($rootScope, $scope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $mdDialog,
                                     Payment, $state, LoopBackAuth, ApiPath, CylUtils,
                                     $q, breadcrumbManager, $translate, AuthenticationService,  User, Organization,
                                     OfferedService, ServiceDoctype, SubscriptionDocument, AlertMessageService, _,
                                     PaymentReason, Order) {
        var vm = this;
        vm.currentUserId = null;                // current logged user
        vm.organizations = [];                  // current user's managed organizations
        vm.user = null;                         // user currerntly filtered
        vm.selectedOrganization = null;         // organization currently viewed
        vm.organizationServices = [];           // services offered by currently managed organization
        vm.isAdmin = null;                      // true if user is organization administrator (used only in some views)

        // datatable variables
        vm.dtSubscriptionsInstance = null;
        vm.dtSubscriptionsOptions = null;
        vm.dtSubscriptionsColumns = null;
        vm.searchFilter = {
            paymentStatus: (($state.params.paymentsFilter && $state.params.paymentsFilter !== null) ? $state.params.paymentsFilter : 'A' ),
            documentStatus: (($state.params.documentsFilter && $state.params.documentsFilter !== null) ? $state.params.documentsFilter : '' ),
            userId: (($state.params.userId && $state.params.userId !== '') ? $state.params.userId : '' ),
        };
        // override periodo di riferimento (se indico nell'URL la data di fine periodo)
        vm.overrideDtEndRefPeriodDate = $state.params.dtEndRefPeriod ? moment($state.params.dtEndRefPeriod, 'YYYYMMDD').toDate() : null;
        vm.overrideDtEndRefPeriod = $state.params.dtEndRefPeriod ? $state.params.dtEndRefPeriod : null;
        // periodo di riferimento (lo tengo qui per confrontarlo con l'eventuale periodo overridden)
        vm.refPeriod = null;

        // flag per nascondere delle colonne dall'elenco. Il valore è letto dai parametri dell'URL
        vm.hiddenColumns = $state.params.hiddenColumns || '';
        vm.hidePaymentsColumn = false;
        vm.hideDocumentsColumn = false;




        vm.init = function() {
            $log.debug('SubscriptionsController.vm.init()');
            $log.debug({state: $state});
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();

                // manage filters
                var isFromDashboard = ($state.current.name === 'app.pages_subscriptions_pre' || $state.current.name === 'app.pages_subscriptions_person');
                if ($rootScope.subcriptionsFilter && !isFromDashboard) {
                    vm.searchFilter = $rootScope.subcriptionsFilter;
                }
                if (!isFromDashboard) {
                    vm.searchFilter.userId = null;
                }
                if (vm.searchFilter.userId) {
                    vm.fetchUser(vm.searchFilter.userId).then(
                        function(user) {
                            vm.user = user;
                        });
                }

                // load current user and it managed organizations
                vm.fetchUser(vm.currentUserId).then(
                    function(user) {
                        vm.fetchManagedOrganizations(user);
                    }
                );

                // controlla se nascondere alcune colonne
                if (vm.hiddenColumns.toLowerCase().indexOf('d') >= 0) {
                    vm.hideDocumentsColumn = true;
                }
                if (vm.hiddenColumns.toLowerCase().indexOf('p') >= 0) {
                    vm.hidePaymentsColumn = true;
                }

                // initializes DataTable
                vm.initSubscriptionsTable();
                $rootScope.subscriptionsInited=true;
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Returns the html code to generate a button
         *
         * @param {string} label
         * @param {string} icon
         * @param {string} fn
         * @returns {string}
         */
        vm.getDtButtonHtml = function(label, icon, fn, disabled) {
            return '<md-button class="edit-button md-icon-button" ' +
                'title="' + label + '" aria-label="' + label + '" ng-click="' + fn + '" ' +
                (disabled ? 'ng-disabled="true" ' : '') + '>' +
                '    <md-icon md-font-icon="' + icon + '"></md-icon>' +
                '</md-button>';
        };


        /**
         * Services DataTable rendering methods
         */
        vm.renderDtSubscriptionsColumnServiceName = function(data, type, subscription) {
            return (subscription && subscription.offeredServiceName) ? subscription.offeredServiceName : 'Servizio senza nome';
        };
        vm.renderDtSubscriptionsColumnUserAvatar = function(data, type, subscription) {
            if (subscription && subscription.uriAvatar) {
                return '<img md-menu-align-target class="avatar" ' +
                    'src="' + vm.apiPath + '/userDocumentsContainers/' + $rootScope.CYL_USER_DOC_PREFIX + subscription.id +
                    '/download/' + subscription.uriAvatar + '">';
            } else {
                return '<img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg">';
            }
        };
        vm.renderDtSubscriptionsColumnUserName = function(data, type, subscription) {
            return subscription.familyName + ' ' + subscription.givenName + '<br />' +
                    ((subscription.email.endsWith(' invalid')) ? ' ' : subscription.email);
        };
        vm.renderDtSubscriptionsColumnUserPayments = function(data, type, subscription) {
            return '<ov-subscription-payments-status class="ov-cursor-pointer" ' +
                'ng-click="vm.gotoSubscriptionPayments(' + subscription.subscriptionId + ')" ' +
                'totaldue="' + subscription.totalDue + '" ' +
                'totalpaid="' + subscription.totalPaid + '" ' +
                'todaydue="' + subscription.todayDue + '" ' +
                'todaypaid="' + subscription.todayPaid + '" ' +
                '></ov-subscription-payments-status>';
        };
        vm.renderDtSubscriptionsColumnUserDocuments = function(data, type, subscription) {
            var s = '';
            _.each(subscription.docs, function(doc) {
                s += '<li>' + doc.name + ': ' + $translate.instant('OFFERED_SERVICES.DOC_STATUS.' + doc.status) + '</li>';
            });
            if (s !== '') {
                s = '<ul>' + s + '</ul>';
            }
            // dyndoc button, if present
            if (subscription.dyndocId) {
                s += vm.getDtButtonHtml($translate.instant('OFFERED_SERVICES.SUBSCRIPTION_FORM'), 'icon-eye', 'vm.gotoPayments(' + subscription.subscriptionId + ');');
            }
            return s;
        };
        vm.renderDtSubscriptionsColumnActions = function(data, type, subscription) {
            var s = '';
            var isBtnPaymentDisabled = subscription.paymentMissingToDate <= 0;
            if (!vm.hidePaymentsColumn) {
                // vecchio pagamento con modal
                // s += vm.getDtButtonHtml('Inserisci pagamento', 'icon-currency-eur', 'vm.askPaymentDetails($event, ' + subscription.userId + ', ' + subscription.subscriptionId + ', ' + (subscription.todayDue - subscription.todayPaid) + ');', isBtnPaymentDisabled);
                s += vm.getDtButtonHtml('Inserisci pagamento', 'icon-currency-eur', 'vm.gotoPay(' + $state.params.organizationId + ', ' + subscription.subscriptionId + ', ' + subscription.userId + ', ' + (subscription.todayDue - subscription.todayPaid) + ');', isBtnPaymentDisabled);
            }
            if (!vm.hideDocumentsColumn) {
                s += vm.getDtButtonHtml($translate.instant('OFFERED_SERVICES.SUBSCRIBER.VALIDATE_DOCS'),
                    'icon-file-document',
                    'vm.gotoDocumentsValidation(' + subscription.subscriptionId + ', ' + subscription.offeredServiceId + ', ' + subscription.userId + ');',
                    false);
            }
            s += vm.getDtButtonHtml($translate.instant('OFFERED_SERVICES.EDIT'), 'icon-pencil', 'vm.gotoEditSubscriber(' + subscription.subscriptionId + ', ' + subscription.offeredServiceId + ');', false);
            return s;
        };


        /**
         * Retrieve data for Subscriptions Datatable
         */
        vm.loadDtSubscriptionsItems = function(sSource, aoData, fnCallback, oSettings) {
            $log.debug('vm.loadDtSubscriptionsItems()');
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;


            // versione che usa la nuova funzione
            if (vm.selectedOrganization && vm.selectedOrganization.id) {
                // legge periodi di riferimento impostato
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    var dateFrom = null, dateTo = null;
                    if (refPeriod) {
                        dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : 20000101;
                        dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : 29991231;
                    }
                    // copio il periodi di riferimento per mostrarlo all'utente
                    vm.refPeriod = {
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        dtFrom: moment(refPeriod.dateFrom).toDate(),
                        dtTo: moment(refPeriod.dateTo).toDate(),
                    };
                    // apply filters
                    vm.searchFilter.organizationId = vm.selectedOrganization.id;
                    vm.searchFilter.dateFrom = dateFrom;
                    vm.searchFilter.dateTo = vm.overrideDtEndRefPeriod ? vm.overrideDtEndRefPeriod : dateTo;  // se è passata come parametro la data di fine periodo di riferimento usala, altrimenti usa quella del selettore in alto
                    if (vm.searchFilter.service && vm.searchFilter.service.id) {
                        vm.searchFilter.serviceId = vm.searchFilter.service.id; // mantengo per ogni evenienza
                        vm.searchFilter.offeredServiceId = vm.searchFilter.service.id;
                    } else {
                        delete vm.searchFilter.serviceId;   // mantengo per ogni evenienza
                        delete vm.searchFilter.offeredServiceId;
                    }
                    $rootScope.subcriptionsFilter = vm.searchFilter;
                    $rootScope.subcriptionsOrganization = vm.selectedOrganization;
                    // $log.debug('vm.searchFilter: ' + JSON.stringify(vm.searchFilter));

                    // start query
                    Organization.subscribersList(vm.searchFilter).$promise.then(
                        function(subscribers) {
                            subscribers = JSON.parse(JSON.stringify(subscribers));
                            $log.debug('Risultato di Organization.subscribersList():');
                            $log.debug({subscribers: subscribers});

                            // filters elements #
                            // $log.debug('Filtro elementi per pagina.');
                            // $log.debug('Elementi totali: ' + subscribers.length);
                            // $log.debug('Pagina: ' + start + ' - ' + length);
                            var recordsTotal = subscribers.length;
                            var i = 0;
                            var items = [];
                            _.each(subscribers, function(item) {
                                if (i >= start && i < start+length) {
                                    items.push(item);
                                }
                                i++;
                            });
                            // $log.debug('Elementi filtrati: ' + items.length);
                            subscribers = JSON.parse(JSON.stringify(items));
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': recordsTotal,
                                'recordsFiltered': recordsTotal,
                                'data': subscribers,
                            });
                        },
                        function(err) {
                            $log.error('Errore chiamando Organization.subscribersList():');
                            $log.error(err);
                            fnCallback({
                                'draw': draw,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': []
                            });
                        }
                    );
                });

            // }
            // // versione precedente, parcheggiata
            // else if (false && vm.selectedOrganization) {
            //     // load reference period
            //     breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
            //         Organization.findById({
            //             id: vm.selectedOrganization.id,
            //         }).$promise.then(
            //             function(organization) {
            //                 $log.debug('organization: ' + JSON.stringify(organization));
            //                 // read reference period
            //                 var dateFrom = null, dateTo = null;
            //                 if (refPeriod) {
            //                     dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
            //                     dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
            //                 }
            //                 // apply filters
            //                 if (vm.searchFilter.service && vm.searchFilter.service.id !== null) {
            //                     vm.searchFilter.serviceId = vm.searchFilter.service.id;
            //                 } else {
            //                     delete vm.searchFilter.serviceId;
            //                 }
            //                 $rootScope.subcriptionsFilter = vm.searchFilter;
            //                 $rootScope.subcriptionsOrganization = vm.selectedOrganization;
            //                 vm.searchFilter.dateFrom = dateFrom;
            //                 vm.searchFilter.dateTo = dateTo;
            //
            //                 // read subscriptions
            //                 organization.$prototype$allSubscribers(vm.searchFilter).then(
            //                     function(response) {
            //                         vm.serviceSubscribers = response.result.users;
            //
            //                         // filters elements #
            //                         var recordsTotal = vm.serviceSubscribers.length;
            //                         var i = 0;
            //                         var items = [];
            //                         _.each(vm.serviceSubscribers, function(item) {
            //                             if (i >= start && i < start+length) {
            //                                 items.push(item);
            //                             }
            //                             i++;
            //                         });
            //                         vm.serviceSubscribers = items;
            //
            //                         $log.debug('subscribers: ' + JSON.stringify(vm.serviceSubscribers));
            //                         fnCallback({
            //                             'draw': draw,
            //                             'recordsTotal': recordsTotal,
            //                             'recordsFiltered': recordsTotal,
            //                             'data': vm.serviceSubscribers
            //                         });
            //                     }, function(error) {
            //                         $log.error('organization.$prototype$allSubscribers() failed');
            //                         $log.debug(error);
            //                     });
            //             },
            //             function(err) {
            //                 $log.error('Organization.findById() failed');
            //             }
            //         );
            //     });

            } else {
                fnCallback({
                    'draw': draw,
                    'recordsTotal': 0,
                    'recordsFiltered': 0,
                    'data': []
                });
            }
        };


        /**
         * Initializes DataTable
         */
        vm.initSubscriptionsTable = function() {
            vm.dtSubscriptionsOptions = DTOptionsBuilder
                .newOptions()
                .withOption('serverSide', true)
                .withFnServerData(vm.loadDtSubscriptionsItems)  // TODO
                .withDataProp('data')
                .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
                .withOption('responsive', true)
                .withOption('autoWidth', false)
                .withDisplayLength(50)
                .withPaginationType('full_numbers')
                .withOption('createdRow', function(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                })
                .withOption('headerCallback', function(header) {
                    if (!vm.headerCompiled) {
                        // Use this headerCompiled field to only compile header once
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            ;
            vm.dtSubscriptionsColumns = [
                DTColumnBuilder.newColumn('userAvatar').withTitle('').notSortable().renderWith(vm.renderDtSubscriptionsColumnUserAvatar),
                DTColumnBuilder.newColumn('userName').withTitle('Nome').notSortable().renderWith(vm.renderDtSubscriptionsColumnUserName),
                DTColumnBuilder.newColumn('serviceName').withTitle('Servizio').notSortable().renderWith(vm.renderDtSubscriptionsColumnServiceName),
            ];
            if (!vm.hidePaymentsColumn) {
                vm.dtSubscriptionsColumns.push(DTColumnBuilder.newColumn('userPayments').withTitle('Pagamenti').notSortable().renderWith(vm.renderDtSubscriptionsColumnUserPayments));
            }
            if (!vm.hideDocumentsColumn) {
                vm.dtSubscriptionsColumns.push(DTColumnBuilder.newColumn('userDocuments').withTitle('Documenti').notSortable().renderWith(vm.renderDtSubscriptionsColumnUserDocuments));
            }
            vm.dtSubscriptionsColumns.push(DTColumnBuilder.newColumn('actions').withTitle('Azioni').notSortable().renderWith(vm.renderDtSubscriptionsColumnActions));
        };


        /**
         * Update Datatable's locale
         */
        vm.updateSubscriptionsTableLocale = function() {
            vm.dtSubscriptionsOptions.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
        };


        /**
         * launches reloading dataTable data
         */
        vm.reloadSubscriptionsTableItems = function() {
            vm.dtSubscriptionsInstance.DataTable.draw();
        };


        /**
         * Load a user by id
         *
         * @param {number} userId
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchUser = function(userId) {
            return User.findById({ id: userId }).$promise;
        };


        /**
         * fetches user managed organizations
         *
         * @param {User} user
         * @returns {Resource.$promise|*|_.$promise}
         */
        vm.fetchManagedOrganizations = function(user) {
            return user.$prototype$allOrganizations().then(
                function(data){
                    // extract administered organizations
                    var administeredOrganizations = _.filter(data.result.organizations, function(o) {
                        return o.isAdmin===true;
                    });
                    vm.organizations = administeredOrganizations;

                    if (vm.organizations && vm.organizations.length>0) {
                        var myOrganization=null;
                        //prendo eventuale organizzazione passata in ingresso oppure la prima se questa non c'è
                        if ($state.params.organizationId && $state.params.organizationId!==null) {
                            var tmp = _.filter(vm.organizations, function(o) {
                                return o.id.toString() == $state.params.organizationId;
                            });
                            myOrganization = tmp[0];
                        } else {
                            myOrganization = vm.organizations[0];
                            if ($rootScope.subcriptionsOrganization) {
                                myOrganization= $rootScope.subcriptionsOrganization;
                            }
                        }
                        // set isAdmin value
                        if (myOrganization && myOrganization.isAdmin) {
                            vm.isAdmin = true;
                        }
                        vm.selectedOrganization = myOrganization;
                        breadcrumbManager.pushOrganization(vm.selectedOrganization);
                        vm.fetchOrganizationServices(vm.selectedOrganization);
                    }
                });
        };


        /**
         * Fetches organization services, to fill filter dropdown
         *
         * @param {Organization} organization
         */
        vm.fetchOrganizationServices = function(organization) {
            OfferedService.find( {filter: {
                    where : {organizationId: organization.id, standalone:'S', dtDel: null}
                }
            }, function(services, responseHeaders) {
                var found=null;
                if (vm.searchFilter.service) {
                    found = _.find(services, function (s) {return s.id == vm.searchFilter.service.id; });
                }
                if (!found) {
                    delete vm.searchFilter.service;
                }
                vm.organizationServices = services;
                // $log.info('vm.organizationServices: ' + JSON.stringify(vm.organizationServices));

                // se è stato indicato un servizio per cui filtrare, aggiungo il filtro.
                if ($state.params.offeredServiceId) {
                    vm.searchFilter.service = _.find(vm.organizationServices, function(s) {
                        return s.id == $state.params.offeredServiceId;
                    });
                    // $log.info('vm.searchFilter: ' + JSON.stringify(vm.searchFilter));
                // } else {
                //     $log.info('Nessun parametro offeredServiceId');
                }

                // reload datatable data
                vm.reloadSubscriptionsTableItems();
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        };


        /**
         * Mostra, in una dialog, i campi personalizzati che l'utente ha compilato dalla form della pagina
         * web di iscrizione.
         *
         * @param ev
         * @param subscription
         */
        vm.showSubscriptionForm = function(ev, dyndocId) {
            $log.debug('showSubscriptionForm()');
            $scope.dyndocUrl= vm.apiPath + '/dynamicDocumentConnectors/' + dyndocId;
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/dyndoc_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                targetEvent: ev,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {});
        };


        vm.gotoSubscriptionPayments = function(subscriptionId) {
            $log.debug('vm.gotoSubscriptionPayments()');
            $state.go('app.pages_subscription_payments',{subscriptionId: subscriptionId});
        };


        /**
         * Va alla pagina di validazione documenti per una subscription
         *
         * @param subscriptionId
         * @param serviceId
         * @param userId
         */
        vm.gotoDocumentsValidation = function(subscriptionId, serviceId, userId) {
            var service = _.find(vm.organizationServices, function(service) {
                return service.id === serviceId;
            });
            // $log.debug('service found: ' + JSON.stringify(service));
            breadcrumbManager.pushOrganizationAndService(vm.selectedOrganization, {id: serviceId, name: service.name, type: service.serviceType} );

            $state.go('app.pages_user_documents', {userId: userId, subscriptionId: subscriptionId});
            //$state.go('app.docs_validation', {serviceId: serviceId, subscriptionId:  subscriptionId});
        };


        vm.gotoEditSubscriber = function(subscriptionId, serviceId) {
            var service = _.find(vm.organizationServices, function(service) {
                return service.id === serviceId;
            });
            breadcrumbManager.pushOrganizationAndService(vm.selectedOrganization, {id: serviceId, name: service.name, type: service.serviceType} );
            $state.go('app.pages_subscription', {subscriptionId: subscriptionId});
        };



        //Controller comune alle varie dialogs
        function DialogController($scope, $mdDialog) {
            $scope.dynDocIntro = 'Se in fase di iscrizione dal modulo web l\'utente ha inserito dei campi ' +
                'personalizzati, sono elencati in questa finestra.';
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        /**
         * Mostra una modal che per inserire un pagamento di una subscription
         * @param ev
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        vm.askPaymentDetails = function(ev, userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.selectedOrganization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.selectedOrganization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.selectedOrganization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.selectedOrganization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(amount);
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            vm.loadUserServices(userId);

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        // update table data
                        vm.reloadSubscriptionsTableItems();
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        };


        vm.loadUserServices = function(myUserId) {
            User.findById({
                id: myUserId
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {

                        if ( response.result.services &&  response.result.services!==null) {

                            //potrei avere i corsi che faccio io piu quelli dei miei parenti: quindi filtro per i miei
                            var services = _.filter( response.result.services,function (s) {return s.userId==myUserId;});

                            for (var i = 0; i <  services.length; i++) {
                                var dateFrom =  services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }

                        $scope.userServices = services;
                    });
            });
        };



        /**
         * Add a new subscriber to the selected organization
         */
        vm.gotoNewSubscriptionUser = function(userId, organizationId) {
            $state.go('app.new_user_subcription', {userId: userId, organizationId: organizationId});
        };


        /**
         * Apre la finestra di pagamento
         *
         * @param organizationId
         * @param subscriptionId
         * @param userId
         * @param amount
         */
        vm.gotoPay = function(organizationId, subscriptionId, userId, amount) {
            sessionStorage.setItem('payModalState', JSON.stringify({
                backState: $state.current.name,
                backParams: $state.params,
            }));
            $state.go('app.pages_payments_pay', {
                organizationId: organizationId,
                subscriptionId: subscriptionId,
                userId: userId,
                amount: amount,
            });
        };


    }//SubscriptionsController
})();

(function() {
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('SubscriptionPaymentsController', SubscriptionPaymentsController);

    /** @ngInject */
    function SubscriptionPaymentsController($log, $q, $location, $state, $scope, $rootScope, $translate, OfferedService, Organization, Subscription, EarningCost, Payment, CylUtils, DTOptionsBuilder, $mdDialog, AuthenticationService, AlertMessageService, OrganizationDoctype, $filter, User, ApiPath, _) {
        var vm = this;

        // Data
        vm.apiPath = ApiPath;
        vm.items = [];
        vm.details = [];
        vm.payments = [];
        vm.subscriptionId = null;
        vm.userProfile = null;


        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('order', [['0', 'asc']])
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        $rootScope.$on('$translateChangeEnd', function() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');

        });






        /**
         * Initialize
         */
        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                if ($state.params.subscriptionId) {
                    vm.subscriptionId = $state.params.subscriptionId;
                    loadSubscriptionAndOrders(vm.subscriptionId);
                    vm.loadItems(vm.subscriptionId);
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica gli elementi da mostrare (i pagamenti di una sottoscrizione)
         */
        vm.loadItems = function(itemId) {
            Subscription.findById({
                id: itemId,
                filter: {
                    include: ['user', { orders: {orderDetails: [{payments: 'earningCost'}, 'offeredService', {subscriptionDiscount: 'discount'}]}}]
                }
            }).$promise.then(
                function(subscription) {
                    $log.debug(JSON.stringify(subscription));
                    vm.payments = [];
                    // ordina gli Order in per data
                    var orders = subscription.orders.sort(function(a,b) {
                        if (a && b && a.dtBillingPeriodStart && b.dtBillingPeriodStart) {
                            if (moment(a.dtBillingPeriodStart).isAfter(moment(b.dtBillingPeriodStart))) {
                                return b.dtBillingPeriodStart;
                            } else {
                                return a.dtBillingPeriodStart;
                            }
                        }
                    });
                    // per ogni Order
                    _.each(orders, function(order) {
                        // prepara struttura per dati aggiuntivi
                        order.data = {
                            importoPagato: 0,
                            importoTot: 0,
                        };
                        // unisce i valori dei singoli OrderDetail
                        _.each(order.orderDetails, function(orderDetail) {
                            _.each(orderDetail.payments, function(payment) {
                                vm.payments.push(payment);
                                if (payment.paymentStatus === 'PAYED' || payment.paymentStatus === 'PAID' ||
                                    payment.paymentStatus === 'DISCOUNT_USED') {
                                    order.data.importoPagato += payment.paymentValue;
                                }
                                order.data.importoTot += payment.paymentValue;
                            });
                        });
                        // accoda order agli elementi da visualizzare
                        vm.items.push(JSON.parse(JSON.stringify(order)));
                    });
                },
                function(err) {
                    $log.debug('Errore in caricamento subscription');
                    $log.debug(err);
                }
            );
        };



        /**
         * carica dettaglio iscrizione e ordini
         */
        function loadSubscriptionAndOrders(subscriptionId) {
            Subscription.findById({
                id: subscriptionId,
                filter: {
                    include: ['user', 'payments', {orders: {orderDetails: ['offeredService', {subscriptionDiscount: 'discount'}]}}]
                }
            }).$promise.then(
                function(data, headers) {
                    $log.debug(JSON.stringify(data));
                    if (data && data.user) {
                        vm.userProfile = data.user;
                        $log.debug(vm.userProfile);
                    }
                    var payments = data.payments;

                    _.each(data.orders, function(order) {
                        _.each(order.orderDetails, function(orderDetail) {
                            var obj = orderDetail;

                            if (obj.subscriptionDiscountId) {
                                var discounts = _.filter(payments, function(p) {
                                    return p.orderDetailId == orderDetail.id && (p.paymentStatus === 'DISCOUNT' || p.paymentStatus === 'DISCOUNT_USED');
                                });
                                var amount = _.reduce(discounts, function(memo, p) {
                                    return memo + p.paymentValue;
                                }, 0);
                                obj.amount = amount;
                            } else {

                                obj.dtBillingPeriodStart = order.dtBillingPeriodStart;
                                obj.dtBillingPeriodEnd = order.dtBillingPeriodEnd;
                                //PER OGNUNO CONTROLLO SE E' PAGATO O MENO E METTO L'IMPORTO
                                var paymentsPayed = _.filter(payments, function(p) {
                                    return p.orderDetailId == orderDetail.id && p.paymentStatus === 'PAYED';
                                });
                                var paymentsUnpayed = _.filter(payments, function(p) {
                                    return p.orderDetailId == orderDetail.id && p.paymentStatus === 'UNPAYED';
                                });

                                if (paymentsPayed.length > 0 && paymentsUnpayed.length == 0) {
                                    obj.paymentStatus = 'PAYED';
                                } else if (paymentsPayed.length == 0 && paymentsUnpayed.length > 0) {
                                    obj.paymentStatus = 'UNPAYED';
                                } else if (paymentsPayed.length > 0 && paymentsUnpayed.length > 0) {
                                    obj.paymentStatus = 'UNPAYED_PART';
                                }

                                var payed = _.reduce(paymentsPayed, function(memo, p) {
                                    return memo + p.paymentValue;
                                }, 0);
                                var unpayed = _.reduce(paymentsUnpayed, function(memo, p) {
                                    return memo + p.paymentValue;
                                }, 0);
                                obj.payed = payed;
                                obj.unpayed = unpayed;
                            }

                            vm.details.push(obj);
                        });
                    });
                    vm.details = _.sortBy(vm.details, function(d) {
                        return d.created;
                    });
                    vm.details.reverse();
                },
                function(error) {
                    $log.debug(error);
                });
        }


        /**
         * Permette di modificare l'importo di un pagamento
         * @param id
         */
        vm.modificaImporto = function(id) {
            var payment = _.find(vm.payments, function(payment) {
                return payment.id === id;
            });
            $scope.myResource = {};
            if (payment.paymentValue) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(payment.paymentValue);
            } else {
                $scope.myResource.paymentValue = null;
            }
            $scope.myResource.paymentDescription = payment.paymentDescription;

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_importo_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
                .then(function(answer) {
                    Payment.findById({
                        id : id
                    }).$promise.then(function(thePayment) {
                        thePayment.paymentDescription = answer.paymentDescription;
                        thePayment.paymentValue = answer.paymentValue;
                        Payment.prototype$patchAttributes(
                            { id: thePayment.id },
                            thePayment).$promise.then(function (res) {
                            vm.items = [];
                            vm.details = [];
                            vm.payments = [];
                            loadSubscriptionAndOrders($state.params.subscriptionId);
                            vm.loadItems($state.params.subscriptionId);
                            //
                            if (payment.earningCost) {
                                EarningCost.updateFromPayments({
                                    id : payment.earningCost.id.toString()
                                }).$promise.then(function(ec) {
                                    AlertMessageService.showSuccessMessage();
                                }, function(httpResponse){
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            } else {
                                AlertMessageService.showSuccessMessage();
                            }
                        }, function(httpResponse){
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        function DialogController($scope, $mdDialog) {
            $scope.showStorno = false;
            $scope.showHelp = false;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.setStorno = function(value) {
                $scope.showStorno = value;
            };
            $scope.gotoCassa = function() {
                if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                    $state.go('app.pages_earningcosts', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
                }
            };
            $scope.showHelpToggle = function() {
                $scope.showHelp = !$scope.showHelp;
            };
        }

        vm.formatDate = function(date) {
            if (!date || date === null) {
                return '';
            }
            return moment(date).format('DD/MM/YYYY');
        };



        /**
         * Avvia la procedura che crea gli order mancanti alla Subscription indicata
         *
         * @param subscriptionId
         */
        vm.addOrderMancanti = function(subscriptionId) {
            $log.debug('vm.addOrderMancanti(' + subscriptionId + ')');
            Subscription.find({
                filter: {
                    where: {id: subscriptionId},
                    include: 'offeredService',
                },
            }).$promise.then(
                function(subscriptions) {
                    subscriptions = JSON.parse(JSON.stringify(subscriptions));
                    $log.debug('Subscriptions: ' + JSON.stringify(subscriptions));
                    if (subscriptions) {
                        var subscription = _.first(subscriptions);
                        // var o = {
                        //     subscription: subscription,
                        //     offeredService: subscription.offeredService,
                        // };
                        // console.log(o);
                        // AlertMessageService.showSuccessMessage();
                        Subscription.createMissingOrders({
                            subscriptionContext: {
                                subscription: subscription,
                                offeredService: subscription.offeredService,
                            }
                        }).$promise.then(
                            function(data) {
                                $log.debug('Terminato di aggiornare la subscription: ' + JSON.stringify(data));
                                AlertMessageService.showSuccessMessage();
                            },
                            function(err) {
                                $log.error('Problema aggiornando la subscription: ' + JSON.stringify(err));
                                AlertMessageService.showErrorAlert(err);
                            }
                        );
                    }
                },
                function(err) {
                    $log.error(err);
                });
        };


    }
})();

(function (){
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('SubscriptionDetailController', SubscriptionDetailController);

    /** @ngInject */
    function SubscriptionDetailController($log, $q, $location, $state, $scope, $rootScope, $translate, OfferedService, Organization,Subscription , $mdDialog, AuthenticationService, AlertMessageService, OrganizationDoctype, $filter, User, ApiPath, _ )
    {
        var vm = this;

        var organizationId;

        // Data
        vm.userId = null;           // necessario per menu in alto
        vm.organizationId = null;   // necessario per menu in alto
        vm.subscriberData={};
        vm.offeredService = {};
        vm.subscription = {};
        vm.attachableServices=[];
        vm.selectedServices=[];
        vm.selectedServiceDates = [];       // date di attivazione dei servizi attivati/disattivati (vedi vm.selectedServices)
        vm.apiPath=ApiPath;
        vm.formatDate=formatDate;
        vm.editProfile=editProfile;
        vm.saveDateEnd = saveDateEnd;
        vm.additionalServices = [];         // servizi aggiuntivi, con il loro status

        // Methods
        vm.standaloneServices = [];

        vm.saveSubscriptionServices = saveSubscriptionServices;
        vm.mustChooseService=false;
        init();

        //////////



        /**
         * Initialize
         */
        function init(){
            if (AuthenticationService.isAuthenticated()){
                loadSubscriptionAndOfferedService( $state.params.subscriptionId);
            } else {
                $state.go('app.pages_auth_login');
            }

        }



        function editProfile(){
            $state.go('app.pages_user_detail', {userId: vm.subscription.user.id, organizationId: vm.offeredService.organizationId});
        }


        /**
         * salvataggio finale
         */
        function saveSubscriptionServices(){
            var servicesList = [];
            // genera array per ogni servizio opzionale, indicando ID e lo stato attivo o meno
            _.each(vm.additionalServices, function(service) {
                servicesList.push({
                    offeredServiceId: service.id,
                    active: service._active,
                    referenceDate: service._referenceDate,
                });
            });
            OfferedService.updateOptionalServices({
                subscriptionId: vm.subscription.id.toString(),
                services: servicesList,
            }).$promise
            .then(function(data){
                AlertMessageService.showSuccessMessage();
                $log.debug('success');
                $log.debug(data);
            },function(httpResponse){
                $log.debug('error');
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        }

        /**
         * carica i servizi della associazione che sono agganciabili
         */
        function loadAllAttachableService(){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: vm.offeredService.organizationId,
                        standalone: {neq: 'S'},
                        serviceType: 'SERVICE',
                        dtDel: null
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.attachableServices = data;

                    // aggiunge i servizi aggiuntivi al relativo array
                    if (data && data.length > 0) {
                        _.each(data, function(service) {
                            // aggiunge i campi per la gestione dei servizi selezionati
                            service._active = vm.getActiveStatus(service.id);
                            service._referenceDate = moment().toDate();
                            vm.additionalServices.push(service);
                        });
                    }
                },
                function(error){
                    $log.debug(error);
                });
        }


        /**
         * Ritorna lo status di un servizio, leggendolo dall'array dei servizi attivi.
         *
         * @param serviceId
         * @returns {boolean}
         */
        vm.getActiveStatus = function(serviceId) {
            var active = false;
            _.each(vm.selectedServices, function(status, id) {
                if (serviceId === id && status) {
                    active = true;
                }
            });
            return active;
        };



        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }



        /**
         * Salva la data di fine di una iscrizione e, se necessario, ne elimina gli Order futuri.
         */
        function saveDateEnd() {
            Subscription.quit(
                {subscriptionId: vm.subscription.id, endDate: moment(vm.subscription.dtEnd).toISOString()},
                function(data, responseHeaders) {
                    $log.debug(data);
                    AlertMessageService.showSuccessMessage();
                },
                function(httpResponse) {
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
        }



        /**
         * carica dettaglio iscrizione e servizio
         */
        function loadSubscriptionAndOfferedService(subscriptionId){
            Subscription.findById({
                id: subscriptionId,
                filter: {
                    include: ['user', 'orderDetails']
                }
            }).$promise.then(
                function(data, headers){
                    vm.subscription = data;

                    // imposta valori per sirettiva menu
                    vm.userId = vm.subscription.user.id;
                    vm.organizationId = vm.offeredService.organizationId;

                    if (vm.subscription.dtEnd) {
                        vm.subscription.dtEnd = new Date(vm.subscription.dtEnd);
                    }

                    vm.selectedServices[vm.subscription.offeredServiceId]=true;
                    //filtro gli ordini non cancellati precedentemente
                    vm.subscription.orderDetails=_.filter(vm.subscription.orderDetails, function(o) {return !o.dtDel && (o.status=='OK' || o.status=='TO_RENEW');});
                    for (var i = 0; i < vm.subscription.orderDetails.length; i++) {
                        vm.selectedServices[ vm.subscription.orderDetails[i].offeredServiceId]=true;
                    }

                    OfferedService.findById({
                        id: vm.subscription.offeredServiceId,
                        filter: {
                            include: ['organization']
                        }
                    }).$promise.then(
                        function(data, headers){
                            var myService = data;
                            vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                            loadAllAttachableService();
                        },
                        function(error){
                            $log.debug(error);
                        });
                },
                function(error){
                    $log.debug(error);
                });

        }

    }
})();

(function (){
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('SubscriptionRenewController', SubscriptionRenewController);

    /** @ngInject */
    function SubscriptionRenewController($log, $q, $location, $state, $scope, $rootScope, $translate, OfferedService, Organization, DTOptionsBuilder, ServiceSchedule , blockUI, Discount, $mdDialog, Subscription, AuthenticationService, AlertMessageService, Payment, PaymentReason, breadcrumbManager, OrganizationDoctype, $filter, User, ApiPath, _ )
    {
        var vm = this;

        var organizationId;

        // Data
        vm.subscriberData={};
        vm.offeredService = {};
        vm.attachableServices=[];
        vm.discounts=[];
        vm.apiPath=ApiPath;

        // Methods
        vm.standaloneServices = [];

        vm.subscriptionServicesIds= [];
        vm.subscriptionServices = [];
        vm.organization = {};
        vm.renewSubscription = renewSubscription;

        vm.askPaymentDetails=askPaymentDetails;
        vm.mustChooseService=false;
        vm.searchMode='ORG';
        vm.subscriptionDiscount={id: ''};

        vm.serviziQuotaAssociativaUtente = [];
        vm.serviziQuotaAssociativaAttivabili = [];

        vm.subscriptionToAdd = {};//quota associativa da aggiungere in fase di iscrizione
        vm.flgAddSubscription = null;
        vm.changeFlgAddSubscription = changeFlgAddSubscription;

        vm.organizationSubscriptionStatusType = {
            QUOTA_ASSOCIATIVA_NON_NECESSARIA: 0,
            QUOTA_ASSOCIATIVA_NON_ISCRITTO: 10,
            QUOTA_ASSOCIATIVA_NON_PAGATA: 20,
            QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI: 30,
            QUOTA_ASSOCIATIVA_OK: 100,
        };
        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA;

        init();

        //////////


        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });


        /**
         * Initialize
         */
        function init(){
            if (AuthenticationService.isAuthenticated()){
                if ($state.params.subscriptionId && $state.params.offeredServiceId!=='' ) {
                    //carico dettaglio servizio
                    vm.selecteServices = {};
                    vm.selecteServices[ $state.params.offeredServiceId] = true;
                    loadSubscription( $state.params.subscriptionId);
                }

            } else {
                $state.go('app.pages_auth_login');
            }

        }


        function changeFlgAddSubscription() {
            if (vm.flgAddSubscription === 'NO') {
                vm.subscriptionToAdd = {};
            }
        }



        function renewSubscription() {
            var subscribedServicesKeys = _.keys(vm.selecteServices);
            var subscribedServices=[];
            for (var i = 0; i < subscribedServicesKeys.length; i++) {
                if (vm.selecteServices[subscribedServicesKeys[i]]) {
                    subscribedServices.push(subscribedServicesKeys[i]);
                }
            }

            if (vm.flgAddSubscription === 'YES') {
                var subscriptionToAddIds = [];
                _.each(_.keys(vm.subscriptionToAdd), function(key) {
                    if (vm.subscriptionToAdd[key]) {
                        subscriptionToAddIds.push(key);
                    }
                });

                if (subscriptionToAddIds.length === 0) {
                    AlertMessageService.showErrorAlert('E\' obbligatorio selezionare almeno una quota associativa');
                    return;
                }

                blockUI.start();
                var promisesToCall = [];
                for (var i = 0; i < subscriptionToAddIds.length; i++) {
                    promisesToCall.push(OfferedService.addNonRegisteredSubscriber({
                        offeredServiceId: subscriptionToAddIds[i], //servizio capofila
                        subscriberData: vm.subscriberData,             //dati utente
                        subscribedServices: [subscriptionToAddIds[i]],        //servizi accessori, nessuno, solo la quota stessa
                        subscriptionDiscount: {id: ''}  //sconto, nessuno sulla quota
                    }).$promise);
                }

                $q.all(promisesToCall)
                    .then(function(results){
                        $log.debug('success q. associativa');
                        $log.debug(results);
                        OfferedService.renewSubscription({
                            subscriptionId: $state.params.subscriptionId.toString(),
                            offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                            subscriberData: vm.subscriberData,             //dati utente
                            subscribedServices: subscribedServices,        //servizi accessori
                            subscriptionDiscount: vm.subscriptionDiscount  //sconto eventuale
                        }).$promise.then(function(data) {
                            blockUI.stop();
                            $log.debug('success');
                            $log.debug(data);
                            AlertMessageService.showSuccessMessage();
                            window.history.back();
                        }, function(httpResponse) {
                            blockUI.stop();
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    }, function(httpResponse){
                        blockUI.stop();
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
            } else {
                blockUI.start();
                OfferedService.renewSubscription({
                    subscriptionId: $state.params.subscriptionId.toString(),
                    offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                    subscriberData: vm.subscriberData,             //dati utente
                    subscribedServices: subscribedServices,        //servizi accessori
                    subscriptionDiscount: vm.subscriptionDiscount  //sconto eventuale
                }).$promise.then(function(data){
                    blockUI.stop();
                    $log.debug('success');
                    $log.debug(data);
                    AlertMessageService.showSuccessMessage();
                    window.history.back();
                },function(httpResponse){
                    blockUI.stop();
                    $log.debug('error');
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
            }
        }





        /**
         * carica i servizi della associazione che sono agganciabili
         */
        function loadAllAttachableService(){
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {

                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: vm.offeredService.organizationId},
                                {standalone: {neq: 'S'}},
                                {serviceType: 'SERVICE'},
                                {dtDel: null},
                            ]
                        }
                    }
                };

                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }

                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    query.filter.where.and.push(
                        {
                            or: [
                                {scheduleType: {inq: ['R', 'N']}},
                                {and: [
                                        {start: {lte: dateTo}},
                                        {end: {gte: dateFrom}}
                                    ]}
                            ]
                        }
                    );
                }


                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.attachableServices = data;
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }

        /**
         * carica i servizi rivendibili singolarmente
         */
        function loadAllStandaloneService(organizationId){
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: organizationId},
                                {standalone: 'S'},
                                {dtDel: null}
                            ]
                        },
                        include: 'serviceTypes'
                    }
                };

                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }

                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    query.filter.where.and.push(
                        {
                            or: [
                                {scheduleType: {inq: ['R', 'N']}},
                                {and: [
                                        {start: {lte: dateTo}},
                                        {end: {gte: dateFrom}}
                                    ]}
                            ]
                        }
                    );
                }

                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.standaloneServices = data;

                        vm.step0SubscriptionServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return false;
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return true;
                            } else {
                                return false;
                            }
                        });

                        vm.step0StandaloneServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return d.serviceType !== 'EVENT';
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return false;
                            } else {
                                return d.serviceType !== 'EVENT';
                            }
                        });

                        vm.step0Events = _.filter(data, function(d) {
                            return d.serviceType === 'EVENT';
                        });
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }


        function loadUserServices() {

            if (vm.subscriberData.id ) {
                User.findById({
                    id: vm.subscriberData.id
                }).$promise.then(function(user){
                    user.$prototype$allServices().then(
                        function(response) {

                            if ( response.result.services &&  response.result.services!==null) {
                                var theServices = response.result.services;
                                for (var i = 0; i <  theServices.length; i++) {
                                    var dateFrom =  theServices[i].dateFrom;
                                    if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                        theServices[i].dateFrom=new Date(dateFrom);
                                    }
                                    var dateTo =  theServices[i].dateTo;
                                    if (dateTo && dateTo!==null && dateTo!=='') {
                                        theServices[i].dateTo=new Date(dateTo);
                                    }
                                }

                                //FILTRO PER QUELLI DELLA ORGANIZZAZIONE DI TIPO ISCRIZIONE
                                theServices = _.filter(theServices,  function (s) {
                                    if (s.organizationId != vm.organization.id) {
                                        return false;
                                    }
                                    //
                                    var found = _.find(vm.subscriptionServicesIds, function(id) {
                                        return id == s.id;
                                    });
                                    return found ? true:false;
                                });
                                vm.serviziQuotaAssociativaUtente = theServices;
                            } else {
                                vm.serviziQuotaAssociativaUtente=[];
                            }

                            checkQuoteAssociativeAttivabili();

                        });
                });
            } else {
                checkQuoteAssociativeAttivabili();
            }
        }


        function checkQuoteAssociativeAttivabili() {
            //SE IL SERVIZIO CORRENTE RICHIEDE ISCRIZIONE ALLA QUOTA ASSOCIATIVA ALLORA CERCO tra i vm.subscriptionServices
            //SE QUELLI CHE PER DATA SI AGGANCIANO AL SERVIZIO SONO PRESENTI, PAGATI O CON DOC MANCANTI
            if (vm.offeredService.needsOrganizationSubscription) {
                //cerco tra i vm.subscriptionServices le iscrizioni plausibili includendo:
                // - quelle la cui data di inizio fine comprende data di inizio del servizio
                // - quelle la cui data di inizio fine comprende la data di oggi
                vm.serviziQuotaAssociativaAttivabili = _.filter(vm.subscriptionServices, function(sqa) {
                    if (sqa.start && sqa.end) {
                        if (vm.offeredService.start && !moment(sqa.start).isAfter(vm.offeredService.start) && !moment(vm.offeredService.start).isAfter(sqa.end)) {
                            return true;
                        } else if (!moment(sqa.start).isAfter(new Date()) && !moment().isAfter(sqa.end)) {
                            return true;
                        }
                    } else if (!sqa.start && !sqa.end) {
                        //quota associativa che non ha nè inizio nè fine: ha senso?
                        return true;
                    }
                    return false;
                });

                //CONTROLLO LO STATO DELLE ISCRIZIONI RISPETTO serviziQuotaAssociativaAttivabili
                var iscrizioneQuotaAssociativa = null;
                for (var i = 0; i < vm.serviziQuotaAssociativaAttivabili.length; i++) {
                    var servizioAttivabile = vm.serviziQuotaAssociativaAttivabili[i];
                    var found = _.find(vm.serviziQuotaAssociativaUtente, function(squ) {
                        return squ.id == servizioAttivabile.id;
                    });
                    if (found) {
                        iscrizioneQuotaAssociativa = found;
                        break;
                    }
                }

                if (!iscrizioneQuotaAssociativa) {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                } else {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                    if (iscrizioneQuotaAssociativa.paymentValue < iscrizioneQuotaAssociativa.paymentDue) {
                        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA;
                    } else {
                        var docOk = true;
                        for (var i = 0; i < iscrizioneQuotaAssociativa.docs.length; i++) {
                            var doc = iscrizioneQuotaAssociativa.docs[i];
                            if (doc.status === 'MISSING' || doc.status === 'EXPIRED' || doc.status === 'REJECTED' || doc.status === 'EXPIRING') {
                                docOk = false;
                                break;
                            }
                        }
                        if (docOk) {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK;
                        } else {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI;
                        }
                    }

                }
            }

        }


        /**
         * Effettua un pagamento di iscrizione
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        function askPaymentDetails( userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue=amount;
            } else {
                $scope.myResource.paymentValue=null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            loadUserServices(userId);

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        loadUserServices();
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         * Cerca un utente per mail
         * @param mail
         * @param callback
         */
        function findUserByMail(mail, callback){
            var query ={filter: {
                    where : {email: mail}
                }
            }
            User.find(query, function(users) {
                callback(users);
            });
        }


        function loadUserDetail(id, callback){
            User.loadUser({
                id: id,
                organizationId: vm.organization.id,
                filter: {}
            }, function(user) {
                callback(user);
            }, function(error){
                $log.debug(error);
            });
        }


        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllSubscriptionsService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.subscriptionServices = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return false;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode==='SUBSCRIPTION';
                        });
                        if (found) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    vm.subscriptionServicesIds = _.map(vm.subscriptionServices, function (s) {
                        return s.id;
                    });
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica le tipologie di sconti da applicare all'iscrizione
         * @param organizationId
         */
        function loadAllDiscounts(organizationId){
            Discount.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.discounts = data;
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica dettaglio servizio
         */
        function loadSubscription(id){
            Subscription.findById({
                id: id,
                filter: {
                    include: [{offeredService: 'organization'}]
                }
            }).$promise.then(
                function(data, headers){
                    var theSubscription = JSON.parse(JSON.stringify(data));
                    var myService = theSubscription.offeredService;
                    vm.organization = myService.organization;
                    vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                    if (vm.offeredService.start && vm.offeredService.start!==null) {
                        vm.offeredService.start=new Date(vm.offeredService.start);
                    }

                    if (vm.offeredService.end && vm.offeredService.end!==null) {
                        vm.offeredService.end=new Date(vm.offeredService.end);

                    }

                    vm.subscriberData.dtStart=new Date();
                    vm.subscriberData.id = theSubscription.userId;
                    if (vm.offeredService.scheduleType==='P') {
                        vm.subscriberData.dtStart=vm.offeredService.start;
                        vm.subscriberData.dtEnd=vm.offeredService.end;
                    }
                    loadUserServices();
                    loadAllAttachableService();
                    loadAllSubscriptionsService(vm.organization.id);
                    loadAllDiscounts(vm.organization.id);
                },
                function(error){
                    $log.debug(error);
                });
        }

        function findOrganization(id) {
            $log.debug('RenewSubscriptionController.findOrganization()');
            return Organization.findById({
                id : id,
                filter : {
                }
            }).$promise;
        }

        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };


        }

    }
})();

(function() {
    'use strict';

    angular
    .module('app.pages.payments')
    .controller('PublicSubscriptionSuccessController', PublicSubscriptionSuccessController);

    /** @ngInject */
    function PublicSubscriptionSuccessController($rootScope, $scope,  $mdDialog, $compile, $http, DTOptionsBuilder,
                                                 Payment, DTColumnBuilder, $log,LoopBackAuth, $translate,
                                                 AuthenticationService, User, Organization, $location,  $state,
                                                 PaymentReason, AlertMessageService, _, StripePublicKey, ApiPath)
    {
        var vm = this;
        vm.currentUserId = null;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.stripePublicKey = StripePublicKey;
        vm.service = null;
        vm.subscriptionId = null;
        vm.savingStatus = 'saving';
        vm.checkoutSessionId = null;
        vm.amount = null;


        /**
         *
         */
        vm.init = function() {
            $log.debug('PublicSubscriptionSuccessController.init()');
            vm.subscriptionId = $state.params.subscriptionId;
            vm.checkoutSessionId = $state.params.checkoutSessionId;
            if ($state.params.amount) {
                try {
                    vm.amount = parseInt(atob($state.params.amount)) / 100;
                } catch(e) {};
            }
            vm.registerPayment();
        };


        /**
         * Registra il pagamento della subscription
         */
        vm.registerPayment = function() {
            vm.savingStatus = 'saving';
            $http.post(
                ApiPath + '/stripe/setsubscriptionpaid',
                {
                    subscriptionId: vm.subscriptionId,
                    checkoutSessionId: vm.checkoutSessionId,
                    amount: vm.amount,
                }
            ).then(
                function(response) {
                    if (response.status === 200) {
                        vm.savingStatus = 'ok';
                    } else {
                        vm.savingStatus = 'failed';
                        $log.warn(response.status);
                        $log.warn(response.data);
                        AlertMessageService.showErrorAlert(response.err.message);
                    }
                },
                function(err) {
                    vm.savingStatus = 'failed';
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Problema con i parametri, riprovare.');
                }
            );
        };



        vm.gotoLoginPage = function() {
            $state.go('app.pages_auth_login');
        };


    }

})();


(function (){
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('PublicSubscriptionController', PublicSubscriptionController);

    /** @ngInject */
    function PublicSubscriptionController($log, $q, $http, $location, $state, $scope, $rootScope, $translate, _,
                                          $anchorScroll, PublicCylUrl, OfferedService, Organization, SubscriptionPage,
                                          ServiceSchedule , $mdDialog, Subscription, AuthenticationService, blockUI,
                                          AlertMessageService, StripePublicKey, OrganizationDoctype, $filter, User,
                                          ApiPath, Payment)
    {
        var vm = this;

        var organizationId;

        // Data
        vm.subscriberData={};
        vm.offeredService = {};
        vm.organization = null;
        vm.attachableServices=[];
        vm.selecteServices = {};
        vm.apiPath=ApiPath;
        vm.organizationUserTemplateId=null;
        vm.templateUrl=null;
        vm.standaloneServices = [];
        vm.mandatoryOfferedServices = [];
        vm.subscriptionPage = null;
        vm.subscriptionPageOptions = {};
        vm.moneyDue = null;
        vm.jsonOptions = {mode: 'code'};
        vm.publicCylUrl = PublicCylUrl;
        vm.scrollTo = scrollTo;

        vm.stripePublicKey = StripePublicKey;
        vm.logoImageUrl = null;
        vm.isPaymentStep=false;
        vm.recaptchaResponse=null;

        vm.saveSubscription = saveSubscription;
        vm.backgroundImage=backgroundImage;
        vm.formatDate = formatDate;
        vm.formatDateFriendly = formatDateFriendly;

        vm.stripeInfo = {       // raccolgo qui le informazioni sul pagamento con Stripe
            paying: false,      // true se ho avviato la procedura di pagamento
            loading: false,
            submitting: false,
            submitStatus: null,
            publicKey: StripePublicKey,
            elementsParameters: {
                locale: 'it'
            },
            cardStyles: {
                style: {
                    base: {
                        color: "#32325D",
                        fontWeight: 500,
                        fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
                        fontSize: "16px",
                        fontSmoothing: "antialiased",

                        "::placeholder": {
                            color: "#CFD7DF"
                        }
                    },
                    invalid: {
                        color: "#E25950"
                    }
                }
            }
        };

        init();

        //////////



        /**
         * Initialize
         */
        function init(){
            //carico dettaglio servizio
            vm.selecteServices = {};
            loadOfferedService( $state.params.uuid);

        }


        /**
         * Funzione che calcola lo stile della intestazione
         * @returns {*}
         */
        function backgroundImage() {
            if (vm.offeredService && vm.offeredService.uriBackgroundImage && vm.offeredService.uriBackgroundImage !==null) {
                vm.backgroundImageUrl=ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.uriBackgroundImage;
                return {'background-image': 'url('+vm.backgroundImageUrl+')', 'background-size': 'cover', 'max-height': '100%', 'height': '100%'};
            } else if (vm.offeredService.organization && vm.offeredService.organization.uriBackgroundImage && vm.offeredService.organization.uriBackgroundImage !==null) {
                vm.backgroundImageUrl=ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriBackgroundImage;
                return {'background-image': 'url('+vm.backgroundImageUrl+')', 'background-size': 'cover', 'max-height': '100%', 'height': '100%'};
            }
            return '';
        }


        vm.scrollTo = function(id) {
            $location.hash(id);
            $anchorScroll();
        }

        /**
         * salvataggio finale
         */
        function saveSubscription(){
            blockUI.start();
            $rootScope.$emit('DYN-DOC-DO-SAVE', {action:'SAVE_DONE', extradata: {subscriptionId: vm.subscriptionId}});
        }

        function findContactByMail(mail, callback){
            var query ={filter: {
                    where : {email: mail},
                    include: 'organizations'
                }
            }
            User.find(query, function(users) {
                callback(users);
            });
        }


        /**
         * carica i servizi della associazione che sono agganciabili
         */
        function loadAllAttachableService(){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: vm.offeredService.organizationId,
                        standalone: {neq: 'S'},
                        serviceType: 'SERVICE',
                        dtDel: null
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.attachableServices = data;
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica i servizi rivendibili singolarmente
         */
        function loadAllStandaloneService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        dtDel: null
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.standaloneServices = data;
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica dettaglio servizio
         */
        function loadOfferedService(uuid){
            SubscriptionPage.find({filter: {
                    where: {uuid: uuid},
                    include: [{offeredService: 'organization'}]
                }
            }).$promise.then(
                function(data, headers){

                    if (data && data.length > 0) {
                        vm.subscriptionPage=data[0];
                        vm.subscriptionPageOptions=JSON.parse(vm.subscriptionPage.options);
                        if (vm.subscriptionPage.templateId) {
                            vm.templateUrl=vm.apiPath+'/dynamicDocumentConnectors/template/'+vm.subscriptionPage.templateId;
                        }
                        var myService = data[0].offeredService;
                        vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                        vm.organization = vm.offeredService && vm.offeredService.organization;
                        vm.selecteServices[vm.offeredService.id]=true;

                        if (vm.offeredService.start && vm.offeredService.start!==null) {
                            vm.offeredService.start=new Date(vm.offeredService.start);
                        }

                        if (vm.offeredService.end && vm.offeredService.end!==null) {
                            vm.offeredService.end=new Date(vm.offeredService.end);

                        }

                        if (vm.offeredService && vm.offeredService.uriLogo && vm.offeredService.uriLogo !==null) {
                            vm.logoImageUrl = vm.apiPath  + '/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriLogo;
                        } else if (vm.offeredService.organization && vm.offeredService.organization.uriLogo && vm.offeredService.organization.uriLogo !==null) {
                            vm.logoImageUrl = vm.apiPath  + '/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriLogo;
                        }

                        vm.subscriberData.dtStart=new Date();
                        if (vm.offeredService.scheduleType==='P') {
                            vm.subscriberData.dtStart=vm.offeredService.start;
                        }


                        //INIZIALIZZAZIONE DELLA MAPPA
                        setTimeout(function() {
                            $(".gllpLatlonPicker").each(function () {
                                var $obj = $(document).gMapsLatLonPicker();
                                $obj.init( $(this) );
                            });

                            var mapElement = document.getElementById('map');
                            if (mapElement) {
                                var map = new google.maps.Map(document.getElementById('map'), {
                                    center: {lat: parseFloat(vm.offeredService.latitude), lng: parseFloat(vm.offeredService.longitude)},
                                    zoom: 13
                                });
                                var marker = new google.maps.Marker({
                                    position: {lat: parseFloat(vm.offeredService.organization.latitude), lng: parseFloat(vm.offeredService.organization.longitude)},
                                    map: map
                                });
                            }
                        }, 2000);

                        loadAllAttachableService();
                        // carica glo offeredService obblgatori per questa iscrizione
                        loadMandatoryOfferedServices();
                    } else {
                        $location.url('/messagefs/ERROR/E?submsg='+btoa('Impossibile processare le richiesta'));
                    }
                },
                function(error){
                    $log.debug(error);
                    $location.url('/messagefs/ERROR/E?submsg='+btoa('Impossibile processare le richiesta'));
                });
        }


        /**
         * Questa viene chiamata quando ha terminato il salvataggio del dynamic document.
         * Effettua il vero salvataggio dell'iscrizione al servizio
         */
        $scope.myOnSuccess=function (succ, action) {
            $log.debug('$scope.myOnSuccess()');
            var dynDocumentId = null;
            if (succ && succ.data && succ.data.data && succ.data.data.id) {
                dynDocumentId = succ.data.data.id;
            }

            if (action==='SAVE_DONE') {
                $log.debug('action===\'SAVE_DONE\'');

                var subscribedServicesKeys = _.keys(vm.selecteServices);
                var subscribedServices=[];
                for (var i = 0; i < subscribedServicesKeys.length; i++) {
                    if (vm.selecteServices[subscribedServicesKeys[i]]) {
                        subscribedServices.push(subscribedServicesKeys[i]);
                    }
                }

                // issue #450
                var parameters = {
                    offeredServiceId: vm.offeredService.id.toString(),
                    subscriberData: vm.subscriberData,
                    subscribedServices: subscribedServices,
                    recaptchaResponse: vm.recaptchaResponse
                };
                if (dynDocumentId) {
                    parameters.dyndocId = dynDocumentId;
                }

                // iscrive la persona al servizio
                User.publicSubscribeToService(parameters).$promise
                    .then(function(data) {
                        $log.debug('User.publicSubscribeToService() succeeded');
                        $log.debug(JSON.stringify(data));

                        // iscrive ai servizi obbligatori (best effort)
                        subscribeToMandatoryOfferedServices();

                        // calcola il pagamento e mostra la sezione per pagare con Stripe
                        vm.service=data.result;
                        $log.debug('vm.service: ' + JSON.stringify(vm.service));
                        vm.moneyDue = vm.service.subscriptionPrice - vm.service.paymentValue;
                        // aggiunge il costo dei servizi obbligatori
                        _.each(vm.mandatoryOfferedServices, function(mandatoryOfferedService) {
                            $log.debug('Aggiungo costo: ' + mandatoryOfferedService.subscriptionPrice);
                            vm.moneyDue += mandatoryOfferedService.subscriptionPrice;
                        });

                        if (vm.offeredService.organization.flgEnableStripePayments && vm.moneyDue>0) {
                            vm.isPaymentStep=true;
                        } else {
                            $location.url('/messagefs/SUCCESS/S');
                        }
                        blockUI.stop();
                    }, function(httpResponse) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
            } else {
                blockUI.stop();
            }
        }

        $scope.myOnErr=function (err) {
            blockUI.stop();
        }


        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }


        function formatDateFriendly(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('dddd DD MMMM YYYY');
        }


        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };


        }


        /**
         * Invia il pagamento tramite stripe, versione con SCA (Strong Client Authentication)
         * NOTA: obsoleta dopo aver spostato il pagamento al metodo con intent
         */
        vm.sendStripePayment_delme = function() {
            // $log.debug('vm.sendStripePayment()');
            $log.debug('vm.service: ' + JSON.stringify(vm.service));
            var amount = Math.trunc(vm.moneyDue * 100);
            $http.post(
                ApiPath + '/stripe/paydynamicproduct',
                {
                    name: vm.service.name,
                    description: 'Pagamento di ' + vm.service.displayName,
                    currency: 'eur',
                    quantity: 1,
                    amount: amount,
                    successUrl: PublicCylUrl + '/public_subscription_success/' + vm.service.subscriptionId + '/success/{CHECKOUT_SESSION_ID}/' + btoa(amount),
                    cancelUrl: PublicCylUrl + '/subscribe/' + $state.params.uuid,
                    subscriptionId: vm.service.subscriptionId,
                    on_behalf_of: vm.organization.stripeAccountId,
                    transfer_data: {
                        // account id dell'organizzazione che riceve i soldi
                        destination: vm.organization.stripeAccountId,
                    }
                }
            ).then(
                function(response) {
                    if (response.status === 200) {
                        // $log.debug('Sessione stripe creata correttamente');
                        // $log.debug(response.data);
                        var checkoutSessionData = response.data;
                        // metto nel local storage la sessione di pagamento
                        var stripe = Stripe(StripePublicKey);
                        stripe.redirectToCheckout({
                            // Make the id field from the Checkout Session creation API response
                            // available to this file, so you can provide it as parameter here
                            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                            sessionId: checkoutSessionData.id
                        }).then(function(result) {
                            // If `redirectToCheckout` fails due to a browser or network
                            // error, display the localized error message to your customer
                            // using `result.error.message`.
                            $log.error(result);
                            AlertMessageService.showErrorAlert('Il pagamento non è andato a buon fine.');
                        });
                    } else {
                        $log.warn(response.status);
                        $log.warn(response.data);
                        AlertMessageService.showErrorAlert(response.err.message);
                    }
                },
                function(err) {
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Problema con i parametri di pagamento, riprovare.');
                }
            );
        };


        /**
         * Legge gli offeredServices obbligatori per l'iscrizione a questo servizio.
         * Si trovano in un campo nelle opzioni della SubscriptionPage
         */
        function loadMandatoryOfferedServices() {
            $log.debug('loadMandatoryOfferedServices()');
            // crea un array degli offeredService obbligatori, che vanno caricati
            var mandatoryOfferedServiceIds = [];
            if (vm.subscriptionPageOptions && vm.subscriptionPageOptions.mandatoryOfferedServices &&
                Array.isArray(vm.subscriptionPageOptions.mandatoryOfferedServices)) {
                _.each(vm.subscriptionPageOptions.mandatoryOfferedServices, function(mandatoryOfferedService) {
                    if (mandatoryOfferedService && mandatoryOfferedService.offeredServiceId) {
                        mandatoryOfferedServiceIds.push(mandatoryOfferedService.offeredServiceId);
                    }
                });
                if (mandatoryOfferedServiceIds.length > 0) {
                    $log.debug('mandatoryOfferedServiceIds: ' + JSON.stringify(mandatoryOfferedServiceIds));
                    // carica tutti gli offeredService obbligatori
                    OfferedService.find({
                        filter: {
                            where : {
                                id: {inq: mandatoryOfferedServiceIds}
                            },
                            include: []
                        }
                    }).$promise.then(
                        function(offeredServices) {
                            $log.debug('offeredServices: ' + JSON.stringify(offeredServices));
                            vm.mandatoryOfferedServices = JSON.parse(JSON.stringify(offeredServices));
                        },
                        function(err) {
                            $log.error(err);
                        }
                    );
                } else {
                    $log.debug('No mandatoryOfferedServices lo load');
                }
            } else {
                $log.debug('No subscriptionPageOptions.mandatoryOfferedServices section');
            }
        }


        // versione semplificata best-effort
        function subscribeToMandatoryOfferedServices() {
            $log.debug('subscribeToMandatoryOfferedServices()');

            var offeredServiceId;
            var subscriberData;
            var subscribedServices;
            var subscriptionDiscount;

            $log.debug('vm.mandatoryOfferedServices: ' + JSON.stringify(vm.mandatoryOfferedServices));
            _.each(vm.mandatoryOfferedServices, function(mandatoryOfferedService) {
                offeredServiceId = mandatoryOfferedService.id.toString();
                subscriberData = vm.subscriberData;
                subscribedServices = [mandatoryOfferedService.id.toString()];
                subscriptionDiscount = { "id":"", "amount":0 };

                $log.debug(offeredServiceId);
                $log.debug(subscriberData);
                $log.debug(subscribedServices);
                $log.debug(subscriptionDiscount);

                OfferedService.addNonRegisteredSubscriber({
                    offeredServiceId: offeredServiceId,
                    subscriberData: subscriberData,
                    subscribedServices: subscribedServices,
                    subscriptionDiscount: subscriptionDiscount
                }).$promise.then(
                    function(result) {
                        $log.info('OfferedService.addNonRegisteredSubscriber() riuscita');
                        $log.debug(JSON.stringify(result));
                    },
                    function(err) {
                        $log.error('OfferedService.addNonRegisteredSubscriber() fallita');
                        $log.error(JSON.stringify(err));
                    }
                );
            });
        }



        /**
        * Crea l'intent per il pagamento via Stripe di una subscription.
        */
        vm.startStripePayment = function() {
            $log.debug('vm.startStripePayment()');
            $log.debug('vm.service: ' + JSON.stringify(vm.service));

            // mostra il form di pagamento (e nasconde le sezioni non necessarie)
            vm.stripeInfo.paying = true;
            vm.stripeInfo.loading = true;

            // chiede al server API CYL il paymentIntent
            var intentData = {
                amount: Math.trunc(vm.moneyDue * 100),
                currency: 'eur',
                description: 'Pagamento di ' + vm.service.displayName,
                // metadati arbitrari
                metadata: {
                    type: 'payment',
                    source: 'website ppi',
                    userId: vm.service.userId,
                    subscriptionId: vm.service.subscriptionId,
                },
                // lo aggiunge il server
                // on_behalf_of: vm.organization.stripeAccountId,
                // transfer_data: {
                //     // account id dell'organizzazione che riceve i soldi
                //     destination: vm.organization.stripeAccountId,
                // }
            };
            $log.debug('intentData: ' + JSON.stringify(intentData));
            Payment.getStripePaymentIntent({ intentData: intentData }).$promise.then(
                function(paymentIntent) {
                    $log.debug('paymentIntent: ' + JSON.stringify(paymentIntent));
                    vm.stripeInfo.loading = false;
                    vm.stripeInfo.instance = Stripe(vm.stripeInfo.publicKey);
                    // crea form di pagamento
                    var stripeElements = vm.stripeInfo.instance.elements(vm.stripeInfo.elementsParameters);
                    vm.stripeInfo.cardElement = stripeElements.create('card', vm.stripeInfo.cardStyles);
                    vm.stripeInfo.cardElement.mount('#stripe-card');
                    vm.stripeInfo.clientSecret = paymentIntent.paymentIntent.client_secret;
                    // gestione errori compilazione
                    vm.stripeInfo.cardElement.on('change', function(error) {
                        $log.debug('Error: ' + JSON.stringify(error));
                        if (error && error.error) {
                            $scope.$apply(function() {
                                vm.stripeInfo.error = error.error;
                            });
                        } else {
                            $scope.$apply(function() {
                                vm.stripeInfo.error = null;
                            });
                        }
                    });
                },
                function(err) {
                    vm.stripeInfo.loading = false;
                    vm.stripeInfo.paying = false;
                    $log.error('Errore creando paymentIntent:');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Si è verificato un errore comunicando con Stripe.');
                }
            );
        };


        /**
         * Invia il pagamento a Stripe. Il server CYL lo registra con un webhook
         * Rif: https://stripe.com/docs/payments/payment-intents/web#completing-payment
         */
        vm.submitStripePayment = function() {
            $log.debug('vm.submitStripePayment()');
            vm.stripeInfo.submitting = true;
            vm.stripeInfo.submitStatus = null;
            vm.stripeInfo.instance.handleCardPayment(
                vm.stripeInfo.clientSecret,
                vm.stripeInfo.cardElement,
                {
                    payment_method_data: {
                        billing_details: { name: vm.service.displayName }
                    }
                }
            ).then(function(result) {
                if (!result.error) {
                    $scope.$apply(function() {
                        vm.stripeInfo.submitting = false;
                        vm.stripeInfo.submitStatus = 'ok';
                    });
                    $log.debug('Pagamento inviato correttamente.');
                    $log.debug('result: ' + JSON.stringify(result));
                } else {
                    $scope.$apply(function() {
                        vm.stripeInfo.submitting = false;
                        vm.stripeInfo.submitStatus = 'error';
                    });
                    $log.error('Errore inviando il pagamento');
                    $log.error(result.error);
                }
            });
        };


        /**
         * @description
         * Formatta il numero euro come #,##
         */
        vm.formatEuro = function(n) {
            if (!n) return '0,00';
            var str = n.toFixed(2).toString();
            str=str.replace('.', ',');
            return str;
        };

    }
})();

(function (){
    'use strict';

    angular
        .module('app.pages.subscriptions')
        .controller('SubscriptionNewController', SubscriptionNewController);

    /** @ngInject */
    function SubscriptionNewController($log, $q, $location, $state, $timeout, $interval, $scope, $rootScope, blockUI,
                                       $translate, OfferedService, Organization, DTOptionsBuilder, ServiceSchedule,
                                       Discount, $mdDialog, AuthenticationService, OfferedServiceRelation,
                                       UserOrganizationRole, AlertMessageService, Subscription, Payment, PaymentReason,
                                       breadcrumbManager, OrganizationDoctype, $filter, User, ApiPath, UserRelation, _,
                                       DateFormatter)
    {
        var vm = this;

        var organizationId;

        // Data
        vm.subscriberData={};
        vm.offeredService = {};
        vm.attachableServices=[];
        vm.discounts=[];
        vm.apiPath=ApiPath;
        vm.subscriptionDone = false;
        vm.cleanup = cleanup;
        vm.formatDate = formatDate;

        // Methods
        vm.standaloneServices = [];

        vm.step0StandaloneServices = [];
        vm.step0SubscriptionServices = [];
        vm.step0Events = [];
        vm.servicesToPay = [];

        vm.subscriptionServicesIds= [];
        vm.subscriptionServices = [];
        vm.organization = {};
        vm.subscriberId=null;
        vm.saveSubscription = saveSubscription;
        vm.selectedUserChange=selectedUserChange;
        vm.selectService=selectService;
        vm.lookupUser=lookupUser;
        vm.goToNextStep=goToNextStep;
        vm.askPaymentDetails=askPaymentDetails;
        vm.mustChooseService=false;
        vm.searchMode='ORG';
        vm.subscriptionDiscount={id: '', amount: 0};
        vm.lookupUserChildren = lookupUserChildren;

        vm.serviziQuotaAssociativaUtente = [];
        vm.serviziQuotaAssociativaAttivabili = [];

        vm.subscriptionToAdd = {};//quota associativa da aggiungere in fase di iscrizione
        vm.flgAddSubscription = null;
        vm.changeFlgAddSubscription = changeFlgAddSubscription;

        vm.organizationSubscriptionStatusType = {
            QUOTA_ASSOCIATIVA_NON_NECESSARIA: 0,
            QUOTA_ASSOCIATIVA_NON_ISCRITTO: 10,
            QUOTA_ASSOCIATIVA_NON_PAGATA: 20,
            QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI: 30,
            QUOTA_ASSOCIATIVA_OK: 100,
        };
        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA;
        vm.unconditionalDiscountAmount = 0;

        vm.children = [];           // elenco dipi di pagamento
        vm.childSelectedId = null;  // tipo di pagamento selezionato

        init();

        //////////


        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        $rootScope.$on('$translateChangeEnd', function () {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
        });

        $rootScope.$on('REF_PERIOD_CHANGED', function (event, value) {
            setTimeout(function() {
                loadAllStandaloneService($state.params.organizationId);
            },200);
        });
        /**
         * Initialize
         */
        function init(){
            if (AuthenticationService.isAuthenticated()){
                if ($state.params.offeredServiceId && $state.params.offeredServiceId!=='' ) {
                    //carico dettaglio servizio
                    vm.selecteServices = {};
                    vm.selecteServices[ $state.params.offeredServiceId] = true;
                    loadOfferedService( $state.params.offeredServiceId);
                }
                else {
                    vm.mustChooseService=true;
                    loadAllStandaloneService($state.params.organizationId);

                    if ($state.params.userId) {
                        vm.userIdParam = $state.params.userId;
                        loadUserDetail($state.params.userId, function(item) {
                            vm.subscriberData=item;
                            vm.subscriberData.birthDate=(item.birthDate && item.birthDate!==null && item.birthDate!=='')?moment(item.birthDate).toDate():null;
                            vm.parentUserEmail = (item.parents && item.parents.length > 0) ? item.parents[0].email : null;
                            vm.isRelativeSubscription = (item.parents && item.parents.length > 0);
                        });
                    }
                }
                loadAllSubscriptionsService($state.params.organizationId);
                loadAllDiscounts($state.params.organizationId);
                findOrganization($state.params.organizationId).then(function(org) {
                    vm.organization= org;
                });
            } else {
                $state.go('app.pages_auth_login');
            }

        }


        /**
         * Resetta la maschera
         */
        function cleanup() {
            vm.subscriberId=null;
            vm.subscriberData = {};
            vm.parentUserEmail = null;
            vm.isRelativeSubscription = false;
            vm.subscriberData.dtStart=new Date();
            if (vm.offeredService.scheduleType==='P') {
                vm.subscriberData.dtStart=vm.offeredService.start;
                vm.subscriberData.dtEnd=vm.offeredService.end;
            }
        }

        /**
         * Avanza di uno step nel wizard
         */
        function goToNextStep() {
            // TODO FIXME modificare questa espressione allucinante!!!
            if ($scope.$$childHead.$$childHead && $scope.$$childHead.$$childHead.msWizard) {
                $scope.$$childHead.$$childHead.msWizard.nextStep();
            } else if ($scope.$$childHead.$$nextSibling.$$childHead && $scope.$$childHead.$$nextSibling.$$childHead.msWizard) {
                $scope.$$childHead.$$nextSibling.$$childHead.msWizard.nextStep();
            } else if ($scope.$$childHead.$$nextSibling.$$nextSibling.$$childHead && $scope.$$childHead.$$nextSibling.$$nextSibling.$$childHead.msWizard) {
                //$scope.$$childHead.$$nextSibling.$$nextSibling.$$childHead.msWizard.nextStep();
                $scope.$$childHead.$$nextSibling.$$nextSibling.$$childHead.msWizard.selectedIndex++;
            } else if ($scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead && $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.msWizard) {
                $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.msWizard.nextStep();
            } else {
                $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.msWizard.nextStep();
            }
            loadUserServices();
        }



        /**
         * salvataggio finale
         */
        function saveSubscription(){
            saveSubscriptionInternal();
        }


        function changeFlgAddSubscription() {
            if (vm.flgAddSubscription === 'NO') {
                vm.subscriptionToAdd = {};
            }
        }


        /**
         * eFFETTUA LA EFFETTIVA CREAZIONE DELL'UTENTE figlio A PARTIRE DAl PADRE/GENITORE
         * @param parent
         */
        var doRealChildCreation = function(theParentUser, callback) {
            User.findById({id: theParentUser.id}).$promise.then(function(parent) {
                //se è stata messa al figlo la mail del padre allora sbianco quella del figlio
                // e salvo (tanto saranno propagate automaticamente le info)
                var aParent = parent;

                if (vm.subscriberData.email && vm.subscriberData.email.trim().toLowerCase() === aParent.email.trim().toLowerCase()) {
                    vm.subscriberData.email = null;
                }

                //altrimenti cerco che non vi sia già l'utente in cyl
                if (vm.subscriberData.email) {
                    findUserByMail(vm.subscriberData.email, function(users) {
                        if (!users || users === null || users.length === 0) {
                            var organizationId = vm.organization.id;
                            aParent.$prototype$addChild({user: vm.subscriberData, organizationId: organizationId}).then(function(data) {
                                $log.debug('Child created');
                                callback(data.child);
                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                        else {
                            // AlertMessageService.showErrorAlert("LP_ERRORS.EMAIL_ALREADY_IN_USE");
                            // Controllo se ho una relazione con l'utente
                            var theUser = users[0];
                            //SE NO La CREO E RITORNO A PAGINA FIGLI
                            UserRelation.find({
                                filter: {
                                    where: {
                                        childId: theUser.id,
                                        parentId: aParent.id
                                    }
                                }
                            }).$promise.then(function(relations) {
                                if (relations && relations.length > 0) {
                                    blockUI.stop();
                                    AlertMessageService.showSuccessMessage();
                                    callback(theUser);
                                } else {
                                    var organizationId = vm.organization.id;
                                    UserRelation.create({
                                        childId: theUser.id,
                                        parentId: aParent.id,
                                        createOrganizationId: organizationId
                                    }).$promise.then(function(data) {
                                        blockUI.stop();
                                        AlertMessageService.showSuccessMessage();
                                        callback(theUser);
                                    }, function(error) {
                                        blockUI.stop();
                                        AlertMessageService.showErrorAlert(error);
                                    });
                                }

                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                    });
                } else {
                    var organizationId = null;
                    if ($state.params.organizationId) {
                        organizationId = $state.params.organizationId;
                    }
                    aParent.$prototype$addChild({user: vm.subscriberData, organizationId: organizationId}).then(function(data) {
                        $log.debug('Child created');
                        callback(data.child);
                    }, function(error) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(error);
                    });
                }
            });
        };

        var completeChildCreationAsAdmin = function(theParent, callback) {
            doRealChildCreation(theParent, function(childUser) {
                vm.subscriberData.id = childUser.id;
                vm.subscriberData.contactEmail = theParent.email;
                User.saveUser({
                    user: vm.subscriberData,
                    organizationId: vm.organization.id.toString(),
                }).$promise.then(
                    function(data) {
                        $log.debug(data);
                        UserOrganizationRole.addAsContact({
                            userId: childUser.id.toString(),
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false
                        }).$promise.then(
                            function(data) {
                                callback(data);
                            },
                            function(httpResponse) {
                                blockUI.stop();
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            }
                        );
                    },
                    function(httpResponse) {
                        blockUI.stop();
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    }
                );


            });
        };

        var checkForChildParentCreation = function(callback) {
            if (vm.isRelativeSubscription && !vm.subscriberData.id && vm.parentUserEmail) {
                //CERCO IL PADRE VIA MAIL: SE ESISTE LO ASSOCIO SE NO LO CREO CON NOME FITTIZIO
                findUserByMail(vm.parentUserEmail, function(users) {
                    if (!users || users === null || users.length === 0) {
                        //creazione fittizia del genitore
                        User.createUserAndNotify({
                            user: {
                                givenName: 'Genitore di ' + vm.subscriberData.givenName,
                                familyName: vm.subscriberData.familyName,
                                email: vm.parentUserEmail
                            },
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false,
                            notificationText: ''
                        }).$promise.then(
                            function(response) {
                                var theParent = response.user;
                                completeChildCreationAsAdmin(theParent, callback);
                            },
                            function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                    }
                    else {
                        var theParent = users[0];
                        completeChildCreationAsAdmin(theParent, callback);

                    }
                });
            } else {
                callback();
            }
        };


        /**
         * Salvataggio Subscription
         */
        function saveSubscriptionInternal() {
            $log.debug('SubscriptionNewController.saveSubscriptionInternal()');
            blockUI.start();
            checkForChildParentCreation(function(done) {
                var subscribedServicesKeys = _.keys(vm.selecteServices);
                var subscribedServices = [];
                for (var i = 0; i < subscribedServicesKeys.length; i++) {
                    if (vm.selecteServices[subscribedServicesKeys[i]]) {
                        subscribedServices.push(subscribedServicesKeys[i]);
                    }
                }
                // se ho lo sconto incondizionato, ne segno l'importo
                if (vm.subscriptionDiscount.id === 'UNCONDITIONAL') {
                    vm.subscriptionDiscount.amount = vm.unconditionalDiscountAmount;
                }

                var theDiscountToApply = JSON.parse(JSON.stringify(vm.subscriptionDiscount));

                if (vm.flgAddSubscription === 'YES') {
                    var subscriptionToAddIds = [];
                    _.each(_.keys(vm.subscriptionToAdd), function(key) {
                        if (vm.subscriptionToAdd[key]) {
                            subscriptionToAddIds.push(key);
                        }
                    });

                    if (subscriptionToAddIds.length === 0) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert('E\' obbligatorio selezionare almeno una quota associativa');
                        return;
                    }

                    var promisesToCall = [];
                    for (var i = 0; i < subscriptionToAddIds.length; i++) {
                        promisesToCall.push(OfferedService.addNonRegisteredSubscriber({
                            offeredServiceId: subscriptionToAddIds[i], //servizio capofila
                            subscriberData: vm.subscriberData,             //dati utente
                            subscribedServices: [subscriptionToAddIds[i]],        //servizi accessori, nessuno, solo la quota stessa
                            subscriptionDiscount: {id: ''}  //sconto, nessuno sulla quota
                        }).$promise);
                    }

                    $q.all(promisesToCall)
                        .then(function(results) {
                            $log.debug('SubscriptionNewController.saveSubscriptionInternal - success q. associativa');
                            $log.debug(results);
                            $log.debug('SubscriptionNewController.saveSubscriptionInternal - Chiamo OfferedService.addNonRegisteredSubscriber()');
                            OfferedService.addNonRegisteredSubscriber({
                                //offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                                offeredServiceId: vm.childSelectedId.toString(),           //servizio capofila
                                subscriberData: vm.subscriberData,              //dati utente
                                subscribedServices: subscribedServices,         //servizi accessori
                                subscriptionDiscount: theDiscountToApply   //sconto eventuale
                            }).$promise.then(function(data) {
                                $log.debug('SubscriptionNewController.saveSubscriptionInternal - ritorno da OfferedService.addNonRegisteredSubscriber(); data: ' + JSON.stringify(data));
                                Subscription.findById({id: data.result}).$promise.then(function(subscription) {
                                    blockUI.stop();
                                    $log.debug('SubscriptionNewController.saveSubscriptionInternal - success');
                                    AlertMessageService.showSuccessMessage();
                                    vm.subscriptionDone = true;
                                    vm.subscriberId = subscription.userId;

                                    // #658: anzichè mostrare il tab 4 con il riepilogo dei pagamenti, vado alle iscrizioni della persona
                                    // $log.debug('SubscriptionNewController.saveSubscriptionInternal() - Mi sposto alle iscrizioni della persona');
                                    // $log.debug({organization: vm.organization, subscriberData: vm.subscriberData});
                                    if (vm.organization && vm.organization.id && vm.subscriberData && vm.subscriberData.id) {
                                        vm.gotoUserSubscriptions(vm.organization.id, vm.subscriberData.id);
                                    }
                                    // $timeout(function() {
                                    //     goToNextStep();
                                    //     loadServicesToPay();
                                    // }, 1000);
                                }, function (httpResponse) {
                                    $log.debug('fallita Subscription.findById(); httpResponse: ' + JSON.stringify(httpResponse));
                                    blockUI.stop();
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            }, function(httpResponse) {
                                $log.debug('fallita OfferedService.addNonRegisteredSubscriber(); httpResponse: ' + JSON.stringify(httpResponse));
                                blockUI.stop();
                                $log.debug('error');
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                        }, function(httpResponse){
                            $log.debug('fallita chiamata $q.all(): ' + JSON.stringify(httpResponse));
                            blockUI.stop();
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });

                } else {
                    $log.debug('SubscriptionNewController.saveSubscriptionInternal - Chiamo OfferedService.addNonRegisteredSubscriber()');
                    OfferedService.addNonRegisteredSubscriber({
                        //offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                        offeredServiceId: vm.childSelectedId.toString(),           //servizio capofila
                        subscriberData: vm.subscriberData,              //dati utente
                        subscribedServices: subscribedServices,         //servizi accessori
                        subscriptionDiscount: theDiscountToApply   //sconto eventuale
                    }).$promise.then(function(data){
                        $log.debug('SubscriptionNewController.saveSubscriptionInternal - ritorno da OfferedService.addNonRegisteredSubscriber(); data: ' + JSON.stringify(data));
                        Subscription.findById({id: data.result}).$promise.then(function(subscription) {
                            $log.debug('SubscriptionNewController.saveSubscriptionInternal - ritorno da Subscription.findById(); data: ' + JSON.stringify(data));
                            blockUI.stop();
                            $log.debug('SubscriptionNewController.saveSubscriptionInternal - success');
                            AlertMessageService.showSuccessMessage();
                            vm.subscriptionDone = true;
                            vm.subscriberId = subscription.userId;

                            // #658: anzichè mostrare il tab 4 con il riepilogo dei pagamenti, vado alle iscrizioni della persona
                            // $log.debug('SubscriptionNewController.saveSubscriptionInternal() - Mi sposto alle iscrizioni della persona');
                            // $log.debug({organization: vm.organization, subscriberData: vm.subscriberData});
                            if (vm.organization && vm.organization.id && vm.subscriberData && vm.subscriberData.id) {
                                vm.gotoUserSubscriptions(vm.organization.id, vm.subscriberData.id);
                            }
                            // vm.goToNextStep();
                            // loadServicesToPay();
                        }, function(httpResponse) {
                            $log.debug('SubscriptionNewController.saveSubscriptionInternal - fallita Subscription.findById(); httpResponse: ' + JSON.stringify(httpResponse));
                            blockUI.stop();
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    }, function(httpResponse) {
                        $log.debug('fallita OfferedService.addNonRegisteredSubscriber(); httpResponse: ' + JSON.stringify(httpResponse));
                        blockUI.stop();
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }
            });
        }


        function lookupUserChildren() {
            if (!vm.parentUserEmail && !vm.subscriberData.id) {
                return;
            }

            findUserByMail(vm.parentUserEmail, function(users) {
                if (users && users.length > 0) {
                    var children = users[0].children;
                    if (children && children.length > 0) {
                        $scope.parentChildren = children;
                        $scope.parentDisplayName = users[0].displayName;
                        $scope.parentEmail = users[0].email;
                        $mdDialog.show({
                            controller : DialogController,
                            templateUrl: 'app/main/pages/commons/dialogs/children_lookup_dialog.html',
                            parent : angular.element(document.body),
                            scope : $scope,
                            preserveScope : true,
                            clickOutsideToClose : true
                        }).then(function(answer) {
                            if (answer) {
                                loadUserDetail(answer, function(item) {
                                    selectedUserChange(item);
                                });
                            }
                        });
                    }
                }
            });
        }

        /**
         * selezione utente da autocompletion
         */
        function selectedUserChange(item) {

            if (!item) {
                return;
            }

            var tmpDtStart = vm.subscriberData.dtStart;
            var tmpDtEnd = vm.subscriberData.dtEnd;

            if (!item.numRoles) {
                //CHIEDO CONFERMA PER UTENTI DI CYL NON GIA DELLA MIA ORGANIZZAZIONE
                $mdDialog.show({
                    controller : DialogController,
                    templateUrl: 'app/main/pages/commons/dialogs/add_user_as_contact.html',
                    parent : angular.element(document.body),
                    scope : $scope,
                    preserveScope : true,
                    clickOutsideToClose : true
                })
                    .then(function(answer) {
                        if (item && item!==null) {
                            loadUserDetail(item.id, function(myUser) {
                                if (myUser.email && myUser.email.endsWith('.invalid')) {
                                    myUser.email='';
                                }
                                vm.subscriberData=myUser;
                                vm.subscriberData.birthDate=(myUser.birthDate && myUser.birthDate!==null && myUser.birthDate!=='')?moment(myUser.birthDate).toDate():null;
                                vm.subscriberData.dtStart = tmpDtStart;
                                vm.subscriberData.dtEnd = tmpDtEnd;
                                vm.parentUserEmail = (myUser.parents && myUser.parents.length > 0) ? myUser.parents[0].email : null;
                                vm.isRelativeSubscription = (myUser.parents && myUser.parents.length > 0);
                            });
                        }
                        else {
                            vm.subscriberData={};
                            vm.subscriberData.dtStart = tmpDtStart;
                            vm.subscriberData.dtEnd = tmpDtEnd;
                        }
                    });

            }
            else {
                if (item && item!==null) {
                    loadUserDetail(item.id, function(myUser) {
                        if (myUser.email && myUser.email.endsWith('.invalid')) {
                            myUser.email='';
                        }
                        vm.subscriberData=myUser;
                        vm.subscriberData.birthDate=(myUser.birthDate && myUser.birthDate!==null && myUser.birthDate!=='')?moment(myUser.birthDate).toDate():null;
                        vm.subscriberData.dtStart = tmpDtStart;
                        vm.subscriberData.dtEnd = tmpDtEnd;
                        vm.parentUserEmail = (myUser.parents && myUser.parents.length > 0) ? myUser.parents[0].email : null;
                        vm.isRelativeSubscription = (myUser.parents && myUser.parents.length > 0);
                    });
                }
                else {
                    vm.subscriberData={};
                    vm.subscriberData.dtStart = tmpDtStart;
                    vm.subscriberData.dtEnd = tmpDtEnd;
                }
            }
        }

        /**
         * ricerca utente
         */
        function lookupUser(txt){
            txt=txt+'%';
            var deferred = $q.defer();

            var orgToSearch = (vm.searchMode === 'ORG') ? vm.offeredService.organizationId : null;
            var isGlobalSearch = (vm.searchMode !== 'ORG');
            User.lookupUsers({text: txt, organizationId: orgToSearch, isGlobalSearch: isGlobalSearch}).$promise.then (function(data) {
                deferred.resolve(data.users);
            });
            return deferred.promise;
        }

        /**
         * seleziona un servizio standalone e fa partire il wizard
         */
        function selectService(service) {
            //servizi selezionati per l'acquisto
            vm.selecteServices = {};
            vm.selecteServices[service.id] = true;
            // nasconde la selezione del servizio mostrando il wizard
            vm.mustChooseService=false;
            loadOfferedService( service.id );

            // attende che esisita il wizard prima di avviarne il nextstep
            var skipWizardStep = $interval(function() {
                $log.debug('Controllo esistenza wizard');
                if ($scope.$$childHead) {
                    if (angular.isDefined(skipWizardStep)) {
                        $log.debug('Rimuovo controllo esistenza wizard');
                        $interval.cancel(skipWizardStep);
                        skipWizardStep = undefined;
                        goToNextStep();
                    }
                }
            }, 250);
        }


        /**
         * carica i servizi della associazione che sono agganciabili
         */
        function loadAllAttachableService(){
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {

                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: vm.offeredService.organizationId},
                                {standalone: {neq: 'S'}},
                                {serviceType: 'SERVICE'},
                                {dtDel: null},
                            ]
                        }
                    }
                };

                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }

                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    query.filter.where.and.push(
                        {
                            or: [
                                {scheduleType: {inq: ['R', 'N']}},
                                {and: [
                                        {start: {lte: dateTo}},
                                        {end: {gte: dateFrom}}
                                    ]}
                            ]
                        }
                    );
                }


                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.attachableServices = data;
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }

        /**
         * carica i servizi rivendibili singolarmente
         */
        function loadAllStandaloneService(organizationId){
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: organizationId},
                                {standalone: 'S'},
                                {dtDel: null}
                            ]
                        },
                        include: 'serviceTypes'
                    }
                };

                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }

                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    query.filter.where.and.push(
                        {
                            and: [
                                { isPaymentPlan: null },
                                {
                                    or: [
                                        {scheduleType: {inq: ['R', 'N']}},
                                        {and: [
                                                {start: {lte: dateTo}},
                                                {end: {gte: dateFrom}}
                                            ]}
                                    ]
                                }
                            ],

                        }
                    );
                }

                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.standaloneServices = data;

                        vm.step0SubscriptionServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return false;
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return true;
                            } else {
                                return false;
                            }
                        });

                        vm.step0StandaloneServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return d.serviceType !== 'EVENT';
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return false;
                            } else {
                                return d.serviceType !== 'EVENT';
                            }
                        });

                        vm.step0Events = _.filter(data, function(d) {
                            return d.serviceType === 'EVENT';
                        });
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }


        function loadUserServices() {

            checkForSelectedUser(function(userId) {
                vm.subscriberId = userId;
                if (userId) {
                    User.findById({
                        id: userId
                    }).$promise.then(function(user){
                        user.$prototype$allServices().then(
                            function(response) {

                                if ( response.result.services &&  response.result.services!==null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i <  theServices.length; i++) {
                                        var dateFrom =  theServices[i].dateFrom;
                                        if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                            theServices[i].dateFrom=new Date(dateFrom);
                                        }
                                        var dateTo =  theServices[i].dateTo;
                                        if (dateTo && dateTo!==null && dateTo!=='') {
                                            theServices[i].dateTo=new Date(dateTo);
                                        }
                                    }

                                    //FILTRO PER QUELLI DELLA ORGANIZZAZIONE DI TIPO ISCRIZIONE
                                    theServices = _.filter(theServices,  function (s) {
                                        if (s.organizationId != $state.params.organizationId) {
                                            return false;
                                        }
                                        //
                                        var found = _.find(vm.subscriptionServicesIds, function(id) {
                                            return id == s.id;
                                        });
                                        return found ? true:false;
                                    });

                                    //scremo eventuali doppioni per parenti o tutelati
                                    theServices = _.filter(theServices,  function (s) {
                                        return userId == s.userId;
                                    });

                                    vm.serviziQuotaAssociativaUtente = theServices;
                                } else {
                                    vm.serviziQuotaAssociativaUtente=[];
                                }

                                checkQuoteAssociativeAttivabili();

                            });
                    });
                } else {
                    checkQuoteAssociativeAttivabili();
                }
            });
        }


        function checkQuoteAssociativeAttivabili() {
            //SE IL SERVIZIO CORRENTE RICHIEDE ISCRIZIONE ALLA QUOTA ASSOCIATIVA ALLORA CERCO tra i vm.subscriptionServices
            //SE QUELLI CHE PER DATA SI AGGANCIANO AL SERVIZIO SONO PRESENTI, PAGATI O CON DOC MANCANTI
            if (vm.offeredService.needsOrganizationSubscription) {
                //cerco tra i vm.subscriptionServices le iscrizioni plausibili includendo:
                // - quelle la cui data di inizio fine comprende data di inizio del servizio
                // - quelle la cui data di inizio fine comprende la data di oggi
                vm.serviziQuotaAssociativaAttivabili = _.filter(vm.subscriptionServices, function(sqa) {
                    if (sqa.start && sqa.end) {
                        if (vm.offeredService.start && !moment(sqa.start).isAfter(vm.offeredService.start) && !moment(vm.offeredService.start).isAfter(sqa.end)) {
                            return true;
                        } else if (!moment(sqa.start).isAfter(new Date()) && !moment().isAfter(sqa.end)) {
                            return true;
                        }
                    } else if (!sqa.start && !sqa.end) {
                        //quota associativa che non ha nè inizio nè fine: ha senso?
                        return true;
                    }
                    return false;
                });

                //CONTROLLO LO STATO DELLE ISCRIZIONI RISPETTO serviziQuotaAssociativaAttivabili
                var iscrizioneQuotaAssociativa = null;
                for (var i = 0; i < vm.serviziQuotaAssociativaAttivabili.length; i++) {
                    var servizioAttivabile = vm.serviziQuotaAssociativaAttivabili[i];
                    var found = _.find(vm.serviziQuotaAssociativaUtente, function(squ) {
                        return squ.id == servizioAttivabile.id;
                    });
                    if (found) {
                        iscrizioneQuotaAssociativa = found;
                        break;
                    }
                }

                if (!iscrizioneQuotaAssociativa) {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                } else {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                    if (iscrizioneQuotaAssociativa.paymentValue < iscrizioneQuotaAssociativa.paymentDue) {
                        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA;
                    } else {
                        var docOk = true;
                        for (var i = 0; i < iscrizioneQuotaAssociativa.docs.length; i++) {
                            var doc = iscrizioneQuotaAssociativa.docs[i];
                            if (doc.status === 'MISSING' || doc.status === 'EXPIRED' || doc.status === 'REJECTED' || doc.status === 'EXPIRING') {
                                docOk = false;
                                break;
                            }
                        }
                        if (docOk) {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK;
                        } else {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI;
                        }
                    }

                }
            }

        }


        /**
         * Effettua un pagamento di iscrizione
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        function askPaymentDetails( userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue=amount;
            } else {
                $scope.myResource.paymentValue=null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            loadUserServices(userId);

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        if (!vm.subscriptionDone) {
                            loadUserServices();
                        } else {
                            loadServicesToPay();
                        }
                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         * verifica se l'utente che si vuole iscrivere esiste già o meno e chiama la callback passandone eventuale ID
         * @param callback
         */
        function checkForSelectedUser(callback) {
            if (vm.subscriberData.id) {
                callback(vm.subscriberData.id);
            } else {
                //UTENTE COMPILATO A MANO
                findUserByMail(vm.subscriberData.email, function(users) {
                    if (!users || users===null || users.length===0) {
                        callback(null);
                    }
                    else {
                        callback(users[0].id);
                        //TODO USERRLOAD

                    }
                });
            }
        }


        /**
         * Cerca un utente per mail
         * @param mail
         * @param callback
         */
        function findUserByMail(mail, callback){
            var query ={filter: {
                    where : {email: mail},
                    include: 'children'
                }
            }
            User.find(query, function(users) {
                callback(users);
            });
        }


        function loadUserDetail(id, callback){
            User.loadUser({
                id: id,
                organizationId: $state.params.organizationId,
                filter: { include: 'parents'}
            }, function(user) {
                callback(user);
            }, function(error){
                $log.debug(error);
            });
        }


        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllSubscriptionsService(organizationId){
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone:'S',
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers){
                    vm.subscriptionServices = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length===0) {
                            return false;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode==='SUBSCRIPTION';
                        });
                        if (found) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    vm.subscriptionServicesIds = _.map(vm.subscriptionServices, function (s) {
                        return s.id;
                    });
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica le tipologie di sconti da applicare all'iscrizione
         * @param organizationId
         */
        function loadAllDiscounts(organizationId){
            Discount.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.discounts = data;
                    // vm.discounts.concat([
                    //     {
                    //         id: "",
                    //         name: $translate.instant('SUBSCRIPTIONS.NO_DISCOUNT'),
                    //         type: 'AMOUNT',
                    //         value: 0
                    //     },
                    //     {
                    //         id: "UNCONDITIONAL",
                    //         name: $translate.instant('SUBSCRIPTIONS.UNCONDITIONAL_DISCOUNT'),
                    //         type: 'AMOUNT',
                    //         value: 0
                    //     }
                    // ]);
                    // vm.discounts.concat(data);
                    // $log.debug(vm.discounts);
                },
                function(error){
                    $log.debug(error);
                });
        }

        /**
         * carica dettaglio servizio
         */
        function loadOfferedService(id){
            OfferedService.findById({
                id: id,
                filter: {
                    include: ['organization']
                }
            }).$promise.then(
                function(data, headers){
                    var myService = data;
                    vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                    if (vm.offeredService.start && vm.offeredService.start!==null) {
                        vm.offeredService.start=new Date(vm.offeredService.start);
                    }

                    if (vm.offeredService.end && vm.offeredService.end!==null) {
                        vm.offeredService.end=new Date(vm.offeredService.end);

                    }

                    vm.subscriberData.dtStart=new Date();
                    if (vm.offeredService.scheduleType==='P') {
                        vm.subscriberData.dtStart=vm.offeredService.start;
                        vm.subscriberData.dtEnd=vm.offeredService.end;
                    }

                    vm.loadChildServices();

                    loadAllAttachableService();
                },
                function(error){
                    $log.debug(error);
                });
        }


        /**
         * Carica i servizi figli di quello visualizzato. Imposta il servizio attualmente visualizzato come
         * primo figlio.
         */
        vm.loadChildServices = function() {
            $log.debug('vm.loadChildServices()');
            vm.children = [];
            // come primo figlio mette il servizio stesso
            vm.children.push(vm.offeredService);

            // poi cercai servizi figli e li aggiunge
            OfferedService.findById({
                id: vm.offeredService.id,
                filter: {
                    include: ['children'],
                }
            }).$promise.then(
                function(offeredService) {
                    offeredService = JSON.parse(JSON.stringify(offeredService));
                    // carica i children in vm.children
                    _.each(offeredService.children, function(child) {
                        if (!child.dtDel) {
                            vm.children.push(child);
                        }
                    });
                    // seleziono il primo child (ovvero il servizio principale) se il servizio non ha figli
                    if (vm.children.length === 1) {
                        vm.childSelectedId = vm.offeredService.id;
                    }
                },
                function(err) {
                    $log.error('Errore caricando OfferedService figli');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Errore caricando OfferedService figli: ' + err.message);
                }
            );
        };



        /**
         * Calcola i servizi dell'utente ancora da pagare all'ultimo step della iscrizione
         */
        function loadServicesToPay() {
            vm.servicesToPay = [];
            User.loadUser({
                id: vm.subscriberData.id || vm.subscriberId,
                organizationId: vm.organization.id
            }).$promise.then(function(user) {
                user.$prototype$allServices().then(
                    function(response) {
                        blockUI.stop();
                        if (response.result.services && response.result.services !== null) {
                            var theServices = response.result.services;
                            for (var i = 0; i < theServices.length; i++) {
                                var dateFrom = theServices[i].dateFrom;
                                if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                    theServices[i].dateFrom = new Date(dateFrom);
                                }
                                var dateTo = theServices[i].dateTo;
                                if (dateTo && dateTo !== null && dateTo !== '') {
                                    theServices[i].dateTo = new Date(dateTo);
                                }
                            }
                            //filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                            theServices = _.filter(theServices, function(service) {
                                return (vm.organization.id == service.organizationId && service.paymentValue < service.paymentDue);
                            })
                            //PRENDO GLI ORDER DETAILS RELATIVI
                            //TODO #189
                            if (theServices.length > 0) {
                                var subscritpionIds = _.map(theServices, function(s) {
                                    return s.subscriptionId;
                                });
                                Subscription.find({
                                    filter: {
                                        where: {id: {inq: subscritpionIds}},
                                        include: ['user', 'payments', {orders: {orderDetails: ['offeredService', {subscriptionDiscount: 'discount'}]}}]
                                    }
                                }).$promise.then(
                                    function(data, headers) {
                                        _.each(data, function(subscription) {
                                            var curService = _.find(theServices, function(s) {
                                                return s.subscriptionId == subscription.id;
                                            });
                                            curService.details = [];
                                            var payments = subscription.payments;
                                            // ordino gli Order prima di mostrarli
                                            subscription.orders = _.sortBy(subscription.orders, function(order) {
                                                return moment(order.created).toISOString();
                                            });
                                            _.each(subscription.orders, function(order) {
                                                // ordino gli OrderDetail
                                                order.orderDetails = _.sortBy(order.orderDetails, function(orderDetail) {
                                                    return moment(orderDetail.created).toISOString();
                                                });
                                                _.each(order.orderDetails, function(orderDetail) {
                                                    var obj = orderDetail;
                                                    obj.dtBillingPeriodStart = order.dtBillingPeriodStart;
                                                    obj.dtBillingPeriodEnd = order.dtBillingPeriodEnd;
                                                    if (obj.subscriptionDiscountId) {
                                                        var discounts = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'DISCOUNT';
                                                        });
                                                        var amount = _.reduce(discounts, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    } else {
                                                        var paymentsUnpayed = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'UNPAYED';
                                                        });
                                                        var amount = _.reduce(paymentsUnpayed, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    }

                                                    if (obj.paymentStatus !== 'PAYED') {
                                                        curService.details.push(obj);
                                                    }
                                                });
                                            });
                                            curService.details = _.sortBy(curService.details, function(d) {
                                                return d.dtBillingPeriodStart;
                                            });
                                        });
                                        _.each(theServices, function(service) {
                                            var paymentDueAtToday = 0;
                                            _.each(service.details, function(detail) {
                                                if (moment().isAfter(detail.dtBillingPeriodStart)) {
                                                    paymentDueAtToday += detail.amount;
                                                }
                                            });
                                            if (paymentDueAtToday === 0 && service.details.length>0) {
                                                //prendo order id del primo ordine
                                                var firstOrderId = service.details[0].orderId;
                                                //prendo tutti i dettagli di quell'ordine
                                                _.each(service.details, function(detail) {
                                                    if (detail.orderId === firstOrderId) {
                                                        paymentDueAtToday += detail.amount;
                                                    }
                                                });
                                            }
                                            service.paymentDue = paymentDueAtToday;
                                        });
                                        vm.servicesToPay = theServices;

                                    },
                                    function(error) {
                                        $log.debug(error);
                                    });
                            }


                        } else {
                            vm.servicesToPay = [];
                        }
                    }, function(error) {
                        blockUI.stop();
                        $log.debug(error);
                    });
            }, function(error){
                blockUI.stop();
                $log.debug(error);
            });
        }

        function findOrganization(id) {
            $log.debug('NewSubscriptionController.findOrganization()');
            return Organization.findById({
                id : id,
                filter : {
                }
            }).$promise;
        }


        function formatDate(date) {
            return DateFormatter.formatDate(date);
        }


        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        /**
         * Applica uno sconto ad un importo
         *
         * @param {number} importo
         * @param {object} sconto
         * @returns {number} importo scontato
         */
        vm.applicaSconto = function(importo, sconto) {
            // $log.debug('vm.applicaSconto()');
            // $log.debug('importo: ' + importo);
            // $log.debug('sconto: ' + JSON.stringify(sconto));
            if (importo && sconto && sconto.value && sconto.type) {
                if (sconto.type.toUpperCase() === 'AMOUNT') {
                    return importo = importo - sconto.value;
                } else if (sconto.type.toUpperCase() === 'PERCENT') {
                    return importo - (importo * sconto.value / 100);
                }
            } else {
                return importo;
            }
        };
        vm.calcolaSconto = function(importo, sconto) {
            // $log.debug('vm.applicaSconto()');
            // $log.debug('importo: ' + importo);
            // $log.debug('sconto: ' + JSON.stringify(sconto));
            if (importo && sconto && sconto.value && sconto.type) {
                if (sconto.type.toUpperCase() === 'AMOUNT') {
                    return sconto.value;
                } else if (sconto.type.toUpperCase() === 'PERCENT') {
                    return (importo * sconto.value / 100);
                }
            } else {
                return 0;
            }
        };


        /**
         * Calcola il prezzo totale di un'iscrizione
         * @returns {number} Prezzo totale, considerando costo di subscription, rinnovo, sconto
         */
        vm.calculateTotalPrice = function() {
            // $log.debug('vm.calculateTotalPrice()');
            vm.subscriptionDiscount.amount = 0;

            // il servizio da usare è quello selezionato tra i figli (
            var selectedService = null;
            _.each(vm.children, function(child) {
                if (child.id === vm.childSelectedId) {
                    selectedService = JSON.parse(JSON.stringify(child));
                }
            });

            if (selectedService) {
                // calcola l'importo, senza sconti, per ora
                var tot = (selectedService.subscriptionPrice ? selectedService.subscriptionPrice : 0) +
                    (selectedService.renewalPrice ? selectedService.renewalPrice : 0);
                // aggiungo i costi dei servizi selezionati
                for (var i = 0; i < vm.attachableServices.length; i++) {
                    if (vm.selecteServices[vm.attachableServices[i].id]) {
                        tot += vm.attachableServices[i].subscriptionPrice ? vm.attachableServices[i].subscriptionPrice : 0;
                        tot += vm.attachableServices[i].renewalPrice ? vm.attachableServices[i].renewalPrice : 0;
                    }
                }
                // calcolo lo sconto selezionato
                for (var j = 0; j < vm.discounts.length; j++) {
                    if (vm.discounts[j].id === vm.subscriptionDiscount.id) {
                        // lo applico al totale
                        vm.subscriptionDiscount.amount = vm.calcolaSconto(tot, vm.discounts[j]);
                    }
                }
                if (vm.subscriptionDiscount.id !== 'UNCONDITIONAL') {
                    vm.unconditionalDiscountAmount = 0;
                }
                tot = tot - vm.subscriptionDiscount.amount - vm.unconditionalDiscountAmount;
            }

            return tot;
        };

        vm.openNuovoPiano = function() {
            $scope.child = {};
            $mdDialog.show({
                controller : DialogController,
                templateUrl: 'app/main/pages/subscriptions/dialogs/new_child_service_dialog.html',
                parent : angular.element(document.body),
                scope : $scope,
                preserveScope : true,
                clickOutsideToClose : true
            }).then(function() {
                $scope.child.organizationId = vm.offeredService.organizationId;
                $scope.child.start =  vm.offeredService.start;
                $scope.child.end =  vm.offeredService.end;
                $scope.child.isPaymentPlan = true;
                $scope.child.isDeleted = false;
                // crea nuovo elemento
                OfferedService.create(
                    $scope.child
                ).$promise.then(
                    function(newChildInstance) {
                        $log.debug('Creato OfferedService: ' + JSON.stringify(newChildInstance));
                        // aggiunge il riferimento al genitore
                        OfferedServiceRelation.create({
                            childId: newChildInstance.id,
                            parentId: vm.offeredService.id,
                        }).$promise.then(
                            function(osRelationInstance) {
                                // avvia il reload dei servizi children
                                vm.loadChildServices();
                            },
                            function(err) {
                                $log.error('Errore in creazione OfferedServiceRelation');
                                $log.error(err);
                                AlertMessageService.showErrorAlert('Errore in creazione OfferedServiceRelation: ' + err.message);
                            }
                        );
                    },
                    function(err) {
                        $log.error('Errore in creazione OfferedService');
                        $log.error(err);
                        AlertMessageService.showErrorAlert('Errore in creazione OfferedService: ' + err.message);
                    }
                );
            });
        }


        /**
         * Salva un OfferedService dopo la modifica o la creazione
         *
         * @param {OfferedService} child
         */
        vm.saveChild = function(child) {
            $log.debug('vm.saveChild()');
            // copia i dati che non sono di pagamento dal genitore
            vm.copiaDati(vm.item, child);
            $log.debug('Salvo offeredService (in new_subscription_controller.js): ' + JSON.stringify(child));
        };



        /**
         * Al clic su un OfferedService child (Tab "piano di pagamento"), lo indico come
         * selezionato, e permetto all'utente di proseguire al prossimo step.
         *
         * @param offeredServiceId
         */
        vm.selectChildService = function(offeredServiceId) {
            vm.childSelectedId = offeredServiceId;
            vm.selecteServices = {};
            vm.selecteServices[offeredServiceId] = true;
        };


        vm.gotoUserSubscriptions = function(organizationId, userId) {
            $log.debug('SubscriptionNewController.gotoUserSubscriptions()');
            $state.go('app.pages_subscriptions_person', {
                organizationId: organizationId,
                offeredServiceId: null,
                paymentsFilter: 'A',
                documentsFilter: null,
                userId: userId,
            });
        };

    }
})();

'use strict';

(function() {
    angular
        .module('app.pages.subscriptions')
        .controller('NewSubscriptionFromServiceController', NewSubscriptionFromServiceController);

    /** @ngInject */
    function NewSubscriptionFromServiceController($log, $q, $location, $state, $timeout, $scope, $rootScope, blockUI,
                                                  $translate, OfferedService, Organization, DTOptionsBuilder,
                                                  ServiceSchedule, Discount, $mdDialog, AuthenticationService,
                                                  OfferedServiceRelation, UserOrganizationRole, AlertMessageService,
                                                  Subscription, Payment, PaymentReason, breadcrumbManager,
                                                  OrganizationDoctype, $filter, User, ApiPath, UserRelation, _) {
        var vm = this;

        var organizationId;

        // Data
        vm.subscriberData = {};
        vm.offeredService = {};
        vm.attachableServices = [];
        vm.discounts = [];
        vm.apiPath = ApiPath;
        vm.subscriptionDone = false;
        vm.cleanup = cleanup;
        vm.formatDate = formatDate;

        // Methods
        vm.standaloneServices = [];

        vm.step0StandaloneServices = [];
        vm.step0SubscriptionServices = [];
        vm.step0Events = [];
        vm.servicesToPay = [];

        vm.subscriptionServicesIds = [];
        vm.subscriptionServices = [];
        vm.organization = {};
        vm.subscriberId = null;
        vm.saveSubscription = saveSubscription;
        vm.selectedUserChange = selectedUserChange;
        vm.selectService = selectService;
        vm.lookupUser = lookupUser;
        vm.goToNextStep = goToNextStep;
        vm.askPaymentDetails = askPaymentDetails;
        vm.mustChooseService = false;
        vm.searchMode = 'ORG';
        vm.subscriptionDiscount = {id: '', amount: 0};
        vm.lookupUserChildren = lookupUserChildren;
        vm.saveButtonEnabled = true;

        vm.serviziQuotaAssociativaUtente = [];
        vm.serviziQuotaAssociativaAttivabili = [];

        vm.subscriptionToAdd = {};//quota associativa da aggiungere in fase di iscrizione
        vm.flgAddSubscription = null;
        vm.changeFlgAddSubscription = changeFlgAddSubscription;

        vm.organizationSubscriptionStatusType = {
            QUOTA_ASSOCIATIVA_NON_NECESSARIA: 0,
            QUOTA_ASSOCIATIVA_NON_ISCRITTO: 10,
            QUOTA_ASSOCIATIVA_NON_PAGATA: 20,
            QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI: 30,
            QUOTA_ASSOCIATIVA_OK: 100,
        };
        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA;
        vm.unconditionalDiscountAmount = 0;

        vm.children = [];           // elenco dipi di pagamento
        vm.childSelectedId = null;  // tipo di pagamento selezionato

        init();

        //////////


        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json')
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');


        $rootScope.$on('$translateChangeEnd', function() {
            vm.dtOptionServices.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
        });

        $rootScope.$on('REF_PERIOD_CHANGED', function(event, value) {
            setTimeout(function() {
                loadAllStandaloneService($state.params.organizationId);
            }, 200);
        });

        /**
         * Initialize
         */
        function init() {
            if (AuthenticationService.isAuthenticated()) {
                if ($state.params.offeredServiceId && $state.params.offeredServiceId !== '') {
                    //carico dettaglio servizio
                    vm.selecteServices = {};
                    vm.selecteServices[$state.params.offeredServiceId] = true;
                    loadOfferedService($state.params.offeredServiceId);
                } else {
                    vm.mustChooseService = true;
                    loadAllStandaloneService($state.params.organizationId);

                    if ($state.params.userId) {
                        loadUserDetail($state.params.userId, function(item) {
                            vm.subscriberData = item;
                            vm.subscriberData.birthDate = (item.birthDate && item.birthDate !== null && item.birthDate !== '') ? moment(item.birthDate).toDate() : null;
                            vm.parentUserEmail = (item.parents && item.parents.length > 0) ? item.parents[0].email : null;
                            vm.isRelativeSubscription = (item.parents && item.parents.length > 0);
                        });
                    }
                }
                loadAllSubscriptionsService($state.params.organizationId);
                loadAllDiscounts($state.params.organizationId);
                findOrganization($state.params.organizationId).then(function(org) {
                    vm.organization = org;
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        /**
         * Resetta la maschera
         */
        function cleanup() {
            vm.subscriberId = null;
            vm.subscriberData = {};
            vm.parentUserEmail = null;
            vm.isRelativeSubscription = false;
            vm.subscriberData.dtStart = new Date();
            if (vm.offeredService.scheduleType === 'P') {
                vm.subscriberData.dtStart = vm.offeredService.start;
                vm.subscriberData.dtEnd = vm.offeredService.end;
            }
        }


        /**
         * Cerca il componente wizard
         * @param contesto
         * @param depth
         */
        function searchMsWizard(contesto, depth) {
            if (contesto && depth > 0) {
                if (contesto['msWizard']) {
                    return contesto['msWizard'];
                } else if (contesto.$$childHead) {
                    return searchMsWizard(contesto.$$childHead, depth-1);
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }


        function goToNextStep() {
            console.log($scope);
            var wizard = searchMsWizard($scope, 10);
            if (wizard) {
                wizard.nextStep();
            }
            loadUserServices();
        }

        /**
         * salvataggio finale
         */
        function saveSubscription() {
            saveSubscriptionInternal();
        }


        function changeFlgAddSubscription() {
            if (vm.flgAddSubscription === 'NO') {
                vm.subscriptionToAdd = {};
            }
        }


        /**
         * eFFETTUA LA EFFETTIVA CREAZIONE DELL'UTENTE figlio A PARTIRE DAl PADRE/GENITORE
         * @param parent
         */
        var doRealChildCreation = function(theParentUser, callback) {
            User.findById({id: theParentUser.id}).$promise.then(function(parent) {
                //se è stata messa al figlo la mail del padre allora sbianco quella del figlio
                // e salvo (tanto saranno propagate automaticamente le info)
                var aParent = parent;

                if (vm.subscriberData.email && vm.subscriberData.email.trim().toLowerCase() === aParent.email.trim().toLowerCase()) {
                    vm.subscriberData.email = null;
                }

                //altrimenti cerco che non vi sia già l'utente in cyl
                if (vm.subscriberData.email) {
                    findUserByMail(vm.subscriberData.email, function(users) {
                        if (!users || users === null || users.length === 0) {
                            var organizationId = vm.organization.id;
                            aParent.$prototype$addChild({
                                user: vm.subscriberData,
                                organizationId: organizationId
                            }).then(function(data) {
                                $log.debug('Child created');
                                callback(data.child);
                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                        else {
                            // AlertMessageService.showErrorAlert("LP_ERRORS.EMAIL_ALREADY_IN_USE");
                            // Controllo se ho una relazione con l'utente
                            var theUser = users[0];
                            //SE NO La CREO E RITORNO A PAGINA FIGLI
                            UserRelation.find({
                                filter: {
                                    where: {
                                        childId: theUser.id,
                                        parentId: aParent.id
                                    }
                                }
                            }).$promise.then(function(relations) {
                                if (relations && relations.length > 0) {
                                    blockUI.stop();
                                    AlertMessageService.showErrorAlert('RELAZIONE GIA ESISTENTE');
                                } else {
                                    var organizationId = vm.organization.id;
                                    UserRelation.create({
                                        childId: theUser.id,
                                        parentId: aParent.id,
                                        createOrganizationId: organizationId
                                    }).$promise.then(function(data) {
                                        blockUI.stop();
                                        AlertMessageService.showSuccessMessage();
                                        callback(theUser);
                                    }, function(error) {
                                        blockUI.stop();
                                        AlertMessageService.showErrorAlert(error);
                                    });
                                }

                            }, function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                        }
                    });
                } else {
                    var organizationId = null;
                    if ($state.params.organizationId) {
                        organizationId = $state.params.organizationId;
                    }
                    aParent.$prototype$addChild({
                        user: vm.subscriberData,
                        organizationId: organizationId
                    }).then(function(data) {
                        $log.debug('Child created');
                        callback(data.child);
                    }, function(error) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert(error);
                    });
                }
            });
        };


        var completeChildCreationAsAdmin = function(theParent, callback) {
            doRealChildCreation(theParent, function(childUser) {
                vm.subscriberData.id = childUser.id;
                vm.subscriberData.contactEmail = theParent.email;
                User.saveUser({
                    user: vm.subscriberData,
                    organizationId: vm.organization.id.toString(),
                }).$promise.then(
                    function(data) {
                        $log.debug(data);
                        UserOrganizationRole.addAsContact({
                            userId: childUser.id.toString(),
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false
                        }).$promise.then(
                            function(data) {
                                callback(data);
                            },
                            function(httpResponse) {
                                blockUI.stop();
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            }
                        );
                    },
                    function(httpResponse) {
                        blockUI.stop();
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    }
                );


            });
        };


        var checkForChildParentCreation = function(callback) {
            if (vm.isRelativeSubscription && !vm.subscriberData.id && vm.parentUserEmail) {
                //CERCO IL PADRE VIA MAIL: SE ESISTE LO ASSOCIO SE NO LO CREO CON NOME FITTIZIO
                findUserByMail(vm.parentUserEmail, function(users) {
                    if (!users || users === null || users.length === 0) {
                        //creazione fittizia del genitore
                        User.createUserAndNotify({
                            user: {
                                givenName: 'Genitore di ' + vm.subscriberData.givenName,
                                familyName: vm.subscriberData.familyName,
                                email: vm.parentUserEmail
                            },
                            organizationId: vm.organization.id.toString(),
                            sendNotification: false,
                            notificationText: ''
                        }).$promise.then(
                            function(response) {
                                var theParent = response.user;
                                completeChildCreationAsAdmin(theParent, callback);
                            },
                            function(error) {
                                blockUI.stop();
                                AlertMessageService.showErrorAlert(error);
                            });
                    }
                    else {
                        var theParent = users[0];
                        completeChildCreationAsAdmin(theParent, callback);

                    }
                });
            } else {
                callback();
            }
        };


        /**
         * Salvataggio Subscription
         */
        function saveSubscriptionInternal() {
            vm.saveButtonEnabled = false;
            blockUI.start();
            checkForChildParentCreation(function(done) {
                var subscribedServicesKeys = _.keys(vm.selecteServices);
                var subscribedServices = [];
                for (var i = 0; i < subscribedServicesKeys.length; i++) {
                    if (vm.selecteServices[subscribedServicesKeys[i]]) {
                        subscribedServices.push(subscribedServicesKeys[i]);
                    }
                }
                // se ho lo sconto incondizionato, ne segno l'importo
                if (vm.subscriptionDiscount.id === 'UNCONDITIONAL') {
                    vm.subscriptionDiscount.amount = vm.unconditionalDiscountAmount;
                }

                var theDiscountToApply = JSON.parse(JSON.stringify(vm.subscriptionDiscount));

                if (vm.flgAddSubscription === 'YES') {
                    var subscriptionToAddIds = [];
                    _.each(_.keys(vm.subscriptionToAdd), function(key) {
                        if (vm.subscriptionToAdd[key]) {
                            subscriptionToAddIds.push(key);
                        }
                    });

                    if (subscriptionToAddIds.length === 0) {
                        blockUI.stop();
                        AlertMessageService.showErrorAlert('E\' obbligatorio selezionare almeno una quota associativa');
                        return;
                    }

                    var promisesToCall = [];
                    for (var i = 0; i < subscriptionToAddIds.length; i++) {
                        promisesToCall.push(OfferedService.addNonRegisteredSubscriber({
                            offeredServiceId: subscriptionToAddIds[i], //servizio capofila
                            subscriberData: vm.subscriberData,             //dati utente
                            subscribedServices: [subscriptionToAddIds[i]],        //servizi accessori, nessuno, solo la quota stessa
                            subscriptionDiscount: {id: ''}  //sconto, nessuno sulla quota
                        }).$promise);
                    }

                    $q.all(promisesToCall)
                        .then(function(results) {
                            $log.debug('success q. associativa');
                            $log.debug(results);
                            $log.debug('Chiamo OfferedService.addNonRegisteredSubscriber()');
                            OfferedService.addNonRegisteredSubscriber({
                                //offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                                offeredServiceId: vm.childSelectedId.toString(),           //servizio capofila
                                subscriberData: vm.subscriberData,              //dati utente
                                subscribedServices: subscribedServices,         //servizi accessori
                                subscriptionDiscount: theDiscountToApply   //sconto eventuale
                            }).$promise.then(function(data) {
                                $log.debug('ritorno da OfferedService.addNonRegisteredSubscriber(); data: ' + JSON.stringify(data));
                                Subscription.findById({id: data.result}).$promise.then(function(subscription) {
                                    blockUI.stop();
                                    vm.saveButtonEnabled = true;
                                    $log.debug('success');
                                    AlertMessageService.showSuccessMessage();
                                    vm.subscriptionDone = true;
                                    vm.subscriberId = subscription.userId;
                                    vm.goToNextStep();
                                    loadServicesToPay();
                                }, function(httpResponse) {
                                    $log.debug('fallita Subscription.findById(); httpResponse: ' + JSON.stringify(httpResponse));
                                    blockUI.stop();
                                    vm.saveButtonEnabled = true;
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            }, function(httpResponse) {
                                $log.debug('fallita OfferedService.addNonRegisteredSubscriber(); httpResponse: ' + JSON.stringify(httpResponse));
                                blockUI.stop();
                                vm.saveButtonEnabled = true;
                                $log.debug('error');
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                        }, function(httpResponse) {
                            $log.debug('fallita chiamata $q.all(): ' + JSON.stringify(httpResponse));
                            blockUI.stop();
                            vm.saveButtonEnabled = true;
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });

                } else {
                    $log.debug('Chiamo OfferedService.addNonRegisteredSubscriber()');
                    OfferedService.addNonRegisteredSubscriber({
                        //offeredServiceId: vm.offeredService.id.toString(), //servizio capofila
                        offeredServiceId: vm.childSelectedId.toString(),           //servizio capofila
                        subscriberData: vm.subscriberData,              //dati utente
                        subscribedServices: subscribedServices,         //servizi accessori
                        subscriptionDiscount: theDiscountToApply   //sconto eventuale
                    }).$promise.then(function(data) {
                        $log.debug('ritorno da OfferedService.addNonRegisteredSubscriber(); data: ' + JSON.stringify(data));
                        Subscription.findById({id: data.result}).$promise.then(function(subscription) {
                            $log.debug('ritorno da Subscription.findById(); data: ' + JSON.stringify(data));
                            blockUI.stop();
                            vm.saveButtonEnabled = true;
                            $log.debug('success');
                            AlertMessageService.showSuccessMessage();
                            vm.subscriptionDone = true;
                            vm.subscriberId = subscription.userId;
                            vm.goToNextStep();
                            loadServicesToPay();
                        }, function(httpResponse) {
                            $log.debug('fallita Subscription.findById(); httpResponse: ' + JSON.stringify(httpResponse));
                            blockUI.stop();
                            vm.saveButtonEnabled = true;
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    }, function(httpResponse) {
                        $log.debug('fallita OfferedService.addNonRegisteredSubscriber(); httpResponse: ' + JSON.stringify(httpResponse));
                        blockUI.stop();
                        vm.saveButtonEnabled = true;
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });
                }
            });
        }


        function lookupUserChildren() {
            if (!vm.parentUserEmail && !vm.subscriberData.id) {
                return;
            }

            findUserByMail(vm.parentUserEmail, function(users) {
                if (users && users.length > 0) {
                    var children = users[0].children;
                    if (children && children.length > 0) {
                        $scope.parentChildren = children;
                        $scope.parentDisplayName = users[0].displayName;
                        $scope.parentEmail = users[0].email;
                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'app/main/pages/commons/dialogs/children_lookup_dialog.html',
                            parent: angular.element(document.body),
                            scope: $scope,
                            preserveScope: true,
                            clickOutsideToClose: true
                        }).then(function(answer) {
                            if (answer) {
                                loadUserDetail(answer, function(item) {
                                    selectedUserChange(item);
                                });
                            }
                        });
                    }
                }
            });
        }


        /**
         * selezione utente da autocompletion
         */
        function selectedUserChange(item) {
            if (!item) {
                return;
            }
            var tmpDtStart = vm.subscriberData.dtStart;
            var tmpDtEnd = vm.subscriberData.dtEnd;
            if (!item.numRoles) {
                //CHIEDO CONFERMA PER UTENTI DI CYL NON GIA DELLA MIA ORGANIZZAZIONE
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'app/main/pages/commons/dialogs/add_user_as_contact.html',
                    parent: angular.element(document.body),
                    scope: $scope,
                    preserveScope: true,
                    clickOutsideToClose: true
                })
                    .then(function(answer) {
                        if (item && item !== null) {
                            loadUserDetail(item.id, function(myUser) {
                                if (myUser.email && myUser.email.endsWith('.invalid')) {
                                    myUser.email = '';
                                }
                                vm.subscriberData = myUser;
                                vm.subscriberData.birthDate = (myUser.birthDate && myUser.birthDate !== null && myUser.birthDate !== '') ? moment(myUser.birthDate).toDate() : null;
                                vm.subscriberData.dtStart = tmpDtStart;
                                vm.subscriberData.dtEnd = tmpDtEnd;
                                vm.parentUserEmail = (myUser.parents && myUser.parents.length > 0) ? myUser.parents[0].email : null;
                                vm.isRelativeSubscription = (myUser.parents && myUser.parents.length > 0);
                            });
                        }
                        else {
                            vm.subscriberData = {};
                            vm.subscriberData.dtStart = tmpDtStart;
                            vm.subscriberData.dtEnd = tmpDtEnd;
                        }
                    });

            }
            else {
                if (item && item !== null) {
                    loadUserDetail(item.id, function(myUser) {
                        if (myUser.email && myUser.email.endsWith('.invalid')) {
                            myUser.email = '';
                        }
                        vm.subscriberData = myUser;
                        vm.subscriberData.birthDate = (myUser.birthDate && myUser.birthDate !== null && myUser.birthDate !== '') ? moment(myUser.birthDate).toDate() : null;
                        vm.subscriberData.dtStart = tmpDtStart;
                        vm.subscriberData.dtEnd = tmpDtEnd;
                        vm.parentUserEmail = (myUser.parents && myUser.parents.length > 0) ? myUser.parents[0].email : null;
                        vm.isRelativeSubscription = (myUser.parents && myUser.parents.length > 0);
                    });
                }
                else {
                    vm.subscriberData = {};
                    vm.subscriberData.dtStart = tmpDtStart;
                    vm.subscriberData.dtEnd = tmpDtEnd;
                }
            }
        }


        /**
         * ricerca utente
         */
        function lookupUser(txt) {
            txt = txt + '%';
            var deferred = $q.defer();

            var orgToSearch = (vm.searchMode === 'ORG') ? vm.offeredService.organizationId : null;
            var isGlobalSearch = (vm.searchMode !== 'ORG');
            User.lookupUsers({
                text: txt,
                organizationId: orgToSearch,
                isGlobalSearch: isGlobalSearch
            }).$promise.then(function(data) {
                deferred.resolve(data.users);
            });
            return deferred.promise;
        }


        /**
         * seleziona un servizio standalone e fa partire il wizard
         */
        function selectService(service) {
            //servizi selezionati per l'acquisto
            vm.selecteServices = {};
            vm.selecteServices[service.id] = true;
            vm.mustChooseService = false;
            loadOfferedService(service.id);
        }


        /**
         * carica i servizi della associazione che sono agganciabili
         */
        function loadAllAttachableService() {
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: vm.offeredService.organizationId},
                                {standalone: {neq: 'S'}},
                                {serviceType: 'SERVICE'},
                                {dtDel: null},
                            ]
                        }
                    }
                };
                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }
                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');
                    query.filter.where.and.push(
                        {
                            or: [
                                {scheduleType: {inq: ['R', 'N']}},
                                {
                                    and: [
                                        {start: {lte: dateTo}},
                                        {end: {gte: dateFrom}}
                                    ]
                                }
                            ]
                        }
                    );
                }
                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.attachableServices = data;
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }


        /**
         * carica i servizi rivendibili singolarmente
         */
        function loadAllStandaloneService(organizationId) {
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var query = {
                    filter: {
                        where: {
                            and: [
                                {organizationId: organizationId},
                                {standalone: 'S'},
                                {dtDel: null}
                            ]
                        },
                        include: 'serviceTypes'
                    }
                };
                //se ho impostato il periodo di riferimento allora:
                if (refPeriod) {
                    var dateFrom = refPeriod.dateFrom;
                    if (!dateFrom) {
                        dateFrom = moment('01/01/1900', 'DD/MM/YYYY').toDate();
                    }
                    var dateTo = refPeriod.dateTo;
                    if (!dateTo) {
                        dateTo = moment('31/12/3000', 'DD/MM/YYYY').toDate();
                    }

                    dateFrom = moment(dateFrom).startOf('day');
                    dateTo = moment(dateTo).startOf('day').add(23, 'hours').add(59, 'minutes');

                    query.filter.where.and.push(
                        {
                            or: [
                                {scheduleType: {inq: ['R', 'N']}},
                                {
                                    and: [
                                        {start: {lte: dateTo}},
                                        {end: {gte: dateFrom}}
                                    ]
                                }
                            ]
                        }
                    );
                }
                OfferedService.find(query).$promise.then(
                    function(data, headers) {
                        vm.standaloneServices = data;

                        vm.step0SubscriptionServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return false;
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        vm.step0StandaloneServices = _.filter(data, function(d) {
                            if (!d.serviceTypes || d.serviceTypes.length === 0) {
                                return d.serviceType !== 'EVENT';
                            }
                            var found = _.find(d.serviceTypes, function(s) {
                                return s.internalCode === 'SUBSCRIPTION';
                            });
                            if (found) {
                                return false;
                            } else {
                                return d.serviceType !== 'EVENT';
                            }
                        });
                        vm.step0Events = _.filter(data, function(d) {
                            return d.serviceType === 'EVENT';
                        });
                    },
                    function(error) {
                        $log.debug(error);
                    });
            });
        }


        function loadUserServices() {
            checkForSelectedUser(function(userId) {
                vm.subscriberId = userId;
                if (userId) {
                    User.findById({
                        id: userId
                    }).$promise.then(function(user) {
                        user.$prototype$allServices().then(
                            function(response) {

                                if (response.result.services && response.result.services !== null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i < theServices.length; i++) {
                                        var dateFrom = theServices[i].dateFrom;
                                        if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                            theServices[i].dateFrom = new Date(dateFrom);
                                        }
                                        var dateTo = theServices[i].dateTo;
                                        if (dateTo && dateTo !== null && dateTo !== '') {
                                            theServices[i].dateTo = new Date(dateTo);
                                        }
                                    }

                                    //FILTRO PER QUELLI DELLA ORGANIZZAZIONE DI TIPO ISCRIZIONE
                                    theServices = _.filter(theServices, function(s) {
                                        if (s.organizationId != $state.params.organizationId) {
                                            return false;
                                        }
                                        //
                                        var found = _.find(vm.subscriptionServicesIds, function(id) {
                                            return id == s.id;
                                        });
                                        return found ? true : false;
                                    });

                                    //scremo eventuali doppioni per parenti o tutelati
                                    theServices = _.filter(theServices, function(s) {
                                        return userId == s.userId;
                                    });

                                    vm.serviziQuotaAssociativaUtente = theServices;
                                } else {
                                    vm.serviziQuotaAssociativaUtente = [];
                                }

                                checkQuoteAssociativeAttivabili();

                            });
                    });
                } else {
                    checkQuoteAssociativeAttivabili();
                }
            });
        }


        function checkQuoteAssociativeAttivabili() {
            //SE IL SERVIZIO CORRENTE RICHIEDE ISCRIZIONE ALLA QUOTA ASSOCIATIVA ALLORA CERCO tra i vm.subscriptionServices
            //SE QUELLI CHE PER DATA SI AGGANCIANO AL SERVIZIO SONO PRESENTI, PAGATI O CON DOC MANCANTI
            if (vm.offeredService.needsOrganizationSubscription) {
                //cerco tra i vm.subscriptionServices le iscrizioni plausibili includendo:
                // - quelle la cui data di inizio fine comprende data di inizio del servizio
                // - quelle la cui data di inizio fine comprende la data di oggi
                vm.serviziQuotaAssociativaAttivabili = _.filter(vm.subscriptionServices, function(sqa) {
                    if (sqa.start && sqa.end) {
                        if (vm.offeredService.start && !moment(sqa.start).isAfter(vm.offeredService.start) && !moment(vm.offeredService.start).isAfter(sqa.end)) {
                            return true;
                        } else if (!moment(sqa.start).isAfter(new Date()) && !moment().isAfter(sqa.end)) {
                            return true;
                        }
                    } else if (!sqa.start && !sqa.end) {
                        //quota associativa che non ha nè inizio nè fine: ha senso?
                        return true;
                    }
                    return false;
                });

                //CONTROLLO LO STATO DELLE ISCRIZIONI RISPETTO serviziQuotaAssociativaAttivabili
                var iscrizioneQuotaAssociativa = null;
                for (var i = 0; i < vm.serviziQuotaAssociativaAttivabili.length; i++) {
                    var servizioAttivabile = vm.serviziQuotaAssociativaAttivabili[i];
                    var found = _.find(vm.serviziQuotaAssociativaUtente, function(squ) {
                        return squ.id == servizioAttivabile.id;
                    });
                    if (found) {
                        iscrizioneQuotaAssociativa = found;
                        break;
                    }
                }

                if (!iscrizioneQuotaAssociativa) {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                } else {
                    vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO;
                    if (iscrizioneQuotaAssociativa.paymentValue < iscrizioneQuotaAssociativa.paymentDue) {
                        vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA;
                    } else {
                        var docOk = true;
                        for (var i = 0; i < iscrizioneQuotaAssociativa.docs.length; i++) {
                            var doc = iscrizioneQuotaAssociativa.docs[i];
                            if (doc.status === 'MISSING' || doc.status === 'EXPIRED' || doc.status === 'REJECTED' || doc.status === 'EXPIRING') {
                                docOk = false;
                                break;
                            }
                        }
                        if (docOk) {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK;
                        } else {
                            vm.organizationSubscriptionStatus = vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI;
                        }
                    }

                }
            }

        }


        /**
         * Effettua un pagamento di iscrizione
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        function askPaymentDetails(userId, subscriptionId, amount) {
            $scope.myResource = {};
            $scope.myResource.paymentDate = new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = amount;
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query = {
                filter: {
                    where: {organizationId: null, paymentType: 'IN', internalCode: 'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query, function(paymentReasons) {
                $scope.paymentReasons = paymentReasons;
                $scope.myResource.paymentReasons = paymentReasons[0];
            });

            loadUserServices(userId);

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
                .then(function(answer) {

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason !== null) ? answer.paymentReason.id.toString() : null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        if (!vm.subscriptionDone) {
                            loadUserServices();
                        } else {
                            loadServicesToPay();
                        }
                    }, function(httpResponse) {
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        /**
         * verifica se l'utente che si vuole iscrivere esiste già o meno e chiama la callback passandone eventuale ID
         * @param callback
         */
        function checkForSelectedUser(callback) {
            if (vm.subscriberData.id) {
                callback(vm.subscriberData.id);
            } else {
                //UTENTE COMPILATO A MANO
                findUserByMail(vm.subscriberData.email, function(users) {
                    if (!users || users === null || users.length === 0) {
                        callback(null);
                    }
                    else {
                        callback(users[0].id);
                        //TODO USERRLOAD

                    }
                });
            }
        }


        /**
         * Cerca un utente per mail
         * @param mail
         * @param callback
         */
        function findUserByMail(mail, callback) {
            var query = {
                filter: {
                    where: {email: mail},
                    include: 'children'
                }
            }
            User.find(query, function(users) {
                callback(users);
            });
        }


        function loadUserDetail(id, callback) {
            User.loadUser({
                id: id,
                organizationId: $state.params.organizationId,
                filter: {include: 'parents'}
            }, function(user) {
                callback(user);
            }, function(error) {
                $log.debug(error);
            });
        }


        /**
         * carica tutti gli eventuali servizi di iscrizione previsti dalla associazione
         * @param organizationId
         */
        function loadAllSubscriptionsService(organizationId) {
            OfferedService.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                        standalone: 'S',
                        dtDel: null
                    },
                    order: 'start DESC',
                    include: 'serviceTypes'
                }
            }).$promise.then(
                function(data, headers) {
                    vm.subscriptionServices = _.filter(data, function(d) {
                        if (!d.serviceTypes || d.serviceTypes.length === 0) {
                            return false;
                        }
                        var found = _.find(d.serviceTypes, function(s) {
                            return s.internalCode === 'SUBSCRIPTION';
                        });
                        if (found) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    vm.subscriptionServicesIds = _.map(vm.subscriptionServices, function(s) {
                        return s.id;
                    });
                },
                function(error) {
                    $log.debug(error);
                });
        }

        /**
         * carica le tipologie di sconti da applicare all'iscrizione
         * @param organizationId
         */
        function loadAllDiscounts(organizationId) {
            Discount.find({
                filter: {
                    where: {
                        organizationId: organizationId,
                    }
                }
            }).$promise.then(
                function(data, headers) {
                    vm.discounts = data;
                    // vm.discounts.concat([
                    //     {
                    //         id: "",
                    //         name: $translate.instant('SUBSCRIPTIONS.NO_DISCOUNT'),
                    //         type: 'AMOUNT',
                    //         value: 0
                    //     },
                    //     {
                    //         id: "UNCONDITIONAL",
                    //         name: $translate.instant('SUBSCRIPTIONS.UNCONDITIONAL_DISCOUNT'),
                    //         type: 'AMOUNT',
                    //         value: 0
                    //     }
                    // ]);
                    // vm.discounts.concat(data);
                    // $log.debug(vm.discounts);
                },
                function(error) {
                    $log.debug(error);
                });
        }

        /**
         * carica dettaglio servizio
         */
        function loadOfferedService(id) {
            OfferedService.findById({
                id: id,
                filter: {
                    include: ['organization']
                }
            }).$promise.then(
                function(data, headers) {
                    var myService = data;
                    vm.offeredService = (JSON.parse(JSON.stringify(myService)));
                    if (vm.offeredService.start && vm.offeredService.start !== null) {
                        vm.offeredService.start = new Date(vm.offeredService.start);
                    }

                    if (vm.offeredService.end && vm.offeredService.end !== null) {
                        vm.offeredService.end = new Date(vm.offeredService.end);

                    }

                    vm.subscriberData.dtStart = new Date();
                    if (vm.offeredService.scheduleType === 'P') {
                        vm.subscriberData.dtStart = vm.offeredService.start;
                        vm.subscriberData.dtEnd = vm.offeredService.end;
                    }

                    vm.loadChildServices();

                    loadAllAttachableService();
                },
                function(error) {
                    $log.debug(error);
                });
        }


        /**
         * Carica i servizi figli di quello visualizzato. Imposta il servizio attualmente visualizzato come
         * primo figlio.
         */
        vm.loadChildServices = function() {
            $log.debug('vm.loadChildServices()');
            vm.children = [];
            // come primo figlio mette il servizio stesso
            vm.children.push(vm.offeredService);

            // poi cercai servizi figli e li aggiunge
            OfferedService.findById({
                id: vm.offeredService.id,
                filter: {
                    include: ['children'],
                }
            }).$promise.then(
                function(offeredService) {
                    offeredService = JSON.parse(JSON.stringify(offeredService));
                    // carica i children in vm.children
                    _.each(offeredService.children, function(child) {
                        if (!child.dtDel && child.isPaymentPlan) {
                            vm.children.push(child);
                        }
                    });
                    // seleziono il primo child (ovvero il servizio principale) se il servizio non ha figli
                    if (vm.children.length === 1) {
                        vm.childSelectedId = vm.offeredService.id;
                    }
                },
                function(err) {
                    $log.error('Errore caricando OfferedService figli');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Errore caricando OfferedService figli: ' + err.message);
                }
            );
        };


        /**
         * Calcola i servizi dell'utente ancora da pagare all'ultimo step della iscrizione
         */
        function loadServicesToPay() {
            vm.servicesToPay = [];
            User.loadUser({
                id: vm.subscriberData.id || vm.subscriberId,
                organizationId: vm.organization.id
            }).$promise.then(function(user) {
                user.$prototype$allServices().then(
                    function(response) {
                        blockUI.stop();
                        if (response.result.services && response.result.services !== null) {
                            var theServices = response.result.services;
                            for (var i = 0; i < theServices.length; i++) {
                                var dateFrom = theServices[i].dateFrom;
                                if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                    theServices[i].dateFrom = new Date(dateFrom);
                                }
                                var dateTo = theServices[i].dateTo;
                                if (dateTo && dateTo !== null && dateTo !== '') {
                                    theServices[i].dateTo = new Date(dateTo);
                                }
                            }
                            //filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                            theServices = _.filter(theServices, function(service) {
                                return (vm.organization.id == service.organizationId && service.paymentValue < service.paymentDue);
                            })
                            //PRENDO GLI ORDER DETAILS RELATIVI
                            //TODO #189
                            if (theServices.length > 0) {
                                var subscritpionIds = _.map(theServices, function(s) {
                                    return s.subscriptionId;
                                });
                                Subscription.find({
                                    filter: {
                                        where: {id: {inq: subscritpionIds}},
                                        include: ['user', 'payments', {orders: {orderDetails: ['offeredService', {subscriptionDiscount: 'discount'}]}}]
                                    }
                                }).$promise.then(
                                    function(data, headers) {
                                        _.each(data, function(subscription) {
                                            var curService = _.find(theServices, function(s) {
                                                return s.subscriptionId == subscription.id;
                                            });
                                            curService.details = [];
                                            var payments = subscription.payments;
                                            // ordino gli Order prima di mostrarli
                                            subscription.orders = _.sortBy(subscription.orders, function(order) {
                                                return moment(order.dtBillingPeriodStart).toISOString() +
                                                    moment(order.created).toISOString() +
                                                    (order.id ? order.id.toString() : '');
                                            });
                                            _.each(subscription.orders, function(order) {
                                                // ordino gli OrderDetail
                                                order.orderDetails = _.sortBy(order.orderDetails, function(orderDetail) {
                                                    return moment(orderDetail.created).toISOString() +
                                                        (orderDetail.id ? orderDetail.id.toString() : '');
                                                });
                                                _.each(order.orderDetails, function(orderDetail) {
                                                    var obj = orderDetail;
                                                    obj.dtBillingPeriodStart = order.dtBillingPeriodStart;
                                                    obj.dtBillingPeriodEnd = order.dtBillingPeriodEnd;
                                                    if (obj.subscriptionDiscountId) {
                                                        var discounts = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'DISCOUNT';
                                                        });
                                                        var amount = _.reduce(discounts, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    } else {
                                                        var paymentsUnpayed = _.filter(payments, function(p) {
                                                            return p.orderDetailId == orderDetail.id && p.paymentStatus === 'UNPAYED';
                                                        });
                                                        var amount = _.reduce(paymentsUnpayed, function(memo, p) {
                                                            return memo + p.paymentValue;
                                                        }, 0);
                                                        obj.amount = amount;
                                                    }

                                                    if (obj.paymentStatus !== 'PAYED') {
                                                        curService.details.push(obj);
                                                    }
                                                });
                                            });
                                            curService.details = _.sortBy(curService.details, function(d) {
                                                return d.dtBillingPeriodStart;
                                            });
                                        });
                                        _.each(theServices, function(service) {
                                            var paymentDueAtToday = 0;
                                            _.each(service.details, function(detail) {
                                                if (moment().isAfter(detail.dtBillingPeriodStart)) {
                                                    paymentDueAtToday += detail.amount;
                                                }
                                            });
                                            if (paymentDueAtToday === 0 && service.details.length > 0) {
                                                //prendo order id del primo ordine
                                                var firstOrderId = service.details[0].orderId;
                                                //prendo tutti i dettagli di quell'ordine
                                                _.each(service.details, function(detail) {
                                                    if (detail.orderId === firstOrderId) {
                                                        paymentDueAtToday += detail.amount;
                                                    }
                                                });
                                            }
                                            service.paymentDue = paymentDueAtToday;
                                        });
                                        vm.servicesToPay = theServices;

                                    },
                                    function(error) {
                                        $log.debug(error);
                                    });
                            }


                        } else {
                            vm.servicesToPay = [];
                        }
                    }, function(error) {
                        blockUI.stop();
                        $log.debug(error);
                    });
            }, function(error) {
                blockUI.stop();
                $log.debug(error);
            });
        }

        function findOrganization(id) {
            $log.debug('NewFromServiceController.findOrganization()');
            return Organization.findById({
                id: id,
                filter: {}
            }).$promise;
        }

        function formatDate(date) {
            if (!date || date === null) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }


        /**
         * Applica uno sconto ad un importo
         *
         * @param {number} importo
         * @param {object} sconto
         * @returns {number} importo scontato
         */
        vm.applicaSconto = function(importo, sconto) {
            // $log.debug('vm.applicaSconto()');
            // $log.debug('importo: ' + importo);
            // $log.debug('sconto: ' + JSON.stringify(sconto));
            if (importo && sconto && sconto.value && sconto.type) {
                if (sconto.type.toUpperCase() === 'AMOUNT') {
                    return importo = importo - sconto.value;
                } else if (sconto.type.toUpperCase() === 'PERCENT') {
                    return importo - (importo * sconto.value / 100);
                }
            } else {
                return importo;
            }
        };
        vm.calcolaSconto = function(importo, sconto) {
            // $log.debug('vm.applicaSconto()');
            // $log.debug('importo: ' + importo);
            // $log.debug('sconto: ' + JSON.stringify(sconto));
            if (importo && sconto && sconto.value && sconto.type) {
                if (sconto.type.toUpperCase() === 'AMOUNT') {
                    return sconto.value;
                } else if (sconto.type.toUpperCase() === 'PERCENT') {
                    return (importo * sconto.value / 100);
                }
            } else {
                return 0;
            }
        };


        /**
         * Calcola il prezzo totale di un'iscrizione
         * @returns {number} Prezzo totale, considerando costo di subscription, rinnovo, sconto
         */
        vm.calculateTotalPrice = function() {
            // $log.debug('vm.calculateTotalPrice()');
            vm.subscriptionDiscount.amount = 0;

            // il servizio da usare è quello selezionato tra i figli (
            var selectedService = null;
            _.each(vm.children, function(child) {
                if (child.id === vm.childSelectedId) {
                    selectedService = JSON.parse(JSON.stringify(child));
                }
            });

            if (selectedService) {
                // calcola l'importo, senza sconti, per ora
                var tot = (selectedService.subscriptionPrice ? selectedService.subscriptionPrice : 0) +
                    (selectedService.renewalPrice ? selectedService.renewalPrice : 0);
                // aggiungo i costi dei servizi selezionati
                for (var i = 0; i < vm.attachableServices.length; i++) {
                    if (vm.selecteServices[vm.attachableServices[i].id]) {
                        tot += vm.attachableServices[i].subscriptionPrice ? vm.attachableServices[i].subscriptionPrice : 0;
                        tot += vm.attachableServices[i].renewalPrice ? vm.attachableServices[i].renewalPrice : 0;
                    }
                }
                // calcolo lo sconto selezionato
                for (var j = 0; j < vm.discounts.length; j++) {
                    if (vm.discounts[j].id === vm.subscriptionDiscount.id) {
                        // lo applico al totale
                        vm.subscriptionDiscount.amount = vm.calcolaSconto(tot, vm.discounts[j]);
                    }
                }
                if (vm.subscriptionDiscount.id !== 'UNCONDITIONAL') {
                    vm.unconditionalDiscountAmount = 0;
                }
                tot = tot - vm.subscriptionDiscount.amount - vm.unconditionalDiscountAmount;
            }

            return tot;
        };

        vm.openNuovoPiano = function() {
            $scope.child = {};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/subscriptions/dialogs/new_child_service_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            }).then(function() {
                $scope.child.organizationId = vm.offeredService.organizationId;
                $scope.child.start = vm.offeredService.start;
                $scope.child.end = vm.offeredService.end;
                $scope.child.isPaymentPlan = true;
                $scope.child.isDeleted = false;
                // crea nuovo elemento
                OfferedService.create(
                    $scope.child
                ).$promise.then(
                    function(newChildInstance) {
                        $log.debug('Creato OfferedService: ' + JSON.stringify(newChildInstance));
                        // aggiunge il riferimento al genitore
                        OfferedServiceRelation.create({
                            childId: newChildInstance.id,
                            parentId: vm.offeredService.id,
                        }).$promise.then(
                            function(osRelationInstance) {
                                // avvia il reload dei servizi children
                                vm.loadChildServices();
                            },
                            function(err) {
                                $log.error('Errore in creazione OfferedServiceRelation');
                                $log.error(err);
                                AlertMessageService.showErrorAlert('Errore in creazione OfferedServiceRelation: ' + err.message);
                            }
                        );
                    },
                    function(err) {
                        $log.error('Errore in creazione OfferedService');
                        $log.error(err);
                        AlertMessageService.showErrorAlert('Errore in creazione OfferedService: ' + err.message);
                    }
                );
            });
        }


        /**
         * Salva un OfferedService dopo la modifica o la creazione
         *
         * @param {OfferedService} child
         */
        vm.saveChild = function(child) {
            $log.debug('vm.saveChild()');
            // copia i dati che non sono di pagamento dal genitore
            vm.copiaDati(vm.item, child);
            $log.debug('Salvo offeredService (in new_from_service.js): ' + JSON.stringify(child));
        };


        /**
         * Al clic su un OfferedService child (Tab "piano di pagamento"), lo indico come
         * selezionato, e permetto all'utente di proseguire al prossimo step.
         *
         * @param offeredServiceId
         */
        vm.selectChildService = function(offeredServiceId) {
            vm.childSelectedId = offeredServiceId;
            vm.selecteServices = {};
            vm.selecteServices[offeredServiceId] = true;
        };


        /**
         * Va all'elenco delle subscription dell'utente appena iscritto
         */
        vm.gotoSubscriptions = function() {
            $state.go('app.pages_subscriptions_person', {
                organizationId: vm.organization.id,
                offeredServiceId: vm.offeredService.id,
                paymentsFilter: 'A',
                userId: vm.subscriberId,
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.seasonchange', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.pages_seasonchange', {
            url      : '/seasonchange/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/seasonchange/seasonchange.html',
                    controller : 'SeasonChangeController as vm'
                }
            },
            bodyClass: 'seasonchange'
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.seasonchange')
        .controller('SeasonChangeController', SeasonChangeController);

    /** @ngInject */
    function SeasonChangeController($log, $state, AlertMessageService, OfferedService, RoleType, Organization) {
        var vm = this;
        vm.organizationId = $state.params.organizationId;
        vm.process = {
            status: 'ready',  // [ready|processing|done]
            error: null,
        };
        // impostazioni da inviare al backend per effettuare il cambio stagione
        vm.settings = {
            startDate: new Date(),
            endDate: moment().add(1, 'year').toDate(),
            services: {
                prefix: 'Copia di ',
                postfix: '',
                items: [],
            },
            roleTypes: {
                add: [],
                remove: [],
            }
        };
        // elenco dei servizi esistenti
        vm.offeredServices = {
            loading: false,
            items: [],
        };
        // elenco dei roleType esistenti
        vm.roleTypes = {
            loading: false,
            items: [],
        };


        vm.init = function() {
            $log.debug('SeasonChangeController.init()');
            fetchOfferedServices();
            fetchRoleTypes();
        };


        /**
         * Carica l'elenco dei servizi
         */
        function fetchOfferedServices() {
            vm.offeredServices.loading = true;
            vm.offeredServices.items = [];
            OfferedService.getItems({
                    filters: {
                        organizationId: vm.organizationId,
                        isDeleted: false,
                        isPaymentPlan: false,
                        isCarnet: false,
                        limit: 9999,
                    },
                    excludeMemberships: true,
                },
                function(items) {
                    vm.offeredServices.items = items;
                    vm.offeredServices.loading = false;
                }
            );
        }


        /**
         * Carica l'elenco dei ruoli
         */
        function fetchRoleTypes() {
            vm.roleTypes.loading = true;
            vm.roleTypes.items = [];
            RoleType.find({
                filter: {
                        where: {organizationId: vm.organizationId},
                        order: 'name ASC',
                    }
                },
                function(items) {
                    vm.roleTypes.items = items;
                    vm.roleTypes.loading = false;
                }
            );
        }


        /**
         * Gestisce l'aggiunta o la rimozione di un servizio alla lista di quelli da clonare
         * nella nuova stagione
         *
         * @param {OfferedService} service
         */
        vm.offeredServiceClicked = function(service) {
            service.selected = !service.selected;
            if (service.selected) {
                $log.debug('adding service to right list');
                vm.settings.services.items.push(service);
            } else {
                $log.debug('removing service from right list');
                var serviceIndex = vm.settings.services.items.indexOf(service);
                vm.settings.services.items.splice(serviceIndex, 1);
            }
        };


        /**
         * Gestisce l'aggiunta o la rimozione di un roleType alla lista di quelli da eliminare
         * da tutti gli utenti
         *
         * @param {RoleType} roleType
         */
        vm.removeRoleTypeClicked = function(roleType) {
            if (!vm.isRoleForbiddenToRemove(roleType)) {
                roleType.selectedToRemove = !roleType.selectedToRemove;
                if (roleType.selectedToRemove) {
                    vm.settings.roleTypes.remove.push(roleType);
                } else {
                    var roleTypeIndex = vm.settings.roleTypes.remove.indexOf(roleType);
                    vm.settings.roleTypes.remove.splice(roleTypeIndex, 1);
                }
            }
        };


        /**
         * Gestisce l'aggiunta o la rimozione di un roleType alla lista di quelli da assegnare a
         * tutti gli utenti
         *
         * @param {RoleType} roleType
         */
        vm.addRoleTypeClicked = function(roleType) {
            if (!vm.isRoleForbiddenToAdd(roleType)) {
                roleType.selectedToAdd = !roleType.selectedToAdd;
                if (roleType.selectedToAdd) {
                    vm.settings.roleTypes.add.push(roleType);
                } else {
                    var roleTypeIndex = vm.settings.roleTypes.add.indexOf(roleType);
                    vm.settings.roleTypes.add.splice(roleTypeIndex, 1);
                }
            }
        };


        /**
         * Esegue il cambio di stagione
         */
        vm.doSeasonChange = function() {
            $log.debug('vm.doSeasonChange()');
            vm.process.status = 'processing';
            Organization.seasonChange({
                organizationId: vm.organizationId,
                settings: vm.settings,
            }).$promise.then(
                function(response) {
                    $log.debug({response: response});
                    AlertMessageService.showSuccessMessage();
                    vm.process.status = 'done';
                },
                function(err) {
                    $log.error({err: err});
                    AlertMessageService.showErrorAlert(err.message);
                    vm.process.status = 'done';
                    vm.process.error = err;
                }
            );
        };




        vm.isRoleForbiddenToAdd = function(roleType) {
            return roleType && roleType.internalCode &&
                (roleType.internalCode.toUpperCase() === 'ADMIN' || roleType.internalCode.toUpperCase() === 'STAFF');
        };


        vm.isRoleForbiddenToRemove = function(roleType) {
            return roleType && roleType.internalCode && roleType.internalCode.toUpperCase() === 'CONTACT';
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages.payments')
        .controller('PaymentsController', PaymentsController);

    /** @ngInject */
    function PaymentsController($rootScope, $scope, $mdDialog, $compile, $timeout, DTOptionsBuilder, Payment,
                                DTColumnBuilder, $log, ApiPath, LoopBackAuth, CylUtils, EarningCost, blockUI,
                                $translate, AuthenticationService, User, Organization, $location, $state,
                                PaymentReason, AlertMessageService, OrganizationPrivateDocPrefix, _,
                                breadcrumbManager) {
        var vm = this;
        var self = this;
        var userId;

        vm.loadPayments = loadPayments;
        vm.payments = [];
        vm.selected = {};
        vm.dtInstance = {};
        vm.reloadPayments = reloadPayments;
        vm.apiPath = ApiPath;
        vm.accessToken = LoopBackAuth.accessTokenId;
        vm.isProfileDetail = ($location.path().startsWith('/profile'));

        // eventuali filtri da applicare all'elenco
        vm.filters = {
            hideDonePayments: false,
        };


        init();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadPayments)
            .withDisplayLength(100)
            .withOption('processing', true)
            .withDataProp('data')
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('pagingType', 'simple')
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            //			.withOption('rowCallback', rowCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('paymentDate').withTitle($translate.instant('PAYMENTS.DATE')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    if (data && data != null)
                        ret += formatDate(new Date(data));
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn('paymentReason').withTitle($translate.instant('PAYMENTS.REASON')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    if (row.paymentReason && row.paymentReason !== null) {
                        ret += row.paymentReason.name;
                    }
                    //return formatRowCell(ret, row);
                    return '<pre>' + JSON.stringify(row.user.displayName) + '</pre>';
                }),
            DTColumnBuilder.newColumn('offeredService').withTitle($translate.instant('PAYMENTS.SERVICE')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    // nome servizio
                    if (row.orderDetail && row.orderDetail.subscriptionDiscount) {
                        if (row.orderDetail.subscriptionDiscount.discount) {
                            ret += row.orderDetail.subscriptionDiscount.discount.name;
                        } else {
                            ret += 'Sconto incondizionato';
                        }
                    } else if (row.offeredService && row.offeredService !== null) {
                        ret += row.offeredService.name;
                    }
                    // eventuale periodo di riferimento
                    if (row.orderDetail && row.orderDetail.order && row.orderDetail.order.dtBillingPeriodStart) {
                        ret += ' (' + formatDate(row.orderDetail.order.dtBillingPeriodStart);
                        if (row.orderDetail.order.dtBillingPeriodEnd) {
                            ret += ' - ' + formatDate(row.orderDetail.order.dtBillingPeriodEnd);
                        }
                        ret += ')';
                    }
                    // indicazione periodico/una-tantum/eliminato
                    if (row.orderDetail && row.orderDetail.status) {
                        if (row.orderDetail.status.toUpperCase() === 'TO_RENEW' ||
                            row.orderDetail.status.toUpperCase() === 'OK_RENEWED') {
                            ret += '<br /><small>rinnovo periodico</small>'
                        } else if (row.orderDetail.status.toUpperCase() === 'DELETED') {
                            ret += '<br /><small>pagamento eliminato</small>'
                        }
                    }

                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn('paymentValue').withTitle($translate.instant('PAYMENTS.AMOUNT')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    if (data && data != null) {
                        ret += data.toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
                        if (!vm.isProfileDetail && (!row.earningCost || !row.earningCost.locked)) {
                            // var editButton = '<md-icon class="s-16" md-font-icon="icon-pencil" title="Modifica importo" ng-click="vm.modificaImporto(' + row.id + ');" style="cursor: pointer; color: #ccc; font-size: 18px"></md-icon>';
                            // ret += '&nbsp;&nbsp;' + editButton;
                        } else if (!vm.isProfileDetail && row.earningCost && row.earningCost.locked) {
                            var locked = '<md-icon class="s-16" md-font-icon="icon-lock-outline" title="Pagamento contabilizzato" style="color: #ccc; font-size: 18px"></md-icon>';
                            ret += '&nbsp;&nbsp;' + locked;
                        }
                    }
                    return formatAmountCell(ret, row);
                }),

            DTColumnBuilder.newColumn('paymentStatus').withTitle($translate.instant('PAYMENTS.STATUS')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    if (data && data != null) {
                        if (data === 'PAYED') {
                            ret += '<span class="green-900-fg">Pagamento effettuato</span>';
                        } else if (data === 'UNPAYED') {
                            // var payButton = '<md-icon class="s-16" md-font-icon="icon-currency-eur" title="Paga" style="cursor: pointer"></md-icon>';
                            // ret += payButton;
                            ret += '<span class="red-900-fg">Pagamento da effettuare</span>';
                        } else if (data === 'DISCOUNT') {
                            ret += 'Sconto';
                        } else if (data === 'DISCOUNT_USED') {
                            ret += '<span class="green-900-fg">Sconto utilizzato</span>';
                        }
                    }
                    return formatRowCell(ret, row);
                }),

            DTColumnBuilder.newColumn('paymentDescription').withTitle($translate.instant('PAYMENTS.DESCRIPTION')).notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    if (data && data != null)
                        ret += data;
                    return formatRowCell(ret, row);
                }),


            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(
                function(data, type, row) {
                    var ret = '';
                    // pulsante edit pagamento
                    if (!vm.isProfileDetail && (!row.earningCost || !row.earningCost.locked)) {
                        var editButton = '<md-icon class="s-16" md-font-icon="icon-pencil" title="Modifica importo" ng-click="vm.modificaImporto(' + row.id + ');" style="cursor: pointer;"></md-icon>';
                        ret += editButton;
                    }
                    // pulsante paga (da mostrare solo al gestore dell'organizzazione)
                    if (row.paymentStatus === 'UNPAYED' && !vm.isProfileDetail) {
                        // prima versione, che apriva la vecchia modal
                        // var payButton = '<md-icon class="s-16" md-font-icon="icon-currency-eur" title="Paga" style="cursor: pointer;" ng-click="vm.singlePayment(' + row.id + ');"></md-icon>';
                        // versiohe intermedia, che andava alle iscrizioni
                        // var payButton = '<md-icon class="s-16" md-font-icon="icon-currency-eur" title="Paga" style="cursor: pointer;" ng-click="vm.gotoSubscriptionDetail(' + row.id + ');"></md-icon>';
                        // ultima versione, apre schermata di pagamento unificato
                        var payButton = '<md-icon class="s-16" md-font-icon="icon-currency-eur" title="Paga" style="cursor: pointer;" ng-click="vm.gotoPaymentWindow(' + row.id + ');"></md-icon>';
                        ret += payButton;
                    }
                    // pulsante invoice
                    if (row.invoiceId){
                        ret += '<a title="Scarica ricevuta" ng-href="' + vm.apiPath + '/organizationPrivateDocumentsContainers/' + OrganizationPrivateDocPrefix + row.organizationId + '/download/' + row.invoice.pdfUri + '?access_token=' + vm.accessToken + '" target="_blank"><md-icon md-font-icon="icon-file-pdf"></md-icon></a>';
                    }
                    return ret;
                }),
        ];

        $rootScope.$on('$translateChangeEnd', function() {
            updateTableLocale();
        });

        //updateTableLocale(); TODO capire se è questa la riga responsabile per https://github.com/l-lin/angular-datatables/issues/181


        function init() {
            $log.debug('PaymentsController.init()');
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                userId = ($state.params.userId ? $state.params.userId : User.getCurrentId());
                vm.userId = userId.toString();
                $log.debug('vm.userId: ' + vm.userId);
                if (!vm.isProfileDetail) {
                    //carico le causali
                    var query = {
                        filter: {
                            where: {organizationId: null, paymentType: 'IN', internalCode: 'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                        }
                    };
                    PaymentReason.find(query, function(paymentReasons) {
                        $scope.paymentReasons = paymentReasons;
                    });
                    loadUserServices(vm.userId);
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function loadPayments(sSource, aoData, fnCallback, oSettings) {
            $log.debug('PaymentsController.loadPayments()');
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            // leggo periodo, per filtrare i dati
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var dateFrom = (refPeriod && refPeriod.dateFrom) ? moment(refPeriod.dateFrom) : moment('20000101', 'YYYYMMDD');
                var dateTo = (refPeriod && refPeriod.dateTo) ? moment(refPeriod.dateTo): moment('29991231', 'YYYYMMDD');

                var query = {
                    filter: {
                        where: {
                            userId: vm.userId,
                            dtDel: null,
                            paymentValue: {neq: 0},
                            // NDR: vorrei filtrare per data del periodo di pagamento dell'order, ma Loopback nn mi lascia
                            // devo filtrare dopo aver letto la pagina di dati, che potrebbe avere effetti indesiderati a video
                        },
                        // limit: length,
                        // skip: start,
                        include: [
                            'user',
                            {offeredService: ['serviceTypes', 'offeredServiceTypeRelations']},
                            'subscription',
                            'paymentReason',
                            'invoice',
                            'earningCost',
                            {orderDetail: ['order', {subscriptionDiscount: 'discount'}]}
                        ]
                    }
                };
                $log.debug('PaymentsController.loadPayments: query: ' + JSON.stringify(query));
                // aggiungo eventuale filtro su pagamenti effettuati
                if (vm.filters && vm.filters.hideDonePayments) {
                    query.filter.where.paymentStatus = {inq: ['UNPAYED', 'DISCOUNT']}
                }
                // Payment.count({where: query.filter.where}, function(totalNumber) {
                    Payment.find(query, function(payments) {
                        vm.payments = payments;
                        // faccio un giro per eliminare i pagamenti di subscription eliminate
                        vm.payments = _.filter(vm.payments, function(payment) {
                            if (payment && (!payment.subscription || (payment.subscription && payment.subscription.dtDel===null))) {
                                // totalNumber.count--;
                                return true;
                            }
                        });
                        // faccio un secondo giro per eliminare i pagamenti fuori dal periodo di riferimento
                        // $log.debug(dateFrom.toDate());
                        // $log.debug(dateTo.toDate());
                        vm.payments = _.filter(vm.payments, function(payment) {
                            // $log.debug(payment);
                            if (payment && payment.orderDetail && payment.orderDetail.order &&
                                payment.orderDetail.order.dtBillingPeriodStart) {
                                if (
                                    moment(payment.orderDetail.order.dtBillingPeriodStart).isSameOrAfter(dateFrom) &&
                                    moment(payment.orderDetail.order.dtBillingPeriodStart).isSameOrBefore(dateTo)) {
                                    return true;
                                }
                            }
                            return false;
                        });
                        // ricalcolo totalNumber
                        // ordino i pagamenti per data periodo di riferimento
                        _.each(vm.payments, function(payment) {
                            self.addDateSortField(payment);
                        });
                        vm.payments = _.sortBy(vm.payments, function(payment) {
                            return payment.sortDateField;
                        });
                        $log.debug('vm.payments:');
                        $log.debug(vm.payments);
                        var records = {
                            'draw': draw,
                            'recordsTotal': vm.payments.count,
                            'recordsFiltered': vm.payments.count,
                            // 'recordsTotal': totalNumber.count,
                            // 'recordsFiltered': totalNumber.count,
                            'data': vm.payments
                        };
                        fnCallback(records);
                    });
                // });
            });
        }


        function reloadPayments() {
            // $log.debug('Ematto PAYMENTS_TO_BE_RELOADED vm.userId:' + vm.userId)
            // $rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }



        vm.modificaImporto = function(id) {
            var payment = _.find(vm.payments, function(payment) {
                return payment.id === id;
            });
            $scope.myResource = {};
            if (payment.paymentValue) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(payment.paymentValue);
            } else {
                $scope.myResource.paymentValue = null;
            }
            $scope.myResource.paymentDescription = payment.paymentDescription;

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_importo_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
                .then(function(answer) {
                    //$log.debug(answer);
                    Payment.findById({
                        id: id
                    }).$promise.then(function(thePayment) {
                        thePayment.paymentDescription = answer.paymentDescription;
                        thePayment.paymentValue = answer.paymentValue;
                        Payment.prototype$patchAttributes(
                            {id: thePayment.id},
                            thePayment).$promise.then(function(res) {
                            reloadPayments();
                            //
                            if (payment.earningCost) {
                                EarningCost.updateFromPayments({
                                    id: payment.earningCost.id.toString()
                                }).$promise.then(function(ec) {
                                    AlertMessageService.showSuccessMessage();
                                }, function(httpResponse) {
                                    $log.debug('error');
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            } else {
                                AlertMessageService.showSuccessMessage();
                            }
                        }, function(httpResponse) {
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        };


        function DialogController($scope, $mdDialog) {
            $scope.showStorno = false;
            $scope.showHelp = false;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.setStorno = function(value) {
                $scope.showStorno = value;
            };
            $scope.gotoCassa = function() {
                if (sessionStorage.getItem('CURRENT_ORGANIZATION')) {
                    $state.go('app.pages_earningcosts', {organizationId: sessionStorage.getItem('CURRENT_ORGANIZATION')});
                }
            };
            $scope.showHelpToggle = function() {
                $scope.showHelp = !$scope.showHelp;
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];



        function updateTableLocale() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/' + $translate.use() + '.json');
            setTimeout(function() {
                vm.dtInstance.DataTable.column(1).header().textContent = 'Data pagamento';
                vm.dtInstance.DataTable.column(2).header().textContent = $translate.instant('PAYMENTS.REASON');
                vm.dtInstance.DataTable.column(3).header().textContent = $translate.instant('PAYMENTS.SERVICE');
                vm.dtInstance.DataTable.column(4).header().textContent = $translate.instant('PAYMENTS.AMOUNT');
                vm.dtInstance.DataTable.column(5).header().textContent = $translate.instant('PAYMENTS.STATUS');
                vm.dtInstance.DataTable.column(6).header().textContent = $translate.instant('PAYMENTS.DESCRIPTION');
            }, 300);
        }


        function loadUserServices(myUserId) {
            User.findById({
                id: myUserId
            }).$promise.then(function(user) {
                user.$prototype$allServices().then(
                    function(response) {
                        if (response.result.services && response.result.services !== null) {
                            //potrei avere i corsi che faccio io piu quelli dei miei parenti: quindi filtro per i miei
                            var services = _.filter(response.result.services, function(s) {
                                return s.userId == myUserId;
                            });
                            for (var i = 0; i < services.length; i++) {
                                var dateFrom = services[i].dateFrom;
                                if (dateFrom && dateFrom !== null && dateFrom !== '') {
                                    services[i].dateFrom = new Date(dateFrom);
                                }
                                var dateTo = services[i].dateTo;
                                if (dateTo && dateTo !== null && dateTo !== '') {
                                    services[i].dateTo = new Date(dateTo);
                                }
                            }
                        }
                        $scope.userServices = services;
                        $log.debug('$scope.userServices: ' + JSON.stringify(vm.userServices, undefined, 2));
                    });
            });
        }


        /**
         * Va alla pagina di elenco delle subscription, filtrando per utente e servizio con quelli del Payment indicato.
         *
         * @param paymentId
         */
        vm.gotoSubscriptionDetail = function(paymentId) {
            // cerca il pagamento dato l'ID
            var payment = _.find(vm.payments, function(payment) {
                return parseInt(payment.id) === parseInt(paymentId);
            });

            $state.go('app.pages_subscriptions_person', {
                organizationId: payment.organizationId,
                offeredServiceId: payment.offeredServiceId,
                paymentsFilter: 'A',
                documentsFilter: null,
                userId: payment.userId,
            });
        };


        /**
         * Apre la modal di pagamento per un payment
         * @param {number} paymentId
         */
        vm.gotoPaymentWindow = function(paymentId) {
            // trova pagamento con quell'id
            try {
                if (paymentId && vm.payments && Array.isArray(vm.payments)) {
                    var payment = vm.payments.find(function(element) {
                        return element && element.id && element.id === paymentId;
                    });
                    if (payment && payment.organizationId && payment.subscriptionId &&
                        payment.userId && payment.paymentValue) {
                        // console.log(payment);
                        sessionStorage.setItem('payModalState', JSON.stringify({
                            backState: $state.current.name,
                            backParams: $state.params,
                        }));
                        $state.go('app.pages_payments_pay', {
                            organizationId: payment.organizationId,
                            subscriptionId: payment.subscriptionId,
                            userId: payment.userId,
                            amount: payment.paymentValue,
                        });
                    }
                }
            } catch(e) {
                console.error(e);
            }
        };


        // deprecato, adesso vado all'elenco delle subscription filtrando per utente/servizio
        // (vedi vm.gotoSubscriptionDetail)
        // /**
        //  * Apre la dialog per effettuare un pagamento singolo
        //  *
        //  * @param paymentId
        //  */
        // vm.singlePayment = function(paymentId) {
        //     // cerca il pagamento dato l'ID
        //     var payment = _.find(vm.payments, function(payment) {
        //         return parseInt(payment.id) === parseInt(paymentId);
        //     });
        //
        //     $mdDialog.show({
        //         controller: SinglePaymentDialogController,
        //         locals: {payment: payment },
        //         bindToController: true,
        //         templateUrl: 'app/main/pages/earningcosts/dialogs/singlepayment/singlepayment.html',
        //         clickOutsideToClose: true,
        //         fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints
        //     }).then(
        //         function(answer) {
        //             // se rispondo, ho solo cliccato [Paga]
        //             // blockUI.start();
        //             Payment.pay({
        //                 subscriptionId: '' + payment.subscriptionId,
        //                 paymentDate: answer.paymentData.paymentDate,
        //                 amount: answer.paymentData.paymentValue,
        //                 description: answer.paymentData.paymentDescription ? answer.paymentData.paymentDescription : '',
        //                 //paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
        //                 flgGenerateReceipt: answer.paymentData.flgGenerateInvoice,
        //                 flgSendReceipt: answer.paymentData.flgSendNotification
        //             }).$promise.then(
        //                 function(data) {
        //                     // $log.debug('success');
        //                     // $log.debug(data);
        //                     //aggiungo un piccolo T.O. per la generazione della ricevuta
        //                     // if (answer.paymentData.flgGenerateInvoice) {
        //                     //     $timeout(function () {
        //                     //         blockUI.stop();
        //                     //     }, 3000);
        //                     // } else {
        //                     //     blockUI.stop();
        //                     // }
        //                     AlertMessageService.showSuccessMessage();
        //                     reloadPayments();
        //                 },
        //                 function(httpResponse) {
        //                     $log.debug('error');
        //                     $log.debug(httpResponse);
        //                     AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
        //                     // blockUI.stop();
        //                 });
        //         },
        //         function() {
        //             // se annullo non faccio nulla
        //         }
        //     );
        // };


        /**
         * Controller della dialog di pagamento singolo
         *
         * @param $scope
         * @param $log
         * @constructor
         */
        function SinglePaymentDialogController($scope, $mdDialog, payment) {
            $log.debug('SinglePaymentDialogController()');
            $scope.payment = payment;
            $scope.paymentData = {
                paymentDate: moment().toDate(),
                paymentValue: payment.paymentValue,
                paymentDescription: payment.paymentDescription,
                flgGenerateInvoice: true,
                flgSendNotification: false,
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.answer = function(answer) {
                answer = answer || { paymentData: $scope.paymentData };
                $mdDialog.hide(answer);
            };
        }
        SinglePaymentDialogController.inject = ['$scope', '$mdDialog'];


        function formatAmountCell(data, row) {
            return '<span >' + data + '</span>';

        }

        function formatRowCell(data, row) {
            return data;
        }

        function formatDate(date) {
            if (!date || date === null) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }


        vm.togglePaymentStatusfilter = function() {
            vm.filters.hideDonePayments = !vm.filters.hideDonePayments;
            vm.dtInstance.DataTable.draw();
        };


        /**
         * Aggiunge un campo per l'ordinamento in base alla data di inizio del periodi di ordine.
         *
         * @param payment
         */
        self.addDateSortField = function(payment) {
            var s = '';
            // add start billing period date
            s += (payment && payment.orderDetail && payment.orderDetail.order &&
                payment.orderDetail.order.dtBillingPeriodStart) ?
                moment(payment.orderDetail.order.dtBillingPeriodStart).format('YYYYMMDD') :
               '';
            // add end billing period date
            s += (payment && payment.orderDetail && payment.orderDetail.order &&
                payment.orderDetail.order.dtBillingPeriodEnd) ?
                moment(payment.orderDetail.order.dtBillingPeriodEnd).format('YYYYMMDD') :
                '';
            // add payment creation date
            s += (payment && payment.paymentDate) ? moment(payment.paymentDate).format('YYYYMMDD') : '';
            payment.sortDateField = s;
        };


    }

})();

(function() {
    'use strict';

    angular
    .module('app.pages.payments')
    .controller('PaySubscriptionSuccessController', PaySubscriptionSuccessController);

    /** @ngInject */
    function PaySubscriptionSuccessController($rootScope, $scope,  $mdDialog, $compile, $http, DTOptionsBuilder, Payment, DTColumnBuilder, $log,LoopBackAuth,
            $translate, AuthenticationService, User, Organization, $location,  $state, PaymentReason, AlertMessageService, _, StripePublicKey,
                                       ApiPath)
    {
        var vm = this;
        vm.currentUserId = null;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.stripePublicKey = StripePublicKey;
        vm.service = null;
        vm.subscriptionId = null;
        vm.savingStatus = 'saving';
        vm.checkoutSessionId = null;


        /**
         *
         */
        vm.init = function() {
            vm.currentUserId = User.getCurrentId().toString();
            vm.subscriptionId = $state.params.subscriptionId;
            vm.checkoutSessionId = $state.params.checkoutSessionId;
            //PRENDO L'ELENCO DELLE ISCRIZIONI UTENTE + SUOI PARENTI E RECUPERO QUELLA IN QUESTIONE
            if (AuthenticationService.isAuthenticated()){
                User.findById({
                    id: vm.currentUserId
                }).$promise.then(function(user){
                    // carica i servizi dell'utente loggato per cercare quello da mostrare
                    user.$prototype$allServices().then(
                        function(response) {
                            if ( response.result.services &&  response.result.services!==null) {
                                vm.service =_.find(response.result.services, function(s) {
                                    return s.subscriptionId==vm.subscriptionId;
                                });
                                // aggiorna lo stato del pagamento della Subscription
                                vm.registerPayment();
                            } if (!vm.service) {
                                AlertMessageService.showErrorAlert('MESSAGE.OFFERED_SERVICE_NOT_FOUND');
                            }
                        });
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Registra il pagamento della subscription
         */
        vm.registerPayment = function() {
            vm.savingStatus = 'saving';
            $http.post(
                ApiPath + '/stripe/setsubscriptionpaid',
                {
                    subscriptionId: vm.subscriptionId,
                    checkoutSessionId: vm.checkoutSessionId,
                    amount: vm.service && vm.service.paymentDue ? vm.service.paymentDue - (vm.service.paymentValue || 0) : 0,
                }
            ).then(
                function(response) {
                    if (response.status === 200) {
                        vm.savingStatus = 'ok';
                    } else {
                        vm.savingStatus = 'failed';
                        $log.warn(response.status);
                        $log.warn(response.data);
                        AlertMessageService.showErrorAlert(response.err.message);
                    }
                },
                function(err) {
                    vm.savingStatus = 'failed';
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Problema con i parametri, riprovare.');
                }
            );
        };



        vm.gotoSubscriptions = function() {
            $state.go('app.pages_profile_services', { userID: vm.currentUserId });
        };


    }

})();


(function() {
    'use strict';

    angular
    .module('app.pages.payments')
    .controller('PaySubscriptionController', PaySubscriptionController);

    /** @ngInject */
    function PaySubscriptionController($rootScope, $scope,  $mdDialog, $compile, $http, DTOptionsBuilder, Payment, DTColumnBuilder, $log,LoopBackAuth,
            $translate, AuthenticationService,  User, Organization, $location,  $state, PaymentReason, AlertMessageService, _, StripePublicKey,
                                       ApiPath, PublicCylUrl, Subscription)
    {
        var vm = this;
        vm.loading = false;
        vm.currentUserId = null;
        vm.currentUser = null;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.service = null;
        vm.subscriptionId = null;
        vm.organization = null;

        vm.stripeInfo = {       // raccolgo qui le informazioni sul pagamento con Stripe
            paying: false,      // true se ho avviato la procedura di pagamento
            loading: false,
            submitting: false,
            submitStatus: null,
            publicKey: StripePublicKey,
            elementsParameters: {
                locale: 'it'
            },
            cardStyles: {
                style: {
                    base: {
                        color: "#32325D",
                        fontWeight: 500,
                        fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
                        fontSize: "16px",
                        fontSmoothing: "antialiased",

                        "::placeholder": {
                            color: "#CFD7DF"
                        }
                    },
                    invalid: {
                        color: "#E25950"
                    }
                }
            }
        };


        init();

        function init() {
            vm.loading = true;
            vm.subscriptionId = $state.params.subscriptionId;
            vm.currentUserId = User.getCurrentId().toString();
            //PRENDO L'ELENCO DELLE ISCRIZIONI UTENTE + SUOI PARENTI E RECUPERO QUELLA IN QUESTIONE
            if (AuthenticationService.isAuthenticated()) {
                User.findById({
                    id: vm.currentUserId
                }).$promise.then(function(user){
                    vm.currentUser = JSON.parse(JSON.stringify(user));
                    user.$prototype$allServices().then(
                        function(response) {
                            if (response.result.services) {
                                vm.service =_.find(response.result.services, function(s) {
                                    return s.subscriptionId.toString() === vm.subscriptionId;
                                });
                            }
                            if (!vm.service) {
                                vm.loading = false;
                                AlertMessageService.showErrorAlert('MESSAGE.OFFERED_SERVICE_NOT_FOUND');
                            } else {
                                // se ho il servizio, carico la relativa Organization, così ne trovo lo Stripe account id
                                $log.debug('PaySubscriptionController.init()');
                                Organization.findById({ id: vm.service.organizationId }).$promise.then(
                                    function(org) {
                                        vm.loading = false;
                                        vm.organization = JSON.parse(JSON.stringify(org));
                                    },
                                    function(err) {
                                        vm.loading = false;
                                        $log.error('Errore in caricamento organizzazione');
                                        $log.error(err);
                                    }
                                );
                            }
                        },
                        function(err) {
                            vm.loading = false;
                            $log.error('Errore in caricamento servizi utente');
                            $log.error(err);
                        });
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        /**
         * Crea l'intent per il pagamento via Stripe di una subscription.
         */
        vm.startStripePayment = function() {
            $log.debug('vm.startStripePayment()');
            $log.debug('vm.service: ' + JSON.stringify(vm.service));

            // mostra il form di pagamento (e nasconde le sezioni non necessarie)
            vm.stripeInfo.paying = true;
            vm.stripeInfo.loading = true;

            // chiede al server API CYL il paymentIntent
            var intentData = {
                amount: Math.trunc((vm.service.paymentDue ? vm.service.paymentDue : 0) - (vm.service.paymentValue ? vm.service.paymentValue : 0)) * 100,
                currency: 'eur',
                description: (vm.service.name ? vm.service.name : '') + ' ' + (vm.service.displayName ? vm.service.displayName : ''),
                // metadati arbitrari
                metadata: {
                    type: 'payment',
                    source: 'website',
                    userId: vm.currentUserId ? vm.currentUserId : null,
                    subscriptionId: vm.service.subscriptionId ? vm.service.subscriptionId : null,
                },
                // lo aggiunge il server
                // on_behalf_of: vm.organization.stripeAccountId,
                // transfer_data: {
                //     // account id dell'organizzazione che riceve i soldi
                //     destination: vm.organization.stripeAccountId,
                // }
            };
            $log.debug('intentData: ' + JSON.stringify(intentData));
            Payment.getStripePaymentIntent({ intentData: intentData }).$promise.then(
                function(paymentIntent) {
                    $log.debug('paymentIntent: ' + JSON.stringify(paymentIntent));
                    vm.stripeInfo.loading = false;
                    vm.stripeInfo.instance = Stripe(vm.stripeInfo.publicKey);
                    // crea form di pagamento
                    var stripeElements = vm.stripeInfo.instance.elements(vm.stripeInfo.elementsParameters);
                    vm.stripeInfo.cardElement = stripeElements.create('card', vm.stripeInfo.cardStyles);
                    vm.stripeInfo.cardElement.mount('#stripe-card');
                    vm.stripeInfo.clientSecret = paymentIntent.paymentIntent.client_secret;
                    // gestione errori compilazione
                    vm.stripeInfo.cardElement.on('change', function(error) {
                        $log.debug('Error: ' + JSON.stringify(error));
                        if (error && error.error) {
                            $scope.$apply(function() {
                                vm.stripeInfo.error = error.error;
                            });
                        } else {
                            $scope.$apply(function() {
                                vm.stripeInfo.error = null;
                            });
                        }
                    });
                },
                function(err) {
                    vm.stripeInfo.loading = false;
                    vm.stripeInfo.paying = false;
                    $log.error('Errore creando paymentIntent:');
                    $log.error(err);
                    AlertMessageService.showErrorAlert('Si è verificato un errore comunicando con Stripe.');
                }
            );
        };



        /**
         * Invia il pagamento a Stripe. Il server CYL lo registra con un webhook
         * Rif: https://stripe.com/docs/payments/payment-intents/web#completing-payment
         */
        vm.submitStripePayment = function() {
            $log.debug('vm.submitStripePayment()');
            vm.stripeInfo.submitting = true;
            vm.stripeInfo.submitStatus = null;
            vm.stripeInfo.instance.handleCardPayment(
                vm.stripeInfo.clientSecret,
                vm.stripeInfo.cardElement,
                {
                    payment_method_data: {
                        billing_details: { name: vm.currentUser.familyName + ' ' + vm.currentUser.givenName }
                    }
                }
            ).then(function(result) {
                if (!result.error) {
                    $scope.$apply(function() {
                        vm.stripeInfo.submitting = false;
                        vm.stripeInfo.submitStatus = 'ok';
                    });
                    $log.debug('Pagamento inviato correttamente.');
                    $log.debug('result: ' + JSON.stringify(result));
                } else {
                    $scope.$apply(function() {
                        vm.stripeInfo.submitting = false;
                        vm.stripeInfo.submitStatus = 'error';
                    });
                    $log.error('Errore inviando il pagamento');
                    $log.error(result.error);
                }
            });
        };


        /**
         * @description
         * Formatta il numero euro come #,##
         */
        vm.formatEuro = function(n) {
            if (!n) return '0,00';
            var str = n.toFixed(2).toString();
            str=str.replace('.', ',');
            return str;
        };


        /**
         * Torna alla pagina precedente (elenco pagamenti utente)
         */
        vm.close = function() {
            $state.go('app.pages_profile_services', { userId: vm.currentUserId });
        };
    }

})();


(function() {
    'use strict';

    angular
    .module('app.pages.payments')
    .controller('PayCylplanSuccessController', PayCylplanSuccessController);

    /** @ngInject */
    function PayCylplanSuccessController($rootScope, $scope,  $mdDialog, $compile, $http, DTOptionsBuilder, Payment, DTColumnBuilder, $log,LoopBackAuth,
            $translate, AuthenticationService, User, Organization, $location,  $state, PaymentReason, AlertMessageService, _, StripePublicKey,
                                         CylPlan)
    {
        var vm = this;
        vm.currentUser = null;
        vm.currentUserId = null;
        vm.savingStatus = 'saving';
        vm.organizationId = null;
        vm.plan = null;
        vm.cylCustomer = null;
        vm.paymentCardId = null;


        /**
         *
         */
        vm.init = function() {
            vm.currentUserId = User.getCurrentId().toString();
            if (AuthenticationService.isAuthenticated()){
                User.findById({
                    id: vm.currentUserId
                }).$promise.then(function(user){
                    vm.currentUser = user;
                    vm.registerPayment();
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Registra il pagamento della subscription
         */
        vm.registerPayment = function() {
            vm.organizationId = $state.params.organizationId ? $state.params.organizationId : null;
            var planData = $state.params.planData ? $state.params.planData : null;
            try {
                vm.plan = JSON.parse(atob(planData));
            } catch (e) {}

            if (vm.organizationId && vm.plan) {
                vm.savingStatus = 'saving';
                // prima carica l'organizzazione come cliente
                CylPlan.loadOrganizationAsCustomer({organizationId: vm.organizationId}).$promise.then(
                    function(cus) {
                        vm.cylCustomer = cus;
                        vm.paymentCardId = cus.default_source;
                        if (!vm.paymentCardId) {
                            vm.paymentCardId = 'NEW_CARD';
                        }
                        // poi aggiorna la subscription
                        CylPlan.upgradeSubscription({
                            organizationId: vm.organizationId,
                            planId: vm.plan.id,
                            sourceId: vm.paymentCardId
                        }).$promise.then(function(done) {
                            $log.debug(done);
                            vm.savingStatus = 'ok';
                            AlertMessageService.showSuccessMessage();
                            window.location.href = '/organizations/' + vm.organizationId;
                        }, function(httpResponse) {
                            $log.error(httpResponse);
                            vm.savingStatus = 'failed';
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    }, function(httpResponse) {
                        $log.debug(httpResponse);
                        vm.savingStatus = 'failed';
                    });
            }
        };



        vm.gotoHome = function() {
            $state.go('app.organization', { organizationId: vm.organizationId });
        };


    }

})();


(function() {
    'use strict';

    /**
     * Pagina che mostra il messaggio di pagamento ricevuto tramite app. L'app viene inviata a questa pagina dopo un
     * pagamento con Stripe, usando il sistema con SCA.
     */
    angular
    .module('app.pages.payments')
    .controller('PayAppSubscriptionController', PayAppSubscriptionController);

    /** @ngInject */
    function PayAppSubscriptionController($state) {
        var vm = this;
        vm.status = null;


        vm.init = function() {
            // non verifico l'utente, è una pagina pubblica
            if ($state && $state.params && $state.params.success) {
                if ($state.params.success.toLowerCase() === 'ok') {
                    vm.status = 'ok';
                } else {
                    vm.status = 'fail';
                }
            }
        };


    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.pages.notifications', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_notifications', {
            url      : '/notifications',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/notifications/notifications.html',
                    controller : 'NotificationsController as vm'
                }
            },
            bodyClass: 'notifications'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/notifications');

//        msNavigationServiceProvider.saveItem('pages.notifications', {
//            title: 'Notifications',
//            translate  : 'PAGES.NOTIFICATIONS',
//            icon  : 'icon-email',
//            state: 'app.pages_notifications'
////            	,
////            weight     : 4            
//        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.notifications')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController($rootScope, $scope, $state, $mdDialog, $compile, DTOptionsBuilder, Notification, DTColumnBuilder, $log, ApiPath, LoopBackAuth, $sce,
                                     $translate, AuthenticationService,  User, Organization, CylNotifier, PubSub)
    {
        var vm = this;

        vm.loadNotifications=loadNotifications;
        vm.notifications=[];
        vm.selected = {};
        vm.selectAll = false;
        vm.selectedItems = [];
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.deleteSelected=deleteSelected;
        vm.markSelectedAsRead=markSelectedAsRead;
        vm.markAsRead=markAsRead;
        vm.deleteNotification=deleteNotification;
        vm.dtInstance = {};
        vm.reloadNotifications=reloadNotifications;
        vm.openNotification=openNotification;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.apiPath=ApiPath;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-click="vm.toggleAll()">';

        init();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadNotifications)
            .withOption('processing', true)
            .withDataProp('data')
            .withDisplayLength(100)
            .withPaginationType('full_numbers')
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            //			.withOption('rowCallback', rowCallback)
            .withOption('createdRow', function(row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('status').withTitle('STATUS').notVisible(),
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(
                function (data,type, row) {
                    //vm.selected[row.id] = false;
                    return '<input type="checkbox" ng-model="vm.selectedItems[' + row.id + ']" ng-click="vm.toggleOne()">';
                }),
            DTColumnBuilder.newColumn('notificationDate').withTitle($translate.instant('NOTIFICATIONS.DATE')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= formatDate(new Date(data));
                    return formatByState(ret, row);
                }),
            DTColumnBuilder.newColumn('sender').withTitle($translate.instant('NOTIFICATIONS.SENDER')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null) {
                        ret+= data.displayName;
                    }
                    if (row.senderOrganization && row.senderOrganization!==null) {
                        if (ret!=='') {
                            ret += ' - ';
                        }
                        ret+=row.senderOrganization.name;
                    }
                    return formatByState(ret, row);
                }),
            DTColumnBuilder.newColumn('title').withTitle($translate.instant('NOTIFICATIONS.TITLE')).notSortable().renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= data;
                    return formatByState(ret, row);
                }),
            DTColumnBuilder.newColumn(null).withTitle($translate.instant('NOTIFICATIONS.DELETE')).notSortable().renderWith(
                function (data,type, row) {
                    //vm.selected[row.id] = false;
                    return '<md-button title="'+$translate.instant('NOTIFICATIONS.DELETE')+'" class="edit-button md-icon-button" ng-click="vm.deleteNotification('+row.id +');" ><md-icon md-font-icon="icon-delete" ></md-icon></md-button>';
                }),
        ];

        $rootScope.$on('$translateChangeEnd', function () {
            updateTableLocale();
        });

        updateTableLocale();


        function init() {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId();
            } else {
                $state.go('app.pages_auth_login');
            }
        }


        function loadNotifications(sSource, aoData, fnCallback, oSettings) {

            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            var query ={
                filter: {
                    where : {recipientId: vm.currentUserId, status: {neq: 'D'}, notificationType: {neq: 'CHAT'}},
                    limit: length,
                    order: 'notificationDate DESC',
                    skip: start,
                    include: ['sender','senderOrganization']
                }
            };

            Notification.count({where: query.filter.where}, function(totalNumber) {

                Notification.find(query, function(notifications) {
                    vm.notifications=notifications;
                    for (var i = 0; i < notifications.length; i++) {
                        vm.selectedItems[notifications[i].id.toString()]=false;
                    }
                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': notifications
                    };
                    fnCallback(records);

                    //riconto le notifiche non lette
                    CylNotifier.countNotifications(vm.currentUserId);

                });
            });


        }


        function markSelectedAsRead() {

            var idToUpd = [];
            for (var id in vm.selectedItems) {
                if (vm.selectedItems.hasOwnProperty(id)) {
                    if(vm.selectedItems[id]) {
                        idToUpd.push(id);
                    }
                }
            }

            Notification.updateAll(
                {
                    where: { id: {inq: idToUpd}}
                },
                {status: 'R'},
                function(org,responseHeaders){
                    $log.debug(org);
                    vm.dtInstance.DataTable.draw();
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });

        }

        function markAsRead(notificationId) {

            Notification.updateAll(
                {
                    where: { id: notificationId}
                },
                {status: 'R'},
                function(org,responseHeaders){
                    $log.debug(org);
                    vm.dtInstance.DataTable.draw();
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });

        }

        function reloadNotifications() {
            vm.dtInstance.DataTable.draw();
        }

        function deleteNotification(notificationId) {

            Notification.updateAll(
                {
                    where: { id: notificationId}
                },
                {status: 'D'},
                function(org,responseHeaders){
                    $log.debug(org);
                    //loadOfferedService( $state.params.offeredServiceId);
                    vm.dtInstance.DataTable.draw()
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });

        }

//         function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
//             // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
//             $('td', nRow).unbind('click');
//             $('td', nRow).bind('click', function() {
//                 $scope.$apply(function() {
//                     //vm.someClickHandler(aData);
//                	 Notification.updateAll(
//                             {
//                                 where: { id: aData.id}
//                             },
//                             {status: 'R'},
//                             function(org,responseHeaders){
//                                 $log.debug(org);
//                                 //loadOfferedService( $state.params.offeredServiceId);
//                                 vm.dtInstance.DataTable.draw()
//                             },
//                             function(httpResponse){
//                                 $log.debug(httpResponse);
//                                 AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
//
//                             });
//                	 });
//             });
//             return nRow;
//         }

        function deleteSelected() {

            var idToUpd = [];
            for (var id in vm.selectedItems) {
                if (vm.selectedItems.hasOwnProperty(id)) {
                    if(vm.selectedItems[id]) {
                        idToUpd.push(id);
                    }
                }
            }

            Notification.updateAll(
                {
                    where: { id: {inq: idToUpd}}
                },
                {status: 'D'},
                function(org,responseHeaders){
                    $log.debug(org);
                    vm.dtInstance.DataTable.draw()
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                });

        }

        function updateTableLocale() {
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            setTimeout(function() {
                vm.dtInstance.DataTable.column(3).header().textContent=$translate.instant('NOTIFICATIONS.DATE');
                vm.dtInstance.DataTable.column(4).header().textContent=$translate.instant('NOTIFICATIONS.SENDER');
                vm.dtInstance.DataTable.column(5).header().textContent=$translate.instant('NOTIFICATIONS.TITLE');
                vm.dtInstance.DataTable.column(6).header().textContent=$translate.instant('NOTIFICATIONS.DELETE');

            }, 200);
        }

        function openNotification(id) {
            //alert(' -> '+(id)+' '+sender+' '+notificationDate+' '+title+' '+message);

            $scope.message = _.find(vm.notifications, function(n) {
               return n.id==id;
            });
            $scope.message.notificationDate= formatDate($scope.message.notificationDate);
            $scope.message.attachments = $scope.message.attachmentLinks ? JSON.parse($scope.message.attachmentLinks) : [];

            $scope.message.senderToShow='';
            if ($scope.message.sender) {
                $scope.message.senderToShow = $scope.message.sender.displayName;
            }
           // $scope.message={
            //     id: id,
            //     sender: sender,
            //     notificationDate: formatDate(notificationDate),
            //     title: title,
            //     message: message};

            $scope.message.html = $scope.message.text;
            if ($scope.message.text) {
                var tokens = $scope.message.text.split(/\r?\n/);
                $scope.message.htmlMessage = '';//$scope.message.text.replace(/\n/g, '<br>');
                for (var i = 0; i < tokens.length; i++) {
                    $scope.message.htmlMessage+='<p>'+tokens[i]+'</p>';
                }
            }
            $scope.message.htmlMessage = $sce.trustAsHtml($scope.message.htmlMessage);

            $scope.dyndocUrl='';
            if ($scope.message.dyndocId && $scope.message.dyndocId!=='' && $scope.message.dyndocId!=='null' && $scope.message.dyndocId!=='undefined') {
                $scope.dyndocUrl= vm.apiPath + '/dynamicDocumentConnectors/' + $scope.message.dyndocId;
            }


            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/notifications/dialogs/open_message_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });

            markAsRead(id);
        }




        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function formatByState(data, row) {
            var val = '';
            if (row.status==='N') {
                val= '<b>'+data+'</b>';
            }
            else {
                val=data;
            }
            var senderOrgName = "";
            if (row.senderOrganization && row.senderOrganization!==null)
                senderOrgName= escapeApex(row.senderOrganization.name);

            return '<span style=\"cursor: pointer;\" ng-click=\"vm.openNotification('+row.id+')\">'+val+'</span>';


        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY HH:mm');
        }

        function toggleAll () {
            for (var id in vm.selectedItems) {
                if (vm.selectedItems.hasOwnProperty(id)) {
                    vm.selectedItems[id] = vm.selectAll;
                }
            }
        }
        function toggleOne () {
            for (var id in vm.selectedItems) {
                if (vm.selectedItems.hasOwnProperty(id)) {
                    if(!vm.selectedItems[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function escapeApex( str ) {
            if (!str || str===null) return '';
            return str.replace(/'/g, "\\'");
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.message')
        .controller('MessageController', MessageController);

    /** @ngInject */
    function MessageController($rootScope, $q, $scope,  $mdDialog, $compile, DTOptionsBuilder, Payment, DTColumnBuilder, $log,ApiPath,
    		$translate, AuthenticationService,  User, Organization, $location,  $state, PaymentReason, AlertMessageService, EarningCost, _)
    {
        var vm = this;
        vm.message = '';
        vm.done=false;

         init();

         function init() {
             vm.messageCode=$state.params.messageCode;
             vm.messageType=$state.params.messageType;
             vm.submessage='';
             try {
                 vm.submessage = atob($location.search().submsg);
             } catch(err) {}
             vm.done=true;
         }


    }

})();

'use strict';

(function() {
    angular
        .module('app.pages.massive_notification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.pages_massive_notification', {
            url      : '/massive_notification/:organizationId/:offeredServiceId/:paymentsFilter',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/massive_notification/massive_notification.html',
                    controller : 'MassiveNotificationController as vm'
                }
            },
            bodyClass: 'massive-notification'
        });
    }


})();

'use strict';

(function() {
    angular
        .module('app.pages.massive_notification')
        .controller('MassiveNotificationController', MassiveNotificationController);

    /** @ngInject */
    function MassiveNotificationController($log, $state, $mdDialog, $q, $timeout, AuthenticationService, breadcrumbManager,
                                           AlertMessageService,
                                           Organization, User, Notification) {
        var vm = this;
        vm.currentUserId = null;
        vm.organizationId = null;
        vm.offeredServiceId = null;
        vm.paymentsFilter = null;
        vm.items = [];
        vm.loadingItems = true;
        vm.subject = 'Notifica di pagamento in scadenza';
        vm.message = "Gentile utente,\n\nti ricordiamo che hai una quota in scadenza. Puoi accedere all'app o tramite il sito clubyourlife.cloud per controllare la tua situazione.";
        vm.sending = false;     // se true, sto inviando le notifiche
        vm.sendingProgress = 0; // valore del progress per l'invio
        vm.sent = 0;            // numero di notifiche inviate


        /**
         * Inizializza il controller
         */
        vm.init = function() {
            $log.debug('MassiveNotificationController.init()');
            // verifica utente loggato
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                // legge parametri
                vm.organizationId = $state.params.organizationId || (breadcrumbManager.currentOrganization() || null);
                vm.offeredServiceId = $state.params.offeredServiceId || null;
                vm.paymentsFilter = $state.params.paymentsFilter || null;
                // carica le persone
                loadItems();
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Carica le persone
         */
        function loadItems() {
            vm.loadingItems = true;
            if (vm.organizationId) {
                // prima legge il periodo di riferimento
                breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                    var filter = {};
                    //imposta periodo di riferimento nel filtro per la query
                    if (refPeriod) {
                        filter.dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                        filter.dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                    }
                    // poi legge l'orgenizzazione, poichè userò un metodo di istanza
                    $log.debug('MassiveNotificationController.loadItems()');
                    Organization.findById({
                        id: vm.organizationId,
                    }).$promise.then(
                        function(organization) {
                            // imposto filtri per la query
                            if (vm.offeredServiceId) {
                                filter.serviceId = vm.offeredServiceId;
                            }
                            if (vm.paymentsFilter) {
                                filter.payments = vm.paymentsFilter;
                            }

                            // nuova API
                            var searchFilter = {
                                organizationId: vm.organizationId,
                                dateFrom: '19990101',
                                dateTo: '29991231',
                                documentStatus: 'DONOTADD', // non estrae il documentStatus, la query va più veloce
                            };
                            if (vm.offeredServiceId) {
                                searchFilter.offeredServiceId = vm.offeredServiceId;
                            }
                            if (vm.paymentsFilter) {
                                searchFilter.paymentStatus = vm.paymentsFilter;
                            }
                            Organization.subscribersList(searchFilter).$promise.then(
                                function(subscribers) {
                                    if (subscribers) {
                                        vm.items = JSON.parse(JSON.stringify(subscribers));
                                        vm.items = _.map(vm.items, function(item) {
                                            item.id = item.userId;
                                            return item;
                                        });
                                    } else {
                                        vm.items = [];
                                    }
                                    $log.debug(vm.items);
                                    vm.loadingItems = false;
                                },
                                function(err) {
                                    $log.error('Errore in ricerca iscritti a organizzazione');
                                    $log.error(err);
                                    vm.loadingItems = false;
                                }
                            );

                            // vecchia API deprecata
                            // organization.$prototype$allSubscribers(filter).then(
                            //     function(data) {
                            //         if (data && data.result && data.result.users) {
                            //             vm.items = JSON.parse(JSON.stringify(data.result.users));
                            //         }
                            //         $log.debug(vm.items);
                            //         vm.loadingItems = false;
                            //     },
                            //     function(err) {
                            //         $log.error('Errore in ricerca iscritti a organizzazione');
                            //         $log.error(err);
                            //         vm.loadingItems = false;
                            //     }
                            // );
                        },
                        function(err) {
                            $log.error('Errore in ricerca Organization con id=' + vm.organizationId);
                            $log.error(err);
                            vm.loadingItems = false;
                        }
                    );
                });
            } else {
                $log.error('organizationId mancante, impossibile interrogarla per ottenere gli iscritti.')
                vm.loadingItems = false;
            }
        }


        /**
         * Seleziona o deseleziona tutti gli elementi
         */
        vm.selectAllToggle = function() {
            // se tutto gli elementi sono selezionati
            if (vm.areSelectedAllItems()) {
                // deseleziona tutti
                _.each(vm.items, function(item) {
                    item.selected = false;
                });
            } else {
                // altrimenti seleziona tutti
                _.each(vm.items, function(item) {
                    item.selected = true;
                });
            }
            $log.debug(vm.items);
        };


        /**
         * Ritorna true se tutti gli elementi sono selezionati
         * @returns {boolean}
         */
        vm.areSelectedAllItems = function() {
            var all = true;
            _.each(vm.items, function(item) {
                if (!item.selected) {
                    all = false;
                }
            });
            return all;
        };


        /**
         * Ritorna true se almeno un elemento è selezionato
         * @returns {boolean}
         */
        vm.isSelectedSomeItem = function() {
            var some = false;
            _.each(vm.items, function(item) {
                if (item.selected) {
                    some = true;
                }
            });
            return some;
        };


        /**
         * Chiede conferma ed eventualmente invia le notifiche
         *
         * @param ev
         */
        vm.sendNotificationsConfirm = function(ev) {
            var confirm = $mdDialog.confirm()
                .title('Confermi l\'invio delle notifiche?')
                .textContent('Proseguendo invierai le notifiche alle persone selezionate.')
                .ok('Invia')
                .cancel('Annulla');

            $mdDialog.show(confirm).then(function() {
                $log.debug('Invia notifiche');
                vm.sendNotifications();
            }, function() {
                // ho annullato
            });
        };


        /**
         * Effettua l'invio delle notifiche alle persone selezionate
         */
        vm.sendNotifications = function() {
            vm.sent = 0;
            vm.sendingProgress = 0;
            vm.sending = true;

            // costruisce un array con le funzioni di invio notifica
            var promises = [];
            // per ogni elemento selezionato
            _.each(vm.items, function(item) {
                if (item.selected) {
                    // uso la creazione della notifica, funziona
                    var f = (function(paramsObject) {
                        Notification.create(
                            paramsObject,
                            function(n, responseHeaders) {
                                $log.debug('Notifica inviata a utente ' + item.id);
                            },
                            function(httpResponse) {
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                            });
                        }).bind(null, {
                            senderId: vm.currentUserId,
                            recipientId: item.id,
                            title: vm.subject,
                            text: vm.message,
                            notificationType: 'NOTIFICATION',
                            status: 'N',
                            notificationDate: new Date()
                        })();
                    promises.push(f);

                    // con questo sistema le promise vengono risolte ma sembra che non arrivino
                    // var myPromise = User.notifyUser({ userId: item.id, subject: vm.subject, text: vm.message });
                    // promises.push(myPromise);

                    // questa è una promise annidata, che non riesco a far funzionare
                    // var f = (function(item, subject, message) {
                    //     var deferred = $q.defer();
                    //     User.notifyUser({ userId: item.id, subject: subject, text: message }).$promise.then(
                    //         function(){
                    //             deferred.resolve({
                    //                 msg: 'Notifica inviata a ' + item.givenName + ' ' + item.familyName,
                    //                 status: 'ok'
                    //             });
                    //             vm.sent++;
                    //             vm.sendingProgress += Math.trunc(100 / vm.items.length);
                    //         },
                    //         function(){
                    //             deferred.reject({
                    //                 msg: 'Fallito invio notifica per ' + item.givenName + ' ' + item.familyName,
                    //                 status: 'error'
                    //             });
                    //             vm.sent++;
                    //             vm.sendingProgress += Math.trunc(100 / vm.items.length);
                    //         }
                    //     );
                    //     return deferred.promise;
                    // }).bind(null, item, vm.subject, vm.message)();
                    // promises.push(f);

                    // con il timeout di test funziona bene
                    // var f = (function(item, subject, message) {
                    //     var deferred = $q.defer();
                    //     // con il timeout funziona, con la $promise annidata no
                    //     // $timeout(function() {
                    //     //     console.log('Risolta funzione');
                    //     //     deferred.resolve('ok');
                    //     //     vm.sent++;
                    //     //     vm.sendingProgress += Math.trunc(100 / vm.items.length);
                    //     //     $log.debug('vm.sent: ' + vm.sent);
                    //     // }, Math.random()*3000 + 2000);
                    //     return deferred.promise;
                    // }).bind(null, item, vm.subject, vm.message)();
                    // promises.push(f);
                }
            });
            $log.debug(promises);
            // avvia in paralello l'eleborazione
            $q.all(promises)
                .then(function(results){
                    console.log('terminati i processi in parallelo');
                    console.log(results);
                    vm.sending = false;
                    vm.sendingProgress = 0;
                    AlertMessageService.showSuccessMessage();
                    vm.sent = results.length;
                }, function(err){
                    console.log('errore nei processi in parallelo');
                    console.log(err);
                    vm.sending = false;
                    vm.sendingProgress = 0;
                    AlertMessageService.showErrorAlert('Errore in invio delle notifiche');
                });
        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.invitations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_invitations', {
            url      : '/invitations/:offeredServiceId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/invitations/invitations.html',
                    controller : 'InvitationsController as vm'
                }
            },
            bodyClass: 'invitations'
        }).state('app.pages_public_invitation', {
            url      : '/invited/:uuid',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_public_invitation': {
                    templateUrl: 'app/main/pages/invitations/public_invitation.html',
                    controller : 'PublicInvitationsController as vm'
                }
            },
            bodyClass: 'invitations'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/invitations');

    }

})();

'use strict';

(function (){

    angular
        .module('app.pages.invitations')
        .controller('PublicInvitationsController', PublicInvitationsController);

    /** @ngInject */
    function PublicInvitationsController ($log, $q, $location, $state, $scope, $rootScope, $translate, $anchorScroll, PublicCylUrl, OfferedService, Organization, Invitation,
                                          ServiceSchedule , $mdDialog, Subscription, AuthenticationService, blockUI, AlertMessageService, StripePublicKey, OrganizationDoctype, $filter, User, ApiPath, _ )
    {
        var vm = this;

        var organizationId;

        // Data
        vm.offeredService = {};
        vm.apiPath=ApiPath;
        vm.invitationPage = null;
        vm.publicCylUrl = PublicCylUrl;
        vm.scrollTo = scrollTo;

        vm.logoImageUrl = null;

        vm.backgroundImage=backgroundImage;
        vm.formatDate = formatDate;
        vm.formatDateFriendly = formatDateFriendly;
        vm.saveInvitation = saveInvitation;

        init();

        //////////



        /**
         * Initialize
         */
        function init(){
            //carico dettaglio servizio
            loadOfferedService( $state.params.uuid);

        }


        /**
         * Funzione che calcola lo stile della intestazione
         * @returns {*}
         */
        function backgroundImage() {
            if (vm.offeredService && vm.offeredService.uriBackgroundImage && vm.offeredService.uriBackgroundImage !==null) {
                vm.backgroundImageUrl=ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.uriBackgroundImage;
                return {'background-image': 'url('+vm.backgroundImageUrl+')', 'background-size': 'cover', 'max-height': '100%', 'height': '100%'};
            } else if (vm.offeredService.organization && vm.offeredService.organization.uriBackgroundImage && vm.offeredService.organization.uriBackgroundImage !==null) {
                vm.backgroundImageUrl=ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriBackgroundImage;
                return {'background-image': 'url('+vm.backgroundImageUrl+')', 'background-size': 'cover', 'max-height': '100%', 'height': '100%'};
            }
            return '';
        }


        vm.scrollTo = function(id) {
            $location.hash(id);
            $anchorScroll();
        };



        function findContactByMail(mail, callback){
            var query ={filter: {
                    where : {email: mail},
                    include: 'organizations'
                }
            };
            User.find(query, function(users) {
                callback(users);
            });
        }




        /**
         * carica dettaglio servizio
         */
        function loadOfferedService(uuid){
            Invitation.find({filter: {
                    where: {uuid: uuid},
                    include: [{offeredService: 'organization'}, 'user']
                }
            }).$promise.then(
                function(data, headers){
                    if (data && data.length > 0) {
                        vm.invitation=data[0];
                        var myService = data[0].offeredService;
                        vm.offeredService = (JSON.parse(JSON.stringify(myService)));

                        if (vm.offeredService.start && vm.offeredService.start!==null) {
                            vm.offeredService.start=new Date(vm.offeredService.start);
                        }

                        if (vm.offeredService.end && vm.offeredService.end!==null) {
                            vm.offeredService.end=new Date(vm.offeredService.end);

                        }

                        if (vm.offeredService && vm.offeredService.uriLogo && vm.offeredService.uriLogo !==null) {
                            vm.logoImageUrl = vm.apiPath  + '/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriLogo;
                        } else if (vm.offeredService.organization && vm.offeredService.organization.uriLogo && vm.offeredService.organization.uriLogo !==null) {
                            vm.logoImageUrl = vm.apiPath  + '/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.offeredService.organization.id +'/download/'+vm.offeredService.organization.uriLogo;
                        }

                        //INIZIALIZZAZIONE DELLA MAPPA
                        setTimeout(function() {
                            $('.gllpLatlonPicker').each(function () {
                                var $obj = $(document).gMapsLatLonPicker();
                                $obj.init( $(this) );
                            });

                            var mapElement = document.getElementById('map');
                            if (mapElement) {
                                var map = new google.maps.Map(document.getElementById('map'), {
                                    center: {lat: parseFloat(vm.offeredService.latitude), lng: parseFloat(vm.offeredService.longitude)},
                                    zoom: 13
                                });
                                var marker = new google.maps.Marker({
                                    position: {lat: parseFloat(vm.offeredService.organization.latitude), lng: parseFloat(vm.offeredService.organization.longitude)},
                                    map: map
                                });
                            }
                        }, 2000);

                    } else {
                        $location.url('/messagefs/ERROR/E?submsg='+btoa('Impossibile processare le richiesta'));
                    }
                },
                function(error){
                    $log.debug(error);
                    $location.url('/messagefs/ERROR/E?submsg='+btoa('Impossibile processare le richiesta'));
                });
        }


        function saveInvitation(status) {
            Invitation.find({
                filter: {
                    where: {
                        uuid: $state.params.uuid,
                    }
                }
            }).$promise.then(
                function(data, headers){
                    if (data && data.length > 0) {
                        Invitation.update({
                            where: {
                                id: data[0].id
                            }
                        },{
                            status : status
                        }, function(value, responseHeaders) {
                            $log.debug(value);
                            $location.url('/messagefs/SUCCESS/S?submsg='+btoa('Grazie per aver inviato la tua risposta'));
                        }, function(httpResponse) {
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                    } else {
                        $location.url('/messagefs/ERROR/E?submsg='+btoa('Impossibile processare le richiesta'));
                    }
                },
                function(error){
                    $log.debug(error);
                });
        }



        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }


        function formatDateFriendly(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('dddd DD MMMM YYYY');
        }


        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];

    }
})();

'use strict';

(function ()
{

    angular
        .module('app.pages.invitations')
        .controller('InvitationsController', InvitationsController);

    /** @ngInject */
    function InvitationsController ($rootScope, $scope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $mdDialog, $state, LoopBackAuth, ApiPath, blockUI, DTColumnDefBuilder, Invitation,
                                    $q, breadcrumbManager, $translate, AuthenticationService,  User, Organization, OfferedService, ServiceDoctype, SubscriptionDocument, AlertMessageService, _  )
    {
        var vm = this;
        vm.offeredService = {};
        vm.invitationsUsers = {};
        vm.selectedUser = {};
        vm.selectAll = false;
        vm.searchStatus = '';

        vm.doSelectAll = doSelectAll;
        vm.sendInvitation = sendInvitation;
        vm.formatDate = formatDate;
        vm.isOneSelected = isOneSelected;
        vm.inviteAll = inviteAll;
        vm.loadOfferedService = loadOfferedService;

        init();


        function init()
        {

            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                loadOfferedService();

            } else {
                $state.go('app.pages_auth_login');
            }

        }


        function doSelectAll() {
            if (!vm.selectAll) {
                vm.selectedUser = {};
                return;
            }

            for (var i = 0; i < vm.offeredService.subscribers.length; i++) {
                var userId = vm.offeredService.subscribers[i].userId;
                if (!vm.invitationsUsers[userId] || !vm.invitationsUsers[userId].status || vm.invitationsUsers[userId].status === 'SENT') {
                    vm.selectedUser[userId] = true;
                }
            }
        }

        function isOneSelected() {
            var userIds = _.keys(vm.selectedUser);
            if (userIds.length === 0) {
                return false;
            }

            for (var i = 0; i < userIds.length; i++ ) {
                if (vm.selectedUser[userIds[i]]) {
                    return true;
                }
            }
            return false;
        }

        function loadOfferedService(){
            vm.invitationsUsers = {};
            vm.selectedUser = {};
            vm.selectAll = false;

            OfferedService.findById({
                id: $state.params.offeredServiceId,
                filter: {
                    include: ['organization']
                }
            }).$promise.then(
                function(data, headers){
                    vm.offeredService = JSON.parse(JSON.stringify(data));

                    // vecchio sistema, deprecato
                    // data.$prototype$allSubscribers({payments: 'A', documents: '', hasCard: ''}).then(
                    //     function(response) {
                    //         $log.debug('allSubscribers:');
                    //         $log.debug(response.result.users);
                    //         vm.offeredService.subscribers = response.result.users;
                    //         vm.offeredService.subscribers = _.sortBy( vm.offeredService.subscribers, function(s){ return s.familyName.toUpperCase() + ' ' +  s.givenName.toUpperCase(); });
                    //         loadInvitations();
                    //     }, function(err) {
                    //         $log.debug(err);
                    //     });

                    // nuovo sistema
                    var searchFilter = {
                        organizationId: vm.offeredService.organizationId,
                        dateFrom: '19990101',
                        dateTo: '29991231',
                        offeredServiceId: vm.offeredService.id,
                        documentStatus: 'DONOTADD', // non estrae il documentStatus, la query va più veloce
                    };
                    Organization.subscribersList(searchFilter).$promise.then(
                        function(subscribers) {
                            subscribers = JSON.parse(JSON.stringify(subscribers));
                            // ordina per cognome
                            vm.offeredService.subscribers = _.sortBy(subscribers, function(s){
                                return s.familyName.toUpperCase() + ' ' +  s.givenName.toUpperCase();
                            });

                            $log.debug('subscribersList: ');
                            $log.debug(subscribers);

                            // carica gli inviti
                            loadInvitations();
                        }, function(err) {
                            $log.debug(err);
                        }
                    );
                },
                function(error){
                    $log.debug(error);
                });
        }


        function loadInvitations(){
            vm.invitationsUsers = {};
            var searchFilter = {
                filter: {
                    where: {
                        offeredServiceId: $state.params.offeredServiceId
                    }
                }
            };

            if (vm.searchStatus) {
                searchFilter.filter.where.status = vm.searchStatus;
            }

            Invitation.find(searchFilter).$promise.then(
                function(data, headers){
                    var invitations = data;
                    _.each(invitations, function(invitation) {
                        vm.invitationsUsers[invitation.userId] = invitation;
                    });

                    if (vm.searchStatus) {
                        var userIds = _.keys(vm.invitationsUsers);
                        vm.offeredService.subscribers = _.filter(vm.offeredService.subscribers, function(subscriber) {
                            return _.contains(userIds, subscriber.userId.toString());
                        });
                    }
                },
                function(error){
                    $log.debug(error);
                });

        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY HH:mm');
        }

        function sendInvitation(userId) {
            Invitation.find({
                filter: {
                    where: {
                        offeredServiceId: $state.params.offeredServiceId,
                        userId: userId
                    }
                }
            }).$promise.then(
                function(data, headers){
                    if (data && data.length > 0) {
                        Invitation.update({
                            where: {
                                id: data[0].id
                            }
                        },{
                            status : 'SENT'
                        }, function(value, responseHeaders) {
                            loadOfferedService();
                            $log.debug(value);
                            AlertMessageService.showSuccessMessage();
                        }, function(httpResponse) {
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                    } else {
                        Invitation.create({
                            offeredServiceId: vm.offeredService.id,
                            userId: userId,
                            status: 'SENT'
                        }, function(value, responseHeaders) {
                            loadOfferedService();
                            $log.debug(value);
                            AlertMessageService.showSuccessMessage();
                        }, function(httpResponse) {
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                    }
                },
                function(error){
                    $log.debug(error);
                });
        }

        function inviteAll() {
            blockUI.start();
            var userIds = [];
            _.each(_.keys(vm.selectedUser), function(key) {
                if(vm.selectedUser[key]) {
                    userIds.push(key);
                }
            });

            var promisesToCall = [];
            Invitation.find({
                filter: {
                    where: {
                        userId: {inq: userIds},
                        offeredServiceId: $state.params.offeredServiceId
                    }
                }
            }).$promise.then(
                function(data, headers){
                    for (var i = 0; i < userIds.length; i++) {
                        var found = _.find(data, function(a) { return a.userId == userIds[i];});
                        if (found) {
                            promisesToCall.push(Invitation.update({
                                where: {
                                    id: found.id
                                }
                            },{
                                status : 'SENT'
                            }).$promise);
                        } else {
                            promisesToCall.push(Invitation.create({
                                userId : userIds[i],
                                offeredServiceId: vm.offeredService.id,
                                status : 'SENT'
                            }).$promise);
                        }
                    }

                    $q.all(promisesToCall)
                        .then(function(results){
                            blockUI.stop();
                            loadOfferedService();
                            AlertMessageService.showSuccessMessage();
                        }, function(httpResponse){
                            blockUI.stop();
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }, function(httpResponse){
                    blockUI.stop();
                    $log.debug('error');
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
        }



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.earningcosts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_earningcosts', {
            url      : '/earningcosts/:organizationId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/earningcosts/earningcosts.html',
                    controller : 'EarningcostsController as vm'
                }
            },
            bodyClass: 'payments'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/earningcosts');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.earningcosts')
        .controller('EarningcostsController', EarningcostsController);

    /** @ngInject */
    function EarningcostsController($rootScope, $q, $scope,  $mdDialog, $compile, DTOptionsBuilder, Payment,
                                    DTColumnBuilder, $log, ApiPath, blockUI, breadcrumbManager, CylUtils,
                                    $translate, AuthenticationService,  User, Organization,
                                    $state, PaymentReason, AlertMessageService, EarningCost, _, LoopBackAuth,
                                    OrganizationPrivateDocPrefix, appDataService, OfferedService)
    {
        var vm = this;

        vm.searchText = '';
        vm.loadEntries=loadEntries;
        vm.earningcosts=[];
        vm.selected = {};
        vm.deleteEntry=deleteEntry;
        vm.dtInstance = {};
        vm.reloadEntries=reloadEntries;
        vm.askEntryDetails=askEntryDetails;
        vm.organizationId='';
        vm.organization={};
        vm.apiPath=ApiPath;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.gotoOrganizations=gotoOrganizations;
        vm.goToOrganization=goToOrganization;
        vm.backgroundImage=backgroundImage;
        vm.exportExcel=exportExcel;
        vm.generateInvoice=generateInvoice;
        vm.lockEntry=lockEntry;
        vm.askPaymentDetails=askPaymentDetails;
        vm.modificaDescrizione=modificaDescrizione;
        vm.showAllMyOrganizations = false;  // se true, mostro tutte le organizzazioni che amministro
        vm.appDataService = appDataService;
        // periodo di riferimento, che leggo una volta per tutte
        vm.referencePeriod = {
            dtFrom: null,
            dtTo: null,
        };
        // filtri per ricerca
        vm.searchFilters = {
            dtFrom: null,
            dtTo: null,
            description: null,
            offeredServiceId: null,
            userId: null,
            paymentReasonId: null,
            entryValueFrom: null,
            entryValueTo: null,
            // elementi per popolare dropdown e autocomplete
            lists: {
                services: [],
                paymentReasons: [],
                users: [],
            },
            // elementi selezionati dalle md-autocomplete
            selectedOfferedService: null,
            selectedUser: null,
            loading: {
                filtersData: false,
                data: false,
            }
        };


        vm.dtOptionServices = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers').withDisplayLength(100)
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withOption('paging', false)
            .withOption('searching', false)
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('');

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('serverSide', true)
            .withFnServerData(vm.loadEntries)
            .withDataProp('data')
            .withOption('processing', true) // Enable or disable the display of a 'processing' indicator when the table is being processed
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withDisplayLength(100)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtColumns = [
            // DTColumnBuilder.newColumn('id').withTitle('ID').notVisible(),
            DTColumnBuilder.newColumn('entryDate').withTitle($translate.instant('EARNING_COST.DATE')).withClass('dt-column-date').notSortable().withOption('width', '10%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if ( data && data!=null)
                        ret+= formatDate(new Date(data));
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn('paymentReason').withTitle($translate.instant('EARNING_COST.REASON')).withClass('dt-column-paymentreason').notSortable().withOption('width', '10%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if (row.paymentReason && row.paymentReason!==null) {
                        ret += '<span class="cell-paymentreason-' + row.paymentReason.id + '">' +
                            row.paymentReason.name +
                            '</span>';
                    }
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn('entryCompany')
                .withTitle($translate.instant('EARNING_COST.COUNTER_PART'))
                .notSortable()
                .withOption('width', '15%')
                .withClass('dt-column-user')
                .renderWith(
                    function (data,type, row) {
                        var ret = '';
                        if (row.user && row.user!==null) {
                            ret += '<span class="cell-user-' + row.user.id + '">' +
                                row.user.familyName + ' ' + row.user.givenName +
                                '</span>';
                        } else if ( data && data!=null) {
                            ret+= data;
                        }
                        return formatRowCell(ret, row);
                    }),
            DTColumnBuilder.newColumn('offeredService').withTitle($translate.instant('EARNING_COST.SERVICE')).withClass('dt-column-service').notSortable().withOption('width', '15%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    if (row.offeredService && row.offeredService!==null) {
                        ret += '<span class="cell-offeredService-' + row.offeredService.id + '">' +
                            row.offeredService.name + '</span>';
                    }
                    return formatRowCell(ret, row);
                }),
            DTColumnBuilder.newColumn('entryValue').withTitle($translate.instant('EARNING_COST.AMOUNT')).withClass('dt-column-amount').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    var ret = '';
                    var iVal = parseInt(data);
                    if ( data && data!=null)
                        ret+= data;
                    return formatAmountCell(ret, row, iVal)
                }),
            DTColumnBuilder.newColumn('entryDescription').withTitle($translate.instant('EARNING_COST.DESCRIPTION')).withClass('dt-column-description').notSortable().withOption('width', '30%').renderWith(
                function (data,type, row) {
                    var ret = '';

                    if (row.creditNote) {
                        ret += 'NOTA DI CREDITO:<br>';
                    }

                    if ( data && data!=null)
                        ret+= data;

                    var edit = '<md-icon class="s-16" md-font-icon="icon-pencil" title="Modifica descrizione" ng-click="vm.modificaDescrizione('+row.id +');" style="cursor: pointer; color: #ccc; font-size: 18px"></md-icon>';
                    return edit + '&nbsp;&nbsp;' + formatRowCell(ret, row);
                }),



            DTColumnBuilder.newColumn(null).withClass('dt-column-regenerateinvoice').withTitle('').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    if (row.invoiceId) {
                        return '<md-icon id="btn-regenerateinvoice-' + row.invoiceId + '" ' +
                            'class="btn-regenerateinvoice" ' +
                            'md-font-icon="icon-backup-restore" ' +
                            'title="Rigenera ricevuta" ' +
                            'ng-click="vm.generateInvoice('+row.id +');" ' +
                            'style="cursor: pointer"></md-icon>';
                    } else {
                        return '';
                    }

                }),

            DTColumnBuilder.newColumn(null).withClass('dt-column-generateinvoice').withTitle('').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    if (!row.invoiceId) {
                        if ( (row.entryValue > 0 || row.creditNote )&& (row.user || row.entryOrganization)) {
                            return '<md-icon id="btn-generateinvoice-' + row.id + '" ' +
                                'class="btn-generateinvoice" ' +
                                'md-font-icon="icon-playlist-plus" ' +
                                'title="Genera ricevuta" ' +
                                'ng-click="vm.generateInvoice('+ row.id +');" ' +
                                'style="cursor: pointer"></md-icon>';
                        } else {
                            return '';
                        }
                    } else {
                        return '<a title="Scarica ricevuta" ' +
                                'id="btn-downloadinvoice-' + row.invoice.id + '" ' +
                                'class="btn-downloadinvoice" ' +
                                'ng-href="' + vm.apiPath + '/organizationPrivateDocumentsContainers/'+ OrganizationPrivateDocPrefix + row.organizationId + '/download/' + row.invoice.pdfUri + '?access_token='+vm.accessToken+'" ' +
                                'target="_blank">' +
                                '<md-icon md-font-icon="icon-file-pdf"></md-icon>' +
                            '</a>';
                    }

                }),

            DTColumnBuilder.newColumn(null).withClass('dt-column-delete').withTitle('').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    if (vm.isProfileDetail || row.locked)
                        return '';
                    return '<md-button ' +
                        'id="btn-deletepayment' + row.id + '" ' +
                        'title="' + $translate.instant('EARNING_COST.DELETE')+'" ' +
                        'class="edit-button md-icon-button btn-deletepayment" ' +
                        'ng-click="vm.deleteEntry('+row.id +');" >' +
                            '<md-icon md-font-icon="icon-delete"></md-icon>' +
                        '</md-button>';
                }),

            DTColumnBuilder.newColumn(null).withClass('dt-column-lock').withTitle('').notSortable().withOption('width', '5%').renderWith(
                function (data,type, row) {
                    if (row.locked)
                        return '';
                    return '<md-button ' +
                        'id="btn-lockpayment' + row.id + '" ' +
                        'title="'+$translate.instant('EARNING_COST.LOCK')+'" ' +
                        'class="edit-button md-icon-button btn-lockpayment" ' +
                        'ng-click="vm.lockEntry('+row.id +');" >' +
                            '<md-icon md-font-icon="icon-lock-outline"></md-icon>' +
                        '</md-button>';
                }),


        ];

        $rootScope.$on('$translateChangeEnd', function () {
            $log.debug('EarningcostsController.$translateChangeEnd()');
            updateTableLocale();
        });

        $rootScope.$on('REF_PERIOD_CHANGED', function (event, value) {
            setTimeout(function() {
                reloadEntries();
            },200);
        });


        updateTableLocale();

        vm.init = function() {
            if (AuthenticationService.isAuthenticated()) {
                vm.currentUserId = User.getCurrentId().toString();
                vm.organizationId = $state.params.organizationId;
                vm.searchFilters.loading.filtersData = true;
                $q.all([
                    readOrganization(vm.organizationId),
                    readPaymentReasons(vm.organizationId),
                    readOfferedServices(vm.organizationId),
                    readReferencePeriod(),
                    readUsers(vm.organizationId),
                ]).then(
                    function(results) {
                        $log.debug({results: results});
                        vm.organization = results[0];
                        vm.searchFilters.lists.paymentReasons = results[1];
                        vm.searchFilters.lists.offeredServices = results[2];
                        vm.searchFilters.lists.users = results[4];
                        // set reference period
                        var refPeriod = results[3];
                        if (refPeriod && refPeriod.dateFrom) {
                            vm.searchFilters.dtFrom = moment(refPeriod.dateFrom).startOf('day').toDate();
                        }
                        if (refPeriod && refPeriod.dateTo) {
                            vm.searchFilters.dtTo = moment(refPeriod.dateTo).startOf('day').add(23, 'hours').add(59, 'minutes').toDate();
                        }
                        vm.referencePeriod = {
                            dtFrom: vm.searchFilters.dtFrom,
                            dtTo: vm.searchFilters.dtTo,
                        }
                        vm.searchFilters.loading.filtersData = false;
                    },
                    function(err) {
                        vm.searchFilters.loading.filtersData = false;
                        AlertMessageService.showErrorAlert('Errore caricando i dati');
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }
        };


        /**
         * Avvia una promise per leggere le PaymentReason (globali e per una organization)
         */
        function readOrganization(organizationId) {
            var deferred = $q.defer();
            Organization.findById(
                {id: organizationId},
                function(organization) {
                    deferred.resolve(organization);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        /**
         * Avvia una promise per leggere le PaymentReason (globali e per una organization)
         */
        function readPaymentReasons(organizationId) {
            var deferred = $q.defer();
            PaymentReason.find(
                {
                    filter: {
                        where : {
                            organizationId: null,
                            // paymentType:'IN',
                        },
                        order: 'name'
                    }
                },
                function(paymentReasons) {
                    deferred.resolve(paymentReasons);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        /**
         * Legge i servizi di una organizzazione
         * @param {number} organizationId
         */
        function readOfferedServices(organizationId) {
            var deferred = $q.defer();
            OfferedService.find(
                {
                    filter: {
                        where : {
                            organizationId: organizationId,
                            isDeleted: 0,
                        },
                        order: 'name'
                    }
                },
                function(paymentReasons) {
                    deferred.resolve(paymentReasons);
                },
                function(err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }


        /**
         * Legge gli utenti di una organizzazione
         * @param {number} organizationId
         */
        function readUsers(organizationId) {
            var deferred = $q.defer();
            Organization.findById({id: organizationId}).$promise.then(
                function(organization) {
                    if (organization) {
                        organization.$prototype$allUsers().then(
                            function(response) {
                                if (response && response.result && response.result.users) {
                                    deferred.resolve(response.result.users);
                                } else {
                                    deferred.resolve([]);
                                }
                            },
                            function(err) {
                                $log.error(err);
                                deferred.reject(err);
                            }
                        );
                    } else {
                        deferred.resolve([]);
                    }
                },
                function(err) {
                    $log.error(err);
                        deferred.reject(err);
                }
            );
            return deferred.promise;
        }


        /**
         * Legge il periodo di riferimento
         */
        function readReferencePeriod() {
            var deferred = $q.defer();
            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                deferred.resolve(refPeriod);
            });
            return deferred.promise;
        }


        function loadEntries(sSource, aoData, fnCallback, oSettings) {
            vm.searchFilters.loading.data = true;
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            // filtro su organizzazione
            var organizationFilter = {
                organizationId: vm.organizationId
            };
            if (vm.showAllMyOrganizations) {
                organizationFilter = {
                    or: []
                };
                _.each(appDataService.adminOrganizations, function(org) {
                    organizationFilter.or.push({ organizationId: org.id });
                });
            }
            var query = {
                filter: {
                    where: {
                        and: [
                            organizationFilter,
                            {dtDel: null},
                            {_p: new Date().getTime()}
                        ]
                    },
                    limit: length,
                    order: 'entryDate DESC',
                    skip: start,
                    include: ['offeredService', 'entryOrganization', 'user', 'paymentReason', 'invoice', 'payments']
                }
            };

            // reference period filter
            if (vm.searchFilters.dtFrom) {
                query.filter.where.and.push({entryDate: {gte: vm.searchFilters.dtFrom}});
            }
            if (vm.searchFilters.dtTo) {
                query.filter.where.and.push({entryDate: {lte: vm.searchFilters.dtTo}});
            }
            // description contained
            if (vm.searchFilters.description) {
                query.filter.where.and.push({entryDescription: {like: '%' + vm.searchFilters.description + '%'}});
            }
            // entryValue from-to
            if (vm.searchFilters.entryValueFrom) {
                query.filter.where.and.push({entryValue: {gte: vm.searchFilters.entryValueFrom}});
            }
            if (vm.searchFilters.entryValueTo) {
                query.filter.where.and.push({entryValue: {lte: vm.searchFilters.entryValueTo}});
            }
            // paymentReason filter
            if (vm.searchFilters.paymentReasonId) {
                if (vm.searchFilters.paymentReasonId === -999999) {
                    query.filter.where.and.push({paymentReasonId: null});
                } else {
                    query.filter.where.and.push({paymentReasonId: vm.searchFilters.paymentReasonId});
                }
            }
            // offeredService filter
            if (vm.searchFilters.selectedOfferedService && vm.searchFilters.selectedOfferedService.id) {
                query.filter.where.and.push({offeredServiceId: vm.searchFilters.selectedOfferedService.id});
            }
            // user filter
            if (vm.searchFilters.selectedUser && vm.searchFilters.selectedUser.id) {
                query.filter.where.and.push({userId: vm.searchFilters.selectedUser.id});
            }

            // perform query
            EarningCost.count({where: query.filter.where}, function(totalNumber) {
                // $log.debug('query: ' + JSON.stringify(query,null,2));
                EarningCost.find(query, function(payments) {
                    vm.earningcosts = payments;

                    var records = {
                        'draw': draw,
                        'recordsTotal': totalNumber.count,
                        'recordsFiltered': totalNumber.count,
                        'data': payments
                    };
                    vm.searchFilters.loading.data = false;
                    fnCallback(records);
                });
            });
        }


        /**
         * Cerca gli OfferedService che contengono una stringa
         *
         * @param {string} searchText
         */
        vm.getMatchingOfferedServices = function(searchText) {
            var matchingItems = [];
            if (searchText && typeof searchText === 'string' && searchText.length >= 2) {
                if (vm.searchFilters.lists.offeredServices && vm.searchFilters.lists.offeredServices.length > 0) {
                    vm.searchFilters.lists.offeredServices.forEach(function(item) {
                        if (item && item.name && (item.name.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)) {
                            matchingItems.push(item);
                        }
                    })
                }
            }
            return matchingItems;
        };


        /**
         * Cerca gli User che contengono una stringa
         *
         * @param {string} searchText
         */
        vm.getMatchingUsers = function(searchText) {
            // $log.debug('vm.getMatchingUsers(' + searchText + ')');
            var matchingItems = [];
            if (searchText && typeof searchText === 'string' && searchText.length >= 2) {
                // $log.debug('searchText valid...');
                if (vm.searchFilters.lists.users && vm.searchFilters.lists.users.length > 0) {
                    // $log.debug('users list valid');
                    vm.searchFilters.lists.users.forEach(function(item) {
                        // $log.debug('analyzing item: ' + JSON.stringify(item));
                        if (item && item.familyName && item.givenName && (
                            (item.familyName.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) ||
                            (item.givenName.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)) ||
                            (item.displayName && item.displayName.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                            ) {
                            // $log.debug('**** FOUND *** item: ' + JSON.stringify(item));
                            // create displayName, in case it's not set
                            item.displayName = (item.familyName + ' ' + item.givenName).trim().toUpperCase();
                            matchingItems.push(item);
                        }
                    })
                }
            }
            return matchingItems;
        };


        /**
         * Puilisce i filtri di ricerca e riavvia la ricerca
         */
        vm.cleanFilters = function() {
            vm.searchFilters.offeredServiceId = null;
            vm.searchFilters.userId = null;
            vm.searchFilters.paymentReasonId = null;
            vm.searchFilters.selectedUser = null;
            vm.searchFilters.selectedOfferedService = null;
            vm.searchFilters.dtFrom = vm.referencePeriod.dtFrom;
            vm.searchFilters.dtTo = vm.referencePeriod.dtTo;
            vm.searchFilters.description = null;
            vm.searchFilters.entryValueFrom = null;
            vm.searchFilters.entryValueTo = null;
            reloadEntries();
        };




        function reloadEntries() {
            $rootScope.$emit('PAYMENTS_TO_BE_RELOADED', vm.userId);
            vm.dtInstance.DataTable.draw();
        }




        function lockEntry(id) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to lockEntry....');
                    EarningCost.prototype$patchAttributes(
                        { id: id },
                        {locked: true}).$promise.then(
                        function(data){
                            $log.debug(data);
                            reloadEntries();
                        }, function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        function deleteEntry(id) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/earningcosts/dialogs/delete_earningcost_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    $log.debug('You choosed to delete....');
                    EarningCost.deleteEntry(
                        { id: id.toString() }).$promise.then(
                        function(data){
                            $log.debug(data);
                            reloadEntries();
                        }, function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }

        function askEntryDetails() {
            $scope.myResource={};
            $scope.myResource.entryDate=new Date();
            $scope.myResource.paymentOrEntry='E';
            $scope.userOrg={};
            $scope.organizationId=vm.organizationId;
            $scope.saveButtonEnabled = true;    // prevent double click
            vm.userServices=[];

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/earningcosts/dialogs/edit_earningcost_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    var entryType = parseInt(answer.entryType);
                    if ($scope.myResource.paymentOrEntry === 'N') {
                        entryType = -1; //LA NOTA DI CREDITO E' UNA USCITA
                    }
                    answer.entryValue=answer.entryValue* entryType;

                    var userId = ($scope.myResource.selectedItem && $scope.myResource.selectedItem!==null && $scope.myResource.selectedItem.type==='U') ? $scope.myResource.selectedItem.id:null;
                    var entryOrganizationId = ($scope.myResource.selectedItem && $scope.myResource.selectedItem!==null && $scope.myResource.selectedItem.type==='O') ? $scope.myResource.selectedItem.id:null;
                    var entryCompany = ($scope.myResource.selectedItem && $scope.myResource.selectedItem!==null && $scope.myResource.selectedItem.type==='O') ? $scope.myResource.selectedItem.displayName:null;

                    //caso in cui ho scritto il fornitore ma non lo hho selezionato daq tendina
                    if (!entryCompany && !$scope.myResource.selectedItem && vm.searchText && vm.searchText.trim()!=='') {
                        entryCompany=vm.searchText.trim();
                    }

                    vm.searchText = '';
                    var newEarningCost = {
                        entryDate: moment(answer.entryDate).add(2, 'hours').toDate(),
                        entryValue: answer.entryValue,
                        entryDescription: answer.entryDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason.id ? answer.paymentReason.id : null),
                        userId: userId,
                        entryOrganizationId: entryOrganizationId,
                        entryCompany: entryCompany,
                        organizationId: vm.organizationId,
                        creditNote: ($scope.myResource.paymentOrEntry === 'N')
                    };
                    Payment.createPaymentWithoutSubscription({earningCost: newEarningCost}).$promise.then(
                        function(data) {
                            $log.debug('success');
                            $log.debug(data);
                            $scope.saveButtonEnabled = true;
                            reloadEntries();
                        },
                        function(httpResponse) {
                            $log.debug('error');
                            $log.debug(httpResponse);
                            $scope.saveButtonEnabled = true;
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        }
                    );

                    // sistema pre issue #498: gli EarningCost privi di Payment non vengono visti tra i pagamenti di un utente
                    // EarningCost.create({
                    //     entryDate: moment(answer.entryDate).add(2, 'hours').toDate(),
                    //     entryValue: answer.entryValue,
                    //     entryDescription: answer.entryDescription,
                    //     paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id:null,
                    //     userId: userId,
                    //     entryOrganizationId: entryOrganizationId,
                    //     entryCompany: entryCompany,
                    //     organizationId: vm.organizationId,
                    //     creditNote: ($scope.myResource.paymentOrEntry === 'N')
                    // }).$promise.then(function(data) {
                    //     $log.debug('success');
                    //     $log.debug(data);
                    //     $scope.saveButtonEnabled = true;
                    //     reloadEntries();
                    // },function(httpResponse){
                    //     $log.debug('error');
                    //     $log.debug(httpResponse);
                    //     $scope.saveButtonEnabled = true;
                    //     AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                    // });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                    vm.searchText = '';
                    $scope.saveButtonEnabled = true;
                });
        }


        function updateTableLocale() {
            $log.debug('EarningcostsController.updateTableLocale()');
            vm.dtOptions.withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json');
            try {
                setTimeout(function() {
                    vm.dtInstance.DataTable.column(0).header().textContent=$translate.instant('EARNING_COST.DATE');
                    vm.dtInstance.DataTable.column(1).header().textContent=$translate.instant('EARNING_COST.REASON');
                    vm.dtInstance.DataTable.column(2).header().textContent=$translate.instant('EARNING_COST.COUNTER_PART');
                    vm.dtInstance.DataTable.column(3).header().textContent=$translate.instant('EARNING_COST.SERVICE');
                    vm.dtInstance.DataTable.column(4).header().textContent=$translate.instant('EARNING_COST.AMOUNT');
                    vm.dtInstance.DataTable.column(5).header().textContent=$translate.instant('EARNING_COST.DESCRIPTION');
                    $('.dataTables_wrapper').css( "width", "100%" );
                }, 300);
            } catch (e) {}
        }


        function exportExcel() {
            var url = ApiPath + '/organizations/xlsx-organization-earnincosts?organizationId='+vm.organization.id+'&tk='+LoopBackAuth.accessTokenId;
            window.open(url, '_blank');
        }

        function DialogController($scope, $mdDialog) {
            var self = this;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
            $scope.reloadReason = function() {
                var paymentType='';
                if ($scope.myResource.entryType==1) {
                    paymentType='IN';
                }
                else {
                    paymentType='EX';
                }

                var query =  {
                    filter: {
                        where : {
                            organizationId: null,
                            paymentType:paymentType,
                            internalCode: null
                        }//TODO gestire quelle specifiche della organizzazione
                    }
                };
                PaymentReason.find(query,function(paymentReasons) {
                    $scope.paymentReasons =  paymentReasons;
                });

            };
            $scope.addUserOrganization = function() {
                $scope.isAddingUserOrganization=true;
            };
            $scope.isUserOrganizationValid = function() {
                if (!$scope.userOrg || $scope.userOrg===null  || !$scope.userOrg.type || ($scope.userOrg.type!=='U' && $scope.userOrg.type!=='O') ) {
                    return false;
                }

                if (!$scope.userOrg.email || $scope.userOrg.email===null || $scope.userOrg.email==='') {
                    return false;
                }


                return true;
            };
            $scope.cancelUserOrganization = function() {
                $scope.isAddingUserOrganization=false;
            };
            $scope.addUserOrganizationOnDB = function() {
                $log.debug('$scope.addUserOrganizationOnDB()');
                return Organization.findById({
                    id : $scope.organizationId
                }).$promise.then(function(organization) {

                    organization.$prototype$findOrAddUserOrganization({
                        search_type:$scope.userOrg.type,
                        search_givenName:$scope.userOrg.givenName,
                        search_familyName:$scope.userOrg.familyName,
                        search_name:$scope.userOrg.name,
                        search_piva:$scope.userOrg.piva,
                        search_email:$scope.userOrg.email
                    })
                        .then(function(response) {
                            $scope.isAddingUserOrganization=false;
                            var val = $scope.userOrg;
                            val.id=response.result.id;
                            if ( $scope.userOrg.type==='U') {
                                val.displayName = $scope.userOrg.givenName.charAt(0).toUpperCase()
                                    + $scope.userOrg.givenName.slice(1) + " "
                                    + $scope.userOrg.familyName.charAt(0).toUpperCase()
                                    + $scope.userOrg.familyName.slice(1);
                            }
                            else {
                                val.displayName=$scope.userOrg.name;
                            }
                            $scope.myResource.selectedItem=val;
                        });
                });
            };


            /**
             * Cerca tra gli utenti dell'organizzazione corrente o tra le organizzazioni esistenti.
             * La logoca della ricerca viene lasciata al server.
             *
             * Result example: [{id: number, type: string = ['U', 'O'], email: string, displayName: string}]
             *
             * @param {string} searchText Parte del nome/cognome/email della persona o dell'organizzazione
             */
            $scope.lookupUserOrganizations = function(searchText) {
                $log.debug('$scope.lookupUserOrganizations()');
                var deferred = $q.defer();
                User.searchUsersOrOrganizations({organizationId: vm.organizationId, searchText: searchText}).$promise.then(
                    function(items) {
                        $log.debug('$scope.lookupUserOrganizations: items retrivved from User.searchUsersOrOrganizations');
                        $log.debug(items);
                        deferred.resolve(items);
                        // deferred.resolve([{id:1, type: 'O', email:'sdasdasd', displayName:'3234sadas' }]);
                    },
                    function(err) {
                        // ignore errors
                        $log.error('$scope.lookupUserOrganizations: Error calling User.searchUsersOrOrganizations()');
                        $log.error(err);
                        deferred.reject();
                    }
                );
                return deferred.promise;
            };


            // // Vecchia versione: cerca senza filtrare gli utenti per organizzazione,
            // // inoltre la logica della ricerca viene effettuata lato client.
            // // esempio risultato persone: [{"givenName":"Stefano","familyName":"Di Nicola","displayName":"Stefano Di nicola","contactEmail":"dinicola_s@yahoo.com.stage","uriAvatar":null,"uriBackground":null,"resetPwdToken":"b5540a9f-e025-11e7-a2aa-eeaf96f72178","flgMustResetPwd":true,"activationToken":"b5540ad1-e025-11e7-a2aa-eeaf96f72178","status":"active","isSearchable":false,"userDetailVisibility":null,"changeEmailAddress":null,"changeEmailToken":null,"consensoTecnico":null,"consensoMarketing":null,"consensoProfilazione":null,"createdAt":null,"updatedAt":null,"createdBy":null,"updatedBy":null,"realm":null,"username":"dinicola_s@yahoo.com.stage","email":"dinicola_s@yahoo.com.stage","emailVerified":null,"id":1028},{"givenName":"Nicola","familyName":"Spiezia","displayName":"Nicola Spiezia","contactEmail":"nicpettelone@libero.it/nicolaspiezia.ns@gmail.com.stage","uriAvatar":null,"uriBackground":null,"resetPwdToken":"b7d00a79-e025-11e7-a2aa-eeaf96f72178","flgMustResetPwd":true,"activationToken":"b7d00abe-e025-11e7-a2aa-eeaf96f72178","status":"active","isSearchable":false,"userDetailVisibility":null,"changeEmailAddress":null,"changeEmailToken":null,"consensoTecnico":null,"consensoMarketing":null,"consensoProfilazione":null,"createdAt":null,"updatedAt":null,"createdBy":null,"updatedBy":null,"realm":null,"username":"nicpettelone@libero.it.stage","email":"nicolaspiezia.ns@gmail.com.stage","emailVerified":null,"id":1132}]
            // // esempio risultato organizzazioni: [{"name":"Associazione prova Nicola Openview","description":null,"address":null,"addressNumber":null,"postalCode":null,"province":null,"city":null,"addressOperat":null,"addressNumberOperat":null,"postalCodeOperat":null,"provinceOperat":null,"cityOperat":null,"latitude":null,"longitude":null,"phone":null,"mobilePhone":null,"fax":null,"email":null,"website":null,"facebookPage":null,"IBAN":null,"PEC":null,"piva":null,"taxCode":null,"uriLogo":"200x200_1565189048789_vault-boy.png","uriBackgroundImage":"1200x600_1565189061517_IMG_0388.jpeg","notes":null,"organizationTypeId":null,"clubyourlifeId":null,"flgEnableParentChild":true,"titleColor":null,"privacyPolicy":null,"privacyLink":null,"privacyPolicyType":"NONE","flgEnableServices":true,"dtDel":null,"flgEnableStripePayments":false,"stripeAccountId":null,"stripeRequestToken":"YPE7R11v4EhwYfgeZf1FsGuR8ltsA1kfpjTipCewZ9wTrP3duPKkcIXYqehGUH9m","cylCustomerId":null,"cylSubscriptionId":null,"cylCustomPlanId":null,"cylSubscriptionStatus":null,"emailFrom":null,"emailFromName":null,"organizationUserTemplateId":null,"flgUserDynAttributes":null,"flgEnableInvoice":false,"flgEnableChat":true,"flgExtendChatToContacts":null,"invoiceHeader":null,"invoiceSection":null,"invoiceNextNumber":null,"creditNoteSection":null,"creditNoteNextNumber":null,"cylFee":0,"refPerson":null,"refPersonMail":null,"refPersonPhone":null,"lastCheckoutSessionId":null,"createdAt":null,"updatedAt":null,"createdBy":null,"updatedBy":null,"id":43}]
            // $scope.lookupUserOrganizations_old = function(txt){
            //
            //     var deferred = $q.defer();
            //
            //     txt='%' + txt+'%';
            //     var queryUsers = {
            //         filter: {
            //             where :
            //                 {or: [
            //                         {username: { like: txt } },
            //                         {displayName: { like: txt } },
            //                         {email: { like: txt }},
            //                         {givenName: { like: txt }},
            //                         {familyName: { like: txt }}
            //                     ]
            //                 }
            //         }
            //     };
            //
            //
            //     User.find(queryUsers).$promise.then (function(users) {
            //         var queryOrgs = {
            //             filter: {
            //                 where : {name: { like: txt } }
            //             }
            //         };
            //         Organization.find(queryOrgs).$promise.then(function(orgs) {
            //             var finalList = [];
            //             for (var i = 0; i < users.length; i++) {
            //                 finalList.push({id:users[i].id, type: 'U', email:users[i].email, displayName:users[i].displayName });
            //             }
            //             for (var i = 0; i < orgs.length; i++) {
            //                 finalList.push({id:orgs[i].id, type: 'O', email:orgs[i].email, displayName:orgs[i].name });
            //             }
            //             var finalOrderedList = _.sortBy(finalList, function(x){ return x.displayName; });
            //
            //             deferred.resolve(finalOrderedList);
            //
            //         });
            //     });
            //     return deferred.promise;
            //
            // }





            $scope.lookupUser= function(txt){

                var deferred = $q.defer();

                User.lookupUsers({text: txt, organizationId: vm.organizationId}).$promise.then (function(data) {
                    deferred.resolve(data.users);
                });
                return deferred.promise;
            };

            $scope.selectedUserOrganizationChange= function(item) {
                $scope.myResource.selectedItem=item;
            };
            $scope.selectedUserChange= function(item) {
                $scope.myResource.selectedUser=item;
                if ($scope.myResource.selectedUser && $scope.myResource.selectedUser.id) {
                    //carico la lista dei servizi da pagare
                    User.loadUser({
                        id: $scope.myResource.selectedUser.id,
                        organizationId: vm.organizationId
                    }).$promise.then(function(user){
                        user.$prototype$allServices().then(
                            function(response) {

                                if ( response.result.services &&  response.result.services!==null) {
                                    var theServices = response.result.services;
                                    for (var i = 0; i <  theServices.length; i++) {
                                        var dateFrom =  theServices[i].dateFrom;
                                        if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                            theServices[i].dateFrom=new Date(dateFrom);
                                        }
                                        var dateTo =  theServices[i].dateTo;
                                        if (dateTo && dateTo!==null && dateTo!=='') {
                                            theServices[i].dateTo=new Date(dateTo);
                                        }
                                    }
                                    //filtro solo quelli non pagati e della mia associazione corrente (il servizio carica quelli delle associazioni che amministro)
                                    theServices = _.filter(theServices, function(service) {
                                        return (vm.organization.id == service.organizationId && service.paymentValue < service.paymentDue);
                                    })
                                    vm.userServices = theServices;
                                } else {
                                    vm.userServices=[];
                                }
                            });
                    });
                }
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function formatRowCell(data, row) {
            return data;
        }


        function generateInvoice(earningCostId) {
            $log.debug('EarningCostsController.generateInvoice()');
            blockUI.start();
            EarningCost.generateInvoice({id: earningCostId.toString()}).$promise.then(function(data) {
                $log.debug('EarningCostsController.generateInvoice: data: ' + JSON.stringify(data));
                reloadEntries();
                blockUI.stop();
                AlertMessageService.showSuccessMessage();
            }, function(httpResponse) {
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                blockUI.stop();
            });
        }


        function findOrganization(id) {
            $log.debug('findOrganization()');
            return Organization.findById({
                id : id,
                filter : {
                }
            }).$promise;
        }

        function formatAmountCell(data, row, iVal) {
            if (iVal>0) {
                return '<span style=\"color:green; font-weight: bold; float: right;\">'+data+'</span>';
            }
            else if (iVal<0) {
                return '<span style=\"color:red; font-weight: bold;  float: right;\">'+data+'</span>';
            }
            return data;
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        /**
         * Go to organizations page
         */
        function gotoOrganizations() {
            $state.go('app.organizations',{userId: User.getCurrentId()});
        }

        function goToOrganization() {
            $state.go('app.organization',{organizationId: vm.organization.id});
        }

        function backgroundImage() {
            if (vm.organization && vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage !==null) {
                return {'background-image': 'url('+ApiPath+'/organizationDocumentsContainers/'+$rootScope.CYL_ORG_DOC_PREFIX+vm.organization.id +'/download/'+vm.organization.uriBackgroundImage+')'};
            }
            return {'background-image': 'none'};
        }

        /**
         * Effettua un pagamento di iscrizione
         * @param userId
         * @param subscriptionId
         * @param amount
         */
        function askPaymentDetails( userId, subscriptionId, amount) {
            $scope.myResource={};
            $scope.myResource.paymentDate=new Date();
            $scope.myResource.flgGenerateInvoice = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.flgSendNotification = vm.organization.flgEnableInvoice ? true : false;
            $scope.myResource.showFlgGenerateInvoice = vm.organization.flgEnableInvoice;
            $scope.myResource.showFlgSendNotification = vm.organization.flgEnableInvoice;

            if (amount) {
                $scope.myResource.paymentValue = CylUtils.roundEuro(amount);
            } else {
                $scope.myResource.paymentValue = null;
            }
            var query =  {
                filter: {
                    where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
                }
            };
            PaymentReason.find(query,function(paymentReasons) {
                $scope.paymentReasons =  paymentReasons;
                $log.debug($scope.paymentReasons);
                $scope.myResource.paymentReasons=paymentReasons[0];
            });

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    blockUI.start();

                    Payment.pay({
                        subscriptionId: subscriptionId.toString(),
                        paymentDate: answer.paymentDate,
                        amount: answer.paymentValue,
                        description: answer.paymentDescription,
                        paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id.toString():null,
                        flgGenerateReceipt: answer.flgGenerateInvoice,
                        flgSendReceipt: answer.flgSendNotification
                    }).$promise.then(function(data) {
                        $log.debug('success');
                        $log.debug(data);
                        reloadEntries();
                        //aggiungo un piccolo T.O. per la generazione della ricevuta
                        if ($scope.myResource.showFlgGenerateInvoice) {
                            setTimeout(function () {
                                reloadEntries();
                                blockUI.stop();
                            }, 3000);
                        } else {
                            blockUI.stop();
                        }

                    },function(httpResponse){
                        $log.debug('error');
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        blockUI.stop();
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


        function modificaDescrizione(earningCostId) {
            var entry = _.find(vm.earningcosts, function (e) {
               return e.id ==  earningCostId;
            });
            $scope.myResource = {entryDescription: entry.entryDescription}
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/earningcosts/dialogs/edit_description_dialog.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            })
                .then(function(answer) {
                    EarningCost.findById({
                        id : entry.id
                    }).$promise.then(function(ec) {
                        ec.entryDescription = $scope.myResource.entryDescription;
                        EarningCost.prototype$patchAttributes(
                        { id: entry.id },
                        ec).$promise.then(function (res) {
                            vm.reloadEntries();
                        }, function(httpResponse){
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                    });

                }, function() {
                    $log.debug('You cancelled the dialog.');
                });
        }


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.docs_validation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.docs_validation', {
            url      : '/docs_validation/:serviceId/:subscriptionId',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/docs_validation/docs_validation.html',
                    controller : 'DocsValidationController as vm'
                }
            },
            bodyClass: 'subscriptions'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/docs_validation');

    }

})();

(function ()
{
    'use strict';

    /**
     * NOTA: questa pagina è deprecata, si è confluito solo sulla users/user_documents
     */
    angular
        .module('app.pages.docs_validation')
        .controller('DocsValidationController', DocsValidationController);

    /** @ngInject */
    function DocsValidationController($rootScope, $scope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $mdDialog, Payment, $state, LoopBackAuth, ApiPath,
                                      $translate, AuthenticationService,  User, Organization, OfferedService, ServiceDoctype, SubscriptionDocument, AlertMessageService, _, PaymentReason, Subscription, UserDocument )
    {
        var vm = this;
        vm.validateSubscriptionDocument=validateSubscriptionDocument;

        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.apiPath = ApiPath;
        vm.serviceName = '';
        vm.userDisplayName = '';
        vm.userId = null;
        vm.upload = upload;
        vm.fileAdded = fileAdded;
        vm.fileSuccess = fileSuccess;
        vm.subscription = null;

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            chunkSize: 15 * 1024 * 1024,
            maxChunkRetries: 1,
            simultaneousUploads: 1,
            testChunks: false,
            progressCallbacksInterval: 1000,
            allowDuplicateUploads: true,
            headers : {authorization :  LoopBackAuth.accessTokenId},
            query: {}
        };

        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
        };

        init();

        function init()
        {

            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();

                //carico utente e corso
                // modifica ndr: salvo i dati in vm.subscription per solo salvarmi i parametri necessari alla
                // Subscription.getNormalizedSubscriptions che userò poco dopo
                Subscription.findById({id: $state.params.subscriptionId, filter: {
                        include: ['offeredService', 'user']
                    }
                }).$promise.then(
                    function(data) {
                        $log.debug(data);
                        vm.subscription = JSON.parse(JSON.stringify(data));
                        vm.serviceName=data.offeredService.name;
                        vm.userDisplayName=data.user.displayName;
                        vm.userId=data.user.id;
                        vm.ngFlowOptions.target = ApiPath + "/userDocumentsContainers/"+$rootScope.CYL_USER_DOC_PREFIX+data.user.id+"/upload";
                        loadUserDocuments();
                    }, function (err) {
                        $log.debug(err);
                    }
                );
            } else {
                $state.go('app.pages_auth_login');
            }
        }

        //TODO USERRLOAD ELIMINARE
        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }


        function fileAdded(file, idDoctype) {
            $mdDialog.hide();
            $log.debug(file);

            // Prepare the temp file data for media list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };
            vm.contentToUpload = uploadingFile;
            upload(idDoctype);
        }

        function upload( idDoctype) {
            vm.contentToUpload.type = 'uploading';
            vm.ngFlowOptions.query.cyl_type='FILE';
            vm.ngFlowOptions.query.authorization = LoopBackAuth.accessTokenId;
            vm.ngFlow[''+idDoctype].upload();
        }

        function fileSuccess(file, message,  idDoctype) {
            $log.debug('fileSuccess');

            //PER FS recupero file FIXME
            var uri = JSON.parse(message).result.files.file[0].name;

            //scrivo nella UserDocument
            UserDocument.create(
                {userId: vm.userId, name: file.name, uri: uri, flgActive: 1},
                function(doc,responseHeaders){
                    $log.debug('UserDocument create() riuscita: ');
                    $log.debug(doc);


                    vm.serviceDocuments[idDoctype] = {};
                    vm.serviceDocuments[idDoctype].isPaperDoc = false;
                    vm.serviceDocuments[idDoctype].uri = uri;
                    vm.serviceDocuments[idDoctype].userDocumentId = doc.id;

                    var subscriptionDocuments = [];
                    for (var i = 0; i <  vm.doctypes.length; i++) {
                        var serviceDocument = vm.serviceDocuments[vm.doctypes[i].organizationDoctype.id];
                        if (!serviceDocument || serviceDocument.isPaperDoc) {
                            continue;
                        }

                        var subscriptionDocument = {};
                        subscriptionDocument.subscriptionId=$state.params.subscriptionId;
                        subscriptionDocument.organizationDoctypeId=vm.doctypes[i].organizationDoctype.id;
                        subscriptionDocument.userDocumentId=serviceDocument.userDocumentId;
                        subscriptionDocument.uri=serviceDocument.uri;
                        subscriptionDocument.flgValidated=serviceDocument.flgValidated;
                        subscriptionDocument.validTo=serviceDocument.validTo;
                        subscriptionDocuments.push(subscriptionDocument);
                    }

                    Subscription.findById({
                        id: $state.params.subscriptionId
                    }).$promise.then(function(mySub) {
                        mySub.$prototype$updateSubscriptionDocuments({subscriptionDocuments: subscriptionDocuments})
                            .then(function(data){
                                $log.debug('success');
                                $log.debug(data);
                                loadUserDocuments();
                                AlertMessageService.showSuccessMessage();
                            },function(httpResponse){
                                $log.debug('error');
                                $log.debug(httpResponse);
                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                            });
                    });
                },
                function(httpResponse){
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
        }


        /**
         * Carica l'elenco e lo status dei documenti per la subscription esaminata.
         * Questa versione prende i dati dalla funzione standardizzata che fornisce i dati al widget dell'homepage
         */
        function loadUserDocumentsV2() {
            $log.debug('loadUserDocumentsV2()');
            $log.debug(JSON.stringify(vm.subscription));
            // ndr: leggo el subscription pi organizzazione utente, poi estraggo olo quella che sto esaminando
            Subscription.getNormalizedSubscriptions(
                {
                    organizationId: vm.subscription.offeredService.organizationId.toString(),
                    userId: vm.subscription.userId.toString(),
                    dateFrom: null,
                    dateTo: null
                }, {}).$promise.then(
                    function(subscriptions) {
                        $log.debug('normalized subscriptions: ' + JSON.stringify(subscriptions));
                        // filtra con la subscription cercata e sostituisce quella letta in precedenza
                        vm.subscription = _.find(subscriptions.subscriptions, function(subscription) {
                            return subscription.id === vm.subscription.id;
                        });
                        $log.debug('normalized subscription: ' + JSON.stringify(vm.subscription));

                        // estraggo i requiredDocuments
                        vm.doctypes = vm.subscription.offeredService.requiredDocuments;

                        // riempio le variabili dei documenti
                        if (vm.subscription.documents && vm.subscription.documents.length > 0) {
                            for (var i = 0; i < vm.subscription.documents.length; i++) {
                                var validFrom = vm.subscription.documents[i].validFrom;
                                if (validFrom && validFrom!==null && validFrom!=='') {
                                    vm.subscription.documents[i].validFrom=new Date(validFrom);
                                }
                                var validTo = vm.subscription.documents[i].validTo;
                                if (validTo && validTo!==null && validTo!=='') {
                                    vm.subscription.documents[i].validTo=new Date(validTo);
                                }
                                vm.serviceDocuments[vm.subscription.documents[i].organizationDoctype.id] = vm.subscription.documents[i];
                            }
                        }
                    },
                    function(err) {
                        $log.error('Errore caricando i documenti');
                        $log.error(err);
                    }
                );
        }



        function loadUserDocuments() {
            //prende la lista di subscription docs completa di doctype -> organizationdoctype
            vm.doctypes={};
            vm.minDateForValidation=new Date();
            vm.serviceDocuments={};
            //carica documenti necessari per il servizio
            var query ={
                filter: {
                    where : {offeredServiceId:  $state.params.serviceId},
                    include : ['organizationDoctype' ]
                }
            };
            ServiceDoctype.find(query, function(docs) {
                vm.doctypes=docs;
                //carico eventuale documentazione già salvata
                var querySubDocs ={
                    filter: {
                        where : {subscriptionId: $state.params.subscriptionId},
                        include : ['userDocument','organizationDoctype' ]
                    }
                };
                SubscriptionDocument.find(querySubDocs, function(subDocs) {
                    if (subDocs && subDocs!==null) {
                        for (var i = 0; i < subDocs.length; i++) {
                            var validFrom = subDocs[i].validFrom;
                            if (validFrom && validFrom!==null && validFrom!=='') {
                                subDocs[i].validFrom=new Date(validFrom);
                            }
                            var validTo = subDocs[i].validTo;
                            if (validTo && validTo!==null && validTo!=='') {
                                subDocs[i].validTo=new Date(validTo);
                            }
                            vm.serviceDocuments[subDocs[i].organizationDoctype.id]= subDocs[i];
                        }
                    }
                });
            });
        }


        //Controller comune alle varie dialogs
        function DialogController($scope, $mdDialog) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];


        function gotoUserProfile(userId) {
            $state.go('app.pages_profile',{ userId: userId });
        }

        function gotoOfferedService(offeredServiceId) {
            $state.go('app.offered_service', {
                offeredServiceId : offeredServiceId,
                organizationId : vm.selectedOrganization.id
            });
        }

        function gotoUserPayments(userId) {
            $state.go('app.pages_profile_tabbed',{ userId: userId, tab: 'PAY' });
        }


        function askPaymentDetails(ev, userId, subscriber) {
            // $scope.myResource={};
            // $scope.myResource.paymentDate=new Date();
            // var query =  {
            //     filter: {
            //         where : {organizationId: null, paymentType:'IN', internalCode:'SERVICE'}//TODO gestire quelle specifiche della organizzazione
            //     }
            // };
            // PaymentReason.find(query,function(paymentReasons) {
            //     $scope.paymentReasons =  paymentReasons;
            //     $scope.myResource.paymentReasons=paymentReasons[0];
            // });
            //
            // loadUserServices(userId);
            //
            // $mdDialog.show({
            //     controller: DialogController,
            //     templateUrl: 'app/main/pages/payments/dialogs/edit_payment_dialog.html',
            //     parent: angular.element(document.body),
            //     targetEvent: ev,
            //     scope: $scope,
            //     preserveScope: true,
            //     clickOutsideToClose:true
            // })
            //     .then(function(answer) {
            //         Payment.create({
            //             paymentDate: answer.paymentDate,
            //             paymentValue: answer.paymentValue,
            //             paymentDescription: answer.paymentDescription,
            //             subscriptionId: subscriber.subscriptionId,
            //             offeredServiceId: subscriber.serviceId,
            //             organizationId: vm.selectedOrganization.id,
            //             paymentReasonId: (answer.paymentReason && answer.paymentReason!==null)? answer.paymentReason.id:null,
            //             userId: userId
            //         }).$promise.then(function(data) {
            //             $log.debug('success');
            //             $log.debug(data);
            //             doSubscribersSearch();
            //         },function(httpResponse){
            //             $log.debug('error');
            //             $log.debug(httpResponse);
            //             AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            //         });
            //
            //     }, function() {
            //         $log.debug('You cancelled the dialog.');
            //     });
        }


        /**
         * Funzione che effettua la validazione o il respingimento del doc per questa singola iscrizione
         * @param subscriptionDocument
         */
        var doValidationForThisSubscription = function(subscriptionDocument) {
            //cerco eventuale ID
            SubscriptionDocument.find({
                filter: {
                    where: {
                        subscriptionId: subscriptionDocument.subscriptionId,
                        organizationDoctypeId: subscriptionDocument.organizationDoctypeId
                    }
                }
            }).$promise.then(function(data) {
                if (data && data.length > 0 && data[0].id) {
                    subscriptionDocument.id = data[0].id;

                    //lo sto validando o rigettando. Se valido allora resetto i flag per le notifiche
                    if (subscriptionDocument.isValid > 0) {
                        subscriptionDocument.expiringNotificationDate = null;
                        subscriptionDocument.expiredNotificationDate = null;
                    }

                    SubscriptionDocument.updateAll(
                        {
                            where: {id: subscriptionDocument.id}
                        },
                        subscriptionDocument, function(org, responseHeaders) {
                            $log.debug('validateSubscriptionDocument() riuscita: ');
                            $log.debug(org);
                            AlertMessageService.showSuccessMessage();
                            if (subscriptionDocument.flgValidated) {
                                //domando se voglio spalmare il doc in tutte le richieste valide ad oggi
                                $mdDialog.show({
                                    controller: DialogController,
                                    templateUrl: 'app/main/pages/docs_validation/dialogs/validate_doc_in_all_subscription_confirm_dialog.html',
                                    parent: angular.element(document.body),
                                    scope: $scope,
                                    preserveScope: true,
                                    clickOutsideToClose:true
                                }).then(function(answer) {
                                    SubscriptionDocument.validateDocInAllSubscriptions({subscriptionDocumentId: subscriptionDocument.id.toString()}).$promise.then(function(data) {
                                        AlertMessageService.showSuccessMessage();
                                    }, function(httpResponse) {
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                    });
                                }, function() {
                                    $log.debug('You cancelled the dialog.');
                                });
                            }

                        },
                        function(httpResponse) {
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                } else {
                    SubscriptionDocument.create(
                        subscriptionDocument, function(sd, responseHeaders) {
                            $log.debug('validateSubscriptionDocument() riuscita: ');
                            $log.debug(sd);
                            subscriptionDocument.id = sd.id;
                            AlertMessageService.showSuccessMessage();
                            if (subscriptionDocument.flgValidated) {
                                //domando se voglio spalmare il doc in tutte le richieste valide ad oggi
                                $mdDialog.show({
                                    controller: DialogController,
                                    templateUrl: 'app/main/pages/docs_validation/dialogs/validate_doc_in_all_subscription_confirm_dialog.html',
                                    parent: angular.element(document.body),
                                    scope: $scope,
                                    preserveScope: true,
                                    clickOutsideToClose:true
                                }).then(function(answer) {
                                    SubscriptionDocument.validateDocInAllSubscriptions({subscriptionDocumentId: subscriptionDocument.id.toString()}).$promise.then(function(data) {
                                        AlertMessageService.showSuccessMessage();
                                    }, function(httpResponse) {
                                        $log.debug(httpResponse);
                                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                    });
                                }, function() {
                                    $log.debug('You cancelled the dialog.');
                                });
                            }
                        },
                        function(httpResponse) {
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }

            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });
        };

        function validateSubscriptionDocument(ev, subscriptionDocument, isValid, organizationDoctypeId) {

            subscriptionDocument.flgValidated=isValid;
            subscriptionDocument.subscriptionId=$state.params.subscriptionId;
            subscriptionDocument.organizationDoctypeId=organizationDoctypeId;

            doValidationForThisSubscription(subscriptionDocument);

        }


        function loadUserServices(myUserId) {
            User.findById({
                id: myUserId
            }).$promise.then(function(user){
                user.$prototype$allServices().then(
                    function(response) {

                        if ( response.result.services &&  response.result.services!==null) {

                            //potrei avere i corsi che faccio io piu quelli dei miei parenti: quindi filtro per i miei
                            var services = _.filter( response.result.services,function (s) {return s.userId==myUserId;});

                            for (var i = 0; i <  services.length; i++) {
                                var dateFrom =  services[i].dateFrom;
                                if (dateFrom && dateFrom!==null && dateFrom!=='') {
                                    services[i].dateFrom=new Date(dateFrom);
                                }
                                var dateTo =  services[i].dateTo;
                                if (dateTo && dateTo!==null && dateTo!=='') {
                                    services[i].dateTo=new Date(dateTo);
                                }
                            }
                        }

                        $scope.userServices = services;
                    });
            });
        }


        /**
         * Torna alla pagina precedente
         */
        vm.goBack = function() {
            $log.debug('vm.goBack()');
            window.history.back();
        };

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.dispatcher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dispatcher', {
            url      : '/dispatcher',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/dispatcher/dispatcher.html',
                    controller : 'DispatcherController as vm'
                }
            }
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.dispatcher')
        .controller('DispatcherController', DispatcherController);

    /** @ngInject */
    function DispatcherController($state, $location, $log, AuthenticationService, User, Organization,
                                  UserOrganizationRole, _, UserPreference)
    {
        $log.debug('DispatcherController()');
    	var vm = this;
    	var self = this;
        var clubyourlifeId = sessionStorage.getItem('clubyourlifeId');

    	if (AuthenticationService.isAuthenticated() && User.getCurrentId() && User.getCurrentId()!==null){
            $log.debug("USER SEEMS AUTHENTICATED");
    		AuthenticationService.getLoggedUserDataFromServer(User.getCurrentId()).then(
                    function(data){
                    	if (!data || data===null) {
                            goToLogin();
                    	}
                    	else if (data.flgMustResetPwd) {
                    		$state.go("app.pages_auth_change_pwd");
                    	}
                    	else {
                            if (data && data.id) {
                                var userId = data.id;
                                $log.debug('userId: ' + data.id);
                                loadUser(data.id).then(function(user) {
                                    // proseguo solo se ho il consenso tecnico
                                    if (user && user.consensoTecnico) {
                                        loadOrganizations(user).then(
                                            function(data) {
                                                vm.organizations = _.filter(data.result.organizations, function(o) { return o.isAdmin; });
                                                // $log.debug('user: ' + userId);
                                                // $log.debug('vm.organizations: ' + JSON.stringify(vm.organizations));
                                                // zoho CYL-I19: controlla se chiedere con quale modalità avviare l'applicazione la prossima
                                                // volta (utente o gestore di associazione)
                                                self.getUserPreference(userId, 'LOGIN_DESTINATION', function(err, destination) {
                                                    if (!err) {
                                                        $log.debug('destination: ' + destination);
                                                        if (destination && destination.length > 0) {
                                                            // redirige alla pagina indicata
                                                            if (destination === 'manageorganization') {
                                                                if (vm.organizations && vm.organizations.length === 1) {
                                                                    // $log.debug('vado a gestione organizzazione singola: ' + vm.organizations[0].id);
                                                                    $state.go("app.organization", {organizationId: vm.organizations[0].id});
                                                                } else {
                                                                    // $log.debug('vado a gestione organizzazioni');
                                                                    $state.go('app.organizations');
                                                                }
                                                            } else if (destination === 'user') {
                                                                // $log.debug('vado a profilo socio');
                                                                $state.go('app.pages_profile_socio', { userId: userId });
                                                            } else {
                                                                // non dovrei arrivare qui. Nel dubbio vado a profilo utente
                                                                // $log.debug('non dovrei arrivare qui');
                                                                $state.go('app.pages_profile_socio', { userId: userId });
                                                            }
                                                        } else {
                                                            // se non ho ancora impostato la destinazione dopo login
                                                            // se ho organizzazioni, imposto la login_destination come gestore organizzazioni
                                                            if (vm.organizations && vm.organizations.length > 0) {
                                                                $log.debug('Salvo la preferenza per andare alle organizzazioni');
                                                                UserPreference.save({
                                                                    userId: userId,
                                                                    code: 'LOGIN_DESTINATION',
                                                                    value: 'manageorganization'
                                                                }, function(newPreference) {
                                                                    // $log.debug('salvataggio ok; non posso andare al dispatcher perchè ci sono gia, vado in gest organizzazioni');
                                                                    $state.go('app.organizations');
                                                                }, function(err) {
                                                                    // $log.debug('vado alla gestione organizzazioni dopo errore');
                                                                    $state.go('app.organizations');
                                                                })
                                                            } else {
                                                                // altrimenti chiedo all'utente (perchè potrebbe essere nuovo e non so come vuole usare CYL)
                                                                // $log.debug('Chiedo la login_destinatio perchè non so cosa fare');
                                                                $state.go('app.pages_user_logindestination');
                                                            }
                                                        }
                                                    } else {
                                                        // ignora errori
                                                        $log.warn('errore in DispatcherController.getUserProperty()');
                                                        $log.warn(err);
                                                    }
                                                });
                                                // if (vm.organizations && vm.organizations.length==1) {
                                                //     $state.go("app.organization", {organizationId: vm.organizations[0].id});
                                                // }
                                                // else if (vm.organizations && vm.organizations.length>1) {
                                                //     $state.go("app.organizations");
                                                // }
                                                // else {
                                                //     $state.go("app.pages_profile_socio", { userId: user.id });
                                                // }
                                            },
                                            function(err) {
                                                $log.warn('Errore in loading organizations, vado al profilo socio');
                                                $state.go("app.pages_profile_socio", { userId: userId });
                                            }
                                        );
                                    } else {
                                        // se non ho il consenso tecnico, vado alla pagina per richiederlo
                                        $state.go('app.legal_gdpr_settings');
                                    }
                                });
                            }
                            // se l'utente non ha nemmeno l'ID, lo mando alle organizzazioni
                            else {
                                // non dovrebbe mai finire qui
                                $log.warn('Non dovrei mai finire qui, vado a gestione organizzazioni');
                                $state.go("app.organizations");
                            }
                    	}
                    },
                    function(error){
                        goToLogin();
                    }
                );
    	}
    	else {
    	    goToLogin();
    	}


    	/**
    	 * carica tutte le organizzazioni dell'utente
    	 */
        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        /**
         * carica dettaglio dell'utente
         */
        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }




        function goToLogin(){
            if (clubyourlifeId && clubyourlifeId!==''  && clubyourlifeId!=='null'  && clubyourlifeId!=='undefined') {
                window.location.href="/pages/auth/"+clubyourlifeId+"/login";
            } else {
                window.location.href="/pages/auth/login";
            }
        }

        /**
         * Ritorna tutte le organizazioni di un utente
         */
        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }


        /**
         * Ritorna lo stato di una preferenza dell'utente
         *
         * @param {number} userId Utente del quale leggere la preferenza
         * @param {string} propertyName Nome della preferenza da leggere
         * @param {function(err, data)} callback Funzione con il risultato
         */
        self.getUserPreference = function(userId, propertyName, callback) {
            // $log.debug('self.getUserPreference()');
            UserPreference.find(
                {
                    filter: {
                        where: {
                            and: [
                                { userId: userId },
                                { code: propertyName }
                            ]
                        }
                    }
                },
                function(data) {
                    // $log.debug(JSON.stringify(data));
                    if (data && data.length > 0 && data[0].value) {
                        callback(null, data[0].value);
                    } else {
                        callback(null, []);
                    }
                },
                function(err) {
                    callback(err, null);
                });
        };


    }
})();













'use strict';

(function ()
{

    angular
        .module('app.pages.attendances')
        .controller('AttendancesController', AttendancesController);

    /** @ngInject */
    function AttendancesController($rootScope, $scope, $compile, DTOptionsBuilder, DTColumnBuilder, $log, $mdDialog, $state, LoopBackAuth, ApiPath, Attendance, DTColumnDefBuilder,
                                   $q, breadcrumbManager, $translate, AuthenticationService, User, Organization, $location,
                                   OfferedService, ServiceDoctype, SubscriptionDocument, AlertMessageService, _,
                                   appDataService)
    {
        var vm = this;

        vm.dtOptionAttendances = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withLanguageSource('assets/datatable-lang/'+$translate.use()+'.json')
            .withDisplayLength(100)
            .withOption('responsive',true)
            .withOption('autoWidth', false)
            .withOption('order', [])
            //.withOption('sAjaxSource', ApiPath+'/offeredServices/{id}/all-subscribers');
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
        ];

        vm.searchFiler= {};

        vm.loadOrganizationData=loadOrganizationData;
        vm.doAttendancesSearch=doAttendancesSearch;
        vm.gotoUserProfile=gotoUserProfile;
        vm.gotoOfferedService=gotoOfferedService;
        vm.accessToken=LoopBackAuth.accessTokenId;
        vm.apiPath = ApiPath;
        vm.onChangeEnabled=false;
        vm.goToAttendanceDetail = goToAttendanceDetail;
        vm.formatDateFromDay = formatDateFromDay;
        vm.loading = true;
        //flag che mi dice se son o nella pagien delle presenze mostrata a schermo intero (non in tab nella lista dei servizi della associazione)
        vm.isAttendanceStandalonePage = $location.path().startsWith('/attendances');

        $rootScope.$on('REF_PERIOD_CHANGED', function (event, value) {
            setTimeout(function() {
                doAttendancesSearch();
            },200);
        });

        init();


        function init()
        {

            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();

                var isFromPre = ($state.current.name ===  'app.pages_attendances_pre' );
                if ($rootScope.attendancesFilter && !isFromPre) {
                    vm.searchFiler=$rootScope.attendancesFilter;
                }

                loadUser( vm.currentUserId ).then(function(user){
                    loadOrganizations(user);
                });
                $rootScope.subscriptionsInited=true;
            } else {
                $state.go('app.pages_auth_login');
            }

        }


        function goToAttendanceDetail(day) {
            if (!day) {
                day = moment().format('YYYYMMDD');
            }
            $state.go('app.pages_attendance_detail', {offeredServiceId: vm.searchFiler.service.id, day: day});
        }

        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations().then(
                function(data){
                    var administeredOrganizations = _.filter( data.result.organizations, function(o){ return o.isAdmin===true || o.isStaff===true; });
                    vm.organizations =administeredOrganizations;
                    if (vm.organizations && vm.organizations.length>0) {
                        var myOrganization=null;
                        //prendo eventuale organizazzione passata in ingresso oppure la prima se questa non c'è
                        if ($state.params.organizationId && $state.params.organizationId!==null) {
                            var tmp = _.filter(vm.organizations, function (o) {
                                return o.id.toString() == $state.params.organizationId;
                            });
                            myOrganization=tmp[0];
                        }
                        else {
                            myOrganization = vm.organizations[0];
                            if ($rootScope.attendancesOrganization) {
                                myOrganization= $rootScope.attendancesOrganization;
                            }
                        }
                        vm.selectedOrganization=myOrganization;

                        vm.loadOrganizationData(myOrganization);
                    }
                });
        }

        function loadOrganizationData(){
            breadcrumbManager.pushOrganization(vm.selectedOrganization);
            loadOrganizationServices(vm.selectedOrganization);
        }



        function loadOrganizationServices(org){
            OfferedService.find( {filter: {
                    where : {organizationId: org.id, standalone:'S', dtDel: null},
                    include: ['serviceTypes', 'children']
                }
            }, function(services, responseHeaders) {

                var found=null;

                //purgo i servizi che sono quote associative xk x quelli non mi interessano le presenze
                services = _.filter(services, function(s) {
                    var found = _.find(s.serviceTypes, function(st) {return st.internalCode === 'SUBSCRIPTION'; });
                    return !found;
                });

                //tolgo i carnet comprensivi di N servizi xk non segno le presenze su quelli ma sui servizi figli
                services = _.filter(services, function(s) {
                    return !(s.scheduleType === 'A' && s.children && s.children.length > 0);
                });

                //tolgo i servizi con enableAttendances FALSE che non siano carnet (issue #226)
                services = _.filter(services, function(s) {
                    return !(s.scheduleType !== 'A' && !s.enableAttendances);
                });

                if (vm.searchFiler.service) {
                    found = _.find(services, function (s) {return s.id == vm.searchFiler.service.id; });
                }
                if (!found) {
                    delete vm.searchFiler.service;
                }

                if (!vm.searchFiler.service && services.length > 0) {
                    vm.searchFiler.service = services[0];
                }


                vm.organizationServices=services;
                doAttendancesSearch();
            }, function(httpResponse) {
                $log.debug(httpResponse);
                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
            });

        }


        function doAttendancesSearch(){
            if (vm.requestInProgress) return;

            vm.requestInProgress=true;
            vm.loading = true;

            breadcrumbManager.loadReferencePeriodForOrganization(function(refPeriod) {
                var dateFrom = null, dateTo = null;
                if (refPeriod) {
                    dateFrom = refPeriod.dateFrom ? moment(refPeriod.dateFrom).format('YYYYMMDD') : null;
                    dateTo = refPeriod.dateTo ? moment(refPeriod.dateTo).format('YYYYMMDD') : null;
                }

                $log.debug('doAttendancesSearch()');
                Organization.findById({
                    id: vm.selectedOrganization.id,
                }).$promise.then(
                    function(data, headers) {

                        if (vm.searchFiler.service && vm.searchFiler.service.id !== null) {
                            vm.searchFiler.serviceId = vm.searchFiler.service.id;
                            // condivide l'elemento selezionato
                            if (appDataService.current) {
                                appDataService.current.selectedServiceId = vm.searchFiler.serviceId;
                            }
                        }
                        else {
                            delete vm.searchFiler.serviceId;
                        }

                        $rootScope.attendancesFilter = vm.searchFiler;
                        $rootScope.attendancesOrganization = vm.selectedOrganization;

                        vm.searchFiler.dateFrom = dateFrom;
                        vm.searchFiler.dateTo = dateTo;

                        Attendance.allAttendances(vm.searchFiler).$promise.then(
                            function(response) {
                                vm.serviceAttendances = response.attendances;
                                $log.debug(vm.serviceAttendances);
                                vm.requestInProgress = false;
                                vm.loading = false;
                            }, function(error) {
                                $log.debug(error);
                                vm.requestInProgress = false;
                                vm.loading = false;
                            });
                    },
                    function(error) {
                        $log.debug(error);
                        vm.requestInProgress = false;
                        vm.loading = false;
                    });
            });
        }



        //Controller comune alle varie dialogs
        function DialogController($scope, $mdDialog) {
            $scope.apiPath = ApiPath;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }
        DialogController.inject = ['$scope', '$mdDialog'];

        function gotoUserProfile(userId) {
            $state.go('app.pages_profile',{ userId: userId });
        }

        function gotoOfferedService(offeredService) {
            var theService = {id: offeredService.serviceId, name: offeredService.name};
            breadcrumbManager.pushOrganizationAndService(vm.selectedOrganization, theService);
            $state.go('app.offered_service', {
                offeredServiceId : theService.id,
                organizationId : vm.selectedOrganization.id
            });
        }

        function formatDateFromDay(day) {
            return moment(day, 'YYYYMMDD').format('DD/MM/YYYY');
        }


        /**
         * Ritorna TRUE se un utente fa parte dello staff
         */
        vm.isStaffOrAdmin = function() {
            return (vm.selectedOrganization && (vm.selectedOrganization.isStaff || vm.selectedOrganization.isAdmin));
        };


        function goToAttendanceDetail(day) {
            if (!day) {
                day = moment().format('YYYYMMDD');
            }
            $state.go('app.pages_attendance_detail', {offeredServiceId: vm.searchFiler.service.id, day: day});
        }


    }

})();

'use strict';

(function ()
{
    angular
        .module('app.pages.attendances')
        .controller('AttendanceDetailController', AttendanceDetailController);

    /** @ngInject */
    function AttendanceDetailController($rootScope, $q, $scope,  $mdDialog, $compile, DTOptionsBuilder, OfferedService, DTColumnBuilder, $log, ApiPath, Attendance, AttendanceNote, blockUI, UserOrganizationRole,
                                        $translate, AuthenticationService,  User, Organization, $location,  $state, PaymentReason, AlertMessageService, EarningCost, _)
    {
        var vm = this;
        vm.offeredService = {};
        vm.currentDate = new Date();
        vm.attendances = [];
        vm.attendancesUsers = {};
        vm.loadAttendances = loadAttendances;
        vm.saveAttendanceNote = saveAttendanceNote;
        vm.doSelectAll = doSelectAll;
        vm.saveAll = saveAll;
        vm.goBack = goBack;
        vm.today = new Date();
        vm.attendanceNote = null;
        vm.selectAll = false;
        vm.isAdmin = false;
        vm.isStaff = false;

        init();

        function init() {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId().toString();
                if ($state.params.day) {
                    try {
                        vm.currentDate = moment($state.params.day, 'YYYYMMDD').toDate();
                    } catch (err) {
                        $log.debug(err);
                    }
                }
                loadOfferedService();
                //
                $('.md-datepicker-input').css('color', 'white');
            } else {
                $state.go('app.pages_auth_login');
            }
        }

        function goBack() {
            if (!vm.isAdmin && vm.isStaff) {
                $state.go('app.pages_attendances_pre', {organizationId: vm.offeredService.organizationId});
            } /*else if ($state.current.name === 'app.pages_attendance_detail') {
                $state.go('app.pages_service_attendances');
            }*/ else {
                window.history.back();
            }
        }

        function loadOfferedService(id){
            OfferedService.findById({
                id: $state.params.offeredServiceId,
                filter: {
                    include: ['organization', 'parents']
                }
            }).$promise.then(
                function(data, headers){
                    vm.offeredService = JSON.parse(JSON.stringify(data));

                    //carico i ruoli dell'utente per vedere se è amministratore o solo staff
                    UserOrganizationRole.find({
                        filter: {
                            where: {
                                userId: User.getCurrentId(),
                                organizationId:  vm.offeredService.organizationId
                            },
                            include: ['roleType']
                        }
                    }, function(userOrgRoles) {
                        _.each(userOrgRoles, function (userOrgRole) {
                            if (userOrgRole.roleType) {
                                if (userOrgRole.roleType.internalCode === 'ADMIN') {
                                    vm.isAdmin = true;
                                } else if (userOrgRole.roleType.internalCode === 'STAFF') {
                                    vm.isStaff = true;
                                }
                            }
                        });
                    });

                    // API specifica per presenze
                    Organization.attendanceSubscribersList({offeredServiceId: vm.offeredService.id}).$promise.then(
                        function(subscribers) {
                            subscribers = JSON.parse(JSON.stringify(subscribers));
                            $log.debug('subscribers: ' + JSON.stringify(subscribers));
                            // rende compatibile l'API nuova con i dati della vecchia
                            vm.offeredService.subscribers = _.map(subscribers, function(subscriber) {
                                subscriber.id = subscriber.userId;
                                return subscriber;
                            });
                            vm.offeredService.subscribers = _.sortBy(vm.offeredService.subscribers, function(s){
                                return s.familyName.toUpperCase() + ' ' +  s.givenName.toUpperCase();
                            });
                            loadAttendances();
                        }
                    );

                    // vecchia API deprecata
                    // data.$prototype$allSubscribers({payments: 'A', documents: '', hasCard: ''}).then(
                    //     function(response) {
                    //         vm.offeredService.subscribersOld = response.result.users;
                    //         vm.offeredService.subscribersOld = _.sortBy( vm.offeredService.subscribersOld, function(s){ return s.familyName.toUpperCase() + ' ' +  s.givenName.toUpperCase(); });
                    //         $log.debug('vm.offeredService.subscribersOld: ' + JSON.stringify(vm.offeredService.subscribersOld));
                    //         // loadAttendances();
                    //     }, function(err) {
                    //         $log.debug(err);
                    //     });
                },
                function(error){
                    $log.debug(error);
                });
        }

        function loadAttendances(){
            vm.attendancesUsers = {};
            Attendance.find({
                filter: {
                    where: {
                        offeredServiceId: $state.params.offeredServiceId,
                        day: moment(vm.currentDate).format('YYYYMMDD')
                    }
                }
            }).$promise.then(
                function(data, headers){
                    vm.attendances = data;
                    _.each(vm.attendances, function(attendance) {
                        if (attendance.present) {
                            vm.attendancesUsers[attendance.userId] = true;
                        }
                    });
                },
                function(error){
                    $log.debug(error);
                });

            AttendanceNote.find({
                filter: {
                    where: {
                        offeredServiceId: $state.params.offeredServiceId,
                        day: moment(vm.currentDate).format('YYYYMMDD')
                    }
                }
            }).$promise.then(
                function(data, headers){
                    if (data && data.length) {
                        vm.attendanceNote = data[0].note;
                    } else {
                        vm.attendanceNote = null;
                    }
                },
                function(error){
                    $log.debug(error);
                });
        }

        function doSelectAll() {
            for (var i = 0; i < vm.offeredService.subscribers.length; i++) {
                vm.attendancesUsers[vm.offeredService.subscribers[i].id] = vm.selectAll;
            }
        }

        function saveAll() {

            blockUI.start();
            var promisesToCall = [];
            var userIds = _.keys(vm.attendancesUsers);
            Attendance.find({
                filter: {
                    where: {
                        userId: {inq: userIds},
                        offeredServiceId: $state.params.offeredServiceId,
                        day: moment(vm.currentDate).format('YYYYMMDD')
                    }
                }
            }).$promise.then(
                function(data, headers){
                    for (var i = 0; i < userIds.length; i++) {
                        var found = _.find(data, function(a) { return a.userId == userIds[i];});
                        if (found) {
                            promisesToCall.push(Attendance.update({
                                where: {
                                    id: found.id
                                }
                            },{
                                userId : userIds[i],
                                day: moment(vm.currentDate).format('YYYYMMDD'),
                                offeredServiceId: vm.offeredService.id,
                                organizationId: vm.offeredService.organizationId,
                                present:  vm.attendancesUsers[userIds[i]]
                            }).$promise);
                        } else {
                            promisesToCall.push(Attendance.create({
                                userId : userIds[i],
                                day: moment(vm.currentDate).format('YYYYMMDD'),
                                offeredServiceId: vm.offeredService.id,
                                organizationId: vm.offeredService.organizationId,
                                present:  vm.attendancesUsers[userIds[i]]
                            }).$promise);
                        }
                    }

                    $q.all(promisesToCall)
                        .then(function(results){
                            saveAttendanceNote();
                        }, function(httpResponse){
                            blockUI.stop();
                            $log.debug('error');
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                        });
                }, function(httpResponse){
                    blockUI.stop();
                    $log.debug('error');
                    $log.debug(httpResponse);
                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                });
        }

        function saveAttendanceNote() {
            AttendanceNote.find({
                filter: {
                    where: {
                        offeredServiceId: $state.params.offeredServiceId,
                        day: moment(vm.currentDate).format('YYYYMMDD')
                    }
                }
            }).$promise.then(
                function(data, headers){
                    if (data && data.length > 0) {
                        AttendanceNote.update({
                            where: {
                                id: data[0].id
                            }
                        },{
                            note : vm.attendanceNote
                        }, function(value, responseHeaders) {
                            blockUI.stop();
                            $log.debug(value);
                            AlertMessageService.showSuccessMessage();
                        }, function(httpResponse) {
                            blockUI.stop();
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                    } else {
                        AttendanceNote.create({
                            day: moment(vm.currentDate).format('YYYYMMDD'),
                            offeredServiceId: vm.offeredService.id,
                            organizationId: vm.offeredService.organizationId,
                            note:  vm.attendanceNote
                        }, function(value, responseHeaders) {
                            blockUI.stop();
                            $log.debug(value);
                            AlertMessageService.showSuccessMessage();
                        }, function(httpResponse) {
                            blockUI.stop();
                            $log.error(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse);
                        });
                    }
                },
                function(error){
                    blockUI.stop();
                    $log.debug(error);
                });
        }


    }

})();

(function() {
    'use strict';

    /**
     * Direttiva che mostra lo stato del pagamento di una subscription (alla data attuale)
     */
    angular
        .module('ov-subscription-payments-status', [])
        .directive('ovSubscriptionPaymentsStatus', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-subscription-payments-status/ov-subscription-payments-status.html',
                replace: true,
                scope: {
                    totaldue: '=',
                    totalpaid: '=',
                    todaydue: '=',
                    todaypaid: '='
                },
                controller: ['$scope', '$rootScope', function($scope, $rootScope) {
                    $scope.init = function() {
                        if (!$scope.totaldue) $scope.totaldue = 0;
                        if (!$scope.totalpaid) $scope.totalpaid = 0;
                        if (!$scope.todaydue) $scope.todaydue = 0;
                        if (!$scope.todaypaid) $scope.todaypaid = 0;
                        if (typeof $scope.totaldue === 'string') {
                            $scope.totaldue = parseFloat($scope.totaldue);
                        }
                        if (typeof $scope.totalpaid === 'string') {
                            $scope.totalpaid = parseFloat($scope.totalpaid);
                        }
                        if (typeof $scope.todaydue === 'string') {
                            $scope.todaydue = parseFloat($scope.todaydue);
                        }
                        if (typeof $scope.todaypaid === 'string') {
                            $scope.todaypaid = parseFloat($scope.todaypaid);
                        }
                    };
                }],
            };
        }]);
})();

(function() {
    'use strict';

    /**
     * Direttiva che mostra lo stato dei carnet di una subscription
     */
    angular
        .module('ov-subscription-carnet-status', [])
        .directive('ovSubscriptionCarnetStatus', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-subscription-carnet-status/ov-subscription-carnet-status.html',
                replace: true,
                scope: {
                    carnetstatus: '=carnetstatus',
                },
                controller: ['$scope', '$log', '$state',
                    function($scope, $log, $state) {
                    $scope.init = function() {
                        //
                    };


                    /**
                     * Rinnova un carnet dato il suo order
                     *
                     * @param {object} order
                     */
                    $scope.renewSubscription = function(ev, order) {
                        // normalmente chiede conferma prima di procedere
                        // var templateUrl = 'app/main/pages/commons/dialogs/proceed_confirm_dialog.html';
                        // // se il carnetr non è consumato, chiede conferma prima di procedeere indicando che non èp terminato
                        // if (!order.attendanceCount || order.attendanceCount < order.numMaxAccessForOrder) {
                        //     templateUrl = 'app/main/pages/offered_services/views/offered_service/tabs/dialogs/renew_confirm_dialog.html';
                        // }
                        // $mdDialog.show({
                        //     controller: $scope.dialogController,
                        //     templateUrl: templateUrl,
                        //     parent: angular.element(document.body),
                        //     scope: $scope,
                        //     targetEvent: ev,
                        //     preserveScope: true,
                        //     clickOutsideToClose:true
                        // }).then(function(answer) {
                            $state.go('app.renew_subscription', {
                                offeredServiceId: order.offeredServiceId,
                                subscriptionId: order.subscriptionId
                            });
                        // }, function() {
                        //     // ignora errori
                        // });
                    };


                    /**
                     * Controller per la dialog del rinnovo carnet
                     *
                     * @param $scope
                     * @param $mdDialog
                     */
                    // $scope.dialogController = function($scope, $mdDialog) {
                    //     $scope.apiPath = ApiPath;
                    //     $scope.hide = function() {
                    //         $mdDialog.hide();
                    //     };
                    //     $scope.cancel = function() {
                    //         $mdDialog.cancel();
                    //     };
                    //     $scope.answer = function(answer) {
                    //         $mdDialog.hide(answer);
                    //     };
                    // };
                }],
            };
        }]);
})();

(function() {
    'use strict';

    /**
     * Direttiva che mostra la cella con il rpospetto dei pagamenti di una subscription
     */
    angular
        .module('ov-subscriber-payments-cell', [])
        .directive('ovSubscriberPaymentsCell', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-subscriber-payments-cell/ov-subscriber-payments-cell.html',
                replace: true,
                scope: {
                    paymentdue: '@',
                    paymentdone: '@',
                    paymenttotal: '@',
                    paymenttotaldone: '@',
                },
                controller: ['$scope', '$rootScope', '$log', function($scope, $rootScope, $log) {
                    $scope.init = function() {
                        //
                    };
                }],
            };
        }]);
})();

(function ()
{
    'use strict';

    /**
     * Direttiva per la gestione delle breadcrumbs
     */
    angular
        .module('ov-profile-navigation-bar', [])
        .directive('ovProfileNavigationBar', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-profile-navigation-bar/ov-profile-navigation-bar.html',
                replace: true,
                scope: {
                    showDateInterval: '@',
                    hideOrganzationMenu: '@'
                },
                controller: ['$scope', '$rootScope', '$state', 'breadcrumbManager', '$location', 'User', '$mdDialog', 'AlertMessageService', 'Notification',
                    function($scope, $rootScope, $state, breadcrumbManager, $location, User, $mdDialog, AlertMessageService, Notification){

                        $scope.isUserDetail= ($location.path().startsWith('/user') || $location.path().startsWith('/subscription'));
                        $scope.currentUserId = User.getCurrentId().toString();
                        $scope.isParentManagementEnabled = false;
                        $scope.backState = null;
                        $scope.backParams = {};

                        if (sessionStorage.getItem('USER_DETAIL_FROM_STATE')) {
                            try {
                                $scope.backState = JSON.parse(sessionStorage.getItem('USER_DETAIL_FROM_STATE'));
                                $scope.backParams =  JSON.parse(sessionStorage.getItem('USER_DETAIL_FROM_PARAMS'));
                            } catch (err) {}
                        }

                        $scope.goBack = function() {
                            $state.go($scope.backState.name, $scope.backParams);
                        };

                        $scope.gotoProfile = function() {
                            $state.go('app.pages_profile_socio',{ userId: $scope.userId, tab: 'GEN' });
                        };

                        $scope.gotoRelatives = function() {
                            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
                            if ($scope.isUserDetail) {
                                $state.go('app.pages_user_relatives', {userId: $scope.userId});
                            } else {
                                $state.go('app.pages_profile_relatives', {userId: $scope.userId});
                            }
                        };

                        $scope.gotoParents = function() {
                            //cambio lo state a seconda che sia nel dettaglio del mio utente come socio (pages_profile_xxx) o come amministratore (pages_user_xxx)
                            if ($scope.isUserDetail) {
                                $state.go('app.pages_user_parents', {userId: $scope.userId});
                            } else {
                                $state.go('app.pages_profile_parents', {userId: $scope.userId});
                            }
                        };


                        $scope.gotoSubscriptions = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.pages_subscriptions_person', {
                                organizationId: item.id,
                                offeredServiceId: '',
                                paymentsFilter: 'A',
                                documentsFilter: '',
                                userId: $scope.userId
                            });
                        };

                        $scope.gotoServices = function() {
                            $state.go('app.pages_profile_services', {userId: $scope.userId});
                        };

                        $scope.gotoSettings = function() {
                            $state.go('app.pages_profile_settings', {userId: $scope.userId});
                        };

                        $scope.gotoUserDetail = function() {
                            if (!$scope.organizationId) {
                                var organization = breadcrumbManager.currentOrganization();
                                $scope.organizationId = organization ? organization.id : null;
                            }
                            $state.go('app.pages_user_detail', {userId: $scope.userId, organizationId: $scope.organizationId});
                        };

                        // $scope.gotoDocuments = function() {
                        //     $state.go('app.pages_profile_docs', {userId: $scope.userId});
                        // };

                        $scope.gotoDocuments = function() {
                            if ($scope.userId === $scope.currentUserId && !$scope.isUserDetail) {
                                // accedo come me stesso e posso gestirmi i miei documenti
                                $state.go('app.pages_profile_docs', {userId: $scope.userId});
                            } else {
                                // accedo come amministratore di organizzazione
                                $state.go('app.pages_user_documents', {userId: $scope.userId});
                            }
                        };

                        $scope.gotoPayments = function() {
                            if ($scope.isUserDetail) {
                                $state.go('app.pages_user_payments', {userId: $scope.userId});
                            } else {
                                $state.go('app.pages_profile_payments', {userId: $scope.userId});
                            }
                        };

                        $scope.gotoProfileAttendances = function() {
                            if ($scope.isUserDetail) {
                                $state.go('app.user_attendances', {userId: $scope.userId});
                            } else {
                                $state.go('app.profile_attendances', {userId: $scope.userId});
                            }
                        };

                        $scope.loadParentsManagement = function () {
                            if ($scope.userId) {
                                User.isParentManagementEnabled({userId: $scope.userId}).$promise.then(function(data) {
                                    $scope.isParentManagementEnabled=data.result;
                                });
                                User.findById({
                                    id: $scope.userId,
                                    filter: {include: ['parents']}
                                }).$promise.then(function(data) {
                                    $scope.isChild = data.parents && data.parents.length > 0;
                                });
                            }
                        };


                        /**
                         * Ritorna al genitore, o permette di scegliere il genitore a cui andare.
                         */
                        $scope.gotoParent = function() {
                            User.findById({
                                id: $scope.userId,
                                filter: {include: ['parents']}
                            }).$promise.then(function(data) {
                                // se ho genitori
                                if (data.parents && data.parents.length > 0) {
                                    // se ho un solo genitore, vado direttamente a quello
                                    if (data.parents.length === 1) {
                                        var genitore = data.parents.pop();
                                        $state.go('app.pages_user_detail', {userId: genitore.id});
                                    } else {
                                        // TODO: se ho più genitori, mi fa scegiere a quale andare tramite una dialog
                                        // nota: finchè non ho altri genitori, non ha senso farla, sarebbe impossibile provarla
                                    }
                                }
                            });
                        };



                        $scope.sendMessage = function () {
                            $scope.myResource={};
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'app/main/pages/users/user_profile/tabs/services/send_message_dialog.html',
                                parent: angular.element(document.body),
                                scope: $scope,
                                preserveScope: true,
                                clickOutsideToClose:true
                            })
                                .then(function(answer) {
                                    User.notifyUser({userId: $scope.userId, subject: answer.title, text: answer.text }).$promise.then(
                                        function(n,responseHeaders){
                                            AlertMessageService.showSuccessMessage();
                                        },
                                        function(httpResponse){
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                        }
                                    );
                                    Notification.create(
                                        {senderId: $scope.currentUserId,
                                            recipientId: $scope.userId,
                                            title: answer.title,
                                            text: answer.text,
                                            notificationType: 'CHAT',
                                            status: 'N',
                                            notificationDate: new Date()
                                        },
                                        function(n,responseHeaders){
                                            AlertMessageService.showSuccessMessage();
                                        },
                                        function(httpResponse){
                                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                                        });
                                }, function() {});
                        };


                        /**
                         * Si sposta all'elenco dei contatti dell'associazione corrente
                         */
                        $scope.gotoMembers = function() {
                            var organization = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_members', {organizationId: organization.id });
                        };


                        /**
                         * Si sposta al dettaglio dell'utente indicato
                         */
                        $scope.gotoMembers = function() {
                            var organization = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_members', {organizationId: organization.id });
                        };


                        function DialogController($scope, $mdDialog) {
                            $scope.hide = function() {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function() {
                                $mdDialog.cancel();
                            };
                            $scope.answer = function(answer) {
                                $mdDialog.hide(answer);
                            };
                        }


                    }],

                link: function(scope, iElement, iAttrs, ctrl) {
                    scope.userId = iAttrs.userId;
                    scope.organizationId=iAttrs.organizationId;
                    scope.selectedPage = iAttrs.selectedPage;
                    scope.$watch(function() {
                        return iAttrs.userId;
                    }, function(newValue){
                        scope.userId = iAttrs.userId;
                        scope.loadParentsManagement();
                    });
                    scope.$watch(function() {
                        return iAttrs.organizationId;
                    }, function(newValue){
                        scope.organizationId = iAttrs.organizationId;
                    });
                    scope.$watch(function() {
                        return iAttrs.selectedPage;
                    }, function(newValue){
                        scope.selectedPage = iAttrs.selectedPage;
                    });
                }
            }
        }]);
})();

(function ()
{
    'use strict';

    /**
     * Direttiva per i messaggi bloccanti su una associazione
     */
    angular
        .module('ov-organization-alert', [])
        .directive('ovOrganizationAlert', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-organization-alert/ov-organization-alert.html',
                replace: true,
                scope: {
                    organizationId: '@'
                },
                controller: ['$scope', '$rootScope', '$state', 'breadcrumbManager', '$mdDialog', '$log', '$translate', 'User', 'UserPreference', 'CylPlan',
                    function($scope, $rootScope, $state, breadcrumbManager, $mdDialog, $log, $translate, User, UserPreference, CylPlan){

                        $scope.message = '';
                        $scope.isPayDue = false;
                        $scope.isMaxContacts = false;

                        $scope.loadOrganizationStats = function() {
                            if ($scope.organizationId) {
                                CylPlan.loadCurrentOrganizationStats({organizationId: $scope.organizationId}).$promise.then(function(stats) {
                                    $scope.organizationPlanStats = stats;

                                    if ($scope.organizationPlanStats.subscriptionStatus !== 'active' && $scope.organizationPlanStats.subscriptionStatus !== 'trialing') {
                                        $scope.isPayDue = true;
                                        $scope.isMaxContacts = false;
                                        $scope.showOrganizationAlert = true;
                                        $scope.message = 'Risultano pagamenti da effettuare per il piano ' + $scope.organizationPlanStats.plan.nickname + '. Procedere al saldo per continuare ad utilizzare l\'applicazione. ' +
                                            'Se invece hai appena effettuato il pagamento questo potrebbe essere in fase di registrazione, in questo caso sarà sufficiente attendere qualche istante.';
                                    } else {
                                        var maxContacts = 0;
                                        if ($scope.organizationPlanStats.plan.metadata['max-org-members']) {
                                            maxContacts = $scope.organizationPlanStats.plan.metadata['max-org-members'];
                                        }
                                        if (maxContacts > 0 && $scope.organizationPlanStats.numActiveContacts > maxContacts) {
                                            $scope.isMaxContacts = true;
                                            $scope.isPayDue = false;
                                            $scope.showOrganizationAlert = true;
                                            $scope.message = 'Il numero di contatti attivi supera il massimo previsto dal piano ' + $scope.organizationPlanStats.plan.nickname + '. Effettua un UPGRADE di piano oppure disattiva i contatti attivi non usati.';
                                        } else {
                                            $scope.showOrganizationAlert = false;
                                            $scope.isPayDue = false;
                                            $scope.isMaxContacts = false;
                                            $scope.message = '';
                                        }
                                    }


                                }, function(httpResponse) {
                                    $log.debug(httpResponse);
                                });
                            }
                        };

                        $scope.goToSettings = function() {
                            $state.go('app.organization_plans', {organizationId: $scope.organizationId});
                        }

                        $scope.goToContacts = function() {
                            $state.go('app.organization_members', {organizationId: $scope.organizationId});
                        }



                        $scope.loadOrganizationStats();


                    }],

                link: function(scope, iElement, iAttrs, ctrl) {

                    scope.organizationId = iAttrs.organizationId;
                    scope.$watch(function() {
                        return iAttrs.organizationId;
                    }, function(newValue){
                        scope.organizationId = iAttrs.organizationId;
                        scope.loadOrganizationStats();
                    });
                }
            }
        }]);
})();

(function() {
    'use strict';

    /**
     * Direttiva per la gestione delle breadcrumbs
     */
    angular.module('ov-navigation-bar', []).directive('ovNavigationBar', [
        function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-navigation-bar/ov-navigation-bar.html',
                replace: true,
                scope: {
                    showDateInterval: '@',
                    hideOrganzationMenu: '@',
                },
                controller: [
                    '$scope',
                    '$rootScope',
                    '$state',
                    '$log',
                    'breadcrumbManager',
                    '$location',
                    'User',
                    'Organization',
                    'AlertMessageService',
                    function($scope, $rootScope, $state, $log, breadcrumbManager, $location, User) {
                        $scope.currentUserId = User.getCurrentId().toString();

                        $scope.getCurrentOrganizationId = function() {
                            if ($scope.organizationId) {
                                return $scope.organizationId;
                            } else {
                                return sessionStorage.getItem('CURRENT_ORGANIZATION');
                            }
                        };

                        $scope.gotoResources = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_resources', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.gotoMembers = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_members', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.gotoOrganizationStartpage = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_startpage', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.gotoMembershipsIndex = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.pages_memberships_index', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.gotoServices = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_services', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                    serviceType: 'SERVICE',
                                });
                            }
                        };

                        $scope.gotoCarnet = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_services', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                    serviceType: 'CARNET',
                                });
                            }
                        };

                        $scope.gotoEvents = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_events', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                    serviceType: 'EVENT',
                                });
                            }
                        };

                        $scope.goToOrganizationDetail = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization', { organizationId: $scope.getCurrentOrganizationId() });
                            }
                        };

                        $scope.gotoEarningCosts = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.pages_earningcosts', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.goToOrganizationSettings = function() {
                            if ($scope.getCurrentOrganizationId()) {
                                $state.go('app.organization_settings', {
                                    organizationId: $scope.getCurrentOrganizationId(),
                                });
                            }
                        };

                        $scope.sendMessage = function(ev) {
                            $rootScope.$emit('SERVICE_SEND_MESSAGE', {});
                        };

                        $scope.goToInvitations = function() {
                            $state.go('app.pages_invitations', { offeredServiceId: $scope.currentOfferedService.id });
                        };

                        $scope.goToGeneratedEvent = function() {
                            $state.go('app.new_generated_event', {
                                organizationId: $scope.currentOfferedService.organizationId,
                                srcOfferedServiceId: $scope.currentOfferedService.id,
                            });
                        };

                        // ritorna TRUE se selectedPage fa parte di una delle voci relative all'organizzazione
                        $scope.isOrganizationSelected = function(selectedPage) {
                            return (
                                selectedPage &&
                                [
                                    'ORGANIZATION',
                                    'MEMBERSHIPS',
                                    'SERVICES',
                                    'CARNET',
                                    'EARNING_COSTS',
                                    'EVENTS',
                                    'RESOURCES',
                                    'SETTINGS',
                                ].findIndex(function(element) {
                                    return element.toUpperCase() === selectedPage.toUpperCase();
                                }) >= 0
                            );
                        };
                    },
                ],

                link: function(scope, iElement, iAttrs, ctrl) {
                    scope.organizationId = iAttrs.organizationId;
                    scope.selectedPage = iAttrs.selectedPage;
                    scope.currentOfferedService = iAttrs.currentOfferedService;
                    scope.$watch(
                        function() {
                            return iAttrs.organizationId;
                        },
                        function(newValue) {
                            scope.organizationId = iAttrs.organizationId;
                        }
                    );
                    scope.$watch(
                        function() {
                            return iAttrs.selectedPage;
                        },
                        function(newValue) {
                            scope.selectedPage = iAttrs.selectedPage;
                        }
                    );
                },
            };
        },
    ]);
})();

'use strict';

(function(){
    /**
     * Direttiva che mostra un prospetto di esempio delle periodicità di un servizio
     */
    angular
        .module('ov-interval-table', [])
        .directive('ovIntervalTable', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-interval-table/ov-interval-table.html',
                replace: true,
                scope: {
                    startdate: '=',
                    enddate: '='
                },
                controller: ['$scope', '$rootScope', '$log', function($scope, $rootScope, $log) {

                    $scope.init = function() {
                        updateValues();
                    };

                    $scope.$watch(
                        function(scope) {
                            return scope.startdate;
                        },
                        function(newValue, oldValue) {
                            updateValues();
                        }
                    );
                    $scope.$watch(
                        function(scope) {
                            return scope.enddate;
                        },
                        function(newValue, oldValue) {
                            updateValues();
                        }
                    );


                    /**
                     * Aggiorna le periodicità tra le date
                     */
                    function updateValues() {
                        if ($scope.startdate && $scope.enddate) {
                            var inizio = moment($scope.startdate).startOf('day');
                            var fine = moment($scope.enddate).endOf('day');
                            $scope.giorni = Math.trunc(fine.diff(inizio, 'days', true) +0.5);
                            $scope.settimane = Math.trunc(fine.diff(inizio, 'weeks', true) +0.5);
                            $scope.mesi = Math.trunc(fine.diff(inizio, 'months', true) +0.5);
                        }
                    }
                }],
            }
        }]);
})();

(function ()
{
    'use strict';

    /**
     * Direttiva per la gestione delle breadcrumbs
     */
    angular
        .module('ov-breadcrumbs', [])
        .directive('ovBreadcrumbs', [function() {
            return {
                restrict: 'E',
                templateUrl: 'app/main/directives/ov-breadcrumbs/ov-breadcrumbs.html',
                replace: true,
                scope: {
                    showDateInterval: '@',
                    hideOrganzationMenu: '@'
                },
                controller: ['$scope', '$rootScope', '$state', 'breadcrumbManager', '$mdDialog', '$log', '$translate', 'User', 'UserPreference',
                    function($scope, $rootScope, $state, breadcrumbManager, $mdDialog, $log, $translate, User, UserPreference){

                        $scope.currentOrganization = breadcrumbManager.currentOrganization();
                        $scope.currentOfferedService = breadcrumbManager.currentOfferedService();

                        $scope.currentUserId = User.getCurrentId();

                        $scope.organizationPeriod = {
                            description: $translate.instant('PAGES.SET_REF_PERIOD'),
                            organizationId: $scope.currentOrganization ? $scope.currentOrganization.id : null,
                            dateFrom: null,
                            dateTo: null
                        };

                        //CARICO IL PERIODO DI RIF DA DB
                        $scope.currentUserId = User.getCurrentId();

                        /**
                         * Funzione che carica il periodo di riferimento della stagione prendendolo dal DB
                         */


                        if ($scope.currentOrganization && $scope.currentUserId) {
                            breadcrumbManager.loadReferencePeriodForOrganization(function(data) {
                                if (!data.description) {
                                    data.description = $translate.instant('PAGES.SET_REF_PERIOD');
                                }
                                $scope.organizationPeriod = data;
                            });
                        }

                        $rootScope.$on('PUSH_ORGANIZATION', function (event, value) {
                            $scope.currentOrganization = value;
                            breadcrumbManager.loadReferencePeriodForOrganization(function(data) {
                                $scope.organizationPeriod = data;
                                if (data && !data.description) {
                                    data.description = $translate.instant('PAGES.SET_REF_PERIOD');
                                }
                            });
                        });
                        $rootScope.$on('POP_ORGANIZATION', function (event, value) {
                            $scope.currentOrganization = null;
                        });

                        $rootScope.$on('PUSH_OFFERED_SERVICE', function (event, value) {
                            $scope.currentOfferedService = value;
                        });
                        $rootScope.$on('POP_OFFERED_SERVICE', function (event, value) {
                            $scope.currentOfferedService = null;
                        });


                        /****************************************************************************************************
                         * FUNZIONI PER LA GESTIONE DELLA STAGIONE
                         */

                        $scope.openPeriodModal = function() {
                            $mdDialog.show({
                                controller: RefPeriodDialogController,
                                templateUrl: 'app/main/directives/ov-breadcrumbs/dialogs/ref_period_dialog.html',
                                parent: angular.element(document.body),
                                scope: $scope,
                                preserveScope: true,
                                clickOutsideToClose:true
                            }).then(function(answer) {
                                var item = breadcrumbManager.currentOrganization();
                                $scope.organizationPeriod.organizationId = item.id;
                                $scope.organizationPeriod.description = '';
                                if ($scope.organizationPeriod.dateFrom) {
                                    $scope.organizationPeriod.description +=  $translate.instant('PAGES.DATE_FROM') + ' ' + moment($scope.organizationPeriod.dateFrom).format('DD/MM/YYYY');
                                }
                                if ($scope.organizationPeriod.dateTo) {
                                    $scope.organizationPeriod.description += ' '  + $translate.instant('PAGES.DATE_TO') + ' ' + moment($scope.organizationPeriod.dateTo).format('DD/MM/YYYY');
                                }

                                breadcrumbManager.saveReferencePeriodForOrganization($scope.organizationPeriod, function(data) {
                                    if (!data.description) {
                                        data.description = $translate.instant('PAGES.SET_REF_PERIOD');
                                    }
                                    $scope.organizationPeriod = data;
                                });

                            }, function() {
                                $log.debug('You cancelled the dialog.');
                            });
                        };


                        function RefPeriodDialogController($scope, $mdDialog) {
                            // $scope.apiPath = ApiPath;
                            $scope.hide = function() {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function() {
                                $mdDialog.cancel();
                                breadcrumbManager.loadReferencePeriodForOrganization(function(data) {
                                    if (!data.description) {
                                        data.description = $translate.instant('PAGES.SET_REF_PERIOD');
                                    }
                                    $scope.organizationPeriod = data;
                                });
                            };
                            $scope.clearDates = function() {
                                $scope.organizationPeriod.dateFrom=null;
                                $scope.organizationPeriod.dateTo=null;
                            };
                        }


                        $scope.applyDates = function(answer) {
                            var isOk = false;
                            //CHECK
                            //- data inizio <= data fine
                            if ($scope.organizationPeriod.dateFrom && $scope.organizationPeriod.dateTo && moment($scope.organizationPeriod.dateFrom).isAfter(moment($scope.organizationPeriod.dateTo))) {
                                $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_INTERVAL_INVALID');
                            } else {
                                isOk=true;
                            }

                            //giorno obbligatorio se settimanale
                            if (isOk) {
                                $mdDialog.hide(answer);

                            }
                        };

                        /*****************************************************************************************************
                         * FUNZIONI PER LA GESTIONE DELLE BREADCRUBS, OVVERO DEL BOTTONE HOME PRESENTE IN TUTTE LE PAGINE
                         */
                        $scope.gotoOfferedServices = function() {
                            var item = breadcrumbManager.currentOrganization();
                            var service = breadcrumbManager.currentOfferedService();
                            if (item && service) {
                                if (service.type==='EVENT') {
                                    $state.go('app.organization_events', {organizationId: item.id, serviceType: 'EVENT'});
                                } else {
                                    $state.go('app.organization_services', {organizationId: item.id, serviceType: 'SERVICE'});
                                }
                            }
                        };

                        $scope.goToOrganization = function() {
                            var item = breadcrumbManager.currentOrganization();
                            if (item) {
                                $state.go('app.organization', {organizationId: item.id});
                            }
                        };

                        $scope.gotoOrganizations = function() {
                            $state.go('app.organizations', {});
                        };

                        $scope.openMenu = function($mdOpenMenu, ev) {
                            $mdOpenMenu(ev);
                        };


                        $scope.goToOrganizationSettings = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_settings', {organizationId: item.id });
                        };

                        $scope.gotoResources = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_resources', {organizationId:item.id});
                        };

                        $scope.gotoMembers = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_members', {organizationId:item.id});
                        };

                        $scope.gotoServices = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_services', {organizationId:item.id, serviceType: 'SERVICE'});
                        };

                        $scope.gotoEvents = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.organization_events', {organizationId:item.id, serviceType: 'EVENT'});
                        };

                        $scope.gotoEarningCosts = function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.pages_earningcosts', {organizationId:item.id});
                        };

                        $scope.goToOrganizationSubscriptions =  function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.pages_subscriptions_pre', {
                                organizationId: item.id,
                                offeredServiceId: '',
                                paymentsFilter: 'A',
                                documentsFilter: '',
                                userId: ''
                            });
                        };

                        $scope.goToOrganizationAttendances =  function() {
                            var item = breadcrumbManager.currentOrganization();
                            $state.go('app.pages_attendances_pre', {
                                organizationId: item.id
                            });
                        };

                    }],

                link: function(scope, iElement, iAttrs, ctrl) {

                    scope.showDateInterval=(iAttrs.showDateInterval === 'true');
                    scope.$watch(function() {
                        return iAttrs.showDateInterval;
                    }, function(newValue){
                        scope.showDateInterval=(iAttrs.showDateInterval === 'true');
                    });

                    scope.hideOrganzationMenu=(iAttrs.hideOrganzationMenu === 'true');
                    scope.$watch(function() {
                        return iAttrs.hideOrganzationMenu;
                    }, function(newValue){
                        scope.hideOrganzationMenu=(iAttrs.hideOrganzationMenu === 'true');
                    });


                }
            }
        }]);
})();

(function ()
{
    'use strict';
  angular.module('on-finish-render', [])
    .directive('onFinishRender', function() {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    setTimeout(function () {
                        scope.$emit(attr.onFinishRender, attr.groupName);
                    });
                }
            }
        }
    });

})();

'use strict';

(function() {
    angular
        .module('dyndoc', ['underscore', 'on-finish-render'])
        .directive('dynamicDocument', function() {
            return {
                restrict: 'E',
                scope: {
                    onSuccess: "&",
                    onError: "&"
                },
                templateUrl: 'app/main/directives/dynamic-document/templates/dynamic-document.html',

                controller: ['$log', '$scope', '$http', '_', '$sce', '$mdDialog', '$rootScope', '$location',
                    '$mdConstant', 'LoopBackAuth', '$q', '$timeout',
                    function($log, $scope, $http, _, $sce, $mdDialog, $rootScope, $location,
                             $mdConstant, LoopBackAuth, $q, $timeout) {
                        var myTemplateStructure = {};
                        var myModel = {};
                        var myStats = {};
                        var multipleCollectionsBackup = {};
                        var modelToSave = {};

                        var fieldRules = [];
                        $scope.fieldsDisabled = {}; //CAMPI DISABILITATI:  {'campo-iesimo':true}
                        $scope.fieldsRequired = []; // elenco campi necessari
                        $scope.fieldsRequiredForPage={}; // elenco campi necessari per pagine di wizard
                        var variableFields = [];
                        var flattenedFields = [];   // elenco dei campi appiattiti
                        $scope.wizardPages=[];
                        $scope.currentWizardPage=null;

                        $scope.lookupDataStatus = null; // stato del lookup dei dati dei campi con una sorgente esterna (select con  dataSource: URL, ...)
                        $scope.lookupDataLoading = 0;   // numero di campi in cui è in corso il caricamento dei dati esterni


                        if (!String.prototype.startsWith) {
                            String.prototype.startsWith = function(searchString, position) {
                                position = position || 0;
                                return this.indexOf(searchString, position) === position;
                            };
                        }

                        /**
                         * Questo evento viene invocato ogni qual volta viene risdisegnato un gruppo multivalore.
                         * Solo la prima volta, dopo il primo disegno, lo riempiamo con eventuali dati
                         */
                        $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent, groupName) {

                            if (groupName==='DYNAMIC_DOCUMENT') {
                                myTemplateStructure._wizard = {};
                                $scope.wizardPages = _.uniq($scope.wizardPages);
                                myTemplateStructure._wizard.pages = $scope.wizardPages;
                                myTemplateStructure._wizard.currentPage = $scope.currentWizardPage;
                                myTemplateStructure._form = $scope.myForm;
                                myTemplateStructure._template = $scope.template;
                                myTemplateStructure._isEditForm = $scope.isEditMode;
                                myTemplateStructure._model = $scope.myModel;
                                myTemplateStructure.calculateCompletionRatio = $scope.calculateCompletionRatio;
                                myTemplateStructure.calculatePageCompletionRatio = $scope.calculatePageCompletionRatio;
                                myTemplateStructure.goToFirstMissingField = $scope.goToFirstMissingField;
                                myTemplateStructure.goToFirstMissingFieldForPage = $scope.goToFirstMissingFieldForPage;

                                $rootScope.$emit('DYN-DOC-RENDERED', myTemplateStructure);
                            }

                            if (!angular.isDefined(multipleCollectionsBackup[groupName])) return;

                            var elementiGruppo = _.keys($scope.myModel[groupName]);
                            _.each(elementiGruppo, function(elementoGruppo) {
                                var datiElemento = multipleCollectionsBackup[groupName][elementoGruppo];
                                //copio le chiavi
                                _.each(_.keys(datiElemento), function(chiave) {
                                    $scope.myModel[groupName][elementoGruppo][chiave]=datiElemento[chiave];
                                });
                            });

                            delete multipleCollectionsBackup[groupName];

                        });

                        /**
                         * Funzione che recupera template e documento e avvia il disegno della form
                         */
                        $scope.getTemplateData = function() {
                            $log.debug('$scope.getTemplateData()');
                            $scope.wizardPages=[];

                            if ($scope.retrieveDataUrl && $scope.retrieveDataUrl!==null && $scope.retrieveDataUrl!=='') {
                                $log.debug('edit documento');
                                $http.get($scope.retrieveDataUrl).then(function (res) {
                                    myModel = res.data.data.document;
                                    var myTemplate = res.data.data.template;

                                    if (!myTemplate.items || myTemplate.items.length === 0) {
                                        $rootScope.$emit('DYN-DOC-RENDERED', myTemplateStructure);
                                        return;
                                    }

                                    createFormulaParser();
                                    _retrieveTemplateInfo(myTemplate.items);

                                    //bonifica date
                                    _normalizeModel();

                                    $scope.myModel = myModel;
                                    $scope.template = myTemplate;
                                    $scope.populateLookupData(flattenedFields);

                                    $scope.processRules();


                                });
                            } else if ($scope.retrieveStatsUrl && $scope.retrieveStatsUrl !== null &&
                                $scope.retrieveStatsUrl !== '') {
                                $log.debug('stat documento');
                                $scope.isStatsMode = true;
                                $http.get($scope.retrieveStatsUrl).then(function(res) {
                                    myModel = {templateId: res.data.data.template.id};
                                    var myTemplate = res.data.data.template;

                                    if (!myTemplate.items || myTemplate.items.length === 0) {
                                        $rootScope.$emit('DYN-DOC-RENDERED', myTemplateStructure);
                                        return;
                                    }


                                    $scope.myStats = res.data.data.stats;

                                    createFormulaParser();
                                    _retrieveTemplateInfo(myTemplate.items);

                                    _initCharts();

                                    $scope.myModel = myModel;
                                    $scope.template = myTemplate;
                                });
                            } else if ($scope.retrieveTemplateUrl && $scope.retrieveTemplateUrl !== null &&
                                $scope.retrieveTemplateUrl !== '') {                    // nuovo documento
                                $log.debug('nuovo documento');
                                $http.get($scope.retrieveTemplateUrl).then(function(res) {
                                    var myTemplate = res.data;
                                    myModel = {templateId: res.data.id};

                                    if (!myTemplate.items || myTemplate.items.length === 0) {
                                        $rootScope.$emit('DYN-DOC-RENDERED', myTemplateStructure);
                                        return;
                                    }

                                    createFormulaParser();
                                    _retrieveTemplateInfo(myTemplate.items);

                                    //bonifica date
                                    //_normalizeModel();

                                    $scope.myModel = myModel;
                                    $scope.template = myTemplate;
                                    $scope.populateLookupData(flattenedFields);

                                    $scope.processRules();

                                    console.log(' **************** myModel: ' + JSON.stringify(myModel));
                                });
                            }
                            $rootScope.$emit('DYN-DOC-LOADED', myTemplateStructure);
                        }




                        /**
                         * Popola i dati dei campi con sorgente esterna (es. select con dataSource di tipo URL)
                         */
                        $scope.populateLookupData = function(fields) {
                            $log.debug('$scope.populateLookupData()');
                            // semaforo per non leggere più volte contemporaneamente
                            if (!$scope.lookupDataStatus) {
                                $scope.lookupDataStatus = 'loading';
                                $scope.lookupDataLoading = 0;
                                _.each(fields, function(field) {
                                    // se il campo ha dei dati esterni
                                    if ($scope.hasExternalData(field)) {
                                        // carica i dati per quel campo
                                        $scope.lookupDataLoading++;
                                        $scope.loadExternalData(field, function(data) {
                                            $scope.lookupDataLoading--;
                                            // sblocca il semaforo quando ha finito
                                            if ($scope.lookupDataLoading === 0) {
                                                $scope.lookupDataStatus = null;
                                            }
                                        });
                                    }
                                });
                            }
                        };


                        /**
                         * Carica i dati esterni in un campo e li applica
                         * @param field
                         */
                        $scope.loadExternalData = function(field, callback) {
                            $log.debug('$scope.loadExternalData()');
                            $scope.getExternalData(field, function(err, data) {
                                if (!err) {
                                    // aggiunge gli elementi choice
                                    if (field && field.type &&
                                        (field.type.toLowerCase() === 'select' || field.type.toLowerCase() === 'radio')
                                    ) {
                                        $scope.addChoiceItems(field, data);
                                    }
                                } else {
                                    $log.error('errore in lettura dati esterni');
                                    $log.error(err);
                                }
                            });
                            callback({
                                fieldName: field.name,
                            });
                        };


                        /**
                         * Preleva i dati esterni di un campo
                         *
                         * @param field
                         * @param callback
                         */
                        $scope.getExternalData = function(field, callback) {
                            $log.debug('$scope.getExternalData()');
                            if (field && field.options && field.options.dataSource &&
                                field.options.dataSource.type && field.options.dataSource.type.toLowerCase() === 'url' &&
                                field.options.dataSource.source) {
                                var items = [];
                                // se non ho già tutti i record, li leggo dalla sorgente
                                if (!field.allData || field.allData.length === 0) {
                                    // se ho i nomi dei campi da usare come valore e come etichetta
                                    if (field.options.dataSource.labelField && field.options.dataSource.valueField) {
                                        $http.get(field.options.dataSource.source).then(
                                            function success(res) {
                                                items = res.data.items;
                                                // imposta allData
                                                field.allData = items;
                                                // se ci sono dei filtri da applicare in base ad un altro campo
                                                if (field.options.parentElement && field.options.dataSource.parentFilterField &&
                                                    $scope.myModel && $scope.myModel[field.options.parentElement]) {
                                                    items = $scope.filterParentFieldData(items,
                                                        field.options.dataSource.parentFilterField,
                                                        $scope.myModel[field.options.parentElement]);
                                                }

                                                // ritorna gli elementi
                                                callback(null, items);
                                            }, function failed(res) {
                                                $log.error('Interrogazione API fallita: ' + field.options.dataSource.source);
                                                $log.warn(res);
                                                callback({ msg: 'err.dyndoc4.externaldata.apifailed' });
                                            }
                                        );
                                    } else {
                                        callback({ msg: 'err.dyndoc4.externaldata.missingfields' });
                                    }
                                }
                                // se ho già prelevato i record dalla API, evito di chiederli nuovamente
                                else {
                                    items = field.allData;
                                    // se ci sono dei filtri da applicare in base ad un altro campo
                                    if (field.options.parentElement && field.options.dataSource.parentFilterField &&
                                        $scope.myModel && $scope.myModel[field.options.parentElement]) {
                                        items = $scope.filterParentFieldData(items,
                                            field.options.dataSource.parentFilterField,
                                            $scope.myModel[field.options.parentElement]);
                                    }

                                    // ritorna gli elementi
                                    callback(null, items);
                                }
                            } else {
                                callback({ msg: 'err.dyndoc4.externaldata.missingsource' });
                            }
                        };



                        /**
                         * Filtra gli elementi di data, ritornando solo quelli in cui il campo fieldToFilter vale selectedValue
                         *
                         * @param data
                         * @param fieldToFilter
                         * @param selectedValue
                         * @returns {Array}
                         */
                        $scope.filterParentFieldData = function(data, fieldToFilter, selectedValue) {
                            $log.debug('$scope.filterParentFieldData()');
                            var r = [];
                            for (var i = 0; i < data.length; i++) {
                                if (data[i][fieldToFilter] === selectedValue) {
                                    r.push(data[i]);
                                }
                            }
                            return r;
                        };


                        /**
                         * Aggiunge i dati indicati come elementi choice del campo indicato
                         *
                         * @param field Campo
                         * @param data Dati da usare come elementi del choice
                         */
                        $scope.addChoiceItems = function(field, data) {
                            $log.debug('$scope.addChoiceItems()');
                            field.choices = [];
                            if (field && field.options && field.options.dataSource &&
                                field.options.dataSource.labelField && field.options.dataSource.valueField) {
                                _.each(data, function(choiceItem) {
                                    field.choices.push({
                                        uuid: choiceItem[field.options.dataSource.valueField],
                                        value: choiceItem[field.options.dataSource.valueField],
                                        weight: field.choices.length,
                                        caption: choiceItem[field.options.dataSource.labelField],
                                    });
                                });
                            } else {
                                $log.error('Mancano i campi da mostrare');
                                $log.debug(field.options);
                            }
                        };



                        /**
                         * Verifica se un campo di un template ha un datasource esterno
                         *
                         * @param field Campo di un template
                         */
                        $scope.hasExternalData = function(field) {
                            if (field && field.options && field.options.dataSource &&
                                field.options.dataSource.type) {
                                if (field.options.dataSource.type.toLowerCase() === 'url' && field.options.dataSource.source) {
                                    return true;
                                }
                            }
                            return false;
                        };



                        $scope.addMultipleEntry = function(myItem) {
                            if (!$scope.fieldCounter[myItem.name]) {
                                $scope.fieldCounter[myItem.name] = [];
                            }
                            $scope.fieldCounter[myItem.name].push('');
                        };



                        var dyndocEraseCleanupFunction = $rootScope.$on('DYN-DOC-ERASE', function (event, value) {

                            $http.get(value.retrieveTemplateUrl).then(function (res) {
                                var myTemplate = res.data;

                                myModel={templateId: res.data.id};

                                _retrieveTemplateInfo( myTemplate.items);

                                //bonifica date
                                //_normalizeModel();

                                $scope.myModel = myModel;
                                $scope.template = myTemplate;

                                $scope.processRules();

                                if (value.documentId) {
                                    $scope.myModel.id=value.documentId;
                                }
                            });

                        });

                        var dyndocLoadTemplateCleanupFunc = $rootScope.$on('DYN-DOC-LOADTEMPLATE', function (event, value) {
                            var myTemplate = value;

                            myModel={templateId: value.id};

                            _retrieveTemplateInfo( myTemplate.items);

                            //bonifica date
                            //_normalizeModel();

                            $scope.myModel = myModel;
                            $scope.template = myTemplate;

                            $scope.processRules();

                            if (value.documentId) {
                                $scope.myModel.id=value.documentId;
                            }
                        });


                        var dyndocShowWizCleanupFunc = $rootScope.$on('DYN-DOC-SHOW-WIZARD-PAGE', function (event, value) {
                            $scope.currentWizardPage=value.page;
                        });




                        $scope.createLabelTag = function(myItem) {
                            var tag = 'h2';
                            var color = '';
                            if (myItem.options && myItem.options!==null && myItem.options['html-tag']  && myItem.options['html-tag']!==null) {
                                tag = myItem.options['html-tag'];
                            }

                            if (myItem.options && myItem.options!==null && myItem.options['color'] && myItem.options['color']!==null) {
                                color = ' color: ' +myItem.options['color'] +';';
                            }

                            var html = '<'+tag+' style=\' '+color+' \'>'+myItem.caption+'</'+tag+'>';

                            return $sce.trustAsHtml(html);
                        }

                        /**
                         * Funzione per massima lunghezza campo
                         */
                        $scope.calculateMaxLength = function(myItem) {
                            var maxLength = '';
                            if (myItem.options && myItem.options !== null && myItem.options['max-length'] && myItem.options['max-length'] !== null) {
                                maxLength = myItem.options['max-length'];
                            }
                            return maxLength;
                        };


                        /**
                         * Ritorna il massimo valore numerico per il campo, se indicato nelle opzioni
                         */
                        $scope.calculateMaxValue = function(myItem) {
                            if (myItem && myItem.options) {
                                if (myItem.options['max-value'] || myItem.options['max-value']===0) {
                                    return myItem.options['max-value'];
                                }
                            }
                            return null;
                        };



                        /**
                         * Ritorna il minimo valore numerico per il campo, se indicato nelle opzioni
                         */
                        $scope.calculateMinValue = function(myItem) {
                            if (myItem && myItem.options) {
                                if (myItem.options['min-value'] || myItem.options['min-value']===0) {
                                    return myItem.options['min-value'];
                                }
                            }
                            return null;
                        };



                        /**
                         * Ritorna il valore degli step di incremento per il campo, se indicato nelle opzioni
                         */
                        $scope.calculateStepValue = function(myItem) {
                            if (myItem && myItem.options) {
                                if (myItem.options['step-value'] || myItem.options['step-value']===0) {
                                    return myItem.options['step-value'];
                                }
                            }
                            return null;
                        };



                        /**
                         * Funzione che torna true se campo obbligatorio
                         */
                        $scope.calculateRequired = function(myItem) {
                            if (myItem.options && myItem.options !== null && myItem.options['required'] && myItem.options['required'] !== null) {
                                return myItem.options['required'];
                            }
                            return false;
                        };


                        /**
                         * Funzione che ritorna il pattern di validazione per un campo
                         */
                        $scope.calculatePattern = function(myItem) {
                            if (myItem.options && myItem.options !== null && myItem.options['validation-mask'] && myItem.options['validation-mask'] !== null) {
                                return myItem.options['validation-mask'];
                            }
                            return '';
                        };


                        /**
                         * Calcola la percentuale di completamento della compilazione
                         */
                        $scope.calculateCompletionRatio = function() {
                            var campiTot = $scope.fieldsRequired.length;    // numero di campi required totali
                            var campiCompilati = 0;                         // numero di campi compilati

                            // se non ho campi obbligatori, è già al 100%
                            if (campiTot === 0) {
                                return 100;
                            } else {
                                // per ogni campo required
                                _.each($scope.fieldsRequired, function(reqFieldName) {
                                    // se il campo required è disabilitato, non lo considera
                                    if (!$scope.isFieldEnabled(reqFieldName)) {
                                        campiTot--;
                                    } else if ((typeof $scope.myModel[reqFieldName] !== 'undefined') &&
                                        $scope.myModel[reqFieldName] !== null &&
                                        $scope.myModel[reqFieldName] !== '') {
                                        // se il campo è abilitato e compilato, aggiunge il campo al conto
                                        campiCompilati++;
                                    }
                                });
                                if (campiTot > 0) {
                                    return Math.round(Number(campiCompilati * 100 / campiTot));
                                } else {
                                    return 100;
                                }
                            }
                        };



                        /**
                         * Calcola la percentuale di completamento della compilazione di pagina di wizard
                         */
                        $scope.calculatePageCompletionRatio = function(pageId) {

                            if (!$scope.wizardPages || !$scope.wizardPages[pageId]) {
                                return 100;
                            }

                            var wizardPageId = $scope.wizardPages[pageId];
                            if (!wizardPageId || !$scope.fieldsRequiredForPage[wizardPageId] || $scope.fieldsRequiredForPage[wizardPageId].length===0) {
                                return 100;
                            }
                            $scope.fieldsRequiredForPage[wizardPageId]
                            var count = 0;
                            _.each($scope.fieldsRequiredForPage[wizardPageId], function(reqFieldName) {
                                if ($scope.myModel[reqFieldName] && reqFieldName[reqFieldName]!==null && $scope.myModel[reqFieldName]!=='') {
                                    count++;
                                }
                            });

                            return Math.round(Number(count*100/$scope.fieldsRequiredForPage[wizardPageId].length));
                        }

                        $scope.displayIfWizard = function(item) {
                            if ($scope.wizardPages.length===0) {//se il template non è organizzato a wizard mostro sempre
                                return true;
                            }
                            //altrimenti controllo se sono nella pagina corrente del wizard
                            if (item && item.wizardPage && item.wizardPage===$scope.currentWizardPage) {
                                return true;
                            }
                            return false;
//                    return true;
                        }

                        /**
                         * Controlla se un campo è abilitato o meno.
                         *
                         * @param {string} fieldName Nome del campo da controllare
                         */
                        $scope.isFieldEnabled = function(fieldName) {
                            if ($scope.fieldsDisabled && $scope.fieldsDisabled[fieldName]) {
                                return false;
                            } else {
                                return true;
                            }
                        };


                        /**
                         * Sposta il cursore al primo campo non compilato del documento.
                         */
                        $scope.goToFirstMissingField = function() {
                            for (var i = 0; i < $scope.fieldsRequired.length; i++) {
                                var reqFieldName = $scope.fieldsRequired[i];
                                if (!$scope.myModel[reqFieldName] || $scope.myModel[reqFieldName] == null || $scope.myModel[reqFieldName] === '') {
                                    $('#dyn-doc').animate({
                                        scrollTop: $('#dyndoc_' + reqFieldName).offset().top - $('#dyn-doc').offset().top + $('#dyn-doc').scrollTop() - 100
                                    }, 2000);
                                    break;
                                }
                            }
                        };

                        /**
                         * Sposta il cursore al primo campo non compilato del documento per pagina di wizard
                         */
                        $scope.goToFirstMissingFieldForPage = function(pageId) {

                            if (!$scope.wizardPages || !$scope.wizardPages[pageId]) {
                                return;
                            }

                            var wizardPageId = $scope.wizardPages[pageId];
                            if (!wizardPageId || !$scope.fieldsRequiredForPage[wizardPageId] || $scope.fieldsRequiredForPage[wizardPageId].length===0) {
                                return;
                            }

                            for (var i = 0; i < $scope.fieldsRequiredForPage[wizardPageId].length; i++) {
                                var reqFieldName=$scope.fieldsRequiredForPage[wizardPageId][i];
                                if (!$scope.myModel[reqFieldName] || $scope.myModel[reqFieldName]==null || $scope.myModel[reqFieldName]==='') {
                                    $('#dyn-doc').animate({
                                        scrollTop: $('#dyndoc_'+reqFieldName).offset().top -  $('#dyn-doc').offset().top +  $('#dyn-doc').scrollTop() - 100
                                    }, 2000);
                                    break;
                                }
                            }

                        }


                        /**
                         * Formattazione data
                         * @param date
                         * @returns {*}
                         */
                        $scope.formatDate = function(date) {
                            if (!date || date === null) {
                                return '-';
                            }
                            return moment(date).format('DD/MM/YYYY');
                        };


                        $scope.decodeChoice = function(item, val) {
                            var choices = myTemplateStructure[item.name].choices;
                            for (var i = 0; i < choices.length; i++) {
                                if (choices[i].uuid === val) {
                                    return choices[i].caption;
                                }
                            }
                            return '';
                        };



                        $scope.decodeScaleChoice = function(item, val) {
                            var choices = myTemplateStructure[item.name].choices;
                            for (var i = 0; i < choices.length; i++) {
                                if (choices[i].value == val) {
                                    return choices[i].caption;
                                }
                            }
                            return '';
                        };


                        /**
                         * Mostra una modale con i suggerimenti per un campo.
                         * @param myItem
                         */
                        $scope.showModalHint = function(myItem) {
                            if (myItem.options && myItem.options !== null && myItem.options['modal-hint-html'] && myItem.options['modal-hint-html'] !== null) {

                                var htmlString = myItem.options['modal-hint-html'];
                                htmlString = htmlString.replace('$accessToken', LoopBackAuth.accessTokenId);
                                var dialog = $mdDialog.alert({
                                    clickOutsideToClose: true,
                                    escapeToClose: true,
                                    onComplete: function(scope, element) {
                                        //piccolo accrocchio per rendere non scaricabile l'immagine
                                        $("img").on("contextmenu", function() {
                                            return false;
                                        });
                                    }
                                }).title('')
                                    .htmlContent(htmlString)
                                    .ok('Close');
                                $mdDialog.show(dialog).finally(function() {
                                    alert = undefined;
                                });
                            }
                        };


                        /**
                         * Mostra l'eventuale immagine che aiuta la compilazione di un campo
                         * @param myItem
                         */
                        $scope.showImageHint = function(myItem) {
                            if (myItem.options && myItem.options !== null && myItem.options['image-hint'] && myItem.options['image-hint'] !== null) {
                                var pswpElement = document.querySelectorAll('.pswp')[0];

                                var htmlString = myItem.options['image-hint'];
                                htmlString = htmlString.replace('$accessToken', LoopBackAuth.accessTokenId);


                                // build items array
                                var items = [{
                                    src: htmlString,
                                    w: window.innerWidth - 60,
                                    h: window.innerHeight - 60,
                                }];

                                // define options (if needed)
                                var options = {
                                    // optionName: 'option value'
                                    // for example:
                                    index: 0, // start at first slide
                                    bgOpacity: 0.5
                                };

                                // Initializes and opens PhotoSwipe
                                var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                                gallery.listen('imageLoadComplete', function(index, item) {
                                    $timeout(function() {
                                        $(".pswp__img").on("contextmenu", function() {
                                            return false;
                                        });
                                    }, 500);
                                });
                                gallery.init();
                            }
                        };


                        /**
                         * Funzione che processa le regole: se myItem non è definito le processa tutte
                         */
                        $scope.processRules = function(myItem) {
                            $('md-radio-group').off('keydown');

                            //cerco le regole di pertinenza del campo
                            _.each(fieldRules, function(rule) {
                                if (!myItem || rule.fieldToWatch === myItem.name) {
                                    // VALUTO L'ESPRESSIONE
                                    if ('enable' === rule.action) {
                                        $scope.fieldsDisabled[rule.subject] = !(eval(rule.expression));
                                    } else if ('disable' === rule.action.toLowerCase()) {
                                        $scope.fieldsDisabled[rule.subject] = (eval(rule.expression));
                                    } else if ('clear' === rule.action) {
                                        if (eval(rule.expression)) {
                                            $scope.myModel[rule.subject] = null;
                                        }
                                    } else if ('focus' === rule.action) {
                                        if (eval(rule.expression)) {
                                            $timeout(function() {
                                                $('#dyndoc_' + rule.subject).focus();
                                            }, 200);

                                        }
                                    }
                                    //TODO altre implementazioni
                                }
                            });
                        };



                        /**
                         * Evento da lanciare quando un campo cambia di valore.
                         *
                         * @param field
                         * @param item elemento selezionato, se applicabile
                         */
                        $scope.fieldChanged = function(field, item) {
                            $log.debug('fieldChanged()');
                            // in caso di textLookup
                            if (field && field.type && field.type.toLowerCase() === 'textlookup') {
                                // imposta il valore selezionato nel model del documento
                                $scope.myModel[field.name] = item[field.options.dataSource.valueField];
                                // imposta i selectedItems in base alla selezione
                                $scope.textLookupSetSelectedItems(field, item);
                            }
                            // per tutti i campi che hanno questo campo come parentElement,
                            // e che hanno una sorgente esterna di dati
                            _.each(flattenedFields, function(currentField) {
                                if (currentField && currentField.options &&
                                    currentField.options.parentElement &&
                                    currentField.options.parentElement === field.name) {
                                    if ($scope.hasExternalData(currentField)) {
                                        // ne aggiorno i dati (filtrandoli per il valore di parentElement)
                                        $scope.lookupDataStatus = 'loading';
                                        $scope.lookupDataLoading++;
                                        $scope.loadExternalData(currentField, function(data) {
                                            $scope.lookupDataLoading--;
                                            // sblocca il semaforo quando ha finito
                                            if ($scope.lookupDataLoading === 0) {
                                                $scope.lookupDataStatus = null;
                                            }
                                        });
                                    }
                                }
                            });
                            // applica regole da onChange
                            $scope.executeOnChange(field);
                            // applica le regole
                            $scope.processRules(field);
                        };


                        /**
                         * Esegue l'azione di setValue per impostare un valore ad un campo
                         *
                         * @param myItem
                         * @param action
                         */
                        $scope.executeOnChangeActionSetValue = function(myItem, action) {
                            $log.debug('$scope.executeOnChangeActionSetValue()');
                            if (action.target && action.origin) {
                                // se l'origine è un valore statico, lo imposta subito
                                if (action.origin.toLowerCase() === 'value' && action.value) {
                                    //$log.debug('Imposto valore ' + action.value + ' a campo ' + action.origin);
                                    myModel[action.target] = action.value;
                                }
                                // se l'origine è un campo del dataSource e il campo è radio o select
                                else if (action.origin.toLowerCase() === 'datasource' && action.field &&
                                    (myItem.type.toLowerCase() === 'radio' || myItem.type.toLowerCase() === 'select')) {
                                    // in myModel[myItem.name] ho il valore selezionato
                                    var valoreSelezionato = myModel[myItem.name];
                                    // $log.debug('valoreSelezionato: ' + valoreSelezionato);
                                    // $log.debug('flattenedFields:');
                                    // $log.debug(flattenedFields);
                                    // $log.debug('myItem:');
                                    // $log.debug(myItem);
                                    // estraggo l'elemento del datasource che corrisponde al valore selezionato
                                    var dataItemSelezionato = _.find(myItem.allData, function(dataItem) {
                                        return dataItem && action && myItem.options.dataSource.valueField &&
                                            dataItem[myItem.options.dataSource.valueField] === valoreSelezionato;
                                    });
                                    // $log.debug('dataItemSelezionato:');
                                    // $log.debug(dataItemSelezionato);
                                    // estraggo dall'elemento il campo indicato in myItem[action.field]
                                    if (dataItemSelezionato) {
                                        // imposto il campo di destinazione con il valore appena estratto
                                        myModel[action.target] = dataItemSelezionato[action.field];
                                    }
                                }
                                // se l'origine è un campo del dataSource e il campo ha deii selectedItems, usa quello (textLookup)
                                else if (action.origin.toLowerCase() === 'datasource' && action.field &&
                                    myItem.selectedItems && myItem.selectedItems.length > 0) {
                                    var elemento = _.first(myItem.selectedItems);
                                    if (elemento && elemento[action.field]) {
                                        //$log.debug('Imposto valore del campo ' + action.field + ' (' + elemento[action.field] + ') a campo ' + action.origin);
                                        myModel[action.target] = elemento[action.field];
                                    } else {
                                        $log.warning('Impossibile leggere il valore dell\'elemento selezionato');
                                        $log.warning(elemento);
                                    }
                                } else {
                                    $log.debug('action non gestita: ');
                                    $log.debug(action);
                                    $log.debug(myItem);
                                }
                            }
                        };


                        /**
                         * Esegue un'azione di un evento onChange
                         *
                         * @param myItem
                         * @param action
                         */
                        $scope.executeOnChangeAction = function(myItem, action) {
                            $log.debug('$scope.executeOnChangeAction()');
                            if (action && action.action) {
                                switch (action.action.toLowerCase()) {
                                    case 'setvalue':
                                        $scope.executeOnChangeActionSetValue(myItem, action);
                                        break;
                                    default:
                                        $log.debug('Action unknown: ' + action.action);
                                }
                            }
                        };


                        /**
                         * Esegue le azioni indicate nell'evento onChange del campo
                         *
                         * @param myItem Campo oggetto della funzione
                         */
                        $scope.executeOnChange = function(myItem) {
                            $log.debug('$scope.executeOnChange()');
                            if (myItem && myItem.options && myItem.options.onChange &&
                                Array.isArray(myItem.options.onChange)) {
                                // scorre tutte le regole
                                for (var i = 0; i < myItem.options.onChange.length; i++) {
                                    $scope.executeOnChangeAction(myItem, myItem.options.onChange[i]);
                                }
                            }
                        };


                        /**
                         * Ritorna i dati filtrati in base alla configurazione del campo
                         */
                        $scope.getTextLookupFilteredData = function(myItem, allData, searchText) {
                            $log.debug('$scope.getTextLookupFilteredData()');
                            //$log.debug(allData);
                            //$log.debug(searchText);
                            //return allData;
                            var r = [];
                            var item = null;
                            if (myItem.options && myItem.options.dataSource && myItem.options.dataSource.labelField &&
                                myItem.options.dataSource.valueField) {
                                var labelField = myItem.options.dataSource.labelField;
                                var valueField = myItem.options.dataSource.valueField;
                                for (var i = 0; i < allData.length; i++) {
                                    if (allData && allData[i] && allData[i][labelField] && searchText) {
                                        //$log.debug(allData[i]);
                                        //$log.debug('Confronto ' + allData[i][labelField].toLowerCase() + ' con ' + searchText.toLowerCase());
                                        if (allData[i][labelField].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                                            item = {};
                                            item[labelField] = allData[i][labelField];
                                            item[valueField] = allData[i][valueField];
                                            // se indicato, aggiungo il campo del filtro dell'elemento padre, così posso filtrarlo
                                            if (myItem.options.parentElement && myItem.options.dataSource.parentFilterField) {
                                                item[myItem.options.dataSource.parentFilterField] = allData[i][myItem.options.dataSource.parentFilterField];
                                            }
                                            r.push(item);
                                            //$log.debug('Aggiunto ' + allData[i][labelField]);
                                        }
                                    }
                                }
                                // elimina i duplicati
                                if (myItem.options && myItem.options.dataSource &&
                                    myItem.options.dataSource.removeDuplicates &&
                                    myItem.options.dataSource.removeDuplicates.toLowerCase() === "true") {
                                    r = _.uniq(r, labelField);
                                }
                                // filtra per il campo del parentField, se indicato
                                if (myItem.options.parentElement && myItem.options.dataSource.parentFilterField) {
                                    r = $scope.filterParentFieldData(r, myItem.options.dataSource.parentFilterField, myModel[myItem.options.parentElement]);
                                }
                            }
                            //$log.debug('Ritorno: ');
                            //$log.debug(r);
                            return r;
                        };


                        /**
                         * Ritorna i dati che corrispondono con quanto digitato da un campo di tipo textLookup,
                         * in base alla sua sorgente di dati.
                         *
                         * @param myItem
                         * @param searchText
                         * @returns {*[]}
                         */
                        $scope.getTextLookupData = function(myItem, searchText) {
                            $log.debug('$scope.getTextLookupData()');
                            var deferred = $q.defer();

                            // se non ho ancora i dati, li carico; poi fintro in base al testo digitato
                            if (!myItem.dataFetchStarted) {
                                myItem.dataFetchStarted = true;
                                // se ho un dataSource
                                if (myItem && myItem.options && myItem.options.dataSource) {
                                    myItem.allData = [];
                                    // se è di tipo URL, legge il dato
                                    if (myItem.options.dataSource.type && myItem.options.dataSource.source &&
                                        myItem.options.dataSource.type.toLowerCase() === 'url') {
                                        // effettua chiamata all'API dei dati
                                        $http.get(myItem.options.dataSource.source).then(
                                            function success(res) {
                                                myItem.allData = res.data.items;
                                                deferred.resolve($scope.getTextLookupFilteredData(myItem, myItem.allData, searchText));
                                            }, function failed(res) {
                                                $log.error('Interrogazione API fallita: ' + myItem.options.dataSource.source);
                                                $log.warn(res);
                                                deferred.reject();
                                            }
                                        );
                                    } else {
                                        $log.debug('datasource sconosciuto:');
                                        $log.warn(JSON.stringify(myItem.options.dataSource));
                                        deferred.reject();
                                    }
                                } else {
                                    $log.debug('non ho un datasource specificato');
                                    $log.warn(myItem);
                                    deferred.reject();
                                }
                            } else {
                                deferred.resolve($scope.getTextLookupFilteredData(myItem, myItem.allData, searchText));
                            }
                            return deferred.promise;
                        };


                        /**
                         * Imposta il campo selectedItems con tutti gli elementi di allData che corrispondono alla
                         * selezione effettuata.
                         *
                         * @param myItem
                         * @param item
                         */
                        $scope.textLookupSetSelectedItems = function(myItem, item) {
                            $log.debug('$scope.textLookupSetSelectedItems()');
                            myItem.selectedItems = [];
                            if (myItem && myItem.options && myItem.options.dataSource &&
                                myItem.options.dataSource.valueField && item[myItem.options.dataSource.valueField]) {
                                // per ogni elemento di allItem
                                for (var i = 0; i < myItem.allData.length; i++) {
                                    // se corrisponde al valore selezionato, aggiungilo
                                    if (myItem.allData[i][myItem.options.dataSource.valueField] === item[myItem.options.dataSource.valueField]) {
                                        myItem.selectedItems.push(myItem.allData[i]);
                                    }
                                }
                            }
                        };


                        /**
                         * Ritorna una stringa casuale
                         *
                         * @param stringLength
                         * @returns {string}
                         */
                        function randomString(stringLength) {
                            var text = "";
                            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

                            for (var i = 0; i < stringLength; i++)
                                text += possible.charAt(Math.floor(Math.random() * possible.length));

                            return text;
                        }



                        /**
                         * Esplora il template ritornando un oggetto piatto con chiave nome campo e valore le caratteristiche salienti
                         */
                        function _retrieveTemplateInfo( items) {
                            _.each(items, function (item) {
                                // $log.debug('Esamino campo: ' + item.name );
                                flattenedFields.push(item);
                                if (item.name && item.name !== null) {
                                    myTemplateStructure[item.name] = {
                                        type: item.type,
                                        multiple: item.multiple,
                                        choices: item.choices
                                    };
                                }
                                if (item.type && item.type==='group') {
                                    if (item.options && item.options!==null && item.options['wizard-page-id']  && item.options['wizard-page-id']!==null && item.options['wizard-page-id']!=='') {
                                        var found = false;
                                        $scope.wizardPages.push(item.options['wizard-page-id']);
                                        if ($scope.wizardPages.length===1) {
                                            $scope.currentWizardPage=$scope.wizardPages[0];
                                        }
                                    }
                                    _retrieveTemplateInfo( item.items);
                                } else {
                                    //NE METTO IL VALORE PER LA TRADUZIONE
                                    var varName = randomString(20);
                                    variableFields.push({variable: varName, field: item.name});
                                }

                                //TENGO TRACCIA SE è OBBLIGATORIO
                                if ($scope.calculateRequired(item)) {
                                    $scope.fieldsRequired.push(item.name);
                                    if ($scope.wizardPages.length>0) {
                                        var wizardPage=$scope.wizardPages[$scope.wizardPages.length-1];
                                        if (!$scope.fieldsRequiredForPage[wizardPage]) {
                                            $scope.fieldsRequiredForPage[wizardPage]=[];
                                        }
                                        $scope.fieldsRequiredForPage[wizardPage].push(item.name);
                                    }
                                }

                                if ($scope.wizardPages.length>0) {
                                    item.wizardPage=$scope.wizardPages[$scope.wizardPages.length-1];
                                }


                                //SE CI SONO REGOLE LE RACCOLGO (NELLE STATISTICHE SKIPPO XK NON MI SERVE)
                                if (!$scope.isStatsMode && item.options && item.options!==null && item.options.rules  && item.options.rules!==null) {
                                    _.each(item.options.rules, function (rule) {
                                        //scorro le azioni della regola
                                        if (rule.actions && rule.actions!==null) {
                                            //....per ogni azione
                                            _.each(rule.actions, function(a) {
                                                //se actions è 'enable' vado a mettere disabled di default il rispettivo campo (subject)

                                                //preparo l'oggetto da salvare in fieldRules
                                                var myRule = {
                                                    subject: a.subject,
                                                    action: a.action
                                                };

                                                //valuto l'espressione
                                                var tokens = rule.when.split(' ');
                                                //per ora supportiamo solo la singola condizione TODO
                                                myRule.fieldToWatch=tokens[0];
                                                // la regola per verificare se il campo è vuoto controlla più cose
                                                if (tokens[1] === 'ISEMPTY') {
                                                    myRule.expression = '!$scope.myModel[\'' + myRule.fieldToWatch + '\']';
                                                } else if (tokens[1] === 'ISNOTEMPTY') {
                                                    myRule.expression = '$scope.myModel[\'' + myRule.fieldToWatch + '\']';
                                                } else {
                                                    myRule.expression = '';
                                                    myRule.expression += '$scope.myModel[\'' + myRule.fieldToWatch + '\']';
                                                    if (tokens[1] === 'EQ') {
                                                        myRule.expression += '===';
                                                    } else if (tokens[1] === 'NEQ') {
                                                        myRule.expression += '!==';
                                                    } else if (tokens[1] === 'LT') {
                                                        myRule.expression += '<';
                                                    } else if (tokens[1] === 'GT') {
                                                        myRule.expression += '>';
                                                    }
                                                    myRule.expression += tokens[2];
                                                }

                                                //TODO gestire altri operatori
                                                fieldRules.push(myRule);
                                            });

                                        }
                                    });

                                }

                            });
                        }

                        /**
                         * Normalizza il modello ricevuto
                         */
                        function _normalizeModel() {
                            _.each(_.keys(myModel), function(key) {

                                var fieldValue = myModel[key];
                                if (fieldValue && fieldValue !== null) {
                                    //se DATE la normalizzo
                                    if (myTemplateStructure[key] && myTemplateStructure[key] !== null && myTemplateStructure[key].type === 'date') {
                                        myModel[key] = new Date(fieldValue);
                                    } else if (myTemplateStructure[key] && myTemplateStructure[key] !== null && myTemplateStructure[key].type === 'number') {
                                        try {
                                            myModel[key] = Number(fieldValue);
                                        } catch (e) {
                                            $log.debug('Errore di conversione a numero: ' + e);
                                        }
                                    }
                                    //SE CB li metto a bool true anche se hanno valore string "true"
                                    else if (myTemplateStructure[key] && myTemplateStructure[key] !== null && myTemplateStructure[key].type === 'checkbox') {
                                        if (fieldValue === 'true') {
                                            myModel[key] = true;
                                        }
                                    }
                                    //SE ARRAY LO TRASFORMO IN OGGETTO
                                    if (Array.isArray(fieldValue)) {
                                        var myNormalizedArray = {};
                                        for (var i = 0; i < fieldValue.length; i++) {
                                            myNormalizedArray[i.toString()] = fieldValue[i];
                                        }
                                        myModel[key] = myNormalizedArray;
                                    }
                                    //SE MULTIPLO LO INIZIALIZZO
                                    if (myTemplateStructure[key] && myTemplateStructure[key] !== null && myTemplateStructure[key].multiple) {
                                        _initializeMultipleSize(key);
                                        var array = myModel[key];
                                        for (var x = 0; x < _.keys(array).length; x++) {
                                            var obj = array[x];
                                            _.each(_.keys(obj), function(objkey) {

                                                var fieldValue = obj[objkey];
                                                if (fieldValue && fieldValue !== null) {
                                                    //se DATE la normalizzo
                                                    if (myTemplateStructure[objkey] && myTemplateStructure[objkey] !== null && myTemplateStructure[objkey].type === 'date') {
                                                        obj[objkey] = new Date(fieldValue);
                                                    } else if (myTemplateStructure[objkey] && myTemplateStructure[objkey] !== null && myTemplateStructure[objkey].type === 'number') {
                                                        try {
                                                            myModel[objkey] = Number(fieldValue);
                                                        } catch (e) {
                                                            $log.debug('Errore di conversione a numero: ' + e);
                                                        }
                                                    }

                                                }
                                            });

                                        }
                                        multipleCollectionsBackup[key] = angular.copy(myModel[key]); //BACKUP DEI DATI PER PREVENIRE ERRORI CON I NG_REPEAT
                                    }


                                }

                            });
                        }


                        /**
                         * Prepara il modello (una copia apposita) prima del salvataggio
                         */
                        function _normalizeModelForSave() {
                            _.each(_.keys(modelToSave), function(key) {

                                // se campo multiplo trasformo gli oggetti in array di valori
                                if (myTemplateStructure[key] && myTemplateStructure[key] !== null && myTemplateStructure[key].multiple) {
                                    if (modelToSave[key] && modelToSave[key] !== null) {
                                        modelToSave[key] = _.values(modelToSave[key]);
                                    }
                                }

                            });
                        }


                        /**
                         * funzione che ha lo scopo di inizializzare gli ngrepeat dei campi
                         * ripetuti al giusto size
                         */
                        function _initializeMultipleSize(itemName) {
                            if (angular.isDefined(multipleCollectionsBackup[itemName])) return;
                            //$log.debug(myModel[itemName]);
                            var myLength = Object.keys(myModel[itemName]).length;
                            if (!angular.isDefined($scope.fieldCounter[itemName])) {
                                $scope.fieldCounter[itemName] = [];
                            }
                            for (var i = 0; i < myLength; i++) {
                                $scope.fieldCounter[itemName].push('');
                            }
                        }


                        /***** statistiche
                         *
                         *
                         */
                        $scope.chartOptions = {
                            refreshDataOnly: true,
                            deepWatchData: false
                        };


                        /**
                         * Funzione che inizializza le opzioni dei grafici
                         */
                        function _initCharts() {
                            //
                            //  1 . CHART OPTIONS
                            //
                            $scope.chartOptions = {};
                            //scorro myStats: per ogni campo recupero il tipo di grafico e ne imposto le opzioni
                            //NOTA: bisogna farlo in maniera "statica" una tantum se no la direttiova nvd3 inizia
                            //a ricalcolare a ogni momento e il brower crasha

                            _.each(_.keys($scope.myStats), function(statName) {
                                // prendo le info del campo in questione
                                var type = myTemplateStructure[statName].type;

                                if (type === 'radio' || type === 'scale' || type === 'select') {

                                    //calcolo dinamicamente l'altezza
                                    var altezza = myTemplateStructure[statName].choices.length * 80;
                                    if (altezza > 500) altezza = 500;

                                    //colori
                                    var coloriDefault = ['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1', '#82B1FF', '#448AFF', '#2979FF'];
                                    var colori = null;
                                    if (type === 'scale') {
                                        colori = _.map(myTemplateStructure[statName].choices, function(c) {
                                            return c['background-color'] ? c['background-color'] : '#03a9f4';
                                        });
                                    } else {
                                        colori = _.first(coloriDefault, myTemplateStructure[statName].choices.length);
                                    }

                                    $scope.chartOptions[statName] = {
                                        chart: {
                                            type: 'multiBarHorizontalChart',
                                            color: colori,
                                            height: altezza,
                                            showControls: true,
                                            showValues: true,
                                            duration: 500,
                                            x: function(d) {
                                                return d.label;
                                            },
                                            y: function(d) {
                                                return d.value;
                                            },
                                            xAxis: {
                                                showMaxMin: false
                                            },
                                            yAxis: {
                                                axisLabel: "Values"
                                            }
                                        }
                                    };
                                }

                            });


                            //
                            //  1 . CHART OPTIONS
                            //
                            $scope.chartData = {};
                            //scorro myStats: per ogni campo recupero il tipo di grafico e ne imposto i valori a seconda del tipo di grafico
                            //NOTA: bisogna farlo in maniera "statica" una tantum se no la direttiova nvd3 inizia
                            //a ricalcolare a ogni momento e il brower crasha
                            _.each(_.keys($scope.myStats), function(statName) {
                                // prendo le info del campo in questione
                                var type = myTemplateStructure[statName].type;

                                if (type === 'scale' || type === 'radio' || type === 'select') {
                                    var data = [];
                                    var choices = myTemplateStructure[statName].choices;
                                    _.each(choices, function(choice) {
                                        var chiaveStatistica = (type === 'scale') ? choice.value.toString() : choice.uuid.toString(); //FIXME rivedere quando passiamo a uuid per tutti i campi
                                        var val = $scope.myStats[statName][chiaveStatistica]; //valore corrispondente estratto dalla statistca
                                        if (!val) {
                                            val = 0;
                                        }
                                        data.push({
                                            key: choice.caption,
                                            values: [{
                                                "label": "",
                                                "value": val
                                            }]
                                        });

                                    });

                                    $scope.chartData[statName]=data;

                                }


                            });
                        }


                        $scope.calculateFormula = function(myItem) {
                            var formula = myItem.options.formula;
                            formula = fixFormulaWithVariables(formula);
                            var c = $scope.parser.parse(formula);
                            $scope.myModel[myItem.name] = c.result;
                            return c.result;
                        }

                        function fixFormulaWithVariables(formula) {
                            //cerco le sottostringhe tra graffe
                            var matches = formula.match(/(?:\{)[^\{\}]*?(?:\})/g);

                            if (!matches) {
                                return formula;
                            }

                            for (var i = 0; i < matches.length; i++) {
                                var field = matches[i].substring(1, matches[i].length - 1);
                                //cerco il replacement
                                var varTraslation = _.find(variableFields, function(v) {
                                    return v.field === field;
                                });
                                if (!varTraslation) {
                                    continue;
                                }
                                //sostituisco
                                formula = formula.split(matches[i]).join(varTraslation.variable);
                                $scope.parser.setVariable(varTraslation.variable, Number($scope.myModel[field]));

                            }
                            //$log.debug("FORMULA: " + formula);
                            return formula;
                        }


                        function createFormulaParser() {
                            $scope.parser = new formulaParser.Parser();
                            $scope.parser.on('callVariable', function(name, done) {
                                var value = $scope.parser.getVariable(name);
                                //                        $log.debug('--> '+name +' = ' + value);
                                done(value);
                            });
                            return $scope.parser;
                        }


                        /** FINE STATISTICHE ****/
                        //EVENTO PER SALVARE LA FORM DA FUORI
                        var dyndocSaveCleanupFunc = $rootScope.$on('DYN-DOC-DO-SAVE', function(event, value) {

                            //SKIPPO SE NON MI RIGUARDA
                            if (!$scope.myModel) return;

                            if (value.documentId && value.documentId !== null) {
                                if ($scope.myModel.id != value.documentId) {
                                    return;
                                }
                            }

                            if (value.templateId && value.templateId !== null) {
                                if ($scope.myModel.templateId != value.templateId) {
                                    return;
                                }

                            }
                            $log.debug('--- Effettuo SAVE doc');

                            if (value.extradata) {
                                _.extend($scope.myModel, value.extradata);
                            }

                            $scope.saveData(value.action);
                        });


                        /**
                         * Metodo che invoca il servizio di salvataggio
                         */
                        $scope.saveData = function(action) {
                            $log.debug('$scope.saveData()');
                            modelToSave = angular.copy($scope.myModel);
                            _normalizeModelForSave();
                            var toSave = {
                                data: {
                                    document: modelToSave
                                }
                            };
                            if ($scope.template) {
                                toSave.data.template = {id: $scope.template.id};
                            }
                            $log.debug(JSON.stringify(toSave));
                            if (!$scope.myModel.id || $scope.myModel.id === null) {
                                $http.post($scope.saveDataUrl, toSave).then(function(succ) {
                                    // issue #450 ClubYourLife
                                    // ignoro se salvo un documento inesistente
                                    if (succ && succ.data && succ.data.data && succ.data.data.id) {
                                        $scope.myModel.id = succ.data.data.id;
                                        succ.completionPercentage = $scope.calculateCompletionRatio();
                                    } else {
                                        $scope.myModel.id = null;
                                        succ.completionPercentage = 100;
                                    }
                                    $scope.myForm.$setPristine();
                                    $scope.onSuccess({succ: succ, action: action});
                                }, function(err) {
                                    $scope.onError({err: err});
                                });
                            } else {
                                $http.patch($scope.saveDataUrl, toSave).then(function(succ) {
                                    succ.completionPercentage = $scope.calculateCompletionRatio();
                                    $scope.myForm.$setPristine();
                                    $scope.onSuccess({succ: succ, action: action});
                                }, function(err) {
                                    $scope.onError({err: err});
                                });
                            }
                        };



//                $scope.$on('$locationChangeStart', function(event, newUrl, oldUrl){
//                    if ($scope.myForm.$dirty) {
//                        event.preventDefault();
//                        $mdDialog.show({
//                            controller: DialogController,
//                            templateUrl: 'app/main/directives/dynamic-document/dialogs/back_confirm_dialog.html',
//                            parent: angular.element(document.body),
//                            clickOutsideToClose:true
//                        })
//                        .then(function(answer) {
//                            window.location.href=newUrl;
//                        }, function() { });
//                    }
//                  });

                        /**
                         * Funzione che controlla il back
                         */
                        $scope.goBack = function() {
//                    if ($scope.myForm.$dirty) {
//                        $mdDialog.show({
//                            controller: DialogController,
//                            templateUrl: 'app/main/directives/dynamic-document/dialogs/back_confirm_dialog.html',
//                            parent: angular.element(document.body),
//                            clickOutsideToClose:true
//                        })
//                        .then(function(answer) {
//                            $rootScope.$emit('DYN-DOC-EXIT', '');
//                        }, function() {});
//                    }
//                    else {
                            $rootScope.$emit('DYN-DOC-EXIT', '');
//                    }

                        }


                        /**
                         * Metodo che torna la classe del singolo di contenente un item in una riga
                         * width-perc è la larghezza in percentuale dell'elemento rispetto alla riga
                         * sono ammesse percentuali multiple di 5 e di 100/3 e 200/3
                         */
                        $scope.calculateClass = function(myItem) {
                            if (myItem.options && myItem.options !== null && myItem.options['width-perc'] && myItem.options['width-perc'] !== null) {
                                return 'ng-scope flex-' + myItem.options['width-perc'];
                            }
                            return 'ng-scope flex'; //'ng-scope layout-column';//'flex-20';//'ng-scope layout-row';
                        }

                        /**
                         * Cancella un elemento in sezioni ripetute
                         */
                        $scope.deleteRepeatedItem = function(modello, index, fieldCounter) {
                            fieldCounter.length = 0;

                            var values = _.values(modello);

                            if (index === values.length - 1) {
                                delete modello[index];
                            } else {

                                for (var i = index; i <= values.length - 2; i++) {

                                    var chiaviModello = _.keys(modello[i + 1]);
                                    if (chiaviModello && chiaviModello.length > 0) {
                                        _.each(chiaviModello, function(key) {
                                            modello[i][key] = modello[i + 1][key];
                                        });
                                    } else {
                                        modello[i] = angular.copy(modello[i + 1]);
                                    }

                                }
                                delete modello[values.length - 1];

                            }


                            for (var i = 0; i < values.length - 1; i++) {
                                fieldCounter.push(new Date());
                            }


                        };

                        /**
                         * Inizializza il modello per un gruppo
                         */
                        $scope.initModel = function(groupName, groupIndex) {
                            if (angular.isDefined(groupIndex)) {
                                if (!angular.isDefined($scope.myModel[groupName])) {
                                    $scope.myModel[groupName] = {};
                                }

                                $scope.myModel[groupName][groupIndex.toString()] = {};
                            }
                        }


                        $scope.$on('$destroy', function() {
                            if (dyndocEraseCleanupFunction) {
                                dyndocEraseCleanupFunction();
                            }
                            if (dyndocLoadTemplateCleanupFunc) {
                                dyndocLoadTemplateCleanupFunc();
                            }
                            if (dyndocShowWizCleanupFunc) {
                                dyndocShowWizCleanupFunc();
                            }
                            if (dyndocSaveCleanupFunc) {
                                dyndocSaveCleanupFunc();
                            }
                        });

                        function DialogController($scope, $mdDialog) {
                            $scope.hide = function() {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function() {
                                $mdDialog.cancel();
                            };
                            $scope.answer = function(answer) {
                                $mdDialog.hide(answer);
                            };
                        }

                    }
                ],

                link: function(scope, iElement, iAttrs, ctrl) {
                    scope.myModel = {};
                    scope.retrieveDataUrl = iAttrs.ngDataUrl;
                    scope.retrieveTemplateUrl = iAttrs.ngTemplateUrl;
                    scope.retrieveStatsUrl = iAttrs.ngStatsUrl;
                    scope.saveDataUrl = iAttrs.ngSaveUrl;
                    scope.isEditMode = (iAttrs.ngEditMode === 'true');
                    scope.fieldCounter = {};
                    scope.indexData = {};

                    scope.$on('$destroy', function() {
                        delete scope.myModel;
                    })

                    scope.$watch(function() {
                        return iAttrs.ngEditMode;
                    }, function(newValue) {
                        scope.isEditMode = (iAttrs.ngEditMode === 'true');
                    });

                    scope.$watch(function() {
                        return iAttrs.ngDataUrl;
                    }, function(newValue) {
                        scope.retrieveDataUrl = iAttrs.ngDataUrl;
                        scope.retrieveTemplateUrl = iAttrs.ngTemplateUrl;
                        scope.retrieveStatsUrl = iAttrs.ngStatsUrl;
                    });

                    scope.$watch(function() {
                        return iAttrs.ngTemplateUrl;
                    }, function(newValue) {
                        scope.retrieveDataUrl = iAttrs.ngDataUrl;
                        scope.retrieveTemplateUrl = iAttrs.ngTemplateUrl;
                        scope.retrieveStatsUrl = iAttrs.ngStatsUrl;
                    });

                    scope.$watch(function() {
                        return iAttrs.ngStatsUrl;
                    }, function(newValue) {
                        scope.retrieveDataUrl = iAttrs.ngDataUrl;
                        scope.retrieveTemplateUrl = iAttrs.ngTemplateUrl;
                        scope.retrieveStatsUrl = iAttrs.ngStatsUrl;
                    });

                    scope.$watch(function() {
                        return iAttrs.ngDoLoad;
                    }, function(newValue){
                        scope.getTemplateData();
                    });


                }
            }
        });
})();

(function ()
{
    'use strict';

    angular
        .module('app.designer-service',[])
        .factory('DesignerService', DesignerService);

    /** @ngInject */
    function DesignerService($q, msApi)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';
  angular
  .module('lowercase',[])
  .directive('lowercase', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var lowercase = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var lowercased = inputValue.toLowerCase();
          if (lowercased !== inputValue) {
            modelCtrl.$setViewValue(lowercased);
            modelCtrl.$render();
          }
          return lowercased;
        }
        modelCtrl.$parsers.push(lowercase);
        lowercase(scope[attrs.ngModel]); // lowercase initial value
      }
    };
  });
})();  
(function () {
  'use strict';

  var dd = angular.module('rorymadden.date-dropdowns', []);

  dd.factory('rsmdateutils', function () {
    var that = this,
        dayRange = [1, 31],
        months = [
          'JANUARY',
          'FEBRUARY',
          'MARCH',
          'APRIL',
          'MAY',
          'JUNE',
          'JULY',
          'AUGUST',
          'SEPTEMBER',
          'OCTOBER',
          'NOVEMBER',
          'DECEMBER'
        ];

    function changeDate (date) {
      if(date.day > 28) {
        date.day--;
        return date;
      } else if (date.month > 11) {
        date.day = 31;
        date.month--;
        return date;
      }
    };

    return {
      checkDate: function (date) {
        var d;
        if (!date.day || date.month === null || date.month === undefined || !date.year) return false;

        d = new Date(Date.UTC(date.year, date.month, date.day));
        
        if (d && (d.getMonth() === date.month && d.getDate() === Number(date.day))) {
          return d;
        }

        return this.checkDate(changeDate(date));
      },
      days: (function () {
        var days = [];
        while (dayRange[0] <= dayRange[1]) {
          days.push(dayRange[0]++);
        }
        return days;
      }()),
      months: (function () {
        var lst = [],
            mLen = months.length;

        for (var i = 0; i < mLen; i++) {
          lst.push({
            value: i,
            name: months[i]
          });
        }
        return lst;
      }())
    };
  })

  dd.directive('rsmdatedropdowns', ['rsmdateutils', function (rsmdateutils) {
    return {
      restrict: 'A',
      replace: true,
      require: 'ngModel',
      scope: {
        model: '=ngModel'
      },
      controller: ['$scope', 'rsmdateutils', function ($scope, rsmDateUtils) {
        $scope.days = rsmDateUtils.days;
        $scope.months = rsmDateUtils.months;

        $scope.dateFields = {};

        $scope.dateFields.day = new Date($scope.model).getUTCDate();
        $scope.dateFields.month = new Date($scope.model).getUTCMonth();
        $scope.dateFields.year = new Date($scope.model).getUTCFullYear();

        // Initialize with current date (if set)
        $scope.$watch('model', function (newDate) {
          if(newDate && newDate!==null) {
        	var momDate = moment(newDate);
            $scope.dateFields.day = momDate.date();   //new Date(newDate).getUTCDate();
            $scope.dateFields.month = momDate.month();//new Date(newDate).getUTCMonth();
            $scope.dateFields.year =  momDate.year(); //new Date(newDate).getUTCFullYear();
          }
          else {
        	  $scope.dateFields.day=null;
        	  $scope.dateFields.month=null;
        	  $scope.dateFields.year=null;
          }
        });

        $scope.checkDate = function () {
          var date = rsmDateUtils.checkDate($scope.dateFields);
          
          if ($scope.denyFutureDates && date>new Date()) {
        	  date=new Date();
          }
          if (date) {
            $scope.model = date;
          }
        };
      }],
      template:
      '<div layout="row" div class="md-inline-form" style="border:none;">' +
      '  <md-input-container>' +
      '     <md-select name="dateFields.day" data-ng-model="dateFields.day" placeholder="{{ \'DAY\' | translate }}" class="form-control" ng-change="checkDate()" ng-disabled="disableFields">' +
      '        <md-option ng-repeat="day in days">{{day}}</md-option>' +
      '     </md-select>' +
      '  </md-input-container>' +
      '  <md-input-container>' +
      '     <md-select name="dateFields.month" data-ng-model="dateFields.month" placeholder="{{ \'MONTH\' | translate }}" class="form-control" ng-change="checkDate()" ng-disabled="disableFields">' +
      '			<md-option ng-value="month.value" ng-selected="{{ month.value === dateFields.month ? \'true\' : \'false\' }}" ng-repeat="month in months track by month.value">{{month.name | translate}}</md-option>' +
      '     </md-select>' +      
      '  </md-input-container>' +
      '  <md-input-container>' +
      '     <md-select ng-if="!yearText" name="dateFields.year" data-ng-model="dateFields.year" placeholder="{{ \'YEAR\' | translate }}" class="form-control" ng-change="checkDate()" ng-disabled="disableFields">' +
      '        <md-option ng-repeat="year in years">{{year}}</md-option>' +
      '     </md-select>' +      
      '    <input ng-if="yearText" type="text" name="dateFields.year" data-ng-model="dateFields.year" placeholder="Year" class="form-control" ng-disabled="disableFields">' +
      '  </md-input-container>' +
      '</div>',
      link: function (scope, element, attrs, ctrl) {
        var currentYear = parseInt(attrs.startingYear, 10) || new Date().getFullYear(),
            numYears = parseInt(attrs.numYears,10) || 120,
            oldestYear = currentYear - numYears,
            overridable = [
              'dayDivClass',
              'dayClass',
              'monthDivClass',
              'monthClass',
              'yearDivClass',
              'yearClass'
            ],
            required;

        scope.years = [];
        scope.yearText = attrs.yearText ? true : false;
        scope.denyFutureDates = attrs.denyFutureDates ? true : false;

        if (attrs.ngDisabled) {
          scope.$parent.$watch(attrs.ngDisabled, function (newVal) {
            scope.disableFields = newVal;
          });
        }

        if (attrs.required) {
          required = attrs.required.split(' ');

          ctrl.$parsers.push(function (value) {
            angular.forEach(required, function (elem) {
              if (!angular.isNumber(elem)) {
                ctrl.$setValidity('required', false);
              }
            });
            ctrl.$setValidity('required', true);
          });
        }

        for (var i = currentYear; i >= oldestYear; i--) {
          scope.years.push(i);
        }

        (function () {
          var oLen = overridable.length,
              oCurrent,
              childEle;
          while (oLen--) {
            oCurrent = overridable[oLen];
            childEle = element[0].children[Math.floor(oLen / 2)];

            if (oLen % 2 && oLen != 2) {
              childEle = childEle.children[0];
            }

            if (attrs[oCurrent]) {
              angular.element(childEle).attr('class', attrs[oCurrent]);
            }
          }
        }());
      }
    };
  }]);
}());
(function ()
{
    'use strict';
  angular
  .module('capitalize',[])
  .directive('capitalize', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        }
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  });
})();  
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController( ChatsService, $scope, $rootScope, $mdSidenav, $log, User, PubSub, $timeout, $document, $mdMedia, OfferedService, _, UserRelation, Organization,
                             Notification, AuthenticationService, AlertMessageService, CylNotifier, SocketIOPath, LoopBackAuth, $location, ApiPath, NotificationChannel )
    {

        var vm = this;

        // Data
        vm.contacts = [];
        vm.children = [];
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = [];
        vm.chatSearch='';
        vm.filteredChat=[];
        vm.filteredContact=[];
        vm.currentContact = null;
        vm.chatPage = 0;
        vm.contactSearch = '';
        var socket = null;
        vm.isChildChat=false;
        vm.child=null;
        vm.loadingContacts = false;
        vm.currentChatService = null;
        vm.currentUser = null;

        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;
        vm.sendMessage = sendMessage;
        vm.searchUser = searchUser;
        vm.addAndGetChat = addAndGetChat;
        vm.apiPath = ApiPath;
        vm.goOffline=goOffline;
        vm.viewChildChat=viewChildChat;
        vm.reloadChat=reloadChat;
        vm.backToUserChat=backToUserChat;
        vm.loadGroupSubscribers=loadGroupSubscribers;
        vm.loadOrganizationGroupMembers = loadOrganizationGroupMembers;
        vm.formatDate=formatDate;
        //////////


        function init() {
            if (AuthenticationService.isAuthenticated()){
                vm.currentUserId = User.getCurrentId();
                AuthenticationService.getLoggedUserDataFromServer(User.getCurrentId()).then(
                    function(data){
                        vm.currentUser = data;
                        _initChatView(vm.currentUserId);
                    }
                );


            } else {
                $state.go('app.pages_auth_login');
            }


            $rootScope.$on('CHAT_INIT', function (event, valore) {
                $log.debug("Login event detected");
                initChatSockets();
            });
            if (AuthenticationService.isAuthenticated()){
                initChatSockets();
            }


        }

        init();


        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contact)
        {
            //
            vm.chatPage=0;
            vm.currentContact=contact;
            _loadChat();

        }

        function addAndGetChat(contact) {
            var found = _.find(vm.contacts, function(c) {
                return (c.id == contact.id && c.type === contact.type);
            });
            if (!found) {
                vm.contacts.push(contact);
            }
            getChat(contact);
        }

        function _loadChat()
        {
            //
            if (vm.chatPage===0) {
                vm.chat=[];
            }

            var whereClause = {
                and : [
                    {status: {neq: 'D'}},
                    {notificationType: 'CHAT'},
                    {or : [
                            {and: [{senderId: vm.currentContact.id},{recipientId: vm.currentUserId}]},
                            {and: [{senderId: vm.currentUserId},{recipientId: vm.currentContact.id}]}
                        ]}
                ]
            };

            if (vm.currentContact.type==='O') {
                whereClause = {
                    and : [
                        {status: {neq: 'D'}},
                        {notificationType: 'CHAT'},
                        {senderOrganizationId: vm.currentContact.id}
                    ]
                };

            }
            else if (vm.currentContact.type==='S') {
                if (vm.currentContact.groupType === 'G') {
                    whereClause = {
                        and : [
                            {status: {neq: 'D'}},
                            {notificationType: 'CHAT'},
                            {senderOfferedServiceId: vm.currentContact.id}
                        ]
                    };
                } else if (vm.currentContact.groupType === 'B') {
                    whereClause = {
                        and : [
                            {status: {neq: 'D'}},
                            {notificationType: 'CHAT'},
                            {senderId: vm.currentUserId},
                            {recipientId: null},
                            {broadcastChatServiceId: vm.currentContact.id}
                        ]
                    };
                }
            }

            var query ={
                filter: {
                    where : whereClause,
                    limit: 10,
                    order: 'notificationDate DESC',
                    skip: vm.chatPage*10,
                    include: ['sender','senderOrganization', 'senderOfferedService']
                }
            };


            Notification.find(query, function(notifications) {
                var tmpNotifications = notifications;//.reverse();
                //passo in rassegna le notifiche per aggiungere attributi utili per la visualizzazione
                for (var i = 0; i < tmpNotifications.length; i++) {
                    if (vm.currentUserId==tmpNotifications[i].senderId) {
                        tmpNotifications[i].who='user';
                    }
                    else {
                        tmpNotifications[i].who='contact';
                    }
                    vm.chat.unshift(tmpNotifications[i]);
                }

                if (vm.chatPage===0) {
                    // Reset the reply textarea
                    resetReplyTextarea();

                    // Scroll to the last message
                    scrollToBottomOfChat();

                    if ( !$mdMedia('gt-md') )
                    {
                        $mdSidenav('left-sidenav').close();
                    }

                    // Reset Left Sidenav View
                    vm.toggleLeftSidenavView(false);
                }

                //MARCO COME LETTE LE NOTIFICHE NUOVE IN PAGINA
                var notificationstoBeRead=[];
                for (var i = 0; i < tmpNotifications.length; i++) {
                    if (tmpNotifications[i].status==='N') {
                        notificationstoBeRead.push(tmpNotifications[i].id);
                    }
                }

                var sender = vm.contacts.getByIdAndType(vm.currentContact.id, vm.currentContact.type);
                if (sender && sender.unread) {
                    sender.unread-=notificationstoBeRead.length;
                    if (sender.unread<0) sender.unread=0;
                }

                if (notificationstoBeRead.length > 0) {


                    Notification.updateAll(
                        {
                            where: { id : { inq: notificationstoBeRead} }
                        },
                        {status: 'R'},
                        function(org,responseHeaders){
                            $log.debug(org);
                            CylNotifier.countChatUnreadMessages(vm.currentUserId);
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                        });
                }
                else {
                    sender.unread=0;
                }

            });

        }


        /**
         * Carica gli iscritti ad un servizio
         * @param offeredServiceId
         */
        function loadGroupSubscribers(offeredServiceId, togglePanel, callback) {
            if (togglePanel) {
                vm.toggleSidenav('right-sidenav');
            }
            vm.currentChatService = null;
            OfferedService.findById({
                id: offeredServiceId,
                filter: {
                    include: ['organization']
                }
            }).$promise.then(
                function(data, headers){
                    vm.currentChatService = JSON.parse(JSON.stringify(data));
                    var searchFilter = {
                        organizationId: data.organizationId,
                        dateFrom: '19990101',
                        dateTo: '29991231',
                        offeredServiceId: offeredServiceId,
                        documentStatus: 'DONOTADD', // non estrae il documentStatus, la query va più veloce
                    };
                    Organization.subscribersList(searchFilter).$promise.then(
                        function(response) {
                            vm.currentChatService.subscribers = response;
                            vm.currentChatService.subscribers = _.map(vm.currentChatService.subscribers, function(sub) {
                                sub.type = 'U';//sono utenti
                                sub.name = sub.displayName;
                                sub.id = sub.userId;        // rendo compatibile il risultato della nuova procedura con quello della vecchia allSubscribers
                                return sub;
                            });
                            vm.currentChatService.subscribers = _.sortBy( vm.currentChatService.subscribers, function(s){ return s.familyName; });
                            if (callback) {
                                callback(null);
                            }
                        }, function(err) {
                            $log.debug(err);
                            if (callback) {
                                callback(err);
                            }
                        }
                    );

                    // vecchia API, deprecata
                    // data.$prototype$allSubscribers({payments: 'A', documents: '', hasCard: ''}).then(
                    //     function(response) {
                    //         vm.currentChatService.subscribers = response.result.users;
                    //         vm.currentChatService.subscribers = _.map(vm.currentChatService.subscribers, function(sub) {
                    //             sub.type = 'U';//sono utenti
                    //             sub.name = sub.displayName;
                    //             return sub;
                    //         });
                    //         vm.currentChatService.subscribers = _.sortBy( vm.currentChatService.subscribers, function(s){ return s.familyName; });
                    //         if (callback) {
                    //             callback(null);
                    //         }
                    //     }, function(err) {
                    //         $log.debug(err);
                    //         if (callback) {
                    //             callback(err);
                    //         }
                    //     });
                },
                function(error){
                    $log.debug(error);
                    if (callback) {
                        callback(error);
                    }
                });
        }


        /**
         * Carica gli utenti di una associazione abilitati a vedere la chat
         * @param offeredServiceId
         * @param togglePanel
         * @param callback
         */
        function loadOrganizationGroupMembers(organizationId, togglePanel, callback) {
            if (togglePanel) {
                vm.toggleSidenav('right-sidenav');
            }
            vm.currentChatService = null;
            if (organizationId) {
                Organization.findById({
                    id: organizationId
                }).$promise.then(
                    function(data, headers) {
                        vm.currentChatService = JSON.parse(JSON.stringify(data));
                        data.$prototype$allUsers({}).then(
                            function(response) {
                                var users = _.filter(response.result.users, function(user) {
                                    var internalCodes = user.internalCodes;
                                    if (internalCodes) {
                                        var internalCodeArr = internalCodes.split(',');
                                        var isInGroup = false;
                                        _.each(internalCodeArr, function(code) {
                                            code = code.trim();
                                            if (code === 'ADMIN' || code === 'MEMBER' || code === 'STAFF') {
                                                isInGroup = true;
                                            }
                                            if (vm.currentChatService.flgExtendChatToContacts && code === 'CONTACT') {
                                                isInGroup = true;
                                            }
                                        });
                                        return isInGroup;
                                    }
                                    return false;
                                });
                                vm.currentChatService.subscribers = users;
                                vm.currentChatService.subscribers = _.map(vm.currentChatService.subscribers, function(sub) {
                                    sub.type = 'U';//sono utenti
                                    sub.name = sub.displayName;
                                    return sub;
                                });
                                vm.currentChatService.subscribers = _.sortBy(vm.currentChatService.subscribers, function(s) {
                                    return s.familyName;
                                });
                                if (callback) {
                                    callback(null);
                                }
                            }, function(err) {
                                $log.debug(err);
                                if (callback) {
                                    callback(err);
                                }
                            });
                    },
                    function(error) {
                        $log.debug(error);
                        if (callback) {
                            callback(error);
                        }
                    });
            }
        }



        function setContactAtTheTop(contact) {
            var found = _.find(vm.contacts, function(c) {
                return (c.id == contact.id && c.type === contact.type);
            });
            if (found) {
                vm.contacts = _.without(vm.contacts, found);
                vm.contacts.unshift(contact);
            }
        }

        function sendMessage(message) {
            if (vm.currentContact.type==='U') {
                Notification.create(
                    {senderId: vm.currentUserId,
                        recipientId: vm.currentContact.id,
                        title: (vm.currentUser && vm.currentUser.displayName) ? vm.currentUser.displayName : 'Nuovo messaggio',
                        text: message.text,
                        notificationType: 'CHAT',
                        status: 'N',
                        notificationDate: new Date()
                    },
                    function(n,responseHeaders){
                        setContactAtTheTop(vm.currentContact);
                        AlertMessageService.showSuccessMessage();
                        scrollToBottomOfChat();
                    },
                    function(httpResponse){
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
            }
            else if (vm.currentContact.type==='O') {
                var groupName = vm.currentContact.name ? (' @ ' + vm.currentContact.name) : '';
                Notification.create(
                    {senderId: vm.currentUserId,
                        recipientId: null,
                        title: ((vm.currentUser && vm.currentUser.displayName) ? vm.currentUser.displayName : 'Nuovo messaggio')  + groupName,
                        senderOrganizationId: vm.currentContact.id,
                        text: message.text,
                        notificationType: 'CHAT',
                        status: 'N',
                        notificationDate: new Date()
                    },
                    function(n,responseHeaders){
                        setContactAtTheTop(vm.currentContact);
                        AlertMessageService.showSuccessMessage();
                        scrollToBottomOfChat();
                    },
                    function(httpResponse){
                        $log.debug(httpResponse);
                        AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                    });
            }
            else if (vm.currentContact.type === 'S') {
                if (vm.currentContact.groupType === 'G') {
                    var groupName = vm.currentContact.name ? (' @ ' + vm.currentContact.name) : '';
                    Notification.create(
                        {senderId: vm.currentUserId,
                            recipientId: null,
                            title: ((vm.currentUser && vm.currentUser.displayName) ? vm.currentUser.displayName : 'Nuovo messaggio')  + groupName,
                            senderOfferedServiceId: vm.currentContact.id,
                            text: message.text,
                            notificationType: 'CHAT',
                            status: 'N',
                            notificationDate: new Date()
                        },
                        function(n,responseHeaders){
                            setContactAtTheTop(vm.currentContact);
                            AlertMessageService.showSuccessMessage();
                            scrollToBottomOfChat();
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                            AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);

                        });
                } else if (vm.currentContact.groupType === 'B'){
                    //CHAT BROADCAST: scrivo sulla chat N messaggi (per ogni iscritto) con senderOfferedServiceId = null
                    var notifications = [];

                    loadGroupSubscribers(vm.currentContact.id, false, function(err) {
                        if (err) {
                            $log.debug(err);
                            AlertMessageService.showErrorAlert(err);
                        } else {
                            var userToNotify = _.clone(vm.currentChatService.subscribers);
                            var userToNotifyIds = _.map(userToNotify, function(u){ return u.id; });
                            if (userToNotifyIds.length > 0) {
                                //PRENDO ANCHE I GENITORI
                                UserRelation.find({filter: {
                                        where: {
                                            childId: {inq: userToNotifyIds}
                                        }
                                    }}).$promise.then(function(userRelations) {
                                    var parentIds = _.map(userRelations, function(u){ return u.parentId; });
                                    userToNotifyIds.push(parentIds);
                                    userToNotifyIds = _.uniq(_.flatten(userToNotifyIds));
                                    for (var i = 0; i < userToNotifyIds.length; i++) {
                                        if (vm.currentUserId == userToNotifyIds[i]) {
                                            continue;
                                        }
                                        notifications.push({
                                            senderId: vm.currentUserId,
                                            recipientId: userToNotifyIds[i],
                                            title: (vm.currentUser && vm.currentUser.displayName) ? vm.currentUser.displayName : 'Nuovo messaggio',
                                            text: message.text,
                                            notificationType: 'CHAT',
                                            status: 'N',
                                            notificationDate: new Date(),
                                            broadcastChatServiceId: vm.currentContact.id
                                        });
                                    }

                                    //AGGIUNGO NOTIFICA FITTIZIA SENZA DESTINATARIO per pterla vedere nella "room"
                                    notifications.push({
                                        senderId: vm.currentUserId,
                                        recipientId: null,
                                        title: (vm.currentUser && vm.currentUser.displayName) ? vm.currentUser.displayName : 'Nuovo messaggio',
                                        text: message.text,
                                        notificationType: 'CHAT',
                                        status: 'N',
                                        notificationDate: new Date(),
                                        broadcastChatServiceId: vm.currentContact.id
                                    });

                                    if (notifications.length > 0) {
                                        //creo la notifica
                                        Notification.createMany(
                                            notifications,
                                            function(n,responseHeaders){
                                                setContactAtTheTop(vm.currentContact);
                                                AlertMessageService.showSuccessMessage();
                                                scrollToBottomOfChat();
                                            },
                                            function(httpResponse){
                                                $log.debug(httpResponse);
                                                AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                            });
                                    }
                                }, function(httpResponse){
                                    $log.debug(httpResponse);
                                    AlertMessageService.showErrorAlert(httpResponse.data && httpResponse.data.error);
                                });
                            }
                        }
                    });




                }


            }
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                text: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);

//            // Update Contact's lastMessage
//            vm.contacts.getById(vm.currentContact.id).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

            sendMessage(message);

        }

        function searchUser()
        {
            var txt=vm.contactSearch+'%';
            User.lookupUsers({text: txt, organizationId: null, isGlobalSearch: false}).$promise.then (function(data) {
                var result = data.users;
                vm.contactsForSearch=[];
                if (result && result.length) {
                    for (var i = 0; i < result.length; i++) {
                        vm.contactsForSearch.push({id: result[i].id, name: result[i].displayName, type: 'U', uriAvatar:result[i].uriAvatar});
                    }
                }
            });

            //
        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = [];
            vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);

                $('#chat-content').scroll(function() {
                    var top = $('#chat-content').scrollTop();
                    if (top===0) {
                        vm.chatPage++;
                        _loadChat();
                    }
                });

            }, 100);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

        Array.prototype.getByIdAndType = function (id,type)
        {
            return this.filter(function (x)
            {
                return x.id === id && x.type === type;
            })[0];
        };


        $rootScope.$on('LOGOUT_EVENT', function (event, valore) {
            if (socket && socket!=null) {
                PubSub.unSubscribeAll(socket);
            }
        });


        $rootScope.$on('NEW_CHAT_MESSAGE', function (event, valore) {
            $log.debug('NEW_CHAT_MESSAGE -> manageIncomingMessage');
            if (valore && valore!=null) {
                manageIncomingMessage(valore);
            }
        });

        function manageIncomingMessage(notification) {
            $log.debug('Notifica in chat');

            if (vm.isChildChat || ($rootScope.userChatStatus && $rootScope.userChatStatus!=null && $rootScope.userChatStatus.code==='offline' )) {
                //SE SONO OFFLINE NON AFCCIO NULLA
                $log.debug('SONO OFFLINE NON FACCIO VEDERE LA NOTIFICA: ');
                return;
            }


            $log.debug('$location.path():              '+$location.path());
            $log.debug('vm.currentContact:              '+JSON.stringify(vm.currentContact));
            $log.debug('notification:              '+JSON.stringify(notification));

            if ($location.path()==='/chat' && vm.currentContact && vm.currentContact!==null
                && notification.notificationType==='CHAT'
//notifica di organizzazione
                && ((vm.currentContact.type==='O' && notification.senderOrganizationId && notification.senderOrganizationId!==null  && notification.senderOrganizationId==vm.currentContact.id)
                    //NOTIFICA DEL SERVIZIO / CORSO
                    ||  (vm.currentContact.type==='S' && notification.senderOfferedServiceId && notification.senderOfferedServiceId!==null  && notification.senderOfferedServiceId==vm.currentContact.id)

                    //notifica x utente singolo
                    || (vm.currentContact.type==='U' && (!notification.senderOrganizationId || notification.senderOrganizationId===null) && notification.senderId && notification.senderId!==null  && notification.senderId==vm.currentContact.id ))
            ){
                // Message
                var message = {
                    who    : 'contact',
                    text: notification.text,
                    time   : notification.notificationDate,
                    sender   : notification.sender,
                    id: notification.id
                };

                //CONTROLLO CHE IL MESSAGGIO NON SIA GIA PRESENTE PER EVITARE DOPPIONI IN CASO DI RITRASMISSIONE
                var msgOld = _.find(vm.chat, function(c) {return c.id==message.id});

                if (!msgOld) {
                    $log.debug('effettuo push messaggio ');
                    // Add the message to the chat
                    vm.chat.push(message);
                    // Scroll to the new message
                    $log.debug('push messaggio effettuato');
                    scrollToBottomOfChat();
                    $log.debug('scoll effettuato');

                }

                setTimeout(function() {
                    Notification.updateAll(
                        {
                            where: { id : notification.id }
                        },
                        {status: 'R'},
                        function(org,responseHeaders){
                            $log.debug(org);
                            CylNotifier.countChatUnreadMessages(vm.currentUserId);
                        },
                        function(httpResponse){
                            $log.debug(httpResponse);
                        });
                }, 2000);

            }
            else {

                // Update Contact's lastMessage
                var idToSearch = null;
                var typeToSearch = null;

                if (notification.senderOrganizationId && notification.senderOrganizationId!==null) {
                    idToSearch=notification.senderOrganizationId;
                    typeToSearch='O';
                }
                else if (notification.senderOfferedServiceId && notification.senderOfferedServiceId!==null) {
                    idToSearch=notification.senderOfferedServiceId;
                    typeToSearch='S';
                }
                else {
                    idToSearch=notification.senderId;
                    typeToSearch='U';
                }
                var sender = vm.contacts.getByIdAndType(idToSearch, typeToSearch);
                if (sender) {
                    sender.lastMessage = message;

                    if (!sender.unread) sender.unread=1;
                    else sender.unread++;
                }

                //aumento il contatore nel menu
                CylNotifier.countChatUnreadMessages(vm.currentUserId);

            }
        }


        function initChatSockets() {
            socket = io.connect(SocketIOPath);

            //This part is only for login users for authenticated socket connection between client and server.
            //If you are not using login page in you website then you should remove rest piece of code..
            var id = LoopBackAuth.accessTokenId;
            var userId = LoopBackAuth.currentUserId;
            $log.debug('socket factory:: init');

            socket.on('connect', function(){
                $log.debug('socket factory:: on connect');

                socket.emit('authentication', {id: id, userId: userId, channel: NotificationChannel });
                socket.on('authenticated', function() {
                    $log.debug('chat controller::SOCKET_IO_AUTHENTICATED');
                    PubSub.subscribe(
                        socket,
                        /*
                         * CALLBACK I MESSAGGI IN ARRIVO
                         */
                        manageIncomingMessage,
                        /*
                         * CALLBACK PER STATO UTENTI
                         */
                        function(statusData) {
                            $log.debug('Chat Controlller: variato status_ ' + JSON.stringify(statusData));
                            var user = vm.contacts.getByIdAndType(statusData.userId, 'U');
                            if (user) {
                                $log.debug(user.name + ' ' + statusData.status);
                                $scope.$apply(function() {
                                    user.status=statusData.status;
                                });
                            }
                        });
                });
            });
        }


        function formatDate(date) {
            if (!date || date===null ) {
                return '';
            }
            return moment(date).format('DD/MM/YYYY HH:mm');
        }

        function goOffline() {
            User.findById({
                id: vm.currentUserId
            }).$promise.then(function(user){
                user.$prototype$updatePreference({code:'CHAT_STATUS', value: 'offline'}).then(
                    function(response) {
                        //LOG ONLY
                        $log.debug('chat status updated to OFFLINE ');
                    });
            });

            $rootScope.userChatStatus=  {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161',
                'code' : 'offline'
            };

            $rootScope.$emit('CHAT_STATUS_CHANGED', 'offline');


        }


        function _initChatView(chatUserId) {
            vm.contacts=[];
            vm.loadingContacts = true;
            vm.chatUserId = chatUserId;
            User.find({
                filter: {
                    where: {id: chatUserId },
                    include: 'children'
                }
            }).$promise.then(function(users){

                var user = users[0];
                vm.children=user.children;
                user.$prototype$chatContacts().then(
                    function(response) {

                        //vm.contacts.length=0;
                        for (var i = 0; i < response.result.contacts.length; i++) {
                            if (response.result.contacts[i].type==='U' && response.result.contacts[i].id==vm.currentUserId) {
                                continue;
                            }
                            if (!response.result.contacts[i].status || response.result.contacts[i].status===null) {
                                response.result.contacts[i].status='offline';
                            }
                            vm.contacts.push(response.result.contacts[i]);
                        }

                        vm.contactsForSearch=vm.contacts.slice();
                        vm.loadingContacts = false;
                    }, function (err) {
                        $log.error(err);
                        vm.loadingContacts = false;
                    });
            }, function (err) {
                $log.error(err);
                vm.loadingContacts = false;
            });
        }


        function reloadChat() {
            _initChatView(vm.child.id);

        }

        function backToUserChat() {
            vm.isChildChat=false;
            vm.child=null;
            vm.currentUserId=User.getCurrentId();
            _initChatView(vm.currentUserId);
        }

        function viewChildChat(child) {
            vm.isChildChat=true;
            vm.child=child;
            vm.currentUserId=child.id;
            _initChatView(child.id);
        }

    }
})();

!function(a){"function"==typeof define&&define.amd?define(["jquery","moment"],a):"object"==typeof exports?module.exports=a(require("jquery"),require("moment")):a(jQuery,moment)}(function(a,b){!function(){"use strict";var a=(b.defineLocale||b.lang).call(b,"it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),weekdaysShort:"Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),weekdaysMin:"Do_Lu_Ma_Me_Gi_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(a){return(/^[0-9].+$/.test(a)?"tra":"in")+" "+a},past:"%s fa",s:"alcuni secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return a}(),a.fullCalendar.datepickerLang("it","it",{closeText:"Chiudi",prevText:"&#x3C;Prec",nextText:"Succ&#x3E;",currentText:"Oggi",monthNames:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthNamesShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],dayNames:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],dayNamesShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayNamesMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),a.fullCalendar.lang("it",{buttonText:{month:"Mese",week:"Settimana",day:"Giorno",list:"Agenda"},allDayHtml:"Tutto il<br/>giorno",eventLimitText:function(a){return"+altri "+a}})});
!function(a){"function"==typeof define&&define.amd?define(["jquery","moment"],a):"object"==typeof exports?module.exports=a(require("jquery"),require("moment")):a(jQuery,moment)}(function(a,b){!function(){"use strict";var a=(b.defineLocale||b.lang).call(b,"en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(a){var b=a%10,c=1===~~(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th";return a+c},week:{dow:1,doy:4}});return a}(),a.fullCalendar.datepickerLang("en-gb","en-GB",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),a.fullCalendar.lang("en-gb")});
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'textAngular',
                'ui.router',
                'angularSpectrumColorpicker'                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function (){
    'use strict';

    var underscore = angular.module('underscore', []);
    underscore.factory('_', ['$window', function($window) {
      return $window._; // assumes underscore has already been loaded on the page
    }]);

    var servicesModule = angular.module('app.services', ['underscore']);


    servicesModule.factory('breadcrumbManager', function( $log, $rootScope, msNavigationService, User, UserPreference, $translate) {

    	var clearByPrefix =  function(prefix) {
    		var arr = []; // Array to hold the keys
    		// Iterate over localStorage and insert the keys that meet the condition into arr
    		for (var i = 0; i < sessionStorage.length; i++){
    		    if (sessionStorage.key(i).startsWith(prefix)) {
    		        arr.push(sessionStorage.key(i));
    		    }
    		}

    		// Iterate over arr and remove the items by key
    		for (var i = 0; i < arr.length; i++) {
    			sessionStorage.removeItem(arr[i]);
    		}
        };

        /**
         * Pulisce le breadcrumbs dallo storage locale
         */
        var clearAll =  function() {
            clearByPrefix('BREADCRUMBS');
        };

        /**
         * Elimina il servizio dalle bread crumbs
         */
        var popOfferedService =  function() {
            clearByPrefix('BREADCRUMBS_SERVICE');
            $rootScope.$emit('POP_OFFERED_SERVICE', '');
        };

        /**
         * inserisce la organizz nell breadcrumbs
         * @param organization
         */
        var pushOrganization =  function(organization) {
        	sessionStorage.setItem('BREADCRUMBS_ORGANIZATION_ID', organization.id);
        	sessionStorage.setItem('BREADCRUMBS_ORGANIZATION_NAME', organization.name);
            $rootScope.$emit('PUSH_ORGANIZATION', {id:  organization.id, name:  organization.name});
            popOfferedService();
        };

        /**
         * inserisce il servizio nelle breadcrumbs
         * @param service
         */
        var pushOfferedService =  function(service) {
        	sessionStorage.setItem('BREADCRUMBS_SERVICE_ID', service.id);
        	sessionStorage.setItem('BREADCRUMBS_SERVICE_NAME', service.name);
            sessionStorage.setItem('BREADCRUMBS_SERVICE_TYPE', service.serviceType);
            $rootScope.$emit('PUSH_OFFERED_SERVICE', {id:  service.id, name:  service.name, type: service.serviceType});
        };

        /**
         * inserisce organizzaz e servizio nelle breadcrumbs
         * @param organization
         * @param service
         */
        var pushOrganizationAndService =  function(organization, service) {
            pushOrganization(organization);
            pushOfferedService(service);
        };


        /**
         * inserisce utente nelle breadcrumbs. ATTUALMENTE NON USATA
         * @param user
         */
        var pushUser =  function(user) {
        	sessionStorage.setItem('BREADCRUMBS_USER_ID', user.id);
        	sessionStorage.setItem('BREADCRUMBS_USER_NAME', user.displayName);
        };

        /**
         * toglie organizzazione dalle breadcrumbs
         */
        var popOrganization =  function() {
        	clearByPrefix('BREADCRUMBS_ORGANIZATION');
            $rootScope.$emit('POP_ORGANIZATION', '');
        };


        /**
         * toglie utente dalle breadcrumbs. ATTUALMENTE NON USATA
         */
        var popUser =  function() {
        	clearByPrefix('BREADCRUMBS_USER');
        };

        /**
         * organizzazione corrente delle breadcrumbs
         * @returns {*}
         */
        var currentOrganization = function() {
            var id = sessionStorage.getItem('BREADCRUMBS_ORGANIZATION_ID');
            var name = sessionStorage.getItem('BREADCRUMBS_ORGANIZATION_NAME');
            if (id && id!=='') {
                return {
                  id: id,
                  name: name
                };
            } else {
                return null;
            }
        };

        /**
         * servizio corrente delle breadcrumbs
         * @returns {*}
         */
        var currentOfferedService = function() {
            var id = sessionStorage.getItem('BREADCRUMBS_SERVICE_ID');
            var name = sessionStorage.getItem('BREADCRUMBS_SERVICE_NAME');
            var type = sessionStorage.getItem('BREADCRUMBS_SERVICE_TYPE');
            if (id && id!=='') {
                return {
                    id: id,
                    name: name,
                    type: type
                };
            } else {
                return null;
            }
        };

        /**
         * utente corrente delle breadcrumbs NON USATA
         * @returns {*}
         */
        var currentUser = function() {
            var id = sessionStorage.getItem('BREADCRUMBS_USER_ID');
            var name = sessionStorage.getItem('BREADCRUMBS_USER_NAME');
            if (id && id!=='') {
                return {
                    id: id,
                    name: name
                };
            } else {
                return null;
            }
        };

        /**
         * carica il periodo corrente per la navigazione della organizzazione
         */
        var loadReferencePeriodForOrganization = function(callback) {
            $log.debug('loadReferencePeriodForOrganization()');
            var theOrganization = currentOrganization();
            if (!theOrganization) {
                callback(null);
                return;
            }

            UserPreference.find({
                filter: {
                    where: {
                        userId: User.getCurrentId(),
                        code: 'ORG_' + theOrganization.id + '_REF_PERIOD'
                    }
                }
            }, function(preferences) {
                $log.debug('preferences: ' + JSON.stringify(preferences));
                var organizationPeriod = null;
                if (preferences && preferences.length > 0) {
                    var value = preferences[0].value;
                    organizationPeriod = JSON.parse(value);
                    var timezoneOffset = new Date().getTimezoneOffset();
                    if (organizationPeriod.dateFrom) {
                        organizationPeriod.dateFrom = moment(organizationPeriod.dateFrom).add(timezoneOffset, 'minutes').toDate();
                    }
                    if (organizationPeriod.dateTo) {
                        organizationPeriod.dateTo = moment(organizationPeriod.dateTo).add(timezoneOffset, 'minutes').toDate();
                    }
                } else {
                    organizationPeriod = {
                        description: $translate.instant('PAGES.SET_REF_PERIOD'),
                        organizationId: null,
                        dateFrom: null,
                        dateTo: null
                    };
                }
                $log.debug({ organizationPeriod: organizationPeriod });
                callback(organizationPeriod);
            });
        };

        //SALVO SU DB
        //aggiorno la preferenza
        /**
         * Aggiorna il periodo di riferimento per una organizzazione
         *
         * @param {object} organizationPeriod {description: 'Anno corrente', organizationId: 999, dateFrom: new date(), dateTo: dateTo()}
         * @param {function(err, data)} callback data: {description: 'Anno corrente', organizationId: 999, dateFrom: new date(), dateTo: dateTo()}
         */
        var saveReferencePeriodForOrganization = function(organizationPeriod, callback) {
            $log.debug('breadcrumbManager.saveReferencePeriodForOrganization()');
            $log.debug('breadcrumbManager.saveReferencePeriodForOrganization - organizationPeriod: ' + JSON.stringify(organizationPeriod));
            var theOrganization = currentOrganization();
            if (!theOrganization) {
                $log.debug('breadcrumbManager.saveReferencePeriodForOrganization - no current organization');
                callback(organizationPeriod);
                return;
            }

            User.findById({
                id: User.getCurrentId(),
            }).$promise.then(function(user) {
                var toSavePeriod = JSON.parse(JSON.stringify(organizationPeriod));
                if (toSavePeriod.description) {
                    toSavePeriod.description = toSavePeriod.description.replace(/\//g, '#');
                }
                user.$prototype$updatePreference({
                    code: 'ORG_' + theOrganization.id + '_REF_PERIOD',
                    value: JSON.stringify(toSavePeriod)
                }).then(
                    function(response) {
                        //LOG ONLY
                        $log.debug('breadcrumbManager.saveReferencePeriodForOrganization - _REF_PERIOD updated:');
                        $log.debug('breadcrumbManager.saveReferencePeriodForOrganization - ' + JSON.stringify(response));
                        $rootScope.$emit('REF_PERIOD_CHANGED', organizationPeriod);
                        callback(organizationPeriod);
                    });
            });
        };

        return {
        	clearAll: clearAll,

            pushOrganizationAndService: pushOrganizationAndService,

            pushOrganization: pushOrganization,
            popOrganization: popOrganization,
            currentOrganization: currentOrganization,

        	pushOfferedService: pushOfferedService,
            popOfferedService: popOfferedService,
            currentOfferedService: currentOfferedService,

            loadReferencePeriodForOrganization: loadReferencePeriodForOrganization,
            saveReferencePeriodForOrganization: saveReferencePeriodForOrganization
        };
    });

    servicesModule.factory('CylUtils', function( $rootScope) {

    	var randomString = function(stringLength){
    	    var text = "";
    	    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    	    for( var i=0; i < stringLength; i++ )
    	        text += possible.charAt(Math.floor(Math.random() * possible.length));

    	    return text;
    	}

        var roundEuro = function(n) {
            if (!n) return 0;
            var str = n.toFixed(2).toString();
            return Number(str);
        }

    	var cyl_createRandomString = function() {
    		return randomString(10);
    	}

        return {
        	cyl_createRandomString: cyl_createRandomString,
            roundEuro: roundEuro
        };
    });

    servicesModule.factory('CylNotifier', function( $rootScope, Notification, UserOrganizationRole, Subscription, OfferedService, User, _) {



    	var countNotifications = function(userId) {

        	var query ={
         			where : {recipientId: userId, status: 'N', notificationType: {neq: 'CHAT'}}
               };

        	Notification.count(query, function(totalNumber) {
        		$rootScope.$emit('USER_NOTIFICATION_COUNT', totalNumber.count);
        	});
    	}

    	var countChatUnreadMessages = function(userId) {  //FIXME capire se ottimizzare questa parte con un servizio dedicato che faccia tutto
    		//PRENDO LA DISTINCT DELLE ORGANIZZAZIONI DI CUI FACCIO PARTE
            User.countUnreadChatMessages({}).$promise.then(function(totalNumber) {
                $rootScope.$emit('USER_CHAT_COUNT', totalNumber.result);
            });
    	}

        return {
        	countNotifications: countNotifications,
        	countChatUnreadMessages: countChatUnreadMessages
        };
    });


    servicesModule.factory('PubSub', function (LoopBackAuth, NotificationChannel) {
        var container =  [];
        return {
            subscribe: function(socket, callback, callbackStatus){
            		 //SOTTOSCRIZIONE PER LE NOTIFICHE
                     var userId = LoopBackAuth.currentUserId;
                     var name = 'NOTIFICATIONS_'+NotificationChannel+'_'+userId+'_'+LoopBackAuth.accessTokenId;
                	 socket.on(name, callback);
                	 this.pushContainer(name);

                	 //SOTTOSCRIZIONE PER LO STATO DEGLI 'AMICI'
                     name = 'CONTACT_STATUS_'+NotificationChannel+'_'+userId+'_'+LoopBackAuth.accessTokenId;
                	 socket.on(name, callbackStatus);
                	 this.pushContainer(name);

            }, //end subscribe

            pushContainer : function(subscriptionName){
                container.push(subscriptionName);
            },

            //Unsubscribe all containers..
            unSubscribeAll: function(socket){
                for(var i=0; i<container.length; i++){
                    socket.removeAllListeners(container[i]);
                }
                //Now reset the container..
                container = [];
            }

        };
    });

    servicesModule.factory('CylMessageFormatter', function( $rootScope, $translate ) {



    	var formatMessage = function(error) {

    		if (error && error.details && error.details!==null && error.details.codes && error.details.codes!==null) {
    			var message = '';
    			for (var key in error.details.codes) {
    				var parts = error.details.codes[key];
    				message+= key+': ';
    	    		if (parts && parts!==null && parts.length) {
    	    			for (var i = 0; i < parts.length; i++) {
    	    				var partTranslated = $translate.instant('LP_ERRORS.'+parts[i]);
    	    				message+=partTranslated+";";
    	    			}
    	    		}
    			}
    			return message;
    		}
    		else if (error && error.code && error.code!==null) {
				message=$translate.instant('LP_ERRORS.'+error.code);
    			return message;
    		}
    		else if (error && error.message && error.message!==null) {
				message=$translate.instant(error.message);
    			return message;
    		}
    		else {
    			return $translate.instant(error);
    		}


    	}

        return {
        	formatMessage: formatMessage
        };
    });



    servicesModule.factory('GeolocalService', function( ) {



    	var findByAddress = function(address) {
    		$(document).ready(function(){
    			// aggiorna mappa in base all'indirizzo
    			$('#btn-findaddressonmap').click(function(){
    				$('input.gllpSearchField').val($('#field-address').data('value') + $('#field-city').data('value'));
    				$('input.gllpSearchButton').click();
    			});
    			// aggiorna la posizione in base alla mappa
    			$('#btn-updatelocation').click(function(){
    				var centerId = $('#field-id').data('value');
    				var latitude = $('input.gllpLatitude').val();
    				var longitude = $('input.gllpLongitude').val();
    				var url = Routing.generate('api_v1_center_setlocation', {'center_id': centerId, 'lat': latitude, 'lon': longitude});
    				$.ajax({
    					url: url
    				}).done(function(data){
    					try {
    						if (data.err > 0) {
    							$('#btn-updatelocation').after('<i class="fa fa-warning red"></i>');
    						} else {
    							$('#btn-updatelocation').after('<i class="fa fa-info-circle blue"></i>');
    							// aggiorna coordinate in pannello informazioni
    							$('#field-coordinates').text(
    									Math.round(latitude*10000)/10000 + ', ' + Math.round(longitude*10000)/10000
    							);
    						}
    					} catch (e) {};
    				});
    			});
    		});
    	}

        return {
        	findByAddress: findByAddress
        };
    });



    servicesModule.factory('DictionaryService', function( $rootScope, $translate, Dictionary, _, $log) {

        var loadSection = function(section) {

            if ($rootScope.cylDictionary && $rootScope.cylDictionary!==null) {
                var record = _.filter($rootScope.cylDictionary, function(d) {
                    return (d.section===section && d.locale===$rootScope.currentLanguage);
                });
                return (!record )? [] :record;
            }

            return [];
        }

    	var translateMessage = function(section, code, defaultMsg, lang) {

    		if ($rootScope.cylDictionary && $rootScope.cylDictionary!==null) {
    			var record = _.find($rootScope.cylDictionary, function(d) {
    				return (d.section===section && d.code===code && d.locale===$rootScope.currentLanguage);
    			});
    			return (!record || record.value===null || record.value==='')?defaultMsg:record.value;
    		}

    		return defaultMsg;
    	}

        var loadDictionary = function(callback) {
            Dictionary.find({}, function(data) {
                $rootScope.cylDictionary = data;
                $log.debug("DICTIONARY LOADED");
                if (callback) {
                    callback();
                }
            });
    	}

        return {
        	translateMessage: translateMessage,
        	loadDictionary: loadDictionary,
            loadSection: loadSection
        };
    });


    servicesModule.factory('TourService', function(  $cookies) {

        var execTour=true;
        var _currentTourcode = '';
        var _currentStep = {};

        var initTour = function(tourCode, currentStep) {
        	_currentStep=currentStep;
        	_currentTourcode=tourCode;
            var curStep = $cookies.get('TOUR_ORGANIZATION_'+tourCode);
            if (curStep==='9999') {
         	   execTour=false;
            }
            else {
         	   execTour=true;
            }

            if(typeof curStep === 'string')
                curStep = parseInt(curStep);
            _currentStep[tourCode] = curStep || 0;

            if (execTour) {
 	  		setTimeout(function() {
 	   			$('#TOUR_ORGANIZATION_'+tourCode+'_OPENER').click();
 	   		}, 3500);
            }

        }
         var stepComplete = function(currentStep) {
         	_currentStep=currentStep;
     	   if (execTour) {
     		   $cookies.put('TOUR_ORGANIZATION_'+_currentTourcode, _currentStep[_currentTourcode]);
     	   }
        };

        var tourComplete = function() {
        //alert('COMPLETE ' + _currentStep[_currentTourcode]);
     	   $cookies.put('TOUR_ORGANIZATION_'+_currentTourcode, '9999');
     	   execTour=false;
        };

        var tourEnded = function() {
        //	alert('END ' + _currentStep[_currentTourcode]);
      	  // $cookies.put('TOUR_ORGANIZATION_'+_currentTourcode, '9999');
      	  // execTour=false;
         };

        return {
        	initTour: initTour,
        	stepComplete: stepComplete,
        	tourComplete: tourComplete,
        	tourEnded: tourEnded
        };
    });




})();

(function (){
    'use strict';

    /**
     * Servizio con metodi usati frequentemente per l'accesos alle entità
     */
    angular.module('app.services').factory('entitiesService', ['$log', '$q', 'Organization',
        function($log, $q, Organization) {
        var service = {
            fetchOrganization: fetchOrganization,
        };


        /**
         * Legge un'organizzazione dato il suo id.
         * @param {number} id
         * @param {array | string | null} include Es. ['roleTypes','offeredServices'] | 'offeredServices'
         * @returns {*} Promise con l'organizzazione o l'errore
         *
         * Chiamare con:
         * entitiesService.fetchOrganization(id).then(resultFunction, errFunction);
         * */
        function fetchOrganization(id, include) {
            $log.debug('entitiesService.fetchOrganization()');
            $log.debug({id: id, include: include});
            var deferred = $q.defer();
            if (id) {
                var config = {id: id};
                if (include) {
                    config.filter = {include: include};
                }
                $log.debug({config: config});
                Organization.findById(config).$promise.then(
                // Organization.findById({id: id, filter: { include: include}}).$promise.then(
                    function(entity) {
                        $log.debug({entity: entity});
                        deferred.resolve(entity);
                    },
                    function(err) {
                        $log.error({err: err});
                        deferred.reject(err);
                    }
                );
            } else {
                deferred.reject(new Error('Missing entity ID'));
            }
            return deferred.promise;
        }



        return service;
    }]);

})();

(function (){
    'use strict';

    /**
     * Servizio di condivisione dati in tutta l'applicazione
     */
    angular.module('app.services').factory('appDataService', ['$log', '$interval', function($log, $interval) {
        var allData = {
            // organizzazione corrente
            currentOrganization: null,
            // elenco delle organizzazioni che gestisco
            adminOrganizations: [],
            // piano di pagamento
            organizationPlanStats: null,
            // condivisione dati correnti con altri controller, da intendere
            // come un archivio non persistente e da usare all'interno della stessa schermata
            current: {
            },


            /**
             * Chiama una callback quando un oggetto osservato non è più null (o quando scade il timeout)
             *
             * @param { object } observee
             * @param { function(err, data) } callback
             * @param { object } options
             * - timeout: tempo massimo per attendere il dato; dafault 5s; ha priorità su maxCount
             * - checkInterval: tempo tra i controlli; default 250ms
             * - maxCount: numero massimo di interazioni: numero massimo di cicli di ricerca; default 100
             *
             * TODO far funzionare onDataReady
             */
            onDataReady: function(observee, callback, options) {
                $log.debug('onDataReady()');
                $log.debug('observee: ' + JSON.stringify(observee));
                // opzioni di default
                options = options || { };
                if (!options.timeout) options.timeout = 5000;
                if (!options.checkInterval) options.checkInterval = 250;
                if (!options.maxCount) options.maxCount = 100;
                // imposta il numero massimo di esecuzioni se il timeout le ferma prima
                if (options.timeout / options.checkInterval > options.maxCount) {
                    options.maxCount = options.timeout / options.checkInterval;
                }

                var i = $interval(function() {
                    $log.debug('interval tick');
                    // se trovo l'oggetto, lo ritorno e interrompo i controlli
                    if (observee !== null) {
                        $log.debug('observee found: ' + JSON.stringify(observee));
                        $interval.cancel(i);
                        callback(null, observee);
                    }
                }, options.checkInterval, options.maxCount);
            }
        };

        return allData;
    }]);

})();

'use strict';

(function(){
    angular.module('app.services').factory('DateFormatter', function(  ) {

        /**
         *
         * @param date
         * @returns {string}
         */
        function formatDateTime(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY HH:mm');
        }

        function formatDate(date) {
            if (!date || date===null ) {
                return '-';
            }
            return moment(date).format('DD/MM/YYYY');
        }

        return {
            formatDateTime: formatDateTime,
            formatDate: formatDate
        };
    });
})();

(function (){
    'use strict';
    
angular.module('app.filters',[]).filter('cylDictionary',['DictionaryService','$rootScope',function (DictionaryService, $rootScope) {
    return function (item, section, code) {

        var value =  DictionaryService.translateMessage(section, code, item);
        return value;
        
    };
}]);




})();



(function (){
    'use strict';

    /**
     * Servizio di condivisione dati in tutta l'applicazione
     */
    angular.module('app.services').factory('dateUtilitiesService', ['$log', function($log) {
        var service = {


            /**
             * Verifica se due periodi di tempo si intersecano (significa che period2 è incluso, almeno parzialmente, in period1).
             * Nota: period2End potrebbe non essere definito (tipicamente è un evento in singola data), in quel caso il suo
             * istante è il termine della giornata del period2Start
             *
             * @param {moment} period1Start
             * @param {moment} period1End
             * @param {moment} period2Start
             * @param {moment | null} period2End
             * @return boolean
             */
            arePeriodsOverlapping: function(period1Start, period1End, period2Start, period2End) {
                // $log.debug('arePeriodsOverlapping()');
                if (period1Start && period1End && period2Start) {
                    // imposta period2End, se non impostato
                    if (!period2End) {
                        period2End = moment(period2Start).endOf('day');
                    }
                    // $log.debug(period1Start.format('YYYY-MM-DD') + ' - ' + period1End.format('YYYY-MM-DD'));
                    // $log.debug(period2Start.format('YYYY-MM-DD') + ' - ' + period2End.format('YYYY-MM-DD'));
                    // se period2Start è incluso oppure period2End è incluso
                    if ((period2Start.isAfter(period1Start) && period2Start.isBefore(period2End)) ||
                        (period2End.isAfter(period1Start) && period2End.isBefore(period1End))) {
                        // $log.debug('overlapping');
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            }

        };

        return service;
    }]);

})();

(function ()
{
    /**
     * Direttiva per restringere a set di caratteri di uso comune gli input txt
     */
    'use strict';
    angular
        .module('restrictInput',[])
        .directive('restrictInput', function() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ctrl) {
                    ctrl.$parsers.unshift(function(viewValue) {
                        var options = scope.$eval(attr.restrictInput);
                        if (!options.regex && options.type) {
                            switch (options.type) {
                                case 'digitsOnly': options.regex = '^[0-9]*$'; break;
                                case 'lettersOnly': options.regex = '^[a-zA-Z]*$'; break;
                                case 'lowercaseLettersOnly': options.regex = '^[a-z]*$'; break;
                                case 'uppercaseLettersOnly': options.regex = '^[A-Z]*$'; break;
                                case 'lettersAndDigitsOnly': options.regex = '^[a-zA-Z0-9]*$'; break;
                                case 'validPhoneCharsOnly': options.regex = '^[0-9 ()/-]*$'; break;
                                default: options.regex = '';
                            }
                        }
                        var reg = new RegExp(options.regex);
                        if (reg.test(viewValue)) { //if valid view value, return it
                            return viewValue;
                        } else { //if not valid view value, use the model value (or empty string if that's also invalid)
                            var overrideValue = (reg.test(ctrl.$modelValue) ? ctrl.$modelValue : '');
                            element.val(overrideValue);
                            return overrideValue;
                        }
                    });
                }
            };
        });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            "primary":{"name":"fuse-paleblue","hues":{"default":"700","hue-1":"500","hue-2":"600","hue-3":"400"}},"accent":{"name":"teal","hues":{"default":"600","hue-1":"400","hue-2":"700","hue-3":"A100"}},"warn":{"name":"pink","hues":{"default":"700","hue-1":"500","hue-2":"500","hue-3":"A100"}},"background":{"name":"grey","hues":{"default":"A100","hue-1":"A100","hue-2":"100","hue-3":"300"}}
            // primary   : {
            //     name: 'fuse-paleblue',
            //     hues: {
            //         'default': '700',
            //         'hue-1'  : '500',
            //         'hue-2'  : '600',
            //         'hue-3'  : '400'
            //     }
            // },
            // accent    : {
            //     name: 'light-blue',
            //     hues: {
            //         'default': '600',
            //         'hue-1'  : '400',
            //         'hue-2'  : '700',
            //         'hue-3'  : 'A100'
            //     }
            // },
            // warn      : {
            //     name: 'red'
            // },
            // background: {
            //     name: 'grey',
            //     hues: {
            //         'default': 'A100',
            //         'hue-1'  : 'A100',
            //         'hue-2'  : '100',
            //         'hue-3'  : '300'
            //     }
            // }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('AuthenticationService', AuthenticationService);

        /** @ngInject */
        function AuthenticationService($log, $state, $location, $cookies, $q, User, LoopBackAuth)
        {
            var service = {
                isAuthenticated: isAuthenticated,
                login: login,
                checkPwd: checkPwd,
                logout: logout,
                loggedUser: loggedUser,
                createFakePassword: createFakePassword,
                clearCookie: clearCookie,
                getLoggedUserDataFromServer: getLoggedUserDataFromServer
            }

            return service;

            function isAuthenticated(){
                if (User.isAuthenticated()){
                    return true;
                } else {
                    if (checkCookie()) {
                        doUserLoginFromCookie($cookies.get('access_token'),$cookies.get('userId'),{});
                        clearCookie();
                    }
                    return User.isAuthenticated();
                }
            }

            function login(email,password){
                return User.login({
                    include: "user",
                    rememberMe: false//per ora per gestire la durata del token
                },
                {
                    email: email,
                    password: password,
                    ttl: 64800 // 18 ore
                }).$promise;
            }

            //login fittizia per verificare la pwd in cambio pwd
            function checkPwd(email,password){
                return User.login({
                    rememberMe: false
                },
                {
                    email: email,
                    password: password,
                    ttl: 60 //un giorno
                }).$promise;
            }

            function createFakePassword(){
                return randomString(10);
            }

            function randomString(stringLength){
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for( var i=0; i < stringLength; i++ )
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            }

            function logout(){
                User.logout(
                {},
                {},
                function(value, responseHeaders){
                    localStorage.clear();
                    sessionStorage.clear();
                    $state.go('app.pages_auth_login');
                },
                function(error){
                    sessionStorage.clear();
                    localStorage.clear();
                });
            }

            function loggedUser(){
                var id = User.getCurrentId();

                return getLoggedUserFromLocalStorage().then(
                    function(data){
                        return data;
                    },
                    function(error){
                        $log.debug(error);
                        return getLoggedUserDataFromServer(id).then(
                            function(data){
                                localStorage.setItem('userData',JSON.stringify(mergeSocialdata(data)));
                                return data;
                            },
                            function(error){
                                return error;
                            }
                        );
                    }
                );
            }

            function getLoggedUserFromLocalStorage(){
                return $q(function(resolve, reject) {
                    if (localStorage.getItem('userData') !== null){
                        resolve(JSON.parse(localStorage.getItem('userData')));
                    } else {
                        reject('no cached data');
                    }
                });
            }

            function getLoggedUserDataFromServer(id){
                return User.findById({
                    id: id,
                        filter: {
                            include: 'identities'
                        }
                    }).$promise;
            }

            function doUserLoginFromCookie(access_token,userId){
                LoopBackAuth.setUser($cookies.get('access_token'),$cookies.get('userId'),{});
                LoopBackAuth.rememberMe = true;
                LoopBackAuth.save();
            }

            function checkCookie(){
                return $cookies.get('userId')&&$cookies.get('access_token');
            }

            function clearCookie(){
                $cookies.remove('userId');
                $cookies.remove('access_token');
            }

            /*
            set displayName to show when login with social or not
            */
            function mergeSocialdata(data){
                if (data.identities.length > 0){
                    data.displayName = data.identities[0].profile.displayName;
                } else {
                    data.displayName = data.username;
                }
                return data;
            }
        };

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('AlertMessageService', AlertMessageService);

        /** @ngInject */
        function AlertMessageService($mdDialog, $mdToast, $translate, CylMessageFormatter)
        {
            var service = {
                showAlert: showAlert,
                showErrorAlert: showErrorAlert,
                showSuccessMessage: showSuccessMessage,
                showNotificationAlert: showNotificationAlert
            }

            return service;

            function showAlert(title, text){
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title(title)
                    .textContent(text)
                    .ok("OK")
                );
            }


            function showErrorAlert(error){
            	var txt = CylMessageFormatter.formatMessage(error);
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title($translate.instant('LP_ERRORS.ERROR'))
                    .textContent(txt)
                    .ariaLabel('Error')
                    .ok("OK")
                );
            }


            function showSuccessMessage(){
                $mdToast.show({
                    hideDelay: 5000,
                    position: 'bottom right',
                    template  : '<md-toast>' +
				                   '<div class="md-toast-content">' +
				                     '<span class="md-toast-text" flex>'+$translate.instant('SUCCESSFULLY_DONE')+'</span>'+
				                     '<md-icon md-font-icon="icon-check" style="width: 36px; height: 36px; color: #0f0;"></md-icon>'+
				                  '</div>' +
				                '</md-toast>'
                  });
            }

            function showNotificationAlert(notification){

                var txt = '';
            	if ( notification && notification!=null && notification.sender && notification.sender!==null) {
            		txt+= notification.sender.displayName;
    			}
    			if (notification.senderOrganization && notification.senderOrganization!==null) {
    				if (txt!=='') {
    					txt += ' - ';
    				}
    				txt+=notification.senderOrganization.name;
    			}
    			else if (notification.senderOfferedService && notification.senderOfferedService!==null) {
    				if (txt!=='') {
    					txt += ' - ';
    				}
    				txt+=notification.senderOfferedService.name;
    			}

                txt+=': '+notification.title;

                $mdToast.show({
                    hideDelay   : 5000,
                    position    : 'top right',
                    template  : '<md-toast>' +
				                   '<div class="md-toast-content">' +
				                     '<span class="md-toast-text" flex>'+txt+'</span>'+
				                  '</div>' +
				                '</md-toast>'
                  });
            }


        };

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($log, $rootScope, $q, $scope, $state, $mdDateLocale, $timeout, $mdSidenav, $mdDialog,
                               $translate, _, CylPlan, Category, msNavigationService, UserChatStatus, Organization,
                               UserPreference, User, ApiPath, AuthenticationService, LoopBackAuth, breadcrumbManager,
                               DictionaryService, appDataService, OfferedService)
    {
        var vm = this;

        vm.isAdmin = false;
        vm.currentOrganization = null;
        appDataService.currentOrganization = null;

        // periodi di riferimento tra cui scegliere
        vm.referencePeriods = [];
        // periodo di riferimento correntemente selezionato
        vm.currentReferencePeriod = {
            description: null,
            organizationId: (vm.currentOrganization && vm.currentOrganization.id) ? vm.currentOrganization.id : null,
            dateFrom: null,
            dateTo: null
        };

        vm.loadOrganizationPlan = loadOrganizationPlan;

        // Data
        $rootScope.global = {
            search: ''
        };


        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options)
        {
            vm.isAdmin = toState.url.indexOf('/profile') < 0  && toState.url.indexOf('/notifications') < 0  && toState.url.indexOf('/chat') < 0 ;
            vm.switchAdminUser = !vm.isAdmin;

            if (toState.name === 'app.pages_user_detail') {
                var comingFromUrl = fromState.url;
                if (fromState && !fromState.abstract && comingFromUrl.indexOf('/user') < 0 && comingFromUrl.indexOf('/subscription') < 0) {
                    sessionStorage.setItem('USER_DETAIL_FROM_STATE', JSON.stringify(fromState));
                    sessionStorage.setItem('USER_DETAIL_FROM_PARAMS', JSON.stringify(fromParams));
                }
            }

        });


        vm.doSwitchAdminUser = function() {
            if (vm.isAdmin) {
                gotoProfile();
            } else {
                if (!vm.adminOrganizations || vm.adminOrganizations.length === 0) {
                    goToNewOrganization();
                } else if (vm.adminOrganizations.length === 1) {
                    goToOrganization(vm.adminOrganizations[0]);
                } else {
                    goToOrganizations();
                }
            }
        }

        var loadUserAndOrganizationsMenu = function() {
            loadUser(vm.user.id).then(function(user) {
                loadOrganizations(user).then(
                    function(data) {
                        vm.adminOrganizations = _.filter(data.result.organizations, function(o) {
                            return o.isAdmin;
                        });
                        vm.adminOrganizations = _.sortBy(vm.adminOrganizations, function(o) {
                            return o.name;
                        });
                        appDataService.adminOrganizations = vm.adminOrganizations;


                        vm.staffOnlyOrganization = _.filter(data.result.organizations, function(o) {
                            return !o.isAdmin && o.isStaff;
                        });
                        vm.staffOnlyOrganization = _.sortBy(vm.staffOnlyOrganization, function(o) {
                            return o.name;
                        });

                        var currentOrganization =  sessionStorage.getItem('CURRENT_ORGANIZATION');
                        if (currentOrganization) {
                            var theOrg = _.find(vm.adminOrganizations, function(o) { return o.id == currentOrganization; });
                            if (!theOrg) {
                                theOrg = _.find(vm.staffOnlyOrganization, function(o) { return o.id == currentOrganization; })
                            }
                            if (theOrg) {
                                vm.currentOrganization = theOrg;
                                appDataService.currentOrganization = theOrg;
                                loadOrganizationPlan();
                                // costruisce i periodi di riferimento
                                fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                                    if (!err) {
                                        vm.referencePeriods = referencePeriods;
                                    } else {
                                        vm.referencePeriods = [];
                                    }
                                });
                            }
                        }

                    });
            });
        };

        var reloadMenuCleanupFcn = $rootScope.$on('RELOAD_MENU', function(event, valore) {
            loadUserAndOrganizationsMenu();
        });

        var orgDelCleanupFcn = $rootScope.$on('ORGANIZATION_DELETED', function(event, valore) {
            loadUserAndOrganizationsMenu();
        });

        var orgSelCleanupFcn = $rootScope.$on('ORGANIZATION_SELECTED', function(event, valore) {
            if (valore) {
                var theOrg = _.find(vm.adminOrganizations, function(o) { return o.id == valore; });
                if (!theOrg) {
                    theOrg = _.find(vm.staffOnlyOrganization, function(o) { return o.id == valore; })
                }
                if (theOrg) {
                    vm.currentOrganization = theOrg;
                    appDataService.currentOrganization = theOrg;
                    loadOrganizationPlan();
                    // costruisce i periodi di riferimento
                    fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                        if (!err) {
                            vm.referencePeriods = referencePeriods;
                        } else {
                            vm.referencePeriods = [];
                        }
                    });
                }
            } else {
                vm.currentOrganization = null;
                appDataService.currentOrganization = null;
                sessionStorage.setItem('CURRENT_ORGANIZATION', null);
                // costruisce i periodi di riferimento
                fetchReferencePeriods(null, function(err, referencePeriods) {
                    if (!err) {
                        vm.referencePeriods = referencePeriods;
                    } else {
                        vm.referencePeriods = [];
                    }
                });
            }
        });

        var chatStatusCleanupFcn = $rootScope.$on('CHAT_STATUS_CHANGED', function(event, valore) {
            vm.userStatus = $rootScope.userChatStatus;
        });


        var currentOrgRefreshCleanupFcn = $rootScope.$on('CURRENT_ORGNANIZATION_REFRESH', function(event, valore) {
            if (vm.currentOrganization && vm.currentOrganization.id) {
                Organization.findById({id: vm.currentOrganization.id}).$promise.then(function(data) {
                    vm.currentOrganization = data;
                    appDataService.currentOrganization = data;
                    loadUserAndOrganizationsMenu();
                    // costruisce i periodi di riferimento
                    fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                        if (!err) {
                            vm.referencePeriods = referencePeriods;
                        } else {
                            vm.referencePeriods = [];
                        }
                    });
                }, function(err) {
                    $log.error(err);
                });
            }
        });

        //CLEANUP
        $scope.$on('$destroy', function() {
            if (reloadMenuCleanupFcn) reloadMenuCleanupFcn();
            if (orgDelCleanupFcn) orgDelCleanupFcn();
            if (orgSelCleanupFcn) orgSelCleanupFcn();
            if (chatStatusCleanupFcn) chatStatusCleanupFcn();
            if (currentOrgRefreshCleanupFcn) currentOrgRefreshCleanupFcn();
        });

        var months={};
        var shortMonths={};
        var days={};
        var shortDays={};
        var firstDayOfWeek={};
        var clubyourlifeId = sessionStorage.getItem('clubyourlifeId');
        vm.adminOrganizations = [];

        vm.cylVersion = $('#cyl-app-version').text();
        vm.cylLastCommit = $('#cyl-app-version-commit').text();

        months['it'] = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
        shortMonths['it'] = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
        days['it'] = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
        shortDays['it'] =['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
        firstDayOfWeek['it']=1;

        months['en'] = ['january','february','march','april','may','june','july	','august','september','october','november','december'];
        shortMonths['en'] = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
        days['en'] = ['sunday', 'monday', 'tuesday','wednesday', 'thursday', 'friday', 'saturday'];
        shortDays['en'] =['sun', 'mon', 'tue','wed', 'thu', 'fri', 'sat'];
        firstDayOfWeek['en']=0;

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50',
                'code' : 'online'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107',
                'code' : 'away'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336',
                'code' : 'do-not-disturb'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD',
                'code' : 'invisible'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161',
                'code' : 'offline'
            }
        ];
        vm.languages = {
            it: {
                'title'      : 'Italiano',
                'translation': 'TOOLBAR.ITALIAN',
                'code'       : 'it',
                'flag'       : 'it'
            },
            // en: {
            //     'title'      : 'English',
            //     'translation': 'TOOLBAR.ENGLISH',
            //     'code'       : 'en',
            //     'flag'       : 'us'
            // }
        };
        vm.apiPath=ApiPath;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.gotoProfile = gotoProfile;
        vm.gotoSettings = gotoSettings;
        vm.gotoNotifications = gotoNotifications;
        vm.goToChat = goToChat;
        vm.goToOrganization = goToOrganization;
        vm.goToOrganizationAttendances = goToOrganizationAttendances;
        vm.translateStatus=translateStatus;
        vm.goToNewOrganization = goToNewOrganization;
        //vm.goToChangePwd=goToChangePwd; //spostato da nic in pagina impostazioni
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            $rootScope.currentLanguage='it';
            localizeDatepickers('it');

            if (AuthenticationService.isAuthenticated()){
                AuthenticationService.loggedUser().then(
                    function(value,headers){
                        vm.user = value;
                        // $log.debug('ToolbarController vm.user: ' + JSON.stringify(vm.user));

                        // usa avatar impostato, se manca prova con gravatar
                        // if (vm.user && vm.user.uriAvatar) {
                        //     $rootScope.uriAvatar = vm.apiPath + "/userDocumentsContainers/"+$rootScope.CYL_USER_DOC_PREFIX + vm.user.id + "/download/" + vm.user.uriAvatar;
                        // } else {
                        //     // se non ha un avatar impostato, prova con gravatar
                        //     var mailHash = md5.createHash(vm.user.email);
                        //     $rootScope.uriAvatar = "https://secure.gravatar.com/avatar/" + mailHash + "?s=100&d=identicon";
                        //     //$rootScope.uriAvatar = "assets/images/avatars/profile.jpg";
                        // }

                        loadUserAndOrganizationsMenu();

                        $rootScope.uriAvatar=value.uriAvatar;
                    	UserPreference.find({
                    		filter: {
                				where : {
                					userId: vm.user.id,
                					code: {inq: ['CHAT_STATUS','LANGUAGE']}
                				}
                        	}
                        }, function(preferences) {
                        	if (preferences && preferences.length>0) {
                        		for (var k = 0; k < preferences.length; k++) {

                        			if (preferences[k].code==='CHAT_STATUS') {
                                        var codice = preferences[k].value;
                                        for (var i in vm.userStatusOptions) {
                                        	if (vm.userStatusOptions[i].code===codice) {
                                                vm.userStatus = vm.userStatusOptions[i];
                                                $rootScope.userChatStatus=vm.userStatus;

                                                if ($rootScope.userChatStatus && $rootScope.userChatStatus.code) {
                                                    UserChatStatus.upsert({
                                                        userId: LoopBackAuth.currentUserId,
                                                        status: $rootScope.userChatStatus.code,
                                                        updated: new Date()
                                                    }, function(value, responseHeaders) {
                                                        $log.debug(value);
                                                    }, function(httpResponse) {
                                                        $log.error(httpResponse);
                                                    });
                                                }

                                        		break;
                                        	}
                                        }

                        			}
                        			else if (preferences[k].code==='LANGUAGE') {
                                        var codice = preferences[k].value;
                                        $rootScope.currentLanguage=codice;

                                        for (var i in vm.languages) {
                                        	if (vm.languages[i].code===codice) {
                                	            vm.selectedLanguage = vm.languages[i];
                                	            $translate.use(vm.selectedLanguage.code );
                                	            localizeDatepickers(vm.selectedLanguage.code);
                                        		break;
                                        	}
                                        }
                        			}

                        		}


                        	}
                    	});

                    	//carico le categorie
                		Category.find({}, function(data) {
                            $rootScope.organizationCategories = data;
                		});

                    	DictionaryService.loadDictionary();
                    }
                );
            } else {
                $log.debug("User not logged-in");
                goToLogin();
            }

            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];//TODO


        }

        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
            $rootScope.userChatStatus=status;
            //aggiorno la preferenza
      	   User.findById({
               id: vm.user.id
           }).$promise.then(function(user){
        	   user.$prototype$updatePreference({code:'CHAT_STATUS', value: status.code}).then(
					function(response) {
						//LOG ONLY
                        $log.debug('chat status updated to '+status.code);
					});
           });
        }

        /**
         * Logout Function
         */
        function logout()
        {
    		$rootScope.$emit('LOGOUT_EVENT', 'Logout');

            //$log.debug("Logging out");
        	breadcrumbManager.clearAll();

            AuthenticationService.logout();
            goToLogin();
        }


        function goToLogin() {
            if (clubyourlifeId && clubyourlifeId!==''  && clubyourlifeId!=='null'  && clubyourlifeId!=='undefined') {
                //window.location.href="/pages/auth/"+clubyourlifeId+"/login";
                $state.go('app.pages_auth_login_custom', { clubyourlifeId: clubyourlifeId });
            } else {
                $state.go('app.pages_auth_login');
                //window.location.href="/pages/auth/login";
            }
        }


        function goToNewOrganization()
        {
            vm.currentOrganization = null;
            appDataService.currentOrganization = null;
            // costruisce i periodi di riferimento
            fetchReferencePeriods(null, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.new_organization');
            });
        }

        function loadOrganizationPlan() {
            CylPlan.loadCurrentOrganizationStats({organizationId: vm.currentOrganization.id}).$promise.then(function(stats) {
                appDataService.organizationPlanStats = stats;
                vm.organizationPlanStats = stats;
            },  function(httpResponse) {
                $log.debug(httpResponse);
            });
        }



        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);

            $rootScope.currentLanguage=lang.code;
            $rootScope.$emit('CHANGE_LANGUAGE', lang.code);
            localizeDatepickers(lang.code);

            //aggiorno la preferenza
       	   User.findById({
                id: vm.user.id
            }).$promise.then(function(user){
         	   user.$prototype$updatePreference({code:'LANGUAGE', value: lang.code}).then(
 					function(response) {
 						//LOG ONLY
                        $log.debug('LANGUAGE updated to '+lang.code);
 					});
            });
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }

        function gotoProfile(){
            vm.currentOrganization = null;
            // costruisce i periodi di riferimento
            fetchReferencePeriods(null, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.pages_profile_socio',{ userId: vm.user.id, tab: 'GEN' });
            });
        }

        function goToChat() {
            vm.currentOrganization = null;
            // costruisce i periodi di riferimento
            fetchReferencePeriods(null, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.chat');
            });
        }


        function goToOrganization(organization) {
            vm.currentOrganization = organization;
            appDataService.currentOrganization = organization;
            loadOrganizationPlan();
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.organization', {organizationId: organization.id});
        }

        function goToOrganizationAttendances(organization) {
            vm.currentOrganization = organization;
            appDataService.currentOrganization = organization;
            loadOrganizationPlan();
            // costruisce i periodi di riferimento
            fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.pages_attendances_pre', {organizationId: organization.id});
            });
        }

        function gotoSettings(){
            vm.currentOrganization = null;
            // costruisce i periodi di riferimento
            fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.pages_profile_settings');
            });
        }


        function goToOrganizations(){
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.organizations', {});
        }


        function gotoNotifications(){
            vm.currentOrganization = null;
            // costruisce i periodi di riferimento
            fetchReferencePeriods(vm.currentOrganization, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go('app.pages_notifications',{});
            });
        }


        function localizeDatepickers(lang) {


            var lang = $rootScope.currentLanguage;
            if (!lang || lang===null) lang = 'it';

            // Example of a French localization.
            $mdDateLocale.months = months[lang];
            $mdDateLocale.shortMonths = shortMonths[lang];
            $mdDateLocale.days = days[lang];
            $mdDateLocale.shortDays =shortDays[lang];

            // Can change week display to start on Monday.
            $mdDateLocale.firstDayOfWeek = firstDayOfWeek[lang];

            $rootScope.$on('CHANGE_LANGUAGE', function (lang) {
                // Example of a French localization.
            	$mdDateLocale.months = months[lang];
            	$mdDateLocale.shortMonths = shortMonths[lang];
            	$mdDateLocale.days = days[lang];
                $mdDateLocale.shortDays =shortDays[lang];

                // Can change week display to start on Monday.
                $mdDateLocale.firstDayOfWeek = firstDayOfWeek[lang];
               });

        }

        /*function goToChangePwd() { //eliminato da nic (spostato in pagina impostazioni)
            $state.go('app.pages_auth_change_pwd');
        }*/


        function translateStatus() {
        	if (!rootScope.userChatStatus) return;

        	switch($rootScope.userChatStatus.code) {
        		case 'online': return 'icon-checkbox-marked-circle mr-8 green-fg';
        		case 'away': return 'icon-clock mr-8 yellow-fg';
        		case 'do-not-disturb': return 'icon-minus-circle mr-8 red-fg';
        		case 'invisible': return 'icon-checkbox-blank-circle-outline';
        		case 'offline': return 'icon-checkbox-blank-circle-outline mr-8';
        	}
        }



        /**
         * Apre una modale con la quale scegliere il periodo di riferimento personalizzato
         */
        vm.openCustomReferencePeriodModal = function() {
            $log.debug('ToolbarController.vm.openCustomReferencePeriodModal()');
            $log.debug('ToolbarController.vm.openCustomReferencePeriodModal - vm.currentReferencePeriod: ' + JSON.stringify(vm.currentReferencePeriod));
            function RefPeriodDialogController($scope, $mdDialog) {
                // $scope.apiPath = ApiPath;
                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                    breadcrumbManager.loadReferencePeriodForOrganization(function(data) {
                        vm.currentReferencePeriod = data;
                    });
                };
                $scope.clearDates = function() {
                    vm.currentReferencePeriod.description = null;
                    vm.currentReferencePeriod.dateFrom = null;
                    vm.currentReferencePeriod.dateTo = null;
                };
                $scope.applyDates = function(answer) {
                    var isOk = false;
                    //CHECK
                    //- data inizio <= data fine
                    if (vm.currentReferencePeriod.dateFrom && vm.currentReferencePeriod.dateTo && moment(vm.currentReferencePeriod.dateFrom).isAfter(moment(vm.currentReferencePeriod.dateTo))) {
                        $scope.displayErrorDates = $translate.instant('OFFERED_SERVICES.SCHEDULES.ERROR_DATE_INTERVAL_INVALID');
                    } else {
                        isOk=true;
                    }
                    if (isOk) {
                        $mdDialog.hide(answer);
                    }
                };
            }

            $mdDialog.show({
                controller: RefPeriodDialogController,
                templateUrl: 'app/toolbar/dialogs/custom-reference-period.html',
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true
            }).then(function(answer) {
                $log.debug('ToolbarController.vm.openCustomReferencePeriodModal - answer: ' + JSON.stringify(answer));
                var newReferencePeriod = {
                    organizationId : vm.currentOrganization.id,
                    description: '',
                    dateFrom: $scope.organizationPeriod.dateFrom,
                    dateTo: $scope.organizationPeriod.dateTo,
                };
                if (newReferencePeriod.dateFrom) {
                    newReferencePeriod.description +=  moment(newReferencePeriod.dateFrom).format('DD/MM/YYYY');
                }
                if (newReferencePeriod.dateTo) {
                    newReferencePeriod.description += ' - ' + moment(newReferencePeriod.dateTo).format('DD/MM/YYYY');
                }
                breadcrumbManager.saveReferencePeriodForOrganization(newReferencePeriod, function(data) {
                    vm.currentReferencePeriod = data;
                    $log.debug('ToolbarController.vm.openCustomReferencePeriodModal - nuovo vm.currentReferencePeriod: ' + JSON.stringify(vm.currentReferencePeriod));
                });
            }, function() {
                $log.debug('ToolbarController.vm.openCustomReferencePeriodModal - You cancelled the dialog.');
            });
        };


        /**
         * Imposta il periodo di riferimento passato come parametro.
         * 
         * @param {object} referencePeriod 
         */
        vm.setReferencePeriod = function(referencePeriod) {
            breadcrumbManager.saveReferencePeriodForOrganization(referencePeriod, function(data) {
                vm.currentReferencePeriod = data;
            });
        };


        /**
         * handler application menu
         */
        vm.gotoOrganizationContacts = function() {
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.organization_members', { organizationId: vm.currentOrganization.id });
        }
        vm.gotoOrganizationServices = function() {
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.organization_services', { organizationId: vm.currentOrganization.id, serviceType: 'SERVICE' });
        }
        vm.gotoOrganizationEarningCosts = function() {
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_earningcosts', { organizationId: vm.currentOrganization.id });
        }
        vm.gotoOrganizationSettings = function() {
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.organization_settings', { organizationId: vm.currentOrganization.id });
        }
        vm.gotoUserDashboard = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_socio', { userId: vm.user.id, tab: 'GEN' });
        }
        vm.gotoUserRelatives = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_relatives', {userId: vm.user.id});
        }
        vm.gotoUserParents = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_parents', {userId: vm.user.id});
        }
        vm.gotoUserServices = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_services', {userId: vm.user.id});
        }
        vm.gotoUserDocuments = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_docs', {userId: vm.user.id});
        }
        vm.gotoUserPayments = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_payments', {userId: vm.user.id});
        }
        vm.gotoUserSettings = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.pages_profile_settings', {userId: vm.user.id});
        }
        vm.gotoUserPrivacySettings = function() {
            vm.currentOrganization = null;
            fetchReferencePeriodsAndGoTo(vm.currentOrganization, 'app.legal_gdpr_settings');
        }


        /**
         * Legge e applica i periodi di riferimento per l'organizzazione, poi segue la rotta indicata.
         * 
         * @param {object} currentOrganization 
         * @param {string} routeName 
         * @param {object} routeParams 
         */
        function fetchReferencePeriodsAndGoTo(currentOrganization, routeName, routeParams) {
            routeParams = routeParams || {};
            fetchReferencePeriods(currentOrganization, function(err, referencePeriods) {
                if (!err) {
                    vm.referencePeriods = referencePeriods;
                } else {
                    vm.referencePeriods = [];
                }
                $state.go(routeName, routeParams);
            });
        }


        /**
         * Legge i periodi di riferimento per l'organizzazione visualizzata, e li ritorna
         * in un array.
         * 
         * @param {object | null} organization 
         * @param {function(err, data)} Callback. Data è un Array con i periodi di riferimento
         */
        function fetchReferencePeriods(organization, callback) {
            if (organization && organization.id) {
                // prima aggiunge i periodi predefiniti
                var periods = [
                    {
                        description: "Anno " + moment().format('YYYY'),
                        organizationId: organization.id,
                        dateFrom: moment().startOf('year').toDate(),
                        dateTo: moment().endOf('year').toDate(),
                    },
                    {
                        description: "Anno " + moment().subtract(1, 'year').format('YYYY'),
                        organizationId: organization.id,
                        dateFrom: moment().subtract(1, 'year').startOf('year').toDate(),
                        dateTo: moment().subtract(1, 'year').endOf('year').toDate(),
                    },
                    {
                        description: "-",
                        organizationId: null,
                        dateFrom: null,
                        dateTo: null,
                    },
                    {
                        description: "Nessun filtro",
                        organizationId: organization.id,
                        dateFrom: null,
                        dateTo: null,
                    },
                ];
                // poi reperisce i periodi dalle quote di iscrizione
                fetchSubscriptionServices(organization.id, function(err, subscriptionServices) {
                    if (!err && subscriptionServices && subscriptionServices.length > 0) {
                        $log.debug('fetched subscriptionServices: ' + JSON.stringify(subscriptionServices));
                        subscriptionServices.forEach(function(subscriptionService) {
                            if (subscriptionService && subscriptionService.start && subscriptionService.end) {
                                var description = moment(subscriptionService.start).add(10, 'hours').format('DD/MM/YYYY') + ' - ' + moment(subscriptionService.end).add(10, 'hours').format('DD/MM/YYYY');
                                // accoda il periodo solo se non esiste già
                                if (periods.findIndex(function(existingPeriod) {
                                    return existingPeriod && existingPeriod.description === description;
                                }) === -1) {
                                    var newPeriod = {
                                        description: description,
                                        organizationId: organization.id,
                                        dateFrom: subscriptionService.start,
                                        dateTo: subscriptionService.end,
                                    };
                                    periods.unshift(newPeriod);
                                }
                            }
                        });
                    }
                    callback(null, periods);
                });
            } else {
                callback(new Error('err.missingParameter.organizationId'), []);
            }
        }



        /**
         * Reperisce i servizi di quote di iscrizione per una organizzazione
         * @param {number} organizationId 
         * @param {function(err, data)} callback Callback con l'elenco dei servizi di quota associativa
         */
        function fetchSubscriptionServices(organizationId, callback) {
            if (organizationId) {
                OfferedService.find({
                    filter: {
                        where: {
                            organizationId: organizationId,
                            isDeleted: false,
                        },
                        include: ['serviceTypes', 'offeredServiceTypeRelations'],
                    }
                }).$promise.then(
                    function(items) {
                        var items = JSON.parse(JSON.stringify(items));
                        // filtra eliminando i servizi che non sono sottoscrizioni
                        items = _.filter(items, function(item) {
                            var ret = false;
                            if (item && item.serviceTypes) {
                                _.each(item.serviceTypes, function(serviceType) {
                                    if (serviceType.internalCode === 'SUBSCRIPTION') {
                                        ret = true;
                                    }
                                });
                            }
                            return ret;
                        });
                        callback(null, items);
                    },
                    function(httpResponse) {
                        $log.error(httpResponse);
                        callback(new Error('err.failedRequest'), null);
                    }
                );
            } else {
                callback(new Error('err.missingParameter.organizationId'), null);
            }
        }



        /**
         * Va alla dashboard della organizzazione corrente.
         */
        vm.gotoCurrentOrganizationDashboard = function() {
            if (appDataService && appDataService.currentOrganization) {
                $state.go('app.organization', {organizationId: appDataService.currentOrganization.id});
            }
        };


        /**
         * Va alla pagina delle impostazioni GDPR
         */
        vm.gotoGdprSettings = function() {
            $state.go('app.legal_gdpr_settings', {});
        };


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Loopback integration
            'lbServices',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            //pages
            'app.pages',

            //chat
            'app.chat',

//            'angular-tour',
            'angular-md5',

            // libreria c3.js per grafici
            'gridshore.c3js.chart'

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $state, $rootScope, CylNotifier, User, msNavigationService, PubSub,
                            AlertMessageService, SocketIOPath, LoopBackAuth, AuthenticationService, UserChatStatus,
                            $mdDialog, $log, NotificationChannel, ApiPath)
    {
        // Data
    	var socket=null;
        var vm = this;
        var self = this;
        vm.apiPath=ApiPath;

    	vm.organizionAdminIds = [];
        //////////


    	init();

    	function init() {
            if (AuthenticationService.isAuthenticated()){
                // initMenu();
                initChatsCounters();
                //CASO IN CUI CARICO LA PAGINA GIA LOGGATO: RITARDO DI 5 SECONDI L'AUTENTICAZIONE VS LA CHAT
                setTimeout(function() {
                    initChats();
                }, 5000);
            }
    	}

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });


        $rootScope.$on('USER_NOTIFICATION_COUNT', function (event, valore) {
        	$rootScope.totalNewNotification=valore;

        });

        $rootScope.$on('USER_CHAT_COUNT', function (event, valore) {
        	var nav = msNavigationService.getNavigation();
        	if (nav && nav.length) {
        		var children = nav[1].children;
            	if (children && children.length) {
            		for (var child in children) {
            			var item = children[child];
            			if (item._id==='chat') {
            				if (valore) {
            					item.badge = {
            		                content: valore,
            		                color  : '#09d261'
            		            };
            				} else if (item.badge) {
            					delete item.badge;
            				}
            				break;
            			}
            		}
            	}
        	}
        	$rootScope.totalNewChatMessage=valore;

        });


        // function initMenu () {
        //
            // for (var i = 0; i < vm.organizionAdminIds.length; i++) {
            //     msNavigationService.deleteItem('admin.organization_'+vm.organizionAdminIds[i]);
            // }
            // msNavigationService.deleteItem('user.profile.relatives');
            //
            //
            // // Utente
            // msNavigationService.saveItem('admin', {
            //     title : 'ADMIN',
            //     translate  : 'USERS.ME_AS_ADMIN',
            //     group : true,
            //     userId: LoopBackAuth.currentUserId,
            //     weight: 3
            // });
            //
            // msNavigationService.saveItem('admin.organizations', {
            //     title: 'Organizations',
            //     translate  : 'USERS.MY_ORGANIZATIONS',
            //     icon  : 'icon-apps',
            //     state: 'app.organizations',
            //     weight     : 30
            //
            // });
            //
            //
            // // Utente
            // msNavigationService.saveItem('user', {
            //     title : 'USER',
            //     translate  : 'USERS.MY_PROFILE',
            //     group : true,
            // 	userId: LoopBackAuth.currentUserId,
            //     weight: 3
            // });
            //
            //
            // msNavigationService.saveItem('user.profile', {
            //     title: 'Profile',
            //     translate  : 'USERS.MANAGE',
            //     icon  : 'icon-account',
            //     state: 'app.pages_profile_socio',
            //     stateParams: {
            //     	userId: LoopBackAuth.currentUserId,
            //     },
            //     weight: 4
            //
            // });
            //
            // msNavigationService.saveItem('user.profile.documents', {
            //     title: 'Documents',
            //     translate  : 'USERS.DOCUMENTS',
            //     icon  : 'icon-file-document',
            //     state: 'app.pages_profile_docs',
            //     stateParams: {
            //         userId: LoopBackAuth.currentUserId,
            //     },
            //     weight: 5
            //
            // });
            //
            // User.isParentManagementEnabled({userId: User.getCurrentId().toString()}).$promise.then(function(data) {
            //     if (data.result) {
            //         msNavigationService.saveItem('user.profile.relatives', {
            //             title: 'Relatives',
            //             translate  : 'USERS.RELATIVES',
            //             icon  : 'icon-human-child',
            //             state: 'app.pages_profile_relatives',
            //             stateParams: {
            //                 userId: LoopBackAuth.currentUserId,
            //             },
            //             weight: 6
            //
            //         });
            //         setTimeout(function() {
            //             msNavigationService.sort();
            //         }, 1000);
            //     }
            // });
            //
            //
            //
            // msNavigationService.saveItem('user.profile.services', {
            //     title: 'Services',
            //     translate  : 'USERS.OFFERED_SERVICES',
            //     icon  : 'icon-calendar-multiple',
            //     state: 'app.pages_profile_services',
            //     stateParams: {
            //         userId: LoopBackAuth.currentUserId,
            //     },
            //     weight: 7
            // });
            //
            // msNavigationService.saveItem('user.profile.attendances', {
            //     title: 'Attendances',
            //     translate  : 'ATTENDANCES.PROFILE_ATTENDANCES',
            //     icon  : 'icon-account-check',
            //     state: 'app.profile_attendances',
            //     stateParams: {
            //         userId: LoopBackAuth.currentUserId,
            //     },
            //     weight: 8
            //
            // });
            //
            // msNavigationService.saveItem('user.profile.payments', {
            //     title: 'Payments',
            //     translate  : 'USERS.PAYMENTS',
            //     icon  : 'icon-cash-100',
            //     state: 'app.pages_profile_payments',
            //     stateParams: {
            //         userId: LoopBackAuth.currentUserId,
            //     },
            //     weight: 9
            // });
            //
            // //carico le associazioni amministrate e le metto a menu
            // var currentUserId = User.getCurrentId();
            // loadUser(currentUserId).then(function(user){
            //     loadOrganizations(user).then(
            //         function(data){
            //             var adminOrgs = _.filter(data.result.organizations, function(o) { return o.isAdmin; });
            //             //TRONCO ALLE PRIME 20
            //             adminOrgs = _.first(adminOrgs, 20);
            //             for (var i = 0; i < adminOrgs.length; i++) {
            //                 var theOrg = adminOrgs[i];
            //
            //                 vm.organizionAdminIds.push(theOrg.id);
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id, {
            //                     title: theOrg.name,
            //                     icon  : 'icon-shield',
            //                     img   : (theOrg.uriLogo && theOrg.uriLogo!=='') ? ( vm.apiPath + '/organizationDocumentsContainers/'+ $rootScope.CYL_ORG_DOC_PREFIX + theOrg.id +'/download/' +theOrg.uriLogo): null,
            //                     state: 'app.organization',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                     },
            //                     weight     : i
            //                 });
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.services', {
            //                     title: 'services',
            //                     translate: 'ORGANIZATIONS.OFFERED_SERVICES.OFFERED_SERVICES_AND_SUBSCRIPTIONS',
            //                     icon  : 'icon-calendar-multiple',
            //                     state: 'app.organization_services',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                         serviceType: 'SERVICE'
            //                     },
            //                     weight     : i
            //                 });
            //
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.members', {
            //                     title: 'members',
            //                     translate: 'ORGANIZATIONS.MEMBERS',
            //                     icon  : 'icon-account-multiple',
            //                     state: 'app.organization_members',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                     },
            //                     weight     : i
            //                 });
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.resources', {
            //                     title: 'resources',
            //                     translate: 'ORGANIZATIONS.RESOURCES.RESOURCES',
            //                     icon  : 'icon-package',
            //                     state: 'app.organization_resources',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                     },
            //                     weight     : i
            //                 });
            //
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.earningcosts', {
            //                     title: 'earningcosts',
            //                     translate: 'ORGANIZATIONS.EARNING_COSTS',
            //                     icon  : 'icon-coin',
            //                     state: 'app.pages_earningcosts',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                     },
            //                     weight     : i
            //                 });
            //
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.events', {
            //                     title: 'events',
            //                     translate: 'ORGANIZATIONS.OFFERED_SERVICES.EVENTS',
            //                     icon  : 'icon-calendar-check',
            //                     state: 'app.organization_events',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                         serviceType: 'EVENT'
            //                     },
            //                     weight     : i
            //                 });
            //
            //                 msNavigationService.saveItem('admin.organization_'+theOrg.id+'.settings', {
            //                     title: 'events',
            //                     translate: 'ORGANIZATIONS.SETTINGS',
            //                     icon  : 'icon-cog',
            //                     state: 'app.organization_settings',
            //                     stateParams: {
            //                         organizationId: theOrg.id,
            //                     },
            //                     weight     : i
            //                 });
            //             }
            //
            //             if (adminOrgs.length > 0) {
            //
            //                 msNavigationService.saveItem('admin.subscriptions', {
            //                     title: 'Subscriptions',
            //                     translate  : 'PAGES.SUBSCRIPTIONS',
            //                     icon  : 'icon-pencil-box-outline',
            //                     state: 'app.pages_subscriptions',
            //                     weight     : 2000
            //                 });
            //             }
            //
            //             var staffOrgs = _.filter(data.result.organizations, function(o) { return o.isStaff; });
            //             if (adminOrgs.length > 0 || staffOrgs.length > 0) {
            //                 msNavigationService.saveItem('admin.attendances', {
            //                     title: 'Attendances',
            //                     translate  : 'PAGES.ATTENDANCES',
            //                     icon  : 'icon-account-check',
            //                     state: 'app.pages_attendances',
            //                     weight     : 2001
            //                 });
            //             }
            //
            //             msNavigationService.sort();
            //         },
            //         function(err) {
            //             $log.error('Error: '+err);
            //         }
            //     );
            // });
            //
            //
            // msNavigationService.sort();
        //
        // }

        function initChatsCounters() {
            var currentUserId = User.getCurrentId();
            if (currentUserId && currentUserId!==null) {
                CylNotifier.countNotifications(currentUserId);
                CylNotifier.countChatUnreadMessages(currentUserId);
            }
        }

        function initChats() {

            $log.debug("initChats()");
            socket = io.connect(SocketIOPath);

            //This part is only for login users for authenticated socket connection between client and server.
            //If you are not using login page in you website then you should remove rest piece of code..
            var id = LoopBackAuth.accessTokenId;
            var userId = LoopBackAuth.currentUserId;


            var currentUserId = User.getCurrentId();
            if (currentUserId && currentUserId!==null) {
                CylNotifier.countNotifications(currentUserId);
                var myInterval  = setInterval(function(){
                    CylNotifier.countNotifications(currentUserId);
                    CylNotifier.countChatUnreadMessages(currentUserId);
                }, 30000);//1 minuti

                var myIntervalChatStatus  = setInterval(function(){
                    if ($rootScope.userChatStatus && $rootScope.userChatStatus.code) {
                        UserChatStatus.upsert({
                            userId: currentUserId,
                            status: ($rootScope.userChatStatus && $rootScope.userChatStatus.code ? $rootScope.userChatStatus.code : null),
                            updated: new Date()
                        }, function(value, responseHeaders) {
                            $log.debug(value);
                        }, function(httpResponse) {
                            $log.error(httpResponse);
                        });
                    }
                }, 120000);//sottometto lo stato ogni 2 minuti


                CylNotifier.countChatUnreadMessages(currentUserId);

                $scope.$on('$destroy', function() {
                    $log.debug('Main controller: destroy');
                    clearInterval(myInterval);
                    clearInterval(myIntervalChatStatus);
//                      PubSub.unSubscribeAll(socket);
                });
            }

            socket.on('connect', function(){
                $log.debug('socket factory:: on connect');

                socket.emit('authentication', {id: id, userId: userId, channel: NotificationChannel });
                socket.on('authenticated', function() {
                    // use the socket as usual
                    $log.debug('socket factory:: user is authenticated');

                	var currentUserId = User.getCurrentId();
                	if (currentUserId && currentUserId!==null) {
                        //Mi sottoscrivo alla chat quando arrivo e sono già loggato
                        PubSub.subscribe(socket, function(data) {
            				if ($rootScope.userChatStatus && $rootScope.userChatStatus!=null && $rootScope.userChatStatus.code==='offline' ) {
            					//SE SONO OFFLINE NON AFCCIO NULLA
            					return;
            				}

                        	AlertMessageService.showNotificationAlert(data);
                        	CylNotifier.countNotifications(currentUserId);
        					CylNotifier.countChatUnreadMessages(currentUserId);
        			        $rootScope.$emit('NEW_CHAT_MESSAGE',data);


                        }, function(data) {
                            $log.debug('Main controller: status aggiornato: '+data);
                        });
                	}
                });
            });

    		$rootScope.$emit('CHAT_INIT', User.getCurrentId());

            return socket;
        }


        /**
         * Dopo la login di un utente
         */
        $rootScope.$on('LOGIN_EVENT', function (event, valore) {
            $log.debug("Login event detected");
         	// initMenu();
            initChatsCounters();
        	initChats();
        });




        $rootScope.$on('RELOAD_MENU', function (event, valore) {
            $log.debug("RELOAD_MENU event detected");
            // initMenu();
        });

        $rootScope.$on('ORGANIZATION_DELETED', function (event, valore) {
            msNavigationService.deleteItem('admin.organization_'+valore);
            vm.organizionAdminIds = _.filter(vm.organizionAdminIds, function(o) {return o!=valore;})
        });


        $rootScope.$on('LOGOUT_EVENT', function (event, valore) {
        	if (socket && socket!=null) {
       		    PubSub.unSubscribeAll(socket);

    			UserChatStatus.upsert({
   					userId : LoopBackAuth.currentUserId,
   					status: 'offline',
   					updated: new Date()
    			}, function(value, responseHeaders) {
                    $log.debug(value);
    			}, function(httpResponse) {
                    $log.error(httpResponse);
    			});
        	}
        });

        /**
         * carica tutte le organizzazioni dell'utente
         */
        function loadOrganizations(user){
            return user.$prototype$allOrganizations();
        }

        /**
         * carica dettaglio dell'utente
         */
        function loadUser(userId){
            return User.findById({
                id: userId,
            }).$promise;
        }



    	//sovrascrittura alert di default datatables
    	$.fn.dataTable.ext.errMode = 'none';
    	$('.dataTables').on('error.dt', function(e, settings, techNote, message) { $log.error( 'An error occurred: ', message); });
    }
})();

// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.identities.findById() instead.
            "prototype$__findById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.identities.destroyById() instead.
            "prototype$__destroyById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.updateById() instead.
            "prototype$__updateById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.userOrganizationRoles.findById() instead.
            "prototype$__findById__userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.userOrganizationRoles.destroyById() instead.
            "prototype$__destroyById__userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.userOrganizationRoles.updateById() instead.
            "prototype$__updateById__userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.organizations.findById() instead.
            "prototype$__findById__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.organizations.destroyById() instead.
            "prototype$__destroyById__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.updateById() instead.
            "prototype$__updateById__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.organizations.link() instead.
            "prototype$__link__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.organizations.unlink() instead.
            "prototype$__unlink__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.exists() instead.
            "prototype$__exists__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.subscriptions.findById() instead.
            "prototype$__findById__subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.subscriptions.destroyById() instead.
            "prototype$__destroyById__subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.subscriptions.updateById() instead.
            "prototype$__updateById__subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.serviceSubscriptions.findById() instead.
            "prototype$__findById__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.serviceSubscriptions.destroyById() instead.
            "prototype$__destroyById__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.updateById() instead.
            "prototype$__updateById__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.serviceSubscriptions.link() instead.
            "prototype$__link__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.serviceSubscriptions.unlink() instead.
            "prototype$__unlink__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.exists() instead.
            "prototype$__exists__serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__link__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Add a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__link__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__unlink__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Remove the children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__exists__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check the existence of children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__exists__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/children/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__link__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Add a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__link__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__unlink__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Remove the parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__exists__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check the existence of parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__exists__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parents/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.childRelations.findById() instead.
            "prototype$__findById__childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.childRelations.destroyById() instead.
            "prototype$__destroyById__childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.childRelations.updateById() instead.
            "prototype$__updateById__childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.parentRelations.findById() instead.
            "prototype$__findById__parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations.destroyById() instead.
            "prototype$__destroyById__parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.parentRelations.updateById() instead.
            "prototype$__updateById__parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.contacts.findById() instead.
            "prototype$__findById__contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.contacts.destroyById() instead.
            "prototype$__destroyById__contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.contacts.updateById() instead.
            "prototype$__updateById__contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.documents.findById() instead.
            "prototype$__findById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.documents.destroyById() instead.
            "prototype$__destroyById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.updateById() instead.
            "prototype$__updateById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use User.identities() instead.
            "prototype$__get__identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "GET",
            },

            // INTERNAL. Use User.identities.create() instead.
            "prototype$__create__identities": {
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.destroyAll() instead.
            "prototype$__delete__identities": {
              url: urlBase + "/users/:id/identities",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.count() instead.
            "prototype$__count__identities": {
              url: urlBase + "/users/:id/identities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries credentials of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__credentials": {
              isArray: true,
              url: urlBase + "/users/:id/credentials",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in credentials of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__credentials": {
              url: urlBase + "/users/:id/credentials",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all credentials of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__credentials": {
              url: urlBase + "/users/:id/credentials",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__credentials
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts credentials of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__credentials": {
              url: urlBase + "/users/:id/credentials/count",
              method: "GET",
            },

            // INTERNAL. Use User.userOrganizationRoles() instead.
            "prototype$__get__userOrganizationRoles": {
              isArray: true,
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "GET",
            },

            // INTERNAL. Use User.userOrganizationRoles.create() instead.
            "prototype$__create__userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "POST",
            },

            // INTERNAL. Use User.userOrganizationRoles.destroyAll() instead.
            "prototype$__delete__userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "DELETE",
            },

            // INTERNAL. Use User.userOrganizationRoles.count() instead.
            "prototype$__count__userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles/count",
              method: "GET",
            },

            // INTERNAL. Use User.organizations() instead.
            "prototype$__get__organizations": {
              isArray: true,
              url: urlBase + "/users/:id/organizations",
              method: "GET",
            },

            // INTERNAL. Use User.organizations.create() instead.
            "prototype$__create__organizations": {
              url: urlBase + "/users/:id/organizations",
              method: "POST",
            },

            // INTERNAL. Use User.organizations.destroyAll() instead.
            "prototype$__delete__organizations": {
              url: urlBase + "/users/:id/organizations",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.count() instead.
            "prototype$__count__organizations": {
              url: urlBase + "/users/:id/organizations/count",
              method: "GET",
            },

            // INTERNAL. Use User.subscriptions() instead.
            "prototype$__get__subscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/subscriptions",
              method: "GET",
            },

            // INTERNAL. Use User.subscriptions.create() instead.
            "prototype$__create__subscriptions": {
              url: urlBase + "/users/:id/subscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.subscriptions.destroyAll() instead.
            "prototype$__delete__subscriptions": {
              url: urlBase + "/users/:id/subscriptions",
              method: "DELETE",
            },

            // INTERNAL. Use User.subscriptions.count() instead.
            "prototype$__count__subscriptions": {
              url: urlBase + "/users/:id/subscriptions/count",
              method: "GET",
            },

            // INTERNAL. Use User.serviceSubscriptions() instead.
            "prototype$__get__serviceSubscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "GET",
            },

            // INTERNAL. Use User.serviceSubscriptions.create() instead.
            "prototype$__create__serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.serviceSubscriptions.destroyAll() instead.
            "prototype$__delete__serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.count() instead.
            "prototype$__count__serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries children of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__children": {
              isArray: true,
              url: urlBase + "/users/:id/children",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__children": {
              url: urlBase + "/users/:id/children",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__children": {
              url: urlBase + "/users/:id/children",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__children
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts children of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__children": {
              url: urlBase + "/users/:id/children/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries parents of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__parents": {
              isArray: true,
              url: urlBase + "/users/:id/parents",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__parents": {
              url: urlBase + "/users/:id/parents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__parents": {
              url: urlBase + "/users/:id/parents",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__parents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts parents of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__parents": {
              url: urlBase + "/users/:id/parents/count",
              method: "GET",
            },

            // INTERNAL. Use User.childRelations() instead.
            "prototype$__get__childRelations": {
              isArray: true,
              url: urlBase + "/users/:id/childRelations",
              method: "GET",
            },

            // INTERNAL. Use User.childRelations.create() instead.
            "prototype$__create__childRelations": {
              url: urlBase + "/users/:id/childRelations",
              method: "POST",
            },

            // INTERNAL. Use User.childRelations.destroyAll() instead.
            "prototype$__delete__childRelations": {
              url: urlBase + "/users/:id/childRelations",
              method: "DELETE",
            },

            // INTERNAL. Use User.childRelations.count() instead.
            "prototype$__count__childRelations": {
              url: urlBase + "/users/:id/childRelations/count",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations() instead.
            "prototype$__get__parentRelations": {
              isArray: true,
              url: urlBase + "/users/:id/parentRelations",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations.create() instead.
            "prototype$__create__parentRelations": {
              url: urlBase + "/users/:id/parentRelations",
              method: "POST",
            },

            // INTERNAL. Use User.parentRelations.destroyAll() instead.
            "prototype$__delete__parentRelations": {
              url: urlBase + "/users/:id/parentRelations",
              method: "DELETE",
            },

            // INTERNAL. Use User.parentRelations.count() instead.
            "prototype$__count__parentRelations": {
              url: urlBase + "/users/:id/parentRelations/count",
              method: "GET",
            },

            // INTERNAL. Use User.contacts() instead.
            "prototype$__get__contacts": {
              isArray: true,
              url: urlBase + "/users/:id/contacts",
              method: "GET",
            },

            // INTERNAL. Use User.contacts.create() instead.
            "prototype$__create__contacts": {
              url: urlBase + "/users/:id/contacts",
              method: "POST",
            },

            // INTERNAL. Use User.contacts.destroyAll() instead.
            "prototype$__delete__contacts": {
              url: urlBase + "/users/:id/contacts",
              method: "DELETE",
            },

            // INTERNAL. Use User.contacts.count() instead.
            "prototype$__count__contacts": {
              url: urlBase + "/users/:id/contacts/count",
              method: "GET",
            },

            // INTERNAL. Use User.documents() instead.
            "prototype$__get__documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use User.documents.create() instead.
            "prototype$__create__documents": {
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.documents.destroyAll() instead.
            "prototype$__delete__documents": {
              url: urlBase + "/users/:id/documents",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.count() instead.
            "prototype$__count__documents": {
              url: urlBase + "/users/:id/documents/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/users",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/users/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Il corpo della risposta contiene proprietà del AccessToken creato all'accesso.
             * In base al valore del parametro `include`, il corpo può contenere ulteriori proprietà:
             *   - `user` - `U+007BUserU+007D` - Dati dell'utente attualmente collegato.. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/users/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$addChild
             * @methodOf lbServices.User
             *
             * @description
             *
             * Add a child to selected user by id
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `user` – `{object}` - data of the to-be user child
             *
             *  - `organizationId` – `{number=}` - data of organization that creates the relation
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `child` – `{Object=}` -
             */
            "prototype$addChild": {
              url: urlBase + "/users/:id/add-child",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$allOrganizations
             * @methodOf lbServices.User
             *
             * @description
             *
             * find all the organizations of a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allOrganizations": {
              url: urlBase + "/users/:id/all-organizations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$countUserOrganizations
             * @methodOf lbServices.User
             *
             * @description
             *
             * count the total users of the organizations the specified user belongs to
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `onlyAdministered` – `{boolean}` - flag to filter just administered organizations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$countUserOrganizations": {
              url: urlBase + "/users/:id/count-user-organizations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$countUsersForMyOrganizations
             * @methodOf lbServices.User
             *
             * @description
             *
             * count the total organizations for which the specified user is admin
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$countUsersForMyOrganizations": {
              url: urlBase + "/users/:id/count-users-for-my-organizations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$chatContacts
             * @methodOf lbServices.User
             *
             * @description
             *
             * get the user's chat counter parts
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$chatContacts": {
              url: urlBase + "/users/:id/get-user-contacts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$allServices
             * @methodOf lbServices.User
             *
             * @description
             *
             * find all the offered services joined by a user, with payments details
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allServices": {
              url: urlBase + "/users/:id/all-offered-services",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updatePreference
             * @methodOf lbServices.User
             *
             * @description
             *
             * update the specified user preference
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `code` – `{string}` - code of the preference to update
             *
             *  - `value` – `{string}` - value of the preference to update
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$updatePreference": {
              params: {
                'code': '@code',
                'value': '@value',
              },
              url: urlBase + "/users/:id/update-preference/:code/:value",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$changePwd
             * @methodOf lbServices.User
             *
             * @description
             *
             * update the specified user pwd
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `newPwd` – `{string}` - new Pwd
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$changePwd": {
              params: {
                'newPwd': '@newPwd',
              },
              url: urlBase + "/users/:id/change-pwd/:newPwd",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$changePwdAfterReset
             * @methodOf lbServices.User
             *
             * @description
             *
             * update the specified user pwd
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `token` – `{string}` - reset token
             *
             *  - `newPwd` – `{string}` - new Pwd
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$changePwdAfterReset": {
              params: {
                'token': '@token',
                'newPwd': '@newPwd',
              },
              url: urlBase + "/users/:id/change-pwd-after-reset/:newPwd",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$allMySubscriptionsStats
             * @methodOf lbServices.User
             *
             * @description
             *
             * compute statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allMySubscriptionsStats": {
              url: urlBase + "/users/:id/all-subscriptions-stats",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#isParentManagementEnabled
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` - user to check
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{boolean=}` -
             */
            "isParentManagementEnabled": {
              url: urlBase + "/users/isParentManagementEnabled",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#countUnreadChatMessages
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{number=}` -
             */
            "countUnreadChatMessages": {
              url: urlBase + "/users/countUnreadChatMessages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#removeChildEmail
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `organizationId` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "removeChildEmail": {
              url: urlBase + "/users/removeChildEmail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#requestChangeEmailAddress
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `newEmail` – `{string}` -
             *
             *  - `organizationId` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `action` – `{string=}` -
             */
            "requestChangeEmailAddress": {
              url: urlBase + "/users/requestChangeEmailAddress",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changeEmailAddressFromToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `tokenId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "changeEmailAddressFromToken": {
              url: urlBase + "/users/changeEmailAddressFromToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createUserAndNotify
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `user` – `{object}` -
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `sendNotification` – `{boolean=}` -
             *
             *  - `notificationText` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{User=}` -
             */
            "createUserAndNotify": {
              url: urlBase + "/users/createUserAndNotify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#activateReset
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{User=}` -
             */
            "activateReset": {
              url: urlBase + "/users/activateReset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findByIdAndToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{User=}` -
             */
            "findByIdAndToken": {
              url: urlBase + "/users/findByIdAndToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePwdAfterReset
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `newPwd` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{User=}` -
             */
            "changePwdAfterReset": {
              url: urlBase + "/users/changePwdAfterReset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#activateNewUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `activationToken` – `{string}` - user activation token
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "activateNewUser": {
              url: urlBase + "/users/activateNewUser/:activationToken",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#publicSubscribeToService
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - id servzio offerto
             *
             *  - `subscriberData` – `{object}` - utente
             *
             *  - `subscribedServices` – `{*}` - oggetto contenent gli id dei servizi sottoscritti
             *
             *  - `dyndocId` – `{string=}` - id di eventuale documento con dati accessori
             *
             *  - `recaptchaResponse` – `{string}` - recaptchaResponse da validare
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "publicSubscribeToService": {
              url: urlBase + "/users/external-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#registerNewUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userData` – `{object}` - user registration data. Example: {"userData": {"givenName":"Nicola", "familyName":"Da Rold", "email":"nicola.darold@openview.it", "password":"password"}}
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "registerNewUser": {
              url: urlBase + "/users/register",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#sendResetPasswordUrl
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` - user email
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "sendResetPasswordUrl": {
              url: urlBase + "/users/sendresetpasswordurl",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#removeChildUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `childId` – `{string}` - child id to be removed
             *
             *  - `parentId` – `{string}` - parent of the child id to be removed
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` - object with the details about child user
             */
            "removeChildUser": {
              url: urlBase + "/users/removeUserRelation",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteChild
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` - userId to delete
             *
             *  - `parentId` – `{string}` - parentId of the user to delete
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{string=}` -
             */
            "deleteChild": {
              url: urlBase + "/users/deleteChild/:userId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#notifyUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` - user to notify
             *
             *  - `subject` – `{string}` -
             *
             *  - `text` – `{string}` - body of the notification
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "notifyUser": {
              url: urlBase + "/users/notifyUser",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#doLoginWithGoogle
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessToken` – `{string}` -
             *
             *  - `device` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "doLoginWithGoogle": {
              url: urlBase + "/users/doLoginWithGoogle",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#doLoginWithFacebook
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessToken` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "doLoginWithFacebook": {
              url: urlBase + "/users/doLoginWithFacebook",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#lookupUsers
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `text` – `{string}` - Testo da cercare nel nome o cognome o email
             *
             *  - `organizationId` – `{string=}` - cerco in una sola organizzazione tra quelle che amministro
             *
             *  - `isGlobalSearch` – `{boolean=}` - se true cerco in tutto CYL
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `users` – `{*=}` -
             */
            "lookupUsers": {
              url: urlBase + "/users/lookupUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#loadUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - user to load
             *
             *  - `organizationId` – `{string=}` -
             *
             *  - `filter` – `{object=}` - filter loopback-like
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * dettaglio utente
             */
            "loadUser": {
              url: urlBase + "/users/loadUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#saveUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `user` – `{object}` - user to save
             *
             *  - `organizationId` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * dettaglio utente salvato
             */
            "saveUser": {
              url: urlBase + "/users/saveUser",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#activateUserForOrganization
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` - user to activate
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `isActive` – `{boolean}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * dettaglio utente salvato
             */
            "activateUserForOrganization": {
              url: urlBase + "/users/activateUserForOrganization",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#loginInfo
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `username` – `{string}` - username
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * user login details
             */
            "loginInfo": {
              url: urlBase + "/users/loginInfo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#sendResetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `username` – `{string}` - username
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * action results
             */
            "sendResetPassword": {
              url: urlBase + "/users/sendResetPassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#activatePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `username` – `{string}` - username
             *
             *  - `resetPwdChars` – `{string}` - verification chars sento to user via notification
             *
             *  - `newPassword` – `{string}` - new password
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * action results
             */
            "activatePassword": {
              url: urlBase + "/users/activatePassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#searchUsersOrOrganizations
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{number}` - organizationId where the users will be searched
             *
             *  - `searchText` – `{string}` - name/email to search for
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * matching users or organizations
             */
            "searchUsersOrOrganizations": {
              isArray: true,
              url: urlBase + "/users/searchUsersOrOrganizations/:organizationId/:searchText",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            // INTERNAL. Use UserIdentity.user() instead.
            "::get::UserIdentity::user": {
              url: urlBase + "/UserIdentities/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Organization.users.findById() instead.
            "::findById::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.users.destroyById() instead.
            "::destroyById::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.updateById() instead.
            "::updateById::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.users.link() instead.
            "::link::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.users.unlink() instead.
            "::unlink::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.exists() instead.
            "::exists::Organization::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.users() instead.
            "::get::Organization::users": {
              isArray: true,
              url: urlBase + "/organizations/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Organization.users.create() instead.
            "::create::Organization::users": {
              url: urlBase + "/organizations/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Organization.users.createMany() instead.
            "::createMany::Organization::users": {
              isArray: true,
              url: urlBase + "/organizations/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Organization.users.destroyAll() instead.
            "::delete::Organization::users": {
              url: urlBase + "/organizations/:id/users",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.count() instead.
            "::count::Organization::users": {
              url: urlBase + "/organizations/:id/users/count",
              method: "GET",
            },

            // INTERNAL. Use UserOrganizationRole.user() instead.
            "::get::UserOrganizationRole::user": {
              url: urlBase + "/userOrganizationRoles/:id/user",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.staffMember() instead.
            "::get::OrganizationResource::staffMember": {
              url: urlBase + "/organizationResources/:id/staffMember",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.staffMember() instead.
            "::get::ResourceCalendar::staffMember": {
              url: urlBase + "/resourceCalendars/:id/staffMember",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers.findById() instead.
            "::findById::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers.destroyById() instead.
            "::destroyById::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.updateById() instead.
            "::updateById::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscribers.link() instead.
            "::link::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscribers.unlink() instead.
            "::unlink::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.exists() instead.
            "::exists::OfferedService::subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.subscribers() instead.
            "::get::OfferedService::subscribers": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers.create() instead.
            "::create::OfferedService::subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscribers.createMany() instead.
            "::createMany::OfferedService::subscribers": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscribers.destroyAll() instead.
            "::delete::OfferedService::subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.count() instead.
            "::count::OfferedService::subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers/count",
              method: "GET",
            },

            // INTERNAL. Use Subscription.user() instead.
            "::get::Subscription::user": {
              url: urlBase + "/subscriptions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Invitation.user() instead.
            "::get::Invitation::user": {
              url: urlBase + "/invitations/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Invitation.senderUser() instead.
            "::get::Invitation::senderUser": {
              url: urlBase + "/invitations/:id/senderUser",
              method: "GET",
            },

            // INTERNAL. Use UserRelation.child() instead.
            "::get::UserRelation::child": {
              url: urlBase + "/userRelations/:id/child",
              method: "GET",
            },

            // INTERNAL. Use UserRelation.parent() instead.
            "::get::UserRelation::parent": {
              url: urlBase + "/userRelations/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use UserContact.user() instead.
            "::get::UserContact::user": {
              url: urlBase + "/userContacts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserPreference.user() instead.
            "::get::UserPreference::user": {
              url: urlBase + "/userPreferences/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Payment.user() instead.
            "::get::Payment::user": {
              url: urlBase + "/payments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.user() instead.
            "::get::EarningCost::user": {
              url: urlBase + "/earningCosts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.user() instead.
            "::get::UserDocument::user": {
              url: urlBase + "/userDocuments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Notification.sender() instead.
            "::get::Notification::sender": {
              url: urlBase + "/notifications/:id/sender",
              method: "GET",
            },

            // INTERNAL. Use Notification.recipient() instead.
            "::get::Notification::recipient": {
              url: urlBase + "/notifications/:id/recipient",
              method: "GET",
            },

            // INTERNAL. Use UserChatStatus.user() instead.
            "::get::UserChatStatus::user": {
              url: urlBase + "/userChatStatuses/:id/user",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.findById() instead.
            "::findById::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.destroyById() instead.
            "::destroyById::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.updateById() instead.
            "::updateById::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceType.offeredServices.link() instead.
            "::link::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceType.offeredServices.unlink() instead.
            "::unlink::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.exists() instead.
            "::exists::ServiceType::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ServiceType.offeredServices() instead.
            "::get::ServiceType::offeredServices": {
              isArray: true,
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.create() instead.
            "::create::ServiceType::offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use ServiceType.offeredServices.createMany() instead.
            "::createMany::ServiceType::offeredServices": {
              isArray: true,
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use ServiceType.offeredServices.destroyAll() instead.
            "::delete::ServiceType::offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.count() instead.
            "::count::ServiceType::offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices/count",
              method: "GET",
            },

            // INTERNAL. Use Attendance.user() instead.
            "::get::Attendance::user": {
              url: urlBase + "/attendances/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Oplog.user() instead.
            "::get::Oplog::user": {
              url: urlBase + "/oplog/:id/user",
              method: "GET",
            },

            // INTERNAL. Use OrganizationPreference.user() instead.
            "::get::OrganizationPreference::user": {
              url: urlBase + "/organizationPreferences/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.identities
     * @header lbServices.User.identities
     * @object
     * @description
     *
     * The object `User.identities` groups methods
     * manipulating `UserIdentity` instances related to `User`.
     *
     * Call {@link lbServices.User#identities User.identities()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#identities
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries identities of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::get::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#count
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Counts identities of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.identities.count = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::count::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#create
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Creates a new instance in identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.create = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::create::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#createMany
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Creates a new instance in identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.createMany = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::createMany::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#destroyAll
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Deletes all identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.identities.destroyAll = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::delete::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#destroyById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Delete a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.identities.destroyById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::destroyById::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#findById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Find a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.findById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::findById::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#updateById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Update a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.updateById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::updateById::User::identities"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.userOrganizationRoles
     * @header lbServices.User.userOrganizationRoles
     * @object
     * @description
     *
     * The object `User.userOrganizationRoles` groups methods
     * manipulating `UserOrganizationRole` instances related to `User`.
     *
     * Call {@link lbServices.User#userOrganizationRoles User.userOrganizationRoles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#userOrganizationRoles
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries userOrganizationRoles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRoles = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::get::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#count
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Counts userOrganizationRoles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.userOrganizationRoles.count = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::count::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#create
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Creates a new instance in userOrganizationRoles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRoles.create = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::create::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#createMany
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Creates a new instance in userOrganizationRoles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRoles.createMany = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::createMany::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#destroyAll
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Deletes all userOrganizationRoles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.userOrganizationRoles.destroyAll = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::delete::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#destroyById
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Delete a related item by id for userOrganizationRoles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRoles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.userOrganizationRoles.destroyById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::destroyById::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#findById
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Find a related item by id for userOrganizationRoles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRoles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRoles.findById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::findById::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.userOrganizationRoles#updateById
             * @methodOf lbServices.User.userOrganizationRoles
             *
             * @description
             *
             * Update a related item by id for userOrganizationRoles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRoles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRoles.updateById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::updateById::User::userOrganizationRoles"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.organizations
     * @header lbServices.User.organizations
     * @object
     * @description
     *
     * The object `User.organizations` groups methods
     * manipulating `Organization` instances related to `User`.
     *
     * Call {@link lbServices.User#organizations User.organizations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#organizations
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries organizations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#count
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Counts organizations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.organizations.count = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::count::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#create
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Creates a new instance in organizations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.create = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::create::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#createMany
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Creates a new instance in organizations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.createMany = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::createMany::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#destroyAll
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Deletes all organizations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.organizations.destroyAll = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::delete::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#destroyById
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Delete a related item by id for organizations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.organizations.destroyById = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::destroyById::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#exists
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Check the existence of organizations relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.exists = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::exists::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#findById
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Find a related item by id for organizations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.findById = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::findById::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#link
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Add a related item by id for organizations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.link = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::link::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#unlink
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Remove the organizations relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.organizations.unlink = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::unlink::User::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.organizations#updateById
             * @methodOf lbServices.User.organizations
             *
             * @description
             *
             * Update a related item by id for organizations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organizations.updateById = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::updateById::User::organizations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.subscriptions
     * @header lbServices.User.subscriptions
     * @object
     * @description
     *
     * The object `User.subscriptions` groups methods
     * manipulating `Subscription` instances related to `User`.
     *
     * Call {@link lbServices.User#subscriptions User.subscriptions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#subscriptions
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries subscriptions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscriptions = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#count
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Counts subscriptions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subscriptions.count = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::count::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#create
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Creates a new instance in subscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscriptions.create = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::create::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#createMany
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Creates a new instance in subscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscriptions.createMany = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::createMany::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#destroyAll
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Deletes all subscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptions.destroyAll = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::delete::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#destroyById
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Delete a related item by id for subscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptions.destroyById = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::destroyById::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#findById
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Find a related item by id for subscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscriptions.findById = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::findById::User::subscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.subscriptions#updateById
             * @methodOf lbServices.User.subscriptions
             *
             * @description
             *
             * Update a related item by id for subscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for subscriptions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscriptions.updateById = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::updateById::User::subscriptions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.serviceSubscriptions
     * @header lbServices.User.serviceSubscriptions
     * @object
     * @description
     *
     * The object `User.serviceSubscriptions` groups methods
     * manipulating `OfferedService` instances related to `User`.
     *
     * Call {@link lbServices.User#serviceSubscriptions User.serviceSubscriptions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#serviceSubscriptions
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries serviceSubscriptions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#count
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Counts serviceSubscriptions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceSubscriptions.count = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::count::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#create
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Creates a new instance in serviceSubscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.create = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::create::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#createMany
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Creates a new instance in serviceSubscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.createMany = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::createMany::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#destroyAll
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Deletes all serviceSubscriptions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceSubscriptions.destroyAll = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::delete::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#destroyById
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Delete a related item by id for serviceSubscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceSubscriptions.destroyById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::destroyById::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#exists
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Check the existence of serviceSubscriptions relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.exists = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::exists::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#findById
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Find a related item by id for serviceSubscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.findById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::findById::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#link
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Add a related item by id for serviceSubscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.link = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::link::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#unlink
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Remove the serviceSubscriptions relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceSubscriptions.unlink = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::unlink::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.serviceSubscriptions#updateById
             * @methodOf lbServices.User.serviceSubscriptions
             *
             * @description
             *
             * Update a related item by id for serviceSubscriptions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for serviceSubscriptions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.serviceSubscriptions.updateById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::updateById::User::serviceSubscriptions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.childRelations
     * @header lbServices.User.childRelations
     * @object
     * @description
     *
     * The object `User.childRelations` groups methods
     * manipulating `UserRelation` instances related to `User`.
     *
     * Call {@link lbServices.User#childRelations User.childRelations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#childRelations
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries childRelations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.childRelations = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::get::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#count
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Counts childRelations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.childRelations.count = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::count::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#create
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Creates a new instance in childRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.childRelations.create = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::create::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#createMany
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Creates a new instance in childRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.childRelations.createMany = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::createMany::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#destroyAll
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Deletes all childRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.childRelations.destroyAll = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::delete::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#destroyById
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Delete a related item by id for childRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for childRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.childRelations.destroyById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::destroyById::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#findById
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Find a related item by id for childRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for childRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.childRelations.findById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::findById::User::childRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.childRelations#updateById
             * @methodOf lbServices.User.childRelations
             *
             * @description
             *
             * Update a related item by id for childRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for childRelations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.childRelations.updateById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::updateById::User::childRelations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.parentRelations
     * @header lbServices.User.parentRelations
     * @object
     * @description
     *
     * The object `User.parentRelations` groups methods
     * manipulating `UserRelation` instances related to `User`.
     *
     * Call {@link lbServices.User#parentRelations User.parentRelations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#parentRelations
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries parentRelations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.parentRelations = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::get::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#count
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Counts parentRelations of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.parentRelations.count = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::count::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#create
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Creates a new instance in parentRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.parentRelations.create = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::create::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#createMany
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Creates a new instance in parentRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.parentRelations.createMany = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::createMany::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#destroyAll
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Deletes all parentRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.parentRelations.destroyAll = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::delete::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#destroyById
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Delete a related item by id for parentRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parentRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.parentRelations.destroyById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::destroyById::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#findById
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Find a related item by id for parentRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parentRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.parentRelations.findById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::findById::User::parentRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.parentRelations#updateById
             * @methodOf lbServices.User.parentRelations
             *
             * @description
             *
             * Update a related item by id for parentRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for parentRelations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R.parentRelations.updateById = function() {
          var TargetResource = $injector.get("UserRelation");
          var action = TargetResource["::updateById::User::parentRelations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.contacts
     * @header lbServices.User.contacts
     * @object
     * @description
     *
     * The object `User.contacts` groups methods
     * manipulating `UserContact` instances related to `User`.
     *
     * Call {@link lbServices.User#contacts User.contacts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#contacts
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries contacts of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R.contacts = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::get::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#count
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Counts contacts of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.contacts.count = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::count::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#create
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Creates a new instance in contacts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R.contacts.create = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::create::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#createMany
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Creates a new instance in contacts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R.contacts.createMany = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::createMany::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#destroyAll
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Deletes all contacts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.contacts.destroyAll = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::delete::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#destroyById
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Delete a related item by id for contacts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for contacts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.contacts.destroyById = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::destroyById::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#findById
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Find a related item by id for contacts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for contacts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R.contacts.findById = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::findById::User::contacts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.contacts#updateById
             * @methodOf lbServices.User.contacts
             *
             * @description
             *
             * Update a related item by id for contacts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for contacts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R.contacts.updateById = function() {
          var TargetResource = $injector.get("UserContact");
          var action = TargetResource["::updateById::User::contacts"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.documents
     * @header lbServices.User.documents
     * @object
     * @description
     *
     * The object `User.documents` groups methods
     * manipulating `UserDocument` instances related to `User`.
     *
     * Call {@link lbServices.User#documents User.documents()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#documents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries documents of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.documents = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::get::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#count
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Counts documents of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.documents.count = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::count::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#create
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.documents.create = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::create::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#createMany
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.documents.createMany = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::createMany::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#destroyAll
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Deletes all documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.documents.destroyAll = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::delete::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#destroyById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Delete a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.documents.destroyById = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::destroyById::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#findById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Find a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.documents.findById = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::findById::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#updateById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Update a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.documents.updateById = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::updateById::User::documents"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserIdentity
 * @header lbServices.UserIdentity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserIdentity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserIdentity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/UserIdentities/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserIdentity.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/UserIdentities/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#create
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/UserIdentities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#patchOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/UserIdentities",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#replaceOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/UserIdentities/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#upsertWithWhere
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/UserIdentities/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#exists
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/UserIdentities/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#findById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/UserIdentities/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#replaceById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/UserIdentities/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#find
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/UserIdentities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#findOne
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/UserIdentities/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#updateAll
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/UserIdentities/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#deleteById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/UserIdentities/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#count
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/UserIdentities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#prototype$patchAttributes
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/UserIdentities/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#createChangeStream
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/UserIdentities/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#createMany
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/UserIdentities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.findById() instead.
            "::findById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.identities.destroyById() instead.
            "::destroyById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.updateById() instead.
            "::updateById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.identities() instead.
            "::get::User::identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "GET",
            },

            // INTERNAL. Use User.identities.create() instead.
            "::create::User::identities": {
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.createMany() instead.
            "::createMany::User::identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.destroyAll() instead.
            "::delete::User::identities": {
              url: urlBase + "/users/:id/identities",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.count() instead.
            "::count::User::identities": {
              url: urlBase + "/users/:id/identities/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#upsert
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#updateOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#patchOrCreateWithWhere
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#update
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#destroyById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#removeById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#prototype$updateAttributes
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserIdentity#modelName
        * @propertyOf lbServices.UserIdentity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserIdentity`.
        */
        R.modelName = "UserIdentity";


            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#user
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserIdentity::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Organization
 * @header lbServices.Organization
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Organization` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Organization",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Organization.users.findById() instead.
            "prototype$__findById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.users.destroyById() instead.
            "prototype$__destroyById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.updateById() instead.
            "prototype$__updateById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.users.link() instead.
            "prototype$__link__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.users.unlink() instead.
            "prototype$__unlink__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.exists() instead.
            "prototype$__exists__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.organizationResources.findById() instead.
            "prototype$__findById__organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.organizationResources.destroyById() instead.
            "prototype$__destroyById__organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.organizationResources.updateById() instead.
            "prototype$__updateById__organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.roleTypes.findById() instead.
            "prototype$__findById__roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.roleTypes.destroyById() instead.
            "prototype$__destroyById__roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.roleTypes.updateById() instead.
            "prototype$__updateById__roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.offeredServices.findById() instead.
            "prototype$__findById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices.destroyById() instead.
            "prototype$__destroyById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.offeredServices.updateById() instead.
            "prototype$__updateById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__findById__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__findById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__destroyById__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__updateById__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__updateById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__link__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Add a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__link__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__unlink__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Remove the children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__exists__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Check the existence of children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__exists__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/children/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__findById__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__findById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__destroyById__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__updateById__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__updateById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__link__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Add a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__link__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__unlink__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Remove the parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__exists__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Check the existence of parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__exists__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/parents/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.categories.findById() instead.
            "prototype$__findById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.categories.destroyById() instead.
            "prototype$__destroyById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.updateById() instead.
            "prototype$__updateById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.categories.link() instead.
            "prototype$__link__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.categories.unlink() instead.
            "prototype$__unlink__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.exists() instead.
            "prototype$__exists__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.earningCosts.findById() instead.
            "prototype$__findById__earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.earningCosts.destroyById() instead.
            "prototype$__destroyById__earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.earningCosts.updateById() instead.
            "prototype$__updateById__earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.users() instead.
            "prototype$__get__users": {
              isArray: true,
              url: urlBase + "/organizations/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Organization.users.create() instead.
            "prototype$__create__users": {
              url: urlBase + "/organizations/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Organization.users.destroyAll() instead.
            "prototype$__delete__users": {
              url: urlBase + "/organizations/:id/users",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.users.count() instead.
            "prototype$__count__users": {
              url: urlBase + "/organizations/:id/users/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.organizationResources() instead.
            "prototype$__get__organizationResources": {
              isArray: true,
              url: urlBase + "/organizations/:id/organizationResources",
              method: "GET",
            },

            // INTERNAL. Use Organization.organizationResources.create() instead.
            "prototype$__create__organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources",
              method: "POST",
            },

            // INTERNAL. Use Organization.organizationResources.destroyAll() instead.
            "prototype$__delete__organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.organizationResources.count() instead.
            "prototype$__count__organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.roleTypes() instead.
            "prototype$__get__roleTypes": {
              isArray: true,
              url: urlBase + "/organizations/:id/roleTypes",
              method: "GET",
            },

            // INTERNAL. Use Organization.roleTypes.create() instead.
            "prototype$__create__roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes",
              method: "POST",
            },

            // INTERNAL. Use Organization.roleTypes.destroyAll() instead.
            "prototype$__delete__roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.roleTypes.count() instead.
            "prototype$__count__roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices() instead.
            "prototype$__get__offeredServices": {
              isArray: true,
              url: urlBase + "/organizations/:id/offeredServices",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices.create() instead.
            "prototype$__create__offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use Organization.offeredServices.destroyAll() instead.
            "prototype$__delete__offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.offeredServices.count() instead.
            "prototype$__count__offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__get__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries children of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__get__children": {
              isArray: true,
              url: urlBase + "/organizations/:id/children",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__create__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Creates a new instance in children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__create__children": {
              url: urlBase + "/organizations/:id/children",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__delete__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Deletes all children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__children": {
              url: urlBase + "/organizations/:id/children",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__count__children
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Counts children of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__children": {
              url: urlBase + "/organizations/:id/children/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__get__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries parents of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__get__parents": {
              isArray: true,
              url: urlBase + "/organizations/:id/parents",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__create__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Creates a new instance in parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$__create__parents": {
              url: urlBase + "/organizations/:id/parents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__delete__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Deletes all parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__parents": {
              url: urlBase + "/organizations/:id/parents",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$__count__parents
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Counts parents of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__parents": {
              url: urlBase + "/organizations/:id/parents/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.categories() instead.
            "prototype$__get__categories": {
              isArray: true,
              url: urlBase + "/organizations/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Organization.categories.create() instead.
            "prototype$__create__categories": {
              url: urlBase + "/organizations/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Organization.categories.destroyAll() instead.
            "prototype$__delete__categories": {
              url: urlBase + "/organizations/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.count() instead.
            "prototype$__count__categories": {
              url: urlBase + "/organizations/:id/categories/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.earningCosts() instead.
            "prototype$__get__earningCosts": {
              isArray: true,
              url: urlBase + "/organizations/:id/earningCosts",
              method: "GET",
            },

            // INTERNAL. Use Organization.earningCosts.create() instead.
            "prototype$__create__earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts",
              method: "POST",
            },

            // INTERNAL. Use Organization.earningCosts.destroyAll() instead.
            "prototype$__delete__earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.earningCosts.count() instead.
            "prototype$__count__earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#create
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#patchOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#replaceOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#upsertWithWhere
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#exists
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#findById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#replaceById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#find
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#findOne
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#updateAll
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#deleteById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#count
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$patchAttributes
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#createChangeStream
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$addAdmin
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Add an admin user to current organization
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `userId` – `{number}` - id of to-be admin user
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$addAdmin": {
              params: {
                'userId': '@userId',
              },
              url: urlBase + "/organizations/:id/add-admin/:userId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$allUsers
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * find all the users of an organization, completing with role names
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allUsers": {
              url: urlBase + "/organizations/:id/all-users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$deleteRolesByUser
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * deletes all user organization roles by a spec user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `userId` – `{number}` - id of to-be admin user
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$deleteRolesByUser": {
              params: {
                'userId': '@userId',
              },
              url: urlBase + "/organizations/:id/delete-roles-by-user/:userId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$findOrAddUserOrganization
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * find the user or the organization or give back the existing one
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `search_type` – `{string}` - U or O depending if we are adding an organization or a user 
             *
             *  - `search_givenName` – `{string=}` - given name of the to-be added user 
             *
             *  - `search_familyName` – `{string=}` - family name of the to-be added user 
             *
             *  - `search_name` – `{string=}` - organization name
             *
             *  - `search_piva` – `{string=}` - organization p.iva 
             *
             *  - `search_email` – `{string}` - email address of the to-be user/org 
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$findOrAddUserOrganization": {
              url: urlBase + "/organizations/:id/find-create-user-organization",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$isAdmin
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * returns an obj with isAdmin = true if current user is admin for this organization
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `userId` – `{number}` - id of to-be admin user
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$isAdmin": {
              params: {
                'userId': '@userId',
              },
              url: urlBase + "/organizations/:id/is-admin/:userId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$allStats
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * compute statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `dateFrom` – `{string=}` -
             *
             *  - `dateTo` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allStats": {
              url: urlBase + "/organizations/:id/all-stats",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$allSubscribers
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * find all the subscribers of the service completing with payments
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `serviceId` – `{number=}` -
             *
             *  - `payments` – `{string=}` -
             *
             *  - `documents` – `{string=}` -
             *
             *  - `txt` – `{string=}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `dateFrom` – `{string=}` -
             *
             *  - `dateTo` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allSubscribers": {
              url: urlBase + "/organizations/:id/all-subscribers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#exportExcelAllUsers
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `tk` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `data` – `{*=}` -
             */
            "exportExcelAllUsers": {
              url: urlBase + "/organizations/xlsx-organization-users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#exportExcelEarningCosts
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `tk` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `data` – `{*=}` -
             */
            "exportExcelEarningCosts": {
              url: urlBase + "/organizations/xlsx-organization-earnincosts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#isOrganizationAdmin
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{number}` - id organizzazione
             *
             *  - `userId` – `{number}` - id utente
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "isOrganizationAdmin": {
              url: urlBase + "/organizations/:organizationId/is-organization-admin/:userId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#paymentsStats
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "paymentsStats": {
              url: urlBase + "/organizations/paymentsStats/:organizationId/:dateFrom/:dateTo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#userPaymentsStats
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             *  - `userId` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "userPaymentsStats": {
              url: urlBase + "/organizations/userPaymentsStats/:organizationId/:dateFrom/:dateTo/:userId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#clientUserPaymentsStats
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             *  - `userId` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "clientUserPaymentsStats": {
              url: urlBase + "/organizations/clientUserPaymentsStats/:dateFrom/:dateTo/:userId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#documentStats
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             *  - `userId` – `{number=}` - eventuale ID utente
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "documentStats": {
              url: urlBase + "/organizations/documentStats",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#getStatsEntrateUscite
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "getStatsEntrateUscite": {
              url: urlBase + "/organizations/getStatsEntrateUscite/:organizationId/:dateFrom/:dateTo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#generateStripeRequestToken
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{object=}` -
             */
            "generateStripeRequestToken": {
              url: urlBase + "/organizations/generateStripeRequestToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#eraseStripeRequestToken
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "eraseStripeRequestToken": {
              url: urlBase + "/organizations/eraseStripeRequestToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#enableInvoices
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `startFrom` – `{number=}` -
             *
             *  - `section` – `{string=}` -
             *
             *  - `type` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "enableInvoices": {
              url: urlBase + "/organizations/enableInvoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#deactivateStripe
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "deactivateStripe": {
              url: urlBase + "/organizations/deactivateStripe",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#attendanceSubscribersList
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `offeredServiceId` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "attendanceSubscribersList": {
              isArray: true,
              url: urlBase + "/organizations/attendanceSubscribersList/:offeredServiceId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#subscribersList
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD, di default 20000101, incluso
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD di default oggi, incluso
             *
             *  - `userId` – `{string=}` -
             *
             *  - `offeredServiceId` – `{string=}` -
             *
             *  - `searchText` – `{string=}` - testo da cercare in nome, cognome, email utente
             *
             *  - `paymentStatus` – `{string=}` - Filtra i pagamenti: [A|M|D] (tutti,mancanti,effettuati)
             *
             *  - `documentStatus` – `{string=}` - Filtra i documenti: [MISSING|EXPIRED|EXIRING|REJECTED|VALIDATED|TO_BE_VALIDATED|DONOTADD] (vuoto per non filtrare, usa DONOTADD per non estrarre lo stato dei documenti e velocizzare la query)
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "subscribersList": {
              isArray: true,
              url: urlBase + "/organizations/subscribersList/:organizationId/:dateFrom/:dateTo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#seasonChange
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `settings` – `{object}` - Settings object
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "seasonChange": {
              url: urlBase + "/organizations/seasonChange",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#createMany
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizations",
              method: "POST",
            },

            // INTERNAL. Use User.organizations.findById() instead.
            "::findById::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.organizations.destroyById() instead.
            "::destroyById::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.updateById() instead.
            "::updateById::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.organizations.link() instead.
            "::link::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.organizations.unlink() instead.
            "::unlink::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.exists() instead.
            "::exists::User::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/organizations/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.organizations() instead.
            "::get::User::organizations": {
              isArray: true,
              url: urlBase + "/users/:id/organizations",
              method: "GET",
            },

            // INTERNAL. Use User.organizations.create() instead.
            "::create::User::organizations": {
              url: urlBase + "/users/:id/organizations",
              method: "POST",
            },

            // INTERNAL. Use User.organizations.createMany() instead.
            "::createMany::User::organizations": {
              isArray: true,
              url: urlBase + "/users/:id/organizations",
              method: "POST",
            },

            // INTERNAL. Use User.organizations.destroyAll() instead.
            "::delete::User::organizations": {
              url: urlBase + "/users/:id/organizations",
              method: "DELETE",
            },

            // INTERNAL. Use User.organizations.count() instead.
            "::count::User::organizations": {
              url: urlBase + "/users/:id/organizations/count",
              method: "GET",
            },

            // INTERNAL. Use UserOrganizationRole.organization() instead.
            "::get::UserOrganizationRole::organization": {
              url: urlBase + "/userOrganizationRoles/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.organization() instead.
            "::get::OrganizationResource::organization": {
              url: urlBase + "/organizationResources/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.organization() instead.
            "::get::ResourceCalendar::organization": {
              url: urlBase + "/resourceCalendars/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use RoleType.organization() instead.
            "::get::RoleType::organization": {
              url: urlBase + "/roleTypes/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.organization() instead.
            "::get::OfferedService::organization": {
              url: urlBase + "/offeredServices/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Invitation.senderOrganization() instead.
            "::get::Invitation::senderOrganization": {
              url: urlBase + "/invitations/:id/senderOrganization",
              method: "GET",
            },

            // INTERNAL. Use UserContact.organization() instead.
            "::get::UserContact::organization": {
              url: urlBase + "/userContacts/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OrganizationCategory.user() instead.
            "::get::OrganizationCategory::user": {
              url: urlBase + "/organizationCategories/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Payment.organization() instead.
            "::get::Payment::organization": {
              url: urlBase + "/payments/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.organization() instead.
            "::get::EarningCost::organization": {
              url: urlBase + "/earningCosts/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.entryOrganization() instead.
            "::get::EarningCost::entryOrganization": {
              url: urlBase + "/earningCosts/:id/entryOrganization",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderOrganization() instead.
            "::get::Notification::senderOrganization": {
              url: urlBase + "/notifications/:id/senderOrganization",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.organization() instead.
            "::get::ServiceType::organization": {
              url: urlBase + "/serviceTypes/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Discount.organization() instead.
            "::get::Discount::organization": {
              url: urlBase + "/discounts/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Attendance.organization() instead.
            "::get::Attendance::organization": {
              url: urlBase + "/attendances/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use AttendanceNote.organization() instead.
            "::get::AttendanceNote::organization": {
              url: urlBase + "/attendanceNotes/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use PaymentReport.organization() instead.
            "::get::PaymentReport::organization": {
              url: urlBase + "/paymentReports/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Oplog.organization() instead.
            "::get::Oplog::organization": {
              url: urlBase + "/oplog/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OfferedServicePicture.organization() instead.
            "::get::OfferedServicePicture::organization": {
              url: urlBase + "/offeredServicePictures/:id/organization",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Organization#upsert
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#updateOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#patchOrCreateWithWhere
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#update
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#destroyById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#removeById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$updateAttributes
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Organization#modelName
        * @propertyOf lbServices.Organization
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Organization`.
        */
        R.modelName = "Organization";

    /**
     * @ngdoc object
     * @name lbServices.Organization.users
     * @header lbServices.Organization.users
     * @object
     * @description
     *
     * The object `Organization.users` groups methods
     * manipulating `User` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#users Organization.users()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#users
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries users of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#count
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Counts users of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.users.count = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::count::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#create
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Creates a new instance in users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.create = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::create::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#createMany
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Creates a new instance in users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.createMany = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::createMany::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#destroyAll
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Deletes all users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.destroyAll = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::delete::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#destroyById
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Delete a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.destroyById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::destroyById::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#exists
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Check the existence of users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.exists = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::exists::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#findById
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Find a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#link
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Add a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#unlink
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Remove the users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::Organization::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.users#updateById
             * @methodOf lbServices.Organization.users
             *
             * @description
             *
             * Update a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.updateById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::updateById::Organization::users"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.organizationResources
     * @header lbServices.Organization.organizationResources
     * @object
     * @description
     *
     * The object `Organization.organizationResources` groups methods
     * manipulating `OrganizationResource` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#organizationResources Organization.organizationResources()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#organizationResources
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries organizationResources of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResources = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::get::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#count
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Counts organizationResources of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.organizationResources.count = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::count::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#create
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Creates a new instance in organizationResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResources.create = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::create::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#createMany
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Creates a new instance in organizationResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResources.createMany = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::createMany::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#destroyAll
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Deletes all organizationResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.organizationResources.destroyAll = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::delete::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#destroyById
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Delete a related item by id for organizationResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizationResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.organizationResources.destroyById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::destroyById::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#findById
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Find a related item by id for organizationResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for organizationResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResources.findById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::findById::Organization::organizationResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.organizationResources#updateById
             * @methodOf lbServices.Organization.organizationResources
             *
             * @description
             *
             * Update a related item by id for organizationResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for organizationResources
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResources.updateById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::updateById::Organization::organizationResources"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.roleTypes
     * @header lbServices.Organization.roleTypes
     * @object
     * @description
     *
     * The object `Organization.roleTypes` groups methods
     * manipulating `RoleType` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#roleTypes Organization.roleTypes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#roleTypes
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries roleTypes of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleTypes = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::get::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#count
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Counts roleTypes of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roleTypes.count = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::count::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#create
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Creates a new instance in roleTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleTypes.create = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::create::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#createMany
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Creates a new instance in roleTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleTypes.createMany = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::createMany::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#destroyAll
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Deletes all roleTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roleTypes.destroyAll = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::delete::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#destroyById
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Delete a related item by id for roleTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roleTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roleTypes.destroyById = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::destroyById::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#findById
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Find a related item by id for roleTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roleTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleTypes.findById = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::findById::Organization::roleTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.roleTypes#updateById
             * @methodOf lbServices.Organization.roleTypes
             *
             * @description
             *
             * Update a related item by id for roleTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for roleTypes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleTypes.updateById = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::updateById::Organization::roleTypes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.offeredServices
     * @header lbServices.Organization.offeredServices
     * @object
     * @description
     *
     * The object `Organization.offeredServices` groups methods
     * manipulating `OfferedService` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#offeredServices Organization.offeredServices()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#offeredServices
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries offeredServices of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#count
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Counts offeredServices of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offeredServices.count = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::count::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#create
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Creates a new instance in offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices.create = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::create::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#createMany
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Creates a new instance in offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices.createMany = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::createMany::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#destroyAll
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Deletes all offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServices.destroyAll = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::delete::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#destroyById
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Delete a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServices.destroyById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::destroyById::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#findById
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Find a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices.findById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::findById::Organization::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.offeredServices#updateById
             * @methodOf lbServices.Organization.offeredServices
             *
             * @description
             *
             * Update a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices.updateById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::updateById::Organization::offeredServices"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.categories
     * @header lbServices.Organization.categories
     * @object
     * @description
     *
     * The object `Organization.categories` groups methods
     * manipulating `Category` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#categories Organization.categories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#categories
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries categories of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#count
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Counts categories of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.categories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#create
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Creates a new instance in categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#createMany
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Creates a new instance in categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#destroyAll
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Deletes all categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#destroyById
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Delete a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#exists
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Check the existence of categories relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.exists = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::exists::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#findById
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Find a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#link
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Add a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.link = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::link::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#unlink
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Remove the categories relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.unlink = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::unlink::Organization::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.categories#updateById
             * @methodOf lbServices.Organization.categories
             *
             * @description
             *
             * Update a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Organization::categories"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.earningCosts
     * @header lbServices.Organization.earningCosts
     * @object
     * @description
     *
     * The object `Organization.earningCosts` groups methods
     * manipulating `EarningCost` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#earningCosts Organization.earningCosts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#earningCosts
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries earningCosts of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCosts = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::get::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#count
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Counts earningCosts of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.earningCosts.count = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::count::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#create
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Creates a new instance in earningCosts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCosts.create = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::create::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#createMany
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Creates a new instance in earningCosts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCosts.createMany = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::createMany::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#destroyAll
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Deletes all earningCosts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.earningCosts.destroyAll = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::delete::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#destroyById
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Delete a related item by id for earningCosts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for earningCosts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.earningCosts.destroyById = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::destroyById::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#findById
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Find a related item by id for earningCosts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for earningCosts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCosts.findById = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::findById::Organization::earningCosts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.earningCosts#updateById
             * @methodOf lbServices.Organization.earningCosts
             *
             * @description
             *
             * Update a related item by id for earningCosts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organization id
             *
             *  - `fk` – `{*}` - Foreign key for earningCosts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCosts.updateById = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::updateById::Organization::earningCosts"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserOrganizationRole
 * @header lbServices.UserOrganizationRole
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserOrganizationRole` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserOrganizationRole",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userOrganizationRoles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserOrganizationRole.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/userOrganizationRoles/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use UserOrganizationRole.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userOrganizationRoles/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserOrganizationRole.roleType() instead.
            "prototype$__get__roleType": {
              url: urlBase + "/userOrganizationRoles/:id/roleType",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#create
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userOrganizationRoles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#patchOrCreate
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userOrganizationRoles",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#replaceOrCreate
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userOrganizationRoles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#upsertWithWhere
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userOrganizationRoles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#exists
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userOrganizationRoles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#findById
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userOrganizationRoles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#replaceById
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userOrganizationRoles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#find
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userOrganizationRoles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#findOne
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userOrganizationRoles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#updateAll
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userOrganizationRoles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#deleteById
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userOrganizationRoles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#count
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userOrganizationRoles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#prototype$patchAttributes
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserOrganizationRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userOrganizationRoles/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#createChangeStream
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userOrganizationRoles/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#addAsContact
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `sendNotification` – `{boolean=}` -
             *
             *  - `notificationText` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{string=}` -
             */
            "addAsContact": {
              url: urlBase + "/userOrganizationRoles/addAsContact",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#addAs
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `roleTypeInternalCode` – `{string}` -
             *
             *  - `sendNotification` – `{boolean=}` -
             *
             *  - `notificationText` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{string=}` -
             */
            "addAs": {
              url: urlBase + "/userOrganizationRoles/addAs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#addAsRoles
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{string}` -
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `roleTypeInternalCodes` – `{string}` -
             *
             *  - `sendNotification` – `{boolean=}` -
             *
             *  - `notificationText` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{string=}` -
             */
            "addAsRoles": {
              url: urlBase + "/userOrganizationRoles/addAsRoles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#createMany
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userOrganizationRoles",
              method: "POST",
            },

            // INTERNAL. Use User.userOrganizationRoles.findById() instead.
            "::findById::User::userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.userOrganizationRoles.destroyById() instead.
            "::destroyById::User::userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.userOrganizationRoles.updateById() instead.
            "::updateById::User::userOrganizationRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/userOrganizationRoles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.userOrganizationRoles() instead.
            "::get::User::userOrganizationRoles": {
              isArray: true,
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "GET",
            },

            // INTERNAL. Use User.userOrganizationRoles.create() instead.
            "::create::User::userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "POST",
            },

            // INTERNAL. Use User.userOrganizationRoles.createMany() instead.
            "::createMany::User::userOrganizationRoles": {
              isArray: true,
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "POST",
            },

            // INTERNAL. Use User.userOrganizationRoles.destroyAll() instead.
            "::delete::User::userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles",
              method: "DELETE",
            },

            // INTERNAL. Use User.userOrganizationRoles.count() instead.
            "::count::User::userOrganizationRoles": {
              url: urlBase + "/users/:id/userOrganizationRoles/count",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.findById() instead.
            "::findById::RoleType::userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.destroyById() instead.
            "::destroyById::RoleType::userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.updateById() instead.
            "::updateById::RoleType::userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RoleType.userOrganizationRole() instead.
            "::get::RoleType::userOrganizationRole": {
              isArray: true,
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.create() instead.
            "::create::RoleType::userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "POST",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.createMany() instead.
            "::createMany::RoleType::userOrganizationRole": {
              isArray: true,
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "POST",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.destroyAll() instead.
            "::delete::RoleType::userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "DELETE",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.count() instead.
            "::count::RoleType::userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#upsert
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#updateOrCreate
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#patchOrCreateWithWhere
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#update
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#destroyById
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#removeById
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#prototype$updateAttributes
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserOrganizationRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserOrganizationRole#modelName
        * @propertyOf lbServices.UserOrganizationRole
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserOrganizationRole`.
        */
        R.modelName = "UserOrganizationRole";


            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#organization
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserOrganizationRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::UserOrganizationRole::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#user
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserOrganizationRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserOrganizationRole::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserOrganizationRole#roleType
             * @methodOf lbServices.UserOrganizationRole
             *
             * @description
             *
             * Fetches belongsTo relation roleType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserOrganizationRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R.roleType = function() {
          var TargetResource = $injector.get("RoleType");
          var action = TargetResource["::get::UserOrganizationRole::roleType"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ServiceResource
 * @header lbServices.ServiceResource
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ServiceResource` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ServiceResource",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/serviceResources/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ServiceResource.organizationResource() instead.
            "prototype$__get__organizationResource": {
              url: urlBase + "/serviceResources/:id/organizationResource",
              method: "GET",
            },

            // INTERNAL. Use ServiceResource.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/serviceResources/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceResource.serviceSchedule() instead.
            "prototype$__get__serviceSchedule": {
              url: urlBase + "/serviceResources/:id/serviceSchedule",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#create
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/serviceResources",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#patchOrCreate
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/serviceResources",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#replaceOrCreate
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/serviceResources/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#upsertWithWhere
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/serviceResources/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#exists
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/serviceResources/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#findById
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/serviceResources/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#replaceById
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/serviceResources/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#find
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/serviceResources",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#findOne
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/serviceResources/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#updateAll
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/serviceResources/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#deleteById
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/serviceResources/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#count
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/serviceResources/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#prototype$patchAttributes
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/serviceResources/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#createChangeStream
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/serviceResources/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#createMany
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use ResourceCalendar.serviceResource() instead.
            "::get::ResourceCalendar::serviceResource": {
              url: urlBase + "/resourceCalendars/:id/serviceResource",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources.findById() instead.
            "::findById::OfferedService::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources.destroyById() instead.
            "::destroyById::OfferedService::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceResources.updateById() instead.
            "::updateById::OfferedService::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceResources() instead.
            "::get::OfferedService::serviceResources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources.create() instead.
            "::create::OfferedService::serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceResources.createMany() instead.
            "::createMany::OfferedService::serviceResources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceResources.destroyAll() instead.
            "::delete::OfferedService::serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceResources.count() instead.
            "::count::OfferedService::serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources/count",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.findById() instead.
            "::findById::ServiceSchedule::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.destroyById() instead.
            "::destroyById::ServiceSchedule::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.updateById() instead.
            "::updateById::ServiceSchedule::serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources() instead.
            "::get::ServiceSchedule::serviceResources": {
              isArray: true,
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.create() instead.
            "::create::ServiceSchedule::serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.createMany() instead.
            "::createMany::ServiceSchedule::serviceResources": {
              isArray: true,
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.destroyAll() instead.
            "::delete::ServiceSchedule::serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.count() instead.
            "::count::ServiceSchedule::serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources/count",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.serviceResource() instead.
            "::get::EarningCost::serviceResource": {
              url: urlBase + "/earningCosts/:id/serviceResource",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#upsert
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#updateOrCreate
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#patchOrCreateWithWhere
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#update
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#destroyById
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#removeById
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#prototype$updateAttributes
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ServiceResource#modelName
        * @propertyOf lbServices.ServiceResource
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ServiceResource`.
        */
        R.modelName = "ServiceResource";


            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#organizationResource
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Fetches belongsTo relation organizationResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResource = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::get::ServiceResource::organizationResource"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#offeredService
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::ServiceResource::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceResource#serviceSchedule
             * @methodOf lbServices.ServiceResource
             *
             * @description
             *
             * Fetches belongsTo relation serviceSchedule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedule = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::get::ServiceResource::serviceSchedule"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationResource
 * @header lbServices.OrganizationResource
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationResource` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationResource",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationResources/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OrganizationResource.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/organizationResources/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.staffMember() instead.
            "prototype$__get__staffMember": {
              url: urlBase + "/organizationResources/:id/staffMember",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.findById() instead.
            "prototype$__findById__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.destroyById() instead.
            "prototype$__destroyById__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.updateById() instead.
            "prototype$__updateById__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrganizationResource.services.link() instead.
            "prototype$__link__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrganizationResource.services.unlink() instead.
            "prototype$__unlink__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.exists() instead.
            "prototype$__exists__services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OrganizationResource.services() instead.
            "prototype$__get__services": {
              isArray: true,
              url: urlBase + "/organizationResources/:id/services",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.create() instead.
            "prototype$__create__services": {
              url: urlBase + "/organizationResources/:id/services",
              method: "POST",
            },

            // INTERNAL. Use OrganizationResource.services.destroyAll() instead.
            "prototype$__delete__services": {
              url: urlBase + "/organizationResources/:id/services",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.count() instead.
            "prototype$__count__services": {
              url: urlBase + "/organizationResources/:id/services/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#create
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationResources",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#patchOrCreate
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationResources",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#replaceOrCreate
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationResources/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#upsertWithWhere
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationResources/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#exists
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationResources/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#findById
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationResources/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#replaceById
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationResources/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#find
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationResources",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#findOne
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationResources/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#updateAll
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationResources/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#deleteById
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationResources/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#count
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationResources/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#prototype$patchAttributes
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationResources/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#createChangeStream
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationResources/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#createMany
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationResources",
              method: "POST",
            },

            // INTERNAL. Use Organization.organizationResources.findById() instead.
            "::findById::Organization::organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.organizationResources.destroyById() instead.
            "::destroyById::Organization::organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.organizationResources.updateById() instead.
            "::updateById::Organization::organizationResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/organizationResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.organizationResources() instead.
            "::get::Organization::organizationResources": {
              isArray: true,
              url: urlBase + "/organizations/:id/organizationResources",
              method: "GET",
            },

            // INTERNAL. Use Organization.organizationResources.create() instead.
            "::create::Organization::organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources",
              method: "POST",
            },

            // INTERNAL. Use Organization.organizationResources.createMany() instead.
            "::createMany::Organization::organizationResources": {
              isArray: true,
              url: urlBase + "/organizations/:id/organizationResources",
              method: "POST",
            },

            // INTERNAL. Use Organization.organizationResources.destroyAll() instead.
            "::delete::Organization::organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.organizationResources.count() instead.
            "::count::Organization::organizationResources": {
              url: urlBase + "/organizations/:id/organizationResources/count",
              method: "GET",
            },

            // INTERNAL. Use ServiceResource.organizationResource() instead.
            "::get::ServiceResource::organizationResource": {
              url: urlBase + "/serviceResources/:id/organizationResource",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.organizationResource() instead.
            "::get::ResourceCalendar::organizationResource": {
              url: urlBase + "/resourceCalendars/:id/organizationResource",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.findById() instead.
            "::findById::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.destroyById() instead.
            "::destroyById::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.updateById() instead.
            "::updateById::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.resources.link() instead.
            "::link::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.resources.unlink() instead.
            "::unlink::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.exists() instead.
            "::exists::OfferedService::resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.resources() instead.
            "::get::OfferedService::resources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/resources",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.create() instead.
            "::create::OfferedService::resources": {
              url: urlBase + "/offeredServices/:id/resources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.resources.createMany() instead.
            "::createMany::OfferedService::resources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/resources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.resources.destroyAll() instead.
            "::delete::OfferedService::resources": {
              url: urlBase + "/offeredServices/:id/resources",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.count() instead.
            "::count::OfferedService::resources": {
              url: urlBase + "/offeredServices/:id/resources/count",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.resource() instead.
            "::get::EarningCost::resource": {
              url: urlBase + "/earningCosts/:id/resource",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#upsert
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#updateOrCreate
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#update
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#destroyById
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#removeById
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#prototype$updateAttributes
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationResource#modelName
        * @propertyOf lbServices.OrganizationResource
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationResource`.
        */
        R.modelName = "OrganizationResource";


            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#organization
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::OrganizationResource::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#staffMember
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Fetches belongsTo relation staffMember.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.staffMember = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::OrganizationResource::staffMember"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OrganizationResource.services
     * @header lbServices.OrganizationResource.services
     * @object
     * @description
     *
     * The object `OrganizationResource.services` groups methods
     * manipulating `OfferedService` instances related to `OrganizationResource`.
     *
     * Call {@link lbServices.OrganizationResource#services OrganizationResource.services()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource#services
             * @methodOf lbServices.OrganizationResource
             *
             * @description
             *
             * Queries services of OrganizationResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#count
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Counts services of OrganizationResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.services.count = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::count::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#create
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Creates a new instance in services of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.create = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::create::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#createMany
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Creates a new instance in services of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.createMany = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::createMany::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#destroyAll
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Deletes all services of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.services.destroyAll = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::delete::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#destroyById
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Delete a related item by id for services.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.services.destroyById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::destroyById::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#exists
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Check the existence of services relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.exists = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::exists::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#findById
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Find a related item by id for services.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.findById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::findById::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#link
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Add a related item by id for services.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.link = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::link::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#unlink
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Remove the services relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.services.unlink = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::unlink::OrganizationResource::services"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationResource.services#updateById
             * @methodOf lbServices.OrganizationResource.services
             *
             * @description
             *
             * Update a related item by id for services.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationResource id
             *
             *  - `fk` – `{*}` - Foreign key for services
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.services.updateById = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::updateById::OrganizationResource::services"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ResourceCalendar
 * @header lbServices.ResourceCalendar
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ResourceCalendar` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ResourceCalendar",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/resourceCalendars/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ResourceCalendar.organizationResource() instead.
            "prototype$__get__organizationResource": {
              url: urlBase + "/resourceCalendars/:id/organizationResource",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.serviceResource() instead.
            "prototype$__get__serviceResource": {
              url: urlBase + "/resourceCalendars/:id/serviceResource",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.staffMember() instead.
            "prototype$__get__staffMember": {
              url: urlBase + "/resourceCalendars/:id/staffMember",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/resourceCalendars/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/resourceCalendars/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.serviceSchedule() instead.
            "prototype$__get__serviceSchedule": {
              url: urlBase + "/resourceCalendars/:id/serviceSchedule",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#create
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/resourceCalendars",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#patchOrCreate
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/resourceCalendars",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#replaceOrCreate
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/resourceCalendars/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#upsertWithWhere
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/resourceCalendars/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#exists
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/resourceCalendars/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#findById
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/resourceCalendars/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#replaceById
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/resourceCalendars/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#find
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/resourceCalendars",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#findOne
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/resourceCalendars/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#updateAll
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/resourceCalendars/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#deleteById
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/resourceCalendars/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#count
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/resourceCalendars/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#prototype$patchAttributes
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/resourceCalendars/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#createChangeStream
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/resourceCalendars/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#createMany
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/resourceCalendars",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#upsert
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#updateOrCreate
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#patchOrCreateWithWhere
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#update
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#destroyById
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#removeById
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#prototype$updateAttributes
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ResourceCalendar` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ResourceCalendar#modelName
        * @propertyOf lbServices.ResourceCalendar
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ResourceCalendar`.
        */
        R.modelName = "ResourceCalendar";


            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#organizationResource
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation organizationResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.organizationResource = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::get::ResourceCalendar::organizationResource"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#serviceResource
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation serviceResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResource = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::get::ResourceCalendar::serviceResource"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#staffMember
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation staffMember.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.staffMember = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::ResourceCalendar::staffMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#organization
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::ResourceCalendar::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#offeredService
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::ResourceCalendar::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ResourceCalendar#serviceSchedule
             * @methodOf lbServices.ResourceCalendar
             *
             * @description
             *
             * Fetches belongsTo relation serviceSchedule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ResourceCalendar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedule = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::get::ResourceCalendar::serviceSchedule"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RoleType
 * @header lbServices.RoleType
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RoleType` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RoleType",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/roleTypes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RoleType.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/roleTypes/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.findById() instead.
            "prototype$__findById__userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.destroyById() instead.
            "prototype$__destroyById__userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.updateById() instead.
            "prototype$__updateById__userOrganizationRole": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/roleTypes/:id/userOrganizationRole/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RoleType.userOrganizationRole() instead.
            "prototype$__get__userOrganizationRole": {
              isArray: true,
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "GET",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.create() instead.
            "prototype$__create__userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "POST",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.destroyAll() instead.
            "prototype$__delete__userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole",
              method: "DELETE",
            },

            // INTERNAL. Use RoleType.userOrganizationRole.count() instead.
            "prototype$__count__userOrganizationRole": {
              url: urlBase + "/roleTypes/:id/userOrganizationRole/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#create
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/roleTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#patchOrCreate
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/roleTypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#replaceOrCreate
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/roleTypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#upsertWithWhere
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/roleTypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#exists
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/roleTypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#findById
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/roleTypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#replaceById
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/roleTypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#find
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/roleTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#findOne
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/roleTypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#updateAll
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/roleTypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#deleteById
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/roleTypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#count
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/roleTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#prototype$patchAttributes
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/roleTypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#createChangeStream
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/roleTypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoleType#createMany
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/roleTypes",
              method: "POST",
            },

            // INTERNAL. Use Organization.roleTypes.findById() instead.
            "::findById::Organization::roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.roleTypes.destroyById() instead.
            "::destroyById::Organization::roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.roleTypes.updateById() instead.
            "::updateById::Organization::roleTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/roleTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.roleTypes() instead.
            "::get::Organization::roleTypes": {
              isArray: true,
              url: urlBase + "/organizations/:id/roleTypes",
              method: "GET",
            },

            // INTERNAL. Use Organization.roleTypes.create() instead.
            "::create::Organization::roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes",
              method: "POST",
            },

            // INTERNAL. Use Organization.roleTypes.createMany() instead.
            "::createMany::Organization::roleTypes": {
              isArray: true,
              url: urlBase + "/organizations/:id/roleTypes",
              method: "POST",
            },

            // INTERNAL. Use Organization.roleTypes.destroyAll() instead.
            "::delete::Organization::roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.roleTypes.count() instead.
            "::count::Organization::roleTypes": {
              url: urlBase + "/organizations/:id/roleTypes/count",
              method: "GET",
            },

            // INTERNAL. Use UserOrganizationRole.roleType() instead.
            "::get::UserOrganizationRole::roleType": {
              url: urlBase + "/userOrganizationRoles/:id/roleType",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RoleType#upsert
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#updateOrCreate
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#patchOrCreateWithWhere
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#update
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#destroyById
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#removeById
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RoleType#prototype$updateAttributes
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleType` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RoleType#modelName
        * @propertyOf lbServices.RoleType
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RoleType`.
        */
        R.modelName = "RoleType";


            /**
             * @ngdoc method
             * @name lbServices.RoleType#organization
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::RoleType::organization"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.RoleType.userOrganizationRole
     * @header lbServices.RoleType.userOrganizationRole
     * @object
     * @description
     *
     * The object `RoleType.userOrganizationRole` groups methods
     * manipulating `UserOrganizationRole` instances related to `RoleType`.
     *
     * Call {@link lbServices.RoleType#userOrganizationRole RoleType.userOrganizationRole()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.RoleType#userOrganizationRole
             * @methodOf lbServices.RoleType
             *
             * @description
             *
             * Queries userOrganizationRole of RoleType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRole = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::get::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#count
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Counts userOrganizationRole of RoleType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.userOrganizationRole.count = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::count::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#create
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Creates a new instance in userOrganizationRole of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRole.create = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::create::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#createMany
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Creates a new instance in userOrganizationRole of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRole.createMany = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::createMany::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#destroyAll
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Deletes all userOrganizationRole of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.userOrganizationRole.destroyAll = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::delete::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#destroyById
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Delete a related item by id for userOrganizationRole.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRole
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.userOrganizationRole.destroyById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::destroyById::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#findById
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Find a related item by id for userOrganizationRole.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRole
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRole.findById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::findById::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RoleType.userOrganizationRole#updateById
             * @methodOf lbServices.RoleType.userOrganizationRole
             *
             * @description
             *
             * Update a related item by id for userOrganizationRole.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleType id
             *
             *  - `fk` – `{*}` - Foreign key for userOrganizationRole
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserOrganizationRole` object.)
             * </em>
             */
        R.userOrganizationRole.updateById = function() {
          var TargetResource = $injector.get("UserOrganizationRole");
          var action = TargetResource["::updateById::RoleType::userOrganizationRole"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OfferedService
 * @header lbServices.OfferedService
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OfferedService` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OfferedService",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/offeredServices/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OfferedService.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/offeredServices/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.findById() instead.
            "prototype$__findById__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.destroyById() instead.
            "prototype$__destroyById__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.updateById() instead.
            "prototype$__updateById__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.resources.link() instead.
            "prototype$__link__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.resources.unlink() instead.
            "prototype$__unlink__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.exists() instead.
            "prototype$__exists__resources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/resources/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.serviceResources.findById() instead.
            "prototype$__findById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources.destroyById() instead.
            "prototype$__destroyById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceResources.updateById() instead.
            "prototype$__updateById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.findById() instead.
            "prototype$__findById__serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.destroyById() instead.
            "prototype$__destroyById__serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.updateById() instead.
            "prototype$__updateById__serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscribers.findById() instead.
            "prototype$__findById__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers.destroyById() instead.
            "prototype$__destroyById__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.updateById() instead.
            "prototype$__updateById__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscribers.link() instead.
            "prototype$__link__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscribers.unlink() instead.
            "prototype$__unlink__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.exists() instead.
            "prototype$__exists__subscribers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscribers/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.findById() instead.
            "prototype$__findById__subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.destroyById() instead.
            "prototype$__destroyById__subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.updateById() instead.
            "prototype$__updateById__subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__findById__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Find a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__findById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__destroyById__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Delete a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__updateById__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__updateById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__link__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Add a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__link__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__unlink__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Remove the children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__exists__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Check the existence of children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__exists__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/children/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__findById__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Find a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__findById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__destroyById__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Delete a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__updateById__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__updateById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__link__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Add a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__link__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__unlink__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Remove the parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__exists__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Check the existence of parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__exists__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/parents/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.findById() instead.
            "prototype$__findById__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.destroyById() instead.
            "prototype$__destroyById__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.updateById() instead.
            "prototype$__updateById__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.link() instead.
            "prototype$__link__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.unlink() instead.
            "prototype$__unlink__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.exists() instead.
            "prototype$__exists__requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.serviceTypes.findById() instead.
            "prototype$__findById__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes.destroyById() instead.
            "prototype$__destroyById__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.updateById() instead.
            "prototype$__updateById__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceTypes.link() instead.
            "prototype$__link__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceTypes.unlink() instead.
            "prototype$__unlink__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.exists() instead.
            "prototype$__exists__serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.findById() instead.
            "prototype$__findById__offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.destroyById() instead.
            "prototype$__destroyById__offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.updateById() instead.
            "prototype$__updateById__offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.categories.findById() instead.
            "prototype$__findById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories.destroyById() instead.
            "prototype$__destroyById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.updateById() instead.
            "prototype$__updateById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.categories.link() instead.
            "prototype$__link__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.categories.unlink() instead.
            "prototype$__unlink__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.exists() instead.
            "prototype$__exists__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.serviceCategories.findById() instead.
            "prototype$__findById__serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceCategories.destroyById() instead.
            "prototype$__destroyById__serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceCategories.updateById() instead.
            "prototype$__updateById__serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.pictures.findById() instead.
            "prototype$__findById__pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.pictures.destroyById() instead.
            "prototype$__destroyById__pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.pictures.updateById() instead.
            "prototype$__updateById__pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.resources() instead.
            "prototype$__get__resources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/resources",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.resources.create() instead.
            "prototype$__create__resources": {
              url: urlBase + "/offeredServices/:id/resources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.resources.destroyAll() instead.
            "prototype$__delete__resources": {
              url: urlBase + "/offeredServices/:id/resources",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.resources.count() instead.
            "prototype$__count__resources": {
              url: urlBase + "/offeredServices/:id/resources/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources() instead.
            "prototype$__get__serviceResources": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceResources.create() instead.
            "prototype$__create__serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceResources.destroyAll() instead.
            "prototype$__delete__serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceResources.count() instead.
            "prototype$__count__serviceResources": {
              url: urlBase + "/offeredServices/:id/serviceResources/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules() instead.
            "prototype$__get__serviceSchedules": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.create() instead.
            "prototype$__create__serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.destroyAll() instead.
            "prototype$__delete__serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.count() instead.
            "prototype$__count__serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers() instead.
            "prototype$__get__subscribers": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscribers.create() instead.
            "prototype$__create__subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscribers.destroyAll() instead.
            "prototype$__delete__subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscribers.count() instead.
            "prototype$__count__subscribers": {
              url: urlBase + "/offeredServices/:id/subscribers/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscriptionPages() instead.
            "prototype$__get__subscriptionPages": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.create() instead.
            "prototype$__create__subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.destroyAll() instead.
            "prototype$__delete__subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.count() instead.
            "prototype$__count__subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__get__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries children of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__get__children": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/children",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__create__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Creates a new instance in children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__create__children": {
              url: urlBase + "/offeredServices/:id/children",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__delete__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Deletes all children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__children": {
              url: urlBase + "/offeredServices/:id/children",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__count__children
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Counts children of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__children": {
              url: urlBase + "/offeredServices/:id/children/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__get__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries parents of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__get__parents": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/parents",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__create__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Creates a new instance in parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$__create__parents": {
              url: urlBase + "/offeredServices/:id/parents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__delete__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Deletes all parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__parents": {
              url: urlBase + "/offeredServices/:id/parents",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$__count__parents
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Counts parents of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__parents": {
              url: urlBase + "/offeredServices/:id/parents/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.requiredDocuments() instead.
            "prototype$__get__requiredDocuments": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.create() instead.
            "prototype$__create__requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.destroyAll() instead.
            "prototype$__delete__requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.count() instead.
            "prototype$__count__requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes() instead.
            "prototype$__get__serviceTypes": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes.create() instead.
            "prototype$__create__serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceTypes.destroyAll() instead.
            "prototype$__delete__serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.count() instead.
            "prototype$__count__serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations() instead.
            "prototype$__get__offeredServiceTypeRelations": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.create() instead.
            "prototype$__create__offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.destroyAll() instead.
            "prototype$__delete__offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.count() instead.
            "prototype$__count__offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories() instead.
            "prototype$__get__categories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories.create() instead.
            "prototype$__create__categories": {
              url: urlBase + "/offeredServices/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.categories.destroyAll() instead.
            "prototype$__delete__categories": {
              url: urlBase + "/offeredServices/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.count() instead.
            "prototype$__count__categories": {
              url: urlBase + "/offeredServices/:id/categories/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceCategories() instead.
            "prototype$__get__serviceCategories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceCategories.create() instead.
            "prototype$__create__serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceCategories.destroyAll() instead.
            "prototype$__delete__serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceCategories.count() instead.
            "prototype$__count__serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.pictures() instead.
            "prototype$__get__pictures": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/pictures",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.pictures.create() instead.
            "prototype$__create__pictures": {
              url: urlBase + "/offeredServices/:id/pictures",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.pictures.destroyAll() instead.
            "prototype$__delete__pictures": {
              url: urlBase + "/offeredServices/:id/pictures",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.pictures.count() instead.
            "prototype$__count__pictures": {
              url: urlBase + "/offeredServices/:id/pictures/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#create
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/offeredServices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#patchOrCreate
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/offeredServices",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#replaceOrCreate
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/offeredServices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#upsertWithWhere
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/offeredServices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#exists
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/offeredServices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#findById
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/offeredServices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#replaceById
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/offeredServices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#find
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/offeredServices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#findOne
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/offeredServices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateAll
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/offeredServices/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#deleteById
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/offeredServices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#count
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/offeredServices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$patchAttributes
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/offeredServices/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#createChangeStream
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/offeredServices/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$allSubscribers
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * find all the subscribers of the service completing with payments
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `payments` – `{string=}` -
             *
             *  - `documents` – `{string=}` -
             *
             *  - `hasCard` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{Object=}` -
             */
            "prototype$allSubscribers": {
              url: urlBase + "/offeredServices/:id/all-subscribers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$updateRequiredDocTypes
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * updates the list of service's doc types
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `requiredDocuments` – `{[object]=}` - list of required doc types 
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$updateRequiredDocTypes": {
              url: urlBase + "/offeredServices/:id/update-required-doctypes/",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$notifyAllSubscribersWithAutomaticMessage
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Notify the subscribed users
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `senderOrganizationId` – `{number=}` -
             *
             *  - `senderId` – `{number=}` -
             *
             *  - `title` – `{string=}` -
             *
             *  - `text` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$notifyAllSubscribersWithAutomaticMessage": {
              url: urlBase + "/offeredServices/:id/notify-all-subscribers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#addNonRegisteredSubscriber
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - id servzio offerto
             *
             *  - `subscriberData` – `{object}` - utente
             *
             *  - `subscribedServices` – `{*}` - oggetto contenent gli id dei servizi sottoscritti
             *
             *  - `subscriptionDiscount` – `{object}` - oggetto che contiene lo sconto da applicare alla sottoscrizione
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "addNonRegisteredSubscriber": {
              url: urlBase + "/offeredServices/new-service-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#renewSubscription
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id sottoscrizione da rinnovare
             *
             *  - `offeredServiceId` – `{string}` - id servizio offerto
             *
             *  - `subscriberData` – `{object}` - utente
             *
             *  - `subscribedServices` – `{*}` - oggetto contenent gli id dei servizi sottoscritti
             *
             *  - `subscriptionDiscount` – `{object}` - oggetto che contiene lo sconto da applicare alla sottoscrizione
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "renewSubscription": {
              url: urlBase + "/offeredServices/renew-service-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateOptionalServices
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id servzio offerto
             *
             *  - `services` – `{*}` - oggetto contenente un array di oggetti {offeredServiceId: number, active: boolean}
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "updateOptionalServices": {
              url: urlBase + "/offeredServices/update-optional-services",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateOrderDetails
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id servzio offerto
             *
             *  - `subscribedServices` – `{*}` - oggetto contenent gli id dei servizi sottoscritti
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "updateOrderDetails": {
              url: urlBase + "/offeredServices/update-order-details",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#copySubscribers
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `sourceOfferedServiceId` – `{string}` -
             *
             *  - `destOfferedServiceId` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `data` – `{string=}` -
             */
            "copySubscribers": {
              url: urlBase + "/offeredServices/copySubscribers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#exportExcelSubscribers
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `offeredServiceId` – `{string}` -
             *
             *  - `tk` – `{string}` -
             *
             *  - `payments` – `{string=}` -
             *
             *  - `documents` – `{string=}` -
             *
             *  - `hasCard` – `{string=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `data` – `{*=}` -
             */
            "exportExcelSubscribers": {
              url: urlBase + "/offeredServices/xlsx-service-subscribers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateServiceTypes
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - id servzio offerto
             *
             *  - `serviceTypes` – `{object}` - oggetto con i tipi di servizio
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "updateServiceTypes": {
              url: urlBase + "/offeredServices/updateServiceTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateServiceChildren
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - id servzio offerto
             *
             *  - `children` – `{object}` - oggetto con id dei servizi figli come chiavi
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` - OK se tutto va bene
             */
            "updateServiceChildren": {
              url: urlBase + "/offeredServices/updateServiceChildren",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#isCurrentUserAdminForOfferedService
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - offeredServiceId to check
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{boolean=}` -
             */
            "isCurrentUserAdminForOfferedService": {
              url: urlBase + "/offeredServices/isCurrentUserAdminForOfferedService",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#saveSubscriptionByQrCode
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `offeredServiceId` – `{string}` - offeredServiceId
             *
             *  - `enabled` – `{boolean}` - true / false to generate QR code
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `uri` – `{string=}` - uri del QR code
             */
            "saveSubscriptionByQrCode": {
              url: urlBase + "/offeredServices/saveSubscriptionByQrCode",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#qrcodeAction
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `qrcode` – `{string}` - qrcode in ingresso
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` - OK se operazione effettuata
             */
            "qrcodeAction": {
              url: urlBase + "/offeredServices/qrcodeAction",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#getItems
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `filters` – `{object}` -
             *
             *  - `excludeMemberships` – `{boolean=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * elenco elementi
             */
            "getItems": {
              isArray: true,
              url: urlBase + "/offeredServices/getItems",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#getItemsCount
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `filters` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `itemsNumber` – `{number=}` - numero di elementi
             */
            "getItemsCount": {
              url: urlBase + "/offeredServices/getItemsCount",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#search
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Paginated search for OfferedService
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `searchText` – `{string=}` - Text to be searched in organization name, service (name, description, categories), ciry, province, ...
             *
             *  - `geolocation` – `{object=}` - {latitude: xxx, longitude: xxx, km: 50}
             *
             *  - `options` – `{object=}` - {start: 0, count: 50, minIntensity: 0, maxIntensity: 100, minAge: 0, maxAge: 100, dateFrom: 20210101, dateTo: 20210131, organizationIds: [], categoryIds: [10,44]}
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * {items: [], start: 0, count: 50, total: 376}
             */
            "search": {
              url: urlBase + "/offeredServices/search",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#createMany
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use User.serviceSubscriptions.findById() instead.
            "::findById::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.serviceSubscriptions.destroyById() instead.
            "::destroyById::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.updateById() instead.
            "::updateById::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.serviceSubscriptions.link() instead.
            "::link::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.serviceSubscriptions.unlink() instead.
            "::unlink::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.exists() instead.
            "::exists::User::serviceSubscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/serviceSubscriptions/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.serviceSubscriptions() instead.
            "::get::User::serviceSubscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "GET",
            },

            // INTERNAL. Use User.serviceSubscriptions.create() instead.
            "::create::User::serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.serviceSubscriptions.createMany() instead.
            "::createMany::User::serviceSubscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.serviceSubscriptions.destroyAll() instead.
            "::delete::User::serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions",
              method: "DELETE",
            },

            // INTERNAL. Use User.serviceSubscriptions.count() instead.
            "::count::User::serviceSubscriptions": {
              url: urlBase + "/users/:id/serviceSubscriptions/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices.findById() instead.
            "::findById::Organization::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices.destroyById() instead.
            "::destroyById::Organization::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.offeredServices.updateById() instead.
            "::updateById::Organization::offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/offeredServices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.offeredServices() instead.
            "::get::Organization::offeredServices": {
              isArray: true,
              url: urlBase + "/organizations/:id/offeredServices",
              method: "GET",
            },

            // INTERNAL. Use Organization.offeredServices.create() instead.
            "::create::Organization::offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use Organization.offeredServices.createMany() instead.
            "::createMany::Organization::offeredServices": {
              isArray: true,
              url: urlBase + "/organizations/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use Organization.offeredServices.destroyAll() instead.
            "::delete::Organization::offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.offeredServices.count() instead.
            "::count::Organization::offeredServices": {
              url: urlBase + "/organizations/:id/offeredServices/count",
              method: "GET",
            },

            // INTERNAL. Use ServiceResource.offeredService() instead.
            "::get::ServiceResource::offeredService": {
              url: urlBase + "/serviceResources/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.findById() instead.
            "::findById::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.destroyById() instead.
            "::destroyById::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.updateById() instead.
            "::updateById::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrganizationResource.services.link() instead.
            "::link::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrganizationResource.services.unlink() instead.
            "::unlink::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.exists() instead.
            "::exists::OrganizationResource::services": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizationResources/:id/services/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OrganizationResource.services() instead.
            "::get::OrganizationResource::services": {
              isArray: true,
              url: urlBase + "/organizationResources/:id/services",
              method: "GET",
            },

            // INTERNAL. Use OrganizationResource.services.create() instead.
            "::create::OrganizationResource::services": {
              url: urlBase + "/organizationResources/:id/services",
              method: "POST",
            },

            // INTERNAL. Use OrganizationResource.services.createMany() instead.
            "::createMany::OrganizationResource::services": {
              isArray: true,
              url: urlBase + "/organizationResources/:id/services",
              method: "POST",
            },

            // INTERNAL. Use OrganizationResource.services.destroyAll() instead.
            "::delete::OrganizationResource::services": {
              url: urlBase + "/organizationResources/:id/services",
              method: "DELETE",
            },

            // INTERNAL. Use OrganizationResource.services.count() instead.
            "::count::OrganizationResource::services": {
              url: urlBase + "/organizationResources/:id/services/count",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.offeredService() instead.
            "::get::ResourceCalendar::offeredService": {
              url: urlBase + "/resourceCalendars/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.offeredService() instead.
            "::get::ServiceSchedule::offeredService": {
              url: urlBase + "/serviceSchedules/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Subscription.offeredService() instead.
            "::get::Subscription::offeredService": {
              url: urlBase + "/subscriptions/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionPage.offeredService() instead.
            "::get::SubscriptionPage::offeredService": {
              url: urlBase + "/subscriptionPages/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Order.offeredService() instead.
            "::get::Order::offeredService": {
              url: urlBase + "/orders/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Invitation.offeredService() instead.
            "::get::Invitation::offeredService": {
              url: urlBase + "/invitations/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use OfferedServiceRelation.child() instead.
            "::get::OfferedServiceRelation::child": {
              url: urlBase + "/OfferedServiceRelations/:id/child",
              method: "GET",
            },

            // INTERNAL. Use OfferedServiceRelation.parent() instead.
            "::get::OfferedServiceRelation::parent": {
              url: urlBase + "/OfferedServiceRelations/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Payment.offeredService() instead.
            "::get::Payment::offeredService": {
              url: urlBase + "/payments/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.offeredService() instead.
            "::get::EarningCost::offeredService": {
              url: urlBase + "/earningCosts/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceDoctype.offeredService() instead.
            "::get::ServiceDoctype::offeredService": {
              url: urlBase + "/serviceDoctypes/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderOfferedService() instead.
            "::get::Notification::senderOfferedService": {
              url: urlBase + "/notifications/:id/senderOfferedService",
              method: "GET",
            },

            // INTERNAL. Use OfferedServiceTypeRelation.user() instead.
            "::get::OfferedServiceTypeRelation::user": {
              url: urlBase + "/offeredServiceTypeRelations/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Attendance.offeredService() instead.
            "::get::Attendance::offeredService": {
              url: urlBase + "/attendances/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Attendance.subscribedOfferedService() instead.
            "::get::Attendance::subscribedOfferedService": {
              url: urlBase + "/attendances/:id/subscribedOfferedService",
              method: "GET",
            },

            // INTERNAL. Use AttendanceNote.offeredService() instead.
            "::get::AttendanceNote::offeredService": {
              url: urlBase + "/attendanceNotes/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use PaymentReport.offeredService() instead.
            "::get::PaymentReport::offeredService": {
              url: urlBase + "/paymentReports/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Oplog.offeredService() instead.
            "::get::Oplog::offeredService": {
              url: urlBase + "/oplog/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceCategory.offeredServices() instead.
            "::get::ServiceCategory::offeredServices": {
              url: urlBase + "/serviceCategories/:id/offeredServices",
              method: "GET",
            },

            // INTERNAL. Use OfferedServicePicture.offeredService() instead.
            "::get::OfferedServicePicture::offeredService": {
              url: urlBase + "/offeredServicePictures/:id/offeredService",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OfferedService#upsert
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#updateOrCreate
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#patchOrCreateWithWhere
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#update
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#destroyById
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#removeById
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedService#prototype$updateAttributes
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OfferedService#modelName
        * @propertyOf lbServices.OfferedService
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OfferedService`.
        */
        R.modelName = "OfferedService";


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#organization
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::OfferedService::organization"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.resources
     * @header lbServices.OfferedService.resources
     * @object
     * @description
     *
     * The object `OfferedService.resources` groups methods
     * manipulating `OrganizationResource` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#resources OfferedService.resources()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#resources
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries resources of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::get::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#count
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Counts resources of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.resources.count = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::count::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#create
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Creates a new instance in resources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.create = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::create::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#createMany
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Creates a new instance in resources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.createMany = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::createMany::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#destroyAll
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Deletes all resources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.resources.destroyAll = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::delete::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#destroyById
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Delete a related item by id for resources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.resources.destroyById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::destroyById::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#exists
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Check the existence of resources relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.exists = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::exists::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#findById
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Find a related item by id for resources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.findById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::findById::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#link
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Add a related item by id for resources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.link = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::link::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#unlink
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Remove the resources relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.resources.unlink = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::unlink::OfferedService::resources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.resources#updateById
             * @methodOf lbServices.OfferedService.resources
             *
             * @description
             *
             * Update a related item by id for resources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for resources
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resources.updateById = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::updateById::OfferedService::resources"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.serviceResources
     * @header lbServices.OfferedService.serviceResources
     * @object
     * @description
     *
     * The object `OfferedService.serviceResources` groups methods
     * manipulating `ServiceResource` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#serviceResources OfferedService.serviceResources()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#serviceResources
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries serviceResources of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::get::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#count
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Counts serviceResources of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceResources.count = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::count::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#create
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Creates a new instance in serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.create = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::create::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#createMany
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Creates a new instance in serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.createMany = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::createMany::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#destroyAll
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Deletes all serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceResources.destroyAll = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::delete::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#destroyById
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Delete a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceResources.destroyById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::destroyById::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#findById
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Find a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.findById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::findById::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceResources#updateById
             * @methodOf lbServices.OfferedService.serviceResources
             *
             * @description
             *
             * Update a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.updateById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::updateById::OfferedService::serviceResources"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.serviceSchedules
     * @header lbServices.OfferedService.serviceSchedules
     * @object
     * @description
     *
     * The object `OfferedService.serviceSchedules` groups methods
     * manipulating `ServiceSchedule` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#serviceSchedules OfferedService.serviceSchedules()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#serviceSchedules
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries serviceSchedules of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedules = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::get::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#count
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Counts serviceSchedules of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceSchedules.count = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::count::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#create
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Creates a new instance in serviceSchedules of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedules.create = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::create::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#createMany
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Creates a new instance in serviceSchedules of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedules.createMany = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::createMany::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#destroyAll
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Deletes all serviceSchedules of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceSchedules.destroyAll = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::delete::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#destroyById
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Delete a related item by id for serviceSchedules.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSchedules
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceSchedules.destroyById = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::destroyById::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#findById
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Find a related item by id for serviceSchedules.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceSchedules
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedules.findById = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::findById::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceSchedules#updateById
             * @methodOf lbServices.OfferedService.serviceSchedules
             *
             * @description
             *
             * Update a related item by id for serviceSchedules.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for serviceSchedules
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedules.updateById = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::updateById::OfferedService::serviceSchedules"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.subscribers
     * @header lbServices.OfferedService.subscribers
     * @object
     * @description
     *
     * The object `OfferedService.subscribers` groups methods
     * manipulating `User` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#subscribers OfferedService.subscribers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#subscribers
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries subscribers of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#count
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Counts subscribers of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subscribers.count = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::count::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#create
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Creates a new instance in subscribers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.create = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::create::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#createMany
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Creates a new instance in subscribers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.createMany = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::createMany::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#destroyAll
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Deletes all subscribers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscribers.destroyAll = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::delete::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#destroyById
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Delete a related item by id for subscribers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscribers.destroyById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::destroyById::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#exists
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Check the existence of subscribers relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.exists = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::exists::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#findById
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Find a related item by id for subscribers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#link
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Add a related item by id for subscribers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#unlink
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Remove the subscribers relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscribers.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscribers#updateById
             * @methodOf lbServices.OfferedService.subscribers
             *
             * @description
             *
             * Update a related item by id for subscribers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for subscribers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.subscribers.updateById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::updateById::OfferedService::subscribers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.subscriptionPages
     * @header lbServices.OfferedService.subscriptionPages
     * @object
     * @description
     *
     * The object `OfferedService.subscriptionPages` groups methods
     * manipulating `SubscriptionPage` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#subscriptionPages OfferedService.subscriptionPages()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#subscriptionPages
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries subscriptionPages of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R.subscriptionPages = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::get::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#count
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Counts subscriptionPages of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subscriptionPages.count = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::count::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#create
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Creates a new instance in subscriptionPages of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R.subscriptionPages.create = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::create::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#createMany
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Creates a new instance in subscriptionPages of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R.subscriptionPages.createMany = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::createMany::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#destroyAll
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Deletes all subscriptionPages of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptionPages.destroyAll = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::delete::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#destroyById
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Delete a related item by id for subscriptionPages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionPages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptionPages.destroyById = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::destroyById::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#findById
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Find a related item by id for subscriptionPages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionPages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R.subscriptionPages.findById = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::findById::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.subscriptionPages#updateById
             * @methodOf lbServices.OfferedService.subscriptionPages
             *
             * @description
             *
             * Update a related item by id for subscriptionPages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionPages
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R.subscriptionPages.updateById = function() {
          var TargetResource = $injector.get("SubscriptionPage");
          var action = TargetResource["::updateById::OfferedService::subscriptionPages"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.requiredDocuments
     * @header lbServices.OfferedService.requiredDocuments
     * @object
     * @description
     *
     * The object `OfferedService.requiredDocuments` groups methods
     * manipulating `OrganizationDoctype` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#requiredDocuments OfferedService.requiredDocuments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#requiredDocuments
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries requiredDocuments of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::get::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#count
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Counts requiredDocuments of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.requiredDocuments.count = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::count::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#create
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Creates a new instance in requiredDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.create = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::create::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#createMany
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Creates a new instance in requiredDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.createMany = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::createMany::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#destroyAll
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Deletes all requiredDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.requiredDocuments.destroyAll = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::delete::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#destroyById
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Delete a related item by id for requiredDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.requiredDocuments.destroyById = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::destroyById::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#exists
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Check the existence of requiredDocuments relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.exists = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::exists::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#findById
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Find a related item by id for requiredDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.findById = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::findById::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#link
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Add a related item by id for requiredDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.link = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::link::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#unlink
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Remove the requiredDocuments relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.requiredDocuments.unlink = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::unlink::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.requiredDocuments#updateById
             * @methodOf lbServices.OfferedService.requiredDocuments
             *
             * @description
             *
             * Update a related item by id for requiredDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for requiredDocuments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.requiredDocuments.updateById = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::updateById::OfferedService::requiredDocuments"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.serviceTypes
     * @header lbServices.OfferedService.serviceTypes
     * @object
     * @description
     *
     * The object `OfferedService.serviceTypes` groups methods
     * manipulating `Category` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#serviceTypes OfferedService.serviceTypes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#serviceTypes
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries serviceTypes of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#count
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Counts serviceTypes of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceTypes.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#create
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Creates a new instance in serviceTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#createMany
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Creates a new instance in serviceTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#destroyAll
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Deletes all serviceTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceTypes.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#destroyById
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Delete a related item by id for serviceTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceTypes.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#exists
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Check the existence of serviceTypes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.exists = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::exists::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#findById
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Find a related item by id for serviceTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#link
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Add a related item by id for serviceTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.link = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::link::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#unlink
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Remove the serviceTypes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceTypes.unlink = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::unlink::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceTypes#updateById
             * @methodOf lbServices.OfferedService.serviceTypes
             *
             * @description
             *
             * Update a related item by id for serviceTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for serviceTypes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.serviceTypes.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::OfferedService::serviceTypes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.offeredServiceTypeRelations
     * @header lbServices.OfferedService.offeredServiceTypeRelations
     * @object
     * @description
     *
     * The object `OfferedService.offeredServiceTypeRelations` groups methods
     * manipulating `OfferedServiceTypeRelation` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#offeredServiceTypeRelations OfferedService.offeredServiceTypeRelations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#offeredServiceTypeRelations
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries offeredServiceTypeRelations of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R.offeredServiceTypeRelations = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::get::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#count
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Counts offeredServiceTypeRelations of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offeredServiceTypeRelations.count = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::count::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#create
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Creates a new instance in offeredServiceTypeRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R.offeredServiceTypeRelations.create = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::create::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#createMany
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Creates a new instance in offeredServiceTypeRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R.offeredServiceTypeRelations.createMany = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::createMany::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#destroyAll
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Deletes all offeredServiceTypeRelations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServiceTypeRelations.destroyAll = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::delete::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#destroyById
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Delete a related item by id for offeredServiceTypeRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServiceTypeRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServiceTypeRelations.destroyById = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::destroyById::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#findById
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Find a related item by id for offeredServiceTypeRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServiceTypeRelations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R.offeredServiceTypeRelations.findById = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::findById::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.offeredServiceTypeRelations#updateById
             * @methodOf lbServices.OfferedService.offeredServiceTypeRelations
             *
             * @description
             *
             * Update a related item by id for offeredServiceTypeRelations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for offeredServiceTypeRelations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R.offeredServiceTypeRelations.updateById = function() {
          var TargetResource = $injector.get("OfferedServiceTypeRelation");
          var action = TargetResource["::updateById::OfferedService::offeredServiceTypeRelations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.categories
     * @header lbServices.OfferedService.categories
     * @object
     * @description
     *
     * The object `OfferedService.categories` groups methods
     * manipulating `Category` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#categories OfferedService.categories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#categories
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries categories of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#count
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Counts categories of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.categories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#create
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Creates a new instance in categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#createMany
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Creates a new instance in categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#destroyAll
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Deletes all categories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#destroyById
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Delete a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#exists
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Check the existence of categories relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.exists = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::exists::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#findById
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Find a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#link
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Add a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.link = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::link::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#unlink
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Remove the categories relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.unlink = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::unlink::OfferedService::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.categories#updateById
             * @methodOf lbServices.OfferedService.categories
             *
             * @description
             *
             * Update a related item by id for categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::OfferedService::categories"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.serviceCategories
     * @header lbServices.OfferedService.serviceCategories
     * @object
     * @description
     *
     * The object `OfferedService.serviceCategories` groups methods
     * manipulating `ServiceCategory` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#serviceCategories OfferedService.serviceCategories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#serviceCategories
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries serviceCategories of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R.serviceCategories = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::get::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#count
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Counts serviceCategories of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceCategories.count = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::count::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#create
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Creates a new instance in serviceCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R.serviceCategories.create = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::create::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#createMany
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Creates a new instance in serviceCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R.serviceCategories.createMany = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::createMany::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#destroyAll
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Deletes all serviceCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceCategories.destroyAll = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::delete::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#destroyById
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Delete a related item by id for serviceCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceCategories.destroyById = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::destroyById::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#findById
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Find a related item by id for serviceCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R.serviceCategories.findById = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::findById::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.serviceCategories#updateById
             * @methodOf lbServices.OfferedService.serviceCategories
             *
             * @description
             *
             * Update a related item by id for serviceCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for serviceCategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R.serviceCategories.updateById = function() {
          var TargetResource = $injector.get("ServiceCategory");
          var action = TargetResource["::updateById::OfferedService::serviceCategories"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OfferedService.pictures
     * @header lbServices.OfferedService.pictures
     * @object
     * @description
     *
     * The object `OfferedService.pictures` groups methods
     * manipulating `OfferedServicePicture` instances related to `OfferedService`.
     *
     * Call {@link lbServices.OfferedService#pictures OfferedService.pictures()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OfferedService#pictures
             * @methodOf lbServices.OfferedService
             *
             * @description
             *
             * Queries pictures of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R.pictures = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::get::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#count
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Counts pictures of OfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.pictures.count = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::count::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#create
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Creates a new instance in pictures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R.pictures.create = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::create::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#createMany
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Creates a new instance in pictures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R.pictures.createMany = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::createMany::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#destroyAll
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Deletes all pictures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.pictures.destroyAll = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::delete::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#destroyById
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Delete a related item by id for pictures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for pictures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.pictures.destroyById = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::destroyById::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#findById
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Find a related item by id for pictures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for pictures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R.pictures.findById = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::findById::OfferedService::pictures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedService.pictures#updateById
             * @methodOf lbServices.OfferedService.pictures
             *
             * @description
             *
             * Update a related item by id for pictures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedService id
             *
             *  - `fk` – `{*}` - Foreign key for pictures
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R.pictures.updateById = function() {
          var TargetResource = $injector.get("OfferedServicePicture");
          var action = TargetResource["::updateById::OfferedService::pictures"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ServiceSchedule
 * @header lbServices.ServiceSchedule
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ServiceSchedule` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ServiceSchedule",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/serviceSchedules/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ServiceSchedule.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/serviceSchedules/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.findById() instead.
            "prototype$__findById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.destroyById() instead.
            "prototype$__destroyById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.updateById() instead.
            "prototype$__updateById__serviceResources": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceSchedules/:id/serviceResources/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources() instead.
            "prototype$__get__serviceResources": {
              isArray: true,
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "GET",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.create() instead.
            "prototype$__create__serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "POST",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.destroyAll() instead.
            "prototype$__delete__serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceSchedule.serviceResources.count() instead.
            "prototype$__count__serviceResources": {
              url: urlBase + "/serviceSchedules/:id/serviceResources/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#create
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/serviceSchedules",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#patchOrCreate
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/serviceSchedules",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#replaceOrCreate
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/serviceSchedules/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#upsertWithWhere
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/serviceSchedules/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#exists
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/serviceSchedules/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#findById
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/serviceSchedules/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#replaceById
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/serviceSchedules/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#find
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/serviceSchedules",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#findOne
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/serviceSchedules/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#updateAll
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/serviceSchedules/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#deleteById
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/serviceSchedules/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#count
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/serviceSchedules/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#prototype$patchAttributes
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/serviceSchedules/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#createChangeStream
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/serviceSchedules/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#prototype$updateScheduleResources
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * updates the resources linked to a schedule
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `serviceScheduleResources` – `{[object]}` - list of ServiceResources 
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$updateScheduleResources": {
              url: urlBase + "/serviceSchedules/:id/update-schedule-resources/",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#createMany
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/serviceSchedules",
              method: "POST",
            },

            // INTERNAL. Use ServiceResource.serviceSchedule() instead.
            "::get::ServiceResource::serviceSchedule": {
              url: urlBase + "/serviceResources/:id/serviceSchedule",
              method: "GET",
            },

            // INTERNAL. Use ResourceCalendar.serviceSchedule() instead.
            "::get::ResourceCalendar::serviceSchedule": {
              url: urlBase + "/resourceCalendars/:id/serviceSchedule",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.findById() instead.
            "::findById::OfferedService::serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.destroyById() instead.
            "::destroyById::OfferedService::serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.updateById() instead.
            "::updateById::OfferedService::serviceSchedules": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceSchedules/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceSchedules() instead.
            "::get::OfferedService::serviceSchedules": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.create() instead.
            "::create::OfferedService::serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.createMany() instead.
            "::createMany::OfferedService::serviceSchedules": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.destroyAll() instead.
            "::delete::OfferedService::serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceSchedules.count() instead.
            "::count::OfferedService::serviceSchedules": {
              url: urlBase + "/offeredServices/:id/serviceSchedules/count",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.serviceSchedule() instead.
            "::get::EarningCost::serviceSchedule": {
              url: urlBase + "/earningCosts/:id/serviceSchedule",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#upsert
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#updateOrCreate
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#patchOrCreateWithWhere
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#update
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#destroyById
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#removeById
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#prototype$updateAttributes
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ServiceSchedule#modelName
        * @propertyOf lbServices.ServiceSchedule
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ServiceSchedule`.
        */
        R.modelName = "ServiceSchedule";


            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#offeredService
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::ServiceSchedule::offeredService"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ServiceSchedule.serviceResources
     * @header lbServices.ServiceSchedule.serviceResources
     * @object
     * @description
     *
     * The object `ServiceSchedule.serviceResources` groups methods
     * manipulating `ServiceResource` instances related to `ServiceSchedule`.
     *
     * Call {@link lbServices.ServiceSchedule#serviceResources ServiceSchedule.serviceResources()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule#serviceResources
             * @methodOf lbServices.ServiceSchedule
             *
             * @description
             *
             * Queries serviceResources of ServiceSchedule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::get::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#count
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Counts serviceResources of ServiceSchedule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.serviceResources.count = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::count::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#create
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Creates a new instance in serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.create = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::create::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#createMany
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Creates a new instance in serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.createMany = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::createMany::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#destroyAll
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Deletes all serviceResources of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceResources.destroyAll = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::delete::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#destroyById
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Delete a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.serviceResources.destroyById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::destroyById::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#findById
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Find a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.findById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::findById::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceSchedule.serviceResources#updateById
             * @methodOf lbServices.ServiceSchedule.serviceResources
             *
             * @description
             *
             * Update a related item by id for serviceResources.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceSchedule id
             *
             *  - `fk` – `{*}` - Foreign key for serviceResources
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResources.updateById = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::updateById::ServiceSchedule::serviceResources"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Subscription
 * @header lbServices.Subscription
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Subscription` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Subscription",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscriptions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Subscription.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/subscriptions/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Subscription.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/subscriptions/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__findById__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__findById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orderDetails/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__destroyById__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orderDetails/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__updateById__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__updateById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orderDetails/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.orders.findById() instead.
            "prototype$__findById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.orders.destroyById() instead.
            "prototype$__destroyById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.orders.updateById() instead.
            "prototype$__updateById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.documents.findById() instead.
            "prototype$__findById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.documents.destroyById() instead.
            "prototype$__destroyById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.documents.updateById() instead.
            "prototype$__updateById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__findById__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find a related item by id for subscriptionDiscounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDiscounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__findById__subscriptionDiscounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__destroyById__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete a related item by id for subscriptionDiscounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDiscounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__subscriptionDiscounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__updateById__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update a related item by id for subscriptionDiscounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDiscounts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__updateById__subscriptionDiscounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.attendances.findById() instead.
            "prototype$__findById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.attendances.destroyById() instead.
            "prototype$__destroyById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.attendances.updateById() instead.
            "prototype$__updateById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__get__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries orderDetails of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__get__orderDetails": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/orderDetails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__create__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Creates a new instance in orderDetails of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__create__orderDetails": {
              url: urlBase + "/subscriptions/:id/orderDetails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__delete__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Deletes all orderDetails of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__orderDetails": {
              url: urlBase + "/subscriptions/:id/orderDetails",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__count__orderDetails
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Counts orderDetails of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__orderDetails": {
              url: urlBase + "/subscriptions/:id/orderDetails/count",
              method: "GET",
            },

            // INTERNAL. Use Subscription.orders() instead.
            "prototype$__get__orders": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/orders",
              method: "GET",
            },

            // INTERNAL. Use Subscription.orders.create() instead.
            "prototype$__create__orders": {
              url: urlBase + "/subscriptions/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use Subscription.orders.destroyAll() instead.
            "prototype$__delete__orders": {
              url: urlBase + "/subscriptions/:id/orders",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.orders.count() instead.
            "prototype$__count__orders": {
              url: urlBase + "/subscriptions/:id/orders/count",
              method: "GET",
            },

            // INTERNAL. Use Subscription.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Subscription.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/subscriptions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Subscription.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/subscriptions/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/subscriptions/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Subscription.documents() instead.
            "prototype$__get__documents": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use Subscription.documents.create() instead.
            "prototype$__create__documents": {
              url: urlBase + "/subscriptions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use Subscription.documents.destroyAll() instead.
            "prototype$__delete__documents": {
              url: urlBase + "/subscriptions/:id/documents",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.documents.count() instead.
            "prototype$__count__documents": {
              url: urlBase + "/subscriptions/:id/documents/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__get__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries subscriptionDiscounts of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__get__subscriptionDiscounts": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__create__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Creates a new instance in subscriptionDiscounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$__create__subscriptionDiscounts": {
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__delete__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Deletes all subscriptionDiscounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__subscriptionDiscounts": {
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$__count__subscriptionDiscounts
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Counts subscriptionDiscounts of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__subscriptionDiscounts": {
              url: urlBase + "/subscriptions/:id/subscriptionDiscounts/count",
              method: "GET",
            },

            // INTERNAL. Use Subscription.attendances() instead.
            "prototype$__get__attendances": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/attendances",
              method: "GET",
            },

            // INTERNAL. Use Subscription.attendances.create() instead.
            "prototype$__create__attendances": {
              url: urlBase + "/subscriptions/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Subscription.attendances.destroyAll() instead.
            "prototype$__delete__attendances": {
              url: urlBase + "/subscriptions/:id/attendances",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.attendances.count() instead.
            "prototype$__count__attendances": {
              url: urlBase + "/subscriptions/:id/attendances/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#create
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscriptions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#patchOrCreate
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/subscriptions",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#replaceOrCreate
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subscriptions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#upsertWithWhere
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subscriptions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#exists
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subscriptions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#findById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscriptions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#replaceById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subscriptions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#find
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscriptions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#findOne
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subscriptions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#updateAll
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subscriptions/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#deleteById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subscriptions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#count
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscriptions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$patchAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscriptions/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createChangeStream
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subscriptions/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$updateSubscriptionDocuments
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * updates the documents of a user linked to a subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `subscriptionDocuments` – `{[object]}` - list of subscriptionDocuments 
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$updateSubscriptionDocuments": {
              url: urlBase + "/subscriptions/:id/update-subscription-documents/",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#notifyPaymentLink
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - subscriptionId
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * OK se tutto va bene
             */
            "notifyPaymentLink": {
              url: urlBase + "/subscriptions/notifyPaymentLink",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#updateNumMaxAccessForOrder
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - subscriptionId
             *
             *  - `numMaxAccessForOrder` – `{number}` - numMaxAccessForOrder
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * OK se tutto va bene
             */
            "updateNumMaxAccessForOrder": {
              url: urlBase + "/subscriptions/updateNumMaxAccessForOrder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createMissingOrders
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionContext` – `{object}` - {subscription: Object, offeredService: Object}
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "createMissingOrders": {
              url: urlBase + "/subscriptions/createMissingOrders",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#quit
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{number}` - subscriptionId
             *
             *  - `endDate` – `{string}` - Subscription end date, ad ISO string
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * result object
             */
            "quit": {
              url: urlBase + "/subscriptions/quit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#testCheckExpiringPayments
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `subscriptionId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "testCheckExpiringPayments": {
              url: urlBase + "/subscriptions/testCheckExpiringPayments/:subscriptionId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#getCarnetSummary
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Elenca i carnet associati ad un offeredService
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `offeredServiceId` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * array di carnet
             */
            "getCarnetSummary": {
              isArray: true,
              url: urlBase + "/subscriptions/getCarnetSummary",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#getCarnetPerUser
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Elenca i carnet associati ad un utente
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `userId` – `{string}` -
             *
             *  - `offeredServiceId` – `{string=}` - eventuale unico servizio da considerare
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * array di carnet
             */
            "getCarnetPerUser": {
              isArray: true,
              url: urlBase + "/subscriptions/getCarnetPerUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#getNormalizedSubscriptions
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `subscriptions` – `{*=}` -
             */
            "getNormalizedSubscriptions": {
              url: urlBase + "/subscriptions/getNormalizedSubscriptions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#carnet
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `options` – `{object=}` - currently unused
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "carnet": {
              isArray: true,
              url: urlBase + "/subscriptions/carnet/:organizationId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#carnetAnomalies
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `options` – `{object=}` - { withOverdue: true }
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "carnetAnomalies": {
              isArray: true,
              url: urlBase + "/subscriptions/carnet-anomalies/:organizationId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#getMemberships
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Ritorna i tesseramenti attivi per una organizzazione
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `filters` – `{object}` - {"organizationId":36, "searchText": "nicola", "dateFrom": "2019-01-01 00:00:00", "dateTo": "2019-12-31 23:59:59", "order":[{"column":1,"dir":"asc"}], "start": 0, "length": 100}
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * {items: [], recordsTotal: 0, recordsFiltered: 0}
             */
            "getMemberships": {
              url: urlBase + "/subscriptions/getMemberships",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createMany
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.subscriptions.findById() instead.
            "::findById::User::subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.subscriptions.destroyById() instead.
            "::destroyById::User::subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.subscriptions.updateById() instead.
            "::updateById::User::subscriptions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/subscriptions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.subscriptions() instead.
            "::get::User::subscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/subscriptions",
              method: "GET",
            },

            // INTERNAL. Use User.subscriptions.create() instead.
            "::create::User::subscriptions": {
              url: urlBase + "/users/:id/subscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.subscriptions.createMany() instead.
            "::createMany::User::subscriptions": {
              isArray: true,
              url: urlBase + "/users/:id/subscriptions",
              method: "POST",
            },

            // INTERNAL. Use User.subscriptions.destroyAll() instead.
            "::delete::User::subscriptions": {
              url: urlBase + "/users/:id/subscriptions",
              method: "DELETE",
            },

            // INTERNAL. Use User.subscriptions.count() instead.
            "::count::User::subscriptions": {
              url: urlBase + "/users/:id/subscriptions/count",
              method: "GET",
            },

            // INTERNAL. Use Order.subscription() instead.
            "::get::Order::subscription": {
              url: urlBase + "/orders/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Payment.subscription() instead.
            "::get::Payment::subscription": {
              url: urlBase + "/payments/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.subscription() instead.
            "::get::EarningCost::subscription": {
              url: urlBase + "/earningCosts/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionDocument.subscription() instead.
            "::get::SubscriptionDocument::subscription": {
              url: urlBase + "/subscriptionDocument/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderSubscription() instead.
            "::get::Notification::senderSubscription": {
              url: urlBase + "/notifications/:id/senderSubscription",
              method: "GET",
            },

            // INTERNAL. Use Attendance.subscription() instead.
            "::get::Attendance::subscription": {
              url: urlBase + "/attendances/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Oplog.subscription() instead.
            "::get::Oplog::subscription": {
              url: urlBase + "/oplog/:id/subscription",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Subscription#upsert
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#updateOrCreate
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#patchOrCreateWithWhere
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#update
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#destroyById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#removeById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$updateAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Subscription#modelName
        * @propertyOf lbServices.Subscription
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Subscription`.
        */
        R.modelName = "Subscription";


            /**
             * @ngdoc method
             * @name lbServices.Subscription#offeredService
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Subscription::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription#user
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Subscription::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Subscription.orders
     * @header lbServices.Subscription.orders
     * @object
     * @description
     *
     * The object `Subscription.orders` groups methods
     * manipulating `Order` instances related to `Subscription`.
     *
     * Call {@link lbServices.Subscription#orders Subscription.orders()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Subscription#orders
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries orders of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#count
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Counts orders of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.orders.count = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::count::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#create
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Creates a new instance in orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.create = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::create::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#createMany
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Creates a new instance in orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.createMany = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::createMany::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#destroyAll
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Deletes all orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.orders.destroyAll = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::delete::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#destroyById
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Delete a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.orders.destroyById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::destroyById::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#findById
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Find a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.findById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::findById::Subscription::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.orders#updateById
             * @methodOf lbServices.Subscription.orders
             *
             * @description
             *
             * Update a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.updateById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::updateById::Subscription::orders"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Subscription.payments
     * @header lbServices.Subscription.payments
     * @object
     * @description
     *
     * The object `Subscription.payments` groups methods
     * manipulating `Payment` instances related to `Subscription`.
     *
     * Call {@link lbServices.Subscription#payments Subscription.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Subscription#payments
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries payments of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#count
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Counts payments of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#create
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#createMany
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#destroyAll
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#destroyById
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#findById
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::Subscription::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.payments#updateById
             * @methodOf lbServices.Subscription.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::Subscription::payments"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Subscription.documents
     * @header lbServices.Subscription.documents
     * @object
     * @description
     *
     * The object `Subscription.documents` groups methods
     * manipulating `SubscriptionDocument` instances related to `Subscription`.
     *
     * Call {@link lbServices.Subscription#documents Subscription.documents()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Subscription#documents
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries documents of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.documents = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::get::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#count
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Counts documents of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.documents.count = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::count::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#create
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.documents.create = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::create::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#createMany
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.documents.createMany = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::createMany::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#destroyAll
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Deletes all documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.documents.destroyAll = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::delete::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#destroyById
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Delete a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.documents.destroyById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::destroyById::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#findById
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Find a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.documents.findById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::findById::Subscription::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.documents#updateById
             * @methodOf lbServices.Subscription.documents
             *
             * @description
             *
             * Update a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.documents.updateById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::updateById::Subscription::documents"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Subscription.attendances
     * @header lbServices.Subscription.attendances
     * @object
     * @description
     *
     * The object `Subscription.attendances` groups methods
     * manipulating `Attendance` instances related to `Subscription`.
     *
     * Call {@link lbServices.Subscription#attendances Subscription.attendances()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Subscription#attendances
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Queries attendances of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::get::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#count
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Counts attendances of Subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.attendances.count = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::count::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#create
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Creates a new instance in attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.create = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::create::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#createMany
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Creates a new instance in attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.createMany = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::createMany::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#destroyAll
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Deletes all attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.attendances.destroyAll = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::delete::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#destroyById
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Delete a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.attendances.destroyById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::destroyById::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#findById
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Find a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.findById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::findById::Subscription::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Subscription.attendances#updateById
             * @methodOf lbServices.Subscription.attendances
             *
             * @description
             *
             * Update a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.updateById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::updateById::Subscription::attendances"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SubscriptionPage
 * @header lbServices.SubscriptionPage
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SubscriptionPage` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SubscriptionPage",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscriptionPages/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use SubscriptionPage.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/subscriptionPages/:id/offeredService",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#create
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscriptionPages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#patchOrCreate
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/subscriptionPages",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#replaceOrCreate
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subscriptionPages/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#upsertWithWhere
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subscriptionPages/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#exists
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subscriptionPages/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#findById
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscriptionPages/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#replaceById
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subscriptionPages/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#find
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscriptionPages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#findOne
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subscriptionPages/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#updateAll
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subscriptionPages/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#deleteById
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subscriptionPages/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#count
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscriptionPages/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#prototype$patchAttributes
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionPage id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscriptionPages/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#createChangeStream
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subscriptionPages/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#createMany
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscriptionPages",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.findById() instead.
            "::findById::OfferedService::subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.destroyById() instead.
            "::destroyById::OfferedService::subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.updateById() instead.
            "::updateById::OfferedService::subscriptionPages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/subscriptionPages/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.subscriptionPages() instead.
            "::get::OfferedService::subscriptionPages": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.create() instead.
            "::create::OfferedService::subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.createMany() instead.
            "::createMany::OfferedService::subscriptionPages": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.destroyAll() instead.
            "::delete::OfferedService::subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.subscriptionPages.count() instead.
            "::count::OfferedService::subscriptionPages": {
              url: urlBase + "/offeredServices/:id/subscriptionPages/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#upsert
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#updateOrCreate
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#patchOrCreateWithWhere
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#update
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#destroyById
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#removeById
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#prototype$updateAttributes
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionPage id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionPage` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SubscriptionPage#modelName
        * @propertyOf lbServices.SubscriptionPage
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SubscriptionPage`.
        */
        R.modelName = "SubscriptionPage";


            /**
             * @ngdoc method
             * @name lbServices.SubscriptionPage#offeredService
             * @methodOf lbServices.SubscriptionPage
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionPage id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::SubscriptionPage::offeredService"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Order
 * @header lbServices.Order
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Order` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Order",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/orders/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Order.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/orders/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Order.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/orders/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Order.previousOrder() instead.
            "prototype$__get__previousOrder": {
              url: urlBase + "/orders/:id/previousOrder",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__findById__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__findById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/orderDetails/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__destroyById__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/orderDetails/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__updateById__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update a related item by id for orderDetails.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `fk` – `{*}` - Foreign key for orderDetails
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__updateById__orderDetails": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/orderDetails/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Order.attendances.findById() instead.
            "prototype$__findById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances.destroyById() instead.
            "prototype$__destroyById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Order.attendances.updateById() instead.
            "prototype$__updateById__attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__get__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Queries orderDetails of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__get__orderDetails": {
              isArray: true,
              url: urlBase + "/orders/:id/orderDetails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__create__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Creates a new instance in orderDetails of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__create__orderDetails": {
              url: urlBase + "/orders/:id/orderDetails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__delete__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Deletes all orderDetails of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__orderDetails": {
              url: urlBase + "/orders/:id/orderDetails",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__count__orderDetails
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Counts orderDetails of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__orderDetails": {
              url: urlBase + "/orders/:id/orderDetails/count",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances() instead.
            "prototype$__get__attendances": {
              isArray: true,
              url: urlBase + "/orders/:id/attendances",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances.create() instead.
            "prototype$__create__attendances": {
              url: urlBase + "/orders/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Order.attendances.destroyAll() instead.
            "prototype$__delete__attendances": {
              url: urlBase + "/orders/:id/attendances",
              method: "DELETE",
            },

            // INTERNAL. Use Order.attendances.count() instead.
            "prototype$__count__attendances": {
              url: urlBase + "/orders/:id/attendances/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#create
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/orders",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#patchOrCreate
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/orders",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#replaceOrCreate
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/orders/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#upsertWithWhere
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/orders/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#exists
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/orders/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#findById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/orders/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#replaceById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/orders/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#find
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/orders",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#findOne
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/orders/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#updateAll
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/orders/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#deleteById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/orders/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#count
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/orders/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$patchAttributes
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/orders/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#createChangeStream
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/orders/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#createMany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/orders",
              method: "POST",
            },

            // INTERNAL. Use Subscription.orders.findById() instead.
            "::findById::Subscription::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.orders.destroyById() instead.
            "::destroyById::Subscription::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.orders.updateById() instead.
            "::updateById::Subscription::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/orders/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.orders() instead.
            "::get::Subscription::orders": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/orders",
              method: "GET",
            },

            // INTERNAL. Use Subscription.orders.create() instead.
            "::create::Subscription::orders": {
              url: urlBase + "/subscriptions/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use Subscription.orders.createMany() instead.
            "::createMany::Subscription::orders": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use Subscription.orders.destroyAll() instead.
            "::delete::Subscription::orders": {
              url: urlBase + "/subscriptions/:id/orders",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.orders.count() instead.
            "::count::Subscription::orders": {
              url: urlBase + "/subscriptions/:id/orders/count",
              method: "GET",
            },

            // INTERNAL. Use Order.previousOrder() instead.
            "::get::Order::previousOrder": {
              url: urlBase + "/orders/:id/previousOrder",
              method: "GET",
            },

            // INTERNAL. Use Attendance.order() instead.
            "::get::Attendance::order": {
              url: urlBase + "/attendances/:id/order",
              method: "GET",
            },

            // INTERNAL. Use Oplog.order() instead.
            "::get::Oplog::order": {
              url: urlBase + "/oplog/:id/order",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Order#upsert
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Order#updateOrCreate
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Order#patchOrCreateWithWhere
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Order#update
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Order#destroyById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Order#removeById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$updateAttributes
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Order#modelName
        * @propertyOf lbServices.Order
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Order`.
        */
        R.modelName = "Order";


            /**
             * @ngdoc method
             * @name lbServices.Order#offeredService
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Order::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#subscription
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::Order::subscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#previousOrder
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation previousOrder.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.previousOrder = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::Order::previousOrder"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Order.attendances
     * @header lbServices.Order.attendances
     * @object
     * @description
     *
     * The object `Order.attendances` groups methods
     * manipulating `Attendance` instances related to `Order`.
     *
     * Call {@link lbServices.Order#attendances Order.attendances()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Order#attendances
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Queries attendances of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::get::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#count
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Counts attendances of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.attendances.count = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::count::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#create
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Creates a new instance in attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.create = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::create::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#createMany
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Creates a new instance in attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.createMany = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::createMany::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#destroyAll
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Deletes all attendances of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.attendances.destroyAll = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::delete::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#destroyById
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Delete a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.attendances.destroyById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::destroyById::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#findById
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Find a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.findById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::findById::Order::attendances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.attendances#updateById
             * @methodOf lbServices.Order.attendances
             *
             * @description
             *
             * Update a related item by id for attendances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `fk` – `{*}` - Foreign key for attendances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R.attendances.updateById = function() {
          var TargetResource = $injector.get("Attendance");
          var action = TargetResource["::updateById::Order::attendances"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Invitation
 * @header lbServices.Invitation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Invitation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Invitation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/invitations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Invitation.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/invitations/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Invitation.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/invitations/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Invitation.senderUser() instead.
            "prototype$__get__senderUser": {
              url: urlBase + "/invitations/:id/senderUser",
              method: "GET",
            },

            // INTERNAL. Use Invitation.senderOrganization() instead.
            "prototype$__get__senderOrganization": {
              url: urlBase + "/invitations/:id/senderOrganization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#create
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/invitations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#patchOrCreate
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/invitations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#replaceOrCreate
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/invitations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#upsertWithWhere
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/invitations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#exists
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/invitations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#findById
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/invitations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#replaceById
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/invitations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#find
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/invitations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#findOne
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/invitations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#updateAll
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/invitations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#deleteById
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/invitations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#count
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/invitations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#prototype$patchAttributes
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/invitations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#createChangeStream
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/invitations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invitation#createMany
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/invitations",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Invitation#upsert
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#updateOrCreate
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#patchOrCreateWithWhere
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#update
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#destroyById
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#removeById
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invitation#prototype$updateAttributes
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invitation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Invitation#modelName
        * @propertyOf lbServices.Invitation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Invitation`.
        */
        R.modelName = "Invitation";


            /**
             * @ngdoc method
             * @name lbServices.Invitation#offeredService
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Invitation::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invitation#user
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invitation::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invitation#senderUser
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Fetches belongsTo relation senderUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.senderUser = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invitation::senderUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invitation#senderOrganization
             * @methodOf lbServices.Invitation
             *
             * @description
             *
             * Fetches belongsTo relation senderOrganization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invitation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.senderOrganization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Invitation::senderOrganization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OfferedServiceRelation
 * @header lbServices.OfferedServiceRelation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OfferedServiceRelation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OfferedServiceRelation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OfferedServiceRelations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OfferedServiceRelation.child() instead.
            "prototype$__get__child": {
              url: urlBase + "/OfferedServiceRelations/:id/child",
              method: "GET",
            },

            // INTERNAL. Use OfferedServiceRelation.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/OfferedServiceRelations/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#create
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OfferedServiceRelations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#patchOrCreate
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OfferedServiceRelations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#replaceOrCreate
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OfferedServiceRelations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#upsertWithWhere
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OfferedServiceRelations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#exists
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OfferedServiceRelations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#findById
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OfferedServiceRelations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#replaceById
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OfferedServiceRelations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#find
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OfferedServiceRelations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#findOne
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OfferedServiceRelations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#updateAll
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OfferedServiceRelations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#deleteById
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OfferedServiceRelations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#count
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OfferedServiceRelations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#prototype$patchAttributes
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OfferedServiceRelations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#createChangeStream
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OfferedServiceRelations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#createMany
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OfferedServiceRelations",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#upsert
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#updateOrCreate
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#patchOrCreateWithWhere
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#update
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#destroyById
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#removeById
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#prototype$updateAttributes
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceRelation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OfferedServiceRelation#modelName
        * @propertyOf lbServices.OfferedServiceRelation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OfferedServiceRelation`.
        */
        R.modelName = "OfferedServiceRelation";


            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#child
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Fetches belongsTo relation child.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.child = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::OfferedServiceRelation::child"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceRelation#parent
             * @methodOf lbServices.OfferedServiceRelation
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::OfferedServiceRelation::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserDocumentsContainer
 * @header lbServices.UserDocumentsContainer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserDocumentsContainer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserDocumentsContainer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userDocumentsContainers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#getContainers
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/userDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#createContainer
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/userDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#destroyContainer
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/userDocumentsContainers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#getContainer
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/userDocumentsContainers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#getFiles
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/userDocumentsContainers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#getFile
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/userDocumentsContainers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#removeFile
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/userDocumentsContainers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#upload
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/userDocumentsContainers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#download
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/userDocumentsContainers/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#create
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#patchOrCreate
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userDocumentsContainers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#replaceOrCreate
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userDocumentsContainers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#upsertWithWhere
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userDocumentsContainers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#exists
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userDocumentsContainers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#findById
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userDocumentsContainers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#replaceById
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userDocumentsContainers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#find
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#findOne
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userDocumentsContainers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#updateAll
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userDocumentsContainers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#deleteById
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userDocumentsContainers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#count
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userDocumentsContainers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#prototype$patchAttributes
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userDocumentsContainers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#createChangeStream
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userDocumentsContainers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#createMany
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userDocumentsContainers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#upsert
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#updateOrCreate
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#patchOrCreateWithWhere
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#update
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#destroyById
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#removeById
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocumentsContainer#prototype$updateAttributes
             * @methodOf lbServices.UserDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocumentsContainer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserDocumentsContainer#modelName
        * @propertyOf lbServices.UserDocumentsContainer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserDocumentsContainer`.
        */
        R.modelName = "UserDocumentsContainer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SubscriptionDocumentsContainer
 * @header lbServices.SubscriptionDocumentsContainer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SubscriptionDocumentsContainer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SubscriptionDocumentsContainer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscriptionDocumentsContainers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#getContainers
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#createContainer
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#destroyContainer
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/subscriptionDocumentsContainers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#getContainer
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/subscriptionDocumentsContainers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#getFiles
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/subscriptionDocumentsContainers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#getFile
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/subscriptionDocumentsContainers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#removeFile
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/subscriptionDocumentsContainers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#upload
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/subscriptionDocumentsContainers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#download
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/subscriptionDocumentsContainers/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#create
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#patchOrCreate
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#replaceOrCreate
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subscriptionDocumentsContainers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#upsertWithWhere
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subscriptionDocumentsContainers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#exists
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subscriptionDocumentsContainers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#findById
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscriptionDocumentsContainers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#replaceById
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subscriptionDocumentsContainers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#find
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#findOne
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subscriptionDocumentsContainers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#updateAll
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subscriptionDocumentsContainers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#deleteById
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subscriptionDocumentsContainers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#count
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscriptionDocumentsContainers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#prototype$patchAttributes
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscriptionDocumentsContainers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#createChangeStream
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subscriptionDocumentsContainers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#createMany
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscriptionDocumentsContainers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#upsert
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#updateOrCreate
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#patchOrCreateWithWhere
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#update
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#destroyById
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#removeById
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocumentsContainer#prototype$updateAttributes
             * @methodOf lbServices.SubscriptionDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocumentsContainer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SubscriptionDocumentsContainer#modelName
        * @propertyOf lbServices.SubscriptionDocumentsContainer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SubscriptionDocumentsContainer`.
        */
        R.modelName = "SubscriptionDocumentsContainer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationDocumentsContainer
 * @header lbServices.OrganizationDocumentsContainer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationDocumentsContainer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationDocumentsContainer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationDocumentsContainers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#getContainers
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/organizationDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#createContainer
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/organizationDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#destroyContainer
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/organizationDocumentsContainers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#getContainer
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/organizationDocumentsContainers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#getFiles
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/organizationDocumentsContainers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#getFile
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/organizationDocumentsContainers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#removeFile
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/organizationDocumentsContainers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#upload
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/organizationDocumentsContainers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#download
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/organizationDocumentsContainers/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#create
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#patchOrCreate
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationDocumentsContainers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#replaceOrCreate
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationDocumentsContainers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#upsertWithWhere
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationDocumentsContainers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#exists
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationDocumentsContainers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#findById
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationDocumentsContainers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#replaceById
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationDocumentsContainers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#find
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#findOne
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationDocumentsContainers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#updateAll
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationDocumentsContainers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#deleteById
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationDocumentsContainers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#count
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationDocumentsContainers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#prototype$patchAttributes
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationDocumentsContainers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#createChangeStream
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationDocumentsContainers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#createMany
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationDocumentsContainers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#upsert
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#updateOrCreate
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#update
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#destroyById
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#removeById
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDocumentsContainer#prototype$updateAttributes
             * @methodOf lbServices.OrganizationDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDocumentsContainer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationDocumentsContainer#modelName
        * @propertyOf lbServices.OrganizationDocumentsContainer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationDocumentsContainer`.
        */
        R.modelName = "OrganizationDocumentsContainer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationPrivateDocumentsContainer
 * @header lbServices.OrganizationPrivateDocumentsContainer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationPrivateDocumentsContainer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationPrivateDocumentsContainer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationPrivateDocumentsContainers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#getContainers
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#createContainer
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#destroyContainer
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#getContainer
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#getFiles
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/organizationPrivateDocumentsContainers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#getFile
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#removeFile
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#upload
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#download
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#create
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#patchOrCreate
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#replaceOrCreate
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationPrivateDocumentsContainers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#upsertWithWhere
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationPrivateDocumentsContainers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#exists
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#findById
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#replaceById
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#find
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#findOne
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationPrivateDocumentsContainers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#updateAll
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationPrivateDocumentsContainers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#deleteById
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#count
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationPrivateDocumentsContainers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#prototype$patchAttributes
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationPrivateDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationPrivateDocumentsContainers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#createChangeStream
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationPrivateDocumentsContainers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#createMany
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationPrivateDocumentsContainers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#upsert
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#updateOrCreate
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#update
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#destroyById
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#removeById
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPrivateDocumentsContainer#prototype$updateAttributes
             * @methodOf lbServices.OrganizationPrivateDocumentsContainer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationPrivateDocumentsContainer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPrivateDocumentsContainer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationPrivateDocumentsContainer#modelName
        * @propertyOf lbServices.OrganizationPrivateDocumentsContainer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationPrivateDocumentsContainer`.
        */
        R.modelName = "OrganizationPrivateDocumentsContainer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Mailer
 * @header lbServices.Mailer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Mailer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Mailer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Mailers/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Mailer#modelName
        * @propertyOf lbServices.Mailer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Mailer`.
        */
        R.modelName = "Mailer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserRelation
 * @header lbServices.UserRelation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserRelation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserRelation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userRelations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserRelation.child() instead.
            "prototype$__get__child": {
              url: urlBase + "/userRelations/:id/child",
              method: "GET",
            },

            // INTERNAL. Use UserRelation.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/userRelations/:id/parent",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#create
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userRelations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#patchOrCreate
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userRelations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#replaceOrCreate
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userRelations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#upsertWithWhere
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userRelations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#exists
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userRelations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#findById
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userRelations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#replaceById
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userRelations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#find
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userRelations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#findOne
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userRelations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#updateAll
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userRelations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#deleteById
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userRelations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#count
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userRelations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#prototype$patchAttributes
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userRelations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#createChangeStream
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userRelations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#createMany
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userRelations",
              method: "POST",
            },

            // INTERNAL. Use User.childRelations.findById() instead.
            "::findById::User::childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.childRelations.destroyById() instead.
            "::destroyById::User::childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.childRelations.updateById() instead.
            "::updateById::User::childRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/childRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.parentRelations.findById() instead.
            "::findById::User::parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations.destroyById() instead.
            "::destroyById::User::parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.parentRelations.updateById() instead.
            "::updateById::User::parentRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/parentRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.childRelations() instead.
            "::get::User::childRelations": {
              isArray: true,
              url: urlBase + "/users/:id/childRelations",
              method: "GET",
            },

            // INTERNAL. Use User.childRelations.create() instead.
            "::create::User::childRelations": {
              url: urlBase + "/users/:id/childRelations",
              method: "POST",
            },

            // INTERNAL. Use User.childRelations.createMany() instead.
            "::createMany::User::childRelations": {
              isArray: true,
              url: urlBase + "/users/:id/childRelations",
              method: "POST",
            },

            // INTERNAL. Use User.childRelations.destroyAll() instead.
            "::delete::User::childRelations": {
              url: urlBase + "/users/:id/childRelations",
              method: "DELETE",
            },

            // INTERNAL. Use User.childRelations.count() instead.
            "::count::User::childRelations": {
              url: urlBase + "/users/:id/childRelations/count",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations() instead.
            "::get::User::parentRelations": {
              isArray: true,
              url: urlBase + "/users/:id/parentRelations",
              method: "GET",
            },

            // INTERNAL. Use User.parentRelations.create() instead.
            "::create::User::parentRelations": {
              url: urlBase + "/users/:id/parentRelations",
              method: "POST",
            },

            // INTERNAL. Use User.parentRelations.createMany() instead.
            "::createMany::User::parentRelations": {
              isArray: true,
              url: urlBase + "/users/:id/parentRelations",
              method: "POST",
            },

            // INTERNAL. Use User.parentRelations.destroyAll() instead.
            "::delete::User::parentRelations": {
              url: urlBase + "/users/:id/parentRelations",
              method: "DELETE",
            },

            // INTERNAL. Use User.parentRelations.count() instead.
            "::count::User::parentRelations": {
              url: urlBase + "/users/:id/parentRelations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserRelation#upsert
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#updateOrCreate
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#patchOrCreateWithWhere
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#update
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#destroyById
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#removeById
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#prototype$updateAttributes
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRelation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserRelation#modelName
        * @propertyOf lbServices.UserRelation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserRelation`.
        */
        R.modelName = "UserRelation";


            /**
             * @ngdoc method
             * @name lbServices.UserRelation#child
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Fetches belongsTo relation child.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.child = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserRelation::child"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserRelation#parent
             * @methodOf lbServices.UserRelation
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserRelation::parent"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserContact
 * @header lbServices.UserContact
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserContact` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserContact",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userContacts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserContact.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userContacts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserContact.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/userContacts/:id/organization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#create
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userContacts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#patchOrCreate
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userContacts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#replaceOrCreate
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userContacts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#upsertWithWhere
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userContacts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#exists
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userContacts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#findById
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userContacts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#replaceById
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userContacts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#find
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userContacts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#findOne
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userContacts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#updateAll
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userContacts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#deleteById
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userContacts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#count
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userContacts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#prototype$patchAttributes
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserContact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userContacts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#createChangeStream
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userContacts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserContact#createMany
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userContacts",
              method: "POST",
            },

            // INTERNAL. Use User.contacts.findById() instead.
            "::findById::User::contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.contacts.destroyById() instead.
            "::destroyById::User::contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.contacts.updateById() instead.
            "::updateById::User::contacts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/contacts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.contacts() instead.
            "::get::User::contacts": {
              isArray: true,
              url: urlBase + "/users/:id/contacts",
              method: "GET",
            },

            // INTERNAL. Use User.contacts.create() instead.
            "::create::User::contacts": {
              url: urlBase + "/users/:id/contacts",
              method: "POST",
            },

            // INTERNAL. Use User.contacts.createMany() instead.
            "::createMany::User::contacts": {
              isArray: true,
              url: urlBase + "/users/:id/contacts",
              method: "POST",
            },

            // INTERNAL. Use User.contacts.destroyAll() instead.
            "::delete::User::contacts": {
              url: urlBase + "/users/:id/contacts",
              method: "DELETE",
            },

            // INTERNAL. Use User.contacts.count() instead.
            "::count::User::contacts": {
              url: urlBase + "/users/:id/contacts/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserContact#upsert
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#updateOrCreate
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#patchOrCreateWithWhere
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#update
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#destroyById
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#removeById
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserContact#prototype$updateAttributes
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserContact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserContact` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserContact#modelName
        * @propertyOf lbServices.UserContact
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserContact`.
        */
        R.modelName = "UserContact";


            /**
             * @ngdoc method
             * @name lbServices.UserContact#user
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserContact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserContact::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserContact#organization
             * @methodOf lbServices.UserContact
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserContact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::UserContact::organization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserPreference
 * @header lbServices.UserPreference
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserPreference` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserPreference",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userPreferences/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserPreference.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userPreferences/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#create
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userPreferences",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#patchOrCreate
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userPreferences",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#replaceOrCreate
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userPreferences/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#upsertWithWhere
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userPreferences/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#exists
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userPreferences/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#findById
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userPreferences/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#replaceById
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userPreferences/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#find
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userPreferences",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#findOne
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userPreferences/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#updateAll
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userPreferences/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#deleteById
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userPreferences/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#count
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userPreferences/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#prototype$patchAttributes
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userPreferences/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#createChangeStream
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userPreferences/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#createMany
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userPreferences",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserPreference#upsert
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#updateOrCreate
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#patchOrCreateWithWhere
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#update
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#destroyById
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#removeById
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#prototype$updateAttributes
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserPreference#modelName
        * @propertyOf lbServices.UserPreference
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserPreference`.
        */
        R.modelName = "UserPreference";


            /**
             * @ngdoc method
             * @name lbServices.UserPreference#user
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserPreference::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationType
 * @header lbServices.OrganizationType
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationType` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationType",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationTypes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#create
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#patchOrCreate
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationTypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#replaceOrCreate
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationTypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#upsertWithWhere
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationTypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#exists
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationTypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#findById
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationTypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#replaceById
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationTypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#find
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#findOne
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationTypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#updateAll
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationTypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#deleteById
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationTypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#count
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#prototype$patchAttributes
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationTypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#createChangeStream
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationTypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#createMany
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationTypes",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#upsert
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#updateOrCreate
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#update
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#destroyById
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#removeById
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationType#prototype$updateAttributes
             * @methodOf lbServices.OrganizationType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationType` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationType#modelName
        * @propertyOf lbServices.OrganizationType
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationType`.
        */
        R.modelName = "OrganizationType";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/categories/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/categories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/categories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/categories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsertWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/categories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#exists
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/categories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/categories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/categories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/categories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findOne
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/categories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#updateAll
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/categories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#deleteById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/categories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/categories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createChangeStream
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/categories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/categories",
              method: "POST",
            },

            // INTERNAL. Use Organization.categories.findById() instead.
            "::findById::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.categories.destroyById() instead.
            "::destroyById::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.updateById() instead.
            "::updateById::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.categories.link() instead.
            "::link::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.categories.unlink() instead.
            "::unlink::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.exists() instead.
            "::exists::Organization::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.categories() instead.
            "::get::Organization::categories": {
              isArray: true,
              url: urlBase + "/organizations/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Organization.categories.create() instead.
            "::create::Organization::categories": {
              url: urlBase + "/organizations/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Organization.categories.createMany() instead.
            "::createMany::Organization::categories": {
              isArray: true,
              url: urlBase + "/organizations/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Organization.categories.destroyAll() instead.
            "::delete::Organization::categories": {
              url: urlBase + "/organizations/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.categories.count() instead.
            "::count::Organization::categories": {
              url: urlBase + "/organizations/:id/categories/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes.findById() instead.
            "::findById::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes.destroyById() instead.
            "::destroyById::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.updateById() instead.
            "::updateById::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceTypes.link() instead.
            "::link::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceTypes.unlink() instead.
            "::unlink::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.exists() instead.
            "::exists::OfferedService::serviceTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceTypes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.categories.findById() instead.
            "::findById::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories.destroyById() instead.
            "::destroyById::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.updateById() instead.
            "::updateById::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.categories.link() instead.
            "::link::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.categories.unlink() instead.
            "::unlink::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.exists() instead.
            "::exists::OfferedService::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.serviceTypes() instead.
            "::get::OfferedService::serviceTypes": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceTypes.create() instead.
            "::create::OfferedService::serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceTypes.createMany() instead.
            "::createMany::OfferedService::serviceTypes": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceTypes.destroyAll() instead.
            "::delete::OfferedService::serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceTypes.count() instead.
            "::count::OfferedService::serviceTypes": {
              url: urlBase + "/offeredServices/:id/serviceTypes/count",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories() instead.
            "::get::OfferedService::categories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.categories.create() instead.
            "::create::OfferedService::categories": {
              url: urlBase + "/offeredServices/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.categories.createMany() instead.
            "::createMany::OfferedService::categories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.categories.destroyAll() instead.
            "::delete::OfferedService::categories": {
              url: urlBase + "/offeredServices/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.categories.count() instead.
            "::count::OfferedService::categories": {
              url: urlBase + "/offeredServices/:id/categories/count",
              method: "GET",
            },

            // INTERNAL. Use OrganizationCategory.category() instead.
            "::get::OrganizationCategory::category": {
              url: urlBase + "/organizationCategories/:id/category",
              method: "GET",
            },

            // INTERNAL. Use ServiceCategory.category() instead.
            "::get::ServiceCategory::category": {
              url: urlBase + "/serviceCategories/:id/category",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#upsert
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Category#updateOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreateWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Category#update
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#removeById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationCategory
 * @header lbServices.OrganizationCategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationCategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationCategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationCategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OrganizationCategory.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/organizationCategories/:id/category",
              method: "GET",
            },

            // INTERNAL. Use OrganizationCategory.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/organizationCategories/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#create
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#patchOrCreate
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationCategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#replaceOrCreate
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationCategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#upsertWithWhere
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationCategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#exists
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationCategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#findById
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationCategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#replaceById
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationCategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#find
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#findOne
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationCategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#updateAll
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationCategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#deleteById
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationCategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#count
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#prototype$patchAttributes
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationCategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#createChangeStream
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationCategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#createMany
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationCategories",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#upsert
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#updateOrCreate
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#update
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#destroyById
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#removeById
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#prototype$updateAttributes
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationCategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationCategory#modelName
        * @propertyOf lbServices.OrganizationCategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationCategory`.
        */
        R.modelName = "OrganizationCategory";


            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#category
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::OrganizationCategory::category"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrganizationCategory#user
             * @methodOf lbServices.OrganizationCategory
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::OrganizationCategory::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Payment
 * @header lbServices.Payment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Payment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Payment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/payments/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$__get__orderDetail
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation orderDetail.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$__get__orderDetail": {
              url: urlBase + "/payments/:id/orderDetail",
              method: "GET",
            },

            // INTERNAL. Use Payment.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/payments/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Payment.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/payments/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Payment.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/payments/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Payment.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/payments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Payment.earningCost() instead.
            "prototype$__get__earningCost": {
              url: urlBase + "/payments/:id/earningCost",
              method: "GET",
            },

            // INTERNAL. Use Payment.paymentReason() instead.
            "prototype$__get__paymentReason": {
              url: urlBase + "/payments/:id/paymentReason",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$__get__invoice
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$__get__invoice": {
              url: urlBase + "/payments/:id/invoice",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#create
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/payments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/payments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/payments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#upsertWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/payments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#exists
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/payments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/payments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/payments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#find
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/payments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findOne
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/payments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#updateAll
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/payments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#deleteById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/payments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#count
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/payments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$patchAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/payments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createChangeStream
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/payments/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#checkAndCreatePayments
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id subscription
             *
             *  - `isRenewal` – `{boolean}` - è un rinnovo o una prima creazione?
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "checkAndCreatePayments": {
              url: urlBase + "/payments/check-create-subscription-payments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#pay
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id subscription
             *
             *  - `amount` – `{number}` - importo pagato
             *
             *  - `description` – `{string=}` - note
             *
             *  - `paymentReasonId` – `{string=}` - eventuale id del motivo di pagamento
             *
             *  - `flgGenerateReceipt` – `{boolean=}` - imposta se generare o no la ricevuta all'utente ammesso che sia configurata per l'associazione
             *
             *  - `flgSendReceipt` – `{boolean=}` - imposta se inviare o no la ricevuta all'utente ammesso che sia configurata per l'associazione e flgGenerateReceipt sia true
             *
             *  - `paymentDate` – `{date=}` - data di avvenuto pagamento
             *
             *  - `simulate` – `{boolean=}` - se true, ritorna solo le operazioni che effettuerebbe
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "pay": {
              url: urlBase + "/payments/pay",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#stripePay
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` - id subscription
             *
             *  - `stripeToken` – `{string}` -
             *
             *  - `stripeTokenType` – `{string}` -
             *
             *  - `stripeEmail` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "stripePay": {
              url: urlBase + "/payments/stripePay",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#getStripePaymentIntent
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Crea un paymentIntent su Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `intentData` – `{object}` - Dati del pagamento. Es. { amount: 2000, currency: 'eur' }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `paymentIntent` – `{object=}` - Oggetto paymentIntent
             */
            "getStripePaymentIntent": {
              url: urlBase + "/payments/get-stripe-paymentintent",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#getUserPayments
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Ritorna i pagamenti per un utente
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{number}` - Utente del quale estrarre i pagamenti
             *
             *  - `options` – `{object=}` - { dtFrom: date, dtTo: date, limit: number, skip: number }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `payments` – `{*=}` - Elenco di pagamenti relativi ad un utente
             */
            "getUserPayments": {
              url: urlBase + "/payments/userpayments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createPaymentWithoutSubscription
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Crea un Payment e imposta il relativo EarningCost, senz associarlo ad un servizio. Serve quando viene creato un movimento direttamente dalla cassa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `earningCost` – `{object}` - earningCost da creare, a cui associare il nuovo pagamento
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `payment` – `{object=}` - Pagamento appena creato
             */
            "createPaymentWithoutSubscription": {
              url: urlBase + "/payments/createPaymentWithoutSubscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#fetchUserPagedPayments
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Ritorna i pagamenti per organizzazione e/o utente, ritornando un oggetto usabile con datatables
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{number=}` - Organizzazione della quale estrarre i pagamenti
             *
             *  - `userId` – `{number=}` - Utente del quale estrarre i pagamenti
             *
             *  - `options` – `{object=}` - { dtFrom: date, dtTo: date, limit: number, skip: number, order: boh }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `paymentsData` – `{object=}` - Oggetto risposta: {itemsCount: number, items: object[]}
             */
            "fetchUserPagedPayments": {
              url: urlBase + "/payments/userPagedPayments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createMany
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/payments",
              method: "POST",
            },

            // INTERNAL. Use Subscription.payments.findById() instead.
            "::findById::Subscription::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.payments.destroyById() instead.
            "::destroyById::Subscription::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.payments.updateById() instead.
            "::updateById::Subscription::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.payments() instead.
            "::get::Subscription::payments": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Subscription.payments.create() instead.
            "::create::Subscription::payments": {
              url: urlBase + "/subscriptions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Subscription.payments.createMany() instead.
            "::createMany::Subscription::payments": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Subscription.payments.destroyAll() instead.
            "::delete::Subscription::payments": {
              url: urlBase + "/subscriptions/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.payments.count() instead.
            "::count::Subscription::payments": {
              url: urlBase + "/subscriptions/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.findById() instead.
            "::findById::EarningCost::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.destroyById() instead.
            "::destroyById::EarningCost::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use EarningCost.payments.updateById() instead.
            "::updateById::EarningCost::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use EarningCost.payments() instead.
            "::get::EarningCost::payments": {
              isArray: true,
              url: urlBase + "/earningCosts/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.create() instead.
            "::create::EarningCost::payments": {
              url: urlBase + "/earningCosts/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use EarningCost.payments.createMany() instead.
            "::createMany::EarningCost::payments": {
              isArray: true,
              url: urlBase + "/earningCosts/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use EarningCost.payments.destroyAll() instead.
            "::delete::EarningCost::payments": {
              url: urlBase + "/earningCosts/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use EarningCost.payments.count() instead.
            "::count::EarningCost::payments": {
              url: urlBase + "/earningCosts/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Oplog.payment() instead.
            "::get::Oplog::payment": {
              url: urlBase + "/oplog/:id/payment",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Payment#upsert
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#updateOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreateWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#update
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#destroyById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#removeById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$updateAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Payment#modelName
        * @propertyOf lbServices.Payment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Payment`.
        */
        R.modelName = "Payment";


            /**
             * @ngdoc method
             * @name lbServices.Payment#subscription
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::Payment::subscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#offeredService
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Payment::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#organization
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Payment::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#user
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Payment::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#earningCost
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation earningCost.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R.earningCost = function() {
          var TargetResource = $injector.get("EarningCost");
          var action = TargetResource["::get::Payment::earningCost"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#paymentReason
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation paymentReason.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R.paymentReason = function() {
          var TargetResource = $injector.get("PaymentReason");
          var action = TargetResource["::get::Payment::paymentReason"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EarningCost
 * @header lbServices.EarningCost
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EarningCost` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EarningCost",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/earningCosts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EarningCost.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/earningCosts/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/earningCosts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/earningCosts/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use EarningCost.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/earningCosts/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use EarningCost.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/earningCosts/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.entryOrganization() instead.
            "prototype$__get__entryOrganization": {
              url: urlBase + "/earningCosts/:id/entryOrganization",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.serviceResource() instead.
            "prototype$__get__serviceResource": {
              url: urlBase + "/earningCosts/:id/serviceResource",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.serviceSchedule() instead.
            "prototype$__get__serviceSchedule": {
              url: urlBase + "/earningCosts/:id/serviceSchedule",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.resource() instead.
            "prototype$__get__resource": {
              url: urlBase + "/earningCosts/:id/resource",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.paymentReason() instead.
            "prototype$__get__paymentReason": {
              url: urlBase + "/earningCosts/:id/paymentReason",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#prototype$__get__invoice
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "prototype$__get__invoice": {
              url: urlBase + "/earningCosts/:id/invoice",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/earningCosts/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/earningCosts/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use EarningCost.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/earningCosts/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use EarningCost.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/earningCosts/:id/payments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#create
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/earningCosts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#patchOrCreate
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/earningCosts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#replaceOrCreate
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/earningCosts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#upsertWithWhere
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/earningCosts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#exists
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/earningCosts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#findById
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/earningCosts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#replaceById
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/earningCosts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#find
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/earningCosts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#findOne
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/earningCosts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#updateAll
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/earningCosts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#deleteById
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/earningCosts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#count
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/earningCosts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#prototype$patchAttributes
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/earningCosts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#createChangeStream
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/earningCosts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#generateInvoice
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` - id earning cost
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "generateInvoice": {
              url: urlBase + "/earningCosts/generateInvoice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#updateFromPayments
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` - id earning cost
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "updateFromPayments": {
              url: urlBase + "/earningCosts/updateFromPayments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#deleteEntry
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` - id earning cost
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "deleteEntry": {
              url: urlBase + "/earningCosts/deleteEntry",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#createMany
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/earningCosts",
              method: "POST",
            },

            // INTERNAL. Use Organization.earningCosts.findById() instead.
            "::findById::Organization::earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.earningCosts.destroyById() instead.
            "::destroyById::Organization::earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.earningCosts.updateById() instead.
            "::updateById::Organization::earningCosts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/organizations/:id/earningCosts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.earningCosts() instead.
            "::get::Organization::earningCosts": {
              isArray: true,
              url: urlBase + "/organizations/:id/earningCosts",
              method: "GET",
            },

            // INTERNAL. Use Organization.earningCosts.create() instead.
            "::create::Organization::earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts",
              method: "POST",
            },

            // INTERNAL. Use Organization.earningCosts.createMany() instead.
            "::createMany::Organization::earningCosts": {
              isArray: true,
              url: urlBase + "/organizations/:id/earningCosts",
              method: "POST",
            },

            // INTERNAL. Use Organization.earningCosts.destroyAll() instead.
            "::delete::Organization::earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.earningCosts.count() instead.
            "::count::Organization::earningCosts": {
              url: urlBase + "/organizations/:id/earningCosts/count",
              method: "GET",
            },

            // INTERNAL. Use Payment.earningCost() instead.
            "::get::Payment::earningCost": {
              url: urlBase + "/payments/:id/earningCost",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EarningCost#upsert
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#updateOrCreate
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#patchOrCreateWithWhere
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#update
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#destroyById
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#removeById
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#prototype$updateAttributes
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EarningCost` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EarningCost#modelName
        * @propertyOf lbServices.EarningCost
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EarningCost`.
        */
        R.modelName = "EarningCost";


            /**
             * @ngdoc method
             * @name lbServices.EarningCost#offeredService
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::EarningCost::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#user
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::EarningCost::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#subscription
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::EarningCost::subscription"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.EarningCost.payments
     * @header lbServices.EarningCost.payments
     * @object
     * @description
     *
     * The object `EarningCost.payments` groups methods
     * manipulating `Payment` instances related to `EarningCost`.
     *
     * Call {@link lbServices.EarningCost#payments EarningCost.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.EarningCost#payments
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Queries payments of EarningCost.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#count
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Counts payments of EarningCost.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#create
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#createMany
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#destroyAll
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#destroyById
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#findById
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost.payments#updateById
             * @methodOf lbServices.EarningCost.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::EarningCost::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#organization
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::EarningCost::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#entryOrganization
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation entryOrganization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.entryOrganization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::EarningCost::entryOrganization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#serviceResource
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation serviceResource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceResource` object.)
             * </em>
             */
        R.serviceResource = function() {
          var TargetResource = $injector.get("ServiceResource");
          var action = TargetResource["::get::EarningCost::serviceResource"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#serviceSchedule
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation serviceSchedule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceSchedule` object.)
             * </em>
             */
        R.serviceSchedule = function() {
          var TargetResource = $injector.get("ServiceSchedule");
          var action = TargetResource["::get::EarningCost::serviceSchedule"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#resource
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation resource.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationResource` object.)
             * </em>
             */
        R.resource = function() {
          var TargetResource = $injector.get("OrganizationResource");
          var action = TargetResource["::get::EarningCost::resource"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.EarningCost#paymentReason
             * @methodOf lbServices.EarningCost
             *
             * @description
             *
             * Fetches belongsTo relation paymentReason.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EarningCost id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R.paymentReason = function() {
          var TargetResource = $injector.get("PaymentReason");
          var action = TargetResource["::get::EarningCost::paymentReason"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationDoctype
 * @header lbServices.OrganizationDoctype
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationDoctype` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationDoctype",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationDoctypes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#create
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationDoctypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#patchOrCreate
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationDoctypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#replaceOrCreate
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationDoctypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#upsertWithWhere
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationDoctypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#exists
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationDoctypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#findById
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationDoctypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#replaceById
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationDoctypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#find
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationDoctypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#findOne
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationDoctypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#updateAll
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationDoctypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#deleteById
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationDoctypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#count
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationDoctypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#prototype$patchAttributes
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationDoctypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#createChangeStream
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationDoctypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#createMany
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationDoctypes",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.findById() instead.
            "::findById::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.destroyById() instead.
            "::destroyById::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.updateById() instead.
            "::updateById::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.link() instead.
            "::link::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.unlink() instead.
            "::unlink::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.exists() instead.
            "::exists::OfferedService::requiredDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/requiredDocuments/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OfferedService.requiredDocuments() instead.
            "::get::OfferedService::requiredDocuments": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.create() instead.
            "::create::OfferedService::requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.createMany() instead.
            "::createMany::OfferedService::requiredDocuments": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.destroyAll() instead.
            "::delete::OfferedService::requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.requiredDocuments.count() instead.
            "::count::OfferedService::requiredDocuments": {
              url: urlBase + "/offeredServices/:id/requiredDocuments/count",
              method: "GET",
            },

            // INTERNAL. Use ServiceDoctype.organizationDoctype() instead.
            "::get::ServiceDoctype::organizationDoctype": {
              url: urlBase + "/serviceDoctypes/:id/organizationDoctype",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionDocument.organizationDoctype() instead.
            "::get::SubscriptionDocument::organizationDoctype": {
              url: urlBase + "/subscriptionDocument/:id/organizationDoctype",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#upsert
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#updateOrCreate
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#update
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#destroyById
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#removeById
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationDoctype#prototype$updateAttributes
             * @methodOf lbServices.OrganizationDoctype
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationDoctype#modelName
        * @propertyOf lbServices.OrganizationDoctype
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationDoctype`.
        */
        R.modelName = "OrganizationDoctype";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ServiceDoctype
 * @header lbServices.ServiceDoctype
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ServiceDoctype` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ServiceDoctype",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/serviceDoctypes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ServiceDoctype.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/serviceDoctypes/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use ServiceDoctype.organizationDoctype() instead.
            "prototype$__get__organizationDoctype": {
              url: urlBase + "/serviceDoctypes/:id/organizationDoctype",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#create
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/serviceDoctypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#patchOrCreate
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/serviceDoctypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#replaceOrCreate
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/serviceDoctypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#upsertWithWhere
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/serviceDoctypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#exists
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/serviceDoctypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#findById
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/serviceDoctypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#replaceById
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/serviceDoctypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#find
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/serviceDoctypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#findOne
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/serviceDoctypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#updateAll
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/serviceDoctypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#deleteById
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/serviceDoctypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#count
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/serviceDoctypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#prototype$patchAttributes
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/serviceDoctypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#createChangeStream
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/serviceDoctypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#createMany
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/serviceDoctypes",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#upsert
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#updateOrCreate
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#patchOrCreateWithWhere
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#update
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#destroyById
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#removeById
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#prototype$updateAttributes
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceDoctype` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ServiceDoctype#modelName
        * @propertyOf lbServices.ServiceDoctype
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ServiceDoctype`.
        */
        R.modelName = "ServiceDoctype";


            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#offeredService
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::ServiceDoctype::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceDoctype#organizationDoctype
             * @methodOf lbServices.ServiceDoctype
             *
             * @description
             *
             * Fetches belongsTo relation organizationDoctype.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceDoctype id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.organizationDoctype = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::get::ServiceDoctype::organizationDoctype"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserDocument
 * @header lbServices.UserDocument
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserDocument` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserDocument",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userDocuments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserDocument.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userDocuments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.findById() instead.
            "prototype$__findById__subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.destroyById() instead.
            "prototype$__destroyById__subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.updateById() instead.
            "prototype$__updateById__subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments() instead.
            "prototype$__get__subscriptionDocuments": {
              isArray: true,
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.create() instead.
            "prototype$__create__subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "POST",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.destroyAll() instead.
            "prototype$__delete__subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "DELETE",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.count() instead.
            "prototype$__count__subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#create
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userDocuments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#patchOrCreate
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userDocuments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#replaceOrCreate
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userDocuments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#upsertWithWhere
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userDocuments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#exists
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userDocuments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#findById
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userDocuments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#replaceById
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userDocuments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#find
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userDocuments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#findOne
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userDocuments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#updateAll
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userDocuments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#deleteById
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userDocuments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#count
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userDocuments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#prototype$patchAttributes
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userDocuments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#createChangeStream
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userDocuments/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#createMany
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userDocuments",
              method: "POST",
            },

            // INTERNAL. Use User.documents.findById() instead.
            "::findById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.documents.destroyById() instead.
            "::destroyById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.updateById() instead.
            "::updateById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.documents() instead.
            "::get::User::documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use User.documents.create() instead.
            "::create::User::documents": {
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.documents.createMany() instead.
            "::createMany::User::documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.documents.destroyAll() instead.
            "::delete::User::documents": {
              url: urlBase + "/users/:id/documents",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.count() instead.
            "::count::User::documents": {
              url: urlBase + "/users/:id/documents/count",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionDocument.userDocument() instead.
            "::get::SubscriptionDocument::userDocument": {
              url: urlBase + "/subscriptionDocument/:id/userDocument",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserDocument#upsert
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#updateOrCreate
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#patchOrCreateWithWhere
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#update
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#destroyById
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#removeById
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserDocument#prototype$updateAttributes
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserDocument#modelName
        * @propertyOf lbServices.UserDocument
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserDocument`.
        */
        R.modelName = "UserDocument";


            /**
             * @ngdoc method
             * @name lbServices.UserDocument#user
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserDocument::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.UserDocument.subscriptionDocuments
     * @header lbServices.UserDocument.subscriptionDocuments
     * @object
     * @description
     *
     * The object `UserDocument.subscriptionDocuments` groups methods
     * manipulating `SubscriptionDocument` instances related to `UserDocument`.
     *
     * Call {@link lbServices.UserDocument#subscriptionDocuments UserDocument.subscriptionDocuments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.UserDocument#subscriptionDocuments
             * @methodOf lbServices.UserDocument
             *
             * @description
             *
             * Queries subscriptionDocuments of UserDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.subscriptionDocuments = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::get::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#count
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Counts subscriptionDocuments of UserDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subscriptionDocuments.count = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::count::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#create
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Creates a new instance in subscriptionDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.subscriptionDocuments.create = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::create::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#createMany
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Creates a new instance in subscriptionDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.subscriptionDocuments.createMany = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::createMany::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#destroyAll
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Deletes all subscriptionDocuments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptionDocuments.destroyAll = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::delete::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#destroyById
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Delete a related item by id for subscriptionDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subscriptionDocuments.destroyById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::destroyById::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#findById
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Find a related item by id for subscriptionDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDocuments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.subscriptionDocuments.findById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::findById::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserDocument.subscriptionDocuments#updateById
             * @methodOf lbServices.UserDocument.subscriptionDocuments
             *
             * @description
             *
             * Update a related item by id for subscriptionDocuments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserDocument id
             *
             *  - `fk` – `{*}` - Foreign key for subscriptionDocuments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R.subscriptionDocuments.updateById = function() {
          var TargetResource = $injector.get("SubscriptionDocument");
          var action = TargetResource["::updateById::UserDocument::subscriptionDocuments"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SubscriptionDocument
 * @header lbServices.SubscriptionDocument
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SubscriptionDocument` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SubscriptionDocument",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscriptionDocument/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use SubscriptionDocument.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/subscriptionDocument/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionDocument.organizationDoctype() instead.
            "prototype$__get__organizationDoctype": {
              url: urlBase + "/subscriptionDocument/:id/organizationDoctype",
              method: "GET",
            },

            // INTERNAL. Use SubscriptionDocument.userDocument() instead.
            "prototype$__get__userDocument": {
              url: urlBase + "/subscriptionDocument/:id/userDocument",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#create
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscriptionDocument",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#patchOrCreate
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/subscriptionDocument",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#replaceOrCreate
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subscriptionDocument/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#upsertWithWhere
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subscriptionDocument/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#exists
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subscriptionDocument/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#findById
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscriptionDocument/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#replaceById
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subscriptionDocument/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#find
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscriptionDocument",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#findOne
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subscriptionDocument/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#updateAll
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subscriptionDocument/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#deleteById
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subscriptionDocument/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#count
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscriptionDocument/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#prototype$patchAttributes
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscriptionDocument/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#createChangeStream
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subscriptionDocument/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#validateDocInAllSubscriptions
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionDocumentId` – `{string}` - id del documento
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * OK se tutto va bene
             */
            "validateDocInAllSubscriptions": {
              url: urlBase + "/subscriptionDocument/validateDocInAllSubscriptions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#testCheckExpiringDocuments
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `subscriptionDocumentId` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * array di SubscriptionDocument
             */
            "testCheckExpiringDocuments": {
              isArray: true,
              url: urlBase + "/subscriptionDocument/testCheckExpiringDocuments/:subscriptionDocumentId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#createMany
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscriptionDocument",
              method: "POST",
            },

            // INTERNAL. Use Subscription.documents.findById() instead.
            "::findById::Subscription::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.documents.destroyById() instead.
            "::destroyById::Subscription::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.documents.updateById() instead.
            "::updateById::Subscription::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.documents() instead.
            "::get::Subscription::documents": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use Subscription.documents.create() instead.
            "::create::Subscription::documents": {
              url: urlBase + "/subscriptions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use Subscription.documents.createMany() instead.
            "::createMany::Subscription::documents": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use Subscription.documents.destroyAll() instead.
            "::delete::Subscription::documents": {
              url: urlBase + "/subscriptions/:id/documents",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.documents.count() instead.
            "::count::Subscription::documents": {
              url: urlBase + "/subscriptions/:id/documents/count",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.findById() instead.
            "::findById::UserDocument::subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.destroyById() instead.
            "::destroyById::UserDocument::subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.updateById() instead.
            "::updateById::UserDocument::subscriptionDocuments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments() instead.
            "::get::UserDocument::subscriptionDocuments": {
              isArray: true,
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "GET",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.create() instead.
            "::create::UserDocument::subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "POST",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.createMany() instead.
            "::createMany::UserDocument::subscriptionDocuments": {
              isArray: true,
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "POST",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.destroyAll() instead.
            "::delete::UserDocument::subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments",
              method: "DELETE",
            },

            // INTERNAL. Use UserDocument.subscriptionDocuments.count() instead.
            "::count::UserDocument::subscriptionDocuments": {
              url: urlBase + "/userDocuments/:id/subscriptionDocuments/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#upsert
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#updateOrCreate
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#patchOrCreateWithWhere
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#update
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#destroyById
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#removeById
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#prototype$updateAttributes
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubscriptionDocument` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SubscriptionDocument#modelName
        * @propertyOf lbServices.SubscriptionDocument
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SubscriptionDocument`.
        */
        R.modelName = "SubscriptionDocument";


            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#subscription
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::SubscriptionDocument::subscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#organizationDoctype
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Fetches belongsTo relation organizationDoctype.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationDoctype` object.)
             * </em>
             */
        R.organizationDoctype = function() {
          var TargetResource = $injector.get("OrganizationDoctype");
          var action = TargetResource["::get::SubscriptionDocument::organizationDoctype"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SubscriptionDocument#userDocument
             * @methodOf lbServices.SubscriptionDocument
             *
             * @description
             *
             * Fetches belongsTo relation userDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubscriptionDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserDocument` object.)
             * </em>
             */
        R.userDocument = function() {
          var TargetResource = $injector.get("UserDocument");
          var action = TargetResource["::get::SubscriptionDocument::userDocument"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Notification
 * @header lbServices.Notification
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Notification` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Notification",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/notifications/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Notification.sender() instead.
            "prototype$__get__sender": {
              url: urlBase + "/notifications/:id/sender",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderOrganization() instead.
            "prototype$__get__senderOrganization": {
              url: urlBase + "/notifications/:id/senderOrganization",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderOfferedService() instead.
            "prototype$__get__senderOfferedService": {
              url: urlBase + "/notifications/:id/senderOfferedService",
              method: "GET",
            },

            // INTERNAL. Use Notification.senderSubscription() instead.
            "prototype$__get__senderSubscription": {
              url: urlBase + "/notifications/:id/senderSubscription",
              method: "GET",
            },

            // INTERNAL. Use Notification.recipient() instead.
            "prototype$__get__recipient": {
              url: urlBase + "/notifications/:id/recipient",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#create
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/notifications",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#patchOrCreate
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/notifications",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#replaceOrCreate
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/notifications/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#upsertWithWhere
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/notifications/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#exists
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/notifications/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#findById
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/notifications/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#replaceById
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/notifications/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#find
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/notifications",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#findOne
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/notifications/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#updateAll
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/notifications/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#deleteById
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/notifications/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#count
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/notifications/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#prototype$patchAttributes
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/notifications/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#createChangeStream
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/notifications/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#subscribeToPushNotifications
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessTokenId` – `{string}` - access token utente
             *
             *  - `pushNotificationToken` – `{string}` - FCM token
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "subscribeToPushNotifications": {
              url: urlBase + "/notifications/subscribe-to-push-notifications",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#unsubscribeToPushNotifications
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessTokenId` – `{string}` - access token utente
             *
             *  - `pushNotificationToken` – `{string}` - FCM token
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{string=}` -
             */
            "unsubscribeToPushNotifications": {
              url: urlBase + "/notifications/unsubscribe-to-push-notifications",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Notification#createMany
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/notifications",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Notification#upsert
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#updateOrCreate
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#patchOrCreateWithWhere
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#update
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#destroyById
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#removeById
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Notification#prototype$updateAttributes
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Notification` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Notification#modelName
        * @propertyOf lbServices.Notification
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Notification`.
        */
        R.modelName = "Notification";


            /**
             * @ngdoc method
             * @name lbServices.Notification#sender
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Fetches belongsTo relation sender.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.sender = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Notification::sender"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Notification#senderOrganization
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Fetches belongsTo relation senderOrganization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.senderOrganization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Notification::senderOrganization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Notification#senderOfferedService
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Fetches belongsTo relation senderOfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.senderOfferedService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Notification::senderOfferedService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Notification#senderSubscription
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Fetches belongsTo relation senderSubscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.senderSubscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::Notification::senderSubscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Notification#recipient
             * @methodOf lbServices.Notification
             *
             * @description
             *
             * Fetches belongsTo relation recipient.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Notification id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.recipient = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Notification::recipient"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserChatStatus
 * @header lbServices.UserChatStatus
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserChatStatus` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserChatStatus",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userChatStatuses/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserChatStatus.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userChatStatuses/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#create
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userChatStatuses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#patchOrCreate
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/userChatStatuses",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#replaceOrCreate
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userChatStatuses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#upsertWithWhere
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userChatStatuses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#exists
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userChatStatuses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#findById
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userChatStatuses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#replaceById
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userChatStatuses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#find
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userChatStatuses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#findOne
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userChatStatuses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#updateAll
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userChatStatuses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#deleteById
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userChatStatuses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#count
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userChatStatuses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#prototype$patchAttributes
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserChatStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/userChatStatuses/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#createChangeStream
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userChatStatuses/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#createMany
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userChatStatuses",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#upsert
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#updateOrCreate
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#patchOrCreateWithWhere
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#update
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#destroyById
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#removeById
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#prototype$updateAttributes
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserChatStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserChatStatus` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserChatStatus#modelName
        * @propertyOf lbServices.UserChatStatus
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserChatStatus`.
        */
        R.modelName = "UserChatStatus";


            /**
             * @ngdoc method
             * @name lbServices.UserChatStatus#user
             * @methodOf lbServices.UserChatStatus
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserChatStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserChatStatus::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PaymentReason
 * @header lbServices.PaymentReason
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PaymentReason` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PaymentReason",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/paymentReasons/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#create
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/paymentReasons",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#patchOrCreate
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/paymentReasons",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#replaceOrCreate
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/paymentReasons/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#upsertWithWhere
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/paymentReasons/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#exists
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/paymentReasons/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#findById
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/paymentReasons/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#replaceById
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/paymentReasons/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#find
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/paymentReasons",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#findOne
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/paymentReasons/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#updateAll
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/paymentReasons/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#deleteById
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/paymentReasons/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#count
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/paymentReasons/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#prototype$patchAttributes
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReason id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/paymentReasons/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#createChangeStream
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/paymentReasons/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#createMany
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/paymentReasons",
              method: "POST",
            },

            // INTERNAL. Use Payment.paymentReason() instead.
            "::get::Payment::paymentReason": {
              url: urlBase + "/payments/:id/paymentReason",
              method: "GET",
            },

            // INTERNAL. Use EarningCost.paymentReason() instead.
            "::get::EarningCost::paymentReason": {
              url: urlBase + "/earningCosts/:id/paymentReason",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#upsert
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#updateOrCreate
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#patchOrCreateWithWhere
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#update
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#destroyById
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#removeById
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReason#prototype$updateAttributes
             * @methodOf lbServices.PaymentReason
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReason id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReason` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PaymentReason#modelName
        * @propertyOf lbServices.PaymentReason
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PaymentReason`.
        */
        R.modelName = "PaymentReason";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Dictionary
 * @header lbServices.Dictionary
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Dictionary` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Dictionary",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/dictionaries/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#create
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/dictionaries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#patchOrCreate
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/dictionaries",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#replaceOrCreate
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/dictionaries/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#upsertWithWhere
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/dictionaries/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#exists
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/dictionaries/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#findById
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/dictionaries/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#replaceById
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/dictionaries/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#find
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/dictionaries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#findOne
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/dictionaries/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#updateAll
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/dictionaries/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#deleteById
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/dictionaries/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#count
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/dictionaries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#prototype$patchAttributes
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Dictionary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/dictionaries/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#createChangeStream
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/dictionaries/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#createMany
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/dictionaries",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Dictionary#upsert
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#updateOrCreate
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#patchOrCreateWithWhere
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#update
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#destroyById
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#removeById
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Dictionary#prototype$updateAttributes
             * @methodOf lbServices.Dictionary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Dictionary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dictionary` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Dictionary#modelName
        * @propertyOf lbServices.Dictionary
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Dictionary`.
        */
        R.modelName = "Dictionary";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.DynamicDocumentConnector
 * @header lbServices.DynamicDocumentConnector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `DynamicDocumentConnector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "DynamicDocumentConnector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/dynamicDocumentConnectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#get
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Retrieve a document, joined with its template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `documentId` – `{string}` - DocumentId
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DynamicDocumentConnector` object.)
             * </em>
             */
            "get": {
              url: urlBase + "/dynamicDocumentConnectors/:documentId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#findByUserAndOrganization
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Ritorna un documento su base utente/organizzazione/template
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` - userId
             *
             *  - `organizationId` – `{string}` - organizationId
             *
             *  - `templateId` – `{string}` - templateId
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DynamicDocumentConnector` object.)
             * </em>
             */
            "findByUserAndOrganization": {
              url: urlBase + "/dynamicDocumentConnectors/findByUserAndOrganization/:userId/:organizationId/:templateId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#post
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Persist a new document
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - Document to persist
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Persisted document
             */
            "post": {
              url: urlBase + "/dynamicDocumentConnectors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#patch
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Update an existing document, archiving the previous version
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object}` - Object containing document and template
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Persisted document
             */
            "patch": {
              url: urlBase + "/dynamicDocumentConnectors",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#template
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Retrieve a template by id
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `templateId` – `{string}` - id of the template to retrieve
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Persisted document
             */
            "template": {
              url: urlBase + "/dynamicDocumentConnectors/template/:templateId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#upsertTemplate
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Upserts a template
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - Object containing document and template
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Persisted document
             */
            "upsertTemplate": {
              url: urlBase + "/dynamicDocumentConnectors/template",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.DynamicDocumentConnector#templates
             * @methodOf lbServices.DynamicDocumentConnector
             *
             * @description
             *
             * Retrieve templates list
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Templates list
             */
            "templates": {
              url: urlBase + "/dynamicDocumentConnectors/templates",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.DynamicDocumentConnector#modelName
        * @propertyOf lbServices.DynamicDocumentConnector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `DynamicDocumentConnector`.
        */
        R.modelName = "DynamicDocumentConnector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CylPlan
 * @header lbServices.CylPlan
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CylPlan` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CylPlan",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cylPlans/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#loadAvailablePlans
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve plans list
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Plans list
             */
            "loadAvailablePlans": {
              isArray: true,
              url: urlBase + "/cylPlans/plans",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#loadCurrentSubscription
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve current plan
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` - organization id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "loadCurrentSubscription": {
              url: urlBase + "/cylPlans/currentSubscription",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#loadCurrentOrganizationStats
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve current plan
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` - organization id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "loadCurrentOrganizationStats": {
              url: urlBase + "/cylPlans/loadCurrentOrganizationStats",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#loadOrganizationAsCustomer
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve organization as customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` - organization id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "loadOrganizationAsCustomer": {
              url: urlBase + "/cylPlans/loadOrganizationAsCustomer",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#previewSubscriptionUpdate
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Preview an update subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{string}` - organization id
             *
             *  - `planId` – `{string}` - new plan id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "previewSubscriptionUpdate": {
              url: urlBase + "/cylPlans/previewSubscriptionUpdate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#createOrganization
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve current plan
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `dynDocumentId` – `{string}` - dyn doc id
             *
             *  - `planId` – `{string}` - new plan id
             *
             *  - `stripeToken` – `{string=}` - stripe token
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "createOrganization": {
              url: urlBase + "/cylPlans/createOrganization",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CylPlan#upgradeSubscription
             * @methodOf lbServices.CylPlan
             *
             * @description
             *
             * Retrieve current plan
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` - organization id
             *
             *  - `planId` – `{string}` - new plan id
             *
             *  - `stripeToken` – `{string=}` - stripe token
             *
             *  - `sourceId` – `{string=}` - stripe source already saved for the customer
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * currentPlan
             */
            "upgradeSubscription": {
              url: urlBase + "/cylPlans/upgradeSubscription",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.CylPlan#modelName
        * @propertyOf lbServices.CylPlan
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CylPlan`.
        */
        R.modelName = "CylPlan";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ServiceType
 * @header lbServices.ServiceType
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ServiceType` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ServiceType",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/serviceTypes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ServiceType.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/serviceTypes/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.findById() instead.
            "prototype$__findById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.destroyById() instead.
            "prototype$__destroyById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.updateById() instead.
            "prototype$__updateById__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceType.offeredServices.link() instead.
            "prototype$__link__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ServiceType.offeredServices.unlink() instead.
            "prototype$__unlink__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.exists() instead.
            "prototype$__exists__offeredServices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/serviceTypes/:id/offeredServices/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ServiceType.offeredServices() instead.
            "prototype$__get__offeredServices": {
              isArray: true,
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "GET",
            },

            // INTERNAL. Use ServiceType.offeredServices.create() instead.
            "prototype$__create__offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "POST",
            },

            // INTERNAL. Use ServiceType.offeredServices.destroyAll() instead.
            "prototype$__delete__offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices",
              method: "DELETE",
            },

            // INTERNAL. Use ServiceType.offeredServices.count() instead.
            "prototype$__count__offeredServices": {
              url: urlBase + "/serviceTypes/:id/offeredServices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#create
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/serviceTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#patchOrCreate
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/serviceTypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#replaceOrCreate
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/serviceTypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#upsertWithWhere
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/serviceTypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#exists
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/serviceTypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#findById
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/serviceTypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#replaceById
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/serviceTypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#find
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/serviceTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#findOne
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/serviceTypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#updateAll
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/serviceTypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#deleteById
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/serviceTypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#count
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/serviceTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#prototype$patchAttributes
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/serviceTypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#createChangeStream
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/serviceTypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#createMany
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/serviceTypes",
              method: "POST",
            },

            // INTERNAL. Use OfferedServiceTypeRelation.category() instead.
            "::get::OfferedServiceTypeRelation::category": {
              url: urlBase + "/offeredServiceTypeRelations/:id/category",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ServiceType#upsert
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#updateOrCreate
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#patchOrCreateWithWhere
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#update
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#destroyById
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#removeById
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceType#prototype$updateAttributes
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ServiceType#modelName
        * @propertyOf lbServices.ServiceType
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ServiceType`.
        */
        R.modelName = "ServiceType";


            /**
             * @ngdoc method
             * @name lbServices.ServiceType#organization
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::ServiceType::organization"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ServiceType.offeredServices
     * @header lbServices.ServiceType.offeredServices
     * @object
     * @description
     *
     * The object `ServiceType.offeredServices` groups methods
     * manipulating `User` instances related to `ServiceType`.
     *
     * Call {@link lbServices.ServiceType#offeredServices ServiceType.offeredServices()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ServiceType#offeredServices
             * @methodOf lbServices.ServiceType
             *
             * @description
             *
             * Queries offeredServices of ServiceType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#count
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Counts offeredServices of ServiceType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offeredServices.count = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::count::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#create
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Creates a new instance in offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.create = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::create::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#createMany
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Creates a new instance in offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.createMany = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::createMany::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#destroyAll
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Deletes all offeredServices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServices.destroyAll = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::delete::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#destroyById
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Delete a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServices.destroyById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::destroyById::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#exists
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Check the existence of offeredServices relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.exists = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::exists::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#findById
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Find a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#link
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Add a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#unlink
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Remove the offeredServices relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offeredServices.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceType.offeredServices#updateById
             * @methodOf lbServices.ServiceType.offeredServices
             *
             * @description
             *
             * Update a related item by id for offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceType id
             *
             *  - `fk` – `{*}` - Foreign key for offeredServices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.offeredServices.updateById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::updateById::ServiceType::offeredServices"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OfferedServiceTypeRelation
 * @header lbServices.OfferedServiceTypeRelation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OfferedServiceTypeRelation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OfferedServiceTypeRelation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/offeredServiceTypeRelations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OfferedServiceTypeRelation.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/offeredServiceTypeRelations/:id/category",
              method: "GET",
            },

            // INTERNAL. Use OfferedServiceTypeRelation.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/offeredServiceTypeRelations/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#create
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/offeredServiceTypeRelations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#patchOrCreate
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/offeredServiceTypeRelations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#replaceOrCreate
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/offeredServiceTypeRelations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#upsertWithWhere
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/offeredServiceTypeRelations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#exists
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/offeredServiceTypeRelations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#findById
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/offeredServiceTypeRelations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#replaceById
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/offeredServiceTypeRelations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#find
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/offeredServiceTypeRelations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#findOne
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/offeredServiceTypeRelations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#updateAll
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/offeredServiceTypeRelations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#deleteById
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/offeredServiceTypeRelations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#count
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/offeredServiceTypeRelations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#prototype$patchAttributes
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceTypeRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/offeredServiceTypeRelations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#createChangeStream
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/offeredServiceTypeRelations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#createMany
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/offeredServiceTypeRelations",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.findById() instead.
            "::findById::OfferedService::offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.destroyById() instead.
            "::destroyById::OfferedService::offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.updateById() instead.
            "::updateById::OfferedService::offeredServiceTypeRelations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations() instead.
            "::get::OfferedService::offeredServiceTypeRelations": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.create() instead.
            "::create::OfferedService::offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.createMany() instead.
            "::createMany::OfferedService::offeredServiceTypeRelations": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.destroyAll() instead.
            "::delete::OfferedService::offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.offeredServiceTypeRelations.count() instead.
            "::count::OfferedService::offeredServiceTypeRelations": {
              url: urlBase + "/offeredServices/:id/offeredServiceTypeRelations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#upsert
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#updateOrCreate
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#patchOrCreateWithWhere
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#update
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#destroyById
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#removeById
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#prototype$updateAttributes
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceTypeRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServiceTypeRelation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OfferedServiceTypeRelation#modelName
        * @propertyOf lbServices.OfferedServiceTypeRelation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OfferedServiceTypeRelation`.
        */
        R.modelName = "OfferedServiceTypeRelation";


            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#category
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceTypeRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceType` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("ServiceType");
          var action = TargetResource["::get::OfferedServiceTypeRelation::category"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedServiceTypeRelation#user
             * @methodOf lbServices.OfferedServiceTypeRelation
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServiceTypeRelation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::OfferedServiceTypeRelation::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Discount
 * @header lbServices.Discount
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Discount` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Discount",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/discounts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Discount.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/discounts/:id/organization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#create
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/discounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#patchOrCreate
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/discounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#replaceOrCreate
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/discounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#upsertWithWhere
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/discounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#exists
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/discounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#findById
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/discounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#replaceById
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/discounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#find
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/discounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#findOne
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/discounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#updateAll
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/discounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#deleteById
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/discounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#count
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/discounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#prototype$patchAttributes
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Discount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/discounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#createChangeStream
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/discounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Discount#createMany
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/discounts",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Discount#upsert
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#updateOrCreate
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#patchOrCreateWithWhere
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#update
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#destroyById
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#removeById
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Discount#prototype$updateAttributes
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Discount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Discount` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Discount#modelName
        * @propertyOf lbServices.Discount
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Discount`.
        */
        R.modelName = "Discount";


            /**
             * @ngdoc method
             * @name lbServices.Discount#organization
             * @methodOf lbServices.Discount
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Discount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Discount::organization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Attendance
 * @header lbServices.Attendance
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Attendance` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Attendance",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/attendances/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Attendance.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/attendances/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Attendance.order() instead.
            "prototype$__get__order": {
              url: urlBase + "/attendances/:id/order",
              method: "GET",
            },

            // INTERNAL. Use Attendance.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/attendances/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Attendance.subscribedOfferedService() instead.
            "prototype$__get__subscribedOfferedService": {
              url: urlBase + "/attendances/:id/subscribedOfferedService",
              method: "GET",
            },

            // INTERNAL. Use Attendance.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/attendances/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Attendance.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/attendances/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#create
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/attendances",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#patchOrCreate
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/attendances",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#replaceOrCreate
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/attendances/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#upsertWithWhere
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/attendances/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#exists
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/attendances/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#findById
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/attendances/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#replaceById
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/attendances/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#find
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/attendances",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#findOne
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/attendances/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#updateAll
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/attendances/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#deleteById
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/attendances/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#count
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/attendances/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#prototype$patchAttributes
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/attendances/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#createChangeStream
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/attendances/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#allAttendances
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `serviceId` – `{string}` - servizio per il quale si vogliono vedere le presenze
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "allAttendances": {
              url: urlBase + "/attendances/allAttendances",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#exchangeAttendances
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `orderLeftId` – `{number}` -
             *
             *  - `orderRightId` – `{number}` -
             *
             *  - `changes` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "exchangeAttendances": {
              url: urlBase + "/attendances/exchange-attendances",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#fetchAttendances
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `organizationId` – `{string}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `offeredServiceId` – `{string=}` -
             *
             *  - `carnetId` – `{string=}` -
             *
             *  - `dateFrom` – `{string=}` - YYYYMMDD
             *
             *  - `dateTo` – `{string=}` - YYYYMMDD
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "fetchAttendances": {
              isArray: true,
              url: urlBase + "/attendances/fetch-attendances",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attendance#createMany
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/attendances",
              method: "POST",
            },

            // INTERNAL. Use Subscription.attendances.findById() instead.
            "::findById::Subscription::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Subscription.attendances.destroyById() instead.
            "::destroyById::Subscription::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.attendances.updateById() instead.
            "::updateById::Subscription::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/subscriptions/:id/attendances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Subscription.attendances() instead.
            "::get::Subscription::attendances": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/attendances",
              method: "GET",
            },

            // INTERNAL. Use Subscription.attendances.create() instead.
            "::create::Subscription::attendances": {
              url: urlBase + "/subscriptions/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Subscription.attendances.createMany() instead.
            "::createMany::Subscription::attendances": {
              isArray: true,
              url: urlBase + "/subscriptions/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Subscription.attendances.destroyAll() instead.
            "::delete::Subscription::attendances": {
              url: urlBase + "/subscriptions/:id/attendances",
              method: "DELETE",
            },

            // INTERNAL. Use Subscription.attendances.count() instead.
            "::count::Subscription::attendances": {
              url: urlBase + "/subscriptions/:id/attendances/count",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances.findById() instead.
            "::findById::Order::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances.destroyById() instead.
            "::destroyById::Order::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Order.attendances.updateById() instead.
            "::updateById::Order::attendances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orders/:id/attendances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Order.attendances() instead.
            "::get::Order::attendances": {
              isArray: true,
              url: urlBase + "/orders/:id/attendances",
              method: "GET",
            },

            // INTERNAL. Use Order.attendances.create() instead.
            "::create::Order::attendances": {
              url: urlBase + "/orders/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Order.attendances.createMany() instead.
            "::createMany::Order::attendances": {
              isArray: true,
              url: urlBase + "/orders/:id/attendances",
              method: "POST",
            },

            // INTERNAL. Use Order.attendances.destroyAll() instead.
            "::delete::Order::attendances": {
              url: urlBase + "/orders/:id/attendances",
              method: "DELETE",
            },

            // INTERNAL. Use Order.attendances.count() instead.
            "::count::Order::attendances": {
              url: urlBase + "/orders/:id/attendances/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Attendance#upsert
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#updateOrCreate
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#patchOrCreateWithWhere
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#update
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#destroyById
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#removeById
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Attendance#prototype$updateAttributes
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attendance` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Attendance#modelName
        * @propertyOf lbServices.Attendance
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Attendance`.
        */
        R.modelName = "Attendance";


            /**
             * @ngdoc method
             * @name lbServices.Attendance#subscription
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::Attendance::subscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attendance#order
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.order = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::Attendance::order"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attendance#offeredService
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Attendance::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attendance#subscribedOfferedService
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation subscribedOfferedService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.subscribedOfferedService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Attendance::subscribedOfferedService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attendance#organization
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Attendance::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attendance#user
             * @methodOf lbServices.Attendance
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attendance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Attendance::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AttendanceNote
 * @header lbServices.AttendanceNote
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AttendanceNote` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AttendanceNote",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/attendanceNotes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AttendanceNote.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/attendanceNotes/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use AttendanceNote.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/attendanceNotes/:id/organization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#create
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/attendanceNotes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#patchOrCreate
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/attendanceNotes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#replaceOrCreate
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/attendanceNotes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#upsertWithWhere
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/attendanceNotes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#exists
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/attendanceNotes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#findById
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/attendanceNotes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#replaceById
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/attendanceNotes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#find
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/attendanceNotes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#findOne
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/attendanceNotes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#updateAll
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/attendanceNotes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#deleteById
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/attendanceNotes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#count
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/attendanceNotes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#prototype$patchAttributes
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AttendanceNote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/attendanceNotes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#createChangeStream
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/attendanceNotes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#createMany
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/attendanceNotes",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#upsert
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#updateOrCreate
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#patchOrCreateWithWhere
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#update
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#destroyById
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#removeById
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#prototype$updateAttributes
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AttendanceNote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AttendanceNote` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AttendanceNote#modelName
        * @propertyOf lbServices.AttendanceNote
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AttendanceNote`.
        */
        R.modelName = "AttendanceNote";


            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#offeredService
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AttendanceNote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::AttendanceNote::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AttendanceNote#organization
             * @methodOf lbServices.AttendanceNote
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AttendanceNote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::AttendanceNote::organization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AppCapability
 * @header lbServices.AppCapability
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AppCapability` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AppCapability",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AppCapabilities/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#create
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AppCapabilities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#patchOrCreate
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/AppCapabilities",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#replaceOrCreate
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AppCapabilities/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#upsertWithWhere
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AppCapabilities/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#exists
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AppCapabilities/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#findById
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AppCapabilities/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#replaceById
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AppCapabilities/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#find
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AppCapabilities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#findOne
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AppCapabilities/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#updateAll
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AppCapabilities/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#deleteById
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AppCapabilities/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#count
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AppCapabilities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#prototype$patchAttributes
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppCapability id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/AppCapabilities/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#createChangeStream
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AppCapabilities/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#isAvailable
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Verifica che una capability sia permessa per una determnata versione dell'app
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `major` – `{number}` -
             *
             *  - `minor` – `{number}` -
             *
             *  - `bugfix` – `{number}` -
             *
             *  - `os` – `{string}` -
             *
             *  - `capability` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Object containing available: true if capability is allowed
             */
            "isAvailable": {
              url: urlBase + "/AppCapabilities/isAvailable",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#createMany
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AppCapabilities",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AppCapability#upsert
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#updateOrCreate
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#patchOrCreateWithWhere
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#update
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#destroyById
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#removeById
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AppCapability#prototype$updateAttributes
             * @methodOf lbServices.AppCapability
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppCapability id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppCapability` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AppCapability#modelName
        * @propertyOf lbServices.AppCapability
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AppCapability`.
        */
        R.modelName = "AppCapability";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PaymentReport
 * @header lbServices.PaymentReport
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PaymentReport` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PaymentReport",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/paymentReports/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PaymentReport.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/paymentReports/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use PaymentReport.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/paymentReports/:id/offeredService",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#create
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/paymentReports",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#patchOrCreate
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/paymentReports",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#replaceOrCreate
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/paymentReports/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#upsertWithWhere
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/paymentReports/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#exists
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/paymentReports/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#findById
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/paymentReports/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#replaceById
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/paymentReports/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#find
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/paymentReports",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#findOne
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/paymentReports/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#updateAll
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/paymentReports/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#deleteById
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/paymentReports/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#count
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/paymentReports/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#prototype$patchAttributes
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReport id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/paymentReports/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#createChangeStream
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/paymentReports/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#generate
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `organizationId` – `{number}` -
             *
             *  - `offeredServiceId` – `{number}` -
             *
             *  - `refYear` – `{number}` -
             *
             *  - `refMonth` – `{number}` -
             *
             *  - `linkedOfferedServices` – `{*=}` - Linked services (e.g. yearly subscription)
             *
             *  - `tk` – `{string}` - authentication token
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `data` – `{*=}` -
             */
            "generate": {
              url: urlBase + "/paymentReports/generate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#createMany
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/paymentReports",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#upsert
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#updateOrCreate
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#patchOrCreateWithWhere
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#update
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#destroyById
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#removeById
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#prototype$updateAttributes
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReport id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentReport` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PaymentReport#modelName
        * @propertyOf lbServices.PaymentReport
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PaymentReport`.
        */
        R.modelName = "PaymentReport";


            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#organization
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReport id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::PaymentReport::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentReport#offeredService
             * @methodOf lbServices.PaymentReport
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentReport id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::PaymentReport::offeredService"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Oplog
 * @header lbServices.Oplog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Oplog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Oplog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/oplog/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Oplog.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/oplog/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Oplog.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/oplog/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Oplog.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/oplog/:id/offeredService",
              method: "GET",
            },

            // INTERNAL. Use Oplog.subscription() instead.
            "prototype$__get__subscription": {
              url: urlBase + "/oplog/:id/subscription",
              method: "GET",
            },

            // INTERNAL. Use Oplog.order() instead.
            "prototype$__get__order": {
              url: urlBase + "/oplog/:id/order",
              method: "GET",
            },

            // INTERNAL. Use Oplog.payment() instead.
            "prototype$__get__payment": {
              url: urlBase + "/oplog/:id/payment",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#create
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/oplog",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#patchOrCreate
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/oplog",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#replaceOrCreate
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/oplog/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#upsertWithWhere
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/oplog/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#exists
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/oplog/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#findById
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/oplog/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#replaceById
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/oplog/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#find
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/oplog",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#findOne
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/oplog/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#updateAll
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/oplog/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#deleteById
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/oplog/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#count
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/oplog/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#prototype$patchAttributes
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/oplog/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#createChangeStream
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/oplog/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#add
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add an entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "add": {
              url: urlBase + "/oplog/add",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#debug
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add a debug entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "debug": {
              url: urlBase + "/oplog/addDebug",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#info
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add an info entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "info": {
              url: urlBase + "/oplog/addInfo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#warning
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add a warning entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "warning": {
              url: urlBase + "/oplog/addWarning",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#warn
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add a warning entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "warn": {
              url: urlBase + "/oplog/addWarn",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#error
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add an error entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "error": {
              url: urlBase + "/oplog/addError",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#err
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Add an error entry
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` - { ... }
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Operation result
             */
            "err": {
              url: urlBase + "/oplog/addErr",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Oplog#createMany
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/oplog",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Oplog#upsert
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#updateOrCreate
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#patchOrCreateWithWhere
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#update
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#destroyById
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#removeById
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Oplog#prototype$updateAttributes
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Oplog` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Oplog#modelName
        * @propertyOf lbServices.Oplog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Oplog`.
        */
        R.modelName = "Oplog";


            /**
             * @ngdoc method
             * @name lbServices.Oplog#user
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Oplog::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Oplog#organization
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Oplog::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Oplog#offeredService
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::Oplog::offeredService"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Oplog#subscription
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation subscription.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R.subscription = function() {
          var TargetResource = $injector.get("Subscription");
          var action = TargetResource["::get::Oplog::subscription"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Oplog#order
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.order = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::Oplog::order"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Oplog#payment
             * @methodOf lbServices.Oplog
             *
             * @description
             *
             * Fetches belongsTo relation payment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Oplog id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::Oplog::payment"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrganizationPreference
 * @header lbServices.OrganizationPreference
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrganizationPreference` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrganizationPreference",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/organizationPreferences/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OrganizationPreference.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/organizationPreferences/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#create
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/organizationPreferences",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#patchOrCreate
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/organizationPreferences",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#replaceOrCreate
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/organizationPreferences/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#upsertWithWhere
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/organizationPreferences/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#exists
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/organizationPreferences/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#findById
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/organizationPreferences/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#replaceById
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/organizationPreferences/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#find
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/organizationPreferences",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#findOne
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/organizationPreferences/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#updateAll
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/organizationPreferences/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#deleteById
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/organizationPreferences/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#count
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/organizationPreferences/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#prototype$patchAttributes
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/organizationPreferences/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#createChangeStream
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/organizationPreferences/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#createMany
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/organizationPreferences",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#upsert
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#updateOrCreate
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#patchOrCreateWithWhere
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#update
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#destroyById
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#removeById
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#prototype$updateAttributes
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrganizationPreference` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrganizationPreference#modelName
        * @propertyOf lbServices.OrganizationPreference
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrganizationPreference`.
        */
        R.modelName = "OrganizationPreference";


            /**
             * @ngdoc method
             * @name lbServices.OrganizationPreference#user
             * @methodOf lbServices.OrganizationPreference
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrganizationPreference id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::OrganizationPreference::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ServiceCategory
 * @header lbServices.ServiceCategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ServiceCategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ServiceCategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/serviceCategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ServiceCategory.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/serviceCategories/:id/category",
              method: "GET",
            },

            // INTERNAL. Use ServiceCategory.offeredServices() instead.
            "prototype$__get__offeredServices": {
              url: urlBase + "/serviceCategories/:id/offeredServices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#create
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/serviceCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#patchOrCreate
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/serviceCategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#replaceOrCreate
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/serviceCategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#upsertWithWhere
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/serviceCategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#exists
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/serviceCategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#findById
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/serviceCategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#replaceById
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/serviceCategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#find
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/serviceCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#findOne
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/serviceCategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#updateAll
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/serviceCategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#deleteById
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/serviceCategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#count
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/serviceCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#prototype$patchAttributes
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/serviceCategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#createChangeStream
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/serviceCategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#createMany
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/serviceCategories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceCategories.findById() instead.
            "::findById::OfferedService::serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceCategories.destroyById() instead.
            "::destroyById::OfferedService::serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceCategories.updateById() instead.
            "::updateById::OfferedService::serviceCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/serviceCategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.serviceCategories() instead.
            "::get::OfferedService::serviceCategories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.serviceCategories.create() instead.
            "::create::OfferedService::serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceCategories.createMany() instead.
            "::createMany::OfferedService::serviceCategories": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.serviceCategories.destroyAll() instead.
            "::delete::OfferedService::serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.serviceCategories.count() instead.
            "::count::OfferedService::serviceCategories": {
              url: urlBase + "/offeredServices/:id/serviceCategories/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#upsert
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#updateOrCreate
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#patchOrCreateWithWhere
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#update
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#destroyById
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#removeById
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#prototype$updateAttributes
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ServiceCategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ServiceCategory#modelName
        * @propertyOf lbServices.ServiceCategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ServiceCategory`.
        */
        R.modelName = "ServiceCategory";


            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#category
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::ServiceCategory::category"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ServiceCategory#offeredServices
             * @methodOf lbServices.ServiceCategory
             *
             * @description
             *
             * Fetches belongsTo relation offeredServices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ServiceCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredServices = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::ServiceCategory::offeredServices"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OfferedServicePicture
 * @header lbServices.OfferedServicePicture
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OfferedServicePicture` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OfferedServicePicture",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/offeredServicePictures/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OfferedServicePicture.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/offeredServicePictures/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use OfferedServicePicture.offeredService() instead.
            "prototype$__get__offeredService": {
              url: urlBase + "/offeredServicePictures/:id/offeredService",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#create
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/offeredServicePictures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#patchOrCreate
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/offeredServicePictures",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#replaceOrCreate
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/offeredServicePictures/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#upsertWithWhere
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/offeredServicePictures/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#exists
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/offeredServicePictures/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#findById
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/offeredServicePictures/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#replaceById
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/offeredServicePictures/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#find
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/offeredServicePictures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#findOne
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/offeredServicePictures/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#updateAll
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/offeredServicePictures/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#deleteById
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/offeredServicePictures/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#count
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/offeredServicePictures/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#prototype$patchAttributes
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServicePicture id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/offeredServicePictures/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#createChangeStream
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/offeredServicePictures/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#createMany
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/offeredServicePictures",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.pictures.findById() instead.
            "::findById::OfferedService::pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.pictures.destroyById() instead.
            "::destroyById::OfferedService::pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.pictures.updateById() instead.
            "::updateById::OfferedService::pictures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/offeredServices/:id/pictures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OfferedService.pictures() instead.
            "::get::OfferedService::pictures": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/pictures",
              method: "GET",
            },

            // INTERNAL. Use OfferedService.pictures.create() instead.
            "::create::OfferedService::pictures": {
              url: urlBase + "/offeredServices/:id/pictures",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.pictures.createMany() instead.
            "::createMany::OfferedService::pictures": {
              isArray: true,
              url: urlBase + "/offeredServices/:id/pictures",
              method: "POST",
            },

            // INTERNAL. Use OfferedService.pictures.destroyAll() instead.
            "::delete::OfferedService::pictures": {
              url: urlBase + "/offeredServices/:id/pictures",
              method: "DELETE",
            },

            // INTERNAL. Use OfferedService.pictures.count() instead.
            "::count::OfferedService::pictures": {
              url: urlBase + "/offeredServices/:id/pictures/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#upsert
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#updateOrCreate
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#patchOrCreateWithWhere
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#update
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#destroyById
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#removeById
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#prototype$updateAttributes
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServicePicture id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedServicePicture` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OfferedServicePicture#modelName
        * @propertyOf lbServices.OfferedServicePicture
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OfferedServicePicture`.
        */
        R.modelName = "OfferedServicePicture";


            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#organization
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServicePicture id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::OfferedServicePicture::organization"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OfferedServicePicture#offeredService
             * @methodOf lbServices.OfferedServicePicture
             *
             * @description
             *
             * Fetches belongsTo relation offeredService.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OfferedServicePicture id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OfferedService` object.)
             * </em>
             */
        R.offeredService = function() {
          var TargetResource = $injector.get("OfferedService");
          var action = TargetResource["::get::OfferedServicePicture::offeredService"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, $provide)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);
        
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        //$translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });
        
        // Text Angular options
        $provide.decorator('taOptions', ['taRegisterTool',
            '$delegate', function (taRegisterTool, taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };
                
                taRegisterTool('fontColor', {
                    display:"<spectrum-colorpicker trigger-id='{{trigger}}' ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></spectrum-colorpicker>",
                    action: function (color) {
                        var me = this;
                        if (!this.$editor().wrapSelection) {
                            setTimeout(function () {
                                me.action(color);
                            }, 100)
                        } else {
                            return this.$editor().wrapSelection('foreColor', color);
                        }
                    },
                    options: {
                        replacerClassName: 'icon-format-color', showButtons: true
                    },
                    color: "#000"
                });                
                taOptions.toolbar[0].push('fontColor');
                
                taRegisterTool('backgroundColor', {
                    display: "<div spectrum-colorpicker ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></div>",
                    action: function (color) {
                        var me = this;
                        if (!this.$editor().wrapSelection) {
                            setTimeout(function () {
                                me.action(color);
                            }, 100)
                        } else {
                            return this.$editor().wrapSelection('backColor', color);
                        }
                    },
                    options: {
                        replacerClassName: 'icon-brush', showButtons: true
                    },
                    color: "#fff"
                });
                taOptions.toolbar[0].push('backgroundColor');
                


                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';
                
                

                return taTools;
            }        
            
            ]);
            

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/dispatcher');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController($scope, fuseTheming, msNavigationService,LoopBackAuth, $rootScope,
                             UserDocPrefix, OrganizationDocPrefix, SubscriptionDocPrefix, $location,
                             $state, $interval, $timeout, $log, AlertMessageService, Organization) {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        $rootScope.CYL_USER_DOC_PREFIX=UserDocPrefix;
        $rootScope.CYL_ORG_DOC_PREFIX=OrganizationDocPrefix;
        $rootScope.CYL_SUBSCRIPTION_DOC_PREFIX=SubscriptionDocPrefix;




        vm.checkSession = function() {
            $log.debug('IndexController.checkSession()');
            var organizationId = null;
            if ($scope.organizationId) {
                organizationId = $rootScope.organizationId;
            } else {
                organizationId = sessionStorage.getItem('CURRENT_ORGANIZATION');
            }
            if (organizationId !== 'null' && typeof organizationId === 'string') {
                organizationId = parseInt(organizationId);
            } else if (typeof organizationId === 'number') {
                // non fa nulla, è giusto che sia numerico
            } else {
                organizationId = null;
            }
            var url = $location.url();
            if (organizationId && url !== '/pages/auth/login') {
                $log.debug('organizationId found, trying a authenticated API...');
                $log.debug({organizationId: organizationId});
                Organization.findById({ id: organizationId }).$promise.then(
                    function(org) {
                        $log.debug('...request succeeded, user is still logged in');
                        // sessione verificata, non faccio nulla
                    },
                    function(err) {
                        // sessione non verificata, vado a login
                        $log.debug('...request failed, session is expired');
                        AlertMessageService.showErrorAlert('Sessione scaduta');
                        $state.go('app.pages_auth_login');
                    }
                );
            } else {
                $log.debug('no organizationId found: not logged in or no organization selected');
            }
        };

        vm.checkSessionTimer = $interval(
            function() {
                vm.checkSession();
            },
            60000
        );


    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('ApiPath','https://app.clubyourlife.cloud/api');

    angular
        .module('fuse')
        .constant('SocketIOPath','https://notification-manager.clubyourlife.cloud/');


    angular
        .module('fuse')
        .constant('NotificationChannel','CLUBYOURLIFE');

    angular
        .module('fuse')
        .constant('StripePublicKey', 'pk_live_jCImg3fxLAE6v2nyPJV6WlwP');

    angular
        .module('fuse')
        .constant('UserDocPrefix','PROD_CYL_USER_DOC_');

    angular
        .module('fuse')
        .constant('OrganizationDocPrefix','PROD_CYL_ORG_DOC_');

    angular
        .module('fuse')
        .constant('OrganizationPrivateDocPrefix','PROD_CYL_ORG_PRIVATE_DOC_');

    angular
        .module('fuse')
        .constant('SubscriptionDocPrefix','PROD_CYL_SUBSCRIPTION_DOC_');


    angular
        .module('fuse')
        .constant('DefaultBackgroundUrl','/assets/images/backgrounds/bg-palestra.jpg');

    angular
        .module('fuse')
        .constant('PublicCylUrl','https://app.clubyourlife.cloud');

    angular
        .module('fuse')
        .constant('NewOrganizationTemplateId','PROD_CYL_NUOVA_ASSOCIAZIONE');



})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(LoopBackResourceProvider, $translateProvider, ApiPath, $mdDateLocaleProvider, blockUIConfig)
    {
        // sorgente API
        LoopBackResourceProvider.setUrlBase(ApiPath);

        // Impostazione lingua preferita a italiano
        $translateProvider.preferredLanguage('it');
        moment.locale('it');

        //impostazione delle date in formto dd/MM/yyyy
        $mdDateLocaleProvider.formatDate = function(date) {
           if (!date || date===null ) {
              return null;
           }
           return moment(date).format('DD/MM/YYYY');
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', false);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        // Change the default overlay message
        blockUIConfig.message = 'Attendere un istante...';
        // Change the default delay to 100ms before the blocking is visible
        blockUIConfig.delay = 100;
        blockUIConfig.autoBlock = false;

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function (){
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.change_pwd',
            'app.pages.auth.register',
            'app.pages.auth.activate',
            'app.pages.auth.resetpwd',
            'app.pages.auth.forgot_password',
            'app.pages.auth.changemailconfirm',
            'app.pages.dispatcher',
            'app.pages.organizations',
            'app.pages.offered_services',
            'app.pages.users',
            'app.pages.notifications',
            'app.pages.subscriptions',
            'app.pages.attendances',
            'app.pages.docs_validation',
            'app.pages.payments',
            'app.pages.earningcosts',
            'app.pages.message',
            'app.pages.invitations',
            'app.pages.massive_notification',
            'app.pages.service_payments_report',
            'app.pages.memberships',
            'app.pages.legal',
            'app.pages.seasonchange',
            'app.services',
            'ui.sortable',
            'rorymadden.date-dropdowns',
            'capitalize',
            'restrictInput',
            'blockUI',
            'restrictInput',
            'lowercase',
            'ngclipboard',
            'angular-jsoneditor',
            'ov-breadcrumbs',
            'ov-organization-alert',
            'ov-navigation-bar',
            'ov-profile-navigation-bar',
            'ov-interval-table',
            'ov-subscriber-payments-cell',
            'ov-subscription-payments-status',
            'ov-subscription-carnet-status',
            'dyndoc',
            'vcRecaptcha',
            '720kb.socialshare',
            'mdColorPicker',
            'app.filters'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages');
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2 white-bg\" ms-scroll ui-view=\"content\" flex></md-content><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/toolbar/dialogs/custom-reference-period.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{\'PAGES.SET_REF_PERIOD\' | translate}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\" \nstyle=\"font-size: 80%; font-style: italic\" class=\"md-subhead\">{{\'PAGES.SEASON_FILTER_HINT\' | translate}}</div><div \nlayout=\"row\" style=\"color: red\" class=\"md-subhead\">{{displayErrorDates}}</div><div layout=\"row\" div \nclass=\"md-inline-form\"><md-datepicker ng-model=\"organizationPeriod.dateFrom\" \nmd-placeholder=\"{{ \'PAGES.DATE_FROM\' | translate }}\"></md-datepicker><md-datepicker \nng-model=\"organizationPeriod.dateTo\" md-placeholder=\"{{ \'PAGES.DATE_TO\' | translate }}\"></md-datepicker></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"applyDates()\">Ok</md-button><md-button \nng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"center\"><div ng-if=\"vm.isChildChat\" \nlayout-align=\"center center\" style=\"background-color: #E91E63; color: white\" layout=\"row\" flex><h2 \ntranslate=\"CHAT.YOU_ARE_MONITORING_CHAT_OF\" translate-values=\"{displayName:vm.child.displayName}\"></h2><md-button \nclass=\"md-accent md-raised\" layout-align=\"end\" ng-click=\"vm.backToUserChat();\">{{\'CHAT.BACK_TO_MY_CHAT\'| translate }}\n</md-button></div><div class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat || !vm.currentContact\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-if=\"vm.chat && vm.currentContact\" class=\"chat\" layout=\"column\" flex><md-toolbar \nclass=\"chat-toolbar\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" style=\"cursor: default\"><div class=\"avatar-wrapper\"><img \nng-if=\"vm.currentContact.type===\'U\' && (!vm.currentContact.uriAvatar || vm.currentContact.uriAvatar===null)\" \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar\" alt=\"{{vm.currentContact.name}}\"> <img \nng-if=\"vm.currentContact.type===\'U\' && vm.currentContact.uriAvatar && vm.currentContact.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{vm.currentContact.id}}/download/{{ vm.currentContact.uriAvatar }}\" \nclass=\"avatar\" alt=\"{{vm.currentContact.name}}\"><md-icon \nng-if=\"vm.currentContact.type===\'O\'  && (!vm.currentContact.uriAvatar || vm.currentContact.uriAvatar===null)\" \nmd-font-icon=\"icon-shield\" style=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\">\n</md-icon><img \nng-if=\"vm.currentContact.type===\'O\' && vm.currentContact.uriAvatar && vm.currentContact.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{vm.currentContact.id}}/download/{{ vm.currentContact.uriAvatar }}\" \nclass=\"avatar\"><md-icon ng-if=\"vm.currentContact.type===\'S\'\" md-font-icon=\"icon-account-multiple\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><i \nng-if=\"vm.currentContact.type===\'U\'\" class=\"icon icon- s16 status\" ng-class=\"vm.currentContact.status\"></i></div><div \nclass=\"chat-contact-name\">{{vm.currentContact.name}}</div></div><md-menu md-position-mode=\"target-right target\" \nng-show=\"vm.currentContact.type===\'S\' || vm.currentContact.type===\'O\'\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.currentContact.type===\'S\'\"><md-button \nng-click=\"vm.loadGroupSubscribers(vm.currentContact.id, true);\">Info gruppo</md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentContact.type===\'O\'\"><md-button \nng-click=\"vm.loadOrganizationGroupMembers(vm.currentContact.id, true);\">Info gruppo</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" \nng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.who\">\n<div layout=\"column\"><img ng-if=\"dialog.who ===\'contact\'\" src=\"assets/images/avatars/profile.jpg\" class=\"avatar\" \nalt=\"{{dialog.sender.displayName}}\"> <span style=\"font-size: 80%; width: 100px\" \nng-if=\"dialog.who ===\'contact\' && (vm.currentContact.type===\'O\' || vm.currentContact.type===\'S\')\">\n{{dialog.sender.displayName}}</span></div><img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\"><div class=\"message\" ng-bind-html=\"dialog.text | linky\">\n</div><div class=\"time secondary-text\"><md-icon \nng-if=\"dialog.who ===\'user\' && vm.currentContact.type !== \'S\' && dialog.broadcastChatServiceId\" \nmd-font-icon=\"icon-volume-medium\" style=\"color: #777\"></md-icon>{{vm.formatDate(dialog.notificationDate)}}</div></div>\n</div></div></md-content><div class=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form \nng-if=\"!vm.isChildChat\" ng-submit=\"vm.reply()\" flex class=\"reply-form\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex md-no-float><textarea ng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" \nng-class=\"{\'grow\': vm.textareaGrow}\" placeholder=\"Type and hit enter to send message\" translate \ntranslate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container>\n<md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>\n</div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" md-component-id=\"right-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\"></md-sidenav></div></div></div>");
$templateCache.put("app/main/directives/ov-breadcrumbs/ov-breadcrumbs.html","<span style=\"color:white\" show-gt-sm><md-menu ng-hide=\"hideOrganzationMenu || !currentOrganization\"><md-button \nng-show=\"currentOrganization\" class=\"md-raised md-accent\" ng-click=\"openMenu($mdOpenMenu, $event)\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"s16 separator\" style=\"color: white\"></md-icon>{{currentOrganization.name}}</md-button>\n<md-menu-content style=\"min-height: 400px\"><md-menu-item><md-button ng-click=\"goToOrganization()\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s36 ml-16\"></md-icon>Home Associazione</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"goToOrganizationSubscriptions()\"><md-icon md-font-icon=\"icon-pencil-box-outline\" \nclass=\"s36 ml-16\"></md-icon>{{\'PAGES.SUBSCRIPTIONS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"goToOrganizationAttendances()\"><md-icon md-font-icon=\"icon-account-check\" class=\"s36 ml-16\"></md-icon>\n{{\'PAGES.ATTENDANCES\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"gotoServices()\"><md-icon\n md-font-icon=\"icon-calendar-multiple\" class=\"s36 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.OFFERED_SERVICES.OFFERED_SERVICES_AND_SUBSCRIPTIONS\'|translate}}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"gotoMembers()\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s36 ml-16\">\n</md-icon>{{\'ORGANIZATIONS.MEMBERS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"gotoResources()\"><md-icon md-font-icon=\"icon-package\" class=\"s36 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.RESOURCES.RESOURCES\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"gotoEarningCosts()\"><md-icon md-font-icon=\"icon-coin\" class=\"s36 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.EARNING_COSTS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"gotoEvents()\">\n<md-icon md-font-icon=\"icon-calendar-check\" class=\"s36 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.OFFERED_SERVICES.EVENTS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"goToOrganizationSettings()\"><md-icon md-font-icon=\"icon-cog\" class=\"s36 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-show=\"showDateInterval && currentOrganization\" class=\"md-raised pulsante-imposta-data\" ng-click=\"openPeriodModal()\">\n<md-icon md-font-icon=\"icon-calendar-check-multiple\" class=\"s24\" style=\"color: white\"></md-icon><div \nclass=\"pulsante-imposta-data__testo\">{{organizationPeriod.description}}</div></md-button></span>");
$templateCache.put("app/main/directives/ov-interval-table/ov-interval-table.html","<div class=\"simple-table-container\" ng-init=\"init();\"><div><table class=\"simple\"><thead><tr><th>Giorni</th><th>\nSettimane</th><th>Mesi</th></tr></thead><tbody><tr><td>{{ giorni }}</td><td>{{ settimane }}</td><td>{{ mesi }}</td>\n</tr></tbody></table></div></div>");
$templateCache.put("app/main/directives/ov-navigation-bar/ov-navigation-bar.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><div layout=\"column\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><md-button id=\"btn-navbar-home\" \nclass=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'HOME\'), \'blue-grey-700-bg\': (selectedPage !== \'HOME\')}\" \nng-click=\"goToOrganizationDetail();\"><md-icon style=\"color: white\" md-font-icon=\"icon-home-variant\" class=\"s24 ml-16\">\n</md-icon>Home</md-button><md-button id=\"btn-navbar-members\" class=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'MEMBERS\'), \'blue-grey-700-bg\': (selectedPage !== \'MEMBERS\')}\" \nng-click=\"gotoMembers();\"><md-icon style=\"color: white\" md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon>\n{{\'ORGANIZATIONS.MEMBERS\'|translate}}</md-button><md-button id=\"btn-navbar-memberships\" class=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'MEMBERSHIPS\'), \'blue-grey-700-bg\': (selectedPage !== \'MEMBERSHIPS\')}\" \nng-click=\"gotoMembershipsIndex();\"><md-icon style=\"color: white\" md-font-icon=\"icon-credit-card-multiple\" class=\"s24\">\n</md-icon>Soci</md-button><md-button id=\"btn-navbar-services\" class=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'SERVICES\'), \'blue-grey-700-bg\': (selectedPage !== \'SERVICES\')}\" \nng-click=\"gotoServices();\"><md-icon style=\"color: white\" md-font-icon=\"icon-calendar-multiple\" class=\"s24 ml-16\">\n</md-icon>{{\'ORGANIZATIONS.OFFERED_SERVICES.OFFERED_SERVICES_AND_SUBSCRIPTIONS\'|translate}}</md-button><md-button \nid=\"btn-navbar-carnet\" class=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'CARNET\'), \'blue-grey-700-bg\': (selectedPage !== \'CARNET\')}\" \nng-click=\"gotoCarnet();\"><md-icon style=\"color: white\" md-font-icon=\"icon-tag-multiple\" class=\"s24 ml-16\"></md-icon>\n{{\'ORGANIZATIONS.OFFERED_SERVICES.CARNET\'|translate}}</md-button><md-button id=\"btn-navbar-earningcosts\" \nclass=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'EARNING_COSTS\'), \'blue-grey-700-bg\': (selectedPage !== \'EARNING_COSTS\')}\" \nng-click=\"gotoEarningCosts();\"><md-icon style=\"color: white\" md-font-icon=\"icon-coin\" class=\"s24\"></md-icon>\n{{\'ORGANIZATIONS.EARNING_COSTS\'|translate}}</md-button><md-button id=\"btn-navbar-events\" class=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'EVENTS\'), \'blue-grey-700-bg\': (selectedPage !== \'EVENTS\')}\" \nng-click=\"gotoEvents();\"><md-icon style=\"color: white\" md-font-icon=\"icon-calendar-check\" class=\"s24\"></md-icon>\n{{\'ORGANIZATIONS.OFFERED_SERVICES.EVENTS\'|translate}}</md-button><md-button id=\"btn-navbar-resources\" \nclass=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'RESOURCES\'), \'blue-grey-700-bg\': (selectedPage !== \'RESOURCES\')}\" \nng-click=\"gotoResources();\"><md-icon style=\"color: white\" md-font-icon=\"icon-package\" class=\"s24\"></md-icon>\n{{\'ORGANIZATIONS.RESOURCES.RESOURCES\'|translate}}</md-button><md-button id=\"btn-navbar-settings\" \nclass=\"md-raised white-fg\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'SETTINGS\'), \'blue-grey-700-bg\': (selectedPage !== \'SETTINGS\')}\" \nng-click=\"goToOrganizationSettings();\"><md-icon style=\"color: white\" md-font-icon=\"icon-cog\" class=\"s24\"></md-icon>\n{{\'ORGANIZATIONS.SETTINGS\'|translate}}</md-button></div></div></div>");
$templateCache.put("app/main/directives/ov-organization-alert/ov-organization-alert.html","<div><div class=\"md-padding md-subhead pink-bg\" ng-if=\"showOrganizationAlert\"><div layout=\"column\" \nlayout-align=\"start center\" class=\"white-fg\">{{message}}<div layout=\"row\"><md-button ng-click=\"goToSettings()\" \nclass=\"md-raised md-accent\" ng-if=\"isPayDue\">Gestisci il tuo piano</md-button><md-button ng-click=\"goToSettings()\" \nclass=\"md-raised md-accent\" ng-if=\"isMaxContacts\">Effettua upgrade</md-button><md-button ng-click=\"goToContacts()\" \nclass=\"md-raised md-accent\" ng-if=\"isMaxContacts\">Gestisci i contatti</md-button></div></div></div></div>");
$templateCache.put("app/main/directives/ov-profile-navigation-bar/ov-profile-navigation-bar.html","<div layout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><div layout=\"column\" \nclass=\"margin-right-15 margin-top-5\"></div><div layout=\"column\" class=\"margin-right-10\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><md-button id=\"btn-profilenavbar-members\" \nclass=\"md-raised white-fg pulsante-aggiuntivo-menu\" ng-click=\"gotoMembers();\" ng-if=\"isUserDetail\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'PROFILE\'), \'blue-grey-700-bg\': (selectedPage !== \'PROFILE\')}\" \ntitle=\"Tutte le persone\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24 ml-16 white-fg\"></md-icon>\n</md-button></div></div><div layout=\"column\" ng-if=\"isChild\" class=\"margin-right-10\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><md-button id=\"btn-profilenavbar-parent\" \nclass=\"md-raised white-fg pulsante-aggiuntivo-menu\" ng-click=\"gotoParent()\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'PROFILE\'), \'blue-grey-700-bg\': (selectedPage !== \'PROFILE\')}\" \ntitle=\"Torna alla scheda del genitore\"><md-icon md-font-icon=\"icon-arrow-up-bold-circle-outline\" \nclass=\"s24 ml-16 white-fg\"></md-icon></md-button></div></div><div layout=\"column\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><md-button id=\"btn-profilenavbar-profile\" \nng-if=\"!isUserDetail\" class=\"md-raised white-fg\" ng-click=\"gotoProfile();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'PROFILE\'), \'blue-grey-700-bg\': (selectedPage !== \'PROFILE\')}\">\n<md-icon md-font-icon=\"icon-apps\" class=\"s24 ml-16 white-fg\"></md-icon>Bacheca</md-button><md-button \nid=\"btn-profilenavbar-detail\" ng-if=\"isUserDetail\" class=\"md-raised white-fg\" ng-click=\"gotoUserDetail();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'DETAIL\'), \'blue-grey-700-bg\': (selectedPage !== \'DETAIL\')}\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24 ml-16 white-fg\"></md-icon>Scheda</md-button><md-button \nid=\"btn-profilenavbar-relatives\" ng-hide=\"isChild\" ng-if=\"isParentManagementEnabled\" class=\"md-raised white-fg\" \nng-click=\"gotoRelatives();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'RELATIVES\'), \'blue-grey-700-bg\': (selectedPage !== \'RELATIVES\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-human-child\" class=\"s24\"></md-icon>Figli</md-button><md-button \nid=\"btn-profilenavbar-parents\" ng-hide=\"!isChild\" ng-if=\"isParentManagementEnabled\" class=\"md-raised white-fg\" \nng-click=\"gotoParents();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'PARENTS\'), \'blue-grey-700-bg\': (selectedPage !== \'PARENTS\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-human-child\" class=\"s24\"></md-icon>Genitore</md-button><md-button \nid=\"btn-profilenavbar-services\" ng-if=\"!isUserDetail\" class=\"md-raised white-fg\" ng-click=\"gotoServices();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'SERVICES\'), \'blue-grey-700-bg\': (selectedPage !== \'SERVICES\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-calendar-multiple\" class=\"s24\"></md-icon>\n{{\'USERS.OFFERED_SERVICES\'|translate}}</md-button><md-button id=\"btn-profilenavbar-subscriptions\" ng-if=\"isUserDetail\" \nclass=\"md-raised white-fg\" ng-click=\"gotoSubscriptions();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'SUBSCRIPTIONS\'), \'blue-grey-700-bg\': (selectedPage !== \'SUBSCRIPTIONS\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-calendar-multiple\" class=\"s24\"></md-icon>\n{{\'USERS.OFFERED_SERVICES\'|translate}}</md-button><md-button id=\"btn-profilenavbar-attendances\" \nclass=\"md-raised white-fg\" ng-click=\"gotoProfileAttendances();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'ATTENDANCES\'), \'blue-grey-700-bg\': (selectedPage !== \'ATTENDANCES\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-account-check\" class=\"s24\"></md-icon>\n{{\'ATTENDANCES.PROFILE_ATTENDANCES\'|translate}}</md-button><md-button id=\"btn-profilenavbar-documents\" \nclass=\"md-raised white-fg\" ng-click=\"gotoDocuments();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'DOCUMENTS\'), \'blue-grey-700-bg\': (selectedPage !== \'DOCUMENTS\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-file-multiple\" class=\"s24\"></md-icon>{{\'USERS.DOCUMENTS\'|translate}}\n</md-button><md-button id=\"btn-profilenavbar-payments\" class=\"md-raised white-fg\" ng-click=\"gotoPayments();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'PAYMENTS\'), \'blue-grey-700-bg\': (selectedPage !== \'PAYMENTS\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-cash-100\" class=\"s24\"></md-icon>{{\'USERS.PAYMENTS\'|translate}}\n</md-button><md-button id=\"btn-profilenavbar-settings\" ng-if=\"!isUserDetail\" class=\"md-raised white-fg\" \nng-click=\"gotoSettings();\" \nng-class=\"{\'blue-grey-400-bg\': (selectedPage === \'SETTINGS\'), \'blue-grey-700-bg\': (selectedPage !== \'SETTINGS\')}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-cog\" class=\"s24\"></md-icon>{{\'USERS.SETTINGS\'|translate}}</md-button>\n</div></div><div layout=\"column\" class=\"margin-left-10\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"center center\"><md-button id=\"btn-profilenavbar-message\" ng-if=\"isUserDetail && userId != currentUserId\" \nclass=\"md-raised white-fg blue-grey-700-bg md-accent md-button pulsante-aggiuntivo-menu\" \ntitle=\"{{\'USERS.SEND_MESSAGE\' | translate}}\" translate-attr-aria-label=\"USERS.SEND_MESSAGE\" \nng-click=\"sendMessage($event)\"><md-icon md-font-icon=\"icon-message-text-outline\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/directives/ov-subscriber-payments-cell/ov-subscriber-payments-cell.html","<div ng-init=\"init();\"><span class=\"md-body-2\" ng-class=\"(paymentdue > paymentdone ? \'red-900-fg\' : \'green-900-fg\')\">\n<span ng-if=\"paymentdue > paymentdone\">In scadenza:</span> <span ng-if=\"paymentdue <= paymentdone && paymentdue > 0\">\nPagato </span><span ng-if=\"paymentdue <= paymentdone && paymentdue == 0\">Evviva, nulla da pagare :-) </span><span \nng-if=\"paymentdue > 0\">{{ paymentdone }} su {{ paymentdue }}&euro;</span></span><br><span class=\"secondary-text\">\nTotale piano: {{ paymenttotaldone }} su {{ paymenttotal }}&euro;</span></div>");
$templateCache.put("app/main/directives/ov-subscription-carnet-status/ov-subscription-carnet-status.html","<div ng-init=\"init();\" class=\"ov-subscription-carnet-status\"><div ng-repeat=\"order in carnetstatus\" \nn_g-if=\"order.attendanceCount != order.numMaxAccessForOrder\" class=\"carnet-item\" layout=\"row\" \nlayout-align=\"center start\"><div layout=\"column\" layout-align=\"start center\" class=\"carnet-brief\"><md-progress-linear \nmode=\"determinate\" ng-if=\"order.numMaxAccessForOrder>0\" \nng-class=\"order.attendanceCount > order.numMaxAccessForOrder ? \'ov-mood-error\' : (order.attendanceCount < order.numMaxAccessForOrder ? \'ov-mood-positive\' : \'ov-mood-warning\')\" \nvalue=\"{{ order.attendanceCount / order.numMaxAccessForOrder * 100 }}\"></md-progress-linear><span \ntitle=\"{{ order.subscription.offeredService.name }}\" aria-label=\"{{ order.subscription.offeredService.name }}\" \nng-class=\"order.attendanceCount >= order.numMaxAccessForOrder ? \'carnet-overused-count\' : \'\'\">\n{{ order.attendanceCount }}/{{ order.numMaxAccessForOrder }}</span><md-icon class=\"icon icon-alert md-warn\" \nng-if=\"order.attendanceCount > order.numMaxAccessForOrder\" style=\"font-size: 24px\"></md-icon></div><div \nlayout=\"column\" layout-align=\"start start\" class=\"carnet-detail\"><span>{{ order.subscription.offeredService.name }}\n</span> <span><md-button ng-click=\"renewSubscription($event, order);\">Rinnova</md-button></span></div></div></div>");
$templateCache.put("app/main/directives/ov-subscription-payments-status/ov-subscription-payments-status.html","<div ng-init=\"init();\"><div><md-progress-linear mode=\"determinate\" ng-if=\"todaydue-todaypaid>0\" \nclass=\"ov-mood-warning\" \naria-label=\"Pagato {{ todaypaid | number : 2 }} di {{ todaydue | number : 2 }}&euro;. Da pagare {{ todaydue-todaypaid | number : 2 }}&euro;\" \nvalue=\"{{ todaypaid/todaydue*100 }}\"></md-progress-linear><md-progress-linear mode=\"determinate\" \nng-if=\"todaydue-todaypaid<=0\" class=\"ov-mood-positive\" \naria-label=\"Pagato {{ todaypaid | number : 2 }} di {{ todaydue | number : 2 }}&euro;. Da pagare {{ todaydue-todaypaid | number : 2 }}&euro;\" \nvalue=\"100\"></md-progress-linear></div><div class=\"ov-text-muted\"><strong>\nDa pagare {{ todaydue-todaypaid | number : 2 }}&euro;.</strong> <span ng-if=\"todaydue>0\">\nPagato ad oggi {{ todaypaid | number : 2 }} di {{ todaydue | number : 2 }}&euro;.</span></div><div \nclass=\"ov-text-muted ov-text-hint\"><span ng-if=\"totaldue>0\">\nTotale piano: {{ totalpaid | number : 2 }} di {{ totaldue | number : 2 }}&euro;. Da pagare {{ totaldue-totalpaid | number : 2 }}&euro;\n</span></div></div>");
$templateCache.put("app/main/pages/attendances/attendance_detail.html","<div class=\"page-layout simple white-bg md-padding\" layout=\"column\" ng-if=\"vm.isAdmin || vm.isStaff\"><div \nclass=\"content white-bg md-padding\" layout-align=\"center center\"><ov-navigation-bar ng-if=\"vm.isAdmin\" \norganization-id=\"{{vm.organization.id}}\" selected-page=\"SERVICES\"></ov-navigation-bar><div \nclass=\"contenitore-pagina-padding-e-ombra\"><div layout-align=\"start start\"><div layout=\"row\"><div layout=\"column\" \nflex=\"60\"><span class=\"md-display-1\">{{vm.offeredService.name}}</span><p>{{\'ATTENDANCES.HINT_DETAIL\' | translate}}</p>\n</div><div layout=\"column\" flex=\"30\"><span>Presenze del<md-datepicker ng-model=\"vm.currentDate\" \nng-change=\"vm.loadAttendances()\" md-max-date=\"vm.today\"></md-datepicker></span></div><div layout=\"column\" flex=\"10\">\n<md-button class=\"md-accent md-fab md-mini\" ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-undo-variant\" \nclass=\"md-primary\"></md-icon></md-button></div></div></div><br><br><div layout=\"row\"><div layout=\"column\" flex=\"60\">\n<md-checkbox ng-model=\"vm.selectAll\" ng-change=\"vm.doSelectAll(subscriber.id)\"><cite>Seleziona / Deseleziona tutti\n</cite></md-checkbox><br><div layout=\"row\" ng-repeat=\"subscriber in vm.offeredService.subscribers\"><md-checkbox \nng-model=\"vm.attendancesUsers[subscriber.id]\">{{subscriber.familyName}} {{subscriber.givenName}}</md-checkbox></div>\n</div><div layout=\"column\" flex=\"40\"><md-input-container flex><label>Note</label><textarea \nng-model=\"vm.attendanceNote\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container><div \nclass=\"white-fg ov-floating-btn\"><md-button class=\"md-raised md-accent md-fab\" ng-click=\"vm.saveAll()\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/attendances/attendances.html","<div id=\"subscriptions\" class=\"page-layout simple right-sidenav\" style=\"background-color:white\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"padding-0 margin-bottom-15\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"h-100 p-16 md-grey-200-bg\"><div \nlayout=\"row\" layout-align=\"end start\" div class=\"grey-800-fg md-inline-form\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"grey-800-fg\"><label translate=\"ATTENDANCES.SERVICE\" required class=\"grey-800-fg\">Service</label>\n<md-select id=\"service-filter\" ng-model=\"vm.searchFiler.service\" ng-change=\"vm.doAttendancesSearch()\" \nstyle=\"border-bottom-color:white\"><md-option ng-value=\"service\" \nng-selected=\"{{ vm.searchFiler.service.id === service.id ? \'true\' : \'false\' }}\" \nng-repeat=\"service in vm.organizationServices track by service.id\">{{service.name}}</md-option></md-select>\n</md-input-container></div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center\" \nclass=\"margin-top-80\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<div layout=\"row\" ng-show=\"!vm.loading\"><table class=\"dataTable row-border hover\" id=\"subscribers-table\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionAttendances\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Num.</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Note.</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr \nng-repeat=\"attendance in vm.serviceAttendances track by $index\"><td>{{vm.formatDateFromDay(attendance.day)}}</td><td>\n{{attendance.num}}</td><td>{{attendance.note}}</td><td><md-button \nclass=\"edit-button md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" \nng-click=\"vm.goToAttendanceDetail(attendance.day)\"><md-icon md-font-icon=\"icon-pencil\" \ntitle=\"{{\'PAGES.MANAGE\' | translate}}\"></md-icon></md-button></td></tr></tbody></table></div><div \nclass=\"white-fg ov-floating-btn\"><md-button ng-if=\"vm.isStaffOrAdmin() && vm.isAttendanceStandalonePage\" \ntitle=\"Aggiungi presenze\" class=\"md-fab md-raised md-accent\" ng-click=\"vm.goToAttendanceDetail()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/pages/dispatcher/dispatcher.html","<div id=\"dispatcher\" class=\"page-layout simple right-sidenav\" layout=\"row\"></div>");
$templateCache.put("app/main/pages/docs_validation/docs_validation.html","<div id=\"docs_validation\" class=\"page-layout simple right-sidenav\" style=\"background-color:white\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div class=\"header md-blue-grey-50-bg\" layout=\"column\" layout-align=\"space-between\" \nid=\"docs_validation_header\"><div layout=\"row\" layout-align=\"space-between\"><div><span \nclass=\"md-display-1 font-weight-300\">{{\'DOCS_VALIDATION.TITLE\' | translate }}</span></div></div>\n{{vm.serviceName}}: {{vm.userDisplayName}}</div><div class=\"content\"><table class=\"simple\" ms-responsive-table=\"\">\n<thead><tr><th>{{\'DOCS_VALIDATION.DOCUMENT\' | translate}}</th><th>{{\'DOCS_VALIDATION.VALIDATION_STATE\' | translate}}\n</th><th>{{\'DOCS_VALIDATION.DATE_TO_VALID\' | translate}}</th><th>{{\'DOCS_VALIDATION.PAPER_DOCUMENT\' | translate}}</th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"doctype in vm.doctypes\"><td><a \nng-if=\"vm.serviceDocuments[doctype.organizationDoctype.id] && vm.serviceDocuments[doctype.organizationDoctype.id]!==null && vm.serviceDocuments[doctype.organizationDoctype.id].uri && !vm.serviceDocuments[doctype.organizationDoctype.id].isPaperDoc\" \nng-href=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.serviceDocuments[doctype.organizationDoctype.id].userDocument.userId }}/download/{{ vm.serviceDocuments[doctype.organizationDoctype.id].uri }}?access_token={{ vm.accessToken }}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-download\"></md-icon>{{doctype.organizationDoctype.name}}</a> <span \nng-if=\"!vm.serviceDocuments[doctype.organizationDoctype.id] || vm.serviceDocuments[doctype.organizationDoctype.id]===null || !vm.serviceDocuments[doctype.organizationDoctype.id].uri || vm.serviceDocuments[doctype.organizationDoctype.id].isPaperDoc\">\n{{doctype.organizationDoctype.name}}</span></td><td><md-input-container flex \nng-if=\"vm.serviceDocuments[doctype.organizationDoctype.id].flgValidated===0\"><span style=\"font-weight: bolder\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.TO_BE_VALIDATED\' | translate}}</span></md-input-container><md-input-container flex \nng-if=\"vm.serviceDocuments[doctype.organizationDoctype.id].flgValidated<0\"><span \nstyle=\"color: red; font-weight: bolder\">{{\'OFFERED_SERVICES.DOCUMENT_IS_NOT_VALID\' | translate}}</span>\n</md-input-container><md-input-container flex \nng-if=\"vm.serviceDocuments[doctype.organizationDoctype.id].flgValidated>0\"><span \nstyle=\"color: green; font-weight: bolder\">{{\'OFFERED_SERVICES.DOCUMENT_IS_VALID\' | translate}}</span>\n</md-input-container><md-input-container flex \nng-if=\"!vm.serviceDocuments[doctype.organizationDoctype.id] || vm.serviceDocuments[doctype.organizationDoctype.id]===null\">\n<span style=\"color: red; font-weight: bolder\">{{\'OFFERED_SERVICES.SUBSCRIBER.MISSING_DOCUMENT\' | translate}}</span>\n</md-input-container></td><td><md-datepicker ng-model=\"vm.serviceDocuments[doctype.organizationDoctype.id].validTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.VALID_UNTIL\' | translate }}\"></md-datepicker></td><td><md-checkbox \nng-model=\"vm.serviceDocuments[doctype.organizationDoctype.id].isPaperDoc\"></md-checkbox></td><td><div layout=\"column\">\n<md-button title=\"{{\'OFFERED_SERVICES.SUBSCRIBER.VALIDATE\' | translate}}\" class=\"md-raised md-accent\" \nng-disabled=\"!vm.serviceDocuments[doctype.organizationDoctype.id] || vm.serviceDocuments[doctype.organizationDoctype.id]===null || (!vm.serviceDocuments[doctype.organizationDoctype.id].isPaperDoc && !vm.serviceDocuments[doctype.organizationDoctype.id].uri)\" \nng-click=\"vm.validateSubscriptionDocument($event,vm.serviceDocuments[doctype.organizationDoctype.id], 1, doctype.organizationDoctype.id)\" \naria-label=\"Validate\"><md-icon md-font-icon=\"icon-check\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.SUBSCRIBER.VALIDATE\' | translate}}</md-button><md-button \ntitle=\"{{\'OFFERED_SERVICES.SUBSCRIBER.REJECT\' | translate}}\" class=\"md-raised md-warn\" \nng-disabled=\"!vm.serviceDocuments[doctype.organizationDoctype.id] || vm.serviceDocuments[doctype.organizationDoctype.id]===null || (!vm.serviceDocuments[doctype.organizationDoctype.id].isPaperDoc && !vm.serviceDocuments[doctype.organizationDoctype.id].uri)\" \nng-click=\"vm.validateSubscriptionDocument($event,vm.serviceDocuments[doctype.organizationDoctype.id], -1, doctype.organizationDoctype.id)\" \naria-label=\"Reject\"><md-icon md-font-icon=\"icon-close\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.SUBSCRIBER.REJECT\' | translate}}</md-button></div></td></tr></tbody></table></div></div><div \nlayout=\"row\" style=\"position: fixed; right: 100px; bottom: 30px; z-index: 9999\"><md-button \naria-label=\"Torna alla pagina precedente\" ng-click=\"vm.goBack();\" class=\"md-icon-button md-fab md-raised md-accent\" \ntitle=\"Torna alla pagina precedente\"><md-icon md-font-icon=\"icon-undo-variant\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/earningcosts/earningcosts.html","<div class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" ms-scroll layout=\"column\" \nid=\"page-earningcosts\" ng-init=\"vm.init();\"><div class=\"content\"><ov-organization-alert \norganization-id=\"{{vm.organization.id}}\"></ov-organization-alert><ov-navigation-bar \norganization-id=\"{{vm.organization.id}}\" selected-page=\"EARNING_COSTS\"></ov-navigation-bar><div \nclass=\"contenitore-pagina-padding-e-ombra\"><div layout=\"row\" layout-align=\"end center\" flex><md-switch \nng-model=\"vm.showAllMyOrganizations\" ng-change=\"vm.reloadEntries()\" \naria-label=\"Mostra i pagamenti di tutte le associazioni che amministro\">\nMostra i pagamenti di tutte le associazioni che amministro</md-switch></div><div class=\"ov-box ov-box-filters\" flex \nflex=\"100\"><div flex flex=\"100\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.searchFilters.loading.filtersData\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div flex flex=\"100\" layout=\"row\" \nng-if=\"!vm.searchFilters.loading.filtersData\"><div flex=\"25\" layout=\"row\" class=\"filter-container\"><md-input-container \nclass=\"width-50perc\"><label>Dal</label><input type=\"date\" ng-model=\"vm.searchFilters.dtFrom\"></md-input-container>\n<md-input-container class=\"width-50perc\"><label>Al</label><input type=\"date\" ng-model=\"vm.searchFilters.dtTo\">\n</md-input-container></div><div flex=\"25\" class=\"filter-container\"><label>Servizio</label><md-autocomplete \nmd-selected-item=\"vm.searchFilters.selectedOfferedService\" md-search-text=\"searchTextOfferedService\" \nmd-items=\"item in vm.getMatchingOfferedServices(searchTextOfferedService)\" md-min-length=\"2\" \nplaceholder=\"Digita un servizio...\" md-item-text=\"item.name\"><md-item-template><span md-highlight-text=\"searchText\">\n{{ item.name }}</span></md-item-template><md-not-found>Nessun elemento trovato</md-not-found></md-autocomplete></div>\n<div flex=\"25\" class=\"filter-container\"><label>Persona</label><md-autocomplete \nmd-selected-item=\"vm.searchFilters.selectedUser\" md-search-text=\"searchTextUser\" \nmd-items=\"item in vm.getMatchingUsers(searchTextUser)\" md-min-length=\"2\" placeholder=\"Cerca in rubrica...\" \nmd-item-text=\"item.displayName\"><md-item-template><span md-highlight-text=\"searchText\">\n{{ item.familyName.toUpperCase() }} {{ item.givenName.toUpperCase() }}</span></md-item-template><md-not-found>\nNessun elemento trovato</md-not-found></md-autocomplete></div><div flex=\"25\" class=\"filter-container\">\n<md-input-container><md-select ng-model=\"vm.searchFilters.paymentReasonId\" placeholder=\"Filtra per causale\"><md-option \nng-value=\"null\">- ignora -</md-option><md-option ng-value=\"-999999\">- senza causale -</md-option><md-option \nng-value=\"paymentReason.id\" ng-repeat=\"paymentReason in vm.searchFilters.lists.paymentReasons\">{{ paymentReason.name }}\n</md-option></md-select></md-input-container></div></div><div flex flex=\"100\" layout=\"row\" \nng-if=\"!vm.searchFilters.loading.filtersData\"><div flex=\"25\" layout=\"row\" class=\"filter-container\"><md-input-container \nclass=\"width-50perc\"><label>Importo da</label><input type=\"number\" ng-model=\"vm.searchFilters.entryValueFrom\">\n</md-input-container><md-input-container class=\"width-50perc\"><label>a</label><input type=\"number\" \nng-model=\"vm.searchFilters.entryValueTo\"></md-input-container></div><div flex=\"25\" class=\"filter-container\">\n<md-input-container><label>Descrizione</label><input type=\"text\" ng-model=\"vm.searchFilters.description\">\n</md-input-container></div><div flex=\"25\" class=\"filter-container\"></div><div flex=\"25\" layout=\"row\" \nlayout-align=\"end center\" class=\"filter-container\"><md-button class=\"md-raised\" ng-click=\"vm.cleanFilters();\">\nPulisci filtri</md-button><md-button class=\"md-raised\" ng-click=\"vm.reloadEntries();\">Aggiorna</md-button></div></div>\n</div><div layout=\"column\" flex=\"100\"><table style=\"width: 100%\" datatable=\"\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\"></table><div flex flex=\"100\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.searchFilters.loading.data\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></div></div><div \nclass=\"ov-floating-btn contenitore-button-fixed\"><md-button id=\"btn-export-earningcosts\" layout-align=\"end center\" \ntitle=\"Export excel\" class=\"md-raised md-accent esporta-excel md-fab\" ng-click=\"vm.exportExcel()\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"md-primary\"></md-icon>Export</md-button><md-button id=\"btn-add-earningcost\" \ntitle=\"{{\'EARNING_COST.ADD\' | translate}}\" class=\"md-fab md-raised md-accent\" ng-click=\"vm.askEntryDetails()\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/invitations/invitations.html","<div id=\"invitations\" class=\"page-layout simple right-sidenav\" style=\"background-color:white\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div class=\"md-blue-grey-50-bg height-150\" layout=\"row\" ng-style=\"vm.backgroundImage()\" \nlayout-align=\"center start\" layout-align-gt-sm=\"space-between start\"><div layout=\"column md-padding\"><div \nclass=\"user-info md-padding\" layout=\"column\" layout-align=\"center start\" layout-align-gt-sm=\"start center\"><div \nlayout=\"row\"><span class=\"md-display-1\">{{\'OFFERED_SERVICES.SEND_INVITATION_TO_SUBSCRIBERS\' | translate}}</span></div>\n<div><span class=\"md-subhead name\">{{ vm.offeredService.name }}</span></div></div></div></div><div class=\"content\"><div\n layout=\"column\"><div layout=\"row\"><md-checkbox layout=\"column\" flex=\"40\" ng-model=\"vm.selectAll\" \nng-change=\"vm.doSelectAll()\">Seleziona / Deseleziona tutti</md-checkbox><md-button flex=\"30\" class=\"md-accent\" \nng-click=\"vm.inviteAll()\" ng-disabled=\"!vm.isOneSelected()\"><md-icon md-font-icon=\"icon-send\" class=\"md-primary\">\n</md-icon>Spedisci invito ai selezionati</md-button><md-input-container flex=\"30\" flex-gt-xs=\"30\"><label>Iscritti\n</label><md-select ng-model=\"vm.searchStatus\" ng-change=\"vm.loadOfferedService()\"><md-option value=\"\">\n{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option value=\"ACCEPTED\">Inviti accettati</md-option><md-option \nvalue=\"REFUSED\">Inviti rifiutati</md-option><md-option value=\"MAYBE\">Partecipazioni in forse</md-option><md-option \nvalue=\"SENT\">Inviti senza risposta</md-option></md-select></md-input-container></div><table \nclass=\"dataTable row-border hover\"><tr ng-repeat=\"subscriber in vm.offeredService.subscribers\"><td><md-checkbox \nng-if=\"!vm.invitationsUsers[subscriber.userId] || !vm.invitationsUsers[subscriber.userId].status || vm.invitationsUsers[subscriber.userId].status === \'SENT\'\" \nng-model=\"vm.selectedUser[subscriber.userId]\">{{ subscriber.familyName }} {{ subscriber.givenName }}</md-checkbox>\n<md-checkbox ng-disabled=\"true\" \nng-if=\"vm.invitationsUsers[subscriber.userId].status === \'ACCEPTED\' || vm.invitationsUsers[subscriber.userId].status === \'REFUSED\' || vm.invitationsUsers[subscriber.userId].status === \'MAYBE\'\">\n{{ subscriber.familyName }} {{ subscriber.givenName }}</md-checkbox></td><td><span \nng-if=\"!subscriber.email.endsWith(\'.invalid\')\">{{ subscriber.email }}</span></td><td><span \nng-if=\"vm.invitationsUsers[subscriber.userId].status === \'SENT\'\">\nInvito inviato in data {{vm.formatDate(vm.invitationsUsers[subscriber.userId].lastSent)}}</span> <span \nng-if=\"vm.invitationsUsers[subscriber.userId].status === \'ACCEPTED\'\" class=\"green-fg\"><strong>Invito accettato</strong>\n</span> <span ng-if=\"vm.invitationsUsers[subscriber.userId].status === \'REFUSED\'\" class=\"red-fg\"><strong>\nInvito rifiutato</strong></span> <span ng-if=\"vm.invitationsUsers[subscriber.userId].status === \'MAYBE\'\" \nclass=\"red-fg\"><strong>Forse parteciperà</strong></span></td><td><md-button \nng-if=\"!vm.invitationsUsers[subscriber.userId] || !vm.invitationsUsers[subscriber.userId].status || vm.invitationsUsers[subscriber.userId].status === \'SENT\'\" \nclass=\"md-accent\" ng-click=\"vm.sendInvitation(subscriber.userId)\"><md-icon md-font-icon=\"icon-send\" class=\"md-primary\">\n</md-icon>{{ (vm.invitationsUsers[subscriber.userId].status === \'SENT\') ? \'Rispedisci invito\' : \'Invita\'}}</md-button>\n</td></tr></table></div></div></div></div>");
$templateCache.put("app/main/pages/invitations/public_invitation.html","<div id=\"publicpage\" class=\"page-layout simple tabbed white-bg\" layout=\"column\"><div id=\"publicpage_header\" \nclass=\"md-padding\" class=\"blue-grey-100-bg\" layout=\"row\" layout-align=\"center start\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"blue-grey-100-bg\" layout-align=\"start center\" flex=\"100\" style=\"height: 100%\"><div \nng-style=\"vm.backgroundImage()\" layout-align=\"center center\" layout=\"column\" flex-gt-sm=\"60\" flex=\"100\" hide-xs \nng-if=\"vm.offeredService.organization.uriLogo && vm.offeredService.organization.uriLogo!==null && vm.offeredService.organization.uriLogo!==\'\'\">\n<img class=\"md-avatar avatar contact-avatar huge\" ng-src=\"{{vm.logoImageUrl}}\"></div><div layout-align=\"center center\" \nlayout=\"column\" flex-gt-sm=\"40\" flex=\"100\"><div class=\"md-display-1\" style=\"text-align: center\">\n{{vm.offeredService.name}}</div><div class=\"md-title\">{{vm.offeredService.organization.name}}</div></div></div></div>\n<div class=\"content md-padding white-bg\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex=\"100\"><div layout=\"column\" flex=\"100\" \nclass=\"md-padding\" flex-gt-sm=\"75\"><div ng-if=\"vm.offeredService.description\"><div class=\"md-title\">\n{{\'OFFERED_SERVICES.DESCRIPTION\' | translate}}</div><p>{{vm.offeredService.description}}</p></div><form \nname=\"subscriptionForm\" novalidate style=\"max-width: 900px;     width: 100%\"><h1>\nCiao {{vm.invitation.user.displayName}}, parteciperai all\'evento?</h1><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><md-button ng-class=\"{ \'md-raised\' : vm.invitation.status === \'ACCEPTED\'}\" \nclass=\"md-accent\" flex=\"100\" ng-click=\"vm.saveInvitation(\'ACCEPTED\');\" flex=\"100\"><md-icon \nng-if=\"vm.invitation.status === \'ACCEPTED\'\" md-font-icon=\"icon-checkbox-marked-outline\" class=\"md-primary\"></md-icon>\n<md-icon ng-if=\"vm.invitation.status !== \'ACCEPTED\'\" md-font-icon=\"icon-checkbox-blank-outline\" class=\"md-primary\">\n</md-icon>Parteciperò</md-button><md-button ng-class=\"{ \'md-raised\' : vm.invitation.status === \'MAYBE\'}\" \nclass=\"md-accent\" flex=\"100\" ng-click=\"vm.saveInvitation(\'MAYBE\');\" flex=\"100\"><md-icon \nng-if=\"vm.invitation.status === \'MAYBE\'\" md-font-icon=\"icon-checkbox-marked-outline\" class=\"md-primary\"></md-icon>\n<md-icon ng-if=\"vm.invitation.status !== \'MAYBE\'\" md-font-icon=\"icon-checkbox-blank-outline\" class=\"md-primary\">\n</md-icon>Forse</md-button><md-button ng-class=\"{ \'md-raised\' : vm.invitation.status === \'REFUSED\'}\" class=\"md-accent\" \nflex=\"100\" ng-click=\"vm.saveInvitation(\'REFUSED\');\" flex=\"100\"><md-icon ng-if=\"vm.invitation.status === \'REFUSED\'\" \nmd-font-icon=\"icon-checkbox-marked-outline\" class=\"md-primary\"></md-icon><md-icon \nng-if=\"vm.invitation.status !== \'REFUSED\'\" md-font-icon=\"icon-checkbox-blank-outline\" class=\"md-primary\"></md-icon>\nNon parteciperò</md-button></div></form></div><div layout=\"column\" class=\"md-padding\" layout-align=\"start start\" \nflex=\"100\" flex-gt-sm=\"25\"><div ng-if=\"vm.offeredService.scheduleType === \'R\'\" layout=\"row\"><div layout=\"column\"><div \nclass=\"md-title\">Quando</div>Su richiesta</div></div><div ng-if=\"vm.offeredService.scheduleType === \'D\'\" layout=\"row\">\n<div><div class=\"md-title\">Quando</div>{{vm.formatDateFriendly(vm.offeredService.start)}}<br><span style=\"float: left\" \nng-if=\"vm.offeredService.hourFrom\">\n{{vm.offeredService.hourFrom}}:{{vm.offeredService.minutesFrom ? vm.offeredService.minutesFrom : \'00\'}}</span> <span \nng-if=\"vm.offeredService.hourTo\">\n-{{vm.offeredService.hourTo}}:{{vm.offeredService.minutesTo ? vm.offeredService.minutesTo : \'00\'}}</span></div></div>\n<div ng-if=\"vm.offeredService.scheduleType === \'P\'\" layout=\"row\"><div layout=\"column\"><div class=\"md-title\">Periodo\n</div>{{vm.formatDateFriendly(vm.offeredService.start)}} - {{vm.formatDateFriendly(vm.offeredService.end)}}<br></div>\n</div><div ng-if=\"vm.offeredService.address || (vm.offeredService.latitude && vm.offeredService.longitude)\" \nlayout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Dove</div>{{vm.offeredService.address}}\n<br><a ng-click=\"vm.scrollTo(\'theMap\')\" style=\"cursor: pointer\" \nng-if=\"vm.offeredService.latitude && vm.offeredService.longitude\">Mappa</a></div></div><div layout=\"row\" \nclass=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Prezzo</div><div \nng-if=\"vm.offeredService.paymentType === \'R\' || vm.offeredService.paymentType === \'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}}: {{vm.offeredService.subscriptionPrice ? vm.offeredService.subscriptionPrice : \'Gratuito\'}}\n<div ng-if=\"vm.offeredService.paymentType === \'R\'\">\n{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}}: {{vm.offeredService.renewalPrice}}</div></div><div \nng-if=\"vm.offeredService.paymentType === \'R\'\">{{\'OFFERED_SERVICES.RENEWAL\' | translate}}: <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span></div>\n</div></div><div ng-if=\"vm.offeredService.notes\" layout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div \nclass=\"md-title\">Note</div><p>{{vm.offeredService.notes}}</p></div></div></div></div><div id=\"theMap\" layout=\"row\" \nng-if=\"vm.offeredService.latitude && vm.offeredService.longitude\" class=\"md-padding margin-top-80\" flex=\"100\"><fieldset\n class=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\"></div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.offeredService.latitude ? vm.offeredService.latitude : 41.8919300}}\"> <input type=\"hidden\" \nclass=\"gllpLongitude\" value=\"{{vm.offeredService.longitude ? vm.offeredService.longitude : 12.5113300 }}\"> <input \ntype=\"hidden\" class=\"gllpZoom\" value=\"16\"></fieldset></div></div></div></div>");
$templateCache.put("app/main/pages/massive_notification/massive_notification.html","<div id=\"massive-notification\" ng-init=\"vm.init();\" class=\"page-layout simple white-bg md-padding\" layout=\"column\"><div\n class=\"content contenitore-pagina-padding-e-ombra\" layout=\"column\" flex=\"100\" ms-scroll><h1>Invio notifiche di massa\n</h1><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.loadingItems\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.loadingItems && vm.items.length === 0\" class=\"md-padding\">Nessun elemento da visualizzare</div><md-list \nflex ng-if=\"!vm.loadingItems\"><md-list-item class=\"md-2-line\" flex=\"100\"><md-checkbox flex=\"100\" \nng-click=\"vm.selectAllToggle();\"><div layout=\"row\" flex=\"100\"><div class=\"md-list-item-text\"><h3>\nSeleziona/deseleziona tutti</h3></div></div></md-checkbox></md-list-item><md-list-item class=\"md-2-line\" flex=\"100\" \nng-repeat=\"item in vm.items\"><md-checkbox ng-model=\"item.selected\" \naria-label=\"{{ item.givenName }} {{ item.familyName }}\" flex=\"100\" n_g-click=\"vm.selectItemToggle(item);\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"start center\"><img ng-if=\"!item.uriAvatar || item.uriAvatar === null\" \nclass=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img ng-if=\"item.uriAvatar && item.uriAvatar !== null\" \nclass=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{subscriber.id}}/download/{{ subscriber.uriAvatar }}\">\n<div class=\"md-list-item-text\"><h3>{{ item.givenName }} {{ item.familyName }}</h3><div layout=\"row\" flex=\"100\">\n{{ item.offeredServiceName }} &ndash; Pagato {{ item.todayPaid | number : 2 }} su {{ item.todayDue | number : 2 }}, mancanti: \n<strong>{{ (item.todayDue - item.todayPaid) | number : 2 }}&euro;</strong></div></div></div></md-checkbox>\n</md-list-item></md-list></div><div layout=\"column\" flex=\"50\"><md-input-container><label>Oggetto</label><input \nng-model=\"vm.subject\" required></md-input-container><md-input-container class=\"md-block md-padding\"><label>Messaggio\n</label><textarea ng-model=\"vm.message\" md-maxlength=\"500\" rows=\"10\" md-select-on-focus required></textarea>\n</md-input-container><div layout=\"row\" layout-align=\"end center\" class=\"md-padding\"><md-button title=\"Invia\" \nclass=\"md-icon-button md-raised md-accent\" \nng-disabled=\"!(vm.isSelectedSomeItem() && vm.message.trim().length > 0) || vm.sending\" \nng-click=\"vm.sendNotificationsConfirm();\" aria-label=\"invia\"><md-icon md-font-icon=\"icon-email\" class=\"md-primary\">\n</md-icon></md-button></div><div flex=\"100\" class=\"md-padding\" layout=\"column\" ng-if=\"vm.sending\" \nlayout-align=\"center center\"><md-progress-linear ng-if=\"false\" md-mode=\"determinate\" value=\"{{ vm.sendingProgress }}\">\n</md-progress-linear><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular><div flex=\"100\" layout=\"row\" layout-align=\"center center\" class=\"md-padding\">invio in corso...\n</div></div><div flex=\"100\" class=\"md-padding\" layout=\"column\" ng-if=\"vm.sent > 0\" layout-align=\"center center\"><div \nflex=\"100\" layout=\"row\" layout-align=\"center center\" class=\"md-padding\">Inviate {{ vm.sent }} notifiche</div></div>\n</div></div></div></div>");
$templateCache.put("app/main/pages/message/message.html","<div id=\"message\" class=\"page-layout simple white-bg md-padding\" layout=\"column\" \nstyle=\"height: 100%; text-align: center\"><div class=\"content white-bg md-padding\" layout-align=\"center center\"><div \nclass=\"margin-top-100\" layout-align=\"center center\" ng-if=\"vm.done\"><md-icon ng-if=\"vm.messageType===\'S\'\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-primary font-size-72 line-height-72\" \nstyle=\"font-size: 72px; color: green; margin: 4rem\"></md-icon><md-icon ng-if=\"vm.messageType===\'I\'\" \nmd-font-icon=\"icon-information-outline\" class=\"md-primary font-size-72 line-height-72\" \nstyle=\"font-size: 72px; margin: 4rem\"></md-icon><md-icon ng-if=\"vm.messageType===\'E\'\" md-font-icon=\"icon-alert-circle\" \nclass=\"md-primary font-size-72 line-height-72\" style=\"font-size: 72px; color: red; margin: 4rem\"></md-icon><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-36 line-height-48\">\n{{\'MESSAGE.\'+vm.messageCode | translate}}</div><br><br><div class=\"font-size-18 line-height-24\">\n{{ vm.submessage | translate}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/notifications/notifications.html","<div id=\"notifications\" class=\"page-layout simple right-sidenav white-bg\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"content\"><div layout=\"row\" layout-align=\"center center\"><div><span \nclass=\"md-display-1 font-weight-300\">{{\'NOTIFICATIONS.NOTIFICATIONS\' | translate }}</span></div></div><div \nlayout=\"row\" layout-align=\"start start\"><md-button title=\"{{\'NOTIFICATIONS.DELETE_SELECTED\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.deleteSelected()\" aria-label=\"Delete selected\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-primary\"></md-icon></md-button><md-button \ntitle=\"{{\'NOTIFICATIONS.MARK_AS_READ\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.markSelectedAsRead()\" aria-label=\"Mark as read\"><md-icon md-font-icon=\"icon-check\" class=\"md-primary\">\n</md-icon></md-button><md-button title=\"{{\'NOTIFICATIONS.RELOAD\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.reloadNotifications()\" aria-label=\"Reload\"><md-icon \nmd-font-icon=\"icon-reload\" class=\"md-primary\"></md-icon></md-button></div><div layout=\"row\"><table datatable=\"\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\"></table></div>\n</div></div></div>");
$templateCache.put("app/main/pages/payments/pay_app_subscription.html","<div class=\"page-layout simple white-bg md-padding\" layout=\"column\" style=\"height: 100%; text-align: center\" \nng-init=\"vm.init();\"><div class=\"content white-bg md-padding\" layout-align=\"center center\"><div \nlayout-align=\"center center\" class=\"padding-80\"><div class=\"font-size-36 line-height-36 padding-30\">Esito pagamento\n</div></div><div layout-align=\"center center\" class=\"padding-40\"><div class=\"font-size-24 line-height-36 padding-30\" \nng-if=\"vm.status==\'ok\'\"><md-icon class=\"icon icon-check green-fg\"></md-icon>Grazie, il pagamento è stato ricevuto.<br>\nPupi tornare all\'app e, quando riceverai la notifica, troverai aggiornato lo stato del servizio.</div><div \nclass=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.status==\'fail\'\"><md-icon class=\"icon icon-close\"></md-icon>\nSembra che il pagamento non sia andato a buon fine.<br>\nRiprova e qualora il problema persistesse, contatta l\'assistenza.</div></div></div></div>");
$templateCache.put("app/main/pages/payments/pay_cylplan_success.html","<div id=\"pay_sub_success\" class=\"page-layout simple white-bg md-padding\" layout=\"column\" \nstyle=\"height: 100%; text-align: center\" ng-init=\"vm.init();\"><div class=\"content white-bg md-padding\" \nlayout-align=\"center center\"><div layout-align=\"center center\" class=\"padding-40\"><div \nclass=\"font-size-36 line-height-36 padding-30\" ng-class=\"vm.savingStatus == \'ok\' ? \'green-fg\' : \'grey-600-fg\'\"><strong>\nEuro: {{ vm.plan.amount }}</strong></div><div class=\"font-size-24 line-height-36 padding-30\" \nng-if=\"vm.savingStatus==\'saving\'\" layout-align=\"center center\"><md-progress-circular md-accent></md-progress-circular>\n</div><div class=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.savingStatus==\'ok\'\"><md-icon \nclass=\"icon icon-check green-fg\"></md-icon>Grazie, il pagamento è stato ricevuto.<br>\nOra puoi tornare all\'home page della tua organizzazione.</div><div class=\"font-size-24 line-height-36 padding-30\" \nng-if=\"vm.savingStatus==\'failed\'\"><md-icon class=\"icon icon-close\"></md-icon>\nIl pagamento è stato ricevuto correttamente. Si è però verificato un problema con la registrazione del pagamento.<br>\nRiprova e qualora il problema persistesse, contatta l\'assistenza.</div></div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.gotoHome();\" ng-if=\"vm.savingStatus==\'ok\'\">Ok</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.registerPayment();\" ng-if=\"vm.savingStatus==\'failed\'\">Riprova</md-button></div></div>");
$templateCache.put("app/main/pages/payments/pay_subscription.html","<div id=\"pay_sub\" class=\"page-layout simple white-bg md-padding\" layout=\"column\" \nstyle=\"height: 100%; text-align: center\"><div class=\"content white-bg md-padding\" layout-align=\"center center\">\n<md-progress-circular mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-circular><div layout-align=\"center center\" \nclass=\"padding-40\" ng-if=\"!vm.loading\"><div class=\"font-size-36 line-height-36 padding-30\">\n{{vm.service.displayName}} - {{vm.service.name}}</div><div class=\"font-size-36 line-height-36 padding-30 red-fg\" \nng-if=\"!vm.loading\"><strong>Euro: {{ vm.formatEuro((vm.service.paymentDue || 0) - (vm.service.paymentValue || 0)) }}\n</strong></div><div class=\"font-size-24 line-height-36 padding-30\" ng-if=\"!vm.loading\">\n{{\'PAYMENTS.CLICK_TO_START_PAYMENT\' | translate}}</div></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"padding-16\"><md-button class=\"md-raised\" aria-label=\"Annulla\" ng-click=\"vm.close();\">Annulla</md-button>\n<md-button class=\"md-raised md-accent\" aria-label=\"Paga con Stripe\" \nng-if=\"vm.organization && vm.organization.stripeAccountId\" ng-click=\"vm.startStripePayment();\" \nng-disabled=\"vm.stripeInfo.paying\">Paga con Stripe</md-button></div><div ng-if=\"vm.stripeInfo.paying\" \nclass=\"stripe-payment-form padding\"><md-progress-circular mode=\"indeterminate\" ng-if=\"vm.stripeInfo.loading\">\n</md-progress-circular><div id=\"stripe-card\" class=\"padding-16\"></div><div id=\"stripe-card-errors\" class=\"padding-8\">\n{{ vm.stripeInfo.error.message }}</div><md-button class=\"md-raised md-accent padding-16\" aria-label=\"Paga\" \nng-if=\"!vm.stripeInfo.loading && !vm.stripeInfo.submitStatus\" ng-click=\"vm.submitStripePayment();\" \nng-disabled=\"vm.stripeInfo.submitting || vm.stripeInfo.error.message\">\nPaga {{ vm.formatEuro(vm.service.paymentDue - vm.service.paymentValue) }}&euro;</md-button><md-progress-circular \nmode=\"indeterminate\" ng-if=\"vm.stripeInfo.submitting\"></md-progress-circular><div \nng-if=\"vm.stripeInfo.submitting || vm.stripeInfo.submitStatus\"><p ng-if=\"vm.stripeInfo.submitStatus===\'ok\'\">\nGrazie, il pagamento è stato inviato a Stripe. Di norma entro pochi minuti riceverai conferma.</p><p \nng-if=\"vm.stripeInfo.submitStatus===\'error\'\">\nSi è verificato un problema con l\'invio del pagamento verso Stripe. Ti consigliamo di riprovare e, qualora il problema persistesse a lungo, contattare l\'assistenza.\n</p><md-button class=\"md-raised md-accent\" aria-label=\"Ok\" ng-disabled=\"vm.stripeInfo.submitting\" \nng-click=\"vm.close();\">Ok</md-button></div></div></div></div>");
$templateCache.put("app/main/pages/payments/pay_subscription_success.html","<div id=\"pay_sub_success\" class=\"page-layout simple white-bg md-padding\" layout=\"column\" \nstyle=\"height: 100%; text-align: center\" ng-init=\"vm.init();\"><div class=\"content white-bg md-padding\" \nlayout-align=\"center center\"><div layout-align=\"center center\" class=\"padding-80\"><div \nclass=\"font-size-36 line-height-36 padding-30\">{{vm.service.displayName}} - {{vm.service.name}}</div></div><div \nlayout-align=\"center center\" class=\"padding-40\"><div class=\"font-size-36 line-height-36 padding-30\" \nng-class=\"vm.savingStatus == \'ok\' ? \'green-fg\' : \'grey-600-fg\'\"><strong>\nEuro: {{vm.service.paymentDue - (vm.service.paymentValue || 0)}}</strong></div><div \nclass=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.savingStatus==\'saving\'\" layout-align=\"center center\">\n<md-progress-circular md-accent></md-progress-circular></div><div class=\"font-size-24 line-height-36 padding-30\" \nng-if=\"vm.savingStatus==\'ok\'\"><md-icon class=\"icon icon-check green-fg\"></md-icon>\nGrazie, il pagamento è stato ricevuto.<br>Ora puoi tornare all\'elenco delle tue iscrizioni.</div><div \nclass=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.savingStatus==\'failed\'\"><md-icon class=\"icon icon-close\">\n</md-icon>\nIl pagamento è stato ricevuto correttamente. Si è però verificato un problema con la registrazione del pagamento.<br>\nRiprova e qualora il problema persistesse, contatta l\'assistenza.</div></div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.gotoSubscriptions();\" ng-if=\"vm.savingStatus==\'ok\'\">Ok</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.registerPayment();\" ng-if=\"vm.savingStatus==\'failed\'\">Riprova</md-button></div></div>");
$templateCache.put("app/main/pages/payments/payments-template.html","<div><div layout=\"row\"><table datatable=\"payments-datatable\" dt-options=\"pc.dtOptions\" dt-columns=\"pc.dtColumns\" \ndt-instance=\"pc.dtInstance\" class=\"row-border hover\"></table></div></div>");
$templateCache.put("app/main/pages/payments/payments.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">{{\'PAYMENTS.PAYMENTS\' | translate }}\n</span></div></div></div><div class=\"content\"><div><div layout=\"row\"><table datatable=\"payments-datatable\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\"></table></div>\n</div></div></div></div>");
$templateCache.put("app/main/pages/seasonchange/seasonchange.html","<div id=\"page-memberships-index\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" layout=\"column\" \nms-scroll ng-init=\"vm.init();\"><div class=\"content\"><ov-navigation-bar user-id=\"{{ vm.loggedUserId }}\">\n</ov-navigation-bar><ms-form-wizard flex id=\"seasonChangeWizard\"><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab n_g-disabled=\"msWizard.selectedIndex !== 0\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">1</span> \n<span class=\"ms-form-wizard-step-text\">Istruzioni</span></span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/seasonchange/tabs/intro.html\'\"></md-content></md-tab-body></md-tab><md-tab \nn_g-disabled=\"msWizard.selectedIndex !== 2\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">2</span> <span class=\"ms-form-wizard-step-text\">Periodo</span></span>\n</md-tab-label><md-tab-body><md-content ng-include=\"\'app/main/pages/seasonchange/tabs/base-settings.html\'\">\n</md-content></md-tab-body></md-tab><md-tab n_g-disabled=\"msWizard.selectedIndex !== 3\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span \nclass=\"ms-form-wizard-step-text\">Servizi</span></span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/seasonchange/tabs/services.html\'\"></md-content></md-tab-body></md-tab><md-tab \nn_g-disabled=\"msWizard.selectedIndex !== 4\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">4</span> <span class=\"ms-form-wizard-step-text\">Ruoli</span></span>\n</md-tab-label><md-tab-body><md-content ng-include=\"\'app/main/pages/seasonchange/tabs/roles.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab n_g-disabled=\"msWizard.selectedIndex !== 5\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">5</span> <span \nclass=\"ms-form-wizard-step-text\">Conferma</span></span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/seasonchange/tabs/confirm.html\'\"></md-content></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"Precedente\" \ntitle=\"Precedente\" ng-click=\"msWizard.previousStep()\" class=\"md-raised md-accent md-fab\" \nng-disabled=\"msWizard.isFirstStep()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button aria-label=\"Successivo\" \ntitle=\"Successivo\" class=\"md-raised md-accent md-fab\" ng-click=\"msWizard.nextStep();\" \nng-disabled=\"msWizard.isLastStep()\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n</div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/subscriptions/new_from_service.html","<div id=\"newsubsccription\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content md-padding\">\n<ov-navigation-bar organization-id=\"{{ vm.organization.id }}\"></ov-navigation-bar><ov-organization-alert \norganization-id=\"{{ vm.offeredService.organizationId }}\"></ov-organization-alert><ms-form-wizard flex id=\"myWizard\">\n<md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab \nng-disabled=\"msWizard.selectedIndex !== 0\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">1</span> <span \nclass=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.SUBSCRIBER.DATA\' | translate}}</span></span></md-tab-label>\n<md-tab-body><div class=\"contenitore-pagina-padding-e-ombra\"><form name=\"wizardStep1\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><h3 class=\"titolo-blocco-contenuto padding-bottom-30\">Riepilogo informazioni iscritto\n</h3><div class=\"font-size-12\" layout=\"row\"><p id=\"add-subscriber-in-line-help\" style=\"display:none\">\n{{\'OFFERED_SERVICES.ADD_SUBSCRIBER_INFOS\' | translate}}</p></div><div layout=\"row\" layout-align=\"start center\">\n<md-button title=\"Pulisci maschera\" class=\"h-32\" ng-click=\"vm.cleanup()\"><md-icon md-font-icon=\"icon-eraser\" \nclass=\"md-primary\"></md-icon>Pulisci</md-button><md-autocomplete style=\"min-width: 480px\" \nmd-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in vm.lookupUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"3\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'OFFERED_SERVICES.SEARCH\' | translate}}\" md-selected-item-change=\"vm.selectedUserChange(item)\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus><md-item-template><img md-menu-align-target \nng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img \nmd-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n&nbsp;&nbsp;<md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nonclick=\"$(\'#add-subscriber-in-line-help\').toggle(500)\"><md-icon id=\"icon-help-chat-type\" \nmd-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button>&nbsp;&nbsp;<md-input-container><span \ntranslate=\"OFFERED_SERVICES.SEARCH_ON\" required>Cerca tra</span>:<md-radio-group ng-model=\"vm.searchMode\">\n<md-radio-button value=\"ORG\">{{\'OFFERED_SERVICES.SEARCH_ON_ORGANIZATION_CONTACTS\' | translate}}</md-radio-button>&nbsp;\n<md-radio-button value=\"CYL\">{{\'OFFERED_SERVICES.SEARCH_ON_CYL_USERS\' | translate}}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"row\"><span flex=\"50\">{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_START\' | translate }}:\n<md-datepicker style=\"width:100%\" ng-model=\"vm.subscriberData.dtStart\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_START\' | translate }}\"></md-datepicker></span><span flex=\"50\">\n{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}:<md-datepicker style=\"width:100%\" \nng-model=\"vm.subscriberData.dtEnd\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}\">\n</md-datepicker></span></div><div layout=\"row\"><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"vm.subscriberData.givenName\" capitalize ng-readonly=\"userId && userId!==null\"></md-input-container>\n<md-input-container style=\"width:100%\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" required>Family Name\n</label><input type=\"text\" name=\"familyName\" ng-model=\"vm.subscriberData.familyName\" capitalize \nng-readonly=\"userId && userId!==null\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top: 0px\"><label>Data di nascita*</label><input rsmdatedropdowns \ndeny-future-dates=\"true\" ng-model=\"vm.subscriberData.birthDate\" ng-disabled=\"userId && userId!==null\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.BIRTH_PLACE\">\nLuogo di nascita</label><input type=\"text\" ng-model=\"vm.subscriberData.birthPlace\"></md-input-container></div><div \nlayout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\" ng-if=\"vm.organization.flgEnableParentChild\">\n<md-checkbox class=\"remember-me\" ng-model=\"vm.isRelativeSubscription\" \nng-disabled=\"vm.subscriberData.id && vm.subscriberData.id!==null\"><span>Si tratta di un minore / tutelato</span>\n</md-checkbox></div><div layout=\"row\"><md-input-container style=\"width:100%; margin-top: 21px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"vm.subscriberData.email\" \nng-model=\"vm.subscriberData.email\" lowercase ng-pattern=\"/^.+@.+\\..+$/\" \nng-readonly=\"vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-required=\"(!vm.subscriberData.id || vm.subscriberData.id===null) && !vm.isRelativeSubscription\"><div \nng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</div><div layout=\"row\" ng-if=\"vm.isRelativeSubscription\"><md-input-container style=\"width:100%; margin-top: 21px\">\n<label>Email del genitore</label><input type=\"email\" lowercase ng-model=\"vm.parentUserEmail\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-readonly=\" vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-change=\"vm.lookupUserChildren()\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\"><label \ntranslate=\"USERS.GENDER\">Sesso</label><md-select ng-model=\"vm.subscriberData.gender\"><md-option value=\"M\">\n{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">{{\'USERS.FEMALE\' | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.TAX_CODE\">Codice fiscale\n</label><input type=\"text\" ng-model=\"vm.subscriberData.taxCode\" maxlength=\"16\" capitalize></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.ADDRESS\">\nIndirizzo di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.address\" capitalize></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.CITY\">\nComune di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.city\" capitalize></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.subscriberData.postalCode\" capitalize></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"USERS.PROVINCE\">Province</label><input type=\"text\" ng-model=\"vm.subscriberData.province\" \ncapitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.PHONE\">Telefono</label><input type=\"text\" ng-model=\"vm.subscriberData.phone\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare</label><input \ntype=\"text\" ng-model=\"vm.subscriberData.mobilePhone\"></md-input-container></div></form></div></md-tab-body></md-tab>\n<md-tab ng-disabled=\"msWizard.selectedIndex !== 1\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">2</span> <span class=\"ms-form-wizard-step-text\">\n{{\'SUBSCRIPTIONS.CHILDSERVICE\' | translate}}</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate layout=\"column\"><div>\nSeleziona il piano di pagamenti oppure creane uno nuovo</div><div class=\"contenitore-pagina-padding-e-ombra\"><form \nname=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><h3 class=\"titolo-blocco-contenuto\">\nNuova iscrizione per {{vm.subscriberData.givenName}} {{vm.subscriberData.familyName}}</h3>\nSeleziona il piano di pagamenti oppure creane uno nuovo<md-list flex><md-list-item class=\"md-3-line margin-5\" \nng-repeat=\"child in vm.children\" ng-click=\"vm.selectChildService(child.id);\" \nng-class=\"vm.childSelectedId == child.id ? \'md-grey-200-bg\' : \'md-blue-grey-50-bg\'\" layout=\"row\"><div flex=\"10\" \nlayout-align=\"center center\"><md-icon layout-align=\"center center\" ng-if=\"vm.childSelectedId != child.id\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon layout-align=\"center center\" \nng-if=\"vm.childSelectedId == child.id\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon></div><div \nclass=\"md-list-item-text\" layout=\"column\" flex=\"90\"><h3>{{ child.name }}</h3><h4><span ng-if=\"child.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"child.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"child.paymentType==\'R\'\"><span \nng-if=\"child.paymentRenewInterval === \'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> </span><span \nng-if=\"child.paymentType==\'R\' || child.paymentType==\'O\'\">\n, {{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}: {{ child.subscriptionPrice }}&euro; </span><span \nng-if=\"child.paymentType==\'R\'\">, {{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}: {{ child.renewalPrice }}&euro;\n</span></h4><p>{{ child.description }}</p></div></md-list-item></md-list><div layout=\"column\"><md-button \nng-click=\"vm.openNuovoPiano()\" class=\"md-raised\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Crea nuovo piano\n</md-button></div></form></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"msWizard.selectedIndex !== 2\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> \n<span class=\"ms-form-wizard-step-text\">{{\'SUBSCRIPTIONS.RESUME_PAYMENTS\' | translate}}</span></span></md-tab-label>\n<md-tab-body><div class=\"contenitore-pagina-padding-e-ombra\"><form name=\"wizardStep3\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><div layout=\"column\"><div layout=\"column\" \nng-show=\"vm.organizationSubscriptionStatus !== vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA\">\n<span class=\"md-display-1\">Quota associativa</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO\" \nclass=\"md-title red-fg\">Mancante</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA\" \nclass=\"md-title red-fg\">Il pagamento risulta non completato</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI\">\n<span class=\"md-title green-fg\">Il pagamento risulta in regola</span><br><span class=\"md-title orange-fg\">\nI documenti non sono in regola</span> </span><span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK\" \nclass=\"md-title green-fg\">In regola</span><br><md-input-container \nng-if=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO && vm.serviziQuotaAssociativaAttivabili.length > 0\">\n<span>Vuoi sottoscrivere ora la quota associativa?</span>:<md-radio-group ng-model=\"vm.flgAddSubscription\" \nlayout=\"column\" required=\"\" ng-change=\"vm.changeFlgAddSubscription()\"><md-radio-button value=\"YES\">Sì</md-radio-button>\n<md-radio-button value=\"NO\">No</md-radio-button></md-radio-group><div \nng-repeat=\"servizioQuota in vm.serviziQuotaAssociativaAttivabili\"><md-checkbox \nng-disabled=\"vm.flgAddSubscription !== \'YES\'\" ng-model=\"vm.subscriptionToAdd[servizioQuota.id]\" flex>\n{{servizioQuota.name }}</md-checkbox></div></md-input-container><br></div><span class=\"md-title\">\n{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</span> <span \nng-if=\"!vm.attachableServices || vm.attachableServices.length==0\">\n{{\'SUBSCRIPTIONS.NO_OPTIONAL_SERVICE_AVAILABLE\' | translate}}</span><div ng-repeat=\"service in vm.attachableServices\">\n<md-checkbox ng-model=\"vm.selecteServices[service.id]\" flex ng-click=\"vm.calculateTotalPrice()\">{{service.name}}<div \nstyle=\"font-size: 75%; font-style: italic\"><span ng-if=\"service.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"service.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"service.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"service.paymentType==\'R\'\"><span \nng-if=\"service.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"service.paymentType===\'R\' || service.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{service.subscriptionPrice}} - </span><span \nng-if=\"service.paymentType===\'R\'\">{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{service.renewalPrice}} -</span>\n</div></md-checkbox></div><br><span class=\"md-title\">{{\'SUBSCRIPTIONS.DISCOUNTS\' | translate}}</span><div layout=\"row\">\n<md-input-container><md-select ng-model=\"vm.subscriptionDiscount.id\" layout=\"column\"><md-option value=\"\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.NO_DISCOUNT\' | translate}}</md-option><md-option value=\"UNCONDITIONAL\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.UNCONDITIONAL_DISCOUNT\' | translate}}</md-option><md-option \nng-repeat=\"discount in vm.discounts\" ng-value=\"discount.id\">{{ discount.name }}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.subscriptionDiscount.id===\'UNCONDITIONAL\'\" style=\"margin-top: 14px\">\n<label>Euro</label><input type=\"number\" ng-model=\"vm.unconditionalDiscountAmount\" required></md-input-container></div>\n<div ng-if=\"msWizard.selectedIndex === 1\"><small class=\"secondary-text\">Totale: {{ vm.calculateTotalPrice() }}&euro;\n</small></div></div><br><br><div ng-show=\"vm.subscriptionServicesIds && vm.subscriptionServicesIds.length>0\" \nlayout=\"column\"><div ng-if=\"vm.subscriberId\"><span class=\"md-headline\">Riepilogo quote associative dell\'utente</span>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionServices\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.SERVICES.PAYMENTS\">Payments</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"USERS.SERVICES.DOCUMENTS\">Documents</span></div></th></tr></thead><tbody><tr \nng-repeat=\"service in vm.serviziQuotaAssociativaUtente\"><td>{{service.name}}</td><td \nstyle=\"color: green; font-weight: bold\" ng-if=\"service.paymentValue >= service.paymentDue\">\n{{service.paymentValue}} Euro<md-icon style=\"color: green\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></td><td \nstyle=\"color: red; font-weight: bold\" ng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button\n class=\"md-warn md-raised\" aria-label=\"User Payments\" \nng-click=\"vm.askPaymentDetails(vm.subscriberId, service.subscriptionId, (service.paymentDue - service.paymentValue));\" \ntranslate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\"><md-icon style=\"color: white\" \nmd-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>PAGA</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></td><td><ul><li ng-repeat=\"doc in service.docs\">\n{{doc.name}}: {{ \'OFFERED_SERVICES.DOC_STATUS.\'+doc.status | translate}}</li></ul></td></tr></tbody></table></div><div \nng-show=\"!vm.subscriberId\">Si tratta di un utente nuovo, non sono presenti quote associative</div></div></form></div>\n</md-tab-body></md-tab><md-tab ng-disabled=\"msWizard.selectedIndex !== 3\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">4</span> <span \nclass=\"ms-form-wizard-step-text\">Fine</span></span></md-tab-label><md-tab-body><div \nclass=\"contenitore-pagina-padding-e-ombra\"><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"column\" layout-align=\"center center\"><div flex=\"100\" layout=\"row\"><md-card flex=\"100\" \nflex-gt-md=\"50\" flex-offset-gt-md=\"25\"><md-card-content layout=\"column\" flex=\"100\"><div flex=\"100\" layout=\"row\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-check\" class=\"s32\"></md-icon></div>\n<h3 flex flex-grow>Iscrizione avvenuta con successo</h3></div><div layout=\"column\" layout-align=\"center center\">\nOra puoi andare all\'elenco delle iscrizioni ed eventualmente segnare il pagamento, se già effettuato.</div><div \nlayout=\"column\" layout-align=\"center center\"><md-button ng-click=\"vm.gotoSubscriptions();\" \nclass=\"md-raised md-primary\">Vai alle iscrizioni</md-button></div></md-card-content></md-card></div></div></form></div>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent md-fab\" ng-click=\"msWizard.previousStep()\" ng-show=\"msWizard.selectedIndex <= 2\" \nng-disabled=\"msWizard.isFirstStep()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent md-fab\" ng-c_lick=\"msWizard.nextStep();\" ng-click=\"vm.goToNextStep()\" \nng-show=\"msWizard.selectedIndex <= 1\" \nng-disabled=\"msWizard.currentStepInvalid() || (msWizard.selectedIndex===1 && !vm.childSelectedId)\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-raised md-accent md-fab\" \nng-click=\"vm.saveSubscription();\" ng-show=\"msWizard.selectedIndex === 2\" \nng-disabled=\"msWizard.formsIncomplete() || !vm.saveButtonEnabled\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"md-primary\"></md-icon></md-button><md-button class=\"md-raised md-accent md-fab\" onclick=\"window.history.back()\" \nng-show=\"msWizard.selectedIndex === 3\">Fine</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/subscriptions/new_subscription.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content md-padding\">\n<ov-navigation-bar organization-id=\"{{vm.organization.id}}\"></ov-navigation-bar><ov-organization-alert \norganization-id=\"{{vm.offeredService.organizationId}}\"></ov-organization-alert><md-content \nclass=\"md-padding contenitore-pagina-padding-e-ombra\" ng-if=\"vm.mustChooseService\"><h3 class=\"titolo-blocco-contenuto\">\n{{\'SUBSCRIPTIONS.NEW\' | translate}} {{vm.offeredService.name}}</h3><h4 class=\"titolo-blocco-contenuto\">\nSeleziona l\'elemento al quale vuoi aggiungere un iscritto</h4><md-list ng-if=\"vm.standaloneServices.length > 0\"><span \nclass=\"md-title\">Quote associative</span><md-list-item class=\"md-1-line\" \nng-repeat=\"service in vm.step0SubscriptionServices\" ng-click=\"vm.selectService(service);\"><md-button \nng-click=\"vm.selectService(service);\" aria-label=\"Seleziona\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"md-primary\"></md-icon>\n{{ service.name }} {{service.serviceType===\'EVENT\' ? (\' - \' + (\'OFFERED_SERVICES.EVENT\'|translate )): \'\'}}</md-button>\n</md-list-item><p ng-show=\"vm.step0SubscriptionServices.length===0\">Nessuna</p><br><span class=\"md-title\">Servizi\n</span><md-list-item class=\"md-1-line\" ng-repeat=\"service in vm.step0StandaloneServices\" \nng-click=\"vm.selectService(service);\"><md-button ng-click=\"vm.selectService(service);\" aria-label=\"Seleziona\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"md-primary\"></md-icon>\n{{ service.name }} {{service.serviceType===\'EVENT\' ? (\' - \' + (\'OFFERED_SERVICES.EVENT\'|translate )): \'\'}}</md-button>\n</md-list-item><p ng-show=\"vm.step0StandaloneServices.length===0\">Nessuno</p><br><span class=\"md-title\">Eventi</span>\n<md-list-item class=\"md-1-line\" ng-repeat=\"service in vm.step0Events\" ng-click=\"vm.selectService(service);\"><md-button \nng-click=\"vm.selectService(service);\" aria-label=\"Seleziona\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"md-primary\"></md-icon>\n{{ service.name }} {{service.serviceType===\'EVENT\' ? (\' - \' + (\'OFFERED_SERVICES.EVENT\'|translate )): \'\'}}</md-button>\n</md-list-item><p ng-show=\"vm.step0Events.length===0\">Nessuno</p></md-list><p \nng-if=\"vm.standaloneServices == null || vm.standaloneServices.length == 0\"><cite>\n{{ newSubscriptionDialog.organization.name }}<cite>{{\'SUBSCRIPTIONS.HASNOSERVICES\' | translate }}</cite></cite></p>\n</md-content><ms-form-wizard flex ng-if=\"!vm.mustChooseService\"><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab ng-disabled=\"msWizard.selectedIndex !== 0\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">1</span> \n<span class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.SUBSCRIBER.DATA\' | translate}}</span></span></md-tab-label>\n<md-tab-body><div class=\"contenitore-pagina-padding-e-ombra\" ng-if=\"vm.userIdParam\"><h3 \nclass=\"titolo-blocco-contenuto padding-bottom-30\">{{ vm.subscriberData.givenName }} {{ vm.subscriberData.familyName }}\n</h3><div layout=\"column\"><div ng-if=\"vm.subscriberData.taxCode\">CF: {{ vm.subscriberData.taxCode }}</div><div \nng-if=\"vm.subscriberData.birthDate\">Data di nascita: {{ vm.formatDate(vm.subscriberData.birthDate); }}</div><div \nng-if=\"vm.subscriberData.birthPlace\">Luogo di nascita: {{ vm.subscriberData.birthPlace}}</div><div><span \nng-if=\"vm.subscriberData.address\">{{ vm.subscriberData.address }}<br></span><span \nng-if=\"vm.subscriberData.city || vm.subscriberData.postalCode\">\n{{ vm.subscriberData.postalCode }} {{ vm.subscriberData.city }}<br></span><span ng-if=\"vm.subscriberData.province\">\n({{ vm.subscriberData.province }})</span></div><div ng-if=\"vm.subscriberData.phone || vm.subscriberData.mobilePhone\">\nTel. {{ vm.subscriberData.phone }} <span ng-if=\"vm.subscriberData.phone && vm.subscriberData.mobilePhone\">/</span>\n {{ vm.subscriberData.mobilePhone }}<br></div><div ng-if=\"vm.subscriberData.email || vm.parentUserEmail\">\nEmail: {{ vm.subscriberData.email }} <span ng-if=\"vm.subscriberData.email && vm.parentUserEmail\">/</span>\n {{ vm.parentUserEmail }}</div></div><div layout=\"column\" layout-align=\"center center\" md-padding><md-progress-circular\n md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><div class=\"disabled-text\">\nTi stiamo portanto al prossimo passaggio...</div><div class=\"disabled-text pt-16\">\nSe entro qualche secondo non prosegue automaticamente, premi pure il pulsante di avanzamento qui sotto</div></div>\n</div><div class=\"contenitore-pagina-padding-e-ombra\" ng-if=\"!vm.userIdParam\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><h3 class=\"titolo-blocco-contenuto padding-bottom-30\">\nRiepilogo informazioni iscritto</h3><div class=\"font-size-12\" layout=\"row\"><p id=\"add-subscriber-in-line-help\" \nstyle=\"display:none\">{{\'OFFERED_SERVICES.ADD_SUBSCRIBER_INFOS\' | translate}}</p></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button title=\"Pulisci maschera\" class=\"h-32\" ng-click=\"vm.cleanup()\" \naria-label=\"Pulisci maschera\"><md-icon md-font-icon=\"icon-eraser\" class=\"md-primary\"></md-icon>Pulisci</md-button>\n<md-autocomplete style=\"min-width: 480px\" md-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in vm.lookupUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"3\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'OFFERED_SERVICES.SEARCH\' | translate}}\" md-selected-item-change=\"vm.selectedUserChange(item)\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus><md-item-template><img md-menu-align-target \nng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img \nmd-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n&nbsp;&nbsp;<md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \naria-label=\"Info\" onclick=\"$(\'#add-subscriber-in-line-help\').toggle(500)\"><md-icon id=\"icon-help-chat-type\" \nmd-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button>&nbsp;&nbsp;<md-input-container><span \ntranslate=\"OFFERED_SERVICES.SEARCH_ON\" required>Cerca tra</span>:<md-radio-group ng-model=\"vm.searchMode\">\n<md-radio-button value=\"ORG\">{{\'OFFERED_SERVICES.SEARCH_ON_ORGANIZATION_CONTACTS\' | translate}}</md-radio-button>&nbsp;\n<md-radio-button value=\"CYL\">{{\'OFFERED_SERVICES.SEARCH_ON_CYL_USERS\' | translate}}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"row\"><span flex=\"50\">{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_START\' | translate }}:\n<md-datepicker style=\"width:100%\" ng-model=\"vm.subscriberData.dtStart\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_START\' | translate }}\"></md-datepicker></span><span flex=\"50\">\n{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}:<md-datepicker style=\"width:100%\" \nng-model=\"vm.subscriberData.dtEnd\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}\">\n</md-datepicker></span></div><div layout=\"row\"><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"vm.subscriberData.givenName\" capitalize ng-readonly=\"userId && userId!==null\"></md-input-container>\n<md-input-container style=\"width:100%\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" required>Family Name\n</label><input type=\"text\" name=\"familyName\" ng-model=\"vm.subscriberData.familyName\" capitalize \nng-readonly=\"userId && userId!==null\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top: 0px\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">\nBirth date</label><input rsmdatedropdowns deny-future-dates=\"true\" ng-model=\"vm.subscriberData.birthDate\" \nng-disabled=\"userId && userId!==null\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.BIRTH_PLACE\">Luogo di nascita</label><input type=\"text\" ng-model=\"vm.subscriberData.birthPlace\">\n</md-input-container></div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\" \nng-if=\"vm.organization.flgEnableParentChild\"><md-checkbox class=\"remember-me\" ng-model=\"vm.isRelativeSubscription\" \nng-disabled=\"vm.subscriberData.id && vm.subscriberData.id!==null\"><span>Si tratta di un minore / tutelato</span>\n</md-checkbox></div><div layout=\"row\"><md-input-container style=\"width:100%; margin-top: 21px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"vm.subscriberData.email\" \nng-model=\"vm.subscriberData.email\" lowercase ng-pattern=\"/^.+@.+\\..+$/\" \nng-readonly=\"vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-required=\"(!vm.subscriberData.id || vm.subscriberData.id===null) && !vm.isRelativeSubscription\"><div \nng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</div><div layout=\"row\" ng-if=\"vm.isRelativeSubscription\"><md-input-container style=\"width:100%; margin-top: 21px\">\n<label>Email del genitore</label><input type=\"email\" lowercase ng-model=\"vm.parentUserEmail\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-readonly=\" vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-change=\"vm.lookupUserChildren()\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\"><label \ntranslate=\"USERS.GENDER\">Sesso</label><md-select ng-model=\"vm.subscriberData.gender\"><md-option value=\"M\">\n{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">{{\'USERS.FEMALE\' | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.TAX_CODE\">Codice fiscale\n</label><input type=\"text\" ng-model=\"vm.subscriberData.taxCode\" maxlength=\"16\" capitalize></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.ADDRESS\">\nIndirizzo di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.address\" capitalize></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.CITY\">\nComune di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.city\" capitalize></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.subscriberData.postalCode\" capitalize></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"USERS.PROVINCE\">Province</label><input type=\"text\" ng-model=\"vm.subscriberData.province\" \ncapitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.PHONE\">Telefono</label><input type=\"text\" ng-model=\"vm.subscriberData.phone\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare</label><input \ntype=\"text\" ng-model=\"vm.subscriberData.mobilePhone\"></md-input-container></div></form></div></md-tab-body></md-tab>\n<md-tab ng-disabled=\"msWizard.selectedIndex !== 1\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">2</span> <span class=\"ms-form-wizard-step-text\">\n{{\'SUBSCRIPTIONS.CHILDSERVICE\' | translate}}</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate layout=\"column\"><div>\nSeleziona il piano di pagamenti oppure creane uno nuovo</div><div class=\"contenitore-pagina-padding-e-ombra\"><form \nname=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><h3 class=\"titolo-blocco-contenuto\">\nNuova iscrizione per {{vm.subscriberData.givenName}} {{vm.subscriberData.familyName}}</h3>\nSeleziona il piano di pagamenti oppure creane uno nuovo<md-list flex><md-list-item class=\"md-3-line margin-5\" \nng-repeat=\"child in vm.children\" ng-click=\"vm.selectChildService(child.id);\" \nng-class=\"vm.childSelectedId == child.id ? \'md-grey-200-bg\' : \'md-blue-grey-50-bg\'\" layout=\"row\"><div flex=\"10\" \nlayout-align=\"center center\"><md-icon layout-align=\"center center\" ng-if=\"vm.childSelectedId != child.id\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon layout-align=\"center center\" \nng-if=\"vm.childSelectedId == child.id\" md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon></div><div \nclass=\"md-list-item-text\" layout=\"column\" flex=\"90\"><h3>{{ child.name }}</h3><h4><span ng-if=\"child.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"child.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"child.paymentType==\'R\'\"><span \nng-if=\"child.paymentRenewInterval === \'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> </span><span \nng-if=\"child.paymentType==\'R\' || child.paymentType==\'O\'\">\n, {{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}: {{ child.subscriptionPrice }}&euro; </span><span \nng-if=\"child.paymentType==\'R\'\">, {{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}: {{ child.renewalPrice }}&euro;\n</span></h4><p>{{ child.description }}</p></div></md-list-item></md-list><div layout=\"column\"><md-button \nng-click=\"vm.openNuovoPiano()\" class=\"md-raised\" aria-label=\"Crea nuovo piano\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>Crea nuovo piano</md-button></div></form></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"msWizard.selectedIndex !== 2\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span class=\"ms-form-wizard-step-text\">\n{{\'SUBSCRIPTIONS.RESUME_PAYMENTS\' | translate}}</span></span></md-tab-label><md-tab-body><div \nclass=\"contenitore-pagina-padding-e-ombra\"><form name=\"wizardStep3\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"column\"><div layout=\"column\" \nng-show=\"vm.organizationSubscriptionStatus !== vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA\">\n<span class=\"md-display-1\">Quota associativa</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO\" \nclass=\"md-title red-fg\">Mancante</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA\" \nclass=\"md-title red-fg\">Il pagamento risulta non completato</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI\">\n<span class=\"md-title green-fg\">Il pagamento risulta in regola</span><br><span class=\"md-title orange-fg\">\nI documenti non sono in regola</span> </span><span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK\" \nclass=\"md-title green-fg\">In regola</span><br><md-input-container \nng-if=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO && vm.serviziQuotaAssociativaAttivabili.length > 0\">\n<span>Vuoi sottoscrivere ora la quota associativa?</span>:<md-radio-group ng-model=\"vm.flgAddSubscription\" \nlayout=\"column\" required=\"\" ng-change=\"vm.changeFlgAddSubscription()\"><md-radio-button value=\"YES\">Sì</md-radio-button>\n<md-radio-button value=\"NO\">No</md-radio-button></md-radio-group><div \nng-repeat=\"servizioQuota in vm.serviziQuotaAssociativaAttivabili\"><md-checkbox \nng-disabled=\"vm.flgAddSubscription !== \'YES\'\" ng-model=\"vm.subscriptionToAdd[servizioQuota.id]\" flex>\n{{servizioQuota.name }}</md-checkbox></div></md-input-container><br></div><span class=\"md-title\">\n{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</span> <span \nng-if=\"!vm.attachableServices || vm.attachableServices.length==0\">\n{{\'SUBSCRIPTIONS.NO_OPTIONAL_SERVICE_AVAILABLE\' | translate}}</span><div ng-repeat=\"service in vm.attachableServices\">\n<md-checkbox ng-model=\"vm.selecteServices[service.id]\" flex ng-click=\"vm.calculateTotalPrice()\">{{service.name}}<div \nstyle=\"font-size: 75%; font-style: italic\"><span ng-if=\"service.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"service.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"service.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"service.paymentType==\'R\'\"><span \nng-if=\"service.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"service.paymentType===\'R\' || service.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{service.subscriptionPrice}} - </span><span \nng-if=\"service.paymentType===\'R\'\">{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{service.renewalPrice}} -</span>\n</div></md-checkbox></div><br><span class=\"md-title\">{{\'SUBSCRIPTIONS.DISCOUNTS\' | translate}}</span><div layout=\"row\">\n<md-input-container><md-select ng-model=\"vm.subscriptionDiscount.id\" layout=\"column\"><md-option value=\"\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.NO_DISCOUNT\' | translate}}</md-option><md-option value=\"UNCONDITIONAL\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.UNCONDITIONAL_DISCOUNT\' | translate}}</md-option><md-option \nng-repeat=\"discount in vm.discounts\" ng-value=\"discount.id\">{{ discount.name }}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.subscriptionDiscount.id===\'UNCONDITIONAL\'\" style=\"margin-top: 14px\">\n<label>Euro</label><input type=\"number\" ng-model=\"vm.unconditionalDiscountAmount\" required></md-input-container></div>\n<div ng-if=\"msWizard.selectedIndex === 1\"><small class=\"secondary-text\">Totale: {{ vm.calculateTotalPrice() }}&euro;\n</small></div></div><br><br><div ng-show=\"vm.subscriptionServicesIds && vm.subscriptionServicesIds.length>0\" \nlayout=\"column\"><div ng-if=\"vm.subscriberId\"><span class=\"md-headline\">Riepilogo quote associative dell\'utente</span>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionServices\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.SERVICES.PAYMENTS\">Payments</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"USERS.SERVICES.DOCUMENTS\">Documents</span></div></th></tr></thead><tbody><tr \nng-repeat=\"service in vm.serviziQuotaAssociativaUtente\"><td>{{service.name}}</td><td \nstyle=\"color: green; font-weight: bold\" ng-if=\"service.paymentValue >= service.paymentDue\">\n{{service.paymentValue}} Euro<md-icon style=\"color: green\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></td><td \nstyle=\"color: red; font-weight: bold\" ng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button\n class=\"md-warn md-raised\" aria-label=\"User Payments\" \nng-click=\"vm.askPaymentDetails(vm.subscriberId, service.subscriptionId, (service.paymentDue - service.paymentValue));\" \ntranslate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\"><md-icon style=\"color: white\" \nmd-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>PAGA</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></td><td><ul><li ng-repeat=\"doc in service.docs\">\n{{doc.name}}: {{ \'OFFERED_SERVICES.DOC_STATUS.\'+doc.status | translate}}</li></ul></td></tr></tbody></table></div><div \nng-show=\"!vm.subscriberId\">Si tratta di un utente nuovo, non sono presenti quote associative</div></div></form></div>\n</md-tab-body></md-tab><md-tab ng-disabled=\"msWizard.selectedIndex !== 3\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">4</span> <span \nclass=\"ms-form-wizard-step-text\">Fine</span></span></md-tab-label><md-tab-body><div \nclass=\"contenitore-pagina-padding-e-ombra\"><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" style=\"color: green\"></md-icon><span class=\"md-title\">\nOperazione effettuata con successo</span></div><br><br><br><div layout=\"row\"><span class=\"md-display-1\">\nPagamenti pendenti per l\'utente</span></div><div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionServices\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr\n ng-repeat=\"service in vm.servicesToPay\"><td>{{service.name}}</td><td><ul><li class=\"font-size-12\" \nng-repeat=\"detail in service.details\"><strong>{{detail.amount}} Euro</strong>&nbsp;&nbsp; <span \nng-if=\"detail.subscriptionDiscountId\"><span ng-if=\"detail.subscriptionDiscount.type === \'UNCONDITIONAL\'\">\nSconto incondizionato</span> <span ng-if=\"detail.subscriptionDiscount.type === \'PERCENT\'\">\nSconto {{detail.subscriptionDiscount.discount.name}} ({{detail.subscriptionDiscount.value}} %)</span> <span \nng-if=\"detail.subscriptionDiscount.type === \'AMOUNT\'\">Sconto {{detail.subscriptionDiscount.discount.name}}</span> \n</span><span \nng-if=\"!detail.subscriptionDiscountId && detail.dtBillingPeriodStart && detail.dtBillingPeriodEnd && detail.status.indexOf(\'RENEW\') >= 0\">\nPeriodo {{vm.formatDate(detail.dtBillingPeriodStart)}} - {{vm.formatDate(detail.dtBillingPeriodEnd)}}</span> <span \nng-if=\"!detail.subscriptionDiscountId && (!detail.dtBillingPeriodStart || !detail.dtBillingPeriodEnd || detail.status.indexOf(\'RENEW\') < 0)\">\nIscrizione</span></li></ul></td><td><div style=\"color: green; font-weight: bold\" \nng-if=\"service.paymentValue >= service.paymentDue\">{{service.paymentValue}} Euro<md-icon style=\"color: green\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon></div><div style=\"color: green; font-weight: bold\" \nng-if=\"service.paymentValue >= service.paymentDue\">{{service.paymentValue}} Euro<md-icon style=\"color: green\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon></div><div style=\"color: red; font-weight: bold\" \nng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button class=\"md-warn md-raised\" \naria-label=\"User Payments\" \nng-click=\"vm.askPaymentDetails(vm.subscriberId, service.subscriptionId, (service.paymentDue - service.paymentValue));\" \ntranslate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\"><md-icon style=\"color: white\" \nmd-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>PAGA</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></div></td></tr></tbody></table></div></div></form>\n</div></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-accent md-fab\" aria-label=\"Prececente\" ng-click=\"msWizard.previousStep()\" \nng-show=\"msWizard.selectedIndex <= 3\" ng-disabled=\"msWizard.isFirstStep()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent md-fab\" aria-label=\"Prossimo\" ng-click=\"vm.goToNextStep()\" \nng-show=\"msWizard.selectedIndex <= 1\" \nng-disabled=\"msWizard.currentStepInvalid() || (msWizard.selectedIndex===1 && !vm.childSelectedId)\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-raised md-accent md-fab\" aria-label=\"Salva\" \nng-click=\"vm.saveSubscription();\" ng-show=\"msWizard.selectedIndex === 2\" ng-disabled=\"msWizard.formsIncomplete()\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button><md-button \nclass=\"md-raised md-accent md-fab\" aria-label=\"Indietro\" onclick=\"window.history.back()\" \nng-show=\"msWizard.selectedIndex === 3\">Fine</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/subscriptions/public_subscription.html","<div id=\"publicpage\" class=\"page-layout simple tabbed\" layout=\"column\"><div id=\"publicpage_header\" class=\"md-padding\" \nclass=\"blue-grey-100-bg\" layout=\"row\" layout-align=\"center start\" \nstyle=\"background-color: #0b93d5; background-image: url(../../../../assets/images/backgrounds/bg-palestra-NO.jpg); background-size: cover; background-position: center; margin-bottom: 15px\">\n<div layout=\"column\" layout-gt-sm=\"row\" class=\"blue-grey-100-bg-NO\" layout-align=\"start center\" flex=\"100\" \nstyle=\"height: 100%\"><div layout-align=\"left center\" layout=\"column\" flex-gt-sm=\"100\" flex=\"100\"><img \nng-if=\"vm.offeredService.organization.uriLogo && vm.logoImageUrl\" class=\"md-avatar avatar contact-avatar huge\" \nng-src=\"{{ vm.logoImageUrl }}\"> <img ng-if=\"!vm.offeredService.organization.uriLogo && !vm.logoImageUrl\" \nclass=\"md-avatar avatar contact-avatar huge\" src=\"../../../../assets/images/logos/logo_payments.png\"><div \nclass=\"md-display-1 margin-top-15\" style=\"text-align: center; text-shadow: 0 0px 3px rgba(0,0,0,.2); color: #fff\">\n{{vm.offeredService.name}}</div><div class=\"md-title\" style=\"text-shadow: 0 0px 3px rgba(0,0,0,.2); color: #fff\">\n{{vm.offeredService.organization.name}}</div></div></div></div><div \nclass=\"content md-padding pagina-pubblica-iscrizione\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\" \nng-show=\"!vm.isPaymentStep\"><span class=\"md-display-1 margin-top-25 margin-bottom-25\">\n{{ vm.subscriptionPage.title ? vm.subscriptionPage.title : vm.offeredService.organization.name }}</span><div \nng-if=\"vm.subscriptionPageOptions.options[\'allow-social-share\']\" layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><a href=\"#\" socialshare socialshare-provider=\"facebook\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"twitter\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-twitter-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"linkedin\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-linkedin-box\" \nclass=\"md-accent\"></md-icon></a></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex=\"100\" \nstyle=\"min-width: 70%\"><div style=\"border: 1px solid #bbb; margin-top: 16px; margin-right: 16px\" layout=\"column\" \nflex=\"100\" class=\"md-padding\" flex-gt-sm=\"70\"><h2 style=\"font-weight: bold; margin-top: 0\">Modulo di iscrizione</h2><h3\n style=\"margin-top: 0\">Premendo il pulsante di invio in fondo alla pagina la tua iscrizione sarà completata.</h3><div \nng-if=\"vm.offeredService.description\"><div class=\"md-title\">{{\'OFFERED_SERVICES.DESCRIPTION\' | translate}}</div><p>\n{{vm.offeredService.description}}</p></div><form name=\"subscriptionForm\" novalidate style=\"width: 100%\"><div>\n<md-input-container style=\"width:100%\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\">Given Name</label>\n<input type=\"text\" name=\"givenName\" ng-model=\"vm.subscriberData.givenName\" capitalize \nng-readonly=\"userId && userId!==null\" required></md-input-container><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\">Family Name</label><input type=\"text\" name=\"familyName\" \nng-model=\"vm.subscriberData.familyName\" capitalize ng-readonly=\"userId && userId!==null\" required></md-input-container>\n</div><div><label translate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">Birth date*:</label><br><input rsmdatedropdowns \ndeny-future-dates=\"true\" ng-model=\"vm.subscriberData.birthDate\" ng-disabled=\"userId && userId!==null\" \nng-required=\"true\"></div><div><md-input-container style=\"width:100%; margin-top: 21px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"vm.subscriberData.email\" \nng-model=\"vm.subscriberData.email\" lowercase ng-pattern=\"/^.+@.+\\..+$/\" \nng-readonly=\"vm.subscriberData.id && vm.subscriberData.id!==null\" required><div \nng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</div><div><md-input-container class=\"md-block\" ng-if=\"vm.subscriptionPageOptions.fields[\'gender\']\"><label \ntranslate=\"USERS.GENDER\">Sesso</label><md-select ng-model=\"vm.subscriberData.gender\" required><md-option value=\"M\">\n{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">{{\'USERS.FEMALE\' | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.subscriptionPageOptions.fields[\'taxCode\']\"><label translate=\"USERS.TAX_CODE\">Codice fiscale</label><input \ntype=\"text\" ng-model=\"vm.subscriberData.taxCode\" required maxlength=\"16\" capitalize></md-input-container></div><div>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.subscriptionPageOptions.fields[\'address\']\"><label \ntranslate=\"USERS.ADDRESS\">Indirizzo di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.address\" \nrequired capitalize></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.subscriptionPageOptions.fields[\'city\']\"><label translate=\"USERS.CITY\">Comune di residenza</label><input \ntype=\"text\" ng-model=\"vm.subscriberData.city\" required capitalize></md-input-container></div><div><md-input-container \nclass=\"md-block\" flex-gt-sm ng-if=\"vm.subscriptionPageOptions.fields[\'phone\']\"><label translate=\"USERS.PHONE\">cellulare\n</label><input type=\"text\" ng-model=\"vm.subscriberData.phone\" required></md-input-container></div><div \nng-if=\"vm.subscriptionPage.templateId\"><dynamic-document ng-data-url=\"\" ng-template-url=\"{{vm.templateUrl}}\" \nng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess(succ, action)\" \non-error=\"myOnErr(err)\" ng-edit-mode=\"true\"></dynamic-document></div><div \nng-show=\"vm.subscriptionPageOptions.showAttachableServices && vm.attachableServices && vm.attachableServices.length > 0\">\n<span class=\"md-title\">{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\'| translate}}</span><md-checkbox \nng-model=\"vm.selecteServices[vm.offeredService.id]\" flex ng-disabled=\"true\">{{vm.offeredService.name}}<div \nstyle=\"font-size: 75%; font-style: italic\"><span ng-if=\"vm.offeredService.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"vm.offeredService.paymentType==\'R\'\"><span \nng-if=\"vm.offeredService.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span>\n<span ng-if=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{vm.offeredService.subscriptionPrice}} - </span><span \nng-if=\"vm.offeredService.paymentType===\'R\'\">\n{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{vm.offeredService.renewalPrice}} -</span></div></md-checkbox><br>\n<strong>{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</strong> <span \nng-if=\"!vm.attachableServices || vm.attachableServices.length==0\">\n{{\'SUBSCRIPTIONS.NO_OPTIONAL_SERVICE_AVAILABLE\' | translate}}</span><div ng-repeat=\"service in vm.attachableServices\">\n<md-checkbox ng-model=\"vm.selecteServices[service.id]\" flex>{{service.name}}<div \nstyle=\"font-size: 75%; font-style: italic\"><span ng-if=\"service.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"service.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"service.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"service.paymentType==\'R\'\"><span \nng-if=\"service.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"service.paymentType===\'R\' || service.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{service.subscriptionPrice}} - </span><span \nng-if=\"service.paymentType===\'R\'\">{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{service.renewalPrice}} -</span>\n</div></md-checkbox></div></div><div class=\"ov-recaptcha\" vc-recaptcha \nkey=\"\'6Ld_mUMUAAAAACAHxdmSeOFstaJypEg-4BZnp6IU\'\" ng-model=\"vm.recaptchaResponse\"></div></form><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\" style=\"width: 100%; margin-top: 30px\"><div layout=\"column\" flex=\"100\">\n<md-button class=\"md-raised md-accent\" aria-label=\"Salva\" flex=\"100\" ng-click=\"vm.saveSubscription();\" \nng-disabled=\"subscriptionForm.$invalid || vm.dyndocForm.$invalid\">{{\'OFFERED_SERVICES.SEND\' | translate}}</md-button>\n</div></div></div><div style=\"background: #666; color: #fff; margin-top: 16px; font-size: 16px\" layout=\"column\" \nclass=\"md-padding\" layout-align=\"start start\" flex=\"100\" flex-gt-sm=\"30\"><div \nng-if=\"vm.offeredService.scheduleType === \'R\'\" layout=\"row\"><div layout=\"column\"><div class=\"md-title\">Quando</div>\nSu richiesta</div></div><div ng-if=\"vm.offeredService.scheduleType === \'D\'\" layout=\"row\"><div><div class=\"md-title\">\nQuando</div>{{vm.formatDateFriendly(vm.offeredService.start)}}<br><span style=\"float: left\" \nng-if=\"vm.offeredService.hourFrom\">\n{{vm.offeredService.hourFrom}}:{{vm.offeredService.minutesFrom ? vm.offeredService.minutesFrom : \'00\'}}</span> <span \nng-if=\"vm.offeredService.hourTo\">\n-{{vm.offeredService.hourTo}}:{{vm.offeredService.minutesTo ? vm.offeredService.minutesTo : \'00\'}}</span></div></div>\n<div ng-if=\"vm.offeredService.scheduleType === \'P\'\" layout=\"row\"><div layout=\"column\"><div class=\"md-title\">Periodo\n</div>da {{vm.formatDateFriendly(vm.offeredService.start)}}<br>a {{vm.formatDateFriendly(vm.offeredService.end)}}<br>\n</div></div><div ng-if=\"vm.offeredService.address || (vm.offeredService.latitude && vm.offeredService.longitude)\" \nlayout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Dove</div>{{vm.offeredService.address}}\n<br><a ng-click=\"vm.scrollTo(\'theMap\')\" style=\"cursor: pointer\" \nng-if=\"vm.offeredService.latitude && vm.offeredService.longitude\">Mappa</a></div></div><div layout=\"row\" \nclass=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Prezzo</div><div \nng-if=\"vm.offeredService.paymentType === \'F\'\">Gratuito</div><div \nng-if=\"vm.offeredService.paymentType === \'R\' || vm.offeredService.paymentType === \'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}}: {{vm.offeredService.subscriptionPrice ? vm.offeredService.subscriptionPrice : \'Gratuito\'}}\n<div ng-if=\"vm.offeredService.paymentType === \'R\'\">\n{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}}: {{vm.offeredService.renewalPrice}}</div></div><div \nng-if=\"vm.offeredService.paymentType === \'R\'\">{{\'OFFERED_SERVICES.RENEWAL\' | translate}}: <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentRenewInterval === \'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span></div>\n<div ng-if=\"vm.mandatoryOfferedServices\"><span ng-repeat=\"mandatoryOfferedService in vm.mandatoryOfferedServices\">\n{{ mandatoryOfferedService.name }} (Euro): {{ mandatoryOfferedService.subscriptionPrice }}</span></div></div></div><div\n ng-if=\"vm.offeredService.notes\" layout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Note\n</div><p>{{vm.offeredService.notes}}</p></div></div></div></div><div id=\"theMap\" layout=\"row\" \nng-if=\"vm.offeredService.latitude && vm.offeredService.longitude\" class=\"md-padding margin-top-80\" flex=\"100\"><fieldset\n class=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\"></div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.offeredService.latitude ? vm.offeredService.latitude : 41.8919300}}\"> <input type=\"hidden\" \nclass=\"gllpLongitude\" value=\"{{vm.offeredService.longitude ? vm.offeredService.longitude : 12.5113300 }}\"> <input \ntype=\"hidden\" class=\"gllpZoom\" value=\"16\"></fieldset></div></div><div class=\"content white-bg\" \nlayout-align=\"center center\" ng-show=\"vm.isPaymentStep\" style=\"text-align: center\"><div layout-align=\"center center\">\n<div class=\"md-title\">{{vm.service.displayName}} - {{vm.service.name}}</div><div class=\"md-headline\"><strong>\nEuro: {{ vm.moneyDue }}</strong></div><div class=\"md-title\">{{\'PAYMENTS.CLICK_TO_START_PAYMENT\' | translate}}</div>\n<md-button class=\"md-raised md-accent\" aria-label=\"Paga con Stripe\" \nng-if=\"vm.organization && vm.organization.stripeAccountId\" ng-click=\"vm.startStripePayment();\" \nng-disabled=\"vm.stripeInfo.paying\">Paga con Stripe</md-button><div ng-if=\"vm.stripeInfo.paying\" \nclass=\"stripe-payment-form padding\"><md-progress-circular mode=\"indeterminate\" ng-if=\"vm.stripeInfo.loading\">\n</md-progress-circular><div id=\"stripe-card\" class=\"padding-16\"></div><div id=\"stripe-card-errors\" class=\"padding-8\">\n{{ vm.stripeInfo.error.message }}</div><md-button class=\"md-raised md-accent padding-16\" aria-label=\"Paga\" \nng-if=\"!vm.stripeInfo.loading && !vm.stripeInfo.submitStatus\" ng-click=\"vm.submitStripePayment();\" \nng-disabled=\"vm.stripeInfo.submitting || vm.stripeInfo.error.message\">\nPaga {{ vm.formatEuro(vm.service.paymentDue - vm.service.paymentValue) }}&euro;</md-button><md-progress-circular \nmode=\"indeterminate\" ng-if=\"vm.stripeInfo.submitting\"></md-progress-circular><div \nng-if=\"vm.stripeInfo.submitting || vm.stripeInfo.submitStatus\"><p ng-if=\"vm.stripeInfo.submitStatus===\'ok\'\">\nGrazie, il pagamento è stato inviato a Stripe. Di norma entro pochi minuti riceverai conferma.</p><p \nng-if=\"vm.stripeInfo.submitStatus===\'error\'\">\nSi è verificato un problema con l\'invio del pagamento verso Stripe. Ti consigliamo di riprovare e, qualora il problema persistesse a lungo, contattare l\'assistenza.\n</p></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/subscriptions/public_subscription_success.html","<div id=\"pay_sub_success\" class=\"page-layout simple white-bg md-padding\" layout=\"column\" \nstyle=\"height: 100%; text-align: center\" ng-init=\"vm.init();\"><div class=\"content white-bg md-padding\" \nlayout-align=\"center center\"><div layout-align=\"center center\" class=\"padding-80\"><div \nclass=\"font-size-36 line-height-36 padding-30\">Pagamento con Stripe effettuato</div></div><div \nlayout-align=\"center center\" class=\"padding-40\"><div class=\"font-size-36 line-height-36 padding-30\" \nng-class=\"vm.savingStatus == \'ok\' ? \'green-fg\' : \'grey-600-fg\'\"><strong>Euro: {{ vm.amount }}</strong></div><div \nclass=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.savingStatus==\'saving\'\" layout-align=\"center center\">\n<md-progress-circular md-accent></md-progress-circular></div><div class=\"font-size-24 line-height-36 padding-30\" \nng-if=\"vm.savingStatus==\'ok\'\"><md-icon class=\"icon icon-check green-fg\"></md-icon>\nGrazie, il pagamento è stato ricevuto.<br>Ora puoi accedere a ClubYourLife.</div><div \nclass=\"font-size-24 line-height-36 padding-30\" ng-if=\"vm.savingStatus==\'failed\'\"><md-icon class=\"icon icon-close\">\n</md-icon>\nIl pagamento è stato ricevuto correttamente. Si è però verificato un problema con la registrazione del pagamento.<br>\nRiprova e qualora il problema persistesse, contatta l\'assistenza.</div></div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.gotoLoginPage();\" ng-if=\"vm.savingStatus==\'ok\'\">Ok</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.registerPayment();\" ng-if=\"vm.savingStatus==\'failed\'\">Riprova</md-button></div></div>");
$templateCache.put("app/main/pages/subscriptions/renew_subscription.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div id=\"newservice_header\" \nclass=\"header md-blue-grey-50-bg\" layout=\"column\" layout-align=\"start start\" style=\"background-image: none\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\">\n{{\'SUBSCRIPTIONS.RENEW\' | translate}} {{vm.offeredService.name}}</div></div></div></div><div \nclass=\"content md-padding\"><md-content class=\"md-padding\"><form class=\"md-inline-form\" novalidate name=\"renewForm\"><div\n layout=\"column\"><div layout=\"column\" \nng-show=\"vm.organizationSubscriptionStatus !== vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_NECESSARIA\">\n<span class=\"md-display-1\">Quota associativa</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO\" \nclass=\"md-title red-fg\">Mancante</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_PAGATA\" \nclass=\"md-title red-fg\">Il pagamento risulta non completato</span> <span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_DOCUMENTI_MANCANTI\">\n<span class=\"md-title green-fg\">Il pagamento risulta in regola</span><br><span class=\"md-title orange-fg\">\nI documenti non sono in regola</span> </span><span \nng-show=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_OK\" \nclass=\"md-title green-fg\">In regola</span><br><md-input-container \nng-if=\"vm.organizationSubscriptionStatus === vm.organizationSubscriptionStatusType.QUOTA_ASSOCIATIVA_NON_ISCRITTO && vm.serviziQuotaAssociativaAttivabili.length > 0\">\n<span>Vuoi sottoscrivere ora la quota associativa?</span>:<md-radio-group ng-model=\"vm.flgAddSubscription\" \nlayout=\"column\" required=\"\" ng-change=\"vm.changeFlgAddSubscription()\"><md-radio-button value=\"YES\">Sì</md-radio-button>\n<md-radio-button value=\"NO\">No</md-radio-button></md-radio-group><div \nng-repeat=\"servizioQuota in vm.serviziQuotaAssociativaAttivabili\"><md-checkbox \nng-disabled=\"vm.flgAddSubscription !== \'YES\'\" ng-model=\"vm.subscriptionToAdd[servizioQuota.id]\" flex>\n{{servizioQuota.name }}</md-checkbox></div></md-input-container><br></div><span class=\"md-display-1\">\nRiepilogo rinnovo iscrizione</span><md-checkbox ng-model=\"vm.selecteServices[vm.offeredService.id]\" flex \nng-disabled=\"true\">{{vm.offeredService.name}}<div style=\"font-size: 75%; font-style: italic\"><span \nng-if=\"vm.offeredService.paymentType==\'F\'\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentType==\'O\'\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentType==\'R\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span \nng-if=\"vm.offeredService.paymentType==\'R\'\"><span ng-if=\"vm.offeredService.paymentRenewInterval===\'day\'\">\n{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'month\'\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'year\'\">\n{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'week\'\">\n{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'2-month\'\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'3-month\'\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'4-month\'\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'6-month\'\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{vm.offeredService.subscriptionPrice}} - </span><span \nng-if=\"vm.offeredService.paymentType===\'R\'\">\n{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{vm.offeredService.renewalPrice}} -</span></div></md-checkbox><br>\n<span class=\"md-title\">{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</span> <span \nng-if=\"!vm.attachableServices || vm.attachableServices.length==0\">\n{{\'SUBSCRIPTIONS.NO_OPTIONAL_SERVICE_AVAILABLE\' | translate}}</span><div ng-repeat=\"service in vm.attachableServices\">\n<md-checkbox ng-model=\"vm.selecteServices[service.id]\" flex>{{service.name}}<div \nstyle=\"font-size: 75%; font-style: italic\"><span ng-if=\"service.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"service.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"service.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"service.paymentType==\'R\'\"><span \nng-if=\"service.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"service.paymentType===\'R\' || service.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{service.subscriptionPrice}} - </span><span \nng-if=\"service.paymentType===\'R\'\">{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{service.renewalPrice}} -</span>\n</div></md-checkbox></div><span class=\"md-title\">{{\'SUBSCRIPTIONS.DISCOUNTS\' | translate}}</span><div layout=\"row\">\n<md-input-container><md-select ng-model=\"vm.subscriptionDiscount.id\" layout=\"column\"><md-option value=\"\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.NO_DISCOUNT\' | translate}}</md-option><md-option value=\"UNCONDITIONAL\" \nclass=\"md-primary\">{{\'SUBSCRIPTIONS.UNCONDITIONAL_DISCOUNT\' | translate}}</md-option><md-option \nng-repeat=\"discount in vm.discounts\" ng-value=\"discount.id\">{{discount.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.subscriptionDiscount.id===\'UNCONDITIONAL\'\" style=\"margin-top: 14px\">\n<label>Euro</label><input type=\"number\" min=\"0\" name=\"duration\" ng-model=\"vm.subscriptionDiscount.amount\" required>\n</md-input-container></div></div><br><br><div \nng-show=\"vm.subscriptionServicesIds && vm.subscriptionServicesIds.length>0\" layout=\"column\"><div \nng-if=\"vm.subscriberId\"><span class=\"md-display-1\">Quote associative dell\'utente</span><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionServices\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.SERVICES.PAYMENTS\">Payments</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"USERS.SERVICES.DOCUMENTS\">Documents</span></div></th></tr></thead><tbody><tr \nng-repeat=\"service in vm.serviziQuotaAssociativaUtente\"><td>{{service.name}}</td><td \nstyle=\"color: green; font-weight: bold\" ng-if=\"service.paymentValue >= service.paymentDue\">\n{{service.paymentValue}} Euro<md-icon style=\"color: green\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></td><td \nstyle=\"color: red; font-weight: bold\" ng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button\n class=\"md-warn md-raised\" aria-label=\"User Payments\" \nng-click=\"vm.askPaymentDetails(vm.subscriberId, service.subscriptionId, (service.paymentDue - service.paymentValue));\" \ntranslate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\"><md-icon style=\"color: white\" \nmd-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>PAGA</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></td><td><ul><li ng-repeat=\"doc in service.docs\">\n{{doc.name}}: {{ \'OFFERED_SERVICES.DOC_STATUS.\'+doc.status | translate}}</li></ul></td></tr></tbody></table></div>\n</div></form><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.renewSubscription();\" ng-disabled=\"renewForm.$invalid\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon>{{\'OFFERED_SERVICES.SAVE\' | translate}}</md-button></div>\n</md-content></div></div>");
$templateCache.put("app/main/pages/subscriptions/subscription_detail.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content md-padding\"><div \nlayout=\"row\"><ov-profile-navigation-bar user-id=\"{{vm.userId}}\" organization-id=\"{{vm.organizationId}}\" \nselected-page=\"SUBSCRIPTIONS\"></ov-profile-navigation-bar></div><md-tabs md-dynamic-height md-center-tabs=\"true\">\n<md-tab><md-tab-label>{{\'OFFERED_SERVICES.SUBSCRIBER.DATA\' | translate}}</md-tab-label><md-tab-body><form \nname=\"subscriberData\" class=\"md-inline-form\" novalidate><div layout=\"column\" class=\"md-padding\"><p \nid=\"add-subscriber-in-line-help\" style=\"display:none\">{{\'OFFERED_SERVICES.ADD_SUBSCRIBER_INFOS\' | translate}}</p><p>\n<strong>{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_START\' | translate }}: {{ vm.formatDate(vm.subscription.dtStart)}}</strong>\n</p><p><strong>{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}:</strong><md-datepicker style=\"width:100%\" \nng-model=\"vm.subscription.dtEnd\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.DT_END\' | translate }}\">\n</md-datepicker><md-button class=\"md-raised md-accent md-fab\" ng-click=\"vm.saveDateEnd()\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></p></div><div layout=\"row\"><div \nclass=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-2dp\" layout=\"column\"><div layout=\"row\"><div class=\"content\" \nflex=\"80\"><div class=\"info-line\"><div class=\"title\" translate=\"USERS.GIVEN_NAME\">Given Name</div><div class=\"info\">\n{{vm.subscription.user.givenName}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.FAMILY_NAME\">\nFamily Name</div><div class=\"info\">{{vm.subscription.user.familyName}}</div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"USERS.EMAIL\">Email</div><div class=\"info\">\n{{(vm.subscription.user.email && !vm.subscription.user.email.endsWith(\'invalid\')) ? vm.subscription.user.email : \' - \'}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.BIRTH_DATE\">Birth Date</div><div class=\"info\">\n{{vm.formatDate(vm.subscription.user.birthDate) }}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERS.GENDER\">Gender</div><div class=\"info\">{{vm.subscription.user.gender}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"USERS.TAX_CODE\">Tax code</div><div class=\"info\">\n{{vm.subscription.user.taxCode}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.ADDRESS\">Address\n</div><div class=\"info\">{{vm.subscription.user.address}}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERS.CITY\">City</div><div class=\"info\">{{vm.subscription.user.city}}</div></div><div class=\"info-line\"><div\n class=\"title\" translate=\"USERS.PHONE\">Phone</div><div class=\"info\">{{vm.subscription.user.phone}}</div></div></div>\n<div layout=\"row\" layout-align=\"end\" style=\"padding: 4px\"><md-button title=\"{{\'USERS.EDIT\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.editProfile();\" aria-label=\"Edit\" ng-hide=\"vm.editableProfile\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon></md-button></div></div></div></div></div></form>\n</md-tab-body></md-tab><md-tab><md-tab-label>{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</md-tab-label>\n<md-tab-body><md-button class=\"md-raised md-accent md-fab\" ng-click=\"vm.saveSubscriptionServices();\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button><form name=\"servicesForm\" \nclass=\"md-inline-form\" novalidate><md-checkbox ng-model=\"vm.selectedServices[vm.offeredService.id]\" flex \nng-disabled=\"true\">{{vm.offeredService.name}}<div style=\"font-size: 75%; font-style: italic\"><span \nng-if=\"vm.offeredService.paymentType==\'F\'\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentType==\'O\'\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span \nng-if=\"vm.offeredService.paymentType==\'R\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span \nng-if=\"vm.offeredService.paymentType==\'R\'\"><span ng-if=\"vm.offeredService.paymentRenewInterval===\'day\'\">\n{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'month\'\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'year\'\">\n{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'week\'\">\n{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'2-month\'\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'3-month\'\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'4-month\'\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span ng-if=\"vm.offeredService.paymentRenewInterval===\'6-month\'\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{vm.offeredService.subscriptionPrice}} - </span><span \nng-if=\"vm.offeredService.paymentType===\'R\'\">\n{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{vm.offeredService.renewalPrice}} -</span></div></md-checkbox><br>\n<strong>{{\'SUBSCRIPTIONS.OPTIONAL_SERVICES\' | translate}}</strong> <span \nng-if=\"!vm.additionalServices || vm.additionalServices.length==0\">\n{{\'SUBSCRIPTIONS.NO_OPTIONAL_SERVICE_AVAILABLE\' | translate}}</span><div ng-repeat=\"service in vm.additionalServices\" \nlayout=\"row\" flex><md-checkbox ng-model=\"service._active\" flex=\"50\" ng-change=\"service._showDate = true;\">\n{{service.name}}<div style=\"font-size: 75%; font-style: italic\"><span ng-if=\"service.paymentType==\'F\'\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span ng-if=\"service.paymentType==\'O\'\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span ng-if=\"service.paymentType==\'R\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span> - <span ng-if=\"service.paymentType==\'R\'\"><span \nng-if=\"service.paymentRenewInterval===\'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"service.paymentRenewInterval===\'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> - </span><span \nng-if=\"service.paymentType===\'R\' || service.paymentType===\'O\'\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate}} {{service.subscriptionPrice}} - </span><span \nng-if=\"service.paymentType===\'R\'\">{{\'OFFERED_SERVICES.RENEWAL_PRICE\' | translate}} {{service.renewalPrice}} -</span>\n</div></md-checkbox><div layout=\"row\" flex=\"50\" layout-align=\"start center\" ng-if=\"service._showDate\"><md-datepicker \nng-model=\"service._referenceDate\" md-placeholder=\"Data\"></md-datepicker><div layout=\"row\" layout-padding \nlayout-align=\"center center\">Data di attivazione/disattivazione del servizio</div></div></div></form></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/subscriptions/subscription_payments.html","<div id=\"newservice\" class=\"page-layout simple tabbed page-sunscription-payments\" layout=\"column\" ng-init=\"vm.init();\">\n<div class=\"content md-padding\"><ov-navigation-bar class=\"menu-in-sottopagina\" \norganization-id=\"{{vm.organization.id}}\" selected-page=\"SERVICES\"></ov-navigation-bar><div \nclass=\"user-info md-padding\" layout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\" \nng-show=\"vm.userDetail !== null\"><img ng-if=\"!vm.userProfile.uriAvatar || vm.userProfile.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.userProfile.uriAvatar && vm.userProfile.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.userProfile.id }}/download/{{vm.userProfile.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.userProfile.givenName + \" \" + vm.userProfile.familyName }}</div></div><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><div style=\"display: none\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.addOrderMancanti(subscriber.subscriptionId);\" title=\"Generazione automatica piano pagamenti (temporaneo)\">\n<md-icon md-font-icon=\"icon-auto-fix\"></md-icon></md-button></div><table class=\"dataTable row-border hover\" \nid=\"table-pagamenti\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SUBSCRIPTIONS.PAYMENT_VALIDITY\' | translate }}</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SUBSCRIPTIONS.PAYMENT_VALUE\' | translate }}</span></div></th></tr></thead><tr ng-repeat=\"item in vm.items\" \nng-if=\"!item.dtDel\"><td><span style=\"display: none\">{{ item.dtBillingPeriodStart | date: \'yyyy-MM-dd\' }}</span><div \nstyle=\"float: left\">{{ vm.formatDate(item.dtBillingPeriodStart) }} &ndash; {{ vm.formatDate(item.dtBillingPeriodEnd) }}\n</div><div ng-repeat=\"orderDetail in item.orderDetails\" ng-if=\"!orderDetail.dtDel\" layout=\"column\"><div \nng-repeat=\"payment in orderDetail.payments\" ng-if=\"!payment.dtDel\" layout=\"row\" flex><div flex=\"80\" flex-offset=\"10\">\n{{ orderDetail.offeredService.name }} {{ orderDetail.subscriptionDiscount.discount.name }}</div><div flex=\"20\"><span \nng-if=\"!payment.earningCost.locked\"><md-icon md-font-icon=\"icon-pencil\" style=\"cursor: pointer; font-size: 18px\" \nclass=\"grey-400-fg\" ng-click=\"vm.modificaImporto(payment.id)\"></md-icon>&nbsp;&nbsp; </span><span \nng-if=\"payment.earningCost.locked\"><md-icon md-font-icon=\"icon-lock-outline\" style=\"font-size: 18px\" \nclass=\"grey-400-fg\" title=\"Pagamento contabilizzato\"></md-icon>&nbsp;&nbsp; </span><span \nng-class=\"payment.paymentStatus === \'PAYED\' ? \'payment-paid\' : (payment.paymentStatus === \'UNPAYED\' ? \'payment-unpaid\' : \'\')\">\n{{ payment.paymentValue }} &euro; <span ng-if=\"payment.paymentStatus === \'PAYED\'\"><i class=\"icon s16 icon-check\"></i>\n</span></span></div></div></div></td><td layout=\"column\" layout-align=\"start center\" class=\"md-body-2\" \nng-class=\"item.data.importoPagato >= item.data.importoTot ? \'payment-paid\' : \'\'\">\n{{ item.data.importoPagato }} / {{ item.data.importoTot }} &euro;</td></tr></table></div></div></div>");
$templateCache.put("app/main/pages/subscriptions/subscriptions.html","<div id=\"subscriptions\" class=\"page-layout simple right-sidenav\" style=\"background-color:white\" layout=\"row\" \nng-init=\"vm.init();\"><div class=\"center\" flex ms-scroll><div ng-class=\"{\'content\': vm.searchFilter.userId}\" \nstyle=\"padding-top: 0\"><div ng-if=\"vm.searchFilter.userId\" layout=\"row\"><ov-profile-navigation-bar \nuser-id=\"{{vm.searchFilter.userId}}\" selected-page=\"SUBSCRIPTIONS\"></ov-profile-navigation-bar></div><div \nclass=\"user-info md-padding\" layout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\" \nng-if=\"vm.searchFilter.userId\"><img ng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.givenName + \" \" + vm.user.familyName }}</div></div><div layout=\"row\" \nlayout-align=\"end start\" div class=\"grey-800-fg md-inline-form\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nclass=\"grey-800-fg\"><label translate=\"SUBSCRIPTIONS.SERVICE\" required class=\"grey-800-fg\">Service</label><md-select \nid=\"service-filter\" ng-model=\"vm.searchFilter.service\" ng-change=\"vm.reloadSubscriptionsTableItems();\" \nstyle=\"border-bottom-color:white\"><md-option ng-value>{{\'SUBSCRIPTIONS.ALL\' | translate}}</md-option><md-option \nng-value=\"service\" ng-selected=\"{{ vm.searchFilter.service.id === service.id ? \'true\' : \'false\' }}\" \nng-repeat=\"service in vm.organizationServices track by service.id\">{{service.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"grey-800-fg\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\" required class=\"grey-800-fg\">Payments</label><md-select \nid=\"payments-filter\" ng-model=\"vm.searchFilter.paymentStatus\" ng-change=\"vm.reloadSubscriptionsTableItems();\" \nstyle=\"border-bottom-color:white\"><md-option value=\"A\">{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option \nvalue=\"M\">{{\'OFFERED_SERVICES.SUBSCRIBER.PAYMENTS_MISSING\' | translate}}</md-option><md-option value=\"D\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.PAYMENTS_DONE\' | translate}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"grey-800-fg\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.DOCUMENTS\" required class=\"grey-800-fg\">Documents</label><md-select \nid=\"documents-filter\" ng-model=\"vm.searchFilter.documentStatus\" ng-change=\"vm.reloadSubscriptionsTableItems();\" \nstyle=\"border-bottom-color:white\"><md-option value=\"\">{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option \nvalue=\"MISSING\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_MISSING_DOCS\' | translate}}</md-option><md-option \nvalue=\"EXPIRED\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_EXPIRED_DOCS\' | translate}}</md-option><md-option \nvalue=\"EXPIRING\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_EXPIRING_DOCS\' | translate}}</md-option><md-option \nvalue=\"REJECTED\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_REJECTED_DOCS\' | translate}}</md-option><md-option \nvalue=\"VALIDATED\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_VALIDATED_DOCS\' | translate}}</md-option><md-option \nvalue=\"TO_BE_VALIDATED\">{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_TO_BE_VALIDATED_DOCS\' | translate}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"grey-800-fg\"><label \ntranslate=\"SUBSCRIPTIONS.PERSON\" required class=\"grey-800-fg\">Name</label><input type=\"text\" \nng-model=\"vm.searchFilter.searchText\" ng-blur=\"vm.reloadSubscriptionsTableItems();\" \nng-keyup=\"$event.keyCode == 13 ? vm.reloadSubscriptionsTableItems() : null\" style=\"\"></md-input-container></div><div \nng-if=\"vm.overrideDtEndRefPeriod && vm.refPeriod.dateTo && vm.overrideDtEndRefPeriod != vm.refPeriod.dateTo\" \nclass=\"ov-box ov-box-info\">\nAttenzione: normalmente questi dati sono filtrati in base al periodo di riferimento visibile in alto.<br>\nin questo momento invece, si sta considerando il seguente periodo: <strong>\n{{ vm.refPeriod.dtFrom | date : \'dd/MM/yyyy\' }} - {{ vm.overrideDtEndRefPeriodDate | date : \'dd/MM/yyyy\' }}</strong>\n</div><div layout=\"row\" ng-if=\"vm.selectedOrganization.id\"><ov-organization-alert \norganization-id=\"{{vm.selectedOrganization.id}}\"></ov-organization-alert></div><table \ndatatable=\"subscriptions-datatable\" dt-options=\"vm.dtSubscriptionsOptions\" dt-columns=\"vm.dtSubscriptionsColumns\" \ndt-instance=\"vm.dtSubscriptionsInstance\" class=\"row-border hover\"></table></div><div class=\"row ov-floating-btn\" \nlayout-align=\"end center\" ng-show=\"vm.searchFilter.userId\" ng-if=\"vm.searchFilter.userId !== vm.currentUserId\">\n<md-button ng-if=\"vm.isAdmin\" title=\"Aggiungi iscrizione\" class=\"md-fab md-raised md-accent\" \nng-click=\"vm.gotoNewSubscriptionUser(vm.searchFilter.userId, vm.selectedOrganization.id)\" aria-label=\"Add subscriber\">\n<md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\" style=\"background-color: transparent\">\n<img src=\"assets/images/logos/logo.png\"></span><span class=\"logo-text\">Club Your Life</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div class=\"toolbar-isadmin\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"toolbar-logo-principale\" ng-click=\"vm.gotoCurrentOrganizationDashboard();\"><img \nsrc=\"assets/images/logos/logo-webapp.png\"></div><div class=\"toolbar-separator\"></div><div class=\"shortcuts\" \nlayout=\"row\" layout-align=\"start center\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"Notifications\" ui-sref=\"app.pages_notifications\" \nstyle=\"border-radius: 0px\"><md-icon md-font-icon=\"icon-email\" class=\"icon s24\"></md-icon><md-tooltip \nmd-direction=\"bottom\">{{\'PAGES.NOTIFICATIONS\' | translate}}</md-tooltip><span ng-if=\"totalNewNotification>0\" \nclass=\"badge white-fg ng-binding ng-scope\" \nstyle=\"background: #F44336;\n						position: absolute;top: 0%;\n						min-width: 20px;height: 20px;line-height: 20px;font-size: 11px;\n						font-weight: bold;border-radius: 20px; z-index: 999\">\n{{totalNewNotification}}</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"Chat\" ng-click=\"vm.goToChat()\" style=\"border-radius: 0px\"><md-icon \nmd-font-icon=\"icon-hangouts\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Chat</md-tooltip><span \nng-if=\"totalNewChatMessage>0\" class=\"badge white-fg ng-binding ng-scope\" \nstyle=\"background: rgb(9, 210, 97);\n						position: absolute;top: 0%;\n						min-width: 20px;height: 20px;line-height: 20px;font-size: 11px;\n						font-weight: bold;border-radius: 20px; z-index: 999\">\n{{totalNewChatMessage}}</span></md-button></div></div><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"organizations-dropdown\" n_g-if=\"vm.currentOrganization\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm ng-if=\"vm.currentOrganization.name\">{{ vm.currentOrganization.name }}</span> <span \nclass=\"username\" hide show-gt-sm ng-if=\"!vm.currentOrganization.name\">{{ \"TOOLBAR.SELECTORGANIZATION\" | translate }}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\" class=\"padding-bottom-0\"><md-menu-item ng-repeat=\"club in vm.adminOrganizations\"><md-button \nng-click=\"vm.goToOrganization(club)\">{{club.name}}</md-button></md-menu-item><md-menu-item \nng-repeat=\"club in vm.staffOnlyOrganization\"><md-button ng-click=\"vm.goToOrganizationAttendances(club)\">{{club.name}}\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ui-sref=\".organizations\" \nstyle=\"color: rgba(0,0,0,.87)\">Associazioni in cui sei iscritto</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.goToNewOrganization();\" aria-label=\"Add\" title=\"{{\'ORGANIZATIONS.NEW\' | translate }}\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"icon\" style=\"color: #fff; z-index: 1\"></md-icon>Crea nuova associazione\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\" \nng-if=\"vm.currentOrganization\"></div><md-menu-bar id=\"referenceperiod-dropdown\" ng-if=\"vm.currentOrganization\"><md-menu\n md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\"><div layout=\"row\"><div><span \nng-if=\"!vm.currentReferencePeriod.dateFrom && !vm.currentReferencePeriod.dateTo\">periodo di riferimento</span> <span \nng-if=\"vm.currentReferencePeriod.dateFrom || vm.currentReferencePeriod.dateTo\">\n{{ vm.currentReferencePeriod.description }}</span></div><div><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></div></md-button><md-menu-content width=\"3\" class=\"padding-bottom-0\"><span \nng-repeat=\"period in vm.referencePeriods\"><md-menu-item ng-if=\"period.description !== \'-\'\"><md-button \nng-click=\"vm.setReferencePeriod(period)\">{{ period.description}}</md-button></md-menu-item><md-menu-divider \nng-if=\"period.description === \'-\'\"></md-menu-divider></span><md-menu-divider></md-menu-divider><md-menu-item><md-button\n ng-click=\"vm.openCustomReferencePeriodModal()\">Periodo personalizzato</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\" ng-if=\"vm.currentOrganization\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu-bar id=\"user-name\"><md-button class=\"user-button\" ng-disabled=\"disabled\" \naria-label=\"User name\" translate translate-attr-aria-label=\"TOOLBAR.USER_NAME\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide show-gt-sm>\n{{ vm.user.givenName + \" \" + vm.user.familyName }}</span></div></md-button></md-menu-bar><md-menu-bar \nid=\"menubar-applicationmenu\"><md-menu md-position-mode=\"left bottom\"><md-button id=\"btn-applicationmenu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" title=\"{{ TOOLBAR.APPLICATION_MENU | translate }}\" \naria-label=\"Application menu\" translate translate-attr-aria-label=\"TOOLBAR.APPLICATION_MENU\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\" alt=\"{{ TOOLBAR.APPLICATION_MENU | translate }}\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"padding-bottom-0\"><md-menu-item class=\"md-indent\"><md-button ng-disabled=\"true\" \naria-label=\"Impostazioni\"><strong>{{ \'TOOLBAR.ADMINMENU\' | translate }}</strong></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.gotoCurrentOrganizationDashboard()\" ng-disabled=\"!vm.currentOrganization\">\n{{ \'TOOLBAR.GOTOORGANIZATIONDASHBOARD\' | translate }}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoOrganizationContacts()\" ng-disabled=\"!vm.currentOrganization\">\n{{ \'TOOLBAR.GOTOORGANIZATIONCONTACTS\' | translate }}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoOrganizationServices()\" ng-disabled=\"!vm.currentOrganization\">\n{{ \'TOOLBAR.GOTOORGANIZATIONSERVICES\' | translate }}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoOrganizationEarningCosts()\" ng-disabled=\"!vm.currentOrganization\">\n{{ \'TOOLBAR.GOTOORGANIZATIONEARNINGCOSTS\' | translate }}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoOrganizationSettings()\" ng-disabled=\"!vm.currentOrganization\">\n{{ \'TOOLBAR.GOTOORGANIZATIONSETTINGS\' | translate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-button ng-disabled=\"true\" aria-label=\"Impostazioni\"><strong>\n{{ \'TOOLBAR.USERMENU\' | translate }}</strong></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.gotoUserDashboard()\">{{ \'TOOLBAR.GOTOUSERDASHBOARD\' | translate }}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.gotoUserServices()\">{{ \'TOOLBAR.GOTOUSERSERVICES\' | translate }}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.gotoUserDocuments()\">{{ \'TOOLBAR.GOTOUSERDOCUMENTS\' | translate }}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.gotoUserPayments()\">\n{{ \'TOOLBAR.GOTOUSERPAYMENTS\' | translate }}</md-button></md-menu-item><md-menu-item ng-click=\"vm.gotoUserSettings()\">\n<md-button>{{ \'TOOLBAR.GOTOUSERSETTINGS\' | translate }}</md-button></md-menu-item><md-menu-item \nng-click=\"vm.gotoUserPrivacySettings()\"><md-button>{{ \'TOOLBAR.GOTOUSERPRIVACYSETTINGS\' | translate }}</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"vm.logout()\">\n{{ \'TOOLBAR.LOGOUT\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !node.img\"></i>\n            <img class=\"icon s16\" style=\"width: 1.1em;height: 1.1em;\" ng-src=\"{{node.img}}\" ng-if=\"node.img\"></img>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !node.img\"></i>\n            <img class=\"icon s16\" style=\"width: 1.1em;height: 1.1em;\" ng-src=\"{{node.img}}\" ng-if=\"node.img\"></img>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/directives/ov-breadcrumbs/dialogs/ref_period_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{\'PAGES.SET_REF_PERIOD\' | translate}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\" \nstyle=\"font-size: 80%; font-style: italic\" class=\"md-subhead\">{{\'PAGES.SEASON_FILTER_HINT\' | translate}}</div><div \nlayout=\"row\" style=\"color: red\" class=\"md-subhead\">{{displayErrorDates}}</div><div layout=\"row\" div \nclass=\"md-inline-form\"><md-datepicker ng-model=\"organizationPeriod.dateFrom\" \nmd-placeholder=\"{{ \'PAGES.DATE_FROM\' | translate }}\"></md-datepicker><md-datepicker \nng-model=\"organizationPeriod.dateTo\" md-placeholder=\"{{ \'PAGES.DATE_TO\' | translate }}\"></md-datepicker><md-button \nng-click=\"clearDates()\" title=\"Pulisci le date\"><md-icon md-font-icon=\"icon-eraser\" class=\"\"></md-icon></md-button>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"applyDates()\">Ok</md-button>\n<md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/attendances/carnet_exchange/attendances_carnet_exchange.html","<div id=\"page-attendances-carnet-exchange\" class=\"flex-scrollable\" ms-scroll ng-init=\"vm.init();\"><div \nclass=\"content md-padding\" layout=\"column\" flex><div layout=\"row\"><ov-navigation-bar \norganization-id=\"{{ vm.organizationId }}\"></ov-navigation-bar></div><div layout=\"column\" class=\"md-padding\"><h1>\nScambio presenze tra carnet</h1><p>\nUsa questo strumento per scambiare le presenze tra due carnet. Usa questo strumento con cautela per sanare eventuali situaizoni anomale, nel dubbio contatta l\'assistenza.\n</p></div><div layout=\"row\" flex=\"100\"><md-card layout=\"column\" flex=\"50\"><md-card-content layout=\"row\" flex=\"100\"><div\n flex=\"10\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-credit-card\" class=\"s32\"></md-icon>\n</div><div flex flex-grow layout-align=\"start start\"><h2>{{ vm.orders.left.offeredService.name }}</h2></div>\n</md-card-content></md-card><md-card layout=\"column\" flex=\"50\"><md-card-content layout=\"row\" flex=\"100\"><div flex=\"10\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-credit-card\" class=\"s32\"></md-icon></div><div \nflex flex-grow layout-align=\"start start\"><h2>{{ vm.orders.right.offeredService.name }}</h2></div></md-card-content>\n</md-card></div><div layout=\"row\" flex=\"100\"><md-card layout=\"column\" flex=\"50\"><md-card-content layout=\"row\" \nflex=\"100\"><table class=\"dataTable row-border hover\"><thead><tr><th>Riga</th><th>Data presenza</th><th>Presente</th>\n<th>Note</th><th></th></tr></thead><tbody><tr ng-repeat=\"attendance in vm.orders.left.attendances\"><td \nng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\">{{ $index+1 }}</td><td \nng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\">{{ attendance.dtPresenza | date : \'dd/MM/yyyy\' }}\n</td><td ng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\"><span ng-if=\"!attendance.present\">non</span>\n presente</td><td><span class=\"ov-text-muted\">inserito in data {{ attendance.created | date : \'dd/MM/yyyy H:mm\' }}\n</span></td><td ng-click=\"vm.moveAttendance(attendance, vm.orders.left, vm.orders.right);\"><md-icon \nng-if=\"attendance.status === null\" md-font-icon=\"icon-chevron-right\" class=\"s24\"></md-icon><md-icon \nng-if=\"attendance.status === \'new\'\" md-font-icon=\"icon-plus-circle-outline\" class=\"s24\"></md-icon><md-icon \nng-if=\"attendance.status === \'deleted\'\" md-font-icon=\"icon-close-circle-outline\" class=\"s24\"></md-icon></td></tr>\n</tbody></table></md-card-content></md-card><md-card layout=\"column\" flex=\"50\"><md-card-content layout=\"row\" \nflex=\"100\"><table class=\"dataTable row-border hover\"><thead><tr><th></th><th>Riga</th><th>Data presenza</th><th>\nPresente</th><th>Note</th></tr></thead><tbody><tr ng-repeat=\"attendance in vm.orders.right.attendances\"><td \nng-click=\"vm.moveAttendance(attendance, vm.orders.right, vm.orders.left);\"><md-icon ng-if=\"attendance.status === null\" \nmd-font-icon=\"icon-chevron-right\" class=\"s24\"></md-icon><md-icon ng-if=\"attendance.status === \'new\'\" \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s24\"></md-icon><md-icon ng-if=\"attendance.status === \'deleted\'\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"s24\"></md-icon></td><td \nng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\">{{ $index+1 }}</td><td \nng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\">{{ attendance.dtPresenza | date : \'dd/MM/yyyy\' }}\n</td><td ng-class=\"attendance.status === \'deleted\' ? \'ov-text-muted\' : \'\'\"><span ng-if=\"!attendance.present\">non</span>\n presente</td><td><span class=\"ov-text-muted\">inserito in data {{ attendance.created | date : \'dd/MM/yyyy H:mm\' }}\n</span></td></tr></tbody></table></md-card-content></md-card></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.persist();\" \nng-disabled=\"vm.orders.changes.length === 0\"><md-icon md-font-icon=\"icon-check\"></md-icon>Conferma modifiche\n</md-button></div></div></div>");
$templateCache.put("app/main/pages/auth/activateuser/activateuser.html","<div id=\"activate-user\" ng-style=\"vm.pageStyle\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"activate-user-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"activate-user-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"top\"><div class=\"title\"><span><div class=\"logo\"><img \nsrc=\"assets/images/logos/logo.png\"></div><h1 ng-if=\"vm.user\">\n{{\'ACTIVATEUSER.WELCOME\' | translate }} {{ vm.user.givenName }} {{ vm.user.familyName }}</h1><h1 ng-if=\"!vm.user\">\n{{\'ACTIVATEUSER.ACCOUNT_ACTIVATION\' | translate }}</h1></span></div></div><form name=\"changePwdForm\"><div \nclass=\"title\" ng-if=\"vm.message==\'activated\'\" translate=\"ACTIVATEUSER.ACTIVATED\">ACTIVATEUSER.ACTIVATED</div><div \nclass=\"title\" ng-if=\"vm.message==\'activationError\'\" translate=\"ACTIVATEUSER.ACTIVATIONERROR\">\nACTIVATEUSER.ACTIVATIONERROR</div><div class=\"title\" ng-if=\"vm.message==\'invalidToken\'\" \ntranslate=\"ACTIVATEUSER.INVALIDTOKEN\">ACTIVATEUSER.INVALIDTOKEN</div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button ov-tag-btn-activated\" aria-label=\"LOGIN\" translate=\"ACTIVATEUSER.LOGIN\" \ntranslate-attr-aria-label=\"ACTIVATEUSER.LOGIN\" ng-click=\"vm.gotoLogin();\">LOGIN</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button ov-tag-btn-failedactivationregister\" aria-label=\"REGISTER\" \nng-if=\"vm.message==\'activationError\' || vm.message==\'invalidToken\'\" translate=\"ACTIVATEUSER.REGISTER\" \ntranslate-attr-aria-label=\"ACTIVATEUSER.REGISTER\" ng-click=\"vm.gotoRegister();\">REGISTER</md-button></form><ov-credits>\n</ov-credits></div></div></div>");
$templateCache.put("app/main/pages/auth/change_pwd/change-pwd.html","<div id=\"change-pwd\" ng-style=\"vm.pageStyle\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nclass=\"change-pwd-maschera-pixel\"><div id=\"change-pwd-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"change-pwd-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div \nng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\"><img src=\"assets/images/logos/logo.png\"></div><div \nng-if=\"vm.organization && vm.organization.uriLogo\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div></div><form name=\"changePwdForm\"><div class=\"message\">\n{{ (vm.user.flgMustResetPwd) ? (\'CHANGE_PWD.MESSAGE_SET\' | translate) : (\'CHANGE_PWD.MESSAGE\' | translate) }}</div>\n<md-input-container ng-if=\"!vm.user.flgMustResetPwd\" class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"CHANGE_PWD.PASSWORD\" required></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"passwordNew\" ng-model=\"vm.form.passwordNew\" placeholder=\"New Password\" \ntranslate translate-attr-placeholder=\"CHANGE_PWD.NEW_PASSWORD\" required></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"CHANGE_PWD.PASSWORD_CONFIRM\" required>\n</md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"SUBSCRIBE\" \nng-disabled=\"changePwdForm.$invalid || changePwdForm.$pristine\" translate-attr-aria-label=\"CHANGE_PWD.SUBMIT\" \nng-click=\"vm.doChangePwd();\">\n{{ (vm.user.flgMustResetPwd) ? (\'CHANGE_PWD.SET\' | translate) : (\'CHANGE_PWD.SUBMIT\' | translate) }}</md-button></form>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/changemailconfirm/changemailconfirm.html","<div id=\"dispatcher\" class=\"page-layout simple right-sidenav\" layout=\"row\"></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" ng-style=\"vm.pageStyle\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"top\"><div class=\"title\"><div \nng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\"><img src=\"assets/images/logos/logo.png\"></div><div \nng-if=\"vm.organization && vm.organization.uriLogo\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><h1></h1></div></div><form name=\"changePwdForm\"><div ng-if=\"vm.sent!=true\" class=\"title\" \ntranslate=\"FORGOTPASSWORD.ENTEREMAIL\">FORGOTPASSWORD.ENTEREMAIL</div><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.email\" placeholder=\"FORGOTPASSWORD.EMAIL\" autocapitalize=\"off\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL\" required></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"FORGOTPASSWORD.RESET\" ng-disabled=\"vm.email==null\" \nng-if=\"vm.sent==false\" translate=\"FORGOTPASSWORD.RESET\" translate-attr-aria-label=\"FORGOTPASSWORD.RESET\" \nng-click=\"vm.sendResetPasswordNotification();\">FORGOTPASSWORD.RESET</md-button><div ng-if=\"vm.sent==true\"><span \ntranslate=\"FORGOTPASSWORD.MAILSENT\">FORGOTPASSWORD.MAILSENT</span></div><div ng-if=\"vm.error\"><span>{{ vm.error }}\n</span></div></form><ov-credits></ov-credits></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"page-login\" ng-style=\"vm.pageStyle\" layout=\"row\" layout-align=\"start\"><div \nclass=\"login-maschera-pixel\"><div id=\"login-intro\" flex hide show-gt-sm><div \nng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\"><img src=\"assets/images/logos/logo.png\"></div><div \nng-if=\"vm.organization && vm.organization.uriLogo\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div class=\"title\"><span ng-if=\"!vm.organization || !vm.organization.name\">{{\'LOGIN.INTRO_TITLE\' | translate}}\n</span> <span ng-if=\"vm.organization && vm.organization.name\" ng-style=\"{color: vm.organization.titleColor}\">\n{{\'LOGIN.WELCOME_TO\' | translate}}&nbsp;{{vm.organization.name}}</span></div><div class=\"description\"><span \nng-if=\"!vm.organization || !vm.organization.description\">{{\'LOGIN.INTRO_DESCRIPTION\' | translate}}</span> <span \nng-if=\"vm.organization && vm.organization.description\" ng-style=\"{color: vm.organization.titleColor}\">\n{{vm.organization.description}}</span></div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div \nng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\" hide-gt-sm><img src=\"assets/images/logos/logo.png\">\n</div><div ng-if=\"vm.organization && vm.organization.uriLogo\" hide-gt-sm><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div class=\"description\" \ntranslate=\"LOGIN.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form id=\"popupContainer\" \nname=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" id=\"txt-email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" id=\"txt-password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button ov-tag-btn-login\" aria-label=\"LOG IN\" id=\"loginBtn\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.doLogin();\">LOG IN</md-button><div class=\"text-center\"><a \nclass=\"link text-center font-size-14\" style=\"cursor: pointer\" ng-click=\"vm.goToForgotPassword()\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Request a password reset</a></div></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text font-size-14\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span></div><md-button class=\"md-raised fullwidth md-grey-300-bg ov-tag-btn-register\" \nid=\"btn-register\" ng-click=\"vm.goToRegistration()\"><div layout=\"row\" layout-align=\"center center\"><span><span \ntranslate=\"LOGIN.CREATE_ACCOUNT\">Create an account</span></span></div></md-button><div class=\"separator\"><span \nclass=\"text\" translate=\"LOGIN.OR\">OR</span></div><div layout=\"column\" layout-align=\"start center\"><md-button \nclass=\"md-raised google fullwidth ov-tag-btn-googlelogin\" id=\"btn-google-login\" ng-click=\"vm.googleLogin();\"><div \nlayout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button \nclass=\"md-raised facebook fullwidth ov-tag-btn-facebooklogin\" id=\"btn-facebook-login\" ng-click=\"vm.facebookLogin();\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button></div><div class=\"register\" \nng-if=\"vm.organization && vm.organization.privacyPolicyType===\'LINK\' && vm.organization.privacyLink\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><a class=\"link\" target=\"_blank\" style=\"cursor: pointer\" \nhref=\"{{vm.organization.privacyLink}}\" id=\"lnk-privacy-policy-link\">Privacy policy</a></div><div class=\"register\" \nng-if=\"vm.organization && vm.organization.privacyPolicyType===\'HTML\' && vm.organization.privacyPolicy\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><a class=\"link\" style=\"cursor: pointer\" \nng-click=\"vm.goToPrivacyPolicy()\" id=\"lnk-privacy-policy-page\">Privacy policy</a></div></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"page-register\" ng-style=\"vm.pageStyle\" layout=\"row\" layout-align=\"start\"><div \nclass=\"login-maschera-pixel\"><div id=\"register-intro\" flex hide show-gt-sm><div \nng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\"><img src=\"assets/images/logos/logo.png\"></div><div \nng-if=\"vm.organization && vm.organization.uriLogo\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div class=\"title\"><span ng-if=\"!vm.organization || !vm.organization.name\">{{\'REGISTER.INTRO_TITLE\' | translate}}\n</span> <span ng-if=\"vm.organization && vm.organization.name\" ng-style=\"{color: vm.organization.titleColor}\">\n{{\'LOGIN.WELCOME_TO\' | translate}}&nbsp;{{vm.organization.name}}</span></div><div class=\"description\" \ntranslate=\"REGISTER.INTRO_DESCRIPTION\" ng-style=\"{color: vm.organization.titleColor}\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll>\n<div id=\"register-form\"><div ng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\" hide-gt-sm><img \nsrc=\"assets/images/logos/logo.png\"></div><div ng-if=\"vm.organization && vm.organization.uriLogo\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div class=\"title\"><span ng-if=\"!vm.organization || !vm.organization.name\">{{\'REGISTER.INTRO_TITLE\' | translate}}\n</span> <span ng-if=\"vm.organization && vm.organization.name\" ng-style=\"{color: vm.organization.titleColor}\">\n{{\'LOGIN.WELCOME_TO\' | translate}}&nbsp;{{vm.organization.name}}</span></div><div class=\"description\" \ntranslate=\"REGISTER.INTRO_DESCRIPTION\" ng-style=\"{color: vm.organization.titleColor}\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll>\n<div id=\"register-form\"><div ng-if=\"!vm.organization || !vm.organization.uriLogo\" class=\"logo\" hide-gt-sm><img \nsrc=\"assets/images/logos/logo.png\"></div><div ng-if=\"vm.organization && vm.organization.uriLogo\" hide-gt-sm><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><div class=\"description\" \ntranslate=\"REGISTER.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input name=\"givenName\" id=\"txt-given-name\" \nng-model=\"vm.form.givenName\" placeholder=\"Given Name\" translate translate-attr-placeholder=\"USERS.GIVEN_NAME\" required>\n<div ng-messages=\"registerForm.givenName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.GIVEN_NAME_REQUIRED\">Given Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input name=\"familyName\" id=\"txt-family-name\" \nng-model=\"vm.form.familyName\" placeholder=\"Family Name\" translate translate-attr-placeholder=\"USERS.FAMILY_NAME\" \nrequired><div ng-messages=\"registerForm.familyName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.FAMILY_NAME_REQUIRED\">Family Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float id=\"container-birth-date\"><label translate=\"USERS.BIRTH_DATE\">\nBirth date</label><input rsmdatedropdowns deny-future-dates=\"true\" ng-model=\"vm.form.birthDate\"></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" id=\"txt-email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nid=\"txt-password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nid=\"txt-password-confirm\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required id=\"cb-terms-conditions\"></md-checkbox><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a \nhref=\"privacy.html\" target=\"_blank\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a>\n</div></div><md-button type=\"submit\" id=\"btn-create-account\" \nclass=\"md-raised md-accent submit-button ov-tag-btn-sendregistration\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.doRegister();\">CREATE MY ACCOUNT</md-button></form>\n<div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" \ntranslate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" style=\"cursor: pointer\" \nng-click=\"vm.goToLogin()\" translate=\"REGISTER.LOGIN\" id=\"lnk-login\">Log in</a></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset/reset.html","<div id=\"dispatcher\" class=\"page-layout simple right-sidenav\" layout=\"row\"></div>");
$templateCache.put("app/main/pages/commons/dialogs/add_user_as_contact.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'PAGES.CONFIRM_ADD_USER_AS_NEW_CONTACT\' | translate}}</h3>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\">Ok</md-button><md-button \nng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/ask_contact_notification.html","<md-dialog aria-label=\"Notifica contatto\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex><md-checkbox class=\"remember-me\" \nng-model=\"myResource.sendInvitation\"><span translate=\"PAGES.SEND_NOTIFICATION_NEW_CONTACT\">\nInvia una notifica al nuovo utente</span></md-checkbox></div><div ng-show=\"myResource.sendInvitation\" layout=\"row\" \nflex><md-input-container flex style=\"width:80%\"><label translate=\"OFFERED_SERVICES.MESSAGE_FOR_THE USER\">Message\n</label><textarea ng-model=\"myResource.invitationNote\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\">Procedi\n</md-button><md-button ng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/children_lookup_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><span layout=\"row\">\n{{parentDisplayName}} ({{parentEmail}}) è attualmente genitore / tutore dei seguenti utenti:</span> <span layout=\"row\" \nclass=\"font-size-12\">\nSe stai cercando di inserire uno dei seguenti utenti clicca sul suo nome per selezionarlo, altrimenti premi {{\'PAGES.CANCEL\' | translate}}\n</span><div layout=\"row\" class=\"md-padding\" layout-align=\"start center\" ng-repeat=\"item in parentChildren\" \nstyle=\"cursor: pointer\" ng-click=\"answer(item.id)\"><img md-menu-align-target \nng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img \nmd-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span>{{item.displayName}} {{item.email.indexOf(\'.invalid\') > 0 ? \'\' : item.email}}</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/delete_confirm_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PAGES.DELETE\">Delete</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h3>\n{{\'PAGES.DELETE_CONFIRM\' | translate}}</h3></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer()\" translate=\"PAGES.DO_DELETE\">Delete</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/dyndoc_dialog.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><p ng-if=\"dynDocIntro\">\n{{ dynDocIntro }}</p><dynamic-document ng-data-url=\"{{ dyndocUrl }}\" ng-template-url=\"\" ng-stats-url=\"\" ng-save-url=\"\" \nng-edit-mode=\"false\"></dynamic-document></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer({})\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/help_dialog.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Title</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><h2>Title</h2><p>{{helpTxt}}</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer(\'not useful\')\">Not Useful</md-button>\n<md-button ng-click=\"answer(\'useful\')\">Useful</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/other_contact_dialog.html","<md-dialog aria-label=\"Notifica contatto\" ng-cloak><form name=\"myForm\" novalidate style=\"min-width: 280px\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex><md-select ng-model=\"contact.contactType\" \nrequired><md-option value=\"EMAIL\">{{\'USERS.EMAIL\' | translate}}</md-option><md-option value=\"PHONE\">\n{{\'USERS.PHONE\' | translate}}</md-option><md-option value=\"MOBILE_PHONE\">{{\'USERS.MOBILE_PHONE\' | translate}}\n</md-option></md-select></div><div layout=\"row\" flex><md-input-container><label \ntranslate=\"USERS.OTHER_CONTACTS_CONTACT\">Contact</label><input type=\"text\" ng-model=\"contact.contact\" \nmd-maxlength=\"500\" required></md-input-container></div><div layout=\"row\" flex><md-input-container><label \ntranslate=\"USERS.OTHER_CONTACTS_DESCRIPTION\">Description</label><input type=\"text\" ng-model=\"contact.description\" \nmd-maxlength=\"500\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer()\" ng-disabled=\"!contact.contact || !contact.contactType\">Procedi</md-button><md-button \nng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/proceed_confirm_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'PAGES.PROCEED_CONFIRM\' | translate}}</h3></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\">Ok</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/validate_docs_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"newDocsForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.SUBSCRIBER.VALIDATE_DOCS\">Documents validation</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"min-width: 900px\"><div ng-repeat=\"doctype in doctypes\"><div \nlayout=\"row\" div class=\"md-inline-form\"><div align=\"left\" \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id] && myResource.serviceDocuments[doctype.organizationDoctype.id]!==null\">\n<md-input-container flex><a \nng-href=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ myResource.serviceDocuments[doctype.organizationDoctype.id].userDocument.userId }}/download/{{ myResource.serviceDocuments[doctype.organizationDoctype.id].uri }}?access_token={{ vm.accessToken }}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-download\"></md-icon></a></md-input-container></div><div style=\"width:100%\" \nalign=\"left\"><md-input-container flex>{{doctype.organizationDoctype.name}}</md-input-container></div><div \nstyle=\"width:30%; font-size: 75%\" align=\"left\" \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id] && myResource.serviceDocuments[doctype.organizationDoctype.id]!==null\">\n<md-input-container flex ng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id].flgValidated===0\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.TO_BE_VALIDATED\' | translate}}</md-input-container><md-input-container flex \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id].flgValidated<0\">\n{{\'OFFERED_SERVICES.DOCUMENT_IS_NOT_VALID\' | translate}}</md-input-container><md-input-container flex \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id].flgValidated>0\">\n{{\'OFFERED_SERVICES.DOCUMENT_IS_VALID\' | translate}}</md-input-container></div><div style=\"width:100%\" align=\"center\" \nng-if=\"!myResource.serviceDocuments[doctype.organizationDoctype.id] || myResource.serviceDocuments[doctype.organizationDoctype.id]===null\">\n<md-input-container flex><span style=\"color: red; font-weight: bolder\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.MISSING_DOCUMENT\' | translate}}</span></md-input-container></div><md-datepicker \nstyle=\"width:100%\" md-min-date=\"minDateForValidation\" required \nng-model=\"myResource.serviceDocuments[doctype.organizationDoctype.id].validTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.VALID_UNTIL\' | translate }}\" \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id] && myResource.serviceDocuments[doctype.organizationDoctype.id]!==null\">\n</md-datepicker><div style=\"width:100%; padding-right: 1em\" align=\"right\" \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id] && myResource.serviceDocuments[doctype.organizationDoctype.id]!==null\">\n<md-input-container flex><md-button title=\"{{\'OFFERED_SERVICES.SUBSCRIBER.VALIDATE\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.validateSubscriptionDocument($event,myResource.serviceDocuments[doctype.organizationDoctype.id], 1)\" \naria-label=\"Validate\"><md-icon md-font-icon=\"icon-check\" class=\"md-primary\"></md-icon></md-button></md-input-container>\n<md-input-container flex><md-button title=\"{{\'OFFERED_SERVICES.SUBSCRIBER.REJECT\' | translate}}\" \nclass=\"md-icon-button md-raised md-warn\" \nng-click=\"vm.validateSubscriptionDocument($event,myResource.serviceDocuments[doctype.organizationDoctype.id], -1)\" \naria-label=\"Reject\"><md-icon md-font-icon=\"icon-close\" class=\"md-primary\"></md-icon></md-button></md-input-container>\n</div></div><div style=\"width:100%\" \nng-if=\"myResource.serviceDocuments[doctype.organizationDoctype.id] && myResource.serviceDocuments[doctype.organizationDoctype.id]!==null\" \nflex><md-input-container flex style=\"width:80%\"><label translate=\"OFFERED_SERVICES.MESSAGE_FOR_THE USER\">Message\n</label><input type=\"text\" ng-model=\"myResource.serviceDocuments[doctype.organizationDoctype.id].notes\" rows=\"1\" \nmd-select-on-focus></md-input-container></div><hr></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CLOSE\">Chiudi</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/commons/dialogs/warning_no_mail.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'PAGES.NO_MAIL_CONFIRM\' | translate}}</h3></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\" translate=\"PAGES.PROCEED\">Delete</md-button><md-button \nng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/docs_validation/dialogs/validate_doc_in_all_subscription_confirm_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>\nHai validato il documento! Vuoi anche propagarlo in tutte le eventuali iscrizioni attive dell\'utente che lo richiedono?\n</h3></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\">Ok</md-button><md-button \nng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/earningcosts/dialogs/delete_earningcost_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"delScheduleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.EARNING_COST.DELETE\">Delete earning cost</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'ORGANIZATIONS.EARNING_COST.DELETE_CONFIRM\' | translate}}</h3>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\" translate=\"ORGANIZATIONS.DELETE\">\nDelete</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/earningcosts/dialogs/edit_description_dialog.html","<md-dialog aria-label=\"New earning / cost\" ng-cloak><form name=\"newEarningCostForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\"><md-input-container><label \ntranslate=\"EARNING_COST.ENTRY_DESCRIPTION\" ng-required=\"myResource.paymentOrEntry===\'N\'\">Description</label><textarea \nng-model=\"myResource.entryDescription\" md-maxlength=\"500\" rows=\"4\" md-select-on-focus></textarea></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" ng-show=\"!isAddingUserOrganization\"><md-button \nng-click=\"answer({entryDescription: myResource.entryDescription})\" translate=\"OFFERED_SERVICES.SAVE\">Save</md-button>\n<md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/earningcosts/dialogs/edit_earningcost_dialog.html","<md-dialog aria-label=\"New earning / cost\" ng-cloak><form name=\"newEarningCostForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"EARNING_COST.ADD\">New earning cost</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" ng-if=\"!isAddingUserOrganization\"><div \nlayout=\"row\"><md-radio-group ng-model=\"myResource.paymentOrEntry\" required><md-radio-button value=\"E\">Entrata / Uscita\n</md-radio-button><md-radio-button value=\"N\">Nota di credito</md-radio-button></md-radio-group></div><div \nlayout=\"column\" ng-show=\"myResource.paymentOrEntry===\'E\' || myResource.paymentOrEntry===\'N\'\"><div layout=\"row\" div \nclass=\"md-inline-form\"><md-datepicker ng-model=\"myResource.entryDate\" \nmd-placeholder=\"{{ \'EARNING_COST.ENTRY_DATE\' | translate }}\" required></md-datepicker><md-input-container><label \ntranslate=\"EARNING_COST.ENTRY_VALUE\" required>Amount</label><input type=\"number\" min=\"0\" \nng-model=\"myResource.entryValue\" required></md-input-container></div><md-input-container \nng-if=\"myResource.paymentOrEntry===\'E\'\"><label translate=\"EARNING_COST.ENTRY_TYPE\" required>Entry type</label>\n<md-select ng-model=\"myResource.entryType\" ng-change=\"reloadReason()\"><md-option value=\"1\">\n{{ \'EARNING_COST.INCOME\' | translate}}</md-option><md-option value=\"-1\">{{ \'EARNING_COST.EXPENSE\' | translate}}\n</md-option></md-select></md-input-container><md-input-container ng-if=\"myResource.paymentOrEntry===\'E\'\"><label \ntranslate=\"EARNING_COST.REASON\" required>Reason</label><md-select \nmd-placeholder=\"{{\'EARNING_COST.REASON\'  | translate }}\" ng-model=\"myResource.paymentReason\" style=\"min-width: 300px\">\n<md-option ng-value=\"paymentReason\" ng-repeat=\"paymentReason in paymentReasons  track by paymentReason.id\">\n{{paymentReason.name}}</md-option></md-select></md-input-container><div layout=\"row\"><div layout=\"column\">\n<md-autocomplete style=\"min-width: 480px\" md-selected-item=\"myResource.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in lookupUserOrganizations(vm.searchText)\" md-item-text=\"item.displayName\" \nmd-menu-class=\"autocomplete-custom-template\" md-min-length=\"2\" \nmd-floating-label=\"{{\'EARNING_COST.COUNTER_PART\' | translate}} (email)\" \nmd-selected-item-change=\"selectedUserOrganizationChange(item)\"><md-item-template><span \nmd-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"column\"><md-button class=\"md-accent md-raised\" ng-click=\"addUserOrganization()\">\nAggiungi cliente/fornitore</md-button></div></div><md-input-container><label \ntranslate=\"EARNING_COST.ENTRY_DESCRIPTION\" ng-required=\"myResource.paymentOrEntry===\'N\'\">Description</label><textarea \nng-model=\"myResource.entryDescription\" md-maxlength=\"500\" rows=\"4\" md-select-on-focus></textarea></md-input-container>\n</div><div layout=\"column\" ng-show=\"myResource.paymentOrEntry===\'P\'\"><div layout=\"row\"><div layout=\"column\"><span \nclass=\"md-subhead\">Seleziona l\'utente per cui vuoi registrare il pagamento</span><md-autocomplete \nstyle=\"min-width: 480px\" md-selected-item=\"myResource.selectedUser\" md-search-text=\"vm.searchText\" \nmd-items=\"item in lookupUser(vm.searchText)\" md-item-text=\"item.displayName\" \nmd-menu-class=\"autocomplete-custom-template\" md-min-length=\"2\" md-floating-label=\"Nome, cognome, email\" \nmd-selected-item-change=\"selectedUserChange(item)\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" \nmd-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span></md-item-template><md-not-found>\n{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete></div></div><div layout=\"column\">\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionServices\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.SERVICES.PAYMENTS\">Payments</span></div></th></tr></thead><tbody><tr \nng-repeat=\"service in vm.userServices\"><td>{{service.name}}</td><td style=\"color: green; font-weight: bold\" \nng-if=\"service.paymentValue >= service.paymentDue\">{{service.paymentValue}} Euro<md-icon style=\"color: green\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon></td><td style=\"color: red; font-weight: bold\" \nng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button class=\"md-warn md-raised\" \naria-label=\"User Payments\" \nng-click=\"vm.askPaymentDetails(vm.subscriberId, service.subscriptionId, (service.paymentDue - service.paymentValue));\" \ntranslate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\"><md-icon style=\"color: white\" \nmd-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>PAGA</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></td></tr></tbody></table></div></div></div><div \nng-if=\"isAddingUserOrganization\" style=\"min-width: 600px:\"><div layout=\"row\" layout-align=\"end center\"><md-button \ntitle=\"{{\'OFFERED_SERVICES.RESOURCES.BACK\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"cancelUserOrganization()\"><md-icon md-font-icon=\"icon-undo-variant\" class=\"md-primary\"></md-icon></md-button>\n</div><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n<md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Tipologia</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\">\n<md-input-container class=\"md-block\"><md-radio-group ng-model=\"userOrg.type\" required><md-radio-button value=\"U\">\nPersona fisica</md-radio-button><md-radio-button value=\"O\">Persona giuridica</md-radio-button></md-radio-group>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid && (userOrg.type===\'U\' || userOrg.type===\'O\')\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Dati</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\"><div layout=\"row\" div \nclass=\"md-inline-form\" ng-if=\"userOrg.type===\'U\'\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\">Given Name</label><input type=\"text\" name=\"userOrg.givenName\" \nng-model=\"userOrg.givenName\" ng-required=\"userOrg.type===\'U\'\"></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\">Family Name</label><input type=\"text\" name=\"userOrg.familyName\" \nng-model=\"userOrg.familyName\" ng-required=\"userOrg.type===\'U\'\"></md-input-container></div><div layout=\"row\" div \nclass=\"md-inline-form\" ng-if=\"userOrg.type===\'O\'\"><md-input-container><label translate=\"ORGANIZATIONS.NAME\">Name\n</label><input type=\"text\" name=\"givenName\" ng-model=\"userOrg.name\" ng-required=\"userOrg.type===\'O\'\">\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.PIVA\">P.Iva</label><input type=\"text\" \nname=\"givenName\" ng-model=\"userOrg.piva\"></md-input-container></div><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"email\" ng-model=\"userOrg.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">{{\'OFFERED_SERVICES.PREVIOUS\' | translate}}</md-button><div class=\"steps\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.selectedIndex==1\" \nng-disabled=\"!userOrg || !userOrg.type || (userOrg.type!==\'U\' && userOrg.type!==\'O\')\">\n{{\'OFFERED_SERVICES.NEXT\' | translate}}</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"addUserOrganizationOnDB();\" ng-show=\"msWizard.selectedIndex==1\" ng-disabled=\"!isUserOrganizationValid();\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon>{{\'OFFERED_SERVICES.SAVE\' | translate}}\n</md-button></div></ms-form-wizard></div></md-dialog-content><md-dialog-actions layout=\"row\" \nng-show=\"!isAddingUserOrganization\"><md-button \nng-disabled=\"newEarningCostForm.$invalid || newEarningCostForm.$pristine || !myResource.entryValue || ( (!myResource.paymentReason || myResource.paymentReason===null) && myResource.paymentOrEntry===\'E\') || (!myResource.entryDescription && myResource.paymentOrEntry===\'N\') \" \nng-click=\"answer({entryDate: myResource.entryDate, entryValue: myResource.entryValue,\n          			entryType: myResource.entryType, entryDescription: myResource.entryDescription, paymentReason:myResource.paymentReason, counterPart:myResource.selectedItem})\" \ntranslate=\"OFFERED_SERVICES.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/legal/cookie-policy/it.html","<div id=\"page-legal-personal-data-policy\" class=\"page-legal-personal-data-policy page-layout simple right-sidenav\" \nlayout=\"column\" ng-init=\"vm.init();\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"60\" flex-offset-gt-md=\"20\" flex-gt-lg=\"50\" flex-offset-gt-lg=\"25\"><h1>Cookie policy</h1><h2>\nCosa sono i cookie</h2><p>\nI cookie sono brevi stringhe di testo inviate al browser degli utenti e salvate sul computer (o altro dispositivo utilizzato per la navigazione come smartphone e tablet) ogni volta che si visita un sito web o che si utilizza un social network e possono contenere diversi dati come, ad esempio, il nome del server da cui provengono, un identificatore numerico ecc. I cookie possono rimanere nel sistema per la durata di una sessione (cioè fino a che non si chiude il browser utilizzato per la navigazione sul web) o per lunghi periodi e possono contenere un codice identificativo unico. I gestori dei siti web e i soggetti che attraverso i medesimi siti li installano possono accedere esclusivamente ai cookie che hanno archiviato sul browser dei singoli utenti.\n</p><h2>A cosa servono</h2><p>\nAlcuni cookie sono usati per eseguire autenticazioni informatiche, monitorare sessioni e ricordare preferenze o informazioni specifiche sugli utenti che accedono ad una pagina web. Questi cookie, cosiddetti \n<strong>tecnici</strong>\n, sono spesso utili, perché possono rendere più veloce e rapida la navigazione e fruizione del web, perché ad esempio intervengono a facilitare alcune procedure quando si fanno acquisti online, quando ci si autentica ad aree ad accesso riservato o quando un sito web riconosce in automatico la lingua che si utilizza abitualmente.\n</p><p>\nAltri cookie possono invece essere utilizzati per monitorare e profilare gli utenti durante la navigazione, studiare i loro movimenti e abitudini di consultazione del web o di consumo (cosa comprano, cosa leggono, ecc.), anche allo scopo di inviare pubblicità di servizi mirati e personalizzati (c.d. Behavioural Advertising). Parliamo in questo caso di cookie di \n<strong>profilazione</strong>.</p><p>Una particolare tipologia di cookie, detti <strong>analytics</strong>\n, sono poi utilizzati dai gestori dei siti web per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso, su quali parole chiave hanno usato per raggiungere il sito, e quindi elaborare statistiche generali sul servizio e sul suo utilizzo. Il titolare può utilizzare tali informazioni per compilare rapporti e migliorare il sito. Questi possono essere sia cookie tecnici che di profilazione, a seconda dei dati che raccolgono.\n</p><h2>Come vengono utilizzati i cookie in questo sito</h2><p>Il sito app.clubyourlife.cloud utilizza:</p><ul><li>\nCookie tecnici per la gestione degli accessi alle aree di amministrazione.</li><li>\nCookie di terze parti al fine di registrare dati sul traffico web per poter gestire correttamente il flusso di visitatori e apportare modifiche per fornire una migliore esperienza di navigazione e consultazione delle informazioni. Tutti i dati sono trattati in modo anonimo a fini statistici e non vengono registrati dati identificativi dei visitatori. Il servizio di statistiche sul traffico web utilizzato in questo sito internet è fornito da Google Analytics (opportunamente anonimizzato e rendendolo quindi un cookie “tecnico”) per avere informazioni statistiche di tipo aggregato utili per valutare l’uso del sito web e le attività svolte da parte del visitatore. Google memorizza le informazioni raccolte dal cookie su server che possono essere dislocati anche negli Stati Uniti. Google si riserva di trasferire le informazioni raccolte con il suo cookie a terzi ove ciò sia richiesto per legge o laddove il soggetto terzo processi informazioni per suo conto. Google non assocerà il vostro indirizzo IP a nessun altro dato posseduto da Google al fine di ottenere un profilo dell’utente di maggiore dettaglio. È possibile consultare le più recenti norme sulla privacy che regolano l’utilizzo di questo servizio al link&nbsp;\n<a href=\"http://www.google.com/intl/it/policies/privacy/\">http://www.google.com/intl/it/policies/privacy/</a>\n. L’Utente può disabilitare in modo selettivo l’azione di Google Analytics installando sul proprio browser il componente di opt-out fornito da Google. Per disabilitare la raccolta di dati da parte di Google Analytics, si rinvia al link di seguito indicato: \n<a href=\"https://tools.google.com/dlpage/gaoptout\">https://tools.google.com/dlpage/gaoptout</a>.</li><li>\nCookie di profilazione per consentire la condivisione dei contenuti sui social network o per incorporare contenuti da altre piattaforme. Di seguito un elenco degli strumenti/servizi di terze parti che installano cookie con indicati a fianco i link utili alle rispettive cookie policy:\n<ul><li>Facebook, <a href=\"https://www.facebook.com/help/cookies/\">https://www.facebook.com/help/cookies/</a></li><li>\nGoogle (o altri servizi di Google come Google Maps), <a href=\"http://www.google.com/policies/technologies/types/\">\nhttp://www.google.com/policies/technologies/types/</a></li></ul></li></ul><p>\nDisabilitando questi cookie potranno non essere più disponibili alcuni contenuti quali: Mappe di Google, contenuti provenienti da pagine Facebook o da altri social network.\n</p><p>\nProseguendo nella consultazione del sito internet app.clubyourlife.cloud il visitatore presta il suo consenso all’installazione dei cookie.\n</p><h2>Come disabilitare i cookie</h2><p>\nL’utente può decidere se accettare o meno i cookie utilizzando le impostazioni del proprio browser.</p><p>\nAttenzione: la disabilitazione totale o parziale dei cookie tecnici può compromettere alcune funzionalità del sito. La disabilitazione dei cookie di “terze parti” o di “profilazione” non pregiudica in alcun modo la navigabilità.\n</p><p>\nL’impostazione può essere definita in modo specifico per i diversi siti e applicazioni web. Inoltre i migliori browser consentono di definire impostazioni diverse per i cookie “proprietari” e per quelli di “terze parti”.\n</p><p>Per maggiori informazioni sulla gestione dei cookie nei principali&nbsp;browser consultare i seguenti link:</p>\n<p>Chrome:&nbsp;<a href=\"https://support.google.com/chrome/answer/95647?hl=it\">\nhttps://support.google.com/chrome/answer/95647?hl=it</a><br>Firefox:&nbsp;<a \nhref=\"https://support.mozilla.org/it/kb/Gestione%20dei%20cookie\">\nhttps://support.mozilla.org/it/kb/Gestione%20dei%20cookie</a><br>Internet Explorer:&nbsp;<a \nhref=\"http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11\">\nhttp://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11</a><br>Opera:&nbsp;<a \nhref=\"http://help.opera.com/Windows/10.00/it/cookies.html\">http://help.opera.com/Windows/10.00/it/cookies.html</a><br>\nSafari:&nbsp;<a href=\"http://support.apple.com/kb/HT1677?viewlocale=it_IT\">\nhttp://support.apple.com/kb/HT1677?viewlocale=it_IT</a></p><p>&nbsp;</p><p>\nIl titolare del sito&nbsp;app.clubyourlife.cloud non è in alcun modo responsabile per il contenuto dei cookie di terze parti che non può essere direttamente sotto il proprio controllo, identificandosi in questo caso come editore intermediario di contenuti prodotti da un servizio esterno al sito internet app.clubyourlife.cloud\n</p></div></div></div>");
$templateCache.put("app/main/pages/legal/gdpr-settings/gdpr-settings.html","<div id=\"page-legal-gdpr\" class=\"page-legal-gdpr page-layout simple right-sidenav\" layout=\"column\" \nng-init=\"vm.init();\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\"><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Autorizzazione al trattamento dei dati</span> <span class=\"md-subhead\">\nTi chiediamo di indicarci le tue preferenze riguardo al trattamento dei tuoi dati.</span></md-card-title-text>\n</md-card-title><md-card-header><md-card-avatar><img ng-if=\"!vm.user.uriAvatar\" class=\"md-user-avatar\" \nsrc=\"assets/images/avatars/katherine.jpg\"> <img ng-if=\"vm.user.uriAvatar\" class=\"md-user-avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n</md-card-avatar><md-card-header-text class=\"md-padding\"><span class=\"md-title\">\n{{ vm.user.familyName }} {{ vm.user.givenName }}</span></md-card-header-text></md-card-header><md-card-content \nlayout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\"><md-checkbox ng-model=\"vm.user.consensoTecnico\" \naria-label=\"Consenso tecnico\">Acconsento al trattamento dei dati ai fini dell\'erogazione del servizio <span \nng-if=\"!vm.user.consensoTecnico\" class=\"md-padding\"><md-icon md-font-icon=\"icon-alert\"></md-icon>\nSenza questo consenso non sarà possibile fornirti i servizi di ClubYourLife</span></md-checkbox></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.user.consensoMarketing\" aria-label=\"Consenso marketing\">\nAcconsento al trattamento dei dati con finalità di marketing</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.user.consensoProfilazione\" aria-label=\"Consenso profilazione\">\nAcconsento al trattamento dei dati con finalità di profilazione</md-checkbox></div></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"end center\"><md-button aria-label=\"save\" ng-click=\"vm.savePreferences();\" \nclass=\"md-primary md-raised\"><md-icon md-font-icon=\"icon-check\"></md-icon>Conferma</md-button></md-card-actions>\n</md-card><div layout=\"row\" layout-align=\"center center\"><span class=\"ov-cursor-pointer\" \nng-click=\"vm.goToPrivacyPolicy();\">Trattamento dati personali</span> &nbsp;&nbsp;|&nbsp;&nbsp; <span \nclass=\"ov-cursor-pointer\" ng-click=\"vm.goToCookiePolicy();\">Cookie policy</span></div></div></div></div>");
$templateCache.put("app/main/pages/legal/personal-data-policy/it.html","<div id=\"page-legal-personal-data-policy\" class=\"page-legal-personal-data-policy page-layout simple right-sidenav\" \nlayout=\"column\" ng-init=\"vm.init();\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"60\" flex-offset-gt-md=\"20\" flex-gt-lg=\"50\" flex-offset-gt-lg=\"25\"><h1>\nTrattamento dei dati personali</h1><h2>\nInformativa e richiesta di consenso al trattamento dei dati personali per richieste mediante Form</h2><p>\nai sensi e per gli effetti dell’art. 13 del Regolamento (UE) 2016/679 (di seguito “GDPR”)</p><p>\nPrima di fornirci i Suoi Dati personali attraverso i Form, La preghiamo di leggere la presente Informativa, segnalandoLe che per “Dati personali” si intendono ai sensi del GDPR e della presente sia quelli che Le richiediamo con i moduli presenti nel sito che quelli spontaneamente da Lei forniti nel testo del messaggio del Form.\n</p><h2>Tipologia dei dati trattati</h2><p>\nAl fine di fornirle correttamente le informazioni da Lei richieste sono indispensabili tutti i dati richiesti nel Form, si tratta esclusivamente di dati comuni identificativi e di contatto (nominativo, email, eventuale recapito telefonico).\n</p><h2>Finalità dei trattamenti</h2><p>\nI Dati vengono da noi raccolti e trattati con la esclusiva finalità di fornirle le informazioni richieste.</p><h2>\nModalità di trattamento</h2><p>\nI Dati vengono da noi trattati a mezzo del nostro sistema informatico, con l’applicazione delle Misure di Sicurezza previste dal Codice Privacy, nonché con modalità cartacea, e la documentazione relativa verrà correttamente mantenuta e protetta per tutto il tempo necessario al trattamento.\n</p><p>\nI dati forniti saranno trattati da nostri Collaboratori, in qualità di Responsabili o Incaricati, non verranno diffusi, potranno essere comunicati a terzi solo se strettamente indispensabile in relazione alle Sue richieste.\n</p><h2>Durata del trattamento</h2><p>\nI suoi dati verranno conservati nella nostra banca dati solo per il tempo strettamente necessario al trattamento, salvo Sua espressa indicazione contraria: qualora desideri che i dati vengano cancellati subito dopo averle fornito le informazioni richieste la invitiamo a comunicarcelo nel campo “Messaggio” presente nel Form.\n</p><h2>Natura del conferimento dei dati</h2><p>\nIl conferimento dei Suoi dati è assolutamente facoltativo, parimenti è facoltativo il consenso da parte Sua al trattamento dei dati forniti. Ci corre obbligo informarla che il mancato conferimento dei dati di contatto non ci renderà possibile fornirle le informazioni richieste, parimenti il mancato consenso al trattamento potrebbe costringerci a cancellare i dati forniti.\n</p><h2>Titolare del trattamento</h2><p>\nIl Titolare del Trattamento è Openview S.r.l., con sede in Via Marco Polo 19/A ad Albignasego (PD), e che il Responsabile del Trattamento è il Responsabile dei Servizi Informatici, elettivamente domiciliato, per le disposizioni di cui al GDPR, presso la sede della scrivente, ove è anche disponibile l’elenco aggiornato degli Incaricati al trattamento, contattabile tramite email all’indirizzo supporto@openview.it.\n</p><h2>Diritti dell’Interessato</h2><p>\nLa informiamo che, in qualità di Interessato, ha tutti i diritti previsti dagli articoli 15 – 22 del GDPR, tra i quali ottenere a cura del Titolare e senza ritardo la conferma o meno dell’esistenza di Dati personali che La riguardano, l’aggiornamento, la rettifica, l’integrazione, la cancellazione, la trasformazione in forma anonima o il blocco dei Dati forniti.\n</p></div></div></div>");
$templateCache.put("app/main/pages/memberships/index/memberships-index.html","<div id=\"page-memberships-index\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" layout=\"column\" \nms-scroll ng-init=\"vm.init();\"><div class=\"content\"><ov-navigation-bar user-id=\"{{ vm.loggedUserId }}\" \nselected-page=\"MEMBERSHIPS\"></ov-navigation-bar><div class=\"contenitore-pagina-padding-e-ombra\"><div \nng-if=\"vm.dtItemsCount !== null && vm.dtItemsCount === 0 && !vm.dtServicesSearchText\" class=\"ov-box ov-box-info\"><p>\nSembra che non ci siano tesserati per la tua associazione.<br>\nPuoi creare una tessera alla quale legare i tuoi associati dalle <a href=\"#\" onclick=\"false\" \nng-click=\"vm.gotoImpostazioni();\">impostazioni dell\'associazione</a>.</p></div><div class=\"contenitore-cerca\" \nlayout=\"row\" layout-align=\"end start\"><md-input-container flex=\"100\" class=\"md-block\" flex-gt-xs><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><label for=\"services-search\">\n{{\'ORGANIZATIONS.SEARCH\' | translate }}</label><input id=\"services-search\" type=\"text\" translate flex \nng-model=\"vm.dtServicesSearchText\" n_g-model-options=\"{ debounce: 500 }\" ng-change=\"vm.reloadDatatableItems()\">\n</md-input-container></div><table datatable=\"services-datatable\" dt-options=\"vm.dtServicesOptions\" \ndt-columns=\"vm.dtServicesColumns\" dt-instance=\"vm.dtServicesInstance\" class=\"row-border hover\"></table></div></div><div\n class=\"contenitore-button-fixed\"><md-button aria-label=\"Esporta in Excel\" \nclass=\"md-raised md-accent ov-floating-btn esporta-excel md-fab\" ng-click=\"vm.exportExcel()\" title=\"Export excel\" \ndisabled=\"disabled\"><md-icon class=\"md-primary\" md-font-icon=\"icon-file-excel\"></md-icon>Export</md-button><md-button \naria-label=\"Nuovo tesserato\" title=\"Nuovo tesserato\" class=\"md-fab md-raised md-accent ov-floating-btn\" \nid=\"addMemberBtn\" ng-click=\"vm.gotoNuovoTesserato();\"><md-icon class=\"md-primary\" md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/main/pages/memberships/new/memberships-new.html","<div id=\"page-memberships-new\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" layout=\"column\" \nms-scroll ng-init=\"vm.init();\"><div class=\"content\"><ov-navigation-bar user-id=\"{{ vm.loggedUserId }}\" \nselected-page=\"MEMBERSHIPS\"></ov-navigation-bar><ms-form-wizard flex id=\"newMembershipWizard\"><md-tabs \nmd-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab \nn_g-disabled=\"msWizard.selectedIndex !== 0\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"frmUser.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"frmUser.$valid\">1</span> <span class=\"ms-form-wizard-step-text\">\nTesserato</span></span></md-tab-label><md-tab-body><div class=\"contenitore-pagina-padding-e-ombra\"><h3 \nclass=\"titolo-blocco-contenuto padding-16\">Selezione associato</h3><div layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-md=\"60\" flex-offset-gt-md=\"20\"><h3>Cerca una persona</h3><md-autocomplete id=\"elSearch\" \nmd-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in vm.lookupUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"3\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'OFFERED_SERVICES.SEARCH\' | translate}}\" md-selected-item-change=\"vm.selectedUserChange(item)\" \nmd-menu-class=\"autocomplete-custom-template\" ng-model-options=\"{ debounce: 500 }\" style=\"width: 100%\" md-autofocus>\n<md-item-template><img md-menu-align-target ng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><md-divider></md-divider><form name=\"frmUser\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-md=\"60\" flex-offset-gt-md=\"20\"><h3>\nOppure crea una nuova persona</h3></div><div layout=\"row\"><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"vm.subscriberData.givenName\" capitalize ng-readonly=\"userId && userId!==null\"></md-input-container>\n<md-input-container style=\"width:100%\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" required>Family Name\n</label><input type=\"text\" name=\"familyName\" ng-model=\"vm.subscriberData.familyName\" capitalize \nng-readonly=\"userId && userId!==null\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top: 0px\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">\nBirth date</label><input rsmdatedropdowns deny-future-dates=\"true\" ng-model=\"vm.subscriberData.birthDate\" \nng-disabled=\"userId && userId!==null\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.BIRTH_PLACE\">Luogo di nascita</label><input type=\"text\" ng-model=\"vm.subscriberData.birthPlace\">\n</md-input-container></div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\" \nng-if=\"vm.organization.flgEnableParentChild\"><md-checkbox class=\"remember-me\" ng-model=\"vm.isRelativeSubscription\" \nng-disabled=\"vm.subscriberData.id && vm.subscriberData.id!==null\"><span>Si tratta di un minore / tutelato</span>\n</md-checkbox></div><div layout=\"row\"><md-input-container style=\"width:100%; margin-top: 21px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"vm.subscriberData.email\" \nng-model=\"vm.subscriberData.email\" lowercase ng-pattern=\"/^.+@.+\\..+$/\" \nng-readonly=\"vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-required=\"(!vm.subscriberData.id || vm.subscriberData.id===null) && !vm.isRelativeSubscription\"><div \nng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</div><div layout=\"row\" ng-if=\"vm.isRelativeSubscription\"><md-input-container style=\"width:100%; margin-top: 21px\">\n<label>Email del genitore</label><input type=\"email\" lowercase ng-model=\"vm.parentUserEmail\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-readonly=\" vm.subscriberData.id && vm.subscriberData.id!==null\" \nng-change=\"vm.lookupUserChildren()\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\"><label \ntranslate=\"USERS.GENDER\">Sesso</label><md-select ng-model=\"vm.subscriberData.gender\"><md-option value=\"M\">\n{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">{{\'USERS.FEMALE\' | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.TAX_CODE\">Codice fiscale\n</label><input type=\"text\" ng-model=\"vm.subscriberData.taxCode\" maxlength=\"16\" capitalize></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.ADDRESS\">\nIndirizzo di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.address\" capitalize></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.CITY\">\nComune di residenza</label><input type=\"text\" ng-model=\"vm.subscriberData.city\" capitalize></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.subscriberData.postalCode\" capitalize></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"USERS.PROVINCE\">Province</label><input type=\"text\" ng-model=\"vm.subscriberData.province\" \ncapitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.PHONE\">Telefono</label><input type=\"text\" ng-model=\"vm.subscriberData.phone\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare</label><input \ntype=\"text\" ng-model=\"vm.subscriberData.mobilePhone\"></md-input-container></div></form></div></md-tab-body></md-tab>\n<md-tab n_g-disabled=\"msWizard.selectedIndex !== 1\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"frmUser.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"frmUser.$valid\">2</span> <span class=\"ms-form-wizard-step-text\">\nTessera</span></span></md-tab-label><md-tab-body><div class=\"contenitore-pagina-padding-e-ombra\" layout=\"column\"><h3 \nclass=\"titolo-blocco-contenuto padding-16\">Selezione tessera associativa</h3><form id=\"frmTessera\" ms-form-wizard-form \nnovalidate><md-list><md-list-item ng-repeat=\"service in vm.membershipServices\" \nng-click=\"vm.toggleSelectedService(service.id);\"><div layout=\"row\" flex=\"100\"><div flex=\"20\" \nstyle=\"vertical-align: middle; text-align: center; height: 100%; margin: auto\"><md-icon \nmd-font-icon=\"icon-check-circle\" ng-if=\"service.selected\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" ng-if=\"!service.selected\"></md-icon></div><div flex=\"60\"><h2>\n{{ service.name }}</h2><p ng-if=\"service.notes\">{{ service.notes }}</p><p>\nValidità: dal {{ service.start | date : \'dd/MM/yyyy\' }} al {{ service.end | date : \'dd/MM/yyyy\' }}</p></div><div \nflex=\"20\" style=\"vertical-align: middle; text-align: center; height: 100%; margin: auto\"><h2>\n{{ service.subscriptionPrice }}&euro;</h2></div></div></md-list-item></md-list></form></div></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"Annulla\" \ntitle=\"Annulla\" class=\"md-fab md-raised md-accent\" id=\"cancelBtn\" ng-click=\"vm.gotoMembershipsIndex();\"><md-icon \nclass=\"md-primary\" md-font-icon=\"icon-undo-variant\"></md-icon></md-button><md-button aria-label=\"Precedente\" \ntitle=\"Precedente\" ng-click=\"msWizard.previousStep()\" class=\"md-raised md-accent md-fab\" \nng-disabled=\"msWizard.isFirstStep()\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button aria-label=\"Successivo\" \ntitle=\"Successivo\" class=\"md-raised md-accent md-fab\" ng-click=\"msWizard.nextStep();\" \nng-disabled=\"msWizard.isLastStep()\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></md-button>\n<md-button aria-label=\"Salva\" title=\"Salva\" class=\"md-fab md-raised md-accent\" id=\"saveBtn\" \nng-disabled=\"!vm.isFormValid()\" ng-click=\"vm.saveMembership();\"><md-icon class=\"md-primary\" md-font-icon=\"icon-floppy\">\n</md-icon></md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/notifications/dialogs/open_message_dialog.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{message.title}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><p><b>\n{{\'NOTIFICATIONS.SENDER\' | translate}}:</b> {{message.senderToShow}}</p><p><b>{{\'NOTIFICATIONS.DATE\' | translate}}:</b>\n {{message.notificationDate}}</p><p><b>{{\'NOTIFICATIONS.TITLE\' | translate}}:</b> {{message.title}}</p><p><b>\n{{\'NOTIFICATIONS.MESSAGE\' | translate}}:</b></p><span ng-bind-html=\"message.htmlMessage\"></span><p><dynamic-document \nng-data-url=\"{{dyndocUrl}}\" ng-template-url=\"\" ng-stats-url=\"\" ng-save-url=\"\" ng-edit-mode=\"false\"></dynamic-document>\n</p><p ng-repeat=\"attachment in message.attachments\"><a target=\"_blank\" \nng-href=\"{{vm.apiPath}}{{attachment.cylNotificationLink}}?access_token={{vm.accessToken}}\">{{attachment.filename}}</a>\n</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer(\'useful\')\" \ntranslate=\"ORGANIZATIONS.CLOSE\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/reports/service_payments_report/service_payments_report.html","<div id=\"newservice\" class=\"page-layout simple flex-scrollable\" ms-scroll layout=\"column\" ng-init=\"vm.init();\"><div \nclass=\"content md-padding\"><ov-navigation-bar></ov-navigation-bar><md-card \nmd-theme=\"{{ showDarkTheme ? \'dark-grey\' : \'default\' }}\" md-theme-watch><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Report pagamenti mensili per servizio</span></md-card-title-text></md-card-title><md-card-content \nlayout=\"column\" flex><div layout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\"><md-input-container><label>Servizio\n</label><md-select ng-model=\"vm.reportParams.serviceId\"><md-option ng-repeat=\"offeredService in vm.offeredServices\" \nng-value=\"offeredService.id\">{{ offeredService.name }}</md-option></md-select></md-input-container><md-input-container>\n<label>Anno</label><md-select ng-model=\"vm.reportParams.year\"><md-option ng-repeat=\"year in vm.years\" ng-value=\"year\">\n{{ year }}</md-option></md-select></md-input-container><md-input-container><label>Mese</label><md-select \nng-model=\"vm.reportParams.month\"><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.nr\">{{ month.name }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex=\"100\"><h3>Servizi di tesseramento</h3><div\n layout=\"row\"><div flex=\"100\" flex-gt-md=\"50\"><p>\nIndica i servizi le cui iscrizioni devono comparire nella colonna dei tesseramenti.</p></div><div flex=\"100\" \nflex-gt-md=\"50\"><md-list><md-list-item ng-repeat=\"yearlySubscription in vm.yearlySubscriptionServices\"><md-checkbox \nng-model=\"yearlySubscription.selected\"></md-checkbox><p>{{ yearlySubscription.name }}</p></md-list-item></md-list>\n</div></div></div></div><div layout=\"column\" flex=\"100\" class=\"padding-top-40\" ng-if=\"false\"><div flex=\"100\"><h2>\nReport disponibili</h2></div><div flex=\"100\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.reports.loading\">\n<md-progress-circular></md-progress-circular></div><table class=\"dataTable row-border hover\" flex=\"100\" \nng-if=\"!vm.reports.loading\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports.items\"><td>{{ report.offeredServiceName }}\n</td><td>{{ report.refMonth }}/{{ report.refYear }}</td><td>{{ report.organizationSerial }}/{{ report.refYear }}</td>\n<td>{{ report.organizationServiceSerial }}/{{ report.refYear }}</td><td>\n{{ report.createdAt | date : \'YYYY-MM-DD HH:mm\' }}</td><td>{{ report.updatedAt | date : \'YYYY-MM-DD HH:mm\' }}</td></tr>\n</tbody></table></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.gotoServices();\" aria-label=\"Indietro\">Indietro</md-button><md-button \nclass=\"md-button md-raised md-primary\" ng-click=\"vm.downloadReport();\" aria-label=\"Avvia download\">Avvia</md-button>\n</md-card-actions></md-card></div></div>");
$templateCache.put("app/main/pages/payments/dialogs/delete_payment_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"delScheduleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PAYMENTS.DELETE\">Delete payment</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'PAYMENTS.DELETE_CONFIRM\' | translate}}</h3>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\" translate=\"ORGANIZATIONS.DELETE\">\nDelete</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/payments/dialogs/edit_importo_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"payForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Modifica importo dovuto</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nstyle=\"min-width: 400px\" ng-if=\"!showStorno\"><md-input-container><label>Importo dovuto</label><input required \nng-model=\"myResource.paymentValue\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\' | translate }}\"></md-input-container><div \nstyle=\"width:100%\" flex><md-input-container flex style=\"width:100%\"><label translate=\"PAYMENTS.DESCRIPTION\">Description\n</label><input type=\"text\" ng-model=\"myResource.paymentDescription\" rows=\"3\" md-select-on-focus></md-input-container>\n</div></div><div class=\"ov-help-box\" layout=\"column\"><div ng-click=\"showHelpToggle();\"><md-icon \nmd-font-icon=\"icon-information\" class=\"blue-300-fg\"></md-icon>istruzioni</div><div ng-if=\"showHelp\" \nclass=\"md-padding md-blue-200-bg\"><p><strong>Storna</strong>\n: se il pagamento è già contabilizzato (salvato in \"Cassa\") azzera il pagamento ed elimina il relativo movimento di cassa.\n<br><strong>Elimina pagamento</strong>: il pagamento viene impostato a zero.<br><strong>Salva</strong>\n: dopo aver modificato l\'importo e/o la nota per questo pagamento, premi Salva per accettare la modifica e chiudere la finestra.\n</p></div></div><div ng-if=\"showStorno\"><p>E\' possibile stornare i pagamenti dalla sezione \"Cassa\".</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" ng-if=\"!showStorno\"><md-button ng-click=\"setStorno(true);\">Storna\n</md-button><md-button ng-click=\"answer({ paymentValue: 0, paymentDescription: \'Pagamento annullato\'});\">\nElimina pagamento</md-button><md-button ng-disabled=\"payForm.$invalid || payForm.$pristine\" \nng-click=\"answer({ paymentValue: myResource.paymentValue, paymentDescription: myResource.paymentDescription});\">Salva\n</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" ng-if=\"showStorno\"><md-button \nng-click=\"setStorno(false);\">Torna alla modifica</md-button><md-button ng-click=\"gotoCassa();\">Vai alla cassa\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/payments/dialogs/edit_payment_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"payForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PAYMENTS.ADD\">Add payment</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-datepicker \nng-model=\"myResource.paymentDate\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_DATE\' | translate }}\">\n</md-datepicker><md-input-container><label translate=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\" required></label>\n<input required ng-model=\"myResource.paymentValue\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\' | translate }}\"></md-input-container>\n<md-input-container><label translate=\"PAYMENTS.REASON\" required>Reason</label><md-select \nmd-placeholder=\"{{\'PAYMENTS.REASON\'  | translate }}\" ng-model=\"myResource.paymentReason\" style=\"min-width: 300px\">\n<md-option ng-value=\"paymentReason\" ng-repeat=\"paymentReason in paymentReasons  track by paymentReason.id\">\n{{paymentReason.name}}</md-option></md-select></md-input-container><div style=\"width:100%\" flex><md-input-container \nflex style=\"width:100%\"><label translate=\"PAYMENTS.DESCRIPTION\">Description</label><input type=\"text\" \nng-model=\"myResource.paymentDescription\" rows=\"3\" md-select-on-focus></md-input-container></div><md-input-container \nng-show=\"myResource.showFlgGenerateInvoice\"><md-checkbox ng-model=\"myResource.flgGenerateInvoice\">\n{{\'PAYMENTS.GENERATE_INVOICE\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-show=\"myResource.flgGenerateInvoice\"><md-checkbox ng-model=\"myResource.flgSendNotification\">\n{{\'PAYMENTS.NOTIFY_USER\' | translate}}</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button \nng-disabled=\"payForm.$invalid || payForm.$pristine || !myResource.paymentReason || myResource.paymentReason===null\" \nng-click=\"answer({paymentDate:myResource.paymentDate,paymentValue:myResource.paymentValue,paymentDescription:myResource.paymentDescription,\n          					paymentReason:myResource.paymentReason, flgGenerateInvoice: myResource.flgGenerateInvoice, flgSendNotification: myResource.flgSendNotification})\" \ntranslate=\"OFFERED_SERVICES.ADD\">Add</md-button><md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/payments/pay/pay.html","<div class=\"ov-back-overlay\" ng-click=\"vm.back();\"></div><div class=\"ov-page-pay\" ng-init=\"vm.init();\"><div \nclass=\"ov-page-pay-window\" layout=\"column\"><div class=\"ov-window-header\" layout=\"row\" flex><h3 class=\"flex-grow\">\n{{ \'PAYMENTS.ADD\' | translate }}</h3><md-button class=\"md-icon-button\" ng-click=\"vm.back();\"><i \nclass=\"icon icon-window-close s32\"></i></md-button></div><div class=\"ov-window-body\" layout=\"column\"><div layout=\"row\" \nflex><div flex=\"50\" layout=\"row\"><md-input-container flex=\"100\"><label>\n{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\' | translate }}</label><input required ng-model=\"vm.payment.amount\" \ntype=\"number\" min=\"0\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\' | translate }}\" \nng-disabled=\"vm.paying\"></md-input-container></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-datepicker\n ng-model=\"vm.payment.date\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_DATE\' | translate }}\" \nng-disabled=\"vm.paying\"></md-datepicker></div></div><md-input-container><label translate=\"PAYMENTS.REASON\" required>\nReason</label><md-select md-placeholder=\"{{\'PAYMENTS.REASON\'  | translate }}\" ng-model=\"vm.payment.reasonId\" \nng-disabled=\"vm.paying\"><md-option ng-value=\"paymentReason.id\" \nng-repeat=\"paymentReason in vm.paymentReasons  track by paymentReason.id\">{{ paymentReason.name }}</md-option>\n</md-select></md-input-container><md-input-container><label translate=\"PAYMENTS.DESCRIPTION\">Description</label><input \ntype=\"text\" ng-model=\"vm.payment.description\" rows=\"3\" md-select-on-focus ng-disabled=\"vm.paying\"></md-input-container>\n<md-input-container ng-if=\"vm.showFlgGenerateInvoice\"><md-checkbox ng-model=\"vm.payment.flgGenerateInvoice\" \nng-disabled=\"vm.paying\">{{ \'PAYMENTS.GENERATE_INVOICE\' | translate }}</md-checkbox></md-input-container>\n<md-input-container ng-if=\"vm.payment.flgGenerateInvoice\"><md-checkbox ng-model=\"vm.payment.flgSendNotification\" \nng-disabled=\"vm.paying\">{{ \'PAYMENTS.NOTIFY_USER\' | translate }}</md-checkbox></md-input-container><div layout=\"row\" \nlayout-align=\"center center\" class=\"ov-spinner-container\" flex ng-if=\"vm.paying\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"ov-window-actions\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.back();\">\n{{ \'OFFERED_SERVICES.CANCEL\' | translate }}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.insertPayment();\" ng-disabled=\"vm.isSubmitDisabled()\">{{ \'OFFERED_SERVICES.ADD\' | translate }}</md-button>\n</div></div></div>");
$templateCache.put("app/main/pages/seasonchange/tabs/base-settings.html","<div class=\"contenitore-pagina-padding-e-ombra\"><form ms-form-wizard-form novalidate><div layout=\"column\"><p \nclass=\"md-title\">Periodo di riferimento della stagione</p><p>\nScegli le date di inizio e fine della nuova stagione. Tutti i servizi che migrerai alla nuova stagione avranno inizialmente lo stesso periodo. Se un servizio ha data diversa, potrai sempre modificare la data oppure puoi non trasferirlo alla nuova stagione e crearlo manualmente.\n</p><div layout=\"row\"><div layout=\"column\" flex-order=\"1\" flex-order-gt-sm=\"0\"><md-subheader>Data iniziale\n</md-subheader><md-calendar ng-model=\"vm.settings.startDate\"></md-calendar></div><div layout=\"column\" flex-order=\"1\" \nflex-order-gt-sm=\"1\" class=\"margin-left-16\"><md-subheader>Data finale</md-subheader><md-calendar \nng-model=\"vm.settings.endDate\"></md-calendar></div><div layout=\"column\" flex-order=\"0\" flex-order-gt-sm=\"2\" \nclass=\"margin-left-16\"><md-subheader>Periodo</md-subheader><div><h6>Inizio</h6><div>\n{{vm.settings.startDate | date:shortDate}}</div></div><div><h6>Fine</h6><div>{{vm.settings.endDate | date:shortDate}}\n</div></div></div></div></div></form></div>");
$templateCache.put("app/main/pages/seasonchange/tabs/confirm.html","<div class=\"contenitore-pagina-padding-e-ombra\"><form ms-form-wizard-form novalidate><div layout=\"column\"><p \nclass=\"md-title\">Conferma passaggio stagione</p><p>Confermi l\'esecuzione dela preparazione della nuova stagione?</p>\n</div><div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.process.status === \'ready\'\"><md-button \naria-label=\"Procedi alla preparazione della nuova stagione\" title=\"Procedi alla preparazione della nuova stagione\" \nclass=\"md-raised md-accent\" ng-click=\"vm.doSeasonChange()\"><md-icon md-font-icon=\"icon-check\" class=\"md-primary\">\n</md-icon>Procedi</md-button></div><div layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.process.status === \'processing\'\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><br>\nAttendere, elaborazione in corso, potrebbe impiegare alcuni minuti...</div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.process.status === \'done\'\"><p ng-if=\"!vm.process.error\">\nElaborazione terminata, passaggio di stagione effettuato</p><p ng-if=\"vm.process.error\">\nElaborazione terminata con errori</p></div></form></div>");
$templateCache.put("app/main/pages/seasonchange/tabs/intro.html","<div class=\"contenitore-pagina-padding-e-ombra\"><form ms-form-wizard-form novalidate><p class=\"md-title\">\nStrumento di passaggio a nuova stagione</p><p>\nCon questo strumento potrai essere guidato nel passaggio alla nuova stagione.</p><p>\nI primi passi servono ad impostare le modifiche da applicare mentre l\'ultimo eseguirà effettivamente il passaggio.</p>\n<p>\nRicorda, una volta eseguito il cambio stagione, se vuoi tornare allo stato precedente dovrai effettuare manualmente le operazioni di ripristino.\n</p><p>Nessun servizio o iscrizione ai servizi della precedente stagione sarà modificato.</p></form></div>");
$templateCache.put("app/main/pages/seasonchange/tabs/roles.html","<div class=\"contenitore-pagina-padding-e-ombra\"><form ms-form-wizard-form novalidate><div layout=\"column\"><p \nclass=\"md-title\">Ruoli degli utenti</p><p>\nAl passaggio di stagione gli utenti possono non avere più lo stesso ruolo dell\'anno precedente. Ad esempio i soci potrebbero tornare ad essere dei semplici contatti finchè non rinnovano la tessera associativa.\n<br>Indica quali ruoli andranno rimossi <strong>da tutti</strong>\n gli utenti dell\'a tua organizzazione e quali andranno aggiunti <strong>a tutti</strong>.<br>\nNon sei obbligato ad indicare alcun elemento se preferisci operare manualmente. Ricorda che potrai sempre modificare singolarmente più avanti il ruolo di ogni utente. I ruoli che non selezioni non saranno nè rimossi nè aggiunti ad alcuna persona, rimangono alle persone che già hanno quel ruolo.\n<br>\nAttenzione: se sei amministratore e ti rimuovi il ruolo di staff o admin, potresti tagliarti fuori e avrai bisogno dell\'assistenza tecnica per avere nuovamente accesso.\n</p></div><md-divider></md-divider><div layout=\"row\" flex=\"100\"><div flex=\"50\" layout=\"column\"><p class=\"md-title\">\nRimuovi i seguenti ruoli da tutti gli utenti (me compreso)</p><div layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.roleTypes.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-list \nng-cloak><md-list-item ng-repeat=\"roleType in vm.roleTypes.items\" ng-click=\"vm.removeRoleTypeClicked(roleType)\">\n<md-icon md-font-icon=\"icon-check-circle\" ng-if=\"roleType.selectedToRemove\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" ng-if=\"!roleType.selectedToRemove\"></md-icon><p \nng-class=\"vm.isRoleForbiddenToRemove(roleType) ? \'ov-text-muted ov-text-canceled\' : \'\'\">{{ roleType.name }}</p>\n</md-list-item></md-list></div><div flex=\"50\" layout=\"column\"><p class=\"md-title\">\nAssegna i seguenti ruoli a tutti gli utenti</p><md-list ng-cloak><md-list-item \nng-repeat=\"roleType in vm.roleTypes.items\" ng-click=\"vm.addRoleTypeClicked(roleType)\"><md-icon \nmd-font-icon=\"icon-check-circle\" ng-if=\"roleType.selectedToAdd\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" ng-if=\"!roleType.selectedToAdd\"></md-icon><p \nng-class=\"vm.isRoleForbiddenToAdd(roleType) ? \'ov-text-muted ov-text-canceled\' : \'\'\">{{ roleType.name }}</p>\n</md-list-item></md-list></div></div></form></div>");
$templateCache.put("app/main/pages/seasonchange/tabs/services.html","<div class=\"contenitore-pagina-padding-e-ombra\"><form ms-form-wizard-form novalidate><div layout=\"column\"><p \nclass=\"md-title\">Trasferimento servizi</p><p>\nScegli i servizi che desideri trasferire alla nuova stagione. Questi assumeranno il periodo che hai indicato precedentemente (puoi sempre cambiarlo in seguito) e il prefisso/postfisso che indichi (che potrai modificare in seguito).\n</p></div><md-divider></md-divider><div layout=\"row\"><md-input-container><label>Prefisso</label><input \nng-model=\"vm.settings.services.prefix\"></md-input-container><md-input-container><label>Postfisso</label><input \nng-model=\"vm.settings.services.postfix\"></md-input-container></div><md-divider></md-divider><div layout=\"row\" \nflex=\"100\"><div flex=\"50\" layout=\"column\"><p class=\"md-title\">Servizi esistenti</p><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.offeredServices.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><md-list ng-cloak><md-list-item ng-repeat=\"service in vm.offeredServices.items\" \nng-click=\"vm.offeredServiceClicked(service)\"><md-icon md-font-icon=\"icon-check-circle\" ng-if=\"service.selected\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" ng-if=\"!service.selected\"></md-icon><p>\n{{ service.name }}</p></md-list-item></md-list></div><div flex=\"50\" layout=\"column\"><p class=\"md-title\">Nuovi servizi\n</p><md-list ng-cloak><md-list-item ng-repeat=\"service in vm.settings.services.items\" \nng-click=\"vm.selectedOfferedServiceClicked(service)\"><p>\n{{ vm.settings.services.prefix }}{{ service.name }}{{ vm.settings.services.postfix }}</p></md-list-item></md-list>\n</div></div></form></div>");
$templateCache.put("app/main/pages/users/login_destination/login_destination.html","<div class=\"page-layout simple white-bg md-padding\" layout=\"column\" ng-init=\"vm.init();\"><div \nclass=\"content white-bg md-padding\" layout=\"column\"><div class=\"md-padding\"><div class=\"md-display-1\">\nBenvenuto in Club Your Life!</div><p class=\"md-subhead\">\nOra che hai fatto accesso al sistema puoi scegliere quale sarà l\'uso principale che ne farai.<br>Sei l\'<b>\namministratore </b>di un\'associazione che vuoi gestire con Club Your Life? Clicca sul pulsante \"Amministratore\".<br>\nSei <b>iscritto</b>\n a un\'associazione che fa parte di Club Your Life e vuoi usare la piattaforma per gestire la tua iscrizione? Clicca sul pulsante \"Iscritto\".\n<br></p></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-card \nstyle=\"cursor: pointer; min-height: 120px; padding: 5px 30px; border-radius: 100px; text-align: center; background-color: #00897b\" \nflex=\"50\" class=\"md-padding ov-tag-btn-manageruser\" ng-click=\"vm.setUserPreference(\'manageorganization\')\">\n<md-card-content><div layout=\"row\" class=\"md-headline white-fg\" style=\"display: block; margin: 0 auto\" \nlayout-align=\"start start\"><md-icon class=\"white-fg s40\" md-font-icon=\"icon-shield\"></md-icon><span \nclass=\"margin-left-5 margin-top-5\">Amministratore di associazione</span></div><div style=\"clear: both\"></div><br><div \nlayout=\"row\" class=\"md-subhead white-fg\">\nConfigura la tua associazione (o le tue associazioni) e inserisci i tuoi servizi.<br><br></div></md-card-content>\n</md-card><md-card \nstyle=\"cursor: pointer; min-height: 120px; padding: 5px 30px; border-radius: 100px; text-align: center; background-color: #00897b\" \nflex=\"50\" class=\"md-padding ov-tag-btn-plainuser\" ng-click=\"vm.setUserPreference(\'user\')\"><md-card-content><div \nlayout=\"row\" class=\"md-headline white-fg\" style=\"display: block; margin: 0 auto\" layout-align=\"start start\"><md-icon \nclass=\"white-fg s40\" md-font-icon=\"icon-account-box\"></md-icon><span class=\"margin-left-5 margin-top-5\">Iscritto</span>\n</div><div style=\"clear: both\"></div><br><div layout=\"row\" class=\"md-subhead white-fg\">\nVedi lo stato delle iscrizioni alle associazioni (palestre, società sportive, associazioni culturali...) di cui fai parte.\n</div></md-card-content></md-card></div><div \nstyle=\"background: #e0e0e0; border: 1px solid #ddd; margin: 60px 8px 30px\"><div \nstyle=\"float:left; width: calc(100% - 300px); padding: 20px\"><p class=\"md-subhead\">\nCon questa scelta imposterai la pagina iniziale di accesso al sistema.<br>\nRicorda che, indipendentemente dalla tua selezione, potrai sempre passare da una modalità all\'altra: ti basterà andare nelle impostazioni del tuo account in alto a destra (vedi la freccia n. 1 nell\'immagine a fianco) e muovere il cursore tra \"Amministratore\" e \"Iscritto\" nel campo \"Usa Club Your Life come\" (freccia n. 2).\n<br>\nPer modificare questa impostazione puoi cliccare sulla voce \"Impostazioni\" (freccia n. 3) e andare a \"Sezione di default dopo l\'accesso\".\n</p></div><div style=\"float:right; width: 261px\"><img src=\"/assets/images/etc/finestra-impostazioni-account.png\"></div>\n<div style=\"clear: both\"></div></div></div></div>");
$templateCache.put("app/main/pages/users/new_relative/new_relative.html","<div id=\"newuser\" class=\"page-layout simple tabbed white-bg ov-height-100pct flex-scrollable\" ms-scroll \nlayout=\"column\"><div class=\"content md-padding\"><form name=\"userForm\"><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><div layout=\"row\"><h3 class=\"titolo-blocco-contenuto\">\nAggiungi una minore/tutelato</h3></div><div><h4 class=\"titolo-blocco-contenuto\">\nCompila i campi sottostanti per aggiungere un minore/tutelato.</h4></div><div layout=\"row\"><md-input-container \nid=\"addNewMember\" style=\"width:100%\"><label translate=\"USERS.GIVEN_NAME\" required>Given Name</label><input type=\"text\" \nname=\"givenName\" ng-model=\"vm.user.givenName\" ng-readonly=\"userId && userId!==null\" capitalize required>\n</md-input-container><md-input-container style=\"width:100%\"><label translate=\"USERS.FAMILY_NAME\" required>Family Name\n</label><input type=\"text\" name=\"familyName\" ng-model=\"vm.user.familyName\" ng-readonly=\"userId && userId!==null\" \ncapitalize required></md-input-container><md-input-container class=\"md-block\"><label translate=\"USERS.GENDER\">Sesso\n</label><md-select ng-model=\"vm.user.gender\"><md-option value=\"M\">{{\'USERS.MALE\' | translate}}</md-option><md-option \nvalue=\"F\">{{\'USERS.FEMALE\' | translate}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" div \nclass=\"md-inline-form\" layout-align=\"start center\" ng-if=\"vm.organization.flgEnableParentChild\"><md-checkbox \nclass=\"remember-me\" ng-model=\"vm.isRelativeCreation\"><span>Si tratta di un minore / tutelato</span></md-checkbox></div>\n<div layout=\"row\"><md-input-container style=\"width:100%; margin-top: 21px\"><label translate=\"USERS.EMAIL\">Email</label>\n<input type=\"email\" lowercase ng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" \nng-required=\"(!vm.isRelativeCreation && (!vm.user.id || vm.user.id===null) && !vm.user.hasParents)\" \nng-readonly=\" vm.user.id && vm.user.id!==null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container \nstyle=\"width:100%; margin-top: 21px\" ng-if=\"vm.isRelativeCreation && !vm.parentUserId\"><label>Email del genitore\n</label><input type=\"email\" lowercase ng-model=\"vm.parentUserEmail\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-readonly=\" vm.user.id && vm.user.id!==null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container\n class=\"md-block\" md-no-float style=\"margin-top: -4px\"><label translate=\"USERS.BIRTH_DATE\">Birth date</label><input \nrsmdatedropdowns deny-future-dates=\"true\" ng-model=\"vm.user.birthDate\" ng-disabled=\"userId && userId!==null\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm style=\"width:100%; float: left\"><label \ntranslate=\"USERS.BIRTH_PLACE\">Luogo di nascita</label><input type=\"text\" ng-model=\"vm.user.birthPlace\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm style=\"width:100%; float: left\"><label \ntranslate=\"USERS.TAX_CODE\">Codice fiscale</label><input type=\"text\" ng-model=\"vm.user.taxCode\" maxlength=\"16\" \ncapitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"30\" flex-sm=\"50\"><label translate=\"USERS.ADDRESS\">Indirizzo di residenza</label><input type=\"text\" \nng-model=\"vm.user.address\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"30\" flex-sm=\"50\"><label translate=\"USERS.CITY\">Comune di residenza</label><input type=\"text\" \nng-model=\"vm.user.city\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" flex-gt-sm \nflex=\"20\" flex-sm=\"50\"><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.user.postalCode\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"20\" flex-sm=\"50\"><label translate=\"USERS.PROVINCE\">Province</label><input type=\"text\" \nng-model=\"vm.user.province\" capitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"USERS.PHONE\">telefono</label><input type=\"text\" ng-model=\"vm.user.phone\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare\n</label><input type=\"text\" ng-model=\"vm.user.mobilePhone\"></md-input-container></div><div \nng-if=\"vm.organizationUserTemplateId\"><dynamic-document ng-data-url=\"\" ng-template-url=\"{{vm.templateUrl}}\" \nng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" on-error=\"\" \nng-edit-mode=\"true\"></dynamic-document></div></div></form></div></div><div class=\"contenitore-button-fixed\"><md-button \nng-disabled=\"userForm.$invalid || (!vm.isRelativeCreation && (!vm.user.email || vm.user.email===null || vm.user.email.trim()===\'\') && !vm.user.hasParents)\" \ntitle=\"{{\'USERS.SAVE\' | translate}}\" class=\"md-fab md-accent ov-floating-btn\" ng-click=\"vm.saveUser()\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/users/new_user/new_user.html","<div id=\"newuser\" class=\"page-layout simple tabbed white-bg ov-height-100pct flex-scrollable\" ms-scroll \nlayout=\"column\"><div class=\"content md-padding\"><ov-navigation-bar organization-id=\"{{vm.organization.id}}\" \nselected-page=\"MEMBERS\"></ov-navigation-bar><div layout=\"row\"><p id=\"add-member-in-line-help\" style=\"display:none\">\n{{\'ORGANIZATIONS.ADD_MEMBER_INFOS\' | translate}}</p></div><form name=\"userForm\"><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><div><h3 class=\"titolo-blocco-contenuto\">Ruoli</h3><h4 \nclass=\"titolo-blocco-contenuto\">Seleziona il ruolo (o i ruoli) che la persona ha in {{ vm.organization.name }}:</h4>\n<div layout=\"row\" layout-wrap flex><div flex=\"25\" ng-repeat=\"roleType in vm.organization.roleTypes\"><md-checkbox \nng-checked=\"vm.isRoleTypeSelected(roleType, vm.selectedRoleTypes)\" \nng-click=\"vm.toggleRoleTypeSelected(roleType, vm.selectedRoleTypes)\">{{ roleType.name }}</md-checkbox></div></div>\n</div></div><div layout=\"column\" class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nCerca una persona</h3><h4 class=\"titolo-blocco-contenuto\">\nUsa il campo qui sotto per cercare l\'utente tra gli iscritti a ClubYourLife. Se non è ancora iscritto passa ai campi successivi.\n</h4><div layout=\"row\" id=\"searchNewMember\" ng-if=\"!vm.isRelativeCreation\"><md-autocomplete \nstyle=\"min-width: 480px; width: 100%\" md-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in vm.lookupUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"3\" \nmd-floating-label=\"{{\'OFFERED_SERVICES.SEARCH_ON_CYL\' | translate}}\" \nmd-selected-item-change=\"vm.selectedUserChange(item)\" md-menu-class=\"autocomplete-custom-template\" md-autofocus>\n<md-item-template><img md-menu-align-target ng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"row\" id=\"searchNewMember\" ng-if=\"vm.isRelativeCreation\"><div \nstyle=\"height: 30px; padding-bottom: 20px; margin: 20px 0 42px; border-bottom: 1px solid rgba(0,0,0,.12); width: 100%; color: #c00\">\nI minori/tutelati non sono ricercabili all\'interno della piattaforma.</div></div></div><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><div layout=\"row\"><h3 class=\"titolo-blocco-contenuto\">Aggiungi una persona\n</h3></div><div><h4 class=\"titolo-blocco-contenuto\">\nCompila i campi sottostanti per aggiungere un nuovo utente. Al termine dell\'operazione l\'utente riceverà, all\'indirizzo che hai indicato, una email con le istruzioni per il primo accesso.\n</h4></div><div layout=\"row\"><md-input-container id=\"addNewMember\" style=\"width:100%\"><label \ntranslate=\"USERS.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"vm.user.givenName\" ng-readonly=\"userId && userId!==null\" capitalize required></md-input-container>\n<md-input-container style=\"width:100%\"><label translate=\"USERS.FAMILY_NAME\" required>Family Name</label><input \ntype=\"text\" name=\"familyName\" ng-model=\"vm.user.familyName\" ng-readonly=\"userId && userId!==null\" capitalize required>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"USERS.GENDER\">Sesso</label><md-select \nng-model=\"vm.user.gender\"><md-option value=\"M\">{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">\n{{\'USERS.FEMALE\' | translate}}</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" div \nclass=\"md-inline-form\" layout-align=\"start center\" ng-if=\"vm.organization.flgEnableParentChild\"><md-checkbox \nclass=\"remember-me\" ng-model=\"vm.isRelativeCreation\"><span>Si tratta di un minore / tutelato</span></md-checkbox></div>\n<div layout=\"row\"><md-input-container style=\"width:100%; margin-top: 21px\"><label translate=\"USERS.EMAIL\">Email</label>\n<input type=\"email\" lowercase ng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" \nng-required=\"(!vm.isRelativeCreation && (!vm.user.id || vm.user.id===null) && !vm.user.hasParents)\" \nng-readonly=\" vm.user.id && vm.user.id!==null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container \nstyle=\"width:100%; margin-top: 21px\" ng-if=\"vm.isRelativeCreation && !vm.parentUserId\"><label>Email del genitore\n</label><input type=\"email\" lowercase ng-model=\"vm.parentUserEmail\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-readonly=\" vm.user.id && vm.user.id!==null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container\n class=\"md-block\" md-no-float style=\"margin-top: -4px\"><label translate=\"USERS.BIRTH_DATE\">Birth date</label><input \nrsmdatedropdowns deny-future-dates=\"true\" ng-model=\"vm.user.birthDate\" ng-disabled=\"userId && userId!==null\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm style=\"width:100%; float: left\"><label \ntranslate=\"USERS.BIRTH_PLACE\">Luogo di nascita</label><input type=\"text\" ng-model=\"vm.user.birthPlace\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm style=\"width:100%; float: left\"><label \ntranslate=\"USERS.TAX_CODE\">Codice fiscale</label><input type=\"text\" ng-model=\"vm.user.taxCode\" maxlength=\"16\" \ncapitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"30\" flex-sm=\"50\"><label translate=\"USERS.ADDRESS\">Indirizzo di residenza</label><input type=\"text\" \nng-model=\"vm.user.address\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"30\" flex-sm=\"50\"><label translate=\"USERS.CITY\">Comune di residenza</label><input type=\"text\" \nng-model=\"vm.user.city\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" flex-gt-sm \nflex=\"20\" flex-sm=\"50\"><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.user.postalCode\" capitalize></md-input-container><md-input-container style=\"width:100%; float: left\" \nflex-gt-sm flex=\"20\" flex-sm=\"50\"><label translate=\"USERS.PROVINCE\">Province</label><input type=\"text\" \nng-model=\"vm.user.province\" capitalize></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"USERS.PHONE\">telefono</label><input type=\"text\" ng-model=\"vm.user.phone\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare\n</label><input type=\"text\" ng-model=\"vm.user.mobilePhone\"></md-input-container></div><div \nng-if=\"vm.organizationUserTemplateId\"><dynamic-document ng-data-url=\"\" ng-template-url=\"{{vm.templateUrl}}\" \nng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" on-error=\"\" \nng-edit-mode=\"true\"></dynamic-document></div></div></form></div></div><div class=\"contenitore-button-fixed\"><md-button \nng-disabled=\"!vm.saveButtonEnabled || userForm.$invalid || (!vm.isRelativeCreation && (!vm.user.email || vm.user.email===null || vm.user.email.trim()===\'\') && !vm.user.hasParents)\" \ntitle=\"{{\'USERS.SAVE\' | translate}}\" class=\"md-fab md-accent ov-floating-btn\" ng-click=\"vm.saveUser()\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/users/pending_payments/pending_payments.html","<div id=\"pending_payments\" class=\"page-layout simple tabbed\" layout=\"column\" ng-init=\"vm.init();\"><div \nclass=\"content md-padding\" ms-scroll=\"\"><div layout=\"row\"><ov-profile-navigation-bar user-id=\"{{vm.userId}}\" \nselected-page=\"PAYMENTS\"></ov-profile-navigation-bar></div><div class=\"contenitore-pagina-padding-e-ombra\"><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><span class=\"md-display-1\">\nPagamenti pendenti per {{ vm.user.givenName }} {{ vm.user.familyName }}</span></div><div layout=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Servizio</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\">Pagamenti rimanenti</div></th><th class=\"secondary-text\"><div class=\"table-header\">Azioni</div>\n</th></tr></thead><tbody><tr ng-repeat=\"service in vm.servicesToPay\"><td>{{service.name}}</td><td><ul><li \nclass=\"font-size-12\" ng-repeat=\"detail in service.details\"><strong>{{detail.amount}} Euro</strong>&nbsp;&nbsp; <span \nng-if=\"detail.subscriptionDiscountId\"><span ng-if=\"detail.subscriptionDiscount.type === \'UNCONDITIONAL\'\">\nSconto incondizionato </span><span ng-if=\"detail.subscriptionDiscount.type === \'PERCENT\'\">\nSconto {{detail.subscriptionDiscount.discount.name}} ({{detail.subscriptionDiscount.value}} %) </span><span \nng-if=\"detail.subscriptionDiscount.type === \'AMOUNT\'\">Sconto {{detail.subscriptionDiscount.discount.name}} </span>\n</span><span \nng-if=\"!detail.subscriptionDiscountId && detail.dtBillingPeriodStart && detail.dtBillingPeriodEnd && detail.status.indexOf(\'RENEW\') >= 0\">\nPeriodo: {{ vm.formatDate(detail.dtBillingPeriodStart) }} - {{ vm.formatDate(detail.dtBillingPeriodEnd) }} </span><span\n \nng-if=\"!detail.subscriptionDiscountId && (!detail.dtBillingPeriodStart || !detail.dtBillingPeriodEnd || detail.status.indexOf(\'RENEW\') < 0)\">\nIscrizione</span></li></ul></td><td><div layout=\"column\" flex><div><ul><li>Pagato: {{ service.paymentValue }}&euro;\n</li><li>Rimanenti ad oggi: {{ service.paymentDue }}&euro;</li><li class=\"disabled-text\">\nRimanenti del piano: {{ service.paymentPlanRemaining }}&euro;</li></ul></div><div><md-button class=\"md-warn md-raised\" \naria-label=\"Segna pagamento\" \nng-click=\"vm.askPaymentDetails(vm.userId, service.subscriptionId, (service.paymentDue - service.paymentValue));\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-cash-100\" class=\"s16\"></md-icon>Paga</md-button></div></div></td></tr>\n</tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/profile_settings/profile_settings.html","<div id=\"profile\" class=\"page-layout simple tabbed\" ms-scroll \nng-if=\"(vm.userId === vm.currentUserId || vm.isChild)&& !vm.isUserDetail\"><div class=\"content\" flex><div layout=\"row\" \nflex=\"100\"><div class=\"about\" layout=\"column\" flex=\"100\"><div class=\"profile-box info-box general\" layout=\"column\">\n<ov-profile-navigation-bar user-id=\"{{vm.userId}}\" selected-page=\"SETTINGS\"></ov-profile-navigation-bar><div \nclass=\"content\"><md-card><md-card-content><div layout=\"row\" layout-wrap><div class=\"md-title\">Dati anagrafici <span \nlayout-align=\"end\" style=\"padding: 4px\"><md-button title=\"{{\'USERS.EDIT\' | translate}}\" \nclass=\"md-icon-button md-blue-500-bg md-raised\" ng-click=\"vm.editProfile();\" aria-label=\"Edit\" \nng-hide=\"vm.editableProfile\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-primary grey-50-fg\"></md-icon></md-button>\n</span></div><div class=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" \ntranslate=\"USERS.GIVEN_NAME\">Given Name</div><div class=\"info\">{{vm.userProfile.givenName}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.FAMILY_NAME\">\nFamily Name</div><div class=\"info\">{{vm.userProfile.familyName}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.EMAIL\">Email\n</div><div class=\"info\">\n{{(vm.userProfile.email && !vm.userProfile.email.endsWith(\'invalid\')) ? vm.userProfile.email : \' - \'}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.BIRTH_DATE\">\nBirth Date</div><div class=\"info\">{{vm.formatDate(vm.userProfile.birthDate) }}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.GENDER\">Gender\n</div><div class=\"info\">{{vm.userProfile.gender}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.TAX_CODE\">\nTax code</div><div class=\"info\">{{vm.userProfile.taxCode}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.ADDRESS\">\nAddress</div><div class=\"info\">{{vm.userProfile.address}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.CITY\">City\n</div><div class=\"info\">{{vm.userProfile.city}}</div></div><div \nclass=\"info-line flex-sm-100 flex-gt-md-33 flex-50 padding-right-20\"><div class=\"title\" translate=\"USERS.PHONE\">Phone\n</div><div class=\"info\">{{vm.userProfile.phone}}</div></div></div></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.userId===vm.currentUserId && !vm.isUserDetail\"><md-button \naria-label=\"goto gdpr settings\" ng-click=\"vm.goToGdprSettings();\" class=\"md-primary md-raised\"><md-icon \nmd-font-icon=\"icon-account-key\" class=\"icon\"></md-icon>Impostazioni privacy</md-button><md-button \ntranslate=\"CHANGE_PWD.CHANGE_PWD\" class=\"md-primary md-raised\" aria-label=\"Change password\" \nng-click=\"vm.goToChangePwd();\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon>Change Password</md-button>\n</md-card-actions></md-card><div layout=\"row\" ng-if=\"vm.userId === vm.currentUserId && !vm.isUserDetail\" flex=\"100\">\n<md-card flex=\"100\"><md-card-content layout=\"row\" layout-align=\"space-between\"><span class=\"md-title\">\nImmagine del profilo</span><div layout=\"row\"><div id=\"document-logo-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flowLogo\" flow-files-submitted=\"vm.upload(\'LOGO\')\" flow-file-added=\"vm.fileAdded($file, \'LOGO\')\" \nflow-file-success=\"vm.fileSuccess($file, $message, \'LOGO\')\" flow-file-error=\"vm.fileError( $file, $message, $flow )\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" id=\"logo-uploader\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>{{\'USERS.AVATAR\' | translate }}\n</md-button></div></div><div layout=\"row\" \nng-if=\"vm.userId===vm.currentUserId && !vm.isUserDetail && ( (vm.userProfile.uriAvatar && vm.userProfile.uriAvatar!==null) || (vm.userProfile.uriBackground && vm.userProfile.uriBackground!==null) )\">\n<md-button aria-label=\"Delete image\" class=\"md-icon-button\" ng-click=\"vm.removeAvatar()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-primary icona-cancella-media\" style=\"color: #999; cursor: pointer\"></md-icon>\n</md-button></div></div></md-card-content><md-card-actions><span class=\"font-size-12\">\nL\'immagine di profilo deve essere un file in formato jpeg o png. Si consiglia una immagine quadrata.</span>\n</md-card-actions></md-card></div><md-card ng-if=\"vm.userId===vm.currentUserId && !vm.isUserDetail\"><md-card-content>\n<div class=\"content profile-settings-form\"><form name=\"myForm\"><span class=\"md-title\">Visibilità del profilo</span><div\n class=\"md-subhead\">Imposta le tue preferenze e premi \"salva\".<br><br></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.userProfile.isSearchable\">\nIl mio profilo (nome, cognome, email, avatar) è ricercabile dalle associazioni a cui non appartengo</md-checkbox><br>\n</div><br><br><span layout=\"column\"><span class=\"md-title\">Visibilità dei dati personali</span> <span \nclass=\"md-subhead\">Scegli quali associazioni possono vedere i tuoi dati personali e premi \"salva\".</span></span><div \nlayout=\"row\" layout-wrap><div layout=\"column\" class=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.birthDateVisible = !vm.birthDateVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.BIRTH_DATE\' | translate}}:</strong>\n {{vm.formatDate(vm.userProfile.birthDate)}}</span><div ng-show=\"vm.birthDateVisible\" layout=\"row\"><div \nlayout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.birthDateVisible\" \nlayout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox \nng-model=\"vm.userDetailVisibility.birthDate[org.id]\">{{org.name}}</md-checkbox></div><div \nng-show=\"vm.birthDateVisible\" layout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.birthDate[\'NEW_ORGS\']\">\nEventuali nuove associazioni</md-checkbox></div></div></div></div><br><div layout=\"column\" \nclass=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.birthPlaceVisible = !vm.birthPlaceVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.BIRTH_PLACE\' | translate}}:</strong>\n {{vm.userProfile.birthPlace}}</span><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.birthPlace[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.birthPlace[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br><div layout=\"column\" class=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.genderVisible = !vm.genderVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" class=\"md-accent\" \ntitle=\"Configura visibilità\"></md-icon><strong>{{\'USERS.GENDER\' | translate}}:</strong> {{vm.userProfile.gender}}\n</span><div ng-show=\"vm.genderVisible\" layout=\"row\"><div layout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div \nlayout=\"column\"><div ng-show=\"vm.genderVisible\" layout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\">\n<md-checkbox ng-model=\"vm.userDetailVisibility.gender[org.id]\">{{org.name}}</md-checkbox></div><div \nng-show=\"vm.genderVisible\" layout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.gender[\'NEW_ORGS\']\">\nEventuali nuove associazioni</md-checkbox></div></div></div></div><br><div layout=\"column\" \nclass=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.taxCodeVisible = !vm.taxCodeVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.TAX_CODE\' | translate}}:</strong>\n {{vm.userProfile.taxCode}}</span><div ng-show=\"vm.taxCodeVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.taxCodeVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.taxCode[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.taxCodeVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.taxCode[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br><div layout=\"column\" class=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.addressVisible = !vm.addressVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.ADDRESS\' | translate}}:</strong>\n {{vm.userProfile.address}}</span><div ng-show=\"vm.addressVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.addressVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.address[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.addressVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.address[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br><div layout=\"column\" class=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.phoneVisible = !vm.phoneVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" class=\"md-accent\" \ntitle=\"Configura visibilità\"></md-icon><strong>{{\'USERS.PHONE\' | translate}}:</strong> {{vm.userProfile.phone}}</span>\n<div ng-show=\"vm.phoneVisible\" layout=\"row\"><div layout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div \nlayout=\"column\"><div ng-show=\"vm.phoneVisible\" layout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\">\n<md-checkbox ng-model=\"vm.userDetailVisibility.phone[org.id]\">{{org.name}}</md-checkbox></div><div \nng-show=\"vm.phoneVisible\" layout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.phone[\'NEW_ORGS\']\">\nEventuali nuove associazioni</md-checkbox></div></div></div></div><br><div layout=\"column\" \nclass=\"info-line flex-sm-100 flex-50 padding-right-20\"><span><md-icon \nng-click=\"vm.mobilePhoneVisible = !vm.mobilePhoneVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.MOBILE_PHONE\' | translate}}:</strong>\n {{vm.userProfile.mobilePhone}}</span><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.mobilePhone[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.mobilePhone[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div></div></form></div><br></md-card-content><md-card-actions><md-button ng-disabled=\"myForm.$invalid\" \ntitle=\"{{\'PAGES.SAVE\' | translate}}\" class=\"md-warn md-raised\" ng-click=\"vm.saveProfile()\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-accent\"></md-icon>{{\'USERS.SAVE\' | translate}}</md-button></md-card-actions>\n</md-card><div layout=\"row\" ng-if=\"vm.userId === vm.currentUserId && !vm.isUserDetail\" flex=\"100\"><md-card flex=\"100\">\n<md-card-content layout=\"column\" flex=\"100\"><span class=\"md-title\">Sezione di default dopo l\'accesso</span><div \nlayout=\"column\"><p>\nSe gestisci una o più associazioni, puoi decidere di vedere, appena accedi al sistema, di utilizzarlo come amministratore.\n</p></div></md-card-content><md-card-actions><md-button title=\"Vai alla selezione della destinazione dopo login\" \nclass=\"md-raised\" ng-click=\"vm.gotoLoginDestination();\" aria-label=\"Vai alla selezione della destinazione dopo login\">\nVai all\'impostazione</md-button></md-card-actions></md-card></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/user_carnet/user_carnet.html","<div id=\"page-user-carnet\" class=\"flex-scrollable\" ms-scroll ng-init=\"vm.init();\"><div class=\"content md-padding\" \nlayout=\"column\" flex><div layout=\"row\"><ov-profile-navigation-bar user-id=\"{{ vm.userId }}\" \norganization-id=\"{{ vm.organizationId }}\"></ov-profile-navigation-bar></div><div class=\"user-info md-padding\" \nlayout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\"><img \nng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" class=\"profile-image avatar huge\" \nsrc=\"assets/images/avatars/katherine.jpg\"> <img ng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" \nclass=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.displayName ? vm.user.displayName : vm.user.givenName + \' \' + vm.user.familyName }}\n</div></div><div flex=\"100\" layout=\"column\" class=\"md-padding md-teal-200-bg ov-toolbox\" \nng-if=\"vm.carnet.selectedForAttendanceExchange.length > 0\"><h3>Scambio presenze</h3><p>\nUsa questo strumento per scambiare le presenze tra due carnet. Usa questo strumento con cautela per sanare eventuali situaizoni anomale, nel dubbio contatta l\'assistenza.\n</p><div flex=\"100\" layout=\"row\"><md-card flex=\"50\" \nng-repeat=\"selectedCarnet in vm.carnet.selectedForAttendanceExchange\"><md-card-content layout=\"row\" flex=\"100\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-credit-card\" class=\"s32\"></md-icon>\n</div><h3 flex flex-grow>{{ selectedCarnet.name }}</h3><div flex=\"15\" layout=\"column\" layout-align=\"center center\">\n{{ selectedCarnet.currentAttendances }}/{{ selectedCarnet.numMaxAccessForOrder }}<br><md-progress-linear \nmd-mode=\"determinate\" \nng-class=\"selectedCarnet.currentAttendances > selectedCarnet.numMaxAccessForOrder ? \'ov-mood-error\' : (selectedCarnet.currentAttendances < selectedCarnet.numMaxAccessForOrder ? \'ov-mood-positive\' : \'ov-mood-warning\')\" \nvalue=\"{{ selectedCarnet.currentAttendances/selectedCarnet.numMaxAccessForOrder * 100 }}\"></md-progress-linear></div>\n</md-card-content></md-card></div><div flex=\"100\" layout=\"row\"><div><md-button class=\"md-raised\" \nng-click=\"vm.gotoMoveAttendances(vm.carnet.selectedForAttendanceExchange[0].id, vm.carnet.selectedForAttendanceExchange[1].id);\" \nng-disabled=\"vm.carnet.selectedForAttendanceExchange.length !== 2\">Avvia scambio presenze</md-button></div></div></div>\n<div class=\"ov-list\" flex=\"100\"><md-card class=\"ov-list-item\" ng-repeat=\"carnet in vm.carnet.items\" layout=\"column\" \nflex=\"100\"><div class=\"ov-list-item-compact\" layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-credit-card\" class=\"s32\"></md-icon></div><div flex \nlayout-align=\"start start\"><h2>{{ carnet.offeredServiceName }}</h2></div><div flex=\"10\" layout=\"column\" \nlayout-align=\"center center\">{{ carnet.currentAttendances }}/{{ carnet.numMaxAccessForOrder }}<br><md-progress-linear \nmd-mode=\"determinate\" \nng-class=\"carnet.currentAttendances > carnet.numMaxAccessForOrder ? \'ov-mood-error\' : (carnet.currentAttendances < carnet.numMaxAccessForOrder ? \'ov-mood-positive\' : \'ov-mood-warning\')\" \nvalue=\"{{ carnet.currentAttendances/carnet.numMaxAccessForOrder * 100 }}\"></md-progress-linear></div><div flex=\"5\" \nlayout=\"column\" layout-align=\"center center\"><span ng-if=\"carnet.currentAttendances > carnet.numMaxAccessForOrder\">\n<md-icon md-font-icon=\"icon-alert\"></md-icon></span></div><div flex=\"10\" layout=\"column\" layout-align=\"center center\">\n<md-button class=\"md-raised\" ng-if=\"!carnet.expanded\" ng-click=\"vm.expandCarnetToggle(carnet);\"><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon>Espandi</md-button><md-button class=\"md-raised\" ng-if=\"carnet.expanded\" \nng-click=\"vm.expandCarnetToggle(carnet);\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon>Chiudi</md-button></div>\n</div><md-card-content class=\"ov-list-item-expanded\" ng-if=\"carnet.expanded\" flex=\"100\" layout=\"column\"><div \nlayout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\" class=\"md-padding\"><h3>Può accedere a</h3><table \nclass=\"dataTable row-border hover\"><thead><tr><th>Servizio/evento</th><th>Periodo</th></tr></thead><tbody><tr \nng-repeat=\"servizio in carnet.servizi\"><td>{{ servizio.name }}</td><td>{{ servizio.start | date : \'dd/MM/yyyy\' }} <span\n ng-if=\"servizio.end\">&ndash; {{ servizio.end | date : \'dd/MM/yyyy\' }}</span></td></tr></tbody></table></div><div \nlayout=\"column\" flex=\"50\"><div flex=\"100\" class=\"md-padding\"><h3>Informazioni</h3><table \nclass=\"dataTable row-border hover\"><tbody><tr><td>Registrato il</td><td>\n{{ carnet.orderCreatedAt | date : \'dd/MM/yyyy\' }}</td></tr><tr><td>Periodo di riferimento</td><td>\n{{ carnet.info.dtBillingPeriodStart | date : \'dd/MM/yyyy\' }} <span ng-if=\"carnet.info.dtBillingPeriodEnd\">\n&ndash; {{ carnet.info.dtBillingPeriodEnd | date : \'dd/MM/yyyy\' }}</span></td></tr><tr><td>\nUltima notifica esaurimento inviata</td><td>{{ carnet.info.dtMaxAttandancesReachedNotif | date : \'dd/MM/yyyy\' }}</td>\n</tr></tbody></table></div><div flex=\"100\" class=\"md-padding\"><h3>Pagamenti</h3><table \nclass=\"dataTable row-border hover\"><thead><tr><th>Importo</th><th>Status</th><th>Notes</th></tr></thead><tbody><tr \nng-repeat=\"pagamento in carnet.pagamenti\"><td>{{ pagamento.paymentValue | currency : \'&euro;\' :2 }}</td><td>\n{{ pagamento.paymentStatus }}</td><td>{{ pagamento.paymentDescription }}</td></tr></tbody></table></div></div></div>\n<div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" class=\"md-padding\"><h3>Presenze</h3><table \nclass=\"dataTable row-border hover\"><thead><tr><th>Riga</th><th>Data presenza</th><th>Presente</th><th>Note</th></tr>\n</thead><tbody><tr ng-repeat=\"presenza in carnet.presenze\"><td>{{ $index+1 }}</td><td>\n{{ presenza.dtPresenza | date : \'dd/MM/yyyy\' }}</td><td><span ng-if=\"!presenza.present\">non</span> presente</td><td>\n<span class=\"ov-text-muted\">inserito in data {{ presenza.created | date : \'dd/MM/yyyy H:mm\' }}</span></td></tr></tbody>\n</table></div></div><div layout=\"row\" flex=\"100\" class=\"md-padding\"><span \nng-click=\"vm.toggleSelectedForAttendanceExchange(carnet);\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"!carnet.selectedForAttendanceExchange\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-outline\" \nng-if=\"carnet.selectedForAttendanceExchange\"></md-icon>Seleziona per scambio presenze</span></div></md-card-content>\n</md-card></div><div ng-if=\"vm.carnet.loading\" layout=\"row\" layout-align=\"center center\">&nbsp;<md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"32\"></md-progress-circular></div><div \nng-if=\"!vm.carnet.loading && vm.carnet.items.length === 0\" layout=\"row\" layout-align=\"center center\"><span>\nNessun carnet registrato per questo utente</span></div></div></div>");
$templateCache.put("app/main/pages/users/user_detail/change_mail_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"removeChildForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Modifica email</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><span \nclass=\"md-subhead\">Procedendo con questa operazione verrà modificata la mail dell\'utente selezionato.</span>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"USERS.EMAIL\">Email</label><input type=\"email\" \nng-model=\"userEmail\" required ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"userEmail.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label translate=\"USERS.EMAIL_CONFIRM\">Email confirm</label><input type=\"email\" \nng-model=\"userEmailConfirm\" required ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"userEmailConfirm.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"removeChildForm.$invalid || (userEmail!==userEmailConfirm)\" \nng-click=\"answer({email: userEmail})\" translate=\"PAGES.PROCEED\">Proceed</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"USERS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/user_detail/user-detail.html","<div id=\"profile\" class=\"flex-scrollable\" ms-scroll><div class=\"content md-padding\"><div layout=\"row\">\n<ov-profile-navigation-bar user-id=\"{{vm.userId}}\" organization-id=\"{{vm.organizationId}}\" selected-page=\"DETAIL\">\n</ov-profile-navigation-bar></div><div ng-if=\"vm.isEditMode\" class=\"user-info md-padding\" layout=\"row\" \nlayout-align=\"center center\" layout-gt-sm=\"row\"><img ng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.givenName + \" \" + vm.user.familyName }}</div><md-button class=\"md-fab md-warn\" \nng-click=\"vm.isEditMode = false\" title=\"Torna alla scheda\" style=\"position: absolute; right: 40px\"><md-icon \nclass=\"s-16 font-size-18\" md-font-icon=\"icon-close\" ng-click=\"vm.edit()\" style=\"cursor: pointer\"></md-icon></md-button>\n</div><div ng-if=\"!vm.isEditMode\" layout=\"column\" class=\"contenitore-pagina-padding-e-ombra contenitore-scheda-utente\" \nstyle=\"position:relative; background: #eee\"><md-button class=\"md-fab md-accent\" ng-click=\"vm.isEditMode = true\" \nstyle=\"position: absolute; right: 20px\"><md-icon class=\"s-16 font-size-18\" md-font-icon=\"icon-pencil\" title=\"Modifica\" \nng-click=\"vm.edit()\" style=\"cursor: pointer\"></md-icon></md-button><div class=\"user-info md-padding\" layout=\"row\" \nlayout-align=\"start center\" layout-gt-sm=\"row\"><img ng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.givenName + \" \" + vm.user.familyName }}</div></div><div layout=\"row\" flex=\"100\" \nclass=\"font-size-16 margin-left-20 pb-24\"><div ng-if=\"vm.user.birthDate\" flex=\"25\">\nData nascita: {{ vm.formatDate (vm.user.birthDate) }}</div><div ng-if=\"vm.user.birthPlace\" flex=\"25\">\nLuogo nascita: {{ vm.user.birthPlace }}</div><div ng-if=\"vm.user.taxCode\" flex=\"25\">CF: {{ vm.user.taxCode }}</div><div\n ng-if=\"vm.user.gender\" flex=\"25\" layout=\"row\" layout-align=\"end center\">Sesso: <span ng-if=\"vm.user.gender==\'M\'\">\nMaschio</span> <span ng-if=\"vm.user.gender==\'F\'\">Femmina</span></div></div><div layout=\"row\" flex=\"100\" \nclass=\"font-size-16 margin-left-20\"><h3>Indirizzo</h3></div><div layout=\"row\" flex=\"100\" \nclass=\"font-size-16 margin-left-20\"><div ng-if=\"vm.user.address\" flex=\"75\" flex-offset=\"25\" flex-gt-sm=\"90\" \nflex-offset-gt-sm=\"10\">{{ vm.user.address }}</div></div><div layout=\"row\" flex=\"100\" \nclass=\"font-size-16 margin-left-20 pb-24\"><div ng-if=\"vm.user.postalCode\" flex=\"25\" flex-gt-sm=\"10\" layout=\"row\" \nlayout-align=\"end center\" class=\"pr-16\">{{ vm.user.postalCode }}</div><div ng-if=\"vm.user.city\" flex=\"75\" \nflex-gt-sm=\"90\">{{ vm.user.city }} <span ng-if=\"vm.user.province\">({{ vm.user.province }})</span></div></div><div \nlayout=\"row\" flex=\"100\" class=\"font-size-16 margin-left-20\"><h3>Contatti</h3></div><div layout=\"row\" flex=\"100\" \nclass=\"font-size-16 margin-left-20 pb-24\" style=\"flex-flow: wrap\"><div ng-if=\"vm.user.contactEmail\" flex=\"50\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon>{{ vm.user.contactEmail }}</div><div ng-if=\"vm.user.phone\" flex=\"50\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon>{{ vm.user.phone }}</div><div ng-if=\"vm.user.mobilePhone\" flex=\"50\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon>{{ vm.user.mobilePhone }}</div><div \nng-repeat=\"contact in vm.user.contacts\" flex=\"50\"><span ng-if=\"contact.contactType===\'EMAIL\'\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon></span><span ng-if=\"contact.contactType===\'PHONE\'\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></span><span ng-if=\"contact.contactType===\'MOBILE_PHONE\'\"><md-icon \nmd-font-icon=\"icon-cellphone-android\"></md-icon></span>{{ contact.contact }} <span ng-if=\"contact.description\" \nclass=\"disabled-text\">({{ contact.description }})</span></div></div><div \nng-if=\"vm.organizationUserTemplateId && vm.organizationUserTemplateId!==\'\'\"><p \nclass=\"font-size-16 margin-bottom-0 margin-left-20 ov-cursor-pointer\" \nng-click=\"vm.showAttributiDinamici = !vm.showAttributiDinamici\"><md-icon md-font-icon=\"icon-chevron-right\" \nng-show=\"!vm.showAttributiDinamici\"></md-icon><md-icon md-font-icon=\"icon-chevron-down\" \nng-show=\"vm.showAttributiDinamici\"></md-icon>Altri dati <span ng-if=\"vm.loadingTemplateData\">&nbsp;\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"16\"></md-progress-circular>\n</span></p><div class=\"font-size-16 margin-bottom-0 margin-left-20\" ng-show=\"vm.showAttributiDinamici\">\n<dynamic-document ng-do-load=\"{{vm.organizationUserTemplateId}}\" \nng-data-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/findByUserAndOrganization/{{vm.userId}}/{{vm.organizationId}}/{{vm.organizationUserTemplateId}}\" \nng-template-url=\"\" ng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" \non-error=\"\" ng-edit-mode=\"false\"></dynamic-document></div></div><p \nclass=\"font-size-16 margin-bottom-0 margin-left-20 ov-cursor-pointer\" \nng-if=\"vm.subscriptionsFromPublicPage.length > 0\" \nng-click=\"vm.showAttributiDinamiciIscrizioni = !vm.showAttributiDinamiciIscrizioni\"><md-icon \nmd-font-icon=\"icon-chevron-right\" ng-show=\"!vm.showAttributiDinamiciIscrizioni\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-down\" ng-show=\"vm.showAttributiDinamiciIscrizioni\"></md-icon>\nDati da pagine pubbliche di iscrizione <span ng-if=\"vm.loadingTemplateData\">&nbsp;<md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"16\"></md-progress-circular></span></p><div \nclass=\"font-size-16 margin-bottom-0 margin-left-40\" \nng-show=\"vm.subscriptionsFromPublicPage.length > 0 && vm.showAttributiDinamiciIscrizioni\" \nng-repeat=\"sub in vm.subscriptionsFromPublicPage\"><div ng-if=\"sub.dyndocId\"><div class=\"font-size-16\"><strong>\nIscrizione a {{sub.offeredService.name}}</strong></div><dynamic-document ng-do-load=\"{{sub.dyndocId}}\" \nng-data-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/{{sub.dyndocId}}\" ng-template-url=\"\" ng-stats-url=\"\" \nng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" on-error=\"\" ng-edit-mode=\"false\">\n</dynamic-document></div></div></div><div ng-if=\"vm.isEditMode\"><form name=\"userForm\"><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra contenitore-scheda-utente\"><div><h3 class=\"titolo-blocco-contenuto\">Ruoli\n</h3><h4 class=\"titolo-blocco-contenuto\">\nSeleziona il ruolo (o i ruoli) che la persona ha in {{ vm.organization.name }}:</h4><div layout=\"row\" layout-wrap flex>\n<div flex=\"25\" ng-repeat=\"roleType in vm.organization.roleTypes\"><md-checkbox \nng-checked=\"vm.isRoleTypeSelected(roleType)\" ng-click=\"vm.toggleRoleTypeSelected(roleType)\">{{ roleType.name }}\n</md-checkbox></div></div></div><div layout=\"row\"><md-input-container id=\"addNewMember\" style=\"width:100%\"><label \ntranslate=\"USERS.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" capitalize \nng-model=\"vm.user.givenName\" ng-readonly=\"userId && userId!==null\"></md-input-container><md-input-container \nstyle=\"width:100%\"><label translate=\"USERS.FAMILY_NAME\" required>Family Name</label><input type=\"text\" \nname=\"familyName\" capitalize ng-model=\"vm.user.familyName\" ng-readonly=\"userId && userId!==null\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float style=\"margin-top: -4px; width: 100%\"><label \ntranslate=\"USERS.BIRTH_DATE\">Birth date</label><input rsmdatedropdowns deny-future-dates=\"true\" \nng-model=\"vm.user.birthDate\" ng-disabled=\"userId && userId!==null\"></md-input-container><md-input-container \nclass=\"md-block\" style=\"width: 100%\"><label translate=\"USERS.BIRTH_PLACE\">Luogo di nascita</label><input type=\"text\" \nng-model=\"vm.user.birthPlace\"></md-input-container></div><div layout=\"row\"><div flex=\"50\" \nclass=\"margin-top-25 margin-bottom-25\" ng-if=\"vm.user.emailAlreadyPresent\">Email personale: {{vm.user.email}} <span \nclass=\"md-padding\"><md-icon class=\"s-16 font-size-18\" md-font-icon=\"icon-pencil\" title=\"Modifica\" \nng-click=\"vm.editEmail()\" style=\"cursor: pointer\"></md-icon><md-icon \nng-if=\"vm.user.flgMustResetPwd && vm.user.hasParents\" md-font-icon=\"icon-trash\" ng-click=\"vm.removeChildEmail()\" \nstyle=\"cursor: pointer\" title=\"Elimina indirizzo email\"></md-icon></span><div ng-if=\"vm.user.flgMustResetPwd\" \nclass=\"light-blue-900-fg font-size-12\"><strong>Non confermata dall\'utente</strong></div><div \nng-if=\"!vm.user.flgMustResetPwd\" class=\"green-fg font-size-12\"><strong>Confermata dall\'utente</strong></div><div \nng-if=\"vm.user.changeEmailAddress\" class=\"orange-fg font-size-12\"><strong>\nRichiesta da confermare per cambio a {{vm.user.changeEmailAddress}}</strong></div></div><md-input-container \nng-if=\"!vm.user.emailAlreadyPresent\" flex=\"50\">Email personale: non impostata <span class=\"md-padding\"><md-icon \nclass=\"s-16 font-size-18\" md-font-icon=\"icon-pencil\" title=\"Modifica\" ng-click=\"vm.editEmail()\" \nstyle=\"cursor: pointer\"></md-icon></span></md-input-container><div flex=\"50\" class=\"margin-left-20 margin-top-25\" \nng-if=\"vm.user.hasParents\"><span \nng-if=\"vm.user.hasParents && vm.user.contactEmail && (vm.user.contactEmail !== vm.user.email)\">\nEmail di contatto: {{vm.user.contactEmail}}</span><div class=\"light-blue-900-fg font-size-12\" style=\"cursor: pointer\" \nng-click=\"vm.goToParentData()\"><strong>Vai alla scheda del genitore</strong></div></div></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\"><label translate=\"USERS.GENDER\">Sesso</label><md-select ng-model=\"vm.user.gender\">\n<md-option value=\"M\">{{\'USERS.MALE\' | translate}}</md-option><md-option value=\"F\">{{\'USERS.FEMALE\' | translate}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.TAX_CODE\">Codice fiscale</label><input type=\"text\" ng-model=\"vm.user.taxCode\" maxlength=\"16\" \ncapitalize></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.ADDRESS\">\nIndirizzo di residenza</label><input type=\"text\" ng-model=\"vm.user.address\" capitalize></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.CITY\">Comune di residenza\n</label><input type=\"text\" ng-model=\"vm.user.city\" capitalize></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"USERS.POSTAL_CODE\">CAP</label><input type=\"text\" \nng-model=\"vm.user.postalCode\" capitalize></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.PROVINCE\">Province</label><input type=\"text\" ng-model=\"vm.user.province\" capitalize>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"USERS.PHONE\">cellulare</label><input type=\"text\" capitalize ng-model=\"vm.user.phone\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"USERS.MOBILE_PHONE\">cellulare</label><input \ntype=\"text\" ng-model=\"vm.user.mobilePhone\"></md-input-container></div><div layout-gt-sm=\"row\"><div class=\"md-title\" \nstyle=\"margin-top: 10px\">{{\'USERS.OTHER_CONTACTS\' | translate}}</div><md-button class=\"md-accent md-icon-button\" \nng-click=\"vm.addContact($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'USERS.NEW\' | translate}}</md-button>\n</div><div layout-gt-sm=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"USERS.OTHER_CONTACTS_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.OTHER_CONTACTS_CONTACT\">\nContact</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.OTHER_CONTACTS_DESCRIPTION\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"></div></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.user.contacts\"><td><span \nng-if=\"contact.contactType===\'EMAIL\'\">{{\'USERS.EMAIL\' | translate}}</span> <span ng-if=\"contact.contactType===\'PHONE\'\">\n{{\'USERS.PHONE\' | translate}}</span> <span ng-if=\"contact.contactType===\'MOBILE_PHONE\'\">\n{{\'USERS.MOBILE_PHONE\' | translate}}</span></td><td>{{contact.contact}}</td><td>{{contact.description}}</td><td>\n<md-button class=\"edit-button md-icon-button\" title=\"{{\'USERS.EDIT\' | translate}}\" \nng-click=\"vm.editContact($event,contact)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" title=\"{{\'USERS.DELETE\' | translate}}\" ng-click=\"vm.deleteContact($event,contact)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div><div \nng-if=\"vm.organizationUserTemplateId && vm.organizationUserTemplateId!==\'\'\"><br><br><dynamic-document \nng-do-load=\"{{vm.organizationUserTemplateId}}\" \nng-data-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/findByUserAndOrganization/{{vm.userId}}/{{vm.organizationId}}/{{vm.organizationUserTemplateId}}\" \nng-template-url=\"\" ng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" \non-error=\"\" ng-edit-mode=\"true\"></dynamic-document></div><p ng-if=\"vm.subscriptionsFromPublicPage.length > 0\"></p><div \nclass=\"md-title\">Dati da pagine di iscrizione</div><p></p><div class=\"font-size-16 margin-bottom-0 margin-left-40\" \nng-show=\"vm.subscriptionsFromPublicPage.length > 0\" ng-repeat=\"sub in vm.subscriptionsFromPublicPage\"><div \nng-if=\"sub.dyndocId\"><div class=\"font-size-16\"><strong>Iscrizione a {{sub.offeredService.name}}</strong></div>\n<dynamic-document ng-do-load=\"{{sub.dyndocId}}\" \nng-data-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/{{sub.dyndocId}}\" ng-template-url=\"\" ng-stats-url=\"\" \nng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess\" on-error=\"\" ng-edit-mode=\"true\">\n</dynamic-document></div></div></div></form></div><div class=\"widget-group padding-24\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-if=\"vm.stats.pagamenti\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">{{\'USERS.PAYMENTS_MISSING\' | translate}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-700-fg font-size-72 line-height-72\" \nng-click=\"vm.gotoUserSubscriptions();\" style=\"cursor: pointer\">{{ vm.stats.pagamenti.unpaidSubscriptions }}</div><div \nclass=\"blue-grey-700-fg font-size-24 line-height-48\">{{ vm.stats.pagamenti.unpaidSubscriptionsValue }} Euro</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"contenitore-box-documenti-esterno\" layout=\"column\" flex=\"50\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 teal-600-fg font-size-18\">Documenti</div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'MISSING\')\"><span \nclass=\"etichetta-dashboard-documenti\">Mancanti:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.missing}}</span></div></div></div><div ng-show=\"vm.stats.documenti.missing>0\" \nclass=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" layout-align=\"start start\"><span \nng-repeat=\"doctype in vm.stats.documenti.missingTypes\" layout=\"row\"><span class=\"h4 secondary-text text-truncate\">\n{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">{{doctype.num}}</span></span></div>\n</ms-widget-front><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"blue-grey-700-fg font-size-18 line-height-24\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'A\', \'EXPIRED\')\"><span class=\"etichetta-dashboard-documenti\">Scaduti:</span> <span \nclass=\"valore-dashboard-documenti\">{{vm.stats.documenti.expired}}</span></div></div></div><div \nng-show=\"vm.stats.documenti.expired>0\" class=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" \nlayout-align=\"start start\"><span ng-repeat=\"doctype in vm.stats.documenti.expiredTypes\" layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">\n{{doctype.num}}</span></span></div></ms-widget-front><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"blue-grey-700-fg font-size-18 line-height-24\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'A\', \'REJECTED\')\"><span class=\"etichetta-dashboard-documenti\">Rifiutati:</span> \n<span class=\"valore-dashboard-documenti\">{{vm.stats.documenti.rejected}}</span></div></div></div><div \nng-show=\"vm.stats.documenti.rejected>0\" class=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" \nlayout-align=\"start start\"><span ng-repeat=\"doctype in vm.stats.documenti.rejectedTypes\" layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">\n{{doctype.num}}</span></span></div></ms-widget-front><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"blue-grey-700-fg font-size-18 line-height-24\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'A\', \'EXPIRING\')\"><span class=\"etichetta-dashboard-documenti\">In scadenza:</span> \n<span class=\"valore-dashboard-documenti\">{{vm.stats.documenti.expiring}}</span></div></div></div><div \nng-show=\"vm.stats.documenti.expiring>0\" class=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" \nlayout-align=\"start start\"><span ng-repeat=\"doctype in vm.stats.documenti.expiringTypes\" layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">\n{{doctype.num}}</span></span></div></ms-widget-front><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"blue-grey-700-fg font-size-18 line-height-24\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'A\', \'TO_BE_VALIDATED\')\"><span class=\"etichetta-dashboard-documenti\">Da Validare:\n</span> <span class=\"valore-dashboard-documenti\">{{vm.stats.documenti.toValidate}}</span></div></div></div><div \nng-show=\"vm.stats.documenti.toValidate>0\" class=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" \nlayout-align=\"start start\"><span ng-repeat=\"doctype in vm.stats.documenti.toValidateTypes\" layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">\n{{doctype.num}}</span></span></div></ms-widget-front><ms-widget-front class=\"white-bg contenitore-box-documenti\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"blue-grey-700-fg font-size-18 line-height-24\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'A\', \'VALIDATED\')\"><span class=\"etichetta-dashboard-documenti\">Validati:</span> \n<span class=\"valore-dashboard-documenti\">{{vm.stats.documenti.validated}}</span></div></div></div><div \nng-show=\"vm.stats.documenti.validated>0\" class=\"p-16 border-top box-documenti__dettaglio\" layout=\"column\" \nlayout-align=\"start start\"><span ng-repeat=\"doctype in vm.stats.documenti.validatedTypes\" layout=\"row\"><span \nclass=\"h4 secondary-text text-truncate\">{{doctype.name}}:</span> <span class=\"h4 ml-8\" style=\"cursor: pointer\">\n{{doctype.num}}</span></span></div></ms-widget-front></ms-widget></div><div class=\"widget-group padding-24\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\" \nng-if=\"vm.carnet.items.length > 0\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Ingressi multipli e carnet</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center start\" flex><md-list style=\"width: 100%\"><md-list-item \nclass=\"md-2-line secondary-button-padding\" ng-repeat=\"carnet in vm.carnet.items\" \nng-if=\"vm.carnet.mostraEsauriti || (carnet.currentAttendances != carnet.numMaxAccessForOrder)\" \nng-click=\"vm.gotoUserCarnet(vm.organizationId, carnet.userId);\"><md-icon md-font-icon=\"icon-credit-card\" \nclass=\"md-avatar-icon\" aria-hidden=\"true\"></md-icon><div class=\"md-list-item-text\" layout=\"row\"><div flex><h3>\n{{ carnet.offeredServiceName }}</h3><p ng-if=\"carnet.currentAttendances > carnet.numMaxAccessForOrder\">\nSuperata disponibilità: {{ carnet.currentAttendances }} su {{ carnet.numMaxAccessForOrder }}</p></div><div flex=\"20\" \nlayout=\"column\" layout-align=\"center center\">{{ carnet.currentAttendances }}/{{ carnet.numMaxAccessForOrder }}<br>\n<md-progress-linear md-mode=\"determinate\" value=\"{{ carnet.currentAttendances/carnet.numMaxAccessForOrder * 100 }}\">\n</md-progress-linear></div><div flex=\"5\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"carnet.currentAttendances > carnet.numMaxAccessForOrder\"><md-icon md-font-icon=\"icon-alert\"></md-icon></span>\n</div></div></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\"><md-switch \nng-model=\"vm.carnet.mostraEsauriti\" aria-label=\"Mostra esasuriti\">Vedi anche i carnet chiusi</md-switch></md-subheader>\n</md-list></div></ms-widget-front></ms-widget></div><div class=\"widget-group padding-24\" layout=\"row\" flex layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Iscrizioni attive</div>\n</div><div class=\"pt-8 pb-32 padding-16\" layout=\"column\" layout-align=\"center center\"><table \nclass=\"dataTable row-border hover\"><tbody><tr ng-repeat=\"subscription in vm.subscriptions.items\"><td>\n{{ subscription.offeredService.name }}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoSubscription(subscription.id);\" aria-label=\"Dettaglio iscrizione\" title=\"Dettaglio iscrizione\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoDocumenti(subscription.offeredService.id, subscription.id);\" \nng-disabled=\"!subscription.offeredService.requiredDocuments || subscription.offeredService.requiredDocuments.length == 0\" \naria-label=\"Documenti\" \ntitle=\"{{ (!subscription.offeredService.requiredDocuments || subscription.offeredService.requiredDocuments.length == 0) ?\n                                                \'Nessun documento richiesto\' : \'Documenti\'}}\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></td></tr></tbody></table></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Pagamenti recenti</div>\n</div><div class=\"pt-8 pb-32 padding-16\" layout=\"column\" layout-align=\"center center\"><table \nclass=\"dataTable row-border hover\"><tbody><tr ng-repeat=\"pagamento in vm.payments.items\"><td>\n{{ pagamento.subscription.offeredService.name }}<br><span class=\"ov-text-muted\">\n{{ pagamento.orderDetail.order.dtBillingPeriodStart | date : \'dd/MM/yyyy\' }} <span \nng-if=\"pagamento.orderDetail.order.dtBillingPeriodEnd\">\n- {{ pagamento.orderDetail.order.dtBillingPeriodEnd | date : \'dd/MM/yyyy\' }}</span></span></td><td>\n{{ pagamento.paymentValue | currency : \'&euro;\' : 2 }}</td><td>\n{{ pagamento.paymentStatus === \'UNPAYED\' ? \'non saldato\' : pagamento.paymentStatus === \'DELETED\' ? \'eliminato\' : pagamento.paymentStatus === \'DISCOUNT\' ? \'sconto utilizzabile\' : pagamento.paymentStatus === \'DISCOUNT_USED\' ? \'sconto utilizzato\' : \'saldato\' }}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-if=\"pagamento.paymentDescription\" \naria-label=\"{{ pagamento.paymentDescription }}\" title=\"{{ pagamento.paymentDescription }}\"><md-icon \nmd-font-icon=\"icon-note\" class=\"amber-500-fg\"></md-icon></md-button></td></tr></tbody></table></div><div \nclass=\"pt-8 pb-32 padding-16\" layout=\"column\" layout-align=\"center start\"><md-switch \nng-model=\"vm.payments.options.showOldest\" aria-label=\"Mostra pagamenti vecchi\" ng-change=\"vm.updatePaymentsFilter();\">\nMostra pagamenti più vecchi</md-switch><md-switch ng-model=\"vm.payments.options.showFuture\" \naria-label=\"Mostra pagamenti futuri\" ng-change=\"vm.updatePaymentsFilter();\">Mostra tutti i prossimi pagamenti\n</md-switch><md-switch ng-model=\"vm.payments.options.showPaid\" aria-label=\"Mostra pagamenti saldati\" \nng-change=\"vm.updatePaymentsFilter();\">Mostra pagamenti saldati</md-switch></div></ms-widget-front></ms-widget></div>\n</div></div><div ng-if=\"vm.isEditMode\" layout=\"row\" style=\"position: fixed; right: 100px; bottom: 30px\"><md-button \nclass=\"md-icon-button md-raised md-fab md-warn\" ng-click=\"vm.isEditMode = false\" title=\"Torna alla scheda\" \nstyle=\"position: absolute; right: 100px\"><md-icon md-font-icon=\"icon-close\" ng-click=\"vm.edit()\" \nstyle=\"cursor: pointer\"></md-icon></md-button><md-button aria-label=\"Salva\" \nn_g-disabled=\"userForm.$invalid || ((!vm.user.email || vm.user.email===null || vm.user.email.trim()===\'\') && !vm.user.hasParents)\" \nng-click=\"vm.saveUser();\" class=\"md-icon-button md-fab md-raised md-accent\" title=\"{{\'PAGES.SAVE\' | translate}}\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/users/user_documents/documents.html","<div id=\"profile\" class=\"page-layout simple tabbed flex-scrollable\" ms-scroll ng-init=\"vm.init();\"><div \nclass=\"content md-padding\" flex><ov-profile-navigation-bar user-id=\"{{ vm.user.id }}\" selected-page=\"DOCUMENTS\">\n</ov-profile-navigation-bar><div class=\"user-info md-padding\" layout=\"row\" layout-align=\"start center\" \nlayout-gt-sm=\"row\"><img ng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" class=\"profile-image avatar huge\" \nsrc=\"assets/images/avatars/katherine.jpg\"> <img ng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" \nclass=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.displayName ? vm.user.displayName : vm.user.givenName + \' \' + vm.user.familyName }}\n</div></div><div class=\"widget-group padding-24\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" \nflex=\"100\" f_lex-gt-md=\"50\" ng-repeat=\"subscription in vm.subscriptions\"><ms-widget-front class=\"brown-50-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">\n{{ subscription.offeredService.name }}</div></div><md-divider class=\"ng-scope md-default-theme\"></md-divider><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center start\" flex><div class=\"md-padding\" style=\"width:100%\" \nlayout=\"row\"><div flex=\"40\">Nome</div><div flex=\"10\">Stato</div><div flex=\"25\">Validità</div><div flex=\"10\">Cartaceo\n</div><div flex=\"15\">Azioni</div></div><md-list ng-if=\"subscription.offeredService.requiredDocuments\" \nstyle=\"width:100%\"><md-list-item ng-repeat=\"requiredDocument in subscription.offeredService.requiredDocuments\" \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"row\" flex=\"100\" flex><div flex=\"40\" layout=\"column\" flex><h3>\n<md-icon md-font-icon=\"icon-alert\" ng-if=\"!vm.isRequiredDocumentOk(requiredDocument)\" class=\"red-800-fg\" \ntitle=\"{{ vm.requiredDocumentProblems(requiredDocument) }}\"></md-icon><md-icon md-font-icon=\"icon-check\" \nng-if=\"vm.isRequiredDocumentOk(requiredDocument)\" class=\"green-900-fg\" title=\"tutto ok\"></md-icon>\n{{ requiredDocument.name }}</h3><div class=\"pl-30\">{{ vm.requiredDocumentProblems(requiredDocument) }}</div></div><div \nflex=\"10\"><md-icon md-font-icon=\"icon-file-document\" ng-if=\"requiredDocument._info\" title=\"presente\" \nng-class=\"vm.isRequiredDocumentOk(requiredDocument) ? \'green-900-fg\' : \'red-800-fg\'\"></md-icon><md-icon \nmd-font-icon=\"icon-file-document\" ng-if=\"!requiredDocument._info\" title=\"mancante\" class=\"grey-400-fg\"></md-icon></div>\n<div flex=\"25\"><div ng-if=\"requiredDocument._info && requiredDocument._info.validTo\" \nng-click=\"vm.editDataValidita(requiredDocument);\"><span ng-if=\"!requiredDocument._info.editingDataValidita\">\n{{ requiredDocument._info.validTo | date }} </span><span ng-if=\"requiredDocument._info.editingDataValidita\">\n<md-datepicker ng-model=\"requiredDocument._info.validTo\"></md-datepicker><md-icon md-font-icon=\"icon-content-save\" \nng-click=\"vm.saveDocument(requiredDocument, true);\" title=\"Salva\"></md-icon></span></div><div \nng-if=\"requiredDocument._info && !requiredDocument._info.validTo \" class=\"grey-400-fg\"><md-datepicker \nng-model=\"requiredDocument._info.validTo\"></md-datepicker></div><div ng-if=\"!requiredDocument._info\" \nclass=\"grey-400-fg\">&ndash;</div></div><div flex=\"10\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"!requiredDocument._info.isPaperDoc\" ng-click=\"vm.toggleCartaceo(requiredDocument, subscription)\" \ntitle=\"Spunta per indicare che è stato consegnato in cartaceo\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" ng-click=\"vm.toggleCartaceo(requiredDocument, subscription)\" \nng-if=\"requiredDocument._info.isPaperDoc\" title=\"Spunta per indicare che è stato consegnato in cartaceo\"></md-icon>\n</div><div flex=\"15\"><md-icon md-font-icon=\"icon-thumb-up\" ng-class=\"requiredDocument._info ? \'\' : \'grey-400-fg\'\" \nng-click=\"vm.validate(requiredDocument, subscription, 1);\" title=\"Valida il documento\"></md-icon><md-icon \nmd-font-icon=\"icon-thumb-down\" ng-class=\"requiredDocument._info ? \'\' : \'grey-400-fg\'\" \nng-click=\"vm.validate(requiredDocument, subscription, 0);\" title=\"Rifiuta il documento\"></md-icon></div></div>\n</md-list-item></md-list><div class=\"md-padding\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!subscription.offeredService.requiredDocuments\">Nessun documento necessario</div></div></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" flex \nlayout-align=\"center center\" ng-if=\"!vm.loading && !vm.user\">Non hai selezionato nessun utente</div></div></div>");
$templateCache.put("app/main/pages/users/user_profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"content\" flex><ov-profile-navigation-bar \nuser-id=\"{{vm.userId}}\" selected-page=\"PROFILE\"></ov-profile-navigation-bar><div layout=\"row\" layout-align=\"center\" \nclass=\"margin-top-80\" ng-if=\"!vm.subscriptionsStats.loaded\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"widget-group padding-24\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-if=\"vm.subscriptionsStats.loaded && vm.paymentsStats.unpaidCount > 0\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'USERS.PAYMENTS_MISSING\' | translate}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-700-fg font-size-72 line-height-72\" style=\"cursor: pointer\" \nng-click=\"vm.gotoServices();\">{{ vm.paymentsStats.unpaidCount }}</div><div \nclass=\"blue-grey-700-fg font-size-24 line-height-48\">{{ vm.paymentsStats.unpaidAmount }} Euro</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-if=\"vm.subscriptionsStats.loaded && (vm.subscriptionsStats.docsExpired + vm.subscriptionsStats.docsRejected + vm.subscriptionsStats.docsMissing) > 0\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">{{\'USERS.DOCS_MISSING_ALL\' | translate}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-700-fg font-size-72 line-height-72\" ng-click=\"vm.gotoDocuments();\" \nstyle=\"cursor: pointer\">\n{{vm.subscriptionsStats.docsExpired + vm.subscriptionsStats.docsRejected + vm.subscriptionsStats.docsMissing}}</div><ul\n ng-show=\"vm.subscriptionsStats.docsMissing > 0\">{{\'USERS.DOCS_MISSING\' | translate}}<li \nng-repeat=\"doc in vm.subscriptionsStats.missingTypes\">{{doc.name}}: {{doc.num}}</li></ul><ul \nng-show=\"vm.subscriptionsStats.docsRejected > 0\">{{\'USERS.DOCS_REJECTED\' | translate}}<li \nng-repeat=\"doc in vm.subscriptionsStats.rejectedTypes\">{{doc.name}}: {{doc.num}}</li></ul><ul \nng-show=\"vm.subscriptionsStats.docsExpired > 0\">{{\'USERS.DOCS_EXPIRED\' | translate}}<li \nng-repeat=\"doc in vm.subscriptionsStats.expiredTypes\">{{doc.name}}: {{doc.num}}</li></ul></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-if=\"vm.subscriptionsStats.loaded && vm.subscriptionsStats.docsExpiring > 0\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'USERS.DOCS_EXPIRING\' | translate}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"blue-grey-700-fg font-size-72 line-height-72\" ng-click=\"vm.gotoDocuments();\" style=\"cursor: pointer\">\n{{vm.subscriptionsStats.docsExpiring}}</div><ul><li ng-repeat=\"doc in vm.subscriptionsStats.expiringTypes\">\n{{doc.name}}: {{doc.num}}</li></ul></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-if=\"vm.subscriptionsStats.loaded && vm.subscriptionsStats.unpayed === 0  && vm.subscriptionsStats.docsExpired === 0 && vm.subscriptionsStats.docsRejected === 0 && vm.subscriptionsStats.docsMissing === 0\">\n<ms-widget-front class=\"md-green-200-bg md-padding\"><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-700-fg font-size-72 line-height-72\" style=\"cursor: pointer\"><md-icon\n md-font-icon=\"icon-checkbox-marked-circle\" style=\"font-size:72px; min-width: 72px\" \nclass=\"blue-grey-700-fg md-primary\"></md-icon></div><h3>{{\'USERS.DOCS_AND_PAYMENTS_OK\' | translate}}</h3></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/pages/subscriptions/dialogs/new_child_service_dialog.html","<md-dialog aria-label=\"New Subscriber\" style=\"min-width: 75%\"><form name=\"newChildService\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><span class=\"md-headline\">\n<md-input-container class=\"md-block\"><label>{{ \'OFFERED_SERVICES.NAME\' | translate }}</label><input type=\"text\" \nng-model=\"child.name\" required></md-input-container></span><span class=\"md-subhead\"><span><md-input-container \nclass=\"md-block\"><label>{{ \'OFFERED_SERVICES.DESCRIPTION\' | translate }}</label><textarea ng-model=\"child.description\" \nmd-maxlength=\"500\" rows=\"2\" md-select-on-focus></textarea></md-input-container></span></span><md-list><md-list-item \nlayout=\"row\" flex><p flex=\"50\">{{ \'OFFERED_SERVICES.PRICE_TYPE\' | translate }}</p><div flex=\"50\"><md-input-container>\n<label>{{ \'OFFERED_SERVICES.PRICE_TYPE\' | translate }}</label><md-select required ng-model=\"child.paymentType\">\n<md-option value=\"F\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option><md-option value=\"O\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" ng-if=\"child.scheduleType!==\'A\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select></md-input-container></div></md-list-item>\n<md-list-item layout=\"row\" flex ng-if=\"child.paymentType==\'R\' || child.paymentType==\'O\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}</p><div flex=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}</label><input type=\"number\" min=\"0\" \nng-model=\"child.subscriptionPrice\" ng-required=\"child.paymentType === \'R\' || child.paymentType === \'O\'\">\n</md-input-container></div></md-list-item><md-list-item layout=\"row\" flex ng-if=\"child.paymentType==\'R\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.RENEWAL\' | translate }}</p><div flex=\"50\"><md-input-container><label>\n{{ \'OFFERED_SERVICES.RENEWAL\' | translate }}</label><md-select ng-required=\"child.paymentType === \'R\'\" \nng-model=\"child.paymentRenewInterval\"><md-option value=\"day\">{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option>\n<md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</md-option><md-option value=\"month\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"2-month\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option value=\"3-month\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option><md-option value=\"year\">{{\'OFFERED_SERVICES.YEAR\' | translate}}\n</md-option></md-select></md-input-container></div></md-list-item><md-list-item layout=\"row\" flex \nng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">{{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}</p><div flex=\"50\">\n<md-input-container class=\"md-block\"><label>{{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}</label><input \ntype=\"number\" min=\"0\" ng-model=\"child.renewalPrice\" ng-required=\"child.paymentType === \'R\'\"></md-input-container></div>\n</md-list-item><md-list-item layout=\"row\" flex ng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.NUM_MAX_RENEWAL\' | translate }}<br><span class=\"md-caption\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</span></p><div flex=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \'OFFERED_SERVICES.NUM_MAX_RENEWAL\' | translate }}</label><input type=\"number\" min=\"1\" \nng-model=\"child.numMaxRenewal\"></md-input-container></div></md-list-item><md-list-item layout=\"row\" flex \nng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">{{ \'OFFERED_SERVICES.PRICE\' | translate }}</p><p flex=\"50\">\n{{ child.subscriptionPrice }} + {{ child.numMaxRenewal }} x {{ child.renewalPrice }} = {{ child.subscriptionPrice + child.numMaxRenewal * child.renewalPrice }}&euro;\n</p></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel();\" \nstyle=\"margin-right:20px\">{{\'SUBSCRIPTIONS.CANCEL\' | translate }}</md-button><md-button ng-click=\"answer();\" \nstyle=\"margin-right:20px\" ng-disabled=\"newChildService.$invalid\">{{\'PAGES.SAVE\' | translate }}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/subscriptions/dialogs/new_subscription_dialog.html","<md-dialog aria-label=\"New Subscriber\" style=\"min-width: 75%\"><form name=\"newSubscriberForm\" novalidate><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2><span \nng-if=\"!newSubscriptionDialog.selectedService || newSubscriptionDialog.selectedService == null\">\n{{\'SUBSCRIPTIONS.SUBSCRIBEASERVICEOF\' | translate }} {{ newSubscriptionDialog.organization.name }}</span> <span \nng-if=\"newSubscriptionDialog.selectedService && newSubscriptionDialog.selectedService.name != null\">\n{{\'SUBSCRIPTIONS.SUBSCRIBETO\' | translate }} {{ newSubscriptionDialog.selectedService.name }}</span></h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"newSubscriptionDialog.selectedTab\"><md-tab label=\"Servizio\"><md-content \nclass=\"md-padding\"><md-list ng-if=\"newSubscriptionDialog.services.length > 0\"><md-list-item \nng-repeat=\"service in newSubscriptionDialog.services\" class=\"noright\" \nng-click=\"newSubscriptionDialog.selectService(service);\"><p>{{ service.name }}</p><md-checkbox class=\"md-secondary\" \nng-model=\"service.selected\"></md-checkbox></md-list-item></md-list><p \nng-if=\"newSubscriptionDialog.services == null || newSubscriptionDialog.services.length == 0\"><cite>\n{{ newSubscriptionDialog.organization.name }}<cite>{{\'SUBSCRIPTIONS.HASNOSERVICES\' | translate }}!</cite></cite></p>\n</md-content></md-tab>\'<md-tab label=\"Iscritto\" ng-disabled=\"newSubscriptionDialog.selectedService==null\"><md-content \nclass=\"md-padding\"><h3>{{\'SUBSCRIPTIONS.USER\' | translate }} <cite>{{ newSubscriptionDialog.selectedService.name }}\n</cite></h3><form name=\"newSubscriberForm\" novalidate><div layout=\"column\"><div layout=\"row\"><p \nid=\"add-subscriber-in-line-help\" style=\"display:none\">{{\'OFFERED_SERVICES.ADD_SUBSCRIBER_INFOS\' | translate}}</p></div>\n<div layout=\"row\"><div><md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" \nclass=\"md-icon-button md-accent\" onclick=\"$(\'#add-subscriber-in-line-help\').toggle(500)\"><md-icon \nid=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button></div><div>\n<md-autocomplete style=\"min-width: 480px\" ng-disabled=\"newSubscriptionDialog.searchUser.disabled\" \nmd-no-cache=\"newSubscriptionDialog.searchUser.noCache\" \nmd-selected-item=\"newSubscriptionDialog.searchUser.selectedItem\" \nmd-search-text-change=\"newSubscriptionDialog.searchUser.searchTextChange(newSubscriptionDialog.searchUser.searchText)\" \nmd-search-text=\"newSubscriptionDialog.searchUser.searchText\" \nmd-selected-item-change=\"newSubscriptionDialog.searchUser.selectedItemChange(item)\" \nmd-items=\"item in newSubscriptionDialog.searchUser.querySearch(newSubscriptionDialog.searchUser.searchText)\" \nmd-item-text=\"item.displayName\" md-min-length=\"3\" md-floating-label=\"Cerca una persona\"><md-item-template><img \nmd-menu-align-target ng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> <span \nmd-highlight-text=\"newSubscriptionDialog.searchUser.searchText\" md-highlight-flags=\"^i\">\n{{item.displayName}} - {{item.email}}</span></md-item-template><md-not-found>\n{{ \'SUBSCRIPTIONS.NOMATCHINGUSERS\' | translate }} \"{{ newSubscriptionDialog.searchUser.searchText }}\".</md-not-found>\n</md-autocomplete></div></div><div layout=\"row\"><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"newSubscriptionDialog.selectedUser.givenName\" \nng-readonly=\"newSubscriptionDialog.selectedUser.userId && newSubscriptionDialog.selectedUser.userId!==null\">\n</md-input-container><md-input-container style=\"width:100%\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" \nrequired>Family Name</label><input type=\"text\" name=\"familyName\" \nng-model=\"newSubscriptionDialog.selectedUser.familyName\" \nng-readonly=\"newSubscriptionDialog.selectedUser.userId && newSubscriptionDialog.selectedUser.userId!==null\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"width:100%; margin-top: 0px\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">Birth date</label><input \nrsmdatedropdowns deny-future-dates=\"true\" ng-model=\"newSubscriptionDialog.selectedUser.birthDate\" \nng-disabled=\"newSubscriptionDialog.selectedUser.userId && newSubscriptionDialog.selectedUser.userId!==null\">\n</md-input-container><md-input-container style=\"width:100%; margin-top: 21px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input type=\"email\" \nng-model=\"newSubscriptionDialog.selectedUser.email\" ng-pattern=\"/^.+@.+\\..+$/\" \nng-readonly=\"newSubscriptionDialog.selectedUser.userId && newSubscriptionDialog.selectedUser.userId!==null\" \nng-required=\"!newSubscriptionDialog.selectedUser.userId || newSubscriptionDialog.selectedUser.userId===null\"><div \nng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"USERS.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</div><div layout=\"row\" \nng-if=\"newSubscriptionDialog.selectedUser.userId == null && newSubscriptionDialog.selectedUser.familyName && newSubscriptionDialog.selectedUser.familyName != null && newSubscriptionDialog.selectedUser.familyName != \'\'\">\n<p>{{ \'SUBSCRIPTIONS.USERNOTREGISTERED\' | translate }}</p></div></div></form></md-content></md-tab><md-tab label=\"\">\n</md-tab></md-tabs></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nn_g-if=\"newSubscriptionDialog.services == null || newSubscriptionDialog.services.length == 0\" ng-click=\"cancel();\" \nstyle=\"margin-right:20px\">{{\'SUBSCRIPTIONS.CANCEL\' | translate }}</md-button><md-button \nng-if=\"newSubscriptionDialog.services.length > 0\" ng-click=\"answer();\" style=\"margin-right:20px\" \nng-disabled=\"newSubscriptionDialog.selectedUser==null\">{{\'SUBSCRIPTIONS.ADDUSER\' | translate }}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/directives/dynamic-document/dialogs/back_confirm_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>\nAll unsaved modifications will be lost. Confirm exiting without saving?</h3></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"answer()\" translate=\"PAGES.GO_BACK\">Exit</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_checkbox.html","<div layout=\"row\"><span><md-icon ng-if=\"fieldModel[myItem.name]\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon\n ng-if=\"!fieldModel[myItem.name]\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><span \nng-bind-html=\"myItem.caption\"></span></span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_date.html","<span ng-if=\"!myItem.multiple\"><label style=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}\n</label><br>{{formatDate(fieldModel[myItem.name])}} </span><span ng-if=\"myItem.multiple\"><label \nstyle=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label>:<br><div \nng-repeat=\"field in fieldCounter[myItem.name] track by $index\" ng-init=\"fieldIndex=$index\"><div layout=\"row\" flex><span\n flex class=\"md-icon-float md-block\"><label style=\"font-style:italic; font-size:  90%\">\n{{myItem.caption}} ({{fieldIndex+1}})</label><br>{{formatDate(fieldModel[myItem.name][fieldIndex])}}</span></div></div>\n</span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_field.html","<span ng-switch on=\"myItem.type\"><span ng-switch-when=\"group\"><div \nng-if=\"!item.multiple && !item.options[\'same-row\']\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_field.html\'\" ng-repeat=\"item in item.items\" \nng-init=\"myItem=item\"></div></div><div ng-if=\"item.multiple  && !item.options[\'same-row\']\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_multiple-group.html\'\"></div></div><div \nng-if=\"!item.multiple  && item.options[\'same-row\']\"><div layout=\"row\" layout-xs=\"column\" style=\"padding: 1em\"><div \nng-class=\"calculateClass(item)\" ng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_field.html\'\" \nng-repeat=\"item in item.items\" ng-init=\"myItem=item\"></div></div></div></span><span ng-switch-when=\"label\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/label.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"text\"><div ng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_text.html\'\" \nng-init=\"fieldModel=myModel\"></div></span><span ng-switch-when=\"formula\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_formula.html\'\" ng-init=\"fieldModel=myModel\">\n</div></span><span ng-switch-when=\"number\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_text.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"textarea\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_textarea.html\'\" ng-init=\"fieldModel=myModel\">\n</div></span><span ng-switch-when=\"date\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_date.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"select\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_select.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"radio\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_radio.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"scale\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_scale.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"checkbox\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_checkbox.html\'\" ng-init=\"fieldModel=myModel\">\n</div></span></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_formula.html","<div layout=\"row\" flex><span class=\"md-block\" flex-gt-xs><label \nstyle=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label><br>{{fieldModel[myItem.name]}}\n</span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_multiple-group.html","<label>{{item.caption}}</label><span ng-init=\"groupName=item.name; \"><div layout-gt-sm=\"flex\" \nng-repeat=\"field in fieldCounter[groupName] track by $index\" \nng-init=\"groupIndex=$index; initModel(groupName, groupIndex); \"><div style=\"padding:1em\" \nng-repeat=\"groupItem in item.items\" ng-init=\"myItem=groupItem\" on-finish-render=\"ngRepeatFinished\" \ngroup-name=\"{{groupName}}\"><span ng-switch on=\"groupItem.type\"><span ng-switch-when=\"label\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/label.html\'\"></div></span><span ng-switch-when=\"text\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_text.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"number\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_text.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"textarea\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_textarea.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"date\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_date.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"select\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_select.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"radio\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_radio.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"scale\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_scale.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"checkbox\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_readonly_checkbox.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span></span></div></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_radio.html","<div layout=\"row\"><span><label style=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label>\n<br>{{decodeChoice(myItem, fieldModel[myItem.name])}}</span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_scale.html","<div layout=\"row\"><span><label style=\"font-weight: bold; font-style:italic; font-size:  90%\"><p \nng-bind-html=\"myItem.caption\"></p></label>{{decodeScaleChoice(myItem, fieldModel[myItem.name])}}</span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_select.html","<div layout=\"row\"><span><label style=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label>\n<br>{{decodeChoice(myItem, fieldModel[myItem.name])}}</span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_text.html","<div layout=\"row\" flex><span ng-if=\"!myItem.multiple\" class=\"md-block\" flex-gt-xs><label \nstyle=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label><br>{{fieldModel[myItem.name]}}\n</span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_readonly_textarea.html","<span ng-if=\"!myItem.multiple\"><div layout=\"row\" flex><span ng-if=\"!myItem.multiple\" class=\"md-block\" flex-gt-xs><label\n style=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label><br>\n{{fieldModel[myItem.name]}}</span></div></span><span ng-if=\"myItem.multiple\"><label \nstyle=\"font-weight: bold; font-style:italic; font-size:  90%\">{{myItem.caption}}</label>:<br><div \nng-repeat=\"field in fieldCounter[myItem.name] track by $index\" ng-init=\"fieldIndex=$index\"><div layout=\"row\" flex><span\n flex class=\"md-icon-float md-block\"><label style=\"font-style:italic; font-size:  90%\">\n{{myItem.caption}} ({{fieldIndex+1}})</label><br>{{fieldModel[myItem.name][fieldIndex]}}</span></div></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_checkbox.html","<div layout=\"row\"><span><span ng-bind-html=\"myItem.caption\"></span><br><b>\n{{myStats[myItem.name][\'true\']?myStats[myItem.name][\'true\']:\'0\'}}</b></span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_field.html","<span ng-switch on=\"myItem.type\"><span ng-switch-when=\"group\"><div \nng-if=\"!item.multiple && !item.options[\'same-row\']\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_field.html\'\" ng-repeat=\"item in item.items\" \nng-init=\"myItem=item\"></div></div><div ng-if=\"item.multiple  && !item.options[\'same-row\']\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_multiple-group.html\'\"></div></div><div \nng-if=\"!item.multiple  && item.options[\'same-row\']\"><div layout=\"row\" layout-xs=\"column\" style=\"padding: 1em\"><div \nng-class=\"calculateClass(item)\" ng-include=\"\'app/main/directives/dynamic-document/templates/_stats_field.html\'\" \nng-repeat=\"item in item.items\" ng-init=\"myItem=item\"></div></div></div></span><span ng-switch-when=\"label\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_label.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"select\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_select.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"radio\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_radio.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"scale\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_scale.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span><span ng-switch-when=\"checkbox\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_checkbox.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_label.html","<div layout=\"column\"><div layout=\"row\"><p style=\"width: 100%; margin: 0px\" ng-bind-html=\"createLabelTag(myItem)\"></p>\n</div></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_multiple-group.html","<label>{{item.caption}}</label><span ng-init=\"groupName=item.name; \"><div layout-gt-sm=\"flex\" \nng-repeat=\"field in fieldCounter[groupName] track by $index\" \nng-init=\"groupIndex=$index; initModel(groupName, groupIndex); \"><div ng-repeat=\"groupItem in item.items\" \nng-init=\"myItem=groupItem\" on-finish-render=\"ngRepeatFinished\" group-name=\"{{groupName}}\"><span ng-switch \non=\"groupItem.type\"><span ng-switch-when=\"label\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_label.html\'\"></div></span><span \nng-switch-when=\"select\"><div ng-include=\"\'app/main/directives/dynamic-document/templates/_stats_select.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"radio\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_radio.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"scale\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_scale.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"checkbox\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/_stats_checkbox.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span></span></div></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_radio.html","<div layout=\"row\"><span style=\"width: 100%\"><label style=\"font-weight: bold; font-style:italic; font-size:  90%\">\n{{myItem.caption}}</label><br><nvd3 class=\"remove-x-lines\" config=\"chartConfig\" options=\"chartOptions[myItem.name]\" \ndata=\"chartData[myItem.name]\"></nvd3></span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_scale.html","<div layout=\"row\"><span style=\"width: 100%\"><label style=\"font-weight: bold; font-style:italic; font-size:  90%\"><p \nng-bind-html=\"myItem.caption\"></p></label><nvd3 class=\"remove-x-lines\" config=\"chartConfig\" \noptions=\"chartOptions[myItem.name]\" data=\"chartData[myItem.name]\"></nvd3></span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/_stats_select.html","<div layout=\"row\"><span style=\"width: 100%\"><label style=\"font-weight: bold; font-style:italic; font-size:  90%\">\n{{myItem.caption}}</label><br><nvd3 class=\"remove-x-lines\" config=\"chartConfig\" options=\"chartOptions[myItem.name]\" \ndata=\"chartData[myItem.name]\"></nvd3></span></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/checkbox.html","<div layout=\"row\"><md-input-container ng-if=\"!myItem.multiple\" flex-gt-xs><md-checkbox \nng-model=\"fieldModel[myItem.name]\" ng-change=\"processRules(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\"><p \nng-bind-html=\"myItem.caption\"></p></md-checkbox><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div></md-input-container>\n</div>");
$templateCache.put("app/main/directives/dynamic-document/templates/date.html","<span ng-if=\"!myItem.multiple\"><label ng-if=\"!myItem.options[\'hideLabel\']\" style=\"font-size: 75%\">{{myItem.caption}}\n</label><md-datepicker md-placeholder=\"{{myItem.caption}}\" ng-attr-id=\"dyndoc_{{myItem.name}}\" \nng-model=\"fieldModel[myItem.name]\" ng-required=\"calculateRequired(myItem)\" ng-change=\"processRules(myItem)\">\n</md-datepicker><div style=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">\n{{myItem.options[\'hint\']}}</div></span><span ng-if=\"myItem.multiple\"><label>{{item.caption}}</label><md-button \ntitle=\"Aggiungi\" ng-click=\"fieldCounter[myItem.name].push(\'\')\" class=\"md-accent\" aria-label=\"Aggiungi\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Aggiungi</md-button><div \nng-repeat=\"field in fieldCounter[myItem.name] track by $index\" ng-init=\"fieldIndex=$index\"><label \nstyle=\"font-size: 75%\">{{myItem.caption}} ({{fieldIndex+1}})</label><md-datepicker ng-model=\"myModel[myItem.name]\" \nng-required=\"calculateRequired(myItem)\" ng-change=\"processRules(myItem)\"></md-datepicker><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div><md-button \ntitle=\"Elimina\" ng-click=\"deleteRepeatedItem(fieldModel[myItem.name], fieldIndex, fieldCounter[myItem.name]);\" \nclass=\"md-warn\" aria-label=\"Elimina\"><md-icon md-font-icon=\"icon-minus\"></md-icon>Rimuovi</md-button></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/dynamic-document.html","<div class=\"contenitore-dynamic-document\"><form name=\"myForm\" novalidate \nng-class=\"[{\'mode-stats\': isStatsMode}, {\'mode-edit\': (!isStatsMode && isEditMode)}, {\'mode-readonly\': (!isStatsMode && !isEditMode)}]\">\n<span ng-repeat=\"item in template.items\" ng-init=\"myItem=item\" ng-if=\"isStatsMode\" on-finish-render=\"ngRepeatFinished\" \ngroup-name=\"DYNAMIC_DOCUMENT\" class=\"field-{{ item.type }} fieldname-{{ item.name }}\"><ng-include \nsrc=\"\'app/main/directives/dynamic-document/templates/_stats_field.html\'\"></span><span \nng-repeat=\"item in template.items\" ng-init=\"myItem=item\" ng-if=\"!isStatsMode && isEditMode\" \non-finish-render=\"ngRepeatFinished\" group-name=\"DYNAMIC_DOCUMENT\" \nclass=\"field-{{ item.type }} fieldname-{{ item.name }}\"><ng-include \nsrc=\"\'app/main/directives/dynamic-document/templates/field.html\'\"></span><span ng-repeat=\"item in template.items\" \nng-init=\"myItem=item\" ng-if=\"!isStatsMode && !isEditMode\" on-finish-render=\"ngRepeatFinished\" \ngroup-name=\"DYNAMIC_DOCUMENT\" class=\"field-{{ item.type }} fieldname-{{ item.name }}\"><ng-include \nsrc=\"\'app/main/directives/dynamic-document/templates/_readonly_field.html\'\"></span></form></div><div class=\"pswp\" \ntabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"pswp__bg\"></div><div class=\"pswp__scroll-wrap\"><div \nclass=\"pswp__container\"><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div>\n</div><div class=\"pswp__ui pswp__ui--hidden\"><div class=\"pswp__top-bar\"><div class=\"pswp__counter\"></div><button \nclass=\"pswp__button pswp__button--close\" title=\"Close (Esc)\"></button> <button class=\"pswp__button pswp__button--fs\" \ntitle=\"Toggle fullscreen\"></button> <button class=\"pswp__button pswp__button--zoom\" title=\"Zoom in/out\"></button><div \nclass=\"pswp__preloader\"><div class=\"pswp__preloader__icn\"><div class=\"pswp__preloader__cut\"><div \nclass=\"pswp__preloader__donut\"></div></div></div></div></div><div \nclass=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=\"pswp__share-tooltip\"></div></div>\n<button class=\"pswp__button pswp__button--arrow--left\" title=\"Previous (arrow left)\"></button> <button \nclass=\"pswp__button pswp__button--arrow--right\" title=\"Next (arrow right)\"></button><div class=\"pswp__caption\"><div \nclass=\"pswp__caption__center\"></div></div></div></div></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/field.html","<span ng-switch on=\"myItem.type\"><span ng-switch-when=\"group\"><div \nng-if=\"!item.multiple && !item.options[\'same-row\']\" class=\"group-column\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/field.html\'\" ng-repeat=\"item in item.items\" \nng-init=\"myItem=item\"></div></div><div ng-if=\"!item.multiple  && item.options[\'same-row\']\" class=\"group-row\"><div \nlayout=\"row\" layout-xs=\"column\"><div class=\"margin-right-20\" ng-class=\"calculateClass(item)\" \nng-include=\"\'app/main/directives/dynamic-document/templates/field.html\'\" ng-repeat=\"item in item.items\" \nng-init=\"myItem=item\"></div></div></div><div ng-if=\"item.multiple  && !item.options[\'same-row\']\" \nclass=\"group-multiple\"><div ng-include=\"\'app/main/directives/dynamic-document/templates/multiple-group.html\'\" \nng-if=\"displayIfWizard(myItem)\"></div></div></span><span ng-switch-when=\"label\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/label.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"text\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text.html\'\" ng-init=\"fieldModel=myModel\"></div></span><span\n ng-switch-when=\"email\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text.html\'\" ng-init=\"fieldModel=myModel\"></div></span><span\n ng-switch-when=\"formula\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/formula.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"number\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text.html\'\" ng-init=\"fieldModel=myModel\"></div></span><span\n ng-switch-when=\"textarea\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/textarea.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"date\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/date.html\'\" ng-init=\"fieldModel=myModel\"></div></span><span\n ng-switch-when=\"select\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/select.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"radio\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/radio.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"scale\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/scale.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"checkbox\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/checkbox.html\'\" ng-init=\"fieldModel=myModel\"></div></span>\n<span ng-switch-when=\"textLookup\" ng-if=\"displayIfWizard(myItem)\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text-lookup.html\'\" ng-init=\"fieldModel=myModel\"></div>\n</span></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/formula.html","<div layout=\"row\" flex><md-input-container class=\"md-block\" flex-gt-xs><label>{{myItem.caption}}</label><input \nng-attr-id=\"dyndoc_{{myItem.name}}\" ng-model=\"fieldModel[myItem.name]\" ng-value=\"calculateFormula(myItem)\" \nreadonly=\"readonly\"><div style=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">\n{{myItem.options[\'hint\']}}</div></md-input-container></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/label.html","<div layout=\"column\"><div layout=\"row\"><p style=\"width: 100%; margin: 0px\" ng-bind-html=\"createLabelTag(myItem)\"></p>\n<md-button ng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-click=\"showModalHint(myItem);\" class=\"md-accent\" aria-label=\"Info\"><md-icon md-font-icon=\"icon-lightbulb-outline\">\n</md-icon>More details</md-button></div></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/multiple-group.html","<label>{{item.caption}}</label><span ng-init=\"groupName=item.name; \"><div layout-gt-sm=\"flex\" \nng-repeat=\"field in fieldCounter[groupName] track by $index\" \nng-init=\"groupIndex=$index; initModel(groupName, groupIndex); \"><div ng-repeat=\"groupItem in item.items\" \nng-init=\"myItem=groupItem\" on-finish-render=\"ngRepeatFinished\" group-name=\"{{groupName}}\" \nng-class=\"calculateClass(groupItem)\"><span ng-switch on=\"groupItem.type\"><span ng-switch-when=\"label\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/label.html\'\"></div></span><span ng-switch-when=\"text\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"number\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/text.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"textarea\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/textarea.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"date\"><div \nstyle=\"margin-top: 14px\" ng-include=\"\'app/main/directives/dynamic-document/templates/date.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"select\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/select.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"radio\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/radio.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"scale\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/scale.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span><span ng-switch-when=\"checkbox\"><div \nng-include=\"\'app/main/directives/dynamic-document/templates/checkbox.html\'\" \nng-init=\"fieldModel=myModel[groupName][groupIndex]\"></div></span></span></div><md-button style=\"margin-top: 8px\" \ntitle=\"Elimina\" ng-click=\"deleteRepeatedItem(myModel[groupName], groupIndex, fieldCounter[groupName]);\" flex=\"15\" \nclass=\"md-icon-button md-warn\" aria-label=\"Delete row\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-button title=\"Aggiungi\" ng-click=\"addMultipleEntry(item) \" class=\"md-accent\" aria-label=\"Aggiungi\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Aggiungi</md-button></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/number.html","<div ng-if=\"!myItem.multiple\" layout=\"column\" flex><label \nng-if=\"myItem.options && myItem.options[\'widget\'] && (myItem.options[\'widget\']).toLowerCase()===\'slider\'\">\n{{ myItem.caption }}</label><md-slider-container \nng-if=\"myItem.options && myItem.options[\'widget\'] && (myItem.options[\'widget\']).toLowerCase()===\'slider\'\" layout=\"row\" \nflex><md-slider md-discrete ng-model=\"fieldModel[myItem.name]\" min=\"{{ calculateMinValue(myItem) }}\" \nmax=\"{{ calculateMaxValue(myItem) }}\" step=\"{{ calculateStepValue(myItem) }}\" id=\"fieldModel[myItem.name]\" \naria-label=\"myItem.caption\" flex=\"grow\"></md-slider><md-input-container \nstyle=\"width: 64px !important; max-width: 64px !important\"><input type=\"number\" \nng-if=\"myItem.options && myItem.options[\'widget\'] && (myItem.options[\'widget\']).toLowerCase()===\'slider\'\" \nng-model=\"fieldModel[myItem.name]\" min=\"{{ calculateMinValue(myItem) }}\" max=\"{{ calculateMaxValue(myItem) }}\" \nstep=\"{{ calculateStepValue(myItem) }}\" aria-controls=\"fieldModel[myItem.name]\" aria-label=\"myItem.caption\">\n</md-input-container></md-slider-container><md-input-container \nng-if=\"!myItem.options || !myItem.options[\'widget\'] || (myItem.options[\'widget\']).toLowerCase()!==\'slider\'\"><label>\n{{ myItem.caption }}</label><input ng-attr-id=\"dyndoc_{{myItem.name}}\" min=\"{{calculateMinValue(myItem)}}\" \nmax=\"{{calculateMaxValue(myItem)}}\" ng-model=\"fieldModel[myItem.name]\" type=\"number\" \nng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-pattern=\"calculatePattern(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processRules(myItem)\"><div \nstyle=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div>\n<div ng-messages=\"myForm[myItem.name].$error\"><div ng-message=\"required\">Campo obbligatorio.</div></div>\n</md-input-container><div><md-button \nng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-click=\"showModalHint(myItem);\" class=\"md-icon-button md-accent\" aria-label=\"Info\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon></md-button></div><label>&nbsp;</label></div><span \nng-if=\"myItem.multiple\"><label>{{item.caption}}</label><md-button title=\"Aggiungi\" ng-click=\"addMultipleEntry(myItem)\" \nclass=\"md-accent\" aria-label=\"Aggiungi\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Aggiungi</md-button><div \nng-repeat=\"field in fieldCounter[myItem.name] track by $index\" ng-init=\"fieldIndex=$index\"><div layout=\"row\" flex>\n<md-input-container flex class=\"md-icon-float md-block md-title\"><label>{{myItem.caption}} ({{fieldIndex+1}})</label>\n<input ng-if=\"myItem.type===\'text\'\" ng-model=\"fieldModel[myItem.name][fieldIndex]\" type=\"text\" \nng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-pattern=\"calculatePattern(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processChange(myItem)\" \nstyle=\"width:80%; float:left\"><input ng-if=\"myItem.type===\'number\'\" ng-model=\"fieldModel[myItem.name][fieldIndex]\" \ntype=\"number\" ng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-pattern=\"calculatePattern(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processChange(myItem)\" \nstyle=\"width:80%; float:left\"><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div></md-input-container>\n<div><md-button title=\"Elimina\" \nng-click=\"deleteRepeatedItem(fieldModel[myItem.name], fieldIndex, fieldCounter[myItem.name]);\" class=\"md-warn\" \naria-label=\"Elimina\"><md-icon md-font-icon=\"icon-minus\"></md-icon>Rimuovi</md-button></div></div></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/radio.html","<div layout=\"column\"><label>{{myItem.caption}}:&nbsp;&nbsp;<md-button \nng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-required=\"calculateRequired(myItem)\" ng-click=\"showModalHint(myItem);\" class=\"md-accent\" aria-label=\"Info\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon>More details</md-button><md-button \nng-if=\"myItem.options[\'image-hint\'] && myItem.options[\'image-hint\']!==null\" ng-required=\"calculateRequired(myItem)\" \nng-click=\"showImageHint(myItem);\" class=\"md-accent\" aria-label=\"Info\"><md-icon md-font-icon=\"icon-lightbulb-outline\">\n</md-icon>More details</md-button></label><md-radio-group ng-attr-id=\"dyndoc_{{ myItem.name }}\" \nng-model=\"fieldModel[myItem.name]\" ng-disabled=\"fieldsDisabled[myItem.name]\" class=\"md-primary\" \nng-change=\"fieldChanged(myItem);\" ng-required=\"calculateRequired(myItem)\" \nlayout=\"{{myItem.options[\'layout\'] ? myItem.options[\'layout\'] : \'row\'}}\" layout-xs=\"column\"><md-radio-button \nng-repeat=\"choice in item.choices\" ng-value=\"choice.uuid\" ng-class=\"{\'md-align-top-left\': $index==1}\"><span \nng-bind-html=\"choice.caption\"></span></md-radio-button></md-radio-group><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/scale.html","<div layout=\"column\"><div layout=\"row\" flex><p style=\"margin: 0px\" ng-bind-html=\"myItem.caption\"></p><div><md-button \nng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-required=\"calculateRequired(myItem)\" ng-click=\"showModalHint(myItem);\" class=\"md-accent\" aria-label=\"Info\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon>More details</md-button><md-button \nng-if=\"myItem.options[\'image-hint\'] && myItem.options[\'image-hint\']!==null\" ng-required=\"calculateRequired(myItem)\" \nng-click=\"showImageHint(myItem);\" class=\"md-accent\" aria-label=\"Info\"><md-icon md-font-icon=\"icon-lightbulb-outline\">\n</md-icon>More details</md-button></div></div><md-radio-group ng-attr-id=\"dyndoc_{{myItem.name}}\" \nng-model=\"fieldModel[myItem.name]\" class=\"radioSelector md-primary\" ng-change=\"processRules(myItem)\" layout=\"row\" \nlayout-xs=\"column\"><div ng-repeat=\"choice in item.choices\" class=\"row\"><div flex layout=\"column\" layout-padding \nlayout-align=\"start center\" style=\"padding-left:2px; padding-right:2px\"><div flex \nng-style=\"{maxWidth:\'200px\', minWidth:\'150px\', borderBottom: \'1px solid #ccc\', backgroundColor:choice[\'background-color\'], fontSize:\'90%\'}\">\n{{choice.caption}}</div><md-radio-button flex ng-value=\"choice.value\" class=\"md-primary\">{{choice.value}}\n</md-radio-button></div></div></md-radio-group><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/select.html","<div layout=\"row\"><md-input-container class=\"md-block\"><label>{{myItem.caption}}</label><md-select \nng-attr-id=\"dyndoc_{{ myItem.name }}\" ng-model=\"fieldModel[myItem.name]\" ng-change=\"fieldChanged(myItem);\"><md-option \nng-value=\"choice.uuid\" ng-repeat=\"choice in myItem.choices\">{{ choice.caption }}</md-option></md-select><div \nstyle=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{ myItem.options[\'hint\'] }}\n</div></md-input-container></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/text-lookup.html","<div layout=\"column\" class=\"dyndoc-field-text-lookup\"><md-input-container class=\"md-block\" ng-if=\"!myItem.multiple\" \nflex><label>{{ myItem.caption }}</label><md-autocomplete md-no-cache=\"true\" md-search-text=\"myItem.searchText\" \nmd-items=\"item in getTextLookupData(myItem, myItem.searchText);\" \nmd-item-text=\"item[myItem.options.dataSource.labelField]\" md-selected-item-change=\"fieldChanged(myItem, item)\" \nmd-min-length=\"1\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-model=\"myModel[myItem.name]\" \nplaceholder=\"{{ myItem.caption }}\" flex><span>{{ item[myItem.options.dataSource.labelField] }}</span></md-autocomplete>\n<div style=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\'] !== null\">\n{{ myItem.options[\'hint\'] }}</div></md-input-container><md-input-container class=\"md-block\" ng-if=\"myItem.multiple\" \nflex><label>Campo di tipo textLookup multiplo non supportato.</label></md-input-container></div>");
$templateCache.put("app/main/directives/dynamic-document/templates/text.html","<div ng-if=\"!myItem.multiple\" layout=\"column\" flex><md-input-container \nng-if=\"!myItem.options || !myItem.options[\'widget\'] || (myItem.options[\'widget\']).toLowerCase()!==\'slider\'\"><label>\n{{ myItem.caption }}</label><input ng-attr-id=\"dyndoc_{{myItem.name}}\" ng-model=\"fieldModel[myItem.name]\" \ntype=\"{{myItem.type ? myItem.type : \'text\'}}\" name=\"{{myItem.name}}\" ng-maxlength=\"calculateMaxLength(myItem)\" \nng-required=\"calculateRequired(myItem)\" ng-pattern=\"calculatePattern(myItem)\" \nng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processRules(myItem)\"><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div><div \nng-messages=\"myForm[myItem.name].$error\"><div ng-message=\"required\">Campo obbligatorio.</div></div>\n</md-input-container><div><md-button \nng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-click=\"showModalHint(myItem);\" class=\"md-icon-button md-accent\" aria-label=\"Info\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon>More details</md-button></div><label>&nbsp;</label></div><span \nng-if=\"myItem.multiple\"><label>{{item.caption}}</label><md-button title=\"Aggiungi\" ng-click=\"addMultipleEntry(myItem)\" \nclass=\"md-accent\" aria-label=\"Aggiungi\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Aggiungi</md-button><div \nng-repeat=\"field in fieldCounter[myItem.name] track by $index\" ng-init=\"fieldIndex=$index\"><div layout=\"row\" flex>\n<md-input-container flex class=\"md-icon-float md-block md-title\"><label>{{myItem.caption}} ({{fieldIndex+1}})</label>\n<input ng-if=\"myItem.type===\'text\'\" ng-model=\"fieldModel[myItem.name][fieldIndex]\" type=\"text\" \nng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-pattern=\"calculatePattern(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processChange(myItem)\" \nstyle=\"width:80%; float:left\"> <input ng-if=\"myItem.type===\'number\'\" ng-model=\"fieldModel[myItem.name][fieldIndex]\" \ntype=\"number\" ng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-pattern=\"calculatePattern(myItem)\" ng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processChange(myItem)\" \nstyle=\"width:80%; float:left\"><div style=\"font-size: 75%\" \nng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div></md-input-container>\n<div><md-button title=\"Elimina\" \nng-click=\"deleteRepeatedItem(fieldModel[myItem.name], fieldIndex, fieldCounter[myItem.name]);\" class=\"md-warn\" \naria-label=\"Elimina\"><md-icon md-font-icon=\"icon-minus\"></md-icon>Rimuovi</md-button></div></div></div></span>");
$templateCache.put("app/main/directives/dynamic-document/templates/textarea.html","<div layout=\"row\" flex><md-input-container ng-if=\"!myItem.multiple\" class=\"md-block\" flex-gt-xs><label>\n{{myItem.caption}}</label><textarea ng-attr-id=\"dyndoc_{{myItem.name}}\" ng-model=\"fieldModel[myItem.name]\" \nng-maxlength=\"calculateMaxLength(myItem)\" ng-required=\"calculateRequired(myItem)\" \nng-disabled=\"fieldsDisabled[myItem.name]\" ng-change=\"processRules(myItem)\" rows=\"2\" md-select-on-focus></textarea><div \nstyle=\"font-size: 75%\" ng-if=\"myItem.options[\'hint\'] && myItem.options[\'hint\']!==null\">{{myItem.options[\'hint\']}}</div>\n</md-input-container><div><md-button \nng-if=\"myItem.options[\'modal-hint-html\'] && myItem.options[\'modal-hint-html\']!==null\" \nng-click=\"showModalHint(myItem);\" class=\"md-icon-button md-accent\" aria-label=\"Info\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon>More details</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/pages/earningcosts/dialogs/singlepayment/singlepayment.html","<md-dialog aria-lanel=\"Effettua un pagamento\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Pagamento singolo\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Annulla\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\"><p>\nUsa questa finestra per segnare come pagato un singolo pagamento.</p></div><form layout=\"column\" flex>\n<md-input-container>Importo: {{ paymentData.paymentValue | currency : \'&euro;\' : 2 }}</md-input-container>\n<md-datepicker ng-model=\"paymentData.paymentDate\" md-placeholder=\"Data\"></md-datepicker><md-input-container><label>Note\n</label><input ng-model=\"paymentData.paymentDescription\"></md-input-container><md-input-container><md-checkbox \nng-model=\"paymentData.flgGenerateInvoice\">{{\'PAYMENTS.GENERATE_INVOICE\' | translate}}</md-checkbox>\n</md-input-container><md-input-container ng-show=\"paymentData.flgGenerateInvoice\"><md-checkbox \nng-model=\"paymentData.flgSendNotification\">{{\'PAYMENTS.NOTIFY_USER\' | translate}}</md-checkbox></md-input-container>\n</form></md-dialog-content><md-dialog-actions><md-button class=\"md-raised\" ng-click=\"cancel();\">Annulla</md-button>\n<md-button class=\"md-raised\" ng-click=\"answer();\">Paga</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/changeplan/changeplan.html","<div id=\"organizations-changeplan\" ng-init=\"vm.init();\" class=\"ov-page-organizations-changeplan md-padding\" \nlayout=\"column\"><div class=\"content md-padding\"><div layout=\"row\" flex><div layout=\"column\" flex=\"100\" \nlayout-align=\"center center\"><h1>Cambio piano di ClubYourLife</h1></div></div><div layout=\"row\" flex><div \nlayout=\"column\" flex=\"100\" ng-if=\"vm.success\" layout-align=\"center center\"><p>\nIl cambio di piano è andato a buon fine. Ora puoi tornare a gestire la tua organizzazione.</p></div><div \nlayout=\"column\" flex=\"100\" ng-if=\"!vm.success\" layout-align=\"center center\">\nSembra che il cambio di piano abbia avuto qualche problema. Attendi qualche minuto prima di cambiare nuovamente piano di ClubYourLife, magari si tratta di un problema temporaneo. Prova a contattare l\'assitenza se vedi che il problema persiste.\n<p></p><p>Ora verrai inviato alla pagina principale della tua organizzazione.</p></div></div><div layout=\"row\" flex>\n<div layout=\"column\" flex=\"100\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.gotoOrganizationHome();\">Ok</md-button></div></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/new_organization/new_organization.html","<div class=\"page-layout simple white-bg md-padding\" layout=\"column\"><div \nclass=\"content white-bg md-padding ms-scroll contenitore-pagina-padding-e-ombra\" style=\"padding-top: 12px\" \nng-if=\"vm.status === \'DATI\'\"><dynamic-document ng-data-url=\"{{vm.documentUrl}}\" ng-template-url=\"{{vm.templateUrl}}\" \nng-stats-url=\"\" ng-save-url=\"{{vm.apiPath}}/dynamicDocumentConnectors/\" on-success=\"myOnSuccess(succ, action)\" \non-error=\"myOnErr(err)\" ng-edit-mode=\"true\"></dynamic-document><div layout-align=\"center center\" layout=\"row\" \nflex=\"100\"><md-button class=\"md-accent\" ng-click=\"vm.saveAndGoToPrevWizardPage()\" \nng-show=\"vm.hasWizard && vm.currentWizardIndex>0 && vm.currentWizardIndex<vm.wizardPages.length-1\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\"></md-icon>Indietro</md-button><span \nng-repeat=\"s in vm.wizardPages track by $index\" \nng-show=\"vm.hasWizard && vm.currentWizardIndex>0 && vm.currentWizardIndex<vm.wizardPages.length-1\"><md-icon \nclass=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.currentWizardIndex === $index\">\n</md-icon><md-icon class=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nng-if=\"vm.currentWizardIndex !== $index\"></md-icon></span><md-button class=\"md-raised md-accent\" \nng-class=\"\'ov-tag-btn-neworganization-\' + vm.currentWizardIndex\" ng-click=\"vm.saveAndGoToNextWizardPage()\" \nng-show=\"vm.hasWizard && vm.currentWizardIndex<vm.wizardPages.length-1\" \nng-disabled=\"vm.calculatePageCompletionRatio(vm.currentWizardIndex) < 100\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold\"></md-icon>Avanti</md-button><md-button class=\"md-raised md-grey-200-bg w-90 h-90\" \nng-click=\"vm.saveAndGoToPrevWizardPage()\" style=\"border-radius: 999px\" \nng-show=\"!vm.isLoading && (!vm.hasWizard || (vm.hasWizard &&  vm.currentWizardIndex==vm.wizardPages.length-1))\"><div \nlayout-align=\"center center\"><md-icon class=\"light-blue-500-fg h-40 w-40\" style=\"font-size: 38px; line-height: 38px\" \nmd-font-icon=\"icon-arrow-left-bold\"></md-icon><br><span class=\"light-blue-500-fg font-size-12\">INDIETRO</span></div>\n</md-button><md-button class=\"md-raised md-accent w-120 h-120 ov-tag-btn-neworganization-save\" \nng-click=\"vm.createFreeOrganization()\" style=\"border-radius: 999px\" ng-disabled=\"vm.calculateCompletionRatio() < 100\" \nng-show=\"!vm.isLoading && (!vm.hasWizard || (vm.hasWizard &&  vm.currentWizardIndex==vm.wizardPages.length-1))\"><div \nlayout-align=\"center center\"><md-icon class=\"white-fg h-50 w-50\" style=\"font-size: 48px; line-height: 48px\" \nmd-font-icon=\"icon-content-save\"></md-icon><br><span class=\"white-fg font-size-12\">SALVA</span></div></md-button></div>\n</div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/edit-organization.html","<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"orgForm\"><md-input-container \nclass=\"md-block\"><label translate=\"ORGANIZATIONS.ORGANIZATION_NAME_MANDATORY\">Organization Name</label><input \ntype=\"text\" ng-model=\"vm.organization.name\" required></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ORGANIZATIONS.ORGANIZATION_DESCRIPTION\">Organization Description</label><input type=\"text\" \nng-model=\"vm.organization.description\"></md-input-container><div layout=\"row\" style=\"margin-bottom: 25px\" \nng-if=\"vm.isAdmin\"><div id=\"document-logo-uploader\" ng-if=\"!vm.isCreatingOrganization\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flowLogo\" flow-files-submitted=\"vm.upload(\'LOGO\')\" flow-file-added=\"vm.fileAdded($file, \'LOGO\')\" \nflow-file-success=\"vm.fileSuccess($file, $message, \'LOGO\')\" flow-file-error=\"vm.fileError( $file, $message, $flow )\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" id=\"logo-uploader\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"Upload\" flow-btn>\n{{\'ORGANIZATIONS.LOGO\' | translate }}</md-button></div></div><div id=\"document-background-uploader\" \nng-if=\"!vm.isCreatingOrganization\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flowBackground\" \nflow-files-submitted=\"vm.upload(\'BACKGROUND\')\" flow-file-added=\"vm.fileAdded($file, \'BACKGROUND\')\" \nflow-file-success=\"vm.fileSuccess($file, $message, \'BACKGROUND\')\" \nflow-file-error=\"vm.fileError( $file, $message, $flow )\" flow-complete=\"vm.uploadComplete()\"><div \nclass=\"upload-button\" id=\"background-uploader\" layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"Upload\" flow-btn>{{\'ORGANIZATIONS.BACKGROUND\' | translate }}</md-button></div>\n</div><div layout=\"row\" ng-if=\"vm.isAdmin && vm.isCreatingOrganization\"><md-button class=\"md-icon-button md-raised\" \nng-click=\"vm.saveOrganization();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon>\n</md-button></div><div layout=\"row\" \nng-if=\"vm.isAdmin && ( (vm.organization.uriLogo && vm.organization.uriLogo!==null) || (vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage!==null) )\">\n<md-menu><md-button aria-label=\"Delete image\" class=\"md-icon-button\" \nng-click=\"vm.openMenuImageDeletion($mdOpenMenu, $event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-primary icona-cancella-media\" style=\"color: #999; cursor: pointer\"></md-icon></md-button><md-menu-content \nwidth=\"4\"><md-menu-item><md-button ng-enabled=\"vm.organization.uriLogo && vm.organization.uriLogo!==null\" \naria-label=\"Elimina logo\" ng-click=\"vm.removeLogo()\">\n{{\'ORGANIZATIONS.DELETE\' | translate}} {{\'ORGANIZATIONS.LOGO\' | translate}}</md-button></md-menu-item><md-menu-item>\n<md-button ng-enabled=\"vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage!==null\" \naria-label=\"Elimina sfondo\" ng-click=\"vm.removeBackground()\">\n{{\'ORGANIZATIONS.DELETE\' | translate}} {{\'ORGANIZATIONS.BACKGROUND\' | translate}}</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\">\n<md-checkbox class=\"remember-me\" ng-model=\"vm.organization.flgEnableParentChild\"><span \ntranslate=\"ORGANIZATIONS.ENABLE_PARENT_CHILD\">Abilita gestione genitore / tutore</span> <span \nstyle=\"font-size: 85%; font-style: italic\">- {{\'ORGANIZATIONS.PARENT_CHILD_HINT\' | translate}}</span></md-checkbox>\n</div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex-gt-xs><md-chips ng-model=\"vm.organization.categories\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete \nmd-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in vm.lookupCategories(ctrl.searchText)\" md-item-text=\"vm.translateCategory(item)\" \nmd-floating-label=\"{{\'ORGANIZATIONS.ASSETS\' | translate }}\"><span md-highlight-text=\"ctrl.searchText\">{{item.name}}\n</span></md-autocomplete><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips>\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.ORGANIZATION_TYPE\" required>Organization type\n</label><md-select ng-model=\"vm.organization.organizationTypeId\" style=\"margin-top: 1.25em\"><md-option ng-value>-\n</md-option><md-option ng-selected=\"{{ vm.organization.organizationTypeId === orgtype.id ? \'true\' : \'false\' }}\" \nng-value=\"orgtype.id\" ng-repeat=\"orgtype in vm.organizationTypes track by orgtype.id\">{{orgtype.name}}</md-option>\n</md-select></md-input-container></div><br><br><div class=\"md-title\" layout-gt-sm=\"row\">Legale Rappresentante</div><div\n layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Nome e cognome</label><input type=\"text\" \nng-model=\"vm.organization.refPerson\" required></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Telefono</label><input type=\"text\" ng-model=\"vm.organization.refPersonPhone\" required></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>Email</label><input type=\"email\" \nng-model=\"vm.organization.refPersonMail\" required></md-input-container></div><br><br><div class=\"md-title\" \nlayout-gt-sm=\"row\">Sede legale</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label \ntranslate=\"ORGANIZATIONS.ADDRESS\">Address</label><input type=\"text\" ng-model=\"vm.organization.address\">\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.ADDRESS_NUMBER\">Num.</label><input \ntype=\"text\" ng-model=\"vm.organization.addressNumber\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.POSTAL_CODE\">Postal code</label><input \ntype=\"text\" ng-model=\"vm.organization.postalCode\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"ORGANIZATIONS.PROV\">Province</label><input type=\"text\" ng-model=\"vm.organization.province\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.CITY\">City</label>\n<input type=\"text\" ng-model=\"vm.organization.city\"></md-input-container></div><br><br><div class=\"md-title\" \nlayout-gt-sm=\"row\">Sede operativa</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label \ntranslate=\"ORGANIZATIONS.ADDRESS\">Address</label><input type=\"text\" ng-model=\"vm.organization.addressOperat\">\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.ADDRESS_NUMBER\">Num.</label><input \ntype=\"text\" ng-model=\"vm.organization.addressNumberOperat\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.POSTAL_CODE\">Postal code</label><input \ntype=\"text\" ng-model=\"vm.organization.postalCodeOperat\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"ORGANIZATIONS.PROV\">Province</label><input type=\"text\" \nng-model=\"vm.organization.provinceOperat\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"ORGANIZATIONS.CITY\">City</label><input type=\"text\" ng-model=\"vm.organization.cityOperat\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><md-button \ntitle=\"{{\'ORGANIZATIONS.FIND_ADDRESS\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.updateLocationFromAddress()\" aria-label=\"Update location\"><md-icon md-font-icon=\"icon-map-marker-radius\" \nclass=\"md-primary\"></md-icon></md-button></md-input-container></div><div layout-gt-sm=\"row\"><fieldset \nclass=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\">Google Maps</div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.organization.latitude ? vm.organization.latitude : 41.8919300}}\"> <input type=\"hidden\" \nclass=\"gllpLongitude\" value=\"{{vm.organization.longitude ? vm.organization.longitude : 12.5113300 }}\"> <input \ntype=\"hidden\" class=\"gllpZoom\" value=\"6\"></fieldset></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><md-button title=\"{{\'ORGANIZATIONS.UPDATE_LOCATION\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.updateLocationFromMap()\" aria-label=\"Update location\"><md-icon \nmd-font-icon=\"icon-map\" class=\"md-primary\"></md-icon></md-button><span style=\"font-size: 75%\">\n{{\'ORGANIZATIONS.UPDATE_LOCATION_FROM_MAP\' | translate }}</span></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.LATITUDE\">Latitude</label><input type=\"text\" \nid=\"organization-latitude\" ng-model=\"vm.organization.latitude\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.LONGITUDE\">Longitude</label><input type=\"text\" \nid=\"organization-longitude\" ng-model=\"vm.organization.longitude\"></md-input-container></div><br><br><div \nclass=\"md-title\" layout-gt-sm=\"row\">Contatti</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"ORGANIZATIONS.PHONE\">Phone</label><input type=\"text\" ng-model=\"vm.organization.phone\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.MOBILE_PHONE\">\nMobile phone</label><input type=\"text\" ng-model=\"vm.organization.mobilePhone\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.FAX\">Fax</label><input type=\"text\" \nng-model=\"vm.organization.fax\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"ORGANIZATIONS.EMAIL\">Email</label><input type=\"email\" ng-model=\"vm.organization.email\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.WEBSITE\">\nWeb Site</label><input type=\"text\" ng-model=\"vm.organization.website\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.FACEBOOK_PAGE\">Facebook page</label><input type=\"text\" \nng-model=\"vm.organization.facebookPage\"></md-input-container></div><br><br><div class=\"md-title\" layout-gt-sm=\"row\">\nAltri dati</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\"><label translate=\"ORGANIZATIONS.IBAN\">IBAN\n</label><input type=\"text\" maxlength=\"27\" ng-model=\"vm.organization.IBAN\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.PEC\">PEC</label><input type=\"text\" \nng-model=\"vm.organization.PEC\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"ORGANIZATIONS.PIVA\">P.IVA</label><input type=\"text\" maxlength=\"11\" ng-model=\"vm.organization.piva\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"ORGANIZATIONS.TAX_CODE\">Tax Code\n</label><input type=\"text\" maxlength=\"16\" ng-model=\"vm.organization.taxCode\"></md-input-container></div>\n<md-input-container style=\"width:100%\"><label translate=\"ORGANIZATIONS.NOTES\">NOTES</label><textarea \nng-model=\"vm.organization.notes\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container></form>\n</div>");
$templateCache.put("app/main/pages/organizations/views/organization/organization.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\">\n<ov-organization-alert organization-id=\"{{vm.organization.id}}\"></ov-organization-alert><ov-navigation-bar \norganization-id=\"{{vm.organization.id}}\" selected-page=\"HOME\"></ov-navigation-bar><div \nng-show=\"vm.isAdmin && !vm.isEditing\" \nng-include=\"\'app/main/pages/organizations/views/organization/tabs/organization-dashboard.html\'\"></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_members/organization_members.html","<div class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" layout=\"column\" ms-scroll><div class=\"content\">\n<ov-organization-alert organization-id=\"{{vm.organization.id}}\"></ov-organization-alert><ov-navigation-bar \norganization-id=\"{{vm.organization.id}}\" selected-page=\"MEMBERS\"></ov-navigation-bar><div \nclass=\"contenitore-pagina-padding-e-ombra\"><div class=\"contenitore-cerca\" layout=\"row\" layout-align=\"start start\">\n<md-input-container flex=\"100\" class=\"md-icon-left\"><label class=\"ng-binding\" for=\"members-search\">Cerca</label>\n<md-icon md-font-icon=\"icon-magnify\" aria-hidden=\"true\"></md-icon><input id=\"members-search\" type=\"text\" flex \nng-model=\"vm.dtSearchTerm\" ng-change=\"vm.dtInstance.DataTable.draw();\" ng-model-options=\"{ debounce: 500 }\"><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><table datatable=\"users-datatable\" \ndt-options=\"vm.dtOptionsUsers\" dt-columns=\"vm.dtColumnsUsers\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\">\n</table></div></div><div class=\"contenitore-button-fixed\"><md-button aria-label=\"Esporta in Excel\" \nclass=\"md-raised md-accent ov-floating-btn esporta-excel md-fab\" ng-click=\"vm.exportExcel()\" title=\"Export excel\">\n<md-icon class=\"md-primary\" md-font-icon=\"icon-file-excel\"></md-icon>Export</md-button><md-button \naria-label=\"Nuovo membro\" class=\"md-fab md-raised md-accent ov-floating-btn\" id=\"addMemberBtn\" \nng-click=\"vm.askUserDetails($event)\" title=\"{{\'ORGANIZATIONS.MEMBER.ADD\' | translate}}\"><md-icon class=\"md-primary\" \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_resources/organization_resources.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" layout=\"column\"><div \nclass=\"content\"><ov-organization-alert organization-id=\"{{vm.organization.id}}\"></ov-organization-alert>\n<ov-navigation-bar organization-id=\"{{vm.organization.id}}\" selected-page=\"RESOURCES\"></ov-navigation-bar><div \nng-hide=\"vm.isShowResourceCalendar\"><div class=\"contenitore-pagina-padding-e-ombra\"><div class=\"contenitore-cerca\" \nlayout=\"row\" layout-align=\"end start\"><md-input-container flex=\"100\" class=\"md-block\" flex-gt-xs><label>\n{{\'ORGANIZATIONS.SEARCH\' | translate }}</label><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon>\n<input id=\"resources-search\" type=\"text\" flex></md-input-container></div><div layout=\"row\" layout-align=\"center\" \nclass=\"margin-top-80\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsResources\" \nng-hide=\"vm.isShowResourceCalendar\" ng-show=\"!vm.loading\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NAME\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATIONS.RESOURCES.RESOURCES_DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NUMBER_OF_ITEMS\">\nNumber of items</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATIONS.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"resource in vm.organization.organizationResources\"><td \nng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</td><td ng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">{{resource.description}}\n</td><td ng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">{{resource.totalNumber}}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.showResourceCalendar($event,resource)\" \naria-label=\"Show resource calendar\" translate translate-attr-aria-label=\"ORGANIZATIONS.RESOURCES.CALENDAR_USAGE\">\n<md-icon md-font-icon=\"icon-calendar-clock\"></md-icon></md-button></td></tr></tbody></table></div><div \nng-show=\"vm.isShowResourceCalendar\"><h2>{{vm.calendarResourceName}}</h2><div layout=\"row\" layout-align=\"end start\" \nng-if=\"vm.isAdmin\"><md-button title=\"{{\'OFFERED_SERVICES.RESOURCES.BACK\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.backToResources()\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-undo-variant\" class=\"md-primary\"></md-icon></md-button></div><br><div ng-if=\"vm.isAdmin\"><div \nid=\"myResourceCalendar\" ui-calendar=\"vm.uiConfig.resourceCalendar\" ng-model=\"vm.eventSourcesForResource\" \ncalendar=\"myResourceCalendar\"></div></div></div></div></div></div><div class=\"ov-floating-btn\"><md-button \ntitle=\"{{\'ORGANIZATIONS.RESOURCES.ADD\' | translate}}\" class=\"md-fab md-raised md-accent\" \nng-click=\"vm.askOrganizationResourceDetails($event);\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/organizations/views/organization_services/organization_services.html","<div layout=\"column\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" ms-scroll ng-init=\"vm.init();\">\n<div class=\"content\"><ov-organization-alert organization-id=\"{{vm.organization.id}}\"></ov-organization-alert>\n<ov-navigation-bar organization-id=\"{{vm.organization.id}}\" ng-if=\"vm.serviceType === \'SERVICE\'\" \nselected-page=\"SERVICES\"></ov-navigation-bar><ov-navigation-bar organization-id=\"{{vm.organization.id}}\" \nng-if=\"vm.serviceType === \'CARNET\'\" selected-page=\"CARNET\"></ov-navigation-bar><ov-navigation-bar \norganization-id=\"{{vm.organization.id}}\" ng-if=\"vm.serviceType === \'EVENT\'\" selected-page=\"EVENTS\"></ov-navigation-bar>\n<md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\"><md-tab><md-tab-label><span>Servizi</span></md-tab-label>\n<md-tab-body><div class=\"ov-box ov-box-info\" layout=\"row\" flex=\"100\" \nng-if=\"vm.searchableServicesStats.withEnoughData / vm.searchableServicesStats.total < 0.7\"><div flex=\"10\" layout=\"row\" \nlayout=\"center center\"><md-icon md-font-icon=\"icon-information\" class=\"blue-800-fg s32\"></md-icon></div><div \nflex=\"grow\"><strong>Ricercabilità servizi:</strong><br>\nUno o più servizi sono impostati come pubblicamente ricercabili (vedi colonna \"Pubblicato\"). Pare che alcuni di essi non abbiano sufficienti informazioni per aiutare la ricerca da parte degli utenti. Controlla, fermando il mouse sull\'icona\n<md-icon md-font-icon=\"icon-cloud-outline-off\"></md-icon>\nper vedere quali dati sono compilati e quali potresti aggiungere.<br>\nPer aggiungere dati ad un servizio basta andare tra le sue impostazioni usando l\'icona<md-icon md-font-icon=\"icon-cog\">\n</md-icon>.</div></div><div class=\"contenitore-cerca\" layout=\"row\" layout-align=\"end start\"><md-input-container \nflex=\"50\" class=\"md-block\" flex-gt-xs><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><label>\n{{\'ORGANIZATIONS.SEARCH\' | translate }}</label><input id=\"services-search\" type=\"text\" translate flex \nng-model=\"vm.dtServicesSearchText\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.reloadServicesTableItems()\">\n</md-input-container><md-input-container flex=\"50\" class=\"md-block\" flex-gt-xs ng-if=\"vm.serviceType === \'SERVICE\'\">\n<md-select style=\"margin-left:15px\" required ng-model=\"vm.dtServicesSearchStandalone\" \naria-label=\"Filtra tipo di servizi\" ng-change=\"vm.reloadServicesTableItems()\"><md-option value=\"\">\n{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option value=\"S\">{{\'OFFERED_SERVICES.IS_STANDALONE\' | translate}}\n</md-option><md-option value=\"N\">{{\'OFFERED_SERVICES.IS_NOT_STANDALONE\' | translate}}</md-option></md-select>\n</md-input-container></div><table datatable=\"services-datatable\" dt-options=\"vm.dtServicesOptions\" \ndt-columns=\"vm.dtServicesColumns\" dt-instance=\"vm.dtServicesInstance\" class=\"row-border hover\"></table></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Gestione Iscrizioni</span></md-tab-label><md-tab-body><div \nng-if=\"vm.selectedTabIndex === 1\" ng-include=\"\'app/main/pages/subscriptions/subscriptions.html\'\" \nng-controller=\"SubscriptionsController as vm\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nGestione presenze</span></md-tab-label><md-tab-body><div ng-if=\"vm.selectedTabIndex === 2\" \nng-include=\"\'app/main/pages/attendances/attendances.html\'\" ng-controller=\"AttendancesController as vm\"></div>\n</md-tab-body></md-tab></md-tabs></div></div><div class=\"ov-floating-btn\" ng-if=\"vm.selectedTabIndex === 0\"><md-button \ntitle=\"{{\'ORGANIZATIONS.OFFERED_SERVICES.ADD\' | translate}}\" ng-if=\"vm.serviceType !== \'EVENT\'\" \nclass=\"md-fab md-raised md-accent\" ng-click=\"vm.gotoNewOfferedService();\" aria-label=\"Nuovo servizio\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button><md-button \ntitle=\"{{\'ORGANIZATIONS.OFFERED_SERVICES.ADD_EVENT\' | translate}}\" ng-if=\"vm.serviceType === \'EVENT\'\" \nclass=\"md-fab md-raised md-accent\" ng-click=\"vm.gotoNewEvent();\" aria-label=\"Nuovo evento\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div><div class=\"ov-floating-btn\" \nng-if=\"vm.selectedTabIndex === 1\"><div class=\"white-fg\"><md-button title=\"Invia notifica pagamenti mancanti\" \nng-if=\"vm.serviceType !== \'EVENT\' && vm.paymentsFilter === \'M\'\" class=\"md-fab md-raised md-accent\" \nng-click=\"vm.goToSendMassiveNotification(vm.organizationId, vm.offeredServiceId, \'M\');\" \naria-label=\"Invia notifica pagamenti mancanti\"><md-icon md-font-icon=\"icon-email\" class=\"md-primary\"></md-icon>\n</md-button><md-button title=\"{{\'OFFERED_SERVICES.SUBSCRIBER.ADD\' | translate}}\" ng-if=\"vm.serviceType !== \'EVENT\'\" \nclass=\"md-fab md-raised md-accent\" ng-click=\"vm.goToNewSubscription();\" aria-label=\"Nuovo iscritto\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div></div><div class=\"ov-floating-btn\" \nng-if=\"vm.selectedTabIndex === 2\"><div class=\"white-fg\"><md-button n_g-if=\"vm.isAdmin\" title=\"Aggiungi presenze\" \nclass=\"md-fab md-raised\" aria-label=\"Aggiungi presenze\" \nng-class=\"vm.appDataService.current.selectedServiceId ? \'md-accent\' : \'\'\" \nng-disabled=\"!vm.appDataService.current || !vm.appDataService.current.selectedServiceId\" \nng-click=\"vm.goToAttendanceDetail(vm.appDataService.current.selectedServiceId)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"md-primary\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/organization_settings.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" ms-scroll \nlayout=\"column\"><div class=\"content\"><ov-organization-alert organization-id=\"{{vm.organization.id}}\">\n</ov-organization-alert><ov-navigation-bar organization-id=\"{{vm.organization.id}}\" selected-page=\"SETTINGS\">\n</ov-navigation-bar><md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\"><md-tab ng-if=\"vm.isAdmin\">\n<md-tab-label><span translate=\"ORGANIZATIONS.BASIC_INFO\">Basic info</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/organizations/views/organization/edit-organization.html\'\"></div></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span translate=\"ORGANIZATIONS.DATA_TYPES\">Data types</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/pages/organizations/views/organization_settings/tabs/types.html\'\"></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\" ng-disabled=\"!vm.epaymentsEnabled\"><md-tab-label><span \ntranslate=\"ORGANIZATIONS.ONLINE_PAYMENTS\">Pagamenti online</span></md-tab-label><md-tab-body><div layout-gt-sm=\"row\" \nng-if=\"(!vm.organization.stripeAccountId || vm.organization.stripeAccountId.trim()===\'\')\"><md-input-container>\n<md-checkbox ng-model=\"vm.organization.flgEnableStripePayments\" flex ng-change=\"vm.manageStripeToken()\">\n{{\'ORGANIZATIONS.ENABLE_STRIPE_PAYMENTS\' | translate}} <a href=\"https://stripe.com\" target=\"_blank\">stripe.com</a>\n</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.flgEnableStripePayments && (!vm.organization.stripeAccountId || vm.organization.stripeAccountId.trim()===\'\')\">\n<md-input-container>Prosegui per abilitare i pagamenti tramite il seguente link: <a \nhref=\"https://connect.stripe.com/oauth/authorize?response_type=code&client_id={{vm.stripeClientId}}&scope=read_write&state={{vm.stripeRequestToken}}&redirect_uri={{vm.apiPath}}/stripe/connect\">\n<img src=\"assets/images/logos/blue-on-light.png\"></a></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.stripeAccountId && vm.organization.stripeAccountId.trim()!==\'\'\"><md-input-container><strong>\n{{\'ORGANIZATIONS.PAYMENTS_ENABLED\'|translate}}</strong><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deactivateStripe()\">{{\'ORGANIZATIONS.DEACTIVATE\' | translate }}</md-button></md-input-container></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span translate=\"ORGANIZATIONS.INVOICES_RECEIPTS\">\nReceipts and Invoices</span></md-tab-label><md-tab-body><form name=\"userAttributes\"><div layout=\"row\" \nclass=\"font-size-12\">\nPer rendere modificabili i parametri di avvio numerazione occorre prima disabilitare la generazione delle ricevute e premere \"Salva\". I campi diverranno editabili. Una volta immessi i valori desiderati abilitare nuovamente la generazione delle ricevute e premere \"Salva\".\n</div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container><md-checkbox \nng-model=\"vm.organization.flgEnableInvoice\" flex>{{\'ORGANIZATIONS.FLG_ENABLE_INVOICES_RECEIPTS\' | translate }}\n</md-checkbox></md-input-container><md-button ng-if=\"!vm.organization.flgEnableInvoice\" \nclass=\"md-accent md-raised md-fab\" ng-click=\"vm.saveOrganization();\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button><md-button \nng-if=\"vm.organization.flgEnableInvoice\" ng-disabled=\"vm.flgEnableInvoicesAtStart\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.enableInvoices();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button></div><div layout=\"row\"><span flex=\"30\">{{\'ORGANIZATIONS.RECEIPTS\' | translate }}</span>\n<md-input-container flex=\"30\"><label translate=\"ORGANIZATIONS.INVOICE_NUMBER_STARTS\">Number</label><input \nng-disabled=\"vm.flgEnableInvoicesAtStart\" type=\"number\" name=\"invoiceNumber\" \nng-model=\"vm.organization.invoiceNextNumber\"><div class=\"font-size-12\">\nLasciare vuoto per far iniziare da 1 la numerazione. Altrimenti inserire il numero dell\'ultima ricevuta già emessa.\n</div></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label \ntranslate=\"ORGANIZATIONS.INVOICE_SECTION\" required>Section</label><input \nrestrict-input=\"{type: \'lettersAndDigitsOnly\'}\" ng-disabled=\"vm.flgEnableInvoicesAtStart\" type=\"text\" \nname=\"invoiceSection\" ng-model=\"vm.organization.invoiceSection\"></md-input-container></div><div layout=\"row\"><span \nflex=\"30\">{{\'ORGANIZATIONS.CREDIT_NOTES\' | translate }}</span><md-input-container flex=\"30\"><label \ntranslate=\"ORGANIZATIONS.CREDIT_NOTE_NUMBER_STARTS\">Number</label><input ng-disabled=\"vm.flgEnableInvoicesAtStart\" \ntype=\"number\" name=\"creditNoteNextNumber\" ng-model=\"vm.organization.creditNoteNextNumber\"><div class=\"font-size-12\">\nLasciare vuoto per far iniziare da 1 la numerazione. Altrimenti inserire il numero dell\'ultima nota già emessa.</div>\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label translate=\"ORGANIZATIONS.INVOICE_SECTION\" \nrequired>Section</label><input restrict-input=\"{type: \'lettersAndDigitsOnly\'}\" \nng-disabled=\"vm.flgEnableInvoicesAtStart\" type=\"text\" name=\"creditNoteSection\" \nng-model=\"vm.organization.creditNoteSection\"></md-input-container></div><div layout=\"column\" flex=\"95\">\n<md-input-container><label translate=\"ORGANIZATIONS.INVOICE_HEADER\">HEADER</label><textarea \nng-model=\"vm.organization.invoiceHeader\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div><div layout=\"column\" flex=\"20\"><md-button class=\"md-accent md-raised md-fab\" \nng-click=\"vm.saveOrganization();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button></div></form></md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span \ntranslate=\"ORGANIZATIONS.EMAIL_AND_NOTIFICATIONS\">Email e notifiche</span></md-tab-label><md-tab-body>\n{{\'ORGANIZATIONS.EMAIL_CONF_HINT\' | translate}}:<form name=\"emailconf\"><div layout-gt-sm=\"row\"><md-input-container>\n<label>{{\'ORGANIZATIONS.EMAIL_SENDER_NAME\' | translate}}</label><input type=\"text\" \nng-model=\"vm.organization.emailFromName\" minlength=\"2\" maxlength=\"70\"></md-input-container><md-input-container><label>\n{{\'ORGANIZATIONS.EMAIL_SENDER_ADDERSS\' | translate}}</label><input type=\"text\" ng-model=\"vm.organization.emailFrom\" \nminlength=\"2\" ng-pattern=\"/^[a-zA-Z\\d\\-\\_]+$/\" maxlength=\"70\"><strong>@sg.clubyourlife.cloud</strong>\n</md-input-container><md-input-container><md-button title=\"{{\'ORGANIZATIONS.SAVE\' | translate}}\" \nclass=\"md-raised md-accent md-fab\" ng-click=\"vm.saveOrganization()\" aria-label=\"Save\" ng-disabled=\"emailconf.$invalid\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></md-input-container></div></form>\n<hr>Come amministratore, vuoi ricevere anche la <strong>mail</strong> oltre alle notifiche nei seguenti casi?<form \nname=\"notifyadmin\"><div layout=\"row\"><div layout-gt-sm=\"column\"><md-switch \nng-model=\"vm.adminPreferences.emailOnPaymentsDone\">Avvenuti pagamenti</md-switch><md-switch \nng-model=\"vm.adminPreferences.emailOnNewSubscriptions\">Avvenute iscrizioni</md-switch><md-switch \nng-model=\"vm.adminPreferences.emailOnUserUpdates\">Aggiornamenti anagrafici</md-switch><md-switch \nng-model=\"vm.adminPreferences.emailOnCarnetCompleted\">\nScadenza carnet (al raggiungimento del massimo numero di presenze)</md-switch></div><div layout-gt-sm=\"column\">\n<md-button title=\"{{\'ORGANIZATIONS.SAVE\' | translate}}\" class=\"md-raised md-accent md-fab\" \nng-click=\"vm.saveAdminPreferences()\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button></div></div></form><hr>\nVuoi abilitare una chat di gruppo per l\'Associazione? Sarà visibile a amministratori, soci (membri) e staff, e, eventualmente, anche ai contatti\n<form name=\"notifyadmin\"><div layout=\"row\"><div layout-gt-sm=\"column\"><md-switch \nng-model=\"vm.organization.flgEnableChat\">Chat associazione</md-switch></div><div layout-gt-sm=\"column\"><md-button \ntitle=\"{{\'ORGANIZATIONS.SAVE\' | translate}}\" class=\"md-raised md-accent md-fab\" ng-click=\"vm.saveOrganization()\" \naria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div></div><div \nlayout=\"row\" ng-if=\"vm.organization.flgEnableChat\"><md-input-container><md-checkbox \nng-model=\"vm.organization.flgExtendChatToContacts\" flex>Estendi la chat di gruppo associativa anche ai CONTATTI\n</md-checkbox></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span>\n{{\'ORGANIZATIONS.SETTINGS_ADVANCED\' | translate }}</span></md-tab-label><md-tab-body><form name=\"advancedconf\"><div \nlayout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container class=\"md-block\" \nflex-gt-xs><label translate=\"ORGANIZATIONS.CYL_ID\">CubYourLife ID</label><input type=\"text\" \nng-model=\"vm.organization.clubyourlifeId\" ng-pattern=\"/^[a-zA-Z0-9]*$/\"></md-input-container><md-button \ntitle=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nng-click=\"vm.helpMe($event, \'CYL_ID\')\"><md-icon id=\"icon-help-cyl-id\" md-font-icon=\"icon-help-circle\" \nclass=\"md-primary\"></md-icon></md-button><md-input-container \nng-show=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\'\" class=\"md-block\" flex=\"20\"><label \ntranslate=\"ORGANIZATIONS.TITLE_COLOR\">Title Color</label><div md-color-picker ng-model=\"vm.organization.titleColor\">\n</div></md-input-container><md-input-container><md-button title=\"{{\'ORGANIZATIONS.SAVE\' | translate}}\" \nclass=\"md-raised md-accent md-fab\" ng-click=\"vm.saveOrganization()\" aria-label=\"Save\" ng-disabled=\"emailconf.$invalid\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></md-input-container></div><div \nlayout-gt-sm=\"row\" ng-show=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\'\"><label>\n{{\'ORGANIZATIONS.PRIVACY_POLICY_FOR_ORGANIZATION\' | translate }}:&nbsp;&nbsp;&nbsp;&nbsp;</label><md-radio-group \nng-model=\"vm.organization.privacyPolicyType\"><md-radio-button value=\"NONE\">\n{{\'ORGANIZATIONS.NO_PRIVACY_POLICY\' | translate }}</md-radio-button><md-radio-button value=\"LINK\">\n{{\'ORGANIZATIONS.PRIVACY_POLICY_LINK\' | translate }}</md-radio-button><md-radio-button value=\"HTML\">\n{{\'ORGANIZATIONS.PRIVACY_PAGE\' | translate }}</md-radio-button></md-radio-group></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\' && vm.organization.privacyPolicyType===\'LINK\'\">\n<md-input-container class=\"md-block\" flex><label>Link</label><input type=\"text\" ng-model=\"vm.organization.privacyLink\">\n</md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\' && vm.organization.privacyPolicyType===\'HTML\'\">\n<text-angular ng-model=\"vm.organization.privacyPolicy\" ta-toolbar=\"vm.taToolbar\" class=\"pb-32 edelphi-editor\">\n</text-angular></div></form></md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span>\n{{\'ORGANIZATIONS.USER_ATTRIBUTES\' | translate }}</span></md-tab-label><md-tab-body><form name=\"userAttributes\"><div \nlayout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container><md-checkbox \nng-model=\"vm.organization.flgUserDynAttributes\" flex>{{\'ORGANIZATIONS.FLG_USER_ATTRIBUTES\' | translate }}</md-checkbox>\n</md-input-container><md-button ng-if=\"!vm.organization.flgUserDynAttributes\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.saveOrganization();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button><md-button ng-if=\"vm.organization.flgUserDynAttributes\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.saveTemplate();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon>\n</md-button></div><div ng-if=\"vm.organization.flgUserDynAttributes\"><md-tabs md-dynamic-height \nmd-selected=\"selectedIndex\"><md-tab><md-tab-label>Designer</md-tab-label><md-tab-body><div layout=\"column\" \nlayout-align=\"center start\"><div ui-sortable=\"vm.sortableFieldOptions\" ng-model=\"vm.userTemplate.template.items\" flex \nlayout=\"column\" layout-wrap style=\"width: 100%\" class=\"md-blue-grey-100-bg\"><ms-widget ui-sortable-selectable flex \nng-repeat=\"item in vm.userTemplate.template.items track by $index\"><ms-widget-front class=\"padding-16\" \nstyle=\"background-color:white\"><div layout=\"row\"><md-input-container flex=\"30\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_LABEL\' | translate}}</label><input type=\"text\" ng-model=\"item.caption\" \nng-change=\"vm.calculateTemplateItemName(item)\" required=\"required\"></md-input-container><md-input-container flex=\"30\">\n<label>{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_NAME\' | translate}}</label><input type=\"text\" ng-model=\"item.name\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"20\"><label>Tipo</label><md-select \nng-model=\"item.type\"><md-option value=\"text\">{{\'ORGANIZATIONS.FORM_DESIGNER.TEXT_FIELD\' | translate}}</md-option>\n<md-option value=\"checkbox\">{{\'ORGANIZATIONS.FORM_DESIGNER.CHECKBOX\' | translate}}</md-option><md-option \nvalue=\"select\">{{\'ORGANIZATIONS.FORM_DESIGNER.COMBOBOX\' | translate}}</md-option><md-option value=\"radio\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.RADIOBUTTONS\' | translate}}</md-option><md-option value=\"label\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.LABEL\' | translate}}</md-option></md-select></md-input-container><md-input-container \nflex=\"10\"><md-button ng-click=\"vm.removeItem($index);\" class=\"md-icon-button\" aria-label=\"Add\" \ntitle=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\">\n</md-icon></md-button></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container \nflex ng-if=\"item.type!==\'label\'\"><md-checkbox ng-model=\"item.options.required\" aria-label=\"Disabled\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.REQUIRED\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if=\"item.type===\'label\'\" flex><label>Tag</label><md-select ng-model=\"item.options[\'html-tag\']\"><md-option \nvalue=\"span\"><span></span></md-option><md-option value=\"h1\"><h1>H1</h1></md-option><md-option value=\"h2\"><h2>H2</h2>\n</md-option><md-option value=\"h3\"><h3>H3</h3></md-option><md-option value=\"h4\"><h4>H4</h4></md-option><md-option \nvalue=\"h5\"><h5>H5</h5></md-option></md-select></md-input-container><md-input-container ng-if=\"item.type===\'label\'\" \nflex><label>{{\'ORGANIZATIONS.FORM_DESIGNER.COLOR\' | translate}}</label><input type=\"text\" \nng-model=\"item.options.color\"></md-input-container></div><div ng-if=\"item.type===\'select\' || item.type===\'radio\'\" \nstyle=\"margin: 10px\" flex=\"33\">{{\'ORGANIZATIONS.FORM_DESIGNER.VALUES\' | translate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n<md-button ng-click=\"vm.addChoice(item);\" class=\"md-icon-button\" title=\"Nuovo valore\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"green-500-fg\"></md-icon></md-button><div layout=\"row\" \nng-repeat=\"c in item.choices track by $index\" style=\"border: 1px solid #ddd; margin-bottom:4px\"><md-input-container \nflex=\"40\"><label>{{\'ORGANIZATIONS.FORM_DESIGNER.VALUE\' | translate}}</label><input type=\"text\" ng-model=\"c.uuid\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"40\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.DESCRIPTION\' | translate}}</label><input type=\"text\" ng-model=\"c.caption\" \nrequired=\"required\"></md-input-container><md-button ng-click=\"vm.removeChoice(item, $index);\" class=\"md-icon-button\" \naria-label=\"Add\" title=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"red-500-fg\"></md-icon></md-button></div></div></div></ms-widget-front></ms-widget></div></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.addTemplateItem()\" aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" \ntranslate=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" translate-attr-aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\">\nNew field</md-button></md-tab-body></md-tab><md-tab md-on-select=\"vm.reloadPreview()\">\n\"src/app/main/directives/dynamic-document/templates/textarea.html\"<md-tab-label>Anteprima</md-tab-label><md-tab-body>\n<div style=\"background-color: white; padding: 30px\"><dynamic-document ng-data-url=\"\" ng-template-url=\"\" \nng-stats-url=\"\" ng-save-url=\"\" on-success=\"\" on-error=\"\" ng-edit-mode=\"true\"></dynamic-document></div></md-tab-body>\n</md-tab><md-tab><md-tab-label>Sorgente JSON</md-tab-label><md-tab-body><div style=\"height: 800px\"><angular-jsoneditor \nng-model=\"vm.userTemplate.template\" options=\"vm.jsonOptions\" style=\"width: 100%; height: 800px\"></angular-jsoneditor>\n</div></md-tab-body></md-tab></md-tabs></div></form></md-tab-body></md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label>\n<span>Quote associative</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/organizations/views/organization_settings/tabs/quote-iscrizione.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span>Piano e tariffe</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/organizations/views/organization_settings/tabs/cyl-plan.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.isAdmin\"><md-tab-label><span>Utilità</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/pages/organizations/views/organization_settings/tabs/utilities.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div><div ng-if=\"vm.isAdmin ||  vm.isCreatingOrganization\" \nng-show=\"vm.selectedTabIndex === 0\" class=\"ov-floating-btn\"><md-button ng-disabled=\"orgForm.$invalid\" \ntitle=\"{{\'ORGANIZATIONS.SAVE\' | translate}}\" class=\"md-fab md-accent\" ng-click=\"vm.saveOrganization();\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/organization_welcome_page.html","<div class=\"page-layout simple white-bg md-padding\" layout=\"column\"><div class=\"content white-bg md-padding\" \nng-if=\"vm.welcomeStatus === \'WELCOME\'\"><div layout=\"row\" class=\"md-display-1\">Congratulazioni!</div><br><div \nlayout=\"row\" class=\"md-title\">Hai creato la tua nuova associazione.<br>\nPotrai successivamente modificare tutto quello che hai configurato alla voce impostazioni.<br>\nClubYourLife è gratuita fino a 50 iscritti, al raggiungimento di questa soglia potrai decidere se attivare un piano a pagamento.\n</div><br><div layout=\"row\" class=\"md-subhead\">\nNella barra in alto, alla vove \"i miei club\" trovi la tua nuova associazione. Cliccandoci sopra potrai accedere a tutte le relative funzionalità. Se vuoi aggiungere il tuo logo clicca sul pulsante \"personalizzazione\" qui sotto, puoi comunque decidere di farlo in un altro momento andando nelle impostazioni.\n</div><br><br><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" class=\"md-padding\"><md-card \nng-click=\"vm.goToOrganization();\" style=\"cursor: pointer; min-height: 200px\" flex=\"50\" \nclass=\"md-blue-500-bg md-padding\"><md-card-content><div layout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" \nlayout-align=\"start start\"><md-icon class=\"white-fg\" md-font-icon=\"icon-apps\"></md-icon>BACHECA</div><div \nstyle=\"clear: both\"></div><br><div layout=\"row\" class=\"md-subhead white-fg\">\nQuesta schermata contiene tutto il riepilogo di ciò che riguarda l\'associazione, come lo stato dei pagamenti e i documenti in scadenza.\n</div></md-card-content></md-card><md-card ng-click=\"vm.saveOrganization(\'RICEVUTE\');\" \nstyle=\"cursor: pointer; min-height: 200px\" flex=\"50\" class=\"md-blue-500-bg md-padding\"><md-card-content><div \nlayout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" layout-align=\"start start\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-cog\"></md-icon>PERSONALIZZAZIONE</div><div style=\"clear: both\"></div><br><div layout=\"row\" \nclass=\"md-subhead white-fg\">\nControlla e modifica tutti i dati della tua associazione (indirizzo, logo, immagine di sfondo, ecc.).</div>\n</md-card-content></md-card></div></div><div class=\"content white-bg md-padding\" \nng-if=\"vm.welcomeStatus === \'RICEVUTE\'\"><div layout=\"row\" class=\"md-display-1\">Ricevute e fatture</div><div \nlayout=\"row\">Imposta se vuoi emettere automaticamente ricevute e PDF per le entrate e le uscite della tua associazione\n</div><form name=\"userAttributes\"><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\">\n<md-input-container><md-checkbox ng-model=\"vm.organization.flgEnableInvoice\" flex>\n{{\'ORGANIZATIONS.FLG_ENABLE_INVOICES_RECEIPTS\' | translate }}</md-checkbox></md-input-container></div><div \nlayout=\"row\"><span flex=\"30\">{{\'ORGANIZATIONS.RECEIPTS\' | translate }}</span><md-input-container flex=\"35\" \nclass=\"margin-right-20\"><label translate=\"ORGANIZATIONS.INVOICE_NUMBER_STARTS\">Number</label><input type=\"number\" \nname=\"invoiceNumber\" ng-model=\"vm.organization.invoiceNextNumber\"><div class=\"font-size-12\">\nLasciare vuoto per far iniziare da 1 la numerazione. Altrimenti inserire il numero dell\'ultima ricevuta già emessa.\n</div></md-input-container><md-input-container flex=\"35\"><label translate=\"ORGANIZATIONS.INVOICE_SECTION\" required>\nSection</label><input type=\"text\" restrict-input=\"{type: \'lettersAndDigitsOnly\'}\" name=\"invoiceSection\" \nng-model=\"vm.organization.invoiceSection\"></md-input-container></div><div layout=\"row\"><span flex=\"30\">\n{{\'ORGANIZATIONS.CREDIT_NOTES\' | translate }}</span><md-input-container flex=\"35\" class=\"margin-right-20\"><label \ntranslate=\"ORGANIZATIONS.CREDIT_NOTE_NUMBER_STARTS\">Number</label><input type=\"number\" name=\"creditNoteNextNumber\" \nng-model=\"vm.organization.creditNoteNextNumber\"><div class=\"font-size-12\">\nLasciare vuoto per far iniziare da 1 la numerazione. Altrimenti inserire il numero dell\'ultima nota già emessa.</div>\n</md-input-container><md-input-container flex=\"35\"><label translate=\"ORGANIZATIONS.INVOICE_SECTION\" required>Section\n</label><input type=\"text\" restrict-input=\"{type: \'lettersAndDigitsOnly\'}\" name=\"creditNoteSection\" \nng-model=\"vm.organization.creditNoteSection\"></md-input-container></div><div layout=\"column\" flex=\"80\">\n<md-input-container><label translate=\"ORGANIZATIONS.INVOICE_HEADER\">HEADER</label><textarea \nng-model=\"vm.organization.invoiceHeader\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.saveOrganization(\'WELCOME\');\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>\nIndietro</md-button><span><md-icon class=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle\"></md-icon>\n<md-icon class=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon \nclass=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></span><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.saveOrganization(\'LOGHI\');\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold\"></md-icon>Avanti</md-button></div></form></div><div layout=\"column\" \nclass=\"content white-bg md-padding\" ng-if=\"vm.welcomeStatus === \'LOGHI\'\"><div layout=\"row\" class=\"md-display-1\">\nLogo e sfondo</div><br><div layout=\"row\">\nIl logo della tua associazione comparirà nelle ricevute. Il logo e lo sfondo compariranno nelle eventuali pagine pubbliche di iscrizione ai servizi che la tua associazione eroga, e in eventuali pagine di login personalizzate\n</div><br><br><br><br><div layout=\"column\" ng-if=\"vm.isAdmin\"><div layout=\"row\" class=\"md-subhead\">\nIl logo deve essere una immagine in formato jpeg o png. Si consiglia una immagine quadrata.</div><div layout=\"row\" \nlayout-align=\"start center\"><div style=\"float: left; border: none\" class=\"product-image\" hide-xs \nng-if=\"vm.organization.uriLogo && vm.organization.uriLogo!==null && vm.organization.uriLogo!==\'\'\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div><div id=\"document-logo-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flowLogo\" \nflow-files-submitted=\"vm.upload(\'LOGO\')\" flow-file-added=\"vm.fileAdded($file, \'LOGO\')\" \nflow-file-success=\"vm.fileSuccess($file, $message, \'LOGO\')\" flow-file-error=\"vm.fileError( $file, $message, $flow )\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" id=\"logo-uploader\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn><md-icon md-font-icon=\"icon-upload\">\n</md-icon>{{\'ORGANIZATIONS.LOGO\' | translate }}</md-button></div></div><md-button \nng-enabled=\"vm.organization.uriLogo && vm.organization.uriLogo!==null\" ng-click=\"vm.removeLogo()\">\n{{\'ORGANIZATIONS.DELETE\' | translate}} {{\'ORGANIZATIONS.LOGO\' | translate}}</md-button></div><br><br><br><br><div \nlayout=\"row\" class=\"md-subhead\">\nLo sfondo deve essere una immagine in formato jpeg o png. Si consiglia una immagine di dimensioni approssimative 1000 x 500 px.\n</div><div layout=\"row\" layout-align=\"start center\"><div style=\"float: left; border: none\" class=\"w-150\" hide-xs \nng-if=\"vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage!==null && vm.organization.uriBackgroundImage!==\'\'\">\n<img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriBackgroundImage }}\">\n</div><div id=\"document-background-uploader\" ng-if=\"!vm.isCreatingOrganization\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flowBackground\" flow-files-submitted=\"vm.upload(\'BACKGROUND\')\" \nflow-file-added=\"vm.fileAdded($file, \'BACKGROUND\')\" flow-file-success=\"vm.fileSuccess($file, $message, \'BACKGROUND\')\" \nflow-file-error=\"vm.fileError( $file, $message, $flow )\" flow-complete=\"vm.uploadComplete()\"><div \nclass=\"upload-button\" id=\"background-uploader\" layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" flow-btn><md-icon md-font-icon=\"icon-upload\"></md-icon>\n{{\'ORGANIZATIONS.BACKGROUND\' | translate }}</md-button></div></div><md-button \nng-enabled=\"vm.organization.uriBackgroundImage && vm.organization.uriBackgroundImage!==null\" \nng-click=\"vm.removeBackground()\">{{\'ORGANIZATIONS.DELETE\' | translate}} {{\'ORGANIZATIONS.BACKGROUND\' | translate}}\n</md-button></div></div><br><br><br><br><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.saveOrganization(\'RICEVUTE\');\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\"></md-icon>Indietro</md-button><span><md-icon class=\"md-raised md-accent\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon class=\"md-raised md-accent\" \nmd-font-icon=\"icon-checkbox-blank-circle\"></md-icon><md-icon class=\"md-raised md-accent\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></span><md-button class=\"md-accent md-raised\" \nng-click=\"vm.saveOrganization(\'CYL_ID\');\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon>\nAvanti</md-button></div></div><div class=\"content white-bg md-padding\" ng-if=\"vm.welcomeStatus === \'CYL_ID\'\"><div \nclass=\"md-display-1\">{{\'ORGANIZATIONS.CYL_ID\' | translate}}</div><div>\nSpecifica un Identificativo ClubYourLife per dare alla tua associazione un indirizzo web personalizzato come <b>\nhttps://app.clubyourlife.cloud/pages/auth/<span class=\"red-fg\">\n{{ (vm.organization.clubyourlifeId) ? (vm.organization.clubyourlifeId + \'\') : \'LaMiaAssociazione\'}}</span>/login</b>.\n<br>Specificandolo inoltre possibile configurare la privacy policy specifica della tua associazione</div><br><br><form \nname=\"advancedconf\"><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex-gt-xs><label translate=\"ORGANIZATIONS.CYL_ID\">CubYourLife ID</label><input type=\"text\" \nng-model=\"vm.organization.clubyourlifeId\" restrict-input=\"{type: \'lettersAndDigitsOnly\'}\" lowercase=\"\">\n</md-input-container><md-input-container \nng-show=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\'\" class=\"md-block\" flex=\"20\"><label \ntranslate=\"ORGANIZATIONS.TITLE_COLOR\">Title Color</label><div md-color-picker ng-model=\"vm.organization.titleColor\">\n</div></md-input-container></div><div class=\"md-display-1\">Privacy Policy</div><div>Inserisci la tua privacy policy\n</div><div layout-gt-sm=\"row\"><label>\n{{\'ORGANIZATIONS.PRIVACY_POLICY_FOR_ORGANIZATION\' | translate }}:&nbsp;&nbsp;&nbsp;&nbsp;</label><md-radio-group \nng-model=\"vm.organization.privacyPolicyType\" ng-disabled=\"!vm.organization.clubyourlifeId\"><md-radio-button \nvalue=\"NONE\">{{\'ORGANIZATIONS.NO_PRIVACY_POLICY\' | translate }}</md-radio-button><md-radio-button value=\"LINK\">\n{{\'ORGANIZATIONS.PRIVACY_POLICY_LINK\' | translate }}</md-radio-button><md-radio-button value=\"HTML\">\n{{\'ORGANIZATIONS.PRIVACY_PAGE\' | translate }}</md-radio-button></md-radio-group></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\' && vm.organization.privacyPolicyType===\'LINK\'\">\n<md-input-container class=\"md-block\" flex><label>Link</label><input type=\"text\" ng-model=\"vm.organization.privacyLink\">\n</md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.organization.clubyourlifeId && vm.organization.clubyourlifeId!==\'\' && vm.organization.privacyPolicyType===\'HTML\'\">\n<text-angular ng-model=\"vm.organization.privacyPolicy\" ta-toolbar=\"vm.taToolbar\" class=\"pb-32 edelphi-editor\">\n</text-angular></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.saveOrganization(\'LOGHI\');\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>\nIndietro</md-button><span><md-icon class=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle-outline\">\n</md-icon><md-icon class=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-icon \nclass=\"md-raised md-accent\" md-font-icon=\"icon-checkbox-blank-circle\"></md-icon></span><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.saveOrganization(\'CYL_ID\'); vm.goToOrganization();\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold\"></md-icon>Avanti</md-button></div></form></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_startpage/organization_startpage.html","<div id=\"page-organization-startpage\" class=\"page-layout carded fullwidth flex-scrollable\" ms-scroll \nng-init=\"vm.init();\"><div class=\"content center\" flex><ov-navigation-bar organization-id=\"{{ vm.organizationId }}\" \nselected-page=\"ORGANIZATION\"></ov-navigation-bar><div layout=\"column\" flex><div layout=\"row\"><md-card flex=\"100\" \nflex-gt-sm=\"25\" ng-click=\"vm.gotoMemberships(vm.organizationId);\" class=\"ov-cursor-pointer\"><md-card-header><div \nlayout=\"row\"><span><md-icon md-font-icon=\"icon-account-multiple\" class=\"s48\"></md-icon></span><span \nclass=\"ml-16 md-headline\">Soci</span></div></md-card-header><md-card-content><p>Elenco e gestione tesserati</p>\n</md-card-content></md-card><md-card flex=\"100\" flex-gt-sm=\"25\" ng-click=\"vm.gotoServices(vm.organizationId);\" \nclass=\"ov-cursor-pointer\"><md-card-header><div layout=\"row\"><span><md-icon md-font-icon=\"icon-calendar-multiple\" \nclass=\"s48\"></md-icon></span><span class=\"ml-16 md-headline\">Servizi</span></div></md-card-header><md-card-content><p>\nGestione dei servizi offerti dalla società</p></md-card-content></md-card><md-card flex=\"100\" flex-gt-sm=\"25\" \nng-click=\"vm.gotoCarnet(vm.organizationId);\" class=\"ov-cursor-pointer\"><md-card-header><div layout=\"row\"><span><md-icon\n md-font-icon=\"icon-tag-multiple\" class=\"s48\"></md-icon></span><span class=\"ml-16 md-headline\">Carnet</span></div>\n</md-card-header><md-card-content><p>Getione dei carnet offerti dalla società</p></md-card-content></md-card><md-card \nflex=\"100\" flex-gt-sm=\"25\" ng-click=\"vm.gotoEvents(vm.organizationId);\" class=\"ov-cursor-pointer\"><md-card-header><div \nlayout=\"row\"><span><md-icon md-font-icon=\"icon-calendar-check\" class=\"s48\"></md-icon></span><span \nclass=\"ml-16 md-headline\">Eventi</span></div></md-card-header><md-card-content><p>Gestione eventi</p></md-card-content>\n</md-card></div><div layout=\"row\"><md-card flex=\"100\" flex-gt-sm=\"25\" ng-click=\"vm.gotoResources(vm.organizationId);\" \nclass=\"ov-cursor-pointer\"><md-card-header><div layout=\"row\"><span><md-icon md-font-icon=\"icon-package\" class=\"s48\">\n</md-icon></span><span class=\"ml-16 md-headline\">Risorse</span></div></md-card-header><md-card-content><p>\nRisorse della società: materiali, ambienti, istruttori, ...</p></md-card-content></md-card><md-card flex=\"100\" \nflex-gt-sm=\"25\" ng-click=\"vm.gotoEarningCosts(vm.organizationId);\" class=\"ov-cursor-pointer\"><md-card-header><div \nlayout=\"row\"><span><md-icon md-font-icon=\"icon-coin\" class=\"s48\"></md-icon></span><span class=\"ml-16 md-headline\">Cassa\n</span></div></md-card-header><md-card-content><p>Gestione movimenti di cassa</p></md-card-content></md-card><md-card \nflex=\"100\" flex-gt-sm=\"25\" ng-click=\"vm.gotoSettings(vm.organizationId);\" class=\"ov-cursor-pointer\"><md-card-header>\n<div layout=\"row\"><span><md-icon md-font-icon=\"icon-cog\" class=\"s48\"></md-icon></span><span class=\"ml-16 md-headline\">\nImpostazioni</span></div></md-card-header><md-card-content><p>Preferenze ed impostazioni</p></md-card-content>\n</md-card><md-card flex=\"100\" flex-gt-sm=\"25\" class=\"ov-card-flat\"></md-card></div></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organizations/organizations.html","<div id=\"page-organizations\" class=\"page-organizations page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg\" \nstyle=\"background-image: none\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-shield\"></md-icon><span \ntranslate=\"ORGANIZATIONS.ORGANIZATIONS\">Organizations</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"ORGANIZATIONS.TOTAL_ORGANIZATIONS\">Total organizations:</span> <span>{{vm.organizations.length}}</span>\n</div></div></div><div layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nng-if=\"vm.organizations.length < 1\"><div class=\"elenco-associazioni__singola\" style=\"min-width: 330px\"><div \nid=\"btn-organization-nuova\" class=\"elenco-associazioni__singola__link\" ng-click=\"vm.goToNewOrganization();\"><h3 \nstyle=\"line-height: 1.2; margin-bottom: 15px\" class=\"ng-binding\">Crea la tua prima associazione</h3><h4>\nL\'associazione comparirà in questa pagina. Potrai in futuro crearne di nuove cliccando sul pulsante \"+\" in basso a destra.\n</h4></div></div></div><div class=\"elenco-associazioni\"><div class=\"elenco-associazioni__singola\" \nng-repeat=\"org in vm.organizations\"><div id=\"btn-organization-{{ org.id }}\" class=\"elenco-associazioni__singola__link\" \nng-click=\"vm.goToOrganizationDetail(org.id);\"><h3>{{org.name}}</h3><h4>{{org.description}}</h4></div><div \nng-if=\"!org.isAdmin\"></div><div class=\"elenco-associazioni__singola__cancella\" \nng-click=\"vm.deleteOrganization(org.id);\" ng-if=\"org.isAdmin\"><md-button id=\"btn-delete-organization-{{ org.id }}\" \nclass=\"md-icon-button md-button md-raised md-warn md-hue-2\"><md-icon md-font-icon=\"icon-delete\" \ntitle=\"{{\'ORGANIZATIONS.DELETE\' | translate}}\" style=\"cursor: pointer\"></md-icon></md-button></div></div><div \nclass=\"clearfix\"></div></div><div id=\"btn-organization-add\" class=\"actions elenco-associazioni__aggiungi\" layout=\"row\" \nlayout-align=\"end end\"><md-button class=\"md-fab md-raised md-accent\" ng-click=\"vm.goToNewOrganization();\" \naria-label=\"Add\" title=\"{{\'ORGANIZATIONS.NEW\' | translate }}\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/privacy_page/organization_privacy.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-blue-grey-50-bg\" \nlayout=\"row\" layout-align=\"space-between\" ng-style=\"vm.backgroundImage()\" flex><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><div style=\"float: left; border: none\" class=\"product-image\" hide-xs \nng-if=\"vm.organization.uriLogo && vm.organization.uriLogo!==null && vm.organization.uriLogo!==\'\'\"><img \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.organization.id }}/download/{{vm.organization.uriLogo }}\">\n</div>{{vm.organization.name}} - Privacy policy</div></div></div><div class=\"content\"><div class=\"md-padding\" \nng-bind-html=\"vm.trustedHtml\"></div></div></div>");
$templateCache.put("app/main/pages/offered_services/views/new_carnet/new_carnet.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><div layout=\"row\" \nlayout-align=\"end center\"><ov-navigation-bar class=\"menu-in-sottopagina\" organization-id=\"{{vm.organization.id}}\" \nselected-page=\"CARNET\"></ov-navigation-bar></div><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n1</span> <span class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHAT\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Nome e descrizione</h3><h4>\nStai creando un nuovo servizio ad ingressi (carnet). Puoi associarlo ad uno o più servizi tra quelli che proponi.</h4>\n<h4 class=\"titolo-blocco-contenuto\">\nQueste informazioni possono essere mostrate anche a chi sta cercando servizi come i tuoi ma ancora non ti conosce. Se usi un nome chiaro (ad es. \"Carnet 10 ingressi palestra e solarium\") e aggiungi una descrizione avrai più possibilità di aumentare gli iscritti.\n</h4><md-input-container class=\"md-block\"><label translate=\"OFFERED_SERVICES.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.offeredService.name\" required></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"OFFERED_SERVICES.DESCRIPTION\">Description</label><textarea ng-model=\"vm.offeredService.description\" \nmd-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\" md-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">2</span> <span \nclass=\"ms-form-wizard-step-text\">Accessi</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" class=\"contenitore-pagina-padding-e-ombra\">\n<h3 class=\"titolo-blocco-contenuto\">Modalità di erogazione</h3><md-input-container class=\"md-block\"><label \ntranslate=\"OFFERED_SERVICES.NUM_ACCESS\">Number of accesses</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.numMaxAccess\" ng-required=\"vm.offeredService.scheduleType===\'A\' \"></md-input-container>\n<md-input-container><span>Seleziona i servizi accessibili con questo carnet</span>:<div \nng-repeat=\"servizioChild in vm.serviziChildAttivabili\"><md-checkbox ng-model=\"vm.childServiceToAdd[servizioChild.id]\" \nflex>{{servizioChild.name }} <span ng-show=\"servizioChild.needsOrganizationSubscription\">- <cite>\nNecessita di quota associativa</cite></span></md-checkbox></div></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n3</span> <span class=\"ms-form-wizard-step-text\">\n{{(vm.offeredService.standalone==\'S\' ? \'OFFERED_SERVICES.SUBSCRIPTIONS\':\'OFFERED_SERVICES.PRICE\') | translate}}</span>\n</span></md-tab-label><md-tab-body><form name=\"wizardStep3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\"><div class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nImposta il piano di pagamento principale</h3><h4 class=\"titolo-blocco-contenuto\">In questa fase stai inserendo la \n<strong>modalità di pagamento standard</strong>\n per questo servizio. Alla fine del processo di creazione potrai aggiungere <strong>altri piani di pagamento</strong>\n per personalizzarlo ulteriormente.</h4><md-input-container flex=\"100\" class=\"ov-width-100perc\"><md-select required \nng-model=\"vm.offeredService.paymentType\" ng-change=\"vm.changePaymentType()\"><md-option value=\"F\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option><md-option value=\"O\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" \nng-if=\"vm.offeredService.scheduleType!==\'A\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select>\n</md-input-container></div><div class=\"contenitore-pagina-padding-e-ombra\" \nng-show=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"><md-input-container \nng-show=\"vm.offeredService.paymentType===\'R\'\"><label translate=\"OFFERED_SERVICES.RENEWAL\">Renewal</label><md-select \nng-required=\"vm.offeredService.paymentType===\'R\' \" ng-model=\"vm.offeredService.paymentRenewInterval\"><md-option \nvalue=\"day\">{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option><md-option value=\"month\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"year\">{{\'OFFERED_SERVICES.YEAR\' | translate}}\n</md-option><md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</md-option><md-option value=\"2-month\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option value=\"3-month\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label>Numero di rate</label><input type=\"number\" \nmin=\"1\" ng-model=\"vm.offeredService.numMaxRenewal\"><div class=\"font-size-12\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</div><div class=\"font-size-12\" ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n<strong>Totale</strong>: <span ng-if=\"vm.offeredService.subscriptionPrice > 0\">\nIscrizione {{vm.offeredService.subscriptionPrice}} Euro</span> <span \nng-if=\"vm.offeredService.subscriptionPrice > 0 && vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n+ </span><span ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n{{vm.offeredService.numMaxRenewal}} Rate x {{vm.offeredService.renewalPrice}} Euro </span>= <strong>\n{{ (vm.offeredService.subscriptionPrice ? vm.offeredService.subscriptionPrice : 0 ) + (vm.offeredService.numMaxRenewal * (vm.offeredService.renewalPrice ? vm.offeredService.renewalPrice : 0 ) )}} Euro\n</strong></div></md-input-container><md-input-container class=\"md-block\" \nng-show=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIPTION_PRICE\">Subscription price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.subscriptionPrice\" \nng-required=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label \ntranslate=\"OFFERED_SERVICES.RENEWAL_PRICE\">Renewal price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.renewalPrice\" ng-required=\"vm.offeredService.paymentType===\'R\' \"></md-input-container>\n</div><md-input-container ng-if=\"vm.offeredService.standalone==\'S\'\" class=\"contenitore-pagina-padding-e-ombra\"><h3 \nclass=\"titolo-blocco-contenuto\">Documenti richiesti</h3><div ng-repeat=\"doctype in vm.organizationDoctypes\">\n<md-checkbox ng-model=\"vm.selecteDoctypeIds[doctype.id]\" aria-label=\"Enable chat\" flex>{{doctype.name}}</md-checkbox>\n</div></md-input-container><md-input-container \nng-hide=\"vm.isSubscriptionService || (vm.scheduleType === \'A\' && vm.offeredService.includeMoreServices === \'Y\')\" \nclass=\"contenitore-pagina-padding-e-ombra\"><md-checkbox ng-model=\"vm.offeredService.needsOrganizationSubscription\" \nflex>{{\'OFFERED_SERVICES.NEEDS_ORGANIZATION_SUBSCRIPTION\' | translate}}</md-checkbox></md-input-container>\n<md-input-container \nng-hide=\"vm.isSubscriptionService || vm.scheduleType === \'A\' || vm.offeredService.includeMoreServices === \'Y\'\" \nclass=\"contenitore-pagina-padding-e-ombra\"><md-checkbox ng-model=\"vm.offeredService.enableAttendances\" flex>\nAbilita la gestione delle presenze su questo servizio</md-checkbox></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.offeredService.standalone==\'S\'\" \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid  || wizardStep3.$invalid\" \nmd-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\">4</span> <span \nclass=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.COMUNICATIONS\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Messaggi e chat</h3><h4 \nclass=\"titolo-blocco-contenuto\">{{\'OFFERED_SERVICES.HINT.CHAT_TYPE\' | translate}}</h4><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container><md-checkbox ng-model=\"vm.offeredService.hasChat\" \naria-label=\"Enable chat\" flex>{{\'OFFERED_SERVICES.ENABLE_MESSAGES\' | translate}}</md-checkbox></md-input-container>\n&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container ng-show=\"vm.offeredService.hasChat\"><label \ntranslate=\"OFFERED_SERVICES.MESSAGE_TYPES\" required>Message type</label><md-select \nng-model=\"vm.offeredService.chatType\" ng-change=\"changeTypeCode()\"><md-option value=\"N\">\n{{\'OFFERED_SERVICES.NOTIFICATIONS\' | translate}}</md-option><md-option value=\"G\">\n{{\'OFFERED_SERVICES.GROUP_CHAT\' | translate}}</md-option><md-option value=\"B\">\n{{\'OFFERED_SERVICES.BROADCAST_CHAT\' | translate}}</md-option></md-select></md-input-container></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"!vm.offeredService.id\" md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep5.$invalid\">5</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep5.$valid\">\n5</span> <span class=\"ms-form-wizard-step-text\">FINE</span></span></md-tab-label><md-tab-body><form name=\"wizardStep5\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" layout-align=\"center\" flex=\"100\" \nclass=\"md-title\">La creazione del servizio è stata effettuata correttamente</div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" class=\"md-padding\"><md-card ng-click=\"vm.gotoOfferedService()\" \nstyle=\"cursor: pointer; min-height: 200px\" flex=\"50\" class=\"md-teal-500-bg md-padding\"><md-card-content><div \nlayout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" layout-align=\"start start\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-calendar-multiple\"></md-icon>Vai al servizio</div><div style=\"clear: both\"></div><br><div \nlayout=\"row\" class=\"md-subhead white-fg\">Vai alla pagina di gestione del servizio</div></md-card-content></md-card>\n<md-card ng-click=\"vm.gotoPianiPagamento()\" style=\"cursor: pointer; min-height: 200px\" flex=\"50\" \nclass=\"md-teal-500-bg md-padding\"><md-card-content><div layout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" \nlayout-align=\"start start\"><md-icon class=\"white-fg\" md-font-icon=\"icon-cash-multiple\"></md-icon>\nAggiungi piani di pagamento</div><div style=\"clear: both\"></div><br><div layout=\"row\" class=\"md-subhead white-fg\">\nCrea nuove modalità con cui far pagare le iscrizioni al servizio.</div></md-card-content></md-card></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-fab\" ng-click=\"msWizard.previousStep()\" \nng-hide=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex > 3) ||  (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex > 2)\" \nng-class=\"msWizard.isFirstStep() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.isFirstStep();\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"steps\" ng-show=\"!vm.offeredService.id\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-fab\" ng-click=\"msWizard.nextStep()\" \nng-hide=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex >= 3) || (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex >= 2)\" \nng-class=\"msWizard.currentStepInvalid() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.currentStepInvalid();\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-raised md-fab\" ng-click=\"vm.saveOfferedService();\" \nng-show=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex=== 3) ||  (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex=== 2)\" \nng-class=\"msWizard.formsIncomplete() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.formsIncomplete();\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/offered_services/views/new_offered_service/new_event.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><div layout=\"row\" \nlayout-align=\"end center\"><ov-navigation-bar class=\"menu-in-sottopagina\" organization-id=\"{{vm.organization.id}}\" \nselected-page=\"EVENTS\"></ov-navigation-bar></div><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n1</span> <span class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHAT\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Nome e descrizione</h3><h4 \nclass=\"titolo-blocco-contenuto\">\nQueste informazioni possono essere mostrate anche a chi sta cercando eventi come i tuoi ma ancora non ti conosce. Se usi un nome chiaro (ad es. \"Partecipazione ai campionati nazionali di karate\") e aggiungi una descrizione avrai più possibilità di aumentare gli iscritti.\n</h4><md-input-container class=\"md-block\"><label translate=\"OFFERED_SERVICES.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.offeredService.name\" required></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"OFFERED_SERVICES.DESCRIPTION\">Description</label><textarea ng-model=\"vm.offeredService.description\" \nmd-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\" md-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">2</span> <span \nng-if=\"vm.serviceType===\'SERVICE\'\" class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHEN_HOW\' | translate}}</span> \n<span ng-if=\"vm.serviceType===\'EVENT\'\" class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHEN_WHERE\' | translate}}\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"column\" class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nModalità di erogazione</h3><md-input-container><label translate=\"OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE\">Schedule type\n</label><md-select required ng-model=\"vm.offeredService.scheduleType\" ng-change=\"changeTypeCode()\"><md-option \nvalue=\"R\">{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND\' | translate}}</md-option><md-option value=\"P\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_IN_PERIOD\' | translate}}</md-option><md-option value=\"D\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_SINGLE_DATE\' | translate}}</md-option></md-select></md-input-container>\n<md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nng-click=\"vm.showHintScheduleType=!vm.showHintScheduleType\"><md-icon id=\"icon-help-chat-type\" \nmd-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button><div class=\"md-yellow-100-bg md-padding\" \nstyle=\"margin:20px\" ng-show=\"vm.showHintScheduleType\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s36 ml-16\"></md-icon>{{\'OFFERED_SERVICES.HINT.SCHEDULE_TYPE\' | translate}}</div><md-datepicker \nng-show=\"vm.offeredService.scheduleType===\'P\' || vm.offeredService.scheduleType===\'D\'\" \nng-required=\"vm.offeredService.scheduleType===\'P\' || vm.offeredService.scheduleType===\'D\'\" \nng-model=\"vm.offeredService.start\" \nmd-placeholder=\"{{ ( vm.offeredService.scheduleType===\'D\') ? (\'OFFERED_SERVICES.DATE_ON\' | translate) : (\'OFFERED_SERVICES.START\' | translate) }}\">\n</md-datepicker><md-datepicker ng-show=\"vm.offeredService.scheduleType===\'P\'\" \nng-required=\"vm.offeredService.scheduleType===\'P\'\" md-min-date=\"vm.offeredService.start\" \nng-model=\"vm.offeredService.end\" md-placeholder=\"{{ \'OFFERED_SERVICES.END\' | translate }}\"></md-datepicker><div \nlayout=\"row\" div class=\"md-inline-form\" ng-show=\"vm.offeredService.scheduleType===\'D\'\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top:1.5em;   padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_FROM\" \nng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input ng-required=\"vm.offeredService.scheduleType===\'D\'\" \nng-model=\"vm.offeredService.hourFrom\" ng-change=\"vm.changeHourFrom()\" type=\"number\" min=\"0\" max=\"23\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_FROM\' | translate }}\"></md-input-container><md-input-container>\n<label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_FROM\" ng-required=\"vm.offeredService.scheduleType===\'D\'\"></label>\n<input ng-required=\"vm.offeredService.scheduleType===\'D\'\" ng-model=\"vm.offeredService.minutesFrom\" type=\"number\" \nmin=\"0\" max=\"59\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_FROM\' | translate }}\"></md-input-container>\n</div><div layout=\"row\" div class=\"md-inline-form\" ng-show=\"vm.offeredService.scheduleType===\'D\'\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_END\" style=\"padding-top:1.5em;     padding-right: 1em\">End</label><md-input-container>\n<label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_TO\" ng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input\n ng-required=\"vm.offeredService.scheduleType===\'D\'\" ng-model=\"vm.offeredService.hourTo\" ng-change=\"vm.changeHourTo()\" \ntype=\"number\" min=\"0\" max=\"23\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_TO\' | translate }}\">\n</md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_TO\" \nng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input ng-required=\"vm.offeredService.scheduleType===\'D\'\" \nng-model=\"vm.offeredService.minutesTo\" type=\"number\" min=\"0\" max=\"59\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_TO\' | translate }}\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Location</label><input type=\"text\" \nng-model=\"vm.offeredService.address\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><md-button \ntitle=\"{{\'OFFERED_SERVICES.FIND_ADDRESS\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.updateLocationFromAddress()\" aria-label=\"Update location\"><md-icon md-font-icon=\"icon-map-marker-radius\" \nclass=\"md-primary\"></md-icon></md-button></md-input-container></div><div layout-gt-sm=\"row\"><fieldset \nclass=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\">Google Maps</div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.offeredService.latitude ? vm.offeredService.latitude : 41.8919300}}\"> <input type=\"hidden\" \nclass=\"gllpLongitude\" value=\"{{vm.offeredService.longitude ? vm.offeredService.longitude : 12.5113300 }}\"> <input \ntype=\"hidden\" class=\"gllpZoom\" value=\"6\"></fieldset></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><md-button title=\"{{\'OFFERED_SERVICES.UPDATE_LOCATION\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.updateLocationFromMap()\" aria-label=\"Update location\"><md-icon \nmd-font-icon=\"icon-map\" class=\"md-primary\"></md-icon></md-button><span style=\"font-size: 75%\">\n{{\'OFFERED_SERVICES.UPDATE_LOCATION_FROM_MAP\' | translate }}</span></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"OFFERED_SERVICES.LATITUDE\">Latitude</label><input type=\"text\" \nng-model=\"vm.offeredService.latitude\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"OFFERED_SERVICES.LONGITUDE\">Longitude</label><input type=\"text\" ng-model=\"vm.offeredService.longitude\">\n</md-input-container></div></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" md-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">3</span> <span \nclass=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.SUBSCRIPTIONS\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\"><div \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Imposta il piano di pagamento principale\n</h3><h4 class=\"titolo-blocco-contenuto\">Inserisci la <strong>modalità di pagamento standard</strong>\n per questo evento. Potrai aggiungere successivamente <strong>altri piani di pagamento</strong>.</h4>\n<md-input-container flex=\"100\" class=\"ov-width-100perc\"><md-select required ng-model=\"vm.offeredService.paymentType\" \nng-change=\"vm.changePaymentType()\"><md-option value=\"F\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option>\n<md-option value=\"O\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option></md-select></md-input-container>\n</div><md-input-container class=\"md-block\" ng-show=\"vm.offeredService.paymentType === \'O\'\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIPTION_PRICE\">Subscription price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.subscriptionPrice\" ng-required=\"vm.offeredService.paymentType === \'O\'\">\n</md-input-container><md-input-container><md-checkbox ng-model=\"vm.offeredService.enableAttendances\" flex>\nAbilita la gestione delle presenze su questo evento</md-checkbox></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid  || wizardStep3.$invalid\" \nmd-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\">4</span> <span \nclass=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.COMUNICATIONS\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Messaggi e chat</h3><h4 \nclass=\"titolo-blocco-contenuto\">{{\'OFFERED_SERVICES.HINT.CHAT_TYPE\' | translate}}</h4><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container><md-checkbox ng-model=\"vm.offeredService.hasChat\" \naria-label=\"Enable chat\" flex>{{\'OFFERED_SERVICES.ENABLE_MESSAGES\' | translate}}</md-checkbox></md-input-container>\n&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container ng-show=\"vm.offeredService.hasChat\"><label \ntranslate=\"OFFERED_SERVICES.MESSAGE_TYPES\" required>Message type</label><md-select \nng-model=\"vm.offeredService.chatType\" ng-change=\"changeTypeCode()\"><md-option value=\"N\">\n{{\'OFFERED_SERVICES.NOTIFICATIONS\' | translate}}</md-option><md-option value=\"G\">\n{{\'OFFERED_SERVICES.GROUP_CHAT\' | translate}}</md-option><md-option value=\"B\">\n{{\'OFFERED_SERVICES.BROADCAST_CHAT\' | translate}}</md-option></md-select></md-input-container></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"!vm.offeredService.id\" md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep5.$invalid\">5</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep5.$valid\">\n5</span> <span class=\"ms-form-wizard-step-text\">FINE</span></span></md-tab-label><md-tab-body><form name=\"wizardStep5\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" layout-align=\"center\" flex=\"100\" \nclass=\"md-title\">La creazione dell\'evento è stata effettuata correttamente</div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" class=\"md-padding\"><md-card ng-click=\"vm.gotoOfferedService()\" \nstyle=\"cursor: pointer; min-height: 200px\" flex=\"50\" class=\"md-blue-500-bg md-padding\"><md-card-content><div \nlayout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" layout-align=\"start start\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-calendar-multiple\"></md-icon>Vai all\'evento</div><div style=\"clear: both\"></div><br><div \nlayout=\"row\" class=\"md-subhead white-fg\">Vai alla pagina di gestione dell\'evento creato</div></md-card-content>\n</md-card><md-card ng-click=\"vm.gotoPianiPagamento()\" style=\"cursor: pointer; min-height: 200px\" flex=\"50\" \nclass=\"md-blue-500-bg md-padding\"><md-card-content><div layout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" \nlayout-align=\"start start\"><md-icon class=\"white-fg\" md-font-icon=\"icon-cash-multiple\"></md-icon>\nAggiungi piani di pagamento</div><div style=\"clear: both\"></div><br><div layout=\"row\" class=\"md-subhead white-fg\">\nCrea nuove modalità con cui far pagare le iscrizioni all\'evento.</div></md-card-content></md-card></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-fab\" ng-click=\"msWizard.previousStep()\" ng-show=\"!vm.offeredService.id\" \nng-class=\"msWizard.isFirstStep() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.isFirstStep()\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"steps\" ng-show=\"!vm.offeredService.id\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-fab\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.selectedIndex >= 3\" \nng-class=\"msWizard.currentStepInvalid() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.currentStepInvalid()\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-raised md-fab\" ng-click=\"vm.saveOfferedService();\" \nng-hide=\"msWizard.selectedIndex != 3\" ng-class=\"msWizard.formsIncomplete() ? \'\' : \'md-accent\'\" \nng-disabled=\"msWizard.formsIncomplete()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon>\n</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/offered_services/views/new_offered_service/new_offered_service.html","<div id=\"newservice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><div layout=\"row\" \nlayout-align=\"end center\"><ov-navigation-bar class=\"menu-in-sottopagina\" organization-id=\"{{vm.organization.id}}\" \nselected-page=\"SERVICES\"></ov-navigation-bar></div><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n1</span> <span class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHAT\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Nome e descrizione</h3><h4 \nclass=\"titolo-blocco-contenuto\">\nQueste informazioni possono essere mostrate anche a chi sta cercando servizi come i tuoi ma ancora non ti conosce. Se usi un nome chiaro (ad es. \"Corso di karate per bambini e ragazzi\") e aggiungi una descrizione avrai più possibilità di aumentare gli iscritti.\n</h4><md-input-container class=\"md-block\"><label translate=\"OFFERED_SERVICES.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.offeredService.name\" required></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"OFFERED_SERVICES.DESCRIPTION\">Description</label><textarea ng-model=\"vm.offeredService.description\" \nmd-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\" md-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">2</span> <span \nng-if=\"vm.serviceType===\'SERVICE\'\" class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHEN_HOW\' | translate}}</span> \n<span ng-if=\"vm.serviceType===\'EVENT\'\" class=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.WHEN_WHERE\' | translate}}\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div layout=\"column\" class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nModalità di erogazione</h3><md-input-container><label translate=\"OFFERED_SERVICES.IS_STANDALONE_QUESTION\">Is standalone\n</label><md-select required ng-model=\"vm.offeredService.standalone\" ng-change=\"vm.changeStandalone()\"><md-option \nvalue=\"S\">{{\'OFFERED_SERVICES.IS_STANDALONE\' | translate}}</md-option><md-option value=\"N\">\n{{\'OFFERED_SERVICES.IS_NOT_STANDALONE\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"vm.offeredService.standalone===\'S\'\"><label translate=\"OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE\">Schedule type\n</label><md-select ng-required=\"vm.offeredService.standalone===\'S\'\" ng-model=\"vm.offeredService.scheduleType\">\n<md-option value=\"R\">{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND\' | translate}}</md-option><md-option \nvalue=\"P\">{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_IN_PERIOD\' | translate}}</md-option><md-option value=\"D\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_SINGLE_DATE\' | translate}}</md-option></md-select></md-input-container>\n<md-button ng-show=\"vm.offeredService.standalone===\'S\'\" title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" \nclass=\"md-icon-button md-accent\" ng-click=\"vm.showHintScheduleType=!vm.showHintScheduleType\"><md-icon \nid=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button><div \nclass=\"md-yellow-100-bg md-padding\" style=\"margin:20px\" \nng-show=\"vm.showHintScheduleType && vm.offeredService.standalone===\'S\'\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s36 ml-16\"></md-icon>\n{{\'OFFERED_SERVICES.HINT.SCHEDULE_TYPE\' | translate}}</div><div layout=\"row\" flex><div layout=\"column\" flex=\"25\">\n<md-datepicker \nng-show=\"vm.offeredService.standalone===\'S\' && (vm.offeredService.scheduleType===\'P\' || vm.offeredService.scheduleType===\'D\')\" \nng-required=\"vm.offeredService.standalone===\'S\' && (vm.offeredService.scheduleType===\'P\' || vm.offeredService.scheduleType===\'D\')\" \nng-model=\"vm.offeredService.start\" \nmd-placeholder=\"{{ ( vm.offeredService.scheduleType===\'D\') ? (\'OFFERED_SERVICES.DATE_ON\' | translate) : (\'OFFERED_SERVICES.START\' | translate) }}\">\n</md-datepicker><md-datepicker ng-show=\"vm.offeredService.standalone===\'S\' && vm.offeredService.scheduleType===\'P\'\" \nng-required=\"vm.offeredService.scheduleType===\'P\'\" md-min-date=\"vm.offeredService.start\" \nng-model=\"vm.offeredService.end\" md-placeholder=\"{{ \'OFFERED_SERVICES.END\' | translate }}\"></md-datepicker></div><div \nlayout=\"column\" flex=\"75\" ng-if=\"vm.offeredService.scheduleType === \'P\'\"><h4 class=\"titolo-blocco-contenuto\" \nstyle=\"margin-bottom: 0; margin-top: -23px\">\nIl calcolo automatico della durata di un arco temporale può presentare delle imprecisioni. Usa la tabella sottostante per verificare se il numero di mesi è corretto. Dati imprecisi possono causare \n<strong>errori nel calcolo del numero di rate!</strong></h4><ov-interval-table startdate=\"vm.offeredService.start\" \nenddate=\"vm.offeredService.end\"></ov-interval-table></div></div><md-input-container class=\"md-block\" \nng-show=\"vm.offeredService.scheduleType === \'A\'\"><label translate=\"OFFERED_SERVICES.NUM_ACCESS\">Number of accesses\n</label><input type=\"number\" min=\"0\" ng-model=\"vm.offeredService.numMaxAccess\" \nng-required=\"vm.offeredService.scheduleType===\'A\' \"></md-input-container><md-input-container \nng-if=\"vm.offeredService.scheduleType === \'A\'\"><span required>\nSi tratta di un servizio indipendente o un carnet che comprende più servizi?</span><md-radio-group \nng-model=\"vm.offeredService.includeMoreServices\" layout=\"column\"><md-radio-button value=\"N\">Servizio indipendente\n</md-radio-button><md-radio-button value=\"Y\">E\' un carnet valido per più servizi</md-radio-button></md-radio-group>\n</md-input-container><md-input-container ng-if=\"vm.offeredService.includeMoreServices === \'Y\'\"><span>\nSeleziona i servizi compresi da questo carnet</span>:<div ng-repeat=\"servizioChild in vm.serviziChildAttivabili\">\n<md-checkbox ng-model=\"vm.childServiceToAdd[servizioChild.id]\" flex>{{servizioChild.name }} <span \nng-show=\"servizioChild.needsOrganizationSubscription\">- <cite>Necessita di quota associativa</cite></span> <span \nclass=\"md-warn\" ng-show=\"!servizioChild.enableAttendances && servizioChild.scheduleType !== \'A\'\">&nbsp;<md-icon \nmd-font-icon=\"icon-alert\" class=\"md-warn\"></md-icon>&nbsp;Presenze disabilitate</span></md-checkbox></div>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" md-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">3</span> <span \nclass=\"ms-form-wizard-step-text\">\n{{(vm.offeredService.standalone==\'S\' ? \'OFFERED_SERVICES.SUBSCRIPTIONS\':\'OFFERED_SERVICES.PRICE\') | translate}}</span>\n</span></md-tab-label><md-tab-body><form name=\"wizardStep3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\"><div class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nImposta il piano di pagamento principale</h3><h4 class=\"titolo-blocco-contenuto\">In questa fase stai inserendo la \n<strong>modalità di pagamento standard</strong>\n per questo servizio. Alla fine del processo di creazione potrai aggiungere <strong>altri piani di pagamento</strong>\n per personalizzarlo ulteriormente.</h4><md-input-container flex=\"100\" class=\"ov-width-100perc\"><md-select required \nng-model=\"vm.offeredService.paymentType\" ng-change=\"vm.changePaymentType()\"><md-option value=\"F\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option><md-option value=\"O\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" \nng-if=\"vm.offeredService.scheduleType!==\'A\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select>\n</md-input-container></div><div class=\"contenitore-pagina-padding-e-ombra\" \nng-show=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"><md-input-container \nng-show=\"vm.offeredService.paymentType===\'R\'\"><label translate=\"OFFERED_SERVICES.RENEWAL\">Renewal</label><md-select \nng-required=\"vm.offeredService.paymentType===\'R\' \" ng-model=\"vm.offeredService.paymentRenewInterval\"><md-option \nvalue=\"day\">{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option><md-option value=\"month\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"year\">{{\'OFFERED_SERVICES.YEAR\' | translate}}\n</md-option><md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</md-option><md-option value=\"2-month\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option value=\"3-month\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label>Numero di rate</label><input type=\"number\" \nmin=\"1\" ng-model=\"vm.offeredService.numMaxRenewal\"><div class=\"font-size-12\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</div><div class=\"font-size-12\" ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n<strong>Totale</strong>: <span ng-if=\"vm.offeredService.subscriptionPrice > 0\">\nIscrizione {{vm.offeredService.subscriptionPrice}} Euro</span> <span \nng-if=\"vm.offeredService.subscriptionPrice > 0 && vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n+ </span><span ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n{{vm.offeredService.numMaxRenewal}} Rate x {{vm.offeredService.renewalPrice}} Euro </span>= <strong>\n{{ (vm.offeredService.subscriptionPrice ? vm.offeredService.subscriptionPrice : 0 ) + (vm.offeredService.numMaxRenewal * (vm.offeredService.renewalPrice ? vm.offeredService.renewalPrice : 0 ) )}} Euro\n</strong></div></md-input-container><md-input-container class=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'O\'\">\n<label>Costo</label><input type=\"number\" min=\"0\" ng-model=\"vm.offeredService.subscriptionPrice\" \nng-required=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label \ntranslate=\"OFFERED_SERVICES.RENEWAL_PRICE\">Renewal price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.renewalPrice\" ng-required=\"vm.offeredService.paymentType===\'R\' \"></md-input-container>\n</div><div class=\"contenitore-pagina-padding-e-ombra\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><md-checkbox \nng-model=\"vm.offeredService.enableSubscriptionPrice\" ng-change=\"vm.enableSubscriptionPriceChanged();\" flex>\nIl servizio ha un costo di iscrizione</md-checkbox><md-input-container class=\"md-block\" \nng-show=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\" \nng-if=\"vm.offeredService.enableSubscriptionPrice\"><label translate=\"OFFERED_SERVICES.SUBSCRIPTION_PRICE\">\nSubscription price</label><input type=\"number\" min=\"0\" ng-model=\"vm.offeredService.subscriptionPrice\" \nng-required=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"></md-input-container></div>\n<md-input-container ng-if=\"vm.offeredService.standalone==\'S\'\" class=\"contenitore-pagina-padding-e-ombra\"><h3 \nclass=\"titolo-blocco-contenuto\">Documenti richiesti</h3><div ng-repeat=\"doctype in vm.organizationDoctypes\">\n<md-checkbox ng-model=\"vm.selecteDoctypeIds[doctype.id]\" aria-label=\"Enable chat\" flex>{{doctype.name}}</md-checkbox>\n</div></md-input-container><md-input-container \nng-hide=\"vm.isSubscriptionService || (vm.scheduleType === \'A\' && vm.offeredService.includeMoreServices === \'Y\')\" \nclass=\"contenitore-pagina-padding-e-ombra\"><md-checkbox ng-model=\"vm.offeredService.needsOrganizationSubscription\" \nflex>{{\'OFFERED_SERVICES.NEEDS_ORGANIZATION_SUBSCRIPTION\' | translate}}</md-checkbox></md-input-container>\n<md-input-container \nng-hide=\"vm.isSubscriptionService || vm.scheduleType === \'A\' || vm.offeredService.includeMoreServices === \'Y\'\" \nclass=\"contenitore-pagina-padding-e-ombra\"><md-checkbox ng-model=\"vm.offeredService.enableAttendances\" flex>\nAbilita la gestione delle presenze su questo servizio</md-checkbox></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.offeredService.standalone==\'S\'\" \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid  || wizardStep3.$invalid\" \nmd-on-select=\"vm.onWizardStepChange()\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\">4</span> <span \nclass=\"ms-form-wizard-step-text\">{{\'OFFERED_SERVICES.COMUNICATIONS\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nclass=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Messaggi e chat</h3><h4 \nclass=\"titolo-blocco-contenuto\">{{\'OFFERED_SERVICES.HINT.CHAT_TYPE\' | translate}}</h4><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container><md-checkbox ng-model=\"vm.offeredService.hasChat\" \naria-label=\"Enable chat\" flex>{{\'OFFERED_SERVICES.ENABLE_MESSAGES\' | translate}}</md-checkbox></md-input-container>\n&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container ng-show=\"vm.offeredService.hasChat\"><label \ntranslate=\"OFFERED_SERVICES.MESSAGE_TYPES\" required>Message type</label><md-select \nng-model=\"vm.offeredService.chatType\" ng-change=\"changeTypeCode()\"><md-option value=\"N\">\n{{\'OFFERED_SERVICES.NOTIFICATIONS\' | translate}}</md-option><md-option value=\"G\">\n{{\'OFFERED_SERVICES.GROUP_CHAT\' | translate}}</md-option><md-option value=\"B\">\n{{\'OFFERED_SERVICES.BROADCAST_CHAT\' | translate}}</md-option></md-select></md-input-container></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"!vm.offeredService.id\" md-on-select=\"vm.onWizardStepChange()\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep5.$invalid\">5</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep5.$valid\">\n5</span> <span class=\"ms-form-wizard-step-text\">FINE</span></span></md-tab-label><md-tab-body><form name=\"wizardStep5\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"row\" layout-align=\"center\" flex=\"100\" \nclass=\"md-title\">La creazione del servizio è stata effettuata correttamente</div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" class=\"md-padding\"><md-card ng-click=\"vm.gotoOfferedService();\" \nstyle=\"cursor: pointer; min-height: 200px\" flex=\"50\" class=\"md-teal-500-bg md-padding\"><md-card-content><div \nlayout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" layout-align=\"start start\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-calendar-multiple\"></md-icon>Vai al servizio</div><div style=\"clear: both\"></div><br><div \nlayout=\"row\" class=\"md-subhead white-fg\">Vai alla pagina di gestione del servizio</div></md-card-content></md-card>\n<md-card ng-click=\"vm.gotoPianiPagamento();\" style=\"cursor: pointer; min-height: 200px\" flex=\"50\" \nclass=\"md-teal-500-bg md-padding\"><md-card-content><div layout=\"row\" class=\"md-headline white-fg\" style=\"float: left\" \nlayout-align=\"start start\"><md-icon class=\"white-fg\" md-font-icon=\"icon-cash-multiple\"></md-icon>\nAggiungi piani di pagamento</div><div style=\"clear: both\"></div><br><div layout=\"row\" class=\"md-subhead white-fg\">\nCrea nuove modalità con cui far pagare le iscrizioni al servizio.</div></md-card-content></md-card></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-fab\" ng-click=\"msWizard.previousStep()\" \nng-hide=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex > 3) ||  (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex > 2)\" \nng-class=\"msWizard.isFirstStep() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.isFirstStep();\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"ng-scope md-font icon-chevron-left material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"steps\" ng-show=\"!vm.offeredService.id\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-fab\" ng-click=\"msWizard.nextStep()\" \nng-hide=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex >= 3) || (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex >= 2)\" \nng-class=\"msWizard.currentStepInvalid() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.currentStepInvalid();\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"ng-scope md-font icon-chevron-right material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-raised md-fab\" ng-click=\"vm.saveOfferedService();\" \nng-show=\"(vm.offeredService.standalone===\'S\' && msWizard.selectedIndex=== 3) ||  (vm.offeredService.standalone!==\'S\' && msWizard.selectedIndex=== 2)\" \nng-class=\"msWizard.formsIncomplete() ? \'\' : \'md-accent\'\" ng-disabled=\"msWizard.formsIncomplete();\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/offered_service.html","<div id=\"profile\" class=\"page-layout simple tabbed ov-height-100pct flex-scrollable\" ms-scroll n_g-cloak \nlayout=\"column\"><div class=\"content\" \nng-show=\"vm.offeredService.serviceType == \'EVENT\' || vm.offeredService.serviceType == \'SERVICE\'\"><ov-organization-alert\n organization-id=\"{{vm.offeredService.organizationId}}\"></ov-organization-alert><ov-navigation-bar \nclass=\"menu-in-sottopagina\" organization-id=\"{{vm.offeredService.organizationId}}\" \ncurrent-offered-service=\"{{vm.offeredService}}\" \nselected-page=\"{{vm.offeredService.serviceType == \'EVENT\' ? \'EVENTS\' : \'SERVICES\'}}\"></ov-navigation-bar><div \nclass=\"user-info md-padding\" layout=\"row\" layout-align=\"center center\"><img ng-if=\"vm.offeredService.uriLogo\" \nclass=\"profile-image avatar\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.offeredService.organizationId }}/download/{{vm.offeredService.uriLogo }}\">\n<div layout=\"column\"><div class=\"md-display-1\">{{ vm.offeredService.name }}</div></div><div layout=\"column\" \nclass=\"margin-left-20\" ng-if=\"vm.offeredService\"><md-menu><md-button class=\"pulsante-multiopzione\" title=\"Azioni\" \nng-click=\"$mdOpenMenu($event)\"><md-icon style=\"font-size:36px\" md-font-icon=\"icon-apps\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.offeredService.standalone===\'S\'\"><md-button \nng-click=\"vm.gotoServiceSettings(vm.offeredService.id)\"><md-icon md-font-icon=\"icon-cog\"></md-icon>Impostazioni\n</md-button></md-menu-item><md-menu-item><md-button \ntitle=\"{{ (vm.offeredService.hasChatUnsaved) ? (\'OFFERED_SERVICES.SEND_MESSAGE\' | translate):(\'OFFERED_SERVICES.ENABLE_CHAT_TO_SEND_MESSAGE\' |translate)}}\" \ntranslate-attr-aria-label=\"OFFERED_SERVICES.SEND_MESSAGE\" ng-click=\"vm.sendMessage()\" \nng-disabled=\"!vm.offeredService.hasChatUnsaved\"><md-icon md-font-icon=\"icon-message\" \nng-if=\"vm.offeredService.chatType === \'G\'\"></md-icon><span ng-if=\"vm.offeredService.chatType === \'G\'\">Chat di gruppo\n</span><md-icon md-font-icon=\"icon-message\" ng-if=\"vm.offeredService.chatType === \'B\'\"></md-icon><span \nng-if=\"vm.offeredService.chatType === \'B\'\">Messaggio broadcast</span><md-icon md-font-icon=\"icon-email\" \nng-if=\"vm.offeredService.chatType !== \'B\' && vm.offeredService.chatType !== \'G\'\"></md-icon><span \nng-if=\"vm.offeredService.chatType !== \'B\' && vm.offeredService.chatType !== \'G\'\">Invia notifica</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.offeredService.standalone===\'S\' && vm.offeredService.serviceType === \'EVENT\'\">\n<md-button ng-click=\"vm.goToInvitations()\"><md-icon md-font-icon=\"icon-comment-check-outline\"></md-icon>\n{{\'OFFERED_SERVICES.SEND_INVITATION_TO_SUBSCRIBERS\' | translate}}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.offeredService.standalone===\'S\' && vm.offeredService.serviceType !== \'EVENT\'\"><md-button \nng-click=\"vm.goToGeneratedEvent()\"><md-icon md-font-icon=\"icon-calendar-check\"></md-icon>Aggiungi evento</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\">\n<md-tab ng-if=\"vm.isAdmin && vm.offeredService.standalone===\'S\'\"><md-tab-label><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><span translate=\"OFFERED_SERVICES.SUBSCRIBERS\">Subscribers</span>\n</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/subscribers.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.isAdmin && vm.offeredService\"><md-tab-label><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><span translate=\"OFFERED_SERVICES.ABOUT\">About</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/about.html\'\"></div>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"!vm.offeredService.enableAttendances && vm.offeredService.scheduleType !== \'A\'\" \nng-if=\"vm.isAdmin && vm.offeredService.standalone===\'S\' && !vm.isSubscriptionService\"><md-tab-label><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon><span translate=\"PAGES.ATTENDANCES\">Attendances</span></md-tab-label>\n<md-tab-body><div class=\"md-padding\" layout-align=\"center center\" \nng-show=\"vm.offeredService.children && vm.offeredService.children.length > 0 && vm.offeredService.scheduleType === \'A\'\">\n<md-icon md-font-icon=\"icon-information\"></md-icon><span layout-align=\"center center\" class=\"md-subhead\">\nTrattandosi di un carnet che comprende più servizi le presenze vanno gestite nei singoli servizi di cui l\'utente usufruisce\n</span></div><div \nng-hide=\"vm.offeredService.children && vm.offeredService.children.length > 0 && vm.offeredService.scheduleType === \'A\'\" \nng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/attendances.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.isAdmin && vm.offeredService.standalone===\'S\'\"><md-tab-label><md-icon \nmd-font-icon=\"icon-clock-fast\"></md-icon><span translate=\"OFFERED_SERVICES.SERVICES_SCHEDULES\">Schedules</span>\n</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/schedules.html\'\"></div></md-tab-body></md-tab>\n<md-tab ng-if=\"!vm.isAdmin && vm.offeredService.standalone===\'S\'\"><md-tab-label><md-icon md-font-icon=\"icon-bank\">\n</md-icon><span translate=\"OFFERED_SERVICES.ORGANIZATION.ORGANIZATION\">Organization</span></md-tab-label><md-tab-body>\n<div ng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/organization.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.isAdmin && vm.offeredService.standalone===\'S\'\"><md-tab-label><md-icon \nmd-font-icon=\"icon-package-variant\"></md-icon><span translate=\"OFFERED_SERVICES.USED_RESOURCES\">Resources</span>\n</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service/tabs/resources.html\'\"></div></md-tab-body></md-tab>\n<md-tab ng-show=\"vm.offeredService.standalone===\'S\'\"><md-tab-label><md-icon md-font-icon=\"icon-calendar-text\">\n</md-icon><span translate=\"OFFERED_SERVICES.CALENDAR\">Calendar</span></md-tab-label><md-tab-body><div \nid=\"offeredService-calendar\" ui-calendar=\"vm.uiConfig.calendar\" ng-model=\"vm.eventSources\" \ncalendar=\"myServiceCalendar\"></div></md-tab-body></md-tab></md-tabs></div></div><div \nng-if=\"vm.selectedTabIndex === 0 &&  vm.offeredService.standalone===\'S\'\" class=\"ov-floating-btn\"><md-button \naria-label=\"Scroll up\" id=\"btnScrollUp\" style=\"display: none\" class=\"md-icon-button md-raised md-accent\"><md-icon \nmd-font-icon=\"icon-chevron-double-up\"></md-icon></md-button><md-button ng-if=\"vm.isAdmin\" \ntitle=\"{{\'OFFERED_SERVICES.SUBSCRIBER.ADD\' | translate}}\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.goToNewSubscription()\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon>\n</md-button><div class=\"contenitore-button-fixed contenitore-button-fixed-superiore\"><md-button \nng-if=\"vm.isAdmin && vm.offeredService.standalone===\'S\' && vm.selectedTabIndex===0\" title=\"Export excel\" \naria-label=\"Export excel\" class=\"md-raised md-accent md-fab esporta-excel\" ng-click=\"vm.exportSubscribersExcel()\">\n<md-icon md-font-icon=\"icon-file-excel\" class=\"md-primary\"></md-icon>Excel iscritti</md-button></div></div><div \nng-if=\"vm.selectedTabIndex === 2 && vm.isAdmin && vm.offeredService.standalone===\'S\' && !vm.isSubscriptionService\" \nclass=\"ov-floating-btn\"><md-button title=\"Aggiungi presenze\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.goToAttendanceDetail()\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon>\n</md-button></div><div ng-if=\"vm.selectedTabIndex === 3 && vm.isAdmin && vm.offeredService.standalone===\'S\'\" \nclass=\"ov-floating-btn\"><md-button title=\"{{\'OFFERED_SERVICES.SCHEDULES.ADD\' | translate}}\" \nclass=\"md-accent md-raised md-fab\" ng-click=\"vm.askScheduleDetails($event, null)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div><div \nng-if=\"vm.selectedTabIndex === 4 && vm.isAdmin && vm.offeredService.standalone===\'S\'\" class=\"ov-floating-btn\">\n<md-button title=\"{{\'OFFERED_SERVICES.RESOURCES.ADD\' | translate}}\" class=\"md-accent md-raised md-fab\" \nng-click=\"vm.askResourceDetails($event, null)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/offered_service_settings.html","<div id=\"page-offered-service-settings\" class=\"page-layout simple tabbed\" ms-scroll ng-init=\"vm.init();\" \nstyle=\"height: 100%\"><div class=\"content\" layout=\"column\"><ov-navigation-bar class=\"menu-in-sottopagina\" \norganization-id=\"{{vm.organization.id}}\" selected-page=\"SERVICES\"></ov-navigation-bar><div layout=\"column\" \nclass=\"md-padding\"><div class=\"user-info\" layout=\"row\" layout-align=\"start start\"></div><div class=\"user-info\" \nlayout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"center center\"><img ng-if=\"vm.item.uriLogo\" \nclass=\"profile-image avatar\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{ CYL_ORG_DOC_PREFIX }}{{ vm.item.organizationId }}/download/{{ vm.item.uriLogo }}\">\n<div layout=\"column\"><div class=\"md-display-1\" ng-show=\"vm.item.name\">{{ vm.item.name }} - Impostazioni</div></div><div\n layout=\"column\" class=\"margin-left-20\" ng-if=\"vm.item\"><md-menu><md-button class=\"pulsante-multiopzione\" \ntitle=\"Azioni\" ng-click=\"$mdOpenMenu($event)\"><md-icon style=\"font-size:36px\" md-font-icon=\"icon-apps\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.item.standalone===\'S\'\"><md-button \nng-click=\"vm.gotoService()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Vai alla gestione</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.item.standalone===\'S\' && vm.item.serviceType === \'EVENT\'\"><md-button \nng-click=\"vm.goToInvitations()\"><md-icon md-font-icon=\"icon-comment-check-outline\"></md-icon>\n{{\'OFFERED_SERVICES.SEND_INVITATION_TO_SUBSCRIBERS\' | translate}}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.item.standalone===\'S\' && vm.item.serviceType !== \'EVENT\'\"><md-button ng-click=\"vm.goToGeneratedEvent()\">\n<md-icon md-font-icon=\"icon-calendar-check\"></md-icon>Aggiungi evento</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.loading.service\" class=\"ov-box\">\n<md-progress-circular></md-progress-circular></div><div class=\"ov-box ov-box-info\" \nng-if=\"!vm.isAdmin && !vm.loading.service\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s36\"></md-icon>\n{{ \'MESSAGES.NOT_ALLOWED\' | translate }}</div><div ng-if=\"vm.isAdmin && !vm.loading.service\"><md-tabs \nmd-dynamic-height md-selected=\"vm.selectedTabIndex\"><md-tab><md-tab-label><md-icon md-font-icon=\"icon-cog\"></md-icon>\n{{ \'OFFERED_SERVICES.SETTINGS.MAIN\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/main.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"vm.item.standalone !== \'S\'\"><md-tab-label><md-icon md-font-icon=\"icon-calendar-clock\">\n</md-icon>{{ \'OFFERED_SERVICES.SETTINGS.SCHEDULE\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/schedule.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"vm.item && vm.item.standalone && vm.item.standalone !== \'S\'\"><md-tab-label><md-icon \nmd-font-icon=\"icon-cash-multiple\"></md-icon>Piani di pagamento</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/payment_plans.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><md-icon md-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon>\n{{ \'OFFERED_SERVICES.SETTINGS.OPTIONS\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/options.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"vm.item.scheduleType === \'A\'\"><md-tab-label><md-icon md-font-icon=\"icon-sitemap\">\n</md-icon>{{ \'OFFERED_SERVICES.SETTINGS.CHILDREN\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/children.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"vm.item.standalone !== \'S\'\"><md-tab-label><md-icon md-font-icon=\"icon-web\"></md-icon>\n{{ \'OFFERED_SERVICES.SETTINGS.WEB\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/web.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"vm.item.standalone !== \'S\'\"><md-tab-label><md-icon md-font-icon=\"icon-picture\"></md-icon>\n{{ \'OFFERED_SERVICES.SETTINGS.PICTURES\' | translate }}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/pages/offered_services/views/offered_service_settings/tabs/pictures.html\'\"></div></md-tab-body>\n</md-tab></md-tabs></div></div></div><div class=\"ov-floating-btn\" \nng-if=\"vm.selectedTabIndex !== 2 && vm.selectedTabIndex !== 6\"><md-button class=\"md-fab md-accent\" \nng-click=\"vm.saveOfferedService();\" title=\"{{\'OFFERED_SERVICES.SAVE\' | translate}}\" \naria-label=\"{{\'OFFERED_SERVICES.SAVE\' | translate}}\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button></div><div class=\"ov-floating-btn\" ng-if=\"vm.selectedTabIndex === 5\"><md-button \nclass=\"md-fab md-accent\" ng-click=\"vm.saveWebAttributes();\" title=\"{{\'OFFERED_SERVICES.SAVE\' | translate}}\" \naria-label=\"{{\'OFFERED_SERVICES.SAVE\' | translate}}\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\">\n</md-icon></md-button></div><div class=\"ov-floating-btn\" ng-if=\"vm.selectedTabIndex == 2\"><md-button \nclass=\"md-raised md-accent md-fab\" ng-click=\"vm.addChildShow(vm.item.id);\" title=\"Aggiungi piano di pagamento\"><md-icon\n md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/pages/organizations/views/discounts/dialogs/edit_discount_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"myForm\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORGANIZATIONS.DISCOUNTS.EDIT\"></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" style=\"min-width: 400px\"><md-input-container>\n<label translate=\"ORGANIZATIONS.DISCOUNTS.DISCOUNT_NAME\" required></label><input type=\"text\" name=\"discountName\" \nng-model=\"discountName\" required></md-input-container></div><div layout=\"column\"><label \ntranslate=\"ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE\" required></label><md-radio-group ng-model=\"discountType\">\n<md-radio-button value=\"PERCENT\" class=\"md-primary\">{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE_PERCENT\' | translate}}\n</md-radio-button><md-radio-button value=\"AMOUNT\">{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE_AMOUNT\' | translate}}\n</md-radio-button></md-radio-group></div><div layout=\"column\"><md-input-container><label required>\n{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_VALUE\' | translate}} in {{ (discountType===\'PERCENT\') ? \'%\' : \'Euro\'}}</label>\n<input type=\"number\" min=\"0\" max=\"{{ (discountType===\'PERCENT\') ? 100 : 999999999}}\" name=\"discountValue\" \nng-model=\"discountValue\" required></md-input-container></div><div layout=\"column\"><label \ntranslate=\"ORGANIZATIONS.DISCOUNTS.DURATION_TYPE\" required></label><md-radio-group ng-model=\"durationType\">\n<md-radio-button value=\"ONCE\" class=\"md-primary\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_ONCE\' | translate}}\n</md-radio-button><md-radio-button value=\"FOR_EVER\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_FOR_EVER\' | translate}}\n</md-radio-button><md-radio-button value=\"MONTHS\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_MONTHS\' | translate}}\n</md-radio-button></md-radio-group></div><div layout=\"column\" ng-show=\"durationType===\'MONTHS\'\"><md-input-container>\n<label translate=\"ORGANIZATIONS.DISCOUNTS.DURATION\"></label><input type=\"number\" min=\"1\" name=\"duration\" \nng-model=\"duration\" ng-required=\"durationType===\'MONTHS\'\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"myForm.$invalid || myForm.$pristine\" \nng-click=\"answer({name: discountName, type: discountType, value:discountValue, durationType: durationType, duration: duration })\" \ntranslate=\"ORGANIZATIONS.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/discounts/dialogs/new_discount_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"myForm\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORGANIZATIONS.DISCOUNTS.ADD\"></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" style=\"min-width: 400px\"><md-input-container>\n<label translate=\"ORGANIZATIONS.DISCOUNTS.DISCOUNT_NAME\" required></label><input type=\"text\" name=\"discountName\" \nng-model=\"discountName\" required></md-input-container></div><div layout=\"column\"><label \ntranslate=\"ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE\" required></label><md-radio-group ng-model=\"discountType\">\n<md-radio-button value=\"PERCENT\" class=\"md-primary\">{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE_PERCENT\' | translate}}\n</md-radio-button><md-radio-button value=\"AMOUNT\">{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_TYPE_AMOUNT\' | translate}}\n</md-radio-button></md-radio-group></div><div layout=\"column\"><md-input-container><label required>\n{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNT_VALUE\' | translate}} in {{ (discountType===\'PERCENT\') ? \'%\' : \'Euro\'}}</label>\n<input type=\"number\" min=\"0\" max=\"{{ (discountType===\'PERCENT\') ? 100 : 999999999}}\" name=\"discountValue\" \nng-model=\"discountValue\" required></md-input-container></div><div layout=\"column\"><label \ntranslate=\"ORGANIZATIONS.DISCOUNTS.DURATION_TYPE\" required></label><md-radio-group ng-model=\"durationType\">\n<md-radio-button value=\"ONCE\" class=\"md-primary\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_ONCE\' | translate}}\n</md-radio-button><md-radio-button value=\"FOR_EVER\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_FOR_EVER\' | translate}}\n</md-radio-button><md-radio-button value=\"MONTHS\">{{\'ORGANIZATIONS.DISCOUNTS.DURATION_TYPE_MONTHS\' | translate}}\n</md-radio-button></md-radio-group></div><div layout=\"column\" ng-show=\"durationType===\'MONTHS\'\"><md-input-container>\n<label translate=\"ORGANIZATIONS.DISCOUNTS.DURATION\"></label><input type=\"number\" min=\"1\" name=\"duration\" \nng-model=\"duration\" ng-required=\"durationType===\'MONTHS\'\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"myForm.$invalid || myForm.$pristine\" \nng-click=\"answer({name: discountName, type: discountType, value:discountValue, durationType: durationType, duration: duration })\" \ntranslate=\"ORGANIZATIONS.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/components/alert-incomplete-localization.component.html","<div class=\"ov-box ov-box-info\" flex=\"100\" layout=\"row\"><div layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s32 pr-16\"></md-icon></div><div flex=\"grow\">\nLe informazioni sulla localizzazione di questa organizzazione possono essere completate. Più le informazioni di localizzazione sono complete e più sarà facile trovare nuovi interessati.\n<br>Puoi aggiornare l\'indirizzo e la posizione sulla mappa alla <a href=\"#\" title=\"Impostazioni organizzazione\" \nng-click=\"vm.goToOrganizationSettings(vm.organization.id);\" onclick=\"false\">pagina delle impostazioni</a>.</div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/dialogs/edit_resource_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.RESOURCES.EDIT\">Edit Resource</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NAME\" required>Name</label><input type=\"text\" name=\"resourceName\" \nng-model=\"myResource.name\"><div ng-messages=\"newResourceForm.roleName.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"ORGANIZATIONS.ERRORS.RESOURCES_NAME_REQUIRED\">The resource name field is required</span></div></div>\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_DESCRIPTION\" required>\nDescription</label><input type=\"text\" name=\"myResource.description\" ng-model=\"myResource.description\">\n</md-input-container><md-checkbox ng-model=\"myResource.flgStaff\" ng-change=\"myResource.totalNumber=1\" \naria-label=\"Resource is staff member\">{{\'ORGANIZATIONS.RESOURCES.IS_STAFF\' | translate}}</md-checkbox><div \nlayout=\"row\" id=\"searchNewStaffMember\" ng-show=\"myResource.flgStaff\"><md-autocomplete \nstyle=\"min-width: 400px; width: 100%\" md-selected-item=\"myResource.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in lookupStaffUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"0\" \nplaceholder=\"{{\'ORGANIZATIONS.SEARCH_ON_STAFF\' | translate}}\" md-selected-item-change=\"selectedStaffMember(item)\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus><md-item-template><img md-menu-align-target \nng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img \nmd-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"row\"><md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NUMBER_OF_ITEMS\" \nrequired>Number of items</label><input type=\"number\" min=\"1\" ng-disabled=\"myResource.flgStaff\" name=\"resourceNumber\" \nng-model=\"myResource.totalNumber\"></md-input-container><md-input-container><md-checkbox \nng-model=\"myResource.freeUsage\" aria-label=\"User cost\">{{\'ORGANIZATIONS.RESOURCES.FREE_USAGE\' | translate}}\n</md-checkbox></md-input-container></div><div layout=\"row\" div class=\"md-inline-form\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.RESOURCES.USER_COST\" required></label><input ng-model=\"myResource.userCost\" type=\"number\" \nmin=\"0\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.USER_COST\' | translate }}\"></md-input-container>\n<md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.ORGANIZATION_COST\" required></label><input \nng-model=\"myResource.organizationCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\' | translate }}\"></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newResourceForm.$invalid || newResourceForm.$pristine\" \nng-click=\"answer({name: myResource.name, \r\n          			description: myResource.description, \r\n          			totalNumber: myResource.totalNumber, \r\n          			freeUsage: myResource.freeUsage, \r\n          			flgStaff: myResource.flgStaff, \r\n          			userCost:myResource.userCost, \r\n          			userId: myResource.userId,\r\n          			organizationCost:myResource.organizationCost})\" \ntranslate=\"ORGANIZATIONS.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/dialogs/edit_user_roles_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.MEMBER_ROLES.EDIT_ROLES\">Edit user roles</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.MEMBER_ROLES.ROLES\" required>Roles</label><md-select \nmd-placeholder=\"{{\'ORGANIZATIONS.MEMBER_ROLES.SELECT_RESOURCE\'  | translate }}\" ng-model=\"userRoles\" \nstyle=\"min-width: 200px\" multiple=\"multiple\"><md-option ng-value=\"role\" ng-repeat=\"role in roles\">{{role}}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newResourceForm.$invalid || newResourceForm.$pristine || !userRoles || userRoles===null || userRoles.length==0\" \nng-click=\"answer({})\" translate=\"ORGANIZATIONS.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"ORGANIZATIONS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/dialogs/help_dialog.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{helpTitle}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><p ng-bind-html=\"helpText\"></p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer(\'useful\')\" \ntranslate=\"ORGANIZATIONS.CLOSE\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/dialogs/new_resource_dialog.html","<md-dialog aria-label=\"New Resource\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.RESOURCES.ADD\">New Resource</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NAME\" required>Name</label><input type=\"text\" name=\"resourceName\" \nng-model=\"myResource.name\"><div ng-messages=\"newResourceForm.roleName.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"ORGANIZATIONS.ERRORS.RESOURCES_NAME_REQUIRED\">The resource name field is required</span></div></div>\n</md-input-container><md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_DESCRIPTION\" required>\nDescription</label><input type=\"text\" name=\"resourceDescription\" ng-model=\"myResource.description\">\n</md-input-container><md-checkbox ng-model=\"myResource.flgStaff\" ng-change=\"myResource.totalNumber=1\" \naria-label=\"Resource is staff member\">{{\'ORGANIZATIONS.RESOURCES.IS_STAFF\' | translate}}</md-checkbox><div \nlayout=\"row\" id=\"searchNewStaffMember\" ng-show=\"myResource.flgStaff\"><md-autocomplete \nstyle=\"min-width: 400px; width: 100%\" md-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" \nmd-items=\"item in lookupStaffUser(ctrl.searchText)\" md-item-text=\"item.displayName\" md-min-length=\"0\" \nplaceholder=\"{{\'ORGANIZATIONS.SEARCH_ON_STAFF\' | translate}}\" md-selected-item-change=\"selectedStaffMember(item)\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus><md-item-template><img md-menu-align-target \nng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img \nmd-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> \n<span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"row\"><md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NUMBER_OF_ITEMS\" \nrequired>Number of items</label><input type=\"number\" min=\"1\" ng-disabled=\"myResource.flgStaff\" name=\"resourceNumber\" \nng-model=\"myResource.totalNumber\"></md-input-container><md-input-container><md-checkbox \nng-model=\"myResource.freeUsage\" aria-label=\"User cost\">{{\'ORGANIZATIONS.RESOURCES.FREE_USAGE\' | translate}}\n</md-checkbox></md-input-container></div><div layout=\"row\" div class=\"md-inline-form\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.RESOURCES.USER_COST\" required></label><input ng-model=\"myResource.userCost\" type=\"number\" \nmin=\"0\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.USER_COST\' | translate }}\"></md-input-container>\n<md-input-container><label translate=\"ORGANIZATIONS.RESOURCES.ORGANIZATION_COST\" required></label><input \nng-model=\"myResource.organizationCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\' | translate }}\"></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newResourceForm.$invalid || newResourceForm.$pristine\" \nng-click=\"\r\n          			answer({name: myResource.name, \r\n          			description: myResource.description, \r\n          			totalNumber: myResource.totalNumber, \r\n          			freeUsage: myResource.freeUsage, \r\n          			flgStaff: myResource.flgStaff, \r\n          			userCost:myResource.userCost, \r\n          			userId: myResource.userId,\r\n          			organizationCost:myResource.organizationCost})\" \ntranslate=\"ORGANIZATIONS.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/dialogs/new_subscriber_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newSubscriberForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.MEMBER.ADD\">New member</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><p id=\"add-member-in-line-help\" \nstyle=\"display:none\">{{\'ORGANIZATIONS.ADD_MEMBER_INFOS\' | translate}}</p></div><div layout=\"column\"><div layout=\"row\" \nid=\"searchNewMember\"><md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nonclick=\"$(\'#add-member-in-line-help\').toggle(500)\"><md-icon id=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" \nclass=\"md-primary\"></md-icon></md-button><md-autocomplete style=\"min-width: 480px; width: 100%\" \nmd-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" md-items=\"item in lookupUser(ctrl.searchText)\" \nmd-item-text=\"item.displayName\" md-min-length=\"3\" md-floating-label=\"{{\'OFFERED_SERVICES.SEARCH_ON_CYL\' | translate}}\" \nmd-selected-item-change=\"selectedUserChange(item)\" md-menu-class=\"autocomplete-custom-template\" md-autofocus>\n<md-item-template><img md-menu-align-target ng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> <span \nmd-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"row\"><md-input-container id=\"addNewMember\" style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"givenName\" ng-readonly=\"userId && userId!==null\"></md-input-container><md-input-container style=\"width:100%\">\n<label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" required>Family Name</label><input type=\"text\" \nname=\"familyName\" ng-model=\"familyName\" ng-readonly=\"userId && userId!==null\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float style=\"width:100%; margin-top: 0px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">Birth date</label><input rsmdatedropdowns deny-future-dates=\"true\" \nng-model=\"birthDate\" ng-disabled=\"userId && userId!==null\"></md-input-container><md-input-container \nstyle=\"width:100%; margin-top: 21px\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input \ntype=\"email\" ng-model=\"email\" ng-pattern=\"/^.+@.+\\..+$/\" ng-required=\"!userId || userId===null\" \nng-readonly=\"userId && userId!==null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"newSubscriberForm.$invalid || newSubscriberForm.$pristine\" \nng-click=\"answer({givenName: givenName,familyName: familyName,birthDate: birthDate,email: email, id:userId})\" \ntranslate=\"OFFERED_SERVICES.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/earning-costs.html","<div ng-controller=\"EarningcostsController as ecVm\" ng-init=\"ecVm.init(vm.organization.id)\"><div layout=\"row\" \nlayout-align=\"end start\" div class=\"md-inline-form\"><md-button title=\"{{\'EARNING_COST.ADD\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"ecVm.askEntryDetails($event)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div><div layout=\"row\"><table \ndatatable=\"earningcosts-datatable\" dt-options=\"ecVm.dtOptions\" dt-columns=\"ecVm.dtColumns\" \ndt-instance=\"ecVm.dtInstance\" class=\"row-border hover\"></table></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/events.html","<div ng-controller=\"OrganizationServicesController as servicesVm\" \nng-init=\"servicesVm.init(vm.organizationId, \'EVENT\')\"><div layout=\"row\" layout-align=\"end start\" ng-if=\"vm.isAdmin\">\n<md-input-container flex=\"100\" class=\"md-block\" flex-gt-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input id=\"services-search\" type=\"text\" \nplaceholder=\"{{\'ORGANIZATIONS.SEARCH\' | translate }}\" translate flex ng-model=\"servicesVm.searchText\" \nng-change=\"servicesVm.doTxtSearch()\"></md-input-container><md-button \ntitle=\"{{\'ORGANIZATIONS.OFFERED_SERVICES.ADD_EVENT\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"servicesVm.gotoNewEvent();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon>\n</md-button></div><div layout=\"row\"><table datatable=\"offeredservice-datatable\" dt-options=\"servicesVm.dtOptions\" \ndt-columns=\"servicesVm.dtColumns\" dt-instance=\"servicesVm.dtInstance\" class=\"row-border hover\"></table></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/members.html","<div layout=\"row\" layout-align=\"start start\"><md-input-container flex=\"100\" class=\"md-block\" flex-gt-xs><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input id=\"members-search\" type=\"text\" \nplaceholder=\"{{\'ORGANIZATIONS.SEARCH\' | translate }}\" translate flex></md-input-container><md-button id=\"addMemberBtn\" \ntitle=\"{{\'ORGANIZATIONS.MEMBER.ADD\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.askUserDetails($event)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsUsers\"><thead \nid=\"goToMemberoDetailHint\"><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATIONS.NAME\">Nome</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ORGANIZATIONS.EMAIL\">Email</span></div></th><th class=\"secondary-text\" \nid=\"goToMemberoRoleslHint\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATIONS.ROLES\">Roles\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr \nng-repeat=\"member in vm.usersWithRoles\"><td style=\"cursor: pointer\" ng-click=\"vm.gotoUserProfile(member.id);\"><img \nmd-menu-align-target ng-if=\"!member.uriAvatar || member.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"member.uriAvatar && member.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{member.id}}/download/{{ member.uriAvatar }}\">\n</td><td style=\"cursor: pointer; text-decoration: underline\" ng-click=\"vm.gotoUserProfile(member.id);\">\n{{member.displayName}}</td><td style=\"cursor: pointer; text-decoration: underline\" \nng-click=\"vm.gotoUserProfile(member.id);\">{{(member.email.endsWith(\'invalid\')) ? \' \' : member.email}}</td><td \nstyle=\"cursor: pointer\" ng-click=\"vm.editUserRoles($event, member);\"><md-icon md-font-icon=\"icon-pencil-box\" \nclass=\"s16\"></md-icon>{{member.roles}}</td><td><md-button \nng-disabled=\"subscriber.paymentStatus.paymentTotal <= subscriber.paymentStatus.paymentTotalDone\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.deleteMember($event, member);\"><md-icon \nng-show=\"member.id!==vm.user.id\" md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody>\n</table>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/organization-dashboard.html","<div class=\"pl-24 pr-24 pt-8 pb-8\" layout=\"column\" flex=\"100\"><div \nng-if=\"vm.organization && !((vm.organization.address || vm.organization.addressOperat) && vm.organization.latitude && vm.organization.longitude)\" \nng-include=\"\'app/main/pages/organizations/views/organization/components/alert-incomplete-localization.component.html\'\">\n</div></div><div class=\"widget-group padding-24\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 teal-600-fg font-size-18\">Pagamenti mancanti ad oggi</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-700-fg font-size-72 line-height-72\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'M\', \'\', \'today\', \'d\');\">{{ vm.stats.pagamenti.unpaidSubscriptions }}</div><div \nclass=\"blue-grey-700-fg font-size-24 line-height-48\">\n{{ vm.stats.pagamenti.unpaidSubscriptionsValue | currency : \'&euro;\' : 2 }}</div></div><div \nclass=\"pl-16 pr-8 pv-16 h-55 border-top\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.stats.pagamentiRif\"><div class=\"h3\">Pagamenti mancanti al {{ vm.stats.pagamentiRif.dateTo }}</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.stats.pagamentiRif\"><div \nclass=\"blue-grey-700-fg font-size-72 line-height-72\" style=\"cursor: pointer\" \nng-click=\"vm.goToSubscriptions(\'\', \'M\', \'\', null, \'d\');\">{{ vm.stats.pagamentiRif.unpaidSubscriptions }}</div><div \nclass=\"blue-grey-700-fg font-size-24 line-height-48\">\n{{ vm.stats.pagamentiRif.unpaidSubscriptionsValue | currency : \'&euro;\' : 2 }}</div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 teal-600-fg font-size-18\">{{ \"ORGANIZATIONS.DASHBOARD.ENTRATE\" | translate }}</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg font-size-36 line-height-36\" \nstyle=\"cursor: pointer\" ng-click=\"vm.gotoEarningCosts()\"><span ng-if=\"vm.stats.entrateUscite\">\n{{vm.stats.entrateUscite.entrate}} Euro</span></div></div><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{ \"ORGANIZATIONS.DASHBOARD.USCITE\" | translate }}</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-36 line-height-36\" \nstyle=\"cursor: pointer\" ng-click=\"vm.gotoEarningCosts()\"><span ng-if=\"vm.stats.entrateUscite\">\n{{vm.stats.entrateUscite.uscite}} Euro</span></div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"contenitore-box-documenti-esterno\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 teal-600-fg font-size-18\">Documenti</div></div></ms-widget-front>\n<ms-widget-front class=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'MISSING\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">Mancanti:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.missing}}</span></div></div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'EXPIRED\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">Scaduti:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.expired}}</span></div></div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'REJECTED\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">Rifiutati:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.rejected}}</span></div></div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'EXPIRING\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">In scadenza:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.expiring}}</span></div></div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'TO_BE_VALIDATED\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">Da Validare:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.toValidate}}</span></div></div></div></ms-widget-front><ms-widget-front \nclass=\"white-bg contenitore-box-documenti\"><div class=\"pl-16 pr-8 pv-16 h-55 box-documenti\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"blue-grey-700-fg font-size-18 line-height-24\" \nstyle=\"cursor: pointer\" ng-click=\"vm.goToSubscriptions(\'\', \'A\', \'VALIDATED\', null, \'p\')\"><span \nclass=\"etichetta-dashboard-documenti\">Validati:</span> <span class=\"valore-dashboard-documenti\">\n{{vm.stats.documenti.validated}}</span></div></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg box-piano-corrente\"><div \nclass=\"pl-16 pr-8 pv-16 h-40\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 teal-600-fg font-size-18\">{{ vm.appDataService.organizationPlanStats.plan.nickname }}</div></div><div \nclass=\"h4 pl-16 secondary-text text-truncate\">\n{{ \'ORGANIZATIONS.DASHBOARD.PLAN_MAXCONTACTS_INTRO\' | translate }} {{ vm.appDataService.organizationPlanStats.plan.metadata[\'max-org-members\'] }} {{ \'ORGANIZATIONS.DASHBOARD.PLAN_MAXCONTACTS\' | translate }} - {{ \'ORGANIZATIONS.DASHBOARD.NUM_ACTIVE_CONTACTS_INTRO\' | translate }} {{ vm.appDataService.organizationPlanStats.numActiveContacts }}\n</div><div class=\"pt-8 pb-10\" layout=\"column\" layout-align=\"center center\"><c3chart bindto-id=\"donut-plot1-chart\" \nchart-data=\"vm.planChart.dataPoints\" chart-columns=\"vm.planChart.dataColumns\"><chart-donut \ntitle=\"{{ vm.appDataService.organizationPlanStats.plan.nickname }}\" width=\"60\"><chart-colors \ncolor-pattern=\"#2bd3be,#ccc\"></c3chart></div></ms-widget-front></ms-widget></div><div class=\"widget-group padding-24\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-40\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3 teal-600-fg font-size-18\">Anomalie ingressi multipli e carnet</div></div><div><div \nng-if=\"vm.carnetAnomalies.loading\" layout=\"row\" layout-align=\"center center\">&nbsp;<md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent md-hue-1\" md-diameter=\"32\"></md-progress-circular></div><div \nng-if=\"!vm.carnetAnomalies.loading && vm.carnetAnomalies.items.length === 0\" layout=\"row\" layout-align=\"center center\">\n<span>Nessun carnet sembra presentare anomalie</span></div><md-list flex><md-list-item class=\"md-2-line\" \nng-repeat=\"carnet in vm.carnetAnomalies.items\" ng-click=\"vm.gotoUserCarnet(vm.organizationId, carnet.userId);\"><md-icon\n md-font-icon=\"icon-credit-card\" class=\"md-avatar-icon\" aria-hidden=\"true\"></md-icon><div class=\"md-list-item-text\" \nlayout=\"row\"><div flex><h3>{{ carnet.familyName }} {{ carnet.givenName }}</h3><p><span \nng-if=\"carnet.currentAttendances > carnet.numMaxAccessForOrder\">\nSuperata disponibilità: {{ carnet.currentAttendances }} su {{ carnet.numMaxAccessForOrder }}</span></p></div><div \nflex=\"20\" layout=\"column\" layout-align=\"center center\">\n{{ carnet.currentAttendances }}/{{ carnet.numMaxAccessForOrder }}<br><md-progress-linear md-mode=\"determinate\" \nng-class=\"carnet.currentAttendances > carnet.numMaxAccessForOrder ? \'ov-mood-error\' : (carnet.currentAttendances < carnet.numMaxAccessForOrder ? \'ov-mood-positive\' : \'ov-mood-warning\')\" \nvalue=\"{{ carnet.currentAttendances/carnet.numMaxAccessForOrder * 100 }}\"></md-progress-linear></div><div flex=\"5\">\n&nbsp;</div></div></md-list-item></md-list></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/resources.html","<div ng-hide=\"vm.isShowResourceCalendar\"><div layout=\"row\" layout-align=\"end start\"><md-input-container flex=\"100\" \nclass=\"md-block\" flex-gt-xs><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nid=\"resources-search\" type=\"text\" placeholder=\"{{\'ORGANIZATIONS.SEARCH\' | translate }}\" translate flex>\n</md-input-container><md-button title=\"{{\'ORGANIZATIONS.RESOURCES.ADD\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.askOrganizationResourceDetails($event);\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsResources\" \nng-hide=\"vm.isShowResourceCalendar\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NAME\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATIONS.RESOURCES.RESOURCES_DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATIONS.RESOURCES.RESOURCES_NUMBER_OF_ITEMS\">\nNumber of items</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATIONS.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"resource in vm.organization.organizationResources\"><td \nng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</td><td ng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">{{resource.description}}\n</td><td ng-click=\"vm.editOrganizationResourceDetails($event,resource)\" style=\"cursor:pointer\">{{resource.totalNumber}}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.showResourceCalendar($event,resource)\" \naria-label=\"Show resource calendar\" translate translate-attr-aria-label=\"ORGANIZATIONS.RESOURCES.CALENDAR_USAGE\">\n<md-icon md-font-icon=\"icon-calendar-clock\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div><div \nng-show=\"vm.isShowResourceCalendar\"><h2>{{vm.calendarResourceName}}</h2><div layout=\"row\" layout-align=\"end start\" \nng-if=\"vm.isAdmin\"><md-button title=\"{{\'OFFERED_SERVICES.RESOURCES.BACK\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.backToResources()\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-undo-variant\" class=\"md-primary\"></md-icon></md-button></div><br><div ng-if=\"vm.isAdmin\"><div \nid=\"myResourceCalendar\" ui-calendar=\"vm.uiConfig.resourceCalendar\" ng-model=\"vm.eventSourcesForResource\" \ncalendar=\"myResourceCalendar\"></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/services.html","<div ng-controller=\"OrganizationServicesController as servicesVm\" \nng-init=\"servicesVm.init(vm.organizationId, \'SERVICE\')\"><div layout=\"row\" layout-align=\"end start\" ng-if=\"vm.isAdmin\">\n<md-input-container flex=\"100\" class=\"md-block\" flex-gt-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input id=\"services-search\" type=\"text\" \nplaceholder=\"{{\'ORGANIZATIONS.SEARCH\' | translate }}\" translate flex ng-model=\"servicesVm.searchText\" \nng-change=\"servicesVm.doTxtSearch()\"></md-input-container><md-button \ntitle=\"{{\'ORGANIZATIONS.OFFERED_SERVICES.ADD\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"servicesVm.gotoNewOfferedService();\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\">\n</md-icon></md-button></div><div layout=\"row\"><table datatable=\"offeredservice-datatable\" \ndt-options=\"servicesVm.dtOptions\" dt-columns=\"servicesVm.dtColumns\" dt-instance=\"servicesVm.dtInstance\" \nclass=\"row-border hover\"></table></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/view-organization-fullwidth.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\" style=\"padding: 16px\"><header \nclass=\"md-accent-bg\"><div style=\"font-size: 17px; padding: 16px; float: left\" class=\"title\" \ntranslate=\"OFFERED_SERVICES.ORGANIZATION.INFORMATION\">Organization Information</div><div layout=\"row\" \nlayout-align=\"end\" ng-if=\"vm.isAdmin\" style=\"padding: 4px\"><md-button id=\"organizationEditBtn\" ng-if=\"vm.isAdmin\" \nclass=\"md-icon-button md-raised\" ng-click=\"vm.gotoEdit()\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-primary\"></md-icon></md-button></div></header><div class=\"content\"><div class=\"row\" style=\"display: flex\">\n<div class=\"flex-50\"><div class=\"info-line\"><div class=\"title\" translate=\"ORGANIZATIONS.ORGANIZATION_NAME\">\nOrganization Name</div><div class=\"info\">{{ vm.organization.name }}</div></div><div class=\"info-line\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"OFFERED_SERVICES.ORGANIZATION.CONTACTS\">Contacts</div><div \nclass=\"info\">\n{{ vm.organization.address }} - {{vm.organization.postalCode}} {{vm.organization.city}} {{vm.organization.province}}\n</div><div ng-if=\"vm.organization.phone!==null || vm.organization.mobilePhone!==null || vm.organization.fax!==null\" \nclass=\"info\">Tel: {{ vm.organization.phone }} - {{ vm.organization.mobilePhone }} Fax: {{vm.organization.fax}}</div>\n</div><div class=\"info-line\" ng-if=\"vm.organization.email!==null\"><div class=\"title\" translate=\"ORGANIZATIONS.EMAIL\">\nEmail</div><div class=\"info\"><a href=\"mailto:{{ vm.organization.email }}\" target=\"_blank\">{{ vm.organization.email }}\n</a></div></div><div class=\"info-line\" ng-if=\"vm.organization.website!==null\"><div class=\"title\" \ntranslate=\"ORGANIZATIONS.WEBSITE\">Website</div><div class=\"info\"><a ng-href=\"{{ vm.organization.website }}\" \ntarget=\"_blank\">{{ vm.organization.website }}</a></div></div></div></div><div class=\"flex-50\"><div id=\"map\" \nstyle=\"width:100%; height:200px\" \nng-if=\"vm.organization.longitude\n							                && vm.organization.longitude!==null \n							                && vm.organization.latitude \n							                && vm.organization.latitude!==null\">\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization/tabs/view-organization.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\" style=\"padding: 16px\"><header \nclass=\"md-accent-bg\"><div style=\"font-size: 17px; padding: 16px; float: left\" class=\"title\" \ntranslate=\"OFFERED_SERVICES.ORGANIZATION.INFORMATION\">Organization Information</div><div layout=\"row\" \nlayout-align=\"end\" ng-if=\"vm.isAdmin\" style=\"padding: 4px\"><md-button id=\"organizationEditBtn\" ng-if=\"vm.isAdmin\" \nclass=\"md-icon-button md-raised\" ng-click=\"vm.gotoEdit()\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md-primary\"></md-icon></md-button></div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"ORGANIZATIONS.ORGANIZATION_NAME\">Organization Name</div><div class=\"info\">{{ vm.organization.name }}</div>\n</div><div class=\"info-line\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"OFFERED_SERVICES.ORGANIZATION.CONTACTS\">Contacts</div><div class=\"info\">\n{{ vm.organization.address }} - {{vm.organization.postalCode}} {{vm.organization.city}} {{vm.organization.province}}\n</div><div ng-if=\"vm.organization.phone!==null || vm.organization.mobilePhone!==null || vm.organization.fax!==null\" \nclass=\"info\">Tel: {{ vm.organization.phone }} - {{ vm.organization.mobilePhone }} Fax: {{vm.organization.fax}}</div>\n</div><div class=\"info-line\" ng-if=\"vm.organization.email!==null\"><div class=\"title\" translate=\"ORGANIZATIONS.EMAIL\">\nEmail</div><div class=\"info\"><a href=\"mailto:{{ vm.organization.email }}\" target=\"_blank\">{{ vm.organization.email }}\n</a></div></div><div class=\"info-line\" ng-if=\"vm.organization.website!==null\"><div class=\"title\" \ntranslate=\"ORGANIZATIONS.WEBSITE\">Website</div><div class=\"info\"><a ng-href=\"{{ vm.organization.website }}\" \ntarget=\"_blank\">{{ vm.organization.website }}</a></div></div></div><div id=\"map\" style=\"width:100%; height:200px\" \nng-if=\"vm.organization.longitude \r\n							                && vm.organization.longitude!==null \r\n							                && vm.organization.latitude \r\n							                && vm.organization.latitude!==null\">\n</div></div></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/tabs/cyl-plan.html","<div layout=\"column\" style=\"height: 100%\"><div ng-if=\"vm.planPage === \'STATUS\'\"><div><div class=\"md-title\">\nPiano corrente: {{vm.cylPlan.nickname}} <span ng-if=\"vm.cylPlan.id !== \'FREE\'\">\n({{vm.cylSubscriptionStart}} - {{vm.cylSubscriptionEnd}})</span></div><div class=\"md-title\" ng-if=\"vm.planWarning\">\n{{vm.planWarning}}</div></div><div class=\"content white-bg md-padding\" layout-align=\"center center\" layout=\"column\">\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{ \"ORGANIZATIONS.DASHBOARD.PLAN\" | translate }}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><c3chart bindto-id=\"donut-plot1-chart\" chart-data=\"vm.planChart.dataPoints\" \nchart-columns=\"vm.planChart.dataColumns\"><chart-donut \ntitle=\"{{  vm.appDataService.organizationPlanStats.plan.nickname }}\" width=\"60\"><chart-colors \ncolor-pattern=\"{{vm.planChart.colors}}\"></c3chart></div><div class=\"p-16 border-top\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"h4 secondary-text text-truncate\">\n{{ vm.appDataService.organizationPlanStats.plan.nickname }}: {{ \'ORGANIZATIONS.DASHBOARD.PLAN_MAXCONTACTS_INTRO\' | translate }} {{ vm.appDataService.organizationPlanStats.plan.metadata[\'max-org-members\'] }} {{ \'ORGANIZATIONS.DASHBOARD.PLAN_MAXCONTACTS\' | translate }},\n</span></div></ms-widget-front></ms-widget><div layout=\"row\"><md-card ng-repeat=\"plan in vm.plans\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">{{plan.nickname}}</span> <span class=\"md-subhead\"><span \nng-if=\"plan.id === \'FREE\'\">Gratuito</span> <span ng-if=\"plan.id === \'CUSTOM\'\">Tariffa: da definire</span> <span \nng-if=\"plan.id !== \'FREE\' && plan.id !== \'CUSTOM\'\">Tariffa mensile: {{plan.amount / 100}} Euro</span></span>\n</md-card-title-text></md-card-title><md-card-content><strong>\nNumero massimo di contatti attivi: {{plan.metadata[\'max-org-members\']}}</strong></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"plan.id !== \'CUSTOM\'\" class=\"md-raised md-accent\" \nng-click=\"vm.goToPreview(plan)\" ng-hide=\"vm.cylPlan.id === plan.id\">Scegli</md-button><div \nng-show=\"vm.cylPlan.id === plan.id\" class=\"md-title\"><md-icon style=\"color: green\" md-font-icon=\"icon-check\"></md-icon>\nAttivo</div><md-button ng-if=\"plan.id === \'CUSTOM\'\" class=\"md-raised md-accent\" ng-hide=\"vm.cylPlan.id === plan.id\" \ntarget=\"_blank\" ng-href=\"https://www.clubyourlife.com/#wpcf7-f4-p47-o1\">Contattaci</md-button></md-card-actions>\n</md-card></div></div></div><div ng-show=\"vm.planPage === \'PREVIEW\'\"><table class=\"dataTable row-border hover\" \nng-show=\"vm.previewInvoice.items && vm.previewInvoice.items.length > 1\"><tr \nng-repeat=\"item in vm.previewInvoice.items\"><td>{{item.planName}}</td><td>\nDal {{vm.formatDate(item.start)}} al {{vm.formatDate(item.end)}}</td><td>{{item.amount / 100}} Euro</td></tr><tr><td>\n</td><td colspan=\"2\"><strong>TOTALE: {{vm.previewInvoice.amount / 100}} Euro</strong></td></tr></table><div \nlayout=\"row\" layout-align=\"center center\" \nng-show=\"vm.previewInvoice.amount > 0 && (!vm.previewInvoice.items || vm.previewInvoice.items.length <= 1)\"><h3>\n<strong>TOTALE: {{vm.previewInvoice.amount / 100}} Euro</strong></h3></div><div class=\"margin-left-100 margin-top-50\" \nng-show=\"vm.previewInvoice.amount > 0 && vm.cylCustomer.sources.data && vm.cylCustomer.sources.data.length > 0\"><span \nclass=\"md-padding md-title margin-bottom-30\">Paga con:</span><br><br><md-radio-group ng-model=\"vm.paymentCardId\" \nrequired><md-radio-button ng-repeat=\"card in vm.cylCustomer.sources.data\" ng-value=\"card.id\"><div layout=\"column\" \nlayout-align=\"center center\"><span>\n{{card.brand}} **** **** **** {{card.last4}} (scadenza {{card.exp_month}}/{{card.exp_year}})</span></div>\n</md-radio-button><md-radio-button ng-value=\"NEW_CARD\"><div layout=\"column\" layout-align=\"center center\"><span>\nNuova carta</span></div></md-radio-button></md-radio-group></div><div layout=\"row\" \nng-show=\"vm.previewInvoice.amount > 0 && (!vm.paymentCardId || vm.paymentCardId===\'NEW_CARD\')\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.planPage = \'STATUS\'\">Annulla</md-button><button \nclass=\"stripe-cyl-button\" ng-click=\"vm.sendStripePayment();\"><i class=\"fa fa-2x fa-cc-stripe\"></i>\n&nbsp;&nbsp;&nbsp;&nbsp;PAGA CON STRIPE</button></div><div layout=\"row\" \nng-show=\"vm.previewInvoice.amount > 0 && vm.paymentCardId && vm.paymentCardId !== \'NEW_CARD\'\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.planPage = \'STATUS\'\">Annulla</md-button><button \nng-click=\"vm.sendStripePayment();\" class=\"stripe-cyl-button\"><i class=\"fa fa-2x fa-cc-stripe\"></i>\n&nbsp;&nbsp;&nbsp;&nbsp;PAGA CON STRIPE</button></div><div layout=\"row\" ng-show=\"vm.previewInvoice.amount < 0\" \nlayout-align=\"center center\">Procedere con la modifica al piano?</div><div layout=\"row\" \nng-show=\"vm.previewInvoice.amount < 0\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.planPage = \'STATUS\'\">Annulla</md-button><button ng-click=\"vm.sendStripePayment();\" \nclass=\"stripe-cyl-button\">PROCEDI</button></div></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/tabs/quote-iscrizione.html","<div layout=\"column\" ng-controller=\"QuoteIscrizioneController as vm\" ng-init=\"vm.init();\"><p>\nCrea e modifica da qui le quote di iscrizione a {{ vm.organization.name }}.</p><div flex=\"100\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><md-card flex=\"100\" class=\"brown-50-bg\" ng-if=\"vm.items.length == 0\"><md-card-content \nlayout=\"column\" flex=\"100\"><md-card-title-text layout=\"column\"><span class=\"md-headline\" layout=\"row\" flex><div \nflex=\"100\">Crea una quota associativa</div></span><span class=\"md-subhead\"><p>\nAl momento non è impostata alcuna quota associativa per {{ vm.organization.name }}. Desideri crearne una adesso?</p><p \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-primary\" ng-click=\"vm.newItem();\" \naria-label=\"Crea quota associativa\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></p></span>\n</md-card-title-text></md-card-content></md-card><md-card flex=\"100\" class=\"brown-50-bg\" ng-repeat=\"item in vm.items\">\n<md-card-content layout=\"column\" flex=\"100\"><md-card-title-text layout=\"column\"><span class=\"md-headline\" layout=\"row\" \nflex><div flex=\"75\"><span ng-if=\"!item._info.editing\">{{ item.name }}</span><md-input-container class=\"md-block\" \nng-if=\"item._info.editing\"><label>Nome</label><input type=\"text\" ng-model=\"item.name\" required></md-input-container>\n</div><div flex=\"15\"><span ng-if=\"!item._info.editing\">{{ item.subscriptionPrice | currency : \'&euro;\' : 2 }}</span>\n<md-input-container class=\"md-block\" ng-if=\"item._info.editing\"><label>Prezzo</label><input type=\"number\" \nng-model=\"item.subscriptionPrice\" required></md-input-container></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.editItem(item);\" \naria-label=\"Modifica\" ng-if=\"!item._info.editing\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.deleteItem(item);\" aria-label=\"Elimina\" ng-if=\"!item._info.editing\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.unEditItem(item);\" aria-label=\"Annulla\" ng-if=\"item._info.editing && !item._info.saving\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.saveItem(item);\" aria-label=\"Salva\" ng-if=\"item._info.editing && !item._info.saving\"><md-icon \nmd-font-icon=\"icon-floppy\"></md-icon></md-button><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"item._info.saving\" md-diameter=\"16px\" class=\"md-accent\"></md-progress-circular></div></span><span \nclass=\"md-subhead\"><p ng-if=\"!item._info.editing\">{{ item.description }}</p><md-input-container class=\"md-block\" \nng-if=\"item._info.editing\"><label>Descrizione</label><textarea ng-model=\"item.description\" md-maxlength=\"500\" rows=\"5\" \nmd-select-on-focus></textarea></md-input-container></span><span class=\"md-subhead\"><p ng-if=\"!item._info.editing\">\nPeriodo: {{ item.start | date : \'dd/MM/yyyy\' }} - {{ item.end | date : \'dd/MM/yyyy\' }}</p><div \nng-if=\"item._info.editing\" layout=\"row\" layout-align=\"start center\"><md-datepicker ng-model=\"item.start\" \nmd-placeholder=\"Da\"></md-datepicker><md-datepicker ng-model=\"item.end\" md-placeholder=\"a\"></md-datepicker></div></span>\n</md-card-title-text></md-card-content></md-card><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.items.length > 0\"><md-button class=\"md-fab md-primary\" ng-click=\"vm.newItem();\" \naria-label=\"Crea quota associativa\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/tabs/types.html","<md-tabs md-dynamic-height><md-tab><md-tab-label><div layout=\"row\" class=\"md-title\">\n{{\'ORGANIZATIONS.MEMBERS_TYPES.MEMBERS_TYPES\' | translate}}</div></md-tab-label><md-tab-body><div \nng-controller=\"RoleTypesController as roleTypesVm\" ng-init=\"roleTypesVm.init(vm.organization.id)\"><div layout=\"row\" \nlayout-align=\"end start\" div class=\"md-inline-form\"><md-button \ntitle=\"{{\'ORGANIZATIONS.MEMBERS_TYPES.ADD\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"roleTypesVm.addRoleType($event)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\">\n</md-icon></md-button></div><div layout=\"row\"><table datatable=\"roletypes-datatable\" \ndt-options=\"roleTypesVm.dtOptions\" dt-columns=\"roleTypesVm.dtColumns\" dt-instance=\"roleTypesVm.dtInstance\" \nclass=\"row-border hover\"></table></div></div></md-tab-body></md-tab><md-tab><md-tab-label><div layout=\"row\" \nclass=\"md-title\">{{\'ORGANIZATIONS.SERVICE_TYPES.SERVICE_TYPES\' | translate}}</div></md-tab-label><md-tab-body><div \nng-controller=\"ServiceTypesController as serviceTypesVm\" ng-init=\"serviceTypesVm.init(vm.organization.id)\"><div \nlayout=\"row\" layout-align=\"end start\" div class=\"md-inline-form\"><md-button \ntitle=\"{{\'ORGANIZATIONS.SERVICE_TYPES.ADD\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"serviceTypesVm.addServiceType($event)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" class=\"md-primary\">\n</md-icon></md-button></div><div layout=\"row\"><table datatable=\"servicetypes-datatable\" \ndt-options=\"serviceTypesVm.dtOptions\" dt-columns=\"serviceTypesVm.dtColumns\" dt-instance=\"serviceTypesVm.dtInstance\" \nclass=\"row-border hover\"></table></div></div></md-tab-body></md-tab><md-tab><md-tab-label><div layout=\"row\" \nclass=\"md-title\">{{\'ORGANIZATIONS.DISCOUNTS.DISCOUNTS\' | translate}}</div></md-tab-label><md-tab-body><div \nng-controller=\"DiscountsController as discountsVm\" ng-init=\"discountsVm.init(vm.organization.id)\"><div layout=\"row\" \nlayout-align=\"end start\" div class=\"md-inline-form\"><md-button title=\"{{\'ORGANIZATIONS.DISCOUNTS.ADD\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"discountsVm.addDiscount($event)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div><div layout=\"row\"><table \ndatatable=\"discounts-datatable\" dt-options=\"discountsVm.dtOptions\" dt-columns=\"discountsVm.dtColumns\" \ndt-instance=\"discountsVm.dtInstance\" class=\"row-border hover\"></table></div></div></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/main/pages/organizations/views/organization_settings/tabs/utilities.html","<div class=\"md-title\">Strumenti di utilità</div><div layout=\"row\" flex=\"100\"><div flex=\"30\"><md-button \naria-label=\"Cambio stagione\" title=\"Cambio stagione\" class=\"md-raised md-accent\" flex=\"100\" \nng-click=\"vm.gotoSeasonChange()\"><md-icon md-font-icon=\"icon-auto-fix\" class=\"md-primary\"></md-icon>Cambio stagione\n</md-button></div><div flex=\"60\"><p>Strumento per guidarti al passaggio alla nuova stagione.</p></div></div>");
$templateCache.put("app/main/pages/organizations/views/role_types/dialogs/delete_roletype_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"delScheduleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PAGES.DELETE\">Delete roletype</h2><span flex></span><md-button \nclass=\"md-icon-button\" aria-label=\"Chiudi\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><h3>{{\'PAGES.DELETE_CONFIRM\' | translate}}</h3></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\" aria-label=\"Elimina\" translate=\"PAGES.DO_DELETE\">Delete\n</md-button><md-button ng-click=\"cancel()\" aria-label=\"Annulla\" translate=\"PAGES.CANCEL\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/role_types/dialogs/edit_role_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"newRoleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.MEMBERS_TYPES.EDIT\">Edit Role</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.MEMBERS_TYPES.MEMBERS_TYPE_NAME\" required>Name</label><input type=\"text\" \nid=\"idOrganizationRoleName\" name=\"roleName\" ng-model=\"roleName\"><div ng-messages=\"newRoleForm.roleName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"ORGANIZATIONS.ERRORS.MEMBERS_TYPE_NAME_REQUIRED\">\nThe role name field is required</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-disabled=\"newRoleForm.$invalid || newRoleForm.$pristine\" \nng-click=\"answer({name: roleName})\" translate=\"ORGANIZATIONS.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"ORGANIZATIONS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/role_types/dialogs/new_role_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"newRoleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"ORGANIZATIONS.MEMBERS_TYPES.ADD\">New Role</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"ORGANIZATIONS.MEMBERS_TYPES.MEMBERS_TYPE_NAME\" required>Name</label><input type=\"text\" \nid=\"idOrganizationRoleName\" name=\"roleName\" ng-model=\"roleName\"><div ng-messages=\"newRoleForm.roleName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"ORGANIZATIONS.ERRORS.MEMBERS_TYPE_NAME_REQUIRED\">\nThe role name field is required</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-disabled=\"newRoleForm.$invalid || newRoleForm.$pristine\" \nng-click=\"answer({name: roleName})\" translate=\"ORGANIZATIONS.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"ORGANIZATIONS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/service_types/dialogs/edit_servicetype_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"myForm\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORGANIZATIONS.SERVICE_TYPES.EDIT\">Edit Service Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\">\n<md-input-container><label translate=\"ORGANIZATIONS.SERVICE_TYPES.SERVICE_TYPE_NAME\" required>Name</label><input \ntype=\"text\" id=\"idOrganizationRoleName\" name=\"serviceTypeName\" ng-model=\"serviceTypeName\"><div \nng-messages=\"myForm.serviceTypeName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ORGANIZATIONS.ERRORS.SERVICE_TYPE_NAME_REQUIRED\">The type name field is required</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"myForm.$invalid || myForm.$pristine\" ng-click=\"answer({name: serviceTypeName})\" \ntranslate=\"ORGANIZATIONS.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/organizations/views/service_types/dialogs/new_servicetype_dialog.html","<md-dialog aria-label=\"New Role\" ng-cloak><form name=\"myForm\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORGANIZATIONS.SERVICE_TYPES.ADD\">New Role</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\">\n<md-input-container><label translate=\"ORGANIZATIONS.SERVICE_TYPES.SERVICE_TYPE_NAME\" required>Name</label><input \ntype=\"text\" id=\"idOrganizationRoleName\" name=\"serviceTypeName\" ng-model=\"serviceTypeName\"><div \nng-messages=\"myForm.serviceTypeName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ORGANIZATIONS.ERRORS.MEMBERS_TYPE_NAME_REQUIRED\">The type name field is required</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"myForm.$invalid || myForm.$pristine\" ng-click=\"answer({name: serviceTypeName})\" \ntranslate=\"ORGANIZATIONS.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" translate=\"ORGANIZATIONS.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/about.html","<div layout=\"row\" class=\"md-padding md-margin\" layout-wrap ng-cloak><div class=\"about\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"65\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"OFFERED_SERVICES.GENERAL_INFORMATION\">General Information</div>\n</header><div class=\"content\"><div layout=\"column\" class=\"md-padding\" layout-align=\"start start\" flex=\"100\" \nflex-gt-sm=\"25\"><div ng-if=\"vm.offeredService.scheduleType === \'R\'\" layout=\"row\"><div layout=\"column\"><div \nclass=\"md-title\">Quando</div>Su richiesta</div></div><div ng-if=\"vm.offeredService.scheduleType === \'D\'\" layout=\"row\">\n<div><div class=\"md-title\">Quando</div>{{vm.formatDateFriendly(vm.offeredService.start)}}<br><span style=\"float: left\" \nng-if=\"vm.offeredService.hourFrom\">\n{{vm.offeredService.hourFrom}}:{{vm.offeredService.minutesFrom ? vm.offeredService.minutesFrom : \'00\'}}</span> <span \nng-if=\"vm.offeredService.hourTo\">\n-{{vm.offeredService.hourTo}}:{{vm.offeredService.minutesTo ? vm.offeredService.minutesTo : \'00\'}}</span></div></div>\n<div ng-if=\"vm.offeredService.scheduleType === \'P\'\" layout=\"row\"><div layout=\"column\"><div class=\"md-title\">Periodo\n</div>{{vm.formatDateFriendly(vm.offeredService.start)}} - {{vm.formatDateFriendly(vm.offeredService.end)}}<br></div>\n</div><div ng-if=\"vm.offeredService.address || (vm.offeredService.latitude && vm.offeredService.longitude)\" \nlayout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Dove</div>{{vm.offeredService.address}}\n<br><a ng-click=\"vm.scrollTo(\'theMap\')\" style=\"cursor: pointer\" \nng-if=\"vm.offeredService.latitude && vm.offeredService.longitude\">Mappa</a></div></div><div \nng-if=\"vm.offeredService.notes\" layout=\"row\" class=\"margin-top-20\"><div layout=\"column\"><div class=\"md-title\">Note\n</div><p>{{vm.offeredService.notes}}</p></div></div></div><div layout-gt-sm=\"row\" \nng-if=\"vm.offeredService.serviceType===\'EVENT\' && vm.offeredService.latitude && vm.offeredService.longitude\"><fieldset \nclass=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\">Google Maps</div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.offeredService.latitude ? vm.offeredService.latitude : 41.8919300}}\"> <input type=\"hidden\" \nclass=\"gllpLongitude\" value=\"{{vm.offeredService.longitude ? vm.offeredService.longitude : 12.5113300 }}\"> <input \ntype=\"hidden\" class=\"gllpZoom\" value=\"6\"></fieldset></div></div></div></div></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/attendances.html","<div layout=\"row\"><table class=\"dataTable row-border hover\" id=\"subscribers-table\" datatable=\"ng\" \ndt-options=\"vm.dtOptionAttendances\" dt-column-defs=\"vm.dtColumnDefsAttendances\"><thead><tr><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Num.</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"><span class=\"column-title\">Note.</span></div></th><th \nclass=\"secondary-text no-sort\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr \nng-repeat=\"attendance in vm.serviceAttendances track by $index\"><td>{{vm.formatDateFromDay(attendance.day)}}</td><td>\n{{attendance.num}}</td><td>{{attendance.note}}</td><td><md-button class=\"md-accent md-raised\" \nng-click=\"vm.goToAttendanceDetail(attendance.day)\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n{{\'PAGES.MANAGE\' | translate}}</md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/edit_detail_deleted.html","<div layout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout=\"column\" flex=\"100\"><md-input-container \nclass=\"md-block\"><label translate=\"OFFERED_SERVICES.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.offeredService.name\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"OFFERED_SERVICES.DESCRIPTION\">Description</label><textarea ng-model=\"vm.offeredService.description\" \nmd-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container><md-input-container \nng-if=\"vm.offeredService.standalone!=\'N\' && vm.offeredService.serviceType===\'SERVICE\'\"><label \ntranslate=\"OFFERED_SERVICES.TYPES\" style=\"padding-bottom:2em\"><strong>Tipologia</strong></label><div \nng-repeat=\"sType in vm.organizationServicetypes\"><md-checkbox \nng-show=\"sType.internalCode==\'SUBSCRIPTION\' && vm.offeredService.scheduleType !== \'A\'\" \nng-model=\"vm.selectedServiceIds[sType.id]\" flex \nng-change=\"vm.serviceTypeChanged(sType, vm.selectedServiceIds[sType.id])\">{{sType.name}} <span \nstyle=\"font-size: 85%; font-style: italic\" ng-if=\"sType.internalCode==\'SUBSCRIPTION\'\">\n- {{\'OFFERED_SERVICES.SUBSCRIPTION_TYPE_HINT\' | translate}}</span></md-checkbox></div><md-input-container \nng-hide=\"vm.isSubscriptionService || (vm.scheduleType === \'A\' && vm.offeredService.includeMoreServices === \'Y\')\">\n<md-checkbox ng-model=\"vm.offeredService.needsOrganizationSubscription\" flex>\n{{\'OFFERED_SERVICES.NEEDS_ORGANIZATION_SUBSCRIPTION\' | translate}}</md-checkbox></md-input-container>\n</md-input-container><md-input-container ng-if=\"vm.offeredService.serviceType===\'SERVICE\'\"><label \ntranslate=\"OFFERED_SERVICES.IS_STANDALONE_QUESTION\">Is standalone</label><md-select required \nng-model=\"vm.offeredService.standalone\" ng-disabled=\"true\"><md-option value=\"S\">\n{{\'OFFERED_SERVICES.IS_STANDALONE\' | translate}}</md-option><md-option value=\"N\">\n{{\'OFFERED_SERVICES.IS_NOT_STANDALONE\' | translate}}</md-option></md-select></md-input-container><div layout=\"row\" div \nclass=\"md-inline-form\"><md-input-container class=\"md-block\"><label translate=\"OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE\" \nrequired>Schedule type</label><md-select ng-model=\"vm.offeredService.scheduleType\" ng-change=\"changeTypeCode()\">\n<md-option value=\"R\">{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND\' | translate}}</md-option><md-option \nvalue=\"P\">{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_IN_PERIOD\' | translate}}</md-option><md-option value=\"D\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_SINGLE_DATE\' | translate}}</md-option><md-option \nng-if=\"vm.offeredService.serviceType !== \'EVENT\'\" value=\"A\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_ACCESS\' | translate}}</md-option></md-select></md-input-container>\n<md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nng-click=\"vm.showHintScheduleType=!vm.showHintScheduleType\"><md-icon id=\"icon-help-chat-type\" \nmd-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button><div class=\"md-yellow-100-bg md-padding\" \nstyle=\"margin:20px\" ng-show=\"vm.showHintScheduleType\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s36 ml-16\"></md-icon>{{\'OFFERED_SERVICES.HINT.SCHEDULE_TYPE\' | translate}}</div><div \nng-if=\"vm.offeredService.serviceType !== \'EVENT\' && vm.offeredService.scheduleType === \'A\'\" layout=\"row\" div \nclass=\"md-inline-form\"><md-input-container class=\"md-block\" ng-show=\"vm.offeredService.scheduleType === \'A\'\"><label \ntranslate=\"OFFERED_SERVICES.NUM_ACCESS\">Number of accesses</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.numMaxAccess\" ng-required=\"vm.offeredService.scheduleType===\'A\' \"></md-input-container>\n</div></div><div layout=\"row\" div class=\"md-inline-form\" \nng-if=\"vm.offeredService.serviceType !== \'EVENT\' && vm.offeredService.scheduleType === \'A\'\"><md-input-container \nng-if=\"vm.offeredService.serviceType !== \'EVENT\' && vm.offeredService.scheduleType === \'A\'\"><span required>\nSi tratta di un servizio indipendente o un carnet che comprende più servizi?</span><md-radio-group \nng-model=\"vm.offeredService.includeMoreServices\" layout=\"column\" ng-change=\"vm.onChangeCarnetType()\"><md-radio-button \nvalue=\"N\">Servizio indipendente</md-radio-button><md-radio-button value=\"Y\">E\' un carnet valido per più servizi\n</md-radio-button></md-radio-group></md-input-container></div><div layout=\"row\" div class=\"md-inline-form\" \nng-if=\"vm.offeredService.serviceType !== \'EVENT\' && vm.offeredService.scheduleType === \'A\'\"><md-input-container \nng-if=\"vm.offeredService.serviceType !== \'EVENT\' && vm.offeredService.includeMoreServices === \'Y\'  && vm.offeredService.scheduleType === \'A\'\">\n<span>Servizi compresi da questo carnet</span>:<div ng-repeat=\"servizioChild in vm.serviziChildAttivabili\"><md-checkbox\n ng-model=\"vm.childServiceToAdd[servizioChild.id]\" flex>{{servizioChild.name }} <span \nng-show=\"servizioChild.needsOrganizationSubscription\">- <cite>Necessita di quota associativa</cite></span> <span \nclass=\"md-warn\" ng-show=\"!servizioChild.enableAttendances && servizioChild.scheduleType !== \'A\'\">&nbsp;<md-icon \nmd-font-icon=\"icon-alert\" class=\"md-warn\"></md-icon>&nbsp;Presenze disabilitate</span></md-checkbox></div>\n</md-input-container></div><div layout=\"row\" div class=\"md-inline-form\" \nng-hide=\"vm.isSubscriptionService || vm.scheduleType === \'A\' || vm.offeredService.includeMoreServices === \'Y\'\">\n<md-input-container><md-checkbox ng-model=\"vm.offeredService.enableAttendances\" flex>Abilita la gestione delle presenze\n</md-checkbox></md-input-container></div><div layout=\"row\" div class=\"md-inline-form\"><div \nng-if=\"vm.offeredService.serviceType === \'EVENT\'\" layout=\"row\" div class=\"md-inline-form\" \nng-show=\"vm.offeredService.scheduleType===\'D\'\"><label translate=\"OFFERED_SERVICES.HOUR_START\" \nstyle=\"padding-top:1.5em;   padding-right: 1em\">Start</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.HOUR_FROM\" ng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input \nng-required=\"vm.offeredService.scheduleType===\'D\'\" ng-model=\"vm.offeredService.hourFrom\" \nng-change=\"vm.changeHourFrom()\" type=\"number\" min=\"0\" max=\"23\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_FROM\' | translate }}\"></md-input-container><md-input-container>\n<label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_FROM\" ng-required=\"vm.offeredService.scheduleType===\'D\'\"></label>\n<input ng-required=\"vm.offeredService.scheduleType===\'D\'\" ng-model=\"vm.offeredService.minutesFrom\" type=\"number\" \nmin=\"0\" max=\"59\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_FROM\' | translate }}\"></md-input-container>\n</div><div ng-if=\"vm.offeredService.serviceType === \'EVENT\'\" layout=\"row\" div class=\"md-inline-form\" \nng-show=\"vm.offeredService.scheduleType===\'D\'\"><label translate=\"OFFERED_SERVICES.HOUR_END\" \nstyle=\"padding-top:1.5em;     padding-right: 1em\">End</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.HOUR_TO\" ng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input \nng-required=\"vm.offeredService.scheduleType===\'D\'\" ng-model=\"vm.offeredService.hourTo\" ng-change=\"vm.changeHourTo()\" \ntype=\"number\" min=\"0\" max=\"23\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_TO\' | translate }}\">\n</md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_TO\" \nng-required=\"vm.offeredService.scheduleType===\'D\'\"></label><input ng-required=\"vm.offeredService.scheduleType===\'D\'\" \nng-model=\"vm.offeredService.minutesTo\" type=\"number\" min=\"0\" max=\"59\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_TO\' | translate }}\"></md-input-container></div></div><div \nlayout=\"row\" div class=\"md-inline-form\"><md-datepicker \nng-show=\"vm.offeredService.scheduleType===\'P\' || vm.offeredService.scheduleType===\'D\'\" \nng-model=\"vm.offeredService.start\" \nng-change=\"vm.offeredServiceStartdateChange(vm.offeredService.start, vm.offeredService.scheduleType);\" \nmd-placeholder=\"{{ ( vm.offeredService.scheduleType===\'D\') ? (\'OFFERED_SERVICES.DATE_ON\' | translate) : (\'OFFERED_SERVICES.START\' | translate) }}\">\n</md-datepicker><md-datepicker ng-show=\"vm.offeredService.scheduleType===\'P\'\" ng-model=\"vm.offeredService.end\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.END\' | translate }}\"></md-datepicker></div><div layout-gt-sm=\"row\" \nng-if=\"vm.offeredService.serviceType===\'EVENT\'\"><md-input-container class=\"md-block\" flex-gt-sm><label>Location</label>\n<input type=\"text\" ng-model=\"vm.offeredService.address\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><md-button title=\"{{\'OFFERED_SERVICES.FIND_ADDRESS\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.updateLocationFromAddress()\" aria-label=\"Update location\">\n<md-icon md-font-icon=\"icon-map-marker-radius\" class=\"md-primary\"></md-icon></md-button></md-input-container></div><div\n layout-gt-sm=\"row\" ng-if=\"vm.offeredService.serviceType===\'EVENT\'\"><fieldset class=\"gllpLatlonPicker\" \nstyle=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" style=\"display:none\"> <input \ntype=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div class=\"gllpMap\">Google Maps</div><input\n type=\"hidden\" class=\"gllpLatitude\" value=\"{{vm.offeredService.latitude ? vm.offeredService.latitude : 41.8919300}}\"> \n<input type=\"hidden\" class=\"gllpLongitude\" \nvalue=\"{{vm.offeredService.longitude ? vm.offeredService.longitude : 12.5113300 }}\"> <input type=\"hidden\" \nclass=\"gllpZoom\" value=\"6\"></fieldset></div><div layout-gt-sm=\"row\" ng-if=\"vm.offeredService.serviceType===\'EVENT\'\">\n<md-input-container class=\"md-block\" flex-gt-sm><md-button title=\"{{\'OFFERED_SERVICES.UPDATE_LOCATION\' | translate}}\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.updateLocationFromMap()\" aria-label=\"Update location\"><md-icon \nmd-font-icon=\"icon-map\" class=\"md-primary\"></md-icon></md-button><span style=\"font-size: 75%\">\n{{\'OFFERED_SERVICES.UPDATE_LOCATION_FROM_MAP\' | translate }}</span></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"OFFERED_SERVICES.LATITUDE\">Latitude</label><input type=\"text\" \nng-model=\"vm.offeredService.latitude\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"OFFERED_SERVICES.LONGITUDE\">Longitude</label><input type=\"text\" ng-model=\"vm.offeredService.longitude\">\n</md-input-container></div><md-input-container><label translate=\"OFFERED_SERVICES.PRICE_TYPE\">Price type</label>\n<md-select required ng-model=\"vm.offeredService.paymentType\" ng-change=\"vm.changePaymentType()\"><md-option value=\"F\">\n{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option><md-option value=\"O\">\n{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" \nng-if=\"vm.offeredService.serviceType===\'SERVICE\' && vm.offeredService.scheduleType!==\'A\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"vm.offeredService.paymentType===\'R\'\"><label translate=\"OFFERED_SERVICES.RENEWAL\">Renewal</label><md-select \nng-required=\"vm.offeredService.paymentType===\'R\' \" ng-model=\"vm.offeredService.paymentRenewInterval\"><md-option \nvalue=\"day\">{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option><md-option value=\"month\">\n{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"year\">{{\'OFFERED_SERVICES.YEAR\' | translate}}\n</md-option><md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</md-option><md-option value=\"2-month\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option value=\"3-month\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label>Numero di rate</label><input type=\"number\" \nmin=\"1\" ng-model=\"vm.offeredService.numMaxRenewal\" ng-required=\"vm.offeredService.paymentType===\'R\'\"><div \nclass=\"font-size-12\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</div><div class=\"font-size-12\" ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n<strong>Totale</strong>: <span ng-if=\"vm.offeredService.subscriptionPrice > 0\">\nIscrizione {{vm.offeredService.subscriptionPrice}} Euro</span> <span \nng-if=\"vm.offeredService.subscriptionPrice > 0 && vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n+ </span><span ng-if=\"vm.offeredService.numMaxRenewal > 0 && vm.offeredService.paymentType===\'R\'\">\n{{vm.offeredService.numMaxRenewal}} Rate x {{vm.offeredService.renewalPrice}} Euro </span>= <strong>\n{{ (vm.offeredService.subscriptionPrice ? vm.offeredService.subscriptionPrice : 0 ) + (vm.offeredService.numMaxRenewal * (vm.offeredService.renewalPrice ? vm.offeredService.renewalPrice : 0 ) )}} Euro\n</strong></div></md-input-container><md-input-container class=\"md-block\" \nng-show=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIPTION_PRICE\">Subscription price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.subscriptionPrice\" \nng-required=\"vm.offeredService.paymentType===\'R\' || vm.offeredService.paymentType===\'O\'\"></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"vm.offeredService.paymentType===\'R\'\"><label \ntranslate=\"OFFERED_SERVICES.RENEWAL_PRICE\">Renewal price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.offeredService.renewalPrice\" ng-required=\"vm.offeredService.paymentType===\'R\' \"></md-input-container><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.offeredService.standalone===\'S\'\"><md-input-container><md-checkbox \nng-model=\"vm.offeredService.hasChat\" aria-label=\"Enable chat\" flex>{{\'OFFERED_SERVICES.ENABLE_MESSAGES\' | translate}}\n</md-checkbox></md-input-container>&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container ng-show=\"vm.offeredService.hasChat\">\n<label translate=\"OFFERED_SERVICES.MESSAGE_TYPES\" required>Message type</label><md-select \nng-model=\"vm.offeredService.chatType\" ng-change=\"changeTypeCode()\"><md-option value=\"N\">\n{{\'OFFERED_SERVICES.NOTIFICATIONS\' | translate}}</md-option><md-option value=\"G\">\n{{\'OFFERED_SERVICES.GROUP_CHAT\' | translate}}</md-option><md-option value=\"B\">\n{{\'OFFERED_SERVICES.BROADCAST_CHAT\' | translate}}</md-option></md-select></md-input-container><md-button \ntitle=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nng-click=\"vm.showHintChatType=!vm.showHintChatType\"><md-icon id=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" \nclass=\"md-primary\"></md-icon></md-button><div class=\"md-yellow-100-bg md-padding\" style=\"margin:20px\" \nng-show=\"vm.showHintChatType\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s36 ml-16\"></md-icon>\n{{\'OFFERED_SERVICES.HINT.CHAT_TYPE\' | translate}}</div></div><md-input-container><label \ntranslate=\"OFFERED_SERVICES.DOCTYPES\" style=\"padding-bottom:2em\">Required documents</label><div \nng-repeat=\"doctype in vm.organizationDoctypes\"><md-checkbox ng-model=\"vm.selecteDoctypeIds[doctype.id]\" \naria-label=\"Enable chat\" flex>{{doctype.name }}</md-checkbox></div></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.NOTES\">NOTES</label><textarea ng-model=\"vm.offeredService.notes\" md-maxlength=\"500\" \nrows=\"5\" md-select-on-focus></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end start\" \nng-if=\"vm.isAdmin && ((vm.offeredService.standalone===\'S\' && vm.selectedTabIndex===1) || (vm.offeredService.standalone!==\'S\' && vm.selectedTabIndex===0))\">\n<div id=\"btn-container\" align=\"right\" class=\"top-page-btns\" style=\"\"><md-button \ntitle=\"{{\'OFFERED_SERVICES.EDIT\' | translate}}\" class=\"md-fab md-warn\" ng-click=\"vm.saveOfferedService();\" \naria-label=\"Edit\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button></div></div>\n</form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/organization.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"OFFERED_SERVICES.ORGANIZATION.INFORMATION\">Organization Information</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"OFFERED_SERVICES.ORGANIZATION.NAME\">Organization Name</div><div \nclass=\"info\">{{ vm.offeredService.organization.name }}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"OFFERED_SERVICES.ORGANIZATION.CONTACTS\">Contacts</div><div class=\"info\">\n{{ vm.offeredService.organization.address }} - {{vm.offeredService.organization.postalCode}} {{vm.offeredService.organization.city}} {{vm.offeredService.organization.province}}\n</div><div class=\"info\">{{\'ORGANIZATIONS.PHONE\' | translate}}: {{ vm.offeredService.organization.phone }}</div><div \nclass=\"info\">{{\'ORGANIZATIONS.MOBILE_PHONE\' | translate}}: {{ vm.offeredService.organization.mobilePhone }}</div><div \nclass=\"info\">{{\'ORGANIZATIONS.FAX\' | translate}}: {{ vm.offeredService.organization.fax }}</div><div class=\"info\">\n{{\'ORGANIZATIONS.EMAIL\' | translate}}: <a href=\"mailto:{{ vm.offeredService.organization.email }}\" target=\"_blank\">\n{{ vm.offeredService.organization.email }}</a></div><div class=\"info\"><a \nng-href=\"{{ vm.offeredService.organization.website }}\" target=\"_blank\">{{\'ORGANIZATIONS.WEBSITE\' | translate}}</a>\n</div></div><div id=\"map\" style=\"width:100%; height:200px\" \nng-if=\"vm.offeredService.organization.longitude \r\n							                && vm.offeredService.organization.longitude!==null \r\n							                && vm.offeredService.organization.latitude \r\n							                && vm.offeredService.organization.latitude!==null\">\n</div></div></div></div></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/resources.html","<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.RESOURCES.NAME\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"OFFERED_SERVICES.RESOURCES.DATE_FROM\">from</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.RESOURCES.DATE_TO\">to</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULE\">time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULE_TYPE\">\nschedule type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.RESOURCES.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"resource in vm.offeredService.serviceResources\"><td style=\"cursor:pointer\" \nng-click=\"vm.editResourceDetails($event,resource)\">\n{{resource.organizationResource.name}} {{(resource.organizationResource.staffMember && resource.organizationResource.staffMember!==null)?\' - \' : \'\'}} {{resource.organizationResource.staffMember.displayName}}\n</td><td style=\"cursor:pointer\" ng-click=\"vm.editResourceDetails($event,resource)\">{{vm.formatDate(resource.dateFrom)}}\n</td><td style=\"cursor:pointer\" ng-click=\"vm.editResourceDetails($event,resource)\">{{vm.formatDate(resource.dateTo)}}\n</td><td style=\"cursor:pointer\" ng-click=\"vm.editResourceDetails($event,resource)\">\n{{resource.hourFrom}}:{{vm.formatMinutes(resource.minutesFrom)}} - {{resource.hourTo}}:{{vm.formatMinutes(resource.minutesTo)}}\n</td><td style=\"cursor:pointer\" ng-click=\"vm.editResourceDetails($event,resource)\" ng-if=\"resource.typeCode==\'S\'\">\n{{\'OFFERED_SERVICES.WEEKLY\' | translate}} - <span ng-if=\"resource.weekDay==1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==2\">\n{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==3\">\n{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==5\">\n{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==6\">\n{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</span> <span ng-if=\"resource.weekDay==0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</span></td><td style=\"cursor:pointer\" \nng-click=\"vm.editResourceDetails($event,resource)\" ng-if=\"resource.typeCode==\'P\'\">\n{{\'OFFERED_SERVICES.PUNCTUAL\' | translate}}</td><td style=\"cursor:pointer\" \nng-click=\"vm.editResourceDetails($event,resource)\" ng-if=\"resource.typeCode==\'G\'\">\n{{\'OFFERED_SERVICES.DAILY\' | translate}}</td><td style=\"cursor:pointer\" \nng-click=\"vm.editResourceDetails($event,resource)\" ng-if=\"resource.typeCode==\'GW\'\">\n{{\'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.askResourceDetails($event,resource)\" aria-label=\"Copy resource\" \ntitle=\"{{\'OFFERED_SERVICES.RESOURCES.COPY\' | translate }}\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.RESOURCES.COPY\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n</md-button><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.deleteResource($event,resource)\" \naria-label=\"Delete resource\" title=\"{{\'OFFERED_SERVICES.RESOURCES.DELETE\' | translate }}\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.RESOURCES.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/schedules.html","<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.SCHEDULES.DATE_FROM\">from</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULES.DATE_TO\">to</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULE\">time\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.SCHEDULE_TYPE\">schedule type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULES.ACTIONS\">Actions</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.offeredService.serviceSchedules\"><td style=\"cursor:pointer\" \nng-click=\"vm.editScheduleDetails($event,schedule)\">{{vm.formatDate(schedule.dateFrom)}}</td><td style=\"cursor:pointer\" \nng-click=\"vm.editScheduleDetails($event,schedule)\">{{vm.formatDate(schedule.dateTo)}}</td><td style=\"cursor:pointer\" \nng-click=\"vm.editScheduleDetails($event,schedule)\">\n{{schedule.hourFrom}}:{{vm.formatMinutes(schedule.minutesFrom)}} - {{schedule.hourTo}}:{{vm.formatMinutes(schedule.minutesTo)}}\n</td><td style=\"cursor:pointer\" ng-if=\"schedule.typeCode==\'S\'\" ng-click=\"vm.editScheduleDetails($event,schedule)\">\n{{\'OFFERED_SERVICES.WEEKLY\' | translate}} - <span ng-if=\"schedule.weekDay==1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==2\">\n{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==3\">\n{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==5\">\n{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==6\">\n{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</span> <span ng-if=\"schedule.weekDay==0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</span></td><td style=\"cursor:pointer\" ng-if=\"schedule.typeCode==\'P\'\" \nng-click=\"vm.editScheduleDetails($event,schedule)\">{{\'OFFERED_SERVICES.PUNCTUAL\' | translate}}</td><td \nstyle=\"cursor:pointer\" ng-if=\"schedule.typeCode==\'G\'\" ng-click=\"vm.editScheduleDetails($event,schedule)\">\n{{\'OFFERED_SERVICES.DAILY\' | translate}}</td><td style=\"cursor:pointer\" ng-if=\"schedule.typeCode==\'GW\'\" \nng-click=\"vm.editScheduleDetails($event,schedule)\">{{\'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</td><td>\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.askScheduleDetails($event,schedule)\" \naria-label=\"Copy schedule\" title=\"{{\'OFFERED_SERVICES.SCHEDULES.COPY\' | translate }}\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.SCHEDULES.COPY\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n</md-button><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.deleteSchedule($event,schedule)\" \naria-label=\"Delete schedule\" title=\"{{\'OFFERED_SERVICES.SCHEDULES.DELETE\' | translate }}\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.SCHEDULES.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/subscribers.html","<div layout=\"row\" class=\"page-layout\"><md-input-container flex=\"20\" class=\"md-block\" flex-gt-xs=\"20\" \nng-show=\"vm.showFilters\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nid=\"subscribers-search\" type=\"text\" placeholder=\"{{\'ORGANIZATIONS.SEARCH\' | translate }}\" translate flex>\n</md-input-container><md-input-container flex=\"20\" flex-gt-xs=\"20\" ng-show=\"vm.showFilters\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\" required>Payments</label><md-select id=\"payments-filter\" \nng-model=\"vm.searchFilter.paymentStatus\" ng-change=\"vm.doSubscribersSearch()\"><md-option value=\"A\">\n{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option value=\"M\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.PAYMENTS_MISSING\' | translate}}</md-option><md-option value=\"D\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.PAYMENTS_DONE\' | translate}}</md-option></md-select></md-input-container>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container flex=\"30\" flex-gt-xs=\"30\" ng-show=\"vm.showFilters\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.DOCUMENTS\" required>Documents</label><md-select id=\"documents-filter\" \nng-model=\"vm.searchFilter.documentStatus\" ng-change=\"vm.doSubscribersSearch()\"><md-option value=\"\">\n{{\'OFFERED_SERVICES.ALL\' | translate}}</md-option><md-option value=\"MISSING\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_MISSING_DOCS\' | translate}}</md-option><md-option value=\"EXPIRED\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_EXPIRED_DOCS\' | translate}}</md-option><md-option value=\"EXPIRING\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_EXPIRING_DOCS\' | translate}}</md-option><md-option value=\"REJECTED\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_REJECTED_DOCS\' | translate}}</md-option><md-option value=\"VALIDATED\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_VALIDATED_DOCS\' | translate}}</md-option><md-option value=\"TO_BE_VALIDATED\">\n{{\'OFFERED_SERVICES.SUBSCRIBER.SEARCH_TO_BE_VALIDATED_DOCS\' | translate}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"20\" flex-gt-xs=\"20\" ng-show=\"vm.showFilters\"><label required>Riscontro tessera</label>\n<md-select id=\"card-filter\" ng-model=\"vm.searchFilter.hasCard\" ng-change=\"vm.doSubscribersSearch()\"><md-option \nvalue=\"\">Tutti</md-option><md-option value=\"Y\">Sì</md-option><md-option value=\"N\">No</md-option></md-select>\n</md-input-container><md-button ng-if=\"vm.isAdmin\" ng-show=\"!vm.showFilters\" \ntitle=\"{{\'OFFERED_SERVICES.SUBSCRIBER.ADD\' | translate}}\" class=\"md-accent\" ng-click=\"vm.showFilters=true\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-filter-outline\" class=\"md-primary\"></md-icon>{{\'SHOW_FILTERS\'|translate}}\n</md-button><md-button ng-if=\"vm.isAdmin\" ng-show=\"vm.showFilters\" \ntitle=\"{{\'OFFERED_SERVICES.SUBSCRIBER.ADD\' | translate}}\" class=\"md-accent\" ng-click=\"vm.showFilters=false\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-filter-outline\" class=\"md-primary\"></md-icon>{{\'HIDE_FILTERS\'|translate}}\n</md-button></div><div layout=\"column\" flex=\"100\"><table class=\"dataTable row-border hover\" id=\"subscribers-table-2\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionSubscribers2\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">&nbsp;</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Iscritto</span></div></th><th class=\"secondary-text\" ng-if=\"vm.offeredService.scheduleType===\'A\'\">\n<div class=\"table-header\"><span class=\"column-title\">Carnet</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.offeredService.serviceType !== \'EVENT\'\"><div class=\"table-header\"><span class=\"column-title\">Periodo</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\">Payments</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SUBSCRIBER.DOCUMENTS\">Documents</span>\n</div></th><th ng-if=\"vm.isSubscriptionService\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Riscontro tessera</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr \nng-repeat=\"subscriber in vm.serviceSubscribers\"><td><img md-menu-align-target \nng-if=\"!subscriber.uriAvatar || subscriber.uriAvatar===null\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> \n<img md-menu-align-target ng-if=\"subscriber.uriAvatar && subscriber.uriAvatar!==null\" class=\"avatar\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{subscriber.id}}/download/{{ subscriber.uriAvatar }}\">\n</td><td><div>{{subscriber.familyName}} {{subscriber.givenName}}</div><div \nng-if=\"!subscriber.email.endsWith(\'invalid\')\">{{ subscriber.email }}</div><div \nng-if=\"vm.offeredService.id !== subscriber.offeredServiceId\"><cite>(* {{subscriber.offeredServiceName}})</cite></div>\n</td><td ng-if=\"vm.offeredService.scheduleType===\'A\'\"><ov-subscription-carnet-status \ncarnetstatus=\"subscriber.carnetSummary\"></ov-subscription-carnet-status></td><td \nng-if=\"vm.offeredService.serviceType !== \'EVENT\'\"><span ng-if=\"subscriber.subscriptionDtStart \">\ndal {{ vm.formatDate(subscriber.subscriptionDtStart) }}</span> <span ng-if=\"subscriber.subscriptionDtEnd \"><br \nng-if=\"subscriber.subscriptionDtStart\">al {{ vm.formatDate(subscriber.subscriptionDtEnd) }}</span></td><td>\n<ov-subscription-payments-status class=\"ov-cursor-pointer\" \nng-click=\"vm.goToSubscriptionPayments(subscriber.subscriptionId);\" totaldue=\"subscriber.totalDue\" \ntotalpaid=\"subscriber.totalPaid\" todaydue=\"subscriber.todayDue\" todaypaid=\"subscriber.todayPaid\">\n</ov-subscription-payments-status></td><td><ul><li ng-repeat=\"doc in subscriber.docs\">\n{{ doc.name }}: {{ \'OFFERED_SERVICES.DOC_STATUS.\' + doc.status | translate }}</li></ul></td><td \nng-if=\"vm.isSubscriptionService\"><md-checkbox ng-model=\"subscriber.subscriptionHasCard\" \nng-change=\"vm.saveHasCard(subscriber.subscriptionId, subscriber.subscriptionHasCard)\"></md-checkbox><md-icon \nng-if=\"subscriber.subscriptionHasCard\" style=\"cursor: pointer\" md-font-icon=\"icon-credit-card\" \nng-click=\"vm.modificaNumTessera(subscriber.subscriptionId)\"></md-icon></td><td><md-button \nclass=\"edit-button md-icon-button\" \nng-if=\"vm.userTemplate && vm.userTemplate.template && vm.userTemplate.template.items && vm.userTemplate.template.items.length > 0 && subscriber.subscriptionDyndocId\" \nng-click=\"vm.showSubscriptionForm($event, subscriber)\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIPTION_FORM\" \ntitle=\"{{\'OFFERED_SERVICES.SUBSCRIPTION_FORM\' | translate}}\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button>\n</td><td><md-button ng-disabled=\"subscriber.totalDue <= subscriber.totalPaid\" class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoPaymentWindow(subscriber);\" aria-label=\"Paga\" title=\"Paga\"><md-icon md-font-icon=\"icon-currency-eur\">\n</md-icon></md-button><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.gotoUserDetail(subscriber.userId);\" \naria-label=\"Scheda personale\" title=\"Scheda personale\"><md-icon md-font-icon=\"icon-account-box\"></md-icon></md-button>\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.validateUserDocuments($event, subscriber)\" \naria-label=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.VALIDATE_DOCS\' | translate }}\" \ntitle=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.VALIDATE_DOCS\' | translate }}\"><md-icon md-font-icon=\"icon-file-document\">\n</md-icon></md-button><cite \nng-if=\"vm.offeredService.id !== subscriber.offeredServiceId && vm.offeredService.scheduleType === \'A\'\">\nGestione in \'{{subscriber.offeredServiceName}}\'</cite><md-button \nng-hide=\"vm.offeredService.id !== subscriber.offeredServiceId && vm.offeredService.scheduleType === \'A\'\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.editSubscriber($event, subscriber)\" aria-label=\"Edit\" translate \ntranslate-attr-aria-label=\"OFFERED_SERVICES.EDIT\" title=\"{{\'OFFERED_SERVICES.EDIT\' | translate}}\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nng-hide=\"vm.offeredService.id !== subscriber.offeredServiceId && vm.offeredService.scheduleType === \'A\'\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.deleteSubscriber($event, subscriber)\" \naria-label=\"{{ \'OFFERED_SERVICES.DELETE\' | translate }}\" translate translate-attr-aria-label=\"OFFERED_SERVICES.DELETE\" \ntitle=\"{{\'OFFERED_SERVICES.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><utton \nclass=\"edit-button md-icon-button\" ng-click=\"vm.addOrderMancanti(subscriber.subscriptionId);\" \naria-label=\"Generazione automatica piano pagamenti (temporaneo)\" \ntitle=\"Generazione automatica piano pagamenti (temporaneo)\" style=\"display: none\"><md-icon \nmd-font-icon=\"icon-auto-fix\"></md-icon></utton></td></tr></tbody></table></div><div>{{ vm.serviceSubscribersOld }}\n</div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/subscription_page_deleted.html","<div layout=\"row\" layout-wrap><form name=\"userAttributes\" flex=\"100\"><div layout-gt-xs=\"row\" div \nclass=\"md-inline-form\" layout-align=\"start center\"><md-input-container><md-checkbox \nng-model=\"vm.flgHasSubscriptionByQrCode\" flex>{{\'OFFERED_SERVICES.FLG_USE_SUBSCRIPTION_QR_CODE\' | translate }}\n</md-checkbox></md-input-container><md-button class=\"md-accent md-raised\" ng-click=\"vm.saveSubscriptionByQrCode();\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.SAVE\' | translate}}</md-button><span class=\"md-title\" \nng-if=\"vm.offeredService.subscriptionQrCodeUri\"><md-button ngclipboard \ndata-clipboard-text=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.offeredService.organizationId }}/download/{{vm.offeredService.subscriptionQrCodeUri }}\" \nclass=\"md-warn\" aria-label=\"copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.COPY_LINK\' | translate}}</md-button></span><span ng-if=\"vm.offeredService.subscriptionQrCodeUri\">\n<img class=\"w-160 h-160\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.offeredService.organizationId }}/download/{{vm.offeredService.subscriptionQrCodeUri }}\">\n</span></div><div layout-gt-xs=\"row\" div class=\"md-inline-form\" layout-align=\"start center\"><md-input-container>\n<md-checkbox ng-model=\"vm.flgHasSubscriptionPage\" ng-change=\"vm.changeHasSubscriptionPage()\" flex>\n{{\'OFFERED_SERVICES.FLG_USE_PUBLIC_SUBSCRIPTION_PAGE\' | translate }}</md-checkbox></md-input-container><md-button \nng-if=\"!vm.subscriptionPage\" class=\"md-accent md-raised\" ng-click=\"vm.deleteSubscriptionPage();\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon>{{\'OFFERED_SERVICES.SAVE\' | translate}}</md-button>\n<md-button ng-if=\"vm.subscriptionPage\" class=\"md-accent md-raised\" ng-click=\"vm.saveSubscriptionPage();\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.SAVE\' | translate}}</md-button></div><div ng-if=\"vm.subscriptionPage\"><span class=\"md-title\" \nng-if=\"vm.subscriptionPage.id\"><a ng-href=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\" id=\"page_link\" \ntarget=\"_blank\">{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_LINK\' | translate}}</a><md-button ngclipboard \ndata-clipboard-text=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\" class=\"md-warn\" aria-label=\"copy\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"md-primary\"></md-icon>{{\'OFFERED_SERVICES.COPY_LINK\' | translate}}\n</md-button><a href=\"#\" socialshare socialshare-provider=\"facebook\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"twitter\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-twitter-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"google\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon \nmd-font-icon=\"icon-google-plus-box\" class=\"md-accent\"></md-icon></a><a href=\"#\" socialshare \nsocialshare-provider=\"linkedin\" socialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon \nmd-font-icon=\"icon-linkedin-box\" class=\"md-accent\"></md-icon></a></span><div layout=\"row\"><md-input-container \nflex=\"100\"><label translate=\"OFFERED_SERVICES.SUBSCRIPTION_PAGE_TITLE\" required>Title</label><input type=\"text\" \nname=\"title\" ng-model=\"vm.subscriptionPage.title\"></md-input-container></div><br><br><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.options[\'allow-social-share\']\" flex>\nInserisci nella pagina bottoni di condivisione social</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.offeredService.latitude || !vm.offeredService.longitude\" \nng-model=\"vm.subscriptionPageOptions.options[\'show-location\']\" flex>Mostra mappa con la location</md-checkbox><br>\n</div><br><br><br><br><div layout=\"row\"><strong>{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_FIELDS\' | translate}}</strong>\n</div><div layout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'birthDate\']\" flex>\n{{\'OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\' | translate}}</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.fields[\'gender\']\" flex>{{\'USERS.GENDER\' | translate}}</md-checkbox><br></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'taxCode\']\" flex>{{\'USERS.TAX_CODE\' | translate}}\n</md-checkbox><br></div><div layout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'address\']\" flex>\n{{\'USERS.ADDRESS\' | translate}}</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.fields[\'city\']\" flex>{{\'USERS.CITY\' | translate}}</md-checkbox><br></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'phone\']\" flex>{{\'USERS.PHONE\' | translate}}\n</md-checkbox><br></div><br><br><br><br><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.showAttachableServices\" flex>\nMostra anche servizi a pacchetto nel modulo di iscrizione</md-checkbox><br></div><br><br><br><strong>\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_ADDITIONAL_FIELDS\' | translate}}</strong><md-tabs md-dynamic-height \nmd-selected=\"selectedIndex\"><md-tab><md-tab-label>Designer</md-tab-label><md-tab-body><div layout=\"column\" \nlayout-align=\"center start\"><div ui-sortable=\"vm.sortableFieldOptions\" ng-model=\"vm.userTemplate.template.items\" flex \nlayout=\"column\" layout-wrap style=\"width: 100%\" class=\"md-blue-grey-100-bg\"><ms-widget ui-sortable-selectable flex \nng-repeat=\"item in vm.userTemplate.template.items track by $index\"><ms-widget-front class=\"padding-16\" \nstyle=\"background-color:white\"><div layout=\"row\"><md-input-container flex=\"30\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_LABEL\' | translate}}</label><input type=\"text\" ng-model=\"item.caption\" \nng-change=\"vm.calculateTemplateItemName(item)\" required=\"required\"></md-input-container><md-input-container flex=\"30\">\n<label>{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_NAME\' | translate}}</label><input type=\"text\" ng-model=\"item.name\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"20\"><label>Tipo</label><md-select \nng-model=\"item.type\"><md-option value=\"text\">{{\'ORGANIZATIONS.FORM_DESIGNER.TEXT_FIELD\' | translate}}</md-option>\n<md-option value=\"checkbox\">{{\'ORGANIZATIONS.FORM_DESIGNER.CHECKBOX\' | translate}}</md-option><md-option \nvalue=\"select\">{{\'ORGANIZATIONS.FORM_DESIGNER.COMBOBOX\' | translate}}</md-option><md-option value=\"radio\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.RADIOBUTTONS\' | translate}}</md-option><md-option value=\"label\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.LABEL\' | translate}}</md-option></md-select></md-input-container><md-input-container \nflex=\"10\"><md-button ng-click=\"vm.removeItem($index);\" class=\"md-icon-button\" aria-label=\"Add\" \ntitle=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\">\n</md-icon></md-button></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container \nflex ng-if=\"item.type!==\'label\'\"><md-checkbox ng-model=\"item.options.required\" aria-label=\"Disabled\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.REQUIRED\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if=\"item.type===\'label\'\" flex><label>Tag</label><md-select ng-model=\"item.options[\'html-tag\']\"><md-option \nvalue=\"span\"><span></span></md-option><md-option value=\"h1\"><h1>H1</h1></md-option><md-option value=\"h2\"><h2>H2</h2>\n</md-option><md-option value=\"h3\"><h3>H3</h3></md-option><md-option value=\"h4\"><h4>H4</h4></md-option><md-option \nvalue=\"h5\"><h5>H5</h5></md-option></md-select></md-input-container><md-input-container ng-if=\"item.type===\'label\'\" \nflex><label>{{\'ORGANIZATIONS.FORM_DESIGNER.COLOR\' | translate}}</label><input type=\"text\" \nng-model=\"item.options.color\"></md-input-container></div><div ng-if=\"item.type===\'select\' || item.type===\'radio\'\" \nstyle=\"margin: 10px\" flex=\"33\">{{\'ORGANIZATIONS.FORM_DESIGNER.VALUES\' | translate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n<md-button ng-click=\"vm.addChoice(item);\" class=\"md-icon-button\" title=\"Nuovo valore\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"green-500-fg\"></md-icon></md-button><div layout=\"row\" \nng-repeat=\"c in item.choices track by $index\" style=\"border: 1px solid #ddd; margin-bottom:4px\"><md-input-container \nflex=\"40\"><label>{{\'ORGANIZATIONS.FORM_DESIGNER.VALUE\' | translate}}</label><input type=\"text\" ng-model=\"c.uuid\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"40\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.DESCRIPTION\' | translate}}</label><input type=\"text\" ng-model=\"c.caption\" \nrequired=\"required\"></md-input-container><md-button ng-click=\"vm.removeChoice(item, $index);\" class=\"md-icon-button\" \naria-label=\"Add\" title=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"red-500-fg\"></md-icon></md-button></div></div></div></ms-widget-front></ms-widget></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.addTemplateItem()\" aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" \ntranslate=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" translate-attr-aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\">\nNew field</md-button></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.reloadPreview()\">\n\"src/app/main/directives/dynamic-document/templates/textarea.html\"<md-tab-label>Anteprima</md-tab-label><md-tab-body>\n<div style=\"background-color: white; padding: 30px\"><dynamic-document ng-data-url=\"\" ng-template-url=\"\" \nng-stats-url=\"\" ng-save-url=\"\" on-success=\"\" on-error=\"\" ng-edit-mode=\"true\"></dynamic-document></div></md-tab-body>\n</md-tab><md-tab><md-tab-label>Sorgente JSON</md-tab-label><md-tab-body><div style=\"height: 800px\"><angular-jsoneditor \nng-model=\"vm.userTemplate.template\" options=\"vm.jsonOptions\" style=\"width: 100%; height: 800px\"></angular-jsoneditor>\n</div></md-tab-body></md-tab></md-tabs></div></form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/children.html","<div layout=\"column\" class=\"md-padding\"><md-card flex=\"100\"><md-card-title layout=\"column\"><md-card-title-text><span \nclass=\"md-headline\">Sottoservizi</span></md-card-title-text><md-card-content>\nQui verranno messi i servizi accessori riferiti a questo servizio. Torna presto a vederli!</md-card-content>\n</md-card-title></md-card></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/main.html","<div layout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout=\"column\" flex=\"100\"><div layout=\"row\" flex=\"100\">\n<md-card flex=\"100\"><md-card-content layout=\"column\" layout-align=\"space-between\"><span class=\"md-title\">Logo</span>\n<div layout=\"row\"><div id=\"document-logo-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flowLogo\" \nflow-files-submitted=\"vm.upload(\'LOGO\')\" flow-file-added=\"vm.fileAdded($file, \'LOGO\')\" \nflow-file-success=\"vm.fileSuccess($file, $message, \'LOGO\')\" flow-file-error=\"vm.fileError( $file, $message, $flow )\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" id=\"logo-uploader\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>{{\'USERS.AVATAR\' | translate }}\n</md-button></div></div><div layout=\"row\" ng-if=\"vm.item.uriLogo\"><md-button aria-label=\"Delete image\" \nclass=\"md-icon-button\" ng-click=\"vm.removeLogo()\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-primary icona-cancella-media\" style=\"color: #999; cursor: pointer\"></md-icon></md-button></div></div><div>\n<span class=\"font-size-12\">L\'immagine del logo deve essere una immagine quadrata in formato jpeg o png.</span></div>\n</md-card-content></md-card></div><div layout=\"row\" flex=\"100\"><md-card flex=\"100\"><md-card-content layout=\"column\" \nlayout-align=\"space-between\"><span class=\"md-title\">Informazioni generali</span><md-input-container class=\"md-block\">\n<label>{{ \'OFFERED_SERVICES.SETTINGS.NAME\' | translate }}</label><input type=\"text\" ng-model=\"vm.item.name\">\n</md-input-container><md-input-container ng-if=\"vm.item.serviceType === \'SERVICE\'\"><label>\n{{ \'OFFERED_SERVICES.IS_STANDALONE_QUESTION\' | translate }}</label><md-select required ng-model=\"vm.item.standalone\" \nng-disabled=\"true\"><md-option value=\"S\">{{ \'OFFERED_SERVICES.IS_STANDALONE\' | translate }}</md-option><md-option \nvalue=\"N\">{{ \'OFFERED_SERVICES.IS_NOT_STANDALONE\' | translate }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>{{ \'OFFERED_SERVICES.SETTINGS.DESCRIPTION\' | translate }}</label><textarea \nng-model=\"vm.item.description\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container><span \nclass=\"md-title pt-32\">Localizzazione</span><div layout-gt-sm=\"row\"><div flex=\"50\" layout=\"column\"><div flex=\"100\">\n<fieldset class=\"gllpLatlonPicker\" style=\"border: none; width: 100%\"><input type=\"text\" class=\"gllpSearchField\" \nstyle=\"display:none\"> <input type=\"button\" class=\"gllpSearchButton\" value=\"search\" style=\"display:none\"><div \nclass=\"gllpMap\">Google Maps</div><input type=\"hidden\" class=\"gllpLatitude\" \nvalue=\"{{vm.item.latitude ? vm.item.latitude : 41.8919300}}\"> <input type=\"hidden\" class=\"gllpLongitude\" \nvalue=\"{{vm.item.longitude ? vm.item.longitude : 12.5113300 }}\"> <input type=\"hidden\" class=\"gllpZoom\" value=\"6\">\n</fieldset></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"OFFERED_SERVICES.LATITUDE\">Latitude</label><input type=\"text\" ng-model=\"vm.item.latitude\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"OFFERED_SERVICES.LONGITUDE\">\nLongitude</label><input type=\"text\" ng-model=\"vm.item.longitude\"></md-input-container></div><div flex=\"100\" \nng-if=\"false\"><md-input-container class=\"md-block\" flex-gt-sm><md-button \ntitle=\"{{\'OFFERED_SERVICES.UPDATE_LOCATION\' | translate}}\" class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.updateLocationFromMap()\" aria-label=\"Update location\"><md-icon md-font-icon=\"icon-map\" class=\"md-primary\">\n</md-icon></md-button><span style=\"font-size: 75%\">{{\'OFFERED_SERVICES.UPDATE_LOCATION_FROM_MAP\' | translate }}</span>\n</md-input-container></div></div><div flex=\"50\" layout=\"column\"><div layout-gt-sm=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"80\"><label>Indirizzo</label><input type=\"text\" ng-model=\"vm.item.address\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Civico</label><input type=\"text\" \nng-model=\"vm.item.addressNumber\"></md-input-container></div><div layout-gt-sm=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\"><label>CAP</label><input type=\"text\" ng-model=\"vm.item.postalCode\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"60\"><label>Città</label><input type=\"text\" \nng-model=\"vm.item.city\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><label>Provincia\n</label><input type=\"text\" ng-model=\"vm.item.province\"></md-input-container></div><div layout-gt-sm=\"row\" flex=\"100\" \nlayout-align=\"end center\"><md-input-container flex-gt-sm=\"10\"><md-button title=\"Aggiorna mappa\" \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.updateLocationFromAddress()\" aria-label=\"Aggiorna mappa\">\n<md-icon md-font-icon=\"icon-map-marker-radius\" class=\"md-primary\"></md-icon></md-button></md-input-container></div>\n</div></div></md-card-content></md-card></div><div layout=\"row\" flex=\"100\"><md-card flex=\"100\"><md-card-content \nlayout=\"column\" layout-align=\"space-between\"><span class=\"md-title\">Dettagli attività</span><div layout-gt-sm=\"row\" \nflex-gt-sm=\"100\" class=\"pb-16\"><div flex=\"50\" class=\"p-8\"><md-chips ng-model=\"vm.categories.selectedItems\" \nmd-autocomplete-snap md-transform-chip=\"vm.categories.transformChip($chip)\" md-require-match=\"true\" \ninput-aria-label=\"Categorie attività\"><md-autocomplete id=\"autocomplete-categories\" \nmd-selected-item=\"vm.categories.selectedItem\" md-search-text=\"vm.categories.searchText\" \nmd-items=\"item in vm.categories.querySearch(vm.categories.searchText)\" md-item-text=\"item.name\" md-min-length=\"2\" \nmd-delay=\"250\" input-aria-describedby=\"Selezionare categorie attività\" placeholder=\"Cerca una categoria\"><span \nmd-highlight-text=\"vm.categories.searchText\">{{item.name}}</span></md-autocomplete><md-chip-template><span><strong>\n{{$chip.name}}</strong></span></md-chip-template></md-chips></div><div flex=\"50\" class=\"p-8\">\nCategorie associate (es. \'rugby\', \'nuoto\', \'prevenzione cardiovascolare\', \'adatto a bambini/anziani\', ...)</div></div>\n<div layout-gt-sm=\"row\" flex-gt-sm=\"100\" class=\"pb-16\"><md-slider-container flex=\"50\"><md-slider min=\"0\" max=\"100\" \nng-model=\"vm.item.intensity\" aria-label=\"Intensità dell\'attività\"></md-slider></md-slider-container><div flex=\"50\" \nclass=\"p-8\">Intensità dell\'attività: <span ng-if=\"vm.item.intensity <= 15\">Molto bassa</span> <span \nng-if=\"vm.item.intensity > 15 && vm.item.intensity <= 30\">Bassa</span> <span \nng-if=\"vm.item.intensity > 30 && vm.item.intensity <= 70\">Media</span> <span ng-if=\"vm.item.intensity > 70\">Alta</span>\n</div></div><div layout-gt-sm=\"row\" flex-gt-sm=\"100\"><md-slider-container flex=\"50\"><md-slider min=\"0\" max=\"100\" \nng-model=\"vm.item.ageFrom\" aria-label=\"Età minima consigliata\"></md-slider></md-slider-container><div flex=\"50\" \nclass=\"p-8\">Età minima consigliata: {{ vm.item.ageFrom }}</div></div><div layout-gt-sm=\"row\" flex-gt-sm=\"100\" \nclass=\"pb-16\"><md-slider-container flex=\"50\"><md-slider min=\"0\" max=\"100\" ng-model=\"vm.item.ageTo\" \naria-label=\"Età massima consigliata\"></md-slider></md-slider-container><div flex=\"50\" class=\"p-8\">\nEtà massima consigliata: {{ vm.item.ageTo }}</div></div><div layout-gt-sm=\"row\" flex-gt-sm=\"100\"><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><md-switch ng-model=\"vm.item.isIndoor\" aria-label=\"Attività indoor\"></md-switch>\n</div><div flex=\"50\" layout=\"row\" layout-align=\"start center\" class=\"p-8\">Attività svolta indoor: <span \nng-if=\"vm.item.isIndoor === true\">sì</span> <span ng-if=\"vm.item.isIndoor === false\">no</span></div></div><div \nlayout-gt-sm=\"row\" flex-gt-sm=\"100\"><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-switch \nng-model=\"vm.item.isOutdoor\" aria-label=\"Attività outdoor\"></md-switch></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"start center\" class=\"p-8\">Attività svolta outdoor: <span ng-if=\"vm.item.isOutdoor === true\">sì</span> \n<span ng-if=\"vm.item.isOutdoor === false\">no</span></div></div></md-card-content></md-card></div><div layout=\"row\" \nflex=\"100\"><md-card flex=\"100\"><md-card-content layout=\"column\" layout-align=\"space-between\"><span class=\"md-title\">\nNote</span><md-input-container><label>{{ \'OFFERED_SERVICES.SETTINGS.NOTES\' | translate }}</label><textarea \nng-model=\"vm.item.notes\" md-maxlength=\"500\" rows=\"10\" md-select-on-focus></textarea></md-input-container>\n</md-card-content></md-card></div></div></form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/options.html","<div layout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout=\"column\" flex=\"100\" \nclass=\"md-inline-form contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Opzioni</h3><div \nlayout=\"row\" class=\"md-inline-form\" \nng-hide=\"vm.isSubscriptionService || (vm.scheduleType === \'A\' && vm.offeredService.includeMoreServices === \'Y\')\">\n<md-input-container><md-checkbox ng-model=\"vm.item.needsOrganizationSubscription\" flex>\n{{\'OFFERED_SERVICES.NEEDS_ORGANIZATION_SUBSCRIPTION\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"row\" class=\"md-inline-form\" \nng-hide=\"vm.isSubscriptionService || vm.item.scheduleType === \'A\' || vm.item.includeMoreServices === \'Y\'\">\n<md-input-container><md-checkbox ng-model=\"vm.item.enableAttendances\" flex>Abilita la gestione delle presenze\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"vm.item.standalone===\'S\'\"><div layout=\"row\" style=\"width: 100%\"><md-input-container flex=\"30\"><md-checkbox \nng-model=\"vm.item.hasChat\" aria-label=\"Enable chat\" flex>{{\'OFFERED_SERVICES.ENABLE_MESSAGES\' | translate}}\n</md-checkbox></md-input-container><md-input-container ng-show=\"vm.item.hasChat\" flex=\"30\"><label \ntranslate=\"OFFERED_SERVICES.MESSAGE_TYPES\">Message type</label><md-select ng-model=\"vm.item.chatType\"><md-option \nvalue=\"N\">{{ \'OFFERED_SERVICES.NOTIFICATIONS\' | translate }}</md-option><md-option value=\"G\">\n{{ \'OFFERED_SERVICES.GROUP_CHAT\' | translate }}</md-option><md-option value=\"B\">\n{{ \'OFFERED_SERVICES.BROADCAST_CHAT\' | translate }}</md-option></md-select></md-input-container><md-button \ntitle=\"{{ \'OFFERED_SERVICES.MORE_INFO\' | translate }}\" class=\"md-icon-button md-accent\" \nng-click=\"vm.showHintChatType=!vm.showHintChatType\"><md-icon id=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" \nclass=\"md-primary\"></md-icon></md-button></div><div class=\"ov-box ov-box-info\" ng-show=\"vm.showHintChatType\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s36 ml-16\"></md-icon>{{ \'OFFERED_SERVICES.HINT.CHAT_TYPE\' | translate }}\n</div></div><md-input-container><h3 class=\"titolo-blocco-contenuto\">Documenti necessari</h3><div layout=\"row\" \nstyle=\"width: 100%\"><div ng-repeat=\"doctype in vm.organizationDoctypes\" flex=\"25\"><md-checkbox \nng-model=\"vm.selecteDoctypeIds[doctype.id]\" aria-label=\"Enable chat\" flex>{{doctype.name }}</md-checkbox></div></div>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/payment_plans.html","<div layout=\"column\" class=\"md-padding\"><md-card flex=\"100\"><md-card-title layout=\"column\"><md-card-title-text><span \nclass=\"md-headline\">Modalità di pagamento</span></md-card-title-text><md-card-content>Se vuoi permettere a <strong>\n{{ vm.item.name }}</strong> di essere pagato con diverse modalità e/o tempistiche, puoi aggiungerle qui.\n</md-card-content></md-card-title></md-card><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" \nng-if=\"vm.loading.children\"><md-progress-circular class=\"md-accent\"></md-progress-circular></div><md-card flex=\"100\" \nng-repeat=\"child in vm.children track by $index\" class=\"brown-50-bg\" ng-if=\"!vm.loading.children\" \nid=\"child-{{ child.id ? child.id : \'new\' }}\"><a name=\"child-{{ child.id ? child.id : \'new\' }}\"></a><md-card-content \nlayout=\"column\" flex=\"100\"><md-card-title-text layout=\"column\"><span class=\"md-headline\"><span ng-if=\"!child._editing\">\n{{ child.name }}</span> <span ng-if=\"!child._editing\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editPayment(child);\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.deleteChild(child);\" ng-if=\"$index !== 0\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></span><md-input-container class=\"md-block\" ng-if=\"child._editing\">\n<label>{{ \'OFFERED_SERVICES.NAME\' | translate }}</label><input type=\"text\" ng-model=\"child.name\" required>\n</md-input-container></span><span class=\"md-subhead\"><span ng-if=\"!child._editing\"><p>{{ child.description }}</p>\n</span><span ng-if=\"child._editing\"><md-input-container class=\"md-block\"><label>\n{{ \'OFFERED_SERVICES.DESCRIPTION\' | translate }}</label><textarea ng-model=\"child.description\" md-maxlength=\"500\" \nrows=\"5\" md-select-on-focus></textarea></md-input-container></span></span></md-card-title-text><md-list><md-list-item \nlayout=\"row\" flex><p flex=\"50\">{{ \'OFFERED_SERVICES.PRICE_TYPE\' | translate }}</p><div flex=\"50\"><p \nng-if=\"!child._editing\"><span ng-if=\"child.paymentType==\'F\'\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</span> <span\n ng-if=\"child.paymentType==\'O\'\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</span> <span \nng-if=\"child.paymentType==\'R\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</span></p><md-input-container \nng-if=\"child._editing\"><label>{{ \'OFFERED_SERVICES.PRICE_TYPE\' | translate }}</label><md-select required \nng-model=\"child.paymentType\"><md-option value=\"F\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option><md-option \nvalue=\"O\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" \nng-if=\"child.scheduleType!==\'A\'\">{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select>\n</md-input-container></div></md-list-item><md-list-item layout=\"row\" flex \nng-if=\"child.paymentType==\'R\' || child.paymentType==\'O\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}</p><div flex=\"50\"><p ng-if=\"!child._editing\">\n{{ child.subscriptionPrice }}&euro;</p><md-input-container class=\"md-block\" ng-if=\"child._editing\"><label>\n{{ \'OFFERED_SERVICES.SUBSCRIPTION_PRICE\' | translate }}</label><input type=\"number\" min=\"0\" \nng-model=\"child.subscriptionPrice\" ng-required=\"child.paymentType === \'R\' || child.paymentType === \'O\'\">\n</md-input-container></div></md-list-item><md-list-item layout=\"row\" flex ng-if=\"child.paymentType==\'R\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.RENEWAL\' | translate }}</p><div flex=\"50\" layout=\"column\"><p ng-if=\"!child._editing\"><span \nng-if=\"child.paymentRenewInterval === \'day\'\">{{\'OFFERED_SERVICES.DAY\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'week\'\">{{\'OFFERED_SERVICES.WEEK\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'month\'\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'2-month\'\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'3-month\'\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'4-month\'\">{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'6-month\'\">{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</span> <span \nng-if=\"child.paymentRenewInterval === \'year\'\">{{\'OFFERED_SERVICES.YEAR\' | translate}}</span></p><md-input-container \nng-if=\"child._editing\"><label>{{ \'OFFERED_SERVICES.RENEWAL\' | translate }}</label><md-select \nng-required=\"child.paymentType === \'R\'\" ng-model=\"child.paymentRenewInterval\"><md-option value=\"day\">\n{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option><md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}\n</md-option><md-option value=\"month\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"2-month\">\n{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option value=\"3-month\">\n{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option><md-option value=\"year\">{{\'OFFERED_SERVICES.YEAR\' | translate}}\n</md-option></md-select></md-input-container><div ng-if=\"child._editing\">\nDal {{ vm.item.start | date : \'dd/MM/yyyy\' }} al {{ vm.item.end | date : \'dd/MM/yyyy\' }} sono {{ vm.calcolaNumRate(vm.item, child, {ignoreNumMaxRenewal: true}) }} rate.\n</div></div></md-list-item><md-list-item layout=\"row\" flex ng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">\n{{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}</p><div flex=\"50\"><p ng-if=\"!child._editing\">\n{{ child.renewalPrice }}&euro;</p><md-input-container class=\"md-block\" ng-if=\"child._editing\"><label>\n{{ \'OFFERED_SERVICES.RENEWAL_PRICE\' | translate }}</label><input type=\"number\" min=\"0\" ng-model=\"child.renewalPrice\" \nng-required=\"child.paymentType === \'R\'\"></md-input-container></div></md-list-item><md-list-item layout=\"row\" flex \nng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">{{ \'OFFERED_SERVICES.NUM_MAX_RENEWAL\' | translate }}<br><span \nclass=\"md-caption\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</span></p><div flex=\"50\"><p ng-if=\"!child._editing\">{{ child.numMaxRenewal }}</p><md-input-container class=\"md-block\" \nng-if=\"child._editing\"><label>{{ \'OFFERED_SERVICES.NUM_MAX_RENEWAL\' | translate }}</label><input type=\"number\" min=\"1\" \nng-model=\"child.numMaxRenewal\"></md-input-container></div></md-list-item><md-list-item layout=\"row\" flex \nng-if=\"child.paymentType === \'R\'\"><p flex=\"50\">{{ \'OFFERED_SERVICES.PRICE\' | translate }}</p><p flex=\"50\">\n{{ child.subscriptionPrice }} + {{ vm.calcolaNumRate(vm.item, child) }} x {{ child.renewalPrice }} = {{ child.subscriptionPrice + vm.calcolaNumRate(vm.item, child) * child.renewalPrice }}&euro;\n</p></md-list-item></md-list><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"child._editing\"><md-button \nclass=\"md-raised md-fab md-warn\" ng-click=\"vm.editChildCancel(child);\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md-primary\"></md-icon></md-button><md-button class=\"md-raised md-accent md-fab\" ng-disabled=\"child._saving\" \nng-click=\"vm.saveChild(child);\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-primary\"></md-icon></md-button>\n</md-card-actions></md-card-content></md-card></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/pictures.html","<div layout=\"column\" class=\"md-padding\" flex=\"100\"><md-card flex=\"100\"><md-card-content layout=\"column\" \nlayout-align=\"space-between\"><span class=\"md-title\">Immagini</span><p>\nIn questa sezione puoi caricare alcune immagini illustrative per questo servizio/corso. Se il corso è pubblicamente ricercabile, èqueste immagini saranno proposte tra i risultati della ricerca.\n</p><p>Seleziona un\'immagine dal tuo computer per aggiungerla all\'elenco</p><div id=\"service-image-uploader\" \nflow-init=\"vm.pictures.ngFlowOptions\" flow-name=\"vm.pictures.ngFlow.flowOfferedServicePicture\" \nflow-files-submitted=\"vm.pictures.upload()\" flow-file-added=\"vm.pictures.fileAdded($file)\" \nflow-file-success=\"vm.pictures.fileSuccess($file, $message)\" \nflow-file-error=\"vm.pictures.fileError($file, $message, $flow)\" flow-complete=\"vm.pictures.uploadComplete()\"><md-button\n class=\"md-accent md-raised\" flow-btn>{{ \'PAGES.UPLOAD\' | translate }}</md-button></div><p>\nL\'immagine deve essere formato jpeg o png.</p></md-card-content></md-card><div flex=\"100\"><md-grid-list \nmd-cols-gt-md=\"12\" md-cols=\"3\" md-cols-md=\"8\" md-row-height-gt-md=\"1:1\" md-row-height=\"4:3\" md-gutter-gt-md=\"16px\" \nmd-gutter-md=\"8px\" md-gutter=\"4px\"><md-grid-tile ng-repeat=\"picture in vm.item.pictures\" ng-if=\"!picture.isDeleted\" \nmd-colspan-gt-sm=\"3\" md-rowspan-gt-sm=\"3\"><md-card><md-card-content layout=\"column\" layout-align=\"space-between\"><img \nalt=\"Immagine: {{ picture.uri }}\" title=\"Immagine: {{ picture.uri }}\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{ CYL_ORG_DOC_PREFIX }}{{ picture.organizationId }}/download/{{ picture.uri }}\">\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \naria-label=\"Elimina immagine\" ng-click=\"vm.pictures.remove(picture);\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></md-card-actions></md-card></md-grid-tile></md-grid-list></div></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/price.html","<div layout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout=\"column\" flex=\"100\" \nclass=\"contenitore-pagina-padding-e-ombra\"><div layout=\"column\" class=\"md-inline-form\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.PRICE_TYPE\">Price type</label><md-select required ng-model=\"vm.item.paymentType\" \nng-change=\"vm.changePaymentType()\"><md-option value=\"F\">{{\'OFFERED_SERVICES.PRICE_FREE\' | translate}}</md-option>\n<md-option value=\"O\">{{\'OFFERED_SERVICES.PRICE_ONE_SHOT\' | translate}}</md-option><md-option value=\"R\" \nng-if=\"vm.item.serviceType===\'SERVICE\' && vm.item.scheduleType!==\'A\'\">\n{{\'OFFERED_SERVICES.PRICE_RENEWABLE\' | translate}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" class=\"md-inline-form\"><md-input-container ng-show=\"vm.item.paymentType===\'R\'\"><label \ntranslate=\"OFFERED_SERVICES.RENEWAL\">Renewal</label><md-select ng-required=\"vm.item.paymentType===\'R\' \" \nng-model=\"vm.item.paymentRenewInterval\"><md-option value=\"day\">{{\'OFFERED_SERVICES.DAY\' | translate}}</md-option>\n<md-option value=\"month\">{{\'OFFERED_SERVICES.MONTH\' | translate}}</md-option><md-option value=\"year\">\n{{\'OFFERED_SERVICES.YEAR\' | translate}}</md-option><md-option value=\"week\">{{\'OFFERED_SERVICES.WEEK\' | translate}}\n</md-option><md-option value=\"2-month\">{{\'OFFERED_SERVICES.2_MONTH\' | translate}}</md-option><md-option \nvalue=\"3-month\">{{\'OFFERED_SERVICES.3_MONTH\' | translate}}</md-option><md-option value=\"4-month\">\n{{\'OFFERED_SERVICES.4_MONTH\' | translate}}</md-option><md-option value=\"6-month\">\n{{\'OFFERED_SERVICES.6_MONTH\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nclass=\"md-inline-form\"><md-input-container class=\"md-block\" ng-show=\"vm.item.paymentType===\'R\'\"><label>\n{{ \'OFFERED_SERVICES.NUM_MAX_RENEWAL\' | translate }}</label><input type=\"number\" min=\"1\" \nng-model=\"vm.item.numMaxRenewal\" ng-required=\"vm.item.paymentType===\'R\'\"><div class=\"font-size-12\">\nIn caso di pagamento ricorrente le rate si rinnovano automaticamente nel periodo di validità dell\'iscrizione, secondo la periodicità indicata. E\' tuttavia possibile limitare il rinnovo ad un numero massimo di rateizzazioni.\n</div><div class=\"font-size-12\" ng-if=\"vm.item.numMaxRenewal > 0 && vm.item.paymentType===\'R\'\"><strong>Totale</strong>\n: <span ng-if=\"vm.item.subscriptionPrice > 0\">Iscrizione {{vm.item.subscriptionPrice}} Euro</span> <span \nng-if=\"vm.item.subscriptionPrice > 0 && vm.item.numMaxRenewal > 0 && vm.item.paymentType===\'R\'\">+ </span><span \nng-if=\"vm.item.numMaxRenewal > 0 && vm.item.paymentType===\'R\'\">\n{{vm.item.numMaxRenewal}} Rate x {{vm.item.renewalPrice}} Euro </span>= <strong>\n{{ (vm.item.subscriptionPrice ? vm.item.subscriptionPrice : 0 ) + (vm.item.numMaxRenewal * (vm.item.renewalPrice ? vm.item.renewalPrice : 0 ) )}} Euro\n</strong></div></md-input-container></div><div layout=\"column\" class=\"md-inline-form\"><md-input-container \nclass=\"md-block\" ng-show=\"vm.item.paymentType===\'R\' || vm.item.paymentType===\'O\'\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIPTION_PRICE\">Subscription price</label><input type=\"number\" min=\"0\" \nng-model=\"vm.item.subscriptionPrice\" ng-required=\"vm.item.paymentType===\'R\' || vm.item.paymentType===\'O\'\">\n</md-input-container></div><div layout=\"column\" class=\"md-inline-form\"><md-input-container class=\"md-block\" \nng-show=\"vm.item.paymentType===\'R\'\"><label translate=\"OFFERED_SERVICES.RENEWAL_PRICE\">Renewal price</label><input \ntype=\"number\" min=\"0\" ng-model=\"vm.item.renewalPrice\" ng-required=\"vm.item.paymentType===\'R\' \"></md-input-container>\n</div></div></form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/schedule.html","<div layout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout=\"column\" flex=\"100\"><div layout=\"column\" \nclass=\"md-inline-form contenitore-pagina-padding-e-ombra\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"100\"><label required>{{ \'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE\' | translate }}</label><md-select \nng-model=\"vm.item.scheduleType\" ng-change=\"vm.changeScheduleType()\"><md-option value=\"R\">\n{{ \'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND\' | translate }}</md-option><md-option value=\"P\">\n{{ \'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_IN_PERIOD\' | translate }}</md-option><md-option value=\"D\">\n{{ \'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_SINGLE_DATE\' | translate }}</md-option><md-option \nng-if=\"vm.item.serviceType !== \'EVENT\'\" value=\"A\">{{ \'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_ACCESS\' | translate }}\n</md-option></md-select></md-input-container><md-button title=\"{{ \'OFFERED_SERVICES.MORE_INFO\' | translate }}\" \nclass=\"md-icon-button md-accent\" ng-click=\"vm.showHintScheduleType = !vm.showHintScheduleType\"><md-icon \nid=\"icon-help-chat-type\" md-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button></div><div \nclass=\"ov-box ov-box-info\" ng-show=\"vm.showHintScheduleType\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s36 ml-16\"></md-icon>{{ \'OFFERED_SERVICES.HINT.SCHEDULE_TYPE\' | translate }}</div><div \nng-if=\"vm.item.serviceType !== \'EVENT\' && vm.item.scheduleType === \'A\'\" layout=\"row\" class=\"md-inline-form\">\n<md-input-container class=\"md-block\" ng-show=\"vm.item.scheduleType === \'A\'\"><label>\n{{ \'OFFERED_SERVICES.NUM_ACCESS\' | translate }}</label><input type=\"number\" min=\"0\" ng-model=\"vm.item.numMaxAccess\" \nng-required=\"vm.item.scheduleType===\'A\'\"></md-input-container></div><div layout=\"row\" class=\"md-inline-form\" \nng-if=\"vm.item.serviceType !== \'EVENT\' && vm.item.scheduleType === \'A\'\"><md-input-container \nng-if=\"vm.item.serviceType !== \'EVENT\' && vm.item.scheduleType === \'A\'\"><span>\nSi tratta di un servizio indipendente o un carnet che comprende più servizi?</span><md-radio-group \nng-model=\"vm.item.includeMoreServices\" layout=\"column\" ng-change=\"vm.onChangeCarnetType()\"><md-radio-button value=\"N\">\nServizio indipendente</md-radio-button><md-radio-button value=\"Y\">E\' un carnet valido per più servizi</md-radio-button>\n</md-radio-group></md-input-container></div><div layout=\"row\" div class=\"md-inline-form\" \nng-if=\"vm.item.serviceType !== \'EVENT\' && vm.item.scheduleType === \'A\'\"><md-input-container \nng-if=\"vm.item.serviceType !== \'EVENT\' && vm.item.includeMoreServices === \'Y\'  && vm.item.scheduleType === \'A\'\"><span>\nServizi compresi da questo carnet</span>:<div ng-repeat=\"servizioChild in vm.serviziChildAttivabili\"><md-checkbox \nng-model=\"vm.childServiceToAdd[servizioChild.id]\" flex>{{servizioChild.name }} <span \nng-show=\"servizioChild.needsOrganizationSubscription\">- <cite>Necessita di quota associativa</cite></span> <span \nclass=\"md-warn\" ng-show=\"!servizioChild.enableAttendances && servizioChild.scheduleType !== \'A\'\">&nbsp;<md-icon \nmd-font-icon=\"icon-alert\" class=\"md-warn\"></md-icon>&nbsp;Presenze disabilitate</span></md-checkbox></div>\n</md-input-container></div><div layout=\"row\" div class=\"md-inline-form\"><div ng-if=\"vm.item.serviceType === \'EVENT\'\" \nlayout=\"row\" div class=\"md-inline-form\" ng-show=\"vm.item.scheduleType===\'D\'\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top:1.5em;   padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_FROM\" ng-required=\"vm.item.scheduleType===\'D\'\">\n</label><input ng-required=\"vm.item.scheduleType===\'D\'\" ng-model=\"vm.item.hourFrom\" ng-change=\"vm.changeHourFrom()\" \ntype=\"number\" min=\"0\" max=\"23\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_FROM\' | translate }}\">\n</md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_FROM\" \nng-required=\"vm.item.scheduleType===\'D\'\"></label><input ng-required=\"vm.item.scheduleType===\'D\'\" \nng-model=\"vm.item.minutesFrom\" type=\"number\" min=\"0\" max=\"59\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_FROM\' | translate }}\"></md-input-container></div><div \nng-if=\"vm.item.serviceType === \'EVENT\'\" layout=\"row\" div class=\"md-inline-form\" ng-show=\"vm.item.scheduleType===\'D\'\">\n<label translate=\"OFFERED_SERVICES.HOUR_END\" style=\"padding-top:1.5em;     padding-right: 1em\">End</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_TO\" ng-required=\"vm.item.scheduleType===\'D\'\">\n</label><input ng-required=\"vm.item.scheduleType===\'D\'\" ng-model=\"vm.item.hourTo\" ng-change=\"vm.changeHourTo()\" \ntype=\"number\" min=\"0\" max=\"23\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.HOUR_TO\' | translate }}\">\n</md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_TO\" \nng-required=\"vm.item.scheduleType===\'D\'\"></label><input ng-required=\"vm.item.scheduleType===\'D\'\" \nng-model=\"vm.item.minutesTo\" type=\"number\" min=\"0\" max=\"59\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.MINUTES_TO\' | translate }}\"></md-input-container></div></div><div \nlayout=\"row\" class=\"md-inline-form\" ng-show=\"vm.item.scheduleType===\'P\' || vm.item.scheduleType===\'D\'\"><md-datepicker \nng-model=\"vm.item.start\" ng-change=\"vm.offeredServiceStartdateChange(vm.item.start, vm.item.scheduleType);\" \nmd-placeholder=\"{{ ( vm.item.scheduleType===\'D\') ? (\'OFFERED_SERVICES.DATE_ON\' | translate) : (\'OFFERED_SERVICES.START\' | translate) }}\">\n</md-datepicker><md-datepicker ng-model=\"vm.item.end\" ng-if=\"vm.item.scheduleType===\'P\'\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.END\' | translate }}\"></md-datepicker></div></div></div></form></div>");
$templateCache.put("app/main/pages/offered_services/views/offered_service_settings/tabs/web.html","<div layout=\"column\" flex=\"100\" class=\"md-inline-form contenitore-pagina-padding-e-ombra\"><h3 \nclass=\"titolo-blocco-contenuto\">Attiva pagina web e iscrizione via QR code</h3><h4 class=\"titolo-blocco-contenuto\">\nOgni campo deve essere salvato con il relativo pulsante di salvataggio. Effettua un salvataggio alla volta.</h4><div \nlayout=\"row\" class=\"md-padding\"><form flex=\"100\"><div layout-gt-xs=\"row\" div class=\"md-inline-form\" \nlayout-align=\"start center\"><md-input-container><md-checkbox ng-model=\"vm.flgHasSubscriptionByQrCode\" flex>\n{{\'OFFERED_SERVICES.FLG_USE_SUBSCRIPTION_QR_CODE\' | translate }}</md-checkbox></md-input-container><span \nclass=\"md-title\" ng-if=\"vm.item.subscriptionQrCodeUri\"><md-button ngclipboard \ndata-clipboard-text=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.item.organizationId }}/download/{{vm.item.subscriptionQrCodeUri }}\" \nclass=\"md-warn\" aria-label=\"copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"md-primary\"></md-icon>\n{{\'OFFERED_SERVICES.COPY_LINK\' | translate}}</md-button></span><span ng-if=\"vm.item.subscriptionQrCodeUri\"><img \nclass=\"w-160 h-160\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{ vm.item.organizationId }}/download/{{vm.item.subscriptionQrCodeUri }}\">\n</span></div><div layout-gt-xs=\"row\" class=\"md-inline-form\" layout-align=\"start center\"><md-input-container>\n<md-checkbox ng-model=\"vm.flgHasSubscriptionPage\" ng-change=\"vm.changeHasSubscriptionPage();\" flex>\n{{\'OFFERED_SERVICES.FLG_USE_PUBLIC_SUBSCRIPTION_PAGE\' | translate }}</md-checkbox></md-input-container></div><div \nng-if=\"vm.subscriptionPage\"><span class=\"md-title\" ng-if=\"vm.subscriptionPage.id\"><a \nng-href=\"{{ vm.publicCylUrl }}/subscribe/{{vm.subscriptionPage.uuid}}\" id=\"page_link\" target=\"_blank\">\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_LINK\' | translate}}</a><md-button ngclipboard \ndata-clipboard-text=\"{{ vm.publicCylUrl }}/subscribe/{{vm.subscriptionPage.uuid}}\" class=\"md-warn\" aria-label=\"copy\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"md-primary\"></md-icon>{{\'OFFERED_SERVICES.COPY_LINK\' | translate}}\n</md-button><a href=\"#\" socialshare socialshare-provider=\"facebook\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-facebook-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"twitter\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon md-font-icon=\"icon-twitter-box\" \nclass=\"md-accent\"></md-icon></a><a href=\"#\" socialshare socialshare-provider=\"google\" \nsocialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon \nmd-font-icon=\"icon-google-plus-box\" class=\"md-accent\"></md-icon></a><a href=\"#\" socialshare \nsocialshare-provider=\"linkedin\" socialshare-url=\"{{vm.publicCylUrl}}/subscribe/{{vm.subscriptionPage.uuid}}\"><md-icon \nmd-font-icon=\"icon-linkedin-box\" class=\"md-accent\"></md-icon></a></span><div flex=\"100\" class=\"padding-top-40\"><h3 \nclass=\"titolo-blocco-contenuto\">Pagina di iscrizione</h3><h4 class=\"titolo-blocco-contenuto\">\nUsa un titolo chiaro ed efficace come \"Iscriviti al corso di kayak per bambini e ragazzi\"</h4></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label translate=\"OFFERED_SERVICES.SUBSCRIPTION_PAGE_TITLE\" required>Title</label><input\n type=\"text\" name=\"title\" ng-model=\"vm.subscriptionPage.title\"></md-input-container></div><br><br><div layout=\"row\">\n<md-checkbox ng-model=\"vm.subscriptionPageOptions.options[\'allow-social-share\']\" flex>\nInserisci nella pagina bottoni di condivisione social</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.offeredService.latitude || !vm.offeredService.longitude\" \nng-model=\"vm.subscriptionPageOptions.options[\'show-location\']\" flex>Mostra mappa con la location</md-checkbox><br>\n</div><br><br><br><br><div layout=\"row\"><strong>{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_FIELDS\' | translate}}</strong>\n</div><div layout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'birthDate\']\" flex>\n{{\'OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\' | translate}}</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.fields[\'gender\']\" flex>{{\'USERS.GENDER\' | translate}}</md-checkbox><br></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'taxCode\']\" flex>{{\'USERS.TAX_CODE\' | translate}}\n</md-checkbox><br></div><div layout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'address\']\" flex>\n{{\'USERS.ADDRESS\' | translate}}</md-checkbox><br></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.fields[\'city\']\" flex>{{\'USERS.CITY\' | translate}}</md-checkbox><br></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.subscriptionPageOptions.fields[\'phone\']\" flex>{{\'USERS.PHONE\' | translate}}\n</md-checkbox><br></div><br><br><br><br><div layout=\"row\"><md-checkbox \nng-model=\"vm.subscriptionPageOptions.showAttachableServices\" flex>\nMostra anche servizi a pacchetto nel modulo di iscrizione</md-checkbox><br></div><br><br><br><strong>\n{{\'OFFERED_SERVICES.SUBSCRIPTION_PAGE_ADDITIONAL_FIELDS\' | translate}}</strong><md-tabs md-dynamic-height \nmd-selected=\"selectedIndex\"><md-tab><md-tab-label>Designer</md-tab-label><md-tab-body><div layout=\"column\" \nlayout-align=\"center start\"><div ui-sortable=\"vm.sortableFieldOptions\" ng-model=\"vm.userTemplate.template.items\" flex \nlayout=\"column\" layout-wrap style=\"width: 100%\" class=\"md-blue-grey-100-bg\"><ms-widget ui-sortable-selectable flex \nng-repeat=\"item in vm.userTemplate.template.items track by $index\"><ms-widget-front class=\"padding-16\" \nstyle=\"background-color:white\"><div layout=\"row\"><md-input-container flex=\"30\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_LABEL\' | translate}}</label><input type=\"text\" ng-model=\"item.caption\" \nng-change=\"vm.calculateTemplateItemName(item)\" required=\"required\"></md-input-container><md-input-container flex=\"30\">\n<label>{{\'ORGANIZATIONS.FORM_DESIGNER.FIELD_NAME\' | translate}}</label><input type=\"text\" ng-model=\"item.name\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"20\"><label>Tipo</label><md-select \nng-model=\"item.type\"><md-option value=\"text\">{{\'ORGANIZATIONS.FORM_DESIGNER.TEXT_FIELD\' | translate}}</md-option>\n<md-option value=\"checkbox\">{{\'ORGANIZATIONS.FORM_DESIGNER.CHECKBOX\' | translate}}</md-option><md-option \nvalue=\"select\">{{\'ORGANIZATIONS.FORM_DESIGNER.COMBOBOX\' | translate}}</md-option><md-option value=\"radio\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.RADIOBUTTONS\' | translate}}</md-option><md-option value=\"label\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.LABEL\' | translate}}</md-option></md-select></md-input-container><md-input-container \nflex=\"10\"><md-button ng-click=\"vm.removeItem($index);\" class=\"md-icon-button\" aria-label=\"Add\" \ntitle=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\">\n</md-icon></md-button></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container \nflex ng-if=\"item.type!==\'label\'\"><md-checkbox ng-model=\"item.options.required\" aria-label=\"Disabled\">\n{{\'ORGANIZATIONS.FORM_DESIGNER.REQUIRED\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-if=\"item.type===\'label\'\" flex><label>Tag</label><md-select ng-model=\"item.options[\'html-tag\']\"><md-option \nvalue=\"span\"><span></span></md-option><md-option value=\"h1\"><h1>H1</h1></md-option><md-option value=\"h2\"><h2>H2</h2>\n</md-option><md-option value=\"h3\"><h3>H3</h3></md-option><md-option value=\"h4\"><h4>H4</h4></md-option><md-option \nvalue=\"h5\"><h5>H5</h5></md-option></md-select></md-input-container><md-input-container ng-if=\"item.type===\'label\'\" \nflex><label>{{\'ORGANIZATIONS.FORM_DESIGNER.COLOR\' | translate}}</label><input type=\"text\" \nng-model=\"item.options.color\"></md-input-container></div><div ng-if=\"item.type===\'select\' || item.type===\'radio\'\" \nstyle=\"margin: 10px\" flex=\"33\">{{\'ORGANIZATIONS.FORM_DESIGNER.VALUES\' | translate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n<md-button ng-click=\"vm.addChoice(item);\" class=\"md-icon-button\" title=\"Nuovo valore\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"green-500-fg\"></md-icon></md-button><div layout=\"row\" \nng-repeat=\"c in item.choices track by $index\" style=\"border: 1px solid #ddd; margin-bottom:4px\"><md-input-container \nflex=\"40\"><label>{{\'ORGANIZATIONS.FORM_DESIGNER.VALUE\' | translate}}</label><input type=\"text\" ng-model=\"c.uuid\" \nrequired=\"required\"></md-input-container><md-input-container flex=\"40\"><label>\n{{\'ORGANIZATIONS.FORM_DESIGNER.DESCRIPTION\' | translate}}</label><input type=\"text\" ng-model=\"c.caption\" \nrequired=\"required\"></md-input-container><md-button ng-click=\"vm.removeChoice(item, $index);\" class=\"md-icon-button\" \naria-label=\"Add\" title=\"{{\'ORGANIZATIONS.FORM_DESIGNER.DELETE\' | translate}}\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"red-500-fg\"></md-icon></md-button></div></div></div></ms-widget-front></ms-widget></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.addTemplateItem()\" aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" \ntranslate=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\" translate-attr-aria-label=\"ORGANIZATIONS.FORM_DESIGNER.NEW_FIELD\">\nNew field</md-button></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.reloadPreview()\">\n\"src/app/main/directives/dynamic-document/templates/textarea.html\"<md-tab-label>Anteprima</md-tab-label><md-tab-body>\n<div style=\"background-color: white; padding: 30px\"><dynamic-document ng-data-url=\"\" ng-template-url=\"\" \nng-stats-url=\"\" ng-save-url=\"\" on-success=\"\" on-error=\"\" ng-edit-mode=\"true\"></dynamic-document></div></md-tab-body>\n</md-tab><md-tab><md-tab-label>Sorgente JSON</md-tab-label><md-tab-body><div style=\"height: 800px\"><angular-jsoneditor \nng-model=\"vm.userTemplate.template\" options=\"vm.jsonOptions\" style=\"width: 100%; height: 800px\"></angular-jsoneditor>\n</div></md-tab-body></md-tab></md-tabs></div></form></div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \nstyle=\"font-size: 17px; padding: 16px; float: left\" translate=\"USERS.GENERAL_INFORMATION\">General Information</div><div\n layout=\"row\" layout-align=\"end\" style=\"padding: 4px\"><md-button title=\"{{\'USERS.EDIT\' | translate}}\" \nclass=\"md-icon-button md-raised\" ng-click=\"vm.editProfile();\" aria-label=\"Edit\" ng-hide=\"vm.editableProfile\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"md-primary\"></md-icon></md-button></div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"USERS.GIVEN_NAME\">Given Name</div><div class=\"info\">\n{{vm.userProfile.givenName}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.FAMILY_NAME\">\nFamily Name</div><div class=\"info\">{{vm.userProfile.familyName}}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERS.EMAIL\">Email</div><div class=\"info\">\n{{(vm.userProfile.email && !vm.userProfile.email.endsWith(\'invalid\')) ? vm.userProfile.email : \' - \'}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"USERS.BIRTH_DATE\">Birth Date</div><div class=\"info\">\n{{vm.formatDate(vm.userProfile.birthDate) }}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERS.GENDER\">Gender</div><div class=\"info\">{{vm.userProfile.gender}}</div></div><div class=\"info-line\"><div\n class=\"title\" translate=\"USERS.TAX_CODE\">Tax code</div><div class=\"info\">{{vm.userProfile.taxCode}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"USERS.ADDRESS\">Address</div><div class=\"info\">\n{{vm.userProfile.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.CITY\">City</div><div \nclass=\"info\">{{vm.userProfile.city}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERS.PHONE\">Phone\n</div><div class=\"info\">{{vm.userProfile.phone}}</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/attendances/attendances.html","<div id=\"page-user-attendances\" class=\"page-layout simple tabbed\" ms-scroll ng-init=\"vm.init();\"><div \nclass=\"content md-padding\" layout=\"column\" flex><div layout=\"row\"><ov-profile-navigation-bar user-id=\"{{ vm.userId }}\" \nselected-page=\"ATTENDANCES\"></ov-profile-navigation-bar></div><div class=\"user-info md-padding\" layout=\"row\" \nlayout-align=\"start center\" layout-gt-sm=\"row\"><img ng-if=\"!vm.user.uriAvatar || vm.user.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.user.uriAvatar && vm.user.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.user.id }}/download/{{vm.user.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.user.givenName + \" \" + vm.user.familyName }} - Gestione presenze</div></div><div \nlayout=\"column\" flex=\"100\"><md-card layout=\"column\" flex=\"100\"><md-card-title><h3>Filtri</h3></md-card-title>\n<md-card-content layout=\"row\" flex=\"100\"><div flex=\"25\"><md-input-container><label>Servizio</label><md-select \nng-model=\"vm.searchFilter.offeredService\" ng-change=\"vm.dtInstance.DataTable.draw();\" \nplaceholder=\"Filtra per servizio\"><md-option ng-value>Tutti i servizi</md-option><md-option ng-value=\"service\" \nng-repeat=\"service in vm.offeredServices\">{{ service.name }}</md-option></md-select></md-input-container></div><div \nflex=\"25\"><md-input-container><label>Carnet</label><md-select ng-model=\"vm.searchFilter.carnet\" \nng-change=\"vm.dtInstance.DataTable.draw();\" placeholder=\"Filtra per carnet\"><md-option ng-value>Tutti i carnet\n</md-option><md-option ng-value=\"service\" ng-repeat=\"service in vm.carnet\">{{ service.name }}</md-option></md-select>\n</md-input-container></div></md-card-content></md-card></div><table datatable=\"attendances-datatable\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\"></table></div>\n</div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/documents/documents.html","<div id=\"profile\" class=\"page-layout simple tabbed flex-scrollable\" ms-scroll><div class=\"content\" flex><div \nlayout=\"row\"><ov-profile-navigation-bar user-id=\"{{vm.userId}}\" selected-page=\"DOCUMENTS\"></ov-profile-navigation-bar>\n</div><div class=\"user-info md-padding\" layout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\" \nng-show=\"vm.isUserDetail\"><img ng-if=\"!vm.userProfile.uriAvatar || vm.userProfile.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.userProfile.uriAvatar && vm.userProfile.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.userProfile.id }}/download/{{vm.userProfile.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.userProfile.givenName + \" \" + vm.userProfile.familyName }}</div></div><div \nclass=\"md-green-200-bg md-padding\" style=\"margin:20px\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s36 ml-16\"></md-icon>{{\'USERS.HINT.DOCUMENT\' | translate}}</div><div layout=\"column\" flex=\"100\" flex><div \nid=\"document-uploader\" flex=\"100\" layout=\"column\" layout-align=\"center center\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dragEnter()\" flow-drag-leave=\"vm.dragLeave()\" class=\"document-uploader\"><div class=\"upload-button\" \nlayout=\"column\" layout-align=\"center center\"><span translate=\"USERS.DROP_TO_UPLOAD\">Drop to upload</span><md-button \nclass=\"md-accent md-raised\" flow-btn>Upload</md-button></div></div><table class=\"simple\" ms-responsive-table=\"\"><thead>\n<tr><th>Documento</th><th>Condiviso con</th><th>Azioni</th></tr></thead><tbody><tr \nng-repeat=\"document in vm.userDocuments\"><td><span class=\"md-headline\">{{document.name}}</span><br><span>\n{{document.description}}</span></td><td><div ng-repeat=\"subscriptionDocument in document.subscriptionDocuments\"><span \nng-if=\"subscriptionDocument.subscription && subscriptionDocument.subscription.offeredService && subscriptionDocument.subscription.offeredService.organization\">\n{{ subscriptionDocument.subscription.offeredService.organization.name }} - {{ subscriptionDocument.subscription.offeredService.name }} \n</span><span ng-if=\"subscriptionDocument.organizationDoctype\">{{ subscriptionDocument.organizationDoctype.name }}\n</span><md-button title=\"Non condividere\" class=\"md-icon-button\" aria-label=\"Non condividere\" \nng-click=\"vm.deleteSubscriptionDocument(subscriptionDocument);\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-button title=\"Aggiungi condivisione\" class=\"md-icon-button\" aria-label=\"Aggiungi condivisione\" \nng-click=\"vm.AddSubscriptionDocument(document);\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></td><td>\n<md-button class=\"md-icon-button\" aria-label=\"delete\" title=\"{{\'USERS.EDIT_DOCUMENT\' | translate}}\" \nng-click=\"vm.editDocument(document);\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><a \ntitle=\"{{\'USERS.DOWNLOAD_DOCUMENT\' | translate}}\" \nng-href=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ document.userId }}/download/{{ document.uri }}?access_token={{ vm.accessToken }}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-download\"></md-icon></a><md-button \ntitle=\"{{\'USERS.DELETE_DOCUMENT\' | translate}}\" class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteDocument(document);\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/documents/edit_document_dialog.html","<md-dialog aria-label=\"Edit document\" ng-cloak><form name=\"editDocForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"USERS.EDIT_DOCUMENT\">New Child</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" style=\"width: 400px\"><md-input-container><label \ntranslate=\"USERS.DOC_NAME\" required>Name</label><input type=\"text\" name=\"name\" ng-model=\"myResource.name\" required>\n</md-input-container><md-input-container flex style=\"width:100%\"><label translate=\"USERS.DOC_DESCRIPTION\">Description\n</label><textarea ng-model=\"myResource.description\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"editDocForm.$invalid || editDocForm.$pristine\" \nng-click=\"answer({name: myResource.name, description: myResource.description})\" translate=\"USERS.EDIT\">Create\n</md-button><md-button ng-click=\"cancel()\" translate=\"USERS.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/user_profile/tabs/parents/parents.html","<div id=\"profile\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"content\" flex><div layout=\"row\">\n<ov-profile-navigation-bar user-id=\"{{vm.userId}}\" selected-page=\"PARENTS\"></ov-profile-navigation-bar></div><div \nlayout=\"column\" class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">\nGenitori / Tutori di {{vm.child.displayName}}</h3><h4 class=\"titolo-blocco-contenuto\">\nIn questa sezione vengono visualizzate le persone di riferimento per <strong>{{vm.child.displayName}}</strong></h4><div\n layout=\"row\" layout-align=\"center\" class=\"margin-top-80\" ng-if=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"vm.child.parents.length > 0\" layout=\"row\" \nng-show=\"!vm.loading\"><md-card ng-repeat=\"parent in vm.child.parents\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-lg-25 flex-gt-md-30 flex-gt-sm-33 flex-50\">\n<md-card-content><div layout=\"row\" layout-align=\"start center\"><div class=\"avatar-wrapper\"><img \nng-if=\"(!parent.uriAvatar || parent.uriAvatar===null)\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{parent.displayName}}\"> <img \nng-if=\"parent.uriAvatar && parent.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{parent.id}}/download/{{ parent.uriAvatar }}\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{parent.displayName}}\"></div><div layout=\"column\" \nclass=\"md-padding\" style=\"cursor: pointer\" ng-click=\"vm.goToRelativeDetail(parent.id)\"><span class=\"md-title\">\n{{parent.displayName}}</span> <span class=\"md-subheader\">{{parent.email}}</span></div></div></md-card-content>\n</md-card></div></div></div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/payments/payments.html","<div id=\"profile\" class=\"page-layout simple tabbed\" ms-scroll ng-init=\"vm.init();\"><div class=\"content\" flex><div \nlayout=\"row\"><ov-profile-navigation-bar user-id=\"{{vm.userId}}\" selected-page=\"PAYMENTS\"></ov-profile-navigation-bar>\n</div><div class=\"user-info md-padding\" layout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\" \nng-show=\"vm.isUserDetail\"><img ng-if=\"!vm.userProfile.uriAvatar || vm.userProfile.uriAvatar===null\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"> <img \nng-if=\"vm.userProfile.uriAvatar && vm.userProfile.uriAvatar!==null\" class=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.userProfile.id }}/download/{{vm.userProfile.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.userProfile.givenName + \" \" + vm.userProfile.familyName }}</div></div><div \nclass=\"ov-box ov-box-filters\" flex flex=\"100\"><div flex flex=\"100\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.searchFilters.loading.filtersData\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div flex flex=\"100\" layout=\"row\" ng-if=\"!vm.searchFilters.loading.filtersData\"><div flex=\"25\" layout=\"row\" \nclass=\"filter-container\"><md-input-container class=\"width-50perc\"><label>Dal</label><input type=\"date\" \nng-model=\"vm.searchFilters.dtFrom\"></md-input-container><md-input-container class=\"width-50perc\"><label>Al</label>\n<input type=\"date\" ng-model=\"vm.searchFilters.dtTo\"></md-input-container></div><div flex=\"25\" class=\"filter-container\">\n<label>Organizzazione</label><md-autocomplete md-selected-item=\"vm.searchFilters.selectedOrganization\" \nmd-search-text=\"searchTextOrganization\" md-items=\"item in vm.getMatchingOrganizations(searchTextOrganization)\" \nmd-min-length=\"2\" placeholder=\"Digita...\" md-item-text=\"item.name\"><md-item-template><span \nmd-highlight-text=\"searchText\">{{ item.name }}</span></md-item-template><md-not-found>Nessun elemento trovato\n</md-not-found></md-autocomplete></div><div flex=\"25\" class=\"filter-container\"></div><div flex=\"25\" \nclass=\"filter-container\"><md-input-container><label>Causale</label><md-select \nng-model=\"vm.searchFilters.paymentReasonId\" placeholder=\"Filtra per causale\"><md-option ng-value=\"null\">- ignora -\n</md-option><md-option ng-value=\"-999999\">- senza causale -</md-option><md-option ng-value=\"paymentReason.id\" \nng-repeat=\"paymentReason in vm.searchFilters.lists.paymentReasons\">{{ paymentReason.name }}</md-option></md-select>\n</md-input-container></div></div><div flex flex=\"100\" layout=\"row\" ng-if=\"!vm.searchFilters.loading.filtersData\"><div \nflex=\"25\" class=\"filter-container\"></div><div flex=\"25\" layout=\"row\" class=\"filter-container\"><md-input-container \nclass=\"width-50perc\"><label>Importo da</label><input type=\"number\" ng-model=\"vm.searchFilters.entryValueFrom\">\n</md-input-container><md-input-container class=\"width-50perc\"><label>a</label><input type=\"number\" \nng-model=\"vm.searchFilters.entryValueTo\"></md-input-container></div><div flex=\"25\" class=\"filter-container\">\n<md-input-container><label>Descrizione</label><input type=\"text\" ng-model=\"vm.searchFilters.description\">\n</md-input-container></div><div flex=\"25\" layout=\"row\" layout-align=\"end center\" class=\"filter-container\"><md-button \nclass=\"md-raised\" ng-click=\"vm.cleanFilters();\">Pulisci filtri</md-button><md-button class=\"md-raised\" \nng-click=\"vm.reloadEntries();\">Aggiorna</md-button></div></div></div><div layout=\"column\" flex=\"100\"><table \nstyle=\"width: 100%\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" \nclass=\"row-border hover\"></table><div flex flex=\"100\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.searchFilters.loading.data\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/relatives/relatives.html","<div id=\"profile\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"content\" flex><div layout=\"row\">\n<ov-profile-navigation-bar user-id=\"{{vm.userId}}\" selected-page=\"RELATIVES\"></ov-profile-navigation-bar></div><div \nlayout=\"column\" class=\"contenitore-pagina-padding-e-ombra\"><h3 class=\"titolo-blocco-contenuto\">Genitore o tutore</h3>\n<h4 class=\"titolo-blocco-contenuto\">{{\'USERS.HINT.RELATIVES\' | translate}}</h4><div class=\"user-info md-padding\" \nlayout=\"row\" layout-align=\"start center\" layout-gt-sm=\"row\" ng-show=\"vm.isUserDetail\"><img \nng-if=\"!vm.userProfile.uriAvatar || vm.userProfile.uriAvatar===null\" class=\"profile-image avatar huge\" \nsrc=\"assets/images/avatars/katherine.jpg\"> <img ng-if=\"vm.userProfile.uriAvatar && vm.userProfile.uriAvatar!==null\" \nclass=\"profile-image avatar huge\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ vm.userProfile.id }}/download/{{vm.userProfile.uriAvatar }}\">\n<div class=\"md-title\">{{ vm.userProfile.givenName + \" \" + vm.userProfile.familyName }}</div></div><div layout=\"column\">\n<div layout=\"row\" layout-align=\"center start\" ng-if=\"vm.userChildren.length===0 && vm.userParents.length===0 \" \nng-show=\"!vm.loading\"><span class=\"md-padding md-title grey-fg\">{{\'PAGES.NO_DATA\' | translate }}</span></div>\n<md-content class=\"md-padding\" layout=\"column\"><div layout=\"row\" layout-align=\"center\" class=\"margin-top-80\" \nng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\">\n<md-card ng-repeat=\"child in vm.userChildren\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-xs-50 flex-gt-lg-25 flex-gt-md-30 flex-gt-sm-33 flex-50\">\n<md-card-content><div layout=\"row\" layout-align=\"start center\"><div class=\"avatar-wrapper\"><img \nng-if=\"(!child.uriAvatar || child.uriAvatar===null)\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{child.displayName}}\"> <img \nng-if=\"child.uriAvatar && child.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{child.id}}/download/{{ child.uriAvatar }}\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{child.displayName}}\"></div><div layout=\"column\" class=\"md-padding\">\n<span class=\"md-title\" style=\"cursor: pointer\" ng-click=\"vm.goToRelativeDetail(child.id)\">{{child.displayName}}</span>\n<md-input-container><md-select ng-model=\"child.relationType\" ng-change=\"vm.updateChildRelationType(child)\"><md-option \nng-repeat=\"relationType in vm.childRelationTypes\" ng-value=\"relationType.code\">{{relationType.value}}</md-option>\n</md-select></md-input-container></div></div></md-card-content><md-card-actions><md-button class=\"md-warn md-raised\" \naria-label=\"Remove\" style=\"width: 100%; margin: 0 0 10px\" title=\"{{\'USERS.REMOVE_AS_CHILD\' | translate}}\" \nng-click=\"vm.removeAsChild(child)\"><md-icon md-font-icon=\"icon-account-remove\" class=\"md-primary\"></md-icon>\n{{\'USERS.REMOVE_AS_CHILD\' | translate}}</md-button><md-button class=\"md-warn md-raised\" aria-label=\"Remove\" \nstyle=\"width: 100%; margin: 0px\" title=\"{{\'USERS.DELETE\' | translate}}\" ng-click=\"vm.deleteChild(child)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-primary\"></md-icon>{{\'USERS.DELETE\' | translate}}</md-button></md-card-actions>\n</md-card></div></md-content><div layout=\"row\" layout-align=\"end start\" ng-if=\"!vm.isUserDetail\"><md-button \nclass=\"md-fab md-raised md-accent\" aria-label=\"Add Child\" ng-click=\"vm.askUserDetails($event)\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"md-primary\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/relatives/remove_child_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"removeChildForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"USERS.REMOVE_AS_CHILD\">Remove</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><span class=\"md-subhead\"><strong>\n{{\'PAGES.WARNING\'|translate}}:&nbsp;</strong>{{ \'USERS.REMOVE_CHILD_HINT\' | translate:child }}</span>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"USERS.EMAIL\">Email</label><input type=\"email\" \nng-model=\"childEmail\" required ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"childEmail.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label translate=\"USERS.EMAIL_CONFIRM\">Email confirm</label><input type=\"email\" \nng-model=\"childEmailConfirm\" required ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"childEmailConfirm.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"removeChildForm.$invalid || (childEmail!==childEmailConfirm)\" \nng-click=\"answer({email: childEmail})\" translate=\"PAGES.PROCEED\">Proceed</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"USERS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/user_profile/tabs/security/security.html","<form name=\"myForm\"><div layout=\"row\" layout-align=\"end center\"><md-button ng-disabled=\"myForm.$invalid\" \ntitle=\"{{\'PAGES.SAVE\' | translate}}\" class=\"md-warn md-raised\" ng-click=\"vm.saveProfile()\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-accent\"></md-icon>{{\'USERS.SAVE\' | translate}}</md-button></div><span \nclass=\"md-title\">Visibilità del profilo</span><div layout=\"row\"><md-checkbox ng-model=\"vm.userProfile.isSearchable\">\nIl mio profilo (nome, cognome, email, avatar) è ricercabile dalle associazioni a cui non appartengo</md-checkbox></div>\n<br><br><span layout=\"column\"><span class=\"md-title\">Visibilità dei dati personali</span> <span class=\"md-subhead\">\nScegli quali associazioni possono vedere i tuoi dati personali</span></span><br><div layout=\"column\"><span><md-icon \nng-click=\"vm.birthDateVisible = !vm.birthDateVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.BIRTH_DATE\' | translate}}:</strong>\n {{vm.formatDate(vm.userProfile.birthDate)}}</span><div ng-show=\"vm.birthDateVisible\" layout=\"row\"><div \nlayout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.birthDateVisible\" \nlayout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox \nng-model=\"vm.userDetailVisibility.birthDate[org.id]\">{{org.name}}</md-checkbox></div><div \nng-show=\"vm.birthDateVisible\" layout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.birthDate[\'NEW_ORGS\']\">\nEventuali nuove associazioni</md-checkbox></div></div></div></div><br><div layout=\"column\"><span><md-icon \nng-click=\"vm.birthPlaceVisible = !vm.birthPlaceVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.BIRTH_PLACE\' | translate}}:</strong>\n {{vm.userProfile.birthPlace}}</span><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.birthPlace[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.birthPlaceVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.birthPlace[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br><div layout=\"column\"><span><md-icon ng-click=\"vm.genderVisible = !vm.genderVisible\" \nmd-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" class=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>\n{{\'USERS.GENDER\' | translate}}:</strong> {{vm.userProfile.gender}}</span><div ng-show=\"vm.genderVisible\" layout=\"row\">\n<div layout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.genderVisible\" \nlayout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox \nng-model=\"vm.userDetailVisibility.gender[org.id]\">{{org.name}}</md-checkbox></div><div ng-show=\"vm.genderVisible\" \nlayout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.gender[\'NEW_ORGS\']\">Eventuali nuove associazioni\n</md-checkbox></div></div></div></div><br><div layout=\"column\"><span><md-icon \nng-click=\"vm.taxCodeVisible = !vm.taxCodeVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.TAX_CODE\' | translate}}:</strong>\n {{vm.userProfile.taxCode}}</span><div ng-show=\"vm.taxCodeVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.taxCodeVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.taxCode[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.taxCodeVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.taxCode[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br><div layout=\"column\"><span><md-icon ng-click=\"vm.addressVisible = !vm.addressVisible\" \nmd-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" class=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>\n{{\'USERS.ADDRESS\' | translate}}:</strong> {{vm.userProfile.address}}</span><div ng-show=\"vm.addressVisible\" \nlayout=\"row\"><div layout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div \nng-show=\"vm.addressVisible\" layout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox \nng-model=\"vm.userDetailVisibility.address[org.id]\">{{org.name}}</md-checkbox></div><div ng-show=\"vm.addressVisible\" \nlayout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.address[\'NEW_ORGS\']\">Eventuali nuove associazioni\n</md-checkbox></div></div></div></div><br><div layout=\"column\"><span><md-icon \nng-click=\"vm.phoneVisible = !vm.phoneVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" class=\"md-accent\" \ntitle=\"Configura visibilità\"></md-icon><strong>{{\'USERS.PHONE\' | translate}}:</strong> {{vm.userProfile.phone}}</span>\n<div ng-show=\"vm.phoneVisible\" layout=\"row\"><div layout=\"column\">Visibile a:&nbsp;&nbsp;&nbsp;</div><div \nlayout=\"column\"><div ng-show=\"vm.phoneVisible\" layout=\"row\" ng-repeat=\"org in vm.userProfile.organizations\">\n<md-checkbox ng-model=\"vm.userDetailVisibility.phone[org.id]\">{{org.name}}</md-checkbox></div><div \nng-show=\"vm.phoneVisible\" layout=\"row\"><md-checkbox ng-model=\"vm.userDetailVisibility.phone[\'NEW_ORGS\']\">\nEventuali nuove associazioni</md-checkbox></div></div></div></div><br><div layout=\"column\"><span><md-icon \nng-click=\"vm.mobilePhoneVisible = !vm.mobilePhoneVisible\" md-font-icon=\"icon-cog-box\" style=\"cursor: pointer\" \nclass=\"md-accent\" title=\"Configura visibilità\"></md-icon><strong>{{\'USERS.MOBILE_PHONE\' | translate}}:</strong>\n {{vm.userProfile.mobilePhone}}</span><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\"><div layout=\"column\">\nVisibile a:&nbsp;&nbsp;&nbsp;</div><div layout=\"column\"><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\" \nng-repeat=\"org in vm.userProfile.organizations\"><md-checkbox ng-model=\"vm.userDetailVisibility.mobilePhone[org.id]\">\n{{org.name}}</md-checkbox></div><div ng-show=\"vm.mobilePhoneVisible\" layout=\"row\"><md-checkbox \nng-model=\"vm.userDetailVisibility.mobilePhone[\'NEW_ORGS\']\">Eventuali nuove associazioni</md-checkbox></div></div></div>\n</div><br></form>");
$templateCache.put("app/main/pages/users/user_profile/tabs/services/edit_docs_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"newDocsForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"USERS.SERVICES.USER_DOCUMENT_MANAGE\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><table class=\"row-border hover\"><thead><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">File</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"></div></th><th class=\"secondary-text\"><div class=\"table-header\"></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Stato</span></div></th></thead><tbody><tr \nng-repeat=\"doctype in doctypes\" ng-init=\"currentEntry=myResource.serviceDocuments[doctype.organizationDoctype.id]\"><td>\n{{doctype.organizationDoctype.name}}</td><td><span ng-if=\"!currentEntry.isEditing && currentEntry.isPaperDoc\">\n{{\'DOCS_VALIDATION.PAPER_DOCUMENT\' | translate}}</span> <span \nng-if=\"!currentEntry.isEditing && !currentEntry.isPaperDoc && currentEntry.userDocument\">\n{{currentEntry.userDocument.name}}</span> <span \nng-if=\"!currentEntry.isEditing && !currentEntry.isPaperDoc && !currentEntry.userDocument\">\n{{\'OFFERED_SERVICES.DOC_STATUS.MISSING\' | translate}}</span><md-input-container ng-show=\"currentEntry.isEditing\" flex>\n<md-select md-placeholder=\"{{\'OFFERED_SERVICES.RESOURCES.SELECT_RESOURCE\'  | translate }}\" \nng-model=\"currentEntry.userDocument\" style=\"min-width: 200px\"><md-option ng-value=\"document\" \nng-selected=\"{{ currentEntry.userDocument.id === document.id ? \'true\' : \'false\' }}\" \nng-repeat=\"document in vm.userDocuments track by document.id\">{{document.name}}</md-option></md-select>\n</md-input-container></td><td><md-button class=\"md-accent\" ng-show=\"!currentEntry.isEditing\" \nng-click=\"currentEntry.isEditing=true\"><md-icon md-font-icon=\"icon-confirm\" class=\"md-primary\"></md-icon>\n{{\'PAGES.EDIT\' | translate}}</md-button><md-button class=\"md-warn\" ng-show=\"currentEntry.isEditing\" \nng-click=\"currentEntry.isEditing=false\"><md-icon md-font-icon=\"icon-undo\" class=\"md-primary\"></md-icon>\n{{\'PAGES.CANCEL\' | translate}}</md-button></td><td><md-input-container flex><a \nng-if=\"currentEntry.userDocument && currentEntry.userDocument!==null\" \nng-href=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{ currentEntry.userDocument.userId }}/download/{{ currentEntry.userDocument.uri }}?access_token={{ vm.accessToken }}\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-download\"></md-icon></a></md-input-container></td><td><span \nng-if=\"currentEntry.flgValidated>0\">{{\'OFFERED_SERVICES.DOC_STATUS.VALIDATED\' | translate}}</span> <span \nng-if=\"currentEntry.flgValidated==0\">{{\'OFFERED_SERVICES.DOC_STATUS.TO_BE_VALIDATED\' | translate}}</span> <span \nng-if=\"currentEntry.flgValidated<0\">{{\'OFFERED_SERVICES.DOC_STATUS.REJECTED\' | translate}}</span> <span \nng-if=\"currentEntry.flgValidated>0 && currentEntry.validTo\">fino al {{vm.formatDate(currentEntry.validTo)}}</span></td>\n<td>{{currentEntry.notes}}</td></tr></tbody></table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newDocsForm.$invalid || newDocsForm.$pristine\" \nng-click=\"answer({serviceDocuments: myResource.serviceDocuments})\" translate=\"USERS.CONFIRM\">Confirm</md-button>\n<md-button ng-click=\"cancel()\" translate=\"USERS.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/users/user_profile/tabs/services/offered-services.html","<div id=\"profile\" ng-show=\"vm.isAuthorized\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"content\" flex><div \nlayout=\"row\"><ov-profile-navigation-bar class=\"menu-in-sottopagina\" user-id=\"{{vm.userId}}\" selected-page=\"SERVICES\">\n</ov-profile-navigation-bar></div><div class=\"md-green-200-bg md-padding\" style=\"margin:20px\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s36 ml-16\"></md-icon>{{\'USERS.HINT.OFFERED_SERVICES\' | translate}}</div>\n<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionServices\"><thead><tr>\n<th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.USER\">User</span></div></th><th class=\"secondary-text\" style=\"width: 15%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"USERS.SERVICES.NAME\">Name</span></div></th><th class=\"secondary-text\" \nstyle=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OFFERED_SERVICES.SCHEDULE_TYPE\">\nSchedule type</span></div></th><th class=\"secondary-text\" style=\"width: 20%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"USERS.SERVICES.PAYMENTS\">Payments</span></div></th><th class=\"secondary-text\" \nstyle=\"width: 35%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.SERVICES.DOCUMENTS\">Documents\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"service in vm.userServices\"><td>{{service.displayName}}</td><td>\n<strong>{{service.name}}</strong><br>{{service.organizationName}}</td><td ng-if=\"service.scheduleType===\'P\'\">\n{{vm.formatDate(service.dateFrom)}} - {{vm.formatDate(service.dateTo)}}</td><td ng-if=\"service.scheduleType===\'R\'\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_ON_DEMAND\' | translate}}</td><td ng-if=\"service.scheduleType===\'N\'\">\n{{\'OFFERED_SERVICES.SERVICE_SCHEDULE_TYPE_NONE\' | translate}}</td><td ng-if=\"service.scheduleType===\'D\'\">\n{{vm.formatDate(service.dateFrom)}}</td><td ng-if=\"service.scheduleType===\'A\'\">\nPresenze: {{service.presences ? service.presences : 0}} / {{service.numMaxAccess}}</td><td \nstyle=\"color: green; font-weight: bold\" ng-if=\"service.paymentValue >= service.paymentDue\">\n{{service.paymentValue}} Euro<md-icon style=\"color: green\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></td><td \nstyle=\"color: red; font-weight: bold\" ng-if=\"service.paymentValue < service.paymentDue\"><div layout=\"column\"><md-button\n class=\"md-warn md-raised\" aria-label=\"User Payments\" ng-click=\"vm.goToPayment(service);\" \nng-disabled=\"!service.stripeEnabled\" translate translate-attr-aria-label=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\" \ntitle=\"{{ (service.stripeEnabled) ? \'OFFERED_SERVICES.SUBSCRIBER.PAYMENTS\' : \'MESSAGE.ORGANIZATION_WITHOUT_STRIPE_ENABLED\' | translate}}\">\n<md-icon style=\"color: white\" md-font-icon=\"icon-cash-100\" class=\"s24\"></md-icon>Registra pagamento</md-button>\nPagati {{service.paymentValue}} / {{service.paymentDue}} Euro</div></td><td><div class=\"row\"><md-button \nng-disabled=\"!service.docs || service.docs.length===0\" class=\"md-accent md-raised md-icon-button\" \nng-click=\"vm.editUserServiceDocuments($event,service)\" aria-label=\"User Documents\" \ntitle=\"{{ (!service.docs || service.docs.length===0) ? \'Il servizio non prevede documenti\' : \'Documenti dell\\\'iscrizione\'}}\" \ntranslate translate-attr-aria-label=\"USERS.SERVICES.DOCUMENTS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button><ul><li ng-repeat=\"doc in service.docs\">\n{{doc.name}}: {{ \'OFFERED_SERVICES.DOC_STATUS.\'+doc.status | translate}}</li></ul></div></td></tr></tbody></table>\n</div></div></div><div class=\"md-padding md-display-2\" ng-show=\"!vm.isAuthorized\">\nNon sei autorizzato a vedere questa pagina</div>");
$templateCache.put("app/main/pages/users/user_profile/tabs/services/send_message_dialog.html","<md-dialog aria-label=\"Send message\" ng-cloak><form name=\"newMessageForm\" novalidate style=\"min-width: 400px\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"NOTIFICATIONS.NEW_MESSAGE\">New message</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout-gt-sm=\"row\" flex-100><md-input-container \nstyle=\"width:100%\"><label translate=\"NOTIFICATIONS.TITLE\">Title</label><input type=\"text\" ng-model=\"myResource.title\">\n</md-input-container></div><div layout-gt-sm=\"row\" flex-100><md-input-container style=\"width:100%\"><label \ntranslate=\"NOTIFICATIONS.MESSAGE\">Message</label><textarea ng-model=\"myResource.text\" md-maxlength=\"500\" rows=\"5\" \nmd-select-on-focus></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button\n ng-disabled=\"newMessageForm.$invalid || newMessageForm.$pristine\" \nng-click=\"answer({title:myResource.title,text:myResource.text})\" translate=\"NOTIFICATIONS.SEND\">Send</md-button>\n<md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\" \nng-if=\"!vm.isChildChat\"><img ng-if=\"!uriAvatar || uriAvatar===null\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar\" style=\"cursor: default\" alt=\"{{vm.user.name}}\"> <img ng-if=\"uriAvatar && uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{vm.currentUserId}}/download/{{ uriAvatar }}\" \nclass=\"md-avatar avatar\" style=\"cursor: default\" alt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i \nng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" ng-class=\"vm.translateStatus()\"></i><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_ONLINE\">Online\n</span></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span \ntranslate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span translate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb\n</span></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'offline\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\">\n</i> <span translate=\"CHAT.STATUS_OFFLINE\">Offline</span></div></md-button></md-menu-item></md-menu-content></md-menu>\n</div><md-menu md-position-mode=\"target-right target\" ng-if=\"!vm.isChildChat\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.children && vm.children!==null && vm.children.length > 0\"><md-menu>\n<md-button style=\"text-transform: none;font-size: 15px;font-weight: normal\" ng-click=\"$mdOpenMenu()\" \ntranslate=\"CHAT.SHOW_CHILDREN\">Show your children\'s messages</md-button><md-menu-content><md-menu-item \nng-repeat=\"child in vm.children\"><md-button ng-click=\"vm.viewChildChat(child);\">{{child.displayName}}</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button ng-click=\"vm.goOffline()\" \ntranslate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"vm.isChildChat\" \nclass=\"md-accent md-raised\" layout-align=\"end\" ng-click=\"vm.reloadChat();\">{{\'CHAT.UPDATE\'| translate }}</md-button>\n</div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': vm.filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && vm.filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.chatSearch}  |  filter:query as filteredChat\" \nng-click=\"vm.getChat(contact)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-if=\"contact.type === \'U\' && (!contact.uriAvatar || contact.uriAvatar === null)\" \nsrc=\"assets/images/avatars/profile.jpg\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <img \nng-if=\"contact.type === \'U\' && contact.uriAvatar && contact.uriAvatar !== null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{contact.id}}/download/{{ contact.uriAvatar }}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"><md-icon \nng-if=\"contact.type === \'O\'  && (!contact.uriAvatar || contact.uriAvatar === null)\" md-font-icon=\"icon-shield\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><img \nng-if=\"contact.type === \'O\' && contact.uriAvatar && contact.uriAvatar !== null\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{contact.id}}/download/{{ contact.uriAvatar }}\" \nclass=\"md-avatar avatar\"><md-icon ng-if=\"contact.type === \'S\' && contact.groupType === \'G\'\" \nmd-font-icon=\"icon-account-multiple\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><md-icon \nng-if=\"contact.type === \'S\' && contact.groupType === \'B\'\" md-font-icon=\"icon-volume-medium\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><i \nng-if=\"contact.type === \'U\'\" class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div \nclass=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage.text}}\n</p></div><div layout=\"column\" layout-align=\"center end\"><div class=\"last-message-time\">\n{{vm.formatDate(contact.lastMessage.notificationDate)}}</div><div ng-if=\"contact.unread\" \nclass=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div></md-list-item><md-divider></md-divider>\n</md-list><md-list class=\"contact-list\"><div ng-show=\"vm.chatSearch && filteredContact.length > 0\" \nclass=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact)\"><div class=\"avatar-wrapper\"><img src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div><md-divider></md-divider></md-list-item></md-list><div \nlayout=\"row\" layout-sm=\"column\" class=\"md-padding\" layout-align=\"space-around\" ng-show=\"vm.loadingContacts\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></md-content><md-button \nclass=\"md-fab md-warn contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\" \nng-if=\"!vm.isChildChat\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contactsForSearch  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.addAndGetChat(contact)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contactsForSearch[$index].name.charAt(0) !== vm.contactsForSearch[$index-1].name.charAt(0)\">\n{{contact.name.charAt(0)}}</div><div class=\"avatar-wrapper\"><img \nng-if=\"contact.type===\'U\' && (!contact.uriAvatar || contact.uriAvatar===null)\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <img \nng-if=\"contact.type===\'U\' && contact.uriAvatar && contact.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{contact.id}}/download/{{ contact.uriAvatar }}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"><md-icon \nng-if=\"contact.type===\'O\'  && (!contact.uriAvatar || contact.uriAvatar===null)\" md-font-icon=\"icon-shield\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><img \nng-if=\"contact.type===\'O\' && contact.uriAvatar && contact.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/organizationDocumentsContainers/{{CYL_ORG_DOC_PREFIX}}{{contact.id}}/download/{{ contact.uriAvatar }}\" \nclass=\"md-avatar avatar\"><md-icon ng-if=\"contact.type===\'S\'\" md-font-icon=\"icon-account-multiple\" \nstyle=\"width: 36px; height: 36px; margin-right: 16px; font-size: 36px;	color: #777\"></md-icon><i \nng-if=\"contact.type===\'U\'\" class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list>\n<div ng-if=\"filteredContact.length <= 0\" class=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div>\n<md-button style=\"margin-top: 50px\" ng-if=\"filteredContact.length <= 0\" class=\"md-raised md-accent\" \ntranslate=\"CHAT.SEARCH_CLUB_YOUR_LIFE_USER\" translate-attr-aria-label=\"CHAT.SEARCH_CLUB_YOUR_LIFE_USER\" \nng-click=\"vm.searchUser()\">Search user</md-button></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\" ng-if=\"vm.currentContact.type === \'S\' || vm.currentContact.type === \'O\'\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div>Info gruppo</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{vm.currentChatService.name}}</div><div class=\"contact-name\">{{vm.currentChatService.organization.name}}</div></div>\n</div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding \nng-if=\"vm.currentContact.type === \'S\' || vm.currentContact.type === \'O\'\"><md-card \nng-repeat=\"subscriber in vm.currentChatService.subscribers\"><md-card-content ng-if=\"subscriber.id != vm.currentUserId\" \nng-click=\"vm.addAndGetChat(subscriber); vm.toggleSidenav(\'right-sidenav\');\" style=\"cursor: pointer\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar-wrapper\"><img \nng-if=\"(!subscriber.uriAvatar || subscriber.uriAvatar===null)\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar\" alt=\"{{subscriber.name}}\"> <img ng-if=\"subscriber.uriAvatar && subscriber.uriAvatar!==null\" \nng-src=\"{{ vm.apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{subscriber.id}}/download/{{ subscriber.uriAvatar }}\" \nclass=\"md-avatar avatar\" alt=\"{{subscriber.name}}\"></div><span>{{subscriber.displayName}}</span></div>\n</md-card-content></md-card></md-content>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_cardnum_dialog.html","<md-dialog aria-label=\"New earning / cost\" ng-cloak><form name=\"newEarningCostForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div layout=\"row\"><md-input-container><label>\nTessera</label><input ng-model=\"myResource.cardNumber\" md-maxlength=\"500\" type=\"text\"></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" ng-show=\"!isAddingUserOrganization\"><md-button \nng-click=\"answer({cardNumber: myResource.cardNumber})\" translate=\"OFFERED_SERVICES.SAVE\">Save</md-button><md-button \nng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_num_max_access_dialog.html","<md-dialog aria-label=\"New earning / cost\" ng-cloak><form name=\"newEarningCostForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\" class=\"w-400\"><h2></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"row\" class=\"font-size-12\"><cite>\nTramite questa funzionalità è possibile variare il numero massimo di ingressi previsti dal carnet per questa singola iscrizione\n</cite></div><div layout=\"row\"><md-input-container class=\"md-block w-300\"><label>Numero massimo di accessi</label>\n<input ng-model=\"myResource.numMaxAccessForOrder\" type=\"number\" min=\"1\" max=\"999\"></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer({numMaxAccessForOrder: myResource.numMaxAccessForOrder})\" translate=\"OFFERED_SERVICES.SAVE\">Save\n</md-button><md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_payment_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"payForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PAYMENTS.ADD\">Add payment</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-datepicker \nng-model=\"myResource.paymentDate\" md-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_DATE\' | translate }}\">\n</md-datepicker><md-input-container><label translate=\"OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\" required></label>\n<input required ng-model=\"myResource.paymentValue\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SUBSCRIBER.PAYMENT_VALUE\' | translate }}\"></md-input-container>\n<md-input-container><label translate=\"PAYMENTS.REASON\" required>Reason</label><md-select \nmd-placeholder=\"{{\'PAYMENTS.REASON\'  | translate }}\" ng-model=\"myResource.paymentReason\" style=\"min-width: 300px\">\n<md-option ng-value=\"paymentReason\" ng-repeat=\"paymentReason in paymentReasons  track by paymentReason.id\">\n{{paymentReason.name}}</md-option></md-select></md-input-container><div style=\"width:100%\" flex><md-input-container \nflex style=\"width:100%\"><label translate=\"PAYMENTS.DESCRIPTION\">Description</label><input type=\"text\" \nng-model=\"myResource.paymentDescription\" rows=\"3\" md-select-on-focus></md-input-container></div><md-input-container \nng-show=\"myResource.showFlgGenerateInvoice\"><md-checkbox ng-model=\"myResource.flgGenerateInvoice\">\n{{\'PAYMENTS.GENERATE_INVOICE\' | translate}}</md-checkbox></md-input-container><md-input-container \nng-show=\"myResource.flgGenerateInvoice\"><md-checkbox ng-model=\"myResource.flgSendNotification\">\n{{\'PAYMENTS.NOTIFY_USER\' | translate}}</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button \nng-disabled=\"payForm.$invalid || payForm.$pristine || !myResource.paymentReason || myResource.paymentReason===null || !paymentButtonEnabled\" \nng-click=\"paymentButtonEnabled = false; answer({paymentDate:myResource.paymentDate,paymentValue:myResource.paymentValue,paymentDescription:myResource.paymentDescription,\n          					paymentReason:myResource.paymentReason, flgGenerateInvoice: myResource.flgGenerateInvoice, flgSendNotification: myResource.flgSendNotification})\" \ntranslate=\"OFFERED_SERVICES.ADD\">Add</md-button><md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_resource_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.RESOURCES.EDIT\">Edit used resource</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.NAME\" required>Name</label><md-select \nmd-placeholder=\"{{\'OFFERED_SERVICES.RESOURCES.SELECT_RESOURCE\'  | translate }}\" ng-model=\"myResource.resource\" \nstyle=\"min-width: 200px\" ng-change=\"populateResourceDefault()\"><md-option ng-value=\"resource\" \nng-selected=\"{{ myResource.resource.id === resource.id ? \'true\' : \'false\' }}\" \nng-repeat=\"resource in resources track by resource.id\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</md-option></md-select></md-input-container><div layout=\"row\" style=\"margin-top: 1em\">\n{{\'OFFERED_SERVICES.SCHEDULES.DATES_HINT\' | translate}}</div><div layout=\"row\" style=\"color: red\" class=\"md-subhead\">\n{{displayErrorDates}}</div><div layout=\"row\" div class=\"md-inline-form\"><md-datepicker md-max-date=\"myResource.dateTo\" \nrequired ng-model=\"myResource.dateFrom\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.DATE_FROM\' | translate }}\">\n</md-datepicker><md-datepicker md-min-date=\"myResource.dateFrom\" required ng-model=\"myResource.dateTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.DATE_TO\' | translate }}\"></md-datepicker></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.SCHEDULE_TYPE_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDay}}</div><div class=\"row\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULE_TYPE\" required>Schedule type</label><md-select ng-model=\"myResource.typeCode\" \nng-change=\"changeTypeCode()\"><md-option value=\"P\">{{ \'OFFERED_SERVICES.PUNCTUAL\' | translate}}</md-option><md-option \nvalue=\"G\">{{ \'OFFERED_SERVICES.DAILY\' | translate}}</md-option><md-option value=\"GW\">\n{{ \'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</md-option><md-option value=\"S\">\n{{ \'OFFERED_SERVICES.WEEKLY\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"showWeekDay\"><label translate=\"OFFERED_SERVICES.WEEK_DAY\">Schedule day</label><md-select \nng-model=\"myResource.weekDay\" ng-required=\"myResource.typeCode===\'S\'\"><md-option value=\"1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</md-option><md-option value=\"2\">{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}\n</md-option><md-option value=\"3\">{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</md-option><md-option value=\"4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</md-option><md-option value=\"5\">{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}\n</md-option><md-option value=\"6\">{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</md-option><md-option value=\"0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.HOURS_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorHours}}</div><div layout=\"row\" div class=\"md-inline-form\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top: 1.5em; padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_FROM\" required></label><md-select required \nng-model=\"myResource.hourFrom\" ng-change=\"changeHourFrom()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.MINUTES_FROM\" required></label><md-select required \nng-model=\"myResource.minutesFrom\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container><label translate=\"OFFERED_SERVICES.HOUR_END\" \nstyle=\"padding-top: 1.5em; padding-right: 1em\">End</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.HOUR_TO\" required></label><md-select required ng-model=\"myResource.hourTo\" \nng-change=\"changeHourTo()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option></md-select></md-input-container>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_TO\" required></label><md-select required \nng-model=\"myResource.minutesTo\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container><md-checkbox \nng-model=\"myResource.freeUsage\" aria-label=\"Finished?\">{{ \'OFFERED_SERVICES.RESOURCES.FREE_USAGE\' | translate}}\n</md-checkbox></md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.NUMBER\"></label>\n<input ng-model=\"myResource.totalNumber\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.NUMBER\' | translate }}\"></md-input-container></div><div layout=\"row\" \ndiv class=\"md-inline-form\"><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.USER_COST\"></label><input \nng-model=\"myResource.userCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.USER_COST\' | translate }}\"></md-input-container><md-input-container \nng-show=\"myResource.userCost && myResource.userCost!==null  && myResource.userCost!==0  && myResource.userCost!==\'\'\">\n<label translate=\"OFFERED_SERVICES.RESOURCES.USER_COST_TYPE\">User cost repartition</label><md-select \nng-model=\"myResource.userCostType\"><md-option value=\"C\">{{ \'OFFERED_SERVICES.COST_TOTAL\' | translate}}</md-option>\n<md-option value=\"D\">{{ \'OFFERED_SERVICES.COST_DATE\' | translate}}</md-option><md-option value=\"DN\">\n{{ \'OFFERED_SERVICES.COST_DATE_NUMBER\' | translate}}</md-option><md-option value=\"N\">\n{{ \'OFFERED_SERVICES.COST_NUMBER\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \ndiv class=\"md-inline-form\"><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\"></label>\n<input ng-model=\"myResource.organizationCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\' | translate }}\"></md-input-container>\n<md-input-container \nng-show=\"myResource.organizationCost && myResource.organizationCost!==null && myResource.organizationCost!==0 && myResource.organizationCost!==\'\'\">\n<label translate=\"OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST_TYPE\">Organization cost repartition</label><md-select \nng-model=\"myResource.organizationCostType\"><md-option value=\"C\">{{ \'OFFERED_SERVICES.COST_TOTAL\' | translate}}\n</md-option><md-option value=\"D\">{{ \'OFFERED_SERVICES.COST_DATE\' | translate}}</md-option><md-option value=\"DN\">\n{{ \'OFFERED_SERVICES.COST_DATE_NUMBER\' | translate}}</md-option><md-option value=\"N\">\n{{ \'OFFERED_SERVICES.COST_NUMBER\' | translate}}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer({resourceId: myResource.resource.id,resourceName: myResource.resource.name,\n          						dateFrom:myResource.dateFrom,dateTo:myResource.dateTo,hourFrom:myResource.hourFrom,\n          						hourTo:myResource.hourTo,minutesFrom:myResource.minutesFrom,minutesTo:myResource.minutesTo,\n          						typeCode:myResource.typeCode,weekDay:myResource.weekDay,totalNumber:myResource.totalNumber,\n          						userCost:myResource.userCost,organizationCost:myResource.organizationCost,\n          						userCostType:myResource.userCostType,organizationCostType:myResource.organizationCostType,\n          						freeUsage:myResource.freeUsage})\" \ntranslate=\"OFFERED_SERVICES.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/edit_schedule_dialog.html","<md-dialog aria-label=\"Edit schedule\" ng-cloak><form name=\"newScheduleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.SCHEDULES.EDIT\">Edit schedule</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"OFFERED_SERVICES.SCHEDULE\">Basic Info</span></md-tab-label><md-tab-body><div layout=\"column\"><div \nlayout=\"row\" style=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.DATES_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDates}}</div><div layout=\"row\" div class=\"md-inline-form\">\n<md-datepicker md-max-date=\"myResource.dateTo\" required ng-model=\"myResource.dateFrom\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SCHEDULES.DATE_FROM\' | translate }}\"></md-datepicker><md-datepicker \nmd-min-date=\"myResource.dateFrom\" ng-model=\"myResource.dateTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SCHEDULES.DATE_TO\' | translate }}\"></md-datepicker></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.SCHEDULE_TYPE_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDay}}</div><div class=\"row\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULE_TYPE\" required>Schedule type</label><md-select required \nng-model=\"myResource.typeCode\" ng-change=\"changeTypeCode()\"><md-option value=\"P\">\n{{ \'OFFERED_SERVICES.PUNCTUAL\' | translate}}</md-option><md-option value=\"G\">{{ \'OFFERED_SERVICES.DAILY\' | translate}}\n</md-option><md-option value=\"GW\">{{ \'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</md-option><md-option \nvalue=\"S\">{{ \'OFFERED_SERVICES.WEEKLY\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"showWeekDay\"><label translate=\"OFFERED_SERVICES.WEEK_DAY\" required>Schedule day</label><md-select \nng-model=\"myResource.weekDay\" ng-required=\"myResource.typeCode===\'S\'\"><md-option value=\"1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</md-option><md-option value=\"2\">{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}\n</md-option><md-option value=\"3\">{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</md-option><md-option value=\"4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</md-option><md-option value=\"5\">{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}\n</md-option><md-option value=\"6\">{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</md-option><md-option value=\"0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.HOURS_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorHours}}</div><div layout=\"row\" div class=\"md-inline-form\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top: 1.5em; padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.SCHEDULES.HOUR_FROM\" required></label><md-select required \nng-model=\"myResource.hourFrom\" ng-change=\"changeHourFrom()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULES.MINUTES_FROM\" required></label><md-select required \nng-model=\"myResource.minutesFrom\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container><label translate=\"OFFERED_SERVICES.HOUR_END\" \nstyle=\"padding-top: 1.5em; padding-right: 1em\">End</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULES.HOUR_TO\" required></label><md-select required ng-model=\"myResource.hourTo\" \nng-change=\"changeHourTo()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option></md-select></md-input-container>\n<md-input-container><label translate=\"OFFERED_SERVICES.SCHEDULES.MINUTES_TO\" required></label><md-select required \nng-model=\"myResource.minutesTo\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"OFFERED_SERVICES.USED_RESOURCES\">Resources</span></md-tab-label><md-tab-body><div layout=\"row\" \nng-repeat=\"resource in resources\"><md-input-container class=\"md-block\" flex-gt-xs><md-checkbox \nng-model=\"myResource.scheduleResources[resource.id]\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</md-checkbox></md-input-container><md-input-container class=\"md-icon-right\" style=\"width: 30%\"><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.NUMBER\"></label><input ng-model=\"myResource.scheduleResourceNumber[resource.id]\" \nng-disabled=\"resource.flgStaff\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.NUMBER\' | translate }}\"></md-input-container></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"answer({dateFrom:myResource.dateFrom,dateTo:myResource.dateTo,hourFrom:myResource.hourFrom,\n          						hourTo:myResource.hourTo,minutesFrom:myResource.minutesFrom,minutesTo:myResource.minutesTo,\n          						typeCode:myResource.typeCode,weekDay:myResource.weekDay,scheduleResources:myResource.scheduleResources,\n          						scheduleResourceNumber:myResource.scheduleResourceNumber})\" \ntranslate=\"OFFERED_SERVICES.EDIT\">Edit</md-button><md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">\nCancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/help_dialog.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Title</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><h2>Title</h2><p>\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer(\'not useful\')\">Not Useful\n</md-button><md-button ng-click=\"answer(\'useful\')\">Useful</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/new_resource_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newResourceForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.RESOURCES.ADD\">New Used Resource</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.NAME\" required>Name</label><md-select \nmd-placeholder=\"{{\'OFFERED_SERVICES.RESOURCES.SELECT_RESOURCE\'  | translate }}\" ng-model=\"myResource.resource\" \nng-change=\"populateResourceDefault()\" style=\"min-width: 200px\"><md-option ng-value=\"resource\" \nng-selected=\"{{ myResource.resource.id === resource.id ? \'true\' : \'false\' }}\" \nng-repeat=\"resource in resources  track by resource.id\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</md-option></md-select></md-input-container><div layout=\"row\" style=\"margin-top: 1em\">\n{{\'OFFERED_SERVICES.SCHEDULES.DATES_HINT\' | translate}}</div><div layout=\"row\" style=\"color: red\" class=\"md-subhead\">\n{{displayErrorDates}}</div><div layout=\"row\" div class=\"md-inline-form\"><md-datepicker md-max-date=\"myResource.dateTo\" \nrequired ng-model=\"myResource.dateFrom\" md-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.DATE_FROM\' | translate }}\">\n</md-datepicker><md-datepicker md-min-date=\"myResource.dateFrom\" required ng-model=\"myResource.dateTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.DATE_TO\' | translate }}\"></md-datepicker></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.SCHEDULE_TYPE_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDay}}</div><div class=\"row\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULE_TYPE\" required>Schedule type</label><md-select ng-model=\"myResource.typeCode\" \nng-change=\"changeTypeCode()\"><md-option value=\"P\">{{ \'OFFERED_SERVICES.PUNCTUAL\' | translate}}</md-option><md-option \nvalue=\"G\">{{ \'OFFERED_SERVICES.DAILY\' | translate}}</md-option><md-option value=\"GW\">\n{{ \'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</md-option><md-option value=\"S\">\n{{ \'OFFERED_SERVICES.WEEKLY\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"showWeekDay\"><label translate=\"OFFERED_SERVICES.WEEK_DAY\">Schedule day</label><md-select \nng-model=\"myResource.weekDay\" ng-required=\"myResource.typeCode===\'S\'\"><md-option value=\"1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</md-option><md-option value=\"2\">{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}\n</md-option><md-option value=\"3\">{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</md-option><md-option value=\"4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</md-option><md-option value=\"5\">{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}\n</md-option><md-option value=\"6\">{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</md-option><md-option value=\"0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.HOURS_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorHours}}</div><div layout=\"row\" div class=\"md-inline-form\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top: 1.5em; padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.HOUR_FROM\" required></label><md-select required \nng-model=\"myResource.hourFrom\" ng-change=\"changeHourFrom()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.MINUTES_FROM\" required></label><md-select required \nng-model=\"myResource.minutesFrom\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container><label translate=\"OFFERED_SERVICES.HOUR_END\" \nstyle=\"padding-top: 1.5em; padding-right: 1em\">End</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.HOUR_TO\" required></label><md-select required ng-model=\"myResource.hourTo\" \nng-change=\"changeHourTo()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option></md-select></md-input-container>\n<md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.MINUTES_TO\" required></label><md-select required \nng-model=\"myResource.minutesTo\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container><md-checkbox \nng-model=\"myResource.freeUsage\" aria-label=\"Finished?\">{{ \'OFFERED_SERVICES.RESOURCES.FREE_USAGE\' | translate}}\n</md-checkbox></md-input-container><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.NUMBER\"></label>\n<input ng-model=\"myResource.totalNumber\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.NUMBER\' | translate }}\"></md-input-container></div><div layout=\"row\" \ndiv class=\"md-inline-form\"><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.USER_COST\"></label><input \nng-model=\"myResource.userCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.USER_COST\' | translate }}\"></md-input-container><md-input-container \nng-show=\"myResource.userCost && myResource.userCost!==null  && myResource.userCost!==0  && myResource.userCost!==\'\'\">\n<label translate=\"OFFERED_SERVICES.RESOURCES.USER_COST_TYPE\">User cost repartition</label><md-select \nng-model=\"myResource.userCostType\"><md-option value=\"C\">{{ \'OFFERED_SERVICES.COST_TOTAL\' | translate}}</md-option>\n<md-option value=\"D\">{{ \'OFFERED_SERVICES.COST_DATE\' | translate}}</md-option><md-option value=\"DN\">\n{{ \'OFFERED_SERVICES.COST_DATE_NUMBER\' | translate}}</md-option><md-option value=\"N\">\n{{ \'OFFERED_SERVICES.COST_NUMBER\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \ndiv class=\"md-inline-form\"><md-input-container><label translate=\"OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\"></label>\n<input ng-model=\"myResource.organizationCost\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST\' | translate }}\"></md-input-container>\n<md-input-container \nng-show=\"myResource.organizationCost && myResource.organizationCost!==null && myResource.organizationCost!==0 && myResource.organizationCost!==\'\'\">\n<label translate=\"OFFERED_SERVICES.RESOURCES.ORGANIZATION_COST_TYPE\">Organization cost repartition</label><md-select \nng-model=\"myResource.organizationCostType\"><md-option value=\"C\">{{ \'OFFERED_SERVICES.COST_TOTAL\' | translate}}\n</md-option><md-option value=\"D\">{{ \'OFFERED_SERVICES.COST_DATE\' | translate}}</md-option><md-option value=\"DN\">\n{{ \'OFFERED_SERVICES.COST_DATE_NUMBER\' | translate}}</md-option><md-option value=\"N\">\n{{ \'OFFERED_SERVICES.COST_NUMBER\' | translate}}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newResourceForm.$pristine || !myResource.resource\" \nng-click=\"answer({resourceId: myResource.resource.id,resourceName: myResource.resource.name,\n          						dateFrom:myResource.dateFrom,dateTo:myResource.dateTo,hourFrom:myResource.hourFrom,\n          						hourTo:myResource.hourTo,minutesFrom:myResource.minutesFrom,minutesTo:myResource.minutesTo,\n          						typeCode:myResource.typeCode,weekDay:myResource.weekDay,totalNumber:myResource.totalNumber,\n          						userCost:myResource.userCost,organizationCost:myResource.organizationCost,\n          						userCostType:myResource.userCostType,organizationCostType:myResource.organizationCostType,\n          						freeUsage:myResource.freeUsage})\" \ntranslate=\"OFFERED_SERVICES.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/new_schedule_dialog.html","<md-dialog aria-label=\"New schedule\" ng-cloak><form name=\"newScheduleForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.SCHEDULES.ADD\">New Schedule</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"OFFERED_SERVICES.SCHEDULE\">Basic Info</span></md-tab-label><md-tab-body><div layout=\"column\"><div \nlayout=\"row\" style=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.DATES_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDates}}</div><div layout=\"row\" div class=\"md-inline-form\">\n<md-datepicker md-max-date=\"myResource.dateTo\" required ng-model=\"myResource.dateFrom\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SCHEDULES.DATE_FROM\' | translate }}\"></md-datepicker><md-datepicker \nmd-min-date=\"myResource.dateFrom\" ng-model=\"myResource.dateTo\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.SCHEDULES.DATE_TO\' | translate }}\"></md-datepicker></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.SCHEDULE_TYPE_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorDay}}</div><div class=\"row\"><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULE_TYPE\" required>Schedule type</label><md-select required \nng-model=\"myResource.typeCode\" ng-change=\"changeTypeCode()\"><md-option value=\"P\">\n{{ \'OFFERED_SERVICES.PUNCTUAL\' | translate}}</md-option><md-option value=\"G\">{{ \'OFFERED_SERVICES.DAILY\' | translate}}\n</md-option><md-option value=\"GW\">{{ \'OFFERED_SERVICES.DAILY_EXCLUDE_WEEKEND\' | translate}}</md-option><md-option \nvalue=\"S\">{{ \'OFFERED_SERVICES.WEEKLY\' | translate}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"showWeekDay\"><label translate=\"OFFERED_SERVICES.WEEK_DAY\" required>Schedule day</label><md-select \nng-model=\"myResource.weekDay\" ng-required=\"myResource.typeCode===\'S\'\"><md-option value=\"1\">\n{{ \'OFFERED_SERVICES.MONDAY\' | translate}}</md-option><md-option value=\"2\">{{ \'OFFERED_SERVICES.TUESDAY\' | translate}}\n</md-option><md-option value=\"3\">{{ \'OFFERED_SERVICES.WEDNESDAY\' | translate}}</md-option><md-option value=\"4\">\n{{ \'OFFERED_SERVICES.THURSDAY\' | translate}}</md-option><md-option value=\"5\">{{ \'OFFERED_SERVICES.FRIDAY\' | translate}}\n</md-option><md-option value=\"6\">{{ \'OFFERED_SERVICES.SATURDAY\' | translate}}</md-option><md-option value=\"0\">\n{{ \'OFFERED_SERVICES.SUNDAY\' | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nstyle=\"margin-top: 1em\">{{\'OFFERED_SERVICES.SCHEDULES.HOURS_HINT\' | translate}}</div><div layout=\"row\" \nstyle=\"color: red\" class=\"md-subhead\">{{displayErrorHours}}</div><div layout=\"row\" div class=\"md-inline-form\"><label \ntranslate=\"OFFERED_SERVICES.HOUR_START\" style=\"padding-top: 1.5em; padding-right: 1em\">Start</label>\n<md-input-container><label translate=\"OFFERED_SERVICES.SCHEDULES.HOUR_FROM\" required></label><md-select required \nng-model=\"myResource.hourFrom\" ng-change=\"changeHourFrom()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULES.MINUTES_FROM\" required></label><md-select required \nng-model=\"myResource.minutesFrom\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container><label translate=\"OFFERED_SERVICES.HOUR_END\" \nstyle=\"padding-top: 1.5em; padding-right: 1em\">End</label><md-input-container><label \ntranslate=\"OFFERED_SERVICES.SCHEDULES.HOUR_TO\" required></label><md-select required ng-model=\"myResource.hourTo\" \nng-change=\"changeHourTo()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option></md-select></md-input-container>\n<md-input-container><label translate=\"OFFERED_SERVICES.SCHEDULES.MINUTES_TO\" required></label><md-select required \nng-model=\"myResource.minutesTo\"><md-option value=\"0\">00</md-option><md-option value=\"5\">05</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option><md-option value=\"25\">\n25</md-option><md-option value=\"30\">30</md-option><md-option value=\"35\">35</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"50\">50</md-option><md-option value=\"55\">55\n</md-option></md-select></md-input-container></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"OFFERED_SERVICES.USED_RESOURCES\">Resources</span></md-tab-label><md-tab-body><div layout=\"row\" \nng-repeat=\"resource in resources\"><md-input-container class=\"md-block\" flex-gt-xs><md-checkbox \nng-model=\"myResource.scheduleResources[resource.id]\">\n{{resource.name}} {{(resource.staffMember && resource.staffMember!==null)?\' - \' : \'\'}} {{resource.staffMember.displayName}}\n</md-checkbox></md-input-container><md-input-container class=\"md-icon-right\" style=\"width: 30%\"><label \ntranslate=\"OFFERED_SERVICES.RESOURCES.NUMBER\"></label><input ng-model=\"myResource.scheduleResourceNumber[resource.id]\" \nng-disabled=\"resource.flgStaff\" type=\"number\" min=\"0\" \nmd-placeholder=\"{{ \'OFFERED_SERVICES.RESOURCES.NUMBER\' | translate }}\"></md-input-container></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newScheduleForm.$pristine\" \nng-click=\"answer({dateFrom:myResource.dateFrom,dateTo:myResource.dateTo,hourFrom:myResource.hourFrom,\n          						hourTo:myResource.hourTo,minutesFrom:myResource.minutesFrom,minutesTo:myResource.minutesTo,\n          						typeCode:myResource.typeCode,weekDay:myResource.weekDay,scheduleResources:myResource.scheduleResources,\n          						scheduleResourceNumber:myResource.scheduleResourceNumber})\" \ntranslate=\"OFFERED_SERVICES.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/new_subscriber_dialog.html","<md-dialog aria-label=\"New Subscriber\" ng-cloak><form name=\"newSubscriberForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"OFFERED_SERVICES.SUBSCRIBER.ADD\">New Subscriber</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><p id=\"add-subscriber-in-line-help\" \nstyle=\"display:none\">{{\'OFFERED_SERVICES.ADD_SUBSCRIBER_INFOS\' | translate}}</p></div><div layout=\"column\"><div \nlayout=\"row\"><md-button title=\"{{\'OFFERED_SERVICES.MORE_INFO\' | translate}}\" class=\"md-icon-button md-accent\" \nonclick=\"$(\'#add-subscriber-in-line-help\').toggle(500)\"><md-icon id=\"icon-help-chat-type\" \nmd-font-icon=\"icon-help-circle\" class=\"md-primary\"></md-icon></md-button><md-autocomplete style=\"min-width: 480px\" \nmd-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" md-items=\"item in lookupUser(ctrl.searchText)\" \nmd-item-text=\"item.displayName\" md-min-length=\"3\" md-floating-label=\"{{\'OFFERED_SERVICES.SEARCH_ON_CYL\' | translate}}\" \nmd-selected-item-change=\"selectedUserChange(item)\" md-menu-class=\"autocomplete-custom-template\" md-autofocus>\n<md-item-template><img md-menu-align-target ng-if=\"!item.uriAvatar || item.uriAvatar===null\" class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target ng-if=\"item.uriAvatar && item.uriAvatar!==null\" \nclass=\"avatar\" \nng-src=\"{{ apiPath }}/userDocumentsContainers/{{CYL_USER_DOC_PREFIX}}{{item.id}}/download/{{ item.uriAvatar }}\"> <span \nmd-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.displayName}} - {{item.email}}</span>\n</md-item-template><md-not-found>{{\'OFFERED_SERVICES.NO_RESULT_FOUND\' | translate}}</md-not-found></md-autocomplete>\n</div><div layout=\"row\"><md-input-container style=\"width:100%\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.GIVEN_NAME\" required>Given Name</label><input type=\"text\" name=\"givenName\" \nng-model=\"givenName\" ng-readonly=\"userId && userId!==null\"></md-input-container><md-input-container style=\"width:100%\">\n<label translate=\"OFFERED_SERVICES.SUBSCRIBER.FAMILY_NAME\" required>Family Name</label><input type=\"text\" \nname=\"familyName\" ng-model=\"familyName\" ng-readonly=\"userId && userId!==null\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float style=\"width:100%; margin-top: 0px\"><label \ntranslate=\"OFFERED_SERVICES.SUBSCRIBER.BIRTH_DATE\">Birth date</label><input rsmdatedropdowns deny-future-dates=\"true\" \nng-model=\"birthDate\" ng-disabled=\"userId && userId!==null\"></md-input-container><md-input-container \nstyle=\"width:100%; margin-top: 21px\"><label translate=\"OFFERED_SERVICES.SUBSCRIBER.EMAIL\">Email</label><input \ntype=\"email\" ng-model=\"email\" ng-pattern=\"/^.+@.+\\..+$/\" ng-readonly=\"userId && userId!==null\" \nng-required=\"!userId || userId===null\"><div ng-messages=\"newSubscriberForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"USERS.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"USERS.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"newSubscriberForm.$invalid || newSubscriberForm.$pristine\" \nng-click=\"answer({givenName: givenName,familyName: familyName,birthDate: birthDate,email: email, userId:userId})\" \ntranslate=\"OFFERED_SERVICES.CREATE\">Create</md-button><md-button ng-click=\"cancel()\" \ntranslate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/renew_confirm_dialog.html","<md-dialog aria-label=\"Delete confit\" ng-cloak><form name=\"delForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Rinnovo iscrizione</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h3>\nAttenzione: le presenze registrate non raggiungono ancora il massimo previsto per questo servizio. Si vuol procedere comunque con il rinnovo?\n</h3></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"answer()\">Ok</md-button><md-button \nng-click=\"cancel()\" translate=\"PAGES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/offered_services/views/offered_service/tabs/dialogs/send_message_dialog.html","<md-dialog aria-label=\"Send message\" ng-cloak><form name=\"newMessageForm\" novalidate style=\"min-width: 400px\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"NOTIFICATIONS.NEW_MESSAGE\">New message</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout-gt-sm=\"row\" flex-100><md-input-container \nstyle=\"width:100%\" ng-if=\"notificationType !== \'G\' && notificationType !== \'B\'\"><label translate=\"NOTIFICATIONS.TITLE\">\nTitle</label><input type=\"text\" ng-model=\"myResource.title\"></md-input-container></div><div layout-gt-sm=\"row\" \nflex-100><md-input-container style=\"width:100%\"><label translate=\"NOTIFICATIONS.MESSAGE\">Message</label><textarea \nng-model=\"myResource.text\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-disabled=\"newMessageForm.$invalid || newMessageForm.$pristine\" \nng-click=\"answer({title:myResource.title,text:myResource.text})\" translate=\"NOTIFICATIONS.SEND\">Send</md-button>\n<md-button ng-click=\"cancel()\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/users/user_profile/tabs/documents/dialogs/link-document-subscription-dialog.html","<md-dialog aria-label=\"Associa documento a servizio\" ng-cloak><form name=\"linkDocumentSubscriptionForm\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Condivisione documento</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content><div><p>\nClicca il servizio a cui vuoi associare il documento. L\'associazione che offre quel servizio potrà visualizzarne il contenuto al fine di confermarne la validità.\n</p></div><md-list flex><md-list-item class=\"md-2-line\" ng-repeat=\"subscription in userSubscriptions\" \nng-click=\"answer(subscription);\"><div class=\"md-list-item-text\"><h3>\n{{ subscription.requiredDocumentName }} per {{ subscription.offeredServiceName }}</h3><p>\nda {{ subscription.organizationName }} <span ng-if=\"subscription.userId !== userId\">( per {{ subscription.userName }})\n</span></p></div></md-list-item></md-list></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel();\" translate=\"OFFERED_SERVICES.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");}]);